/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(561);
	module.exports = __webpack_require__(637);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(87);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(938)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var getTimezoneOffsetInMilliseconds = __webpack_require__(705)
	var isDate = __webpack_require__(181)
	
	var MILLISECONDS_IN_HOUR = 3600000
	var MILLISECONDS_IN_MINUTE = 60000
	var DEFAULT_ADDITIONAL_DIGITS = 2
	
	var parseTokenDateTimeDelimeter = /[T ]/
	var parseTokenPlainTime = /:/
	
	// year tokens
	var parseTokenYY = /^(\d{2})$/
	var parseTokensYYY = [
	  /^([+-]\d{2})$/, // 0 additional digits
	  /^([+-]\d{3})$/, // 1 additional digit
	  /^([+-]\d{4})$/ // 2 additional digits
	]
	
	var parseTokenYYYY = /^(\d{4})/
	var parseTokensYYYYY = [
	  /^([+-]\d{4})/, // 0 additional digits
	  /^([+-]\d{5})/, // 1 additional digit
	  /^([+-]\d{6})/ // 2 additional digits
	]
	
	// date tokens
	var parseTokenMM = /^-(\d{2})$/
	var parseTokenDDD = /^-?(\d{3})$/
	var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
	var parseTokenWww = /^-?W(\d{2})$/
	var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/
	
	// time tokens
	var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
	var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
	var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/
	
	// timezone tokens
	var parseTokenTimezone = /([Z+-].*)$/
	var parseTokenTimezoneZ = /^(Z)$/
	var parseTokenTimezoneHH = /^([+-])(\d{2})$/
	var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/
	
	/**
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * @param {Date|String|Number} argument - the value to convert
	 * @param {Object} [options] - the object with options
	 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parse('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Parse string '+02014101',
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parse('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parse (argument, dirtyOptions) {
	  if (isDate(argument)) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime())
	  } else if (typeof argument !== 'string') {
	    return new Date(argument)
	  }
	
	  var options = dirtyOptions || {}
	  var additionalDigits = options.additionalDigits
	  if (additionalDigits == null) {
	    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
	  } else {
	    additionalDigits = Number(additionalDigits)
	  }
	
	  var dateStrings = splitDateString(argument)
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
	  var year = parseYearResult.year
	  var restDateString = parseYearResult.restDateString
	
	  var date = parseDate(restDateString, year)
	
	  if (date) {
	    var timestamp = date.getTime()
	    var time = 0
	    var offset
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time)
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
	    } else {
	      var fullTime = timestamp + time
	      var fullTimeDate = new Date(fullTime)
	
	      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)
	
	      // Adjust time when it's coming from DST
	      var fullTimeDateNextDay = new Date(fullTime)
	      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
	      var offsetDiff =
	        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
	        getTimezoneOffsetInMilliseconds(fullTimeDate)
	      if (offsetDiff > 0) {
	        offset += offsetDiff
	      }
	    }
	
	    return new Date(timestamp + time + offset)
	  } else {
	    return new Date(argument)
	  }
	}
	
	function splitDateString (dateString) {
	  var dateStrings = {}
	  var array = dateString.split(parseTokenDateTimeDelimeter)
	  var timeString
	
	  if (parseTokenPlainTime.test(array[0])) {
	    dateStrings.date = null
	    timeString = array[0]
	  } else {
	    dateStrings.date = array[0]
	    timeString = array[1]
	  }
	
	  if (timeString) {
	    var token = parseTokenTimezone.exec(timeString)
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '')
	      dateStrings.timezone = token[1]
	    } else {
	      dateStrings.time = timeString
	    }
	  }
	
	  return dateStrings
	}
	
	function parseYear (dateString, additionalDigits) {
	  var parseTokenYYY = parseTokensYYY[additionalDigits]
	  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]
	
	  var token
	
	  // YYYY or ±YYYYY
	  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
	  if (token) {
	    var yearString = token[1]
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    }
	  }
	
	  // YY or ±YYY
	  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
	  if (token) {
	    var centuryString = token[1]
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    }
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  }
	}
	
	function parseDate (dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null
	  }
	
	  var token
	  var date
	  var month
	  var week
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0)
	    date.setUTCFullYear(year)
	    return date
	  }
	
	  // YYYY-MM
	  token = parseTokenMM.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    date.setUTCFullYear(year, month)
	    return date
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = parseTokenDDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    var dayOfYear = parseInt(token[1], 10)
	    date.setUTCFullYear(year, 0, dayOfYear)
	    return date
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = parseTokenMMDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    var day = parseInt(token[2], 10)
	    date.setUTCFullYear(year, month, day)
	    return date
	  }
	
	  // YYYY-Www or YYYYWww
	  token = parseTokenWww.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    return dayOfISOYear(year, week)
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = parseTokenWwwD.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    var dayOfWeek = parseInt(token[2], 10) - 1
	    return dayOfISOYear(year, week, dayOfWeek)
	  }
	
	  // Invalid ISO-formatted date
	  return null
	}
	
	function parseTime (timeString) {
	  var token
	  var hours
	  var minutes
	
	  // hh
	  token = parseTokenHH.exec(timeString)
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR
	  }
	
	  // hh:mm or hhmm
	  token = parseTokenHHMM.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseFloat(token[2].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE
	  }
	
	  // hh:mm:ss or hhmmss
	  token = parseTokenHHMMSS.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseInt(token[2], 10)
	    var seconds = parseFloat(token[3].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE +
	      seconds * 1000
	  }
	
	  // Invalid ISO-formatted time
	  return null
	}
	
	function parseTimezone (timezoneString) {
	  var token
	  var absoluteOffset
	
	  // Z
	  token = parseTokenTimezoneZ.exec(timezoneString)
	  if (token) {
	    return 0
	  }
	
	  // ±hh
	  token = parseTokenTimezoneHH.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  // ±hh:mm or ±hhmm
	  token = parseTokenTimezoneHHMM.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  return 0
	}
	
	function dayOfISOYear (isoYear, week, day) {
	  week = week || 0
	  day = day || 0
	  var date = new Date(0)
	  date.setUTCFullYear(isoYear, 0, 4)
	  var fourthOfJanuaryDay = date.getUTCDay() || 7
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
	  date.setUTCDate(date.getUTCDate() + diff)
	  return date
	}
	
	module.exports = parse


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1017);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1016);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(203);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(203);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(493);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(494);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _react.PropTypes.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _react.PropTypes.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _react.PropTypes.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(36);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.adyenDropInAccount = exports.mapPrefixNumber = exports.adminUserIds = exports.disabledCart = undefined;
	exports.serializeSpecialChars = serializeSpecialChars;
	exports.maskEventRemarks = maskEventRemarks;
	exports.ellipses = ellipses;
	exports.numbersWithComma = numbersWithComma;
	exports.maskAddressErrorMessage = maskAddressErrorMessage;
	exports.maskLocationName = maskLocationName;
	exports.maskRedirectLink = maskRedirectLink;
	exports.isMigratedEventRemarks = isMigratedEventRemarks;
	exports.extensionDetect = extensionDetect;
	exports.netcoreScript = netcoreScript;
	exports.maskOriginID = maskOriginID;
	exports.prefixNumber = prefixNumber;
	exports.handleEnvironment = handleEnvironment;
	exports.maskCartWarehouseLabel = maskCartWarehouseLabel;
	exports.maskWarehouseById = maskWarehouseById;
	
	var _dateFns = __webpack_require__(54);
	
	/* eslint-disable */
	var appConfig = __webpack_require__(71);
	/* eslint-enable */
	var utf8 = __webpack_require__(1198);
	
	function serializeSpecialChars(string) {
	  try {
	    var encoded = utf8.decode(string);
	  } catch (e) {
	    return string;
	  }
	  return encoded;
	}
	
	function maskEventRemarks(event, status_updated_at, status, ev) {
	  if (status === 'accepted' && event && event.toLowerCase().includes('accepted at')) {
	    return "Your shipment has cleared customs and arrived at XORTING CENTER";
	  } else if (event === "Processed by WMS" || event === "Processed by WASP") {
	    return "Your shipment is packed and will be handed over to our forwarding partner.";
	  } else if (event && event.toLowerCase().includes('not delivered due to an unforeseen event.')) {
	    return 'Your shipment will be scheduled for redelivery within 2 days.';
	  } else if (event && event.toLowerCase().includes('estimated')) {
	    return event + (' (' + (0, _dateFns.format)(status_updated_at, 'MM/DD/YYYY') + ')');
	  } else if (event && event.toLowerCase().includes('accepted at office')) {
	    return "Your shipment has been accepted by our forwarding  partner and is on the way to your doorstep.";
	  } else if (event && event.toLowerCase().includes('accepted at lbc express inc')) {
	    return "Your shipment has been accepted by our forwarding  partner and is on the way to your doorstep.";
	  } else if (event && event.toLowerCase().includes('accepted at branch south san francisco')) {
	    return "Your shipment has been accepted by our forwarding  partner and is on the way to your doorstep.";
	  }
	  return event;
	}
	
	function ellipses(word, clipper) {
	  if (word.length > clipper) return word.substring(0, clipper - 2) + '...';
	  return word;
	}
	
	function numbersWithComma(x) {
	  var parts = x.toString().split(".");
	  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	  return parts.join(".");
	}
	
	function maskAddressErrorMessage(msg, country) {
	  if (country === "MY") {
	    if (msg.includes("barangay")) {
	      return msg.replace("barangay", "district/barangay");
	    } else if (msg.includes("province")) {
	      return msg.replace("province", "state/province");
	    }
	  }
	
	  return msg;
	}
	
	function maskLocationName(location) {
	  switch (location) {
	    case "US":
	      return "US";
	    case "UK":
	      return "UK";
	    case "MY":
	      return "Malaysia";
	    case "PH":
	      return "Philippines";
	    default:
	      return location;
	  }
	}
	
	function maskRedirectLink(type, reference_id) {
	  switch (type.redirection_type) {
	    case "prohibited":
	      return "/prohibited";
	    case "item_details":
	      return (/parcel/ + type.item_id
	      );
	    case "order_details":
	      return (/track/ + type.tracking_number
	      );
	    case "payment_success":
	      return (/track/ + type.tracking_number
	      );
	    case "payment_failed":
	      return '/shipment#' + reference_id;
	    case "package_accepted":
	      return '/help-center#delivery';
	    case "delivered":
	      return window.location.pathname;
	    case "vas_completed":
	    case "vas_approved":
	    case "vas_rejected":
	    case "vas_payment_success":
	    case "vas_payment_failed":
	      return (/parcel/ + type.parcel_id
	      );
	    case "terms_and_conditions":
	      return "/terms-conditions";
	    default:
	      return type;
	  }
	}
	
	function isMigratedEventRemarks(remark_date) {
	  return (0, _dateFns.isBefore)((0, _dateFns.format)(remark_date, 'MM/DD/YYYY HH:mm:ss'), (0, _dateFns.format)('2018-03-08', 'MM/DD/YYYY HH:mm:ss'));
	}
	
	function extensionDetect(extensionId) {
	  var script = document.createElement('script');
	  script.onload = function () {
	    setExtDetect(true);
	  };
	  script.onerror = function () {
	    setExtDetect(false);
	  };
	  script.src = 'chrome-extension://' + extensionId + '/assets';
	  document.body.appendChild(script);
	}
	
	function setExtDetect(value) {
	  if (value) {
	    localStorage.setItem("cartExtensionModalShowed", value);
	  }
	}
	
	function netcoreScript(accountNumber) {
	  window.smartech('create', 'ADGMOT35CHFLVDHBJNIG50K969R5IJDR7QSKURD40EMEKF18IN70');
	  window.smartech('register', '5cbfa9252c18508b714b90fa118de653');
	  window.smartech('identify', accountNumber ? accountNumber : ""); // under '', please pass the EMAIL of web visitor. Else please do not pass any value
	  window.smartech('dispatch', 1, {});
	};
	
	var disabledCart = exports.disabledCart = false;
	
	var adminUserIds = exports.adminUserIds = ['34-673340', '20-595738', '61-854920', '77-363736', '65-276502', '70-769683', '87-260932', '39-583168', '64-106181', '12-420535', '36-466687', '28-615882', '27-408808'];
	
	function maskOriginID(origin) {
	  switch (origin) {
	    case "US":
	      return 1;
	    case "UK":
	      return 2;
	    case "AU":
	      return 3;
	    case "KR":
	      return 4;
	    case "JP":
	      return 5;
	    case "OR":
	      return 6;
	    default:
	      return 6;
	  }
	}
	
	function prefixNumber(prefix) {
	  switch (prefix) {
	    case '+63':
	    case '+60':
	    case '001':
	    case '+44':
	    case '+61':
	    case '+82':
	    case '+81':
	      return true;
	    default:
	      return false;
	  }
	}
	
	var mapPrefixNumber = exports.mapPrefixNumber = [{ value: "+63", label: "PH +63" }, { value: "+60", label: "MY +60" }, { value: "001", label: "US 001" }, { value: "+44", label: "UK +44" }, { value: "+61", label: "AU +61" }, { value: "+82", label: "KR +82" }, { value: "+81", label: "JP +81" }];
	
	var adyenDropInAccount = exports.adyenDropInAccount = [
	//staging
	'46-258241', '14-101899', '55-498385', '53-228572', '53-504119', '81-765901', '91-174784',
	//prod
	'87-260932', '39-583168', '85-226208', '63-295648'];
	
	function handleEnvironment(prefix) {
	  var url = appConfig.scApiUrl;
	  if (url.includes('locahost')) {
	    return 'test';
	  }
	  if (url.includes('dev')) {
	    return 'test';
	  }
	  if (url.includes('staging')) {
	    return 'test';
	  }
	  return 'live';
	};
	
	function maskCartWarehouseLabel(location, filterWarehouse) {
	  if (filterWarehouse) {
	    switch (location.id) {
	      case 1:
	      case 6:
	        return "US";
	      default:
	        return location.country_code;
	    }
	  }
	  return location.country_code;
	}
	
	function maskWarehouseById(id) {
	  switch (id) {
	    case 1:
	      return "CA,US";
	    case 2:
	      return "UK";
	    case 3:
	      return "AU";
	    case 4:
	      return "KR";
	    case 5:
	      return "JP";
	    case 6:
	      return "OR,US";
	    default:
	      return id;
	  }
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(57);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(227);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(85);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1142);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(536);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1138);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1153);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1139);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1140);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(538);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1141);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(228);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1151);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(543);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1144);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1145);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1149);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(540);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(698);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(152);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(654)
	var ieee754 = __webpack_require__(893)
	var isArray = __webpack_require__(896)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer, (function() { return this; }())))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1036);


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = undefined;
	
	var _redux = __webpack_require__(58);
	
	var _reactRouterRedux = __webpack_require__(534);
	
	var _reactRouter = __webpack_require__(14);
	
	var _index = __webpack_require__(645);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reduxLogger = __webpack_require__(1171);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reduxThunk = __webpack_require__(1174);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxPromiseMiddleware = __webpack_require__(1172);
	
	var _reduxPromiseMiddleware2 = _interopRequireDefault(_reduxPromiseMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//create an Object for default data
	
	//import the root reducer
	var enhancers = (0, _redux.compose)(window.devToolsExtension ? window.devToolsExtension() : function (f) {
	  return f;
	});
	
	//middleware, promises and logger
	
	var middleware = null;
	if (false) {
	  middleware = (0, _redux.applyMiddleware)((0, _reduxPromiseMiddleware2.default)(), _reduxThunk2.default, (0, _reduxLogger2.default)());
	} else {
	  middleware = (0, _redux.applyMiddleware)((0, _reduxPromiseMiddleware2.default)(), _reduxThunk2.default);
	}
	var store = (0, _redux.createStore)(_index2.default, enhancers, middleware);
	var history = exports.history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	if (false) {
	  module.hot.accept('./reducers/', function () {
	    var nextRootReducer = require('./reducers/index').default;
	    store.replaceReducer(nextRootReducer);
	  });
	}
	
	exports.default = store;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var DOMProperty = __webpack_require__(82);
	var ReactDOMComponentFlags = __webpack_require__(499);
	
	var invariant = __webpack_require__(11);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 22 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 25 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(565);

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable */
	var appConfig = __webpack_require__(71);
	/* eslint-enable */
	
	var URL = appConfig.scApiUrl;
	var LBCX = appConfig.f3ApiUrl;
	
	module.exports = {
	    Actions: {
	        rootUrl: URL,
	        api: URL + 'api/',
	        apiAuth: URL + 'auth/',
	        f3: LBCX
	    }
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 31 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Load modules
	
	var Crypto = __webpack_require__(270);
	var Path = __webpack_require__(941);
	var Util = __webpack_require__(59);
	var Escape = __webpack_require__(892);
	
	
	// Declare internals
	
	var internals = {};
	
	
	// Clone object or array
	
	exports.clone = function (obj, seen) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    seen = seen || { orig: [], copy: [] };
	
	    var lookup = seen.orig.indexOf(obj);
	    if (lookup !== -1) {
	        return seen.copy[lookup];
	    }
	
	    var newObj;
	    var cloneDeep = false;
	
	    if (!Array.isArray(obj)) {
	        if (Buffer.isBuffer(obj)) {
	            newObj = new Buffer(obj);
	        }
	        else if (obj instanceof Date) {
	            newObj = new Date(obj.getTime());
	        }
	        else if (obj instanceof RegExp) {
	            newObj = new RegExp(obj);
	        }
	        else {
	            var proto = Object.getPrototypeOf(obj);
	            if (proto &&
	                proto.isImmutable) {
	
	                newObj = obj;
	            }
	            else {
	                newObj = Object.create(proto);
	                cloneDeep = true;
	            }
	        }
	    }
	    else {
	        newObj = [];
	        cloneDeep = true;
	    }
	
	    seen.orig.push(obj);
	    seen.copy.push(newObj);
	
	    if (cloneDeep) {
	        var keys = Object.getOwnPropertyNames(obj);
	        for (var i = 0, il = keys.length; i < il; ++i) {
	            var key = keys[i];
	            var descriptor = Object.getOwnPropertyDescriptor(obj, key);
	            if (descriptor &&
	                (descriptor.get ||
	                 descriptor.set)) {
	
	                Object.defineProperty(newObj, key, descriptor);
	            }
	            else {
	                newObj[key] = exports.clone(obj[key], seen);
	            }
	        }
	    }
	
	    return newObj;
	};
	
	
	// Merge all the properties of source into target, source wins in conflict, and by default null and undefined from source are applied
	/*eslint-disable */
	exports.merge = function (target, source, isNullOverride /* = true */, isMergeArrays /* = true */) {
	/*eslint-enable */
	    exports.assert(target && typeof target === 'object', 'Invalid target value: must be an object');
	    exports.assert(source === null || source === undefined || typeof source === 'object', 'Invalid source value: must be null, undefined, or an object');
	
	    if (!source) {
	        return target;
	    }
	
	    if (Array.isArray(source)) {
	        exports.assert(Array.isArray(target), 'Cannot merge array onto an object');
	        if (isMergeArrays === false) {                                                  // isMergeArrays defaults to true
	            target.length = 0;                                                          // Must not change target assignment
	        }
	
	        for (var i = 0, il = source.length; i < il; ++i) {
	            target.push(exports.clone(source[i]));
	        }
	
	        return target;
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	        if (value &&
	            typeof value === 'object') {
	
	            if (!target[key] ||
	                typeof target[key] !== 'object' ||
	                (Array.isArray(target[key]) ^ Array.isArray(value)) ||
	                value instanceof Date ||
	                Buffer.isBuffer(value) ||
	                value instanceof RegExp) {
	
	                target[key] = exports.clone(value);
	            }
	            else {
	                exports.merge(target[key], value, isNullOverride, isMergeArrays);
	            }
	        }
	        else {
	            if (value !== null &&
	                value !== undefined) {                              // Explicit to preserve empty strings
	
	                target[key] = value;
	            }
	            else if (isNullOverride !== false) {                    // Defaults to true
	                target[key] = value;
	            }
	        }
	    }
	
	    return target;
	};
	
	
	// Apply options to a copy of the defaults
	
	exports.applyToDefaults = function (defaults, options, isNullOverride) {
	
	    exports.assert(defaults && typeof defaults === 'object', 'Invalid defaults value: must be an object');
	    exports.assert(!options || options === true || typeof options === 'object', 'Invalid options value: must be true, falsy or an object');
	
	    if (!options) {                                                 // If no options, return null
	        return null;
	    }
	
	    var copy = exports.clone(defaults);
	
	    if (options === true) {                                         // If options is set to true, use defaults
	        return copy;
	    }
	
	    return exports.merge(copy, options, isNullOverride === true, false);
	};
	
	
	// Clone an object except for the listed keys which are shallow copied
	
	exports.cloneWithShallow = function (source, keys) {
	
	    if (!source ||
	        typeof source !== 'object') {
	
	        return source;
	    }
	
	    var storage = internals.store(source, keys);    // Move shallow copy items to storage
	    var copy = exports.clone(source);               // Deep copy the rest
	    internals.restore(copy, source, storage);       // Shallow copy the stored items and restore
	    return copy;
	};
	
	
	internals.store = function (source, keys) {
	
	    var storage = {};
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var value = exports.reach(source, key);
	        if (value !== undefined) {
	            storage[key] = value;
	            internals.reachSet(source, key, undefined);
	        }
	    }
	
	    return storage;
	};
	
	
	internals.restore = function (copy, source, storage) {
	
	    var keys = Object.keys(storage);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        internals.reachSet(copy, key, storage[key]);
	        internals.reachSet(source, key, storage[key]);
	    }
	};
	
	
	internals.reachSet = function (obj, key, value) {
	
	    var path = key.split('.');
	    var ref = obj;
	    for (var i = 0, il = path.length; i < il; ++i) {
	        var segment = path[i];
	        if (i + 1 === il) {
	            ref[segment] = value;
	        }
	
	        ref = ref[segment];
	    }
	};
	
	
	// Apply options to defaults except for the listed keys which are shallow copied from option without merging
	
	exports.applyToDefaultsWithShallow = function (defaults, options, keys) {
	
	    exports.assert(defaults && typeof defaults === 'object', 'Invalid defaults value: must be an object');
	    exports.assert(!options || options === true || typeof options === 'object', 'Invalid options value: must be true, falsy or an object');
	    exports.assert(keys && Array.isArray(keys), 'Invalid keys');
	
	    if (!options) {                                                 // If no options, return null
	        return null;
	    }
	
	    var copy = exports.cloneWithShallow(defaults, keys);
	
	    if (options === true) {                                         // If options is set to true, use defaults
	        return copy;
	    }
	
	    var storage = internals.store(options, keys);   // Move shallow copy items to storage
	    exports.merge(copy, options, false, false);     // Deep copy the rest
	    internals.restore(copy, options, storage);      // Shallow copy the stored items and restore
	    return copy;
	};
	
	
	// Deep object or array comparison
	
	exports.deepEqual = function (obj, ref, options, seen) {
	
	    options = options || { prototype: true };
	
	    var type = typeof obj;
	
	    if (type !== typeof ref) {
	        return false;
	    }
	
	    if (type !== 'object' ||
	        obj === null ||
	        ref === null) {
	
	        if (obj === ref) {                                                      // Copied from Deep-eql, copyright(c) 2013 Jake Luer, jake@alogicalparadox.com, MIT Licensed, https://github.com/chaijs/deep-eql
	            return obj !== 0 || 1 / obj === 1 / ref;        // -0 / +0
	        }
	
	        return obj !== obj && ref !== ref;                  // NaN
	    }
	
	    seen = seen || [];
	    if (seen.indexOf(obj) !== -1) {
	        return true;                            // If previous comparison failed, it would have stopped execution
	    }
	
	    seen.push(obj);
	
	    if (Array.isArray(obj)) {
	        if (!Array.isArray(ref)) {
	            return false;
	        }
	
	        if (!options.part && obj.length !== ref.length) {
	            return false;
	        }
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (options.part) {
	                var found = false;
	                for (var r = 0, rl = ref.length; r < rl; ++r) {
	                    if (exports.deepEqual(obj[i], ref[r], options, seen)) {
	                        found = true;
	                        break;
	                    }
	                }
	
	                return found;
	            }
	
	            if (!exports.deepEqual(obj[i], ref[i], options, seen)) {
	                return false;
	            }
	        }
	
	        return true;
	    }
	
	    if (Buffer.isBuffer(obj)) {
	        if (!Buffer.isBuffer(ref)) {
	            return false;
	        }
	
	        if (obj.length !== ref.length) {
	            return false;
	        }
	
	        for (var j = 0, jl = obj.length; j < jl; ++j) {
	            if (obj[j] !== ref[j]) {
	                return false;
	            }
	        }
	
	        return true;
	    }
	
	    if (obj instanceof Date) {
	        return (ref instanceof Date && obj.getTime() === ref.getTime());
	    }
	
	    if (obj instanceof RegExp) {
	        return (ref instanceof RegExp && obj.toString() === ref.toString());
	    }
	
	    if (options.prototype) {
	        if (Object.getPrototypeOf(obj) !== Object.getPrototypeOf(ref)) {
	            return false;
	        }
	    }
	
	    var keys = Object.getOwnPropertyNames(obj);
	
	    if (!options.part && keys.length !== Object.getOwnPropertyNames(ref).length) {
	        return false;
	    }
	
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var descriptor = Object.getOwnPropertyDescriptor(obj, key);
	        if (descriptor.get) {
	            if (!exports.deepEqual(descriptor, Object.getOwnPropertyDescriptor(ref, key), options, seen)) {
	                return false;
	            }
	        }
	        else if (!exports.deepEqual(obj[key], ref[key], options, seen)) {
	            return false;
	        }
	    }
	
	    return true;
	};
	
	
	// Remove duplicate items from array
	
	exports.unique = function (array, key) {
	
	    var index = {};
	    var result = [];
	
	    for (var i = 0, il = array.length; i < il; ++i) {
	        var id = (key ? array[i][key] : array[i]);
	        if (index[id] !== true) {
	
	            result.push(array[i]);
	            index[id] = true;
	        }
	    }
	
	    return result;
	};
	
	
	// Convert array into object
	
	exports.mapToObject = function (array, key) {
	
	    if (!array) {
	        return null;
	    }
	
	    var obj = {};
	    for (var i = 0, il = array.length; i < il; ++i) {
	        if (key) {
	            if (array[i][key]) {
	                obj[array[i][key]] = true;
	            }
	        }
	        else {
	            obj[array[i]] = true;
	        }
	    }
	
	    return obj;
	};
	
	
	// Find the common unique items in two arrays
	
	exports.intersect = function (array1, array2, justFirst) {
	
	    if (!array1 || !array2) {
	        return [];
	    }
	
	    var common = [];
	    var hash = (Array.isArray(array1) ? exports.mapToObject(array1) : array1);
	    var found = {};
	    for (var i = 0, il = array2.length; i < il; ++i) {
	        if (hash[array2[i]] && !found[array2[i]]) {
	            if (justFirst) {
	                return array2[i];
	            }
	
	            common.push(array2[i]);
	            found[array2[i]] = true;
	        }
	    }
	
	    return (justFirst ? null : common);
	};
	
	
	// Test if the reference contains the values
	
	exports.contain = function (ref, values, options) {
	
	    /*
	        string -> string(s)
	        array -> item(s)
	        object -> key(s)
	        object -> object (key:value)
	    */
	
	    var valuePairs = null;
	    if (typeof ref === 'object' &&
	        typeof values === 'object' &&
	        !Array.isArray(ref) &&
	        !Array.isArray(values)) {
	
	        valuePairs = values;
	        values = Object.keys(values);
	    }
	    else {
	        values = [].concat(values);
	    }
	
	    options = options || {};            // deep, once, only, part
	
	    exports.assert(arguments.length >= 2, 'Insufficient arguments');
	    exports.assert(typeof ref === 'string' || typeof ref === 'object', 'Reference must be string or an object');
	    exports.assert(values.length, 'Values array cannot be empty');
	
	    var compare, compareFlags;
	    if (options.deep) {
	        compare = exports.deepEqual;
	
	        var hasOnly = options.hasOwnProperty('only'), hasPart = options.hasOwnProperty('part');
	
	        compareFlags = {
	            prototype: hasOnly ? options.only : hasPart ? !options.part : false,
	            part: hasOnly ? !options.only : hasPart ? options.part : true
	        };
	    }
	    else {
	        compare = function (a, b) {
	
	            return a === b;
	        };
	    }
	
	    var misses = false;
	    var matches = new Array(values.length);
	    for (var i = 0, il = matches.length; i < il; ++i) {
	        matches[i] = 0;
	    }
	
	    if (typeof ref === 'string') {
	        var pattern = '(';
	        for (i = 0, il = values.length; i < il; ++i) {
	            var value = values[i];
	            exports.assert(typeof value === 'string', 'Cannot compare string reference to non-string value');
	            pattern += (i ? '|' : '') + exports.escapeRegex(value);
	        }
	
	        var regex = new RegExp(pattern + ')', 'g');
	        var leftovers = ref.replace(regex, function ($0, $1) {
	
	            var index = values.indexOf($1);
	            ++matches[index];
	            return '';          // Remove from string
	        });
	
	        misses = !!leftovers;
	    }
	    else if (Array.isArray(ref)) {
	        for (i = 0, il = ref.length; i < il; ++i) {
	            for (var j = 0, jl = values.length, matched = false; j < jl && matched === false; ++j) {
	                matched = compare(values[j], ref[i], compareFlags) && j;
	            }
	
	            if (matched !== false) {
	                ++matches[matched];
	            }
	            else {
	                misses = true;
	            }
	        }
	    }
	    else {
	        var keys = Object.keys(ref);
	        for (i = 0, il = keys.length; i < il; ++i) {
	            var key = keys[i];
	            var pos = values.indexOf(key);
	            if (pos !== -1) {
	                if (valuePairs &&
	                    !compare(valuePairs[key], ref[key], compareFlags)) {
	
	                    return false;
	                }
	
	                ++matches[pos];
	            }
	            else {
	                misses = true;
	            }
	        }
	    }
	
	    var result = false;
	    for (i = 0, il = matches.length; i < il; ++i) {
	        result = result || !!matches[i];
	        if ((options.once && matches[i] > 1) ||
	            (!options.part && !matches[i])) {
	
	            return false;
	        }
	    }
	
	    if (options.only &&
	        misses) {
	
	        return false;
	    }
	
	    return result;
	};
	
	
	// Flatten array
	
	exports.flatten = function (array, target) {
	
	    var result = target || [];
	
	    for (var i = 0, il = array.length; i < il; ++i) {
	        if (Array.isArray(array[i])) {
	            exports.flatten(array[i], result);
	        }
	        else {
	            result.push(array[i]);
	        }
	    }
	
	    return result;
	};
	
	
	// Convert an object key chain string ('a.b.c') to reference (object[a][b][c])
	
	exports.reach = function (obj, chain, options) {
	
	    if (chain === false ||
	        chain === null ||
	        typeof chain === 'undefined') {
	
	        return obj;
	    }
	
	    options = options || {};
	    if (typeof options === 'string') {
	        options = { separator: options };
	    }
	
	    var path = chain.split(options.separator || '.');
	    var ref = obj;
	    for (var i = 0, il = path.length; i < il; ++i) {
	        var key = path[i];
	        if (key[0] === '-' && Array.isArray(ref)) {
	            key = key.slice(1, key.length);
	            key = ref.length - key;
	        }
	
	        if (!ref ||
	            !ref.hasOwnProperty(key) ||
	            (typeof ref !== 'object' && options.functions === false)) {         // Only object and function can have properties
	
	            exports.assert(!options.strict || i + 1 === il, 'Missing segment', key, 'in reach path ', chain);
	            exports.assert(typeof ref === 'object' || options.functions === true || typeof ref !== 'function', 'Invalid segment', key, 'in reach path ', chain);
	            ref = options.default;
	            break;
	        }
	
	        ref = ref[key];
	    }
	
	    return ref;
	};
	
	
	exports.reachTemplate = function (obj, template, options) {
	
	    return template.replace(/{([^}]+)}/g, function ($0, chain) {
	
	        var value = exports.reach(obj, chain, options);
	        return (value === undefined || value === null ? '' : value);
	    });
	};
	
	
	exports.formatStack = function (stack) {
	
	    var trace = [];
	    for (var i = 0, il = stack.length; i < il; ++i) {
	        var item = stack[i];
	        trace.push([item.getFileName(), item.getLineNumber(), item.getColumnNumber(), item.getFunctionName(), item.isConstructor()]);
	    }
	
	    return trace;
	};
	
	
	exports.formatTrace = function (trace) {
	
	    var display = [];
	
	    for (var i = 0, il = trace.length; i < il; ++i) {
	        var row = trace[i];
	        display.push((row[4] ? 'new ' : '') + row[3] + ' (' + row[0] + ':' + row[1] + ':' + row[2] + ')');
	    }
	
	    return display;
	};
	
	
	exports.callStack = function (slice) {
	
	    // http://code.google.com/p/v8/wiki/JavaScriptStackTraceApi
	
	    var v8 = Error.prepareStackTrace;
	    Error.prepareStackTrace = function (err, stack) {
	
	        return stack;
	    };
	
	    var capture = {};
	    Error.captureStackTrace(capture, arguments.callee);     /*eslint no-caller:0 */
	    var stack = capture.stack;
	
	    Error.prepareStackTrace = v8;
	
	    var trace = exports.formatStack(stack);
	
	    if (slice) {
	        return trace.slice(slice);
	    }
	
	    return trace;
	};
	
	
	exports.displayStack = function (slice) {
	
	    var trace = exports.callStack(slice === undefined ? 1 : slice + 1);
	
	    return exports.formatTrace(trace);
	};
	
	
	exports.abortThrow = false;
	
	
	exports.abort = function (message, hideStack) {
	
	    if (("production") === 'test' || exports.abortThrow === true) {
	        throw new Error(message || 'Unknown error');
	    }
	
	    var stack = '';
	    if (!hideStack) {
	        stack = exports.displayStack(1).join('\n\t');
	    }
	    console.log('ABORT: ' + message + '\n\t' + stack);
	    process.exit(1);
	};
	
	
	exports.assert = function (condition /*, msg1, msg2, msg3 */) {
	
	    if (condition) {
	        return;
	    }
	
	    if (arguments.length === 2 && arguments[1] instanceof Error) {
	        throw arguments[1];
	    }
	
	    var msgs = [];
	    for (var i = 1, il = arguments.length; i < il; ++i) {
	        if (arguments[i] !== '') {
	            msgs.push(arguments[i]);            // Avoids Array.slice arguments leak, allowing for V8 optimizations
	        }
	    }
	
	    msgs = msgs.map(function (msg) {
	
	        return typeof msg === 'string' ? msg : msg instanceof Error ? msg.message : exports.stringify(msg);
	    });
	    throw new Error(msgs.join(' ') || 'Unknown error');
	};
	
	
	exports.Timer = function () {
	
	    this.ts = 0;
	    this.reset();
	};
	
	
	exports.Timer.prototype.reset = function () {
	
	    this.ts = Date.now();
	};
	
	
	exports.Timer.prototype.elapsed = function () {
	
	    return Date.now() - this.ts;
	};
	
	
	exports.Bench = function () {
	
	    this.ts = 0;
	    this.reset();
	};
	
	
	exports.Bench.prototype.reset = function () {
	
	    this.ts = exports.Bench.now();
	};
	
	
	exports.Bench.prototype.elapsed = function () {
	
	    return exports.Bench.now() - this.ts;
	};
	
	
	exports.Bench.now = function () {
	
	    var ts = process.hrtime();
	    return (ts[0] * 1e3) + (ts[1] / 1e6);
	};
	
	
	// Escape string for Regex construction
	
	exports.escapeRegex = function (string) {
	
	    // Escape ^$.*+-?=!:|\/()[]{},
	    return string.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, '\\$&');
	};
	
	
	// Base64url (RFC 4648) encode
	
	exports.base64urlEncode = function (value, encoding) {
	
	    var buf = (Buffer.isBuffer(value) ? value : new Buffer(value, encoding || 'binary'));
	    return buf.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
	};
	
	
	// Base64url (RFC 4648) decode
	
	exports.base64urlDecode = function (value, encoding) {
	
	    if (value &&
	        !/^[\w\-]*$/.test(value)) {
	
	        return new Error('Invalid character');
	    }
	
	    try {
	        var buf = new Buffer(value, 'base64');
	        return (encoding === 'buffer' ? buf : buf.toString(encoding || 'binary'));
	    }
	    catch (err) {
	        return err;
	    }
	};
	
	
	// Escape attribute value for use in HTTP header
	
	exports.escapeHeaderAttribute = function (attribute) {
	
	    // Allowed value characters: !#$%&'()*+,-./:;<=>?@[]^_`{|}~ and space, a-z, A-Z, 0-9, \, "
	
	    exports.assert(/^[ \w\!#\$%&'\(\)\*\+,\-\.\/\:;<\=>\?@\[\]\^`\{\|\}~\"\\]*$/.test(attribute), 'Bad attribute value (' + attribute + ')');
	
	    return attribute.replace(/\\/g, '\\\\').replace(/\"/g, '\\"');                             // Escape quotes and slash
	};
	
	
	exports.escapeHtml = function (string) {
	
	    return Escape.escapeHtml(string);
	};
	
	
	exports.escapeJavaScript = function (string) {
	
	    return Escape.escapeJavaScript(string);
	};
	
	
	exports.nextTick = function (callback) {
	
	    return function () {
	
	        var args = arguments;
	        process.nextTick(function () {
	
	            callback.apply(null, args);
	        });
	    };
	};
	
	
	exports.once = function (method) {
	
	    if (method._hoekOnce) {
	        return method;
	    }
	
	    var once = false;
	    var wrapped = function () {
	
	        if (!once) {
	            once = true;
	            method.apply(null, arguments);
	        }
	    };
	
	    wrapped._hoekOnce = true;
	
	    return wrapped;
	};
	
	
	exports.isAbsolutePath = function (path, platform) {
	
	    if (!path) {
	        return false;
	    }
	
	    if (Path.isAbsolute) {                      // node >= 0.11
	        return Path.isAbsolute(path);
	    }
	
	    platform = platform || process.platform;
	
	    // Unix
	
	    if (platform !== 'win32') {
	        return path[0] === '/';
	    }
	
	    // Windows
	
	    return !!/^(?:[a-zA-Z]:[\\\/])|(?:[\\\/]{2}[^\\\/]+[\\\/]+[^\\\/])/.test(path);        // C:\ or \\something\something
	};
	
	
	exports.isInteger = function (value) {
	
	    return (typeof value === 'number' &&
	            parseFloat(value) === parseInt(value, 10) &&
	            !isNaN(value));
	};
	
	
	exports.ignore = function () { };
	
	
	exports.inherits = Util.inherits;
	
	
	exports.format = Util.format;
	
	
	exports.transform = function (source, transform, options) {
	
	    exports.assert(source === null || source === undefined || typeof source === 'object' || Array.isArray(source), 'Invalid source object: must be null, undefined, an object, or an array');
	
	    if (Array.isArray(source)) {
	        var results = [];
	        for (var i = 0, il = source.length; i < il; ++i) {
	            results.push(exports.transform(source[i], transform, options));
	        }
	        return results;
	    }
	
	    var result = {};
	    var keys = Object.keys(transform);
	
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var path = key.split('.');
	        var sourcePath = transform[key];
	
	        exports.assert(typeof sourcePath === 'string', 'All mappings must be "." delineated strings');
	
	        var segment;
	        var res = result;
	
	        while (path.length > 1) {
	            segment = path.shift();
	            if (!res[segment]) {
	                res[segment] = {};
	            }
	            res = res[segment];
	        }
	        segment = path.shift();
	        res[segment] = exports.reach(source, sourcePath, options);
	    }
	
	    return result;
	};
	
	
	exports.uniqueFilename = function (path, extension) {
	
	    if (extension) {
	        extension = extension[0] !== '.' ? '.' + extension : extension;
	    }
	    else {
	        extension = '';
	    }
	
	    path = Path.resolve(path);
	    var name = [Date.now(), process.pid, Crypto.randomBytes(8).toString('hex')].join('-') + extension;
	    return Path.join(path, name);
	};
	
	
	exports.stringify = function () {
	
	    try {
	        return JSON.stringify.apply(null, arguments);
	    }
	    catch (err) {
	        return '[Cannot display object: ' + err.message + ']';
	    }
	};
	
	
	exports.shallow = function (source) {
	
	    var target = {};
	    var keys = Object.keys(source);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        target[key] = source[key];
	    }
	
	    return target;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer, __webpack_require__(31)))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(951);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(952);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(953);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(954);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(475);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(109);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(476);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(955);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(956);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(477);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(958);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(959);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(961);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(960);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(198);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(140);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(962);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(141);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(964);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(965);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(968);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(199);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(479);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(969);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(970);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(971);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(974);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(975);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(976);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(480);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(200);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(983);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(984);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(481);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(482);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(483);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(484);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(485);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(987);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(487);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(986);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(486);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(488);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(991);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(992);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(993);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(994);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(995);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _Panel2 = __webpack_require__(997);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(490);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(998);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(999);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(1000);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(1001);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(1002);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(44);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(1003);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(1005);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(201);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(202);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(1006);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(491);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(1007);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(1008);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(1009);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(1010);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(1014);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(238);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 36 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(946)();
	}


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SlimFooter = __webpack_require__(610);
	
	var _SlimFooter2 = _interopRequireDefault(_SlimFooter);
	
	var _FatFooter = __webpack_require__(609);
	
	var _FatFooter2 = _interopRequireDefault(_FatFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var Footer = createReactClass({
	  displayName: 'Footer',
	  renderFooter: function renderFooter() {
	    var slimFooterPages = ['/signin', '/signup', '/signup-success', '/checkout', '/checkout-success', '/reset-password', '/change-password', '/otp-service'];
	
	    if (slimFooterPages.indexOf(this.props.currentPath) > -1) {
	      return _react2.default.createElement(_SlimFooter2.default, this.props);
	    }
	
	    return _react2.default.createElement(_FatFooter2.default, this.props);
	  },
	  render: function render() {
	    return this.renderFooter();
	  }
	});
	
	exports.default = Footer;

/***/ },
/* 39 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.2.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2017-03-20T18:59Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( ">tbody", elem )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with computed style
		var valueIsBorderBox,
			styles = getStyles( elem ),
			val = curCSS( elem, name, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );
	
		// Fall back to offsetWidth/Height when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		if ( val === "auto" ) {
			val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
		}
	
		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var doc, docElem, rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			doc = elem.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( jQuery.isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(169)('wks');
	var uid = __webpack_require__(129);
	var Symbol = __webpack_require__(53).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Load modules
	
	var Hoek = __webpack_require__(32);
	var Ref = __webpack_require__(66);
	var Errors = __webpack_require__(47);
	var Alternatives = null;                // Delay-loaded to prevent circular dependencies
	var Cast = null;
	
	
	// Declare internals
	
	var internals = {};
	
	
	internals.defaults = {
	    abortEarly: true,
	    convert: true,
	    allowUnknown: false,
	    skipFunctions: false,
	    stripUnknown: false,
	    language: {},
	    presence: 'optional',
	    raw: false,
	    strip: false,
	    noDefaults: false
	
	    // context: null
	};
	
	
	internals.checkOptions = function (options) {
	
	    var optionType = {
	        abortEarly: 'boolean',
	        convert: 'boolean',
	        allowUnknown: 'boolean',
	        skipFunctions: 'boolean',
	        stripUnknown: 'boolean',
	        language: 'object',
	        presence: ['string', 'required', 'optional', 'forbidden', 'ignore'],
	        raw: 'boolean',
	        context: 'object',
	        strip: 'boolean',
	        noDefaults: 'boolean'
	    };
	
	    var keys = Object.keys(options);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var opt = optionType[key];
	        var type = opt;
	        var values = null;
	
	        if (Array.isArray(opt)) {
	            type = opt[0];
	            values = opt.slice(1);
	        }
	
	        Hoek.assert(type, 'unknown key ' + key);
	        Hoek.assert(typeof options[key] === type, key + ' should be of type ' + type);
	        if (values) {
	            Hoek.assert(values.indexOf(options[key]) >= 0, key + ' should be one of ' + values.join(', '));
	        }
	    }
	};
	
	
	module.exports = internals.Any = function () {
	
	    Cast = Cast || __webpack_require__(106);
	
	    this.isJoi = true;
	    this._type = 'any';
	    this._settings = null;
	    this._valids = new internals.Set();
	    this._invalids = new internals.Set();
	    this._tests = [];
	    this._refs = [];
	    this._flags = { /*
	        presence: 'optional',                   // optional, required, forbidden, ignore
	        allowOnly: false,
	        allowUnknown: undefined,
	        default: undefined,
	        forbidden: false,
	        encoding: undefined,
	        insensitive: false,
	        trim: false,
	        case: undefined,                        // upper, lower
	        empty: undefined,
	        func: false
	    */ };
	
	    this._description = null;
	    this._unit = null;
	    this._notes = [];
	    this._tags = [];
	    this._examples = [];
	    this._meta = [];
	
	    this._inner = {};                           // Hash of arrays of immutable objects
	};
	
	
	internals.Any.prototype.isImmutable = true;     // Prevents Hoek from deep cloning schema objects
	
	
	internals.Any.prototype.clone = function () {
	
	    var obj = Object.create(Object.getPrototypeOf(this));
	
	    obj.isJoi = true;
	    obj._type = this._type;
	    obj._settings = internals.concatSettings(this._settings);
	    obj._valids = Hoek.clone(this._valids);
	    obj._invalids = Hoek.clone(this._invalids);
	    obj._tests = this._tests.slice();
	    obj._refs = this._refs.slice();
	    obj._flags = Hoek.clone(this._flags);
	
	    obj._description = this._description;
	    obj._unit = this._unit;
	    obj._notes = this._notes.slice();
	    obj._tags = this._tags.slice();
	    obj._examples = this._examples.slice();
	    obj._meta = this._meta.slice();
	
	    obj._inner = {};
	    var inners = Object.keys(this._inner);
	    for (var i = 0, il = inners.length; i < il; ++i) {
	        var key = inners[i];
	        obj._inner[key] = this._inner[key] ? this._inner[key].slice() : null;
	    }
	
	    return obj;
	};
	
	
	internals.Any.prototype.concat = function (schema) {
	
	    Hoek.assert(schema && schema.isJoi, 'Invalid schema object');
	    Hoek.assert(this._type === 'any' || schema._type === 'any' || schema._type === this._type, 'Cannot merge type', this._type, 'with another type:', schema._type);
	
	    var obj = this.clone();
	
	    if (this._type === 'any' && schema._type !== 'any') {
	
	        // Reset values as if we were "this"
	        var tmpObj = schema.clone();
	        var keysToRestore = ['_settings', '_valids', '_invalids', '_tests', '_refs', '_flags', '_description', '_unit',
	            '_notes', '_tags', '_examples', '_meta', '_inner'];
	
	        for (var j = 0, jl = keysToRestore.length; j < jl; ++j) {
	            tmpObj[keysToRestore[j]] = obj[keysToRestore[j]];
	        }
	
	        obj = tmpObj;
	    }
	
	    obj._settings = obj._settings ? internals.concatSettings(obj._settings, schema._settings) : schema._settings;
	    obj._valids.merge(schema._valids, schema._invalids);
	    obj._invalids.merge(schema._invalids, schema._valids);
	    obj._tests = obj._tests.concat(schema._tests);
	    obj._refs = obj._refs.concat(schema._refs);
	    Hoek.merge(obj._flags, schema._flags);
	
	    obj._description = schema._description || obj._description;
	    obj._unit = schema._unit || obj._unit;
	    obj._notes = obj._notes.concat(schema._notes);
	    obj._tags = obj._tags.concat(schema._tags);
	    obj._examples = obj._examples.concat(schema._examples);
	    obj._meta = obj._meta.concat(schema._meta);
	
	    var inners = Object.keys(schema._inner);
	    var isObject = obj._type === 'object';
	    for (var i = 0, il = inners.length; i < il; ++i) {
	        var key = inners[i];
	        var source = schema._inner[key];
	        if (source) {
	            var target = obj._inner[key];
	            if (target) {
	                if (isObject && key === 'children') {
	                    var keys = {};
	
	                    for (var k = 0, kl = target.length; k < kl; ++k) {
	                        keys[target[k].key] = k;
	                    }
	
	                    for (k = 0, kl = source.length; k < kl; ++k) {
	                        var sourceKey = source[k].key;
	                        if (keys[sourceKey] >= 0) {
	                            target[keys[sourceKey]] = {
	                                key: sourceKey,
	                                schema: target[keys[sourceKey]].schema.concat(source[k].schema)
	                            };
	                        }
	                        else {
	                            target.push(source[k]);
	                        }
	                    }
	                }
	                else {
	                    obj._inner[key] = obj._inner[key].concat(source);
	                }
	            }
	            else {
	                obj._inner[key] = source.slice();
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.Any.prototype._test = function (name, arg, func) {
	
	    Hoek.assert(!this._flags.allowOnly, 'Cannot define rules when valid values specified');
	
	    var obj = this.clone();
	    obj._tests.push({ func: func, name: name, arg: arg });
	    return obj;
	};
	
	
	internals.Any.prototype.options = function (options) {
	
	    Hoek.assert(!options.context, 'Cannot override context');
	    internals.checkOptions(options);
	
	    var obj = this.clone();
	    obj._settings = internals.concatSettings(obj._settings, options);
	    return obj;
	};
	
	
	internals.Any.prototype.strict = function (isStrict) {
	
	    var obj = this.clone();
	    obj._settings = obj._settings || {};
	    obj._settings.convert = isStrict === undefined ? false : !isStrict;
	    return obj;
	};
	
	
	internals.Any.prototype.raw = function (isRaw) {
	
	    var obj = this.clone();
	    obj._settings = obj._settings || {};
	    obj._settings.raw = isRaw === undefined ? true : isRaw;
	    return obj;
	};
	
	
	internals.Any.prototype._allow = function () {
	
	    var values = Hoek.flatten(Array.prototype.slice.call(arguments));
	    for (var i = 0, il = values.length; i < il; ++i) {
	        var value = values[i];
	
	        Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
	        this._invalids.remove(value);
	        this._valids.add(value, this._refs);
	    }
	};
	
	
	internals.Any.prototype.allow = function () {
	
	    var obj = this.clone();
	    obj._allow.apply(obj, arguments);
	    return obj;
	};
	
	
	internals.Any.prototype.valid = internals.Any.prototype.only = internals.Any.prototype.equal = function () {
	
	    Hoek.assert(!this._tests.length, 'Cannot set valid values when rules specified');
	
	    var obj = this.allow.apply(this, arguments);
	    obj._flags.allowOnly = true;
	    return obj;
	};
	
	
	internals.Any.prototype.invalid = internals.Any.prototype.disallow = internals.Any.prototype.not = function (value) {
	
	    var obj = this.clone();
	    var values = Hoek.flatten(Array.prototype.slice.call(arguments));
	    for (var i = 0, il = values.length; i < il; ++i) {
	        value = values[i];
	
	        Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
	        obj._valids.remove(value);
	        obj._invalids.add(value, this._refs);
	    }
	
	    return obj;
	};
	
	
	internals.Any.prototype.required = internals.Any.prototype.exist = function () {
	
	    var obj = this.clone();
	    obj._flags.presence = 'required';
	    return obj;
	};
	
	
	internals.Any.prototype.optional = function () {
	
	    var obj = this.clone();
	    obj._flags.presence = 'optional';
	    return obj;
	};
	
	
	internals.Any.prototype.forbidden = function () {
	
	    var obj = this.clone();
	    obj._flags.presence = 'forbidden';
	    return obj;
	};
	
	
	internals.Any.prototype.strip = function () {
	
	    var obj = this.clone();
	    obj._flags.strip = true;
	    return obj;
	};
	
	
	internals.Any.prototype.applyFunctionToChildren = function (children, fn, args, root) {
	
	    children = [].concat(children);
	
	    if (children.length !== 1 || children[0] !== '') {
	        root = root ? (root + '.') : '';
	
	        var extraChildren = (children[0] === '' ? children.slice(1) : children).map(function (child) {
	
	            return root + child;
	        });
	
	        throw new Error('unknown key(s) ' + extraChildren.join(', '));
	    }
	
	    return this[fn].apply(this, args);
	};
	
	
	internals.Any.prototype.default = function (value, description) {
	
	    if (typeof value === 'function' &&
	        !Ref.isRef(value)) {
	
	        if (!value.description &&
	            description) {
	
	            value.description = description;
	        }
	
	        if (!this._flags.func) {
	            Hoek.assert(typeof value.description === 'string' && value.description.length > 0, 'description must be provided when default value is a function');
	        }
	    }
	
	    var obj = this.clone();
	    obj._flags.default = value;
	    Ref.push(obj._refs, value);
	    return obj;
	};
	
	
	internals.Any.prototype.empty = function (schema) {
	
	    var obj;
	    if (schema === undefined) {
	        obj = this.clone();
	        obj._flags.empty = undefined;
	    }
	    else {
	        schema = Cast.schema(schema);
	
	        obj = this.clone();
	        obj._flags.empty = schema;
	    }
	
	    return obj;
	};
	
	
	internals.Any.prototype.when = function (ref, options) {
	
	    Hoek.assert(options && typeof options === 'object', 'Invalid options');
	    Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');
	
	    var then = options.then ? this.concat(Cast.schema(options.then)) : this;
	    var otherwise = options.otherwise ? this.concat(Cast.schema(options.otherwise)) : this;
	
	    Alternatives = Alternatives || __webpack_require__(193);
	    var obj = Alternatives.when(ref, { is: options.is, then: then, otherwise: otherwise });
	    obj._flags.presence = 'ignore';
	    return obj;
	};
	
	
	internals.Any.prototype.description = function (desc) {
	
	    Hoek.assert(desc && typeof desc === 'string', 'Description must be a non-empty string');
	
	    var obj = this.clone();
	    obj._description = desc;
	    return obj;
	};
	
	
	internals.Any.prototype.notes = function (notes) {
	
	    Hoek.assert(notes && (typeof notes === 'string' || Array.isArray(notes)), 'Notes must be a non-empty string or array');
	
	    var obj = this.clone();
	    obj._notes = obj._notes.concat(notes);
	    return obj;
	};
	
	
	internals.Any.prototype.tags = function (tags) {
	
	    Hoek.assert(tags && (typeof tags === 'string' || Array.isArray(tags)), 'Tags must be a non-empty string or array');
	
	    var obj = this.clone();
	    obj._tags = obj._tags.concat(tags);
	    return obj;
	};
	
	internals.Any.prototype.meta = function (meta) {
	
	    Hoek.assert(meta !== undefined, 'Meta cannot be undefined');
	
	    var obj = this.clone();
	    obj._meta = obj._meta.concat(meta);
	    return obj;
	};
	
	
	internals.Any.prototype.example = function (value) {
	
	    Hoek.assert(arguments.length, 'Missing example');
	    var result = this._validate(value, null, internals.defaults);
	    Hoek.assert(!result.errors, 'Bad example:', result.errors && Errors.process(result.errors, value));
	
	    var obj = this.clone();
	    obj._examples = obj._examples.concat(value);
	    return obj;
	};
	
	
	internals.Any.prototype.unit = function (name) {
	
	    Hoek.assert(name && typeof name === 'string', 'Unit name must be a non-empty string');
	
	    var obj = this.clone();
	    obj._unit = name;
	    return obj;
	};
	
	
	internals._try = function (fn, arg) {
	
	    var err;
	    var result;
	
	    try {
	        result = fn.call(null, arg);
	    } catch (e) {
	        err = e;
	    }
	
	    return {
	        value: result,
	        error: err
	    };
	};
	
	
	internals.Any.prototype._validate = function (value, state, options, reference) {
	
	    var self = this;
	    var originalValue = value;
	
	    // Setup state and settings
	
	    state = state || { key: '', path: '', parent: null, reference: reference };
	
	    if (this._settings) {
	        options = internals.concatSettings(options, this._settings);
	    }
	
	    var errors = [];
	    var finish = function () {
	
	        var finalValue;
	
	        if (!self._flags.strip) {
	            if (value !== undefined) {
	                finalValue = options.raw ? originalValue : value;
	            }
	            else if (options.noDefaults) {
	                finalValue = originalValue;
	            }
	            else if (Ref.isRef(self._flags.default)) {
	                finalValue = self._flags.default(state.parent, options);
	            }
	            else if (typeof self._flags.default === 'function' &&
	                    !(self._flags.func && !self._flags.default.description)) {
	
	                var arg;
	
	                if (state.parent !== null &&
	                    self._flags.default.length > 0) {
	
	                    arg = Hoek.clone(state.parent);
	                }
	
	                var defaultValue = internals._try(self._flags.default, arg);
	                finalValue = defaultValue.value;
	                if (defaultValue.error) {
	                    errors.push(Errors.create('any.default', defaultValue.error, state, options));
	                }
	            }
	            else {
	                finalValue = Hoek.clone(self._flags.default);
	            }
	        }
	
	        return {
	            value: finalValue,
	            errors: errors.length ? errors : null
	        };
	    };
	
	    // Check presence requirements
	
	    var presence = this._flags.presence || options.presence;
	    if (presence === 'optional') {
	        if (value === undefined) {
	            var isDeepDefault = this._flags.hasOwnProperty('default') && this._flags.default === undefined;
	            if (isDeepDefault && this._type === 'object') {
	                value = {};
	            }
	            else {
	                return finish();
	            }
	        }
	    }
	    else if (presence === 'required' &&
	            value === undefined) {
	
	        errors.push(Errors.create('any.required', null, state, options));
	        return finish();
	    }
	    else if (presence === 'forbidden') {
	        if (value === undefined) {
	            return finish();
	        }
	
	        errors.push(Errors.create('any.unknown', null, state, options));
	        return finish();
	    }
	
	    if (this._flags.empty && !this._flags.empty._validate(value, null, internals.defaults).errors) {
	        value = undefined;
	        return finish();
	    }
	
	    // Check allowed and denied values using the original value
	
	    if (this._valids.has(value, state, options, this._flags.insensitive)) {
	        return finish();
	    }
	
	    if (this._invalids.has(value, state, options, this._flags.insensitive)) {
	        errors.push(Errors.create(value === '' ? 'any.empty' : 'any.invalid', null, state, options));
	        if (options.abortEarly ||
	            value === undefined) {          // No reason to keep validating missing value
	
	            return finish();
	        }
	    }
	
	    // Convert value and validate type
	
	    if (this._base) {
	        var base = this._base.call(this, value, state, options);
	        if (base.errors) {
	            value = base.value;
	            errors = errors.concat(base.errors);
	            return finish();                            // Base error always aborts early
	        }
	
	        if (base.value !== value) {
	            value = base.value;
	
	            // Check allowed and denied values using the converted value
	
	            if (this._valids.has(value, state, options, this._flags.insensitive)) {
	                return finish();
	            }
	
	            if (this._invalids.has(value, state, options, this._flags.insensitive)) {
	                errors.push(Errors.create('any.invalid', null, state, options));
	                if (options.abortEarly) {
	                    return finish();
	                }
	            }
	        }
	    }
	
	    // Required values did not match
	
	    if (this._flags.allowOnly) {
	        errors.push(Errors.create('any.allowOnly', { valids: this._valids.values({ stripUndefined: true }) }, state, options));
	        if (options.abortEarly) {
	            return finish();
	        }
	    }
	
	    // Helper.validate tests
	
	    for (var i = 0, il = this._tests.length; i < il; ++i) {
	        var test = this._tests[i];
	        var err = test.func.call(this, value, state, options);
	        if (err) {
	            errors.push(err);
	            if (options.abortEarly) {
	                return finish();
	            }
	        }
	    }
	
	    return finish();
	};
	
	
	internals.Any.prototype._validateWithOptions = function (value, options, callback) {
	
	    if (options) {
	        internals.checkOptions(options);
	    }
	
	    var settings = internals.concatSettings(internals.defaults, options);
	    var result = this._validate(value, null, settings);
	    var errors = Errors.process(result.errors, value);
	
	    if (callback) {
	        return callback(errors, result.value);
	    }
	
	    return { error: errors, value: result.value };
	};
	
	
	internals.Any.prototype.validate = function (value, callback) {
	
	    var result = this._validate(value, null, internals.defaults);
	    var errors = Errors.process(result.errors, value);
	
	    if (callback) {
	        return callback(errors, result.value);
	    }
	
	    return { error: errors, value: result.value };
	};
	
	
	internals.Any.prototype.describe = function () {
	
	    var description = {
	        type: this._type
	    };
	
	    var flags = Object.keys(this._flags);
	    if (flags.length) {
	        if (this._flags.empty) {
	            description.flags = {};
	            for (var f = 0, fl = flags.length; f < fl; ++f) {
	                var flag = flags[f];
	                description.flags[flag] = flag === 'empty' ? this._flags[flag].describe() : this._flags[flag];
	            }
	        }
	        else {
	            description.flags = this._flags;
	        }
	    }
	
	    if (this._description) {
	        description.description = this._description;
	    }
	
	    if (this._notes.length) {
	        description.notes = this._notes;
	    }
	
	    if (this._tags.length) {
	        description.tags = this._tags;
	    }
	
	    if (this._meta.length) {
	        description.meta = this._meta;
	    }
	
	    if (this._examples.length) {
	        description.examples = this._examples;
	    }
	
	    if (this._unit) {
	        description.unit = this._unit;
	    }
	
	    var valids = this._valids.values();
	    if (valids.length) {
	        description.valids = valids;
	    }
	
	    var invalids = this._invalids.values();
	    if (invalids.length) {
	        description.invalids = invalids;
	    }
	
	    description.rules = [];
	
	    for (var i = 0, il = this._tests.length; i < il; ++i) {
	        var validator = this._tests[i];
	        var item = { name: validator.name };
	        if (validator.arg !== void 0) {
	            item.arg = validator.arg;
	        }
	        description.rules.push(item);
	    }
	
	    if (!description.rules.length) {
	        delete description.rules;
	    }
	
	    var label = Hoek.reach(this._settings, 'language.label');
	    if (label) {
	        description.label = label;
	    }
	
	    return description;
	};
	
	internals.Any.prototype.label = function (name) {
	
	    Hoek.assert(name && typeof name === 'string', 'Label name must be a non-empty string');
	
	    var obj = this.clone();
	    var options = { language: { label: name } };
	
	    // If language.label is set, it should override this label
	    obj._settings = internals.concatSettings(options, obj._settings);
	    return obj;
	};
	
	
	// Set
	
	internals.Set = function () {
	
	    this._set = [];
	};
	
	
	internals.Set.prototype.add = function (value, refs) {
	
	    Hoek.assert(value === null || value === undefined || value instanceof Date || Buffer.isBuffer(value) || Ref.isRef(value) || (typeof value !== 'function' && typeof value !== 'object'), 'Value cannot be an object or function');
	
	    if (typeof value !== 'function' &&
	        this.has(value, null, null, false)) {
	
	        return;
	    }
	
	    Ref.push(refs, value);
	    this._set.push(value);
	};
	
	
	internals.Set.prototype.merge = function (add, remove) {
	
	    for (var i = 0, il = add._set.length; i < il; ++i) {
	        this.add(add._set[i]);
	    }
	
	    for (i = 0, il = remove._set.length; i < il; ++i) {
	        this.remove(remove._set[i]);
	    }
	};
	
	
	internals.Set.prototype.remove = function (value) {
	
	    this._set = this._set.filter(function (item) {
	
	        return value !== item;
	    });
	};
	
	
	internals.Set.prototype.has = function (value, state, options, insensitive) {
	
	    for (var i = 0, il = this._set.length; i < il; ++i) {
	        var items = this._set[i];
	
	        if (Ref.isRef(items)) {
	            items = items(state.reference || state.parent, options);
	        }
	
	        if (!Array.isArray(items)) {
	            items = [items];
	        }
	
	        for (var j = 0, jl = items.length; j < jl; ++j) {
	            var item = items[j];
	            if (typeof value !== typeof item) {
	                continue;
	            }
	
	            if (value === item ||
	                (value instanceof Date && item instanceof Date && value.getTime() === item.getTime()) ||
	                (insensitive && typeof value === 'string' && value.toLowerCase() === item.toLowerCase()) ||
	                (Buffer.isBuffer(value) && Buffer.isBuffer(item) && value.length === item.length && value.toString('binary') === item.toString('binary'))) {
	
	                return true;
	            }
	        }
	    }
	
	    return false;
	};
	
	
	internals.Set.prototype.values = function (options) {
	
	    if (options && options.stripUndefined) {
	        var values = [];
	
	        for (var i = 0, il = this._set.length; i < il; ++i) {
	            var item = this._set[i];
	            if (item !== undefined) {
	                values.push(item);
	            }
	        }
	
	        return values;
	    }
	
	    return this._set.slice();
	};
	
	
	internals.concatSettings = function (target, source) {
	
	    // Used to avoid cloning context
	
	    if (!target &&
	        !source) {
	
	        return null;
	    }
	
	    var key, obj = {};
	
	    if (target) {
	        var tKeys = Object.keys(target);
	        for (var i = 0, il = tKeys.length; i < il; ++i) {
	            key = tKeys[i];
	            obj[key] = target[key];
	        }
	    }
	
	    if (source) {
	        var sKeys = Object.keys(source);
	        for (var j = 0, jl = sKeys.length; j < jl; ++j) {
	            key = sKeys[j];
	            if (key !== 'language' ||
	                !obj.hasOwnProperty(key)) {
	
	                obj[key] = source[key];
	            }
	            else {
	                obj[key] = Hoek.applyToDefaults(obj[key], source[key]);
	            }
	        }
	    }
	
	    return obj;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  disabled: _react2['default'].PropTypes.bool,
	  role: _react2['default'].PropTypes.string,
	  tabIndex: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var CallbackQueue = __webpack_require__(497);
	var PooledClass = __webpack_require__(67);
	var ReactFeatureFlags = __webpack_require__(502);
	var ReactReconciler = __webpack_require__(83);
	var Transaction = __webpack_require__(145);
	
	var invariant = __webpack_require__(11);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1132);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1133);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Hoek = __webpack_require__(32);
	var Language = __webpack_require__(903);
	
	
	// Declare internals
	
	var internals = {};
	
	internals.stringify = function (value, wrapArrays) {
	
	    var type = typeof value;
	
	    if (value === null) {
	        return 'null';
	    }
	
	    if (type === 'string') {
	        return value;
	    }
	
	    if (value instanceof internals.Err || type === 'function') {
	        return value.toString();
	    }
	
	    if (type === 'object') {
	        if (Array.isArray(value)) {
	            var partial = '';
	
	            for (var i = 0, il = value.length; i < il; ++i) {
	                partial += (partial.length ? ', ' : '') + internals.stringify(value[i], wrapArrays);
	            }
	
	            return wrapArrays ? '[' + partial + ']' : partial;
	        }
	
	        return value.toString();
	    }
	
	    return JSON.stringify(value);
	};
	
	internals.Err = function (type, context, state, options) {
	
	    this.type = type;
	    this.context = context || {};
	    this.context.key = state.key;
	    this.path = state.path;
	    this.options = options;
	};
	
	
	internals.Err.prototype.toString = function () {
	
	    var self = this;
	
	    var localized = this.options.language;
	
	    if (localized.label) {
	        this.context.key = localized.label;
	    }
	    else if (this.context.key === '' || this.context.key === null) {
	        this.context.key = localized.root || Language.errors.root;
	    }
	
	    var format = Hoek.reach(localized, this.type) || Hoek.reach(Language.errors, this.type);
	    var hasKey = /\{\{\!?key\}\}/.test(format);
	    var skipKey = format.length > 2 && format[0] === '!' && format[1] === '!';
	
	    if (skipKey) {
	        format = format.slice(2);
	    }
	
	    if (!hasKey && !skipKey) {
	        format = (Hoek.reach(localized, 'key') || Hoek.reach(Language.errors, 'key')) + format;
	    }
	
	    var wrapArrays = Hoek.reach(localized, 'messages.wrapArrays');
	    if (typeof wrapArrays !== 'boolean') {
	        wrapArrays = Language.errors.messages.wrapArrays;
	    }
	
	    var message = format.replace(/\{\{(\!?)([^}]+)\}\}/g, function ($0, isSecure, name) {
	
	        var value = Hoek.reach(self.context, name);
	        var normalized = internals.stringify(value, wrapArrays);
	        return (isSecure ? Hoek.escapeHtml(normalized) : normalized);
	    });
	
	    return message;
	};
	
	
	exports.create = function (type, context, state, options) {
	
	    return new internals.Err(type, context, state, options);
	};
	
	
	exports.process = function (errors, object) {
	
	    if (!errors || !errors.length) {
	        return null;
	    }
	
	    // Construct error
	
	    var message = '';
	    var details = [];
	
	    var processErrors = function (localErrors, parent) {
	
	        for (var i = 0, il = localErrors.length; i < il; ++i) {
	            var item = localErrors[i];
	
	            var detail = {
	                message: item.toString(),
	                path: internals.getPath(item),
	                type: item.type,
	                context: item.context
	            };
	
	            if (!parent) {
	                message += (message ? '. ' : '') + detail.message;
	            }
	
	            // Do not push intermediate errors, we're only interested in leafs
	            if (item.context.reason && item.context.reason.length) {
	                processErrors(item.context.reason, item.path);
	            }
	            else {
	                details.push(detail);
	            }
	        }
	    };
	
	    processErrors(errors);
	
	    var error = new Error(message);
	    error.name = 'ValidationError';
	    error.details = details;
	    error._object = object;
	    error.annotate = internals.annotate;
	    return error;
	};
	
	
	internals.getPath = function (item) {
	
	    var recursePath = function (it) {
	
	        var reachedItem = Hoek.reach(it, 'context.reason.0');
	        if (reachedItem && reachedItem.context) {
	            return recursePath(reachedItem);
	        }
	
	        return it.path;
	    };
	
	    return recursePath(item) || item.context.key;
	};
	
	
	// Inspired by json-stringify-safe
	internals.safeStringify = function (obj, spaces) {
	
	    return JSON.stringify(obj, internals.serializer(), spaces);
	};
	
	internals.serializer = function () {
	
	    var cycleReplacer = function (key, value) {
	
	        if (stack[0] === value) {
	            return '[Circular ~]';
	        }
	
	        return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
	    };
	
	    var keys = [], stack = [];
	
	    return function (key, value) {
	
	        if (stack.length > 0) {
	            var thisPos = stack.indexOf(this);
	            if (~thisPos) {
	                stack.length = thisPos + 1;
	                keys.length = thisPos + 1;
	                keys[thisPos] = key;
	            }
	            else {
	                stack.push(this);
	                keys.push(key);
	            }
	
	            if (~stack.indexOf(value)) {
	                value = cycleReplacer.call(this, key, value);
	            }
	        }
	        else {
	            stack.push(value);
	        }
	
	        if (Array.isArray(value) && value.placeholders) {
	            var placeholders = value.placeholders;
	            var arrWithPlaceholders = [];
	            for (var i = 0, il = value.length; i < il; ++i) {
	                if (placeholders[i]) {
	                    arrWithPlaceholders.push(placeholders[i]);
	                }
	                arrWithPlaceholders.push(value[i]);
	            }
	
	            value = arrWithPlaceholders;
	        }
	
	        return value;
	    };
	};
	
	
	internals.annotate = function () {
	
	    var obj = Hoek.clone(this._object || {});
	
	    var lookup = {};
	    var el = this.details.length;
	    for (var e = el - 1; e >= 0; --e) {        // Reverse order to process deepest child first
	        var pos = el - e;
	        var error = this.details[e];
	        var path = error.path.split('.');
	        var ref = obj;
	        for (var i = 0, il = path.length; i < il && ref; ++i) {
	            var seg = path[i];
	            if (i + 1 < il) {
	                ref = ref[seg];
	            }
	            else {
	                var value = ref[seg];
	                if (Array.isArray(ref)) {
	                    var arrayLabel = '_$idx$_' + (e + 1) + '_$end$_';
	                    if (!ref.placeholders) {
	                        ref.placeholders = {};
	                    }
	
	                    if (ref.placeholders[seg]) {
	                        ref.placeholders[seg] = ref.placeholders[seg].replace('_$end$_', ', ' + (e + 1) + '_$end$_');
	                    }
	                    else {
	                        ref.placeholders[seg] = arrayLabel;
	                    }
	                } else {
	                    if (value !== undefined) {
	                        delete ref[seg];
	                        var objectLabel = seg + '_$key$_' + pos + '_$end$_';
	                        ref[objectLabel] = value;
	                        lookup[error.path] = objectLabel;
	                    }
	                    else if (lookup[error.path]) {
	                        var replacement = lookup[error.path];
	                        var appended = replacement.replace('_$end$_', ', ' + pos + '_$end$_');
	                        ref[appended] = ref[replacement];
	                        lookup[error.path] = appended;
	                        delete ref[replacement];
	                    }
	                    else {
	                        ref['_$miss$_' + seg + '|' + pos + '_$end$_'] = '__missing__';
	                    }
	                }
	            }
	        }
	    }
	
	    var message = internals.safeStringify(obj, 2)
	        .replace(/_\$key\$_([, \d]+)_\$end\$_\"/g, function ($0, $1) {
	
	            return '" \u001b[31m[' + $1 + ']\u001b[0m';
	        }).replace(/\"_\$miss\$_([^\|]+)\|(\d+)_\$end\$_\"\: \"__missing__\"/g, function ($0, $1, $2) {
	
	            return '\u001b[41m"' + $1 + '"\u001b[0m\u001b[31m [' + $2 + ']: -- missing --\u001b[0m';
	        }).replace(/\s*\"_\$idx\$_([, \d]+)_\$end\$_\",?\n(.*)/g, function ($0, $1, $2) {
	
	            return '\n' + $2 + ' \u001b[31m[' + $1 + ']\u001b[0m';
	        });
	
	    message += '\n\u001b[31m';
	
	    for (e = 0; e < el; ++e) {
	        message += '\n[' + (e + 1) + '] ' + this.details[e].message;
	    }
	
	    message += '\u001b[0m';
	
	    return message;
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var PooledClass = __webpack_require__(67);
	
	var emptyFunction = __webpack_require__(36);
	var warning = __webpack_require__(12);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCurrentUser = setCurrentUser;
	exports.signin = signin;
	exports.signedIn = signedIn;
	exports.FacebookSignedIn = FacebookSignedIn;
	exports.FacebookSignedUp = FacebookSignedUp;
	exports.updateCustomerPassword = updateCustomerPassword;
	exports.updateCustomerEmail = updateCustomerEmail;
	exports.addCustomerProfile = addCustomerProfile;
	exports.updateCustomerProfile = updateCustomerProfile;
	exports.changePassword = changePassword;
	exports.resetPassword = resetPassword;
	exports.resetAccounts = resetAccounts;
	exports.logout = logout;
	exports.getCopyrightYear = getCopyrightYear;
	exports.testLogin = testLogin;
	exports.putReSendOTP = putReSendOTP;
	exports.putReSendOTPRequired = putReSendOTPRequired;
	exports.updateTutorial = updateTutorial;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _setAuthorizationToken = __webpack_require__(160);
	
	var _setAuthorizationToken2 = _interopRequireDefault(_setAuthorizationToken);
	
	var _jsonwebtoken = __webpack_require__(331);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	var _store = __webpack_require__(20);
	
	var _types = __webpack_require__(242);
	
	var _analyticsEvents = __webpack_require__(125);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	var apiAuthUrl = _CommonConstants2.default.Actions.apiAuth;
	var rootUrl = _CommonConstants2.default.Actions.rootUrl;
	
	function setCurrentUser(user) {
	  return {
	    type: _types.SET_CURRENT_USER,
	    user: user
	  };
	}
	function signin(email, password) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    var token = void 0;
	    _axios2.default.post(apiAuthUrl + 'login', {
	      'email': email,
	      'password': password,
	      'role': 'customer'
	    }).then(function (response) {
	      token = response.data.token;
	      localStorage.setItem('jwtToken', token);
	      (0, _setAuthorizationToken2.default)(token);
	      dispatch(setCurrentUser(_jsonwebtoken2.default.decode(token)));
	      dispatch({ type: 'SIGNIN_USER_FULFILLED', payload: response.data });
	      //localStorage.trackPackage ? history.push('/track-package') : history.push('/cart');
	      //localStorage.removeItem("trackPackage");
	      return _axios2.default.get(apiUrl + 'accounts', token);
	    }).then(function (response) {
	      dispatch({ type: 'SIGNEDIN_USER_FULFILLED', payload: response.data });
	      localStorage.trackPackage ? _store.history.push('/track') : localStorage.rewardPage ? window.location.replace('https://rewards.shippingcart.com?token=' + token + '&account_number=' + response.data.party.account_number + '&name=' + response.data.party.first_name) : !_utils.disabledCart ? window.location.replace(window.location.origin + "/cart") : window.location.replace(window.location.origin + "/shipment");
	      localStorage.removeItem('rewardPage');
	      localStorage.removeItem("trackPackage");
	    }).catch(function (err) {
	      dispatch({ type: 'SIGNIN_USER_REJECTED', payload: err });
	    });
	  };
	}
	function signedIn(token) {
	  var timeStamp = Math.floor(Date.now() / 1000);
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'accounts?' + timeStamp, token).then(function (response) {
	      localStorage.setItem('accountNumber', response.data.party.account_number);
	      dispatch({ type: 'SIGNEDIN_USER_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'SIGNEDIN_USER_REJECTED', payload: err });
	      (0, _setAuthorizationToken2.default)("");
	      localStorage.removeItem('jwtToken');
	      localStorage.removeItem('item');
	      localStorage.removeItem('insurance');
	      localStorage.removeItem('accountNumber');
	      dispatch(setCurrentUser({}));
	      _store.history.push('/');
	    });
	  };
	}
	function FacebookSignedIn(token) {
	  return function (dispatch) {
	    _axios2.default.post(apiAuthUrl + 'fb-login', { "token": token }).then(function (response) {
	      var token = response.data.token;
	      localStorage.setItem('jwtToken', token);
	      (0, _setAuthorizationToken2.default)(token);
	      dispatch(setCurrentUser(_jsonwebtoken2.default.decode(token)));
	      dispatch({ type: 'SIGNIN_USER_FULFILLED', payload: response.data });
	      !_utils.disabledCart ? _store.history.push('/cart') : _store.history.push('/shipment');
	    }).catch(function (err) {
	      dispatch({ type: 'FACEBOOK_SIGNEDIN_USER_REJECTED', payload: err });
	    });
	  };
	}
	function FacebookSignedUp(token) {
	  return function (dispatch) {
	    _axios2.default.post(rootUrl + 'sign-up-fb', { "token": token }).then(function (response) {
	      var token = response.data.token;
	      localStorage.setItem('jwtToken', token);
	      (0, _setAuthorizationToken2.default)(token);
	      dispatch(setCurrentUser(_jsonwebtoken2.default.decode(token)));
	      dispatch({ type: 'SIGNUP_USER_FULFILLED', payload: response.data });
	      if (response.data.is_new) {
	        (0, _analyticsEvents.recordEvent)('sign_up_2019', 'Sign Up 2019', 'Completed', 'Facebook sign-up');
	        _store.history.push('/signup-success');
	      } else {
	        // disable cart for wasp
	        !_utils.disabledCart ? _store.history.push('/cart') : _store.history.push('/shipment');
	      }
	    }).catch(function (err) {
	      (0, _analyticsEvents.recordEvent)('sign_up_2019', 'Sign Up 2019', 'Failed', 'Facebook sign-up');
	      dispatch({ type: 'FACEBOOK_SIGNEDIN_USER_REJECTED', payload: err });
	    });
	  };
	}
	function updateCustomerPassword(password, new_password, new_confirm_password, token) {
	
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.put(apiUrl + 'users/update-password', {
	      "data": {
	        "type": "user-update-password",
	        "attributes": {
	          "password": password,
	          "new_password": new_password,
	          "new_confirm_password": new_confirm_password
	        }
	      }
	    }).then(function (response) {
	      dispatch({ type: 'UPDATE_CUSTOMER_PASSWORD_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'UPDATE_CUSTOMER_PASSWORD_REJECTED', payload: err.response });
	    });
	  };
	}
	function updateCustomerEmail(email, password_confirm, token) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.put(apiUrl + 'users/update-email', {
	      "data": {
	        "type": "user-update-email",
	        "attributes": {
	          "email": email,
	          "password_confirm": password_confirm
	        }
	      }
	    }).then(function (response) {
	      dispatch({ type: 'UPDATE_CUSTOMER_EMAIL_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'UPDATE_CUSTOMER_EMAIL_REJECTED', payload: err.response });
	    });
	  };
	}
	function addCustomerProfile(parameter, otp_code) {
	  var attributes = otp_code ? Object.assign({}, parameter, { otp_code: otp_code }) : Object.assign({}, parameter[0]);
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.put(apiUrl + 'users/update-profile', {
	      "data": {
	        "type": "user-update-profile",
	        attributes: attributes
	      }
	    }).then(function (response) {
	      dispatch({ type: 'UPDATE_CUSTOMER_PROFILE_FULFILLED', payload: response.data });
	      if (otp_code) {
	        _store.history.goBack();
	      }
	    }).catch(function (err) {
	      dispatch({ type: 'UPDATE_CUSTOMER_PROFILE_REJECTED', payload: err.response });
	    });
	  };
	}
	
	function updateCustomerProfile(otp_payload, otp_code, phone_number_update, first_name, last_name, phone_number, gender, birthday, token) {
	
	  var attributes = otp_code !== null ? Object.assign({}, otp_payload, { otp_code: otp_code }) : {
	    "first_name": first_name,
	    "last_name": last_name,
	    "phone_number": phone_number,
	    "gender": gender,
	    "birthdate": birthday,
	    "phone_number_update": phone_number_update
	  };
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.put(apiUrl + 'users/update-profile', {
	      "data": {
	        "type": "user-update-profile",
	        attributes: attributes
	      }
	    }).then(function (response) {
	      dispatch({ type: 'UPDATE_CUSTOMER_PROFILE_FULFILLED', payload: response.data });
	      if (otp_code !== null) {
	        localStorage.removeItem('otp_response');
	        localStorage.removeItem('otp_redirect');
	        localStorage.setItem('account_redirect', true);
	        _store.history.goBack('');
	      }
	    }).catch(function (err) {
	      dispatch({ type: 'UPDATE_CUSTOMER_PROFILE_REJECTED', payload: err.response });
	    });
	  };
	}
	
	function changePassword(new_password, new_confirm_password, email, token) {
	
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	
	    _axios2.default.put(apiUrl + 'users/reset-password', {
	      "data": {
	        "type": "user-reset-password",
	        "attributes": {
	          "email": email,
	          "new_password": new_password,
	          "new_password_confirmation": new_confirm_password,
	          "token": token
	        }
	      }
	    }).then(function (response) {
	      var sessionToken = response.data.token;
	      (0, _setAuthorizationToken2.default)(sessionToken);
	
	      localStorage.setItem('jwtToken', sessionToken);
	      localStorage.setItem("ChangePassword", "true");
	
	      dispatch(setCurrentUser(_jsonwebtoken2.default.decode(sessionToken)));
	      dispatch({ type: 'CHANGE_PASSWORD_FULFILLED', payload: response.data });
	
	      !_utils.disabledCart ? window.location.replace("/cart") : window.location.replace("/shipment");
	    }).catch(function (err) {
	      dispatch({ type: 'CHANGE_PASSWORD_REJECTED', payload: err });
	    });
	  };
	}
	
	function resetPassword(email) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.post(apiUrl + 'forgot/password', {
	      "email": email
	    }).then(function (response) {
	      dispatch({ type: 'RESET_PASSWORD_FULFILLED', payload: response.data });
	      localStorage.setItem("resetPassword", "true");
	      _store.history.push('/signin');
	    }).catch(function (err) {
	      dispatch({ type: 'RESET_PASSWORD_REJECTED', payload: err });
	    });
	  };
	}
	function resetAccounts() {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	  };
	}
	function logout() {
	  return function (dispatch) {
	    _axios2.default.post(apiAuthUrl + 'logout').then(function (response) {
	      (0, _setAuthorizationToken2.default)("");
	      localStorage.removeItem('jwtToken');
	      localStorage.removeItem('token');
	      localStorage.removeItem('cartModalShowed');
	      localStorage.removeItem('cartExtensionModalShowed');
	      localStorage.removeItem('checkoutModalShowed');
	      localStorage.removeItem('item');
	      localStorage.removeItem('insurance');
	      localStorage.removeItem('shipment_location_details');
	      localStorage.removeItem('warehouse_id');
	      localStorage.removeItem('accountNumber');
	      dispatch(setCurrentUser({}));
	      dispatch({ type: 'LOGOUT_FULFILLED' });
	    }).catch(function (error) {
	      (0, _setAuthorizationToken2.default)("");
	      localStorage.removeItem('jwtToken');
	      localStorage.removeItem('token');
	      localStorage.removeItem('cartModalShowed');
	      localStorage.removeItem('cartExtensionModalShowed');
	      localStorage.removeItem('checkoutModalShowed');
	      localStorage.removeItem('item');
	      localStorage.removeItem('insurance');
	      localStorage.removeItem('shipment_location_details');
	      localStorage.removeItem('warehouse_id');
	      localStorage.removeItem('accountNumber');
	      dispatch(setCurrentUser({}));
	      dispatch({ type: 'LOGOUT_FULFILLED' });
	    });
	  };
	}
	function getCopyrightYear() {
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'year').then(function (response) {
	      dispatch({ type: 'GET_YEAR_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_YEAR_REJECTED', payload: err });
	    });
	  };
	}
	
	function testLogin(email, passcode) {
	  return function (dispatch) {
	    _axios2.default.post(apiAuthUrl + 'gm-login', {
	      email: email,
	      passcode: passcode
	    }).then(function (response) {
	      var token = response.data.token;
	      localStorage.setItem('jwtToken', token);
	      (0, _setAuthorizationToken2.default)(token);
	      dispatch(setCurrentUser(_jsonwebtoken2.default.decode(token)));
	      dispatch({ type: 'SIGNIN_USER_FULFILLED', payload: response.data });
	      //localStorage.trackPackage ? history.push('/track-package') : history.push('/cart');
	      //localStorage.removeItem("trackPackage");
	      return _axios2.default.get(apiUrl + 'accounts', token);
	    }).then(function (response) {
	      dispatch({ type: 'SIGNEDIN_USER_FULFILLED', payload: response.data });
	      localStorage.trackPackage ? _store.history.push('/track') : _store.history.push('/cart');
	      localStorage.removeItem("trackPackage");
	    }).catch(function (err) {
	      dispatch({ type: 'SIGNIN_USER_REJECTED', payload: err });
	    });
	  };
	}
	
	function putReSendOTP(otp_payload, phone_number_update, first_name, last_name, phone_number, gender, birthday) {
	  var attributes = null;
	  attributes = otp_payload !== null ? {
	    "first_name": otp_payload.first_name,
	    "last_name": otp_payload.last_name,
	    "phone_number": otp_payload.phone_number,
	    "gender": otp_payload.gender,
	    "birthdate": otp_payload.birthday,
	    "phone_number_update": otp_payload.phone_number_update
	  } : {
	    "first_name": first_name,
	    "last_name": last_name,
	    "phone_number": phone_number,
	    "gender": gender,
	    "birthdate": birthday,
	    "phone_number_update": phone_number_update
	  };
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.put(apiUrl + 'users/update-profile', {
	      "data": {
	        "type": "user-update-profile",
	        attributes: attributes
	      }
	    }).then(function (response) {
	      dispatch({ type: 'SEND_OTP_FULFILLED', payload: response.data });
	      if (phone_number_update) {
	        localStorage.setItem("otp_response", JSON.stringify(response.data));
	        localStorage.setItem("otp_redirect", "account");
	        _store.history.push('/otp-service');
	      }
	    }).catch(function (err) {
	      dispatch({ type: 'SEND_OTP_REJECTED', payload: err.response });
	    });
	  };
	}
	
	function putReSendOTPRequired(otp_payload) {
	  var attributes = null;
	  if (otp_payload[0] && !otp_payload[0].gender) {
	    attributes = {
	      "first_name": otp_payload[0].first_name,
	      "last_name": otp_payload[0].last_name,
	      "phone_number": otp_payload[0].phone_number,
	      "phone_number_update": otp_payload[0].phone_number_update
	    };
	    if (otp_payload[0].email) {
	      attributes.email = otp_payload[0].email;
	    }
	  } else {
	    attributes = {
	      "first_name": otp_payload.first_name,
	      "last_name": otp_payload.last_name,
	      "phone_number": otp_payload.phone_number,
	      "phone_number_update": otp_payload.phone_number_update
	    };
	    if (otp_payload.email) {
	      attributes.email = otp_payload[0].email;
	    }
	  }
	
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.put(apiUrl + 'users/update-profile', {
	      "data": {
	        "type": "user-update-profile",
	        attributes: attributes
	      }
	    }).then(function (response) {
	      dispatch({ type: 'SEND_OTP_FULFILLED', payload: response.data });
	      if (otp_payload[0] && !otp_payload[0].gender) {
	        localStorage.setItem("otp_response", JSON.stringify(response.data));
	        localStorage.setItem("otp_redirect", "requiredModal");
	        _store.history.push('/otp-service');
	      }
	    }).catch(function (err) {
	      dispatch({ type: 'SEND_OTP_REJECTED', payload: err.response });
	    });
	  };
	}
	function updateTutorial(type) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.put(apiUrl + 'users/hide-tutorial', {
	      "data": {
	        "type": "user-hide-tutorial",
	        "attributes": _defineProperty({}, type, true)
	      }
	    }).then(function (response) {
	      dispatch({ type: 'UPDATE_CUSTOMER_TUTORIAL_FULFILLED', payload: response.data.original });
	    }).catch(function (err) {
	      dispatch({ type: 'UPDATE_CUSTOMER_PROFILE_REJECTED', payload: err.response });
	    });
	  };
	}

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(95)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(53);
	var core = __webpack_require__(39);
	var ctx = __webpack_require__(162);
	var hide = __webpack_require__(75);
	var has = __webpack_require__(60);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 53 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  addDays: __webpack_require__(101),
	  addHours: __webpack_require__(271),
	  addISOYears: __webpack_require__(272),
	  addMilliseconds: __webpack_require__(102),
	  addMinutes: __webpack_require__(273),
	  addMonths: __webpack_require__(130),
	  addQuarters: __webpack_require__(274),
	  addSeconds: __webpack_require__(275),
	  addWeeks: __webpack_require__(174),
	  addYears: __webpack_require__(276),
	  areRangesOverlapping: __webpack_require__(706),
	  closestIndexTo: __webpack_require__(707),
	  closestTo: __webpack_require__(708),
	  compareAsc: __webpack_require__(103),
	  compareDesc: __webpack_require__(175),
	  differenceInCalendarDays: __webpack_require__(131),
	  differenceInCalendarISOWeeks: __webpack_require__(709),
	  differenceInCalendarISOYears: __webpack_require__(277),
	  differenceInCalendarMonths: __webpack_require__(278),
	  differenceInCalendarQuarters: __webpack_require__(710),
	  differenceInCalendarWeeks: __webpack_require__(711),
	  differenceInCalendarYears: __webpack_require__(279),
	  differenceInDays: __webpack_require__(280),
	  differenceInHours: __webpack_require__(712),
	  differenceInISOYears: __webpack_require__(713),
	  differenceInMilliseconds: __webpack_require__(132),
	  differenceInMinutes: __webpack_require__(714),
	  differenceInMonths: __webpack_require__(176),
	  differenceInQuarters: __webpack_require__(715),
	  differenceInSeconds: __webpack_require__(177),
	  differenceInWeeks: __webpack_require__(716),
	  differenceInYears: __webpack_require__(717),
	  distanceInWords: __webpack_require__(281),
	  distanceInWordsStrict: __webpack_require__(718),
	  distanceInWordsToNow: __webpack_require__(719),
	  eachDay: __webpack_require__(720),
	  endOfDay: __webpack_require__(178),
	  endOfHour: __webpack_require__(721),
	  endOfISOWeek: __webpack_require__(722),
	  endOfISOYear: __webpack_require__(723),
	  endOfMinute: __webpack_require__(724),
	  endOfMonth: __webpack_require__(282),
	  endOfQuarter: __webpack_require__(725),
	  endOfSecond: __webpack_require__(726),
	  endOfToday: __webpack_require__(727),
	  endOfTomorrow: __webpack_require__(728),
	  endOfWeek: __webpack_require__(283),
	  endOfYear: __webpack_require__(729),
	  endOfYesterday: __webpack_require__(730),
	  format: __webpack_require__(731),
	  getDate: __webpack_require__(732),
	  getDay: __webpack_require__(733),
	  getDayOfYear: __webpack_require__(284),
	  getDaysInMonth: __webpack_require__(179),
	  getDaysInYear: __webpack_require__(734),
	  getHours: __webpack_require__(735),
	  getISODay: __webpack_require__(285),
	  getISOWeek: __webpack_require__(180),
	  getISOWeeksInYear: __webpack_require__(736),
	  getISOYear: __webpack_require__(63),
	  getMilliseconds: __webpack_require__(737),
	  getMinutes: __webpack_require__(738),
	  getMonth: __webpack_require__(739),
	  getOverlappingDaysInRanges: __webpack_require__(740),
	  getQuarter: __webpack_require__(286),
	  getSeconds: __webpack_require__(741),
	  getTime: __webpack_require__(742),
	  getYear: __webpack_require__(743),
	  isAfter: __webpack_require__(744),
	  isBefore: __webpack_require__(745),
	  isDate: __webpack_require__(181),
	  isEqual: __webpack_require__(746),
	  isFirstDayOfMonth: __webpack_require__(747),
	  isFriday: __webpack_require__(748),
	  isFuture: __webpack_require__(749),
	  isLastDayOfMonth: __webpack_require__(750),
	  isLeapYear: __webpack_require__(287),
	  isMonday: __webpack_require__(751),
	  isPast: __webpack_require__(752),
	  isSameDay: __webpack_require__(753),
	  isSameHour: __webpack_require__(288),
	  isSameISOWeek: __webpack_require__(289),
	  isSameISOYear: __webpack_require__(290),
	  isSameMinute: __webpack_require__(291),
	  isSameMonth: __webpack_require__(292),
	  isSameQuarter: __webpack_require__(293),
	  isSameSecond: __webpack_require__(294),
	  isSameWeek: __webpack_require__(182),
	  isSameYear: __webpack_require__(295),
	  isSaturday: __webpack_require__(754),
	  isSunday: __webpack_require__(755),
	  isThisHour: __webpack_require__(756),
	  isThisISOWeek: __webpack_require__(757),
	  isThisISOYear: __webpack_require__(758),
	  isThisMinute: __webpack_require__(759),
	  isThisMonth: __webpack_require__(760),
	  isThisQuarter: __webpack_require__(761),
	  isThisSecond: __webpack_require__(762),
	  isThisWeek: __webpack_require__(763),
	  isThisYear: __webpack_require__(764),
	  isThursday: __webpack_require__(765),
	  isToday: __webpack_require__(766),
	  isTomorrow: __webpack_require__(767),
	  isTuesday: __webpack_require__(768),
	  isValid: __webpack_require__(296),
	  isWednesday: __webpack_require__(769),
	  isWeekend: __webpack_require__(770),
	  isWithinRange: __webpack_require__(771),
	  isYesterday: __webpack_require__(772),
	  lastDayOfISOWeek: __webpack_require__(773),
	  lastDayOfISOYear: __webpack_require__(774),
	  lastDayOfMonth: __webpack_require__(775),
	  lastDayOfQuarter: __webpack_require__(776),
	  lastDayOfWeek: __webpack_require__(297),
	  lastDayOfYear: __webpack_require__(777),
	  max: __webpack_require__(781),
	  min: __webpack_require__(782),
	  parse: __webpack_require__(3),
	  setDate: __webpack_require__(783),
	  setDay: __webpack_require__(784),
	  setDayOfYear: __webpack_require__(785),
	  setHours: __webpack_require__(786),
	  setISODay: __webpack_require__(787),
	  setISOWeek: __webpack_require__(788),
	  setISOYear: __webpack_require__(298),
	  setMilliseconds: __webpack_require__(789),
	  setMinutes: __webpack_require__(790),
	  setMonth: __webpack_require__(299),
	  setQuarter: __webpack_require__(791),
	  setSeconds: __webpack_require__(792),
	  setYear: __webpack_require__(793),
	  startOfDay: __webpack_require__(64),
	  startOfHour: __webpack_require__(300),
	  startOfISOWeek: __webpack_require__(65),
	  startOfISOYear: __webpack_require__(104),
	  startOfMinute: __webpack_require__(301),
	  startOfMonth: __webpack_require__(794),
	  startOfQuarter: __webpack_require__(302),
	  startOfSecond: __webpack_require__(303),
	  startOfToday: __webpack_require__(795),
	  startOfTomorrow: __webpack_require__(796),
	  startOfWeek: __webpack_require__(133),
	  startOfYear: __webpack_require__(304),
	  startOfYesterday: __webpack_require__(797),
	  subDays: __webpack_require__(798),
	  subHours: __webpack_require__(799),
	  subISOYears: __webpack_require__(305),
	  subMilliseconds: __webpack_require__(800),
	  subMinutes: __webpack_require__(801),
	  subMonths: __webpack_require__(802),
	  subQuarters: __webpack_require__(803),
	  subSeconds: __webpack_require__(804),
	  subWeeks: __webpack_require__(805),
	  subYears: __webpack_require__(806)
	}


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(339);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(552);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1177);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1176);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1175);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(551);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(553);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1200);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1199);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(31)))

/***/ },
/* 60 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(74);
	var IE8_DOM_DEFINE = __webpack_require__(259);
	var toPrimitive = __webpack_require__(171);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(51) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(260);
	var defined = __webpack_require__(163);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var startOfISOWeek = __webpack_require__(65)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * var result = getISOYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	
	  var fourthOfJanuaryOfNextYear = new Date(0)
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
	  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)
	
	  var fourthOfJanuaryOfThisYear = new Date(0)
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
	  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year
	  } else {
	    return year - 1
	  }
	}
	
	module.exports = getISOYear


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a day
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfDay


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var startOfWeek = __webpack_require__(133)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek (dirtyDate) {
	  return startOfWeek(dirtyDate, {weekStartsOn: 1})
	}
	
	module.exports = startOfISOWeek


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Hoek = __webpack_require__(32);
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.create = function (key, options) {
	
	    Hoek.assert(typeof key === 'string', 'Invalid reference key:', key);
	
	    var settings = Hoek.clone(options);         // options can be reused and modified
	
	    var ref = function (value, validationOptions) {
	
	        return Hoek.reach(ref.isContext ? validationOptions.context : value, ref.key, settings);
	    };
	
	    ref.isContext = (key[0] === ((settings && settings.contextPrefix) || '$'));
	    ref.key = (ref.isContext ? key.slice(1) : key);
	    ref.path = ref.key.split((settings && settings.separator) || '.');
	    ref.depth = ref.path.length;
	    ref.root = ref.path[0];
	    ref.isJoi = true;
	
	    ref.toString = function () {
	
	        return (ref.isContext ? 'context:' : 'ref:') + ref.key;
	    };
	
	    return ref;
	};
	
	
	exports.isRef = function (ref) {
	
	    return typeof ref === 'function' && ref.isJoi;
	};
	
	
	exports.push = function (array, ref) {
	
	    if (exports.isRef(ref) &&
	        !ref.isContext) {
	
	        array.push(ref.root);
	    }
	};


/***/ },
/* 67 */
[1210, 15],
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(309).EventEmitter;
	var inherits = __webpack_require__(79);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(1188);
	Stream.Writable = __webpack_require__(1190);
	Stream.Duplex = __webpack_require__(1186);
	Stream.Transform = __webpack_require__(1189);
	Stream.PassThrough = __webpack_require__(1187);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(100);
	util.inherits = __webpack_require__(79);
	/*</replacement>*/
	
	var Readable = __webpack_require__(555);
	var Writable = __webpack_require__(232);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "v1", {
	  enumerable: true,
	  get: function () {
	    return _v.default;
	  }
	});
	Object.defineProperty(exports, "v3", {
	  enumerable: true,
	  get: function () {
	    return _v2.default;
	  }
	});
	Object.defineProperty(exports, "v4", {
	  enumerable: true,
	  get: function () {
	    return _v3.default;
	  }
	});
	Object.defineProperty(exports, "v5", {
	  enumerable: true,
	  get: function () {
	    return _v4.default;
	  }
	});
	
	var _v = _interopRequireDefault(__webpack_require__(1203));
	
	var _v2 = _interopRequireDefault(__webpack_require__(1204));
	
	var _v3 = _interopRequireDefault(__webpack_require__(1205));
	
	var _v4 = _interopRequireDefault(__webpack_require__(1206));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = {"scApiUrl":"https://sc-api.prod.shippingcart.com/","f3ApiUrl":"https://api.lbcx.ph/v1/","scUxUrl":"https://www.shippingcart.com/","fbAppId":"970241339660687","extensionId":"comhbeibpkdfofkamlfoacboohagncbk","adyenDropIn":"live_EG4WGUMBLJAJPM4OKMTC3QWALQHABNJL"};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getParcel = getParcel;
	exports.getProhibitedParcel = getProhibitedParcel;
	exports.getParcelById = getParcelById;
	exports.updateInsuredValue = updateInsuredValue;
	exports.showInsuredValueErrorMessage = showInsuredValueErrorMessage;
	exports.showInsuredValueLessThanZeroErrorMessage = showInsuredValueLessThanZeroErrorMessage;
	exports.showInsuredValueNaNErrorMessage = showInsuredValueNaNErrorMessage;
	exports.removeInsuredValueErrorMessage = removeInsuredValueErrorMessage;
	exports.updateInsuredValueAndRecalculateShipmentCost = updateInsuredValueAndRecalculateShipmentCost;
	exports.getNotification = getNotification;
	exports.readNotification = readNotification;
	exports.readAllNotification = readAllNotification;
	exports.getCartData = getCartData;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _warehouseFlags = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	function getParcel(token) {
	  return function (dispatch) {
	    dispatch({ type: 'GET_PARCEL_FETCHING' });
	    _axios2.default.get(apiUrl + 'parcels', token).then(function (response) {
	      dispatch({ type: 'GETPARCEL_USER_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GETPARCEL_USER_REJECTED', payload: err });
	    });
	  };
	}
	
	function getProhibitedParcel(token) {
	  return function (dispatch) {
	    dispatch({ type: 'GETPROHIBITED_PARCEL_FETCHING' });
	    _axios2.default.get(apiUrl + 'parcels?status=prohibited', token).then(function (response) {
	      dispatch({ type: 'GETPROHIBITED_PARCEL_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GETPARCEL_USER_REJECTED', payload: err });
	    });
	  };
	}
	
	function getParcelById(id) {
	  var token = localStorage.jwtToken;
	  return function (dispatch) {
	    dispatch({ type: 'PARCEL_FETCHING' });
	    _axios2.default.get(apiUrl + 'parcels/' + id, token).then(function (response) {
	      dispatch({ type: 'GET_PARCEL_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_PARCEL_REJECTED', payload: err });
	    });
	  };
	}
	
	function updateInsuredValue(token, parcel_id, insured_value, warehouse_id, destination_country) {
	  return function (dispatch) {
	    dispatch({ type: 'PARCEL_UPDATING' });
	    _axios2.default.put(apiUrl + 'parcels/' + parcel_id + '/update-insured-value', { insured_value: insured_value,
	      warehouse_id: warehouse_id,
	      destination_country: destination_country
	    }).then(function (response) {
	      dispatch({ type: 'UPDATE_INSURED_VALUE_FULFILLED', payload: response.data });
	
	      _axios2.default.post(apiUrl + 'users/cart', { "data": { "warehouse": (0, _warehouseFlags.warehouseIDToCode)(warehouse_id).toLowerCase(), "prohibited": null, "offsize": null } }).then(function (response) {
	        dispatch({ type: 'GET_CART_DATA_FULFILLED', payload: response.data });
	        dispatch({ type: 'PARCEL_UPDATED' });
	      }).catch(function (err) {
	        dispatch({ type: 'GET_CART_DATA_REJECTED', payload: err });
	        dispatch({ type: 'PARCEL_UPDATED' });
	      });
	    }).catch(function (error) {
	      dispatch({ type: 'UPDATE_INSURED_VALUE_REJECTED', payload: error.response });
	      dispatch({ type: 'PARCEL_UPDATED' });
	    });
	  };
	}
	
	function showInsuredValueErrorMessage() {
	
	  return function (dispatch) {
	    dispatch({ type: 'SHOW_INSURED_VALUE_ERROR_MESSAGE' });
	  };
	}
	
	function showInsuredValueLessThanZeroErrorMessage() {
	
	  return function (dispatch) {
	    dispatch({ type: 'SHOW_INSURED_VALUE_LESS_THAN_ZERO_ERROR_MESSAGE' });
	  };
	}
	
	function showInsuredValueNaNErrorMessage() {
	
	  return function (dispatch) {
	    dispatch({ type: 'SHOW_INSURED_VALUE_NAN_ERROR_MESSAGE' });
	  };
	}
	
	function removeInsuredValueErrorMessage() {
	
	  return function (dispatch) {
	    dispatch({ type: 'REMOVE_INSURED_VALUE_ERROR_MESSAGE' });
	  };
	}
	
	function updateInsuredValueAndRecalculateShipmentCost(parcel_id, insured_value, token, chkItemArray, insurance, warehouse_id, shipment_location_details, willResetInsuredError, sc_protect) {
	  return function (dispatch) {
	    dispatch({ type: 'PARCEL_UPDATING' });
	    _axios2.default.put(apiUrl + 'parcels/' + parcel_id + '/update-insured-value', { insured_value: insured_value,
	      warehouse_id: warehouse_id,
	      "destination_country": shipment_location_details.destination
	    }).then(function (update_response) {
	      dispatch({ type: 'UPDATE_INSURED_VALUE_FULFILLED', payload: update_response.data });
	      dispatch({ type: 'PARCEL_UPDATING' });
	      _axios2.default.post(apiUrl + 'users/cart', { "data": { "warehouse": (0, _warehouseFlags.warehouseIDToCode)(Object.values(warehouse_id)[0]).toLowerCase(), "prohibited": null, "offsize": null } }).then(function (response) {
	        dispatch({ type: 'GET_CART_DATA_FULFILLED', payload: response.data });
	      }).catch(function (err) {
	        dispatch({ type: 'GET_CART_DATA_REJECTED', payload: err });
	      });
	      var payload = {
	        token: token,
	        "air": {
	          "items": chkItemArray.air
	        },
	        "sea": {
	          "items": chkItemArray.sea
	        },
	        shipment_location_details: shipment_location_details,
	        insurance: insurance,
	        warehouse_id: warehouse_id
	      };
	      if (sc_protect) {
	        payload.sc_protect = sc_protect;
	      }
	      return _axios2.default.post(apiUrl + 'shipments', payload);
	    }, function (update_error) {
	      dispatch({ type: 'UPDATE_INSURED_VALUE_REJECTED', payload: update_error.response });
	    }).then(function (calculate_response) {
	      if (calculate_response) {
	        dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: calculate_response.data });
	        dispatch({ type: 'PARCEL_UPDATED' });
	      }
	    }, function (calculate_error) {
	      dispatch({ type: 'CHECKOUT_ITEM_REJECTED', payload: calculate_error });
	      dispatch({ type: 'PARCEL_UPDATED' });
	    }).catch(function (error) {
	      // dispatch({type: 'UPDATE_INSURED_VALUE_REJECTED', payload: error.response,})
	    });
	
	    if (willResetInsuredError) {
	      dispatch({ type: 'PARCEL_UPDATED' });
	      dispatch({ type: 'RESET_INSURED_VALUE_ERROR', payload: null });
	    }
	  };
	}
	
	function getNotification(id) {
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'notifications/' + id + '/get-notifications?desktop_only=true').then(function (response) {
	      dispatch({ type: 'GET_NOTIFICATION_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_NOTIFICATION_REJECTED', payload: err });
	    });
	  };
	}
	function readNotification(id, read) {
	  return function (dispatch) {
	    _axios2.default.put(apiUrl + 'notifications/' + id, {
	      "data": {
	        "read": read
	      }
	    }).then(function (response) {
	      dispatch({ type: 'READ_NOTIFICATION_FULFILLED', payload: response.data });
	      dispatch(getNotification(response.data.data.attributes.party_id));
	    }).catch(function (err) {
	      dispatch({ type: 'GET_NOTIFICATION_REJECTED', payload: err });
	    });
	  };
	}
	function readAllNotification(id, read) {
	  return function (dispatch) {
	    _axios2.default.put(apiUrl + 'notifications/' + id + '/read-all', {
	      "data": {
	        "read": read
	      }
	    }).then(function (response) {
	      dispatch({ type: 'READ_NOTIFICATION_FULFILLED', payload: response.data });
	      dispatch(getNotification(id));
	    }).catch(function (err) {
	      dispatch({ type: 'GET_NOTIFICATION_REJECTED', payload: err });
	    });
	  };
	}
	
	function getCartData() {
	  var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var offsize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  return function (dispatch) {
	    dispatch({ type: 'GET_CART_DATA_FETCHING' });
	    _axios2.default.post(apiUrl + 'users/cart', { "data": { "warehouse": origin, "prohibited": null, offsize: offsize } }).then(function (response) {
	      dispatch({ type: 'GET_CART_DATA_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_CART_DATA_REJECTED', payload: err });
	    });
	  };
	}

/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var renderFlagIconRound = exports.renderFlagIconRound = function renderFlagIconRound(countryCode) {
	  var icons = {
	    US: 'https://cdn.shippingcart.com/assets/flag-round-shadow-us-20210915110953.svg',
	    UK: 'https://cdn.shippingcart.com/assets/flag-round-shadow-uk-20210915111000.svg',
	    AU: 'https://cdn.shippingcart.com/assets/flag-round-shadow-au-20210915111007.svg',
	    KR: 'https://cdn.shippingcart.com/assets/flag-round-shadow-kr-20210915111013.svg',
	    PH: 'https://cdn.shippingcart.com/assets/flag-round-shadow-ph-20210915111020.svg',
	    MY: 'https://cdn.shippingcart.com/assets/flag-round-shadow-my-20210915111027.svg',
	    JP: 'https://cdn.shippingcart.com/assets/flag-round-shadow-jp-20211117050029.svg',
	    default: 'https://cdn.shippingcart.com/assets/flag-round-shadow-us-20210915110953.svg'
	  };
	
	  return icons[convertCountryIDToCode(countryCode)] || icons.default;
	};
	
	var renderFlagSquareSmall = exports.renderFlagSquareSmall = function renderFlagSquareSmall(countryCode) {
	  var icons = {
	    US: 'https://cdn.shippingcart.com/assets/flag-full-shadow-small-us-20220628101526.svg',
	    UK: 'https://cdn.shippingcart.com/assets/flag-full-shadow-small-uk-20220628101526.svg',
	    AU: 'https://cdn.shippingcart.com/assets/flag-full-shadow-small-au-20220628101526.svg',
	    KR: 'https://cdn.shippingcart.com/assets/flag-full-shadow-small-kr-20220628101526.svg',
	    JP: 'https://cdn.shippingcart.com/assets/flag-full-shadow-small-jp-20220628101526.svg',
	    default: 'https://cdn.shippingcart.com/assets/flag-full-shadow-small-us-20220628101526.svg'
	  };
	
	  return icons[convertCountryIDToCode(countryCode)] || icons.default;
	};
	
	var convertCountryIDToCode = function convertCountryIDToCode(value) {
	  switch (value) {
	    case 1:
	      return 'US';
	    case 2:
	      return 'UK';
	    case 3:
	      return 'AU';
	    case 4:
	      return 'KR';
	    case 5:
	      return 'JP';
	    default:
	      return value;
	  }
	};
	
	var warehouseIDToCode = exports.warehouseIDToCode = function warehouseIDToCode(value) {
	  switch (value) {
	    case 1:
	      return 'us';
	    case 2:
	      return 'uk';
	    case 3:
	      return 'au';
	    case 4:
	      return 'kr';
	    case 5:
	      return 'jp';
	    case 6:
	      return 'or';
	    default:
	      return value;
	  }
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(76);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(61);
	var createDesc = __webpack_require__(99);
	module.exports = __webpack_require__(51) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 76 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(55);
	
	var _Actions = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 79 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(661), __esModule: true };

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(205);
	var setInnerHTML = __webpack_require__(147);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(213);
	var setTextContent = __webpack_require__(514);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var invariant = __webpack_require__(11);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1059);
	var ReactInstrumentation = __webpack_require__(41);
	
	var warning = __webpack_require__(12);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(153);
	
	var ReactChildren = __webpack_require__(1159);
	var ReactComponent = __webpack_require__(229);
	var ReactPureComponent = __webpack_require__(1164);
	var ReactClass = __webpack_require__(1160);
	var ReactDOMFactories = __webpack_require__(1161);
	var ReactElement = __webpack_require__(88);
	var ReactPropTypes = __webpack_require__(1162);
	var ReactVersion = __webpack_require__(1165);
	
	var onlyChild = __webpack_require__(1166);
	var warning = __webpack_require__(12);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(153);
	
	var ReactCurrentOwner = __webpack_require__(49);
	
	var warning = __webpack_require__(12);
	var canDefineProperty = __webpack_require__(548);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(546);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 89 */
15,
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.signup = signup;
	exports.sendOtp = sendOtp;
	exports.resetSignUp = resetSignUp;
	exports.getCopyrightYear = getCopyrightYear;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _store = __webpack_require__(20);
	
	var _setAuthorizationToken = __webpack_require__(160);
	
	var _setAuthorizationToken2 = _interopRequireDefault(_setAuthorizationToken);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _analyticsEvents = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	var rootUrl = _CommonConstants2.default.Actions.rootUrl;
	
	function signup(resendOTPData, email, password, password_confirmation, first_name, middle_name, last_name, gender, contact_number, birthdate, recaptcha, partnerCode) {
	  return function (dispatch) {
	    var attributes = resendOTPData !== null ? resendOTPData : {
	      'email': email,
	      'password': password,
	      'password_confirmation': password_confirmation,
	      'last_name': last_name,
	      'middle_name': middle_name,
	      'first_name': first_name,
	      'gender': gender,
	      'phone_number': contact_number,
	      'birthdate': birthdate,
	      'recaptcha': recaptcha,
	      'pcode': partnerCode
	    };
	    dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	    _axios2.default.post(rootUrl + 'sign-up', {
	      'data': {
	        'type': 'users',
	        attributes: attributes
	      }
	    }).then(function (response) {
	      dispatch({ type: 'SIGNUP_USER_FULFILLED', payload: response.data });
	      localStorage.setItem("otp_response", JSON.stringify(response.data));
	      localStorage.setItem("otp_redirect", "signup");
	      _store.history.push('/otp-service');
	    }).catch(function (err) {
	      dispatch({ type: 'SIGNUP_USER_REJECTED', payload: err });
	    });
	  };
	}
	
	function sendOtp(payload, otpCode) {
	  return function (dispatch) {
	    _axios2.default.post(rootUrl + 'multifactor', {
	      'data': {
	        'type': 'users_otp',
	        'attributes': Object.assign({}, payload, {
	          otp_code: otpCode
	        })
	      }
	    }).then(function (response) {
	      var token = response.data.token;
	      localStorage.setItem('jwtToken', token);
	      localStorage.removeItem('otp_response');
	      localStorage.removeItem('otp_redirect');
	      (0, _setAuthorizationToken2.default)(token);
	      dispatch({ type: 'SEND_OTP_FULFILLED', payload: response.data });
	      (0, _analyticsEvents.recordEvent)('sign_up_2019', 'Sign Up 2019', 'Completed', payload.email);
	      _store.history.push('/signup-success');
	    }).catch(function (err) {
	      (0, _analyticsEvents.recordEvent)('sign_up_2019', 'Sign Up 2019', 'Failed', payload.email);
	      dispatch({ type: 'SEND_OTP_REJECTED', payload: err });
	    });
	  };
	}
	
	function resetSignUp() {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_SIGNUP' });
	  };
	}
	function getCopyrightYear() {
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'year').then(function (response) {
	      dispatch({ type: 'GET_YEAR_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_YEAR_REJECTED', payload: err });
	    });
	  };
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DamagedBanner(props) {
	  var message = props.message,
	      _props$bgColor = props.bgColor,
	      bgColor = _props$bgColor === undefined ? null : _props$bgColor,
	      _props$marginTop = props.marginTop,
	      marginTop = _props$marginTop === undefined ? null : _props$marginTop,
	      _props$padding = props.padding,
	      padding = _props$padding === undefined ? null : _props$padding,
	      _props$damaged = props.damaged,
	      damaged = _props$damaged === undefined ? true : _props$damaged;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        display: 'flex',
	        padding: padding || '10px',
	        alignItems: 'center',
	        backgroundColor: bgColor || '#FEF6E7',
	        border: bgColor ? 'none' : '1px solid #FEAB10',
	        borderRadius: '4px',
	        marginBottom: '10px',
	        marginTop: marginTop || '10px',
	        fontSize: '12px'
	      } },
	    _react2.default.createElement('div', { className: 'fa ' + (damaged ? 'icon-damaged' : 'icon-exceed-limit') + ' fa-fw', style: { alignSelf: 'center', marginRight: '8px', backgroundSize: 'contain' } }),
	    _react2.default.createElement(
	      'div',
	      null,
	      message
	    )
	  );
	}
	exports.default = DamagedBanner;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutBoundBanner(props) {
	  var _JSON$parse = JSON.parse(props.outBoundBannerData[0].settings),
	      redirection_link = _JSON$parse.redirection_link,
	      message = _JSON$parse.message,
	      status = _JSON$parse.status;
	
	  return status && status.value === 1 ? _react2.default.createElement(
	    "div",
	    { className: "sc-warning", style: { padding: '10px 24px', height: 'auto', background: '#FEF6E7', borderRadius: '5px', border: 'none', width: 'auto' } },
	    _react2.default.createElement(
	      "div",
	      null,
	      message && message.value
	    ),
	    _react2.default.createElement(
	      "span",
	      { style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer' }, onClick: function onClick() {
	          _store.history.push(redirection_link && redirection_link.value);
	        } },
	      _react2.default.createElement("i", {
	        className: "fa fa-exclamation-circle",
	        style: { color: '#0375D9', fontSize: 13, marginRight: '5px' }
	      }),
	      "Learn more."
	    )
	  ) : null;
	}
	exports.default = OutBoundBanner;

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var filterWarehouse = exports.filterWarehouse = function filterWarehouse(warehouses, userAccount) {
	  return (
	    // warehouses
	    warehouses.filter(function (warehouse) {
	      return warehouse.id !== 1;
	    })
	  );
	};
	// for whitelisting
	// userAccount ?
	// warehouses.filter(warehouse =>
	//   !accountNumber.find(accountNumber => accountNumber === userAccount.account_number)
	//     ? warehouse.id !== 1
	//     : warehouse.id !== 6,
	// ) : warehouses.filter(warehouse => warehouse.id !== 1)
	
	var accountNumber = exports.accountNumber = [
	// staging account number
	// '53-504119',
	// '86-352797',
	// '28-834174',
	// '59-898183',
	// '24-171330',
	// '53-228572',
	// '37-819426',
	// '12-497200',
	// '12-420535',
	// '43-687767',
	// '88-167625',
	// '73-742646',
	// '48-199091',
	// '80-100137',
	// '23-219601',
	// '64-312855',
	//prod
	'63-295648', '20-595738', '12-420535', '61-854920', '82-732382', '28-615882', '77-363736', '59-653617', '71-534632', '88-886422', '28-734851', '99-4657', '68-249652', '99-3423', '38-610054', '77-141334', '38-444426', '63-962263', '55-844621', '54-534745', '66-480119'];

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = clamp
	
	function clamp(value, min, max) {
	  return min < max
	    ? (value < min ? min : value > max ? max : value)
	    : (value < max ? max : value > min ? min : value)
	}


/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(264);
	var enumBugKeys = __webpack_require__(164);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 98 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added
	 * @returns {Date} the new date with the days added
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays (dirtyDate, dirtyAmount) {
	  var date = parse(dirtyDate)
	  var amount = Number(dirtyAmount)
	  date.setDate(date.getDate() + amount)
	  return date
	}
	
	module.exports = addDays


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @returns {Date} the new date with the milliseconds added
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds (dirtyDate, dirtyAmount) {
	  var timestamp = parse(dirtyDate).getTime()
	  var amount = Number(dirtyAmount)
	  return new Date(timestamp + amount)
	}
	
	module.exports = addMilliseconds


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * var result = compareAsc(
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * )
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var timeLeft = dateLeft.getTime()
	  var dateRight = parse(dirtyDateRight)
	  var timeRight = dateRight.getTime()
	
	  if (timeLeft < timeRight) {
	    return -1
	  } else if (timeLeft > timeRight) {
	    return 1
	  } else {
	    return 0
	  }
	}
	
	module.exports = compareAsc


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(63)
	var startOfISOWeek = __webpack_require__(65)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an ISO year
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * var result = startOfISOYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOYear (dirtyDate) {
	  var year = getISOYear(dirtyDate)
	  var fourthOfJanuary = new Date(0)
	  fourthOfJanuary.setFullYear(year, 0, 4)
	  fourthOfJanuary.setHours(0, 0, 0, 0)
	  var date = startOfISOWeek(fourthOfJanuary)
	  return date
	}
	
	module.exports = startOfISOYear


/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Hoek = __webpack_require__(32);
	var Ref = __webpack_require__(66);
	
	// Type modules are delay-loaded to prevent circular dependencies
	
	
	// Declare internals
	
	var internals = {
	    any: null,
	    date: __webpack_require__(194),
	    string: __webpack_require__(328),
	    number: __webpack_require__(326),
	    boolean: __webpack_require__(325),
	    alt: null,
	    object: null
	};
	
	
	exports.schema = function (config) {
	
	    internals.any = internals.any || new (__webpack_require__(43))();
	    internals.alt = internals.alt || __webpack_require__(193);
	    internals.object = internals.object || __webpack_require__(327);
	
	    if (config &&
	        typeof config === 'object') {
	
	        if (config.isJoi) {
	            return config;
	        }
	
	        if (Array.isArray(config)) {
	            return internals.alt.try(config);
	        }
	
	        if (config instanceof RegExp) {
	            return internals.string.regex(config);
	        }
	
	        if (config instanceof Date) {
	            return internals.date.valid(config);
	        }
	
	        return internals.object.keys(config);
	    }
	
	    if (typeof config === 'string') {
	        return internals.string.valid(config);
	    }
	
	    if (typeof config === 'number') {
	        return internals.number.valid(config);
	    }
	
	    if (typeof config === 'boolean') {
	        return internals.boolean.valid(config);
	    }
	
	    if (Ref.isRef(config)) {
	        return internals.any.valid(config);
	    }
	
	    Hoek.assert(config === null, 'Invalid schema content:', config);
	
	    return internals.any.valid(null);
	};
	
	
	exports.ref = function (id) {
	
	    return Ref.isRef(id) ? id : Ref.create(id);
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(338),
	    getRawTag = __webpack_require__(924),
	    objectToString = __webpack_require__(930);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(918),
	    getValue = __webpack_require__(926);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(80);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  block: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  componentClass: _elementType2['default'],
	  href: _react2['default'].PropTypes.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _react2['default'].PropTypes.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var EventPluginRegistry = __webpack_require__(206);
	var EventPluginUtils = __webpack_require__(207);
	var ReactErrorUtils = __webpack_require__(211);
	
	var accumulateInto = __webpack_require__(508);
	var forEachAccumulated = __webpack_require__(509);
	var invariant = __webpack_require__(11);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(110);
	var EventPluginUtils = __webpack_require__(207);
	
	var accumulateInto = __webpack_require__(508);
	var forEachAccumulated = __webpack_require__(509);
	var warning = __webpack_require__(12);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 112 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	var getEventTarget = __webpack_require__(216);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(37);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(1154);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(1087);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(1088);
	
	var _HelmetConstants = __webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(116);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 116 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    arrayOf = _react.PropTypes.arrayOf,
	    oneOfType = _react.PropTypes.oneOfType,
	    element = _react.PropTypes.element,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(18)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.prototype = Object.create(Buffer.prototype)
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCmsBody = getCmsBody;
	exports.getCMSList = getCMSList;
	exports.getMainBannerList = getMainBannerList;
	exports.getFeaturedBannerList = getFeaturedBannerList;
	exports.putBannerClick = putBannerClick;
	exports.getHomepageBlocks = getHomepageBlocks;
	exports.getModalBlocks = getModalBlocks;
	exports.resetCms = resetCms;
	exports.closeModal = closeModal;
	exports.getCartBanner = getCartBanner;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	function getCmsBody(slug) {
	  return function (dispatch) {
	    dispatch({ type: 'FETCHING' });
	    _axios2.default.get(apiUrl + 'cms/pages/' + slug).then(function (response) {
	      dispatch({ type: 'GET_CMS_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_CMS_REJECTED', payload: err });
	    });
	  };
	}
	function getCMSList() {
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'cms/pages').then(function (response) {
	      dispatch({ type: 'GET_CMS_LIST_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_CMS_LIST_REJECTED', payload: err });
	    });
	  };
	}
	function getMainBannerList() {
	  return function (dispatch) {
	    dispatch({ type: 'GET_MAIN_BANNER_LIST_FETCHING' });
	    _axios2.default.get(apiUrl + 'promotion/main').then(function (response) {
	      dispatch({ type: 'GET_MAIN_BANNER_LIST_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_MAIN_BANNER_LIST_REJECTED', payload: err });
	    });
	  };
	}
	function getFeaturedBannerList() {
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'promotion/featured').then(function (response) {
	      dispatch({ type: 'GET_FEATURED_BANNER_LIST_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_FEATURED_BANNER_LIST_REJECTED', payload: err });
	    });
	  };
	}
	function putBannerClick(token, id, url) {
	  return function (dispatch) {
	    _axios2.default.put(apiUrl + 'promotions/click', { token: token, id: id }).then(function (response) {
	      dispatch({ type: 'PUT_BANNER_CLICK_FULFILLED', payload: response.data });
	      window.location.href = url;
	    }).catch(function (err) {
	      dispatch({ type: 'PUT_BANNER_CLICK_REJECTED', payload: err });
	      window.location.href = url;
	    });
	  };
	}
	function getHomepageBlocks() {
	  return function (dispatch) {
	    dispatch({ type: 'GET_HOMEPAGE_BLOCKS_FETCHING' });
	    _axios2.default.get(apiUrl + 'cms/blocks/HomeWelcome,HomeWelcomeOut,HomeSocial,HomeShoppers,HomeShippingEase,HomeStore,HomeStoreOut?variable=1').then(function (response) {
	      dispatch({ type: 'GET_HOMEPAGE_BLOCKS_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_HOMEPAGE_BLOCKS_REJECTED', payload: err });
	    });
	  };
	}
	
	function getModalBlocks(page) {
	  var slug = {
	    cartExtension: 'Extension-Modal',
	    home: 'Homepage-Modal',
	    cart: 'Cart-Modal',
	    checkout: 'Checkout-Modal'
	  };
	
	  return function (dispatch) {
	    dispatch({ type: 'GET_MODAL_BLOCKS_FETCHING' });
	
	    _axios2.default.get(apiUrl + 'cms/blocks/' + slug[page]).then(function (response) {
	      if (page === 'cartExtension') {
	        dispatch({ type: 'GET_MODAL_EXTENSION_FULFILLED', payload: response.data });
	      } else {
	        dispatch({ type: 'GET_MODAL_BLOCKS_FULFILLED', payload: response.data });
	      }
	    }).catch(function (err) {
	      dispatch({ type: 'GET_MODAL_BLOCKS_REJECTED', payload: err });
	    });
	  };
	}
	
	function resetCms() {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_CMS' });
	  };
	}
	
	function closeModal(page) {
	  return function (dispatch) {
	    if (page === "cartExtension") {
	      dispatch({ type: 'HIDE_ADVISORY_EXTENSION_MODAL', page: page });
	    } else {
	      dispatch({ type: 'HIDE_ADVISORY_MODAL', page: page });
	      if (page === "cart") {
	        localStorage.setItem("cartModalShowed", true);
	      }
	      if (page === "checkout") {
	        localStorage.setItem("checkoutModalShowed", true);
	      }
	    }
	  };
	}
	
	function getCartBanner() {
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'bnners?type=marketing_banner&status=1&category=cart&per_page=1').then(function (response) {
	      dispatch({ type: 'GET_CART_BANNER_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_CART_BANNER_REJECTED', payload: err });
	    });
	  };
	}

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(33);
	
	__webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvisoryModal = function (_Component) {
	  _inherits(AdvisoryModal, _Component);
	
	  function AdvisoryModal() {
	    _classCallCheck(this, AdvisoryModal);
	
	    return _possibleConstructorReturn(this, (AdvisoryModal.__proto__ || Object.getPrototypeOf(AdvisoryModal)).apply(this, arguments));
	  }
	
	  _createClass(AdvisoryModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.props.show, onHide: this.props.close, autoFocus: true, dialogClassName: 'custom-modal', style: { "zIndex": "99999" } },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true, style: { "padding": "0" } }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: this.props.content })
	      );
	    }
	  }]);
	
	  return AdvisoryModal;
	}(_react.Component);
	
	exports.default = AdvisoryModal;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(33);
	
	__webpack_require__(134);
	
	var _DamagedBanner = __webpack_require__(91);
	
	var _DamagedBanner2 = _interopRequireDefault(_DamagedBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
	var seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';
	
	var DamagedModal = function (_Component) {
	  _inherits(DamagedModal, _Component);
	
	  function DamagedModal() {
	    _classCallCheck(this, DamagedModal);
	
	    return _possibleConstructorReturn(this, (DamagedModal.__proto__ || Object.getPrototypeOf(DamagedModal)).apply(this, arguments));
	  }
	
	  _createClass(DamagedModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { className: 'alert-modal-checkout', show: this.props.isOpen, onHide: this.props.handleClose, autoFocus: true },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            'p',
	            { style: { fontSize: '20px', fontWeight: 600 } },
	            'Packages with damaged items'
	          ),
	          _react2.default.createElement(_DamagedBanner2.default, { message: 'All items within package/s listed below are not covered by SC Protect.' }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '20px' } },
	            this.props.damageItems && this.props.damageItems.air && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', alignItems: 'center' } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginRight: 10 } },
	                  _react2.default.createElement('img', { src: airIcon, alt: 'air', style: { width: '24px', height: '24px' } })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { style: { fontSize: 16, fontWeight: 600 } },
	                    'Air Cargo'
	                  )
	                )
	              ),
	              this.props.damageItems.air && this.props.damageItems.air.map(function (item) {
	                return _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '16px',
	                      fontWeight: 600,
	                      padding: '5px 0px',
	                      color: '#636363' } },
	                  item
	                );
	              })
	            ),
	            this.props.damageItems && this.props.damageItems.air && this.props.damageItems.sea && _react2.default.createElement('hr', { style: { margin: '10px 0px' } }),
	            this.props.damageItems && this.props.damageItems.sea && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', alignItems: 'center' } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginRight: 10 } },
	                  _react2.default.createElement('img', { src: seaIcon, alt: 'sea', style: { width: '24px', height: '24px' } })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { style: { fontSize: 16, fontWeight: 600 } },
	                    'Sea Cargo'
	                  )
	                )
	              ),
	              this.props.damageItems.sea && this.props.damageItems.sea.map(function (item) {
	                return _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '16px',
	                      fontWeight: 600,
	                      padding: '5px 0px',
	                      color: '#636363' } },
	                  item
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_reactBootstrap.Modal.Footer, null)
	      );
	    }
	  }]);
	
	  return DamagedModal;
	}(_react.Component);
	
	exports.default = DamagedModal;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(46);
	
	__webpack_require__(829);
	
	__webpack_require__(852);
	
	var _CmsActions = __webpack_require__(119);
	
	var _ParcelAction = __webpack_require__(72);
	
	var _utils = __webpack_require__(13);
	
	var _brandIconMobile = __webpack_require__(873);
	
	var _brandIconMobile2 = _interopRequireDefault(_brandIconMobile);
	
	var _iconUser = __webpack_require__(317);
	
	var _iconUser2 = _interopRequireDefault(_iconUser);
	
	var _notification = __webpack_require__(319);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _notificationActive = __webpack_require__(318);
	
	var _notificationActive2 = _interopRequireDefault(_notificationActive);
	
	var _bars = __webpack_require__(872);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _MobileNotifMenu = __webpack_require__(613);
	
	var _MobileNotifMenu2 = _interopRequireDefault(_MobileNotifMenu);
	
	var _MobileProfileMenu = __webpack_require__(614);
	
	var _MobileProfileMenu2 = _interopRequireDefault(_MobileProfileMenu);
	
	var _MobileHeaderMenu = __webpack_require__(612);
	
	var _MobileHeaderMenu2 = _interopRequireDefault(_MobileHeaderMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import search from '../../../../assets/images/search.svg';
	
	
	var MobileHeaderSidenav = function (_Component) {
	  _inherits(MobileHeaderSidenav, _Component);
	
	  function MobileHeaderSidenav() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MobileHeaderSidenav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MobileHeaderSidenav.__proto__ || Object.getPrototypeOf(MobileHeaderSidenav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSideNavOpen: false,
	      isSideNavOpenNotif: false,
	      isNavProfileOpen: false,
	      isAuthenticated: false,
	      login: null,
	      notification: ""
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MobileHeaderSidenav, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.getFeaturedBannerList();
	      this.props.getMainBannerList();
	      if (localStorage.jwtToken) {
	        this.props.getProhibitedParcel(localStorage.jwtToken);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.isAuthenticated && nextProps.login.fetched && this.props.login.fetched && !nextProps.parcel.notification_error) {
	        if (nextProps.parcel.notification) {
	          var notification = nextProps.parcel.notification_fetched ? nextProps.parcel.notification.data.filter(function (notif) {
	            return notif.attributes.read === 0;
	          }) : null;
	          this.setState({ notification: notification });
	        }
	      }
	      this.setState({
	        isSideNavOpen: nextProps.isSideNavOpen,
	        isAuthenticated: nextProps.isAuthenticated,
	        login: nextProps.login
	      });
	    }
	  }, {
	    key: 'handleLogout',
	    value: function handleLogout() {
	      var _this2 = this;
	
	      localStorage.removeItem('jwtToken');
	      this.setState({ isAuthenticated: false }, function () {
	        return _this2.props.logout();
	      });
	    }
	  }, {
	    key: 'handleScrollDisplay',
	    value: function handleScrollDisplay(shouldHide) {
	      //disable scroll of body when mobile menu is open
	      if (shouldHide) {
	        document.getElementsByTagName('body')[0].setAttribute('class', 'noscroll');
	        return;
	      }
	
	      document.getElementsByTagName('body')[0].classList.remove('noscroll');
	    }
	    // handleTrackPackage() {
	    //   localStorage.setItem("trackPackage", "true");
	    // }
	
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'mobile-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'primary-nav-mobile' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { tabIndex: '0', to: '/', className: 'clearfix' },
	              _react2.default.createElement('img', { alt: 'logo', src: _brandIconMobile2.default })
	            ),
	            this.props.isAuthenticated || localStorage.jwtToken ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', {
	                alt: 'icon',
	                src: this.state.notification && this.state.notification.length ? _notificationActive2.default : _notification2.default,
	                style: { paddingLeft: 20, marginRight: 10 },
	                onClick: function onClick() {
	                  _this3.setState({ isSideNavOpenNotif: true });
	                  _this3.handleScrollDisplay(true);
	                } }),
	              _react2.default.createElement('img', {
	                alt: 'icon',
	                src: _iconUser2.default,
	                style: { paddingLeft: 20, marginRight: 10 },
	                onClick: function onClick() {
	                  _this3.setState({ isNavProfileOpen: true });
	                  _this3.handleScrollDisplay(true);
	                } })
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'mobile-login-signup-links ' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: '/signin',
	                  style: { color: '#AA0E0E', fontWeight: 600, padding: '0px 20px', borderRight: '1px solid #E2E2E2' } },
	                'SIGN IN'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: 'signup',
	                  style: { color: '#AA0E0E', fontWeight: 600, border: '1px solid #AA0E0E', borderRadius: 25, marginLeft: 20, padding: '0px 20px' } },
	                'SIGN UP'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'secondary-nav-mobile ' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'secondary-nav-mobile-links' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/shipping-estimate' },
	                  'Shipping Estimate'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { style: { marginLeft: 15 } },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/track' },
	                  'Tracking'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { alt: 'icon', src: _bars2.default, style: { marginLeft: 15 }, onClick: function onClick() {
	                  _this3.setState({ isSideNavOpen: true });
	                  _this3.handleScrollDisplay(true);
	                } })
	            )
	          )
	        ),
	        _react2.default.createElement(_MobileNotifMenu2.default, {
	          isShown: this.state.isSideNavOpenNotif,
	          notification: this.state.notification,
	          readAllNotification: this.props.readAllNotification,
	          readNotification: this.props.readNotification,
	          closeSideNav: function closeSideNav() {
	            _this3.setState({ isSideNavOpenNotif: false });
	            _this3.handleScrollDisplay(false);
	          } }),
	        _react2.default.createElement(_MobileProfileMenu2.default, {
	          isShown: this.state.isNavProfileOpen,
	          login: this.props.login,
	          isAuthenticated: this.props.isAuthenticated,
	          isMenuDisabled: _utils.disabledCart,
	          logout: this.props.logout,
	          closeMenu: function closeMenu() {
	            _this3.setState({ isNavProfileOpen: false });
	            _this3.handleScrollDisplay(false);
	          } }),
	        _react2.default.createElement(_MobileHeaderMenu2.default, {
	          isShown: this.state.isSideNavOpen,
	          login: this.props.login,
	          isAuthenticated: this.props.isAuthenticated,
	          logout: this.props.logout,
	          closeMenu: function closeMenu() {
	            _this3.setState({ isSideNavOpen: false });
	            _this3.handleScrollDisplay(false);
	          } })
	      );
	    }
	  }]);
	
	  return MobileHeaderSidenav;
	}(_react.Component);
	
	;
	
	var mapDispachToProps = {
	  getFeaturedBannerList: _CmsActions.getFeaturedBannerList,
	  getMainBannerList: _CmsActions.getMainBannerList,
	  getProhibitedParcel: _ParcelAction.getProhibitedParcel,
	  getNotification: _ParcelAction.getNotification,
	  readNotification: _ParcelAction.readNotification,
	  readAllNotification: _ParcelAction.readAllNotification };
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    cms: state.cms,
	    parcel: state.parcel
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(MobileHeaderSidenav);

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _reactRouter = __webpack_require__(14);
	
	var _brandLogo = __webpack_require__(188);
	
	var _brandLogo2 = _interopRequireDefault(_brandLogo);
	
	var _iconUser = __webpack_require__(317);
	
	var _iconUser2 = _interopRequireDefault(_iconUser);
	
	var _angleLeft = __webpack_require__(871);
	
	var _angleLeft2 = _interopRequireDefault(_angleLeft);
	
	var _constants = __webpack_require__(124);
	
	var _utils = __webpack_require__(13);
	
	var _CmsActions = __webpack_require__(119);
	
	var _ParcelAction = __webpack_require__(72);
	
	var _NotificationMenu = __webpack_require__(615);
	
	var _NotificationMenu2 = _interopRequireDefault(_NotificationMenu);
	
	__webpack_require__(853);
	
	__webpack_require__(832);
	
	var _SecondaryMenu = __webpack_require__(616);
	
	var _SecondaryMenu2 = _interopRequireDefault(_SecondaryMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      notification: "",
	      enabledCart: false
	    }, _this.renderFirstName = function () {
	      var firstName = '';
	      if (_this.props.login && _this.props.login.login.party && _this.props.login.login.party.first_name) {
	        firstName = _this.props.login.login.party.first_name;
	      }
	      return firstName;
	    }, _this.renderAccountNumber = function () {
	      var accountNumber = '';
	      if (_this.props.login && _this.props.login.login.party && _this.props.login.login.party.account_number) {
	        accountNumber = _this.props.login.login.party.account_number;
	      }
	      return accountNumber;
	    }, _this.renderProhibitedMenuItem = function () {
	      if (_this.props.parcel.parcel_fetching) return;
	      if (_this.props.parcel.prohibited && _this.props.parcel.prohibited.data.length > 0) {
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/prohibited' },
	            'Prohibited Items'
	          )
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Header, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.getFeaturedBannerList();
	      this.props.getMainBannerList();
	      if (localStorage.jwtToken) {
	        this.props.getProhibitedParcel(localStorage.jwtToken);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.isAuthenticated && nextProps.login.fetched && this.props.login.fetched && !nextProps.parcel.notification_error) {
	        if (nextProps.parcel.getProhibited !== this.props.parcel.getProhibited && !this.props.parcel.notification) {
	          this.props.getNotification(nextProps.login.login.party.party_id);
	        }
	        if (nextProps.parcel.notification) {
	          var notification = nextProps.parcel.notification_fetched ? nextProps.parcel.notification.data.filter(function (notif) {
	            return notif.attributes.read === 0;
	          }) : null;
	          this.setState({ notification: notification });
	        }
	      }
	      if (nextProps.login.fetched && nextProps.login.login.party) {
	        var enabledCart = _utils.adminUserIds.find(function (e) {
	          return e === nextProps.login.login.party.account_number;
	        });
	        this.setState({ enabledCart: enabledCart ? true : false });
	      }
	    }
	
	    // handleTrackPackage() {
	    //   localStorage.setItem("trackPackage", "true");
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'nav-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'primary-nav-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'primary-nav' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/' },
	              _react2.default.createElement('img', { alt: 'icon', src: _brandLogo2.default })
	            ),
	            _react2.default.createElement('div', null),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex' } },
	              _react2.default.createElement(
	                'ul',
	                { className: 'primary-nav-links' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'primary-nav-link' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/shipping-estimate', className: 'primary-nav-link' },
	                    'Shipping Estimate'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/track', className: 'primary-nav-link' },
	                    'Tracking'
	                  )
	                )
	              ),
	              this.props.isAuthenticated || localStorage.jwtToken ? _react2.default.createElement(
	                'div',
	                { style: { marginLeft: 20, display: 'flex' } },
	                _react2.default.createElement(_NotificationMenu2.default, {
	                  isAuthenticated: this.props.isAuthenticated,
	                  notification: this.state.notification,
	                  readAllNotification: this.props.readAllNotification,
	                  readNotification: this.props.readNotification }),
	                _react2.default.createElement('img', { alt: 'icon', src: _iconUser2.default, style: { paddingLeft: 20, marginRight: 10 } }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dropdown cursor-pointer' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'dropdown-toggle', 'data-toggle': 'dropdown', style: {
	                        margin: 0,
	                        whiteSpace: 'nowrap',
	                        height: '67px',
	                        display: 'flex',
	                        alignItems: 'center',
	                        fontSize: '16px'
	                      } },
	                    'Hello! ',
	                    this.renderFirstName(),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'margin-left-10' },
	                      _react2.default.createElement('img', { alt: 'icon', src: _angleLeft2.default })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dropdown-menu primary-nav-links-wrapper ' },
	                    _constants.accountLinks.map(function (link, i) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: i },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: link.route, className: _utils.disabledCart && link.route === '/cart' ? 'isDisabled' : '' },
	                          link.label
	                        )
	                      );
	                    }),
	                    this.renderProhibitedMenuItem(),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/', onClick: this.props.logout },
	                        ' Logout '
	                      )
	                    )
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'flex-container', style: { alignItems: 'center', height: 67 } },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/signin', style: { color: '#AA0E0E', fontWeight: 600, padding: '5px 20px', borderRight: '1px solid #E2E2E2', fontSize: 16 } },
	                  'SIGN IN'
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: 'signup', style: { color: '#AA0E0E', fontWeight: 600, border: '1px solid #AA0E0E', borderRadius: 25, marginLeft: 20, padding: '5px 20px', fontSize: 16 } },
	                  'SIGN UP'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_SecondaryMenu2.default, { accountNumber: this.renderAccountNumber(), firstName: this.renderFirstName() })
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	var mapDispachToProps = {
	  getFeaturedBannerList: _CmsActions.getFeaturedBannerList,
	  getMainBannerList: _CmsActions.getMainBannerList,
	  getProhibitedParcel: _ParcelAction.getProhibitedParcel,
	  getNotification: _ParcelAction.getNotification,
	  readNotification: _ParcelAction.readNotification,
	  readAllNotification: _ParcelAction.readAllNotification };
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    cms: state.cms,
	    parcel: state.parcel
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(Header);

/***/ },
/* 124 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var primaryLinks = exports.primaryLinks = [{
	  id: 'shipping-estimate-header-link',
	  title: 'Shipping Estimate',
	  link: ''
	}, {
	  id: 'tracking-header-link',
	  title: 'Tracking',
	  link: ''
	}, {
	  id: 'search-header-link',
	  title: 'Search',
	  link: ''
	}];
	
	var whereToShopMenu = exports.whereToShopMenu = [{
	  id: 'shop-in-AU-header-link',
	  title: 'Australia',
	  url: '/shop-in-au?utm_source=web&utm_medium=deals&utm_campaign=ph-web-deals-australia-launch-20210309'
	}, {
	  id: 'shop-in-KR-header-link',
	  title: 'Korea',
	  url: '/shop-in-kr?utm_source=website&utm_medium=header&utm_campaign=ph-web-tab-korea-shopping-20210922'
	}, {
	  id: 'shop-in-JP-header-link',
	  title: 'Japan',
	  url: '/shop-in-jp?utm_source=web&utm_medium=banner&utm_campaign=shop-in-japan20210120'
	}, {
	  id: 'shop-in-UK-header-link',
	  title: 'United Kingdom',
	  url: '/shop-in-uk'
	}, {
	  id: 'shop-in-US-header-link',
	  title: 'United States',
	  url: '/shop-in-us'
	}];
	
	var servicesMenu = exports.servicesMenu = [{
	  id: "buy-for-me-header-link",
	  title: "Buy-For-Me",
	  url: "/buy-for-me-shopping-guide"
	}, {
	  id: "sc-protect-header-link",
	  title: "SC Protect",
	  url: "/sc-protect"
	}, {
	  id: "social-seller-header-link",
	  title: "Social Seller",
	  url: "/shippingcart-sellers"
	}, {
	  id: "chrome-extension-header-link",
	  title: "Chrome Extension",
	  url: "https://chrome.google.com/webstore/detail/shippingcart-shop-assist/comhbeibpkdfofkamlfoacboohagncbk?hl=en",
	  external: true
	}];
	
	var offersMenu = exports.offersMenu = function offersMenu(_ref) {
	  var accountNumber = _ref.accountNumber,
	      firstName = _ref.firstName;
	  return [{
	    id: 'promos-header-link',
	    title: 'Promos',
	    url: '/promotions'
	  }, {
	    id: 'rewards-header-link',
	    title: 'Rewards',
	    url: accountNumber ? 'https://rewards.shippingcart.com?account_number=' + accountNumber + '&name=' + firstName : 'https://rewards.shippingcart.com/',
	    external: true
	  }, {
	    id: 'referral-header-link',
	    title: 'Referral',
	    url: '/referral'
	  }];
	};
	
	var helpCenterMenu = exports.helpCenterMenu = [{
	  id: 'about-us-header-link',
	  title: 'About Us',
	  url: '/about-us'
	}, {
	  id: 'how-it-works-header-link',
	  title: 'How it works',
	  url: '/how-it-works'
	}, {
	  id: 'faqs-header-link',
	  title: 'FAQ',
	  url: 'https://help-center.shippingcart.com/hc/en-us',
	  external: true
	}, {
	  id: 'special-handling-header-link',
	  title: 'Special Handling',
	  url: '/special-handling'
	}, {
	  id: 'prohibited-item-header-link',
	  title: 'Prohibited Items',
	  url: '/prohibited-items'
	}];
	
	var legalMenu = exports.legalMenu = [{
	  id: 'terms-and-conditions-header-link',
	  title: 'Terms and Conditions',
	  url: '/terms-conditions'
	}, {
	  id: 'privacy-header-link',
	  title: 'Privacy Policy',
	  url: '/privacy-policy'
	}];
	
	var accountLinks = exports.accountLinks = [{ route: '/cart', label: 'Cart' }, { route: '/shipment', label: 'Shipments' }, { route: '/account', label: 'Account' }];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gtmPush = exports.recordEvent = undefined;
	
	var _regenerator = __webpack_require__(126);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Record Event function
	 * Records an event in Google tag manager for marketing purposes
	 * @param  {[String]} evt [Event name]
	 * @param  {[String]} category [Event category]
	 * @param  {[String]} action [Event action]
	 * @param  {[String]} label [Event label]
	 * @return {[Boolean]}
	 */
	var recordEvent = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(evt, category, action, label, currencyCode, saleValue, vcode) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            console.log('Recording', evt, category, action, label, currencyCode, saleValue, vcode);
	            _context.next = 3;
	            return window.dataLayer.push({
	              event: evt,
	              dl_category: category || '',
	              dl_currencycode: currencyCode || '', //USD
	              dl_salevalue: saleValue || '', //Shipment cost
	              dl_vcode: vcode || '', //Promocode
	              dl_action: action || '',
	              dl_label: label || ''
	            });
	
	          case 3:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function recordEvent(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * Record Event function
	 * Records an event in Google tag manager for marketing purposes
	 * @param  {[String]} args [Any argument]
	 */
	var gtmPush = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var _console, _window$dataLayer;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            (_console = console).log.apply(_console, ['GTM push'].concat(_toConsumableArray(args)));
	            _context2.next = 3;
	            return (_window$dataLayer = window.dataLayer).push.apply(_window$dataLayer, _toConsumableArray(args));
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function gtmPush() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	exports.recordEvent = recordEvent;
	exports.gtmPush = gtmPush;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(652);


/***/ },
/* 127 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(163);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 129 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var getDaysInMonth = __webpack_require__(179)
	
	/**
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added
	 * @returns {Date} the new date with the months added
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths (dirtyDate, dirtyAmount) {
	  var date = parse(dirtyDate)
	  var amount = Number(dirtyAmount)
	  var desiredMonth = date.getMonth() + amount
	  var dateWithDesiredMonth = new Date(0)
	  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
	  dateWithDesiredMonth.setHours(0, 0, 0, 0)
	  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
	  return date
	}
	
	module.exports = addMonths


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(64)
	
	var MILLISECONDS_IN_MINUTE = 60000
	var MILLISECONDS_IN_DAY = 86400000
	
	/**
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 */
	function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
	  var startOfDayLeft = startOfDay(dirtyDateLeft)
	  var startOfDayRight = startOfDay(dirtyDateRight)
	
	  var timestampLeft = startOfDayLeft.getTime() -
	    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	  var timestampRight = startOfDayRight.getTime() -
	    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
	}
	
	module.exports = differenceInCalendarDays


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * var result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getTime() - dateRight.getTime()
	}
	
	module.exports = differenceInMilliseconds


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn
	
	  date.setDate(date.getDate() - diff)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfWeek


/***/ },
/* 134 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 136 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 137 */
/***/ function(module, exports) {

	var JsonWebTokenError = function (message, error) {
	  Error.call(this, message);
	  Error.captureStackTrace(this, this.constructor);
	  this.name = 'JsonWebTokenError';
	  this.message = message;
	  if (error) this.inner = error;
	};
	
	JsonWebTokenError.prototype = Object.create(Error.prototype);
	JsonWebTokenError.prototype.constructor = JsonWebTokenError;
	
	module.exports = JsonWebTokenError;

/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(155)(module)))

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(808);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(184);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(196);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(150);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(151);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(154);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(476);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(963);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(478);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(1011);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _react2['default'].PropTypes.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value.
	   *
	   * ```js
	   * function(Boolean isOpen) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _react2['default'].PropTypes.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _react2['default'].PropTypes.oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onMouseLeave: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick() {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen('click');
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen('keydown');
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event);
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(eventType) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventType;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose() {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(null);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, this.handleClose),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(520);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(494);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var EventPluginRegistry = __webpack_require__(206);
	var ReactEventEmitterMixin = __webpack_require__(1051);
	var ViewportMetrics = __webpack_require__(507);
	
	var getVendorPrefixedEventName = __webpack_require__(1084);
	var isEventSupported = __webpack_require__(217);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(113);
	var ViewportMetrics = __webpack_require__(507);
	
	var getEventModifierState = __webpack_require__(215);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var invariant = __webpack_require__(11);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var DOMNamespaces = __webpack_require__(205);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(213);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('prop-types'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.propTypes);
	        global.Lens = mod.exports;
	    }
	})(this, function (exports, _react, _propTypes) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var Lens = function Lens(props) {
	        var fadeDurationInMs = props.fadeDurationInMs,
	            isHovering = props.isHovering,
	            style = props.style,
	            translateX = props.translateX,
	            translateY = props.translateY;
	
	        var translate = 'translate(' + translateX + 'px, ' + translateY + 'px)';
	        var computedStyle = {
	            position: 'absolute',
	            transform: translate,
	            WebkitTransform: translate,
	            msTransform: translate,
	            opacity: isHovering ? 1 : 0,
	            transition: 'opacity ' + fadeDurationInMs + 'ms ease-in'
	        };
	        var defaultStyle = {
	            width: 'auto',
	            height: 'auto',
	            top: 'auto',
	            right: 'auto',
	            bottom: 'auto',
	            left: 'auto',
	            display: 'block'
	        };
	
	        return _react2.default.createElement('div', { style: Object.assign({}, defaultStyle, style, computedStyle) });
	    };
	
	    Lens.propTypes = {
	        style: _propTypes2.default.object,
	        fadeDurationInMs: _propTypes2.default.number,
	        isHovering: _propTypes2.default.bool,
	        translateX: _propTypes2.default.number,
	        translateY: _propTypes2.default.number,
	        userStyle: _propTypes2.default.object
	    };
	
	    Lens.defaultProps = {
	        isHovering: false,
	        fadeDurationInMs: 0,
	        translateX: 0,
	        translateY: 0
	    };
	
	    exports.default = Lens;
	});

/***/ },
/* 149 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(152);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 153 */
22,
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(1196);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(35);
	var normalizeHeaderName = __webpack_require__(579);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(234);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(234);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warehouseCode = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tour = function (_Component) {
	  _inherits(Tour, _Component);
	
	  function Tour() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tour);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tour.__proto__ || Object.getPrototypeOf(Tour)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tour: {
	        active: "",
	        class: "",
	        heading: "",
	        content: "",
	        prev: "",
	        next: ""
	      }
	    }, _this.cancelTour = function () {
	      _this.setState({
	        tour: {
	          active: null
	        }
	      });
	      localStorage.setItem("TourFinish", "true");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tour, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      localStorage.Tour === "true" && localStorage.TourFinish === "false" ? this.setState({
	        tour: {
	          active: "address",
	          class: "take tour1",
	          heading: "Your Shipping Address",
	          content: 'Use this as your delivery address when you checkout from ' + _warehouseCode.warehouseOR + ' online stores. Don\'t forget to input your complete ShippingCart address, including your account number and phone number when you checkout!',
	          prev: null,
	          next: "cart"
	        }
	      }) : this.setState({ tour: { active: null } });
	      localStorage.removeItem('Tour');
	    }
	  }, {
	    key: 'handleTour',
	    value: function handleTour(step) {
	      switch (step) {
	        case "address":
	          this.setState({
	            tour: {
	              active: "address",
	              class: "take tour1",
	              heading: "Your Shipping Address",
	              content: 'Use this as your delivery address when you checkout from ' + _warehouseCode.warehouseOR + ' online stores. Don\'t forget to input your complete ShippingCart address, including your account number and phone number when you checkout!',
	              prev: null,
	              next: "cart"
	            }
	          });
	          break;
	        case "cart":
	          this.setState({ tour: {
	              active: "cart",
	              class: "take tour2",
	              heading: "Cart",
	              content: 'This is where you can view your purchases from ' + _warehouseCode.warehouseOR + ' online stores once they arrive to the ShippingCart Warehouse. All the information you need is here, including photos. Ship them out when you\'re ready!',
	              prev: "address",
	              next: "shipments"
	            } });
	          break;
	        case "shipments":
	          this.setState({ tour: {
	              active: "shipments",
	              class: "take tour3",
	              heading: "Shipments",
	              content: "This is where you can view your shipping history, whether it's paid, in transit, or delivered. This is where you can track your shipment status, as your tracking number appears here once your shipment status is in transit.",
	              prev: "cart",
	              next: "account"
	            } });
	          break;
	        case "account":
	          this.setState({ tour: {
	              active: "account",
	              class: "take tour4",
	              heading: "Account",
	              content: "This is all about you! This is where you can manage your address book or invite friends to try out the ShippingCart service.",
	              prev: "shipments",
	              next: "estimate"
	            } });
	          break;
	        case "estimate":
	          this.setState({ tour: {
	              active: "estimate",
	              class: "take tour5",
	              heading: "Get Shipping Estimate",
	              content: "You'll need your item's dimensions, so you can calculate your cost on the ShippingCart Cost Calculator. Note that this is only an estimate.",
	              prev: "account",
	              next: "track"
	            } });
	          break;
	        case "track":
	          this.setState({ tour: {
	              active: "track",
	              class: "take tour6",
	              heading: "Track Your Package",
	              content: 'Find out where your package is exactly using the tracking number we provided. Note that this is different from the tracking number provided to you by the ' + _warehouseCode.warehouseOR + ' online store you purchased from.',
	              prev: "estimate",
	              next: null
	            } });
	          break;
	        default:
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var tour = this.state.tour;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: tour.active ? "modal-backdrop in" : "disnone" },
	          ' '
	        ),
	        tour.active ? _react2.default.createElement(
	          'div',
	          { className: tour.class },
	          _react2.default.createElement(
	            'span',
	            { className: 'heading' },
	            tour.heading
	          ),
	          ' ',
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            tour.content
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-right' },
	            tour.prev === null ? null : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-angle-left' })
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'previous', onClick: function onClick() {
	                    return _this2.handleTour(tour.prev);
	                  } },
	                'Previous'
	              )
	            ),
	            tour.next === null ? _react2.default.createElement(
	              'a',
	              { className: 'done', onClick: this.cancelTour },
	              'Done'
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'next', onClick: function onClick() {
	                    return _this2.handleTour(tour.next);
	                  } },
	                'Next'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-angle-right' })
	              )
	            )
	          ),
	          tour.next === null ? null : _react2.default.createElement(
	            'div',
	            { className: 'skip-wrapper' },
	            _react2.default.createElement(
	              'a',
	              { className: 'skiptour pull-right', onClick: this.cancelTour },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-close skip-icon' })
	              ),
	              'Skip the tour'
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Tour;
	}(_react.Component);
	
	exports.default = Tour;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Signin = __webpack_require__(50);
	
	var _packageList = __webpack_require__(882);
	
	var _packageList2 = _interopRequireDefault(_packageList);
	
	var _specialHandling = __webpack_require__(883);
	
	var _specialHandling2 = _interopRequireDefault(_specialHandling);
	
	var _damagedItem = __webpack_require__(880);
	
	var _damagedItem2 = _interopRequireDefault(_damagedItem);
	
	var _itemDescription = __webpack_require__(881);
	
	var _itemDescription2 = _interopRequireDefault(_itemDescription);
	
	__webpack_require__(856);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TUTORIAL_DATA = {
	  cart_tutorial: [{
	    index: 0,
	    title: 'Package List',
	    desc: 'Packages in your cart will be listed by courier tracking number\n      instead of the usual generic description.',
	    img: _packageList2.default
	  }, {
	    index: 1,
	    title: 'Special Handling',
	    desc: 'This icon will let you know if your package requires special handling',
	    img: _specialHandling2.default
	  }, {
	    index: 2,
	    title: 'Damaged Item',
	    desc: 'This icon will let you know if your package contains a damaged item.',
	    img: _damagedItem2.default
	  }],
	  item_tutorial: [{
	    index: 0,
	    title: 'Item Description',
	    desc: 'Each item inside your package will be listed in this section. Item description may either be manually encoded or captured automatically from Universal Product Code records.',
	    img: _itemDescription2.default
	  }]
	};
	
	var CartTutorial = function (_React$Component) {
	  _inherits(CartTutorial, _React$Component);
	
	  function CartTutorial() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CartTutorial);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CartTutorial.__proto__ || Object.getPrototypeOf(CartTutorial)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      activeItem: {},
	      isShown: true
	    }, _this.handleClick = function () {
	      if (_this.state.activeItem.index === TUTORIAL_DATA[_this.props.type].length - 1) {
	        _store2.default.dispatch((0, _Signin.updateTutorial)(_this.props.type));
	        _this.setState({ isShown: false });
	        return;
	      }
	      _this.setState({
	        activeItem: TUTORIAL_DATA[_this.props.type][_this.state.activeItem.index + 1]
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CartTutorial, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var tutorialDataAccount = this.props.accountDetails && JSON.parse(this.props.accountDetails.party.metadata)[this.props.type];
	      if (tutorialDataAccount) {
	        this.setState({ isShown: false });
	        return;
	      }
	      this.setState({
	        activeItem: TUTORIAL_DATA[this.props.type][0]
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return this.state.isShown ? _react2.default.createElement(
	        'div',
	        { className: 'tutorial-BG', onClick: function onClick() {
	            return _this2.handleClick();
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'tutorial-content', onClick: function onClick() {
	              return _this2.handleClick();
	            } },
	          _react2.default.createElement(
	            'div',
	            { style: {
	                display: 'flex',
	                justifyContent: 'center',
	                alignItems: 'center'
	              } },
	            _react2.default.createElement('img', { src: this.state.activeItem.img, alt: 'Package List' })
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: {
	                fontSize: '26px',
	                display: 'flex',
	                justifyContent: 'center',
	                alignItems: 'center',
	                fontWeight: 600
	              } },
	            this.state.activeItem.title
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: {
	                fontSize: '14px',
	                display: 'flex',
	                justifyContent: 'center',
	                alignItems: 'center',
	                width: 350,
	                textAlign: 'center' } },
	            this.state.activeItem.desc
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return CartTutorial;
	}(_react2.default.Component);
	
	exports.default = CartTutorial;

/***/ },
/* 159 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var warehouseAND = exports.warehouseAND = "US, UK, AU, KR, and JP";
	var warehouseOR = exports.warehouseOR = "US, UK, AU, KR, or JP";

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setAuthorizationToken;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setAuthorizationToken(token) {
	  if (token) {
	    _axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	  } else {
	    delete _axios2.default.defaults.headers.common['Authorization'];
	  }
	}

/***/ },
/* 161 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(664);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 163 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 164 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(74);
	var dPs = __webpack_require__(679);
	var enumBugKeys = __webpack_require__(164);
	var IE_PROTO = __webpack_require__(168)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(258)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(670).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 166 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(61).f;
	var has = __webpack_require__(60);
	var TAG = __webpack_require__(42)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(169)('keys');
	var uid = __webpack_require__(129);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(39);
	var global = __webpack_require__(53);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(127) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 170 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(76);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(53);
	var core = __webpack_require__(39);
	var LIBRARY = __webpack_require__(127);
	var wksExt = __webpack_require__(173);
	var defineProperty = __webpack_require__(61).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(42);


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var addDays = __webpack_require__(101)
	
	/**
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added
	 * @returns {Date} the new date with the weeks added
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * var result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  var days = amount * 7
	  return addDays(dirtyDate, days)
	}
	
	module.exports = addWeeks


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * var result = compareDesc(
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * )
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var timeLeft = dateLeft.getTime()
	  var dateRight = parse(dirtyDateRight)
	  var timeRight = dateRight.getTime()
	
	  if (timeLeft > timeRight) {
	    return -1
	  } else if (timeLeft < timeRight) {
	    return 1
	  } else {
	    return 0
	  }
	}
	
	module.exports = compareDesc


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var differenceInCalendarMonths = __webpack_require__(278)
	var compareAsc = __webpack_require__(103)
	
	/**
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 7
	 */
	function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
	  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)
	
	  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastMonthNotFull)
	}
	
	module.exports = differenceInMonths


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(132)
	
	/**
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of seconds
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * var result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInSeconds


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a day
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfDay


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  var monthIndex = date.getMonth()
	  var lastDayOfMonth = new Date(0)
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
	  lastDayOfMonth.setHours(0, 0, 0, 0)
	  return lastDayOfMonth.getDate()
	}
	
	module.exports = getDaysInMonth


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var startOfISOWeek = __webpack_require__(65)
	var startOfISOYear = __webpack_require__(104)
	
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the ISO week
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * var result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	function getISOWeek (dirtyDate) {
	  var date = parse(dirtyDate)
	  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
	}
	
	module.exports = getISOWeek


/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * @category Common Helpers
	 * @summary Is the given argument an instance of Date?
	 *
	 * @description
	 * Is the given argument an instance of Date?
	 *
	 * @param {*} argument - the argument to check
	 * @returns {Boolean} the given argument is an instance of Date
	 *
	 * @example
	 * // Is 'mayonnaise' a Date?
	 * var result = isDate('mayonnaise')
	 * //=> false
	 */
	function isDate (argument) {
	  return argument instanceof Date
	}
	
	module.exports = isDate


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var startOfWeek = __webpack_require__(133)
	
	/**
	 * @category Week Helpers
	 * @summary Are the given dates in the same week?
	 *
	 * @description
	 * Are the given dates in the same week?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(
	 *   new Date(2014, 7, 31),
	 *   new Date(2014, 8, 4)
	 * )
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(
	 *   new Date(2014, 7, 31),
	 *   new Date(2014, 8, 4),
	 *   {weekStartsOn: 1}
	 * )
	 * //=> false
	 */
	function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
	  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)
	
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
	}
	
	module.exports = isSameWeek


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var buildDistanceInWordsLocale = __webpack_require__(779)
	var buildFormatLocale = __webpack_require__(780)
	
	/**
	 * @category Locales
	 * @summary English locale.
	 */
	module.exports = {
	  distanceInWords: buildDistanceInWordsLocale(),
	  format: buildFormatLocale()
	}


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(105);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ },
/* 185 */
134,
/* 186 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/vas.36cf23a1.svg";

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/brand-logo.c1707a71.svg";

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(78);
	
	var _DOMUtils = __webpack_require__(136);
	
	var _DOMStateStorage = __webpack_require__(321);
	
	var _PathUtils = __webpack_require__(55);
	
	var _ExecutionEnvironment = __webpack_require__(190);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(886);
	
	var _PathUtils = __webpack_require__(55);
	
	var _runTransitionHook = __webpack_require__(192);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(135);
	
	var _LocationUtils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Hoek = __webpack_require__(32);
	var Any = __webpack_require__(43);
	var Cast = __webpack_require__(106);
	var Ref = __webpack_require__(66);
	var Errors = __webpack_require__(47);
	
	
	// Declare internals
	
	var internals = {};
	
	
	internals.Alternatives = function () {
	
	    Any.call(this);
	    this._type = 'alternatives';
	    this._invalids.remove(null);
	
	    this._inner.matches = [];
	};
	
	Hoek.inherits(internals.Alternatives, Any);
	
	
	internals.Alternatives.prototype._base = function (value, state, options) {
	
	    var errors = [];
	    for (var i = 0, il = this._inner.matches.length; i < il; ++i) {
	        var item = this._inner.matches[i];
	        var schema = item.schema;
	        if (!schema) {
	            var failed = item.is._validate(item.ref(state.parent, options), null, options, state.parent).errors;
	            schema = failed ? item.otherwise : item.then;
	            if (!schema) {
	                continue;
	            }
	        }
	
	        var result = schema._validate(value, state, options);
	        if (!result.errors) {     // Found a valid match
	            return result;
	        }
	
	        errors = errors.concat(result.errors);
	    }
	
	    return { errors: errors.length ? errors : Errors.create('alternatives.base', null, state, options) };
	};
	
	
	internals.Alternatives.prototype.try = function (/* schemas */) {
	
	
	    var schemas = Hoek.flatten(Array.prototype.slice.call(arguments));
	    Hoek.assert(schemas.length, 'Cannot add other alternatives without at least one schema');
	
	    var obj = this.clone();
	
	    for (var i = 0, il = schemas.length; i < il; ++i) {
	        var cast = Cast.schema(schemas[i]);
	        if (cast._refs.length) {
	            obj._refs = obj._refs.concat(cast._refs);
	        }
	        obj._inner.matches.push({ schema: cast });
	    }
	
	    return obj;
	};
	
	
	internals.Alternatives.prototype.when = function (ref, options) {
	
	    Hoek.assert(Ref.isRef(ref) || typeof ref === 'string', 'Invalid reference:', ref);
	    Hoek.assert(options, 'Missing options');
	    Hoek.assert(typeof options === 'object', 'Invalid options');
	    Hoek.assert(options.hasOwnProperty('is'), 'Missing "is" directive');
	    Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');
	
	    var obj = this.clone();
	    var is = Cast.schema(options.is);
	
	    if (options.is === null || !options.is.isJoi) {
	
	        // Only apply required if this wasn't already a schema, we'll suppose people know what they're doing
	        is = is.required();
	    }
	
	    var item = {
	        ref: Cast.ref(ref),
	        is: is,
	        then: options.then !== undefined ? Cast.schema(options.then) : undefined,
	        otherwise: options.otherwise !== undefined ? Cast.schema(options.otherwise) : undefined
	    };
	
	    Ref.push(obj._refs, item.ref);
	    obj._refs = obj._refs.concat(item.is._refs);
	
	    if (item.then && item.then._refs) {
	        obj._refs = obj._refs.concat(item.then._refs);
	    }
	
	    if (item.otherwise && item.otherwise._refs) {
	        obj._refs = obj._refs.concat(item.otherwise._refs);
	    }
	
	    obj._inner.matches.push(item);
	
	    return obj;
	};
	
	
	internals.Alternatives.prototype.describe = function () {
	
	    var description = Any.prototype.describe.call(this);
	    var alternatives = [];
	    for (var i = 0, il = this._inner.matches.length; i < il; ++i) {
	        var item = this._inner.matches[i];
	        if (item.schema) {
	
	            // try()
	
	            alternatives.push(item.schema.describe());
	        }
	        else {
	
	            // when()
	
	            var when = {
	                ref: item.ref.toString(),
	                is: item.is.describe()
	            };
	
	            if (item.then) {
	                when.then = item.then.describe();
	            }
	
	            if (item.otherwise) {
	                when.otherwise = item.otherwise.describe();
	            }
	
	            alternatives.push(when);
	        }
	    }
	
	    description.alternatives = alternatives;
	    return description;
	};
	
	
	module.exports = new internals.Alternatives();


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Any = __webpack_require__(43);
	var Errors = __webpack_require__(47);
	var Ref = __webpack_require__(66);
	var Hoek = __webpack_require__(32);
	var Moment = __webpack_require__(2);
	
	
	// Declare internals
	
	var internals = {};
	
	internals.isoDate = /^(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/;
	internals.invalidDate = new Date('');
	internals.isIsoDate = (function () {
	
	    var isoString = internals.isoDate.toString();
	
	    return function (date) {
	
	        return date && (date.toString() === isoString);
	    };
	})();
	
	internals.Date = function () {
	
	    Any.call(this);
	    this._type = 'date';
	};
	
	Hoek.inherits(internals.Date, Any);
	
	
	internals.Date.prototype._base = function (value, state, options) {
	
	    var result = {
	        value: (options.convert && internals.toDate(value, this._flags.format)) || value
	    };
	
	    if (result.value instanceof Date && !isNaN(result.value.getTime())) {
	        result.errors = null;
	    }
	    else {
	        result.errors = Errors.create(internals.isIsoDate(this._flags.format) ? 'date.isoDate' : 'date.base', null, state, options);
	    }
	
	    return result;
	};
	
	
	internals.toDate = function (value, format) {
	
	    if (value instanceof Date) {
	        return value;
	    }
	
	    if (typeof value === 'string' ||
	        Hoek.isInteger(value)) {
	
	        if (typeof value === 'string' &&
	            /^[+-]?\d+$/.test(value)) {
	
	            value = parseInt(value, 10);
	        }
	
	        var date;
	        if (format) {
	            if (internals.isIsoDate(format)) {
	                date = format.test(value) ? new Date(value) : internals.invalidDate;
	            }
	            else {
	                date = Moment(value, format, true);
	                date = date.isValid() ? date.toDate() : internals.invalidDate;
	            }
	        }
	        else {
	            date = new Date(value);
	        }
	
	        if (!isNaN(date.getTime())) {
	            return date;
	        }
	    }
	
	    return null;
	};
	
	
	internals.compare = function (type, compare) {
	
	    return function (date) {
	
	        var isNow = date === 'now';
	        var isRef = Ref.isRef(date);
	
	        if (!isNow && !isRef) {
	            date = internals.toDate(date);
	        }
	
	        Hoek.assert(date, 'Invalid date format');
	
	        return this._test(type, date, function (value, state, options) {
	
	            var compareTo;
	            if (isNow) {
	                compareTo = Date.now();
	            }
	            else if (isRef) {
	                compareTo = internals.toDate(date(state.parent, options));
	
	                if (!compareTo) {
	                    return Errors.create('date.ref', { ref: date.key }, state, options);
	                }
	
	                compareTo = compareTo.getTime();
	            }
	            else {
	                compareTo = date.getTime();
	            }
	
	            if (compare(value.getTime(), compareTo)) {
	                return null;
	            }
	
	            return Errors.create('date.' + type, { limit: new Date(compareTo) }, state, options);
	        });
	    };
	};
	
	
	internals.Date.prototype.min = internals.compare('min', function (value, date) {
	
	    return value >= date;
	});
	
	
	internals.Date.prototype.max = internals.compare('max', function (value, date) {
	
	    return value <= date;
	});
	
	
	internals.Date.prototype.format = function (format) {
	
	    Hoek.assert(typeof format === 'string' || (Array.isArray(format) && format.every(function (f) {
	
	        return typeof f === 'string';
	    })), 'Invalid format.');
	
	    var obj = this.clone();
	    obj._flags.format = format;
	    return obj;
	};
	
	internals.Date.prototype.iso = function () {
	
	    var obj = this.clone();
	    obj._flags.format = internals.isoDate;
	    return obj;
	};
	
	internals.Date.prototype._isIsoDate = function (value) {
	
	    return internals.isoDate.test(value);
	};
	
	module.exports = new internals.Date();


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/*global exports*/
	var SignStream = __webpack_require__(909);
	var VerifyStream = __webpack_require__(910);
	
	var ALGORITHMS = [
	  'HS256', 'HS384', 'HS512',
	  'RS256', 'RS384', 'RS512',
	  'PS256', 'PS384', 'PS512',
	  'ES256', 'ES384', 'ES512'
	];
	
	exports.ALGORITHMS = ALGORITHMS;
	exports.sign = SignStream.sign;
	exports.verify = VerifyStream.verify;
	exports.decode = VerifyStream.decode;
	exports.isValid = VerifyStream.isValid;
	exports.createSign = function createSign(opts) {
	  return new SignStream(opts);
	};
	exports.createVerify = function createVerify(opts) {
	  return new VerifyStream(opts);
	};


/***/ },
/* 196 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(107),
	    getPrototype = __webpack_require__(923),
	    isObjectLike = __webpack_require__(138);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(815);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(520);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(492);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['height', 'width']), _react2['default'].PropTypes.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _react2['default'].PropTypes.string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(977);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(978);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(979);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(980);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(981);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(982);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__(154);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _react.PropTypes.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _react.PropTypes.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _react.PropTypes.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _react2['default'].PropTypes.shape({
	    activeKey: _react.PropTypes.any,
	    onSelect: _react.PropTypes.func.isRequired,
	    getTabId: _react.PropTypes.func.isRequired,
	    getPaneId: _react.PropTypes.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _react.PropTypes.shape({
	    activeKey: _react.PropTypes.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	    activeKey: _react.PropTypes.any,
	    unmountOnExit: _react.PropTypes.bool,
	    onPaneEnter: _react.PropTypes.func.isRequired,
	    onPaneExited: _react.PropTypes.func.isRequired,
	    exiting: _react.PropTypes.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1019);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1018);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(81);
	var Danger = __webpack_require__(1028);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(41);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(213);
	var setInnerHTML = __webpack_require__(147);
	var setTextContent = __webpack_require__(514);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 205 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var ReactErrorUtils = __webpack_require__(211);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var React = __webpack_require__(87);
	var ReactPropTypesSecret = __webpack_require__(1057);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var invariant = __webpack_require__(11);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(45);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 214 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 215 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 216 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 218 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var emptyFunction = __webpack_require__(36);
	var warning = __webpack_require__(12);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(37)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('prop-types'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.propTypes);
	        global.ImageShape = mod.exports;
	    }
	})(this, function (exports, _propTypes) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    exports.default = _propTypes2.default.shape({
	        alt: _propTypes2.default.string,
	        src: _propTypes2.default.string.isRequired,
	        srcSet: _propTypes2.default.string,
	        sizes: _propTypes2.default.string,
	        width: _propTypes2.default.number.required,
	        height: _propTypes2.default.number.required
	    });
	});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(528));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1130));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1125));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1126));
	
	var _properties = __webpack_require__(527);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1127));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(152);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 225 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  eventIndex: _react.PropTypes.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRouteParams = __webpack_require__(1148);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(226);
	
	var _RouteUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    array = _React$PropTypes.array,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(89);
	
	var ReactNoopUpdateQueue = __webpack_require__(230);
	
	var canDefineProperty = __webpack_require__(548);
	var emptyObject = __webpack_require__(77);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(12);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(69);
	
	/*<replacement>*/
	var util = __webpack_require__(100);
	util.inherits = __webpack_require__(79);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(18).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(100);
	util.inherits = __webpack_require__(79);
	/*</replacement>*/
	
	var Stream = __webpack_require__(68);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(69);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(69);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 233 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	
	  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
	}
	
	var _default = bytesToUuid;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	var settle = __webpack_require__(571);
	var buildURL = __webpack_require__(574);
	var parseHeaders = __webpack_require__(580);
	var isURLSameOrigin = __webpack_require__(578);
	var createError = __webpack_require__(237);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(573);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(576);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(570);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 238 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomerInfo = getCustomerInfo;
	exports.getWarehouse = getWarehouse;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	function getCustomerInfo(token) {
	  var config = {
	    headers: {
	      'authorization': 'Bearer ' + token
	    }
	  };
	  return function (dispatch) {
	    dispatch({ type: 'RESET_UPDATE' });
	    _axios2.default.get(apiUrl + 'accounts', config).then(function (response) {
	      dispatch({ type: 'GET_CUSTOMER_INFO_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_CUSTOMER_INFO_REJECTED', payload: err });
	    });
	  };
	}
	function getWarehouse() {
	  return function (dispatch) {
	    _axios2.default.get(apiUrl + 'warehouse').then(function (response) {
	      dispatch({ type: 'GET_WAREHOUSE_FULFILLED', payload: response.data });
	    }).catch(function (err) {
	      dispatch({ type: 'GET_WAREHOUSE_REJECTED', payload: err });
	    });
	  };
	}

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	exports.getPerPoundValue = getPerPoundValue;
	exports.getStorageSettings = getStorageSettings;
	exports.getGeneralSettings = getGeneralSettings;
	exports.getFees = getFees;
	exports.getCurrencyConversion = getCurrencyConversion;
	exports.getTurnaroundDeliveryTime = getTurnaroundDeliveryTime;
	exports.getCopyrightYear = getCopyrightYear;
	exports.getDestinationSettings = getDestinationSettings;
	exports.getGlobalSettings = getGlobalSettings;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	function getPerPoundValue(token) {
			var warehouse_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
			return function (dispatch) {
					_axios2.default.get(apiUrl + 'settings/per_pound_value/' + warehouse_id, token).then(function (response) {
							dispatch({ type: 'GET_PER_POUND_VALUE_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_PER_POUND_VALUE_REJECTED', payload: err });
					});
			};
	}
	function getStorageSettings() {
			var warehouse_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
			var token = localStorage.jwtToken;
			return function (dispatch) {
					_axios2.default.get(apiUrl + 'settings/storage/' + warehouse_id, token).then(function (response) {
							dispatch({ type: 'GET_STORAGE_SETTINGS_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_STORAGE_SETTINGS_REJECTED', payload: err });
					});
			};
	}
	function getGeneralSettings(token) {
			var warehouse_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
			return function (dispatch) {
					_axios2.default.get(apiUrl + 'settings/general_setting/' + warehouse_id, token).then(function (response) {
							dispatch({ type: 'GET_GENERAL_SETTINGS_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_GENERAL_SETTINGS_REJECTED', payload: err });
					});
			};
	}
	function getFees(token) {
			var warehouse_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
			return function (dispatch) {
					_axios2.default.get(apiUrl + 'settings/air_cargo_fees/' + warehouse_id, token).then(function (response) {
							dispatch({ type: 'GET_FEES_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_FEES_REJECTED', payload: err });
					});
			};
	}
	function getCurrencyConversion(token) {
			var warehouse_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
			return function (dispatch) {
					_axios2.default.get(apiUrl + 'settings/currency_conversion/' + warehouse_id, token).then(function (response) {
							dispatch({ type: 'GET_CURRENCY_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_CURRENCY_REJECTED', payload: err });
					});
			};
	}
	function getTurnaroundDeliveryTime(token) {
			var warehouse_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
			return function (dispatch) {
					_axios2.default.get(apiUrl + 'settings/turnaround_delivery_time/' + warehouse_id, token).then(function (response) {
							dispatch({ type: 'GET_TURNAROUND_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_TURNAROUND_REJECTED', payload: err });
					});
			};
	}
	function getCopyrightYear() {
			return function (dispatch) {
					_axios2.default.get(apiUrl + 'year').then(function (response) {
							dispatch({ type: 'GET_YEAR_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_YEAR_REJECTED', payload: err });
					});
			};
	}
	function getDestinationSettings() {
			var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
			var destination_country = arguments[1];
	
			return function (dispatch) {
					_axios2.default.post(apiUrl + 'settings/all', {
							"data": {
									"warehouse_id": id,
									"destination_country": destination_country
							}
					}).then(function (response) {
							dispatch({ type: 'GET_DESTINATION_SETTINGS_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_DESTINATION_SETTINGS_REJECTED', payload: err });
					});
			};
	}
	function getGlobalSettings() {
			var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
	
			return function (dispatch) {
					_axios2.default.post(apiUrl + 'settings/all', {
							"data": {
									"warehouse_id": id
							}
					}).then(function (response) {
							dispatch({ type: 'GET_GLOBAL_SETTINGS_FULFILLED', payload: response.data });
					}).catch(function (err) {
							dispatch({ type: 'GET_GLOBAL_SETTINGS_REJECTED', payload: err });
					});
			};
	}

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getShipment = getShipment;
	exports.getOrderDetails = getOrderDetails;
	exports.getTrackDetails = getTrackDetails;
	exports.removeTrackDetails = removeTrackDetails;
	exports.resetOrders = resetOrders;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	function getShipment(token, page, per_page, status, range) {
		return function (dispatch) {
			dispatch({ type: 'GET_SHIPMENT_FETCHING' });
			_axios2.default.get(apiUrl + 'shipments?page=' + page + '&per_page=' + per_page + '&status=' + status + '&range=' + range + '&exclude_children=true', {
				"page": page,
				"per_page": per_page,
				"status": status,
				"range": range,
				token: token
			}).then(function (response) {
				dispatch({ type: 'GET_SHIPMENT_FULFILLED', payload: response.data });
			}).catch(function (err) {
				dispatch({ type: 'GET_SHIPMENT_REJECTED', payload: err });
			});
		};
	}
	function getOrderDetails(id, token) {
		return function (dispatch) {
			_axios2.default.get(apiUrl + 'shipments/' + id, token).then(function (response) {
				dispatch({ type: 'GET_ORDER_FULFILLED', payload: response.data });
			}).catch(function (err) {
				dispatch({ type: 'GET_ORDER_REJECTED', payload: err });
			});
		};
	}
	function getTrackDetails(tracking_number) {
		return function (dispatch) {
			dispatch({ type: 'GET_TRACK_FETCHING' });
			_axios2.default.get(apiUrl + 'track/' + tracking_number).then(function (response) {
				dispatch({ type: 'GET_TRACK_FULFILLED', payload: response.data });
			}).catch(function (err) {
				dispatch({ type: 'GET_TRACK_REJECTED', payload: err });
			});
		};
	}
	function removeTrackDetails() {
		return function (dispatch) {
			dispatch({ type: 'REMOVE_TRACK_DETAILS' });
		};
	}
	function resetOrders() {
		return function (dispatch) {
			dispatch({ type: 'RESET_ORDERS' });
		};
	}

/***/ },
/* 242 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_CURRENT_USER = exports.SET_CURRENT_USER = 'SET_CURRENT_USER';

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(126);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(14);
	
	var _adyenWeb = __webpack_require__(562);
	
	var _adyenWeb2 = _interopRequireDefault(_adyenWeb);
	
	__webpack_require__(854);
	
	__webpack_require__(857);
	
	__webpack_require__(312);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _adyenService = __webpack_require__(651);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	// import axios from 'axios';
	
	/* eslint-disable */
	var appConfig = __webpack_require__(71);
	var adyenClientKey = appConfig.adyenDropIn;
	/* eslint-enable */
	
	var createReactClass = __webpack_require__(16);
	// this.paymentContainer = React.createRef();
	
	var AdyenPayment = createReactClass({
	  displayName: 'AdyenPayment',
	  getInitialState: function getInitialState() {
	    return {
	      isLoaderShown: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    (0, _adyenService.getPaymentMethods)(this.props.login.login.party.account_number).then(function (res) {
	      _this.mountAdyenCheckout({ methods: res.data });
	    });
	  },
	  mountAdyenCheckout: function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref) {
	      var _this2 = this;
	
	      var methods = _ref.methods;
	      var configuration, checkout;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              configuration = {
	                paymentMethodsResponse: methods, // The `/paymentMethods` response from the server.
	                clientKey: adyenClientKey, // Web Drop-in versions before 3.10.1 use originKey instead of clientKey.
	                locale: 'en-US',
	                environment: (0, _utils.handleEnvironment)(),
	                translations: {
	                  'en-US': {
	                    'storedPaymentMethod.disable.confirmButton': 'Yes',
	                    'storedPaymentMethod.disable.cancelButton': 'No'
	                  }
	                },
	                onSubmit: function () {
	                  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(state, dropin) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            _this2.setState({ isLoaderShown: true });
	                            _this2.props.checkOutAdyenDropin({ formData: state, checkoutDetails: Object.assign({}, _this2.props.customerCheckout.checkoutDetails) }).then(function (res) {
	                              dropin.handleAction(res);
	                            });
	
	                            // var air = {};
	                            // var sea = {};
	
	                            // air = {
	                            //   items : this.props.customerCheckout.checkoutDetails.itemArry.air,
	                            //   address : this.props.customerCheckout.checkoutDetails.air_address,
	                            //   note: this.props.customerCheckout.checkoutDetails.note_air,
	                            // }
	                            // sea  = {
	                            //   items : this.props.customerCheckout.checkoutDetails.itemArry.sea,
	                            //   address: this.props.customerCheckout.checkoutDetails.sea_address,
	                            //   note: this.props.customerCheckout.checkoutDetails.note_sea,
	                            // }
	
	                            // const adyenPayload = state;
	                            // if (state.data && !state.data.storePaymentMethod) {
	                            //   adyenPayload.data.storePaymentMethod = false;
	                            // }
	
	                            // const payload = {
	                            //   token: this.props.customerCheckout.checkoutDetails.token,
	                            //   air,
	                            //   sea,
	                            //   "insurance":this.props.customerCheckout.checkoutDetails.insurance,
	                            //   "payment_method": "credit_card",
	                            //   "payment_provider": 'adyen-dropin',
	                            //   "promo_code": this.props.customerCheckout.checkoutDetails.promo_code,
	                            //   'shipment_location_details': this.props.customerCheckout.checkoutDetails.shipment_location_details,
	                            //   'warehouse_id': this.props.customerCheckout.checkoutDetails.warehouse_id,
	                            //   'is_dangerous_sea': this.props.customerCheckout.checkoutDetails.is_dangerous_sea,
	                            //   'is_dangerous_air': this.props.customerCheckout.checkoutDetails.is_dangerous_air,
	                            //   'adyen-payment-method': adyenPayload,
	                            //   data: state.data,
	                            // }
	
	                          case 2:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  function onSubmit(_x2, _x3) {
	                    return _ref3.apply(this, arguments);
	                  }
	
	                  return onSubmit;
	                }(),
	                onAdditionalDetails: function onAdditionalDetails(state, dropin) {},
	                paymentMethodsConfiguration: {
	                  card: {
	                    // Example optional configuration for Cards
	                    hasHolderName: true,
	                    holderNameRequired: true,
	                    enableStoreDetails: true,
	                    hideCVC: false, // Change this to true to hide the CVC field for stored cards
	                    name: 'Add a credit or debit card'
	                    // onSubmit: () => {
	                    //   console.log('test');
	                    // }, // onSubmit configuration for card payments. Overrides the global configuration.
	                  }
	                }
	              };
	              _context3.next = 4;
	              return (0, _adyenWeb2.default)(configuration);
	
	            case 4:
	              checkout = _context3.sent;
	
	              checkout.create('dropin', {
	                showRemovePaymentMethodButton: true,
	                onDisableStoredPaymentMethod: function () {
	                  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(storedPaymentMethodId, resolve, reject) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            (0, _adyenService.removeAdyenCard)(storedPaymentMethodId, _this2.props.login.login.party.account_number).then(function (res) {
	                              resolve();
	                            }).catch(function (err) {
	                              console.log(err);
	                              reject();
	                            });
	
	                          case 1:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  function onDisableStoredPaymentMethod(_x4, _x5, _x6) {
	                    return _ref4.apply(this, arguments);
	                  }
	
	                  return onDisableStoredPaymentMethod;
	                }()
	              }).mount(_reactDom2.default.findDOMNode(this.refs.adyenform));_context3.next = 11;
	              break;
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3['catch'](0);
	
	              console.log(_context3.t0);
	
	            case 11:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this, [[0, 8]]);
	    }));
	
	    function mountAdyenCheckout(_x) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return mountAdyenCheckout;
	  }(),
	  handleLogout: function handleLogout() {
	    localStorage.removeItem('jwtToken');
	    this.props.logout();
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'home' },
	      _react2.default.createElement(
	        'header',
	        { className: 'site-header header-minimal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/home', className: 'clearfix' },
	              _react2.default.createElement('div', { className: 'main-img' })
	            )
	          ),
	          _react2.default.createElement(
	            'nav',
	            { className: 'top-nav' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                { className: 'dropdown has-sub' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'dropdown-toggle',
	                    'data-toggle': 'dropdown' },
	                  'Hello ',
	                  this.props.login.fetched ? this.props.login.login.party.first_name : null,
	                  '\xA0',
	                  _react2.default.createElement('i', { className: 'fa fa-angle-down' })
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'sub sub-account dropdown-menu ', style: { top: '80px' } },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/cart' },
	                      ' Cart '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/shipment' },
	                      ' Shipments'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/account' },
	                      ' Account '
	                    )
	                  ),
	                  this.props.parcelInfo.getParcel ? null : this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.length > 0 ? _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/prohibited' },
	                      'Prohibited Items '
	                    )
	                  ) : null : null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/home', onClick: this.handleLogout },
	                      ' Logout '
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      this.state.isLoaderShown && _react2.default.createElement(
	        'div',
	        { style: {
	            position: 'absolute',
	            top: 0,
	            bottom: 0,
	            left: 0,
	            right: 0,
	            backgroundColor: 'rgba(255,255,255,0.6)',
	            display: 'flex',
	            justifyContent: 'center',
	            zIndex: 90,
	            alignItems: 'center'
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'loader' },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            'Loading...'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'body-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkout container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkout-top text-center' },
	            _react2.default.createElement('div', { className: 'checkout-progress' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'checkout-wrapper clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'back-link' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/cart' },
	                ' < Back to Cart'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'center', margin: '0px 25px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement('div', { id: 'dropin-container', ref: 'adyenform' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, {
	        currentPath: this.props.location.pathname,
	        currentYear: this.props.login.year
	      })
	    );
	  }
	});
	exports.default = AdyenPayment;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stepSuccess = exports.stepConfirmation = exports.stepFillOut = exports.steps = undefined;
	
	var _step = __webpack_require__(874);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(875);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(876);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(877);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _step9 = __webpack_require__(878);
	
	var _step10 = _interopRequireDefault(_step9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var steps = exports.steps = [{
	  img: _step2.default,
	  text: 'Fill out and submit the form.'
	}, {
	  img: _step4.default,
	  text: 'Receive billing from customer support.'
	}, {
	  img: _step6.default,
	  text: 'Settle payment via Paypal invoice.'
	}, {
	  img: _step8.default,
	  text: 'Receive purchase confirmation from customer support.'
	}, {
	  img: _step10.default,
	  text: 'Wait for your item to be delivered at the warehouse.'
	}];
	
	var stepFillOut = exports.stepFillOut = [{
	  icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
	  text: 'Fill up form',
	  isActive: true
	}, {
	  icon: 'https://cdn.shippingcart.com/assets/ellipse_7-20220615022122.png',
	  text: 'Confirmation',
	  isActive: false
	}, {
	  icon: 'https://cdn.shippingcart.com/assets/ellipse_7-20220615022122.png',
	  text: 'Success',
	  isActive: false
	}];
	var stepConfirmation = exports.stepConfirmation = [{
	  icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
	  text: 'Fill up form',
	  isActive: true
	}, {
	  icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
	  text: 'Confirmation',
	  isActive: true
	}, {
	  icon: 'https://cdn.shippingcart.com/assets/ellipse_7-20220615022122.png',
	  text: 'Success',
	  isActive: false
	}];
	var stepSuccess = exports.stepSuccess = [{
	  icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
	  text: 'Fill up form',
	  isActive: true
	}, {
	  icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
	  text: 'Confirmation',
	  isActive: true
	}, {
	  icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
	  text: 'Success',
	  isActive: true
	}];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	
	var errorStyling = {
	  maxWidth: '530px',
	  display: 'flex',
	  justifyContent: 'center',
	  alignItems: 'center'
	};
	var ChangePassword = createReactClass({
	  displayName: 'ChangePassword',
	  componentWillMount: function componentWillMount() {
	    this.props.getCopyrightYear();
	    (0, _jquery2.default)('#SCTitle').text("Reset Password | ShippingCart");
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.login.error && nextProps.login.error.response.status === 422) {
	
	      if (nextProps.login.error.response.data.errors.detail === "User is archived.") {
	        this.setState({ isArchived: true });
	      } else if (nextProps.login.error.response.data.errors.detail === 'The new password field is required.') {
	        this.setState({ invalidPassword: true });
	      } else if (nextProps.login.error.response.data.errors.detail === 'Expired token.') {
	        this.setState({ isExpired: true });
	      } else if (nextProps.login.error.response.data.errors.detail === 'Expired token.') {
	        this.setState({ isExpired: true });
	      } else {
	        this.setState({ defaultError: true });
	      }
	    }
	  },
	  getInitialState: function getInitialState() {
	
	    return {
	      error: false,
	      errorLength_newConfirmPassword: false,
	      errorLength_newPassword: false,
	      errorEmpty_newPassword: false,
	      errorEmpty_newConfirmPassword: false,
	      invalidPassword: false,
	      isArchived: false,
	      isExpired: false,
	      defaultError: false
	    };
	  },
	  checkPasswordValidity: function checkPasswordValidity(new_pass, confirm_pass) {
	    var isValid = true;
	
	    if (new_pass !== confirm_pass) {
	      this.setState({ error: true });
	      isValid = false;
	    } else {
	      this.setState({ error: false });
	    }
	
	    if (new_pass.length < 7 || new_pass === "" || confirm_pass === "") {
	      this.setState({ errorLength_newPassword: true });
	      isValid = false;
	    } else {
	      this.setState({ errorLength_newPassword: false });
	    }
	
	    if (confirm_pass.length === 0) {
	      this.setState({ errorEmpty_newConfirmPassword: true, errorLength_newConfirmPassword: false });
	      isValid = false;
	    } else {
	      this.setState({ errorEmpty_newConfirmPassword: false });
	    }
	
	    return isValid;
	  },
	  handleSubmit: function handleSubmit(e) {
	    e.preventDefault();
	
	    this.setState({ error: false, invalidPassword: false, isArchived: false, defaultError: false, isExpired: false, errorLength_newPassword: false });
	
	    var new_password = this.refs.new_password.value;
	    var new_confirm_password = this.refs.new_confirm_password.value;
	    var token = this.props.location.query.token;
	    var email = this.props.location.query.email;
	
	    if (this.checkPasswordValidity(new_password, new_confirm_password)) {
	      this.props.changePassword(new_password, new_confirm_password, email, token);
	    }
	
	    // new_password !== new_confirm_password || new_password === "" || new_confirm_password === "" ?
	    //   this.setState({ error: true, }) : this.setState({ error: false, });
	
	    // new_password.length < 6 ?
	    //   this.setState({ errorLength_newPassword: true, }) : this.setState({ errorLength_newPassword: false, });
	
	    // new_confirm_password.length < 6 ?
	    //   this.setState({ errorLength_newConfirmPassword: true, }) : this.setState({ errorLength_newConfirmPassword: false, });
	
	    // new_password.length === 0 ?
	    //   this.setState({ errorEmpty_newPassword: true, errorLength_newPassword: false, error: false, }) : this.setState({ errorEmpty_newPassword: false, });
	
	    // new_confirm_password.length === 0 ?
	    //   this.setState({ errorEmpty_newConfirmPassword: true, errorLength_newConfirmPassword: false, }) : this.setState({ errorEmpty_newConfirmPassword: false, });
	
	    // this.props.changePassword(new_password, new_confirm_password, email, token);
	  },
	  handleWidget: function handleWidget(e) {
	    e.preventDefault();
	    window.FreshWidget.show();
	  },
	  handleShowPassword: function handleShowPassword(e) {
	    var name = e.target.name;
	    if (this.refs['show_' + name].checked) {
	      this.refs[name].type = 'text';
	    } else {
	      this.refs[name].type = 'password';
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'page-login header-minimal-head' },
	        _react2.default.createElement(
	          'header',
	          { className: 'site-header header-minimal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logo' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/', className: 'clearfix' },
	                _react2.default.createElement('div', { className: 'main-img' })
	              )
	            ),
	            _react2.default.createElement(
	              'nav',
	              { className: 'top-nav' },
	              _react2.default.createElement('ul', null)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'body-wrapper signinpage' },
	        _react2.default.createElement(
	          'section',
	          { className: 'container forgot' },
	          _react2.default.createElement(
	            'div',
	            { className: 'forgot-form' },
	            _react2.default.createElement(
	              'form',
	              { action: '', method: 'POST' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-left' },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Provide some info to ',
	                    _react2.default.createElement('br', null),
	                    ' reset your password'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-right back' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/home' },
	                    ' < Back to home'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'instructions' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Make sure to pick a clever and unforgettable password!'
	                )
	              ),
	              this.state.error ? _react2.default.createElement(
	                'div',
	                { className: 'notify' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger' },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  ' ',
	                  this.props.login.error.response && this.props.login.error.response.data.errors.length ? 'Invalid input' : 'Make sure your passwords match.'
	                )
	              ) : null,
	              this.state.errorLength_newPassword && !this.state.error ? _react2.default.createElement(
	                'div',
	                { className: 'notify' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger',
	                    style: errorStyling
	                  },
	                  _react2.default.createElement('i', { className: 'sc', style: { width: '33px' } }),
	                  'Password must be at least 7 characters long and should contain a combination of uppercase, lowercase, numeric, and special characters.'
	                )
	              ) : null,
	              this.state.invalidPassword ? _react2.default.createElement(
	                'div',
	                { className: 'notify' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger' },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  ' Update Failed. Please enter a valid password'
	                )
	              ) : null,
	              this.state.isArchived ? _react2.default.createElement(
	                'div',
	                { className: 'notify' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger' },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  'This account has been archived. To activate it, ',
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.handleWidget },
	                    'contact'
	                  ),
	                  ' ShippingCart Customer Care.'
	                )
	              ) : null,
	              this.state.isExpired ? _react2.default.createElement(
	                'div',
	                { className: 'notify' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger' },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  'Change password request has expired.'
	                )
	              ) : null,
	              this.state.defaultError ? _react2.default.createElement(
	                'div',
	                { className: 'notify' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger', style: errorStyling },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  this.props.login.error.response.data.errors.detail ? _react2.default.createElement(
	                    'p',
	                    { style: { maxWidth: 'inherit', marginBottom: '0px' } },
	                    this.props.login.error.response.data.errors.detail
	                  ) : this.props.login.error.response.data.errors.map(function (_ref) {
	                    var detail = _ref.detail;
	                    return _react2.default.createElement(
	                      'p',
	                      { style: { maxWidth: '456px', marginBottom: '0px' } },
	                      detail
	                    );
	                  })
	                )
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group ' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control-label' },
	                  ' New Password \xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group', style: { marginTop: '10px' } },
	                  _react2.default.createElement('input', { type: 'password', ref: 'new_password', className: this.state.defaultError || this.state.error || this.state.errorLength_newPassword ? "form-control error-input" : "form-control",
	                    name: 'password', defaultValue: '', autoFocus: true }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group-addon' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'checkbox checkbox_nomargin' },
	                      _react2.default.createElement('input', {
	                        id: 'show_new_password',
	                        name: 'new_password',
	                        type: 'checkbox',
	                        ref: 'show_new_password',
	                        onClick: function onClick(e) {
	                          return _this.handleShowPassword(e);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'show_new_password' },
	                        'SHOW'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group ' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control-label' },
	                  'Re-enter password \xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group' },
	                  _react2.default.createElement('input', { type: 'password', ref: 'new_confirm_password', className: this.state.defaultError || this.state.error || this.state.errorEmpty_newPassword || this.state.errorLength_newPassword ? "form-control error-input" : "form-control",
	                    name: 'confirm_password', defaultValue: '' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group-addon' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'checkbox checkbox_nomargin' },
	                      _react2.default.createElement('input', {
	                        id: 'show_new_confirm_password',
	                        name: 'new_confirm_password',
	                        type: 'checkbox',
	                        ref: 'show_new_confirm_password',
	                        onClick: function onClick(e) {
	                          return _this.handleShowPassword(e);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'show_new_confirm_password' },
	                        'SHOW'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'login-btn' },
	                  _react2.default.createElement('input', { type: 'hidden' }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'submit', className: 'btn align-right btn-orange', onClick: this.handleSubmit },
	                    'Set new password'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('section', { className: 'shadow' })
	      ),
	      _react2.default.createElement(_Footer2.default, { currentPath: this.props.location.pathname, currentYear: this.props.login.year })
	    );
	  }
	});
	
	exports.default = ChangePassword;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(33);
	
	__webpack_require__(826);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _store = __webpack_require__(20);
	
	var _utils = __webpack_require__(13);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _OutBoundBanner = __webpack_require__(92);
	
	var _OutBoundBanner2 = _interopRequireDefault(_OutBoundBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	/* eslint-disable */
	var appConfig = __webpack_require__(71);
	/* eslint-enable */
	// const URL = appConfig.scUxUrl;
	
	// const {
	//   FacebookShareButton,
	//   TwitterShareButton,
	// } = ShareButtons;
	// const FacebookIcon = generateShareIcon('facebook');
	// const TwitterIcon = generateShareIcon('twitter');
	var createReactClass = __webpack_require__(16);
	var CheckOutSuccess = createReactClass({
	  displayName: 'CheckOutSuccess',
	  getInitialState: function getInitialState() {
	    return {
	      viewImageAir: false,
	      viewImageSea: false,
	      imageAir: null,
	      imageSea: null,
	      isPageLoading: true
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var redirectResult = this.props.location.query.redirectResult;
	    if (redirectResult) {
	      _axios2.default.post(apiUrl + 'adyen/payment/get-payment-details', { redirectResult: redirectResult }).then(function (res) {
	        _this.setState({ isPageLoading: true });
	        _store.history.push('/checkout-success?payment_type=adyen&authResult=' + res.data.attributes.resultCode.toUpperCase() + '&merchantReference=' + res.data.attributes.merchantReference + '&pspReference=' + res.data.attributes.pspReference + '&shopperLocale=en_GB');
	        window.location.reload();
	      });
	      return;
	    }
	    this.setState({ isPageLoading: false });
	    if (Object.prototype.hasOwnProperty.call(this.props.location.query, 'authResult')) {
	      var _payment_provider = 'adyen';
	      var _payment_status = this.props.location.query.authResult;
	      var reference_id = this.props.location.query.merchantReference;
	      var psp_reference = this.props.location.query.pspReference;
	
	      this.props.setPayment(_payment_provider, _payment_status, reference_id, null, psp_reference);
	
	      if (_payment_status === 'CANCELLED') {
	        this.props.showCancelledPayment();
	        _store.history.push('cart');
	      }
	
	      if (_payment_status === 'ERROR' || _payment_status === 'REFUSED') {
	        this.props.showErrorOnPayment();
	        _store.history.push('cart');
	      }
	    } else if (Object.prototype.hasOwnProperty.call(this.props.location.query, 'payment_type')) {
	      var _payment_provider2 = this.props.location.query.payment_type;
	      var _reference_id = this.props.location.query.Ref;
	
	      this.props.setPayment(_payment_provider2, "success", _reference_id, null, null);
	
	      if (this.props.customerCheckout.error && this.props.customerCheckout.error.response.data.errors.detail === "Transaction is not a valid for free shipping.") {
	        this.props.showInvalidTransactionError();
	        _store.history.push('cart');
	      }
	    } else {
	      var _reference_id2 = Object.prototype.hasOwnProperty.call(this.props.location.query, 'Ref') ? this.props.location.query.Ref : this.props.location.query.token;
	      var payment_provider = this.props.location.query.payment_provider;
	      var payer_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'PayerID') ? this.props.location.query.PayerID : null;
	      var payment_status = "success";
	
	      this.props.setPayment(payment_provider, payment_status, _reference_id2, payer_id);
	    }
	    // if (localStorage.checkout_response) {
	    //   var reference_id = localStorage.checkout_response;
	    //   this.props.setPayment("asiapay", "success", reference_id);
	    // }
	    // else {
	    //   reference_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'Ref') ? this.props.location.query.Ref : this.props.location.query.token;
	    //   var payment_provider = this.props.location.query.payment_provider;
	    //   var payer_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'PayerID') ? this.props.location.query.PayerID : null;
	    //   var payment_status = "success";
	    //   this.props.setPayment(payment_provider, payment_status, reference_id, payer_id);
	    // }
	    this.props.getCopyrightYear();
	    (0, _jquery2.default)('#SCTitle').text("Payment Successful | ShippingCart");
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.customerCheckout.error) {
	      // if (nextProps.customerCheckout.error.response.status === 422){
	      //   history.push('cart');
	      // }
	    }
	    if (nextProps.customerCheckout.payment !== this.props.customerCheckout.payment) {
	      this.props.getGlobalSettings(nextProps.customerCheckout.payment.data.air ? nextProps.customerCheckout.payment.data.air.item[0].warehouse_id : nextProps.customerCheckout.payment.data.sea.item[0].warehouse_id);
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	  },
	  handleLogout: function handleLogout() {
	    localStorage.removeItem('jwtToken');
	    this.props.logout();
	  },
	  viewImageAir: function viewImageAir(image) {
	    this.setState({ viewImageAir: true, imageAir: image });
	  },
	  viewImageSea: function viewImageSea(image) {
	    this.setState({ viewImageSea: true, imageSea: image });
	  },
	  close: function close() {
	    this.setState({ viewImageAir: false, viewImageSea: false });
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var outboundBanner = this.props.settings && this.props.settings.globalSettings && this.props.settings.globalSettings.data.filter(function (data) {
	      return data.name === 'outbound_banner';
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.state.viewImageAir, onHide: this.close, autoFocus: true },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement('img', { src: this.state.imageAir, className: 'img-responsive adjust padding-bottom-25', alt: '' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.state.viewImageSea, onHide: this.close, autoFocus: true },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement('img', { src: this.state.imageSea, className: 'img-responsive adjust padding-bottom-25', alt: '' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'home' },
	        _react2.default.createElement(
	          'header',
	          { className: 'site-header header-minimal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logo' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/home', className: 'clearfix' },
	                _react2.default.createElement('div', { className: 'main-img' })
	              )
	            ),
	            _react2.default.createElement(
	              'nav',
	              { className: 'top-nav' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  { className: 'dropdown has-sub' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
	                    'Hello ',
	                    this.props.login.fetched ? this.props.login.login.party.first_name : null,
	                    _react2.default.createElement('i', { className: 'fa fa-angle-down' })
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'sub sub-account dropdown-menu ' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/cart' },
	                        ' Cart '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/shipment' },
	                        ' Shipments'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/account' },
	                        ' Account '
	                      )
	                    ),
	                    this.props.parcelInfo.getParcel ? null : this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.length > 0 ? _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/prohibited' },
	                        'Prohibited Items '
	                      )
	                    ) : null : null,
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/home', onClick: this.handleLogout },
	                        ' Logout '
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'body-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkout container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'checkout-top text-center' },
	              _react2.default.createElement('div', { className: 'checkout-success' })
	            ),
	            this.state.isPageLoading ? _react2.default.createElement(
	              'div',
	              { className: 'loader checkout-wrapper clearfix', style: { display: 'flex', justifyContent: 'center' } },
	              _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                'Loading...'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'checkout-wrapper clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'back-link' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/shipment' },
	                  '< Back to Shipments'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Transaction #: ',
	                  this.props.customerCheckout.fetched_payment ? this.props.customerCheckout.payment.transaction_id : null
	                )
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Thank you. Your payment is being processed.'
	              ),
	              _react2.default.createElement(
	                'h5',
	                null,
	                'You will receive an email notification once your payment has been confirmed. Your package will then be queued for consolidation and shipping.'
	              ),
	              this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.sc_protect && _react2.default.createElement(
	                'h5',
	                null,
	                _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg', alt: 'badge', width: 18, height: 18, style: { marginRight: '5px' } }),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '10px', fontWeight: 600, color: '#636363' } },
	                  'SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                { style: { margin: '10px 0px', display: 'flex', justifyContent: 'center' } },
	                this.props.settings && this.props.settings.globalSettings && _react2.default.createElement(
	                  'div',
	                  { style: { maxWidth: '50%' } },
	                  _react2.default.createElement(_OutBoundBanner2.default, { outBoundBannerData: outboundBanner })
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'shipment-list' },
	                this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('air') ? _react2.default.createElement(
	                  'div',
	                  { className: 'shipment-head clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-type checkout', style: { display: 'inline-flex', padding: '20px', justifyContent: 'left' } },
	                    _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg', alt: 'air', width: 24, style: { marginRight: '10px' } }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: { fontSize: '16px', fontWeight: 600 } },
	                      'Air Cargo'
	                    )
	                  )
	                ) : null,
	                this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('air') ? _react2.default.createElement(
	                  'div',
	                  { className: 'shipment-box clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'data-do': 'image-modal', className: 'shipment-image' },
	                      _react2.default.createElement('h5', null),
	                      this.props.customerCheckout.payment.data.air.item.map(function (item) {
	                        return item.images.map(function (image, i) {
	                          return _react2.default.createElement(
	                            'div',
	                            { key: i },
	                            _react2.default.createElement(
	                              'a',
	                              { onClick: _this2.viewImageAir.bind(_this2, image), 'data-toggle': 'lightbox', 'data-gallery': 'hiddenimages' },
	                              _react2.default.createElement('img', { src: image, className: 'img-responsive', alt: '' })
	                            )
	                          );
	                        });
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-item' },
	                      _react2.default.createElement(
	                        'h6',
	                        null,
	                        'Item/s'
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        this.props.customerCheckout.payment.data.air.item.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: i },
	                            item.description,
	                            item.flags.is_abandoned ? _react2.default.createElement('span', { className: 'icon-hope' }) : null
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-status' },
	                      _react2.default.createElement(
	                        'h6',
	                        null,
	                        'Ship to:'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.customerCheckout.payment.data.air.address.name,
	                        _react2.default.createElement('br', null),
	                        this.props.customerCheckout.payment.data.air.address.line_1,
	                        ',\xA0',
	                        this.props.customerCheckout.payment.data.air.address.line_2,
	                        ',',
	                        _react2.default.createElement('br', null),
	                        this.props.customerCheckout.payment.data.air.address.city,
	                        ',\xA0',
	                        this.props.customerCheckout.payment.data.air.address.state,
	                        ',',
	                        _react2.default.createElement('br', null),
	                        (0, _utils.maskLocationName)(this.props.customerCheckout.payment.data.air.address.country_code),
	                        ',\xA0',
	                        this.props.customerCheckout.payment.data.air.address.postal_code,
	                        _react2.default.createElement('br', null),
	                        this.props.customerCheckout.payment.data.air.address.phone_number || this.props.login.login.party.phone_number
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-update', 'data-lazy': 'true', 'data-lazy-id': '68577', 'data-lazy-tracking': '1095781790', 'data-lazy-status': 'PAID', 'data-lazy-delivered-date': '' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tracking-update' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'track-and-trace' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'top-label' },
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Delivery Date:'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'update-date' },
	                            this.props.customerCheckout.payment.data.delivery.air
	                          )
	                        )
	                      )
	                    )
	                  )
	                ) : null,
	                this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('sea') ? _react2.default.createElement(
	                  'div',
	                  { className: 'shipment-head clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-type checkout', style: { display: 'inline-flex', padding: '20px', justifyContent: 'left' } },
	                    _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg', alt: 'sea', width: 24, style: { marginRight: '10px' } }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: { fontSize: '16px', fontWeight: 600 } },
	                      'Sea Cargo'
	                    )
	                  )
	                ) : null,
	                this.props.customerCheckout.fetched_payment && this.props.customerCheckout.payment.data.hasOwnProperty('sea') ? _react2.default.createElement(
	                  'div',
	                  { className: 'shipment-box clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'data-do': 'image-modal', className: 'shipment-image' },
	                      _react2.default.createElement('h5', null),
	                      this.props.customerCheckout.payment.data.sea.item.map(function (item) {
	                        return item.images.map(function (image, i) {
	                          return _react2.default.createElement(
	                            'div',
	                            { key: i },
	                            _react2.default.createElement(
	                              'a',
	                              { key: i, onClick: _this2.viewImageSea.bind(_this2, image), 'data-toggle': 'lightbox', 'data-gallery': 'hiddenimages' },
	                              _react2.default.createElement('img', { src: image, className: 'img-responsive', alt: '' })
	                            )
	                          );
	                        });
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-item' },
	                      _react2.default.createElement(
	                        'h6',
	                        null,
	                        'Item/s'
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        this.props.customerCheckout.payment.data.sea.item.map(function (item, i) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: i },
	                            item.description,
	                            item.flags.is_abandoned ? _react2.default.createElement('span', { className: 'icon-hope' }) : null
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-status' },
	                      _react2.default.createElement(
	                        'h6',
	                        null,
	                        'Ship to:'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.customerCheckout.payment.data.sea.address.name,
	                        ' ',
	                        _react2.default.createElement('br', null),
	                        this.props.customerCheckout.payment.data.sea.address.line_1,
	                        ',\xA0',
	                        this.props.customerCheckout.payment.data.sea.address.line_2,
	                        ',',
	                        _react2.default.createElement('br', null),
	                        this.props.customerCheckout.payment.data.sea.address.city,
	                        ',\xA0',
	                        this.props.customerCheckout.payment.data.sea.address.state,
	                        ',',
	                        _react2.default.createElement('br', null),
	                        (0, _utils.maskLocationName)(this.props.customerCheckout.payment.data.sea.address.country_code),
	                        ',\xA0',
	                        this.props.customerCheckout.payment.data.sea.address.postal_code,
	                        _react2.default.createElement('br', null),
	                        this.props.customerCheckout.payment.data.sea.address.phone_number || this.props.login.login.party.phone_number
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-update', 'data-lazy': 'true', 'data-lazy-id': '68577', 'data-lazy-tracking': '1095781790', 'data-lazy-status': 'PAID', 'data-lazy-delivered-date': '' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tracking-update' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'track-and-trace' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'top-label' },
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Delivery Date:'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'update-date' },
	                            this.props.customerCheckout.payment.data.delivery.sea
	                          )
	                        )
	                      )
	                    )
	                  )
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'inline-flex', width: '100%', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'back-link', style: { placeSelf: 'center', margin: '0px' } },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/shipment' },
	                    '< Back to Shipments'
	                  )
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { href: '/referral?utm_source=web&utm_medium=checkout&utm_campaign=ph-web-checkout-referral-20220727', style: { marginRight: '28px' } },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-orange referral-button' },
	                    'REFERRAL PROMO | LEARN MORE'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'bottom-shadow' })
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, {
	        currentPath: this.props.location.pathname,
	        currentYear: this.props.login.year
	      })
	    );
	  }
	});
	
	exports.default = CheckOutSuccess;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(139);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(14);
	
	__webpack_require__(312);
	
	var _areaWithDelay = __webpack_require__(636);
	
	var _restrictedAreas = __webpack_require__(256);
	
	var _store = __webpack_require__(20);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _utils = __webpack_require__(13);
	
	var _AdvisoryModal = __webpack_require__(120);
	
	var _AdvisoryModal2 = _interopRequireDefault(_AdvisoryModal);
	
	var _CheckoutBreakdown = __webpack_require__(594);
	
	var _CheckoutBreakdown2 = _interopRequireDefault(_CheckoutBreakdown);
	
	var _angleLeft = __webpack_require__(320);
	
	var _angleLeft2 = _interopRequireDefault(_angleLeft);
	
	var _CloudFlareBadge = __webpack_require__(608);
	
	var _CloudFlareBadge2 = _interopRequireDefault(_CloudFlareBadge);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _OutBoundBanner = __webpack_require__(92);
	
	var _OutBoundBanner2 = _interopRequireDefault(_OutBoundBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	var createReactClass = __webpack_require__(16);
	var addresses = [];
	
	var INVALID_ADDRESS_ERROR = 'Please add/select a valid address.';
	
	var cancelToken = void 0;
	
	var Checkout = createReactClass({
	    displayName: 'Checkout',
	    getInitialState: function getInitialState() {
	        return {
	            payment_type: "adyen",
	            air_address: "",
	            sea_address: "",
	            checkedPhp: true,
	            checkedUsd: false,
	            inputtedPromoCode: '',
	            promo_code: "",
	            first_name: false,
	            last_name: false,
	            street: false,
	            country: false,
	            province: false,
	            city: false,
	            district: false,
	            postal: false,
	            form_submitted: false,
	            error: false,
	            customErrorMessage: '',
	            region: "",
	            usd: true,
	            php: false,
	            terms: true,
	            payship: false,
	            air: false,
	            sea: false,
	            has_note: false,
	            note_air: "",
	            note_sea: "",
	            note_submitted: false,
	            country_value: "",
	            province_value: "",
	            city_value: "",
	            postal_code_value: "",
	            promo_success: "",
	            promo_submitted: false,
	            showModalAir: false,
	            showModalSea: false,
	            showAddAddress: false,
	            withoutAddress: false,
	            address_changed: false,
	            showAirSubtotal: false,
	            errors: {},
	            addressState: '',
	            selectedAirAddress: '',
	            selectedSeaAddress: '',
	            sameAddress: false,
	            firstLoad: false,
	            airAddresses: [],
	            seaAddresses: [],
	            airAddressesPagination: {
	                currentPage: 1,
	                lastPage: 1
	            },
	            seaAddressesPagination: {
	                currentPage: 1,
	                lastPage: 1
	            },
	            addressSearchTermAir: '',
	            addressSearchTermSea: '',
	            debouncedSearch: (0, _lodash.debounce)(this.handleGetAddress, 1000),
	            isSearchLoading: false,
	            hasSearchError: false,
	            addAddressType: '',
	            add_countryPrefix: '+63',
	            address_phone_number: '',
	            account_phone_number: '',
	            notes: [],
	            isSCProtectActive: true
	        };
	    },
	    close: function close() {
	        this.setState({
	            showModalAir: false,
	            showModalSea: false,
	            showAddNoteAir: false,
	            showAddNoteSea: false,
	
	            has_note: false,
	            note_submitted: false,
	            showAddAddress: false,
	            air: false,
	            sea: false,
	            showAirSubtotal: false,
	            showSeaSubtotal: false,
	            alertModal: false
	        });
	    },
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        if (!localStorage.jwtToken) {
	            _store.history.push("/signin");
	        } else if (!localStorage.item) {
	            // history.push("/cart")
	            window.location.replace(window.location.origin + "/cart");
	        } else {
	            var token = localStorage.jwtToken;
	            var itemArry = JSON.parse(localStorage.item);
	            var insurance = JSON.parse(localStorage.insurance);
	            var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	            var warehouse_id = JSON.parse(localStorage.warehouse_id);
	            var sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
	            this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
	            this.props.getModalBlocks('checkout');
	
	            var script = document.createElement("script");
	            script.type = "text/javascript";
	            script.src = "/js/custom.js";
	            script.async = false;
	            document.body.appendChild(script);
	        }
	        (0, _jquery2.default)('#SCTitle').text("Secure Checkout | ShippingCart");
	        if (this.props.login && this.props.login.login.party && this.props.cart.shipment_location_details.destination !== 'MY') {
	            var defaultAddress = this.props.login.login.party.addresses.find(function (address) {
	                return address.id === _this.props.login.login.party.address_id;
	            });
	            if (this.findAddress(_areaWithDelay.areaWithDelay, defaultAddress) && defaultAddress.country_code !== 'MY') {
	                this.setState({ alertModal: true });
	            }
	        }
	        this.props.getGlobalSettings(JSON.parse(localStorage.shipment_location_details).origin);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        localStorage.removeItem('item');
	        localStorage.removeItem('insurance');
	        localStorage.removeItem('shipment_location_details');
	        localStorage.removeItem('warehouse_id');
	        localStorage.removeItem('airDangerous');
	        localStorage.removeItem('seaDangerous');
	        this.props.clearCheck();
	    },
	    componentDidUpdate: function componentDidUpdate() {
	
	        var total_price = localStorage.total_price;
	        if (this.props.customerCheckout.fetched_asiapay && total_price !== "0.00") {
	            this.refs.asiapayform.click();
	        }
	
	        if (this.props.customerCheckout.fetched_adyen) {
	            this.refs.adyenForm.click();
	        }
	
	        if (this.state.isSCProtectActive && this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.damage_items.total === this.props.customerCheckout.checkout.data.summary.usd.total_qty) {
	            this.setState({ isSCProtectActive: false });
	        }
	        if (this.state.isSCProtectActive && this.props.customerCheckout.checkout.data && !this.props.customerCheckout.checkout.data.insurance_eligible && this.props.customerCheckout.checkout.data.insurance_error && this.props.customerCheckout.checkout.data.insurance_error.total_package_value) {
	            this.setState({ isSCProtectActive: false });
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (nextProps.login.fetched && nextProps.login.login.party) {
	            this.setState({ account_phone_number: nextProps.login.login.party.phone_number });
	            var admin = _utils.adminUserIds.find(function (id) {
	                return id === nextProps.login.login.party.account_number;
	            });
	            if (!admin && _utils.disabledCart) {
	                return _store.history.push('/shipment');
	            }
	        }
	        if (this.props.customerCheckout.fetched_computed !== nextProps.customerCheckout.fetched_computed) {
	            this.setState({ promo_success: nextProps.customerCheckout.fetched_computed });
	
	            if (this.refs.promo_code && this.refs.promo_code.value) {
	                var promo = nextProps.customerCheckout.checkout.data ? nextProps.customerCheckout.checkout.data.summary.usd.discount.code : null;
	                this.setState({ promo_code: promo });
	            }
	        } else {
	            this.setState({ promo_success: nextProps.customerCheckout.fetched_computed });
	        }
	        if (!this.state.address_changed) {
	            if (this.props.login.fetched) {
	                //to set the state of air_address and sea_address to default address and TO ENABLE TERMS CHECKBOX!
	                var filtered_address = nextProps.login.login.party.addresses.filter(function (add) {
	                    return add.country_code === JSON.parse(localStorage.shipment_location_details).destination;
	                });
	                if (nextProps.login.login.party.address_id != null) {
	                    if (filtered_address.map(function (add) {
	                        return add.id;
	                    }).indexOf(nextProps.login.login.party.address_id) > -1) {
	                        // handle setting of air_address and sea_address states depending on destination country; 
	                        this.setState({
	                            address_changed: true,
	                            air_address: nextProps.login.login.party.address_id,
	                            sea_address: nextProps.login.login.party.address_id
	                        });
	                    }
	                }
	            }
	        }
	        if (nextProps.login.addAddress) {
	            _reactDom2.default.findDOMNode(this.refs.success_addAddress).focus();
	            window.scrollTo(0, 0);
	        }
	
	        if (nextProps.customerCheckout.error && nextProps.customerCheckout.error.response && nextProps.customerCheckout.error.response.status === 422) {
	            this.setState({ promo_code: "" });
	        }
	
	        if (nextProps.customerCheckout.checkout.data && nextProps.customerCheckout.checkout.data.summary.usd.total_price === 0) {
	            this.setState({ promo_free_shipping: true });
	        } else {
	            this.setState({ promo_free_shipping: false });
	        }
	
	        var checkoutModalContent = nextProps.cms.getModal && nextProps.cms.modalContent && nextProps.cms.modalContent.data.variable === "Checkout-Modal" ? nextProps.cms.modalContent.data.status : false;
	        this.setState({ checkoutModalContent: checkoutModalContent });
	
	        if (!this.state.addressState) {
	            var defaultAddress = this.props.login.login.party && this.props.login.login.party.addresses.filter(function (add) {
	                return add.id === _this2.props.login.login.party.address_id;
	            }).map(function (add) {
	                return add.state;
	            });
	            this.setState({ addressState: defaultAddress && defaultAddress[0] });
	        }
	        if (!this.state.selectedAirAddress && !this.state.selectedSeaAddress) {
	            var _defaultAddress = this.props.login.login.party && this.props.login.login.party.addresses.filter(function (add) {
	                return add.id === _this2.props.login.login.party.address_id;
	            }).map(function (add) {
	                return add;
	            });
	            if (_defaultAddress && _defaultAddress[0]) {
	                if (_defaultAddress[0].country_code === JSON.parse(localStorage.shipment_location_details).destination) {
	                    this.setState({
	                        selectedAirAddress: _defaultAddress && _defaultAddress[0],
	                        selectedSeaAddress: _defaultAddress && _defaultAddress[0]
	                    });
	                }
	            }
	        }
	        if (!this.state.firstLoad && nextProps.customerCheckout.checkout && nextProps.customerCheckout.checkout.data && nextProps.customerCheckout.checkout.data.hasOwnProperty('air') && nextProps.customerCheckout.checkout.data.hasOwnProperty('sea')) {
	            var _defaultAddress2 = nextProps.login.login.party && nextProps.login.login.party.addresses.filter(function (add) {
	                return add.id === nextProps.login.login.party.address_id;
	            }).map(function (add) {
	                return add;
	            });
	            if (_defaultAddress2.length >= 1 && _defaultAddress2[0].country_code === JSON.parse(localStorage.shipment_location_details).destination) {
	                this.setState({
	                    selectedAirAddress: _defaultAddress2 && _defaultAddress2[0],
	                    selectedSeaAddress: _defaultAddress2 && _defaultAddress2[0],
	                    sameAddress: true,
	                    firstLoad: true
	                });
	            } else {
	                this.setState({
	                    selectedAirAddress: '',
	                    selectedSeaAddress: '',
	                    firstLoad: true
	                });
	            }
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        window.scrollTo(0, 0);
	        this.handleGetAddress('all', 1);
	    },
	    handleGetAddress: function handleGetAddress(mode, page, searchTerm, isLoadMore) {
	        var _this3 = this;
	
	        if ((typeof cancelToken === 'undefined' ? 'undefined' : _typeof(cancelToken)) !== ( true ? 'undefined' : _typeof(undefined))) {
	            cancelToken.cancel("Operation canceled due to new request.");
	        }
	
	        //Save the cancel token for the current request
	        cancelToken = _axios2.default.CancelToken.source();
	        var currentCountry = JSON.parse(localStorage.shipment_location_details);
	
	        _axios2.default.get(apiUrl + 'user/addresses?page=' + page + '&search=' + (searchTerm || '') + '&country_code=' + currentCountry.destination).then(function (response) {
	            if (mode === 'air') {
	                _this3.setState({
	                    airAddresses: isLoadMore ? [].concat(_toConsumableArray(_this3.state.airAddresses), _toConsumableArray(response.data.data)) : response.data.data,
	                    isSearchLoading: false,
	                    addressSearchTermAir: searchTerm,
	                    airAddressesPagination: {
	                        currentPage: response.data.current_page,
	                        lastPage: response.data.last_page
	                    }
	                });
	                return response;
	            }
	            if (mode === 'sea') {
	                _this3.setState({
	                    seaAddresses: isLoadMore ? [].concat(_toConsumableArray(_this3.state.airAddresses), _toConsumableArray(response.data.data)) : response.data.data,
	                    isSearchLoading: false,
	                    addressSearchTermSea: searchTerm,
	                    seaAddressesPagination: {
	                        currentPage: response.data.current_page,
	                        lastPage: response.data.last_page
	                    }
	                });
	                return response;
	            }
	            _this3.setState({
	                seaAddresses: response.data.data,
	                airAddresses: response.data.data,
	                airAddressesPagination: {
	                    currentPage: response.data.current_page,
	                    lastPage: response.data.last_page
	                },
	                seaAddressesPagination: {
	                    currentPage: response.data.current_page,
	                    lastPage: response.data.last_page
	                },
	                isSearchLoading: false
	            });
	
	            return response;
	        }).catch(function (err) {
	            console.log(err, 'err');
	            return err;
	        });
	    },
	    handleSearchInputChange: function handleSearchInputChange(e, type) {
	        if (e.target.value === ' ' || e.target.value.split('').pop() === ' ') {
	            return;
	        }
	        this.setState({ isSearchLoading: true });
	        this.state.debouncedSearch(type, 1, e.target.value);
	    },
	    handleLoadMoreAddresses: function handleLoadMoreAddresses(type) {
	        if (type === 'air') {
	            var _currentPage = this.state.airAddressesPagination.currentPage + 1;
	            this.handleGetAddress(type, _currentPage, this.state.addressSearchTermAir, true);
	            return;
	        }
	        var currentPage = this.state.seaAddressesPagination.currentPage + 1;
	        this.handleGetAddress(type, currentPage, this.state.addressSearchTermSea, true);
	    },
	    isLoadMoreShown: function isLoadMoreShown(type) {
	        if (type === 'air') {
	            return this.state.airAddressesPagination.currentPage < this.state.airAddressesPagination.lastPage;
	        }
	        return this.state.seaAddressesPagination.currentPage < this.state.seaAddressesPagination.lastPage;
	    },
	    onPaymentChange: function onPaymentChange(e) {
	        this.setState({ promo_submitted: false, promo_success: "", promo_code: "" });
	        this.refs.promo_code.value = "";
	        this.props.resetComputed();
	
	        this.setState({ payment_type: e.currentTarget.value });
	
	        var token = localStorage.jwtToken;
	        var itemArry = JSON.parse(localStorage.item);
	        var insurance = JSON.parse(localStorage.insurance);
	        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	        var warehouse_id = JSON.parse(localStorage.warehouse_id);
	        var sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
	        this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
	    },
	    onAirAddressChange: function onAirAddressChange(e, addresses) {
	        var _this4 = this;
	
	        this.setState({ addressState: addresses.state });
	        var isAddressWithDelay = this.findAddress(_areaWithDelay.areaWithDelay, addresses);
	        if (isAddressWithDelay) {
	            this.setState({
	                alertModal: true
	            });
	        }
	        this.setState({ promo_submitted: false, promo_success: "", promo_code: "" });
	        this.refs.promo_code.value = "";
	        this.props.resetComputed();
	
	        if (this.state.sameAddress) {
	            this.setState({
	                selectedSeaAddress: addresses,
	                sea_address: addresses.id
	            });
	        }
	
	        var token = localStorage.jwtToken;
	        var itemArry = JSON.parse(localStorage.item);
	        var insurance = JSON.parse(localStorage.insurance);
	        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	        var warehouse_id = JSON.parse(localStorage.warehouse_id);
	        this.setState({ address_changed: true });
	        this.setState({ selectedAirAddress: addresses });
	        this.setState({ air_address: addresses.id }, function () {
	            var sc_protect = { avail: _this4.state.isSCProtectActive ? 1 : 0 };
	            _this4.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect, _this4.state.air_address, _this4.state.sea_address);
	        });
	    },
	    onSeaAddressChange: function onSeaAddressChange(e, addresses) {
	        var _this5 = this;
	
	        var isAddressWithDelay = this.findAddress(_areaWithDelay.areaWithDelay, addresses);
	        if (isAddressWithDelay) {
	            this.setState({
	                alertModal: true
	            });
	        }
	        this.setState({ promo_submitted: false, promo_success: "", promo_code: "" });
	        this.refs.promo_code.value = "";
	        this.props.resetComputed();
	
	        var token = localStorage.jwtToken;
	        var itemArry = JSON.parse(localStorage.item);
	        var insurance = JSON.parse(localStorage.insurance);
	        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	        var warehouse_id = JSON.parse(localStorage.warehouse_id);
	        this.setState({ address_changed: true });
	        this.setState({ selectedSeaAddress: addresses });
	        this.setState({ sea_address: addresses.id }, function () {
	            var sc_protect = { avail: _this5.state.isSCProtectActive ? 1 : 0 };
	            _this5.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect, _this5.state.air_address, _this5.state.sea_address);
	        });
	    },
	    handleSubmit: function handleSubmit(e) {
	        e.preventDefault();
	        this.setState({ payship: false, customErrorMessage: '', error: false });
	        var token = localStorage.jwtToken;
	        var itemArry = JSON.parse(localStorage.item);
	        var insurance = JSON.parse(localStorage.insurance);
	        var payment_type = this.state.payment_type;
	        var air_address = this.state.air_address;
	        var sea_address = this.state.sea_address;
	        var note_air = this.state.note_air;
	        var note_sea = this.state.note_sea;
	        localStorage.setItem("note_air", note_air);
	        localStorage.setItem("note_sea", note_sea);
	        var total_price = this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.summary.usd.total_price : null;
	        localStorage.setItem("total_price", total_price);
	        var promo_code = this.state.promo_code;
	        var is_dangerous_air = JSON.parse(localStorage.airDangerous).length > 0 ? 1 : 0;
	        var is_dangerous_sea = JSON.parse(localStorage.seaDangerous).length > 0 ? 1 : 0;
	        var isOffsizeCheckoutItem = this.props.customerCheckout.isOffsizeCheckout;
	        var currentAirAddress = (0, _lodash.find)(addresses, function (address) {
	            // eslint-disable-next-line
	            return address.id === Number(air_address);
	        });
	
	        var currentSeaAddress = (0, _lodash.find)(addresses, function (address) {
	            // eslint-disable-next-line
	            return address.id === Number(sea_address);
	        });
	
	        var sc_protect = void 0;
	        var scProtectIds = this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.insurance;
	        sc_protect = {
	            avail: this.state.isSCProtectActive ? 1 : 0,
	            quotes_id: scProtectIds.quotes_id,
	            submission_id: scProtectIds.submission_id,
	            application_id: scProtectIds.application_id
	        };
	
	        // const admin = adyenDropInAccount.find(id => id === this.props.login.login.party.account_number)
	        if (this.state.payment_type === 'adyen') {
	            if (!this.state.promo_free_shipping) {
	                this.props.setCheckoutDetails(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id), is_dangerous_air, is_dangerous_sea, sc_protect, isOffsizeCheckoutItem);
	                _store.history.push("/adyen-payment");
	                return;
	            }
	        }
	
	        if (itemArry.air.length && !itemArry.sea.length) {
	            if (currentAirAddress && currentAirAddress.isRestricted) {
	                this.setState({ error: true, terms: true, customErrorMessage: INVALID_ADDRESS_ERROR });
	                return;
	            }
	            this.props.checkOutPayAirAndSea(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id), is_dangerous_air, is_dangerous_sea, sc_protect, isOffsizeCheckoutItem);
	        } else if (itemArry.sea.length && !itemArry.air.length) {
	            if (currentSeaAddress && currentSeaAddress.isRestricted) {
	                this.setState({ error: true, terms: true, customErrorMessage: INVALID_ADDRESS_ERROR });
	                return;
	            }
	            this.props.checkOutPayAirAndSea(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id), is_dangerous_air, is_dangerous_sea, sc_protect, isOffsizeCheckoutItem);
	        } else if (itemArry.air.length && itemArry.sea.length) {
	            if (currentSeaAddress && currentSeaAddress.isRestricted || currentAirAddress && currentAirAddress.isRestricted) {
	                this.setState({ error: true, terms: true, customErrorMessage: INVALID_ADDRESS_ERROR });
	                return;
	            }
	            this.props.checkOutPayAirAndSea(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id), is_dangerous_air, is_dangerous_sea, sc_protect, isOffsizeCheckoutItem);
	        }
	    },
	    handleCancelItemAir: function handleCancelItemAir(id, e) {
	        var token = localStorage.jwtToken;
	        e.preventDefault();
	        var itemArry = JSON.parse(localStorage.item);
	        itemArry.air.splice(itemArry.air.indexOf(id), 1);
	        if (itemArry.air.length === 0 && itemArry.sea.length === 0) {
	            this.props.showEmptyItemOnCheckout();
	            // window.location.replace(window.location.origin + "/cart");
	            _store.history.push("/cart");
	        } else {
	            localStorage.setItem("item", JSON.stringify(itemArry));
	            var insurance = JSON.parse(localStorage.insurance);
	            var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	            var warehouse_id = JSON.parse(localStorage.warehouse_id);
	            delete insurance[id];
	            delete shipment_location_details[id];
	            delete warehouse_id[id];
	            localStorage.setItem("insurance", JSON.stringify(insurance));
	            localStorage.setItem("shipment_location_details", JSON.stringify(localStorage.shipment_location_details));
	            localStorage.setItem("warehouse_id", JSON.stringify(warehouse_id));
	            var sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
	            this.props.checkOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
	        }
	    },
	    handleCancelItemSea: function handleCancelItemSea(id, e) {
	        var token = localStorage.jwtToken;
	        e.preventDefault();
	        var itemArry = JSON.parse(localStorage.item);
	        itemArry.sea.splice(itemArry.sea.indexOf(id), 1);
	        if (itemArry.air.length === 0 && itemArry.sea.length === 0) {
	            this.props.showEmptyItemOnCheckout();
	            // window.location.replace(window.location.origin + "/cart");
	            _store.history.push("/cart");
	        } else {
	            localStorage.setItem("item", JSON.stringify(itemArry));
	            var insurance = JSON.parse(localStorage.insurance);
	            var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	            var warehouse_id = JSON.parse(localStorage.warehouse_id);
	            delete insurance[id];
	            delete shipment_location_details[id];
	            delete warehouse_id[id];
	            localStorage.setItem("insurance", JSON.stringify(insurance));
	            localStorage.setItem("shipment_location_details", JSON.stringify(localStorage.shipment_location_details));
	            localStorage.setItem("warehouse_id", JSON.stringify(warehouse_id));
	            var sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
	            this.props.checkOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
	        }
	    },
	    handlePromo: function handlePromo(e) {
	        e.preventDefault();
	        this.setState({ promo_submitted: true, promo_success: "" });
	        var token = localStorage.jwtToken;
	        var itemArry = JSON.parse(localStorage.item);
	        var air_address = this.state.air_address;
	        var sea_address = this.state.sea_address;
	        var insurance = JSON.parse(localStorage.insurance);
	        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	        var warehouse_id = JSON.parse(localStorage.warehouse_id);
	        var promo_code = this.state.inputtedPromoCode;
	        this.setState({ promo_code: promo_code, promo_success: false });
	        var payment_type = this.state.payment_type;
	
	        this.props.clearPromoError();
	
	        if (itemArry.air.length && !itemArry.sea.length) {
	            if (this.state.payment_type) {
	                itemArry.air.address = air_address;
	
	                if (promo_code) {
	                    var sc_protect = {
	                        avail: this.state.isSCProtectActive ? 1 : 0
	                    };
	                    this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, sc_protect);
	                    this.setState({ withoutAddress: false });
	                } else {
	                    this.setState({ promo_success: false });
	                }
	            } else {
	                this.setState({ withoutAddress: true });
	            }
	        } else if (itemArry.sea.length && !itemArry.air.length) {
	            if (this.state.payment_type) {
	                itemArry.sea.address = sea_address;
	
	                if (promo_code) {
	                    var _sc_protect = {
	                        avail: this.state.isSCProtectActive ? 1 : 0
	                    };
	                    this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, _sc_protect);
	                    this.setState({ withoutAddress: false });
	                } else {
	                    this.setState({ promo_success: false });
	                }
	            } else {
	                this.setState({ withoutAddress: true });
	            }
	        } else if (itemArry.air.length && itemArry.sea.length) {
	            if (this.state.payment_type) {
	                itemArry.air.address = air_address;
	                itemArry.sea.address = sea_address;
	
	                if (promo_code) {
	                    var _sc_protect2 = {
	                        avail: this.state.isSCProtectActive ? 1 : 0
	                    };
	                    this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, _sc_protect2);
	                    this.setState({ withoutAddress: false });
	                } else {
	                    this.setState({ promo_success: false });
	                }
	            } else {
	                this.setState({ withoutAddress: true });
	            }
	        }
	    },
	    inputChange: function inputChange(e) {
	        var target = e.target;
	        var value = target.value;
	        this.setState({ inputtedPromoCode: value });
	    },
	    handleCountries: function handleCountries(e, type) {
	        var _this6 = this;
	
	        e.preventDefault();
	        this.setState({
	            showAddAddress: true,
	            form_submitted: false,
	            error: false,
	            country: true,
	            addAddressType: type,
	            country_name: JSON.parse(localStorage.shipment_location_details).destination
	        }, function () {
	            _reactDom2.default.findDOMNode(_this6.refs.first_name).focus();
	            _this6.props.getProvinces(_this6.state.country_name);
	
	            if (_this6.state.country_name === "PH") {
	                _this6.props.getRegions();
	            }
	        });
	        this.props.resetAccounts();
	        this.setState({ error: false, form_submitted: false });
	    },
	    handleProvince: function handleProvince(e) {
	        var _this7 = this;
	
	        this.refs.address_province.value = "";
	        this.refs.address_city.value = "";
	        this.refs.address_district.value = "";
	
	        this.setState({
	            country: true,
	            country_name: e.target.value,
	            province_value: "",
	            city_value: "",
	            district_value: "",
	            postal_code_value: "",
	            province: false,
	            city: false,
	            district: false
	        }, function () {
	            _this7.props.getProvinces(_this7.state.country_name);
	
	            if (_this7.state.country_name === "PH") {
	                _this7.props.getRegions();
	            }
	        });
	    },
	    handleCity: function handleCity(e) {
	        var _this8 = this;
	
	        //when province is changed, cities are populated
	        var id = this.refs.address_province.value;
	        var index = e.nativeEvent.target.selectedIndex;
	        var parent_id = e.nativeEvent.target[index].getAttribute('data-parent-id');
	        var name = e.nativeEvent.target[index].text;
	
	        this.refs.address_city.value = this.refs.address_district.value = "";
	
	        if (id === "") {
	            this.setState({ province: false, city: false, district: false });
	        } else {
	            this.setState({ province_value: name, province: true });
	        }
	
	        if (this.props.login.region_fetched) {
	            this.props.login.region.data.map(function (reg) {
	                return parseInt(parent_id, 10) === parseInt(reg.id, 10) ? _this8.setState({ region: reg.name }) : null;
	            });
	        }
	        this.props.getCities(id);
	        this.setState({ postal_code_value: "" });
	    },
	    handleDistrict: function handleDistrict(e) {
	        //when city is changed, districts are populated
	        var id = this.refs.address_city.value;
	        var index = e.nativeEvent.target.selectedIndex;
	        var city_name = e.nativeEvent.target[index].text;
	        this.refs.address_district.value = "";
	
	        if (id === "") {
	            this.setState({ city: false });
	        } else {
	            this.setState({ city_value: city_name, city: true });
	        }
	        this.setState({ postal_code_value: "" });
	        this.props.getDistricts(id);
	    },
	    handleBarangay: function handleBarangay(e) {
	        var index = e.nativeEvent.target.selectedIndex;
	        var postal_code = e.nativeEvent.target[index].getAttribute('data-postal');
	        this.setState({ postal_code_value: postal_code, district: true, postal: true });
	    },
	    handleInputChange: function handleInputChange(e) {
	        var target = e.target;
	        var name = target.name;
	        var value = target.value;
	
	        if (name === "add_countryPrefix") {
	            this.setState(_defineProperty({}, name, value));
	            this.setState({ phone_number: "" });
	        } else {
	            this.setState(_defineProperty({}, name, value));
	        }
	    },
	    handleAddress: function handleAddress() {
	        var _this9 = this;
	
	        this.setState({ form_submitted: true });
	        var token = localStorage.jwtToken;
	        var first_name = this.refs.first_name.value;
	        var last_name = this.refs.last_name.value;
	        var street = this.refs.street.value;
	        var province = this.state.province_value;
	        var city = this.state.city_value;
	        var district = this.refs.address_district.value;
	        var postal = this.refs.postal.value;
	        var parameters = {
	            token: token,
	            "type": "delivery",
	            "first_name": first_name,
	            "middle_initial": "",
	            "last_name": last_name,
	            "line_1": street,
	            "line_2": district,
	            "city": city,
	            "state": province,
	            "postal_code": postal,
	            "region": this.state.region,
	            "country_code": this.state.country_name,
	            "phone_number": this.state.add_countryPrefix && this.state.address_phone_number && '' + this.state.add_countryPrefix + this.state.address_phone_number
	        };
	        this.setState({ error: false }); //remove negative labels
	        this.props.addAddress(parameters).then(function (res) {
	            if (res && res.response && res.response.data && res.response.data.errors) {
	                var errors = {};
	                res.response.data.errors.forEach(function (_ref) {
	                    var title = _ref.title,
	                        detail = _ref.detail;
	
	                    errors[title] = detail;
	                });
	
	                _this9.setState({ errors: errors });
	                return;
	            }
	            if (_this9.state.addAddressType === 'air') {
	                if (!_this9.state.selectedAirAddress.id) {
	                    _this9.setState({ selectedAirAddress: res.data });
	                }
	                if (!_this9.state.air_address) {
	                    _this9.setState({ air_address: _this9.state.selectedAirAddress.id });
	                }
	                _this9.setState({ airAddresses: [res.data].concat(_toConsumableArray(_this9.state.airAddresses)) });
	            } else {
	                if (!_this9.state.selectedSeaAddress.id) {
	                    _this9.setState({ selectedSeaAddress: res.data });
	                }
	                if (!_this9.state.sea_address) {
	                    _this9.setState({ sea_address: _this9.state.selectedSeaAddress.id });
	                }
	                _this9.setState({ seaAddresses: [res.data].concat(_toConsumableArray(_this9.state.seaAddresses)) });
	            }
	
	            _this9.setState({ showAddAddress: false });
	        }); //add address
	    },
	    handleComputationOverview: function handleComputationOverview(type) {
	        var _props$customerChecko = this.props.customerCheckout.checkout.data[type],
	            chargeable_weight = _props$customerChecko.total_chargeable_weight,
	            usd = _props$customerChecko.usd;
	        var per_pound_value = usd.per_pound_value,
	            fixed_fee = usd.total_fixed_rate;
	        var _props$customerChecko2 = this.props.customerCheckout.checkout.data.original_computation[type].usd,
	            total_cargo = _props$customerChecko2.total_cargo,
	            insurance_fee = _props$customerChecko2.total_insurance,
	            storage_fee = _props$customerChecko2.total_storage_charge,
	            total_price_before_discount = _props$customerChecko2.total_price_before_discount,
	            total_price_before_storage = _props$customerChecko2.total_price_before_storage;
	
	
	        if (type === "air") {
	            this.setState({ showAirSubtotal: !this.state.showAirSubtotal, showSeaSubtotal: false }, !this.state.showAirSubtotal ? this.setState({ breakdown: null }) : null);
	        } else if (type === "sea") {
	            this.setState({ showSeaSubtotal: !this.state.showSeaSubtotal, showAirSubtotal: false });
	        }
	
	        this.setState({
	            breakdown: {
	                chargeable_weight: chargeable_weight,
	                per_pound_value: per_pound_value,
	                fixed_fee: fixed_fee,
	                total_cargo: total_cargo,
	                insurance_fee: insurance_fee,
	                storage_fee: storage_fee,
	                total_price_before_discount: total_price_before_discount,
	                total_price_before_storage: total_price_before_storage
	            }
	        });
	    },
	    handlePhp: function handlePhp() {
	        this.setState({ php: true, usd: false });
	    },
	    handleUsd: function handleUsd() {
	        this.setState({ php: false, usd: true });
	    },
	    handleCancel: function handleCancel() {
	        this.props.resetAccounts();
	        this.setState({
	            error: false,
	            first_name: false,
	            last_name: false,
	            street: false,
	            province: false,
	            city: false,
	            district: false,
	            postal: false
	        });
	    },
	    handleNoteCancel: function handleNoteCancel() {
	        this.setState({ note_submitted: false, has_note: false });
	    },
	    handleTerms: function handleTerms(e) {
	        e.target.checked ? this.setState({ terms: false }) : this.setState({ terms: true });
	        this.state.terms && this.state.air_address && this.state.sea_address && this.state.payment_type ? this.setState({ payship: true }) : this.setState({ payship: false });
	    },
	    handleNoteAir: function handleNoteAir(e) {
	        e.preventDefault();
	        this.setState({ note_submitted: true });
	        this.setState({ note_air: this.refs.note_air.value });
	        this.refs.note_air.value !== "" ? this.setState({ showAddNoteAir: false, has_note: true }) : this.setState({ has_note: false });
	    },
	    handleNoteSea: function handleNoteSea(e) {
	        e.preventDefault();
	        this.setState({ note_submitted: true });
	        this.setState({ note_sea: this.refs.note_sea.value });
	        this.refs.note_sea.value !== "" ? this.setState({ showAddNoteSea: false, has_note: true }) : this.setState({ has_note: false });
	    },
	    handleAir: function handleAir(e) {
	        e.preventDefault();
	        this.setState({ showAddNoteAir: true });
	    },
	    handleSea: function handleSea(e) {
	        e.preventDefault();
	        this.setState({ showAddNoteSea: true });
	    },
	    handleLogout: function handleLogout() {
	        localStorage.removeItem('jwtToken');
	        this.props.logout();
	    },
	    handleRemovePromo: function handleRemovePromo(e) {
	        e.preventDefault();
	        this.setState({ promo_submitted: false, promo_success: false, promo_code: "", payment_type: "", terms: true, payship: false });
	        this.props.resetComputed();
	        if (this.refs.promo_code) {
	            this.refs.promo_code.value = "";
	        }
	        var token = localStorage.jwtToken;
	        var itemArry = JSON.parse(localStorage.item);
	        var insurance = JSON.parse(localStorage.insurance);
	        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	        var warehouse_id = JSON.parse(localStorage.warehouse_id);
	        var sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
	        this.props.checkOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
	    },
	    handleOpenNoteAir: function handleOpenNoteAir(e) {
	        e.preventDefault();
	        this.setState({ showModalAir: true });
	    },
	    handleOpenNoteSea: function handleOpenNoteSea(e) {
	        e.preventDefault();
	        this.setState({ showModalSea: true });
	    },
	    saveNoteAir: function saveNoteAir() {
	        this.setState({ showModalAir: false });
	        this.setState({ note_air: this.refs.edit_note_air.value });
	    },
	    saveNoteSea: function saveNoteSea() {
	        this.setState({ showModalSea: false });
	        this.setState({ note_sea: this.refs.edit_note_sea.value });
	    },
	    handleRemoveNoteAir: function handleRemoveNoteAir() {
	        this.setState({ note_air: "" });
	    },
	    handleRemoveNoteSea: function handleRemoveNoteSea() {
	        this.setState({ note_sea: "" });
	    },
	    handleError: function handleError() {
	        return this.props.login.fetched && this.props.customerCheckout.error && !this.state.promo_submitted ? _react2.default.createElement(
	            'div',
	            { className: 'sc-alert sc-alert-danger checkout-error' },
	            _react2.default.createElement('i', { className: 'sc' }),
	            this.props.customerCheckout.error.response && this.props.customerCheckout.error.response.data.errors.detail
	        ) : null;
	    },
	    handleCustomError: function handleCustomError() {
	        return this.state.error && _react2.default.createElement(
	            'div',
	            { className: 'sc-alert sc-alert-danger checkout-error' },
	            _react2.default.createElement('i', { className: 'sc' }),
	            this.state.customErrorMessage
	        );
	    },
	    showTerms: function showTerms() {
	        window.open('/terms-conditions', 'Terms and Conditions', 'width=1250,height=600');
	    },
	    checkoutModal: function checkoutModal() {
	        return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null };
	    },
	    renderAirAddresses: function renderAirAddresses() {
	        var _this10 = this;
	
	        if (!this.props.customerCheckout.fetched) return;
	
	        addresses = [].concat(_toConsumableArray(this.props.login.login.party.addresses));
	        this.props.login.login.party.addresses.forEach(function (address) {
	            var isRestricted = false;
	            (0, _lodash.find)(_restrictedAreas.restrictedAreas.provinces, function (restrictedArea) {
	                if (address.state === restrictedArea.province) {
	                    isRestricted = true;
	                }
	            });
	            if (!isRestricted) {
	                (0, _lodash.find)(_restrictedAreas.restrictedAreas.cities, function (restrictedArea) {
	                    if (address.state === restrictedArea.province && address.city === restrictedArea.city) {
	                        isRestricted = true;
	                    }
	                });
	            }
	            if (!isRestricted) {
	                (0, _lodash.find)(_restrictedAreas.restrictedAreas.brgys, function (restrictedArea) {
	                    if (address.state === restrictedArea.province && address.city === restrictedArea.city && address.line_2 === restrictedArea.brgy) {
	                        isRestricted = true;
	                    }
	                });
	            }
	            if (isRestricted) {
	                address.isRestricted = true;
	            }
	        });
	
	        return this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.hasOwnProperty("air") && this.props.login.fetched && _react2.default.createElement(
	            'li',
	            { className: 'dropdown', style: { marginBottom: '20px', minHeight: '58px', listStyle: 'none', padding: '7px', border: '1px solid #E2E2E2', background: '#FCFCFC', borderRadius: '5px' } },
	            _react2.default.createElement(
	                'span',
	                { className: 'dropdown-toggle', 'data-toggle': 'dropdown', style: { font: 'normal normal 600 14px/18px Source Sans Pro', width: '100%', display: 'inline-flex', alignItems: 'center' } },
	                this.state.selectedAirAddress ? _react2.default.createElement(
	                    'div',
	                    { style: { padding: '0px 10px', width: '100%' } },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: this.state.selectedAirAddress.id, className: 'css-label' },
	                        (this.state.selectedAirAddress.full_name || JSON.parse(this.state.selectedAirAddress.name)).first_name,
	                        ' ',
	                        (this.state.selectedAirAddress.full_name || JSON.parse(this.state.selectedAirAddress.name)).last_name
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'address', style: { margin: '10px 0px', fontWeight: 500, color: '#707070' } },
	                        this.state.selectedAirAddress.line_1,
	                        ', ',
	                        this.state.selectedAirAddress.line_2,
	                        ', ',
	                        this.state.selectedAirAddress.city,
	                        ', ',
	                        this.state.selectedAirAddress.state,
	                        ', ',
	                        this.state.selectedAirAddress.postal_code
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { fontWeight: 500, color: '#707070', margin: '10px 0px' } },
	                        this.state.selectedAirAddress.phone_number || this.props.login.login.party.phone_number
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { style: { padding: '11px 5px', marginRight: '20px', width: '100%' } },
	                    'Select Shipping Address'
	                ),
	                _react2.default.createElement('i', { className: 'fa fa-angle-down', style: { float: 'right', fontSize: '23px' } })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'sub sub-info dropdown-menu' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: '0px 20px' } },
	                    _react2.default.createElement('input', { type: 'text', className: 'search-address', placeholder: 'Search address', onChange: function onChange(e) {
	                            _this10.handleSearchInputChange(e, 'air');
	                        } }),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { position: 'absolute', top: '25px', right: '30px', backgroundColor: '#fff' } },
	                        _react2.default.createElement('i', { className: 'fa fa-search' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { style: { padding: '0px 20px 20px 20px', maxHeight: '400px', overflow: 'auto', width: '100%' } },
	                    !this.state.isSearchLoading && this.state.airAddresses ? this.state.airAddresses.map(function (add, i) {
	                        return _react2.default.createElement(
	                            'li',
	                            { id: add.id, onClick: function onClick(e) {
	                                    return _this10.onAirAddressChange(e, add);
	                                } },
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: add.id, className: 'css-label' },
	                                (add.full_name || JSON.parse(add.name)).first_name,
	                                ' ',
	                                (add.full_name || JSON.parse(add.name)).last_name
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'address' },
	                                add.line_1,
	                                ', ',
	                                add.line_2,
	                                ', ',
	                                add.city,
	                                ', ',
	                                add.state,
	                                ', ',
	                                add.postal_code
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                add.phone_number || _this10.props.login.login.party.phone_number
	                            )
	                        );
	                    }) : _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'loader' },
	                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'sr-only' },
	                                'Loading...'
	                            )
	                        )
	                    ),
	                    !this.state.isSearchLoading && this.isLoadMoreShown('air') && _react2.default.createElement(
	                        'form',
	                        { style: {
	                                textAlign: 'center',
	                                fontWeight: 600,
	                                cursor: 'pointer',
	                                color: '#0375d9'
	                            } },
	                        _react2.default.createElement(
	                            'p',
	                            { type: 'button', onClick: function onClick() {
	                                    _this10.handleLoadMoreAddresses('air');
	                                } },
	                            'LOAD MORE'
	                        )
	                    ),
	                    !this.state.isSearchLoading && this.state.airAddresses && !this.state.airAddresses.length && _react2.default.createElement(
	                        'p',
	                        { style: { fontWeight: 600, textAlign: 'center' } },
	                        'No Addresses Available'
	                    )
	                )
	            )
	        );
	    },
	    renderSeaAddresses: function renderSeaAddresses() {
	        var _this11 = this;
	
	        if (!this.props.customerCheckout.fetched) return;
	
	        addresses = [].concat(_toConsumableArray(this.props.login.login.party.addresses));
	
	        this.props.login.login.party.addresses.forEach(function (address) {
	            var isRestricted = false;
	            (0, _lodash.find)(_restrictedAreas.restrictedAreas.provinces, function (restrictedArea) {
	                if (address.state === restrictedArea.province) {
	                    isRestricted = true;
	                }
	            });
	            if (!isRestricted) {
	                (0, _lodash.find)(_restrictedAreas.restrictedAreas.cities, function (restrictedArea) {
	                    if (address.state === restrictedArea.province && address.city === restrictedArea.city) {
	                        isRestricted = true;
	                    }
	                });
	            }
	            if (!isRestricted) {
	                (0, _lodash.find)(_restrictedAreas.restrictedAreas.brgys, function (restrictedArea) {
	                    if (address.state === restrictedArea.province && address.city === restrictedArea.city && address.line_2 === restrictedArea.brgy) {
	                        isRestricted = true;
	                    }
	                });
	            }
	            if (isRestricted) {
	                address.isRestricted = true;
	            }
	        });
	
	        return this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.hasOwnProperty("sea") && this.props.login.fetched && (this.state.selectedSeaAddress && this.state.sameAddress ? _react2.default.createElement(
	            'li',
	            { style: { marginBottom: '20px', minHeight: '58px', listStyle: 'none', padding: '7px', border: '1px solid #E2E2E2', background: '#F0F0F0', borderRadius: '5px', cursor: 'not-allowed' } },
	            _react2.default.createElement(
	                'span',
	                { style: { font: 'normal normal 600 14px/18px Source Sans Pro', width: '100%', display: 'inline-flex', alignItems: 'center' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { padding: '0px 10px', width: '100%' } },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: this.state.selectedSeaAddress.id, className: 'css-label' },
	                        (this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).first_name,
	                        ' ',
	                        (this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).last_name
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'address', style: { marginBottom: '0px', font: 'normal normal normal 14px / 18px Source Sans Pro' } },
	                        this.state.selectedSeaAddress.line_1,
	                        ' ',
	                        this.state.selectedSeaAddress.line_2,
	                        ' ',
	                        this.state.selectedSeaAddress.city,
	                        ' ',
	                        this.state.selectedSeaAddress.state,
	                        ' ',
	                        this.state.selectedSeaAddress.postal_code
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { fontWeight: 500, color: '#707070', margin: '10px 0px' } },
	                        this.state.selectedSeaAddress.phone_number || this.props.login.login.party.phone_number
	                    )
	                ),
	                _react2.default.createElement('i', { className: 'fa fa-angle-down', style: { float: 'right', fontSize: '23px' } })
	            )
	        ) : _react2.default.createElement(
	            'li',
	            { className: 'dropdown', style: { marginBottom: '20px', minHeight: '58px', listStyle: 'none', padding: '7px', border: '1px solid #E2E2E2', background: '#FCFCFC', borderRadius: '5px' } },
	            _react2.default.createElement(
	                'span',
	                { className: 'dropdown-toggle', 'data-toggle': 'dropdown', style: { font: 'normal normal 600 14px/18px Source Sans Pro', width: '100%', display: 'inline-flex', alignItems: 'center' } },
	                this.state.selectedSeaAddress ? _react2.default.createElement(
	                    'div',
	                    { style: { padding: '0px 10px', width: '100%' } },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: this.state.selectedSeaAddress.id, className: 'css-label' },
	                        (this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).first_name,
	                        ' ',
	                        (this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).last_name
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'address', style: { marginBottom: '0px', font: 'normal normal normal 14px / 18px Source Sans Pro', color: '#707070' } },
	                        this.state.selectedSeaAddress.line_1,
	                        ', ',
	                        this.state.selectedSeaAddress.line_2,
	                        ', ',
	                        this.state.selectedSeaAddress.city,
	                        ', ',
	                        this.state.selectedSeaAddress.state,
	                        ', ',
	                        this.state.selectedSeaAddress.postal_code
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { fontWeight: 500, color: '#707070', margin: '10px 0px' } },
	                        this.state.selectedSeaAddress.phone_number || this.props.login.login.party.phone_number
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { style: { padding: '11px 5px', marginRight: '20px', width: '100%' } },
	                    'Select Shipping Address'
	                ),
	                _react2.default.createElement('i', { className: 'fa fa-angle-down', style: { float: 'right', fontSize: '23px' } })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'sub sub-info dropdown-menu' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: '0px 20px' } },
	                    _react2.default.createElement('input', { type: 'text', className: 'search-address', placeholder: 'Search address', onChange: function onChange(e) {
	                            _this11.handleSearchInputChange(e, 'sea');
	                        } }),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { position: 'absolute', top: '25px', right: '30px', backgroundColor: '#fff' } },
	                        _react2.default.createElement('i', { className: 'fa fa-search' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { style: { padding: '0px 20px 20px 20px', maxHeight: '400px', overflow: 'auto', width: '100%' } },
	                    !this.state.isSearchLoading && this.state.seaAddresses ? this.state.seaAddresses.map(function (add, i) {
	                        return _react2.default.createElement(
	                            'li',
	                            { id: add.id, onClick: function onClick(e) {
	                                    return _this11.onSeaAddressChange(e, add);
	                                } },
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: add.id, className: 'css-label' },
	                                (add.full_name || JSON.parse(add.name)).first_name,
	                                ' ',
	                                (add.full_name || JSON.parse(add.name)).last_name
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'address', style: { marginBottom: 10 } },
	                                add.line_1,
	                                ', ',
	                                add.line_2,
	                                ', ',
	                                add.city,
	                                ', ',
	                                add.state,
	                                ', ',
	                                add.postal_code
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                add.phone_number || _this11.props.login.login.party.phone_number
	                            )
	                        );
	                    }) : _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'loader' },
	                            _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'sr-only' },
	                                'Loading...'
	                            )
	                        )
	                    ),
	                    !this.state.isSearchLoading && this.isLoadMoreShown('sea') && _react2.default.createElement(
	                        'form',
	                        { style: {
	                                textAlign: 'center',
	                                fontWeight: 600,
	                                cursor: 'pointer',
	                                color: '#0375d9'
	                            } },
	                        _react2.default.createElement(
	                            'p',
	                            { type: 'button', onClick: function onClick() {
	                                    _this11.handleLoadMoreAddresses('sea');
	                                } },
	                            'LOAD MORE'
	                        )
	                    ),
	                    !this.state.isSearchLoading && this.state.seaAddresses && !this.state.seaAddresses.length && _react2.default.createElement(
	                        'p',
	                        { style: { fontWeight: 600, textAlign: 'center' } },
	                        'No Addresses Available'
	                    )
	                )
	            )
	        ));
	    },
	    findAddress: function findAddress(addresses, addressToFind) {
	        if (!addressToFind) return false;
	        var isAddressFound = false;
	        addresses.provinces.find(function (_ref2) {
	            var province = _ref2.province;
	
	            if (province === addressToFind.state) {
	                isAddressFound = true;
	            }
	            return '';
	        });
	
	        if (!isAddressFound) {
	            addresses.cities.find(function (_ref3) {
	                var province = _ref3.province,
	                    city = _ref3.city;
	
	                if (province === addressToFind.state && city === addressToFind.city) {
	                    isAddressFound = true;
	                }
	                return '';
	            });
	        }
	
	        if (!isAddressFound) {
	            addresses.brgys.find(function (_ref4) {
	                var province = _ref4.province,
	                    city = _ref4.city,
	                    brgy = _ref4.brgy;
	
	                if (province === addressToFind.state && city === addressToFind.city && brgy === addressToFind.line_2) {
	                    isAddressFound = true;
	                }
	                return '';
	            });
	        }
	
	        return isAddressFound;
	    },
	    handleSameAddress: function handleSameAddress() {
	        var _this12 = this;
	
	        this.setState({ sameAddress: !this.state.sameAddress }, function () {
	            _this12.setState({
	                selectedSeaAddress: _this12.state.selectedAirAddress,
	                sea_address: _this12.state.air_address
	            });
	        });
	    },
	    isTermsDisabled: function isTermsDisabled() {
	        if (this.state.payment_type !== '' && (!!this.state.selectedAirAddress || !!this.state.selectedSeaAddress)) return false;
	        return true;
	    },
	    handleToggleSCProtect: function handleToggleSCProtect(isSCProtectActive) {
	        var token = localStorage.jwtToken;
	        var itemArry = JSON.parse(localStorage.item);
	        var insurance = JSON.parse(localStorage.insurance);
	        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
	        var warehouse_id = JSON.parse(localStorage.warehouse_id);
	        var sc_protect = { avail: isSCProtectActive ? 1 : 0 };
	        if (this.state.promo_code) {
	            this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, this.state.promo_code, this.state.payment_type, shipment_location_details, warehouse_id, sc_protect);
	        } else {
	            this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
	        }
	    },
	    handleSwitchToggle: function handleSwitchToggle() {
	        var _this13 = this;
	
	        this.setState({ isSCProtectActive: !this.state.isSCProtectActive }, function () {
	            _this13.handleToggleSCProtect(_this13.state.isSCProtectActive);
	        });
	    },
	    render: function render() {
	        var _this14 = this;
	
	        var outboundBanner = this.props.settings && this.props.settings.globalSettings && this.props.settings.globalSettings.data.filter(function (data) {
	            return data.name === 'outbound_banner';
	        });
	        var minChargableWeight = this.props.settings && this.props.settings.globalSettings && this.props.settings.globalSettings.data.filter(function (data) {
	            return data.name === 'minimum_chargeable_weight';
	        })[0];
	        return _react2.default.createElement(
	            'div',
	            { className: 'home' },
	            this.props.customerCheckout.sc_protect_updating && _react2.default.createElement(
	                'div',
	                { style: { top: 0, right: 0, left: 0, bottom: 0, position: 'fixed', alignItems: 'center', background: 'rgba(0,0,0,0.6)', zIndex: '999999', justifyContent: 'center', display: 'flex' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { color: '#FFF' } },
	                    _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        'Loading...'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { className: 'alert-modal-checkout', show: this.state.alertModal, onHide: this.close, autoFocus: true },
	                _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Our partner encountered problems delivering to your area, please expect delays and multiple delivery attempts. Rest assured that our team will ensure safe delivery of your package.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    { style: { "textAlign": "center" } },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'alert-modal-btn btn', onClick: this.close },
	                        'OK GOT IT!'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showModalAir, onHide: this.close, autoFocus: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        'Edit note for Air Cargo'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement('textarea', { className: 'form-control', rows: '20', defaultValue: this.state.note_air,
	                        ref: 'edit_note_air' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: this.saveNoteAir },
	                        'Save'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { onClick: this.close },
	                        'Close'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showModalSea, onHide: this.close, autoFocus: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        'Edit note for Sea Cargo'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement('textarea', { className: 'form-control', rows: '20', defaultValue: this.state.note_sea,
	                        ref: 'edit_note_sea' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { className: 'btn btn-orange', onClick: this.saveNoteSea },
	                        'Save'
	                    ),
	                    '\xA0 \xA0 \xA0',
	                    _react2.default.createElement(
	                        'a',
	                        { onClick: this.close },
	                        'Cancel'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showAddNoteAir, onHide: this.close, autoFocus: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        'Add note for Air Cargo'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    this.state.note_submitted && !this.state.has_note ? _react2.default.createElement(
	                        'label',
	                        { className: 'input-error' },
	                        'Add a note for our Warehouse Team.'
	                    ) : null,
	                    _react2.default.createElement('textarea', { className: 'form-control', rows: '20',
	                        style: this.state.note_submitted ? this.state.has_note ? null : { borderColor: 'red' } : null,
	                        ref: 'note_air' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'submit', className: 'btn btn-orange', onClick: this.handleNoteAir },
	                        'Save Note'
	                    ),
	                    '\xA0 \xA0 \xA0',
	                    _react2.default.createElement(
	                        'a',
	                        { onClick: this.close },
	                        'Cancel'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showAddNoteSea, onHide: this.close, autoFocus: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        'Add note for Sea Cargo'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    this.state.note_submitted && !this.state.has_note ? _react2.default.createElement(
	                        'label',
	                        { className: 'input-error' },
	                        'Add a note for our Warehouse Team.'
	                    ) : null,
	                    _react2.default.createElement('textarea', { className: 'form-control', rows: '20',
	                        style: this.state.note_submitted ? this.state.has_note ? null : { borderColor: 'red' } : null,
	                        ref: 'note_sea' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { className: 'btn btn-orange', onClick: this.handleNoteSea },
	                        'Save'
	                    ),
	                    '\xA0 \xA0 \xA0',
	                    _react2.default.createElement(
	                        'a',
	                        { onClick: this.close },
	                        'Cancel'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Modal,
	                { show: this.state.showAddAddress, onHide: this.close, autoFocus: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { style: { marginBottom: 0, paddingBottom: 0 }, closeButton: true },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', justifyContent: 'space-between' } },
	                        _react2.default.createElement(
	                            'p',
	                            { style: { color: '#333333', fontWeight: 600, fontSize: 20 } },
	                            'Add Address'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { style: { color: '#707070', fontSize: 12, marginTop: 5 } },
	                            'All fields are required.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    { style: { padding: 20, color: '#707070' } },
	                    _react2.default.createElement(
	                        'form',
	                        { id: 'address', 'data-do': 'add-address' },
	                        _react2.default.createElement(
	                            'section',
	                            null,
	                            Object.keys(this.state.errors).length ? _react2.default.createElement(
	                                'div',
	                                { className: 'notify' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'sc-alert sc-alert-danger checkout-error' },
	                                    _react2.default.createElement('i', { className: 'sc' }),
	                                    ' Fill in all fields to add address.'
	                                )
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    'First Name \xA0',
	                                    this.state.errors.first_name && _react2.default.createElement(
	                                        'label',
	                                        { className: 'input-error' },
	                                        this.state.errors.first_name
	                                    )
	                                ),
	                                _react2.default.createElement('input', { type: 'text', maxLength: '20', className: 'checkout-form-control', ref: 'first_name',
	                                    placeholder: 'Enter First Name', defaultValue: '' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    'Last Name \xA0',
	                                    this.state.errors.last_name && _react2.default.createElement(
	                                        'label',
	                                        { className: 'input-error' },
	                                        this.state.errors.last_name
	                                    )
	                                ),
	                                _react2.default.createElement('input', { type: 'text', maxLength: '20', className: ' checkout-form-control', ref: 'last_name',
	                                    placeholder: 'Enter Last Name', defaultValue: '' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    'Street Address \xA0',
	                                    this.state.errors.line_1 && _react2.default.createElement(
	                                        'label',
	                                        { className: 'input-error' },
	                                        this.state.errors.line_1
	                                    )
	                                ),
	                                _react2.default.createElement('input', { type: 'text', maxLength: '255', className: ' checkout-form-control', ref: 'street',
	                                    placeholder: 'Enter Street Address', defaultValue: '' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    'Country\xA0',
	                                    this.state.errors.country && _react2.default.createElement(
	                                        'label',
	                                        { className: 'input-error' },
	                                        this.state.errors.country
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { onChange: this.handleProvince,
	                                        value: localStorage.shipment_location_details ? JSON.parse(localStorage.shipment_location_details).destination : null,
	                                        className: 'checkout-form-control',
	                                        name: 'country',
	                                        ref: 'address_country',
	                                        disabled: true },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '', selected: 'selected' },
	                                        '--- Select Country ---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: 'PH' },
	                                        'Philippines'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    this.state.country_name === "MY" ? "State/Province" : "Province",
	                                    ' \xA0',
	                                    this.state.errors.state && _react2.default.createElement(
	                                        'label',
	                                        { className: 'input-error' },
	                                        this.state.errors.state
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'checkout-form-control', name: 'address_province',
	                                        onChange: this.handleCity,
	                                        disabled: this.state.country ? "" : "disabled",
	                                        ref: 'address_province' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '', selected: 'selected' },
	                                        '--- Select ',
	                                        this.state.country_name === "MY" ? "State/Province" : "Province",
	                                        ' ---'
	                                    ),
	                                    this.props.login.province_fetched ? (this.props.login.provinces.data || this.props.login.provinces).map(function (prov, i) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: i, value: prov.id,
	                                                'data-parent-id': prov.parent_id },
	                                            prov.name
	                                        );
	                                    }) : null
	                                ),
	                                _react2.default.createElement('div', { className: 'error-text' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    'City \xA0',
	                                    this.state.errors.city && _react2.default.createElement(
	                                        'label',
	                                        { className: 'input-error' },
	                                        this.state.errors.city
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'checkout-form-control', name: 'address_province',
	                                        onChange: this.handleDistrict,
	                                        disabled: this.state.province ? "" : "disabled", ref: 'address_city' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '', selected: 'selected' },
	                                        '--- Select City ---'
	                                    ),
	                                    this.props.login.city_fetched ? (this.props.login.cities.data || this.props.login.cities).map(function (city, i) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: i, value: city.id },
	                                            city.name
	                                        );
	                                    }) : null
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    this.state.country_name === "MY" ? "District/Barangay" : "Barangay",
	                                    ' \xA0',
	                                    this.state.errors.line_2 && _react2.default.createElement(
	                                        'label',
	                                        { className: 'input-error' },
	                                        this.state.errors.line_2
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { className: 'checkout-form-control', name: 'address_province',
	                                        disabled: this.state.city ? "" : "disabled", onChange: this.handleBarangay,
	                                        ref: 'address_district' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '', selected: 'selected' },
	                                        '--- Select ',
	                                        this.state.country_name === "MY" ? "District/Barangay" : "Barangay",
	                                        ' ---'
	                                    ),
	                                    this.props.login.district_fetched ? (this.props.login.districts.data || this.props.login.districts).map(function (dist, i) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: i, value: dist.name,
	                                                'data-postal': dist.postal_code },
	                                            dist.name,
	                                            ' ',
	                                            _this14.state.country_name === "MY" && '(' + dist.postal_code + ')'
	                                        );
	                                    }) : null
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    'Postal \xA0'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', className: 'checkout-form-control', ref: 'postal', disabled: true,
	                                    value: this.state.postal_code_value })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginTop: 15 } },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'checkout-form-label' },
	                                    'Contact Number '
	                                ),
	                                '\xA0',
	                                _react2.default.createElement('label', { ref: 'errors_add_phone_number', className: 'disnone' }),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { display: 'flex' } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'select',
	                                            { style: { width: 75 }, value: this.state.add_countryPrefix, onChange: this.handleInputChange, name: 'add_countryPrefix', className: 'checkout-form-control' },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '' },
	                                                'Prefix'
	                                            ),
	                                            _utils.mapPrefixNumber.map(function (prefix) {
	                                                return _react2.default.createElement(
	                                                    'option',
	                                                    { value: prefix.value },
	                                                    prefix.label
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement('img', { src: _angleLeft2.default, alt: 'icon', className: 'account-dropdown-icon', style: { left: 77 } })
	                                    ),
	                                    _react2.default.createElement('input', { type: 'text', style: { margin: '0px 0px 0px 20px', width: '100%' }, ref: 'phone_number', name: 'address_phone_number', maxLength: '10', value: this.state.address_phone_number, onChange: this.handleInputChange, autoComplete: 'off', className: 'checkout-form-control' })
	                                )
	                            ),
	                            this.state.errors.phone_number && _react2.default.createElement(
	                                'label',
	                                { className: 'input-error' },
	                                this.state.errors.phone_number
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'checkout-modal-footer', style: { marginTop: 15, margin: 20 } },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'checkout-add-address-button', onClick: this.handleAddress },
	                        'Add Address'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { style: { color: '#707070', fontWeight: 600, fontSize: 14, display: 'flex', justifyContent: 'center', width: 200, alignItems: 'center' }, onClick: this.close },
	                        'CANCEL'
	                    )
	                )
	            ),
	            this.props.customerCheckout.fetched_asiapay ? _react2.default.createElement(
	                'form',
	                { style: { display: "none" }, method: 'post',
	                    action: this.props.customerCheckout.asiapay.parameters.payments.url },
	                _react2.default.createElement('input', { type: 'hidden', name: 'merchantId',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.merchantId }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'amount',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.amount }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'orderRef',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.orderRef }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'currCode',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.currCode }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'mpsMode',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.mpsMode }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'successUrl',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.successUrl }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'failUrl',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.failUrl }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'cancelUrl',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.cancelUrl }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'payType',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.payType }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'lang',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.lang }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'payMethod',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.payMethod }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'failRetry',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.failRetry }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'secureHash',
	                    value: this.props.customerCheckout.asiapay.parameters.payments.query.secureHash }),
	                _react2.default.createElement('input', { type: 'submit', name: 'submit', ref: 'asiapayform' })
	            ) : null,
	            this.props.customerCheckout.fetched_adyen ? _react2.default.createElement(
	                'form',
	                { style: { display: "none" }, method: 'post',
	                    action: this.props.customerCheckout.adyen.attributes.url },
	                _react2.default.createElement('input', { type: 'hidden', name: 'merchantReference',
	                    value: this.props.customerCheckout.adyen.attributes.merchant_reference }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'paymentAmount',
	                    value: this.props.customerCheckout.adyen.attributes.payment_amount }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'skinCode',
	                    value: this.props.customerCheckout.adyen.attributes.skin_code }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'currencyCode',
	                    value: this.props.customerCheckout.adyen.attributes.currency_code }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'merchantAccount',
	                    value: this.props.customerCheckout.adyen.attributes.merchant_account }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'merchantSig',
	                    value: this.props.customerCheckout.adyen.attributes.merchant_signature }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'sessionValidity',
	                    value: this.props.customerCheckout.adyen.attributes.session_validity }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'shipBeforeDate',
	                    value: this.props.customerCheckout.adyen.attributes.ship_before_date }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'recurringContract',
	                    value: 'ONECLICK' }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'shopperEmail',
	                    value: this.props.customerCheckout.adyen.attributes.shopperEmail }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'shopperReference',
	                    value: this.props.customerCheckout.adyen.attributes.shopperReference }),
	                _react2.default.createElement('input', { type: 'submit', ref: 'adyenForm' })
	            ) : null,
	            _react2.default.createElement(
	                'header',
	                { className: 'site-header header-minimal' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'logo' },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/home', className: 'clearfix' },
	                            _react2.default.createElement('div', { className: 'main-img' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'nav',
	                        { className: 'top-nav' },
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'dropdown has-sub' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: 'dropdown-toggle',
	                                        'data-toggle': 'dropdown' },
	                                    'Hello ',
	                                    this.props.login.fetched ? this.props.login.login.party.first_name : null,
	                                    '\xA0',
	                                    _react2.default.createElement('i', { className: 'fa fa-angle-down' })
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'sub sub-account dropdown-menu ', style: { top: '80px' } },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/cart' },
	                                            ' Cart '
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/shipment' },
	                                            ' Shipments'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/account' },
	                                            ' Account '
	                                        )
	                                    ),
	                                    this.props.parcelInfo.getParcel ? null : this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.length > 0 ? _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/prohibited' },
	                                            'Prohibited Items '
	                                        )
	                                    ) : null : null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/home', onClick: this.handleLogout },
	                                            ' Logout '
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'body-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'checkout container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-top text-center' },
	                        _react2.default.createElement('div', { className: 'checkout-progress' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'checkout-wrapper clearfix' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'back-link' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/cart' },
	                                ' < Back to Cart'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'padding-left-30' },
	                            _react2.default.createElement(
	                                'div',
	                                { ref: 'success_addAddress',
	                                    className: this.props.login.addAddress ? "sc-alert sc-alert-success" : "disnone" },
	                                _react2.default.createElement('i', { className: 'sc' }),
	                                'You\'ve successfully added a new address.'
	                            )
	                        ),
	                        this.handleError(),
	                        this.handleCustomError(),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: this.handleSubmit, className: 'clearfix' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'step-1' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    '1. How do you want to pay?'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'payment-list' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'credit-card radio' },
	                                        _react2.default.createElement('input', { name: 'payment_method', id: 'credit_card', value: 'adyen',
	                                            ref: 'credit-card', onChange: this.onPaymentChange,
	                                            className: 'css-checkbox', 'data-do': 'show-payment-description',
	                                            'data-on': 'click', type: 'radio',
	                                            checked: this.state.payment_type === "adyen",
	                                            disabled: this.state.promo_free_shipping
	                                        }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { htmlFor: 'credit_card', className: 'css-label' },
	                                            'Credit, Debit or Prepaid Card ',
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement('span', { className: 'icon icon-visa' }),
	                                            _react2.default.createElement('span', { className: 'icon icon-master' }),
	                                            _react2.default.createElement('span', { className: 'icon icon-jcb' }),
	                                            _react2.default.createElement('span', { className: 'icon icon-amex' }),
	                                            _react2.default.createElement('span', { className: 'icon icon-union' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: this.state.payment_type === "adyen" && !this.state.promo_free_shipping ? "payment-desc" : "hide" },
	                                            'You may pay using your Visa or MasterCard. Select Credit, Debit or Prepaid Card as your mode of payment. You will be asked to provide information. Fill in the necessary details and click "Submit." Provide your credit, debit or prepaid card information and proceed to check out.'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'paypal radio' },
	                                        _react2.default.createElement('input', { name: 'payment_method', id: 'paypal', value: 'paypal', ref: 'paypal',
	                                            onChange: this.onPaymentChange, className: 'css-checkbox',
	                                            'data-do': 'show-payment-description', 'data-on': 'click', type: 'radio',
	                                            checked: this.state.payment_type === "paypal",
	                                            disabled: this.state.promo_free_shipping
	                                        }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { htmlFor: 'paypal', className: 'css-label' },
	                                            'PayPal ',
	                                            _react2.default.createElement('span', { className: 'icon icon-paypal' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: this.state.payment_type === "paypal" && !this.state.promo_free_shipping ? "payment-desc" : "hide" },
	                                            'Create or Sign-in to your Paypal account and choose between two easy payment options: ',
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'a) Pay with my Credit or Debit Card'
	                                            ),
	                                            _react2.default.createElement('br', null),
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'b) Pay with my Paypal Account'
	                                            )
	                                        )
	                                    ),
	                                    this.state.promo_free_shipping ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'radio freeshipping' },
	                                        _react2.default.createElement('input', { name: 'payment_method', id: 'freeshipping', value: 'free_shipping',
	                                            onChange: this.onPaymentChange,
	                                            className: 'css-checkbox', 'data-do': 'show-payment-description',
	                                            'data-on': 'click', type: 'radio', checked: true }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { htmlFor: 'free_shipping', className: 'css-label' },
	                                            'Free Shipping'
	                                        )
	                                    ) : null
	                                ),
	                                _react2.default.createElement(_CloudFlareBadge2.default, { type: 'e' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'step-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'address-wrapper' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        '2. Select your shipping address'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { style: { 'margin': '-18px 0px 20px 0' } },
	                                        this.props.settings && this.props.settings.globalSettings && _react2.default.createElement(
	                                            'div',
	                                            { style: { margin: '10px 0px' } },
	                                            _react2.default.createElement(_OutBoundBanner2.default, { outBoundBannerData: outboundBanner })
	                                        )
	                                    ),
	                                    this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.hasOwnProperty("air") && this.props.customerCheckout.checkout.data.hasOwnProperty("sea") && _react2.default.createElement(
	                                        'div',
	                                        { className: 'checkbox' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'same-address' },
	                                            _react2.default.createElement('input', { id: 'same-address',
	                                                onClick: this.handleSameAddress,
	                                                type: 'checkbox',
	                                                ref: 'terms',
	                                                className: 'accept-terms',
	                                                checked: this.state.sameAddress
	                                            }),
	                                            _react2.default.createElement(
	                                                'label',
	                                                { htmlFor: 'same-address' },
	                                                'Use the same shipping address for Air and Sea cargo.'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'air-cargo' },
	                                        this.props.customerCheckout.fetched && this.props.login.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty("air") ? _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            'Air Cargo',
	                                            _react2.default.createElement(
	                                                'p',
	                                                { className: 'estimated' },
	                                                'Estimated Delivery Date: \xA0',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    {
	                                                        className: 'from' },
	                                                    this.props.customerCheckout.checkout.data.delivery.air
	                                                )
	                                            )
	                                        ) : null : null,
	                                        this.renderAirAddresses(),
	                                        this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty('air') ? _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'p',
	                                                { className: 'text-center' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    'or'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'address-and-note' },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { onClick: function onClick(e) {
	                                                            _this14.handleCountries(e, 'air');
	                                                        },
	                                                        className: 'add-address btn btn-grey-gradient',
	                                                        'data-type': 'air-cargo' },
	                                                    '+ Add New Shipping Address'
	                                                ),
	                                                this.state.note_air === "" ? _react2.default.createElement(
	                                                    'a',
	                                                    { onClick: this.handleAir, className: 'add-note' },
	                                                    'Add a note for Air Cargo'
	                                                ) : null,
	                                                this.state.note_air !== "" ? _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'note-air-wrap note-wrapper clearfix' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'alert alert-warning' },
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { className: 'remove-air-note close',
	                                                                onClick: this.handleRemoveNoteAir },
	                                                            '\xD7'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'strong',
	                                                                null,
	                                                                'Note:'
	                                                            ),
	                                                            ' ',
	                                                            this.state.note_air
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'a',
	                                                                { className: 'edit-note',
	                                                                    onClick: this.handleOpenNoteAir },
	                                                                'Edit'
	                                                            )
	                                                        )
	                                                    )
	                                                ) : null
	                                            )
	                                        ) : null : null
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'sea-cargo' },
	                                        this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty("sea") ? _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            'Sea Cargo',
	                                            _react2.default.createElement(
	                                                'p',
	                                                { className: 'estimated' },
	                                                'Estimated Delivery Date: \xA0',
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    {
	                                                        className: 'from' },
	                                                    this.props.customerCheckout.checkout.data.delivery.sea
	                                                )
	                                            )
	                                        ) : null : null,
	                                        this.renderSeaAddresses(),
	                                        this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty('sea') ? _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'p',
	                                                { className: 'text-center' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    'or'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'address-and-note' },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { onClick: function onClick(e) {
	                                                            if (_this14.state.sameAddress) return;
	                                                            _this14.handleCountries(e, 'sea');
	                                                        },
	                                                        className: 'add-address btn btn-grey-gradient',
	                                                        'data-type': 'sea-cargo', disabled: this.state.sameAddress },
	                                                    '+ Add New Shipping Address'
	                                                ),
	                                                this.state.note_sea === "" ? _react2.default.createElement(
	                                                    'a',
	                                                    { onClick: this.handleSea, className: 'add-note',
	                                                        'data-do': 'add-note', 'data-on': 'click', 'data-method': 'sea' },
	                                                    'Add a note for Sea Cargo'
	                                                ) : null,
	                                                this.state.note_sea !== "" ? _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'note-air-wrap note-wrapper clearfix' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'alert alert-warning' },
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { className: 'remove-air-note close',
	                                                                onClick: this.handleRemoveNoteSea },
	                                                            '\xD7'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'p',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'strong',
	                                                                null,
	                                                                'Note:'
	                                                            ),
	                                                            ' ',
	                                                            this.state.note_sea
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'a',
	                                                                { className: 'edit-note',
	                                                                    onClick: this.handleOpenNoteSea },
	                                                                'Edit'
	                                                            )
	                                                        )
	                                                    )
	                                                ) : null
	                                            )
	                                        ) : null : null
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'step-3' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'yellowbgch', style: { backgroundColor: '#FEF6E7' } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'head' },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            { className: 'pull-left' },
	                                            '3. Review before paying'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'details clearfix' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            this.props.customerCheckout.fetched && _react2.default.createElement(_CheckoutBreakdown2.default, { data: this.props.customerCheckout.checkout.data, handleSwitchToggle: this.handleSwitchToggle, isSCProtectActive: this.state.isSCProtectActive, minChargableWeight: minChargableWeight }),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: this.props.login.fetched ? this.props.login.login.party.vip_settings.free_insurance === "1" && this.props.login.login.party.vip_settings.free_shipping_fee === "1" && this.props.login.login.party.vip_settings.free_storage_charge === "1" && this.props.login.login.party.vip_settings.free_tax === "1" ? "disnone" : "apply-discount" : null },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { style: { display: 'inline-flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' } },
	                                                        !(this.state.promo_submitted && this.props.customerCheckout.checkout.hasOwnProperty('data') && this.state.promo_success && Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0) && _react2.default.createElement('input', { type: 'text',
	                                                            value: this.state.promo_submitted ? this.state.inputtedPromoCode : null,
	                                                            style: { width: '75%', height: 46, fontSize: 14 },
	                                                            onChange: this.inputChange,
	                                                            className: this.state.promo_submitted && this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ? Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 ? "promo-applied" : "promo-code" : "promo-code",
	                                                            name: 'promo',
	                                                            placeholder: 'Enter promo code',
	                                                            disabled: this.state.promo_submitted && this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ? Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 ? "disabled" : "" : null,
	                                                            'data-on': 'keypress', defaultValue: '', ref: 'promo_code' }),
	                                                        this.state.promo_submitted ? this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ? Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 ? null : _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'button',
	                                                                className: 'promo-button',
	                                                                'data-do': 'get-promo-code', 'data-on': 'click',
	                                                                style: { marginLeft: 15, background: 'none' },
	                                                                onClick: this.handlePromo },
	                                                            'Apply'
	                                                        ) : _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'button',
	                                                                className: 'promo-button',
	                                                                'data-do': 'get-promo-code',
	                                                                'data-on': 'click',
	                                                                onClick: this.handlePromo },
	                                                            'Apply'
	                                                        ) : _react2.default.createElement(
	                                                            'button',
	                                                            { type: 'button', className: 'promo-button',
	                                                                'data-do': 'get-promo-code', 'data-on': 'click',
	                                                                onClick: this.handlePromo },
	                                                            'Apply'
	                                                        )
	                                                    ),
	                                                    this.state.promo_submitted && this.state.payment_type ? !this.state.withoutAddress && this.props.customerCheckout.fetching_computed ? null : !this.state.promo_success && this.props.customerCheckout.error ? _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'error-text', 'data-error': 'promo' },
	                                                        this.props.customerCheckout.error.response && this.props.customerCheckout.error.response.data.errors.detail.includes('invalid') ? this.props.customerCheckout.error.response.data.errors.detail : this.props.customerCheckout.error.response.data.errors.detail.includes('Account is not allowed') ? "You're not authorized to use this code." : this.props.customerCheckout.error.response.data.errors.detail
	                                                    ) : null : null,
	                                                    this.state.promo_submitted && this.state.payment_type ? !this.state.withoutAddress && this.props.customerCheckout.fetching_computed ? null : !this.state.promo_success && !this.props.customerCheckout.error ? _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'error-text', 'data-error': 'promo' },
	                                                        this.props.customerCheckout.error.response.data.errors.detail
	                                                    ) : null : null,
	                                                    this.state.promo_submitted && this.state.withoutAddress && !this.state.payment_type ? _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'error-text', 'data-error': 'promo' },
	                                                        'Please select a payment type first.'
	                                                    ) : null,
	                                                    this.state.promo_submitted && this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ? Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 ? null : _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'error-text',
	                                                            'data-error': 'promo' },
	                                                        this.props.customerCheckout.checkout.data.discount_message
	                                                    ) : null
	                                                ),
	                                                this.state.promo_submitted && this.props.customerCheckout.checkout.hasOwnProperty('data') && this.state.promo_success && Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'discount-fee text-center' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'flex-container' },
	                                                            _react2.default.createElement(
	                                                                'p',
	                                                                { className: 'font-16', style: { color: '#707070' } },
	                                                                'Discount Code'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'p',
	                                                                { className: 'font-16' },
	                                                                this.state.promo_code
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'flex-container' },
	                                                            _react2.default.createElement(
	                                                                'p',
	                                                                { className: 'font-16', style: { color: '#707070' } },
	                                                                this.props.customerCheckout.checkout.data.summary.usd.discount.label + ' Discount'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'p',
	                                                                { className: 'font-16' },
	                                                                '- USD ' + (0, _utils.numbersWithComma)(Number(this.props.customerCheckout.checkout.data.summary.usd.total_discount).toFixed(2))
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'flex-container', style: { justifyContent: 'flex-end' } },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'a',
	                                                                    {
	                                                                        onClick: this.handleRemovePromo, style: { fontSize: 16, fontWeight: 600 } },
	                                                                    'Remove'
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            this.props.settings && this.props.settings.notes && !!this.props.settings.notes.length && _react2.default.createElement(
	                                                'div',
	                                                { className: 'important-notes', style: { padding: '20px', border: '1px solid #0375D9', backgroundColor: '#FFF', margin: '10px 0px', borderRadius: '10px' } },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { style: { fontSize: '16px', fontWeight: 600, marginBottom: '10px' } },
	                                                    _react2.default.createElement('span', { className: 'fa fa-info-circle', style: { color: '#0375D9', fontSize: 16, marginRight: '5px' } }),
	                                                    'Important Note:'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'ul',
	                                                    null,
	                                                    this.props.settings && this.props.settings.notes && this.props.settings.notes.map(function (note) {
	                                                        return _react2.default.createElement('li', { style: { listStyle: 'disc', marginLeft: '20px' }, dangerouslySetInnerHTML: { __html: note } });
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'terms-condition' },
	                                                _react2.default.createElement(
	                                                    'label',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'checkbox' },
	                                                        _react2.default.createElement('input', { id: 'accept-terms',
	                                                            onClick: this.handleTerms,
	                                                            type: 'checkbox',
	                                                            ref: 'terms',
	                                                            className: 'accept-terms',
	                                                            disabled: this.isTermsDisabled() }),
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { htmlFor: 'accept-terms' },
	                                                            JSON.parse(localStorage.shipment_location_details).destination !== 'MY' ? _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                'Ticking this box means I agree & accept the updated ShippingCart ',
	                                                                _react2.default.createElement(
	                                                                    'a',
	                                                                    { onClick: this.showTerms, className: 'terms', style: { fontSize: '13px', textDecoration: 'none' }, target: '_blank' },
	                                                                    'Terms and Conditions'
	                                                                ),
	                                                                ' together with the SC protect coverage.'
	                                                            ) : _react2.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                'Ticking this box and paying for my shipment means I have read, understand, and agree to ShippingCart\'s updated',
	                                                                _react2.default.createElement(
	                                                                    'a',
	                                                                    { onClick: this.showTerms, className: 'terms', target: '_blank' },
	                                                                    'Terms and Conditions'
	                                                                ),
	                                                                '.'
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            this.props.customerCheckout.fetched && _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { style: { display: 'flex', justifyContent: 'space-between', fontSize: '20px', fontWeight: 600, color: '#323232', margin: '20px 0px' } },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        'Shipment Cost'
	                                                    ),
	                                                    'USD ',
	                                                    this.props.customerCheckout.checkout.data && (0, _utils.numbersWithComma)(this.props.customerCheckout.checkout.data.summary.usd.total_price.toFixed(2))
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('input', { type: 'hidden', name: 'csrf', value: '95d7f5f947530b4bd45dc37044bdfd94' }),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'pay-ship text-center', style: { margin: '25px 0px' } },
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    className: this.state.terms ? "proceedToCheckoutButton btn-disabled" : "proceedToCheckoutButton",
	                                                    style: { padding: '5px', borderRadius: '100px', fontSize: '16px', fontWeight: 600 },
	                                                    type: 'submit',
	                                                    disabled: this.state.terms ? "disabled" : "" },
	                                                'PAY AND SHIP'
	                                            ),
	                                            _react2.default.createElement(
	                                                'i',
	                                                { className: 'payment-gateway-disclaimer', style: { fontSize: '10px' } },
	                                                'Note: You will be redirected to our payment gateway after clicking Pay & Ship.'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'back-link bottom' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/cart' },
	                                ' <  Back to Cart'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'bottom-shadow' }),
	                    localStorage.checkoutModalShowed ? null : this.state.checkoutModalContent ? _react2.default.createElement(_AdvisoryModal2.default, { show: this.props.cms.showAdvisoryModal['checkout'],
	                        close: function close(dispatch) {
	                            return _this14.props.closeModal('checkout');
	                        },
	                        content: this.checkoutModal()
	                    }) : null
	                )
	            ),
	            _react2.default.createElement(_Footer2.default, {
	                currentPath: this.props.location.pathname,
	                currentYear: this.props.login.year
	            })
	        );
	    }
	});
	exports.default = Checkout;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SignupSuccess = __webpack_require__(254);
	
	var _SignupSuccess2 = _interopRequireDefault(_SignupSuccess);
	
	var _Checkout = __webpack_require__(247);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _ChangePassword = __webpack_require__(245);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _ResetPassword = __webpack_require__(253);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _TrackPackage = __webpack_require__(255);
	
	var _TrackPackage2 = _interopRequireDefault(_TrackPackage);
	
	var _CheckOutSuccess = __webpack_require__(246);
	
	var _CheckOutSuccess2 = _interopRequireDefault(_CheckOutSuccess);
	
	var _AdyenPayment = __webpack_require__(243);
	
	var _AdyenPayment2 = _interopRequireDefault(_AdyenPayment);
	
	var _store = __webpack_require__(20);
	
	var _MobileHeader = __webpack_require__(122);
	
	var _MobileHeader2 = _interopRequireDefault(_MobileHeader);
	
	var _DefaultDashboardBody = __webpack_require__(598);
	
	var _DefaultDashboardBody2 = _interopRequireDefault(_DefaultDashboardBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var Dashboard = createReactClass({
	  displayName: 'Dashboard',
	  componentWillMount: function componentWillMount() {
	    this.props.getCMSList();
	    var token = localStorage.jwtToken;
	    //this.props.signedIn(token);
	    // this.props.getParcel(token);
	    this.props.getWarehouse();
	    this.props.getProhibitedParcel(token);
	    this.props.getCopyrightYear();
	    this.props.getCartData();
	
	    if (!localStorage.jwtToken && this.props.location.pathname !== "/reset-password" && this.props.location.pathname !== "/change-password" && this.props.location.pathname !== "/track-package") {
	      _store.history.push("/signin");
	    }
	    this.props.getGeneralSettings(token);
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      tooltipText: {
	        "name": false,
	        "address": false,
	        "city": false,
	        "state": false,
	        "zip": false,
	        "tel": false
	      },
	      cmsList: [],
	      footerLinks: ["2", "3", "4", "7"],
	      bottomNavLinks: ["1", "5", "6"],
	      bottomNavLinksClass: ["first about pull-left", "second terms pull-left", "third privacy pull-left"]
	    };
	  },
	  handleLogout: function handleLogout() {
	    localStorage.removeItem('jwtToken');
	    this.props.resetSignUp();
	    this.props.logout();
	  },
	  handleMouseEnter: function handleMouseEnter(e) {
	    var targ = e.target || e.srcElement;
	    if (targ.tagName === "TD") {
	      var str = this.state.tooltipText;
	      str[targ.getAttribute('data-name')] = false;
	      this.setState({
	        tooltipText: str
	      });
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      cmsList: nextProps.cms.getCmsList ? nextProps.cms.CmsList.data : []
	    });
	
	    if (!localStorage.jwtToken && !nextProps.location.pathname === "/reset-password" && !nextProps.location.pathname === "/change-password" && !nextProps.location.pathname === "/track-package") {
	      _store.history.push("/signin");
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (localStorage.trackPackage2) {
	      localStorage.removeItem("trackPackage2");
	    }
	  },
	  renderDashboardBody: function renderDashboardBody() {
	    var body = null;
	    switch (this.props.location.pathname.toLowerCase()) {
	      case "/reset-password":
	        body = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ResetPassword2.default, this.props)
	        );
	        break;
	      case "/change-password":
	        body = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ChangePassword2.default, this.props)
	        );
	        break;
	      case "/signup-success":
	        body = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_SignupSuccess2.default, this.props)
	        );
	        break;
	      case "/checkout-success":
	        body = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_CheckOutSuccess2.default, this.props)
	        );
	        break;
	      case "/checkout":
	        body = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Checkout2.default, this.props)
	        );
	        break;
	      case "/track-package":
	        body = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_TrackPackage2.default, this.props)
	        );
	        break;
	      case "/adyen-payment":
	        body = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_AdyenPayment2.default, this.props)
	        );
	        break;
	      default:
	        body = _react2.default.createElement(_DefaultDashboardBody2.default, this.props);
	    }
	
	    return body;
	  },
	  render: function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_MobileHeader2.default, {
	        isAuthenticated: true,
	        login: this.props.login,
	        isSideNavOpen: false,
	        logout: this.handleLogout
	      }),
	      this.renderDashboardBody()
	    );
	  }
	});
	
	exports.default = Dashboard;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(825);
	
	var _store = __webpack_require__(20);
	
	var _warehouseFlags = __webpack_require__(73);
	
	var _constants = __webpack_require__(599);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { Link } from 'react-router';
	
	var DashboardAddress = function (_Component) {
	  _inherits(DashboardAddress, _Component);
	
	  function DashboardAddress() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DashboardAddress);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashboardAddress.__proto__ || Object.getPrototypeOf(DashboardAddress)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tooltipText: {
	        "name": false,
	        "address": false,
	        "city": false,
	        "state": false,
	        "zip": false,
	        "tel": false
	      },
	      isKRAddressActive: false,
	      isJPAddressActive: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DashboardAddress, [{
	    key: 'copyClipboard',
	    value: function copyClipboard(event, copiedText) {
	      var _this2 = this;
	
	      var textArea = document.createElement("input");
	      textArea.value = copiedText;
	      document.body.appendChild(textArea);
	      textArea.select();
	
	      try {
	        document.execCommand("copy"); // run command to copy selected text to clipboard
	        var str = this.state.tooltipText;
	        Object.keys(str).map(function (key) {
	          return str[key] = false;
	        });
	        str[event.target.getAttribute('data-name')] = true;
	        this.setState({ tooltipText: str });
	
	        setTimeout(function () {
	          Object.keys(str).map(function (key) {
	            return str[key] = false;
	          });
	          _this2.setState({ tooltipText: str });
	        }, 2500);
	      } catch (e) {
	        return false;
	      }
	      textArea.remove();
	    }
	  }, {
	    key: 'renderStateLabel',
	    value: function renderStateLabel(countryCode) {
	      var stateLabel = {
	        KR: 'DISTRICT',
	        UK: 'COUNTY',
	        JP: 'CITY:',
	        default: 'STATE'
	      };
	
	      return stateLabel[countryCode] || stateLabel.default;
	    }
	  }, {
	    key: 'renderWarehouseLabel',
	    value: function renderWarehouseLabel(countryCode, name) {
	      var labels = {
	        US: 'United States',
	        UK: 'United Kingdom',
	        AU: 'Australia',
	        KR: 'South Korea',
	        JP: 'Japan',
	        default: name || 'Warehouse'
	      };
	      return labels[countryCode] || labels.default;
	    }
	  }, {
	    key: 'renderTranslatedAddress',
	    value: function renderTranslatedAddress(countryCode, type) {
	      var translatedAddresses = {
	        KR: _constants.krAddress,
	        JP: _constants.jpAddress
	      };
	      return translatedAddresses[countryCode][type];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var customer_data = this.props.address.country_code !== 'JP' ? {
	        name: this.props.first_name + ' ' + this.props.last_name,
	        line1: this.props.address.address_1 + ' ' + this.props.address.address_2 + '\n\n        Account No. ' + this.props.account_number,
	        city: this.props.address.city,
	        state: this.props.address.state,
	        zip: this.props.address.postal_code,
	        tel: this.props.address.phone_number
	      } : {
	        name: this.props.first_name + ' ' + this.props.last_name,
	        line1: 'Account No. ' + this.props.account_number,
	        line2: this.props.address.address_2,
	        city: this.props.address.state,
	        state: this.props.address.city,
	        zip: this.props.address.postal_code,
	        tel: this.props.address.phone_number
	      };
	      var trimmedAddressStyle = {
	        width: '100%',
	        whiteSpace: 'break-spaces',
	        fontSize: '14px'
	        // overflow: 'hidden',
	        // textOverflow: 'ellipsis',
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'address-box', style: { "marginBottom": "20px" } },
	        _react2.default.createElement(
	          'h4',
	          { className: 'sidebar-header' },
	          _react2.default.createElement('img', { src: (0, _warehouseFlags.renderFlagIconRound)(this.props.address.country_code), alt: 'flags', className: 'flag' }),
	          this.renderWarehouseLabel(this.props.address.country_code)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'address-table' },
	          (this.props.address.country_code === 'KR' || this.props.address.country_code === 'JP') && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              style: {
	                fontSize: '14px',
	                color: '#1f6fe7',
	                background: 'none',
	                border: 'none',
	                margin: '10px 0',
	                width: '100%',
	                textAlign: 'left',
	                marginTop: 0
	              },
	              onClick: function onClick() {
	                _this3.setState({ isKRAddressActive: !_this3.state.isKRAddressActive });
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('img', {
	                src: 'https://cdn.shippingcart.com/assets/translate-icon-20210920091856.png',
	                alt: 'icon',
	                height: '18',
	                style: { marginRight: '5px' }
	              })
	            ),
	            'Translate'
	          ),
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'field' },
	                  'NAME:'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'data-name': 'name', className: 'value tooltip2' },
	                  customer_data.name,
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext', onClick: function onClick(event) {
	                          return _this3.copyClipboard(event, customer_data.name);
	                        }, 'data-name': 'name' },
	                      this.state.tooltipText.name ? "Copied" : "Copy to clipboard"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'field' },
	                  'ADDRESS LINE 1:'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'data-name': 'address', className: 'value tooltip2' },
	                  this.state.isKRAddressActive || this.state.isJPAddressActive ? _react2.default.createElement(
	                    'p',
	                    { style: this.props.unTrimmedAddress ? { fontSize: '14px' } : trimmedAddressStyle },
	                    this.renderTranslatedAddress(this.props.address.country_code, 'addressLine1'),
	                    ' ',
	                    _react2.default.createElement('br', null),
	                    'Account No. ',
	                    this.props.account_number
	                  ) : _react2.default.createElement(
	                    'p',
	                    { style: this.props.unTrimmedAddress ? { fontSize: '14px', marginBottom: 0 } : trimmedAddressStyle },
	                    this.props.address.country_code !== 'JP' && this.props.address.address_1 + ',',
	                    ' ',
	                    this.props.address.country_code === 'KR' && this.props.address.address_2,
	                    'Account No. ',
	                    this.props.account_number
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext', onClick: function onClick(event) {
	                          if (_this3.state.isKRAddressActive || _this3.state.isJPAddressActive) {
	                            _this3.copyClipboard(event, ' ' + _this3.renderTranslatedAddress(_this3.props.address.country_code, 'addressLine1') + ' \n\n                    Account No. ' + _this3.props.account_number);
	                            return;
	                          }
	                          _this3.copyClipboard(event, customer_data.line1);
	                        }, 'data-name': 'address' },
	                      this.state.tooltipText.address ? "Copied" : "Copy to clipboard"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'field' },
	                  this.props.address.country_code === 'JP' ? 'PREFECTURE:' : 'CITY:'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'data-name': 'city', className: 'value tooltip2' },
	                  this.state.isKRAddressActive || this.state.isJPAddressActive ? this.renderTranslatedAddress(this.props.address.country_code, 'city') : customer_data.city,
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext', onClick: function onClick(event) {
	                          if (_this3.state.isKRAddressActive || _this3.state.isJPAddressActive) {
	                            _this3.copyClipboard(event, _this3.renderTranslatedAddress(_this3.props.address.country_code, 'city'));
	                            return;
	                          }
	                          _this3.copyClipboard(event, customer_data.city);
	                        }, 'data-name': 'city' },
	                      this.state.tooltipText.city ? "Copied" : "Copy to clipboard"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'field' },
	                  this.renderStateLabel(this.props.address.country_code)
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'data-name': 'state', className: 'value tooltip2' },
	                  this.state.isKRAddressActive || this.state.isJPAddressActive ? this.renderTranslatedAddress(this.props.address.country_code, 'state') : customer_data.state,
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext', onClick: function onClick(event) {
	                          if (_this3.state.isKRAddressActive || _this3.state.isJPAddressActive) {
	                            _this3.copyClipboard(event, _this3.renderTranslatedAddress(_this3.props.address.country_code, 'state'));
	                            return;
	                          }
	                          _this3.copyClipboard(event, customer_data.state);
	                        }, 'data-name': 'state' },
	                      this.state.tooltipText.state ? "Copied" : "Copy to clipboard"
	                    )
	                  )
	                )
	              ),
	              this.props.address.country_code === 'JP' && _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'field' },
	                  'CHOME:'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'data-name': 'city', className: 'value tooltip2' },
	                  this.state.isKRAddressActive ? this.renderTranslatedAddress(this.props.address.country_code, 'chome') : customer_data.line2,
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext', onClick: function onClick(event) {
	                          if (_this3.state.isKRAddressActive) {
	                            _this3.copyClipboard(event, _this3.renderTranslatedAddress(_this3.props.address.country_code, 'chome'));
	                            return;
	                          }
	                          _this3.copyClipboard(event, customer_data.line2);
	                        }, 'data-name': 'city' },
	                      this.state.tooltipText.city ? "Copied" : "Copy to clipboard"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'field' },
	                  this.props.address.country_code === 'UK' ? 'POSTCODE' : 'ZIP',
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'data-name': 'zip', className: 'value tooltip2' },
	                  customer_data.zip,
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext', onClick: function onClick(event) {
	                          return _this3.copyClipboard(event, customer_data.zip);
	                        }, 'data-name': 'zip' },
	                      this.state.tooltipText.zip ? "Copied" : "Copy to clipboard"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                { className: 'last' },
	                _react2.default.createElement(
	                  'td',
	                  { className: 'field' },
	                  'TEL #:'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'data-name': 'tel', className: 'value tooltip2' },
	                  customer_data.tel,
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext', onClick: function onClick(event) {
	                          return _this3.copyClipboard(event, customer_data.tel);
	                        }, 'data-name': 'tel' },
	                      this.state.tooltipText.tel ? "Copied" : "Copy to clipboard"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        this.props.address.country_code === 'JP' && this.props.unTrimmedAddress && _react2.default.createElement(
	          'div',
	          { style: { border: '1px solid #E2E2E2', borderRadius: '5px', display: 'flex', backgroundColor: '#E5F1FB', padding: '10px', flexDirection: 'column' } },
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '10px', fontSize: '16px', fontWeight: 600, display: 'flex' } },
	            _react2.default.createElement('img', {
	              src: 'https://cdn.shippingcart.com/assets/information_(2)-20230306045336.svg',
	              alt: 'icon',
	              height: '22',
	              style: { marginRight: '5px' }
	            }),
	            'Did you know?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: '14px', color: '#707070' } },
	            'Some websites may ask for your full name in Katakana or Hiragana.'
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer', marginTop: '5px' }, onClick: function onClick() {
	                return _store.history.push('/warehouse-address-guide-jp');
	              } },
	            'Here\u2019s how.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DashboardAddress;
	}(_react.Component);
	
	exports.default = DashboardAddress;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
	var seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';
	
	var ComputationBreakdown = function (_Component) {
	  _inherits(ComputationBreakdown, _Component);
	
	  function ComputationBreakdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ComputationBreakdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ComputationBreakdown.__proto__ || Object.getPrototypeOf(ComputationBreakdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleIcon = function (type) {
	      return type === 'air' ? airIcon : seaIcon;
	    }, _this.renderBreakdown = function () {
	      if (_this.props.data[_this.props.type].usd && _this.props.data[_this.props.type].usd.single_parcel_fixed_rate) {
	        return _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px' } },
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 600, color: '#323232', textTransform: 'capitalize' } },
	            'Fixed Air Cargo Fee'
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 600, color: '#323232' } },
	            'USD ' + (_this.props.data[_this.props.type].usd.total_cargo || 0.00)
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '20px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '13px', fontWeight: 600, color: '#636363' } },
	              'Chargeable weight'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _this.props.data[_this.props.type].usd.total_chargeable_weight,
	              ' lbs'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '13px', fontWeight: 600, color: '#636363', textTransform: 'capitalize' } },
	              _this.props.type,
	              ' Cargo rate'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { marginRight: '5px' } },
	                'X'
	              ),
	              ' ',
	              'USD ' + (_this.props.data[_this.props.type].usd.per_pound_value || 0.00)
	            )
	          ),
	          _this.props.data[_this.props.type] && _this.props.data[_this.props.type].usd.is_sea_higher_rate && _react2.default.createElement(
	            'div',
	            { style: { fontSize: '10px', fontStyle: 'italic' } },
	            'Higher rates apply if any side of a package is over ',
	            _this.props.minChargableWeight && _this.props.minChargableWeight.sea_max_dimension.value,
	            ' inches.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'right', fontSize: '13px', fontWeight: 600, color: '#323232' } },
	            'USD ' + (_this.props.data[_this.props.type].usd.total_chargeable_amount || 0.00)
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '13px', fontWeight: 600, color: '#636363' } },
	              'Fixed handling fee'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { marginRight: '5px' } },
	                '+'
	              ),
	              'USD ' + ((0, _utils.numbersWithComma)(_this.props.data[_this.props.type].usd.total_fixed_rate && _this.props.data[_this.props.type].usd.total_fixed_rate.toFixed(2)) || 0.00)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px' } },
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 600, color: '#323232', textTransform: 'capitalize' } },
	            'Total ',
	            _this.props.type,
	            ' Cargo Fee'
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '13px', fontWeight: 600, color: '#323232' } },
	            'USD ' + (_this.props.data[_this.props.type].usd.total_cargo || 0.00)
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ComputationBreakdown, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.data.hasOwnProperty('air') && this.props.data.hasOwnProperty('sea') && this.props.type === 'sea' && _react2.default.createElement('div', { style: { border: '1px solid #E2E2E2', width: '100%' } }),
	        _react2.default.createElement(
	          'div',
	          { style: { padding: '20px 16px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', flexDirection: 'row' } },
	              _react2.default.createElement('img', { src: this.handleIcon(this.props.type), alt: 'air', width: 24 }),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexDirection: 'column', marginLeft: '5px' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', color: '#323232', fontWeight: 600, textTransform: 'capitalize' } },
	                  this.props.type,
	                  ' Cargo'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '10px', color: '#707070' } },
	                  'Est. delivery: ',
	                  this.props.data.delivery[this.props.type]
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: '16px', color: '#0375D9', fontWeight: 600, alignSelf: 'center' } },
	              this.props.data[this.props.type].total_qty || 0,
	              ' item/s'
	            )
	          ),
	          this.renderBreakdown()
	        )
	      );
	    }
	  }]);
	
	  return ComputationBreakdown;
	}(_react.Component);
	
	exports.default = ComputationBreakdown;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _Signin = __webpack_require__(50);
	
	__webpack_require__(134);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RequiredModal = function (_Component) {
	  _inherits(RequiredModal, _Component);
	
	  function RequiredModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RequiredModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RequiredModal.__proto__ || Object.getPrototypeOf(RequiredModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      countryPrefix: "",
	      email: "",
	      phone_number: "",
	      errors: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RequiredModal, [{
	    key: 'handleInputChange',
	    value: function handleInputChange(e) {
	      var value = e.target.value;
	      var name = e.target.name;
	
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'handleEnable',
	    value: function handleEnable() {
	      if (this.state.email && this.state.phone_number && this.state.phone_number.length >= 7) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var email = !this.props.email || this.props.email === this.props.fb_id + '@gmail.com' ? "" : this.props.email;
	      var phone_number = this.props.phone_number && (0, _utils.prefixNumber)(this.props.phone_number.slice(0, 3)) ? this.props.phone_number.slice(3) : this.props.phone_number;
	      var countryPrefix = this.props.phone_number && (0, _utils.prefixNumber)(this.props.phone_number.slice(0, 3)) ? this.props.phone_number.slice(0, 3) : "";
	
	      this.setState({ email: email, phone_number: phone_number, countryPrefix: countryPrefix }, function () {
	        _this2.setState({
	          phone_number: _this2.state.phone_number && _this2.state.phone_number.length > 10 ? '' : _this2.state.phone_number
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.error ? nextProps.error.map(function (errors) {
	        return errors;
	      }) : null;
	      var updatedErrorList = {};
	
	      if (errors) {
	        for (var i = 0; i < errors.length; i++) {
	          var errkey = errors[i].title;
	          updatedErrorList[errkey] = errors[i].detail;
	        }
	
	        this.setState({
	          errors: Object.assign({}, updatedErrorList)
	        });
	      }
	    }
	  }, {
	    key: 'saveProfile',
	    value: function saveProfile(e) {
	      e.preventDefault();
	      if (!this.state.countryPrefix) {
	        return this.setState({
	          errors: { phone_number: 'Please select country prefix' }
	        });
	      }
	      var first_name = this.props.first_name;
	      var last_name = this.props.last_name;
	      var email = this.state.email;
	      var phone_number = this.state.countryPrefix + this.state.phone_number;
	      var parameters = [];
	      if ((!this.props.phone_number || !(0, _utils.prefixNumber)(this.props.phone_number.slice(0, 3))) && (!this.props.email || this.props.email === this.props.fb_id + '@gmail.com')) {
	        // no email and number
	        parameters.push({ phone_number_update: true, email: email, first_name: first_name, last_name: last_name, phone_number: phone_number });
	      }
	      if ((!this.props.email || this.props.email === this.props.fb_id + '@gmail.com') && (this.props.phone_number || (0, _utils.prefixNumber)(this.props.phone_number.slice(0, 3)))) {
	        // no email only
	        parameters.push({ phone_number_update: false, email: email, first_name: first_name, last_name: last_name });
	      }
	      if ((!this.props.phone_number || !(0, _utils.prefixNumber)(this.props.phone_number.slice(0, 3))) && this.props.email && this.props.email !== this.props.fb_id + '@gmail.com') {
	        // no number only
	        parameters.push({ phone_number_update: true, first_name: first_name, last_name: last_name, phone_number: phone_number });
	      }
	
	      if (this.props.phone_number && !(0, _utils.prefixNumber)(this.props.phone_number.slice(0, 3)) || !this.props.phone_number) {
	        _store2.default.dispatch((0, _Signin.putReSendOTPRequired)(parameters));
	      } else {
	        _store2.default.dispatch((0, _Signin.addCustomerProfile)(parameters));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.props.show, autoFocus: true, dialogClassName: 'custom-modal' },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            null,
	            'Add Information'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'pull-right required-fields' },
	            'Field is required.'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            'form',
	            { className: 'form-horizontal' },
	            _react2.default.createElement(
	              'section',
	              { className: 'modal-body' },
	              !this.props.email || this.props.email === this.props.fb_id + '@gmail.com' ? _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Email Address '
	                ),
	                '\xA0',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'inline-error-message' },
	                  this.state.errors ? this.state.errors.email : null
	                ),
	                _react2.default.createElement('input', { type: 'email', onChange: function onChange(e) {
	                    return _this3.handleInputChange(e);
	                  }, name: 'email', value: this.state.email, autoComplete: 'off' })
	              ) : null,
	              !this.props.phone_number || !(0, _utils.prefixNumber)(this.props.phone_number.slice(0, 3)) ? _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Contact Number '
	                ),
	                '\xA0',
	                _react2.default.createElement(
	                  'label',
	                  { className: 'inline-error-message' },
	                  this.state.errors ? this.state.errors.phone_number : null
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: 'flex' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mobile-country' },
	                    _react2.default.createElement(
	                      'select',
	                      { value: this.state.countryPrefix, onChange: function onChange(e) {
	                          return _this3.handleInputChange(e);
	                        }, name: 'countryPrefix' },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Prefix'
	                      ),
	                      _utils.mapPrefixNumber.map(function (prefix) {
	                        return _react2.default.createElement(
	                          'option',
	                          { value: prefix.value },
	                          prefix.label
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text', style: { margin: '0 0px 0px 71px' }, value: this.state.phone_number, maxLength: '10', name: 'phone_number', onChange: function onChange(e) {
	                      return _this3.handleInputChange(e);
	                    }, autoComplete: 'off' })
	                )
	              ) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-footer' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', onClick: function onClick(e) {
	                    return _this3.saveProfile(e);
	                  }, className: 'btn btn-register btn-orange', disabled: this.handleEnable() },
	                'Save'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RequiredModal;
	}(_react.Component);
	
	exports.default = RequiredModal;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookLogin = function (_Component) {
	  _inherits(FacebookLogin, _Component);
	
	  function FacebookLogin(props) {
	    _classCallCheck(this, FacebookLogin);
	
	    var _this = _possibleConstructorReturn(this, (FacebookLogin.__proto__ || Object.getPrototypeOf(FacebookLogin)).call(this, props));
	
	    _this.checkLoginState = _this.checkLoginState.bind(_this);
	    _this.clickHandler = _this.clickHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(FacebookLogin, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'responseApi',
	    value: function responseApi(authResponse) {
	      var _this2 = this;
	
	      FB.api('/me', { fields: this.props.fields }, function (me) {
	        // eslint-disable-line no-undef
	        me.accessToken = authResponse.accessToken;
	        _this2.props.responseHandler(me);
	      });
	    }
	  }, {
	    key: 'checkLoginState',
	    value: function checkLoginState(response) {
	      if (response.authResponse) {
	        this.responseApi(response.authResponse);
	      } else {
	        if (this.props.responseHandler) {
	          this.props.responseHandler({ status: response.status });
	        }
	      }
	    }
	  }, {
	    key: 'clickHandler',
	    value: function clickHandler() {
	      FB.login(this.checkLoginState, { scope: this.props.scope }); // eslint-disable-line no-undef
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          socialId = _props.socialId,
	          xfbml = _props.xfbml,
	          cookie = _props.cookie,
	          version = _props.version,
	          language = _props.language,
	          fields = _props.fields,
	          responseHandler = _props.responseHandler,
	          children = _props.children,
	          buttonText = _props.buttonText,
	          props = _objectWithoutProperties(_props, ['socialId', 'xfbml', 'cookie', 'version', 'language', 'fields', 'responseHandler', 'children', 'buttonText']);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          Object.assign({}, props, { onClick: this.clickHandler, style: { display: 'flex', alignItems: 'center', gap: '4px' } }),
	          _react2.default.createElement('i', { className: 'fa fa-facebook' }),
	          children,
	          buttonText
	        )
	      );
	    }
	  }]);
	
	  return FacebookLogin;
	}(_react.Component);
	
	exports.default = FacebookLogin;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(837);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var ResetPassword = createReactClass({
	  displayName: 'ResetPassword',
	  getInitialState: function getInitialState() {
	    return {
	      error: false
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.props.getCopyrightYear();
	    (0, _jquery2.default)('#SCTitle').text("Forgot Password | ShippingCart");
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.resetAccounts();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    //this.props.login.fetched && this.props.login.errorResetPassword ?
	    //this.setState({ error: nextProps.login.errorResetPassword, });
	    if (nextProps.login.errorResetPassword) {
	      this.setState({ error: this.maskErrorMessage(nextProps.login.errorResetPassword.response.data.errors.detail) });
	    }
	  },
	  handleSubmit: function handleSubmit(e) {
	    e.preventDefault();
	    var email = this.refs.email.value;
	    this.props.resetPassword(email);
	  },
	  handleWidget: function handleWidget(e) {
	    e.preventDefault();
	    window.FreshWidget.show();
	  },
	  maskErrorMessage: function maskErrorMessage(error) {
	    if (error.includes("does not exist")) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        'The email you entered does not exist.'
	      );
	    } else if (error.includes("archived")) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        error,
	        ' To activate it, ',
	        _react2.default.createElement(
	          'a',
	          { onClick: this.handleWidget },
	          'contact'
	        ),
	        ' ShippingCart Customer Care.'
	      );
	    } else {
	      return error;
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'page-login header-minimal-head' },
	        _react2.default.createElement(
	          'header',
	          { className: 'site-header header-minimal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container reset-password' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logo' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/', className: 'clearfix' },
	                _react2.default.createElement('div', { className: 'main-img' })
	              )
	            ),
	            _react2.default.createElement(
	              'nav',
	              { className: 'top-nav' },
	              _react2.default.createElement('ul', null)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'reset-password body-wrapper' },
	        _react2.default.createElement(
	          'section',
	          { className: 'container forgot' },
	          _react2.default.createElement(
	            'div',
	            { className: 'forgot-form' },
	            _react2.default.createElement(
	              'form',
	              { method: 'POST' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-left' },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Reset your Password'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-right back' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/home' },
	                    ' < Back to home'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'instructions' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We will email you instructions on how to reset your password.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'If it\'s not in your Inbox, check your Spam folder.'
	                )
	              ),
	              this.state.error ? _react2.default.createElement(
	                'div',
	                { className: 'notify' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger' },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  this.state.error
	                )
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group ' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control-label' },
	                  'Email address'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('input', { type: 'email', className: 'form-control', name: 'forgot_email', ref: 'email', autoFocus: true, defaultValue: '', style: this.state.error ? { borderColor: 'red' } : null })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'login-btn' },
	                  _react2.default.createElement('input', { type: 'hidden', name: 'csrf', value: 'c9b69d4ac938792e99ee21422b3a2b5d' }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'submit', className: 'btn align-right btn-orange', onClick: this.handleSubmit },
	                    'Submit'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('section', { className: 'shadow' })
	      ),
	      _react2.default.createElement(_Footer2.default, { currentPath: this.props.location.pathname, currentYear: this.props.login.year })
	    );
	  }
	});
	
	exports.default = ResetPassword;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	__webpack_require__(844);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _DashboardAddress = __webpack_require__(249);
	
	var _DashboardAddress2 = _interopRequireDefault(_DashboardAddress);
	
	var _RequiredModal = __webpack_require__(251);
	
	var _RequiredModal2 = _interopRequireDefault(_RequiredModal);
	
	var _uuid = __webpack_require__(70);
	
	var _utils = __webpack_require__(13);
	
	var _whiteListed = __webpack_require__(93);
	
	var _warehouseCode = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var SignupSuccess = createReactClass({
	  displayName: 'SignupSuccess',
	
	  getInitialState: function getInitialState() {
	    return {
	      phone_number: '',
	      incompleteInfo: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    // <!-- Lightning Bolt Begins -->
	    var lbscript = document.createElement("script");
	    lbscript.type = "text/javascript";
	    lbscript.src = "/js/lightningbolt.js";
	    lbscript.async = true;
	    document.body.appendChild(lbscript);
	
	    var lbscript1 = document.createElement("script");
	    lbscript1.type = "text/javascript";
	    lbscript1.setAttribute('id', 'lightning_bolt');
	    lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
	    lbscript1.async = true;
	    document.body.appendChild(lbscript1);
	    // <!-- Lightning Bolt Ends -->
	
	    var grabKey = localStorage.getItem('grabKey');
	
	    // Append img tag with src coming from Grab
	    var firePixel = function firePixel(r) {
	      var img = document.createElement("img");
	      img.src = grabKey;
	      document.body.appendChild(img);
	    };
	
	    if (!!grabKey) {
	      firePixel();
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var token = localStorage.jwtToken;
	    this.props.signedIn(token);
	    localStorage.setItem("TourFinish", "false");
	    this.props.getCopyrightYear();
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->    
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var title = "Hello ";
	    title += this.props.login.fetched ? nextProps.login.login.party.first_name : "";
	    document.title = title;
	
	    if (nextProps.login.login.party) {
	      if (!nextProps.login.login.party.email || !nextProps.login.login.party.phone_number) {
	        this.setState({ incompleteInfo: true });
	      } else {
	        this.setState({ incompleteInfo: false });
	      }
	    }
	  },
	  handleLogout: function handleLogout() {
	    localStorage.removeItem('jwtToken');
	    this.props.logout();
	  },
	  handleTour: function handleTour() {
	    localStorage.setItem("Tour", "true");
	  },
	  handleSkip: function handleSkip() {
	    localStorage.setItem("Tour", "false");
	  },
	  render: function render() {
	    var _this = this;
	
	    // let warehouse = this.props.customerInfo.warehouse_fetched ? this.props.customerInfo.warehouse.data : null;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('iframe', { title: (0, _uuid.v4)(), src: 'https://9848754.fls.doubleclick.net/activityi;src=9848754;type=signu00;cat=signu0;qty=1;cost=1;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?', width: '1', height: '1', frameBorder: '0', style: { display: 'none' } }),
	      this.props.login.fetched ? _react2.default.createElement(
	        'div',
	        { id: 'shippingcart_app', className: 'header-minimal' },
	        _react2.default.createElement(
	          'nav',
	          { id: 'fullSidebarNav', className: 'sidenav' },
	          _react2.default.createElement(
	            'a',
	            { className: 'customer-name', 'data-do': 'hamburger', 'data-on': 'click', 'data-target': 'account' },
	            _react2.default.createElement(
	              'span',
	              { className: 'name-first' },
	              'Hello  ',
	              this.props.login.login.party.first_name
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/cart' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Cart'
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/shipment' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Shipments'
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/account' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Account'
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/shipping-estimate' },
	            'Get Shipping Estimate'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/track' },
	            'Track Your Package'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/logout' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Logout'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'header',
	          { className: 'site-header header-minimal sign-up-success' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logo' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/home', className: 'clearfix' },
	                _react2.default.createElement('div', { className: 'main-img' })
	              )
	            ),
	            _react2.default.createElement(
	              'nav',
	              { className: 'top-nav' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  { className: 'dropdown has-sub ' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'name-first' },
	                      'Hello ',
	                      this.props.login.login.party.first_name
	                    ),
	                    _react2.default.createElement('i', { className: 'fa fa-angle-down fa-fw' })
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dropdown-menu sub-account2 ' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/cart' },
	                        _react2.default.createElement('i', { className: 'fa fa-archive fa-fw' }),
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Cart'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/shipment' },
	                        _react2.default.createElement('i', { className: 'fa fa-location-arrow fa-fw' }),
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Shipments'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/account' },
	                        _react2.default.createElement('i', { className: 'fa fa-user fa-fw' }),
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Account'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('li', { className: 'spacer' }),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/home', onClick: this.handleLogout },
	                        _react2.default.createElement('i', { className: 'fa fa-power-off fa-fw' }),
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Logout'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'body-wrapper signinpage' },
	          _react2.default.createElement(
	            'section',
	            { className: 'signup-hello' },
	            localStorage.bfmSignup && _react2.default.createElement(
	              'div',
	              { className: 'back', style: { marginLeft: '5%' } },
	              _react2.default.createElement(
	                'span',
	                null,
	                '<'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    return localStorage.removeItem('bfmSignup');
	                  }, to: '/buy-for-me' },
	                'Back to Buy-for-me form'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'heading' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'roboto' },
	                'Thank you for joining, ',
	                this.props.login.login.party.first_name,
	                '!'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Now you can shop online from ',
	                _warehouseCode.warehouseAND,
	                ' and ship to your doorstep.'
	              ),
	              _react2.default.createElement(
	                'h5',
	                null,
	                'Here\'s a quick reminder on how to ship with ShippingCart:'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sc-addresses' },
	              this.props.customerInfo.warehouse_fetched ? (0, _whiteListed.filterWarehouse)(this.props.customerInfo.warehouse.data, this.props.login.login.party).sort(function (a, b) {
	                return a.country_code > b.country_code ? 1 : -1;
	              }).map(function (address, key) {
	                return _react2.default.createElement(_DashboardAddress2.default, {
	                  first_name: _this.props.login.login.party.first_name,
	                  last_name: _this.props.login.login.party.last_name,
	                  account_number: _this.props.login.login.party.account_number,
	                  key: key,
	                  address: address,
	                  highlightOregon: false
	                });
	              }) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: "flex", justifyContent: 'center' } },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  { style: { fontWeight: 'bold' } },
	                  'Your Shipping Address'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Use this as your delivery address when you checkout from ',
	                  _warehouseCode.warehouseAND,
	                  ' online stores.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Don\'t forget to input your complete ShippingCart address, including your account number and phone number when you checkout.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'signup-infographics' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sc-success centered infographics' },
	              _react2.default.createElement('img', { src: '/images/sc-success-shop.png', alt: 'Shop' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Shop'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Shop from ',
	                  _warehouseCode.warehouseAND,
	                  ' online stores and send it to your ShippingCart address.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Don\'t forget to include your account number.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sc-success centered infographics' },
	              _react2.default.createElement('img', { src: '/images/sc-success-accepted.png', alt: 'Check emaik' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Check email'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We\'ll notify you via email when your package arrives at the ShippingCart warehouse.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sc-success centered infographics' },
	              _react2.default.createElement('img', { src: '/images/sc-success-ready.png', alt: 'Ready to Ship' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Ready to Ship'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'After processing, we\'ll notify you via email when your package is ready for checkout and shipping.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sc-success centered infographics' },
	              _react2.default.createElement('img', { src: '/images/sc-success-review.png', alt: 'Review and Pay' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Review and Pay'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Checkout your package and pay the shipping fee.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'If you have multiple packages, you can consolidate them into one shipment.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sc-success centered infographics' },
	              _react2.default.createElement('img', { src: '/images/sc-success-way.png', alt: 'Package is On Its Way' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Package is On Its Way'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Once your payment is posted, we\'ll ship your package to your delivery address.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'signup-tour' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sc-success centered' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'What to do next?'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We\'ll guide you to your Dashboard'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/cart', className: 'sc-btn tour-btn', onClick: this.handleTour },
	                'Take the tour'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/cart', className: 'sc-btn skip-btn', onClick: this.handleSkip },
	                'Go to your Cart'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, {
	          currentPath: this.props.location.pathname,
	          currentYear: this.props.login.year
	        }),
	        this.state.incompleteInfo ? _react2.default.createElement(_RequiredModal2.default, { show: true,
	          first_name: this.props.login.login.party.first_name,
	          last_name: this.props.login.login.party.last_name,
	          email: this.props.login.login.party.email,
	          phone_number: this.props.login.login.party.phone_number,
	          error: this.props.login.error && this.props.login.error.data ? this.props.login.error.data.errors : null
	
	        }) : null
	      ) : null
	    );
	  }
	});
	
	exports.default = SignupSuccess;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _Header = __webpack_require__(123);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _dateFns = __webpack_require__(54);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(847);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var TrackPackage = createReactClass({
	  displayName: 'TrackPackage',
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->  
	  },
	  getInitialState: function getInitialState() {
	    return {
	      activePage: 1,
	      per_page: 10,
	      status: 'confirmed,in_transit,delivered,for_pickup,consolidated,out_for_delivery,failed_delivery,for_consolidation,claimed,picked_up,failed_pickup,return_in_transit,returned,failed_return,for_acceptance,accepted,for_transfer,out_for_return,for_dropoff,dropped_off,received_at_delivery_hub,received_at_delivery_area,at_sorting_center,dws_update',
	      range: "3months",
	      footerLinks: ["2", "3", "4", "7"],
	      bottomNavLinks: ["1", "5", "6"],
	      bottomNavLinksClass: ["first about pull-left", "second terms pull-left", "third privacy pull-left"]
	
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var token = localStorage.jwtToken;
	    if (token) {
	      this.props.getShipment(token, this.state.activePage, this.state.per_page, this.state.status, this.state.range);
	    }
	    // else {
	    //   <SignInContainer />;
	    // }
	    this.props.getCopyrightYear();
	    (0, _jquery2.default)('#SCTitle').text("Track Your Package | ShippingCart");
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    window.scrollTo(0, 0);
	  },
	  onChangeDate: function onChangeDate(event) {
	    //change SPAN OF TIME (60 days, 2016,2017, etc)
	    var token = localStorage.jwtToken;
	    this.setState({ range: event.target.value }, function () {
	      this.props.getShipment(token, this.state.activePage, this.state.per_page, this.state.status, this.state.range);
	    });
	  },
	  handleSelect: function handleSelect(eventKey) {
	    var _this = this;
	
	    //handle pagination data
	    var token = localStorage.jwtToken;
	    localStorage.setItem('page', eventKey);
	    this.setState({ activePage: eventKey }, function () {
	      _this.props.getShipment(token, _this.state.activePage, _this.state.per_page, _this.state.status, _this.state.range);
	    });
	  },
	  handleStatuses: function handleStatuses(shipment_status, type, payment_status) {
	    var str = shipment_status === "canceled" && payment_status === "rejected" ? payment_status : shipment_status;
	
	    if (str) {
	      if (type === "class") {
	        switch (str) {
	          case "confirmed":
	          case "for_pickup":
	          case "consolidated":
	          case "for_consolidation":
	            return "paid";
	          case "failed_pickup":
	          case "in_transit":
	          case "out_for_delivery":
	          case "failed_delivery":
	          case "return_in_transit":
	          case "returned":
	          case "failed_return":
	          case "for_acceptance":
	          case "accepted":
	          case "received_at_pickup_hub":
	          case "received_at_delivery_hub":
	          case "for_return":
	          case "received_at_delivery_area":
	          case "at_sorting_center":
	          case "in_transit_to_delivery_area":
	          case "transferred_to_partner":
	          case "for_transfer":
	          case "out_for_return":
	          case "for_dropoff":
	          case "dropped_off":
	          case "dws_update":
	            return "transit";
	          case "canceled":
	          case "rejected":
	            return "cancelled";
	          case "delivered":
	          case "claimed":
	          case "picked_up":
	            return "delivered";
	          default:
	            return str.replace("_", "-");
	        }
	      } else if (type === "text") {
	        switch (str) {
	          case "confirmed":
	          case "for_pickup":
	          case "consolidated":
	          case "for_consolidation":
	            return "PREPARING FOR SHIPMENT";
	          case "failed_pickup":
	          case "in_transit":
	          case "out_for_delivery":
	          case "failed_delivery":
	          case "return_in_transit":
	          case "returned":
	          case "failed_return":
	          case "for_acceptance":
	          case "accepted":
	          case "received_at_pickup_hub":
	          case "received_at_delivery_hub":
	          case "for_return":
	          case "received_at_delivery_area":
	          case "at_sorting_center":
	          case "in_transit_to_delivery_area":
	          case "transferred_to_partner":
	          case "for_transfer":
	          case "out_for_return":
	          case "for_dropoff":
	          case "dropped_off":
	          case "dws_update":
	            return "ON ITS WAY";
	          case "canceled":
	            return "CANCELLED";
	          case "delivered":
	          case "claimed":
	          case "picked_up":
	            return "DELIVERED";
	          default:
	            return str.replace("_", " ").toUpperCase();
	        }
	      }
	    }
	    return str;
	  },
	  handleDate: function handleDate(date) {
	
	    if (date) {
	      var sliced_date = date.slice(0, 10);
	      var split_date = sliced_date.split("-");
	      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4);
	
	      return new_date;
	    } else {
	      return null;
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    localStorage.removeItem("trackPackage2");
	  },
	  render: function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header2.default, {
	        isAuthenticated: true,
	        login: this.props.login,
	        logout: this.props.logout
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'body-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'trackpackage' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'pull-left' },
	                'Track your package'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'pull-right' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'track-count' },
	                  this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.total : null,
	                  ' Shipments in'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'select-gradient disInline' },
	                  _react2.default.createElement(
	                    'select',
	                    { onChange: this.onChangeDate },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '3months' },
	                      'Last 3 Months'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: '6months' },
	                      'Last 6 Months'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: new Date().getFullYear() },
	                      new Date().getFullYear()
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: new Date().getFullYear() - 1 },
	                      new Date().getFullYear() - 1
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'thead',
	                { className: this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.data ? "" : "hide" : null },
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Transaction Date'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Tracking #'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Items'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Shipping Method'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'ShippingCart',
	                    _react2.default.createElement('br', null),
	                    ' Fee Total'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'From'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Status'
	                  )
	                )
	              ),
	              this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.data ? this.props.shipmentInfo.shipment.data.filter(function (ship) {
	                return ship.payment_reference_id !== "";
	              }).map(function (ship, i) {
	                return _react2.default.createElement(
	                  'tbody',
	                  { key: i },
	                  _react2.default.createElement(
	                    'tr',
	                    { className: 'table-row' },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _dateFns.format)(new Date(ship.tat.pending * 1000), 'MM/DD/YYYY')
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ship.tracking_number
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ship.items.map(function (item, i) {
	                        return item.type === "product" ? _react2.default.createElement(
	                          'p',
	                          { key: i },
	                          item.description
	                        ) : null;
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ship.shipment.includes('air') ? "Air" : "Sea",
	                      ' Cargo'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ship.currency === "USD" ? "USD" : "₱",
	                      ' ',
	                      (0, _utils.numbersWithComma)(Number(ship.total).toFixed(2))
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _utils.maskLocationName)(ship.pickup_address.country.code),
	                      ' Warehouse'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: _this2.handleStatuses(ship.status, "class") },
	                        _this2.handleStatuses(ship.status, "text").toUpperCase()
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement('br', null),
	                      _this2.handleStatuses(ship.status, "text") === "PREPARING FOR SHIPMENT" ? "Your package is being processed for shipping." : _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/tracking/" + ship.tracking_number },
	                        'Track'
	                      )
	                    )
	                  ),
	                  ship.children && ship.children.length !== 0 ? ship.children.map(function (child, i) {
	                    return _react2.default.createElement(
	                      'tr',
	                      { className: 'table-row', key: i },
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _this2.handleDate(ship.created_at)
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        child.tracking_number
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        child.items.map(function (item, i) {
	                          return item.type === "product" ? _react2.default.createElement(
	                            'p',
	                            { key: i },
	                            item.description
	                          ) : null;
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        ship.shipment.includes('air') ? "Air" : "Sea",
	                        ' Cargo'
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        ship.currency === "USD" ? "USD" : "₱",
	                        ' ',
	                        ship.total
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        (0, _utils.maskLocationName)(ship.pickup_address.country.code),
	                        ' Warehouse'
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: _this2.handleStatuses(child.status, "class") },
	                          _this2.handleStatuses(child.status, "text").toUpperCase()
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        child.status === "confirmed" || child.status === "consolidated" || child.status === "for_pickup" || child.status === "for_consolidation" ? "Your package is being processed for shipping." : _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: "/tracking/" + child.tracking_number },
	                          'Track'
	                        )
	                      )
	                    );
	                  }) : null
	                );
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'no-result' },
	                'No Results Found'
	              ) : null
	            ),
	            this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.from == null ? null : _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, ellipsis: true, boundaryLinks: true, items: this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.last_page : null, maxButtons: 5, activePage: this.state.activePage, onSelect: this.handleSelect }) : null
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, { currentYear: this.props.login.year })
	    );
	  }
	});
	
	exports.default = TrackPackage;

/***/ },
/* 256 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var restrictedAreas = exports.restrictedAreas = {
	  provinces: [
	    // {
	    //   province: 'Ifugao'
	    // },
	    // {
	    //   province: 'Mountain Province'
	    // },
	    // {
	    //   province: 'Marinduque'
	    // },
	    // {
	    //   province: 'Masbate'
	    // },
	    // {
	    //   province: 'Occidental Mindoro'
	    // },
	    // {
	    //   province: 'Oriental Mindoro'
	    // },
	    // {
	    //   province: 'Romblon'
	    // },
	    // {
	    //   province: 'Sultan Kudarat'
	    // },
	    // {
	    //   province: 'Batanes'
	    // },
	  ],
	  cities: [
	    // {
	    //   province: 'Albay',
	    //   city: 'Legazpi City'
	    // },
	    // {
	    //   province: 'Aurora',
	    //   city: 'Dipaculao'
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Agoncillo'
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Pulilan'
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Paombong'
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Hagonoy'
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'San Juan'
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Bauan'
	    // },
	    // {
	    //   province: 'Camarines Norte',
	    //   city: 'Daet'
	    // },
	    // {
	    //   province: 'Camarines Sur',
	    //   city: 'Iriga City'
	    // },
	    // {
	    //   province: 'Camarines Sur',
	    //   city: 'Naga City'
	    // },
	    // {
	    //   province: 'Catanduanes',
	    //   city: 'Virac'
	    // },
	    // {
	    //   province: 'Laguna',
	    //   city: 'Nagcarlan'
	    // },
	    // {
	    //   province: 'Laguna',
	    //   city: 'Liliw'
	    // },
	    // {
	    //   province: 'Laguna',
	    //   city: 'Cavinti'
	    // },
	    // {
	    //   province: 'Laguna',
	    //   city: 'Luisiana'
	    // },
	    // {
	    //   province: 'Laguna',
	    //   city: 'Magdalena'
	    // },
	    // {
	    //   province: 'Quezon',
	    //   city: 'Real'
	    // },
	    // {
	    //   province: 'Quezon',
	    //   city: 'Infanta'
	    // },
	    // {
	    //   province: 'Quezon',
	    //   city: 'General Nakar'
	    // },
	    // {
	    //   province: 'Sorsogon',
	    //   city: 'Sorsogon City'
	    // },
	    // {
	    //   province: 'Tarlac',
	    //   city: 'Victoria'
	    // },
	    // {
	    //   province: 'Palawan',
	    //   city: 'Narra'
	    // },
	    // {
	    //   province: 'Palawan',
	    //   city: "Brooke's Point"
	    // },
	    // {
	    //   province: 'Palawan',
	    //   city: 'Coron'
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'San Luis'
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'San Nicolas'
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'San Miguel'
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Bacoor City'
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Carmona'
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Dasmarinas City'
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'General Trias City'
	    // },
	  ],
	  brgys: [
	    // {
	    //   province: 'Bataan',
	    //   city: 'Orani',
	    //   brgy: 'Pag-Asa',
	    // },
	    // {
	    //   province: 'Bataan',
	    //   city: 'Orani',
	    //   brgy: 'Tala',
	    // },
	    // {
	    //   province: 'Bataan',
	    //   city: 'Orani',
	    //   brgy: 'Masantol',
	    // },
	    // {
	    //   province: 'Bataan',
	    //   city: 'Orani',
	    //   brgy: 'Balut',
	    // },
	    // {
	    //   province: 'Bataan',
	    //   city: 'Orani',
	    //   brgy: 'Silahis',
	    // },
	    // {
	    //   province: 'Bataan',
	    //   city: 'Orani',
	    //   brgy: 'Tagumpay',
	    // },
	    // {
	    //   province: 'Bataan',
	    //   city: 'Orani',
	    //   brgy: 'Talimundoc',
	    // },
	    // {
	    //   province: 'Bataan',
	    //   city: 'Hermosa',
	    //   brgy: 'Almacen',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Malolos City',
	    //   brgy: 'Santol',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Malolos City',
	    //   brgy: 'Taal',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Malolos City',
	    //   brgy: 'Niugan',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Malolos City',
	    //   brgy: 'Sta Isabel',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Malolos City',
	    //   brgy: 'Balite',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Baliuag',
	    //   brgy: 'Calantipay',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Baliuag',
	    //   brgy: 'Paitan',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Baliuag',
	    //   brgy: 'Pagala',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Baliuag',
	    //   brgy: 'San Roque',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Baliuag',
	    //   brgy: 'Little Baguio',
	    // },
	    // {
	    //   province: 'Bulacan',
	    //   city: 'Balagtas',
	    //   brgy: 'Balagtas Mc Arthur Highway',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'Floridablanca',
	    //   brgy: 'Nabuclod',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'Floridablanca',
	    //   brgy: 'Mawacat',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'San Fernando City',
	    //   brgy: 'San Jose',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'San Fernando City',
	    //   brgy: 'San Isidro',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'San Fernando City',
	    //   brgy: 'Maimpis',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'San Fernando City',
	    //   brgy: 'Saguin',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'San Fernando City',
	    //   brgy: 'San Nicolas',
	    // },
	    // {
	    //   province: 'Pampanga',
	    //   city: 'Arayat',
	    //   brgy: 'San Mateo',
	    // },
	    // {
	    //   province: 'Zambales',
	    //   city: 'San Antonio',
	    //   brgy: 'Pundaquit',
	    // },
	    // {
	    //   province: 'Zambales',
	    //   city: 'San Antonio',
	    //   brgy: 'San Miguel',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Santo Domingo',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Santo Tomas City',
	    //   brgy: 'San Francisco',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Salong',
	    // },
	    // {
	    //   province: 'Metro Manila',
	    //   city: 'Quezon City',
	    //   brgy: 'Payatas',
	    // },
	    // {
	    //   province: 'Metro Manila',
	    //   city: 'Quezon City',
	    //   brgy: 'Tandang Sora',
	    // },
	    // {
	    //   province: 'Palawan',
	    //   city: 'Roxas',
	    //   brgy: 'San Jose',
	    // },
	    // {
	    //   province: 'Palawan',
	    //   city: 'Roxas',
	    //   brgy: 'Abaroan',
	    // },
	    // {
	    //   province: 'Palawan',
	    //   city: 'San Vicente',
	    //   brgy: 'Port Barton',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Alitagtag',
	    //   brgy: 'Dalipit East',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Alitagtag',
	    //   brgy: 'Dalipit West',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Balayan',
	    //   brgy: 'Baclaran',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Balayan',
	    //   brgy: 'Gimalas',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Balayan',
	    //   brgy: 'Pooc',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Dalig',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Dumantay',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Gulod Itaas',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Ilihan',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Libjo',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Mabacong',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Paharang Kanluran',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Pinamucan',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'San Isidro',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Simlong',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Batangas City',
	    //   brgy: 'Tabangao Ambulong',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Barangay 1',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Barangay 2',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Barangay 3',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Barangay 4',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Barangay 5',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Barangay 6',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Camastilisan',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Lumbang Calzada',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Puting Bato East',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Puting Bato West',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Calaca',
	    //   brgy: 'Quisumbing',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lemery',
	    //   brgy: 'Maligaya',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lemery',
	    //   brgy: 'Sambal Ibaba',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lemery',
	    //   brgy: 'Sambal Ilaya',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lemery',
	    //   brgy: 'Wawa Ibaba',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Bulacnin',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Lumbang',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Munting Pulo',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Pangao',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Poblacion Barangay 3',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'San Benito',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'San Celestino',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'San Francisco',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Santo Nino',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Talisay',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Tangob',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Tanguay',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Lipa City',
	    //   brgy: 'Tibig',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Nasugbu',
	    //   brgy: 'Barangay 12',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Nasugbu',
	    //   brgy: 'Barangay 7',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Nasugbu',
	    //   brgy: 'Bucana',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Nasugbu',
	    //   brgy: 'Pantalan',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Nasugbu',
	    //   brgy: 'Talangan',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Rosario',
	    //   brgy: 'Malaya',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Rosario',
	    //   brgy: 'Marilag',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Rosario',
	    //   brgy: 'Santa Cruz',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Rosario',
	    //   brgy: 'Timbugan',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Santa Teresita',
	    //   brgy: 'Cuta East',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Santa Teresita',
	    //   brgy: 'Pacifico',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Santa Teresita',
	    //   brgy: 'Pacifico',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Santo Tomas City',
	    //   brgy: 'San Francisco',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Santo Tomas City',
	    //   brgy: 'San Luis',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Santo Tomas City',
	    //   brgy: 'Santa Ana',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Ambulong',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Bagumbayan',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Bilog-Bilog',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Hidalgo',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Janopol',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Luyos',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Mabini',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Natatas',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Sala',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'San Jose',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Santor',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Sulpoc',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Talaga',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Tinurik',
	    // },
	    // {
	    //   province: 'Batangas',
	    //   city: 'Tanauan City',
	    //   brgy: 'Trapiche',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Banaba Lejos',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Bancod',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Buna Lejos II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Guyam Munti',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Harasan',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Kayquit III',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Kaytambog',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Kaytapos',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Limbon',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Mahabangkahoy Cerca',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Indang',
	    //   brgy: 'Tambo Balagbag',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Acacia',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Anahaw I',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Anahaw II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Banaba',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Barangay I',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Barangay II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Barangay III',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Barangay IV',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Barangay V',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Biga II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Bulihan',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Ipil I',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Ipil II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Maguyam',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Narra I',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Narra II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Narra III',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Sabutan',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'San Miguel I',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'San Miguel II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'San Vicente I',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'San Vicente II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Tartaria',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Tubuan I',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Tubuan II',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Tubuan III',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Silang',
	    //   brgy: 'Yakal',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Tanza',
	    //   brgy: 'Bagtas',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Trece Martires City',
	    //   brgy: 'Aguado',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Trece Martires City',
	    //   brgy: 'Conchu',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Trece Martires City',
	    //   brgy: 'Gregorio',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Trece Martires City',
	    //   brgy: 'Lallana',
	    // },
	    // {
	    //   province: 'Cavite',
	    //   city: 'Trece Martires City',
	    //   brgy: 'Osorio',
	    // },
	  ]
	};

/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.notificationTemplate = notificationTemplate;
	function notificationTemplate(noticationAttribute) {
	  if (noticationAttribute) {
	    var attributeData = JSON.parse(noticationAttribute.data);
	    switch (attributeData.redirection_type) {
	      case 'vas_payment_success':
	      case 'vas_rejected':
	      case 'vas_completed':
	      case 'vas_payment_failed':
	      case 'vas_approved':
	        return attributeData.reference_id;
	      case 'order_details':
	      case 'payment_success':
	      case 'payment_failed':
	      case 'delivered':
	        return attributeData.tracking_number;
	      default:
	        return noticationAttribute.reference_id;
	    }
	  }
	}

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(76);
	var document = __webpack_require__(53).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(51) && !__webpack_require__(95)(function () {
	  return Object.defineProperty(__webpack_require__(258)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(161);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(127);
	var $export = __webpack_require__(52);
	var redefine = __webpack_require__(266);
	var hide = __webpack_require__(75);
	var Iterators = __webpack_require__(96);
	var $iterCreate = __webpack_require__(674);
	var setToStringTag = __webpack_require__(167);
	var getPrototypeOf = __webpack_require__(681);
	var ITERATOR = __webpack_require__(42)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(98);
	var createDesc = __webpack_require__(99);
	var toIObject = __webpack_require__(62);
	var toPrimitive = __webpack_require__(171);
	var has = __webpack_require__(60);
	var IE8_DOM_DEFINE = __webpack_require__(259);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(51) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(264);
	var hiddenKeys = __webpack_require__(164).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(60);
	var toIObject = __webpack_require__(62);
	var arrayIndexOf = __webpack_require__(666)(false);
	var IE_PROTO = __webpack_require__(168)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(51);
	var getKeys = __webpack_require__(97);
	var toIObject = __webpack_require__(62);
	var isEnum = __webpack_require__(98).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(75);


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(170);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(683)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(261)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1180)
	
	var md5 = toConstructor(__webpack_require__(702))
	var rmd160 = toConstructor(__webpack_require__(1178))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(704)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(269)
	
	exports.createHmac = __webpack_require__(700)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(703)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createCipher'
	, 'createCipheriv'
	, 'createDecipher'
	, 'createDecipheriv'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(102)
	
	var MILLISECONDS_IN_HOUR = 3600000
	
	/**
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added
	 * @returns {Date} the new date with the hours added
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
	}
	
	module.exports = addHours


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(63)
	var setISOYear = __webpack_require__(298)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added
	 * @returns {Date} the new date with the ISO week-numbering years added
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * var result = addISOYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
	}
	
	module.exports = addISOYears


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(102)
	
	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added
	 * @returns {Date} the new date with the minutes added
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
	}
	
	module.exports = addMinutes


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var addMonths = __webpack_require__(130)
	
	/**
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added
	 * @returns {Date} the new date with the quarters added
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * var result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  var months = amount * 3
	  return addMonths(dirtyDate, months)
	}
	
	module.exports = addQuarters


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(102)
	
	/**
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added
	 * @returns {Date} the new date with the seconds added
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, amount * 1000)
	}
	
	module.exports = addSeconds


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var addMonths = __webpack_require__(130)
	
	/**
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added
	 * @returns {Date} the new date with the years added
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMonths(dirtyDate, amount * 12)
	}
	
	module.exports = addYears


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(63)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * var result = differenceInCalendarISOYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
	  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
	}
	
	module.exports = differenceInCalendarISOYears


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()
	
	  return yearDiff * 12 + monthDiff
	}
	
	module.exports = differenceInCalendarMonths


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  return dateLeft.getFullYear() - dateRight.getFullYear()
	}
	
	module.exports = differenceInCalendarYears


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var differenceInCalendarDays = __webpack_require__(131)
	var compareAsc = __webpack_require__(103)
	
	/**
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 */
	function differenceInDays (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
	  dateLeft.setDate(dateLeft.getDate() - sign * difference)
	
	  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastDayNotFull)
	}
	
	module.exports = differenceInDays


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var compareDesc = __webpack_require__(175)
	var parse = __webpack_require__(3)
	var differenceInSeconds = __webpack_require__(177)
	var differenceInMonths = __webpack_require__(176)
	var enLocale = __webpack_require__(183)
	
	var MINUTES_IN_DAY = 1440
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520
	var MINUTES_IN_MONTH = 43200
	var MINUTES_IN_TWO_MONTHS = 86400
	
	/**
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date|String|Number} date - the other date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the distance in words
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = distanceInWords(
	 *   new Date(2014, 6, 2),
	 *   new Date(2015, 0, 1)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * var result = distanceInWords(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = distanceInWords(
	 *   new Date(2016, 0, 1),
	 *   new Date(2015, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = distanceInWords(
	 *   new Date(2016, 7, 1),
	 *   new Date(2015, 0, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
	  var options = dirtyOptions || {}
	
	  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)
	
	  var locale = options.locale
	  var localize = enLocale.distanceInWords.localize
	  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
	    localize = locale.distanceInWords.localize
	  }
	
	  var localizeOptions = {
	    addSuffix: Boolean(options.addSuffix),
	    comparison: comparison
	  }
	
	  var dateLeft, dateRight
	  if (comparison > 0) {
	    dateLeft = parse(dirtyDateToCompare)
	    dateRight = parse(dirtyDate)
	  } else {
	    dateLeft = parse(dirtyDate)
	    dateRight = parse(dirtyDateToCompare)
	  }
	
	  var seconds = differenceInSeconds(dateRight, dateLeft)
	  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
	  var minutes = Math.round(seconds / 60) - offset
	  var months
	
	  // 0 up to 2 mins
	  if (minutes < 2) {
	    if (options.includeSeconds) {
	      if (seconds < 5) {
	        return localize('lessThanXSeconds', 5, localizeOptions)
	      } else if (seconds < 10) {
	        return localize('lessThanXSeconds', 10, localizeOptions)
	      } else if (seconds < 20) {
	        return localize('lessThanXSeconds', 20, localizeOptions)
	      } else if (seconds < 40) {
	        return localize('halfAMinute', null, localizeOptions)
	      } else if (seconds < 60) {
	        return localize('lessThanXMinutes', 1, localizeOptions)
	      } else {
	        return localize('xMinutes', 1, localizeOptions)
	      }
	    } else {
	      if (minutes === 0) {
	        return localize('lessThanXMinutes', 1, localizeOptions)
	      } else {
	        return localize('xMinutes', minutes, localizeOptions)
	      }
	    }
	
	  // 2 mins up to 0.75 hrs
	  } else if (minutes < 45) {
	    return localize('xMinutes', minutes, localizeOptions)
	
	  // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return localize('aboutXHours', 1, localizeOptions)
	
	  // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60)
	    return localize('aboutXHours', hours, localizeOptions)
	
	  // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return localize('xDays', 1, localizeOptions)
	
	  // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY)
	    return localize('xDays', days, localizeOptions)
	
	  // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH)
	    return localize('aboutXMonths', months, localizeOptions)
	  }
	
	  months = differenceInMonths(dateRight, dateLeft)
	
	  // 2 months up to 12 months
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
	    return localize('xMonths', nearestMonth, localizeOptions)
	
	  // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12
	    var years = Math.floor(months / 12)
	
	    // N years up to 1 years 3 months
	    if (monthsSinceStartOfYear < 3) {
	      return localize('aboutXYears', years, localizeOptions)
	
	    // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return localize('overXYears', years, localizeOptions)
	
	    // N years 9 months up to N year 12 months
	    } else {
	      return localize('almostXYears', years + 1, localizeOptions)
	    }
	  }
	}
	
	module.exports = distanceInWords


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a month
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var month = date.getMonth()
	  date.setFullYear(date.getFullYear(), month + 1, 0)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfMonth


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)
	
	  date.setDate(date.getDate() + diff)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfWeek


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var startOfYear = __webpack_require__(304)
	var differenceInCalendarDays = __webpack_require__(131)
	
	/**
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of year
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * var result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var diff = differenceInCalendarDays(date, startOfYear(date))
	  var dayOfYear = diff + 1
	  return dayOfYear
	}
	
	module.exports = getDayOfYear


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * var result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay (dirtyDate) {
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	
	  if (day === 0) {
	    day = 7
	  }
	
	  return day
	}
	
	module.exports = getISODay


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the quarter
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * var result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var quarter = Math.floor(date.getMonth() / 3) + 1
	  return quarter
	}
	
	module.exports = getQuarter


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * var result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
	}
	
	module.exports = isLeapYear


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var startOfHour = __webpack_require__(300)
	
	/**
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour?
	 *
	 * @description
	 * Are the given dates in the same hour?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * var result = isSameHour(
	 *   new Date(2014, 8, 4, 6, 0),
	 *   new Date(2014, 8, 4, 6, 30)
	 * )
	 * //=> true
	 */
	function isSameHour (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
	  var dateRightStartOfHour = startOfHour(dirtyDateRight)
	
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
	}
	
	module.exports = isSameHour


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var isSameWeek = __webpack_require__(182)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week?
	 *
	 * @description
	 * Are the given dates in the same ISO week?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * var result = isSameISOWeek(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 8, 7)
	 * )
	 * //=> true
	 */
	function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
	  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
	}
	
	module.exports = isSameISOWeek


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var startOfISOYear = __webpack_require__(104)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * var result = isSameISOYear(
	 *   new Date(2003, 11, 29),
	 *   new Date(2005, 0, 2)
	 * )
	 * //=> true
	 */
	function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
	  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)
	
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
	}
	
	module.exports = isSameISOYear


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var startOfMinute = __webpack_require__(301)
	
	/**
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute?
	 *
	 * @description
	 * Are the given dates in the same minute?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
	 * // in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 */
	function isSameMinute (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
	  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)
	
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
	}
	
	module.exports = isSameMinute


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(
	 *   new Date(2014, 8, 2),
	 *   new Date(2014, 8, 25)
	 * )
	 * //=> true
	 */
	function isSameMonth (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getFullYear() === dateRight.getFullYear() &&
	    dateLeft.getMonth() === dateRight.getMonth()
	}
	
	module.exports = isSameMonth


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var startOfQuarter = __webpack_require__(302)
	
	/**
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same year quarter?
	 *
	 * @description
	 * Are the given dates in the same year quarter?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(
	 *   new Date(2014, 0, 1),
	 *   new Date(2014, 2, 8)
	 * )
	 * //=> true
	 */
	function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
	  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)
	
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
	}
	
	module.exports = isSameQuarter


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var startOfSecond = __webpack_require__(303)
	
	/**
	 * @category Second Helpers
	 * @summary Are the given dates in the same second?
	 *
	 * @description
	 * Are the given dates in the same second?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
	 * // in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 */
	function isSameSecond (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
	  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)
	
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
	}
	
	module.exports = isSameSecond


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(
	 *   new Date(2014, 8, 2),
	 *   new Date(2014, 8, 25)
	 * )
	 * //=> true
	 */
	function isSameYear (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getFullYear() === dateRight.getFullYear()
	}
	
	module.exports = isSameYear


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var isDate = __webpack_require__(181)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {Date} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} argument must be an instance of Date
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid (dirtyDate) {
	  if (isDate(dirtyDate)) {
	    return !isNaN(dirtyDate)
	  } else {
	    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
	  }
	}
	
	module.exports = isValid


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)
	
	  date.setHours(0, 0, 0, 0)
	  date.setDate(date.getDate() + diff)
	  return date
	}
	
	module.exports = lastDayOfWeek


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var startOfISOYear = __webpack_require__(104)
	var differenceInCalendarDays = __webpack_require__(131)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} isoYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year setted
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * var result = setISOYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOYear (dirtyDate, dirtyISOYear) {
	  var date = parse(dirtyDate)
	  var isoYear = Number(dirtyISOYear)
	  var diff = differenceInCalendarDays(date, startOfISOYear(date))
	  var fourthOfJanuary = new Date(0)
	  fourthOfJanuary.setFullYear(isoYear, 0, 4)
	  fourthOfJanuary.setHours(0, 0, 0, 0)
	  date = startOfISOYear(fourthOfJanuary)
	  date.setDate(date.getDate() + diff)
	  return date
	}
	
	module.exports = setISOYear


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var getDaysInMonth = __webpack_require__(179)
	
	/**
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month setted
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * var result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth (dirtyDate, dirtyMonth) {
	  var date = parse(dirtyDate)
	  var month = Number(dirtyMonth)
	  var year = date.getFullYear()
	  var day = date.getDate()
	
	  var dateWithDesiredMonth = new Date(0)
	  dateWithDesiredMonth.setFullYear(year, month, 15)
	  dateWithDesiredMonth.setHours(0, 0, 0, 0)
	  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth))
	  return date
	}
	
	module.exports = setMonth


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an hour
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMinutes(0, 0, 0)
	  return date
	}
	
	module.exports = startOfHour


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a minute
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setSeconds(0, 0)
	  return date
	}
	
	module.exports = startOfMinute


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var currentMonth = date.getMonth()
	  var month = currentMonth - currentMonth % 3
	  date.setMonth(month, 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfQuarter


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a second
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMilliseconds(0)
	  return date
	}
	
	module.exports = startOfSecond


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a year
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear (dirtyDate) {
	  var cleanDate = parse(dirtyDate)
	  var date = new Date(0)
	  date.setFullYear(cleanDate.getFullYear(), 0, 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfYear


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var addISOYears = __webpack_require__(272)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * var result = subISOYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addISOYears(dirtyDate, -amount)
	}
	
	module.exports = subISOYears


/***/ },
/* 306 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(817);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ },
/* 309 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 310 */
134,
/* 311 */
134,
/* 312 */
134,
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(36);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 314 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/brand-icon-white.28784e2d.svg";

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-user.9f9d5a5e.svg";

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notification-active.4e331b43.svg";

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notification.c2f0b980.svg";

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/angle-left.92830189.svg";

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(192);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(948);
	
	var _runTransitionHook = __webpack_require__(192);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(78);
	
	var _PathUtils = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 324 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Any = __webpack_require__(43);
	var Errors = __webpack_require__(47);
	var Hoek = __webpack_require__(32);
	
	
	// Declare internals
	
	var internals = {};
	
	
	internals.Boolean = function () {
	
	    Any.call(this);
	    this._type = 'boolean';
	};
	
	Hoek.inherits(internals.Boolean, Any);
	
	
	internals.Boolean.prototype._base = function (value, state, options) {
	
	    var result = {
	        value: value
	    };
	
	    if (typeof value === 'string' &&
	        options.convert) {
	
	        var lower = value.toLowerCase();
	        result.value = (lower === 'true' || lower === 'yes' || lower === 'on' ? true
	                                                                              : (lower === 'false' || lower === 'no' || lower === 'off' ? false : value));
	    }
	
	    result.errors = (typeof result.value === 'boolean') ? null : Errors.create('boolean.base', null, state, options);
	    return result;
	};
	
	
	module.exports = new internals.Boolean();


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Any = __webpack_require__(43);
	var Ref = __webpack_require__(66);
	var Errors = __webpack_require__(47);
	var Hoek = __webpack_require__(32);
	
	
	// Declare internals
	
	var internals = {};
	
	
	internals.Number = function () {
	
	    Any.call(this);
	    this._type = 'number';
	    this._invalids.add(Infinity);
	    this._invalids.add(-Infinity);
	};
	
	Hoek.inherits(internals.Number, Any);
	
	internals.compare = function (type, compare) {
	
	    return function (limit) {
	
	        var isRef = Ref.isRef(limit);
	        var isNumber = typeof limit === 'number' && !isNaN(limit);
	
	        Hoek.assert(isNumber || isRef, 'limit must be a number or reference');
	
	        return this._test(type, limit, function (value, state, options) {
	
	            var compareTo;
	            if (isRef) {
	                compareTo = limit(state.parent, options);
	
	                if (!(typeof compareTo === 'number' && !isNaN(compareTo))) {
	                    return Errors.create('number.ref', { ref: limit.key }, state, options);
	                }
	            }
	            else {
	                compareTo = limit;
	            }
	
	            if (compare(value, compareTo)) {
	                return null;
	            }
	
	            return Errors.create('number.' + type, { limit: compareTo, value: value }, state, options);
	        });
	    };
	};
	
	
	internals.Number.prototype._base = function (value, state, options) {
	
	    var result = {
	        errors: null,
	        value: value
	    };
	
	    if (typeof value === 'string' &&
	        options.convert) {
	
	        var number = parseFloat(value);
	        result.value = (isNaN(number) || !isFinite(value)) ? NaN : number;
	    }
	
	    var isNumber = typeof result.value === 'number' && !isNaN(result.value);
	
	    if (options.convert && 'precision' in this._flags && isNumber) {
	
	        // This is conceptually equivalent to using toFixed but it should be much faster
	        var precision = Math.pow(10, this._flags.precision);
	        result.value = Math.round(result.value * precision) / precision;
	    }
	
	    result.errors = isNumber ? null : Errors.create('number.base', null, state, options);
	    return result;
	};
	
	
	internals.Number.prototype.min = internals.compare('min', function (value, limit) {
	
	    return value >= limit;
	});
	
	
	internals.Number.prototype.max = internals.compare('max', function (value, limit) {
	
	    return value <= limit;
	});
	
	
	internals.Number.prototype.greater = internals.compare('greater', function (value, limit) {
	
	    return value > limit;
	});
	
	
	internals.Number.prototype.less = internals.compare('less', function (value, limit) {
	
	    return value < limit;
	});
	
	
	internals.Number.prototype.multiple = function (base) {
	
	    Hoek.assert(Hoek.isInteger(base), 'multiple must be an integer');
	    Hoek.assert(base > 0, 'multiple must be greater than 0');
	
	    return this._test('multiple', base, function (value, state, options) {
	
	        if (value % base === 0) {
	            return null;
	        }
	
	        return Errors.create('number.multiple', { multiple: base, value: value }, state, options);
	    });
	};
	
	
	internals.Number.prototype.integer = function () {
	
	    return this._test('integer', undefined, function (value, state, options) {
	
	        return Hoek.isInteger(value) ? null : Errors.create('number.integer', { value: value }, state, options);
	    });
	};
	
	
	internals.Number.prototype.negative = function () {
	
	    return this._test('negative', undefined, function (value, state, options) {
	
	        if (value < 0) {
	            return null;
	        }
	
	        return Errors.create('number.negative', { value: value }, state, options);
	    });
	};
	
	
	internals.Number.prototype.positive = function () {
	
	    return this._test('positive', undefined, function (value, state, options) {
	
	        if (value > 0) {
	            return null;
	        }
	
	        return Errors.create('number.positive', { value: value }, state, options);
	    });
	};
	
	
	internals.precisionRx = /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/;
	
	
	internals.Number.prototype.precision = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit), 'limit must be an integer');
	    Hoek.assert(!('precision' in this._flags), 'precision already set');
	
	    var obj = this._test('precision', limit, function (value, state, options){
	
	        var places = value.toString().match(internals.precisionRx);
	        var decimals = Math.max((places[1] ? places[1].length : 0) - (places[2] ? parseInt(places[2], 10) : 0), 0);
	        if (decimals <= limit) {
	            return null;
	        }
	
	        return Errors.create('number.precision', { limit: limit, value: value }, state, options);
	    });
	
	    obj._flags.precision = limit;
	    return obj;
	};
	
	
	module.exports = new internals.Number();


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Hoek = __webpack_require__(32);
	var Topo = __webpack_require__(1194);
	var Any = __webpack_require__(43);
	var Cast = __webpack_require__(106);
	var Errors = __webpack_require__(47);
	
	
	// Declare internals
	
	var internals = {};
	
	
	internals.Object = function () {
	
	    Any.call(this);
	    this._type = 'object';
	    this._inner.children = null;
	    this._inner.renames = [];
	    this._inner.dependencies = [];
	    this._inner.patterns = [];
	};
	
	Hoek.inherits(internals.Object, Any);
	
	
	internals.Object.prototype._base = function (value, state, options) {
	
	    var item, key, localState, result;
	    var target = value;
	    var errors = [];
	    var finish = function () {
	
	        return {
	            value: target,
	            errors: errors.length ? errors : null
	        };
	    };
	
	    if (typeof value === 'string' &&
	        options.convert) {
	
	        try {
	            value = JSON.parse(value);
	        }
	        catch (parseErr) { }
	    }
	
	    var type = this._flags.func ? 'function' : 'object';
	    if (!value ||
	        typeof value !== type ||
	        Array.isArray(value)) {
	
	        errors.push(Errors.create(type + '.base', null, state, options));
	        return finish();
	    }
	
	    // Skip if there are no other rules to test
	
	    if (!this._inner.renames.length &&
	        !this._inner.dependencies.length &&
	        !this._inner.children &&                    // null allows any keys
	        !this._inner.patterns.length) {
	
	        target = value;
	        return finish();
	    }
	
	    // Ensure target is a local copy (parsed) or shallow copy
	
	    if (target === value) {
	        if (type === 'object') {
	            target = Object.create(Object.getPrototypeOf(value));
	        }
	        else {
	            target = function () {
	
	                return value.apply(this, arguments);
	            };
	
	            target.prototype = Hoek.clone(value.prototype);
	        }
	
	        var valueKeys = Object.keys(value);
	        for (var t = 0, tl = valueKeys.length; t < tl; ++t) {
	            target[valueKeys[t]] = value[valueKeys[t]];
	        }
	    }
	    else {
	        target = value;
	    }
	
	    // Rename keys
	
	    var renamed = {};
	    for (var r = 0, rl = this._inner.renames.length; r < rl; ++r) {
	        item = this._inner.renames[r];
	
	        if (item.options.ignoreUndefined && target[item.from] === undefined) {
	            continue;
	        }
	
	        if (!item.options.multiple &&
	            renamed[item.to]) {
	
	            errors.push(Errors.create('object.rename.multiple', { from: item.from, to: item.to }, state, options));
	            if (options.abortEarly) {
	                return finish();
	            }
	        }
	
	        if (Object.prototype.hasOwnProperty.call(target, item.to) &&
	            !item.options.override &&
	            !renamed[item.to]) {
	
	            errors.push(Errors.create('object.rename.override', { from: item.from, to: item.to }, state, options));
	            if (options.abortEarly) {
	                return finish();
	            }
	        }
	
	        if (target[item.from] === undefined) {
	            delete target[item.to];
	        }
	        else {
	            target[item.to] = target[item.from];
	        }
	
	        renamed[item.to] = true;
	
	        if (!item.options.alias) {
	            delete target[item.from];
	        }
	    }
	
	    // Validate schema
	
	    if (!this._inner.children &&            // null allows any keys
	        !this._inner.patterns.length &&
	        !this._inner.dependencies.length) {
	
	        return finish();
	    }
	
	    var unprocessed = Hoek.mapToObject(Object.keys(target));
	
	    if (this._inner.children) {
	        for (var i = 0, il = this._inner.children.length; i < il; ++i) {
	            var child = this._inner.children[i];
	            key = child.key;
	            item = target[key];
	
	            delete unprocessed[key];
	
	            localState = { key: key, path: (state.path || '') + (state.path && key ? '.' : '') + key, parent: target, reference: state.reference };
	            result = child.schema._validate(item, localState, options);
	            if (result.errors) {
	                errors.push(Errors.create('object.child', { key: key, reason: result.errors }, localState, options));
	
	                if (options.abortEarly) {
	                    return finish();
	                }
	            }
	
	            if (child.schema._flags.strip || (result.value === undefined && result.value !== item)) {
	                delete target[key];
	            }
	            else if (result.value !== undefined) {
	                target[key] = result.value;
	            }
	        }
	    }
	
	    // Unknown keys
	
	    var unprocessedKeys = Object.keys(unprocessed);
	    if (unprocessedKeys.length &&
	        this._inner.patterns.length) {
	
	        for (i = 0, il = unprocessedKeys.length; i < il; ++i) {
	            key = unprocessedKeys[i];
	
	            for (var p = 0, pl = this._inner.patterns.length; p < pl; ++p) {
	                var pattern = this._inner.patterns[p];
	
	                if (pattern.regex.test(key)) {
	                    delete unprocessed[key];
	
	                    item = target[key];
	                    localState = { key: key, path: (state.path ? state.path + '.' : '') + key, parent: target, reference: state.reference };
	                    result = pattern.rule._validate(item, localState, options);
	                    if (result.errors) {
	                        errors.push(Errors.create('object.child', { key: key, reason: result.errors }, localState, options));
	
	                        if (options.abortEarly) {
	                            return finish();
	                        }
	                    }
	
	                    if (result.value !== undefined) {
	                        target[key] = result.value;
	                    }
	                }
	            }
	        }
	
	        unprocessedKeys = Object.keys(unprocessed);
	    }
	
	    if ((this._inner.children || this._inner.patterns.length) && unprocessedKeys.length) {
	        if (options.stripUnknown ||
	            options.skipFunctions) {
	
	            for (var k = 0, kl = unprocessedKeys.length; k < kl; ++k) {
	                key = unprocessedKeys[k];
	
	                if (options.stripUnknown) {
	                    delete target[key];
	                    delete unprocessed[key];
	                }
	                else if (typeof target[key] === 'function') {
	                    delete unprocessed[key];
	                }
	            }
	
	            unprocessedKeys = Object.keys(unprocessed);
	        }
	
	        if (unprocessedKeys.length &&
	            (this._flags.allowUnknown !== undefined ? !this._flags.allowUnknown : !options.allowUnknown)) {
	
	            for (var e = 0, el = unprocessedKeys.length; e < el; ++e) {
	                errors.push(Errors.create('object.allowUnknown', null, { key: unprocessedKeys[e], path: state.path + (state.path ? '.' : '') + unprocessedKeys[e] }, options));
	            }
	        }
	    }
	
	    // Validate dependencies
	
	    for (var d = 0, dl = this._inner.dependencies.length; d < dl; ++d) {
	        var dep = this._inner.dependencies[d];
	        var err = internals[dep.type](dep.key !== null && value[dep.key], dep.peers, target, { key: dep.key, path: (state.path || '') + (dep.key ? '.' + dep.key : '') }, options);
	        if (err) {
	            errors.push(err);
	            if (options.abortEarly) {
	                return finish();
	            }
	        }
	    }
	
	    return finish();
	};
	
	
	internals.Object.prototype._func = function () {
	
	    var obj = this.clone();
	    obj._flags.func = true;
	    return obj;
	};
	
	
	internals.Object.prototype.keys = function (schema) {
	
	    Hoek.assert(schema === null || schema === undefined || typeof schema === 'object', 'Object schema must be a valid object');
	    Hoek.assert(!schema || !schema.isJoi, 'Object schema cannot be a joi schema');
	
	    var obj = this.clone();
	
	    if (!schema) {
	        obj._inner.children = null;
	        return obj;
	    }
	
	    var children = Object.keys(schema);
	
	    if (!children.length) {
	        obj._inner.children = [];
	        return obj;
	    }
	
	    var topo = new Topo();
	    var child;
	    if (obj._inner.children) {
	        for (var i = 0, il = obj._inner.children.length; i < il; ++i) {
	            child = obj._inner.children[i];
	
	            // Only add the key if we are not going to replace it later
	            if (children.indexOf(child.key) === -1) {
	                topo.add(child, { after: child._refs, group: child.key });
	            }
	        }
	    }
	
	    for (var c = 0, cl = children.length; c < cl; ++c) {
	        var key = children[c];
	        child = schema[key];
	        try {
	            var cast = Cast.schema(child);
	            topo.add({ key: key, schema: cast }, { after: cast._refs, group: key });
	        }
	        catch (castErr) {
	            if (castErr.hasOwnProperty('path')) {
	                castErr.path = key + '.' + castErr.path;
	            }
	            else {
	                castErr.path = key;
	            }
	            throw castErr;
	        }
	    }
	
	    obj._inner.children = topo.nodes;
	
	    return obj;
	};
	
	
	internals.Object.prototype.unknown = function (allow) {
	
	    var obj = this.clone();
	    obj._flags.allowUnknown = (allow !== false);
	    return obj;
	};
	
	
	internals.Object.prototype.length = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('length', limit, function (value, state, options) {
	
	        if (Object.keys(value).length === limit) {
	            return null;
	        }
	
	        return Errors.create('object.length', { limit: limit }, state, options);
	    });
	};
	
	
	internals.Object.prototype.min = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('min', limit, function (value, state, options) {
	
	        if (Object.keys(value).length >= limit) {
	            return null;
	        }
	
	        return Errors.create('object.min', { limit: limit }, state, options);
	    });
	};
	
	
	internals.Object.prototype.max = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('max', limit, function (value, state, options) {
	
	        if (Object.keys(value).length <= limit) {
	            return null;
	        }
	
	        return Errors.create('object.max', { limit: limit }, state, options);
	    });
	};
	
	
	internals.Object.prototype.pattern = function (pattern, schema) {
	
	    Hoek.assert(pattern instanceof RegExp, 'Invalid regular expression');
	    Hoek.assert(schema !== undefined, 'Invalid rule');
	
	    pattern = new RegExp(pattern.source, pattern.ignoreCase ? 'i' : undefined);         // Future version should break this and forbid unsupported regex flags
	
	    try {
	        schema = Cast.schema(schema);
	    }
	    catch (castErr) {
	        if (castErr.hasOwnProperty('path')) {
	            castErr.message += '(' + castErr.path + ')';
	        }
	
	        throw castErr;
	    }
	
	
	    var obj = this.clone();
	    obj._inner.patterns.push({ regex: pattern, rule: schema });
	    return obj;
	};
	
	
	internals.Object.prototype.with = function (key, peers) {
	
	    return this._dependency('with', key, peers);
	};
	
	
	internals.Object.prototype.without = function (key, peers) {
	
	    return this._dependency('without', key, peers);
	};
	
	
	internals.Object.prototype.xor = function () {
	
	    var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
	    return this._dependency('xor', null, peers);
	};
	
	
	internals.Object.prototype.or = function () {
	
	    var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
	    return this._dependency('or', null, peers);
	};
	
	
	internals.Object.prototype.and = function () {
	
	    var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
	    return this._dependency('and', null, peers);
	};
	
	
	internals.Object.prototype.nand = function () {
	
	    var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
	    return this._dependency('nand', null, peers);
	};
	
	
	internals.Object.prototype.requiredKeys = function (children) {
	
	    children = Hoek.flatten(Array.prototype.slice.call(arguments));
	    return this.applyFunctionToChildren(children, 'required');
	};
	
	
	internals.Object.prototype.optionalKeys = function (children) {
	
	    children = Hoek.flatten(Array.prototype.slice.call(arguments));
	    return this.applyFunctionToChildren(children, 'optional');
	};
	
	
	internals.renameDefaults = {
	    alias: false,                   // Keep old value in place
	    multiple: false,                // Allow renaming multiple keys into the same target
	    override: false                 // Overrides an existing key
	};
	
	
	internals.Object.prototype.rename = function (from, to, options) {
	
	    Hoek.assert(typeof from === 'string', 'Rename missing the from argument');
	    Hoek.assert(typeof to === 'string', 'Rename missing the to argument');
	    Hoek.assert(to !== from, 'Cannot rename key to same name:', from);
	
	    for (var i = 0, il = this._inner.renames.length; i < il; ++i) {
	        Hoek.assert(this._inner.renames[i].from !== from, 'Cannot rename the same key multiple times');
	    }
	
	    var obj = this.clone();
	
	    obj._inner.renames.push({
	        from: from,
	        to: to,
	        options: Hoek.applyToDefaults(internals.renameDefaults, options || {})
	    });
	
	    return obj;
	};
	
	
	internals.groupChildren = function (children) {
	
	    children.sort();
	
	    var grouped = {};
	
	    for (var c = 0, lc = children.length; c < lc; c++) {
	        var child = children[c];
	        Hoek.assert(typeof child === 'string', 'children must be strings');
	        var group = child.split('.')[0];
	        var childGroup = grouped[group] = (grouped[group] || []);
	        childGroup.push(child.substring(group.length + 1));
	    }
	
	    return grouped;
	};
	
	
	internals.Object.prototype.applyFunctionToChildren = function (children, fn, args, root) {
	
	    children = [].concat(children);
	    Hoek.assert(children.length > 0, 'expected at least one children');
	
	    var groupedChildren = internals.groupChildren(children);
	    var obj;
	
	    if ('' in groupedChildren) {
	        obj = this[fn].apply(this, args);
	        delete groupedChildren[''];
	    }
	    else {
	        obj = this.clone();
	    }
	
	    if (obj._inner.children) {
	        root = root ? (root + '.') : '';
	
	        for (var i = 0, il = obj._inner.children.length; i < il; ++i) {
	            var child = obj._inner.children[i];
	            var group = groupedChildren[child.key];
	
	            if (group) {
	                obj._inner.children[i] = {
	                    key: child.key,
	                    _refs: child._refs,
	                    schema: child.schema.applyFunctionToChildren(group, fn, args, root + child.key)
	                };
	
	                delete groupedChildren[child.key];
	            }
	        }
	    }
	
	    var remaining = Object.keys(groupedChildren);
	    Hoek.assert(remaining.length === 0, 'unknown key(s)', remaining.join(', '));
	
	    return obj;
	};
	
	
	internals.Object.prototype._dependency = function (type, key, peers) {
	
	    peers = [].concat(peers);
	    for (var i = 0, li = peers.length; i < li; i++) {
	        Hoek.assert(typeof peers[i] === 'string', type, 'peers must be a string or array of strings');
	    }
	
	    var obj = this.clone();
	    obj._inner.dependencies.push({ type: type, key: key, peers: peers });
	    return obj;
	};
	
	
	internals.with = function (value, peers, parent, state, options) {
	
	    if (value === undefined) {
	        return null;
	    }
	
	    for (var i = 0, il = peers.length; i < il; ++i) {
	        var peer = peers[i];
	        if (!Object.prototype.hasOwnProperty.call(parent, peer) ||
	            parent[peer] === undefined) {
	
	            return Errors.create('object.with', { peer: peer }, state, options);
	        }
	    }
	
	    return null;
	};
	
	
	internals.without = function (value, peers, parent, state, options) {
	
	    if (value === undefined) {
	        return null;
	    }
	
	    for (var i = 0, il = peers.length; i < il; ++i) {
	        var peer = peers[i];
	        if (Object.prototype.hasOwnProperty.call(parent, peer) &&
	            parent[peer] !== undefined) {
	
	            return Errors.create('object.without', { peer: peer }, state, options);
	        }
	    }
	
	    return null;
	};
	
	
	internals.xor = function (value, peers, parent, state, options) {
	
	    var present = [];
	    for (var i = 0, il = peers.length; i < il; ++i) {
	        var peer = peers[i];
	        if (Object.prototype.hasOwnProperty.call(parent, peer) &&
	            parent[peer] !== undefined) {
	
	            present.push(peer);
	        }
	    }
	
	    if (present.length === 1) {
	        return null;
	    }
	
	    if (present.length === 0) {
	        return Errors.create('object.missing', { peers: peers }, state, options);
	    }
	
	    return Errors.create('object.xor', { peers: peers }, state, options);
	};
	
	
	internals.or = function (value, peers, parent, state, options) {
	
	    for (var i = 0, il = peers.length; i < il; ++i) {
	        var peer = peers[i];
	        if (Object.prototype.hasOwnProperty.call(parent, peer) &&
	            parent[peer] !== undefined) {
	            return null;
	        }
	    }
	
	    return Errors.create('object.missing', { peers: peers }, state, options);
	};
	
	
	internals.and = function (value, peers, parent, state, options) {
	
	    var missing = [];
	    var present = [];
	    var count = peers.length;
	    for (var i = 0; i < count; ++i) {
	        var peer = peers[i];
	        if (!Object.prototype.hasOwnProperty.call(parent, peer) ||
	            parent[peer] === undefined) {
	
	            missing.push(peer);
	        }
	        else {
	            present.push(peer);
	        }
	    }
	
	    var aon = (missing.length === count || present.length === count);
	    return !aon ? Errors.create('object.and', { present: present, missing: missing }, state, options) : null;
	};
	
	
	internals.nand = function (value, peers, parent, state, options) {
	
	    var present = [];
	    for (var i = 0, il = peers.length; i < il; ++i) {
	        var peer = peers[i];
	        if (Object.prototype.hasOwnProperty.call(parent, peer) &&
	            parent[peer] !== undefined) {
	
	            present.push(peer);
	        }
	    }
	
	    var values = Hoek.clone(peers);
	    var main = values.splice(0, 1)[0];
	    var allPresent = (present.length === peers.length);
	    return allPresent ? Errors.create('object.nand', { main: main, peers: values }, state, options) : null;
	};
	
	
	internals.Object.prototype.describe = function (shallow) {
	
	    var description = Any.prototype.describe.call(this);
	
	    if (this._inner.children &&
	        !shallow) {
	
	        description.children = {};
	        for (var i = 0, il = this._inner.children.length; i < il; ++i) {
	            var child = this._inner.children[i];
	            description.children[child.key] = child.schema.describe();
	        }
	    }
	
	    if (this._inner.dependencies.length) {
	        description.dependencies = Hoek.clone(this._inner.dependencies);
	    }
	
	    if (this._inner.patterns.length) {
	        description.patterns = [];
	
	        for (var p = 0, pl = this._inner.patterns.length; p < pl; ++p) {
	            var pattern = this._inner.patterns[p];
	            description.patterns.push({ regex: pattern.regex.toString(), rule: pattern.rule.describe() });
	        }
	    }
	
	    return description;
	};
	
	
	internals.Object.prototype.assert = function (ref, schema, message) {
	
	    ref = Cast.ref(ref);
	    Hoek.assert(ref.isContext || ref.depth > 1, 'Cannot use assertions for root level references - use direct key rules instead');
	    message = message || 'pass the assertion test';
	
	    var cast;
	    try {
	        cast = Cast.schema(schema);
	    }
	    catch (castErr) {
	        if (castErr.hasOwnProperty('path')) {
	            castErr.message += '(' + castErr.path + ')';
	        }
	
	        throw castErr;
	    }
	
	    var key = ref.path[ref.path.length - 1];
	    var path = ref.path.join('.');
	
	    return this._test('assert', { cast: cast, ref: ref }, function (value, state, options) {
	
	        var result = cast._validate(ref(value), null, options, value);
	        if (!result.errors) {
	            return null;
	        }
	
	        var localState = Hoek.merge({}, state);
	        localState.key = key;
	        localState.path = path;
	        return Errors.create('object.assert', { ref: localState.path, message: message }, localState, options);
	    });
	};
	
	
	internals.Object.prototype.type = function (constructor, name) {
	
	    Hoek.assert(typeof constructor === 'function', 'type must be a constructor function');
	    name = name || constructor.name;
	
	    return this._test('type', name, function (value, state, options) {
	
	        if (value instanceof constructor) {
	            return null;
	        }
	
	        return Errors.create('object.type', { type: name }, state, options);
	    });
	};
	
	
	module.exports = new internals.Object();


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Load modules
	
	var Net = __webpack_require__(473);
	var Hoek = __webpack_require__(32);
	var Isemail = __webpack_require__(897);
	var Any = __webpack_require__(43);
	var Ref = __webpack_require__(66);
	var JoiDate = __webpack_require__(194);
	var Errors = __webpack_require__(47);
	var Uri = __webpack_require__(905);
	var Ip = __webpack_require__(904);
	
	// Declare internals
	
	var internals = {
	    uriRegex: Uri.createUriRegex(),
	    ipRegex: Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], 'optional')
	};
	
	internals.String = function () {
	
	    Any.call(this);
	    this._type = 'string';
	    this._invalids.add('');
	};
	
	Hoek.inherits(internals.String, Any);
	
	internals.compare = function (type, compare) {
	
	    return function (limit, encoding) {
	
	        var isRef = Ref.isRef(limit);
	
	        Hoek.assert((Hoek.isInteger(limit) && limit >= 0) || isRef, 'limit must be a positive integer or reference');
	        Hoek.assert(!encoding || Buffer.isEncoding(encoding), 'Invalid encoding:', encoding);
	
	        return this._test(type, limit, function (value, state, options) {
	
	            var compareTo;
	            if (isRef) {
	                compareTo = limit(state.parent, options);
	
	                if (!Hoek.isInteger(compareTo)) {
	                    return Errors.create('string.ref', { ref: limit.key }, state, options);
	                }
	            }
	            else {
	                compareTo = limit;
	            }
	
	            if (compare(value, compareTo, encoding)) {
	                return null;
	            }
	
	            return Errors.create('string.' + type, { limit: compareTo, value: value, encoding: encoding }, state, options);
	        });
	    };
	};
	
	internals.String.prototype._base = function (value, state, options) {
	
	    if (typeof value === 'string' &&
	        options.convert) {
	
	        if (this._flags.case) {
	            value = (this._flags.case === 'upper' ? value.toLocaleUpperCase() : value.toLocaleLowerCase());
	        }
	
	        if (this._flags.trim) {
	            value = value.trim();
	        }
	
	        if (this._inner.replacements) {
	
	            for (var r = 0, rl = this._inner.replacements.length; r < rl; ++r) {
	                var replacement = this._inner.replacements[r];
	                value = value.replace(replacement.pattern, replacement.replacement);
	            }
	        }
	    }
	
	    return {
	        value: value,
	        errors: (typeof value === 'string') ? null : Errors.create('string.base', { value: value }, state, options)
	    };
	};
	
	
	internals.String.prototype.insensitive = function () {
	
	    var obj = this.clone();
	    obj._flags.insensitive = true;
	    return obj;
	};
	
	
	internals.String.prototype.min = internals.compare('min', function (value, limit, encoding) {
	
	    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
	    return length >= limit;
	});
	
	
	internals.String.prototype.max = internals.compare('max', function (value, limit, encoding) {
	
	    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
	    return length <= limit;
	});
	
	
	internals.String.prototype.creditCard = function () {
	
	    return this._test('creditCard', undefined, function (value, state, options) {
	
	        var i = value.length;
	        var sum = 0;
	        var mul = 1;
	        var char;
	
	        while (i--) {
	            char = value.charAt(i) * mul;
	            sum += char - (char > 9) * 9;
	            mul ^= 3;
	        }
	
	        var check = (sum % 10 === 0) && (sum > 0);
	        return check ? null : Errors.create('string.creditCard', { value: value }, state, options);
	    });
	};
	
	internals.String.prototype.length = internals.compare('length', function (value, limit, encoding) {
	
	    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
	    return length === limit;
	});
	
	
	internals.String.prototype.regex = function (pattern, name) {
	
	    Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');
	
	    pattern = new RegExp(pattern.source, pattern.ignoreCase ? 'i' : undefined);         // Future version should break this and forbid unsupported regex flags
	
	    return this._test('regex', pattern, function (value, state, options) {
	
	        if (pattern.test(value)) {
	            return null;
	        }
	
	        return Errors.create((name ? 'string.regex.name' : 'string.regex.base'), { name: name, pattern: pattern, value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.alphanum = function () {
	
	    return this._test('alphanum', undefined, function (value, state, options) {
	
	        if (/^[a-zA-Z0-9]+$/.test(value)) {
	            return null;
	        }
	
	        return Errors.create('string.alphanum', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.token = function () {
	
	    return this._test('token', undefined, function (value, state, options) {
	
	        if (/^\w+$/.test(value)) {
	            return null;
	        }
	
	        return Errors.create('string.token', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.email = function (isEmailOptions) {
	
	    if (isEmailOptions) {
	        Hoek.assert(typeof isEmailOptions === 'object', 'email options must be an object');
	        Hoek.assert(typeof isEmailOptions.checkDNS === 'undefined', 'checkDNS option is not supported');
	        Hoek.assert(typeof isEmailOptions.tldWhitelist === 'undefined' ||
	            typeof isEmailOptions.tldWhitelist === 'object', 'tldWhitelist must be an array or object');
	        Hoek.assert(typeof isEmailOptions.minDomainAtoms === 'undefined' ||
	            Hoek.isInteger(isEmailOptions.minDomainAtoms) && isEmailOptions.minDomainAtoms > 0,
	            'minDomainAtoms must be a positive integer');
	        Hoek.assert(typeof isEmailOptions.errorLevel === 'undefined' || typeof isEmailOptions.errorLevel === 'boolean' ||
	            (Hoek.isInteger(isEmailOptions.errorLevel) && isEmailOptions.errorLevel >= 0),
	            'errorLevel must be a non-negative integer or boolean');
	    }
	
	    return this._test('email', isEmailOptions, function (value, state, options) {
	
	        try {
	            var result = Isemail(value, isEmailOptions);
	            if (result === true || result === 0) {
	                return null;
	            }
	        }
	        catch (e) {}
	
	        return Errors.create('string.email', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.ip = function (ipOptions) {
	
	    var regex = internals.ipRegex;
	    ipOptions = ipOptions || {};
	    Hoek.assert(typeof ipOptions === 'object', 'options must be an object');
	
	    if (ipOptions.cidr) {
	        Hoek.assert(typeof ipOptions.cidr === 'string', 'cidr must be a string');
	        ipOptions.cidr = ipOptions.cidr.toLowerCase();
	
	        Hoek.assert(ipOptions.cidr in Ip.cidrs, 'cidr must be one of ' + Object.keys(Ip.cidrs).join(', '));
	
	        // If we only received a `cidr` setting, create a regex for it. But we don't need to create one if `cidr` is "optional" since that is the default
	        if (!ipOptions.version && ipOptions.cidr !== 'optional') {
	            regex = Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], ipOptions.cidr);
	        }
	    }
	    else {
	
	        // Set our default cidr strategy
	        ipOptions.cidr = 'optional';
	    }
	
	    if (ipOptions.version) {
	        if (!Array.isArray(ipOptions.version)) {
	            ipOptions.version = [ipOptions.version];
	        }
	
	        Hoek.assert(ipOptions.version.length >= 1, 'version must have at least 1 version specified');
	
	        var versions = [];
	        for (var i = 0, il = ipOptions.version.length; i < il; ++i) {
	            var version = ipOptions.version[i];
	            Hoek.assert(typeof version === 'string', 'version at position ' + i + ' must be a string');
	            version = version.toLowerCase();
	            Hoek.assert(Ip.versions[version], 'version at position ' + i + ' must be one of ' + Object.keys(Ip.versions).join(', '));
	            versions.push(version);
	        }
	
	        // Make sure we have a set of versions
	        versions = Hoek.unique(versions);
	
	        regex = Ip.createIpRegex(versions, ipOptions.cidr);
	    }
	
	    return this._test('ip', ipOptions, function (value, state, options) {
	
	        if (regex.test(value)) {
	            return null;
	        }
	
	        if (versions) {
	            return Errors.create('string.ipVersion', { value: value, cidr: ipOptions.cidr, version: versions }, state, options);
	        }
	
	        return Errors.create('string.ip', { value: value, cidr: ipOptions.cidr }, state, options);
	    });
	};
	
	
	internals.String.prototype.uri = function (uriOptions) {
	
	    var customScheme = '',
	        regex = internals.uriRegex;
	
	    if (uriOptions) {
	        Hoek.assert(typeof uriOptions === 'object', 'options must be an object');
	
	        if (uriOptions.scheme) {
	            Hoek.assert(uriOptions.scheme instanceof RegExp || typeof uriOptions.scheme === 'string' || Array.isArray(uriOptions.scheme), 'scheme must be a RegExp, String, or Array');
	
	            if (!Array.isArray(uriOptions.scheme)) {
	                uriOptions.scheme = [uriOptions.scheme];
	            }
	
	            Hoek.assert(uriOptions.scheme.length >= 1, 'scheme must have at least 1 scheme specified');
	
	            // Flatten the array into a string to be used to match the schemes.
	            for (var i = 0, il = uriOptions.scheme.length; i < il; ++i) {
	                var scheme = uriOptions.scheme[i];
	                Hoek.assert(scheme instanceof RegExp || typeof scheme === 'string', 'scheme at position ' + i + ' must be a RegExp or String');
	
	                // Add OR separators if a value already exists
	                customScheme += customScheme ? '|' : '';
	
	                // If someone wants to match HTTP or HTTPS for example then we need to support both RegExp and String so we don't escape their pattern unknowingly.
	                if (scheme instanceof RegExp) {
	                    customScheme += scheme.source;
	                }
	                else {
	                    Hoek.assert(/[a-zA-Z][a-zA-Z0-9+-\.]*/.test(scheme), 'scheme at position ' + i + ' must be a valid scheme');
	                    customScheme += Hoek.escapeRegex(scheme);
	                }
	            }
	        }
	    }
	
	    if (customScheme) {
	        regex = Uri.createUriRegex(customScheme);
	    }
	
	    return this._test('uri', uriOptions, function (value, state, options) {
	
	        if (regex.test(value)) {
	            return null;
	        }
	
	        if (customScheme) {
	            return Errors.create('string.uriCustomScheme', { scheme: customScheme, value: value }, state, options);
	        }
	
	        return Errors.create('string.uri', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.isoDate = function () {
	
	    return this._test('isoDate', undefined, function (value, state, options) {
	
	        if (JoiDate._isIsoDate(value)) {
	            return null;
	        }
	
	        return Errors.create('string.isoDate', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.guid = function () {
	
	    var regex = /^[A-F0-9]{8}(?:-?[A-F0-9]{4}){3}-?[A-F0-9]{12}$/i;
	    var regex2 = /^\{[A-F0-9]{8}(?:-?[A-F0-9]{4}){3}-?[A-F0-9]{12}\}$/i;
	
	    return this._test('guid', undefined, function (value, state, options) {
	
	        if (regex.test(value) || regex2.test(value)) {
	            return null;
	        }
	
	        return Errors.create('string.guid', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.hex = function () {
	
	    var regex = /^[a-f0-9]+$/i;
	
	    return this._test('hex', regex, function (value, state, options) {
	
	        if (regex.test(value)) {
	            return null;
	        }
	
	        return Errors.create('string.hex', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.hostname = function () {
	
	    var regex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;
	
	    return this._test('hostname', undefined, function (value, state, options) {
	
	        if ((value.length <= 255 && regex.test(value)) ||
	            Net.isIPv6(value)) {
	
	            return null;
	        }
	
	        return Errors.create('string.hostname', { value: value }, state, options);
	    });
	};
	
	
	internals.String.prototype.lowercase = function () {
	
	    var obj = this._test('lowercase', undefined, function (value, state, options) {
	
	        if (options.convert ||
	            value === value.toLocaleLowerCase()) {
	
	            return null;
	        }
	
	        return Errors.create('string.lowercase', { value: value }, state, options);
	    });
	
	    obj._flags.case = 'lower';
	    return obj;
	};
	
	
	internals.String.prototype.uppercase = function () {
	
	    var obj = this._test('uppercase', undefined, function (value, state, options) {
	
	        if (options.convert ||
	            value === value.toLocaleUpperCase()) {
	
	            return null;
	        }
	
	        return Errors.create('string.uppercase', { value: value }, state, options);
	    });
	
	    obj._flags.case = 'upper';
	    return obj;
	};
	
	
	internals.String.prototype.trim = function () {
	
	    var obj = this._test('trim', undefined, function (value, state, options) {
	
	        if (options.convert ||
	            value === value.trim()) {
	
	            return null;
	        }
	
	        return Errors.create('string.trim', { value: value }, state, options);
	    });
	
	    obj._flags.trim = true;
	    return obj;
	};
	
	
	internals.String.prototype.replace = function (pattern, replacement) {
	
	    if (typeof pattern === 'string') {
	        pattern = new RegExp(Hoek.escapeRegex(pattern), 'g');
	    }
	
	    Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');
	    Hoek.assert(typeof replacement === 'string', 'replacement must be a String');
	
	    // This can not be considere a test like trim, we can't "reject"
	    // anything from this rule, so just clone the current object
	    var obj = this.clone();
	
	    if (!obj._inner.replacements) {
	        obj._inner.replacements = [];
	    }
	
	    obj._inner.replacements.push({
	        pattern: pattern,
	        replacement: replacement
	    });
	
	    return obj;
	};
	
	module.exports = new internals.String();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 329 */
/***/ function(module, exports) {

	var internals = {
	    rfc3986: {}
	};
	
	/**
	 * elements separated by forward slash ("/") are alternatives.
	 */
	var or = '|';
	
	/**
	 * DIGIT = %x30-39 ; 0-9
	 */
	var digit = '0-9';
	var digitOnly = '[' + digit + ']';
	
	/**
	 * ALPHA = %x41-5A / %x61-7A   ; A-Z / a-z
	 */
	var alpha = 'a-zA-Z';
	var alphaOnly = '[' + alpha + ']';
	
	/**
	 * cidr       = DIGIT                ; 0-9
	 *            / %x31-32 DIGIT         ; 10-29
	 *            / "3" %x30-32           ; 30-32
	 */
	internals.rfc3986.cidr = digitOnly + or + '[1-2]' + digitOnly + or + '3' + '[0-2]';
	
	/**
	 * HEXDIG = DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
	 */
	var hexDigit = digit + 'A-Fa-f',
	    hexDigitOnly = '[' + hexDigit + ']';
	
	/**
	 * unreserved = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 */
	var unreserved = alpha + digit + '-\\._~';
	
	/**
	 * sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
	 */
	var subDelims = '!\\$&\'\\(\\)\\*\\+,;=';
	
	/**
	 * pct-encoded = "%" HEXDIG HEXDIG
	 */
	var pctEncoded = '%' + hexDigit;
	
	/**
	 * pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
	 */
	var pchar = unreserved + pctEncoded + subDelims + ':@';
	var pcharOnly = '[' + pchar + ']';
	
	/**
	 * Rule to support zero-padded addresses.
	 */
	var zeroPad = '0?';
	
	/**
	 * dec-octet   = DIGIT                 ; 0-9
	 *            / %x31-39 DIGIT         ; 10-99
	 *            / "1" 2DIGIT            ; 100-199
	 *            / "2" %x30-34 DIGIT     ; 200-249
	 *            / "25" %x30-35          ; 250-255
	 */
	var decOctect = '(?:' + zeroPad + zeroPad + digitOnly + or + zeroPad + '[1-9]' + digitOnly + or + '1' + digitOnly + digitOnly + or + '2' + '[0-4]' + digitOnly + or + '25' + '[0-5])';
	
	/**
	 * IPv4address = dec-octet "." dec-octet "." dec-octet "." dec-octet
	 */
	internals.rfc3986.IPv4address = '(?:' + decOctect + '\\.){3}' + decOctect;
	
	/**
	 * h16 = 1*4HEXDIG ; 16 bits of address represented in hexadecimal
	 * ls32 = ( h16 ":" h16 ) / IPv4address ; least-significant 32 bits of address
	 * IPv6address =                            6( h16 ":" ) ls32
	 *             /                       "::" 5( h16 ":" ) ls32
	 *             / [               h16 ] "::" 4( h16 ":" ) ls32
	 *             / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
	 *             / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
	 *             / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
	 *             / [ *4( h16 ":" ) h16 ] "::"              ls32
	 *             / [ *5( h16 ":" ) h16 ] "::"              h16
	 *             / [ *6( h16 ":" ) h16 ] "::"
	 */
	var h16 = hexDigitOnly + '{1,4}';
	var ls32 = '(?:' + h16 + ':' + h16 + '|' + internals.rfc3986.IPv4address + ')';
	var IPv6SixHex = '(?:' + h16 + ':){6}' + ls32;
	var IPv6FiveHex = '::(?:' + h16 + ':){5}' + ls32;
	var IPv6FourHex = h16 + '::(?:' + h16 + ':){4}' + ls32;
	var IPv6ThreeHex = '(?:' + h16 + ':){0,1}' + h16 + '::(?:' + h16 + ':){3}' + ls32;
	var IPv6TwoHex = '(?:' + h16 + ':){0,2}' + h16 + '::(?:' + h16 + ':){2}' + ls32;
	var IPv6OneHex = '(?:' + h16 + ':){0,3}' + h16 + '::' + h16 + ':' + ls32;
	var IPv6NoneHex = '(?:' + h16 + ':){0,4}' + h16 + '::' + ls32;
	var IPv6NoneHex2 = '(?:' + h16 + ':){0,5}' + h16 + '::' + h16;
	var IPv6NoneHex3 = '(?:' + h16 + ':){0,6}' + h16 + '::';
	internals.rfc3986.IPv6address = '(?:' + IPv6SixHex + or + IPv6FiveHex + or + IPv6FourHex + or + IPv6ThreeHex + or + IPv6TwoHex + or + IPv6OneHex + or + IPv6NoneHex + or + IPv6NoneHex2 + or + IPv6NoneHex3 + ')';
	
	/**
	 * IPvFuture = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )
	 */
	internals.rfc3986.IPvFuture = 'v' + hexDigitOnly + '+\\.[' + unreserved + subDelims + ':]+';
	
	/**
	 * scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
	 */
	internals.rfc3986.scheme = alphaOnly + '[' + alpha + digit + '+-\\.]*';
	
	/**
	 * userinfo = *( unreserved / pct-encoded / sub-delims / ":" )
	 */
	var userinfo = '[' + unreserved + pctEncoded + subDelims + ':]*';
	
	/**
	 * IP-literal = "[" ( IPv6address / IPvFuture  ) "]"
	 */
	var IPLiteral = '\\[(?:' + internals.rfc3986.IPv6address + or + internals.rfc3986.IPvFuture + ')\\]';
	
	/**
	 * reg-name = *( unreserved / pct-encoded / sub-delims )
	 */
	var regName = '[' + unreserved + pctEncoded + subDelims + ']{0,255}';
	
	/**
	 * host = IP-literal / IPv4address / reg-name
	 */
	var host = '(?:' + IPLiteral + or + internals.rfc3986.IPv4address + or + regName + ')';
	
	/**
	 * port = *DIGIT
	 */
	var port = digitOnly + '*';
	
	/**
	 * authority   = [ userinfo "@" ] host [ ":" port ]
	 */
	var authority = '(?:' + userinfo + '@)?' + host + '(?::' + port + ')?';
	
	/**
	 * segment       = *pchar
	 * segment-nz    = 1*pchar
	 * path          = path-abempty    ; begins with "/" or is empty
	 *               / path-absolute   ; begins with "/" but not "//"
	 *               / path-noscheme   ; begins with a non-colon segment
	 *               / path-rootless   ; begins with a segment
	 *               / path-empty      ; zero characters
	 * path-abempty  = *( "/" segment )
	 * path-absolute = "/" [ segment-nz *( "/" segment ) ]
	 * path-rootless = segment-nz *( "/" segment )
	 */
	var segment = pcharOnly + '*';
	var segmentNz = pcharOnly + '+';
	var pathAbEmpty = '(?:\\/' + segment + ')*';
	var pathAbsolute = '\\/(?:' + segmentNz + pathAbEmpty + ')?';
	var pathRootless = segmentNz + pathAbEmpty;
	
	/**
	 * hier-part = "//" authority path
	 */
	internals.rfc3986.hierPart = '(?:\\/\\/' + authority + pathAbEmpty + or + pathAbsolute + or + pathRootless + ')';
	
	/**
	 * query = *( pchar / "/" / "?" )
	 */
	internals.rfc3986.query = '[' + pchar + '\\/\\?]*(?=#|$)'; //Finish matching either at the fragment part or end of the line.
	
	/**
	 * fragment = *( pchar / "/" / "?" )
	 */
	internals.rfc3986.fragment = '[' + pchar + '\\/\\?]*';
	
	module.exports = internals.rfc3986;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var jws = __webpack_require__(195);
	
	module.exports = function (jwt, options) {
	  options = options || {};
	  var decoded = jws.decode(jwt, options);
	  if (!decoded) { return null; }
	  var payload = decoded.payload;
	
	  //try parse the payload
	  if(typeof payload === 'string') {
	    try {
	      var obj = JSON.parse(payload);
	      if(typeof obj === 'object') {
	        payload = obj;
	      }
	    } catch (e) { }
	  }
	
	  //return header if `complete` option is enabled.  header includes claims
	  //such as `kid` and `alg` used to select the key within a JWKS needed to
	  //verify the signature
	  if (options.complete === true) {
	    return {
	      header: decoded.header,
	      payload: payload,
	      signature: decoded.signature
	    };
	  }
	  return payload;
	};


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  decode: __webpack_require__(330),
	  verify: __webpack_require__(908),
	  sign: __webpack_require__(907),
	  JsonWebTokenError: __webpack_require__(137),
	  NotBeforeError: __webpack_require__(332),
	  TokenExpiredError: __webpack_require__(333),
	};


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(137);
	
	var NotBeforeError = function (message, date) {
	  JsonWebTokenError.call(this, message);
	  this.name = 'NotBeforeError';
	  this.date = date;
	};
	
	NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);
	
	NotBeforeError.prototype.constructor = NotBeforeError;
	
	module.exports = NotBeforeError;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(137);
	
	var TokenExpiredError = function (message, expiredAt) {
	  JsonWebTokenError.call(this, message);
	  this.name = 'TokenExpiredError';
	  this.expiredAt = expiredAt;
	};
	
	TokenExpiredError.prototype = Object.create(JsonWebTokenError.prototype);
	
	TokenExpiredError.prototype.constructor = TokenExpiredError;
	
	module.exports = TokenExpiredError;

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var bufferEqual = __webpack_require__(655);
	var Buffer = __webpack_require__(118).Buffer;
	var crypto = __webpack_require__(270);
	var formatEcdsa = __webpack_require__(821);
	var util = __webpack_require__(59);
	
	var MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".'
	var MSG_INVALID_SECRET = 'secret must be a string or buffer';
	var MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
	var MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
	
	var supportsKeyObjects = typeof crypto.createPublicKey === 'function';
	if (supportsKeyObjects) {
	  MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
	  MSG_INVALID_SECRET += 'or a KeyObject';
	}
	
	function checkIsPublicKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return;
	  }
	
	  if (!supportsKeyObjects) {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key !== 'object') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.type !== 'string') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.asymmetricKeyType !== 'string') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.export !== 'function') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	};
	
	function checkIsPrivateKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return;
	  }
	
	  if (typeof key === 'object') {
	    return;
	  }
	
	  throw typeError(MSG_INVALID_SIGNER_KEY);
	};
	
	function checkIsSecretKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return key;
	  }
	
	  if (!supportsKeyObjects) {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (typeof key !== 'object') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (key.type !== 'secret') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (typeof key.export !== 'function') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	}
	
	function fromBase64(base64) {
	  return base64
	    .replace(/=/g, '')
	    .replace(/\+/g, '-')
	    .replace(/\//g, '_');
	}
	
	function toBase64(base64url) {
	  base64url = base64url.toString();
	
	  var padding = 4 - base64url.length % 4;
	  if (padding !== 4) {
	    for (var i = 0; i < padding; ++i) {
	      base64url += '=';
	    }
	  }
	
	  return base64url
	    .replace(/\-/g, '+')
	    .replace(/_/g, '/');
	}
	
	function typeError(template) {
	  var args = [].slice.call(arguments, 1);
	  var errMsg = util.format.bind(util, template).apply(null, args);
	  return new TypeError(errMsg);
	}
	
	function bufferOrString(obj) {
	  return Buffer.isBuffer(obj) || typeof obj === 'string';
	}
	
	function normalizeInput(thing) {
	  if (!bufferOrString(thing))
	    thing = JSON.stringify(thing);
	  return thing;
	}
	
	function createHmacSigner(bits) {
	  return function sign(thing, secret) {
	    checkIsSecretKey(secret);
	    thing = normalizeInput(thing);
	    var hmac = crypto.createHmac('sha' + bits, secret);
	    var sig = (hmac.update(thing), hmac.digest('base64'))
	    return fromBase64(sig);
	  }
	}
	
	function createHmacVerifier(bits) {
	  return function verify(thing, signature, secret) {
	    var computedSig = createHmacSigner(bits)(thing, secret);
	    return bufferEqual(Buffer.from(signature), Buffer.from(computedSig));
	  }
	}
	
	function createKeySigner(bits) {
	 return function sign(thing, privateKey) {
	    checkIsPrivateKey(privateKey);
	    thing = normalizeInput(thing);
	    // Even though we are specifying "RSA" here, this works with ECDSA
	    // keys as well.
	    var signer = crypto.createSign('RSA-SHA' + bits);
	    var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
	    return fromBase64(sig);
	  }
	}
	
	function createKeyVerifier(bits) {
	  return function verify(thing, signature, publicKey) {
	    checkIsPublicKey(publicKey);
	    thing = normalizeInput(thing);
	    signature = toBase64(signature);
	    var verifier = crypto.createVerify('RSA-SHA' + bits);
	    verifier.update(thing);
	    return verifier.verify(publicKey, signature, 'base64');
	  }
	}
	
	function createPSSKeySigner(bits) {
	  return function sign(thing, privateKey) {
	    checkIsPrivateKey(privateKey);
	    thing = normalizeInput(thing);
	    var signer = crypto.createSign('RSA-SHA' + bits);
	    var sig = (signer.update(thing), signer.sign({
	      key: privateKey,
	      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
	      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
	    }, 'base64'));
	    return fromBase64(sig);
	  }
	}
	
	function createPSSKeyVerifier(bits) {
	  return function verify(thing, signature, publicKey) {
	    checkIsPublicKey(publicKey);
	    thing = normalizeInput(thing);
	    signature = toBase64(signature);
	    var verifier = crypto.createVerify('RSA-SHA' + bits);
	    verifier.update(thing);
	    return verifier.verify({
	      key: publicKey,
	      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
	      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
	    }, signature, 'base64');
	  }
	}
	
	function createECDSASigner(bits) {
	  var inner = createKeySigner(bits);
	  return function sign() {
	    var signature = inner.apply(null, arguments);
	    signature = formatEcdsa.derToJose(signature, 'ES' + bits);
	    return signature;
	  };
	}
	
	function createECDSAVerifer(bits) {
	  var inner = createKeyVerifier(bits);
	  return function verify(thing, signature, publicKey) {
	    signature = formatEcdsa.joseToDer(signature, 'ES' + bits).toString('base64');
	    var result = inner(thing, signature, publicKey);
	    return result;
	  };
	}
	
	function createNoneSigner() {
	  return function sign() {
	    return '';
	  }
	}
	
	function createNoneVerifier() {
	  return function verify(thing, signature) {
	    return signature === '';
	  }
	}
	
	module.exports = function jwa(algorithm) {
	  var signerFactories = {
	    hs: createHmacSigner,
	    rs: createKeySigner,
	    ps: createPSSKeySigner,
	    es: createECDSASigner,
	    none: createNoneSigner,
	  }
	  var verifierFactories = {
	    hs: createHmacVerifier,
	    rs: createKeyVerifier,
	    ps: createPSSKeyVerifier,
	    es: createECDSAVerifer,
	    none: createNoneVerifier,
	  }
	  var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
	  if (!match)
	    throw typeError(MSG_INVALID_ALGORITHM, algorithm);
	  var algo = (match[1] || match[3]).toLowerCase();
	  var bits = match[2];
	
	  return {
	    sign: signerFactories[algo](bits),
	    verify: verifierFactories[algo](bits),
	  }
	};


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*global module, process*/
	var Buffer = __webpack_require__(118).Buffer;
	var Stream = __webpack_require__(68);
	var util = __webpack_require__(59);
	
	function DataStream(data) {
	  this.buffer = null;
	  this.writable = true;
	  this.readable = true;
	
	  // No input
	  if (!data) {
	    this.buffer = Buffer.alloc(0);
	    return this;
	  }
	
	  // Stream
	  if (typeof data.pipe === 'function') {
	    this.buffer = Buffer.alloc(0);
	    data.pipe(this);
	    return this;
	  }
	
	  // Buffer or String
	  // or Object (assumedly a passworded key)
	  if (data.length || typeof data === 'object') {
	    this.buffer = data;
	    this.writable = false;
	    process.nextTick(function () {
	      this.emit('end', data);
	      this.readable = false;
	      this.emit('close');
	    }.bind(this));
	    return this;
	  }
	
	  throw new TypeError('Unexpected data type ('+ typeof data + ')');
	}
	util.inherits(DataStream, Stream);
	
	DataStream.prototype.write = function write(data) {
	  this.buffer = Buffer.concat([this.buffer, Buffer.from(data)]);
	  this.emit('data', data);
	};
	
	DataStream.prototype.end = function end(data) {
	  if (data)
	    this.write(data);
	  this.emit('end', data);
	  this.emit('close');
	  this.writable = false;
	  this.readable = false;
	};
	
	module.exports = DataStream;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(18).Buffer;
	
	module.exports = function toString(obj) {
	  if (typeof obj === 'string')
	    return obj;
	  if (typeof obj === 'number' || Buffer.isBuffer(obj))
	    return obj.toString();
	  return JSON.stringify(obj);
	};


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(56);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 339 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 340 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 341 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 342 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(107),
	    isObject = __webpack_require__(345);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 344 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 345 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports) {



/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(564);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _react2['default'].PropTypes.bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _react2['default'].PropTypes.string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _react2['default'].PropTypes.node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(150);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(109);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _react2['default'].PropTypes.bool,
	  justified: _react2['default'].PropTypes.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(1012);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _react2['default'].PropTypes.func,
	  active: _react2['default'].PropTypes.bool,
	  animateIn: _react2['default'].PropTypes.bool,
	  animateOut: _react2['default'].PropTypes.bool,
	  index: _react2['default'].PropTypes.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(109);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _react2['default'].PropTypes.bool,
	  open: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.string,
	  useAnchor: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _react2['default'].PropTypes.bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(80);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.any,
	  disabled: _react2['default'].PropTypes.any,
	  header: _react2['default'].PropTypes.node,
	  listItem: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  href: _react2['default'].PropTypes.string,
	  type: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _react2['default'].PropTypes.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _react2['default'].PropTypes.shape({
	    onHide: _react2['default'].PropTypes.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(196);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(150);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _react2['default'].PropTypes.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _react2['default'].PropTypes.bool,
	
	  justified: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _react2['default'].PropTypes.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string,
	    onSelect: _react2['default'].PropTypes.func
	  }),
	
	  $bs_tabContainer: _react2['default'].PropTypes.shape({
	    activeKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func.isRequired,
	    getTabId: _react2['default'].PropTypes.func.isRequired,
	    getPaneId: _react2['default'].PropTypes.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  role: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  onSelect: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Overlay = __webpack_require__(1112);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(141);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2['default'].PropTypes.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _react2['default'].PropTypes.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Use animation
	   */
	  animation: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _react2['default'].PropTypes.bool,
	  previous: _react2['default'].PropTypes.bool,
	  next: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  onSelect: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(493);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _react2['default'].PropTypes.bool,
	  activeKey: _react2['default'].PropTypes.any,
	  defaultActiveKey: _react2['default'].PropTypes.any,
	  onSelect: _react2['default'].PropTypes.func,
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(141);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _react.PropTypes.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _react.PropTypes.string,
	
	  /** @private **/
	  'aria-labelledby': _react.PropTypes.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _react.PropTypes.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _react.PropTypes.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _react.PropTypes.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _react.PropTypes.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _react.PropTypes.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _react.PropTypes.func,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _react.PropTypes.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _react.PropTypes.shape({
	    getId: _react.PropTypes.func,
	    unmountOnExit: _react.PropTypes.bool
	  }),
	  $bs_tabContent: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	    activeKey: _react.PropTypes.any,
	    unmountOnExit: _react.PropTypes.bool,
	    onPaneEnter: _react.PropTypes.func.isRequired,
	    onPaneExited: _react.PropTypes.func.isRequired,
	    exiting: _react.PropTypes.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _react.PropTypes.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 492 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(657), __esModule: true };

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(659), __esModule: true };

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(37);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectAssign = __webpack_require__(1021);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _object = __webpack_require__(940);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _addEventListener = __webpack_require__(1020);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {};
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	        _this.state = {
	            isActive: false,
	            isPositionOutside: true,
	            position: {
	                x: 0,
	                y: 0
	            }
	        };
	
	        _this.eventListeners = [];
	
	        _this.elementOffset = {
	            x: 0,
	            y: 0,
	            h: 0,
	            w: 0
	        };
	
	        _this.onTouchStart = _this.onTouchStart.bind(_this);
	        _this.onTouchMove = _this.onTouchMove.bind(_this);
	        _this.deactivate = _this.deactivate.bind(_this);
	        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	        _this.onMouseMove = _this.onMouseMove.bind(_this);
	        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'onTouchStart',
	        value: function onTouchStart(e) {
	            var position = this.getDocumentRelativePosition(this.getTouchEvent(e));
	            this.elementOffset = this.getDocumentRelativeElementOffset(e.currentTarget);
	            this.setPositionState(position);
	
	            if (this.props.isActivatedOnTouch) {
	                e.preventDefault();
	                this.activate();
	                return;
	            }
	
	            this.initPressEventCriteria(position);
	            this.setPressEventTimer();
	        }
	    }, {
	        key: 'onTouchMove',
	        value: function onTouchMove(e) {
	            var position = this.getDocumentRelativePosition(this.getTouchEvent(e));
	
	            if (!this.state.isActive) {
	                this.setPressEventCriteria(position);
	                return;
	            }
	
	            this.setPositionState(position);
	            e.preventDefault();
	        }
	    }, {
	        key: 'onMouseEnter',
	        value: function onMouseEnter(e) {
	            this.elementOffset = this.getDocumentRelativeElementOffset(e.currentTarget);
	            this.activate();
	            this.setPositionState(this.getDocumentRelativePosition(e));
	        }
	    }, {
	        key: 'onMouseMove',
	        value: function onMouseMove(e) {
	            this.setPositionState(this.getDocumentRelativePosition(e));
	        }
	    }, {
	        key: 'onMouseLeave',
	        value: function onMouseLeave() {
	            this.setState({
	                isPositionOutside: true
	            });
	
	            this.deactivate();
	        }
	    }, {
	        key: 'activate',
	        value: function activate() {
	            this.setState({
	                isActive: true
	            });
	
	            this.props.onActivationChanged({ isActive: true });
	        }
	    }, {
	        key: 'deactivate',
	        value: function deactivate() {
	            var _this2 = this;
	
	            this.clearPressDurationTimer();
	
	            this.setState({
	                isActive: false
	            }, function () {
	                var _state = _this2.state,
	                    isPositionOutside = _state.isPositionOutside,
	                    position = _state.position;
	
	                _this2.props.onPositionChanged({
	                    isPositionOutside: isPositionOutside,
	                    position: position
	                });
	            });
	
	            this.props.onActivationChanged({ isActive: false });
	        }
	    }, {
	        key: 'setPositionState',
	        value: function setPositionState(position) {
	            var _this3 = this;
	
	            var offsetPosition = this.getOffsetPosition(position);
	            var isPositionOutside = this.getIsPositionOutside(position);
	
	            this.setState({
	                isPositionOutside: isPositionOutside,
	                position: offsetPosition
	            }, function () {
	                _this3.triggerOnPositionChanged();
	            });
	        }
	    }, {
	        key: 'setPressEventTimer',
	        value: function setPressEventTimer() {
	            var _this4 = this;
	
	            var _props = this.props,
	                pressDuration = _props.pressDuration,
	                pressMoveThreshold = _props.pressMoveThreshold;
	
	
	            this.pressDurationTimerId = setTimeout(function () {
	                if (Math.abs(_this4.currentElTop - _this4.initialElTop) < pressMoveThreshold) {
	                    _this4.activate();
	                }
	            }, pressDuration);
	        }
	    }, {
	        key: 'setPressEventCriteria',
	        value: function setPressEventCriteria(position) {
	            this.currentElTop = position.y;
	        }
	    }, {
	        key: 'initPressEventCriteria',
	        value: function initPressEventCriteria(position) {
	            var top = position.y;
	            this.initialElTop = top;
	            this.currentElTop = top;
	        }
	    }, {
	        key: 'getIsPositionOutside',
	        value: function getIsPositionOutside(position) {
	            var x = position.x,
	                y = position.y;
	            var _elementOffset = this.elementOffset,
	                elx = _elementOffset.x,
	                ely = _elementOffset.y,
	                elw = _elementOffset.w,
	                elh = _elementOffset.h;
	
	
	            return x < elx || x > elx + elw || y < ely || y > ely + elh;
	        }
	    }, {
	        key: 'getOffsetPosition',
	        value: function getOffsetPosition(position) {
	            var cursorX = position.x,
	                cursorY = position.y;
	            var _elementOffset2 = this.elementOffset,
	                offsetX = _elementOffset2.x,
	                offsetY = _elementOffset2.y;
	
	
	            return {
	                x: cursorX - offsetX,
	                y: cursorY - offsetY
	            };
	        }
	    }, {
	        key: 'getDocumentRelativeElementOffset',
	        value: function getDocumentRelativeElementOffset(el) {
	            var rootEl = this.getRootOfEl(el);
	
	            var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
	                docLeft = _rootEl$getBoundingCl.left,
	                docTop = _rootEl$getBoundingCl.top;
	
	            var _el$getBoundingClient = el.getBoundingClientRect(),
	                elLeft = _el$getBoundingClient.left,
	                elTop = _el$getBoundingClient.top,
	                w = _el$getBoundingClient.width,
	                h = _el$getBoundingClient.height;
	
	            return {
	                x: Math.abs(docLeft) + elLeft,
	                y: Math.abs(docTop) + elTop,
	                h: h,
	                w: w
	            };
	        }
	    }, {
	        key: 'getRootOfEl',
	        value: function getRootOfEl(el) {
	            if (el.parentElement) {
	                return this.getRootOfEl(el.parentElement);
	            }
	            return el;
	        }
	    }, {
	        key: 'getDocumentRelativePosition',
	        value: function getDocumentRelativePosition(event) {
	            return {
	                x: event.pageX,
	                y: event.pageY
	            };
	        }
	    }, {
	        key: 'getTouchEvent',
	        value: function getTouchEvent(e) {
	            return e.touches[0];
	        }
	    }, {
	        key: 'triggerOnPositionChanged',
	        value: function triggerOnPositionChanged() {
	            var _state2 = this.state,
	                isPositionOutside = _state2.isPositionOutside,
	                position = _state2.position;
	
	            this.props.onPositionChanged({
	                isPositionOutside: isPositionOutside,
	                position: position
	            });
	        }
	    }, {
	        key: 'isReactComponent',
	        value: function isReactComponent(reactElement) {
	            return typeof reactElement.type === 'function';
	        }
	    }, {
	        key: 'shouldDecorateChild',
	        value: function shouldDecorateChild(child) {
	            return this.isReactComponent(child) && this.props.shouldDecorateChildren;
	        }
	    }, {
	        key: 'decorateChild',
	        value: function decorateChild(child, props) {
	            return (0, _react.cloneElement)(child, props);
	        }
	    }, {
	        key: 'decorateChildren',
	        value: function decorateChildren(children, props) {
	            var _this5 = this;
	
	            return _react.Children.map(children, function (child) {
	                return _this5.shouldDecorateChild(child) ? _this5.decorateChild(child, props) : child;
	            });
	        }
	    }, {
	        key: 'clearPressDurationTimer',
	        value: function clearPressDurationTimer() {
	            clearTimeout(this.pressDurationTimerId);
	        }
	    }, {
	        key: 'addEventListeners',
	        value: function addEventListeners() {
	            this.eventListeners.push((0, _addEventListener2.default)(this.el, 'touchstart', this.onTouchStart, { passive: false }), (0, _addEventListener2.default)(this.el, 'touchmove', this.onTouchMove, { passive: false }), (0, _addEventListener2.default)(this.el, 'touchend', this.deactivate, { passive: true }), (0, _addEventListener2.default)(this.el, 'touchcancel', this.deactivate, { passive: true }));
	        }
	    }, {
	        key: 'removeEventListeners',
	        value: function removeEventListeners() {
	            while (this.eventListeners.length) {
	                this.eventListeners.pop().removeEventListener();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.addEventListeners();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearPressDurationTimer();
	            this.removeEventListeners();
	        }
	    }, {
	        key: 'getPassThroughProps',
	        value: function getPassThroughProps() {
	            var ownPropNames = Object.keys(this.constructor.propTypes);
	            return (0, _object2.default)(this.props, ownPropNames);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props2 = this.props,
	                children = _props2.children,
	                className = _props2.className,
	                mapChildProps = _props2.mapChildProps,
	                style = _props2.style;
	            var _state3 = this.state,
	                isActive = _state3.isActive,
	                isPositionOutside = _state3.isPositionOutside,
	                position = _state3.position;
	
	            var props = (0, _objectAssign2.default)({}, mapChildProps({
	                isActive: isActive,
	                isPositionOutside: isPositionOutside,
	                position: position
	            }), this.getPassThroughProps());
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: className,
	                    onMouseMove: this.onMouseMove,
	                    onMouseEnter: this.onMouseEnter,
	                    onMouseLeave: this.onMouseLeave,
	                    ref: function ref(el) {
	                        return _this6.el = el;
	                    },
	                    style: (0, _objectAssign2.default)({}, style, {
	                        WebkitUserSelect: 'none'
	                    })
	                },
	                this.decorateChildren(children, props)
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component);
	
	_class.displayName = 'ReactCursorPosition';
	_class.propTypes = {
	    children: _propTypes2.default.any,
	    className: _propTypes2.default.string,
	    isActivatedOnTouch: _propTypes2.default.bool,
	    mapChildProps: _propTypes2.default.func,
	    onActivationChanged: _propTypes2.default.func,
	    onPositionChanged: _propTypes2.default.func,
	    pressDuration: _propTypes2.default.number,
	    pressMoveThreshold: _propTypes2.default.number,
	    shouldDecorateChildren: _propTypes2.default.bool,
	    style: _propTypes2.default.object
	};
	_class.defaultProps = {
	    isActivatedOnTouch: false,
	    mapChildProps: function mapChildProps(props) {
	        return props;
	    },
	    onActivationChanged: noop,
	    onPositionChanged: noop,
	    pressDuration: 500,
	    pressMoveThreshold: 5,
	    shouldDecorateChildren: true
	};
	exports.default = _class;
	;

/***/ },
/* 496 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(67);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(82);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(41);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1085);
	var warning = __webpack_require__(12);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 499 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var LinkedValueUtils = __webpack_require__(209);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(45);
	
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 501 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 502 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var invariant = __webpack_require__(11);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1044);
	
	var containsNode = __webpack_require__(860);
	var focusNode = __webpack_require__(314);
	var getActiveElement = __webpack_require__(315);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var DOMLazyTree = __webpack_require__(81);
	var DOMProperty = __webpack_require__(82);
	var React = __webpack_require__(87);
	var ReactBrowserEventEmitter = __webpack_require__(143);
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMContainerInfo = __webpack_require__(1038);
	var ReactDOMFeatureFlags = __webpack_require__(1040);
	var ReactFeatureFlags = __webpack_require__(502);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(41);
	var ReactMarkupChecksum = __webpack_require__(1054);
	var ReactReconciler = __webpack_require__(83);
	var ReactUpdateQueue = __webpack_require__(212);
	var ReactUpdates = __webpack_require__(45);
	
	var emptyObject = __webpack_require__(77);
	var instantiateReactComponent = __webpack_require__(512);
	var invariant = __webpack_require__(11);
	var setInnerHTML = __webpack_require__(147);
	var shouldUpdateReactComponent = __webpack_require__(218);
	var warning = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var React = __webpack_require__(87);
	
	var invariant = __webpack_require__(11);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 507 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 509 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(506);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var ReactCompositeComponent = __webpack_require__(1035);
	var ReactEmptyComponent = __webpack_require__(501);
	var ReactHostComponent = __webpack_require__(503);
	
	var getNextDebugID = __webpack_require__(1082);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 513 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var escapeTextContentForBrowser = __webpack_require__(146);
	var setInnerHTML = __webpack_require__(147);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var ReactCurrentOwner = __webpack_require__(49);
	var REACT_ELEMENT_TYPE = __webpack_require__(1050);
	
	var getIteratorFn = __webpack_require__(1081);
	var invariant = __webpack_require__(11);
	var KeyEscapeUtils = __webpack_require__(208);
	var warning = __webpack_require__(12);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 516 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(37), __webpack_require__(94), __webpack_require__(220), __webpack_require__(1102)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('prop-types'), require('clamp'), require('./ImageShape'), require('./Point'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.propTypes, global.clamp, global.ImageShape, global.Point);
	        global.EnlargedImage = mod.exports;
	    }
	})(this, function (exports, _react, _propTypes, _clamp, _ImageShape, _Point) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    var _clamp2 = _interopRequireDefault(_clamp);
	
	    var _ImageShape2 = _interopRequireDefault(_ImageShape);
	
	    var _Point2 = _interopRequireDefault(_Point);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _extends = Object.assign || function (target) {
	        for (var i = 1; i < arguments.length; i++) {
	            var source = arguments[i];
	
	            for (var key in source) {
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	
	        return target;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var _class = function (_React$Component) {
	        _inherits(_class, _React$Component);
	
	        function _class(props) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	            _this.state = {
	                isTransitionEntering: false,
	                isTransitionActive: false,
	                isTransitionLeaving: false,
	                isTransitionDone: false
	            };
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var _this2 = this;
	
	                var isHovering = nextProps.isHovering;
	
	
	                if (isHovering === this.props.isHovering) {
	                    return;
	                }
	
	                if (isHovering) {
	                    this.setState({
	                        isTransitionEntering: true
	                    });
	
	                    setTimeout(function () {
	                        _this2.setState({
	                            isTransitionEntering: false,
	                            isTransitionActive: true
	                        });
	                    }, 0);
	                } else {
	                    this.setState({
	                        isTransitionActive: false,
	                        isTransitionLeaving: true
	                    });
	
	                    setTimeout(function () {
	                        _this2.setState({
	                            isTransitionLeaving: false
	                        });
	                    }, this.props.fadeDurationInMs);
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _props = this.props,
	                    containerClassName = _props.containerClassName,
	                    containerStyle = _props.containerStyle,
	                    cursorOffset = _props.cursorOffset,
	                    position = _props.position,
	                    fadeDurationInMs = _props.fadeDurationInMs,
	                    imageClassName = _props.imageClassName,
	                    imageStyle = _props.imageStyle,
	                    isRenderOnDemand = _props.isRenderOnDemand,
	                    largeImage = _props.largeImage,
	                    smallImage = _props.smallImage,
	                    imagePosition = _props.imagePosition;
	                var _state = this.state,
	                    isTransitionEntering = _state.isTransitionEntering,
	                    isTransitionActive = _state.isTransitionActive,
	                    isTransitionLeaving = _state.isTransitionLeaving;
	
	
	                var offsetRatio = {
	                    x: largeImage.width / smallImage.width,
	                    y: largeImage.height / smallImage.height
	                };
	
	                var differentiatedImageCoordinates = {
	                    x: Math.round((position.x - cursorOffset.x) * offsetRatio.x) * -1,
	                    y: Math.round((position.y - cursorOffset.y) * offsetRatio.y) * -1
	                };
	
	                var minCoordinates = {
	                    x: (largeImage.width - smallImage.width) * -1,
	                    y: (largeImage.height - smallImage.height) * -1
	                };
	
	                var maxCoordinate = 0;
	
	                var imageCoordinates = {
	                    x: (0, _clamp2.default)(differentiatedImageCoordinates.x, minCoordinates.x, maxCoordinate),
	                    y: (0, _clamp2.default)(differentiatedImageCoordinates.y, minCoordinates.y, maxCoordinate)
	                };
	
	                var isVisible = void 0;
	                if (isTransitionEntering || isTransitionActive || isTransitionLeaving) {
	                    isVisible = true;
	                } else {
	                    isVisible = false;
	                }
	
	                var imgDataHover = void 0;
	                var defaultContainerStyle = {
	                    position: 'absolute',
	                    top: '0px',
	
	                    overflow: 'hidden'
	                };
	
	                switch (imagePosition) {
	                    case 'over':
	                        imgDataHover = true;
	                        defaultContainerStyle = Object.assign({}, defaultContainerStyle, {
	                            left: '0px'
	                        });
	                        break;
	
	                    case 'beside':
	                    default:
	                        imgDataHover = false;
	                        defaultContainerStyle = Object.assign({}, defaultContainerStyle, {
	                            left: '100%',
	                            marginLeft: '10px',
	                            border: '1px solid #d6d6d6'
	                        });
	                        break;
	                }
	
	                var computedContainerStyle = {
	                    width: smallImage.width,
	                    height: smallImage.height,
	                    opacity: this.state.isTransitionActive ? 1 : 0,
	                    transition: 'opacity ' + fadeDurationInMs + 'ms ease-in'
	                };
	
	                var translate = 'translate(' + imageCoordinates.x + 'px, ' + imageCoordinates.y + 'px)';
	
	                var computedImageStyle = {
	                    width: largeImage.width,
	                    height: largeImage.height,
	                    transform: translate,
	                    WebkitTransform: translate,
	                    msTransform: translate
	                };
	
	                var component = _react2.default.createElement(
	                    'div',
	                    {
	                        className: containerClassName,
	                        key: 'enlarged',
	                        style: Object.assign({}, defaultContainerStyle, containerStyle, computedContainerStyle)
	                    },
	                    _react2.default.createElement('img', _extends({ 'data-hover': imgDataHover }, {
	                        alt: largeImage.alt,
	                        className: imageClassName,
	                        src: largeImage.src,
	                        srcSet: largeImage.srcSet,
	                        sizes: largeImage.sizes,
	                        style: Object.assign({}, imageStyle, computedImageStyle)
	                    }))
	                );
	
	                if (isRenderOnDemand) {
	                    return isVisible ? component : null;
	                }
	
	                return component;
	            }
	        }]);
	
	        return _class;
	    }(_react2.default.Component);
	
	    _class.displayName = 'EnlargedImage';
	    _class.defaultProps = {
	        fadeDurationInMs: 0,
	        isRenderOnDemand: true
	    };
	    _class.propTypes = {
	        containerClassName: _propTypes2.default.string,
	        containerStyle: _propTypes2.default.object,
	        cursorOffset: _Point2.default,
	        position: _Point2.default,
	        fadeDurationInMs: _propTypes2.default.number,
	        imageClassName: _propTypes2.default.string,
	        imageStyle: _propTypes2.default.object,
	        isHovering: _propTypes2.default.bool,
	        isRenderOnDemand: _propTypes2.default.bool,
	        largeImage: _ImageShape2.default,
	        smallImage: _ImageShape2.default,
	        imagePosition: _propTypes2.default.oneOf(['beside', 'over'])
	    };
	    exports.default = _class;
	});

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(224);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(115);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(221);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(222);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(521);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(115);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(524);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(527);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(524);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(1121);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(149);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(116);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 523 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(222));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(149));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(116));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(149));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1128));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ReactRecaptcha=t(require("react")):e.ReactRecaptcha=t(e.React)}(this,function(e){return function(e){function t(r){if(a[r])return a[r].exports;var n=a[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var a={};return t.m=e,t.c=a,t.p="",t(0)}([function(e,t,a){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,a,r){return a&&e(t.prototype,a),r&&e(t,r),t}}(),l=a(6),c=r(l),p=a(4),u=r(p),d={className:u.default.string,onloadCallbackName:u.default.string,elementID:u.default.string,onloadCallback:u.default.func,verifyCallback:u.default.func,expiredCallback:u.default.func,render:u.default.string,sitekey:u.default.string,theme:u.default.string,type:u.default.string,verifyCallbackName:u.default.string,expiredCallbackName:u.default.string,size:u.default.string,tabindex:u.default.string,hl:u.default.string,badge:u.default.string},f={elementID:"g-recaptcha",onloadCallback:void 0,onloadCallbackName:"onloadCallback",verifyCallback:void 0,verifyCallbackName:"verifyCallback",expiredCallback:void 0,expiredCallbackName:"expiredCallback",render:"onload",theme:"light",type:"image",size:"normal",tabindex:"0",hl:"en",badge:"bottomright"},h=function(){return"undefined"!=typeof window&&"undefined"!=typeof window.grecaptcha&&"function"==typeof window.grecaptcha.render},y=void 0,b=function(e){function t(e){n(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a._renderGrecaptcha=a._renderGrecaptcha.bind(a),a.reset=a.reset.bind(a),a.state={ready:h(),widget:null},a.state.ready||(y=setInterval(a._updateReadyState.bind(a),1e3)),a}return i(t,e),s(t,[{key:"componentDidMount",value:function(){this.state.ready&&this._renderGrecaptcha()}},{key:"componentDidUpdate",value:function(e,t){var a=this.props,r=a.render,n=a.onloadCallback;"explicit"===r&&n&&this.state.ready&&!t.ready&&this._renderGrecaptcha()}},{key:"componentWillUnmount",value:function(){clearInterval(y)}},{key:"reset",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.reset(a)}},{key:"execute",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.execute(a)}},{key:"_updateReadyState",value:function(){h()&&(this.setState({ready:!0}),clearInterval(y))}},{key:"_renderGrecaptcha",value:function(){this.state.widget=grecaptcha.render(this.props.elementID,{sitekey:this.props.sitekey,callback:this.props.verifyCallback?this.props.verifyCallback:void 0,theme:this.props.theme,type:this.props.type,size:this.props.size,tabindex:this.props.tabindex,hl:this.props.hl,badge:this.props.badge,"expired-callback":this.props.expiredCallback?this.props.expiredCallback:void 0}),this.props.onloadCallback&&this.props.onloadCallback()}},{key:"render",value:function(){return"explicit"===this.props.render&&this.props.onloadCallback?c.default.createElement("div",{id:this.props.elementID,"data-onloadcallbackname":this.props.onloadCallbackName,"data-verifycallbackname":this.props.verifyCallbackName}):c.default.createElement("div",{id:this.props.elementID,className:"g-recaptcha","data-sitekey":this.props.sitekey,"data-theme":this.props.theme,"data-type":this.props.type,"data-size":this.props.size,"data-badge":this.props.badge,"data-tabindex":this.props.tabindex})}}]),t}(l.Component);t.default=b,b.propTypes=d,b.defaultProps=f,e.exports=t.default},function(e,t){"use strict";function a(e){return function(){return e}}var r=function(){};r.thatReturns=a,r.thatReturnsFalse=a(!1),r.thatReturnsTrue=a(!0),r.thatReturnsNull=a(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,a){"use strict";function r(e,t,a,r,o,i,s,l){if(n(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var p=[a,r,o,i,s,l],u=0;c=new Error(t.replace(/%s/g,function(){return p[u++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var n=function(e){};e.exports=r},function(e,t,a){"use strict";var r=a(1),n=a(2),o=a(5);e.exports=function(){function e(e,t,a,r,i,s){s!==o&&n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return a.checkPropTypes=r,a.PropTypes=a,a}},function(e,t,a){e.exports=a(3)()},function(e,t){"use strict";var a="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=a},function(t,a){t.exports=e}])});

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 531 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports = function requiredIf(type, condition) {
	  return function(props) {
	    var test = condition(props) ? type.isRequired : type;
	    return test.apply(this, arguments);
	  };
	};


/***/ },
/* 533 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(535);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(533);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1137);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1136);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 535 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	
	  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var type = _ref.type;
	  var payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(227);
	
	var _ContextUtils = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    bool = _React$PropTypes.bool,
	    object = _React$PropTypes.object,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func,
	    oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object, func]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 537 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(57);
	
	var _PatternUtils = __webpack_require__(85);
	
	var _InternalPropTypes = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(323);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(322);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(891);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(543);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(86);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1146);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1143);
	
	var _isActive2 = __webpack_require__(1150);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1147);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1152);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(323);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(322);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyContainer = exports.Sticky = undefined;
	
	var _Sticky = __webpack_require__(1156);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	var _Container = __webpack_require__(1155);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sticky = _Sticky2.default;
	exports.StickyContainer = _Container2.default;
	exports.default = _Sticky2.default;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(89);
	
	var ReactCurrentOwner = __webpack_require__(49);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  var setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  var getItem = function (id) {
	    return itemMap.get(id);
	  };
	  var removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  var getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  var addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  var removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  var getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  var setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  var getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  var removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  var getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  var addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  var removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  var getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 546 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 549 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 550 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ },
/* 551 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(197);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1192);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ },
/* 553 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(231);
	
	/*<replacement>*/
	var util = __webpack_require__(100);
	util.inherits = __webpack_require__(79);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(1185);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(18).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(309).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(68);
	
	/*<replacement>*/
	var util = __webpack_require__(100);
	util.inherits = __webpack_require__(79);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(1209);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(69);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(556).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(69);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(556).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(18).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 557 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rng;
	// Unique ID creation requires a high quality random # generator. In the browser we therefore
	// require the crypto API and do not support built-in fallback to lower quality random number
	// generators (like Math.random()).
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
	// find the complete implementation of crypto (msCrypto) on IE11.
	var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
	var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	function rng() {
	  if (!getRandomValues) {
	    throw new Error('uuid: This browser does not seem to support crypto.getRandomValues(). If you need to support this browser, please provide a custom random number generator through options.rng.');
	  }
	
	  return getRandomValues(rnds8);
	}
	
	module.exports = exports.default;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.URL = exports.DNS = void 0;
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(233));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function uuidToBytes(uuid) {
	  // Note: We assume we're being passed a valid uuid string
	  var bytes = [];
	  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
	    bytes.push(parseInt(hex, 16));
	  });
	  return bytes;
	}
	
	function stringToBytes(str) {
	  str = unescape(encodeURIComponent(str)); // UTF8 escape
	
	  var bytes = new Array(str.length);
	
	  for (var i = 0; i < str.length; i++) {
	    bytes[i] = str.charCodeAt(i);
	  }
	
	  return bytes;
	}
	
	const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
	exports.DNS = DNS;
	const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
	exports.URL = URL;
	
	function _default(name, version, hashfunc) {
	  var generateUUID = function (value, namespace, buf, offset) {
	    var off = buf && offset || 0;
	    if (typeof value == 'string') value = stringToBytes(value);
	    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
	    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
	    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3
	
	    var bytes = hashfunc(namespace.concat(value));
	    bytes[6] = bytes[6] & 0x0f | version;
	    bytes[8] = bytes[8] & 0x3f | 0x80;
	
	    if (buf) {
	      for (var idx = 0; idx < 16; ++idx) {
	        buf[off + idx] = bytes[idx];
	      }
	    }
	
	    return buf || (0, _bytesToUuid.default)(bytes);
	  }; // Function#name is not settable on some platforms (#270)
	
	
	  try {
	    generateUUID.name = name;
	  } catch (err) {} // For CommonJS default export support
	
	
	  generateUUID.DNS = DNS;
	  generateUUID.URL = URL;
	  return generateUUID;
	}

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.VMasker = factory();
	  }
	}(this, function() {
	  var DIGIT = "9",
	      ALPHA = "A",
	      ALPHANUM = "S",
	      BY_PASS_KEYS = [9, 16, 17, 18, 36, 37, 38, 39, 40, 91, 92, 93],
	      isAllowedKeyCode = function(keyCode) {
	        for (var i = 0, len = BY_PASS_KEYS.length; i < len; i++) {
	          if (keyCode == BY_PASS_KEYS[i]) {
	            return false;
	          }
	        }
	        return true;
	      },
	      mergeMoneyOptions = function(opts) {
	        opts = opts || {};
	        opts = {
	          precision: opts.hasOwnProperty("precision") ? opts.precision : 2,
	          separator: opts.separator || ",",
	          delimiter: opts.delimiter || ".",
	          unit: opts.unit && (opts.unit.replace(/[\s]/g,'') + " ") || "",
	          suffixUnit: opts.suffixUnit && (" " + opts.suffixUnit.replace(/[\s]/g,'')) || "",
	          zeroCents: opts.zeroCents,
	          lastOutput: opts.lastOutput
	        };
	        opts.moneyPrecision = opts.zeroCents ? 0 : opts.precision;
	        return opts;
	      },
	      // Fill wildcards past index in output with placeholder
	      addPlaceholdersToOutput = function(output, index, placeholder) {
	        for (; index < output.length; index++) {
	          if(output[index] === DIGIT || output[index] === ALPHA || output[index] === ALPHANUM) {
	            output[index] = placeholder;
	          }
	        }
	        return output;
	      }
	  ;
	
	  var VanillaMasker = function(elements) {
	    this.elements = elements;
	  };
	
	  VanillaMasker.prototype.unbindElementToMask = function() {
	    for (var i = 0, len = this.elements.length; i < len; i++) {
	      this.elements[i].lastOutput = "";
	      this.elements[i].onkeyup = false;
	      this.elements[i].onkeydown = false;
	
	      if (this.elements[i].value.length) {
	        this.elements[i].value = this.elements[i].value.replace(/\D/g, '');
	      }
	    }
	  };
	
	  VanillaMasker.prototype.bindElementToMask = function(maskFunction) {
	    var that = this,
	        onType = function(e) {
	          e = e || window.event;
	          var source = e.target || e.srcElement;
	
	          if (isAllowedKeyCode(e.keyCode)) {
	            setTimeout(function() {
	              that.opts.lastOutput = source.lastOutput;
	              source.value = VMasker[maskFunction](source.value, that.opts);
	              source.lastOutput = source.value;
	              if (source.setSelectionRange && that.opts.suffixUnit) {
	                source.setSelectionRange(source.value.length, (source.value.length - that.opts.suffixUnit.length));
	              }
	            }, 0);
	          }
	        }
	    ;
	    for (var i = 0, len = this.elements.length; i < len; i++) {
	      this.elements[i].lastOutput = "";
	      this.elements[i].onkeyup = onType;
	      if (this.elements[i].value.length) {
	        this.elements[i].value = VMasker[maskFunction](this.elements[i].value, this.opts);
	      }
	    }
	  };
	
	  VanillaMasker.prototype.maskMoney = function(opts) {
	    this.opts = mergeMoneyOptions(opts);
	    this.bindElementToMask("toMoney");
	  };
	
	  VanillaMasker.prototype.maskNumber = function() {
	    this.opts = {};
	    this.bindElementToMask("toNumber");
	  };
	  
	  VanillaMasker.prototype.maskAlphaNum = function() {
	    this.opts = {};
	    this.bindElementToMask("toAlphaNumeric");
	  };
	
	  VanillaMasker.prototype.maskPattern = function(pattern) {
	    this.opts = {pattern: pattern};
	    this.bindElementToMask("toPattern");
	  };
	
	  VanillaMasker.prototype.unMask = function() {
	    this.unbindElementToMask();
	  };
	
	  var VMasker = function(el) {
	    if (!el) {
	      throw new Error("VanillaMasker: There is no element to bind.");
	    }
	    var elements = ("length" in el) ? (el.length ? el : []) : [el];
	    return new VanillaMasker(elements);
	  };
	
	  VMasker.toMoney = function(value, opts) {
	    opts = mergeMoneyOptions(opts);
	    if (opts.zeroCents) {
	      opts.lastOutput = opts.lastOutput || "";
	      var zeroMatcher = ("("+ opts.separator +"[0]{0,"+ opts.precision +"})"),
	          zeroRegExp = new RegExp(zeroMatcher, "g"),
	          digitsLength = value.toString().replace(/[\D]/g, "").length || 0,
	          lastDigitLength = opts.lastOutput.toString().replace(/[\D]/g, "").length || 0
	      ;
	      value = value.toString().replace(zeroRegExp, "");
	      if (digitsLength < lastDigitLength) {
	        value = value.slice(0, value.length - 1);
	      }
	    }
	    var number = value.toString().replace(/[\D]/g, ""),
	        clearDelimiter = new RegExp("^(0|\\"+ opts.delimiter +")"),
	        clearSeparator = new RegExp("(\\"+ opts.separator +")$"),
	        money = number.substr(0, number.length - opts.moneyPrecision),
	        masked = money.substr(0, money.length % 3),
	        cents = new Array(opts.precision + 1).join("0")
	    ;
	    money = money.substr(money.length % 3, money.length);
	    for (var i = 0, len = money.length; i < len; i++) {
	      if (i % 3 === 0) {
	        masked += opts.delimiter;
	      }
	      masked += money[i];
	    }
	    masked = masked.replace(clearDelimiter, "");
	    masked = masked.length ? masked : "0";
	    if (!opts.zeroCents) {
	      var beginCents = number.length - opts.precision,
	          centsValue = number.substr(beginCents, opts.precision),
	          centsLength = centsValue.length,
	          centsSliced = (opts.precision > centsLength) ? opts.precision : centsLength
	      ;
	      cents = (cents + centsValue).slice(-centsSliced);
	    }
	    var output = opts.unit + masked + opts.separator + cents + opts.suffixUnit;
	    return output.replace(clearSeparator, "");
	  };
	
	  VMasker.toPattern = function(value, opts) {
	    var pattern = (typeof opts === 'object' ? opts.pattern : opts),
	        patternChars = pattern.replace(/\W/g, ''),
	        output = pattern.split(""),
	        values = value.toString().replace(/\W/g, ""),
	        charsValues = values.replace(/\W/g, ''),
	        index = 0,
	        i,
	        outputLength = output.length,
	        placeholder = (typeof opts === 'object' ? opts.placeholder : undefined)
	    ;
	    
	    for (i = 0; i < outputLength; i++) {
	      // Reached the end of input
	      if (index >= values.length) {
	        if (patternChars.length == charsValues.length) {
	          return output.join("");
	        }
	        else if ((placeholder !== undefined) && (patternChars.length > charsValues.length)) {
	          return addPlaceholdersToOutput(output, i, placeholder).join("");
	        }
	        else {
	          break;
	        }
	      }
	      // Remaining chars in input
	      else{
	        if ((output[i] === DIGIT && values[index].match(/[0-9]/)) ||
	            (output[i] === ALPHA && values[index].match(/[a-zA-Z]/)) ||
	            (output[i] === ALPHANUM && values[index].match(/[0-9a-zA-Z]/))) {
	          output[i] = values[index++];
	        } else if (output[i] === DIGIT || output[i] === ALPHA || output[i] === ALPHANUM) {
	          if(placeholder !== undefined){
	            return addPlaceholdersToOutput(output, i, placeholder).join("");
	          }
	          else{
	            return output.slice(0, i).join("");
	          }
	        }
	      }
	    }
	    return output.join("").substr(0, i);
	  };
	
	  VMasker.toNumber = function(value) {
	    return value.toString().replace(/(?!^-)[^0-9]/g, "");
	  };
	  
	  VMasker.toAlphaNumeric = function(value) {
	    return value.toString().replace(/[^a-z0-9 ]+/i, "");
	  };
	
	  return VMasker;
	}));


/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(945).enable();
	  window.Promise = __webpack_require__(944);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1207);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(939);


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).AdyenCheckout=t()}(this,(function(){"use strict";var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])})(t,r)};function t(t,r){if("function"!=typeof r&&null!==r)throw new TypeError("Class extends value "+String(r)+" is not a constructor or null");function a(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(a.prototype=r.prototype,new a)}var r=function(){return(r=Object.assign||function(e){for(var t,r=1,a=arguments.length;r<a;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e}).apply(this,arguments)};function a(e,t){var r={};for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&t.indexOf(a)<0&&(r[a]=e[a]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(a=Object.getOwnPropertySymbols(e);n<a.length;n++)t.indexOf(a[n])<0&&Object.prototype.propertyIsEnumerable.call(e,a[n])&&(r[a[n]]=e[a[n]])}return r}function n(e,t,r,a){return new(r||(r=Promise))((function(n,o){function i(e){try{l(a.next(e))}catch(e){o(e)}}function s(e){try{l(a.throw(e))}catch(e){o(e)}}function l(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(i,s)}l((a=a.apply(e,t||[])).next())}))}function o(e,t){var r,a,n,o,i={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;i;)try{if(r=1,a&&(n=2&o[0]?a.return:o[0]?a.throw||((n=a.return)&&n.call(a),0):a.next)&&!(n=n.call(a,o[1])).done)return n;switch(a=0,n&&(o=[2&o[0],n.value]),o[0]){case 0:case 1:n=o;break;case 4:return i.label++,{value:o[1],done:!1};case 5:i.label++,a=o[1],o=[0];continue;case 7:o=i.ops.pop(),i.trys.pop();continue;default:if(!(n=i.trys,(n=n.length>0&&n[n.length-1])||6!==o[0]&&2!==o[0])){i=0;continue}if(3===o[0]&&(!n||o[1]>n[0]&&o[1]<n[3])){i.label=o[1];break}if(6===o[0]&&i.label<n[1]){i.label=n[1],n=o;break}if(n&&i.label<n[2]){i.label=n[2],i.ops.push(o);break}n[2]&&i.ops.pop(),i.trys.pop();continue}o=t.call(e,i)}catch(e){o=[6,e],a=0}finally{r=n=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,s])}}}function i(e,t,r){if(r||2===arguments.length)for(var a,n=0,o=t.length;n<o;n++)!a&&n in t||(a||(a=Array.prototype.slice.call(t,0,n)),a[n]=t[n]);return e.concat(a||Array.prototype.slice.call(t))}var s="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},l=function(e){return e&&e.Math==Math&&e},d=l("object"==typeof globalThis&&globalThis)||l("object"==typeof window&&window)||l("object"==typeof self&&self)||l("object"==typeof s&&s)||function(){return this}()||Function("return this")(),c={},u=function(e){try{return!!e()}catch(e){return!0}},p=!u((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),m={},h={}.propertyIsEnumerable,f=Object.getOwnPropertyDescriptor,y=f&&!h.call({1:2},1);m.f=y?function(e){var t=f(this,e);return!!t&&t.enumerable}:h;var b,v,g=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},k={}.toString,C=function(e){return k.call(e).slice(8,-1)},_=C,N="".split,w=u((function(){return!Object("z").propertyIsEnumerable(0)}))?function(e){return"String"==_(e)?N.call(e,""):Object(e)}:Object,P=function(e){if(null==e)throw TypeError("Can't call method on "+e);return e},F=w,D=P,A=function(e){return F(D(e))},S=function(e){return"function"==typeof e},x=S,B=function(e){return"object"==typeof e?null!==e:x(e)},T=d,z=S,I=function(e){return z(e)?e:void 0},M=function(e,t){return arguments.length<2?I(T[e]):T[e]&&T[e][t]},j=M("navigator","userAgent")||"",E=d,O=j,R=E.process,L=E.Deno,V=R&&R.versions||L&&L.version,U=V&&V.v8;U?v=(b=U.split("."))[0]<4?1:b[0]+b[1]:O&&(!(b=O.match(/Edge\/(\d+)/))||b[1]>=74)&&(b=O.match(/Chrome\/(\d+)/))&&(v=b[1]);var K=v&&+v,H=K,q=u,G=!!Object.getOwnPropertySymbols&&!q((function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&H&&H<41})),Y=G&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,W=S,J=M,Z=Y?function(e){return"symbol"==typeof e}:function(e){var t=J("Symbol");return W(t)&&Object(e)instanceof t},Q=function(e){try{return String(e)}catch(e){return"Object"}},$=S,X=Q,ee=function(e){if($(e))return e;throw TypeError(X(e)+" is not a function")},te=ee,re=function(e,t){var r=e[t];return null==r?void 0:te(r)},ae=S,ne=B,oe={exports:{}},ie=d,se=function(e,t){try{Object.defineProperty(ie,e,{value:t,configurable:!0,writable:!0})}catch(r){ie[e]=t}return t},le=se,de="__core-js_shared__",ce=d[de]||le(de,{}),ue=ce;(oe.exports=function(e,t){return ue[e]||(ue[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.18.1",mode:"global",copyright:"\xa9 2021 Denis Pushkarev (zloirock.ru)"});var pe=P,me=function(e){return Object(pe(e))},he=me,fe={}.hasOwnProperty,ye=Object.hasOwn||function(e,t){return fe.call(he(e),t)},be=0,ve=Math.random(),ge=function(e){return"Symbol("+String(void 0===e?"":e)+")_"+(++be+ve).toString(36)},ke=d,Ce=oe.exports,_e=ye,Ne=ge,we=G,Pe=Y,Fe=Ce("wks"),De=ke.Symbol,Ae=Pe?De:De&&De.withoutSetter||Ne,Se=function(e){return _e(Fe,e)&&(we||"string"==typeof Fe[e])||(we&&_e(De,e)?Fe[e]=De[e]:Fe[e]=Ae("Symbol."+e)),Fe[e]},xe=B,Be=Z,Te=re,ze=function(e,t){var r,a;if("string"===t&&ae(r=e.toString)&&!ne(a=r.call(e)))return a;if(ae(r=e.valueOf)&&!ne(a=r.call(e)))return a;if("string"!==t&&ae(r=e.toString)&&!ne(a=r.call(e)))return a;throw TypeError("Can't convert object to primitive value")},Ie=Se("toPrimitive"),Me=function(e,t){if(!xe(e)||Be(e))return e;var r,a=Te(e,Ie);if(a){if(void 0===t&&(t="default"),r=a.call(e,t),!xe(r)||Be(r))return r;throw TypeError("Can't convert object to primitive value")}return void 0===t&&(t="number"),ze(e,t)},je=Z,Ee=function(e){var t=Me(e,"string");return je(t)?t:String(t)},Oe=B,Re=d.document,Le=Oe(Re)&&Oe(Re.createElement),Ve=function(e){return Le?Re.createElement(e):{}},Ue=Ve,Ke=!p&&!u((function(){return 7!=Object.defineProperty(Ue("div"),"a",{get:function(){return 7}}).a})),He=p,qe=m,Ge=g,Ye=A,We=Ee,Je=ye,Ze=Ke,Qe=Object.getOwnPropertyDescriptor;c.f=He?Qe:function(e,t){if(e=Ye(e),t=We(t),Ze)try{return Qe(e,t)}catch(e){}if(Je(e,t))return Ge(!qe.f.call(e,t),e[t])};var $e={},Xe=B,et=function(e){if(Xe(e))return e;throw TypeError(String(e)+" is not an object")},tt=p,rt=Ke,at=et,nt=Ee,ot=Object.defineProperty;$e.f=tt?ot:function(e,t,r){if(at(e),t=nt(t),at(r),rt)try{return ot(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported");return"value"in r&&(e[t]=r.value),e};var it=$e,st=g,lt=p?function(e,t,r){return it.f(e,t,st(1,r))}:function(e,t,r){return e[t]=r,e},dt={exports:{}},ct=S,ut=ce,pt=Function.toString;ct(ut.inspectSource)||(ut.inspectSource=function(e){return pt.call(e)});var mt,ht,ft,yt=ut.inspectSource,bt=S,vt=yt,gt=d.WeakMap,kt=bt(gt)&&/native code/.test(vt(gt)),Ct=oe.exports,_t=ge,Nt=Ct("keys"),wt=function(e){return Nt[e]||(Nt[e]=_t(e))},Pt={},Ft=kt,Dt=B,At=lt,St=ye,xt=ce,Bt=wt,Tt=Pt,zt="Object already initialized",It=d.WeakMap;if(Ft||xt.state){var Mt=xt.state||(xt.state=new It),jt=Mt.get,Et=Mt.has,Ot=Mt.set;mt=function(e,t){if(Et.call(Mt,e))throw new TypeError(zt);return t.facade=e,Ot.call(Mt,e,t),t},ht=function(e){return jt.call(Mt,e)||{}},ft=function(e){return Et.call(Mt,e)}}else{var Rt=Bt("state");Tt[Rt]=!0,mt=function(e,t){if(St(e,Rt))throw new TypeError(zt);return t.facade=e,At(e,Rt,t),t},ht=function(e){return St(e,Rt)?e[Rt]:{}},ft=function(e){return St(e,Rt)}}var Lt={set:mt,get:ht,has:ft,enforce:function(e){return ft(e)?ht(e):mt(e,{})},getterFor:function(e){return function(t){var r;if(!Dt(t)||(r=ht(t)).type!==e)throw TypeError("Incompatible receiver, "+e+" required");return r}}},Vt=p,Ut=ye,Kt=Function.prototype,Ht=Vt&&Object.getOwnPropertyDescriptor,qt=Ut(Kt,"name"),Gt={EXISTS:qt,PROPER:qt&&"something"===function(){}.name,CONFIGURABLE:qt&&(!Vt||Vt&&Ht(Kt,"name").configurable)},Yt=d,Wt=S,Jt=ye,Zt=lt,Qt=se,$t=yt,Xt=Gt.CONFIGURABLE,er=Lt.get,tr=Lt.enforce,rr=String(String).split("String");(dt.exports=function(e,t,r,a){var n,o=!!a&&!!a.unsafe,i=!!a&&!!a.enumerable,s=!!a&&!!a.noTargetGet,l=a&&void 0!==a.name?a.name:t;Wt(r)&&("Symbol("===String(l).slice(0,7)&&(l="["+String(l).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!Jt(r,"name")||Xt&&r.name!==l)&&Zt(r,"name",l),(n=tr(r)).source||(n.source=rr.join("string"==typeof l?l:""))),e!==Yt?(o?!s&&e[t]&&(i=!0):delete e[t],i?e[t]=r:Zt(e,t,r)):i?e[t]=r:Qt(t,r)})(Function.prototype,"toString",(function(){return Wt(this)&&er(this).source||$t(this)}));var ar={},nr=Math.ceil,or=Math.floor,ir=function(e){return isNaN(e=+e)?0:(e>0?or:nr)(e)},sr=ir,lr=Math.min,dr=function(e){return e>0?lr(sr(e),9007199254740991):0},cr=ir,ur=Math.max,pr=Math.min,mr=A,hr=dr,fr=function(e,t){var r=cr(e);return r<0?ur(r+t,0):pr(r,t)},yr=function(e){return function(t,r,a){var n,o=mr(t),i=hr(o.length),s=fr(a,i);if(e&&r!=r){for(;i>s;)if((n=o[s++])!=n)return!0}else for(;i>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}},br={includes:yr(!0),indexOf:yr(!1)},vr=ye,gr=A,kr=br.indexOf,Cr=Pt,_r=function(e,t){var r,a=gr(e),n=0,o=[];for(r in a)!vr(Cr,r)&&vr(a,r)&&o.push(r);for(;t.length>n;)vr(a,r=t[n++])&&(~kr(o,r)||o.push(r));return o},Nr=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],wr=_r,Pr=Nr.concat("length","prototype");ar.f=Object.getOwnPropertyNames||function(e){return wr(e,Pr)};var Fr={};Fr.f=Object.getOwnPropertySymbols;var Dr=ar,Ar=Fr,Sr=et,xr=M("Reflect","ownKeys")||function(e){var t=Dr.f(Sr(e)),r=Ar.f;return r?t.concat(r(e)):t},Br=ye,Tr=xr,zr=c,Ir=$e,Mr=u,jr=S,Er=/#|\.prototype\./,Or=function(e,t){var r=Lr[Rr(e)];return r==Ur||r!=Vr&&(jr(t)?Mr(t):!!t)},Rr=Or.normalize=function(e){return String(e).replace(Er,".").toLowerCase()},Lr=Or.data={},Vr=Or.NATIVE="N",Ur=Or.POLYFILL="P",Kr=Or,Hr=d,qr=c.f,Gr=lt,Yr=dt.exports,Wr=se,Jr=function(e,t){for(var r=Tr(t),a=Ir.f,n=zr.f,o=0;o<r.length;o++){var i=r[o];Br(e,i)||a(e,i,n(t,i))}},Zr=Kr,Qr=function(e,t){var r,a,n,o,i,s=e.target,l=e.global,d=e.stat;if(r=l?Hr:d?Hr[s]||Wr(s,{}):(Hr[s]||{}).prototype)for(a in t){if(o=t[a],n=e.noTargetGet?(i=qr(r,a))&&i.value:r[a],!Zr(l?a:s+(d?".":"#")+a,e.forced)&&void 0!==n){if(typeof o==typeof n)continue;Jr(o,n)}(e.sham||n&&n.sham)&&Gr(o,"sham",!0),Yr(r,a,o,e)}},$r=_r,Xr=Nr,ea=Object.keys||function(e){return $r(e,Xr)},ta=p,ra=u,aa=ea,na=Fr,oa=m,ia=me,sa=w,la=Object.assign,da=Object.defineProperty,ca=!la||ra((function(){if(ta&&1!==la({b:1},la(da({},"a",{enumerable:!0,get:function(){da(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var e={},t={},r=Symbol(),a="abcdefghijklmnopqrst";return e[r]=7,a.split("").forEach((function(e){t[e]=e})),7!=la({},e)[r]||aa(la({},t)).join("")!=a}))?function(e,t){for(var r=ia(e),a=arguments.length,n=1,o=na.f,i=oa.f;a>n;)for(var s,l=sa(arguments[n++]),d=o?aa(l).concat(o(l)):aa(l),c=d.length,u=0;c>u;)s=d[u++],ta&&!i.call(l,s)||(r[s]=l[s]);return r}:la;Qr({target:"Object",stat:!0,forced:Object.assign!==ca},{assign:ca});var ua=d;ua.Object.assign;var pa=me,ma=ea;Qr({target:"Object",stat:!0,forced:u((function(){ma(1)}))},{keys:function(e){return ma(pa(e))}}),ua.Object.keys;var ha,fa=$e,ya=et,ba=ea,va=p?Object.defineProperties:function(e,t){ya(e);for(var r,a=ba(t),n=a.length,o=0;n>o;)fa.f(e,r=a[o++],t[r]);return e},ga=M("document","documentElement"),ka=et,Ca=va,_a=Nr,Na=Pt,wa=ga,Pa=Ve,Fa=wt("IE_PROTO"),Da=function(){},Aa=function(e){return"<script>"+e+"</"+"script>"},Sa=function(e){e.write(Aa("")),e.close();var t=e.parentWindow.Object;return e=null,t},xa=function(){try{ha=new ActiveXObject("htmlfile")}catch(e){}var e,t;xa="undefined"!=typeof document?document.domain&&ha?Sa(ha):((t=Pa("iframe")).style.display="none",wa.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(Aa("document.F=Object")),e.close(),e.F):Sa(ha);for(var r=_a.length;r--;)delete xa.prototype[_a[r]];return xa()};Na[Fa]=!0;var Ba=Object.create||function(e,t){var r;return null!==e?(Da.prototype=ka(e),r=new Da,Da.prototype=null,r[Fa]=e):r=xa(),void 0===t?r:Ca(r,t)},Ta=Ba,za=$e,Ia=Se("unscopables"),Ma=Array.prototype;null==Ma[Ia]&&za.f(Ma,Ia,{configurable:!0,value:Ta(null)});var ja=function(e){Ma[Ia][e]=!0},Ea=br.includes,Oa=ja;Qr({target:"Array",proto:!0},{includes:function(e){return Ea(this,e,arguments.length>1?arguments[1]:void 0)}}),Oa("includes");var Ra=ee,La=function(e,t,r){if(Ra(e),void 0===t)return e;switch(r){case 0:return function(){return e.call(t)};case 1:return function(r){return e.call(t,r)};case 2:return function(r,a){return e.call(t,r,a)};case 3:return function(r,a,n){return e.call(t,r,a,n)}}return function(){return e.apply(t,arguments)}},Va=d,Ua=La,Ka=Function.call,Ha=function(e,t,r){return Ua(Ka,Va[e].prototype[t],r)};Ha("Array","includes");var qa=C,Ga=Array.isArray||function(e){return"Array"==qa(e)},Ya={};Ya[Se("toStringTag")]="z";var Wa="[object z]"===String(Ya),Ja=Wa,Za=S,Qa=C,$a=Se("toStringTag"),Xa="Arguments"==Qa(function(){return arguments}()),en=Ja?Qa:function(e){var t,r,a;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(r=function(e,t){try{return e[t]}catch(e){}}(t=Object(e),$a))?r:Xa?Qa(t):"Object"==(a=Qa(t))&&Za(t.callee)?"Arguments":a},tn=u,rn=S,an=en,nn=yt,on=[],sn=M("Reflect","construct"),ln=/^\s*(?:class|function)\b/,dn=ln.exec,cn=!ln.exec((function(){})),un=function(e){if(!rn(e))return!1;try{return sn(Object,on,e),!0}catch(e){return!1}},pn=!sn||tn((function(){var e;return un(un.call)||!un(Object)||!un((function(){e=!0}))||e}))?function(e){if(!rn(e))return!1;switch(an(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}return cn||!!dn.call(ln,nn(e))}:un,mn=Ga,hn=pn,fn=B,yn=Se("species"),bn=function(e){var t;return mn(e)&&(t=e.constructor,(hn(t)&&(t===Array||mn(t.prototype))||fn(t)&&null===(t=t[yn]))&&(t=void 0)),void 0===t?Array:t},vn=La,gn=w,kn=me,Cn=dr,_n=function(e,t){return new(bn(e))(0===t?0:t)},Nn=[].push,wn=function(e){var t=1==e,r=2==e,a=3==e,n=4==e,o=6==e,i=7==e,s=5==e||o;return function(l,d,c,u){for(var p,m,h=kn(l),f=gn(h),y=vn(d,c,3),b=Cn(f.length),v=0,g=u||_n,k=t?g(l,b):r||i?g(l,0):void 0;b>v;v++)if((s||v in f)&&(m=y(p=f[v],v,h),e))if(t)k[v]=m;else if(m)switch(e){case 3:return!0;case 5:return p;case 6:return v;case 2:Nn.call(k,p)}else switch(e){case 4:return!1;case 7:Nn.call(k,p)}return o?-1:a||n?n:k}},Pn={forEach:wn(0),map:wn(1),filter:wn(2),some:wn(3),every:wn(4),find:wn(5),findIndex:wn(6),filterReject:wn(7)},Fn=Qr,Dn=Pn.find,An=ja,Sn="find",xn=!0;Sn in[]&&Array(1).find((function(){xn=!1})),Fn({target:"Array",proto:!0,forced:xn},{find:function(e){return Dn(this,e,arguments.length>1?arguments[1]:void 0)}}),An(Sn),Ha("Array","find");var Bn=Qr,Tn=Pn.findIndex,zn=ja,In="findIndex",Mn=!0;In in[]&&Array(1).findIndex((function(){Mn=!1})),Bn({target:"Array",proto:!0,forced:Mn},{findIndex:function(e){return Tn(this,e,arguments.length>1?arguments[1]:void 0)}}),zn(In),Ha("Array","findIndex");var jn=!u((function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e)!==e.prototype})),En=ye,On=S,Rn=me,Ln=jn,Vn=wt("IE_PROTO"),Un=Object.prototype,Kn=Ln?Object.getPrototypeOf:function(e){var t=Rn(e);if(En(t,Vn))return t[Vn];var r=t.constructor;return On(r)&&t instanceof r?r.prototype:t instanceof Object?Un:null},Hn=S,qn=et,Gn=function(e){if("object"==typeof e||Hn(e))return e;throw TypeError("Can't set "+String(e)+" as a prototype")},Yn=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,r={};try{(e=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(r,[]),t=r instanceof Array}catch(e){}return function(r,a){return qn(r),Gn(a),t?e.call(r,a):r.__proto__=a,r}}():void 0),Wn=B,Jn=lt,Zn={},Qn=Zn,$n=Se("iterator"),Xn=Array.prototype,eo=en,to=re,ro=Zn,ao=Se("iterator"),no=function(e){if(null!=e)return to(e,ao)||to(e,"@@iterator")||ro[eo(e)]},oo=ee,io=et,so=no,lo=et,co=re,uo=et,po=function(e){return void 0!==e&&(Qn.Array===e||Xn[$n]===e)},mo=dr,ho=La,fo=function(e,t){var r=arguments.length<2?so(e):t;if(oo(r))return io(r.call(e));throw TypeError(String(e)+" is not iterable")},yo=no,bo=function(e,t,r){var a,n;lo(e);try{if(!(a=co(e,"return"))){if("throw"===t)throw r;return r}a=a.call(e)}catch(e){n=!0,a=e}if("throw"===t)throw r;if(n)throw a;return lo(a),r},vo=function(e,t){this.stopped=e,this.result=t},go=function(e,t,r){var a,n,o,i,s,l,d,c=r&&r.that,u=!(!r||!r.AS_ENTRIES),p=!(!r||!r.IS_ITERATOR),m=!(!r||!r.INTERRUPTED),h=ho(t,c,1+u+m),f=function(e){return a&&bo(a,"normal",e),new vo(!0,e)},y=function(e){return u?(uo(e),m?h(e[0],e[1],f):h(e[0],e[1])):m?h(e,f):h(e)};if(p)a=e;else{if(!(n=yo(e)))throw TypeError(String(e)+" is not iterable");if(po(n)){for(o=0,i=mo(e.length);i>o;o++)if((s=y(e[o]))&&s instanceof vo)return s;return new vo(!1)}a=fo(e,n)}for(l=a.next;!(d=l.call(a)).done;){try{s=y(d.value)}catch(e){bo(a,"throw",e)}if("object"==typeof s&&s&&s instanceof vo)return s}return new vo(!1)},ko=en,Co=function(e){if("Symbol"===ko(e))throw TypeError("Cannot convert a Symbol value to a string");return String(e)},_o=Qr,No=Kn,wo=Yn,Po=Ba,Fo=lt,Do=g,Ao=function(e,t){Wn(t)&&"cause"in t&&Jn(e,"cause",e.cause)},So=go,xo=Co,Bo=function(e,t){var r=this;if(!(r instanceof Bo))return new Bo(e,t);wo&&(r=wo(new Error(void 0),No(r))),void 0!==t&&Fo(r,"message",xo(t)),arguments.length>2&&Ao(r,arguments[2]);var a=[];return So(e,a.push,{that:a}),Fo(r,"errors",a),r};Bo.prototype=Po(Error.prototype,{constructor:Do(5,Bo),message:Do(5,""),name:Do(5,"AggregateError")}),_o({global:!0},{AggregateError:Bo});var To,zo,Io,Mo=u,jo=S,Eo=Kn,Oo=dt.exports,Ro=Se("iterator"),Lo=!1;[].keys&&("next"in(Io=[].keys())?(zo=Eo(Eo(Io)))!==Object.prototype&&(To=zo):Lo=!0),(null==To||Mo((function(){var e={};return To[Ro].call(e)!==e})))&&(To={}),jo(To[Ro])||Oo(To,Ro,(function(){return this}));var Vo={IteratorPrototype:To,BUGGY_SAFARI_ITERATORS:Lo},Uo=$e.f,Ko=ye,Ho=Se("toStringTag"),qo=function(e,t,r){e&&!Ko(e=r?e:e.prototype,Ho)&&Uo(e,Ho,{configurable:!0,value:t})},Go=Vo.IteratorPrototype,Yo=Ba,Wo=g,Jo=qo,Zo=Zn,Qo=function(){return this},$o=Qr,Xo=Gt,ei=S,ti=function(e,t,r){var a=t+" Iterator";return e.prototype=Yo(Go,{next:Wo(1,r)}),Jo(e,a,!1),Zo[a]=Qo,e},ri=Kn,ai=Yn,ni=qo,oi=lt,ii=dt.exports,si=Zn,li=Xo.PROPER,di=Xo.CONFIGURABLE,ci=Vo.IteratorPrototype,ui=Vo.BUGGY_SAFARI_ITERATORS,pi=Se("iterator"),mi="keys",hi="values",fi="entries",yi=function(){return this},bi=function(e,t,r,a,n,o,i){ti(r,t,a);var s,l,d,c=function(e){if(e===n&&f)return f;if(!ui&&e in m)return m[e];switch(e){case mi:case hi:case fi:return function(){return new r(this,e)}}return function(){return new r(this)}},u=t+" Iterator",p=!1,m=e.prototype,h=m[pi]||m["@@iterator"]||n&&m[n],f=!ui&&h||c(n),y="Array"==t&&m.entries||h;if(y&&(s=ri(y.call(new e)))!==Object.prototype&&s.next&&(ri(s)!==ci&&(ai?ai(s,ci):ei(s[pi])||ii(s,pi,yi)),ni(s,u,!0)),li&&n==hi&&h&&h.name!==hi&&(di?oi(m,"name",hi):(p=!0,f=function(){return h.call(this)})),n)if(l={values:c(hi),keys:o?f:c(mi),entries:c(fi)},i)for(d in l)(ui||p||!(d in m))&&ii(m,d,l[d]);else $o({target:t,proto:!0,forced:ui||p},l);return m[pi]!==f&&ii(m,pi,f,{name:n}),si[t]=f,l},vi=A,gi=ja,ki=Zn,Ci=Lt,_i=bi,Ni="Array Iterator",wi=Ci.set,Pi=Ci.getterFor(Ni);_i(Array,"Array",(function(e,t){wi(this,{type:Ni,target:vi(e),index:0,kind:t})}),(function(){var e=Pi(this),t=e.target,r=e.kind,a=e.index++;return!t||a>=t.length?(e.target=void 0,{value:void 0,done:!0}):"keys"==r?{value:a,done:!1}:"values"==r?{value:t[a],done:!1}:{value:[a,t[a]],done:!1}}),"values"),ki.Arguments=ki.Array,gi("keys"),gi("values"),gi("entries");var Fi=en,Di=Wa?{}.toString:function(){return"[object "+Fi(this)+"]"},Ai=Wa,Si=dt.exports,xi=Di;Ai||Si(Object.prototype,"toString",xi,{unsafe:!0});var Bi=d.Promise,Ti=dt.exports,zi=M,Ii=$e,Mi=p,ji=Se("species"),Ei=Se("iterator"),Oi=!1;try{var Ri=0,Li={next:function(){return{done:!!Ri++}},return:function(){Oi=!0}};Li[Ei]=function(){return this},Array.from(Li,(function(){throw 2}))}catch(Wh){}var Vi,Ui,Ki,Hi,qi=pn,Gi=Q,Yi=et,Wi=function(e){if(qi(e))return e;throw TypeError(Gi(e)+" is not a constructor")},Ji=Se("species"),Zi=function(e,t){var r,a=Yi(e).constructor;return void 0===a||null==(r=Yi(a)[Ji])?t:Wi(r)},Qi=/(?:ipad|iphone|ipod).*applewebkit/i.test(j),$i="process"==C(d.process),Xi=d,es=S,ts=u,rs=La,as=ga,ns=Ve,os=Qi,is=$i,ss=Xi.setImmediate,ls=Xi.clearImmediate,ds=Xi.process,cs=Xi.MessageChannel,us=Xi.Dispatch,ps=0,ms={},hs="onreadystatechange";try{Vi=Xi.location}catch(Wh){}var fs=function(e){if(ms.hasOwnProperty(e)){var t=ms[e];delete ms[e],t()}},ys=function(e){return function(){fs(e)}},bs=function(e){fs(e.data)},vs=function(e){Xi.postMessage(String(e),Vi.protocol+"//"+Vi.host)};ss&&ls||(ss=function(e){for(var t=[],r=arguments.length,a=1;r>a;)t.push(arguments[a++]);return ms[++ps]=function(){(es(e)?e:Function(e)).apply(void 0,t)},Ui(ps),ps},ls=function(e){delete ms[e]},is?Ui=function(e){ds.nextTick(ys(e))}:us&&us.now?Ui=function(e){us.now(ys(e))}:cs&&!os?(Hi=(Ki=new cs).port2,Ki.port1.onmessage=bs,Ui=rs(Hi.postMessage,Hi,1)):Xi.addEventListener&&es(Xi.postMessage)&&!Xi.importScripts&&Vi&&"file:"!==Vi.protocol&&!ts(vs)?(Ui=vs,Xi.addEventListener("message",bs,!1)):Ui=hs in ns("script")?function(e){as.appendChild(ns("script")).onreadystatechange=function(){as.removeChild(this),fs(e)}}:function(e){setTimeout(ys(e),0)});var gs,ks,Cs,_s,Ns,ws,Ps,Fs,Ds={set:ss,clear:ls},As=d,Ss=/ipad|iphone|ipod/i.test(j)&&void 0!==As.Pebble,xs=/web0s(?!.*chrome)/i.test(j),Bs=d,Ts=c.f,zs=Ds.set,Is=Qi,Ms=Ss,js=xs,Es=$i,Os=Bs.MutationObserver||Bs.WebKitMutationObserver,Rs=Bs.document,Ls=Bs.process,Vs=Bs.Promise,Us=Ts(Bs,"queueMicrotask"),Ks=Us&&Us.value;Ks||(gs=function(){var e,t;for(Es&&(e=Ls.domain)&&e.exit();ks;){t=ks.fn,ks=ks.next;try{t()}catch(e){throw ks?_s():Cs=void 0,e}}Cs=void 0,e&&e.enter()},Is||Es||js||!Os||!Rs?!Ms&&Vs&&Vs.resolve?((Ps=Vs.resolve(void 0)).constructor=Vs,Fs=Ps.then,_s=function(){Fs.call(Ps,gs)}):_s=Es?function(){Ls.nextTick(gs)}:function(){zs.call(Bs,gs)}:(Ns=!0,ws=Rs.createTextNode(""),new Os(gs).observe(ws,{characterData:!0}),_s=function(){ws.data=Ns=!Ns}));var Hs=Ks||function(e){var t={fn:e,next:void 0};Cs&&(Cs.next=t),ks||(ks=t,_s()),Cs=t},qs={},Gs=ee,Ys=function(e){var t,r;this.promise=new e((function(e,a){if(void 0!==t||void 0!==r)throw TypeError("Bad Promise constructor");t=e,r=a})),this.resolve=Gs(t),this.reject=Gs(r)};qs.f=function(e){return new Ys(e)};var Ws,Js,Zs,Qs,$s=et,Xs=B,el=qs,tl=function(e,t){if($s(e),Xs(t)&&t.constructor===e)return t;var r=el.f(e);return(0,r.resolve)(t),r.promise},rl=d,al=function(e){try{return{error:!1,value:e()}}catch(e){return{error:!0,value:e}}},nl="object"==typeof window,ol=Qr,il=d,sl=M,ll=Bi,dl=dt.exports,cl=function(e,t,r){for(var a in t)Ti(e,a,t[a],r);return e},ul=Yn,pl=qo,ml=function(e){var t=zi(e),r=Ii.f;Mi&&t&&!t[ji]&&r(t,ji,{configurable:!0,get:function(){return this}})},hl=ee,fl=S,yl=B,bl=function(e,t,r){if(e instanceof t)return e;throw TypeError("Incorrect "+(r?r+" ":"")+"invocation")},vl=yt,gl=go,kl=function(e,t){if(!t&&!Oi)return!1;var r=!1;try{var a={};a[Ei]=function(){return{next:function(){return{done:r=!0}}}},e(a)}catch(e){}return r},Cl=Zi,_l=Ds.set,Nl=Hs,wl=tl,Pl=function(e,t){var r=rl.console;r&&r.error&&(1===arguments.length?r.error(e):r.error(e,t))},Fl=qs,Dl=al,Al=Lt,Sl=Kr,xl=nl,Bl=$i,Tl=K,zl=Se("species"),Il="Promise",Ml=Al.get,jl=Al.set,El=Al.getterFor(Il),Ol=ll&&ll.prototype,Rl=ll,Ll=Ol,Vl=il.TypeError,Ul=il.document,Kl=il.process,Hl=Fl.f,ql=Hl,Gl=!!(Ul&&Ul.createEvent&&il.dispatchEvent),Yl=fl(il.PromiseRejectionEvent),Wl="unhandledrejection",Jl=!1,Zl=Sl(Il,(function(){var e=vl(Rl),t=e!==String(Rl);if(!t&&66===Tl)return!0;if(Tl>=51&&/native code/.test(e))return!1;var r=new Rl((function(e){e(1)})),a=function(e){e((function(){}),(function(){}))};return(r.constructor={})[zl]=a,!(Jl=r.then((function(){}))instanceof a)||!t&&xl&&!Yl})),Ql=Zl||!kl((function(e){Rl.all(e).catch((function(){}))})),$l=function(e){var t;return!(!yl(e)||!fl(t=e.then))&&t},Xl=function(e,t){if(!e.notified){e.notified=!0;var r=e.reactions;Nl((function(){for(var a=e.value,n=1==e.state,o=0;r.length>o;){var i,s,l,d=r[o++],c=n?d.ok:d.fail,u=d.resolve,p=d.reject,m=d.domain;try{c?(n||(2===e.rejection&&ad(e),e.rejection=1),!0===c?i=a:(m&&m.enter(),i=c(a),m&&(m.exit(),l=!0)),i===d.promise?p(Vl("Promise-chain cycle")):(s=$l(i))?s.call(i,u,p):u(i)):p(a)}catch(e){m&&!l&&m.exit(),p(e)}}e.reactions=[],e.notified=!1,t&&!e.rejection&&td(e)}))}},ed=function(e,t,r){var a,n;Gl?((a=Ul.createEvent("Event")).promise=t,a.reason=r,a.initEvent(e,!1,!0),il.dispatchEvent(a)):a={promise:t,reason:r},!Yl&&(n=il["on"+e])?n(a):e===Wl&&Pl("Unhandled promise rejection",r)},td=function(e){_l.call(il,(function(){var t,r=e.facade,a=e.value;if(rd(e)&&(t=Dl((function(){Bl?Kl.emit("unhandledRejection",a,r):ed(Wl,r,a)})),e.rejection=Bl||rd(e)?2:1,t.error))throw t.value}))},rd=function(e){return 1!==e.rejection&&!e.parent},ad=function(e){_l.call(il,(function(){var t=e.facade;Bl?Kl.emit("rejectionHandled",t):ed("rejectionhandled",t,e.value)}))},nd=function(e,t,r){return function(a){e(t,a,r)}},od=function(e,t,r){e.done||(e.done=!0,r&&(e=r),e.value=t,e.state=2,Xl(e,!0))},id=function(e,t,r){if(!e.done){e.done=!0,r&&(e=r);try{if(e.facade===t)throw Vl("Promise can't be resolved itself");var a=$l(t);a?Nl((function(){var r={done:!1};try{a.call(t,nd(id,r,e),nd(od,r,e))}catch(t){od(r,t,e)}})):(e.value=t,e.state=1,Xl(e,!1))}catch(t){od({done:!1},t,e)}}};if(Zl&&(Ll=(Rl=function(e){bl(this,Rl,Il),hl(e),Ws.call(this);var t=Ml(this);try{e(nd(id,t),nd(od,t))}catch(e){od(t,e)}}).prototype,(Ws=function(e){jl(this,{type:Il,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0})}).prototype=cl(Ll,{then:function(e,t){var r=El(this),a=Hl(Cl(this,Rl));return a.ok=!fl(e)||e,a.fail=fl(t)&&t,a.domain=Bl?Kl.domain:void 0,r.parent=!0,r.reactions.push(a),0!=r.state&&Xl(r,!1),a.promise},catch:function(e){return this.then(void 0,e)}}),Js=function(){var e=new Ws,t=Ml(e);this.promise=e,this.resolve=nd(id,t),this.reject=nd(od,t)},Fl.f=Hl=function(e){return e===Rl||e===Zs?new Js(e):ql(e)},fl(ll)&&Ol!==Object.prototype)){Qs=Ol.then,Jl||(dl(Ol,"then",(function(e,t){var r=this;return new Rl((function(e,t){Qs.call(r,e,t)})).then(e,t)}),{unsafe:!0}),dl(Ol,"catch",Ll.catch,{unsafe:!0}));try{delete Ol.constructor}catch(Wh){}ul&&ul(Ol,Ll)}ol({global:!0,wrap:!0,forced:Zl},{Promise:Rl}),pl(Rl,Il,!1),ml(Il),Zs=sl(Il),ol({target:Il,stat:!0,forced:Zl},{reject:function(e){var t=Hl(this);return t.reject.call(void 0,e),t.promise}}),ol({target:Il,stat:!0,forced:Zl},{resolve:function(e){return wl(this,e)}}),ol({target:Il,stat:!0,forced:Ql},{all:function(e){var t=this,r=Hl(t),a=r.resolve,n=r.reject,o=Dl((function(){var r=hl(t.resolve),o=[],i=0,s=1;gl(e,(function(e){var l=i++,d=!1;o.push(void 0),s++,r.call(t,e).then((function(e){d||(d=!0,o[l]=e,--s||a(o))}),n)})),--s||a(o)}));return o.error&&n(o.value),r.promise},race:function(e){var t=this,r=Hl(t),a=r.reject,n=Dl((function(){var n=hl(t.resolve);gl(e,(function(e){n.call(t,e).then(r.resolve,a)}))}));return n.error&&a(n.value),r.promise}});var sd=ee,ld=qs,dd=al,cd=go;Qr({target:"Promise",stat:!0},{allSettled:function(e){var t=this,r=ld.f(t),a=r.resolve,n=r.reject,o=dd((function(){var r=sd(t.resolve),n=[],o=0,i=1;cd(e,(function(e){var s=o++,l=!1;n.push(void 0),i++,r.call(t,e).then((function(e){l||(l=!0,n[s]={status:"fulfilled",value:e},--i||a(n))}),(function(e){l||(l=!0,n[s]={status:"rejected",reason:e},--i||a(n))}))})),--i||a(n)}));return o.error&&n(o.value),r.promise}});var ud=ee,pd=M,md=qs,hd=al,fd=go,yd="No one promise resolved";Qr({target:"Promise",stat:!0},{any:function(e){var t=this,r=md.f(t),a=r.resolve,n=r.reject,o=hd((function(){var r=ud(t.resolve),o=[],i=0,s=1,l=!1;fd(e,(function(e){var d=i++,c=!1;o.push(void 0),s++,r.call(t,e).then((function(e){c||l||(l=!0,a(e))}),(function(e){c||l||(c=!0,o[d]=e,--s||n(new(pd("AggregateError"))(o,yd)))}))})),--s||n(new(pd("AggregateError"))(o,yd))}));return o.error&&n(o.value),r.promise}});var bd=Qr,vd=Bi,gd=u,kd=M,Cd=S,_d=Zi,Nd=tl,wd=dt.exports;if(bd({target:"Promise",proto:!0,real:!0,forced:!!vd&&gd((function(){vd.prototype.finally.call({then:function(){}},(function(){}))}))},{finally:function(e){var t=_d(this,kd("Promise")),r=Cd(e);return this.then(r?function(r){return Nd(t,e()).then((function(){return r}))}:e,r?function(r){return Nd(t,e()).then((function(){throw r}))}:e)}}),Cd(vd)){var Pd=kd("Promise").prototype.finally;vd.prototype.finally!==Pd&&wd(vd.prototype,"finally",Pd,{unsafe:!0})}var Fd=ir,Dd=Co,Ad=P,Sd=function(e){return function(t,r){var a,n,o=Dd(Ad(t)),i=Fd(r),s=o.length;return i<0||i>=s?e?"":void 0:(a=o.charCodeAt(i))<55296||a>56319||i+1===s||(n=o.charCodeAt(i+1))<56320||n>57343?e?o.charAt(i):a:e?o.slice(i,i+2):n-56320+(a-55296<<10)+65536}},xd={codeAt:Sd(!1),charAt:Sd(!0)}.charAt,Bd=Co,Td=Lt,zd=bi,Id="String Iterator",Md=Td.set,jd=Td.getterFor(Id);zd(String,"String",(function(e){Md(this,{type:Id,string:Bd(e),index:0})}),(function(){var e,t=jd(this),r=t.string,a=t.index;return a>=r.length?{value:void 0,done:!0}:(e=xd(r,a),t.index+=e.length,{value:e,done:!1})})),ua.Promise,[Element.prototype,CharacterData.prototype,DocumentType.prototype].forEach((function(e){e.hasOwnProperty("remove")||Object.defineProperty(e,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){null!==this.parentNode&&this.parentNode.removeChild(this)}})}));var Ed={payButton:"Pay","payButton.redirecting":"Redirecting...",storeDetails:"Save for my next payment","creditCard.holderName":"Name on card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Invalid cardholder name","creditCard.numberField.title":"Card number","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Expiry date","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"Month","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"Year","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Remember for next time","creditCard.cvcField.placeholder.4digits":"4 digits","creditCard.cvcField.placeholder.3digits":"3 digits","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Number of installments",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} months","installments.oneTime":"One time payment","installments.installments":"Installments payment","installments.revolving":"Revolving payment","sepaDirectDebit.ibanField.invalid":"Invalid account number","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Holder Name","sepa.ibanNumber":"Account Number (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirect failed","error.subtitle.payment":"Payment failed","error.subtitle.refused":"Payment refused","error.message.unknown":"An unknown error occurred","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Select your bank","creditCard.success":"Payment Successful",loading:"Loading\u2026",continue:"Continue",continueTo:"Continue to","wechatpay.timetopay":"You have %@ to pay","wechatpay.scanqrcode":"Scan QR code",personalDetails:"Personal details",companyDetails:"Company details","companyDetails.name":"Company name","companyDetails.registrationNumber":"Registration number",socialSecurityNumber:"Social security number",firstName:"First name",infix:"Prefix",lastName:"Last name",mobileNumber:"Mobile number","mobileNumber.invalid":"Invalid mobile number",city:"City",postalCode:"Postal code",countryCode:"Country Code",telephoneNumber:"Telephone number",dateOfBirth:"Date of birth",shopperEmail:"Email address",gender:"Gender",male:"Male",female:"Female",billingAddress:"Billing address",street:"Street",stateOrProvince:"State or province",country:"Country",houseNumberOrName:"House number",separateDeliveryAddress:"Specify a separate delivery address",deliveryAddress:"Delivery Address",zipCode:"Zip code",apartmentSuite:"Apartment / Suite",provinceOrTerritory:"Province or Territory",cityTown:"City / Town",address:"Address",state:"State","field.title.optional":"(optional)","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Select your wallet",privacyPolicy:"Privacy policy","afterPay.agreement":"I agree with the %@ of AfterPay",paymentConditions:"payment conditions",openApp:"Open the app","voucher.readInstructions":"Read instructions","voucher.introduction":"Thank you for your purchase, please use the following coupon to complete your payment.","voucher.expirationDate":"Expiration Date","voucher.alternativeReference":"Alternative Reference","dragonpay.voucher.non.bank.selectField.placeholder":"Select your provider","dragonpay.voucher.bank.selectField.placeholder":"Select your bank","voucher.paymentReferenceLabel":"Payment Reference","voucher.surcharge":"Incl. %@ surcharge","voucher.introduction.doku":"Thank you for your purchase, please use the following information to complete your payment.","voucher.shopperName":"Shopper Name","voucher.merchantName":"Merchant","voucher.introduction.econtext":"Thank you for your purchase, please use the following information to complete your payment.","voucher.telephoneNumber":"Phone Number","voucher.shopperReference":"Shopper Reference","voucher.collectionInstitutionNumber":"Collection Institution Number","voucher.econtext.telephoneNumber.invalid":"Telephone number must be 10 or 11 digits long","boletobancario.btnLabel":"Generate Boleto","boleto.sendCopyToEmail":"Send a copy to my email","button.copy":"Copy","button.download":"Download","boleto.socialSecurityNumber":"CPF/CNPJ","creditCard.storedCard.description.ariaLabel":"Stored card ends in %@","voucher.entity":"Entity",donateButton:"Donate",notNowButton:"Not now",thanksForYourSupport:"Thanks for your support!",preauthorizeWith:"Preauthorize with",confirmPreauthorization:"Confirm preauthorization",confirmPurchase:"Confirm purchase",applyGiftcard:"Redeem",giftcardBalance:"Gift card balance",deductedBalance:"Deducted balance","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"First 2 digits of card password","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Invalid password","creditCard.taxNumber.label":"Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)","creditCard.taxNumber.labelAlt":"Corporate registration number (10 digits)","creditCard.taxNumber.invalid":"Invalid Cardholder birthdate or Corporate registration number","storedPaymentMethod.disable.button":"Remove","storedPaymentMethod.disable.confirmation":"Remove stored payment method","storedPaymentMethod.disable.confirmButton":"Yes, remove","storedPaymentMethod.disable.cancelButton":"Cancel","ach.bankAccount":"Bank account","ach.accountHolderNameField.title":"Account holder name","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Invalid account holder name","ach.accountNumberField.title":"Account number","ach.accountNumberField.invalid":"Invalid account number","ach.accountLocationField.title":"ABA routing number","ach.accountLocationField.invalid":"Invalid ABA routing number","select.state":"Select state","select.stateOrProvince":"Select state or province","select.provinceOrTerritory":"Select province or territory","select.country":"Select country","select.noOptionsFound":"No options found","select.filter.placeholder":"Search...","telephoneNumber.invalid":"Invalid telephone number",qrCodeOrApp:"or","paypal.processingPayment":"Processing payment...",generateQRCode:"Generate QR code","await.waitForConfirmation":"Waiting for confirmation","mbway.confirmPayment":"Confirm your payment on the MB WAY app","shopperEmail.invalid":"Invalid email address","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"You must be at least 18 years old","blik.confirmPayment":"Open your banking app to confirm the payment.","blik.invalid":"Enter 6 numbers","blik.code":"6-digit code","blik.help":"Get the code from your banking app.","swish.pendingMessage":"After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.","error.va.gen.01":"Incomplete field","error.va.gen.02":"Field not valid","error.va.sf-cc-num.01":"Invalid card number","error.va.sf-cc-num.03":"Unsupported card entered","error.va.sf-cc-dat.01":"Card too old","error.va.sf-cc-dat.02":"Date too far in the future","error.va.sf-cc-dat.03":"Your card expires before check out date","error.va.sf-ach-num.01":"Invalid account number","error.va.sf-ach-loc.01":"Invalid ABA routing number","error.va.sf-kcp-pwd.01":"Invalid password","error.giftcard.no-balance":"This gift card has zero balance","error.giftcard.card-error":"In our records we have no gift card with this number","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Sign out from Amazon","amazonpay.changePaymentDetails":"Change payment details","partialPayment.warning":"Select another payment method to pay the remaining","partialPayment.remainingBalance":"Remaining balance will be %{amount}","bankTransfer.beneficiary":"Beneficiary","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.","bankTransfer.instructions":"Thank you for your purchase, please use the following information to complete your payment.","bacs.accountHolderName":"Bank account holder name","bacs.accountHolderName.invalid":"Invalid bank account holder name","bacs.accountNumber":"Bank account number","bacs.accountNumber.invalid":"Invalid bank account number","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Invalid sort code","bacs.consent.amount":"I agree that the above amount will be deducted from my bank account.","bacs.consent.account":"I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.",edit:"Edit","bacs.confirm":"Confirm and pay","bacs.result.introduction":"Download your Direct Debit Instruction (DDI / Mandate)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured card number","creditCard.encryptedCardNumber.aria.label":"Card number field","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for secured card expiry date","creditCard.encryptedExpiryDate.aria.label":"Expiry date field","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for secured card expiry month","creditCard.encryptedExpiryMonth.aria.label":"Expiry month field","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for secured card expiry year","creditCard.encryptedExpiryYear.aria.label":"Expiry year field","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured card security code","creditCard.encryptedSecurityCode.aria.label":"Security code field","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured gift card number","giftcard.encryptedCardNumber.aria.label":"Gift card number field","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured gift card security code","giftcard.encryptedSecurityCode.aria.label":"Gift card security code field",giftcardTransactionLimit:"Max. %{amount} allowed per transaction on this gift card","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for secured bank account number","ach.encryptedBankAccountNumber.aria.label":"Bank account field","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for secured bank routing number","ach.encryptedBankLocationId.aria.label":"Bank routing number field","pix.instructions":"Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code","twint.saved":"saved"},Od=Object.freeze({__proto__:null,default:Ed}),Rd="en-US",Ld=Ed,Vd={ar:function(){return Promise.resolve().then((function(){return Rk}))},"cs-CZ":function(){return Promise.resolve().then((function(){return Lk}))},"da-DK":function(){return Promise.resolve().then((function(){return Vk}))},"de-DE":function(){return Promise.resolve().then((function(){return Uk}))},"el-GR":function(){return Promise.resolve().then((function(){return Kk}))},"en-US":function(){return Promise.resolve().then((function(){return Od}))},"es-ES":function(){return Promise.resolve().then((function(){return Hk}))},"fi-FI":function(){return Promise.resolve().then((function(){return qk}))},"fr-FR":function(){return Promise.resolve().then((function(){return Gk}))},"hr-HR":function(){return Promise.resolve().then((function(){return Yk}))},"hu-HU":function(){return Promise.resolve().then((function(){return Wk}))},"it-IT":function(){return Promise.resolve().then((function(){return Jk}))},"ja-JP":function(){return Promise.resolve().then((function(){return Zk}))},"ko-KR":function(){return Promise.resolve().then((function(){return Qk}))},"nl-NL":function(){return Promise.resolve().then((function(){return $k}))},"no-NO":function(){return Promise.resolve().then((function(){return Xk}))},"pl-PL":function(){return Promise.resolve().then((function(){return eC}))},"pt-BR":function(){return Promise.resolve().then((function(){return tC}))},"ro-RO":function(){return Promise.resolve().then((function(){return rC}))},"ru-RU":function(){return Promise.resolve().then((function(){return aC}))},"sk-SK":function(){return Promise.resolve().then((function(){return nC}))},"sl-SI":function(){return Promise.resolve().then((function(){return oC}))},"sv-SE":function(){return Promise.resolve().then((function(){return iC}))},"zh-CN":function(){return Promise.resolve().then((function(){return sC}))},"zh-TW":function(){return Promise.resolve().then((function(){return lC}))}},Ud=function(e){return e.toLowerCase().substring(0,2)};function Kd(e){var t=e.replace("_","-");if(new RegExp("([a-z]{2})([-])([A-Z]{2})").test(t))return t;var r=t.split("-"),a=r[0],n=r[1];if(!a||!n)return null;var o=[a.toLowerCase(),n.toUpperCase()].join("-");return 5===o.length?o:null}function Hd(e,t){if(void 0===t&&(t=[]),!e||e.length<1||e.length>5)return Rd;var r=Kd(e);return t.indexOf(r)>-1?r:function(e,t){return e&&"string"==typeof e&&t.find((function(t){return Ud(t)===Ud(e)}))||null}(r||e,t)}var qd,Gd,Yd,Wd,Jd,Zd=function(e,t){return e.replace(/%{(\w+)}/g,(function(e,r){return t[r]||""}))},Qd={IDR:1,JPY:1,KRW:1,VND:1,BYR:1,CVE:1,DJF:1,GHC:1,GNF:1,KMF:1,PYG:1,RWF:1,UGX:1,VUV:1,XAF:1,XOF:1,XPF:1,MRO:10,BHD:1e3,IQD:1e3,JOD:1e3,KWD:1e3,OMR:1e3,LYD:1e3,TND:1e3},$d=function(e,t){var r=function(e){return Qd[e]||100}(t);return parseInt(String(e),10)/r},Xd=function(){function e(e,t){var a=this;void 0===e&&(e=Rd),void 0===t&&(t={}),this.translations=Ld;var s=Object.keys(Vd);this.customTranslations=function(e,t){return void 0===e&&(e={}),Object.keys(e).reduce((function(r,a){var n=Kd(a)||Hd(a,t);return n&&(r[n]=e[a]),r}),{})}(t,s);var l=Object.keys(this.customTranslations);this.supportedLocales=i(i([],s),l).filter((function(e,t,r){return r.indexOf(e)===t})),this.locale=Kd(e)||Hd(e,this.supportedLocales)||Rd;var d=this.locale.split("-")[0];this.languageCode=d,this.loaded=function(e,t){return void 0===t&&(t={}),n(void 0,void 0,void 0,(function(){var a,n;return o(this,(function(o){switch(o.label){case 0:return a=Hd(e,Object.keys(Vd))||Rd,[4,Vd[a]()];case 1:return n=o.sent(),[2,r(r(r({},Ld),n.default),!!t[e]&&t[e])]}}))}))}(this.locale,this.customTranslations).then((function(e){a.translations=e}))}return e.prototype.get=function(e,t){var r=function(e,t,r){void 0===r&&(r={values:{},count:0});var a=t+"__plural",n=function(e){return t+"__"+e};return Object.prototype.hasOwnProperty.call(e,n(r.count))?Zd(e[n(r.count)],r.values):Object.prototype.hasOwnProperty.call(e,a)&&r.count>1?Zd(e[a],r.values):Object.prototype.hasOwnProperty.call(e,t)?Zd(e[t],r.values):null}(this.translations,e,t);return null!==r?r:e},e.prototype.amount=function(e,t,a){return function(e,t,a,n){void 0===n&&(n={});var o=e.toString(),i=$d(o,a),s=t.replace("_","-"),l=r({style:"currency",currency:a,currencyDisplay:"symbol"},n);try{return i.toLocaleString(s,l)}catch(e){return o}}(e,this.locale,t,a)},e.prototype.date=function(e,t){void 0===t&&(t={});var a=r({year:"numeric",month:"2-digit",day:"2-digit"},t);return new Date(e).toLocaleDateString(this.locale,a)},e}(),ec={},tc=[],rc=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function ac(e,t){for(var r in t)e[r]=t[r];return e}function nc(e){var t=e.parentNode;t&&t.removeChild(e)}function oc(e,t,r){var a,n,o,i=arguments,s={};for(o in t)"key"==o?a=t[o]:"ref"==o?n=t[o]:s[o]=t[o];if(arguments.length>3)for(r=[r],o=3;o<arguments.length;o++)r.push(i[o]);if(null!=r&&(s.children=r),"function"==typeof e&&null!=e.defaultProps)for(o in e.defaultProps)void 0===s[o]&&(s[o]=e.defaultProps[o]);return ic(e,s,a,n,null)}function ic(e,t,r,a,n){var o={type:e,props:t,key:r,ref:a,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==n?++qd.__v:n};return null!=qd.vnode&&qd.vnode(o),o}function sc(e){return e.children}function lc(e,t){this.props=e,this.context=t}function dc(e,t){if(null==t)return e.__?dc(e.__,e.__.__k.indexOf(e)+1):null;for(var r;t<e.__k.length;t++)if(null!=(r=e.__k[t])&&null!=r.__e)return r.__e;return"function"==typeof e.type?dc(e):null}function cc(e){var t,r;if(null!=(e=e.__)&&null!=e.__c){for(e.__e=e.__c.base=null,t=0;t<e.__k.length;t++)if(null!=(r=e.__k[t])&&null!=r.__e){e.__e=e.__c.base=r.__e;break}return cc(e)}}function uc(e){(!e.__d&&(e.__d=!0)&&Gd.push(e)&&!pc.__r++||Wd!==qd.debounceRendering)&&((Wd=qd.debounceRendering)||Yd)(pc)}function pc(){for(var e;pc.__r=Gd.length;)e=Gd.sort((function(e,t){return e.__v.__b-t.__v.__b})),Gd=[],e.some((function(e){var t,r,a,n,o,i;e.__d&&(o=(n=(t=e).__v).__e,(i=t.__P)&&(r=[],(a=ac({},n)).__v=n.__v+1,Cc(i,n,a,t.__n,void 0!==i.ownerSVGElement,null!=n.__h?[o]:null,r,null==o?dc(n):o,n.__h),_c(r,n),n.__e!=o&&cc(n)))}))}function mc(e,t,r,a,n,o,i,s,l,d){var c,u,p,m,h,f,y,b=a&&a.__k||tc,v=b.length;for(r.__k=[],c=0;c<t.length;c++)if(null!=(m=r.__k[c]=null==(m=t[c])||"boolean"==typeof m?null:"string"==typeof m||"number"==typeof m||"bigint"==typeof m?ic(null,m,null,null,m):Array.isArray(m)?ic(sc,{children:m},null,null,null):m.__b>0?ic(m.type,m.props,m.key,null,m.__v):m)){if(m.__=r,m.__b=r.__b+1,null===(p=b[c])||p&&m.key==p.key&&m.type===p.type)b[c]=void 0;else for(u=0;u<v;u++){if((p=b[u])&&m.key==p.key&&m.type===p.type){b[u]=void 0;break}p=null}Cc(e,m,p=p||ec,n,o,i,s,l,d),h=m.__e,(u=m.ref)&&p.ref!=u&&(y||(y=[]),p.ref&&y.push(p.ref,null,m),y.push(u,m.__c||h,m)),null!=h?(null==f&&(f=h),"function"==typeof m.type&&null!=m.__k&&m.__k===p.__k?m.__d=l=hc(m,l,e):l=yc(e,m,p,b,h,l),d||"option"!==r.type?"function"==typeof r.type&&(r.__d=l):e.value=""):l&&p.__e==l&&l.parentNode!=e&&(l=dc(p))}for(r.__e=f,c=v;c--;)null!=b[c]&&("function"==typeof r.type&&null!=b[c].__e&&b[c].__e==r.__d&&(r.__d=dc(a,c+1)),wc(b[c],b[c]));if(y)for(c=0;c<y.length;c++)Nc(y[c],y[++c],y[++c])}function hc(e,t,r){var a,n;for(a=0;a<e.__k.length;a++)(n=e.__k[a])&&(n.__=e,t="function"==typeof n.type?hc(n,t,r):yc(r,n,n,e.__k,n.__e,t));return t}function fc(e,t){return t=t||[],null==e||"boolean"==typeof e||(Array.isArray(e)?e.some((function(e){fc(e,t)})):t.push(e)),t}function yc(e,t,r,a,n,o){var i,s,l;if(void 0!==t.__d)i=t.__d,t.__d=void 0;else if(null==r||n!=o||null==n.parentNode)e:if(null==o||o.parentNode!==e)e.appendChild(n),i=null;else{for(s=o,l=0;(s=s.nextSibling)&&l<a.length;l+=2)if(s==n)break e;e.insertBefore(n,o),i=o}return void 0!==i?i:n.nextSibling}function bc(e,t,r){"-"===t[0]?e.setProperty(t,r):e[t]=null==r?"":"number"!=typeof r||rc.test(t)?r:r+"px"}function vc(e,t,r,a,n){var o;e:if("style"===t)if("string"==typeof r)e.style.cssText=r;else{if("string"==typeof a&&(e.style.cssText=a=""),a)for(t in a)r&&t in r||bc(e.style,t,"");if(r)for(t in r)a&&r[t]===a[t]||bc(e.style,t,r[t])}else if("o"===t[0]&&"n"===t[1])o=t!==(t=t.replace(/Capture$/,"")),t=t.toLowerCase()in e?t.toLowerCase().slice(2):t.slice(2),e.l||(e.l={}),e.l[t+o]=r,r?a||e.addEventListener(t,o?kc:gc,o):e.removeEventListener(t,o?kc:gc,o);else if("dangerouslySetInnerHTML"!==t){if(n)t=t.replace(/xlink[H:h]/,"h").replace(/sName$/,"s");else if("href"!==t&&"list"!==t&&"form"!==t&&"tabIndex"!==t&&"download"!==t&&t in e)try{e[t]=null==r?"":r;break e}catch(e){}"function"==typeof r||(null!=r&&(!1!==r||"a"===t[0]&&"r"===t[1])?e.setAttribute(t,r):e.removeAttribute(t))}}function gc(e){this.l[e.type+!1](qd.event?qd.event(e):e)}function kc(e){this.l[e.type+!0](qd.event?qd.event(e):e)}function Cc(e,t,r,a,n,o,i,s,l){var d,c,u,p,m,h,f,y,b,v,g,k=t.type;if(void 0!==t.constructor)return null;null!=r.__h&&(l=r.__h,s=t.__e=r.__e,t.__h=null,o=[s]),(d=qd.__b)&&d(t);try{e:if("function"==typeof k){if(y=t.props,b=(d=k.contextType)&&a[d.__c],v=d?b?b.props.value:d.__:a,r.__c?f=(c=t.__c=r.__c).__=c.__E:("prototype"in k&&k.prototype.render?t.__c=c=new k(y,v):(t.__c=c=new lc(y,v),c.constructor=k,c.render=Pc),b&&b.sub(c),c.props=y,c.state||(c.state={}),c.context=v,c.__n=a,u=c.__d=!0,c.__h=[]),null==c.__s&&(c.__s=c.state),null!=k.getDerivedStateFromProps&&(c.__s==c.state&&(c.__s=ac({},c.__s)),ac(c.__s,k.getDerivedStateFromProps(y,c.__s))),p=c.props,m=c.state,u)null==k.getDerivedStateFromProps&&null!=c.componentWillMount&&c.componentWillMount(),null!=c.componentDidMount&&c.__h.push(c.componentDidMount);else{if(null==k.getDerivedStateFromProps&&y!==p&&null!=c.componentWillReceiveProps&&c.componentWillReceiveProps(y,v),!c.__e&&null!=c.shouldComponentUpdate&&!1===c.shouldComponentUpdate(y,c.__s,v)||t.__v===r.__v){c.props=y,c.state=c.__s,t.__v!==r.__v&&(c.__d=!1),c.__v=t,t.__e=r.__e,t.__k=r.__k,t.__k.forEach((function(e){e&&(e.__=t)})),c.__h.length&&i.push(c);break e}null!=c.componentWillUpdate&&c.componentWillUpdate(y,c.__s,v),null!=c.componentDidUpdate&&c.__h.push((function(){c.componentDidUpdate(p,m,h)}))}c.context=v,c.props=y,c.state=c.__s,(d=qd.__r)&&d(t),c.__d=!1,c.__v=t,c.__P=e,d=c.render(c.props,c.state,c.context),c.state=c.__s,null!=c.getChildContext&&(a=ac(ac({},a),c.getChildContext())),u||null==c.getSnapshotBeforeUpdate||(h=c.getSnapshotBeforeUpdate(p,m)),g=null!=d&&d.type===sc&&null==d.key?d.props.children:d,mc(e,Array.isArray(g)?g:[g],t,r,a,n,o,i,s,l),c.base=t.__e,t.__h=null,c.__h.length&&i.push(c),f&&(c.__E=c.__=null),c.__e=!1}else null==o&&t.__v===r.__v?(t.__k=r.__k,t.__e=r.__e):t.__e=function(e,t,r,a,n,o,i,s){var l,d,c,u,p=r.props,m=t.props,h=t.type,f=0;if("svg"===h&&(n=!0),null!=o)for(;f<o.length;f++)if((l=o[f])&&(l===e||(h?l.localName==h:3==l.nodeType))){e=l,o[f]=null;break}if(null==e){if(null===h)return document.createTextNode(m);e=n?document.createElementNS("http://www.w3.org/2000/svg",h):document.createElement(h,m.is&&m),o=null,s=!1}if(null===h)p===m||s&&e.data===m||(e.data=m);else{if(o=o&&tc.slice.call(e.childNodes),d=(p=r.props||ec).dangerouslySetInnerHTML,c=m.dangerouslySetInnerHTML,!s){if(null!=o)for(p={},u=0;u<e.attributes.length;u++)p[e.attributes[u].name]=e.attributes[u].value;(c||d)&&(c&&(d&&c.__html==d.__html||c.__html===e.innerHTML)||(e.innerHTML=c&&c.__html||""))}if(function(e,t,r,a,n){var o;for(o in r)"children"===o||"key"===o||o in t||vc(e,o,null,r[o],a);for(o in t)n&&"function"!=typeof t[o]||"children"===o||"key"===o||"value"===o||"checked"===o||r[o]===t[o]||vc(e,o,t[o],r[o],a)}(e,m,p,n,s),c)t.__k=[];else if(f=t.props.children,mc(e,Array.isArray(f)?f:[f],t,r,a,n&&"foreignObject"!==h,o,i,e.firstChild,s),null!=o)for(f=o.length;f--;)null!=o[f]&&nc(o[f]);s||("value"in m&&void 0!==(f=m.value)&&(f!==e.value||"progress"===h&&!f)&&vc(e,"value",f,p.value,!1),"checked"in m&&void 0!==(f=m.checked)&&f!==e.checked&&vc(e,"checked",f,p.checked,!1))}return e}(r.__e,t,r,a,n,o,i,l);(d=qd.diffed)&&d(t)}catch(e){t.__v=null,(l||null!=o)&&(t.__e=s,t.__h=!!l,o[o.indexOf(s)]=null),qd.__e(e,t,r)}}function _c(e,t){qd.__c&&qd.__c(t,e),e.some((function(t){try{e=t.__h,t.__h=[],e.some((function(e){e.call(t)}))}catch(e){qd.__e(e,t.__v)}}))}function Nc(e,t,r){try{"function"==typeof e?e(t):e.current=t}catch(e){qd.__e(e,r)}}function wc(e,t,r){var a,n,o;if(qd.unmount&&qd.unmount(e),(a=e.ref)&&(a.current&&a.current!==e.__e||Nc(a,null,t)),r||"function"==typeof e.type||(r=null!=(n=e.__e)),e.__e=e.__d=void 0,null!=(a=e.__c)){if(a.componentWillUnmount)try{a.componentWillUnmount()}catch(e){qd.__e(e,t)}a.base=a.__P=null}if(a=e.__k)for(o=0;o<a.length;o++)a[o]&&wc(a[o],t,r);null!=n&&nc(n)}function Pc(e,t,r){return this.constructor(e,r)}function Fc(e,t,r){var a,n,o;qd.__&&qd.__(e,t),n=(a="function"==typeof r)?null:r&&r.__k||t.__k,o=[],Cc(t,e=(!a&&r||t).__k=oc(sc,null,[e]),n||ec,ec,void 0!==t.ownerSVGElement,!a&&r?[r]:n?null:t.firstChild?tc.slice.call(t.childNodes):null,o,!a&&r?r:n?n.__e:t.firstChild,a),_c(o,e)}qd={__e:function(e,t){for(var r,a,n;t=t.__;)if((r=t.__c)&&!r.__)try{if((a=r.constructor)&&null!=a.getDerivedStateFromError&&(r.setState(a.getDerivedStateFromError(e)),n=r.__d),null!=r.componentDidCatch&&(r.componentDidCatch(e),n=r.__d),n)return r.__E=r}catch(t){e=t}throw e},__v:0},lc.prototype.setState=function(e,t){var r;r=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=ac({},this.state),"function"==typeof e&&(e=e(ac({},r),this.props)),e&&ac(r,e),null!=e&&this.__v&&(t&&this.__h.push(t),uc(this))},lc.prototype.forceUpdate=function(e){this.__v&&(this.__e=!0,e&&this.__h.push(e),uc(this))},lc.prototype.render=sc,Gd=[],Yd="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,pc.__r=0,Jd=0;var Dc=function(e,t){return t.split(".").reduce((function(e,t){return e&&e[t]?e[t]:void 0}),e)},Ac=function(){var e=this;this.events={},this.on=function(t,r){e.events[t]=e.events[t]||[],e.events[t].push(r)},this.off=function(t,r){e.events[t]&&(e.events[t]=e.events[t].reduce((function(e,t){return t!==r&&e.push(t),e}),[]))},this.emit=function(t,r){e.events[t]&&e.events[t].forEach((function(e){e(r)}))}};function Sc(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=16*Math.random()|0;return("x"==e?t:3&t|8).toString(16)}))}var xc=function(){function e(e){this._id=this.constructor.type+"-"+Sc(),this.eventEmitter=new Ac,this.props=this.formatProps(r(r({},this.constructor.defaultProps),e)),this._parentInstance=this.props._parentInstance,this._node=null,this.state={}}return e.prototype.formatProps=function(e){return e},e.prototype.formatData=function(){return{}},e.prototype.setState=function(e){this.state=r(r({},this.state),e)},Object.defineProperty(e.prototype,"data",{get:function(){var e=Dc(this.props,"modules.risk.data"),t=Dc(this.props,"modules.analytics.checkoutAttemptId"),a=this.state.order||this.props.order;return r(r(r(r(r({},e&&{riskData:{clientData:e}}),t&&{checkoutAttemptId:t}),a&&{order:{orderData:a.orderData,pspReference:a.pspReference}}),this.formatData()),{clientStateDataIndicator:!0})},enumerable:!1,configurable:!0}),e.prototype.render=function(){throw new Error("Payment method cannot be rendered.")},e.prototype.mount=function(e){var t,r="string"==typeof e?document.querySelector(e):e;if(!r)throw new Error("Component could not mount. Root node was not found.");if(this._node)throw new Error("Component is already mounted.");return this._node=r,this._component=this.render(),Fc(this._component,r),this.props.modules&&this.props.modules.analytics&&!this.props.isDropin&&this.props.modules.analytics.send({containerWidth:this._node&&this._node.offsetWidth,component:null!==(t=this.constructor.analyticsType)&&void 0!==t?t:this.constructor.type,flavor:"components"}),this},e.prototype.update=function(e){return this.props=this.formatProps(r(r({},this.props),e)),this.state={},this.unmount().remount()},e.prototype.remount=function(e){if(!this._node)throw new Error("Component is not mounted.");return Fc(e||this.render(),this._node,null),this},e.prototype.unmount=function(){return this._node&&Fc(null,this._node),this},e.prototype.remove=function(){this.unmount(),this._parentInstance&&this._parentInstance.remove(this)},e.defaultProps={},e}(),Bc="https://checkoutshopper-live.adyen.com/checkoutshopper/",Tc=["amount","countryCode","environment","loadingContext","i18n","modules","order","session","clientKey","showPayButton","installmentOptions","onPaymentCompleted","beforeRedirect","beforeSubmit","onSubmit","onAdditionalDetails","onCancel","onChange","onError","onBalanceCheck","onOrderRequest","setStatusAutomatically"],zc=function(e){var t=e.loadingContext,n=void 0===t?Bc:t,o=e.extension,i=void 0===o?"svg":o,s=a(e,["loadingContext","extension"]);return function(e){return function(e){var t=e.name,r=e.loadingContext,a=e.imageFolder,n=void 0===a?"":a,o=e.parentFolder,i=void 0===o?"":o,s=e.extension,l=e.size,d=void 0===l?"":l,c=e.subFolder;return r+"images/"+n+(void 0===c?"":c)+i+t+d+"."+s}(r({extension:i,loadingContext:n,imageFolder:"logos/",parentFolder:"",name:e},s))}},Ic={exports:{}};!function(e){!function(){var t={}.hasOwnProperty;function r(){for(var e=[],a=0;a<arguments.length;a++){var n=arguments[a];if(n){var o=typeof n;if("string"===o||"number"===o)e.push(n);else if(Array.isArray(n)){if(n.length){var i=r.apply(null,n);i&&e.push(i)}}else if("object"===o)if(n.toString===Object.prototype.toString)for(var s in n)t.call(n,s)&&n[s]&&e.push(s);else e.push(n.toString())}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):window.classNames=r}()}(Ic);var Mc,jc,Ec,Oc=Ic.exports,Rc=function(e){var t=e.inline,r=void 0!==t&&t,a=e.size;return oc("div",{className:"adyen-checkout__spinner__wrapper "+(r?"adyen-checkout__spinner__wrapper--inline":"")},oc("div",{className:"adyen-checkout__spinner adyen-checkout__spinner--"+(void 0===a?"large":a)}))},Lc=0,Vc=[],Uc=qd.__b,Kc=qd.__r,Hc=qd.diffed,qc=qd.__c,Gc=qd.unmount;function Yc(e,t){qd.__h&&qd.__h(jc,e,Lc||t),Lc=0;var r=jc.__H||(jc.__H={__:[],__h:[]});return e>=r.__.length&&r.__.push({}),r.__[e]}function Wc(e){return Lc=1,Jc(iu,e)}function Jc(e,t,r){var a=Yc(Mc++,2);return a.t=e,a.__c||(a.__=[r?r(t):iu(void 0,t),function(e){var t=a.t(a.__[0],e);a.__[0]!==t&&(a.__=[t,a.__[1]],a.__c.setState({}))}],a.__c=jc),a.__}function Zc(e,t){var r=Yc(Mc++,3);!qd.__s&&ou(r.__H,t)&&(r.__=e,r.__H=t,jc.__H.__h.push(r))}function Qc(e,t){var r=Yc(Mc++,4);!qd.__s&&ou(r.__H,t)&&(r.__=e,r.__H=t,jc.__h.push(r))}function $c(e){return Lc=5,Xc((function(){return{current:e}}),[])}function Xc(e,t){var r=Yc(Mc++,7);return ou(r.__H,t)&&(r.__=e(),r.__H=t,r.__h=e),r.__}function eu(e,t){return Lc=8,Xc((function(){return e}),t)}function tu(){Vc.forEach((function(e){if(e.__P)try{e.__H.__h.forEach(au),e.__H.__h.forEach(nu),e.__H.__h=[]}catch(t){e.__H.__h=[],qd.__e(t,e.__v)}})),Vc=[]}qd.__b=function(e){jc=null,Uc&&Uc(e)},qd.__r=function(e){Kc&&Kc(e),Mc=0;var t=(jc=e.__c).__H;t&&(t.__h.forEach(au),t.__h.forEach(nu),t.__h=[])},qd.diffed=function(e){Hc&&Hc(e);var t=e.__c;t&&t.__H&&t.__H.__h.length&&(1!==Vc.push(t)&&Ec===qd.requestAnimationFrame||((Ec=qd.requestAnimationFrame)||function(e){var t,r=function(){clearTimeout(a),ru&&cancelAnimationFrame(t),setTimeout(e)},a=setTimeout(r,100);ru&&(t=requestAnimationFrame(r))})(tu)),jc=void 0},qd.__c=function(e,t){t.some((function(e){try{e.__h.forEach(au),e.__h=e.__h.filter((function(e){return!e.__||nu(e)}))}catch(r){t.some((function(e){e.__h&&(e.__h=[])})),t=[],qd.__e(r,e.__v)}})),qc&&qc(e,t)},qd.unmount=function(e){Gc&&Gc(e);var t=e.__c;if(t&&t.__H)try{t.__H.__.forEach(au)}catch(e){qd.__e(e,t.__v)}};var ru="function"==typeof requestAnimationFrame;function au(e){var t=jc;"function"==typeof e.__c&&e.__c(),jc=t}function nu(e){var t=jc;e.__c=e.__(),jc=t}function ou(e,t){return!e||e.length!==t.length||t.some((function(t,r){return t!==e[r]}))}function iu(e,t){return"function"==typeof t?t(e):t}var su=function(e,t){var r={__c:t="__cC"+Jd++,__:e,Consumer:function(e,t){return e.children(t)},Provider:function(e){var r,a;return this.getChildContext||(r=[],(a={})[t]=this,this.getChildContext=function(){return a},this.shouldComponentUpdate=function(e){this.props.value!==e.value&&r.some(uc)},this.sub=function(e){r.push(e);var t=e.componentWillUnmount;e.componentWillUnmount=function(){r.splice(r.indexOf(e),1),t&&t.call(e)}}),e.children}};return r.Provider.__=r.Consumer.contextType=r}({i18n:new Xd,loadingContext:""});function lu(){return function(e){var t=jc.context[e.__c],r=Yc(Mc++,9);return r.__c=e,t?(null==r.__&&(r.__=!0,t.sub(jc)),t.props.value):e.__}(su)}var du=function(e){function r(){var t=null!==e&&e.apply(this,arguments)||this;return t.onClick=function(e){e.preventDefault(),t.props.disabled||t.props.onClick(e,{complete:t.complete})},t.complete=function(e){void 0===e&&(e=1e3),t.setState({completed:!0}),setTimeout((function(){t.setState({completed:!1})}),e)},t}return t(r,e),r.prototype.render=function(e,t){var r=e.classNameModifiers,a=void 0===r?[]:r,n=e.disabled,o=e.href,s=e.icon,l=e.secondary,d=e.inline,c=e.label,u=e.status,p=t.completed,m=lu().i18n,h=s?oc("img",{className:"adyen-checkout__button__icon",src:s,alt:"","aria-hidden":"true"}):"",f=i(i(i(i(i([],a),d?["inline"]:[]),p?["completed"]:[]),l?["secondary"]:[]),"loading"===u||"redirect"===u?["loading"]:[]),y=Oc(i(["adyen-checkout__button"],f.map((function(e){return"adyen-checkout__button--"+e})))),b={loading:oc(Rc,{size:"medium"}),redirect:oc("span",{className:"adyen-checkout__button__content"},oc(Rc,{size:"small",inline:!0}),m.get("payButton.redirecting")),default:oc("span",{className:"adyen-checkout__button__content"},h,oc("span",{className:"adyen-checkout__button__text"},c))},v=b[u]||b.default;return o?oc("a",{className:y,href:o,disabled:n,target:this.props.target,rel:this.props.rel},v):oc("button",{className:y,type:"button",disabled:n,onClick:this.onClick},v)},r.defaultProps={status:"default",disabled:!1,label:"",secondary:!1,inline:!1,target:"_self",onClick:function(){}},r}(lc),cu=function(e,t){return e.get("payButton")+" "+((null==t?void 0:t.value)&&(null==t?void 0:t.currency)?e.amount(t.value,t.currency):"")},uu=function(e){var t=e.amount,n=e.classNameModifiers,o=void 0===n?[]:n,s=e.label,l=a(e,["amount","classNameModifiers","label"]),d=lu().i18n,c=t&&{}.hasOwnProperty.call(t,"value")&&0===t.value?d.get("confirmPreauthorization"):cu(d,t);return oc(du,r({},l,{disabled:"loading"===l.status,classNameModifiers:i(i([],o),["pay"]),label:s||c}))},pu=["action","resultCode","sessionData","order"];var mu=function(e){function r(t,a){var n=e.call(this,a)||this;return n.name=r.errorTypes[t],n}return t(r,e),r.errorTypes={NETWORK_ERROR:"NETWORK_ERROR",CANCEL:"CANCEL",IMPLEMENTATION_ERROR:"IMPLEMENTATION_ERROR",ERROR:"ERROR"},r}(Error),hu=function(e){function a(t){var a=e.call(this,t)||this;return a.handleError=function(e){a.props.onError&&a.props.onError(e,a.elementRef)},a.handleAdditionalDetails=function(e){return a.props.onAdditionalDetails&&a.props.onAdditionalDetails(e,a.elementRef),a.props.session&&a.submitAdditionalDetails(e.data),e},a.handleOrder=function(e){a.elementRef._parentInstance.update({order:e})},a.handleFinalResult=function(e){if(!1!==a.props.setStatusAutomatically){var t=function(e){switch(e.resultCode){case"Authorised":case"Received":case"Pending":return["success"];case"Cancelled":case"Error":case"Refused":return["error"]}}(e),r=t[0],n=t[1];r&&a.elementRef.setStatus(r,n)}return a.props.onPaymentCompleted&&a.props.onPaymentCompleted(e,a.elementRef),e},a.payButton=function(e){return oc(uu,r({},e,{amount:a.props.amount,onClick:a.submit}))},a.submit=a.submit.bind(a),a.setState=a.setState.bind(a),a.onValid=a.onValid.bind(a),a.onComplete=a.onComplete.bind(a),a.onSubmit=a.onSubmit.bind(a),a.handleAction=a.handleAction.bind(a),a.handleOrder=a.handleOrder.bind(a),a.handleResponse=a.handleResponse.bind(a),a.elementRef=t&&t.elementRef||a,a}return t(a,e),a.prototype.setState=function(e){this.state=r(r({},this.state),e),this.onChange()},a.prototype.onChange=function(){var e=this.isValid,t={data:this.data,errors:this.state.errors,valid:this.state.valid,isValid:e};return this.props.onChange&&this.props.onChange(t,this.elementRef),e&&this.onValid(),t},a.prototype.onSubmit=function(){var e=this;if(this.props.onSubmit)this.props.onSubmit({data:this.data,isValid:this.isValid},this.elementRef);else if(this._parentInstance.session){(this.props.beforeSubmit?new Promise((function(t,r){return e.props.beforeSubmit(e.data,e.elementRef,{resolve:t,reject:r})})):Promise.resolve(this.data)).then((function(t){return e.submitPayment(t)})).catch((function(){}))}else this.handleError(new mu("IMPLEMENTATION_ERROR","Could not submit the payment"))},a.prototype.onValid=function(){var e={data:this.data};return this.props.onValid&&this.props.onValid(e,this.elementRef),e},a.prototype.onComplete=function(e){this.props.onComplete&&this.props.onComplete(e,this.elementRef)},a.prototype.submit=function(){if(!this.isValid)return this.showValidation(),null;this.onSubmit()},a.prototype.showValidation=function(){return this.componentRef&&this.componentRef.showValidation&&this.componentRef.showValidation(),this},a.prototype.setStatus=function(e,t){return this.componentRef&&this.componentRef.setStatus&&this.componentRef.setStatus(e,t),this},a.prototype.submitPayment=function(e){var t=this;return this.setStatus("loading"),this._parentInstance.session.submitPayment(e).then(this.handleResponse).catch((function(e){t.setStatus("ready"),t.handleError(e)}))},a.prototype.submitAdditionalDetails=function(e){return this._parentInstance.session.submitDetails(e).then(this.handleResponse).catch(this.handleError)},a.prototype.handleAction=function(e,t){if(void 0===t&&(t={}),!e||!e.type)throw new Error("Invalid Action");var a=this._parentInstance.createFromAction(e,r(r({},t),{onAdditionalDetails:this.handleAdditionalDetails}));return a?(this.unmount(),a.mount(this._node)):null},a.prototype.handleResponse=function(e){var t,r,a=function(e){var t=[],r=Object.keys(e).reduce((function(r,a){return pu.includes(a)?r[a]=e[a]:t.push(a),r}),{});return t.length&&console.warn("The following properties should not be passed to the client: "+t.join(", ")),r}(e);a.action?this.elementRef.handleAction(a.action):(null===(r=null===(t=a.order)||void 0===t?void 0:t.remainingAmount)||void 0===r?void 0:r.value)>0?this.elementRef.handleOrder(a.order):this.elementRef.handleFinalResult(a)},Object.defineProperty(a.prototype,"isValid",{get:function(){return!1},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"icon",{get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:zc({loadingContext:this.props.loadingContext})(this.constructor.type)},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"displayName",{get:function(){return this.props.name||this.constructor.type},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"accessibleName",{get:function(){return this.displayName},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"type",{get:function(){return this.props.type||this.constructor.type},enumerable:!1,configurable:!0}),a}(xc),fu=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.prototype.iframeOnLoad=function(){this.props.callback&&"function"==typeof this.props.callback&&this.props.callback(this.iframeEl.contentWindow)},r.prototype.componentDidMount=function(){this.iframeEl.addEventListener?this.iframeEl.addEventListener("load",this.iframeOnLoad.bind(this),!1):this.iframeEl.attachEvent?this.iframeEl.attachEvent("onload",this.iframeOnLoad.bind(this)):this.iframeEl.onload=this.iframeOnLoad.bind(this)},r.prototype.componentWillUnmount=function(){this.iframeEl.removeEventListener?this.iframeEl.removeEventListener("load",this.iframeOnLoad.bind(this),!1):this.iframeEl.detachEvent?this.iframeEl.detachEvent("onload",this.iframeOnLoad.bind(this)):this.iframeEl.onload=null},r.prototype.render=function(e){var t=this,r=e.name,a=e.src,n=e.width,o=e.height,i=e.minWidth,s=e.minHeight,l=e.border;return oc("iframe",{ref:function(e){t.iframeEl=e},allow:e.allow,className:"adyen-checkout__iframe adyen-checkout__iframe--"+r,name:r,src:a,width:n,height:o,"min-width":i,"min-height":s,border:l,style:{border:0},frameBorder:"0",title:e.title,referrerpolicy:"origin"})},r.defaultProps={width:"0",height:"0",minWidth:"0",minHeight:"0",border:"0",src:null,allow:null,title:"components iframe"},r}(lc),yu=function(e,t,r){var a;return{promise:new Promise((function(n,o){a=setTimeout((function(){o(r)}),e),t.then((function(e){clearTimeout(a),n(e)})).catch((function(e){clearTimeout(a),o(e)}))})),cancel:function(){clearTimeout(a)}}},bu="deviceFingerprint",vu={result:{type:bu,value:"df-timedOut"},errorCode:"timeout"},gu={result:{type:bu,value:"df-failed"}},ku="unknownError",Cu={timeout:"iframe loading timed out",wrongOrigin:"Result did not come from the expected origin",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},_u=function(e,t,a,n,o){return function(i){var s=r({},n);if((i.origin||i.originalEvent.origin)!==e)return"Message was not sent from the expected domain";if("string"!=typeof i.data)return"Event data was not of type string";if(!i.data.length)return"Invalid event data string";try{var l=JSON.parse(i.data);if(!Object.prototype.hasOwnProperty.call(l,"type")||l.type!==o)return"Event data was not of expected type";t(l)}catch(e){return a(s),!1}return!0}},Nu=function(e){var t=/^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(e);if(!t)return null;var r=t[1],a=t[2],n=t[3],o=t[4];return r&&a&&n?r+":"+a+n+(o?":"+o:""):null},wu=function(e){function r(t){var r=e.call(this,t)||this;return r.postMessageDomain=Nu(r.props.loadingContext)||r.props.loadingContext,r}return t(r,e),r.prototype.getDfpPromise=function(){var e=this;return new Promise((function(t,r){e.processMessageHandler=_u(e.postMessageDomain,t,r,gu,bu),window.addEventListener("message",e.processMessageHandler)}))},r.prototype.componentDidMount=function(){var e=this;this.deviceFingerPrintPromise=yu(2e4,this.getDfpPromise(),vu),this.deviceFingerPrintPromise.promise.then((function(t){e.props.onCompleteFingerprint(t),window.removeEventListener("message",e.processMessageHandler)})).catch((function(t){e.props.onErrorFingerprint(t),window.removeEventListener("message",e.processMessageHandler)}))},r.prototype.render=function(e){var t=e.dfpURL;return oc("div",{className:"adyen-checkout-risk__device-fingerprint"},oc(fu,{name:"dfIframe",src:t,allow:"geolocation; microphone; camera;",title:"devicefingerprinting iframe"}))},r}(lc),Pu=function(e){function r(t){var r=e.call(this,t)||this;return t.clientKey&&(r.state={status:"retrievingFingerPrint",dfpURL:r.props.loadingContext+"assets/html/"+t.clientKey+"/dfp.1.0.0.html"}),r}return t(r,e),r.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){t.props.onComplete(e)}))},r.prototype.render=function(e,t){var r=this,a=e.loadingContext,n=t.dfpURL;return"retrievingFingerPrint"===this.state.status?oc("div",{className:"adyen-checkout-risk__device-fingerprint--wrapper",style:{position:"absolute",width:0,height:0}},oc(wu,{loadingContext:a,dfpURL:n,onCompleteFingerprint:function(e){r.setStatusComplete(e)},onErrorFingerprint:function(e){var t;r.props.onError({errorCode:t=e.errorCode,message:Cu[t]||Cu[ku],type:bu}),r.setStatusComplete(e.result)}})):null},r.defaultProps={onComplete:function(){},onError:function(){}},r}(lc),Fu=window.atob,Du=window.btoa,Au={decode:function(e){return!!Au.isBase64(e)&&(!!Au.isBase64(e)&&(t=e,decodeURIComponent(Array.prototype.map.call(Fu(t),(function(e){return"%"+("00"+e.charCodeAt(0).toString(16)).slice(-2)})).join(""))));var t},encode:function(e){return Du(e)},isBase64:function(e){return!!e&&(!(e.length%4)&&Du(Fu(e))===e)}},Su=function(e){function a(t){var a,n=e.call(this,t)||this;n.nodeRiskContainer=null,n.onComplete=function(e){var t,a=r(r({},n.state.data),((t={})[e.type]=e.value,t.persistentCookie=e.persistentCookie,t.components=e.components,t));n.setState({data:a,isValid:!0}),n.props.risk.onComplete(n.data),n.cleanUp()},n.onError=function(e){n.props.risk.onError(e),n.cleanUp()},n.cleanUp=function(){n.nodeRiskContainer&&n.nodeRiskContainer.remove()};var o=((a={}).deviceFingerprint=null,a);return n.setState({data:o}),!0===n.props.risk.enabled&&(document.querySelector(n.props.risk.node)?(n.nodeRiskContainer=document.createElement("div"),document.querySelector(n.props.risk.node).appendChild(n.nodeRiskContainer),n.mount(n.nodeRiskContainer)):n.onError({message:"RiskModule node was not found"})),n}return t(a,e),a.prototype.formatProps=function(e){return r(r({},e),{risk:r(r({},a.defaultProps.risk),e.risk)})},Object.defineProperty(a.prototype,"isValid",{get:function(){return this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"data",{get:function(){if(this.isValid){var e=r({version:"1.0.0"},this.state.data);return Au.encode(JSON.stringify(e))}return!1},enumerable:!1,configurable:!0}),a.prototype.componentWillUnmount=function(){this.cleanUp()},a.prototype.render=function(){return oc(Pu,r({},this.props,{loadingContext:this.props.loadingContext,onComplete:this.onComplete,onError:this.onError}))},a.type="risk",a.defaultProps={risk:{enabled:!0,onComplete:function(){},onError:function(){},node:"body"}},a}(xc);function xu(e){var t=e.children,r=e.classNameModifiers,a=void 0===r?[]:r,n=e.label,o=e.readonly,s=void 0!==o&&o,l=lu().i18n;return oc("div",{className:Oc(i(i(["adyen-checkout__fieldset"],a.map((function(e){return"adyen-checkout__fieldset--"+e}))),[{"adyen-checkout__fieldset--readonly":s}]))},n&&oc("div",{className:"adyen-checkout__fieldset__title"},l.get(n)),oc("div",{className:"adyen-checkout__fieldset__fields"},t))}var Bu,Tu=function(e){var t=e.type,r=e.className,a=void 0===r?"":r,n=lu().loadingContext,o=zc({loadingContext:n,imageFolder:"components/"})(t);return oc("img",{className:Oc("adyen-checkout__icon",a),alt:t,src:o})},zu=Date.now(),Iu=function(e){return void 0===e&&(e="field"),e+"-"+(zu+=1)},Mu="Unsupported card entered",ju="-ariaError",Eu=((Bu={})["incomplete field"]="error.va.gen.01",Bu["field not valid"]="error.va.gen.02",Bu["luhn check failed"]="error.va.sf-cc-num.01",Bu["Card too old"]="error.va.sf-cc-dat.01",Bu["Date too far in future"]="error.va.sf-cc-dat.02",Bu["Your card expires before check out date"]="error.va.sf-cc-dat.03",Bu["Unsupported card entered"]="error.va.sf-cc-num.03",Bu),Ou=Eu["incomplete field"],Ru=function(e){function a(t){var r=e.call(this,t)||this;return r.state={focused:!1},r.onFocus=r.onFocus.bind(r),r.onBlur=r.onBlur.bind(r),r.uniqueId=Iu("adyen-checkout-"+r.props.name),r}return t(a,e),a.prototype.onFocus=function(e){var t=this;this.setState({focused:!0},(function(){t.props.onFocus&&t.props.onFocus(e)}))},a.prototype.onBlur=function(e){var t=this;this.setState({focused:!1},(function(){t.props.onBlur&&t.props.onBlur(e),t.props.onFieldBlur&&t.props.onFieldBlur(e)}))},a.getDerivedStateFromProps=function(e,t){return void 0!==e.focused&&e.focused!==t.focused?{focused:e.focused}:void 0!==e.filled&&e.filled!==t.filled?{filled:e.filled}:null},a.prototype.render=function(e){var t=this,a=e.className,n=void 0===a?"":a,o=e.classNameModifiers,s=void 0===o?[]:o,l=e.children,d=e.errorMessage,c=e.helper,u=e.inputWrapperModifiers,p=void 0===u?[]:u,m=e.isLoading,h=e.isValid,f=e.label,y=e.dualBrandingElements,b=e.dir,v=e.name,g=e.showValidIcon;return oc("div",{className:Oc("adyen-checkout__field",n,s.map((function(e){return"adyen-checkout__field--"+e})),{"adyen-checkout__field--error":d,"adyen-checkout__field--valid":h})},oc("label",{onClick:this.props.onFocusField,className:Oc({"adyen-checkout__label":!0,"adyen-checkout__label--focused":this.state.focused,"adyen-checkout__label--filled":this.state.filled,"adyen-checkout__label--disabled":this.props.disabled}),htmlFor:v&&this.uniqueId},"string"==typeof f&&oc("span",{className:Oc({"adyen-checkout__label__text":!0,"adyen-checkout__label__text--error":d})},f),"function"==typeof f&&f(),c&&oc("span",{className:"adyen-checkout__helper-text"},c),oc("div",{className:Oc(i(["adyen-checkout__input-wrapper"],p.map((function(e){return"adyen-checkout__input-wrapper--"+e})))),dir:b},fc(l).map((function(e){return function(e,t,r){var a,n,o,i=arguments,s=ac({},e.props);for(o in t)"key"==o?a=t[o]:"ref"==o?n=t[o]:s[o]=t[o];if(arguments.length>3)for(r=[r],o=3;o<arguments.length;o++)r.push(i[o]);return null!=r&&(s.children=r),ic(e.type,s,a||e.key,n||e.ref,null)}(e,r({isValid:h,onFocus:t.onFocus,onBlur:t.onBlur,isInvalid:!!d},v&&{uniqueId:t.uniqueId}))})),m&&oc("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--loading"},oc(Rc,{size:"small"})),h&&!1!==g&&!y&&oc("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--valid"},oc(Tu,{type:"checkmark"})),d&&oc("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--invalid"},oc(Tu,{type:"field_error"}))),d&&d.length&&oc("span",{className:"adyen-checkout__error-text","aria-live":"polite",id:""+this.uniqueId+ju},d)))},a}(lc),Lu=function(e){var t=e.data,r=t.name,a=t.registrationNumber;return oc(xu,{classNameModifiers:["companyDetails"],label:"companyDetails",readonly:!0},r&&r+" ",a&&a+" ")};function Vu(e){var t=e.autoCorrect,n=e.classNameModifiers,o=e.isInvalid,i=e.isValid,s=e.readonly,l=void 0===s?null:s,d=e.spellCheck,c=e.type,u=e.uniqueId,p=Wc(!1),m=p[0],h=p[1],f=Oc("adyen-checkout__input",["adyen-checkout__input--"+c],e.className,{"adyen-checkout__input--invalid":o,"adyen-checkout__input--valid":i},n.map((function(e){return"adyen-checkout__input--"+e})));e.classNameModifiers,e.uniqueId;var y=a(e,["classNameModifiers","uniqueId"]);return oc("input",r({id:u},y,{type:c,className:f,onInput:function(t){t.target.value=t.target.value.replace(/[\uff01-\uff5e]/g,(function(e){return String.fromCharCode(e.charCodeAt(0)-65248)})),e.onInput(t)},readOnly:l,spellCheck:d,autoCorrect:t,"aria-describedby":""+u+ju,onChange:function(t){var r;h(!0),null===(r=null==e?void 0:e.onChange)||void 0===r||r.call(e,t)},onBlur:function(t){var r,a;m||null===(r=null==e?void 0:e.onChange)||void 0===r||r.call(e,t),h(!1),null===(a=null==e?void 0:e.onBlur)||void 0===a||a.call(e,t)}}))}function Uu(e){return oc(Vu,r({classNameModifiers:["large"]},e,{"aria-required":e.required,type:"text"}))}Vu.defaultProps={type:"text",classNameModifiers:[]};var Ku=function(){var e=document.createElement("input");return e.setAttribute("type","date"),"date"===e.type},Hu=function(e){if(void 0===e&&(e=""),-1===e.indexOf("/"))return e;var t=e.split("/"),r=t[0],a=void 0===r?"":r,n=t[1],o=void 0===n?"":n,i=t[2],s=void 0===i?"":i;return a&&o&&s?s+"-"+o+"-"+a:null};function qu(e){return oc(Vu,Xc(Ku,[])?r({},e,{type:"date"}):r({},e,{onInput:function(t){var r=t.target.value;t.target.value=function(e){var t=e.replace(/\D|\s/g,"").replace(/^(00)(.*)?/,"01$2").replace(/^(3[2-9])(.*)?/,"0$1$2").replace(/^([4-9])(.*)?/,"0$1").replace(/^([0-9]{2})(00)(.*)?/,"$101").replace(/^(3[01])(02)(.*)?/,"29$2").replace(/^([0-9]{2})([2-9]|1[3-9])(.*)?/,"$10$2").replace(/^([0-9]{2})([0-9]{2})([0-9])/,"$1/$2/$3").replace(/^([0-9]{2})([0-9])/,"$1/$2"),r=t.split("/"),a=r[0],n=void 0===a?"":a,o=r[1],i=void 0===o?"":o,s=r[2],l=void 0===s?"":s;return 4===l.length&&"29"===n&&"02"===i&&(Number(l)%4!=0||"00"===l.substr(2,2)&&Number(l)%400!=0)?t.replace(/^29/,"28"):t}(r),e.onInput(t)},maxLength:10}))}function Gu(e){return oc(Vu,r({},e,{type:"tel"}))}function Yu(e){return oc(Vu,r({},e,{type:"email",autoCapitalize:"off"}))}function Wu(e){var t=e.items,r=e.i18n,a=e.name,n=e.onChange,o=e.value,i=e.isInvalid,s=e.uniqueId,l=null==s?void 0:s.replace(/[0-9]/g,"").substring(0,s.lastIndexOf("-"));return oc("div",{className:"adyen-checkout__radio_group"},t.map((function(t){var s=Iu(l);return oc("div",{key:t.id,className:"adyen-checkout__radio_group__input-wrapper"},oc("input",{id:s,type:"radio",checked:o===t.id,className:"adyen-checkout__radio_group__input",name:a,onChange:n,onClick:n,value:t.id}),oc("label",{className:Oc(["adyen-checkout__label__text","adyen-checkout__radio_group__label",e.className,{"adyen-checkout__radio_group__label--invalid":i}]),htmlFor:s},r.get(t.name)))})))}function Ju(e){var t=e.classNameModifiers,n=void 0===t?[]:t,o=e.label,i=e.isInvalid,s=e.onChange,l=a(e,["classNameModifiers","label","isInvalid","onChange"]);return oc("label",{className:"adyen-checkout__checkbox"},oc("input",r({},l,{className:Oc(["adyen-checkout__checkbox__input",[l.className],{"adyen-checkout__checkbox__input--invalid":i},n.map((function(e){return"adyen-checkout__input--"+e}))]),type:"checkbox",onChange:s})),oc("span",{className:"adyen-checkout__checkbox__label"},o))}Wu.defaultProps={onChange:function(){},items:[]},Ju.defaultProps={onChange:function(){}};var Zu="Select-module_adyen-checkout__dropdown__2kGp2",Qu="Select-module_adyen-checkout__dropdown__button__waz0I",$u="Select-module_adyen-checkout__dropdown__button--active__1EqeU",Xu="Select-module_adyen-checkout__filter-input__HMjy5",ep="Select-module_adyen-checkout__dropdown__list__2UxAp",tp="Select-module_adyen-checkout__dropdown__list--active__Mlt8t",rp="Select-module_adyen-checkout__dropdown__element__3nIQR";function ap(e){var t=e.backgroundUrl,a=void 0===t?"":t,n=e.className,o=void 0===n?"":n,s=e.classNameModifiers,l=void 0===s?[]:s,d=e.src,c=void 0===d?"":d,u=e.alt,p=void 0===u?"":u,m=e.showOnError,h=void 0!==m&&m,f=Wc(!1),y=f[0],b=f[1],v=$c(null),g=function(){b(!0)},k=Oc.apply(void 0,i([[o],"adyen-checkout__image",{"adyen-checkout__image--loaded":y}],l.map((function(e){return"adyen-checkout__image--"+e}))));return Zc((function(){var e=a?new Image:v.current;e.src=a||c,e.onload=g,b(!!e.complete)}),[]),a?oc("div",r({style:{backgroundUrl:a}},e,{className:k})):oc("img",r({},e,{alt:p,ref:v,className:k,onError:function(){b(h)}}))}function np(e){var t=e.filterable,n=e.toggleButtonRef,o=a(e,["filterable","toggleButtonRef"]);return oc(t?"div":"button",r({},o,{ref:n}))}function op(e){var t,r=lu().i18n,a=e.active,n=e.readonly,o=e.showList;return oc(np,{"aria-disabled":n,"aria-expanded":o,"aria-haspopup":"listbox",className:Oc((t={"adyen-checkout__dropdown__button":!0},t[Qu]=!0,t["adyen-checkout__dropdown__button--readonly"]=n,t["adyen-checkout__dropdown__button--active"]=o,t[$u]=o,t["adyen-checkout__dropdown__button--invalid"]=e.isInvalid,t["adyen-checkout__dropdown__button--valid"]=e.isValid,t)),filterable:e.filterable,onClick:n?null:e.toggleList,onKeyDown:n?null:e.onButtonKeyDown,role:e.filterable?"button":null,tabIndex:"0",title:a.name||e.placeholder,toggleButtonRef:e.toggleButtonRef,type:e.filterable?null:"button","aria-describedby":e.ariaDescribedBy,id:e.id},o&&e.filterable?oc("input",{"aria-autocomplete":"list","aria-controls":e.selectListId,"aria-expanded":o,"aria-owns":e.selectListId,autoComplete:"off",className:Oc("adyen-checkout__filter-input",[Xu]),onInput:e.onInput,placeholder:r.get("select.filter.placeholder"),ref:e.filterInputRef,role:"combobox",type:"text"}):oc(sc,null,oc("span",{className:"adyen-checkout__dropdown__button__text"},a.selectedOptionName||a.name||e.placeholder),a.icon&&oc(ap,{className:"adyen-checkout__dropdown__button__icon",src:a.icon,alt:a.name})))}var ip=function(e){var t=e.item,r=e.selected,n=a(e,["item","selected"]);return oc("li",{"aria-disabled":!!t.disabled,"aria-selected":r,className:Oc(["adyen-checkout__dropdown__element",rp,{"adyen-checkout__dropdown__element--active":r,"adyen-checkout__dropdown__element--disabled":!!t.disabled}]),"data-disabled":!!t.disabled,"data-value":t.id,onClick:n.onSelect,onKeyDown:n.onKeyDown,role:"option",tabIndex:-1},oc("span",null,t.name),t.icon&&oc(ap,{className:"adyen-checkout__dropdown__element__icon",alt:t.name,src:t.icon}))};function sp(e){var t,r=e.active,n=e.items,o=e.showList,i=e.textFilter,s=a(e,["active","items","showList","textFilter"]),l=lu().i18n,d=n.filter((function(e){return!i||e.name.toLowerCase().includes(i)}));return oc("ul",{className:Oc((t={test:!0,"adyen-checkout__dropdown__list":!0},t[ep]=!0,t["adyen-checkout__dropdown__list--active"]=o,t[tp]=o,t)),id:s.selectListId,ref:s.selectListRef,role:"listbox"},d.length?d.map((function(e){return oc(ip,{item:e,key:e.id,onKeyDown:s.onKeyDown,onSelect:s.onSelect,selected:e.id===r.id})})):oc("div",{className:"adyen-checkout__dropdown__element adyen-checkout__dropdown__element--no-options"},l.get("select.noOptionsFound")))}var lp={arrowDown:"ArrowDown",arrowUp:"ArrowUp",enter:"Enter",escape:"Escape",space:" ",tab:"Tab"};function dp(e){var t=e.items,r=void 0===t?[]:t,a=e.className,n=void 0===a?"":a,o=e.classNameModifiers,s=void 0===o?[]:o,l=e.filterable,d=void 0===l||l,c=e.readonly,u=void 0!==c&&c,p=e.onChange,m=void 0===p?function(){}:p,h=e.selected,f=e.name,y=e.isInvalid,b=e.isValid,v=e.placeholder,g=e.uniqueId,k=$c(null),C=$c(null),_=$c(null),N=$c(null),w=Wc(null),P=w[0],F=w[1],D=Wc(!1),A=D[0],S=D[1],x=Xc((function(){return"select-"+Sc()}),[]),B=r.find((function(e){return e.id===h}))||{},T=function(){F(null),S(!1),_.current&&_.current.focus()},z=function(e){e.preventDefault();var t=N.current.contains(e.currentTarget)?e.currentTarget:N.current.firstElementChild;if(!t.getAttribute("data-disabled")){T();var r=t.getAttribute("data-value");m({target:{value:r,name:f}})}},I=function(e){(e.composedPath?!e.composedPath().includes(C.current):!C.current.contains(e.target))&&S(!1)};return Zc((function(){A&&d&&k.current&&k.current.focus()}),[A]),Zc((function(){return document.addEventListener("click",I,!1),function(){document.removeEventListener("click",I,!1)}}),[]),oc("div",{className:Oc(i(["adyen-checkout__dropdown",Zu,n],s.map((function(e){return"adyen-checkout__dropdown--"+e})))),ref:C},oc(op,{id:null!=g?g:null,active:B,filterInputRef:k,filterable:d,isInvalid:y,isValid:b,onButtonKeyDown:function(e){var t;e.key===lp.enter&&d&&A&&P?z(e):e.key===lp.escape?T():![lp.arrowUp,lp.arrowDown,lp.enter].includes(e.key)&&(e.key!==lp.space||d&&A)?(e.shiftKey&&e.key===lp.tab||e.key===lp.tab)&&T():(e.preventDefault(),S(!0),(null===(t=N.current)||void 0===t?void 0:t.firstElementChild)&&N.current.firstElementChild.focus())},onInput:function(e){var t=e.target.value;F(t.toLowerCase())},placeholder:v,readonly:u,selectListId:x,showList:A,toggleButtonRef:_,toggleList:function(e){e.preventDefault(),S(!A)},ariaDescribedBy:g?""+g+ju:null}),oc(sp,{active:B,items:r,onKeyDown:function(e){var t=e.target;switch(e.key){case lp.escape:e.preventDefault(),T();break;case lp.space:case lp.enter:z(e);break;case lp.arrowDown:e.preventDefault(),t.nextElementSibling&&t.nextElementSibling.focus();break;case lp.arrowUp:e.preventDefault(),t.previousElementSibling?t.previousElementSibling.focus():d&&k.current&&k.current.focus();break;case lp.tab:T()}},onSelect:z,selectListId:x,selectListRef:N,showList:A,textFilter:P}))}dp.defaultProps={className:"",classNameModifiers:[],filterable:!0,items:[],readonly:!1,onChange:function(){}};var cp=function(e,t){var a={boolean:Ju,date:qu,emailAddress:Yu,radio:Wu,select:dp,tel:Gu,text:Uu,default:Uu};return oc(a[e]||a.default,r({},t))},up=/^\s*[\w\-+_]+(\.[\w\-+_]+)*@[\w\-+_]+\.[\w\-+_]+(\.[\w-+_]+)*\s*$/,pp=/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/,mp=function(){function e(e,t,r,a){this.shouldValidate=e.modes.includes(r),this.isValid=e.validate(t,a),this.errorMessage=e.errorMessage}return e.prototype.hasError=function(){return!this.isValid&&this.shouldValidate},e}(),hp=function(){function e(e){this.validationResults=e}return Object.defineProperty(e.prototype,"isValid",{get:function(){return this.validationResults.every((function(e){return e.isValid}))},enumerable:!1,configurable:!0}),e.prototype.hasError=function(){return Boolean(this.getError())},e.prototype.getError=function(){return this.validationResults.find((function(e){return e.hasError()}))},e.prototype.getAllErrors=function(){return this.validationResults.filter((function(e){return e.hasError()}))},e}(),fp=function(){function e(e){void 0===e&&(e={}),this.rules={shopperEmail:{validate:function(e){return up.test(e)},errorMessage:"error.va.gen.01",modes:["blur"]},default:{validate:function(){return!0},modes:["blur","input"]}},this.setRules(e)}return e.prototype.setRules=function(e){this.rules=r(r({},this.rules),e)},e.prototype.getRulesFor=function(e){var t,r=null!==(t=this.rules[e])&&void 0!==t?t:this.rules.default;return Array.isArray(r)||(r=[r]),r},e.prototype.validate=function(e,t){var r=e.key,a=e.value,n=e.mode,o=void 0===n?"blur":n,i=this.getRulesFor(r).map((function(e){return new mp(e,a,o,t)}));return new hp(i)},e}(),yp=function(e,t){return Object.keys(e).filter((function(e){return!t.includes(e)})).reduce((function(t,r){return t[r]=e[r],t}),{})},bp=function(e,t,a,n){return t.reduce((function(e,t){var o,i,s;return r(r({},e),((o={})[t]=null!==(s=null!==(i=e[t])&&void 0!==i?i:n[t])&&void 0!==s?s:a,o))}),e)};function vp(e){var t=e.schema,a=e.defaultData,n=e.processField,o=t.reduce((function(e,t){var o,i,s,l=function(e){var t;if(void 0===a[e])return{valid:!1,errors:null,data:null};var r=n({key:e,value:a[e],mode:"blur"},{state:{data:a}}),o=r[0],i=r[1];return{valid:null!==(t=i.isValid)&&void 0!==t&&t,errors:i.hasError()?i.getError():null,data:o}}(t),d=l.valid,c=l.errors,u=l.data;return{valid:r(r({},e.valid),(o={},o[t]=d,o)),errors:r(r({},e.errors),(i={},i[t]=c,i)),data:r(r({},e.data),(s={},s[t]=u,s))}}),{data:{},valid:{},errors:{}});return{schema:t,data:o.data,valid:o.valid,errors:o.errors}}function gp(e){var t,a=e.rules,n=void 0===a?{}:a,o=e.formatters,i=void 0===o?{}:o,s=e.defaultData,l=void 0===s?{}:s,d=Xc((function(){return new fp(n)}),[]),c=function(e,t){var r=e.key,a=e.value,n=e.mode,o=i[r]?i[r](null!=a?a:""):a;return[o,d.validate({key:r,value:o,mode:n},t)]},u=Jc(function(e){return function(t,a){var n,o,i,s,l,d,c,u=a.type,p=a.key,m=a.value,h=a.mode,f=a.defaultData,y=a.schema;switch(u){case"setData":return r(r({},t),{data:r(r({},t.data),(n={},n[p]=m,n))});case"setValid":return r(r({},t),{valid:r(r({},t.valid),(o={},o[p]=m,o))});case"setErrors":return r(r({},t),{errors:r(r({},t.errors),(i={},i[p]=m,i))});case"updateField":var b=e({key:p,value:m,mode:h},{state:t}),v=b[0],g=b[1];return r(r({},t),{data:r(r({},t.data),(s={},s[p]=v,s)),errors:r(r({},t.errors),(l={},l[p]=g.hasError()?g.getError():null,l)),valid:r(r({},t.valid),(d={},d[p]=null!==(c=g.isValid)&&void 0!==c&&c,d))});case"setSchema":var k=vp({schema:y,defaultData:f,processField:e}),C=t.schema.filter((function(e){return!y.includes(e)})),_=y.filter((function(e){return!t.schema.includes(e)})),N=bp(yp(t.data,C),_,null,k.data),w=bp(yp(t.valid,C),_,!1,k.valid),P=bp(yp(t.errors,C),_,null,k.errors);return r(r({},t),{schema:y,data:N,valid:w,errors:P});case"validateForm":var F=t.schema.reduce((function(a,n){var o,i,s,l=e({key:n,value:t.data[n],mode:"blur"},{state:t})[1];return{valid:r(r({},a.valid),(o={},o[n]=null!==(s=l.isValid)&&void 0!==s&&s,o)),errors:r(r({},a.errors),(i={},i[n]=l.hasError()?l.getError():null,i))}}),{valid:t.valid,errors:t.errors});return r(r({},t),{valid:F.valid,errors:F.errors});default:throw new Error("Undefined useForm action")}}}(c),{defaultData:l,schema:null!==(t=e.schema)&&void 0!==t?t:[],processField:c},vp),p=u[0],m=u[1],h=Xc((function(){return p.schema.every((function(e){return p.valid[e]}))}),[p.schema,p.valid]),f=eu((function(){m({type:"validateForm"})}),[]),y=eu((function(e,t){return m({type:"setErrors",key:e,value:t})}),[]),b=eu((function(e,t){return m({type:"setValid",key:e,value:t})}),[]),v=eu((function(e,t){return m({type:"setData",key:e,value:t})}),[]);return{handleChangeFor:function(e,t){return void 0===t&&(t="blur"),function(r){var a=function(e,t){return t.target?"checkbox"===t.target.type?!p.data[e]:t.target.value:t}(e,r);m({type:"updateField",key:e,value:a,mode:t})}},triggerValidation:f,setSchema:eu((function(e){return m({type:"setSchema",schema:e,defaultData:l})}),[p.schema]),setData:v,setValid:b,setErrors:y,isValid:h,schema:p.schema,valid:p.valid,errors:p.errors,data:p.data}}function kp(e){var t=e.label,a=void 0===t?"":t,n=e.namePrefix,o=e.requiredFields,i=e.visibility,s=lu().i18n,l=gp({schema:o,rules:e.validationRules,defaultData:e.data}),d=l.handleChangeFor,c=l.triggerValidation,u=l.data,p=l.valid,m=l.errors,h=l.isValid,f=function(e){return(n?n+".":"")+e},y=function(e){return function(t){var r=t.target.name.split(n+".").pop();d(r,e)(t)}};return Zc((function(){var t=function(e){var t=e.name,a=e.registrationNumber;return r({},(t||a)&&{company:r(r({},t&&{name:t}),a&&{registrationNumber:a})})}(u);e.onChange({data:t,valid:p,errors:m,isValid:h})}),[u,p,m,h]),this.showValidation=c,"hidden"===i?null:"readOnly"===i?oc(Lu,r({},e,{data:u})):oc(xu,{classNameModifiers:[a],label:a},o.includes("name")&&oc(Ru,{label:s.get("companyDetails.name"),classNameModifiers:["name"],errorMessage:!!m.name},cp("text",{name:f("name"),value:u.name,classNameModifiers:["name"],onInput:y("input"),onChange:y("blur"),spellCheck:!1})),o.includes("registrationNumber")&&oc(Ru,{label:s.get("companyDetails.registrationNumber"),classNameModifiers:["registrationNumber"],errorMessage:!!m.registrationNumber},cp("text",{name:f("registrationNumber"),value:u.registrationNumber,classNameModifiers:["registrationNumber"],onInput:y("input"),onChange:y("blur"),spellCheck:!1})))}kp.defaultProps={data:{},onChange:function(){},visibility:"editable",requiredFields:["name","registrationNumber"],validationRules:{default:{validate:function(e){return e&&e.length>0},modes:["blur"]}}};var Cp,_p,Np,wp,Pp,Fp,Dp,Ap,Sp,xp=function(e){var t=e.data,r=t.firstName,a=t.lastName,n=t.shopperEmail,o=t.telephoneNumber;return oc(xu,{classNameModifiers:["personalDetails"],label:"personalDetails",readonly:!0},r&&r+" ",a&&a+" ",n&&oc(sc,null,oc("br",null),n),o&&oc(sc,null,oc("br",null),o))},Bp={default:{validate:function(e){return e&&e.length>0},modes:["blur"]},dateOfBirth:{validate:function(e){return function(e){if(!e)return!1;var t=Hu(e),r=Date.now()-Date.parse(t);return new Date(r).getFullYear()-1970>=18}(e)},errorMessage:"dateOfBirth.invalid",modes:["blur"]},telephoneNumber:{validate:function(e){return pp.test(e)},modes:["blur"]},shopperEmail:{validate:function(e){return up.test(e)},modes:["blur"]}};function Tp(e){var t=e.label,a=void 0===t?"":t,n=e.namePrefix,o=e.placeholders,i=e.requiredFields,s=e.visibility,l=lu().i18n,d=Xc(Ku,[]),c=gp({schema:i,rules:e.validationRules,defaultData:e.data}),u=c.handleChangeFor,p=c.triggerValidation,m=c.data,h=c.valid,f=c.errors,y=c.isValid,b=function(e){return function(t){var r=t.target.name.split(n+".").pop();u(r,e)(t)}},v=function(e){return(n?n+".":"")+e},g=function(e){return e&&e.errorMessage?l.get(e.errorMessage):!!e};return Zc((function(){var t=function(e){var t=e.firstName,a=e.lastName,n=e.gender,o=e.dateOfBirth,i=e.shopperEmail,s=e.telephoneNumber;return r(r(r(r({},(t||a)&&{shopperName:r(r(r({},t&&{firstName:t}),a&&{lastName:a}),n&&{gender:n})}),o&&{dateOfBirth:Hu(o)}),i&&{shopperEmail:i}),s&&{telephoneNumber:s})}(m);e.onChange({data:t,valid:h,errors:f,isValid:y})}),[m,h,f,y]),this.showValidation=p,"hidden"===s?null:"readOnly"===s?oc(xp,r({},e,{data:m})):oc(xu,{classNameModifiers:["personalDetails"],label:a},i.includes("firstName")&&oc(Ru,{label:l.get("firstName"),classNameModifiers:["col-50","firstName"],errorMessage:!!f.firstName,name:"firstName"},cp("text",{name:v("firstName"),value:m.firstName,classNameModifiers:["firstName"],onInput:b("input"),onChange:b("blur"),placeholder:o.firstName,spellCheck:!1})),i.includes("lastName")&&oc(Ru,{label:l.get("lastName"),classNameModifiers:["col-50","lastName"],errorMessage:!!f.lastName,name:"lastName"},cp("text",{name:v("lastName"),value:m.lastName,classNameModifiers:["lastName"],onInput:b("input"),onChange:b("blur"),placeholder:o.lastName,spellCheck:!1})),i.includes("gender")&&oc(Ru,{errorMessage:!!f.gender,classNameModifiers:["gender"],name:"gender"},cp("radio",{i18n:l,name:v("gender"),value:m.gender,items:[{id:"MALE",name:"male"},{id:"FEMALE",name:"female"}],classNameModifiers:["gender"],onInput:b("input"),onChange:b("blur")})),i.includes("dateOfBirth")&&oc(Ru,{label:l.get("dateOfBirth"),classNameModifiers:["col-50","lastName"],errorMessage:g(f.dateOfBirth),helper:d?null:l.get("dateOfBirth.format"),name:"dateOfBirth"},cp("date",{name:v("dateOfBirth"),value:m.dateOfBirth,classNameModifiers:["dateOfBirth"],onInput:b("input"),onChange:b("blur"),placeholder:o.dateOfBirth})),i.includes("shopperEmail")&&oc(Ru,{label:l.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:g(f.shopperEmail),dir:"ltr",name:"emailAddress"},cp("emailAddress",{name:v("shopperEmail"),value:m.shopperEmail,classNameModifiers:["shopperEmail"],onInput:b("input"),onChange:b("blur"),placeholder:o.shopperEmail})),i.includes("telephoneNumber")&&oc(Ru,{label:l.get("telephoneNumber"),classNameModifiers:["telephoneNumber"],errorMessage:g(f.telephoneNumber),dir:"ltr",name:"telephoneNumber"},cp("tel",{name:v("telephoneNumber"),value:m.telephoneNumber,classNameModifiers:["telephoneNumber"],onInput:b("input"),onChange:b("blur"),placeholder:o.telephoneNumber})))}Tp.defaultProps={data:{},onChange:function(){},placeholders:{},requiredFields:["firstName","lastName","gender","dateOfBirth","shopperEmail","telephoneNumber"],validationRules:Bp,visibility:"editable"};var zp="N/A",Ip=["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],Mp=Ip[0],jp=Ip[1],Ep=Ip[2],Op=Ip[3],Rp=Ip[4],Lp=Ip[5],Vp={AU:{hasDataset:!0,labels:(Cp={},Cp[jp]="apartmentSuite",Cp[Rp]="state",Cp[Mp]="address",Cp),optionalFields:[jp],placeholders:(_p={},_p[Rp]="select.state",_p),schema:[Lp,Mp,jp,Op,[[Rp,50],[Ep,50]]]},BR:{hasDataset:!0,labels:(Np={},Np[Rp]="state",Np),placeholders:(wp={},wp[Rp]="select.state",wp)},CA:{hasDataset:!0,labels:(Pp={},Pp[jp]="apartmentSuite",Pp[Rp]="provinceOrTerritory",Pp[Mp]="address",Pp),optionalFields:[jp],schema:[Lp,Mp,jp,[[Op,70],[Ep,30]],Rp]},GB:{labels:(Fp={},Fp[Op]="cityTown",Fp),schema:[Lp,[[jp,30],[Mp,70]],[[Op,70],[Ep,30]],Rp]},US:{hasDataset:!0,labels:(Dp={},Dp[Ep]="zipCode",Dp[jp]="apartmentSuite",Dp[Rp]="state",Dp[Mp]="address",Dp),optionalFields:[jp],placeholders:(Ap={},Ap[Rp]="select.state",Ap),schema:[Lp,Mp,jp,Op,[[Rp,50],[Ep,50]]]},default:{optionalFields:[],placeholders:(Sp={},Sp[Rp]="select.provinceOrTerritory",Sp),schema:[Lp,[[Mp,70],[jp,30]],[[Ep,30],[Op,70]],Rp]}},Up=function(e){var t=e.data,r=e.label,a=t.street,n=t.houseNumberOrName,o=t.city,i=t.postalCode,s=t.stateOrProvince,l=t.country;return oc(xu,{classNameModifiers:[r],label:r,readonly:!0},!!a&&a,n&&", "+n+",",oc("br",null),i&&""+i,o&&", "+o,s&&s!==zp&&", "+s,l&&", "+l+" ")},Kp=function(e){return{houseNumberOrName:{validate:function(t,r){var a,n,o=null===(n=null===(a=r.state)||void 0===a?void 0:a.data)||void 0===n?void 0:n.country;return o&&e.countryHasOptionalField(o,"houseNumberOrName")||(null==t?void 0:t.length)>0},modes:["blur"]},default:{validate:function(e){return(null==e?void 0:e.length)>0},modes:["blur"],errorMessage:Eu["incomplete field"]}}},Hp="undefined"!=typeof globalThis&&globalThis||"undefined"!=typeof self&&self||void 0!==Hp&&Hp,qp="URLSearchParams"in Hp,Gp="Symbol"in Hp&&"iterator"in Symbol,Yp="FileReader"in Hp&&"Blob"in Hp&&function(){try{return new Blob,!0}catch(e){return!1}}(),Wp="FormData"in Hp,Jp="ArrayBuffer"in Hp;if(Jp)var Zp=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],Qp=ArrayBuffer.isView||function(e){return e&&Zp.indexOf(Object.prototype.toString.call(e))>-1};function $p(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e)||""===e)throw new TypeError('Invalid character in header field name: "'+e+'"');return e.toLowerCase()}function Xp(e){return"string"!=typeof e&&(e=String(e)),e}function em(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return Gp&&(t[Symbol.iterator]=function(){return t}),t}function tm(e){this.map={},e instanceof tm?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function rm(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function am(e){return new Promise((function(t,r){e.onload=function(){t(e.result)},e.onerror=function(){r(e.error)}}))}function nm(e){var t=new FileReader,r=am(t);return t.readAsArrayBuffer(e),r}function om(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function im(){return this.bodyUsed=!1,this._initBody=function(e){var t;this.bodyUsed=this.bodyUsed,this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:Yp&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:Wp&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:qp&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():Jp&&Yp&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=om(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):Jp&&(ArrayBuffer.prototype.isPrototypeOf(e)||Qp(e))?this._bodyArrayBuffer=om(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):qp&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},Yp&&(this.blob=function(){var e=rm(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){if(this._bodyArrayBuffer){var e=rm(this);return e||(ArrayBuffer.isView(this._bodyArrayBuffer)?Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset,this._bodyArrayBuffer.byteOffset+this._bodyArrayBuffer.byteLength)):Promise.resolve(this._bodyArrayBuffer))}return this.blob().then(nm)}),this.text=function(){var e=rm(this);if(e)return e;if(this._bodyBlob)return function(e){var t=new FileReader,r=am(t);return t.readAsText(e),r}(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),r=new Array(t.length),a=0;a<t.length;a++)r[a]=String.fromCharCode(t[a]);return r.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},Wp&&(this.formData=function(){return this.text().then(dm)}),this.json=function(){return this.text().then(JSON.parse)},this}tm.prototype.append=function(e,t){e=$p(e),t=Xp(t);var r=this.map[e];this.map[e]=r?r+", "+t:t},tm.prototype.delete=function(e){delete this.map[$p(e)]},tm.prototype.get=function(e){return e=$p(e),this.has(e)?this.map[e]:null},tm.prototype.has=function(e){return this.map.hasOwnProperty($p(e))},tm.prototype.set=function(e,t){this.map[$p(e)]=Xp(t)},tm.prototype.forEach=function(e,t){for(var r in this.map)this.map.hasOwnProperty(r)&&e.call(t,this.map[r],r,this)},tm.prototype.keys=function(){var e=[];return this.forEach((function(t,r){e.push(r)})),em(e)},tm.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),em(e)},tm.prototype.entries=function(){var e=[];return this.forEach((function(t,r){e.push([r,t])})),em(e)},Gp&&(tm.prototype[Symbol.iterator]=tm.prototype.entries);var sm=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function lm(e,t){if(!(this instanceof lm))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');var r=(t=t||{}).body;if(e instanceof lm){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new tm(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,r||null==e._bodyInit||(r=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new tm(t.headers)),this.method=function(e){var t=e.toUpperCase();return sm.indexOf(t)>-1?t:e}(t.method||this.method||"GET"),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&r)throw new TypeError("Body not allowed for GET or HEAD requests");if(this._initBody(r),!("GET"!==this.method&&"HEAD"!==this.method||"no-store"!==t.cache&&"no-cache"!==t.cache)){var a=/([?&])_=[^&]*/;if(a.test(this.url))this.url=this.url.replace(a,"$1_="+(new Date).getTime());else{this.url+=(/\?/.test(this.url)?"&":"?")+"_="+(new Date).getTime()}}}function dm(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var r=e.split("="),a=r.shift().replace(/\+/g," "),n=r.join("=").replace(/\+/g," ");t.append(decodeURIComponent(a),decodeURIComponent(n))}})),t}function cm(e,t){if(!(this instanceof cm))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText=void 0===t.statusText?"":""+t.statusText,this.headers=new tm(t.headers),this.url=t.url||"",this._initBody(e)}lm.prototype.clone=function(){return new lm(this,{body:this._bodyInit})},im.call(lm.prototype),im.call(cm.prototype),cm.prototype.clone=function(){return new cm(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new tm(this.headers),url:this.url})},cm.error=function(){var e=new cm(null,{status:0,statusText:""});return e.type="error",e};var um=[301,302,303,307,308];cm.redirect=function(e,t){if(-1===um.indexOf(t))throw new RangeError("Invalid status code");return new cm(null,{status:t,headers:{location:e}})};var pm=Hp.DOMException;try{new pm}catch(e){(pm=function(e,t){this.message=e,this.name=t;var r=Error(e);this.stack=r.stack}).prototype=Object.create(Error.prototype),pm.prototype.constructor=pm}function mm(e,t){return new Promise((function(r,a){var n=new lm(e,t);if(n.signal&&n.signal.aborted)return a(new pm("Aborted","AbortError"));var o=new XMLHttpRequest;function i(){o.abort()}o.onload=function(){var e,t,a={status:o.status,statusText:o.statusText,headers:(e=o.getAllResponseHeaders()||"",t=new tm,e.replace(/\r?\n[\t ]+/g," ").split("\r").map((function(e){return 0===e.indexOf("\n")?e.substr(1,e.length):e})).forEach((function(e){var r=e.split(":"),a=r.shift().trim();if(a){var n=r.join(":").trim();t.append(a,n)}})),t)};a.url="responseURL"in o?o.responseURL:a.headers.get("X-Request-URL");var n="response"in o?o.response:o.responseText;setTimeout((function(){r(new cm(n,a))}),0)},o.onerror=function(){setTimeout((function(){a(new TypeError("Network request failed"))}),0)},o.ontimeout=function(){setTimeout((function(){a(new TypeError("Network request failed"))}),0)},o.onabort=function(){setTimeout((function(){a(new pm("Aborted","AbortError"))}),0)},o.open(n.method,function(e){try{return""===e&&Hp.location.href?Hp.location.href:e}catch(t){return e}}(n.url),!0),"include"===n.credentials?o.withCredentials=!0:"omit"===n.credentials&&(o.withCredentials=!1),"responseType"in o&&(Yp?o.responseType="blob":Jp&&n.headers.get("Content-Type")&&-1!==n.headers.get("Content-Type").indexOf("application/octet-stream")&&(o.responseType="arraybuffer")),!t||"object"!=typeof t.headers||t.headers instanceof tm?n.headers.forEach((function(e,t){o.setRequestHeader(t,e)})):Object.getOwnPropertyNames(t.headers).forEach((function(e){o.setRequestHeader(e,Xp(t.headers[e]))})),n.signal&&(n.signal.addEventListener("abort",i),o.onreadystatechange=function(){4===o.readyState&&n.signal.removeEventListener("abort",i)}),o.send(void 0===n._bodyInit?null:n._bodyInit)}))}mm.polyfill=!0,Hp.fetch||(Hp.fetch=mm,Hp.Headers=tm,Hp.Request=lm,Hp.Response=cm);var hm="fetch"in window?window.fetch:mm;function fm(e,t){var a=e.headers,n=void 0===a?[]:a,o=e.errorLevel,i=void 0===o?"warn":o,s=e.loadingContext,l=void 0===s?Bc:s,d=e.method,c=void 0===d?"GET":d,u=e.path,p=r({method:c,mode:"cors",cache:"default",credentials:"same-origin",headers:r({Accept:"application/json, text/plain, */*","Content-Type":"POST"===c?"application/json":"text/plain"},n),redirect:"follow",referrerPolicy:"no-referrer-when-downgrade"},t&&{body:JSON.stringify(t)}),m=""+l+u;return hm(m,p).then((function(t){return t.ok?t.json():ym(e.errorMessage||"Service at "+m+" is not available",i)})).catch((function(t){return ym(e.errorMessage||"Call to "+m+" failed. Error= "+t,i)}))}function ym(e,t){switch(t){case"silent":return null;case"info":case"warn":case"error":return console[t](e);default:throw new mu("NETWORK_ERROR",e)}}var bm=function(e,t){return fm(r(r({},e),{method:"POST"}),t)};function vm(e,t,a){return function(e,t){return fm(r(r({},e),{method:"GET"}),t)}({loadingContext:t,errorLevel:"warn",errorMessage:"Dataset "+e+" is not available",path:"datasets/"+e+"/"+a+".json"})}function gm(e){var t=e.classNameModifiers,r=e.label,a=e.onDropdownChange,n=e.readOnly,o=e.selectedCountry,i=e.specifications,s=e.value,l=lu(),d=l.i18n,c=l.loadingContext,u=Wc([]),p=u[0],m=u[1],h=Wc(!1),f=h[0],y=h[1],b=i.getPlaceholderKeyForField("stateOrProvince",o);return Qc((function(){if(!o||!i.countryHasDataset(o))return m([]),void y(!0);vm("states/"+o,c,d.locale).then((function(e){var t=e&&e.length?e:[];m(t),y(!0)})).catch((function(){m([]),y(!0)}))}),[o]),f&&p.length?oc(Ru,{label:r,classNameModifiers:t,errorMessage:e.errorMessage,isValid:!!s,showValidIcon:!1,name:"stateOrProvince"},cp("select",{name:"stateOrProvince",onChange:a,selected:s,placeholder:d.get(b),items:p,readonly:n&&!!s})):null}function km(e){var t=e.allowedCountries,r=void 0===t?[]:t,a=e.classNameModifiers,n=void 0===a?[]:a,o=e.errorMessage,i=e.onDropdownChange,s=e.value,l=lu(),d=l.i18n,c=l.loadingContext,u=Wc([]),p=u[0],m=u[1],h=Wc(!1),f=h[0],y=h[1],b=Wc(e.readOnly),v=b[0],g=b[1];return Qc((function(){vm("countries",c,d.locale).then((function(e){var t=r.length?e.filter((function(e){return r.includes(e.id)})):e;m(t||[]),g(1===t.length||v),y(!0)})).catch((function(e){console.error(e),m([]),y(!0)}))}),[]),f?oc(Ru,{name:"country",label:d.get("country"),errorMessage:o,classNameModifiers:n,isValid:!!s,showValidIcon:!1},cp("select",{onChange:i,name:"country",placeholder:d.get("select.country"),selected:s,items:p,readonly:v&&!!s})):null}function Cm(e){var t,r=lu().i18n,a=e.classNameModifiers,n=void 0===a?[]:a,o=e.data,i=e.errors,s=e.valid,l=e.fieldName,d=e.onInput,c=e.onChange,u=r.get(null===(t=i[l])||void 0===t?void 0:t.errorMessage)||!!i[l],p=o[l],m=o.country,h=e.specifications.countryHasOptionalField(m,l),f=e.specifications.getKeyForField(l,m),y=h?" "+r.get("field.title.optional"):"",b=""+r.get(f)+y;switch(l){case"country":return oc(km,{allowedCountries:e.allowedCountries,classNameModifiers:n,label:b,errorMessage:u,onDropdownChange:e.onDropdownChange,value:p});case"stateOrProvince":return oc(gm,{classNameModifiers:n,label:b,errorMessage:u,onDropdownChange:e.onDropdownChange,selectedCountry:m,specifications:e.specifications,value:p});default:return oc(Ru,{label:b,classNameModifiers:n,errorMessage:u,isValid:s[l],name:l},cp("text",{classNameModifiers:n,name:l,value:p,onInput:d,onChange:c}))}}var _m=function(){function e(e){this.specifications=r(r({},Vp),e)}return e.prototype.countryHasDataset=function(e){var t,r;return!!(null===(r=null===(t=this.specifications)||void 0===t?void 0:t[e])||void 0===r?void 0:r.hasDataset)},e.prototype.countryHasOptionalField=function(e,t){var r,a,n;return!!(null===(n=null===(a=null===(r=this.specifications)||void 0===r?void 0:r[e])||void 0===a?void 0:a.optionalFields)||void 0===n?void 0:n.includes(t))},e.prototype.getAddressSchemaForCountry=function(e){var t,r;return(null===(r=null===(t=this.specifications)||void 0===t?void 0:t[e])||void 0===r?void 0:r.schema)||this.specifications.default.schema},e.prototype.getOptionalFieldsForCountry=function(e){var t,r,a;return(null===(r=null===(t=this.specifications)||void 0===t?void 0:t[e])||void 0===r?void 0:r.optionalFields)||(null===(a=this.specifications.default)||void 0===a?void 0:a.optionalFields)||[]},e.prototype.getKeyForField=function(e,t){var r,a,n;return(null===(n=null===(a=null===(r=this.specifications)||void 0===r?void 0:r[t])||void 0===a?void 0:a.labels)||void 0===n?void 0:n[e])||e},e.prototype.getPlaceholderKeyForField=function(e,t){var r,a,n,o,i,s;return(null===(n=null===(a=null===(r=this.specifications)||void 0===r?void 0:r[t])||void 0===a?void 0:a.placeholders)||void 0===n?void 0:n[e])||(null===(s=null===(i=null===(o=this.specifications)||void 0===o?void 0:o.default)||void 0===i?void 0:i.placeholders)||void 0===s?void 0:s[e])},e}();function Nm(e){var t=e.label,a=void 0===t?"":t,n=e.requiredFields,o=e.visibility,s=Xc((function(){return new _m(e.specifications)}),[e.specifications]),l=gp({schema:n,defaultData:e.data,rules:e.validationRules||Kp(s)}),d=l.data,c=l.errors,u=l.valid,p=l.isValid,m=l.handleChangeFor,h=l.triggerValidation;if(Zc((function(){var e=s.countryHasDataset(d.country)?"":zp,t=r(r({},d),{stateOrProvince:e});n.forEach((function(e){var r;m(e,"input")(null!==(r=t[e])&&void 0!==r?r:"")}))}),[d.country]),Zc((function(){var e=n.includes("stateOrProvince"),t=d.country&&s.countryHasDataset(d.country),r=e&&t,a=d.stateOrProvince||(r?"":zp);m("stateOrProvince","input")(a)}),[]),Zc((function(){var t=s.getOptionalFieldsForCountry(d.country),r=Ip.reduce((function(r,a){var o=t.includes(a),i=n.includes(a),s=d[a],l=e.data[a],c=o&&!s||!i?i||s||!l?zp:l:s;return(null==c?void 0:c.length)&&(r[a]=c),r}),{});e.onChange({data:r,valid:u,errors:c,isValid:p})}),[d,u,c,p]),this.showValidation=h,"hidden"===o)return null;if("readOnly"===o)return oc(Up,{data:d,label:a});var f=function(t,r){var a=r.classNameModifiers,o=void 0===a?[]:a;return n.includes(t)?oc(Cm,{key:t,allowedCountries:e.allowedCountries,classNameModifiers:i(i([],o),[t]),data:d,errors:c,valid:u,fieldName:t,onInput:m(t,"input"),onChange:m(t,"blur"),onDropdownChange:m(t,"blur"),specifications:s}):null};return oc(xu,{classNameModifiers:[a],label:a},s.getAddressSchemaForCountry(d.country).map((function(e){return e instanceof Array?oc("div",{className:"adyen-checkout__field-group"},e.map((function(e){var t=e[0],r=e[1];return f(t,{classNameModifiers:["col-"+r]})}))):f(e,{})})))}function wm(e){var t,r,n=e.errorMessage,o=e.label,s=e.onChange,l=a(e,["errorMessage","label","onChange"]);return oc(Ru,{classNameModifiers:["consentCheckbox"],errorMessage:n},oc(Ju,{name:"consentCheckbox",classNameModifiers:i(i([],null!==(t=l.classNameModifiers)&&void 0!==t?t:l.classNameModifiers=[]),["consentCheckbox"]),onInput:s,value:null===(r=null==l?void 0:l.data)||void 0===r?void 0:r.consentCheckbox,label:o,checked:l.checked}))}Nm.defaultProps={countryCode:null,data:{},onChange:function(){},visibility:"editable",requiredFields:Ip,specifications:{}};var Pm=["companyDetails","personalDetails","billingAddress","deliveryAddress"],Fm=function(e,t){return void 0===t&&(t={}),Pm.reduce((function(r,a){var n,o="hidden"!==e[a],i="deliveryAddress"===a,s="hidden"===(null==e?void 0:e.billingAddress);return r[a]=o&&(!i||s||(void 0===(n=t[a])&&(n={}),Object.keys(n).length>1)),r}),{})};function Dm(e){var t=e.countryCode,a=e.visibility,n=lu().i18n,o=Wc(Fm(a,e.data)),s=o[0],l=o[1],d=Pm.reduce((function(e,t){return e[t]={current:null},e}),{}),c=!!e.consentCheckboxLabel,u=!c&&Object.keys(s).every((function(e){return!s[e]})),p="editable"===a.deliveryAddress&&"hidden"!==a.billingAddress,m=Wc(r(r({},e.data),c&&{consentCheckbox:!1})),h=m[0],f=m[1],y=Wc({}),b=y[0],v=y[1],g=Wc({}),k=g[0],C=g[1],_=Wc("ready"),N=_[0],w=_[1];this.setStatus=w,Zc((function(){var t=Object.keys(s).every((function(e){return!s[e]||!!k[e]})),r=!c||!!k.consentCheckbox,a=t&&r,n=function(e,t){return Object.keys(t).filter((function(t){return e[t]})).reduce((function(e,r){return e[r]=t[r],e}),{})}(s,h);e.onChange({data:n,errors:b,valid:k,isValid:a})}),[h,s]);var P=function(e){return function(t){f((function(a){var n;return r(r({},a),((n={})[e]=t.data,n))})),C((function(a){var n;return r(r({},a),((n={})[e]=t.isValid,n))})),v((function(a){var n;return r(r({},a),((n={})[e]=t.errors,n))}))}};return this.showValidation=function(){Pm.forEach((function(e){d[e].current&&d[e].current.showValidation()})),v(r({},c&&{consentCheckbox:!h.consentCheckbox}))},oc("div",{className:"adyen-checkout__open-invoice"},s.companyDetails&&oc(kp,{data:e.data.companyDetails,label:"companyDetails",onChange:P("companyDetails"),ref:d.companyDetails,visibility:a.companyDetails}),s.personalDetails&&oc(Tp,{data:e.data.personalDetails,requiredFields:e.personalDetailsRequiredFields,label:"personalDetails",onChange:P("personalDetails"),ref:d.personalDetails,visibility:a.personalDetails}),s.billingAddress&&oc(Nm,{allowedCountries:e.allowedCountries,countryCode:t,data:h.billingAddress,label:"billingAddress",onChange:P("billingAddress"),ref:d.billingAddress,visibility:a.billingAddress}),p&&oc(Ju,{label:n.get("separateDeliveryAddress"),checked:s.deliveryAddress,classNameModifiers:["separateDeliveryAddress"],name:"separateDeliveryAddress",onChange:function(){l((function(e){return r(r({},e),{deliveryAddress:!s.deliveryAddress})}))}}),s.deliveryAddress&&oc(Nm,{allowedCountries:e.allowedCountries,countryCode:t,data:h.deliveryAddress,label:"deliveryAddress",onChange:P("deliveryAddress"),ref:d.deliveryAddress,visibility:a.deliveryAddress}),c&&oc(wm,{data:h,errorMessage:!!b.consentCheckbox,label:e.consentCheckboxLabel,onChange:function(e){var t=e.target.checked;f((function(e){return r(r({},e),{consentCheckbox:t})})),C((function(e){return r(r({},e),{consentCheckbox:t})})),v((function(e){return r(r({},e),{consentCheckbox:!t})}))}}),e.showPayButton&&e.payButton({status:N,classNameModifiers:i([],u?["standalone"]:[]),label:n.get("confirmPurchase")}))}var Am=function(e){function r(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={loaded:!1},t}return t(r,e),r.prototype.componentDidMount=function(){var e=this;this.props.i18n?this.props.i18n.loaded.then((function(){e.setState({loaded:!0})})):this.setState({loaded:!0})},r.prototype.render=function(e){var t=e.children;return this.state.loaded?oc(su.Provider,{value:{i18n:this.props.i18n,loadingContext:this.props.loadingContext}},fc(t)):null},r}(lc),Sm=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatProps=function(e){var t,n,o=e.countryCode||(null===(n=null===(t=e.data)||void 0===t?void 0:t.billingAddress)||void 0===n?void 0:n.countryCode);return r(r({},e),{allowedCountries:[o],visibility:r(r({},a.defaultProps.visibility),e.visibility),data:r(r({},e.data),{billingAddress:r(r({},e.data.billingAddress),{country:o}),deliveryAddress:r(r({},e.data.deliveryAddress),{country:o})})})},a.prototype.formatData=function(){var e=this.state.data,t=void 0===e?{}:e,a=t.companyDetails,n=void 0===a?{}:a,o=t.personalDetails,i=void 0===o?{}:o,s=t.billingAddress,l=t.deliveryAddress;return r(r(r(r({paymentMethod:{type:this.constructor.type}},i),n),s&&{billingAddress:s}),(l||s)&&{deliveryAddress:l||s})},a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Dm,r({ref:function(t){e.componentRef=t}},this.props,this.state,{consentCheckbox:this.props.consentCheckbox,onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.defaultProps={onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{}},visibility:{companyDetails:"hidden",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable"}},a}(hu);function xm(e){var t=lu().i18n,r=t.get("paymentConditions"),a=t.get("afterPay.agreement").split("%@"),n=a[0],o=a[1];return n&&o?oc(sc,null,n,oc("a",{className:"adyen-checkout__link",target:"_blank",rel:"noopener noreferrer",href:e.url},r),o):oc("span",{className:"adyen-checkout__checkbox__label"},t.get("privacyPolicy"))}var Bm=["BE","NL"];var Tm=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){var a,n,o;return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Bm,consentCheckboxLabel:oc(xm,{url:(n=t.countryCode,o=null===(a=t.i18n)||void 0===a?void 0:a.locale,"en"===(null==o?void 0:o.toLowerCase().slice(0,2))?"https://www.afterpay.nl/en/algemeen/pay-with-afterpay/payment-conditions":"be"===(null==n?void 0:n.toLowerCase())?"https://www.afterpay.be/be/footer/betalen-met-afterpay/betalingsvoorwaarden":"https://www.afterpay.nl/nl/algemeen/betalen-met-afterpay/betalingsvoorwaarden")})})},a.type="afterpay_default",a}(Sm),zm=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Bm,consentCheckboxLabel:oc(xm,{url:"https://www.afterpay.nl/nl/algemeen/zakelijke-partners/betalingsvoorwaarden-zakelijk"})})},a.type="afterpay_b2b",a.defaultProps={onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{}},visibility:{companyDetails:"editable",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable"}},a}(Sm);function Im(){var e=Dc(window,"screen.colorDepth")||"",t=!!Dc(window,"navigator.javaEnabled")&&window.navigator.javaEnabled(),r=Dc(window,"screen.height")||"",a=Dc(window,"screen.width")||"",n=Dc(window,"navigator.userAgent")||"";return{acceptHeader:"*/*",colorDepth:e,language:Dc(window,"navigator.language")||Dc(window,"navigator.browserLanguage")||"en",javaEnabled:t,screenHeight:r,screenWidth:a,userAgent:n,timeZoneOffset:(new Date).getTimezoneOffset()}}var Mm={EU:"EUR",UK:"GBP",US:"USD"},jm=["en_GB","de_DE","fr_FR","it_IT","es_ES"],Em=["en_US"];function Om(e,t){return function(e){return"US"===e?Em:jm}(t).includes(e)?e:function(e){return"US"===e?"en_US":"en_GB"}(t)}function Rm(e){return"noTagline"===e?"C0001":null}function Lm(e){var t=e.addressDetails,a=e.cancelUrl,n=e.checkoutMode,o=e.deliverySpecifications,i=e.returnUrl,s=e.merchantMetadata,l=e.configuration.storeId,d="ProcessOrder"===n,c=d?function(e){return{amount:String($d(e.value,e.currency)),currencyCode:e.currency}}(e.amount):null;return r(r(r(r({storeId:l,webCheckoutDetails:r(r(r({},d?{checkoutResultReturnUrl:i}:{checkoutReviewReturnUrl:i}),a&&{checkoutCancelUrl:a}),d&&{checkoutMode:n})},d&&{paymentDetails:{chargeAmount:c,paymentIntent:"Confirm",presentmentCurrency:c.currencyCode,totalOrderAmount:c}}),s&&{merchantMetadata:s}),o&&{deliverySpecifications:o}),t&&{addressDetails:t})}function Vm(e,t,r){return bm({loadingContext:e,path:"v1/AmazonPayUtility/getCheckoutDetails?clientKey="+t},r)}function Um(e){var t=this,a=lu().loadingContext,n=e.amazonRef,o=e.configuration,i=void 0===o?{}:o,s=Wc(null),l=s[0],d=s[1],c=Lm(e),u=function(e){var t;return r(r(r({},e.buttonColor&&{buttonColor:e.buttonColor}),e.design&&{design:Rm(e.design)}),{checkoutLanguage:Om(e.locale,e.region),ledgerCurrency:Mm[e.configuration.region]||e.currency||(null===(t=e.amount)||void 0===t?void 0:t.currency),merchantId:e.configuration.merchantId,productType:e.productType,placement:e.placement,sandbox:"TEST"===e.environment})}(e),p=function(){new Promise(e.onClick).then(t.initCheckout).catch((function(r){e.onError&&e.onError(r,t.componentRef)}))};return this.initCheckout=function(){var e={payloadJSON:JSON.stringify(c),publicKeyId:i.publicKeyId,signature:l};n.Pay.initCheckout(r(r({},u),{createCheckoutSessionConfig:e}))},Zc((function(){var r=e.clientKey;(function(e,t,r){var a={loadingContext:e,path:"v1/AmazonPayUtility/signString?clientKey="+t},n={stringToSign:JSON.stringify(r)};return bm(a,n)})(a,r,c).then((function(t){if(!(null==t?void 0:t.signature))return console.error("Could not get AmazonPay signature");d(t.signature),e.showPayButton&&n.Pay.renderButton("#amazonPayButton",u).onClick(p)})).catch((function(r){console.error(r),e.onError&&e.onError(r,t.componentRef)}))}),[]),e.showPayButton?oc("div",{className:"adyen-checkout__amazonpay__button",id:"amazonPayButton"}):null}function Km(e){var t=lu().i18n,r=e.amazonRef,a=e.amazonCheckoutSessionId;return Zc((function(){var e={amazonCheckoutSessionId:a,changeAction:"changeAddress"};r.Pay.bindChangeAction(".adyen-checkout__amazonpay__button--changeAddress",e)}),[]),oc("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--changeAddress"},t.get("amazonpay.changePaymentDetails"))}function Hm(e){var t=this,r=lu(),a=r.i18n,n=r.loadingContext;return this.createOrder=function(){var r=e.amazonCheckoutSessionId,a=e.amount,o=e.clientKey,i=e.publicKeyId,s=e.region,l=e.returnUrl;(function(e,t,r){return bm({loadingContext:e,path:"v1/AmazonPayUtility/updateCheckoutSession?clientKey="+t},r)})(n,o,{amount:a,checkoutResultReturnUrl:l,checkoutSessionId:r,publicKeyId:i,region:s}).then((function(e){var t;if(!(null===(t=null==e?void 0:e.action)||void 0===t?void 0:t.type))return console.error(e.errorMessage||"Could not get the AmazonPay URL");"redirect"===e.action.type&&window.location.assign(e.action.url)})).catch((function(r){e.onError&&e.onError(r,t.componentRef)}))},oc(du,{classNameModifiers:["standalone","pay"],label:a.get("confirmPurchase"),onClick:this.createOrder})}function qm(e){return oc("button",{type:"button",className:"adyen-checkout__button  adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut",onClick:function(){new Promise(e.onSignOut).then((function(){e.amazonRef.Pay.signout()})).catch(console.error)}},lu().i18n.get("amazonpay.signout"))}var Gm=function(e,t,r,a){var n=this;void 0===t&&(t="body"),void 0===r&&(r={}),void 0===a&&(a={}),this.load=function(){return new Promise((function(e,t){Object.assign(n.script,n.attributes),Object.assign(n.script.dataset,n.dataAttributes),n.script.src=n.src,n.script.async=!0,n.script.onload=e,n.script.onerror=function(){n.remove(),t(new Error("Unable to load script "+n.src))};var r=document.querySelector(n.node),a=r.querySelector('script[src="'+n.src+'"]');a?a.addEventListener("load",e):r.appendChild(n.script)}))},this.remove=function(){return n.script.remove()},this.script=document.createElement("script"),this.src=e,this.node=t,this.attributes=r,this.dataAttributes=a};function Ym(e){var t,a,n=Wc("pending"),o=n[0],i=n[1],s=$c(null),l=$c(null),d=function(){i("ready")};return this.submit=function(){return s.current&&s.current.initCheckout?s.current.initCheckout():l.current&&l.current.createOrder?l.current.createOrder():void 0},Zc((function(){var t="US"===e.region?"https://static-na.payments-amazon.com/checkout.js":"https://static-eu.payments-amazon.com/checkout.js",r=new Gm(t);return window.amazon?d():r.load().then(d),function(){r.remove()}}),[]),"pending"===o?oc("div",{className:"adyen-checkout__amazonpay"},oc("div",{className:"adyen-checkout__amazonpay__status adyen-checkout__amazonpay__status--pending"},oc(Rc,null))):e.showSignOutButton?oc("div",{className:"adyen-checkout__amazonpay"},oc(qm,{amazonRef:window.amazon,onSignOut:e.onSignOut})):e.amazonCheckoutSessionId?oc("div",{className:"adyen-checkout__amazonpay"},e.showOrderButton&&oc(Hm,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amount:e.amount,clientKey:e.clientKey,onError:e.onError,publicKeyId:null===(t=e.configuration)||void 0===t?void 0:t.publicKeyId,region:null===(a=e.configuration)||void 0===a?void 0:a.region,returnUrl:e.returnUrl,ref:l}),e.showChangePaymentDetailsButton&&oc(Km,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amazonRef:window.amazon})):oc("div",{className:"adyen-checkout__amazonpay"},oc(Um,r({},e,{amazonRef:window.amazon,ref:s})))}var Wm={cancelUrl:window.location.href,configuration:{},environment:"TEST",locale:"en_GB",placement:"Cart",productType:"PayAndShip",region:"EU",returnUrl:window.location.href,showOrderButton:!0,showChangePaymentDetailsButton:!1,showSignOutButton:!1,showPayButton:!0,onClick:function(e){return e()},onSignOut:function(e){return e()}},Jm=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(e){return r(r({},e),{checkoutMode:e.isDropin?"ProcessOrder":e.checkoutMode,environment:e.environment.toUpperCase(),locale:e.locale.replace("-","_"),productType:e.isDropin&&!e.addressDetails?"PayOnly":e.productType,region:e.region.toUpperCase()})},a.prototype.formatData=function(){var e=this.props.amazonCheckoutSessionId;return{paymentMethod:r({type:a.type},e&&{checkoutSessionId:e}),browserInfo:this.browserInfo}},a.prototype.getShopperDetails=function(){var e=this.props,t=e.amazonCheckoutSessionId,r=e.configuration,a=void 0===r?{}:r,n=e.loadingContext,o=e.clientKey;return t?Vm(n,o,{checkoutSessionId:t,getDeliveryAddress:!0,publicKeyId:a.publicKeyId,region:a.region}):console.error("Could not shopper details. Missing checkoutSessionId.")},a.prototype.handleDeclineFlow=function(){var e=this,t=this.props,r=t.amazonCheckoutSessionId,a=t.configuration,n=void 0===a?{}:a,o=t.loadingContext,i=t.clientKey;if(!r)return console.error("Could handle the decline flow. Missing checkoutSessionId.");Vm(o,i,{checkoutSessionId:r,getDeclineFlowUrl:!0,publicKeyId:n.publicKeyId,region:n.region}).then((function(e){if(void 0===e&&(e={}),!(null==e?void 0:e.declineFlowUrl))throw e;window.location.assign(e.declineFlowUrl)})).catch((function(t){e.props.onError&&e.props.onError(t,e.componentRef)}))},Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"browserInfo",{get:function(){return Im()},enumerable:!1,configurable:!0}),a.prototype.submit=function(){var e=this.data,t=this.isValid,r=this.props.onSubmit,a=void 0===r?function(){}:r;return this.componentRef&&this.componentRef.submit?this.componentRef.submit():a({data:e,isValid:t},this)},a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Ym,r({ref:function(t){e.componentRef=t}},this.props)))},a.type="amazonpay",a.defaultProps=Wm,a}(hu),Zm={"apple-pay-button":"ApplePayButton-module_apple-pay-button__26P3-","apple-pay-button-black":"ApplePayButton-module_apple-pay-button-black__3Ml54","apple-pay-button-white":"ApplePayButton-module_apple-pay-button-white__1qE8A","apple-pay-button-white-with-line":"ApplePayButton-module_apple-pay-button-white-with-line__j9FE5","apple-pay-button--type-plain":"ApplePayButton-module_apple-pay-button--type-plain__2mnnX","apple-pay-button--type-buy":"ApplePayButton-module_apple-pay-button--type-buy__eMnIy","apple-pay-button--type-donate":"ApplePayButton-module_apple-pay-button--type-donate__3zvI8","apple-pay-button--type-check-out":"ApplePayButton-module_apple-pay-button--type-check-out__ipg0J","apple-pay-button--type-book":"ApplePayButton-module_apple-pay-button--type-book__155Xs","apple-pay-button--type-subscribe":"ApplePayButton-module_apple-pay-button--type-subscribe__3uPJ5","apple-pay-button--type-add-money":"ApplePayButton-module_apple-pay-button--type-add-money__xmCaj","apple-pay-button--type-contribute":"ApplePayButton-module_apple-pay-button--type-contribute__RCq2P","apple-pay-button--type-order":"ApplePayButton-module_apple-pay-button--type-order__f5tpZ","apple-pay-button--type-reload":"ApplePayButton-module_apple-pay-button--type-reload__1P53C","apple-pay-button--type-rent":"ApplePayButton-module_apple-pay-button--type-rent__2J4wk","apple-pay-button--type-support":"ApplePayButton-module_apple-pay-button--type-support__3-p0R","apple-pay-button--type-tip":"ApplePayButton-module_apple-pay-button--type-tip__2-gCt","apple-pay-button--type-top-up":"ApplePayButton-module_apple-pay-button--type-top-up__9UKXI"},Qm=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.prototype.render=function(e){var t=e.buttonColor,r=e.buttonType;return oc("button",{type:"button","aria-label":this.props.i18n.get("payButton"),lang:this.props.i18n.languageCode,className:Oc("adyen-checkout__applepay__button","adyen-checkout__applepay__button--"+t,"adyen-checkout__applepay__button--"+r,[Zm["apple-pay-button"]],[Zm["apple-pay-button-"+t]],[Zm["apple-pay-button--type-"+r]]),onClick:this.props.onClick})},r.defaultProps={onClick:function(){},buttonColor:"black",buttonType:"plain"},r}(lc),$m=function(){function e(e,t){var r=this;this.session=new ApplePaySession(t.version,e),this.session.onvalidatemerchant=function(e){return r.onvalidatemerchant(e,t.onValidateMerchant)},this.session.onpaymentauthorized=function(e){return r.onpaymentauthorized(e,t.onPaymentAuthorized)},this.session.oncancel=function(e){return r.oncancel(e,t.onCancel)},"function"==typeof t.onPaymentMethodSelected&&(this.session.onpaymentmethodselected=function(e){return r.onpaymentmethodselected(e,t.onPaymentMethodSelected)}),"function"==typeof t.onShippingContactSelected&&(this.session.onshippingcontactselected=function(e){return r.onshippingcontactselected(e,t.onShippingContactSelected)}),"function"==typeof t.onShippingMethodSelected&&(this.session.onshippingmethodselected=function(e){return r.onshippingmethodselected(e,t.onShippingMethodSelected)})}return e.prototype.begin=function(){return this.session.begin()},e.prototype.onvalidatemerchant=function(e,t){var r=this;new Promise((function(r,a){return t(r,a,e.validationURL)})).then((function(e){r.session.completeMerchantValidation(e)})).catch((function(e){console.error(e),r.session.abort()}))},e.prototype.onpaymentauthorized=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(){r.session.completePayment(ApplePaySession.STATUS_SUCCESS)})).catch((function(){r.session.completePayment(ApplePaySession.STATUS_FAILURE)}))},e.prototype.onpaymentmethodselected=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(e){r.session.completePaymentMethodSelection(e)})).catch((function(e){r.session.completePaymentMethodSelection(e)}))},e.prototype.onshippingcontactselected=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(e){r.session.completeShippingContactSelection(e)})).catch((function(e){r.session.completeShippingContactSelection(e)}))},e.prototype.onshippingmethodselected=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(e){r.session.completeShippingMethodSelection(e)})).catch((function(e){r.session.completeShippingMethodSelection(e)}))},e.prototype.oncancel=function(e,t){return t(e)},e}(),Xm={amount:{currency:"USD",value:0},countryCode:"US",totalPriceStatus:"final",totalPriceLabel:void 0,configuration:{merchantName:"",merchantId:""},initiative:"web",lineItems:void 0,merchantCapabilities:["supports3DS"],shippingMethods:void 0,shippingType:void 0,supportedCountries:void 0,supportedNetworks:["amex","discover","masterCard","visa"],requiredBillingContactFields:void 0,requiredShippingContactFields:void 0,billingContact:void 0,shippingContact:void 0,applicationData:void 0,onClick:function(e){return e()},onAuthorized:function(e){return e()},onPaymentMethodSelected:null,onShippingContactSelected:null,onShippingMethodSelected:null,buttonType:"plain",buttonColor:"black",showPayButton:!0},eh=function(e){var t=e.countryCode;e.companyName;var r=e.amount,n=a(e,["countryCode","companyName","amount"]),o=function(e){return String($d(e.value,e.currency))}(r);return{countryCode:t,currencyCode:r.currency,total:{label:n.totalPriceLabel,amount:o,type:n.totalPriceStatus},lineItems:n.lineItems,shippingMethods:n.shippingMethods,shippingType:n.shippingType,merchantCapabilities:n.merchantCapabilities,supportedCountries:n.supportedCountries,supportedNetworks:n.supportedNetworks,requiredShippingContactFields:n.requiredShippingContactFields,requiredBillingContactFields:n.requiredBillingContactFields,billingContact:n.billingContact,shippingContact:n.shippingContact,applicationData:n.applicationData}};var th=function(e){function a(t){var r=e.call(this,t)||this;return r.startSession=r.startSession.bind(r),r.submit=r.submit.bind(r),r.validateMerchant=r.validateMerchant.bind(r),r}return t(a,e),a.prototype.formatProps=function(e){var t,a,n,o,i=this,s=e.version||function(e){for(var t=[],r=e;r>0;r--)t.push(r);return t.find((function(e){return e&&window.ApplePaySession&&ApplePaySession.supportsVersion(e)}))}(11),l=(null===(t=e.brands)||void 0===t?void 0:t.length)?(n=e.brands,o={mc:"masterCard",amex:"amex",visa:"visa",elodebit:"elo",elo:"elo",interac:"interac",discover:"discover",jcb:"jcb",electron:"electron",maestro:"maestro",girocard:"girocard",cartebancaire:"cartesBancaires"},n.reduce((function(e,t){return o[t]&&!e.includes(o[t])&&e.push(o[t]),e}),[])):e.supportedNetworks;return r(r({},e),{configuration:e.configuration,supportedNetworks:l,version:s,totalPriceLabel:e.totalPriceLabel||(null===(a=e.configuration)||void 0===a?void 0:a.merchantName),onCancel:function(e){return i.handleError(new mu("CANCEL",e))}})},a.prototype.formatData=function(){return{paymentMethod:r({type:a.type},this.state)}},a.prototype.submit=function(){return this.startSession(this.props.onAuthorized)},a.prototype.startSession=function(e){var t=this,a=this.props,n=a.version,o=a.onValidateMerchant,i=a.onCancel,s=a.onPaymentMethodSelected,l=a.onShippingMethodSelected,d=a.onShippingContactSelected;return new Promise((function(e,r){return t.props.onClick(e,r)})).then((function(){var a=eh(r({companyName:t.props.configuration.merchantName},t.props));new $m(a,{version:n,onCancel:i,onPaymentMethodSelected:s,onShippingMethodSelected:l,onShippingContactSelected:d,onValidateMerchant:o||t.validateMerchant,onPaymentAuthorized:function(r,a,n){n.payment.token&&n.payment.token.paymentData&&t.setState({applePayToken:btoa(JSON.stringify(n.payment.token.paymentData))}),t.onSubmit(),e(r,a,n)}}).begin()}))},a.prototype.validateMerchant=function(e,t){return n(this,void 0,void 0,(function(){var r,a,n,i,s,l,d,c,u,p,m,h,f;return o(this,(function(o){switch(o.label){case 0:r=window.location.hostname,a=this.props,n=a.clientKey,i=a.configuration,s=a.loadingContext,l=a.initiative,d=i.merchantName,c=i.merchantId,u={loadingContext:s,path:"v1/applePay/sessions?clientKey="+n},p={displayName:d,domainName:r,initiative:l,merchantIdentifier:c},o.label=1;case 1:return o.trys.push([1,3,,4]),[4,bm(u,p)];case 2:return m=o.sent(),(h=Au.decode(m.data))||t("Could not decode Apple Pay session"),f=JSON.parse(h),e(f),[3,4];case 3:return o.sent(),t("Could not get Apple Pay session"),[3,4];case 4:return[2]}}))}))},Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),a.prototype.isAvailable=function(){return"https:"!==document.location.protocol?Promise.reject(new mu("IMPLEMENTATION_ERROR","Trying to start an Apple Pay session from an insecure document")):this.props.onValidateMerchant||this.props.clientKey?window.ApplePaySession&&ApplePaySession.canMakePayments()&&ApplePaySession.supportsVersion(this.props.version)?Promise.resolve(!0):Promise.reject(new mu("ERROR","Apple Pay is not available on this device")):Promise.reject(new mu("IMPLEMENTATION_ERROR","clientKey was not provided"))},a.prototype.render=function(){var e=this;return this.props.showPayButton?oc(Qm,{i18n:this.props.i18n,buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,onClick:function(t){t.preventDefault(),e.submit()}}):null},a.type="applepay",a.defaultProps=Xm,a}(hu);function rh(e){var t=e.name,r=e.id,a=e.icon,n=e.onClick,o=e.selected,i=void 0!==o&&o;return oc("button",{type:"button",className:Oc("adyen-checkout__issuer-button",{"adyen-checkout__issuer-button--selected":i}),"aria-label":t,"aria-pressed":i,onClick:n,value:r},oc("span",{className:"adyen-checkout__issuer-button-text"},t),!!a&&oc(ap,{className:"adyen-checkout__issuer-button-img",alt:t,src:a}))}var ah=function(e){var t=e.items,a=void 0===t?[]:t,n=e.selectedIssuerId,o=e.onChange,i=lu().i18n,s=eu((function(e){var t=e.currentTarget.value;Object.defineProperty(e.target,"value",{value:t}),o(e)}),[o]);return oc("div",{className:"adyen-checkout__issuer-button-group",role:"group","aria-label":i.get("idealIssuer.selectField.placeholder")},a.map((function(e){return oc(rh,r({key:e.id},e,{selected:n===e.id,onClick:s}))})))};function nh(){return oc("div",{className:"adyen-checkout__field--issuer-list-separator"},lu().i18n.get("qrCodeOrApp"))}var oh,ih=function(e,t){var r,a=e.issuer,n=null===(r=e.items.find((function(e){return e.id===a})))||void 0===r?void 0:r.name;return a&&n?t.get("continueTo")+" "+n:t.get("continue")},sh=["issuer"],lh={issuer:{validate:function(e){return!!e&&e.length>0},modes:["blur"]}};function dh(e){var t=e.items,n=e.placeholder,o=void 0===n?"idealIssuer.selectField.placeholder":n,s=e.issuer,l=e.highlightedIds,d=void 0===l?[]:l,c=a(e,["items","placeholder","issuer","highlightedIds"]),u=lu().i18n,p=gp({schema:sh,defaultData:{issuer:s},rules:lh}),m=p.handleChangeFor,h=p.triggerValidation,f=p.data,y=p.valid,b=p.errors,v=p.isValid,g=Wc("ready"),k=g[0],C=g[1],_=Wc(oh.Dropdown),N=_[0],w=_[1];this.setStatus=function(e){C(e)};var P=eu((function(e){return function(t){w(e),m("issuer")(t)}}),[m]);Zc((function(){c.onChange({data:f,valid:y,errors:b,isValid:v})}),[f,y,b,v]),this.showValidation=function(){h()};var F=t.reduce((function(e,t){return d.includes(t.id)&&e.highlightedItems.push(r({},t)),e}),{highlightedItems:[]}).highlightedItems;return oc("div",{className:"adyen-checkout__issuer-list"},!!F.length&&oc(sc,null,oc(ah,{selectedIssuerId:N===oh.ButtonGroup?f.issuer:null,items:F,onChange:P(oh.ButtonGroup)}),oc(nh,null)),oc(Ru,{errorMessage:!!b.issuer,classNameModifiers:["issuer-list"]},cp("select",{items:t,selected:N===oh.Dropdown?f.issuer:null,placeholder:u.get(o),name:"issuer",className:"adyen-checkout__issuer-list__dropdown",onChange:P(oh.Dropdown)})),c.showPayButton&&c.payButton({status:k,label:ih({issuer:f.issuer,items:i(i([],t),F)},u)}))}!function(e){e[e.ButtonGroup=0]="ButtonGroup",e[e.Dropdown=1]="Dropdown"}(oh||(oh={})),dh.defaultProps={onChange:function(){}};var ch=function(e,t){return function(a){if(!a)return null;var n=r({parentFolder:a?t+"/":"",type:a||t},e);return zc(n)(a)}},uh=function(e){function a(t){var a=e.call(this,t)||this;if(a.props.showImage){var n=ch({loadingContext:a.props.loadingContext},a.constructor.type);a.props.issuers=a.props.issuers.map((function(e){return r(r({},e),{icon:n(e.id)})}))}return a}return t(a,e),a.prototype.formatProps=function(e){var t=e.details&&e.details.length&&(e.details.find((function(e){return"issuer"===e.key}))||{}).items||e.issuers||[];return r(r({},e),{issuers:t})},a.prototype.formatData=function(){var e,t;return{paymentMethod:{type:this.constructor.type,issuer:null===(t=null===(e=this.state)||void 0===e?void 0:e.data)||void 0===t?void 0:t.issuer}}},Object.defineProperty(a.prototype,"isValid",{get:function(){var e;return!!(null===(e=this.state)||void 0===e?void 0:e.isValid)},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(dh,r({ref:function(t){e.componentRef=t},items:this.props.issuers,highlightedIds:this.props.highlightedIssuers},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.defaultProps={showImage:!0,onValid:function(){},issuers:[],highlightedIssuers:[],loadingContext:Bc},a}(hu),ph=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{showImage:!1})},a.type="billdesk_online",a}(uh),mh=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{showImage:!1,placeholder:"issuerList.wallet.placeholder"})},a.type="billdesk_wallet",a}(uh),hh="encryptedCardNumber",fh="encryptedExpiryDate",yh="encryptedExpiryMonth",bh="encryptedExpiryYear",vh="encryptedSecurityCode",gh="encryptedPassword",kh="giftcard",Ch=["amex","mc","visa"],_h=["sepa","sepadirectdebit","ach",kh],Nh="required",wh="optional",Ph="hidden",Fh=Nh,Dh=wh,Ah=Ph,Sh=Nh,xh=wh,Bh=Ph,Th="data-cse",zh="data-info",Ih="data-uid",Mh=function(e,t){return t===fh?(e.encryptedExpiryMonth=!1,e.encryptedExpiryYear=!1):e[t]=!1,e},jh=function(e,t){return function(r,a){var n=!0!==t.valid[a]?function(e,t){return 1!==t||e!==yh&&e!==bh?e:fh}(a,e):null;return(n=function(e,t){var r=e===vh,a=!t.errors.encryptedSecurityCode;return(t.cvcPolicy===Dh||t.cvcPolicy===Ah)&&a&&r?null:e}(n,t))&&!r.includes(n)&&r.push(n),r}},Eh=function(e,t){var r="card"===e?"nocard":e||"nocard";return zc({type:r,extension:"svg",loadingContext:t})(r)};function Oh(e){return"object"==typeof e&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function Rh(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var a=Oh(e[0])?e[0]:e;return{from:function(e){return a.map((function(t){var r;return t in e?((r={})[t]=e[t],r):{}})).reduce((function(e,t){return r(r({},e),t)}),{})}}}function Lh(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=Oh(e[0])?e[0]:e;return{from:function(e){var t=Object.keys(e).filter((function(e){return!r.includes(e)}));return Rh.apply(void 0,t).from(e)}}}var Vh=Object.prototype.toString;function Uh(e){return"object"==typeof e&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function Kh(e){return null!=e}function Hh(e){return!1!==e&&Kh(e)}function qh(e){return!!e&&"object"==typeof e}function Gh(e,t){var r=typeof e;return e&&t&&"object"===r&&r===typeof t?Object.keys(e).length===Object.keys(t).length&&Object.keys(e).every((function(r){return Gh(e[r],t[r])})):e===t}function Yh(e){return!Hh(e)||(!(!("number"==typeof(t=e)||qh(t)&&"[object Number]"===Vh.call(t))||0!==e&&!Number.isNaN(e))||(!(!Uh(e)&&!function(e){return"string"==typeof e||qh(e)&&"[object String]"===Vh.call(e)}(e)||0!==e.length)||!(!qh(e)||0!==Object.keys(e).length)));var t}var Wh=window.console&&window.console.error&&window.console.error.bind(window.console);window.console&&window.console.info&&window.console.info.bind(window.console);var Jh=window.console&&window.console.log&&window.console.log.bind(window.console),Zh=window.console&&window.console.warn&&window.console.warn.bind(window.console);function Qh(){var e;this.config.cardGroupTypes=Uh(e=this.props.cardGroupTypes)&&e.length?e:Ch;var t=this.props.loadingContext;if(t){var r;this.config.loadingContext="/"===(r=t).charAt(r.length-1)?t:t+"/",this.config.isCreditCardType=!1===_h.includes(this.props.type),this.config.iframeUIConfig=this.props.iframeUIConfig,this.config.allowedDOMAccess=!(!1===this.props.allowedDOMAccess||"false"===this.props.allowedDOMAccess),this.config.autoFocus=!(!1===this.props.autoFocus||"false"===this.props.autoFocus),this.config.showWarnings=!0===this.props.showWarnings||"true"===this.props.showWarnings,this.config.trimTrailingSeparator=!(!1===this.props.trimTrailingSeparator||"false"===this.props.trimTrailingSeparator),this.config.keypadFix=!(!1===this.props.keypadFix||"false"===this.props.keypadFix),this.config.legacyInputMode=this.props.legacyInputMode||null,this.config.minimumExpiryDate=this.props.minimumExpiryDate||null,this.config.implementationType=this.props.implementationType,this.config.sfLogAtStart=!0===this.props._b$dl;var a=this.config.isCreditCardType?"card":this.props.type;a.indexOf("sepa")>-1&&(a="iban");var n=btoa(window.location.origin);this.config.iframeSrc=this.config.loadingContext+"securedfields/"+this.props.clientKey+"/3.7.1/securedFields.html?type="+a+"&d="+n}else Zh("WARNING Config :: no loadingContext has been specified!")}var $h=function(){};function Xh(e){void 0===e&&(e={}),this.callbacks.onLoad=e.onLoad?e.onLoad:$h,this.callbacks.onConfigSuccess=e.onConfigSuccess?e.onConfigSuccess:$h,this.callbacks.onFieldValid=e.onFieldValid?e.onFieldValid:$h,this.callbacks.onAllValid=e.onAllValid?e.onAllValid:$h,this.callbacks.onBrand=e.onBrand?e.onBrand:$h,this.callbacks.onError=e.onError?e.onError:$h,this.callbacks.onFocus=e.onFocus?e.onFocus:$h,this.callbacks.onBinValue=e.onBinValue?e.onBinValue:$h,this.callbacks.onAutoComplete=e.onAutoComplete?e.onAutoComplete:$h,this.callbacks.onAdditionalSFConfig=e.onAdditionalSFConfig?e.onAdditionalSFConfig:$h,this.callbacks.onAdditionalSFRemoved=e.onAdditionalSFRemoved?e.onAdditionalSFRemoved:$h}var ef=function(e,t,r){if(t){var a=JSON.stringify(e);t.postMessage(a,r)}};function tf(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var rf=function(e,t){return!Gh(e,t)};function af(e){if(e.fieldType===hh){var t={brand:e.brand,cvcPolicy:e.cvcPolicy,expiryDatePolicy:e.expiryDatePolicy,showSocialSecurityNumber:e.showSocialSecurityNumber},r=rf(t,this.state.brand);if(!r)return null;var a="card"===this.state.type||"bcmc"===this.state.type;if(a&&r&&(this.state.brand=t,tf(this.state.securedFields,vh))){var n={txVariant:this.state.type,brand:t.brand,fieldType:vh,cvcPolicy:e.cvcPolicy,numKey:this.state.securedFields.encryptedSecurityCode.numKey};ef(n,this.getIframeContentWin(vh),this.config.loadingContext)}var o=a?Rh(["brand","cvcPolicy","cvcText","expiryDatePolicy","showSocialSecurityNumber"]).from(e):null;if(o&&o.brand){var i=o;i.type=this.state.type,i.rootNode=this.props.rootNode,this.callbacks.onBrand(i)}return!0}return!1}var nf=function(e){return{fieldType:e.fieldType,encryptedFieldName:e.encryptedFieldName,uid:e.uuid,valid:e.isValid,type:e.txVariant,rootNode:e.rootNode}},of=function(e,t){var r=[];return e&&"function"==typeof e.querySelectorAll&&(r=[].slice.call(e.querySelectorAll(t))),r},sf=function(e,t){if(e)return e.querySelector(t)},lf=function(e,t){if(e)return e.getAttribute(t)},df=function(e,t,r,a){if("function"!=typeof e.addEventListener){if(!e.attachEvent)throw new Error(": Unable to bind "+t+"-event");e.attachEvent("on"+t,r)}else e.addEventListener(t,r,a)},cf=function(e,t,r,a){if("function"==typeof e.addEventListener)e.removeEventListener(t,r,a);else{if(!e.attachEvent)throw new Error(": Unable to unbind "+t+"-event");e.detachEvent("on"+t,r)}},uf=function(e,t,r,a,n){if(!tf(e,"error"))return null;var o=t,i={rootNode:a,fieldType:e.fieldType,error:null,type:null},s=""!==e.error;return s||o.hasError?o.errorType===Eu["Unsupported card entered"]?null:(i.error=s?e.error:"",i.type=r,o.hasError=s,o.errorType=i.error,n(i),i):null};function pf(e){var t,r,a,n,o=e.fieldType;if("card"===this.state.type&&tf(e,"cvcPolicy")&&Kh(e.cvcPolicy)&&tf(this.state.securedFields,vh)&&(this.state.securedFields.encryptedSecurityCode.cvcPolicy=e.cvcPolicy),uf(e,this.state.securedFields[o],this.state.type,this.props.rootNode,this.callbacks.onError),this.state.securedFields[o].isEncrypted){t=function(e){var t,r,a=e.fieldType,n=e.txVariant,o=e.rootNode,i=a===fh,s=[],l=["encryptedExpiryMonth","encryptedExpiryYear"],d=i?2:1;for(t=0;t<d;t+=1){r=i?l[t]:a;var c=nf({fieldType:a,encryptedFieldName:i?r:a,uuid:n+"-encrypted-"+r,isValid:!1,txVariant:n,rootNode:o});s.push(c)}return s}({fieldType:o,txVariant:this.state.type,rootNode:this.props.rootNode}),o===hh&&(t[0].endDigits="");for(var i=0,s=t.length;i<s;i+=1)this.config.allowedDOMAccess&&(r=this.props.rootNode,a=t[i].uid,n=void 0,(n=sf(r,"#"+a))&&r.removeChild(n)),this.callbacks.onFieldValid(t[i]);this.state.securedFields[o].isEncrypted=!1}this.assessFormValidity(),tf(e,"brand")&&this.processBrand(e)}function mf(e){var t,r,a=e.fieldType;this.config.autoFocus&&("year"!==e.type&&a!==bh||this.setFocusOnFrame(vh),a===yh&&this.setFocusOnFrame(bh));var n=e[a];this.state.securedFields[a].isEncrypted=!0,this.config.allowedDOMAccess&&function(e,t,r){var a,n,o,i,s,l,d,c;for(a=0;a<e.length;a+=1){var u=e[a];n=t+"-encrypted-"+(o=u.encryptedFieldName),s=o,l=u.blob,c=void 0,(c=sf(i=r,"#"+(d=n)))||((c=document.createElement("input")).type="hidden",c.name=s,c.id=d,i.appendChild(c)),c.setAttribute("value",l)}}(n,this.state.type,this.props.rootNode),uf({error:"",fieldType:a},this.state.securedFields[a],this.state.type,this.props.rootNode,this.callbacks.onError);var o=function(e){var t,r,a,n,o,i=e.fieldType,s=e.txVariant,l=e.rootNode,d=e.encryptedObjArr,c=[];for(t=0;t<d.length;t+=1){r=s+"-encrypted-"+(n=(a=d[t]).encryptedFieldName),o=a.blob;var u=nf({fieldType:i,encryptedFieldName:n,uuid:r,isValid:!0,txVariant:s,rootNode:l});u.blob=o,c.push(u)}return c}({fieldType:a,txVariant:this.state.type,rootNode:this.props.rootNode,encryptedObjArr:n});if(a===yh&&tf(this.state.securedFields,bh)){var i={txVariant:this.state.type,code:e.code,blob:n[0].blob,fieldType:bh,numKey:this.state.securedFields.encryptedExpiryYear.numKey};ef(i,this.getIframeContentWin(bh),this.config.loadingContext)}for(a===hh&&Hh(e.endDigits)&&(o[0].endDigits=e.endDigits),t=0,r=o.length;t<r;t+=1)this.callbacks.onFieldValid(o[t]);this.assessFormValidity()}var hf={__NO_BRAND:"noBrand",cards:[]};hf.cards.push({cardType:"mc",startingRules:[51,52,53,54,55,22,23,24,25,26,27],permittedLengths:[16],pattern:/^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/,securityCode:"CVC"}),hf.cards.push({cardType:"visadankort",startingRules:[4571],permittedLengths:[16],pattern:/^(4571)[0-9]{0,12}$/}),hf.cards.push({cardType:"visa",startingRules:[4],permittedLengths:[13,16,19],pattern:/^4[0-9]{0,18}$/,securityCode:"CVV"}),hf.cards.push({cardType:"amex",startingRules:[34,37],permittedLengths:[15],pattern:/^3[47][0-9]{0,13}$/,securityCode:"CID"}),hf.cards.push({cardType:"diners",startingRules:[36],permittedLengths:[14],pattern:/^(36)[0-9]{0,12}$/}),hf.cards.push({cardType:"maestrouk",startingRules:[6759],permittedLengths:[16,18,19],pattern:/^(6759)[0-9]{0,15}$/}),hf.cards.push({cardType:"solo",startingRules:[6767],permittedLengths:[16,18,19],pattern:/^(6767)[0-9]{0,15}$/}),hf.cards.push({cardType:"laser",startingRules:[6304,6706,677117,677120],permittedLengths:[16,17,18,19],pattern:/^(6304|6706|6709|6771)[0-9]{0,15}$/,cvcPolicy:"optional"}),hf.cards.push({cardType:"discover",startingRules:[6011,644,645,646,647,648,649,65],permittedLengths:[16],pattern:/^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$/}),hf.cards.push({cardType:"jcb",startingRules:[3528,3529,353,354,355,356,357,358],permittedLengths:[16,19],pattern:/^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$/,securityCode:"CAV"}),hf.cards.push({cardType:"bcmc",startingRules:[6703,479658,606005],permittedLengths:[16,17,18,19],pattern:/^((6703)[0-9]{0,15}|(479658|606005)[0-9]{0,13})$/,cvcPolicy:"hidden"}),hf.cards.push({cardType:"bijcard",startingRules:[5100081],permittedLengths:[16],pattern:/^(5100081)[0-9]{0,9}$/}),hf.cards.push({cardType:"dankort",startingRules:[5019],permittedLengths:[16],pattern:/^(5019)[0-9]{0,12}$/}),hf.cards.push({cardType:"hipercard",startingRules:[606282],permittedLengths:[16],pattern:/^(606282)[0-9]{0,10}$/}),hf.cards.push({cardType:"cup",startingRules:[62,81],permittedLengths:[14,15,16,17,18,19],pattern:/^(62|81)[0-9]{0,17}$/}),hf.cards.push({cardType:"maestro",startingRules:[50,56,57,58,6],permittedLengths:[16,17,18,19],pattern:/^(5[0|6-8][0-9]{0,17}|6[0-9]{0,18})$/,cvcPolicy:"optional"}),hf.cards.push({cardType:"elo",startingRules:[506699,50670,50671,50672,50673,50674,50675,50676,506770,506771,506772,506773,506774,506775,506776,506777,506778,401178,438935,451416,457631,457632,504175,627780,636297,636368],permittedLengths:[16],pattern:/^((((506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$/}),hf.cards.push({cardType:"uatp",startingRules:[1],permittedLengths:[15],pattern:/^1[0-9]{0,14}$/,cvcPolicy:"optional"}),hf.cards.push({cardType:"cartebancaire",startingRules:[4,5,6],permittedLengths:[16],pattern:/^[4-6][0-9]{0,15}$/}),hf.cards.push({cardType:"visaalphabankbonus",startingRules:[450903],permittedLengths:[16],pattern:/^(450903)[0-9]{0,10}$/}),hf.cards.push({cardType:"mcalphabankbonus",startingRules:[510099],permittedLengths:[16],pattern:/^(510099)[0-9]{0,10}$/}),hf.cards.push({cardType:"hiper",startingRules:[637095,637568,637599,637609,637612],permittedLengths:[16],pattern:/^(637095|637568|637599|637609|637612)[0-9]{0,10}$/}),hf.cards.push({cardType:"oasis",startingRules:[982616],permittedLengths:[16],pattern:/^(982616)[0-9]{0,10}$/,cvcPolicy:"optional"}),hf.cards.push({cardType:"karenmillen",startingRules:[98261465],permittedLengths:[16],pattern:/^(98261465)[0-9]{0,8}$/,cvcPolicy:"optional"}),hf.cards.push({cardType:"warehouse",startingRules:[982633],permittedLengths:[16],pattern:/^(982633)[0-9]{0,10}$/,cvcPolicy:"optional"}),hf.cards.push({cardType:"mir",startingRules:[220],permittedLengths:[16,17,18,19],pattern:/^(220)[0-9]{0,16}$/}),hf.cards.push({cardType:"codensa",startingRules:[590712],permittedLengths:[16],pattern:/^(590712)[0-9]{0,10}$/}),hf.cards.push({cardType:"naranja",startingRules:[377798,377799,402917,402918,527571,527572,589562],permittedLengths:[16,17,18,19],pattern:/^(37|40|5[28])([279])\d*$/}),hf.cards.push({cardType:"cabal",startingRules:[589657,600691,603522,6042,6043,636908],permittedLengths:[16,17,18,19],pattern:/^(58|6[03])([03469])\d*$/}),hf.cards.push({cardType:"shopping",startingRules:[2799,589407,603488],permittedLengths:[16,17,18,19],pattern:/^(27|58|60)([39])\d*$/}),hf.cards.push({cardType:"argencard",startingRules:[501],permittedLengths:[16,17,18,19],pattern:/^(50)(1)\d*$/}),hf.cards.push({cardType:"troy",startingRules:[9792],permittedLengths:[16],pattern:/^(97)(9)\d*$/}),hf.cards.push({cardType:"forbrugsforeningen",startingRules:[600722],permittedLengths:[16],pattern:/^(60)(0)\d*$/}),hf.cards.push({cardType:"vpay",startingRules:[401,408,413,434,435,437,439,441,442,443,444,446,447,455,458,460,461,463,466,471,479,482,483,487],permittedLengths:[13,14,15,16,17,18,19],pattern:/^(40[1,8]|413|43[4,5]|44[1,2,3,4,6,7]|45[5,8]|46[0,1,3,6]|47[1,9]|48[2,3,7])[0-9]{0,16}$/}),hf.cards.push({cardType:"rupay",startingRules:[508528],permittedLengths:[16],pattern:/^(100003|508(2|[5-9])|60(69|[7-8])|652(1[5-9]|[2-5][0-9]|8[5-9])|65300[3-4]|8172([0-1]|[3-5]|7|9)|817(3[3-8]|40[6-9]|410)|35380([0-2]|[5-6]|9))[0-9]{0,12}$/});var ff=function(e){return hf.cards.filter((function(t){return t.cardType===e}))[0]},yf=function(e){return void 0===e&&(e="card"),"card"===e||"scheme"===e};hf.__NO_BRAND,hf.cards;var bf=function(e){var t=Eu[e];return t||((t=Object.keys(Eu).find((function(t){return Eu[t]===e})))||e)},vf=function(e,t){var a=r({},e);return a.error=a.error?a.error:function(e){return Object.keys(Eu).reduce((function(t,r){var a=Eu[r];return(a.indexOf("sf-")>-1||a.indexOf("gen.01")>-1)&&(t[a]=e.get(a)),t}),{})}(t),a};var gf,kf=function(e){function a(t,a){var n=e.call(this)||this,o=["fieldType","iframeSrc","cvcPolicy","expiryDatePolicy","loadingContext","holderEl"],i=Lh(o).from(t);n.config=r(r(r({},n.config),i),{iframeUIConfig:r({},i.iframeUIConfig)});var s=Rh(o).from(t);return n.fieldType=s.fieldType,n.cvcPolicy=s.cvcPolicy,n.expiryDatePolicy=s.expiryDatePolicy,n.iframeSrc=s.iframeSrc,n.loadingContext=s.loadingContext,n.holderEl=s.holderEl,n.isValid=!1,n.iframeContentWindow=null,n.numKey=function(){if(!window.crypto)return 4294967296*Math.random()|0;var e=new Uint32Array(1);return window.crypto.getRandomValues(e),e[0]}(),n.isEncrypted=!1,n.hasError=!1,n.errorType="",n.init(a)}return t(a,e),a.prototype.init=function(e){var t=function(e,t,a){var n,o=["ach","giftcard"].includes(e.txVariant)?e.txVariant:"creditCard",i=a.get(o+"."+t+".aria.iframeTitle"),s=a.get(o+"."+t+".aria.label"),l=a.locale,d=vf({iframeTitle:i,label:s},a);return r(r({},l&&{lang:l}),((n={})[t]=d,n))}(this.config,this.fieldType,e);this.config.iframeUIConfig.ariaConfig=t;var a=function(e,t,a){var n,o,i,s=e.txVariant,l=function(e){var t;return(t={}).encryptedCardNumber=e.get&&e.get("creditCard.numberField.placeholder"),t.encryptedExpiryDate=e.get&&e.get("creditCard.expiryDateField.placeholder"),t.encryptedExpiryMonth=e.get&&e.get("creditCard.expiryDateField.month.placeholder"),t.encryptedExpiryYear=e.get&&e.get("creditCard.expiryDateField.year.placeholder"),t.encryptedSecurityCode=e.get&&e.get("creditCard.cvcField.placeholder"),t.encryptedSecurityCode3digits=e.get&&e.get("creditCard.cvcField.placeholder.3digits"),t.encryptedSecurityCode4digits=e.get&&e.get("creditCard.cvcField.placeholder.4digits"),t.encryptedPassword=e.get&&e.get("creditCard.encryptedPassword.placeholder"),t}(a);return r(r(r({},t!==vh&&((n={})[t]=l[t],n)),t===vh&&s===kh&&((o={})[t]=l[t],o)),t===vh&&s!==kh&&((i={}).encryptedSecurityCode3digits=l.encryptedSecurityCode3digits,i.encryptedSecurityCode4digits=l.encryptedSecurityCode4digits,i))}(this.config,this.fieldType,e);this.config.iframeUIConfig.placeholders=a;var n=function(e){var t=e.src,r=e.title,a=void 0===r?"iframe element":r,n=e.policy,o=void 0===n?"origin":n,i=e.styleStr,s=void 0===i?"border: none; height:100%; width:100%;":i,l=document.createElement("iframe");l.setAttribute("src",t),l.setAttribute("class","js-iframe"),l.setAttribute("title",a),l.setAttribute("frameborder","0"),l.setAttribute("scrolling","no"),l.setAttribute("allowtransparency","true"),l.setAttribute("style",s),l.setAttribute("referrerpolicy",o);var d=document.createTextNode("<p>Your browser does not support iframes.</p>");return l.appendChild(d),l}({src:this.iframeSrc,title:t[this.fieldType].iframeTitle,policy:"origin"});this.holderEl.appendChild(n);var o=sf(this.holderEl,".js-iframe");return o&&(this.iframeContentWindow=o.contentWindow,this.iframeOnLoadListener=this.iframeOnLoadListenerFn,df(o,"load",this.iframeOnLoadListener,!1)),this},a.prototype.iframeOnLoadListenerFn=function(){cf(window,"load",this.iframeOnLoadListener,!1),this.postMessageListener=this.postMessageListenerFn,df(window,"message",this.postMessageListener,!1);var e={fieldType:this.fieldType,cvcPolicy:this.cvcPolicy,expiryDatePolicy:this.expiryDatePolicy,numKey:this.numKey,txVariant:this.config.txVariant,extraFieldData:this.config.extraFieldData,cardGroupTypes:this.config.cardGroupTypes,iframeUIConfig:this.config.iframeUIConfig,sfLogAtStart:this.config.sfLogAtStart,showWarnings:this.config.showWarnings,trimTrailingSeparator:this.config.trimTrailingSeparator,isCreditCardType:this.config.isCreditCardType,legacyInputMode:this.config.legacyInputMode,minimumExpiryDate:this.config.minimumExpiryDate,uid:this.config.uid,implementationType:this.config.implementationType};ef(e,this.iframeContentWindow,this.loadingContext),this.onIframeLoadedCallback()},a.prototype.postMessageListenerFn=function(e){if(function(e,t,r){var a=e.origin,n=t.indexOf("/checkoutshopper/"),o=n>-1?t.substring(0,n):t,i=o.length-1;return"/"===o.charAt(i)&&(o=o.substring(0,i)),a===o||(r&&(Zh("WARNING postMessageValidation: postMessage listener for iframe::origin mismatch!\n Received message with origin:",a,"but the only allowed origin for messages to CSF is",o),Zh("### event.data=",e.data)),!1)}(e,this.loadingContext,this.config.showWarnings)){var t;try{t=JSON.parse(e.data)}catch(t){return function(e){return e.data&&e.data.type&&"string"==typeof e.data.type&&e.data.type.indexOf("webpack")>-1}(e)?void(this.config.showWarnings&&Jh("### SecuredField::postMessageListenerFn:: PARSE FAIL - WEBPACK")):function(e){return e.data&&"string"==typeof e.data&&e.data.indexOf("cvox")>-1}(e)?void(this.config.showWarnings&&Jh("### SecuredField::postMessageListenerFn:: PARSE FAIL - CHROMEVOX")):void(this.config.showWarnings&&Jh("### SecuredField::postMessageListenerFn:: PARSE FAIL - UNKNOWN REASON: event.data=",e.data))}if(tf(t,"action")&&tf(t,"numKey"))if(this.numKey===t.numKey)switch(t.action){case"encryption":this.isValid=!0,this.onEncryptionCallback(t);break;case"config":this.onConfigCallback(t);break;case"focus":this.onFocusCallback(t);break;case"binValue":this.onBinValueCallback(t);break;case"click":this.onClickCallback(t);break;case"shifttab":this.onShiftTabCallback(t);break;case"autoComplete":this.onAutoCompleteCallback(t);break;default:this.isValid=!1,this.onValidationCallback(t)}else this.config.showWarnings&&Zh("WARNING SecuredField :: postMessage listener for iframe :: data mismatch! (Probably a message from an unrelated securedField)");else this.config.showWarnings&&Zh("WARNING SecuredField :: postMessage listener for iframe :: data mismatch!")}},a.prototype.destroy=function(){cf(window,"message",this.postMessageListener,!1),this.iframeContentWindow=null,function(e){for(;e.firstChild;)e.removeChild(e.firstChild)}(this.holderEl)},a.prototype.onIframeLoaded=function(e){return this.onIframeLoadedCallback=e,this},a.prototype.onEncryption=function(e){return this.onEncryptionCallback=e,this},a.prototype.onValidation=function(e){return this.onValidationCallback=e,this},a.prototype.onConfig=function(e){return this.onConfigCallback=e,this},a.prototype.onFocus=function(e){return this.onFocusCallback=e,this},a.prototype.onBinValue=function(e){return this.onBinValueCallback=e,this},a.prototype.onClick=function(e){return this.onClickCallback=e,this},a.prototype.onShiftTab=function(e){return this.onShiftTabCallback=e,this},a.prototype.onAutoComplete=function(e){return this.onAutoCompleteCallback=e,this},Object.defineProperty(a.prototype,"errorType",{get:function(){return this._errorType},set:function(e){this._errorType=e},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"hasError",{get:function(){return this._hasError},set:function(e){this._hasError=e},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"isValid",{get:function(){if(this.fieldType===vh)switch(this.cvcPolicy){case Ah:return!0;case Dh:return!this.hasError;default:return this._isValid}if(this.fieldType===fh||this.fieldType===yh||this.fieldType===bh)switch(this.expiryDatePolicy){case Bh:return!0;case xh:return!this.hasError;default:return this._isValid}return this._isValid},set:function(e){this._isValid=e},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"cvcPolicy",{get:function(){return this._cvcPolicy},set:function(e){this.fieldType===vh&&e!==this.cvcPolicy&&(this._cvcPolicy=e,this.hasError&&"isValidated"===this.errorType&&(this.hasError=!1))},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"expiryDatePolicy",{get:function(){return this._expiryDatePolicy},set:function(e){this.fieldType!==fh&&this.fieldType!==yh&&this.fieldType!==bh||e!==this.expiryDatePolicy&&(this._expiryDatePolicy=e,this.hasError&&"isValidated"===this.errorType&&(this.hasError=!1))},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"iframeContentWindow",{get:function(){return this._iframeContentWindow},set:function(e){this._iframeContentWindow=e},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"isEncrypted",{get:function(){return this._isEncrypted},set:function(e){this._isEncrypted=e},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"numKey",{get:function(){return this._numKey},set:function(e){this._numKey=e},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"iframeOnLoadListener",{get:function(){return this._iframeOnLoadListener},set:function(e){this._iframeOnLoadListener=e.bind(this)},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"postMessageListener",{get:function(){return this._postMessageListener},set:function(e){this._postMessageListener=e.bind(this)},enumerable:!1,configurable:!0}),a}((function(){this.config={}}));function Cf(){this.encryptedAttrName=Th;var e=of(this.props.rootNode,"["+this.encryptedAttrName+"]");return gf=Fh,this.config.isCreditCardType?(this.isSingleBrandedCard=!1,this.securityCode="",this.createCardSecuredFields(e)):this.createNonCardSecuredFields(e)}function _f(e){return e.forEach(this.setupSecuredField.bind(this)),e.length}function Nf(e){var t=this,r=this.state.type;if("card"===r&&1===this.config.cardGroupTypes.length&&(r=this.config.cardGroupTypes[0],this.state.type=r),this.isSingleBrandedCard="card"!==r,this.isSingleBrandedCard){var a=ff(r);Kh(a)?(gf=a.cvcPolicy||Fh,this.securityCode=a.securityCode):this.state.type="unrecognised-single-brand"}if(e.forEach(this.setupSecuredField.bind(this)),this.isSingleBrandedCard){var n={type:this.state.type,rootNode:this.props.rootNode,brand:r,cvcPolicy:gf,cvcText:this.securityCode};setTimeout((function(){t.callbacks.onBrand(n)}),0)}return e.length}function wf(e){var t=this,r=lf(e,this.encryptedAttrName);r===bh&&(this.state.hasSeparateDateFields=!0);var a={fieldType:r,extraFieldData:lf(e,zh),uid:lf(e,Ih),txVariant:this.state.type,cardGroupTypes:this.config.cardGroupTypes,iframeUIConfig:this.config.iframeUIConfig?this.config.iframeUIConfig:{},sfLogAtStart:this.config.sfLogAtStart,trimTrailingSeparator:this.config.trimTrailingSeparator,cvcPolicy:gf,expiryDatePolicy:Sh,isCreditCardType:this.config.isCreditCardType,iframeSrc:this.config.iframeSrc,loadingContext:this.config.loadingContext,showWarnings:this.config.showWarnings,holderEl:e,legacyInputMode:this.config.legacyInputMode,minimumExpiryDate:this.config.minimumExpiryDate,implementationType:this.config.implementationType},n=new kf(a,this.props.i18n).onIframeLoaded((function(){if(t.state.iframeCount+=1,t.state.iframeCount===t.state.originalNumIframes){t.callbacks.onLoad({iframesLoaded:!0})}})).onConfig((function(e){t.handleIframeConfigFeedback(e)})).onFocus((function(e){t.handleFocus(e)})).onBinValue((function(e){t.handleBinValue(e)})).onClick((function(e){t.postMessageToAllIframes({fieldType:e.fieldType,click:!0})})).onShiftTab((function(e){t.handleSFShiftTab(e.fieldType)})).onEncryption((function(e){t.handleEncryption(e)})).onValidation((function(e){t.handleValidation(e)})).onAutoComplete((function(e){t.processAutoComplete(e)}));this.state.securedFields[r]=n}function Pf(e,t){if(tf(this.state.securedFields,e)){var r={txVariant:this.state.type,fieldType:e,focus:!0,numKey:this.state.securedFields[e].numKey};ef(r,this.getIframeContentWin(e),this.config.loadingContext)}}function Ff(e){var t=this,r=Object.keys(e||{});r.length&&Object.keys(this.state.securedFields).forEach((function(a){var n={txVariant:t.state.type,fieldType:a,numKey:t.state.securedFields[a].numKey};r.forEach((function(t){n[t]=e[t]})),ef(n,t.getIframeContentWin(a),t.config.loadingContext)}))}function Df(){var e=this;this.postMessageToAllIframes({destroy:!0}),Object.keys(this.state.securedFields).forEach((function(t){var r=e.state.securedFields[t];r&&r.destroy(),e.state.securedFields[t]=null})),this.destroyTouchendListener(),this.state.securedFields={}}function Af(e){var t=this;if("cc-name"===e.name){var a=r({},e);delete a.numKey;var n=a;this.callbacks.onAutoComplete(n)}if("cc-exp"===e.name){var o=e.value.replace(/[^0-9]/gi,"/").split("/");if(2!==o.length)return;1===o[0].length&&(o[0]="0"+o[0]);var i=o[0],s=o[1].substr(2),l=i+"/"+s;if(tf(this.state.securedFields,fh)){var d={txVariant:this.state.type,fieldType:fh,autoComplete:l,numKey:this.state.securedFields.encryptedExpiryDate.numKey};return void ef(d,this.getIframeContentWin(fh),this.config.loadingContext)}if(tf(this.state.securedFields,yh)){d={txVariant:this.state.type,fieldType:yh,autoComplete:i,numKey:this.state.securedFields.encryptedExpiryMonth.numKey};ef(d,this.getIframeContentWin(yh),this.config.loadingContext)}tf(this.state.securedFields,bh)&&setTimeout((function(){var e={txVariant:t.state.type,fieldType:bh,autoComplete:s,numKey:t.state.securedFields.encryptedExpiryYear.numKey};ef(e,t.getIframeContentWin(bh),t.config.loadingContext)}),0)}}function Sf(e){var t=r({},e);delete t.numKey,t.rootNode=this.props.rootNode,t.type=this.state.type;var a=t.fieldType;t.focus?this.state.currentFocusObject!==a&&(this.state.currentFocusObject=a,this.state.registerFieldForIos||this.handleAdditionalFields()):this.state.currentFocusObject===a&&(this.state.currentFocusObject=null);var n=t;n.currentFocusObject=this.state.currentFocusObject,this.callbacks.onFocus(n)}function xf(e){if(this.state.iframeConfigCount+=1,this.state.isConfigured){var t={additionalIframeConfigured:!0,fieldType:e.fieldType,type:this.state.type};this.callbacks.onAdditionalSFConfig(t)}else if(this.state.iframeConfigCount===this.state.originalNumIframes)return this.isConfigured(),!0;return!1}function Bf(){var e;this.state.isConfigured=!0;var t={iframesConfigured:!0,type:this.state.type,rootNode:this.props.rootNode};if(this.callbacks.onConfigSuccess(t),1===this.state.numIframes&&this.config.isCreditCardType){if("card"===this.state.type)return void Wh("ERROR: Payment method with a single secured field - but 'type' has not been set to a specific card brand");var r=ff(this.state.type);if(r)(null!==(e=r.cvcPolicy)&&void 0!==e?e:Fh)!==Fh&&this.assessFormValidity()}}function Tf(){var e=function(e){for(var t=Object.keys(e),r=0,a=t.length;r<a;r+=1)if(!e[t[r]].isValid)return!1;return!0}(this.state.securedFields),t=e!==this.state.allValid;if(this.state.allValid=e,e||t){var r={allValid:e,type:this.state.type,rootNode:this.props.rootNode};this.callbacks.onAllValid(r)}}function zf(e){var t=e.binValue,r=e.encryptedBin,a=e.uuid,n={binValue:t,type:this.state.type};r&&(n.encryptedBin=r,n.uuid=a),this.callbacks.onBinValue(n)}function If(e){if(tf(this.state.securedFields,hh)){var t=r(r({txVariant:this.state.type},e),{fieldType:hh,numKey:this.state.securedFields.encryptedCardNumber.numKey});ef(t,this.getIframeContentWin(hh),this.config.loadingContext)}}function Mf(e){var t=this;(tf(this.state.securedFields,yh)&&tf(this.state.securedFields,bh)?[yh,bh]:[fh]).forEach((function(a){var n=r(r({txVariant:t.state.type},e),{fieldType:a,numKey:t.state.securedFields[a].numKey});ef(n,t.getIframeContentWin(a),t.config.loadingContext)}))}function jf(e){var t,r,a="card"===this.state.type;if(!e||!Object.keys(e).length)return a&&(this.sendBrandToCardSF({brand:"reset"}),this.sendExpiryDatePolicyToSF({expiryDatePolicy:Sh})),void("card"===this.state.type&&tf(this.state.securedFields,fh)&&(this.state.securedFields.encryptedExpiryDate.expiryDatePolicy=Sh));var n=e.supportedBrands[0],o=n.brand,i=null!==(t=n.expiryDatePolicy)&&void 0!==t?t:!0===n.showExpiryDate?Sh:Bh,s={brand:o,cvcPolicy:n.cvcPolicy,expiryDatePolicy:i,cvcText:"Security code",showSocialSecurityNumber:null!==(r=n.showSocialSecurityNumber)&&void 0!==r&&r,fieldType:hh};this.processBrand(s),a&&(this.sendBrandToCardSF({brand:o,enableLuhnCheck:!1!==e.supportedBrands[0].enableLuhnCheck}),this.sendExpiryDatePolicyToSF({expiryDatePolicy:i})),tf(this.state.securedFields,vh)&&(this.state.securedFields.encryptedSecurityCode.cvcPolicy=n.cvcPolicy),tf(this.state.securedFields,fh)?this.state.securedFields.encryptedExpiryDate.expiryDatePolicy=i:tf(this.state.securedFields,yh)&&tf(this.state.securedFields,bh)&&(this.state.securedFields.encryptedExpiryMonth.expiryDatePolicy=i,this.state.securedFields.encryptedExpiryYear.expiryDatePolicy=i),this.assessFormValidity()}var Ef={__IS_ANDROID:/(android)/i.test(navigator.userAgent),__IS_IE:function(){var e=navigator.userAgent,t=e.indexOf("MSIE ");if(t>0)return parseInt(e.substring(t+5,e.indexOf(".",t)),10);if(e.indexOf("Trident/")>0){var r=e.indexOf("rv:");return parseInt(e.substring(r+3,e.indexOf(".",r)),10)}var a=e.indexOf("Edge/");return a>0&&parseInt(e.substring(a+5,e.indexOf(".",a)),10)}(),__IS_IOS:/iphone|ipod|ipad/i.test(navigator.userAgent),__IS_FIREFOX:/(firefox)/i.test(navigator.userAgent),__IS_SAFARI:/(safari)/i.test(navigator.userAgent)&&!/(chrome)/i.test(navigator.userAgent)};var Of={touchendListener:function(e){var t,r=e.target;if(r instanceof HTMLInputElement||HTMLTextAreaElement&&r instanceof HTMLTextAreaElement){var a=r.value,n="selectionStart"in(t=r)?t.selectionStart:0,o=!1;n===a.length&&(n-=1,o=!0),r.value=a,r.setSelectionRange&&(r.focus(),r.setSelectionRange(n,n),o&&(n+=1,setTimeout((function(){r.setSelectionRange(n,n)}),0)))}else{if(this.config.keypadFix){var i=this.props.rootNode,s=document.createElement("input");s.style.width="1px",s.style.height="1px",s.style.opacity="0",s.style.fontSize="18px",i.appendChild(s),s.focus(),i.removeChild(s)}}this.destroyTouchendListener(),this.state.registerFieldForIos=!1,this.postMessageToAllIframes({fieldType:"additionalField",click:!0})},handleAdditionalFields:function(){if(Ef.__IS_IOS){var e=sf(document,"body");e.style.cursor="pointer",df(e,"touchend",this.touchendListener),this.state.registerFieldForIos=!0}},destroyTouchendListener:function(){if(Ef.__IS_IOS){var e=sf(document,"body");e.style.cursor="auto",cf(e,"touchend",this.touchendListener)}}},Rf=function(e,t){return function(e,t){void 0===t&&(t=!0);var r=Array.prototype.slice.call(of(document,"*[data-cse], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]")),a=[];r.forEach((function(e){var t=e.getAttribute("tabindex"),r=!t||parseInt(t,10)>=0,n=e.getBoundingClientRect(),o=n.width>0&&n.height>0;r&&o&&a.push(e)}));var n=function(e,t){for(var r=0;r<e.length;r+=1)if(t(e[r]))return r;return-1}(a,(function(t){return t===e||e.contains(t)}));return a[n+(t?-1:1)]}(sf(t,"[data-cse="+e+"]"))};var Lf=function(e){var t;switch(this.state.type){case"ach":t=function(e){var t;return"encryptedBankLocationId"===e&&(t="encryptedBankAccountNumber"),{fieldToFocus:t,additionalField:void 0}}(e);break;case"giftcard":t=function(e,t){var r,a;switch(e){case hh:r=Rf(hh,t);break;case vh:a=hh}return{fieldToFocus:a,additionalField:r}}(e,this.props.rootNode);break;default:t=this.state.isKCP?function(e,t,r){var a,n;switch(e){case hh:a=Rf(hh,t);break;case fh:case yh:n=hh;break;case bh:n=yh;break;case vh:n=r?bh:fh;break;case gh:case"encryptedPin":a=Rf(e,t)}return{fieldToFocus:n,additionalField:a}}(e,this.props.rootNode,this.state.hasSeparateDateFields):function(e,t,r,a){var n,o;switch(e){case hh:n=Rf(hh,t);break;case fh:case yh:o=hh;break;case bh:o=yh;break;case vh:1===a?n=Rf(vh,t):o=r?bh:fh}return{fieldToFocus:o,additionalField:n}}(e,this.props.rootNode,this.state.hasSeparateDateFields,this.state.numIframes)}var r,a=t.fieldToFocus,n=t.additionalField;a?this.setFocusOnFrame(a,false):n&&(r=n)&&(r.focus(),r.blur(),r.focus())},Vf=function(e){(Ef.__IS_FIREFOX||Ef.__IS_IE&&Ef.__IS_IE<=11)&&this.handleShiftTab(e)},Uf=function(e){void 0===e&&(e="You cannot use secured fields"),Zh(e+" - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.")},Kf=function(e){function r(t){var r=e.call(this,t)||this;return r.state={type:r.props.type,brand:"card"!==r.props.type?{brand:r.props.type,cvcPolicy:"required"}:{brand:null,cvcPolicy:"required"},allValid:void 0,numIframes:0,originalNumIframes:0,iframeCount:0,iframeConfigCount:0,isConfigured:!1,hasSeparateDateFields:!1,currentFocusObject:null,registerFieldForIos:!1,securedFields:{},isKCP:!1},r.configHandler=Qh,r.callbacksHandler=Xh,r.handleIframeConfigFeedback=xf,r.isConfigured=Bf,r.assessFormValidity=Tf,r.processBrand=af,r.handleValidation=pf,r.handleEncryption=mf,r.createSecuredFields=Cf,r.createNonCardSecuredFields=_f,r.createCardSecuredFields=Nf,r.setupSecuredField=wf,r.postMessageToAllIframes=Ff,r.setFocusOnFrame=Pf,r.handleFocus=Sf,r.handleAdditionalFields=Of.handleAdditionalFields,r.touchendListener=Of.touchendListener.bind(r),r.destroyTouchendListener=Of.destroyTouchendListener,r.handleSFShiftTab=Vf,r.handleShiftTab=Lf,r.destroySecuredFields=Df,r.processAutoComplete=Af,r.handleBinValue=zf,r.brandsFromBinLookup=jf,r.sendBrandToCardSF=If,r.sendExpiryDatePolicyToSF=Mf,r.init(),r}return t(r,e),r.prototype.init=function(){this.configHandler(),this.callbacksHandler(this.props.callbacks);var e=this.createSecuredFields();this.state.numIframes=this.state.originalNumIframes=e,this.state.isKCP=!!this.props.isKCP},r.prototype.createReturnObject=function(){var e=this;return{updateStyles:function(t){e.state.isConfigured?e.postMessageToAllIframes({styleObject:t}):Zh("You cannot update the secured fields styling - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.")},setFocusOnFrame:function(t){e.state.isConfigured?e.setFocusOnFrame(t):Uf("You cannot set focus on any secured field")},isValidated:function(t,r){if(e.state.isConfigured){if(tf(e.state.securedFields,t)){e.state.securedFields[t].hasError=!0,""===e.state.securedFields[t].errorType&&(e.state.securedFields[t].errorType="isValidated");var a={txVariant:e.state.type,fieldType:t,externalValidation:!0,code:r,numKey:e.state.securedFields[t].numKey};ef(a,e.getIframeContentWin(t),e.config.loadingContext)}}else Uf("You cannot set validated on any secured field")},hasUnsupportedCard:function(t,r){if(e.state.isConfigured){if(tf(e.state.securedFields,t)){e.state.securedFields[t].hasError=!!r,e.state.securedFields[t].errorType=r;var a={txVariant:e.state.type,fieldType:t,unsupportedCard:!!r,code:r,numKey:e.state.securedFields[t].numKey};ef(a,e.getIframeContentWin(t),e.config.loadingContext)}}else Uf("You cannot set hasUnsupportedCard on any secured field")},destroy:function(){e.state.isConfigured?e.destroySecuredFields():Uf("You cannot destroy secured fields")},brandsFromBinLookup:function(t){if(!e.config.isCreditCardType)return null;e.state.isConfigured?e.brandsFromBinLookup(t):Uf("You cannot set pass brands to secured fields")},addSecuredField:function(t){var r=sf(e.props.rootNode,'[data-cse="'+t+'"]');r&&(e.state.numIframes+=1,e.setupSecuredField(r))},removeSecuredField:function(t){if(e.state.securedFields[t]){e.state.securedFields[t].destroy(),delete e.state.securedFields[t],e.state.numIframes-=1;var r={additionalIframeRemoved:!0,fieldType:t,type:e.state.type};e.callbacks.onAdditionalSFRemoved(r)}},setKCPStatus:function(t){e.state.isKCP=t}}},r.prototype.getIframeContentWin=function(e){var t;return(null===(t=this.state.securedFields[e])||void 0===t?void 0:t.iframeContentWindow)||null},r}((function(e){this.props=e,this.state={},this.config={},this.callbacks={}})),Hf=function(e){if(!e)throw new Error("No securedFields configuration object defined");var t=r({},e),a=yf(t.type);if(t.type=a?"card":t.type,!tf(t,"rootNode"))return Wh('ERROR: SecuredFields configuration object is missing a "rootNode" property'),null;if(Yh(t.clientKey))return Zh('WARNING: AdyenCheckout configuration object is missing a "clientKey" property.'),null;var n=function(e){var t;return"object"==typeof e&&(t=e),"string"!=typeof e||(t=sf(document,e))?t:null}(t.rootNode);return n?(t.rootNode=n,new Kf(t).createReturnObject()):(window.console&&window.console.error&&window.console.error("ERROR: SecuredFields cannot find a valid rootNode element for",t.type),null)};function qf(e,t,r,a){return(t!==wh&&t!==Ph||0!==r[e])&&a[e]}var Gf={handleFocus:function(e){this.numCharsInField[e.fieldType]=e.numChars,this.props.onFocus(e)},handleOnAllValid:function(e){var t=this;return!this.state.hasUnsupportedCard&&(this.setState({isSfpValid:e.allValid},(function(){t.props.onChange(t.state),t.props.onAllValid(e)})),!0)},handleOnAutoComplete:function(e){var t=this;this.setState({autoCompleteName:e.value},(function(){t.props.onChange(t.state),t.setState({autoCompleteName:null})})),this.props.onAutoComplete(e)},handleOnFieldValid:function(e){var t=this;return(!this.state.hasUnsupportedCard||e.fieldType!==hh)&&(this.setState((function(t){var a,n,o,i;return{data:r(r({},t.data),(a={},a[e.encryptedFieldName]=e.blob,a)),valid:r(r({},t.valid),(n={},n[e.encryptedFieldName]=e.valid,n)),errors:r(r({},t.errors),(o={},o[e.fieldType]=null!==(i=t.errors[e.fieldType])&&void 0!==i&&i,o))}}),(function(){t.props.onChange(t.state),t.props.onFieldValid(e)})),!0)},handleOnLoad:function(e){var t=this;this.props.onLoad(e),this.originKeyErrorTimeout=setTimeout((function(){"ready"!==t.state.status&&(t.setState({status:"originKeyError"}),t.props.onError({error:"originKeyError",fieldType:"defaultError"}))}),this.originKeyTimeoutMS)},handleOnConfigSuccess:function(e){var t=this;clearTimeout(this.originKeyErrorTimeout),this.setState({status:"ready"},(function(){t.props.onConfigSuccess(e)}))},handleOnBrand:function(e){var t=this;this.setState((function(a){var n,o,i,s,l,d,c=qf(vh,e.cvcPolicy,t.numCharsInField,a.errors),u=1===t.numDateFields?qf(fh,e.expiryDatePolicy,t.numCharsInField,a.errors):null,p=2===t.numDateFields?qf(yh,e.expiryDatePolicy,t.numCharsInField,a.errors):null,m=2===t.numDateFields?qf(bh,e.expiryDatePolicy,t.numCharsInField,a.errors):null;return{brand:e.brand,cvcPolicy:null!==(l=e.cvcPolicy)&&void 0!==l?l:Fh,showSocialSecurityNumber:e.showSocialSecurityNumber,errors:r(r(r(r(r({},a.errors),Kh(c)&&(n={},n.encryptedSecurityCode=c,n)),Kh(u)&&(o={},o.encryptedExpiryDate=u,o)),Kh(p)&&(i={},i.encryptedExpiryMonth=p,i)),Kh(m)&&(s={},s.encryptedExpiryYear=m,s)),expiryDatePolicy:null!==(d=e.expiryDatePolicy)&&void 0!==d?d:Sh}}),(function(){var a,n;t.props.onChange(t.state);var o=null!==(n=null===(a=t.props.brandsConfiguration[e.brand])||void 0===a?void 0:a.icon)&&void 0!==n?n:Eh(e.brand,t.props.loadingContext);t.props.onBrand(r(r({},e),{brandImageUrl:o}))}))},handleOnError:function(e,t){var a=this;void 0===t&&(t=null);var n=e.error;return this.setState((function(a){var o,i,s;return r(r(r({errors:r(r({},a.errors),(o={},o[e.fieldType]=n||!1,o)),hasUnsupportedCard:null!==t&&t},t&&{data:r(r({},a.data),(i={},i.encryptedCardNumber=void 0,i))}),t&&{valid:r(r({},a.valid),(s={},s.encryptedCardNumber=!1,s))}),t&&{isSfpValid:!1})}),(function(){a.props.onChange(a.state)})),!0},handleOnNoDataRequired:function(){var e=this;this.setState({status:"ready"},(function(){return e.props.onChange({isSfpValid:!0})}))}},Yf={type:"card",keypadFix:!0,rootNode:null,loadingContext:null,groupTypes:[],allowedDOMAccess:!1,showWarnings:!1,autoFocus:!0,trimTrailingSeparator:!0,onChange:function(){},onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onFocus:function(){},onAutoComplete:function(){},placeholders:{},styles:{}},Wf=function(e){function a(t){var r=e.call(this,t)||this;r.setRootNode=function(e){r.rootNode=e};var a={status:"loading",brand:t.type,errors:{},valid:{},data:{},cvcPolicy:Fh,isSfpValid:!1,hasKoreanFields:r.props.hasKoreanFields};return r.state=a,r.originKeyErrorTimeout=null,r.originKeyTimeoutMS=15e3,r.numCharsInField={},r.handleOnLoad=Gf.handleOnLoad.bind(r),r.handleOnConfigSuccess=Gf.handleOnConfigSuccess.bind(r),r.handleOnFieldValid=Gf.handleOnFieldValid.bind(r),r.handleOnAllValid=Gf.handleOnAllValid.bind(r),r.handleOnBrand=Gf.handleOnBrand.bind(r),r.handleFocus=Gf.handleFocus.bind(r),r.handleOnError=Gf.handleOnError.bind(r),r.handleOnNoDataRequired=Gf.handleOnNoDataRequired.bind(r),r.handleOnAutoComplete=Gf.handleOnAutoComplete.bind(r),r.processBinLookupResponse=r.processBinLookupResponse.bind(r),r.setFocusOn=r.setFocusOn.bind(r),r.updateStyles=r.updateStyles.bind(r),r.handleUnsupportedCard=r.handleUnsupportedCard.bind(r),r.showValidation=r.showValidation.bind(r),r.destroy=r.destroy.bind(r),r}return t(a,e),a.prototype.componentDidMount=function(){var e=this;this.props.rootNode&&this.setRootNode(this.props.rootNode);var t,r=(t=this.rootNode)?Array.prototype.slice.call(t.querySelectorAll('[data-cse*="encrypted"]')).map((function(e){return e.getAttribute("data-cse")})):[],a=r.reduce(Mh,{});this.setState({valid:a}),r.forEach((function(t){e.numCharsInField[t]=0})),this.numDateFields=r.filter((function(e){return e.match(/Expiry/)})).length,r.length?(this.destroy(),this.initializeCSF(this.rootNode)):this.handleOnNoDataRequired()},a.prototype.componentDidUpdate=function(){this.checkForKCPFields()},a.prototype.componentWillUnmount=function(){this.csf=null},a.prototype.initializeCSF=function(e){var t=this.props.loadingContext,r={rootNode:e,type:this.props.type,clientKey:this.props.clientKey,cardGroupTypes:this.props.groupTypes,allowedDOMAccess:this.props.allowedDOMAccess,autoFocus:this.props.autoFocus,trimTrailingSeparator:this.props.trimTrailingSeparator,loadingContext:t,keypadFix:this.props.keypadFix,showWarnings:this.props.showWarnings,iframeUIConfig:{sfStyles:this.props.styles},i18n:this.props.i18n,callbacks:{onLoad:this.handleOnLoad,onConfigSuccess:this.handleOnConfigSuccess,onFieldValid:this.handleOnFieldValid,onAllValid:this.handleOnAllValid,onBrand:this.handleOnBrand,onError:this.handleOnError,onFocus:this.handleFocus,onBinValue:this.props.onBinValue,onAutoComplete:this.handleOnAutoComplete,onAdditionalSFConfig:this.props.onAdditionalSFConfig,onAdditionalSFRemoved:this.props.onAdditionalSFRemoved},isKCP:this.state.hasKoreanFields,legacyInputMode:this.props.legacyInputMode,minimumExpiryDate:this.props.minimumExpiryDate,implementationType:this.props.implementationType||"components"};this.csf=Hf(r)},a.prototype.checkForKCPFields=function(){var e=this,t=!1;if(this.props.koreanAuthenticationRequired&&(t=this.issuingCountryCode?"kr"===this.issuingCountryCode:"kr"===this.props.countryCode),this.state.hasKoreanFields&&!t){this.setState((function(e){var t,a,n;return{data:r(r({},e.data),(t={},t.encryptedPassword=void 0,t)),valid:r(r({},e.valid),(a={},a.encryptedPassword=!1,a)),errors:r(r({},e.errors),(n={},n.encryptedPassword=!1,n)),hasKoreanFields:!1}}),(function(){e.props.onChange(e.state)})),this.csf.removeSecuredField(gh),this.csf.setKCPStatus(!1)}if(!this.state.hasKoreanFields&&t){this.setState((function(e){var t;return{valid:r(r({},e.valid),(t={},t.encryptedPassword=!1,t)),hasKoreanFields:!0,isSfpValid:!1}}),(function(){e.props.onChange(e.state)})),this.csf.addSecuredField(gh),this.csf.setKCPStatus(!0)}},a.prototype.getChildContext=function(){return{i18n:this.props.i18n}},a.prototype.handleUnsupportedCard=function(e){var t=!!e.error;return e.rootNode=this.rootNode,this.handleOnError(e,t),this.csf&&this.csf.hasUnsupportedCard(hh,e.error),t},a.prototype.setFocusOn=function(e){this.csf&&this.csf.setFocusOnFrame(e)},a.prototype.updateStyles=function(e){this.csf&&this.csf.updateStyles(e)},a.prototype.destroy=function(){this.csf&&this.csf.destroy()},a.prototype.showValidation=function(){var e=this,t=this.numDateFields,r=this.state;Object.keys(r.valid).reduce(jh(t,r),[]).forEach((function(t){var a=function(e,t,r){return{rootNode:t,fieldType:e,error:Dc(r,"errors."+e)||Ou,type:"card"}}(t,e.rootNode,r);e.handleOnError(a,r.hasUnsupportedCard),e.csf&&e.csf.isValidated&&e.csf.isValidated(t,a.error)}))},a.prototype.mapErrorsToValidationRuleResult=function(){var e=this;return Object.keys(this.state.errors).reduce((function(t,r){return e.state.errors[r]?t[r]={isValid:!1,errorMessage:bf(e.state.errors[r]),errorI18n:e.props.i18n.get(e.state.errors[r]),error:e.state.errors[r],rootNode:e.rootNode}:t[r]=null,t}),{})},a.prototype.processBinLookupResponse=function(e,t){var a,n=this;if(this.state.hasUnsupportedCard&&(this.setState((function(e){var t;return{errors:r(r({},e.errors),(t={},t.encryptedCardNumber=!1,t)),hasUnsupportedCard:!1}})),this.csf&&e)){this.handleUnsupportedCard({type:"card",fieldType:"encryptedCardNumber",error:""})}this.issuingCountryCode=null===(a=null==e?void 0:e.issuingCountryCode)||void 0===a?void 0:a.toLowerCase(),(null==t?void 0:t.brand)&&this.setState(t,(function(){n.props.onChange(n.state)})),this.csf&&this.csf.brandsFromBinLookup(e)},a.prototype.render=function(e,t){return e.render({setRootNode:this.setRootNode,setFocusOn:this.setFocusOn},t)},a.defaultProps=Yf,a}(lc),Jf={base:{caretColor:"#0066FF"}},Zf={"card-input__wrapper":"CardInput-module_card-input__wrapper__2tAzu","card-input__icon":"CardInput-module_card-input__icon__2Iaf5","card-input__form":"CardInput-module_card-input__form__2Ij_n","card-input__spinner":"CardInput-module_card-input__spinner__1wHzq","card-input__spinner--active":"CardInput-module_card-input__spinner--active__1Dzoe","card-input__form--loading":"CardInput-module_card-input__form--loading__3zh3Y","adyen-checkout__input":"CardInput-module_adyen-checkout__input__3Jmld","adyen-checkout__card__cvc__input--hidden":"CardInput-module_adyen-checkout__card__cvc__input--hidden__1Z1lp","adyen-checkout__card__exp-date__input--hidden":"CardInput-module_adyen-checkout__card__exp-date__input--hidden__3850Y","adyen-checkout__card__exp-cvc__exp-date__input--hidden":"CardInput-module_adyen-checkout__card__exp-cvc__exp-date__input--hidden__3wxr3","revolving-plan-installments__disabled":"CardInput-module_revolving-plan-installments__disabled__2yP53"},Qf="LoadingWrapper-module_loading-input__form__1jpVs",$f="LoadingWrapper-module_loading-input__form--loading__3LDWz",Xf="LoadingWrapper-module_loading-input__spinner__3eCyK",ey="LoadingWrapper-module_loading-input__spinner--active__3UDtX",ty=function(e){var t,r,a=e.children,n=e.status,o=Oc("adyen-checkout__loading-input__form",Qf,((t={})[$f]="loading"===n,t));return oc("div",{style:{position:"relative"}},oc("div",{className:Oc(((r={})[Xf]=!0,r[ey]="loading"===n,r))},oc(Rc,null)),oc("div",{className:o},a))};function ry(e){var t=e.frontCVC,r=void 0!==t&&t;return oc("div",{className:Oc({"adyen-checkout__card__cvc__hint__wrapper":!0,"adyen-checkout__field__cvc--front-hint":!!r,"adyen-checkout__field__cvc--back-hint":!r})},oc("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--front",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},oc("path",{d:"M0 3C0 1.34315 1.34315 0 3 0H24C25.6569 0 27 1.34315 27 3V15C27 16.6569 25.6569 18 24 18H3C1.34315 18 0 16.6569 0 15V3Z",fill:"#E6E9EB"}),oc("rect",{x:"4",y:"12",width:"19",height:"2",fill:"#B9C4C9"}),oc("rect",{x:"4",y:"4",width:"4",height:"4",rx:"1",fill:"white"}),oc("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"4.5",width:"7",height:"5",rx:"2.5",stroke:"#D10244"})),oc("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--back",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},oc("path",{d:"M27 4.00001V3.37501C27 2.4799 26.6444 1.62146 26.0115 0.988518C25.3786 0.355581 24.5201 0 23.625 0H3.375C2.47989 0 1.62145 0.355581 0.988514 0.988518C0.355579 1.62146 0 2.4799 0 3.37501V4.00001H27Z",fill:"#E6E9EB"}),oc("path",{d:"M0 6.99994V14.6666C0 15.5507 0.355579 16.3985 0.988514 17.0237C1.62145 17.6488 2.47989 18 3.375 18H23.625C24.5201 18 25.3786 17.6488 26.0115 17.0237C26.6444 16.3985 27 15.5507 27 14.6666V6.99994H0Z",fill:"#E6E9EB"}),oc("rect",{y:"4.00012",width:"27",height:"3.00001",fill:"#687282"}),oc("path",{d:"M4 11C4 10.4477 4.44772 10 5 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H5C4.44771 14 4 13.5523 4 13V11Z",fill:"white"}),oc("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"9.5",width:"7",height:"5",rx:"2.5",stroke:"#D10244"})))}function ay(e){var t,a=((t={})["data-cse"]=e.encryptedFieldType,t[zh]=e["data-info"],t[Ih]=e.uniqueId,t.className=e.className,t);return oc("span",r({},a),e.children)}function ny(e){var t,r,a=e.label,n=e.onFocusField,o=void 0===n?function(){}:n,s=e.error,l=void 0===s?"":s,d=e.className,c=void 0===d?"":d,u=e.classNameModifiers,p=void 0===u?[]:u,m=e.focused,h=e.filled,f=e.isValid,y=e.frontCVC,b=void 0!==y&&y,v=e.cvcPolicy,g=void 0===v?Fh:v,k=lu().i18n,C=Oc(c,((t={"adyen-checkout__field__cvc":!0})[Zf["adyen-checkout__card__cvc__input--hidden"]]=g===Ah,t["adyen-checkout__field__cvc--optional"]=g===Dh,t)),_=Oc(((r={"adyen-checkout__input":!0,"adyen-checkout__input--small":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":l,"adyen-checkout__input--focus":m,"adyen-checkout__input--valid":f})[Zf["adyen-checkout__input"]]=!0,r)),N=g!==Dh?a:k.get("creditCard.cvcField.title.optional");return oc(Ru,{label:N,focused:m,filled:h,classNameModifiers:i(i([],p),["securityCode"]),onFocusField:function(){return o("encryptedSecurityCode")},className:C,errorMessage:l&&k.get(l),isValid:f,dir:"ltr",name:"encryptedSecurityCode"},oc(ay,{encryptedFieldType:"encryptedSecurityCode",className:_}),oc(ry,{frontCVC:b}))}function oy(e){var t=e.brand,r=e.hasCVC,n=e.onFocusField,o=e.errors,i=e.valid,s=a(e,["brand","hasCVC","onFocusField","errors","valid"]),l=lu().i18n;return oc("div",{className:"adyen-checkout__card__form adyen-checkout__card__form--oneClick","aria-label":l.get("creditCard.storedCard.description.ariaLabel").replace("%@",s.lastFour)+" "+l.get("creditCard.expiryDateField.title")+" "+s.expiryMonth+"/"+s.expiryYear},oc("div",{className:"adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper"},oc(Ru,{label:l.get("creditCard.expiryDateField.title"),className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],disabled:!0},oc("div",{className:"adyen-checkout__input adyen-checkout__input--disabled adyen-checkout__card__exp-date__input--oneclick",dir:"ltr"},s.expiryMonth," / ",s.expiryYear)),r&&oc(ny,{cvcPolicy:s.cvcPolicy,error:o.encryptedSecurityCode,focused:"encryptedSecurityCode"===s.focusedElement,filled:!!i.encryptedSecurityCode||!!o.encryptedSecurityCode,isValid:!!i.encryptedSecurityCode,label:l.get("creditCard.cvcField.title"),onFocusField:n,className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],frontCVC:"amex"===t})))}function iy(e){var t,a,n=lu().i18n,o=e.amount,i=e.brand,s=e.onChange,l=e.type,d=e.installmentOptions[i]||e.installmentOptions.card,c=Wc((null==d?void 0:d.preselectedValue)||(null==d?void 0:d.values[0])),u=c[0],p=c[1],m=Wc("onetime"),h=m[0],f=m[1],y=null===(t=null==d?void 0:d.plans)||void 0===t?void 0:t.includes("revolving"),b=function(e){var t=e.target.value;p(Number(t))},v=function(e){var t,r,a;return"amount"===l?(t="installmentOption",r={count:e,values:{times:e,partialValue:(a=e,n.amount(o.value/a,o.currency))}}):(t="installmentOptionMonths",r={count:e,values:{times:e}}),{id:e,name:o.value?n.get(t,r):""+e}};return Zc((function(){var e,t=(null===(e=null==d?void 0:d.values)||void 0===e?void 0:e.includes(u))?u:null==d?void 0:d.values[0];p(t)}),[i]),Zc((function(){var e=r(r({value:u},y&&"revolving"===h&&{plan:h,value:1}),y&&"onetime"===h&&{value:1});s(d?e:{value:null})}),[u,d,h]),d?0===o.value?null:oc("div",{className:"adyen-checkout__installments"},y?oc(xu,{classNameModifiers:["revolving-plan"],label:""},oc(Wu,{items:[{id:"onetime",name:"installments.oneTime"},{id:"installments",name:"installments.installments"},{id:"revolving",name:"installments.revolving"}],i18n:n,onChange:function(e){var t=e.currentTarget.getAttribute("value");f(t)},value:h}),oc(Ru,{className:"installments"!==h?""+Zf["revolving-plan-installments__disabled"]:""+Zf["revolving-plan-installments"],classNameModifiers:["revolving-plan-installments"]},cp("select",{filterable:!1,items:d.values.map(v),selected:u,onChange:b,name:"installments"}))):oc(Ru,{label:n.get("installments"),classNameModifiers:["installments"]},cp("select",{filterable:!1,items:d.values.map(v),selected:u,onChange:b,name:"installments",readonly:1===(null===(a=null==d?void 0:d.values)||void 0===a?void 0:a.length)}))):null}iy.defaultProps={brand:"",amount:{},onChange:function(){}};var sy=function(e,t){return zc({type:"card"===e?"nocard":e||"nocard",extension:"svg",loadingContext:t})(e)};function ly(e){var t,r,a=e.brand,n=e.brandsConfiguration,o=void 0===n?{}:n,i=lu().loadingContext,s="card"===a?"nocard":a,l=null!==(r=null===(t=o[a])||void 0===t?void 0:t.icon)&&void 0!==r?r:sy(s,i);return oc("img",{className:Zf["card-input__icon"]+" adyen-checkout__card__cardNumber__brandIcon",onError:function(e){e.target.style.cssText="display: none"},alt:a,src:l})}var dy=function(e){var t,r,a=e.brand,n=e.onClick,o=e.dataValue,i=e.notSelected,s=e.brandsConfiguration,l=void 0===s?{}:s,d=lu().loadingContext,c="card"===a?"nocard":a,u=null!==(r=null===(t=l[a])||void 0===t?void 0:t.icon)&&void 0!==r?r:sy(c,d);return oc("img",{className:Zf["card-input__icon"]+" "+(i?"adyen-checkout__card__cardNumber__brandIcon--not-selected":"")+" adyen-checkout__card__cardNumber__brandIcon",onError:function(e){e.target.style.cssText="display: none"},alt:a,src:u,onClick:n,"data-value":o})};function cy(e){var t,r=lu().i18n,a=e.error,n=void 0===a?"":a,o=e.isValid,i=void 0!==o&&o,s=e.onFocusField,l=void 0===s?function(){}:s,d=e.dualBrandingElements,c=e.dualBrandingChangeHandler,u=e.dualBrandingSelected;return oc(Ru,{label:e.label,focused:e.focused,filled:e.filled,classNameModifiers:["cardNumber"],onFocusField:function(){return l("encryptedCardNumber")},errorMessage:n&&r.get(n),isValid:i,dualBrandingElements:d,dir:"ltr",name:"encryptedCardNumber"},oc(ay,{encryptedFieldType:"encryptedCardNumber",className:Oc((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0},t[Zf["adyen-checkout__input"]]=!0,t["adyen-checkout__input--error"]=n,t["adyen-checkout__input--focus"]=e.focused,t["adyen-checkout__input--valid"]=i,t["adyen-checkout__card__cardNumber__input--noBrand"]=!e.showBrandIcon,t))},e.showBrandIcon&&!d&&oc(ly,{brandsConfiguration:e.brandsConfiguration,brand:e.brand})),d&&!n&&oc("div",{className:Oc(["adyen-checkout__card__dual-branding__buttons",{"adyen-checkout__card__dual-branding__buttons--active":i}])},d.map((function(t){return oc(dy,{key:t.id,brand:t.id,brandsConfiguration:e.brandsConfiguration,onClick:c,dataValue:t.id,notSelected:""!==u&&u!==t.id})}))))}function uy(e){var t,r=e.label,a=e.focused,n=e.filled,o=e.onFocusField,i=e.className,s=void 0===i?"":i,l=e.error,d=void 0===l?"":l,c=e.isValid,u=void 0!==c&&c,p=e.expiryDatePolicy,m=void 0===p?Sh:p,h=lu().i18n,f=Oc(s,((t={"adyen-checkout__field__exp-date":!0})[Zf["adyen-checkout__card__exp-date__input--hidden"]]=m===Bh,t["adyen-checkout__field__exp-date--optional"]=m===xh,t)),y=m!==xh?r:r+" "+h.get("field.title.optional");return oc(Ru,{label:y,classNameModifiers:["expiryDate"],className:f,focused:a,filled:n,onFocusField:function(){return o("encryptedExpiryDate")},errorMessage:d&&h.get(d),isValid:u,dir:"ltr",name:"encryptedExpiryDate"},oc(ay,{encryptedFieldType:"encryptedExpiryDate",className:Oc("adyen-checkout__input","adyen-checkout__input--small","adyen-checkout__card__exp-date__input",[Zf["adyen-checkout__input"]],{"adyen-checkout__input--error":d,"adyen-checkout__input--focus":a,"adyen-checkout__input--valid":u})}))}function py(e){var t,r=e.brand,a=e.brandsConfiguration,n=e.dualBrandingElements,o=e.dualBrandingChangeHandler,i=e.dualBrandingSelected,s=e.errors,l=e.focusedElement,d=e.hasCVC,c=e.cvcPolicy,u=e.expiryDatePolicy,p=e.onFocusField,m=e.showBrandIcon,h=e.valid,f=lu().i18n;return oc("div",{className:"adyen-checkout__card__form"},oc(cy,{brand:r,brandsConfiguration:a,error:s.encryptedCardNumber,focused:"encryptedCardNumber"===l,isValid:!!h.encryptedCardNumber,label:f.get("creditCard.numberField.title"),onFocusField:p,filled:!!s.encryptedCardNumber||!!h.encryptedCardNumber,showBrandIcon:m,dualBrandingElements:n,dualBrandingChangeHandler:o,dualBrandingSelected:i}),oc("div",{className:Oc("adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper",(t={},t[Zf["adyen-checkout__card__exp-cvc__exp-date__input--hidden"]]=u===Bh,t))},oc(uy,{error:s.encryptedExpiryDate||s.encryptedExpiryYear||s.encryptedExpiryMonth,focused:"encryptedExpiryDate"===l,isValid:!!h.encryptedExpiryMonth&&!!h.encryptedExpiryYear,filled:!!s.encryptedExpiryDate||!!h.encryptedExpiryYear,label:f.get("creditCard.expiryDateField.title"),onFocusField:p,className:"adyen-checkout__field--50",expiryDatePolicy:u}),d&&oc(ny,{error:s.encryptedSecurityCode,focused:"encryptedSecurityCode"===l,cvcPolicy:c,isValid:!!h.encryptedSecurityCode,filled:!!s.encryptedSecurityCode||!!h.encryptedSecurityCode,label:f.get("creditCard.cvcField.title"),onFocusField:p,className:"adyen-checkout__field--50",frontCVC:"amex"===r})))}function my(e){var t,r=lu().i18n,a=Xc((function(){var t;return(null===(t=e.value)||void 0===t?void 0:t.length)>6?r.get("creditCard.taxNumber.labelAlt"):r.get("creditCard.taxNumber.label")}),[e.value]);return oc("div",{className:"adyen-checkout__card__kcp-authentication"},oc(Ru,{label:a,filled:e.filled,classNameModifiers:["kcp-taxNumber"],errorMessage:e.error&&r.get("creditCard.taxNumber.invalid"),isValid:e.isValid,dir:"ltr",name:"kcpTaxNumberOrDOB"},cp("tel",{className:"adyen-checkout__card__kcp-taxNumber__input "+Zf["adyen-checkout__input"],placeholder:r.get("creditCard.taxNumber.placeholder"),maxLength:10,minLength:6,autoComplete:!1,value:e.value,required:!0,onChange:e.onChange,onInput:e.onInput})),oc(Ru,{label:r.get("creditCard.encryptedPassword.label"),focused:"encryptedPassword"===e.focusedElement,filled:e.filled,classNameModifiers:["50","koreanAuthentication-encryptedPassword"],onFocusField:function(){return e.onFocusField("encryptedPassword")},errorMessage:e.encryptedPasswordState.errors&&r.get("creditCard.encryptedPassword.invalid"),isValid:e.encryptedPasswordState.valid,dir:"ltr",name:"encryptedPassword"},oc(ay,{encryptedFieldType:"encryptedPassword",className:Oc((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},t[Zf["adyen-checkout__input"]]=!0,t["adyen-checkout__input--error"]=e.encryptedPasswordState.errors,t["adyen-checkout__input--valid"]=e.encryptedPasswordState.valid,t["adyen-checkout__input--focus"]="encryptedPassword"===e.focusedElement,t))})))}function hy(e){var t=e.onChange,r=e.onInput,a=e.valid,n=void 0!==a&&a,o=e.error,i=void 0===o?null:o,s=e.data,l=void 0===s?"":s,d=lu().i18n;return oc(Ru,{label:""+d.get("boleto.socialSecurityNumber"),classNameModifiers:["socialSecurityNumber"],errorMessage:!!i,isValid:Boolean(n)},cp("text",{name:"socialSecurityNumber",autocorrect:"off",spellcheck:!1,value:l,maxLength:18,onInput:r,onChange:t}))}function fy(e){var t=e.storeDetails,r=void 0!==t&&t,n=a(e,["storeDetails"]),o=lu().i18n,i=Wc(r),s=i[0],l=i[1];return Zc((function(){n.onChange(s)}),[s]),oc("div",{className:"adyen-checkout__store-details"},cp("boolean",{onChange:function(e){l(e.target.checked)},label:o.get("storeDetails"),value:s,name:"storeDetails"}))}function yy(e){return e.replace(/[^0-9]/g,"").trim()}function by(e){if(void 0===e&&(e=""),"string"!=typeof e)return"";var t=yy(e);return t.length>11?function(e){return e.replace(/^(\d{2})(\d{3})(\d{3})?(\d{4})?(\d{1,2})?$/g,(function(e,t,r,a,n,o){return void 0===n&&(n=""),void 0===o&&(o=""),t+"."+r+"."+a+"/"+n+(o.length?"-"+o:"")}))}(t):function(e){return e.replace(/\W/gi,"").replace(/(\d{3})(?!$)/g,"$1.").replace(/(.{11}).(\d{1,2})$/g,"$1-$2")}(t)}function vy(e){return/(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e)}var gy={socialSecurityNumber:by},ky={socialSecurityNumber:[{modes:["blur"],validate:vy}],taxNumber:[{modes:["blur"],validate:function(e){return 6===(null==e?void 0:e.length)||10===(null==e?void 0:e.length)}}],holderName:[{modes:["blur"],validate:function(e){return(null==e?void 0:e.trim().length)>0}}],default:[{modes:["blur"],validate:function(e){return!!e&&"string"==typeof e&&e.trim().length>0}}]};function Cy(e,t,r){var a=t.sfp,n=r.dualBrandSelectElements,o=r.setDualBrandSelectElements,i=r.setSelectedBrandValue,s=r.issuingCountryCode,l=r.setIssuingCountryCode;return{processBinLookup:function(t,r){var n,s=(null==t?void 0:t.issuingCountryCode)?t.issuingCountryCode.toLowerCase():null;if(l(s),t&&Object.keys(t).length){if(null===(n=t.supportedBrands)||void 0===n?void 0:n.length){var d=t.supportedBrands;if(d.length>1){var c=(p=(u=d)[0],m=u[1],{dualBrandSelectElements:[{id:p.brand,brandObject:p},{id:m.brand,brandObject:m}],selectedBrandValue:"",leadBrand:p});o(c.dualBrandSelectElements),i(c.selectedBrandValue),a.current.processBinLookupResponse({issuingCountryCode:t.issuingCountryCode,supportedBrands:[c.leadBrand]})}else o([]),i(""),i(d[0].brand),a.current.processBinLookupResponse({issuingCountryCode:t.issuingCountryCode,supportedBrands:d})}var u,p,m}else{o([]),i("");var h=r&&"card"!==e.type?e.type:null;a.current.processBinLookupResponse(t,{brand:h,cvcPolicy:e.cvcPolicy})}},handleDualBrandSelection:function(e){var t=e;if(e instanceof Event){var r=e.target;t=r.getAttribute("data-value")||r.getAttribute("alt")}i(t);var o=n.reduce((function(e,r){return r.brandObject.brand===t&&e.push(r.brandObject),e}),[]);a.current.processBinLookupResponse({issuingCountryCode:s,supportedBrands:o})}}}function _y(e){var t=e.onChange,r=e.onInput,a=e.placeholder,n=e.value,o=e.required,i=e.error,s=void 0!==i&&i,l=e.isValid,d=lu().i18n;return oc(Ru,{label:d.get("creditCard.holderName"),className:"adyen-checkout__card__holderName",errorMessage:s&&d.get("creditCard.holderName.invalid"),isValid:!!l,name:"holderName"},cp("text",{className:"adyen-checkout__card__holderName__input "+Zf["adyen-checkout__input"],placeholder:a||d.get("creditCard.holderName.placeholder"),value:n,required:o,onChange:t,onInput:r}))}function Ny(e){var t,a,n=this,o=$c(null),s=$c(null),l=Wc("ready"),d=l[0],c=l[1],u=Wc({}),p=u[0],m=u[1],h=Wc(r({},e.holderNameRequired&&{holderName:!1})),f=h[0],y=h[1],b=Wc(r({},e.hasHolderName&&{holderName:null!==(t=e.data.holderName)&&void 0!==t?t:""})),v=b[0],g=b[1],k=Wc(""),C=k[0],_=k[1],N=Wc(!1),w=N[0],P=N[1],F=Wc(Sh),D=F[0],A=F[1],S=Wc(Fh),x=S[0],B=S[1],T=Wc(null),z=T[0],I=T[1],M=Wc([]),j=M[0],E=M[1],O=Wc(""),R=O[0],L=O[1],V=Wc(!1),U=V[0],K=V[1],H=Wc(e.billingAddressRequired?e.data.billingAddress:null),q=H[0],G=H[1],Y=Wc(!1),W=Y[0],J=Y[1],Z=Wc(""),Q=Z[0],$=Z[1],X=Wc({value:null}),ee=X[0],te=X[1],re=gp({schema:[],defaultData:e.data,formatters:gy,rules:ky}),ae=re.handleChangeFor,ne=re.triggerValidation,oe=re.data,ie=re.valid,se=re.errors,le=re.setSchema,de=re.setData,ce=re.setValid,ue=re.setErrors,pe=!!Object.keys(e.installmentOptions).length,me=null===(a=e.showInstallmentAmounts)||void 0===a||a,he="kr"===(null!=z?z:e.countryCode),fe=e.configuration.koreanAuthenticationRequired&&he,ye=W&&"auto"===e.configuration.socialSecurityNumberMode||"show"===e.configuration.socialSecurityNumberMode,be=function(e){K(e)},ve=function(e){te(e)},ge=function(e){de("billingAddress",e.data),ce("billingAddress",e.isValid),ue("billingAddress",e.errors)},ke=Xc((function(){return Cy(e,{sfp:o},{dualBrandSelectElements:j,setDualBrandSelectElements:E,setSelectedBrandValue:L,issuingCountryCode:z,setIssuingCountryCode:I})}),[j,z]);this.showValidation=function(){o.current.showValidation(),ne(),(null==s?void 0:s.current)&&s.current.showValidation()},this.processBinLookupResponse=function(e,t){ke.processBinLookup(e,t)},this.setStatus=c,Zc((function(){return n.setFocusOn=o.current.setFocusOn,n.updateStyles=o.current.updateStyles,n.handleUnsupportedCard=o.current.handleUnsupportedCard,function(){o.current.destroy()}}),[]),Zc((function(){var t=i(i(i(i([],e.hasHolderName?["holderName"]:[]),ye?["socialSecurityNumber"]:[]),fe?["taxNumber"]:[]),e.billingAddressRequired?["billingAddress"]:[]);le(t)}),[e.hasHolderName,ye,fe]),Zc((function(){var t;g(r(r({},v),{holderName:null!==(t=oe.holderName)&&void 0!==t?t:"",taxNumber:oe.taxNumber})),$(oe.socialSecurityNumber),e.billingAddressRequired&&G(r({},oe.billingAddress)),y(r(r({},f),{holderName:!e.holderNameRequired||ie.holderName,socialSecurityNumber:!!ie.socialSecurityNumber&&ie.socialSecurityNumber,taxNumber:!!ie.taxNumber&&ie.taxNumber,billingAddress:!!ie.billingAddress&&ie.billingAddress})),m(r(r({},p),{holderName:e.holderNameRequired&&se.holderName?se.holderName:null,socialSecurityNumber:ye&&se.socialSecurityNumber?se.socialSecurityNumber:null,taxNumber:fe&&se.taxNumber?se.taxNumber:null,billingAddress:e.billingAddressRequired&&se.billingAddress?se.billingAddress:null}))}),[oe,ie,se]),Zc((function(){var t=f.holderName,a=w,n=!e.billingAddressRequired||f.billingAddress,i=!fe||!!f.taxNumber&&!!f.encryptedPassword,s=!ye||!!f.socialSecurityNumber,l=a&&t&&n&&i&&s,d=o.current.mapErrorsToValidationRuleResult();e.onChange({data:v,valid:f,errors:r(r({},p),d),isValid:l,billingAddress:q,selectedBrandValue:R,storePaymentMethod:U,socialSecurityNumber:Q,installments:ee})}),[v,f,p,R,U,ee]);var Ce=oc(_y,{required:e.holderNameRequired,placeholder:e.placeholders.holderName,value:oe.holderName,error:!!se.holderName&&e.holderNameRequired,isValid:!!ie.holderName,onChange:ae("holderName","blur"),onInput:ae("holderName","input")}),_e=function(t){return oc(iy,{amount:e.amount,brand:t,installmentOptions:e.installmentOptions,onChange:ve,type:me?"amount":"months"})};return oc(Wf,r({ref:o},e,{styles:r(r({},Jf),e.styles),koreanAuthenticationRequired:e.configuration.koreanAuthenticationRequired,hasKoreanFields:!(!e.configuration.koreanAuthenticationRequired||"kr"!==e.countryCode),onChange:function(t){if(t.autoCompleteName){if(!e.hasHolderName)return;var a=(n="blur",ky["holderName"].reduce((function(e,t){return e.length||t.modes.includes(n)&&e.push(t.validate),e}),[])[0])(t.autoCompleteName)?t.autoCompleteName:null;a&&(de("holderName",a),ce("holderName",!0),ue("holderName",null))}else{var n;g(r(r({},v),t.data)),m(r(r({},p),t.errors)),y(r(r({},f),t.valid)),P(t.isSfpValid),B(t.cvcPolicy),J(t.showSocialSecurityNumber),A(t.expiryDatePolicy)}},onBrand:e.onBrand,onFocus:function(t){_(t.currentFocusObject),!0===t.focus?e.onFocus(t):e.onBlur(t)},type:e.brand,render:function(t,a){var o,i=t.setRootNode,l=t.setFocusOn;return oc("div",{ref:i,className:"adyen-checkout__card-input "+Zf["card-input__wrapper"]+" adyen-checkout__card-input--"+(null!==(o=e.fundingSource)&&void 0!==o?o:"credit")},e.storedPaymentMethodId?oc(ty,{status:a.status},oc(oy,r({},e,{errors:a.errors,brand:a.brand,hasCVC:e.hasCVC,cvcPolicy:x,onFocusField:l,focusedElement:C,status:a.status,valid:a.valid})),pe&&_e(a.brand)):oc(ty,{status:a.status},e.hasHolderName&&e.positionHolderNameOnTop&&Ce,oc(py,r({},e,{brand:a.brand,brandsConfiguration:n.props.brandsConfiguration,focusedElement:C,onFocusField:l,hasCVC:e.hasCVC,cvcPolicy:x,expiryDatePolicy:D,errors:a.errors,valid:a.valid,dualBrandingElements:j.length>0&&j,dualBrandingChangeHandler:ke.handleDualBrandSelection,dualBrandingSelected:R})),e.hasHolderName&&!e.positionHolderNameOnTop&&Ce,fe&&oc(my,{onFocusField:l,focusedElement:C,encryptedPasswordState:{data:a.encryptedPassword,valid:!!a.valid&&a.valid.encryptedPassword,errors:!!a.errors&&a.errors.encryptedPassword},value:v.taxNumber,error:!!p.taxNumber,isValid:!!f.taxNumber,onChange:ae("taxNumber","blur"),onInput:ae("taxNumber","input")}),ye&&oc("div",{className:"adyen-checkout__card__socialSecurityNumber"},oc(hy,{onChange:ae("socialSecurityNumber","blur"),onInput:ae("socialSecurityNumber","input"),error:null==p?void 0:p.socialSecurityNumber,valid:null==f?void 0:f.socialSecurityNumber,data:Q})),e.enableStoreDetails&&oc(fy,{onChange:be}),pe&&_e(a.brand),e.billingAddressRequired&&oc(Nm,{label:"billingAddress",data:q,onChange:ge,allowedCountries:e.billingAddressAllowedCountries,requiredFields:e.billingAddressRequiredFields,ref:s})),e.showPayButton&&e.payButton({status:d,icon:zc({loadingContext:e.loadingContext,imageFolder:"components/"})("lock")}))}}))}Ny.defaultProps={details:[],type:"card",hasHolderName:!1,holderNameRequired:!1,enableStoreDetails:!1,hideCVC:!1,hasCVC:!0,hasStoreDetails:!1,storedDetails:null,showBrandIcon:!0,positionHolderNameOnTop:!1,billingAddressRequired:!1,billingAddressRequiredFields:["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],installmentOptions:{},configuration:{koreanAuthenticationRequired:!1,socialSecurityNumberMode:"auto"},onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},data:{billingAddress:{}},styles:{},placeholders:{}};var wy=function(e){return function(t){return t.brand===e}},Py=function(e){return e.brand.includes("plcc")||e.brand.includes("cbcc")},Fy=function(e){var t=null;return function(a){if(!1!==e.props.doBinLookup){if(a.encryptedBin&&e.props.clientKey)t=a.uuid,bm({loadingContext:e.props.loadingContext,path:"v2/bin/binLookup?token="+e.props.clientKey},{supportedBrands:e.props.brands||Ch,encryptedBin:a.encryptedBin,requestId:a.uuid}).then((function(n){var o;if((null==n?void 0:n.requestId)===t)if(null===(o=n.brands)||void 0===o?void 0:o.length){var i=(2===n.brands.length?function(e,t){var a=e.map((function(e){return r({},e)})),n=a.some(wy("bcmc")),o=a.some(wy("maestro")),i=a.some(wy("visa")),s=a.some(wy("cartebancaire")),l=a.some(Py);return"bcmc"===t&&n&&"bcmc"!==a[0].brand&&a.reverse(),"bcmc"===t&&n&&o&&(a[1].cvcPolicy=Ah),"card"===t&&i&&s&&"visa"!==a[0].brand&&a.reverse(),"card"===t&&l&&(a[0].brand.includes("plcc")||a[0].brand.includes("cbcc")||a.reverse()),a}(n.brands,e.props.type):n.brands).reduce((function(e,t){return e.detectedBrands.push(t.brand),!0===t.supported?(e.supportedBrands.push(t),e):e}),{supportedBrands:[],detectedBrands:[]});if(i.supportedBrands.length)return e.processBinLookupResponse(r({issuingCountryCode:n.issuingCountryCode,supportedBrands:i.supportedBrands},n.showSocialSecurityNumber?{showSocialSecurityNumber:n.showSocialSecurityNumber}:{})),void e.onBinLookup({type:a.type,detectedBrands:i.detectedBrands,supportedBrands:i.supportedBrands.map((function(e){return e.brand})),supportedBrandsRaw:i.supportedBrands,brands:e.props.brands||Ch});if(i.detectedBrands.length){var s={type:"card",fieldType:"encryptedCardNumber",error:bf(Mu),detectedBrands:i.detectedBrands};return e.handleUnsupportedCard(s),void e.onBinLookup({type:a.type,detectedBrands:i.detectedBrands,supportedBrands:null,brands:e.props.brands||Ch})}}else e.onBinLookup({type:a.type,detectedBrands:null,supportedBrands:null,brands:e.props.brands||Ch}),e.processBinLookupResponse({},!0);else(null==n?void 0:n.requestId)||e.props.onError(n||{errorType:"binLookup",message:"unknownError"})}));else if(t){e.processBinLookupResponse(null,!0),t=null;e.handleUnsupportedCard({type:"card",fieldType:"encryptedCardNumber",error:""}),e.onBinLookup({isReset:!0})}e.props.onBinValue&&e.props.onBinValue(a)}else e.props.onBinValue&&e.props.onBinValue(a)}},Dy=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.onBrand=function(e){t.eventEmitter.emit("brand",r(r({},e),{brand:"card"===e.brand?null:e.brand})),t.props.onBrand&&t.props.onBrand(e)},t.onBinValue=Fy(t),t}return t(a,e),a.prototype.formatProps=function(e){var t,a,n,o;return r(r(r(r({},e),{holderNameRequired:!!e.hasHolderName&&e.holderNameRequired,hasCVC:!(e.brand&&"bcmc"===e.brand||e.hideCVC),billingAddressRequired:!e.storedPaymentMethodId&&e.billingAddressRequired}),e.brands&&!e.groupTypes&&{groupTypes:e.brands}),{type:"scheme"===e.type?"card":e.type,countryCode:e.countryCode?e.countryCode.toLowerCase():null,configuration:r(r({},e.configuration),{socialSecurityNumberMode:null!==(a=null===(t=e.configuration)||void 0===t?void 0:t.socialSecurityNumberMode)&&void 0!==a?a:"auto"}),brandsConfiguration:e.brandsConfiguration||(null===(n=e.configuration)||void 0===n?void 0:n.brandsConfiguration)||{},icon:e.icon||(null===(o=e.configuration)||void 0===o?void 0:o.icon)})},a.prototype.formatData=function(){var e=this.state.selectedBrandValue||this.props.brand,t=this.props.enableStoreDetails&&void 0!==this.state.storePaymentMethod;return r(r(r(r(r({paymentMethod:r(r(r(r({type:a.type},this.state.data),this.props.storedPaymentMethodId&&{storedPaymentMethodId:this.props.storedPaymentMethodId}),e&&{brand:e}),this.props.fundingSource&&{fundingSource:this.props.fundingSource})},this.state.billingAddress&&{billingAddress:this.state.billingAddress}),this.state.socialSecurityNumber&&{socialSecurityNumber:this.state.socialSecurityNumber}),t&&{storePaymentMethod:Boolean(this.state.storePaymentMethod)}),this.state.installments&&this.state.installments.value&&{installments:this.state.installments}),{browserInfo:this.browserInfo,origin:!!window&&window.location.origin})},a.prototype.updateStyles=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.updateStyles)&&this.componentRef.updateStyles(e),this},a.prototype.setFocusOn=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.setFocusOn)&&this.componentRef.setFocusOn(e),this},a.prototype.processBinLookupResponse=function(e,t){var r;return void 0===t&&(t=!1),(null===(r=this.componentRef)||void 0===r?void 0:r.processBinLookupResponse)&&this.componentRef.processBinLookupResponse(e,t),this},a.prototype.handleUnsupportedCard=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.handleUnsupportedCard)&&this.componentRef.handleUnsupportedCard(e),this},a.prototype.onBinLookup=function(e){if(!e.isReset){var t=Lh("supportedBrandsRaw").from(e);this.props.onBinLookup(t)}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"icon",{get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:zc({loadingContext:this.props.loadingContext})(this.brand)},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"brands",{get:function(){var e=this.props,t=e.brands,r=e.loadingContext,a=e.brandsConfiguration;return t?t.map((function(e){var t,n;return{icon:null!==(n=null===(t=a[e])||void 0===t?void 0:t.icon)&&void 0!==n?n:zc({loadingContext:r})(e),name:e}})):[]},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"brand",{get:function(){return this.props.brand||this.props.type},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"displayName",{get:function(){return this.props.storedPaymentMethodId?"\u2022\u2022\u2022\u2022 "+this.props.lastFour:this.props.name||a.type},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"accessibleName",{get:function(){return(this.props.name||a.type)+(this.props.storedPaymentMethodId?" "+this.props.i18n.get("creditCard.storedCard.description.ariaLabel").replace("%@",this.props.lastFour):"")},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"browserInfo",{get:function(){return Im()},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Ny,r({ref:function(t){e.componentRef=t}},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton,onBrand:this.onBrand,onBinValue:this.onBinValue,brand:this.brand})))},a.type="scheme",a.defaultProps={onBinLookup:function(){}},a}(hu),Ay=function(e){function a(t){var r=e.call(this,t)||this;return r.onBrand=function(e){r.props.onBrand&&r.props.onBrand(e)},r}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{type:"bcmc",cvcPolicy:Ah})},a.defaultProps=r(r({},Dy.defaultProps),{brands:["bcmc","maestro","visa"]}),a}(Dy);function Sy(e){var t=e.description,r=void 0===t?"":t,a=e.name,n=void 0===a?"":a,o=e.logoUrl,i=void 0===o?"":o,s=e.url,l=void 0===s?"":s,d=e.backgroundUrl,c=void 0===d?"":d;return oc("div",{className:"adyen-checkout__campaign-container"},oc(ap,{className:"adyen-checkout__campaign-background-image",style:{backgroundImage:"linear-gradient(0, #000, #0003), url("+c+")"},backgroundUrl:c}),oc("div",{className:"adyen-checkout__campaign-content"},i&&oc("img",{src:i,className:"adyen-checkout__campaign-logo",alt:n}),n&&oc("div",{className:"adyen-checkout__campaign-title"},n),r&&oc("div",{className:"adyen-checkout__campaign-description"},r,l&&" \u203a")))}function xy(e){var t=e.url;return oc("div",{className:"adyen-checkout__campaign"},!t&&oc(Sy,r({},e)),t&&oc("a",{href:t,className:"adyen-checkout__campaign-link",target:"_blank",rel:"noopener noreferrer"},oc(Sy,r({},e))))}var By=function(e){var t=e.options,r=void 0===t?[]:t,a=e.name,n=e.onChange;return oc("div",{className:"adyen-checkout__button-group"},r.map((function(e,t){var r=e.label,o=e.selected,i=e.value,s=e.disabled;return oc("label",{key:""+a+t,className:Oc({"adyen-checkout__button":!0,"adyen-checkout__button--selected":o,"adyen-checkout__button--disabled":s})},oc("input",{type:"radio",className:"adyen-checkout__button-group__input",value:i,checked:o,onChange:n,disabled:s}),oc("span",{className:"adyen-checkout__button-text"},r))})))};function Ty(e){var t=e.amounts,a=e.onCancel,n=e.onDonate,o=e.showCancelButton,i=void 0===o||o,s=lu(),l=s.i18n,d=s.loadingContext,c=t.currency,u=Wc("ready"),p=u[0],m=u[1],h=Wc(!1),f=h[0],y=h[1],b=Wc({currency:c,value:null}),v=b[0],g=b[1];this.setStatus=function(e){m(e)};var k=function(e,t){return l.amount(e,t,{minimumFractionDigits:0,maximumFractionDigits:0})};return Zc((function(){e.onChange({data:{amount:v},isValid:f})}),[v,f]),"error"===p?oc("div",{className:"adyen-checkout__adyen-giving"},oc(ap,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--error",src:zc({loadingContext:d,imageFolder:"components/"})("error"),alt:l.get("error.message.unknown")}),oc("div",{className:"adyen-checkout__status__text"},l.get("error.message.unknown"))):"success"===p?oc("div",{className:"adyen-checkout__adyen-giving"},oc(ap,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--success",src:zc({loadingContext:d,imageFolder:"components/"})("heart"),alt:l.get("thanksForYourSupport")}),oc("div",{className:"adyen-checkout__status__text"},l.get("thanksForYourSupport"))):oc("div",{className:"adyen-checkout__adyen-giving"},oc(xy,r({},e)),oc("div",{className:"adyen-checkout__adyen-giving-actions"},oc("div",{className:"adyen-checkout__amounts"},oc(By,{options:t.values.map((function(e){return{value:e,label:k(e,c),disabled:"loading"===p,selected:e===v.value}})),name:"amount",onChange:function(e){var t=e.target,a=parseInt(t.value,10);y(!0),g((function(e){return r(r({},e),{value:a})}))}})),oc(du,{classNameModifiers:["donate"],onClick:function(){m("loading"),n({data:{amount:v}})},label:l.get("donateButton"),disabled:!v.value,status:p}),i&&oc(du,{classNameModifiers:["ghost","decline"],onClick:function(){m("loading"),a({data:{amount:v},isValid:f})},disabled:"loading"===p,label:l.get("notNowButton")+" \u203a"})))}Ty.defaultProps={onCancel:function(){},onChange:function(){},onDonate:function(){},amounts:{},showCancelButton:!0};var zy=function(e){function a(t){var r=e.call(this,t)||this;return r.handleRef=function(e){r.componentRef=e},r.donate=r.donate.bind(r),r}return t(a,e),Object.defineProperty(a.prototype,"data",{get:function(){return this.state.data},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"isValid",{get:function(){return this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.setState=function(e){this.state=r(r({},this.state),e)},a.prototype.donate=function(){var e=this.data,t=this.isValid;this.props.onDonate({data:e,isValid:t},this)},a.prototype.render=function(){return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Ty,r({},this.props,{ref:this.handleRef,onChange:this.setState,onDonate:this.donate})))},a.type="donation",a.defaultProps={onCancel:function(){},onDonate:function(){}},a}(hu),Iy=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.componentDidMount=function(){var e=this;new Promise((function(t,a){return e.props.beforeRedirect(t,a,r({url:e.props.url,method:e.props.method},e.props.data?{data:e.props.data}:{}))})).then((function(){e.postForm?e.postForm.submit():window.location.assign(e.props.url)})).catch((function(){}))},a.prototype.render=function(e){var t=this,r=e.url,a=e.method,n=e.data,o=void 0===n?{}:n;return"POST"===a?oc("form",{method:"post",action:r,style:{display:"none"},ref:function(e){t.postForm=e}},Object.keys(o).map((function(e){return oc("input",{type:"hidden",name:e,key:e,value:o[e]})}))):null},a.defaultProps={beforeRedirect:function(e){return e()},method:"GET"},a}(lc);function My(e){var t=e.payButton,n=e.onSubmit,o=e.amount,i=void 0===o?null:o,s=e.name,l=a(e,["payButton","onSubmit","amount","name"]),d=lu().i18n,c=Wc("ready"),u=c[0],p=c[1];this.setStatus=function(e){p(e)};return oc(sc,null,t(r(r({},l),{status:u,classNameModifiers:["standalone"],label:i&&{}.hasOwnProperty.call(i,"value")&&0===i.value?d.get("preauthorizeWith")+" "+s:d.get("continueTo")+" "+s,onClick:n})))}var jy=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(e){return r(r({},e),{showButton:!!e.showPayButton})},a.prototype.formatData=function(){return{paymentMethod:{type:this.props.type}}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"icon",{get:function(){return zc({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return this.props.url&&this.props.method?oc(Iy,r({},this.props)):this.props.showButton?oc(Am,r({},this.props,{loadingContext:this.props.loadingContext}),oc(My,r({},this.props,{onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null},a.type="redirect",a.defaultProps={type:a.type,showPayButton:!0},a}(hu),Ey=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(e){var t;return r(r({},e),{showPayButton:null!==(t=e.showButton)&&void 0!==t?t:e.showPayButton})},a.prototype.formatData=function(){return{paymentMethod:{type:a.type}}},Object.defineProperty(a.prototype,"displayName",{get:function(){return this.props.name||this.constructor.type},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return this.props.showPayButton?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(My,r({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null},a.type="giropay",a}(jy),Oy=2,Ry=0,Ly="adyen",Vy="https://pay.google.com/gp/p/js/pay.js";function Uy(e){var t=e.amount,n=e.countryCode,o=void 0===n?"US":n,i=e.totalPriceStatus,s=void 0===i?"FINAL":i,l=a(e,["amount","countryCode","totalPriceStatus"]),d=String($d(t.value,t.currency));return r({countryCode:o,currencyCode:t.currency,totalPrice:d,totalPriceStatus:s},l.transactionInfo)}function Ky(e){var t=e.configuration,n=a(e,["configuration"]);return{apiVersion:Oy,apiVersionMinor:Ry,transactionInfo:Uy(n),merchantInfo:r({merchantId:t.merchantId,merchantName:t.merchantName},t.merchantOrigin?{merchantOrigin:t.merchantOrigin}:{}),allowedPaymentMethods:[{type:"CARD",tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{gateway:Ly,gatewayMerchantId:t.gatewayMerchantId}},parameters:{allowedAuthMethods:n.allowedAuthMethods,allowedCardNetworks:n.allowedCardNetworks,allowPrepaidCards:n.allowPrepaidCards,allowCreditCards:n.allowCreditCards,billingAddressRequired:n.billingAddressRequired,billingAddressParameters:n.billingAddressParameters}}],emailRequired:n.emailRequired,shippingAddressRequired:n.shippingAddressRequired,shippingAddressParameters:n.shippingAddressParameters,shippingOptionRequired:n.shippingOptionRequired,shippingOptionParameters:n.shippingOptionParameters,callbackIntents:n.callbackIntents}}var Hy=["en","ar","bg","ca","cs","da","de","el","es","et","fi","fr","hr","id","it","ja","ko","ms","nl","no","pl","pt","ru","sk","sl","sr","sv","th","tr","uk","zh"];var qy=function(){function e(e){var t=function(e){switch(void 0===e&&(e="TEST"),e.toLowerCase()){case"production":case"live":return"PRODUCTION";default:return"TEST"}}(e.environment);this.paymentsClient=this.getGooglePaymentsClient({environment:t,paymentDataCallbacks:e.paymentDataCallbacks})}return e.prototype.getGooglePaymentsClient=function(e){var t;return n(this,void 0,void 0,(function(){return o(this,(function(r){switch(r.label){case 0:return(null===(t=window.google)||void 0===t?void 0:t.payments)?[3,2]:[4,new Gm(Vy).load()];case 1:r.sent(),r.label=2;case 2:return[2,new google.payments.api.PaymentsClient(e)]}}))}))},e.prototype.isReadyToPay=function(e){return this.paymentsClient?this.paymentsClient.then((function(t){return t.isReadyToPay(function(e){var t=e.allowedAuthMethods,r=e.allowedCardNetworks,a=e.existingPaymentMethodRequired;return{apiVersion:Oy,apiVersionMinor:Ry,allowedPaymentMethods:[{type:"CARD",parameters:{allowedAuthMethods:t,allowedCardNetworks:r},tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{}}}],existingPaymentMethodRequired:void 0!==a&&a}}(e))})):Promise.reject(new Error("Google Pay is not available"))},e.prototype.prefetchPaymentData=function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=Ky(e);this.paymentsClient.then((function(e){return e.prefetchPaymentData(t)}))},e.prototype.initiatePayment=function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=Ky(e);return this.paymentsClient.then((function(e){return e.loadPaymentData(t)}))},e}(),Gy=function(e){function r(){var t=null!==e&&e.apply(this,arguments)||this;return t.clicked=!1,t.handleClick=function(e){e.preventDefault(),e.stopPropagation(),t.clicked||(t.props.onClick(e),t.clicked=!0,setTimeout((function(){t.clicked=!1}),300))},t}return t(r,e),r.prototype.componentDidMount=function(){var e=this,t=this.props,r=t.buttonColor,a=t.buttonType,n=t.buttonLocale,o=t.buttonSizeMode;t.paymentsClient.then((function(t){return t.createButton({onClick:e.handleClick,buttonType:a,buttonColor:r,buttonLocale:n,buttonSizeMode:o})})).then((function(t){e.paywithgoogleWrapper.appendChild(t)}))},r.prototype.render=function(){var e=this;return oc("span",{className:"adyen-checkout__paywithgoogle",ref:function(t){e.paywithgoogleWrapper=t}})},r.defaultProps={buttonColor:"default",buttonType:"long",buttonSizeMode:"static"},r}(lc),Yy={environment:"TEST",existingPaymentMethodRequired:!1,buttonColor:"default",buttonType:"long",buttonSizeMode:void 0,showPayButton:!0,configuration:{gatewayMerchantId:"",merchantId:"",merchantName:""},amount:{value:0,currency:"USD"},countryCode:"US",totalPriceStatus:"FINAL",onAuthorized:function(e){return e},onClick:function(e){return e()},allowedAuthMethods:["PAN_ONLY","CRYPTOGRAM_3DS"],allowedCardNetworks:["AMEX","DISCOVER","JCB","MASTERCARD","VISA"],allowCreditCards:!0,allowPrepaidCards:!0,billingAddressRequired:!1,billingAddressParameters:void 0,emailRequired:!1,shippingAddressRequired:!1,shippingAddressParameters:void 0,shippingOptionRequired:!1,shippingOptionParameters:void 0,paymentMethods:[]},Wy=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.googlePay=new qy(t.props),t.submit=function(){var e=t.props.onAuthorized,r=void 0===e?function(){}:e;return new Promise((function(e,r){return t.props.onClick(e,r)})).then((function(){return t.googlePay.initiatePayment(t.props)})).then((function(e){return t.setState({googlePayToken:e.paymentMethodData.tokenizationData.token,googlePayCardNetwork:e.paymentMethodData.info.cardNetwork}),t.onSubmit(),r(e)})).catch((function(e){return t.handleError(new mu("ERROR",e.toString())),Promise.reject(e)}))},t.isAvailable=function(){return t.isReadyToPay().then((function(e){if(!e.result)throw new Error("Google Pay is not available");if(!1===e.paymentMethodPresent)throw new Error("Google Pay - No paymentMethodPresent");return!0})).catch((function(){return!1}))},t.isReadyToPay=function(){return t.googlePay.isReadyToPay(t.props)},t.prefetch=function(){return t.googlePay.prefetchPaymentData(t.props)},t}return t(a,e),a.prototype.formatProps=function(e){var t,a,n,o,i,s,l=(null===(t=e.brands)||void 0===t?void 0:t.length)?(i=e.brands,s={mc:"MASTERCARD",amex:"AMEX",visa:"VISA",interac:"INTERAC",discover:"DISCOVER"},i.reduce((function(e,t){return s[t]&&!e.includes(s[t])&&e.push(s[t]),e}),[])):e.allowedCardNetworks,d=null!==(a=e.buttonSizeMode)&&void 0!==a?a:e.isDropin?"fill":"static",c=function(e){void 0===e&&(e="");var t=e.toLowerCase().substring(0,2);return Hy.includes(t)?t:null}(null!==(n=e.buttonLocale)&&void 0!==n?n:null===(o=e.i18n)||void 0===o?void 0:o.locale);return r(r({},e),{showButton:!0===e.showPayButton,configuration:e.configuration,allowedCardNetworks:l,buttonSizeMode:d,buttonLocale:c})},a.prototype.formatData=function(){var e;return{paymentMethod:r({type:null!==(e=this.props.type)&&void 0!==e?e:a.type},this.state),browserInfo:this.browserInfo}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.googlePayToken},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"browserInfo",{get:function(){return Im()},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"icon",{get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:zc({loadingContext:this.props.loadingContext})("googlepay")},enumerable:!1,configurable:!0}),a.prototype.render=function(){return this.props.showPayButton?oc(Gy,{buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,buttonSizeMode:this.props.buttonSizeMode,buttonLocale:this.props.buttonLocale,paymentsClient:this.googlePay.paymentsClient,onClick:this.submit}):null},a.type="paywithgoogle",a.defaultProps=Yy,a}(hu),Jy=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="entercash",r}(uh),Zy={telephoneNumber:[{validate:function(e){return!!e&&e.length<=11},errorMessage:"voucher.econtext.telephoneNumber.invalid",modes:["input","blur"]},{validate:function(e){return!!e&&pp.test(e)&&(10===e.length||11===e.length)},errorMessage:"voucher.econtext.telephoneNumber.invalid",modes:["blur"]}]};function Qy(e){var t=e.personalDetailsRequired,r=void 0===t||t,a=e.data,n=e.onChange,o=e.showPayButton,i=e.payButton,s=$c(null),l=lu().i18n,d=Wc("ready"),c=d[0],u=d[1];return this.setStatus=u,this.showValidation=function(){s.current&&s.current.showValidation()},oc("div",{className:"adyen-checkout__econtext-input__field"},!!r&&oc(Tp,{data:a,requiredFields:["firstName","lastName","telephoneNumber","shopperEmail"],onChange:n,namePrefix:"econtext",ref:s,validationRules:Zy}),o&&i({status:c,label:l.get("confirmPurchase")}))}function $y(e){var t,r,a=(t=e,(r=document.createElement("textArea")).readOnly=!0,r.value=t,document.body.appendChild(r),r);if(window.navigator.userAgent.match(/ipad|iphone/i)){var n=document.createRange();n.selectNodeContents(a);var o=window.getSelection();o.removeAllRanges(),o.addRange(n),a.setSelectionRange(0,999999)}else a.select();document.execCommand("copy"),document.body.removeChild(a)}function Xy(e){var t=e.voucherDetails,r=void 0===t?[]:t,n=e.className,o=void 0===n?"":n,i=a(e,["voucherDetails","className"]),s=lu(),l=s.i18n,d=s.loadingContext;return oc("div",{className:Oc("adyen-checkout__voucher-result","adyen-checkout__voucher-result--"+i.paymentMethodType,o)},oc("div",{className:"adyen-checkout__voucher-result__top"},oc("div",{className:"adyen-checkout__voucher-result__image"},!!i.imageUrl&&oc("span",{className:"adyen-checkout__voucher-result__image__wrapper"},oc("img",{alt:i.paymentMethodType,className:"adyen-checkout__voucher-result__image__brand",src:i.imageUrl})),!!i.issuerImageUrl&&oc("span",{className:"adyen-checkout__voucher-result__image__wrapper"},oc("img",{alt:i.paymentMethodType,className:"adyen-checkout__voucher-result__image__issuer",src:i.issuerImageUrl}))),oc("div",{className:"adyen-checkout__voucher-result__introduction"},i.introduction," ",i.instructionsUrl&&oc("a",{className:"adyen-checkout__link adyen-checkout__link--voucher-result-instructions",href:i.instructionsUrl,target:"_blank",rel:"noopener noreferrer"},l.get("voucher.readInstructions")," \u203a")),i.amount&&oc("div",{className:"adyen-checkout__voucher-result__amount"},i.amount,i.surcharge&&oc("span",{className:"adyen-checkout__voucher-result__surcharge"},"(",l.get("voucher.surcharge").replace("%@",i.surcharge),")"))),i.reference&&oc("div",{className:"adyen-checkout__voucher-result__separator"},oc("div",{className:"adyen-checkout__voucher-result__separator__inner"}),oc("div",{className:"adyen-checkout__voucher-result__code__label"},oc("span",{className:"adyen-checkout__voucher-result__code__label__text"},l.get("voucher.paymentReferenceLabel")))),oc("div",{className:"adyen-checkout__voucher-result__bottom"},i.reference&&oc("div",{className:"adyen-checkout__voucher-result__code"},i.barcode&&oc("img",{alt:l.get("voucher.paymentReferenceLabel"),className:"adyen-checkout__voucher-result__code__barcode",src:i.barcode}),oc("span",null,i.reference)),(!!i.downloadUrl||!!i.copyBtn)&&oc("ul",{className:"adyen-checkout__voucher-result__actions"},!!i.copyBtn&&oc("li",{className:"adyen-checkout__voucher-result__actions__item"},oc(du,{inline:!0,secondary:!0,onClick:function(e,t){var r=t.complete;$y(i.reference),r()},icon:zc({loadingContext:d,imageFolder:"components/"})("copy"),label:l.get("button.copy")})),!!i.downloadUrl&&oc("li",{className:"adyen-checkout__voucher-result__actions__item"},oc(du,{inline:!0,secondary:!0,href:i.downloadUrl,icon:zc({loadingContext:d,imageFolder:"components/"})("download"),label:i.downloadButtonText||l.get("button.download"),target:"_blank",rel:"noopener noreferrer"}))),oc("ul",{className:"adyen-checkout__voucher-result__details"},r.filter((function(e){var t=e.label,r=e.value;return!!t&&!!r})).map((function(e,t){var r=e.label,a=e.value;return oc("li",{key:t,className:"adyen-checkout__voucher-result__details__item"},oc("span",{className:"adyen-checkout__voucher-result__details__label"},r),oc("span",{className:"adyen-checkout__voucher-result__details__value"},a))})))))}var eb=function(e){var t=e.reference,r=e.totalAmount,a=e.expiresAt,n=e.paymentMethodType,o=e.maskedTelephoneNumber,i=e.instructionsUrl,s=e.collectionInstitutionNumber,l=lu(),d=l.loadingContext,c=l.i18n;return oc(Xy,{paymentMethodType:n,reference:t,introduction:c.get("voucher.introduction.econtext"),imageUrl:zc({loadingContext:d})(n),instructionsUrl:i,amount:r&&c.amount(r.value,r.currency),voucherDetails:[{label:c.get("voucher.collectionInstitutionNumber"),value:s},{label:c.get("voucher.expirationDate"),value:c.date(a)},{label:c.get("voucher.telephoneNumber"),value:o}],copyBtn:!0})},tb=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!this.props.personalDetailsRequired||!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatData=function(){return r(r({},this.state.data),{paymentMethod:{type:this.props.type||a.type}})},Object.defineProperty(a.prototype,"icon",{get:function(){return zc({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?oc(eb,r({ref:function(t){e.componentRef=t}},this.props)):oc(Qy,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="econtext",a.defaultProps={personalDetailsRequired:!0},a}(hu),rb=["ES","FR"],ab=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:rb})},a.type="facilypay_3x",a}(Sm),nb=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:rb})},a.type="facilypay_4x",a}(Sm),ob=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:rb})},a.type="facilypay_6x",a}(Sm),ib=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:rb})},a.type="facilypay_10x",a}(Sm),sb=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:rb})},a.type="facilypay_12x",a}(Sm),lb=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="ideal",r}(uh),db=["black","white"],cb=["en_US","en_AU","en_GB","fr_CA","es_ES","it_IT","fr_FR","de_DE","pt_BR","zh_CN","da_DK","zh_HK","id_ID","he_IL","ja_JP","ko_KR","nl_NL","no_NO","pl_PL","pt_PT","ru_RU","sv_SE","th_TH","zh_TW"],ub=function(e,t){return void 0===t&&(t={}),"paypal"===e?r({},t):Object.keys(t).reduce((function(e,r){var a=t[r];return("color"!==r||db.includes(a))&&(e[r]=a),e}),{})},pb=function(e){var t=e.amount,a=e.countryCode,n=e.debug,o=e.environment,i=void 0===o?"":o,s=e.locale,l=e.configuration,d=e.commit,c=e.vault,u=function(e){var t=e?e.replace("-","_"):null;return cb.includes(t)?t:null}(s),p=t?t.currency:null,m="test"===i.toLowerCase(),h=m?"AVzsPoGmjcm99YG02kq0iWL3KP3JedbMQJO2QUnVUc-t7aUzjkBWte7relkAC5SPUL50ovLGKmxfA674":"AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477",f=l.merchantId,y=l.intent;return r(r(r(r(r(r(r({},f&&{"merchant-id":f}),u&&{locale:u}),a&&m&&{"buyer-country":a}),n&&m&&{debug:n}),p&&{currency:p}),y&&{intent:y}),{commit:d,vault:c,"client-id":h,"integration-date":"2020-02-01",components:"buttons,funding-eligibility"})};function mb(e){var t=e.onInit,r=e.onComplete,a=e.onClick,n=e.onCancel,o=e.onError,i=e.onShippingChange,s=e.onSubmit,l=e.paypalRef,d=e.style,c=$c(null),u=$c(null),p=function(e,c){var u=l.Buttons({fundingSource:e,style:ub(e,d),onInit:t,onClick:a,onCancel:n,onError:o,onShippingChange:i,createOrder:s,onApprove:r});u.isEligible()&&u.render(c.current)};return Zc((function(){var t=l.FUNDING,r=t.PAYPAL,a=t.CREDIT;p(r,c),e.blockPayPalCreditButton||p(a,u)}),[]),oc("div",{className:"adyen-checkout__paypal__buttons"},oc("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--paypal",ref:c}),oc("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--credit",ref:u}))}function hb(e){var t=lu().i18n,a=Wc("pending"),n=a[0],o=a[1];this.setStatus=o;var i=function(){o("ready")};return Zc((function(){var t=function(e){var t=pb(e);return"https://www.paypal.com/sdk/js?"+decodeURIComponent(Object.keys(t).map((function(e){return e+"="+t[e]})).join("&"))}(e),a=r({},e.cspNonce&&{nonce:e.cspNonce}),n=r({},e.cspNonce&&{cspNonce:e.cspNonce}),o=new Gm(t,"body",a,n);return window.paypal?i():o.load().then(i),function(){o.remove()}}),[]),oc("div",{className:"adyen-checkout__paypal"},"pending"===n?oc("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--pending"},oc(Rc,null)):"processing"===n?oc("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--processing"},oc(Rc,{size:"medium",inline:!0})," ",t.get("paypal.processingPayment")):oc(mb,r({},e,{onComplete:function(t){o("processing"),e.onComplete(t)},paypalRef:window.paypal})))}var fb={environment:"TEST",status:"loading",showPayButton:!0,merchantId:"",cspNonce:null,intent:null,commit:!0,vault:!1,style:{height:48},blockPayPalCreditButton:!1,configuration:{merchantId:"",intent:null},onAdditionalDetails:function(){},onInit:function(){},onClick:function(){},onCancel:function(){},onError:function(){},onShippingChange:function(){}},yb="No token was provided",bb="Calling submit() is not supported for this payment method",vb="The instance of the PayPal component being used is not the same which started the payment",gb=function(e){function a(t){var r=e.call(this,t)||this;return r.paymentData=null,r.resolve=null,r.reject=null,r.handleAction=r.handleAction.bind(r),r.updateWithAction=r.updateWithAction.bind(r),r.handleCancel=r.handleCancel.bind(r),r.handleComplete=r.handleComplete.bind(r),r.handleSubmit=r.handleSubmit.bind(r),r.submit=r.submit.bind(r),r}return t(a,e),a.prototype.formatData=function(){return{paymentMethod:{type:a.type,subtype:a.subtype}}},a.prototype.handleAction=function(e){return this.updateWithAction(e)},a.prototype.updateWithAction=function(e){if(e.paymentMethodType!==this.data.paymentMethod.type)throw new Error("Invalid Action");return e.paymentData&&(this.paymentData=e.paymentData),e.sdkData&&e.sdkData.token?this.handleResolve(e.sdkData.token):this.handleReject(yb),null},Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),a.prototype.handleCancel=function(){this.handleError(new mu("CANCEL"))},a.prototype.handleComplete=function(e){var t={data:{details:e,paymentData:this.paymentData}};this.handleAdditionalDetails(t)},a.prototype.handleResolve=function(e){if(!this.resolve)return this.handleError(new mu("ERROR",vb));this.resolve(e)},a.prototype.handleReject=function(e){if(!this.reject)return this.handleError(new mu("ERROR",vb));this.reject(new Error(e))},a.prototype.startPayment=function(){return Promise.reject(new mu("ERROR",bb))},a.prototype.handleSubmit=function(){var e=this;return this.onSubmit(),new Promise((function(t,r){e.resolve=t,e.reject=r}))},a.prototype.submit=function(){this.handleError(new mu("IMPLEMENTATION_ERROR",bb))},a.prototype.render=function(){var e=this;return this.props.showPayButton?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(hb,r({ref:function(t){e.componentRef=t}},this.props,{onCancel:this.handleCancel,onChange:this.setState,onComplete:this.handleComplete,onError:function(t){e.handleError(new mu("ERROR",t.toString()))},onSubmit:this.handleSubmit}))):null},a.type="paypal",a.subtype="sdk",a.defaultProps=fb,a}(hu);function kb(e){var t,a=lu().i18n,n=Wc("ready"),o=n[0],s=n[1],l=!!(null===(t=null==e?void 0:e.items)||void 0===t?void 0:t.length),d=gp({schema:i(i([],l?["phonePrefix"]:[]),["phoneNumber"]),defaultData:r({},l?{phonePrefix:e.selected}:{}),rules:{phoneNumber:{modes:["blur"],errorMessage:"error.va.gen.01",validate:function(e){return(null==e?void 0:e.length)>6}}}}),c=d.handleChangeFor,u=d.triggerValidation,p=d.data,m=d.valid,h=d.errors,f=d.isValid;return Zc((function(){e.onChange({data:p,valid:m,errors:h,isValid:f})}),[p,m,h,f]),this.showValidation=u,this.setStatus=s,oc("div",{className:"adyen-checkout__phone-input"},oc(Ru,{errorMessage:!!h.phoneNumber,label:a.get(e.phoneLabel),className:Oc({"adyen-checkout__input--phone-number":!0}),inputWrapperModifiers:["phoneInput"]},oc("div",{className:"adyen-checkout__input-wrapper"},oc("div",{className:Oc({"adyen-checkout__input":!0,"adyen-checkout__input--invalid":!!h.phoneNumber})},!!l&&oc(Ru,{inputWrapperModifiers:["phoneInput"]},cp("select",{className:"adyen-checkout__dropdown--small adyen-checkout__countryFlag",filterable:!1,items:e.items,name:e.prefixName,onChange:c("phonePrefix"),placeholder:a.get("infix"),selected:p.phonePrefix}),oc("div",{className:"adyen-checkout__phoneNumber"},oc("div",null,p.phonePrefix),oc("input",{type:"tel",name:e.phoneName,value:p.phoneNumber,onInput:c("phoneNumber","input"),onChange:c("phoneNumber","blur"),placeholder:"123 456 789",className:"adyen-checkout__input adyen-checkout__input--phoneNumber",autoCorrect:"off"})))))),this.props.showPayButton&&this.props.payButton({status:o}))}kb.defaultProps={phoneLabel:"telephoneNumber"};var Cb=function(e){if(!e)throw new Error("No item passed");if(!e.code||!e.id)return!1;var t=e.code.toUpperCase().replace(/./g,(function(e){return String.fromCodePoint?String.fromCodePoint(e.charCodeAt(0)+127397):""}));return r(r({},e),{name:t+" "+e.name+" ("+e.id+")",selectedOptionName:t})},_b=function(e,t){if(e&&t){var r=e.find((function(e){return e.code===t}));return!!r&&r.id}return!1},Nb=[{id:"+7",name:"Russian Federation",code:"RU"},{id:"+9955",name:"Georgia",code:"GE"},{id:"+507",name:"Panama",code:"PA"},{id:"+44",name:"United Kingdom",code:"GB"},{id:"+992",name:"Tajikistan",code:"TJ"},{id:"+370",name:"Lithuania",code:"LT"},{id:"+972",name:"Israel",code:"IL"},{id:"+996",name:"Kyrgyzstan",code:"KG"},{id:"+380",name:"Ukraine",code:"UA"},{id:"+84",name:"Viet Nam",code:"VN"},{id:"+90",name:"Turkey",code:"TR"},{id:"+994",name:"Azerbaijan",code:"AZ"},{id:"+374",name:"Armenia",code:"AM"},{id:"+371",name:"Latvia",code:"LV"},{id:"+91",name:"India",code:"IN"},{id:"+66",name:"Thailand",code:"TH"},{id:"+373",name:"Moldova",code:"MD"},{id:"+1",name:"United States",code:"US"},{id:"+81",name:"Japan",code:"JP"},{id:"+998",name:"Uzbekistan",code:"UZ"},{id:"+77",name:"Kazakhstan",code:"KZ"},{id:"+375",name:"Belarus",code:"BY"},{id:"+372",name:"Estonia",code:"EE"},{id:"+40",name:"Romania",code:"RO"},{id:"+82",name:"Korea",code:"KR"}],wb=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatProps=function(e){return r(r({onValid:function(){}},e),{selected:_b(e.items,e.countryCode)})},a.prototype.formatData=function(){return{paymentMethod:{type:a.type,"qiwiwallet.telephoneNumberPrefix":this.state.data?this.state.data.phonePrefix:"","qiwiwallet.telephoneNumber":this.state.data?this.state.data.phoneNumber:""}}},a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(kb,r({ref:function(t){e.componentRef=t}},this.props,this.state,{phoneLabel:"mobileNumber",onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="qiwiwallet",a.defaultProps={items:Nb.map(Cb).filter((function(e){return!1!==e})),countryCode:Nb[0].code,prefixName:"qiwiwallet.telephoneNumberPrefix",phoneName:"qiwiwallet.telephoneNumber"},a}(hu);function Pb(e){var t=this,a=$c(null),n=Wc({}),o=n[0],i=n[1],s=Wc({}),l=s[0],d=s[1],c=Wc({}),u=c[0],p=c[1],m=Wc(!1),h=m[0],f=m[1],y=Wc(null),b=y[0],v=y[1],g=Wc([]),k=g[0],C=g[1],_=Wc(""),N=_[0],w=_[1],P=Xc((function(){return Cy(e,{sfp:a},{dualBrandSelectElements:k,setDualBrandSelectElements:C,setSelectedBrandValue:w,issuingCountryCode:b,setIssuingCountryCode:v})}),[k,b]);return this.processBinLookupResponse=function(e,t){P.processBinLookup(e,t)},this.dualBrandingChangeHandler=P.handleDualBrandSelection,Zc((function(){return t.setFocusOn=a.current.setFocusOn,t.updateStyles=a.current.updateStyles,t.showValidation=a.current.showValidation,t.handleUnsupportedCard=a.current.handleUnsupportedCard,function(){a.current.destroy()}}),[]),Zc((function(){var t=a.current.mapErrorsToValidationRuleResult();e.onChange({data:u,valid:l,errors:r(r({},o),t),isValid:h,selectedBrandValue:N})}),[u,l,o,N]),oc(Wf,r({ref:a},e,{onChange:function(e){p(r(r({},u),e.data)),i(r(r({},o),e.errors)),d(r(r({},l),e.valid)),f(e.isSfpValid)},render:function(){return null}}))}Pb.defaultProps={onChange:function(){},onError:function(){}};var Fb=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.onBinValue=Fy(t),t}return t(a,e),a.prototype.formatProps=function(e){return r(r(r({},e),{type:"scheme"===e.type?"card":e.type}),e.brands&&!e.groupTypes&&{groupTypes:e.brands})},a.prototype.formatData=function(){var e=this.state.selectedBrandValue||this.props.brand;return{paymentMethod:r(r({type:a.type},this.state.data),e&&{brand:e}),browserInfo:this.browserInfo}},a.prototype.updateStyles=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.updateStyles)&&this.componentRef.updateStyles(e),this},a.prototype.setFocusOn=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.setFocusOn)&&this.componentRef.setFocusOn(e),this},a.prototype.processBinLookupResponse=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.processBinLookupResponse)&&this.componentRef.processBinLookupResponse(e),this},a.prototype.dualBrandingChangeHandler=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.dualBrandingChangeHandler)&&this.componentRef.dualBrandingChangeHandler(e),this},a.prototype.handleUnsupportedCard=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.handleUnsupportedCard)&&this.componentRef.handleUnsupportedCard(e),this},a.prototype.onBinLookup=function(e){var t,a=this,n=r({},e);n.rootNode=this._node,n.isReset||(n.supportedBrandsRaw=null===(t=e.supportedBrandsRaw)||void 0===t?void 0:t.map((function(e){var t,r;return e.brandImageUrl=null!==(r=null===(t=a.props.brandsConfiguration[e.brand])||void 0===t?void 0:t.icon)&&void 0!==r?r:Eh(e.brand,a.props.loadingContext),e}))),this.props.onBinLookup(n)},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"icon",{get:function(){return zc({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"browserInfo",{get:function(){return Im()},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Pb,r({ref:function(t){e.componentRef=t}},this.props,this.state,{rootNode:this._node,onChange:this.setState,onBinValue:this.onBinValue,implementationType:"custom"})))},a.type="scheme",a.analyticsType="custom-scheme",a.defaultProps={onBinLookup:function(){},brandsConfiguration:{}},a}(hu),Db={AD:{length:24,structure:"F04F04A12",example:"AD9912345678901234567890"},AE:{length:23,structure:"F03F16",example:"AE993331234567890123456"},AL:{length:28,structure:"F08A16",example:"AL47212110090000000235698741"},AT:{length:20,structure:"F05F11",example:"AT611904300234573201"},AZ:{length:28,structure:"U04A20",example:"AZ21NABZ00000000137010001944"},BA:{length:20,structure:"F03F03F08F02",example:"BA391290079401028494"},BE:{length:16,structure:"F03F07F02",example:"BE68 5390 0754 7034"},BG:{length:22,structure:"U04F04F02A08",example:"BG80BNBG96611020345678"},BH:{length:22,structure:"U04A14",example:"BH67BMAG00001299123456"},BR:{length:29,structure:"F08F05F10U01A01",example:"BR9700360305000010009795493P1"},CH:{length:21,structure:"F05A12",example:"CH9300762011623852957"},CR:{length:22,structure:"F04F14",example:"CR72012300000171549015"},CY:{length:28,structure:"F03F05A16",example:"CY17002001280000001200527600"},CZ:{length:24,structure:"F04F06F10",example:"CZ6508000000192000145399"},DE:{length:22,structure:"F08F10",example:"DE00123456789012345678"},DK:{length:18,structure:"F04F09F01",example:"DK5000400440116243"},DO:{length:28,structure:"U04F20",example:"DO28BAGR00000001212453611324"},EE:{length:20,structure:"F02F02F11F01",example:"EE382200221020145685"},ES:{length:24,structure:"F04F04F01F01F10",example:"ES9121000418450200051332"},FI:{length:18,structure:"F06F07F01",example:"FI2112345600000785"},FO:{length:18,structure:"F04F09F01",example:"FO6264600001631634"},FR:{length:27,structure:"F05F05A11F02",example:"FR1420041010050500013M02606"},GB:{length:22,structure:"U04F06F08",example:"GB29NWBK60161331926819"},GE:{length:22,structure:"U02F16",example:"GE29NB0000000101904917"},GI:{length:23,structure:"U04A15",example:"GI75NWBK000000007099453"},GL:{length:18,structure:"F04F09F01",example:"GL8964710001000206"},GR:{length:27,structure:"F03F04A16",example:"GR1601101250000000012300695"},GT:{length:28,structure:"A04A20",example:"GT82TRAJ01020000001210029690"},HR:{length:21,structure:"F07F10",example:"HR1210010051863000160"},HU:{length:28,structure:"F03F04F01F15F01",example:"HU42117730161111101800000000"},IE:{length:22,structure:"U04F06F08",example:"IE29AIBK93115212345678"},IL:{length:23,structure:"F03F03F13",example:"IL620108000000099999999"},IS:{length:26,structure:"F04F02F06F10",example:"IS140159260076545510730339"},IT:{length:27,structure:"U01F05F05A12",example:"IT60X0542811101000000123456"},KW:{length:30,structure:"U04A22",example:"KW81CBKU0000000000001234560101"},KZ:{length:20,structure:"F03A13",example:"KZ86125KZT5004100100"},LB:{length:28,structure:"F04A20",example:"LB62099900000001001901229114"},LC:{length:32,structure:"U04F24",example:"LC07HEMM000100010012001200013015"},LI:{length:21,structure:"F05A12",example:"LI21088100002324013AA"},LT:{length:20,structure:"F05F11",example:"LT121000011101001000"},LU:{length:20,structure:"F03A13",example:"LU280019400644750000"},LV:{length:21,structure:"U04A13",example:"LV80BANK0000435195001"},MC:{length:27,structure:"F05F05A11F02",example:"MC5811222000010123456789030"},MD:{length:24,structure:"U02A18",example:"MD24AG000225100013104168"},ME:{length:22,structure:"F03F13F02",example:"ME25505000012345678951"},MK:{length:19,structure:"F03A10F02",example:"MK07250120000058984"},MR:{length:27,structure:"F05F05F11F02",example:"MR1300020001010000123456753"},MT:{length:31,structure:"U04F05A18",example:"MT84MALT011000012345MTLCAST001S"},MU:{length:30,structure:"U04F02F02F12F03U03",example:"MU17BOMM0101101030300200000MUR"},NL:{length:18,structure:"U04F10",example:"NL99BANK0123456789"},NO:{length:15,structure:"F04F06F01",example:"NO9386011117947"},PK:{length:24,structure:"U04A16",example:"PK36SCBL0000001123456702"},PL:{length:28,structure:"F08F16",example:"PL00123456780912345678901234"},PS:{length:29,structure:"U04A21",example:"PS92PALS000000000400123456702"},PT:{length:25,structure:"F04F04F11F02",example:"PT50000201231234567890154"},RO:{length:24,structure:"U04A16",example:"RO49AAAA1B31007593840000"},RS:{length:22,structure:"F03F13F02",example:"RS35260005601001611379"},SA:{length:24,structure:"F02A18",example:"SA0380000000608010167519"},SE:{length:24,structure:"F03F16F01",example:"SE4550000000058398257466"},SI:{length:19,structure:"F05F08F02",example:"SI56263300012039086"},SK:{length:24,structure:"F04F06F10",example:"SK3112000000198742637541"},SM:{length:27,structure:"U01F05F05A12",example:"SM86U0322509800000000270100"},ST:{length:25,structure:"F08F11F02",example:"ST68000100010051845310112"},TL:{length:23,structure:"F03F14F02",example:"TL380080012345678910157"},TN:{length:24,structure:"F02F03F13F02",example:"TN5910006035183598478831"},TR:{length:26,structure:"F05F01A16",example:"TR330006100519786457841326"},VG:{length:24,structure:"U04F16",example:"VG96VPVG0000012345678901"},XK:{length:20,structure:"F04F10F02",example:"XK051212012345678906"},AO:{length:25,structure:"F21",example:"AO69123456789012345678901"},BF:{length:27,structure:"F23",example:"BF2312345678901234567890123"},BI:{length:16,structure:"F12",example:"BI41123456789012"},BJ:{length:28,structure:"F24",example:"BJ39123456789012345678901234"},CI:{length:28,structure:"U01F23",example:"CI17A12345678901234567890123"},CM:{length:27,structure:"F23",example:"CM9012345678901234567890123"},CV:{length:25,structure:"F21",example:"CV30123456789012345678901"},DZ:{length:24,structure:"F20",example:"DZ8612345678901234567890"},IR:{length:26,structure:"F22",example:"IR861234568790123456789012"},JO:{length:30,structure:"A04F22",example:"JO15AAAA1234567890123456789012"},MG:{length:27,structure:"F23",example:"MG1812345678901234567890123"},ML:{length:28,structure:"U01F23",example:"ML15A12345678901234567890123"},MZ:{length:25,structure:"F21",example:"MZ25123456789012345678901"},QA:{length:29,structure:"U04A21",example:"QA30AAAA123456789012345678901"},SN:{length:28,structure:"U01F23",example:"SN52A12345678901234567890123"},UA:{length:29,structure:"F25",example:"UA511234567890123456789012345"}},Ab=function(e){return e.replace(/\W/gi,"").replace(/(.{4})(?!$)/g,"$1 ").trim()},Sb=function(e){return e.replace(/[^a-zA-Z0-9]/g,"").toUpperCase()},xb=function(e,t){return function(e,t){if(null===t||!Db[t]||!Db[t].structure)return!1;var r=Db[t].structure.match(/(.{3})/g).map((function(e){var t,r=e.slice(0,1),a=parseInt(e.slice(1),10);switch(r){case"A":t="0-9A-Za-z";break;case"B":t="0-9A-Z";break;case"C":t="A-Za-z";break;case"F":t="0-9";break;case"L":t="a-z";break;case"U":t="A-Z";break;case"W":t="0-9a-z"}return"(["+t+"]{"+a+"})"}));return new RegExp("^"+r.join("")+"$")}(0,t)},Bb=function(e){return void 0===e&&(e=null),e&&Db[e]&&Db[e].example?Ab(Db[e].example):"AB00 1234 5678 9012 3456 7890"};function Tb(e,t){void 0===t&&(t=null),this.status=e,this.code=t}var zb=function(e){var t=Sb(e);return 1===function(e){for(var t,r=e;r.length>2;)t=r.slice(0,9),r=parseInt(t,10)%97+r.slice(t.length);return parseInt(r,10)%97}(function(e){var t=e,r="A".charCodeAt(0),a="Z".charCodeAt(0);return(t=(t=t.toUpperCase()).substr(4)+t.substr(0,4)).split("").map((function(e){var t=e.charCodeAt(0);return t>=r&&t<=a?t-r+10:e})).join("")}(t))&&function(e){var t=e.slice(0,2),r=xb(0,t);return r.test&&r.test(e.slice(4))||!1}(t)},Ib=function(e){var t=Sb(e);if(e.length<2)return new Tb("no-validate","TOO_SHORT");var r=function(e){return!(!e||!Db[e])&&Db[e]}(t.slice(0,2));return r?t.length>r.length?new Tb("invalid","TOO_LONG"):t.length===r.length?zb(e)?new Tb("valid","VALID"):new Tb("invalid","INVALID_IBAN"):new Tb("no-validate","UNKNOWN"):new Tb("invalid","INVALID_COUNTRY")},Mb=function(e){return!!(e&&e.length&&e.length>0)},jb=function(e){function a(t){var a,n,o=e.call(this,t)||this;if(o.setData=function(e,t,a){o.setState((function(a){var n;return{data:r(r({},a.data),(n={},n[e]=t,n))}}),a)},o.setError=function(e,t,a){o.setState((function(a){var n;return{errors:r(r({},a.errors),(n={},n[e]=t,n))}}),a)},o.setValid=function(e,t,a){o.setState((function(a){var n;return{valid:r(r({},a.valid),(n={},n[e]=t,n))}}),a)},o.handleHolderInput=function(e){o.setState((function(t){return{data:r(r({},t.data),{"sepa.ownerName":e})}}),(function(){o.setError("holder",!Mb(o.state.data["sepa.ownerName"])),o.onChange()}))},o.handleIbanInput=function(e){var t=e.target.value,a=Sb(t),n=Ab(a),i=Ib(n).status,s=e.target.selectionStart,l=o.state.data["sepa.ibanNumber"],d=function(e,t,r){if(0===e||!t.length)return 0;var a=t.length-r.length,n=a>0,o=function(e,t){return/\s/.test(e.charAt(t))},i=e-a;return n&&(o(t,i+1)||o(t,i))?e+1:!n&&o(t,e-1)?e-1:e}(s,n,l);o.setState((function(e){return{data:r(r({},e.data),{"sepa.ibanNumber":n}),errors:r(r({},e.errors),{iban:"invalid"===i?"sepaDirectDebit.ibanField.invalid":null}),valid:r(r({},e.valid),{iban:"valid"===i})}}),(function(){e.target.setSelectionRange(d,d),o.onChange()}))},o.handleIbanBlur=function(e){var t=e.target.value;if(t.length>0){var r=Ib(t).status;o.setError("iban","valid"!==r?"sepaDirectDebit.ibanField.invalid":null)}},o.state={status:"ready",data:{"sepa.ownerName":(null===(a=null==t?void 0:t.data)||void 0===a?void 0:a.ownerName)||"","sepa.ibanNumber":(null===(n=null==t?void 0:t.data)||void 0===n?void 0:n.ibanNumber)||""},isValid:!1,cursor:0,errors:{},valid:{}},o.state.data["sepa.ibanNumber"]){var i=Sb(o.state.data["sepa.ibanNumber"]);o.state.data["sepa.ibanNumber"]=Ab(i)}if(o.state.data["sepa.ibanNumber"]||o.state.data["sepa.ownerName"]){var s=o.props.holderName?Mb(o.state.data["sepa.ownerName"]):"",l=(o.state.data["sepa.ibanNumber"]?"valid"===Ib(o.state.data["sepa.ibanNumber"]).status:"")&&s,d={data:o.state.data,isValid:l};o.props.onChange(d)}return o}return t(a,e),a.prototype.setStatus=function(e){this.setState({status:e})},a.prototype.onChange=function(){var e=this.props.holderName?Mb(this.state.data["sepa.ownerName"]):"",t="valid"===Ib(this.state.data["sepa.ibanNumber"]).status&&e,r={data:this.state.data,isValid:t};this.props.onChange(r)},a.prototype.showValidation=function(){var e=Ib(this.state.data["sepa.ibanNumber"]).status,t=Mb(this.state.data["sepa.ownerName"]);this.setError("iban","valid"!==e?"sepaDirectDebit.ibanField.invalid":null),this.setError("holder",!t||null)},a.prototype.render=function(e,t){var r=this,a=e.placeholders,n=e.countryCode,o=t.data,i=t.errors,s=t.valid,l=lu().i18n;return oc("div",{className:"adyen-checkout__iban-input"},this.props.holderName&&oc(Ru,{className:"adyen-checkout__field--owner-name",label:l.get("sepa.ownerName"),filled:o["sepa.ownerName"]&&o["sepa.ownerName"].length,errorMessage:!!i.holder&&l.get("creditCard.holderName.invalid"),dir:"ltr"},cp("text",{name:"sepa.ownerName",className:"adyen-checkout__iban-input__owner-name",placeholder:"ownerName"in a?a.ownerName:l.get("sepaDirectDebit.nameField.placeholder"),value:o["sepa.ownerName"],"aria-invalid":!!this.state.errors.holder,"aria-label":l.get("sepa.ownerName"),onInput:function(e){return r.handleHolderInput(e.target.value)}})),oc(Ru,{className:"adyen-checkout__field--iban-number",label:l.get("sepa.ibanNumber"),errorMessage:!!i.iban&&l.get(i.iban),filled:o["sepa.ibanNumber"]&&o["sepa.ibanNumber"].length,isValid:s.iban,onBlur:this.handleIbanBlur,dir:"ltr"},cp("text",{ref:function(e){r.ibanNumber=e},name:"sepa.ibanNumber",className:"adyen-checkout__iban-input__iban-number",classNameModifiers:["large"],placeholder:"ibanNumber"in a?a.ibanNumber:Bb(n),value:o["sepa.ibanNumber"],onInput:this.handleIbanInput,"aria-invalid":!!this.state.errors.iban,"aria-label":l.get("sepa.ibanNumber"),autocorrect:"off",spellcheck:!1})),this.props.showPayButton&&this.props.payButton({status:this.state.status}))},a.defaultProps={onChange:function(){},countryCode:null,holderName:!0,placeholders:{}},a}(lc),Eb=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(e){return r({holderName:!0},e)},a.prototype.formatData=function(){return{paymentMethod:{type:a.type,iban:this.state.data["sepa.ibanNumber"],ownerName:this.state.data["sepa.ownerName"]}}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,r({},this.props,{loadingContext:this.props.loadingContext}),oc(jb,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="sepadirectdebit",a}(hu),Ob=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.prototype.componentDidMount=function(){this.formEl.submit()},r.prototype.render=function(e){var t=this,r=e.name,a=e.action,n=e.target,o=e.inputName,i=e.inputValue;return oc("form",{ref:function(e){t.formEl=e},method:"POST",className:Oc(["adyen-checkout__threeds2__form","adyen-checkout__threeds2__form--"+r]),name:r,action:a,target:n,style:{display:"none"}},oc("input",{name:o,value:i}))},r}(lc),Rb={result:{transStatus:"U"},type:"challengeResult"},Lb={result:{transStatus:"U"},type:"challengeResult",errorCode:"timeout"},Vb={result:{threeDSCompInd:"N"},type:"fingerPrintResult"},Ub={result:{threeDSCompInd:"N"},type:"fingerPrintResult",errorCode:"timeout"},Kb="unknownError",Hb={timeout:"ThreeDS2 timed out",wrongOrigin:"Result came in the right format but not from the expected origin",HTMLElementError:"No proper HTML element was passed",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},qb={"01":["250px","400px"],"02":["390px","400px"],"03":["500px","600px"],"04":["600px","400px"],"05":["100%","100%"]},Gb=function(e){var t=Au.decode(e);try{return t&&JSON.parse(t)}catch(e){throw new Error("Could not decode token")}},Yb=function(e){if(!e||!Object.keys(e).length)throw new Error("No (populated) data object to encode");return Au.encode(JSON.stringify(e))},Wb=function(e){var t=1===e.length?"0"+e:e;return Object.prototype.hasOwnProperty.call(qb,t)?t:"02"},Jb=function(e,t,r){var a;return{data:(a={},a[e]=Yb({threeDSCompInd:t.threeDSCompInd}),a.paymentData=r,a)}},Zb=function(e,t,r){return{data:{details:{"threeds2.fingerprint":Yb(t)},paymentData:r}}},Qb=function(e,t,r){var a;return{data:{details:(a={},a[e]=Yb({transStatus:t,authorisationToken:r}),a)}}},$b=function(e,t,r){return{data:{details:{"threeds2.challengeResult":Yb({transStatus:t})},paymentData:r}}},Xb=function(e){return{errorCode:e,message:Hb[e]||Hb[Kb]}},ev=function(e){var t=window.btoa(e).split("=")[0];return t=(t=t.replace(/\+/g,"-")).replace(/\//g,"_")},tv=["elementRef"],rv=["createFromAction","onAdditionalDetails"],av="threeDSIframe",nv=function(e){function r(t){var r=e.call(this,t)||this;r.iframeCallback=function(){r.setState({status:"iframeLoaded"})};var a=JSON.stringify(r.props.cReqData),n=ev(a);return r.state={base64URLencodedData:n},r}return t(r,e),r.prototype.get3DS2ChallengePromise=function(){var e=this;return new Promise((function(t,r){e.processMessageHandler=_u(e.props.postMessageDomain,t,r,Rb,"challengeResult"),window.addEventListener("message",e.processMessageHandler)}))},r.prototype.componentDidMount=function(){var e=this;this.challengePromise=yu(6e5,this.get3DS2ChallengePromise(),Lb),this.challengePromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteChallenge(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorChallenge(t)}))},r.prototype.componentWillUnmount=function(){this.challengePromise&&this.challengePromise.cancel(),window.removeEventListener("message",this.processMessageHandler)},r.prototype.render=function(e,t){var r=e.acsURL,a=e.cReqData,n=e.iframeSizeArr,o=t.base64URLencodedData,i=t.status,s=n[0],l=n[1];return oc("div",{className:Oc(["adyen-checkout__threeds2__challenge","adyen-checkout__threeds2__challenge--"+a.challengeWindowSize])},"iframeLoaded"!==i&&oc(Rc,null),oc(fu,{name:av,width:s,height:l,callback:this.iframeCallback}),oc(Ob,{name:"cReqForm",action:r,target:av,inputName:"creq",inputValue:o}))},r}(lc),ov=function(e){function a(t){var r=e.call(this,t)||this;if(r.props.token){var a=function(e){var t,r=e.token,a=e.size,n=Gb(r),o=n.acsTransID,i=n.acsURL,s=n.messageVersion,l=n.threeDSNotificationURL,d=n.threeDSServerTransID,c=Nu(l);return{acsURL:i,cReqData:{acsTransID:o,messageVersion:s,threeDSServerTransID:d,messageType:"CReq",challengeWindowSize:Wb(a)},iframeSizeArr:(t=a,qb[Wb(t)]),postMessageDomain:c}}({token:r.props.token,size:r.props.challengeWindowSize||r.props.size});r.state={status:"retrievingChallengeToken",challengeData:a}}else r.state={status:"error"},r.props.onError("Missing challengeToken parameter");return r}return t(a,e),a.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){var r=(t.props.useOriginalFlow?$b:Qb)(t.props.dataKey,e.transStatus,t.props.paymentData);t.props.onComplete(r)}))},a.prototype.render=function(e,t){var a=this,n=t.challengeData;return"retrievingChallengeToken"===this.state.status?oc(nv,r({onCompleteChallenge:function(e){a.setStatusComplete(e.result)},onErrorChallenge:function(e){var t=Xb(e.errorCode);a.props.onError(t),a.setStatusComplete(e.result)}},n)):null},a.defaultProps={onComplete:function(){},onError:function(){}},a}(lc),iv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.render=function(){return Kh(this.props.paymentData)?oc(ov,r({},this.props,{onComplete:this.onComplete})):(this.props.onError({errorCode:"threeds2.challenge",message:"No paymentData received. Challenge cannot proceed"}),null)},a.type="threeDS2Challenge",a.defaultProps={dataKey:"threeDSResult",size:"02",type:"ChallengeShopper"},a}(hu),sv="threeDSMethodIframe",lv=function(e){function r(t){var r=e.call(this,t)||this,a=r.props,n=a.threeDSServerTransID,o=a.threeDSMethodNotificationURL,i=JSON.stringify({threeDSServerTransID:n,threeDSMethodNotificationURL:o}),s=ev(i);return r.state={base64URLencodedData:s},r}return t(r,e),r.prototype.get3DS2MethodPromise=function(){var e=this;return new Promise((function(t,r){e.processMessageHandler=_u(e.props.postMessageDomain,t,r,Vb,"fingerPrintResult"),window.addEventListener("message",e.processMessageHandler)}))},r.prototype.componentDidMount=function(){var e=this;this.fingerPrintPromise=yu(1e4,this.get3DS2MethodPromise(),Ub),this.fingerPrintPromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteFingerprint(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorFingerprint(t)}))},r.prototype.componentWillUnmount=function(){this.fingerPrintPromise&&this.fingerPrintPromise.cancel(),window.removeEventListener("message",this.processMessageHandler)},r.prototype.render=function(e,t){var r=e.threeDSMethodURL,a=t.base64URLencodedData;return oc("div",{className:"adyen-checkout__3ds2-device-fingerprint"},this.props.showSpinner&&oc(Rc,null),oc("div",{style:{display:"none"}},oc(fu,{name:sv}),oc(Ob,{name:"threeDSMethodForm",action:r,target:sv,inputName:"threeDSMethodData",inputValue:a})))},r.defaultProps={showSpinner:!0},r}(lc),dv=function(e){function a(t){var r=e.call(this,t)||this,a=r.props,n=a.token,o=a.notificationURL;if(n){var i=function(e){var t=e.token,r=e.notificationURL,a=Gb(t),n=a.threeDSMethodNotificationURL,o=a.threeDSMethodUrl,i=r||n;return{threeDSServerTransID:a.threeDSServerTransID,threeDSMethodURL:o,threeDSMethodNotificationURL:i,postMessageDomain:Nu(i)}}({token:n,notificationURL:o});r.state={status:"init",fingerPrintData:i}}else r.state={status:"error"},r.props.onError("Missing fingerprintToken parameter");return r}return t(a,e),a.prototype.componentDidMount=function(){this.state.fingerPrintData&&this.state.fingerPrintData.threeDSMethodURL&&this.state.fingerPrintData.threeDSMethodURL.length?this.setState({status:"retrievingFingerPrint"}):this.setStatusComplete({threeDSCompInd:"U"})},a.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){var r=(t.props.useOriginalFlow?Zb:Jb)(t.props.dataKey,e,t.props.paymentData);t.props.onComplete(r)}))},a.prototype.render=function(e,t){var a=this,n=t.fingerPrintData;return"retrievingFingerPrint"===this.state.status?oc(lv,r({onCompleteFingerprint:function(e){a.setStatusComplete(e.result)},onErrorFingerprint:function(e){var t=Xb(e.errorCode);a.props.onError(t),a.setStatusComplete(e.result)},showSpinner:this.props.showSpinner},n)):null},a.type="scheme",a.defaultProps={onComplete:function(){},onError:function(){},paymentData:"",showSpinner:!0},a}(lc);function cv(e){var t=this,a=e.data;bm({path:"v1/submitThreeDS2Fingerprint?token="+this.props.clientKey,loadingContext:this.props.loadingContext},r({},a)).then((function(e){var r,a,n,o=null!==(r=t.props.elementRef)&&void 0!==r?r:t;if(e.action||e.details){if("completed"===e.type){var i=e.details;return t.onComplete({data:{details:i}})}return"threeDS2"===(null===(a=e.action)||void 0===a?void 0:a.type)?o.handleAction(e.action,Rh("challengeWindowSize").from(t.props)):"redirect"===(null===(n=e.action)||void 0===n?void 0:n.type)?o.handleAction(e.action):void 0}console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: resData=",e)}))}var uv=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.callSubmit3DS2Fingerprint=cv.bind(t),t}return t(a,e),a.prototype.render=function(){return Kh(this.props.paymentData)?oc(dv,r({},this.props,{onComplete:this.props.useOriginalFlow?this.onComplete:this.callSubmit3DS2Fingerprint})):(this.props.onError({errorCode:a.defaultProps.dataKey,message:"No paymentData received. Fingerprinting cannot proceed"}),null)},a.type="threeDS2Fingerprint",a.defaultProps={dataKey:"fingerprintResult",type:"IdentifyShopper"},a}(hu),pv=function(e,t){if(void 0===t&&(t=2),0===t)return e;var r=String(e);return r.length>=t?r:("0".repeat(t)+r).slice(-1*t)},mv=function(e,t){var r=new Date,a=t.getTime()-r.getTime(),n=a/1e3,o=function(e,t,r){var a=r.getTime()-e.getTime();return 100-Math.round(100*(t.getTime()-e.getTime())/a)}(e,r,t);return{total:a,minutes:pv(Math.floor(n/60%60)),seconds:pv(Math.floor(n%60)),completed:a<=0,percentage:o}},hv=function(e){function a(t){var r=e.call(this,t)||this,a=6e4*r.props.minutesFromNow,n=(new Date).getTime();return r.state={startTime:new Date(n),endTime:new Date(n+a),minutes:"-",seconds:"-"},r}return t(a,e),a.prototype.tick=function(){var e=mv(this.state.startTime,this.state.endTime);if(e.completed)return this.props.onCompleted(),this.clearInterval();var t={minutes:e.minutes,seconds:e.seconds,percentage:e.percentage};return this.setState(r({},t)),this.props.onTick(t),t},a.prototype.clearInterval=function(){clearInterval(this.interval),delete this.interval},a.prototype.componentDidMount=function(){var e=this;this.interval=setInterval((function(){e.tick()}),1e3)},a.prototype.componentWillUnmount=function(){this.clearInterval()},a.prototype.render=function(){return oc("span",{className:"adyen-checkout__countdown"},oc("span",{className:"countdown__minutes"},this.state.minutes),oc("span",{className:"countdown__separator"},":"),oc("span",{className:"countdown__seconds"},this.state.seconds))},a.defaultProps={onTick:function(){},onCompleted:function(){}},a}(lc);function fv(e,t,r){if(!e||!t)throw new Error("Could not check the payment status");return bm({loadingContext:r,path:"services/PaymentInitiation/v1/status?clientKey="+t},{paymentData:e})}var yv=function(e){switch(e.resultCode.toLowerCase()){case"refused":case"error":case"cancelled":return{type:"error",props:r(r({},e),{message:"error.subtitle.refused"})};case"unknown":return{type:"error",props:r(r({},e),{message:"error.message.unknown"})};case"pending":case"received":return{type:e.resultCode.toLowerCase(),props:e};case"authorised":default:return{type:"success",props:e}}},bv=function(e){if(!e.type&&e.resultCode)return yv(e);if(!e.type)return{type:"error",props:e};switch(e.type.toLowerCase()){case"pending":return{type:"pending",props:e};case"complete":return yv(e);case"validation":default:return{type:"error",props:e}}},vv=function(e){function r(t){var r=e.call(this,t)||this;return r.statusInterval=function(){r.checkStatus(),r.setState({timePassed:r.state.timePassed+r.props.delay}),r.state.timePassed>=r.props.throttleTime&&r.setState({delay:r.props.throttledInterval})},r.redirectToApp=function(e,t){void 0===t&&(t=function(){}),setTimeout((function(){r.props.onError(new mu("ERROR",r.props.type+" App was not found")),t()}),25),window.location.assign(e)},r.onTick=function(e){r.setState({percentage:e.percentage})},r.onTimeUp=function(){r.setState({expired:!0}),clearInterval(r.interval),r.props.onError(new mu("ERROR","Payment Expired"))},r.onComplete=function(e){return clearInterval(r.interval),r.setState({completed:!0,loading:!1}),r.props.onComplete({data:{details:{payload:e.props.payload},paymentData:r.props.paymentData}}),e},r.onError=function(e){return clearInterval(r.interval),r.setState({expired:!0,loading:!1}),r.props.onComplete({data:{details:{payload:e.props.payload},paymentData:r.props.paymentData}}),e},r.checkStatus=function(){var e=r.props;return fv(e.paymentData,e.clientKey,e.loadingContext).then(bv).catch((function(e){return{type:"network-error",props:e}})).then((function(e){switch(e.type){case"success":return r.onComplete(e);case"error":return r.onError(e);default:r.setState({loading:!1})}return e}))},r.state={buttonStatus:"default",completed:!1,delay:t.delay,expired:!1,loading:!0,percentage:100,timePassed:0},r}return t(r,e),r.prototype.componentDidMount=function(){var e=this,t=this.props,r=t.shouldRedirectOnMobile,a=t.url,n=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent),o=function(){e.interval=setInterval(e.statusInterval,e.state.delay)};r&&a&&n?this.redirectToApp(a,o):o()},r.prototype.componentDidUpdate=function(e,t){t.delay!==this.state.delay&&(clearInterval(this.interval),this.interval=setInterval(this.statusInterval,this.state.delay))},r.prototype.componentWillUnmount=function(){clearInterval(this.interval)},r.prototype.render=function(e,t){var r=this,a=e.amount,n=e.url,o=e.brandLogo,i=e.countdownTime,s=e.type,l=t.expired,d=t.completed,c=t.loading,u=lu(),p=u.i18n,m=u.loadingContext,h=this.props.qrCodeData?m+"barcode.shtml?barcodeType=qrCode&fileType=png&data="+this.props.qrCodeData:this.props.qrCodeImage,f=function(e,t){return oc("div",{className:"adyen-checkout__qr-loader adyen-checkout__qr-loader--result"},oc("img",{className:"adyen-checkout__qr-loader__icon adyen-checkout__qr-loader__icon--result",src:zc({loadingContext:m,imageFolder:"components/"})(e),alt:p.get(t)}),oc("div",{className:"adyen-checkout__qr-loader__subtitle adyen-checkout__qr-loader__subtitle--result"},p.get(t)))};if(l)return f("error","error.subtitle.payment");if(d)return f("success","creditCard.success");if(c)return oc("div",{className:"adyen-checkout__qr-loader"},o&&oc("img",{alt:s,src:o,className:"adyen-checkout__qr-loader__brand-logo"}),oc(Rc,null));var y=p.get("wechatpay.timetopay").split("%@");return oc("div",{className:"\n                    adyen-checkout__qr-loader\n                    adyen-checkout__qr-loader--"+s+"\n                    "+this.props.classNameModifiers.map((function(e){return"adyen-checkout__qr-loader--"+e}))+"\n                "},o&&oc("img",{src:o,alt:s,className:"adyen-checkout__qr-loader__brand-logo"}),oc("div",{className:"adyen-checkout__qr-loader__subtitle"},p.get(this.props.introduction)),oc("img",{src:h,alt:p.get("wechatpay.scanqrcode")}),a&&a.value&&a.currency&&oc("div",{className:"adyen-checkout__qr-loader__payment_amount"},p.amount(a.value,a.currency)),oc("div",{className:"adyen-checkout__qr-loader__progress"},oc("span",{className:"adyen-checkout__qr-loader__percentage",style:{width:this.state.percentage+"%"}})),oc("div",{className:"adyen-checkout__qr-loader__countdown"},y[0],"\xa0",oc(hv,{minutesFromNow:i,onTick:this.onTick,onCompleted:this.onTimeUp}),"\xa0",y[1]),this.props.instructions&&oc("div",{className:"adyen-checkout__qr-loader__instructions"},p.get(this.props.instructions)),this.props.copyBtn&&oc("div",{className:"adyen-checkout__qr-loader__actions"},oc(du,{inline:!0,secondary:!0,onClick:function(e,t){var a=t.complete;$y(r.props.qrCodeData),a()},icon:zc({loadingContext:m,imageFolder:"components/"})("copy"),label:p.get("button.copy")})),n&&oc("div",{className:"adyen-checkout__qr-loader__app-link"},oc("span",{className:"adyen-checkout__qr-loader__separator__label"},p.get("or")),oc(du,{classNameModifiers:["qr-loader"],onClick:function(){return r.redirectToApp(n)},label:p.get("openApp")})))},r.defaultProps={delay:2e3,countdownTime:15,onError:function(){},onComplete:function(){},throttleTime:6e4,classNameModifiers:[],throttledInterval:1e4,introduction:"wechatpay.scanqrcode"},r}(lc),gv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatData=function(){return{paymentMethod:r({type:this.props.type||this.constructor.type},this.state.data)}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),a.prototype.renderQRCode=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(vv,r({ref:function(t){e.componentRef=t}},this.props,{shouldRedirectOnMobile:this.props.shouldRedirectOnMobile,type:this.constructor.type,brandLogo:this.props.brandLogo||this.icon,delay:this.props.delay,onComplete:this.onComplete,countdownTime:this.props.countdownTime,instructions:this.props.instructions})))},a.prototype.render=function(){var e=this;return this.props.paymentData?this.renderQRCode():this.props.showPayButton?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(My,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}})):null},a.defaultProps={qrCodeImage:"",amount:null,paymentData:null,onError:function(){},onComplete:function(){}},a}(hu),kv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r({delay:2e3,countdownTime:15},e.prototype.formatProps.call(this,t))},a.type="wechatpayQR",a}(gv),Cv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){var a=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent);return r({delay:2e3,countdownTime:15,shouldRedirectOnMobile:!0,buttonLabel:a?"openApp":"generateQRCode"},e.prototype.formatProps.call(this,t))},a.type="bcmc_mobile",a}(gv),_v=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="molpay_ebanking_fpx_MY",r}(uh),Nv=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="molpay_ebanking_TH",r}(uh),wv=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="molpay_ebanking_VN",r}(uh),Pv=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="openbanking_UK",r}(uh);function Fv(e){var t=lu().i18n,a=function(){return["dragonpay_ebanking","dragonpay_otc_banking","dragonpay_otc_non_banking"].indexOf(e.type)>-1},n=gp({schema:i(i([],a()?["issuer"]:[]),["shopperEmail"]),rules:{issuer:{validate:function(e){return a()&&!!e},modes:["input","blur"]}}}),o=n.handleChangeFor,s=n.triggerValidation,l=n.data,d=n.valid,c=n.errors,u=n.isValid,p=ch({},e.type),m=e.items.map((function(e){return r(r({},e),{icon:p(e.id&&e.id.toLowerCase())})})),h=function(e){return"dragonpay_otc_non_banking"===e?"dragonpay.voucher.non.bank.selectField.placeholder":"dragonpay.voucher.bank.selectField.placeholder"};Zc((function(){e.onChange({isValid:u,data:l,valid:d,errors:c})}),[u,l,d,c]);var f=Wc("ready"),y=f[0],b=f[1];return this.setStatus=b,this.showValidation=s,oc("div",{className:"adyen-checkout__dragonpay-input__field"},oc(Ru,{label:t.get("shopperEmail"),errorMessage:!!c.shopperEmail},cp("emailAddress",{name:"dragonpay.shopperEmail",autoCorrect:"off",value:l.shopperEmail,className:"adyen-checkout__input--large",spellCheck:!1,onInput:o("shopperEmail","input"),onChange:o("shopperEmail","blur")})),a()&&oc(Ru,{label:t.get(h(e.type)),errorMessage:!!c.issuer},cp("select",{items:m,selected:l.issuer,placeholder:t.get(h(e.type)),name:"issuer",className:"adyen-checkout__dropdown--large adyen-checkout__issuer-list__dropdown",onChange:o("issuer")})),e.showPayButton&&e.payButton({status:y,label:t.get("confirmPurchase")}))}function Dv(e){var t=e.reference,r=e.totalAmount,a=e.surcharge,n=e.expiresAt,o=e.alternativeReference,i=e.instructionsUrl,s=e.icon,l=e.issuer,d=e.paymentMethodType,c=lu(),u=c.loadingContext,p=c.i18n,m=ch({loadingContext:u},d)(l.toLowerCase());return oc(Xy,{reference:t,paymentMethodType:d,introduction:p.get("voucher.introduction"),imageUrl:s,issuerImageUrl:m,instructionsUrl:i,amount:r&&p.amount(r.value,r.currency),surcharge:a&&p.amount(a.value,a.currency),voucherDetails:[{label:p.get("voucher.expirationDate"),value:p.date(n)},{label:p.get("voucher.alternativeReference"),value:o}],copyBtn:!0})}Fv.defaultProps={data:{},items:[],onChange:function(){}};var Av=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatData=function(){var e=this.state.data,t=e.issuer,n=e.shopperEmail;return r(r({},n&&{shopperEmail:n}),{paymentMethod:r(r({},t&&{issuer:t}),{type:this.props.type||a.type})})},a.prototype.formatProps=function(e){var t,a,n;return r(r({},e),{issuers:null!==(n=null===(a=null===(t=e.details)||void 0===t?void 0:t.find((function(e){return"issuer"===e.key})))||void 0===a?void 0:a.items)&&void 0!==n?n:e.issuers})},a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?oc(Dv,r({ref:function(t){e.componentRef=t},icon:this.icon},this.props)):oc(Fv,r({ref:function(t){e.componentRef=t},items:this.props.issuers},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="dragonpay",a}(hu);function Sv(e){var t=$c(null),r=lu().i18n,a=Wc("ready"),n=a[0],o=a[1];return this.setStatus=o,this.showValidation=function(){t.current&&t.current.showValidation()},oc("div",{className:"adyen-checkout__doku-input__field"},oc(Tp,{data:e.data,requiredFields:["firstName","lastName","shopperEmail"],onChange:e.onChange,namePrefix:"doku",ref:t}),e.showPayButton&&e.payButton({status:n,label:r.get("confirmPurchase")}))}var xv=function(e){var t=e.reference,r=e.expiresAt,a=e.instructionsUrl,n=e.shopperName,o=e.merchantName,i=e.totalAmount,s=e.paymentMethodType,l=lu(),d=l.loadingContext,c=l.i18n;return oc(Xy,{paymentMethodType:s,reference:t,introduction:c.get("voucher.introduction.doku"),imageUrl:zc({loadingContext:d})(s),instructionsUrl:a,amount:i&&c.amount(i.value,i.currency),voucherDetails:[{label:c.get("voucher.expirationDate"),value:c.date(r)},{label:c.get("voucher.shopperName"),value:n},{label:c.get("voucher.merchantName"),value:o}],copyBtn:!0})},Bv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatData=function(){return r(r({},this.state.data),{paymentMethod:{type:this.props.type||a.type}})},Object.defineProperty(a.prototype,"icon",{get:function(){return zc({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?oc(xv,r({ref:function(t){e.componentRef=t}},this.props)):oc(Sv,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="doku",a}(hu),Tv={socialSecurityNumber:{validate:vy,errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},zv={socialSecurityNumber:function(e){return by(e)}};function Iv(e){var t=e.errors,r=e.value,a=e.onInput,n=e.onChange,o=lu().i18n,i=Wc(!1),s=i[0],l=i[1];return oc("div",{className:Oc("adyen-checkout__fieldset","adyen-checkout__fieldset--sendCopyToEmail",e.classNames)},oc(Ru,{classNameModifiers:["sendCopyToEmail"]},cp("boolean",{onChange:function(t){l(t.target.checked),e.onToggle(s)},label:o.get("boleto.sendCopyToEmail"),name:"sendCopyToEmail",value:s})),s&&oc(Ru,{label:o.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:t},cp("emailAddress",{name:"shopperEmail",autoCorrect:"off",spellCheck:!1,value:r,onInput:a,onChange:n})))}function Mv(e){var t=e.i18n,r=e.data,a=e.handleChangeFor,n=e.errors,o=e.valid;return oc("div",{className:"adyen-checkout__fieldset adyen-checkout__fieldset--address adyen-checkout__fieldset--personalDetails"},oc("div",{className:"adyen-checkout__fieldset__title"},t.get("personalDetails")),oc("div",{className:"adyen-checkout__fieldset__fields"},oc(Ru,{label:t.get("firstName"),classNameModifiers:["firstName","col-50"],errorMessage:!!n.firstName},cp("text",{name:"firstName",autocorrect:"off",spellcheck:!1,value:r.firstName,onInput:a("firstName","input"),onChange:a("firstName")})),oc(Ru,{label:t.get("lastName"),classNameModifiers:["lastName","col-50"],errorMessage:!!n.lastName},cp("text",{name:"lastName",autocorrect:"off",spellcheck:!1,value:r.lastName,onInput:a("lastName","input"),onChange:a("lastName")})),oc(hy,{data:r.socialSecurityNumber,error:n.socialSecurityNumber,valid:o.socialSecurityNumber,onInput:a("socialSecurityNumber","input"),onChange:a("socialSecurityNumber")})))}function jv(e){var t=lu().i18n,a=$c(null),n=gp({schema:["firstName","lastName","socialSecurityNumber","billingAddress","shopperEmail"],defaultData:e.data,rules:Tv,formatters:zv}),o=n.handleChangeFor,s=n.triggerValidation,l=n.setSchema,d=n.setData,c=n.setValid,u=n.setErrors,p=n.data,m=n.valid,h=n.errors,f=n.isValid,y=Wc(!1),b=y[0],v=y[1];Zc((function(){var t=i(i(i([],e.personalDetailsRequired?["firstName","lastName","socialSecurityNumber"]:[]),e.billingAddressRequired?["billingAddress"]:[]),b?["shopperEmail"]:[]);l(t)}),[b,e.personalDetailsRequired,e.billingAddressRequired]);var g=Wc("ready"),k=g[0],C=g[1];this.setStatus=C,this.showValidation=function(){s(),e.billingAddressRequired&&a.current.showValidation()},Zc((function(){var t=!e.billingAddressRequired||Boolean(m.billingAddress);e.onChange({data:p,valid:m,errors:h,isValid:f&&t})}),[p,m,h]);var _=i([],e.personalDetailsRequired||e.billingAddressRequired||e.showEmailAddress?[]:["standalone"]);return oc("div",{className:"adyen-checkout__boleto-input__field"},e.personalDetailsRequired&&oc(Mv,{i18n:t,data:p,handleChangeFor:o,errors:h,valid:m}),e.billingAddressRequired&&oc(Nm,{allowedCountries:["BR"],label:"billingAddress",data:r(r({},e.data.billingAddress),{country:"BR"}),onChange:function(e){d("billingAddress",e.data),c("billingAddress",e.isValid),u("billingAddress",e.errors)},requiredFields:["country","street","houseNumberOrName","postalCode","city","stateOrProvince"],ref:a}),e.showEmailAddress&&oc(Iv,{value:p.shopperEmail,errors:h.shopperEmail,onToggle:function(){return v(!b)},onInput:o("shopperEmail","input"),onChange:o("shopperEmail")}),e.showPayButton&&e.payButton({status:k,label:t.get("boletobancario.btnLabel"),classNameModifiers:_}))}jv.defaultProps={data:{},showEmailAddress:!0,personalDetailsRequired:!0,billingAddressRequired:!0};var Ev=function(e){var t=lu(),r=t.i18n,a=t.loadingContext,n=e.reference,o=e.expiresAt,i=e.totalAmount,s=e.paymentMethodType,l=e.downloadUrl,d=n.replace(/[^\d]/g,"").replace(/^(\d{4})(\d{5})\d{1}(\d{10})\d{1}(\d{10})\d{1}(\d{15})$/,"$1$5$2$3$4");return oc(Xy,{reference:n,paymentMethodType:"boletobancario",barcode:a+"barcode.shtml?data="+d+"&barcodeType=BT_Int2of5A&fileType=png",introduction:r.get("voucher.introduction"),imageUrl:zc({loadingContext:a})(s),amount:i&&r.amount(i.value,i.currency),voucherDetails:[{label:r.get("voucher.expirationDate"),value:r.date(o)}],downloadUrl:l,copyBtn:!0})},Ov=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatData=function(){var e=this.state.data,t=void 0===e?{}:e,n=t.billingAddress,o=t.shopperEmail,i=t.firstName,s=t.lastName,l=t.socialSecurityNumber,d=void 0===l?"":l;return r(r(r(r({paymentMethod:{type:this.props.type||a.type}},n&&{billingAddress:n}),o&&{shopperEmail:o}),i&&s&&{shopperName:{firstName:i,lastName:s}}),d&&{socialSecurityNumber:yy(d)})},a.prototype.render=function(){return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?oc(Ev,r({ref:this.handleRef,icon:this.icon},this.props)):oc(jv,r({ref:this.handleRef},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="boletobancario",a}(hu),Rv=function(e){var t=lu(),r=t.i18n,a=t.loadingContext,n=e.alternativeReference,o=e.reference,s=e.expiresAt,l=e.merchantReference,d=e.totalAmount,c=e.paymentMethodType,u=e.downloadUrl,p=a+"barcode.shtml?data="+o+"&barcodeType=BT_Code128C&fileType=png",m=i(i(i([],s?[{label:r.get("voucher.expirationDate"),value:r.date(s)}]:[]),l?[{label:r.get("voucher.shopperReference"),value:l}]:[]),n?[{label:r.get("voucher.alternativeReference"),value:n}]:[]);return oc(Xy,{amount:d&&r.amount(d.value,d.currency),barcode:p,copyBtn:!0,downloadUrl:u,imageUrl:zc({loadingContext:a})(c),introduction:r.get("voucher.introduction"),paymentMethodType:"oxxo",reference:o,voucherDetails:m})},Lv=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),a.prototype.formatProps=function(e){return r(r({},e),{name:"Oxxo"})},a.prototype.formatData=function(){return{paymentMethod:{type:this.props.type||a.type}}},a.prototype.render=function(){return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?oc(Rv,r({ref:this.handleRef},this.props)):this.payButton(r(r({},this.props),{classNameModifiers:["standalone"],label:this.props.i18n.get("continueTo")+" "+this.props.name,onClick:this.submit})))},a.type="oxxo",a}(hu),Vv=function(e){var t=lu(),r=t.i18n,a=t.loadingContext,n=e.entity,o=e.reference,s=e.expiresAt,l=e.merchantReference,d=e.totalAmount,c=e.paymentMethodType,u=e.downloadUrl,p=i(i(i([],n?[{label:r.get("voucher.entity"),value:n}]:[]),s?[{label:r.get("voucher.expirationDate"),value:r.date(s)}]:[]),l?[{label:r.get("voucher.shopperReference"),value:l}]:[]);return oc(Xy,{amount:d&&r.amount(d.value,d.currency),barcode:null,copyBtn:!0,downloadUrl:u,imageUrl:zc({loadingContext:a})(c),introduction:r.get("voucher.introduction"),paymentMethodType:"multibanco",reference:o,voucherDetails:p})},Uv=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),a.prototype.formatProps=function(e){return r(r({},e),{name:e.name||"Multibanco"})},a.prototype.formatData=function(){return{paymentMethod:{type:this.props.type||a.type}}},a.prototype.render=function(){var e=this;return this.props.reference?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Vv,r({ref:this.handleRef},this.props))):this.props.showPayButton?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(My,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}})):null},a.type="multibanco",a.defaultProps={showPayButton:!0},a}(hu),Kv=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="dotpay",r}(uh),Hv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{showImage:!1})},a.type="eps",a}(uh);function qv(e){var t=e.children,r=e.classNames,a=void 0===r?[]:r,n=e.type,o=void 0===n?"error":n,i=e.icon;return oc("div",{className:Oc("adyen-checkout__alert-message","adyen-checkout__alert-message--"+o,a)},i&&oc(Tu,{className:"adyen-checkout__alert-message__icon",type:i}),t)}function Gv(e){e.brand;var t=e.amount,r=e.balance,n=e.transactionLimit,o=a(e,["brand","amount","balance","transactionLimit"]),i=lu().i18n,s=t.value>(null==n?void 0:n.value)?n:t,l=(null==r?void 0:r.value)-(null==s?void 0:s.value);return oc("div",{className:"adyen-checkout__giftcard-result"},oc("ul",{className:"adyen-checkout__giftcard-result__balance"},oc("li",{className:"adyen-checkout__giftcard-result__balance__item"},oc("span",{className:"adyen-checkout__giftcard-result__balance__title"},i.get("giftcardBalance")),oc("span",{className:"adyen-checkout__giftcard-result__balance__value adyen-checkout__giftcard-result__balance__value--amount"},i.amount(r.value,r.currency))),n&&n.value&&oc("li",{className:"adyen-checkout__giftcard-result__balance__item"},oc("span",{className:"adyen-checkout__giftcard-result__balance__title adyen-checkout__giftcard-result__balance__title--transactionLimit"},i.get("giftcardTransactionLimit",{values:{amount:i.amount(n.value,n.currency)}})))),this.props.showPayButton&&this.props.payButton({amount:s,status:o.status,onClick:o.onSubmit}),oc("p",{className:"adyen-checkout__giftcard-result__remaining-balance"},i.get("partialPayment.remainingBalance",{values:{amount:i.amount(l,r.currency)}})))}var Yv=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={status:"ready",data:{},balance:null,transactionLimit:null,focusedElement:!1,isValid:!1},t.onChange=function(e){t.props.onChange({data:e.data,isValid:e.isSfpValid})},t.showValidation=function(){t.sfp.showValidation()},t.handleFocus=function(e){t.setState({focusedElement:e.currentFocusObject}),!0===e.focus?t.props.onFocus(e):t.props.onBlur(e)},t.setBalance=function(e){var r=e.balance,a=e.transactionLimit;t.setState({balance:r,transactionLimit:a})},t}return t(a,e),a.prototype.setStatus=function(e){this.setState({status:e})},a.prototype.render=function(e,t){var a,n=this,o=t.focusedElement,s=t.balance,l=t.transactionLimit,d=lu().i18n,c=(null==l?void 0:l.value)<(null==s?void 0:s.value)?l:s,u=(null==c?void 0:c.value)>=(null===(a=this.props.amount)||void 0===a?void 0:a.value);if(c&&u)return oc(Gv,r({balance:s,transactionLimit:l,onSubmit:e.onSubmit},e));var p=function(e){if(e.errors.encryptedCardNumber)return d.get("error.va.gen.01");switch(n.state.status){case"no-balance":return d.get("error.giftcard.no-balance");case"card-error":return d.get("error.giftcard.card-error");case"currency-error":return d.get("error.giftcard.currency-error");default:return null}};return oc("div",{className:"adyen-checkout__giftcard"},"error"===this.state.status&&oc(qv,{icon:"cross"},d.get("error.message.unknown")),oc(Wf,r({},this.props,{ref:function(e){n.sfp=e},onChange:this.onChange,onFocus:this.handleFocus,type:kh,render:function(t,r){var a=t.setRootNode,n=t.setFocusOn;return oc("div",{ref:a,className:"adyen-checkout__field-wrapper"},oc(Ru,{label:d.get("creditCard.numberField.title"),classNameModifiers:i(["number"],e.pinRequired?["70"]:["100"]),errorMessage:p(r),focused:"encryptedCardNumber"===o,onFocusField:function(){return n("encryptedCardNumber")},dir:"ltr",name:"encryptedCardNumber"},oc(ay,{encryptedFieldType:"encryptedCardNumber","data-info":'{"length":"15-32", "maskInterval":4}',className:Oc({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0,"adyen-checkout__input--error":p(r),"adyen-checkout__input--focus":"encryptedCardNumber"===o})})),e.pinRequired&&oc(Ru,{label:d.get("creditCard.pin.title"),classNameModifiers:["pin","30"],errorMessage:r.errors.encryptedSecurityCode&&d.get(r.errors.encryptedSecurityCode),focused:"encryptedSecurityCode"===o,onFocusField:function(){return n("encryptedSecurityCode")},dir:"ltr",name:"encryptedSecurityCode"},oc(ay,{encryptedFieldType:"encryptedSecurityCode","data-info":'{"length":"3-10", "maskInterval": 0}',className:Oc({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":r.errors.encryptedSecurityCode,"adyen-checkout__input--focus":"encryptedSecurityCode"===o})})))}})),this.props.showPayButton&&this.props.payButton({status:this.state.status,onClick:this.props.onBalanceCheck,label:d.get("applyGiftcard")}))},a.defaultProps={pinRequired:!0,onChange:function(){},onFocus:function(){},onBlur:function(){}},a}(lc),Wv=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleBalanceCheck=function(e){return t.props.onBalanceCheck?new Promise((function(r,a){t.props.onBalanceCheck(r,a,e)})):t.props.session?t.props.session.checkBalance(e):void 0},t.onOrderRequest=function(e){return t.props.onOrderRequest?new Promise((function(r,a){t.props.onOrderRequest(r,a,e)})):t.props.session?t.props.session.createOrder():void 0},t.onBalanceCheck=function(){return t.props.session||t.props.onBalanceCheck?t.isValid?(t.setStatus("loading"),void t.handleBalanceCheck(t.formatData()).then((function(e){var r,a=e.balance,n=e.transactionLimit,o=void 0===n?{}:n;if(!a)throw new Error("card-error");if((null==a?void 0:a.currency)!==(null===(r=t.props.amount)||void 0===r?void 0:r.currency))throw new Error("currency-error");if((null==a?void 0:a.value)<=0)throw new Error("no-balance");if(t.componentRef.setBalance({balance:a,transactionLimit:o}),t.props.amount.value>a.value||t.props.amount.value>o.value)return t.props.order?t.submit():t.onOrderRequest(t.data).then((function(e){t.setState({order:{orderData:e.orderData,pspReference:e.pspReference}}),t.submit()}))})).catch((function(e){t.setStatus((null==e?void 0:e.message)||"error"),t.props.onError&&t.handleError(new mu("ERROR",e))}))):(t.showValidation(),!1):t.submit()},t.payButton=function(e){return oc(uu,r({},e))},t}return t(a,e),a.prototype.formatProps=function(e){return r(r({},null==e?void 0:e.configuration),e)},a.prototype.formatData=function(){var e,t;return{paymentMethod:{type:this.constructor.type,brand:this.props.brand,encryptedCardNumber:null===(e=this.state.data)||void 0===e?void 0:e.encryptedCardNumber,encryptedSecurityCode:null===(t=this.state.data)||void 0===t?void 0:t.encryptedSecurityCode}}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"icon",{get:function(){var e;return(null===(e=this.props.brandsConfiguration[this.props.brand])||void 0===e?void 0:e.icon)||this.props.icon||zc({loadingContext:this.props.loadingContext})(this.props.brand)},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Yv,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onBalanceCheck:this.onBalanceCheck,onSubmit:this.submit,payButton:this.payButton})))},a.type="giftcard",a.defaultProps={brandsConfiguration:{}},a}(hu),Jv=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return t(r,e),r.type="vipps",r.defaultProps={type:r.type,showPayButton:!0,name:"Vipps"},r}(jy),Zv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{showImage:!1})},a.type="payu_IN_cashcard",a}(uh),Qv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{showImage:!1})},a.type="payu_IN_nb",a}(uh),$v=["AT","CH","DE","NL"],Xv=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:$v})},a.type="ratepay",a}(Sm),eg=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r({shouldRedirectOnMobile:!0,delay:2e3,countdownTime:15,instructions:"swish.pendingMessage"},e.prototype.formatProps.call(this,t))},a.type="swish",a}(gv),tg={isDropin:!0,onReady:function(){},onComplete:function(){},onCancel:function(){},onError:function(){},onSelect:function(){},onDisableStoredPaymentMethod:null,onChange:function(){},amount:{},installmentOptions:{},paymentMethodsConfiguration:{},openFirstPaymentMethod:!0,openFirstStoredPaymentMethod:!0,showStoredPaymentMethods:!0,showPaymentMethods:!0,showRemoveStoredPaymentMethodButton:!1,showPayButton:!0},rg=function(e){var t=e.paymentMethodComponent,r=e.isLoaded;return t&&r?oc("div",{className:"adyen-checkout__payment-method__details__content"},t):null},ag={"adyen-checkout__payment-methods-list":"DropinComponent-module_adyen-checkout__payment-methods-list__2T9kQ","adyen-checkout__payment-method":"DropinComponent-module_adyen-checkout__payment-method__2ZClo","adyen-checkout__payment-method__details":"DropinComponent-module_adyen-checkout__payment-method__details__2_jFP","adyen-checkout__payment-method__image":"DropinComponent-module_adyen-checkout__payment-method__image__Fg2uw","adyen-checkout__payment-method__image__wrapper":"DropinComponent-module_adyen-checkout__payment-method__image__wrapper__pTTKr","adyen-checkout__payment-method--selected":"DropinComponent-module_adyen-checkout__payment-method--selected__1zXEA"},ng=["googlepay","paywithgoogle"],og=function(e){var t=e.src,r=e.altDescription,a=e.type,n=e.disabled,o=void 0!==n&&n;return oc("span",{className:Oc("adyen-checkout__payment-method__image__wrapper",ag["adyen-checkout__payment-method__image__wrapper"],{"adyen-checkout__payment-method__image__wrapper--outline":!ng.includes(a),"adyen-checkout__payment-method__image__wrapper--disabled":!!o})},oc(ap,{className:"adyen-checkout__payment-method__image "+ag["adyen-checkout__payment-method__image"],src:t,alt:r,focusable:"false"}))},ig=function(e){var t=e.id,r=e.open,a=e.onDisable,n=e.onCancel,o=lu().i18n;return oc("div",{id:t,"aria-hidden":!r,className:Oc({"adyen-checkout__payment-method__disable-confirmation":!0,"adyen-checkout__payment-method__disable-confirmation--open":r})},oc("div",{className:"adyen-checkout__payment-method__disable-confirmation__content"},o.get("storedPaymentMethod.disable.confirmation"),oc("div",{className:"adyen-checkout__payment-method__disable-confirmation__buttons"},oc("button",{type:"button",className:Oc("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--remove"),disabled:!r,onClick:a},o.get("storedPaymentMethod.disable.confirmButton")),oc("button",{type:"button",className:Oc("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--cancel"),disabled:!r,onClick:n},o.get("storedPaymentMethod.disable.cancelButton")))))},sg=function(e){function r(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={showDisableStoredPaymentMethodConfirmation:!1},t.isMouseDown=!1,t.onFocus=function(){t.isMouseDown||t.props.onSelect()},t.onClick=function(){t.props.onSelect()},t.onMouseDown=function(){t.isMouseDown=!0},t.onMouseUp=function(){t.isMouseDown=!1},t.toggleDisableConfirmation=function(){t.setState({showDisableStoredPaymentMethodConfirmation:!t.state.showDisableStoredPaymentMethodConfirmation})},t.onDisableStoredPaymentMethod=function(){t.props.onDisableStoredPaymentMethod(t.props.paymentMethod),t.toggleDisableConfirmation()},t}return t(r,e),r.prototype.componentDidMount=function(){var e=this;this.props.paymentMethod.eventEmitter.on("brand",(function(t){e.setState({activeBrand:t.brand})}))},r.prototype.componentWillUnmount=function(){var e=this;this.props.paymentMethod.eventEmitter.off("brand",(function(t){e.setState({activeBrand:t.brand})}))},r.prototype.render=function(e,t){var r,a,n=e.paymentMethod,o=e.isSelected,i=e.isDisabling,s=e.isLoaded,l=e.isLoading,d=e.onSelect,c=e.standalone,u=t.activeBrand,p=void 0===u?null:u,m=lu().i18n;if(!n)return null;var h=Oc(((r={"adyen-checkout__payment-method":!0})[ag["adyen-checkout__payment-method"]]=!0,r["adyen-checkout__payment-method--"+n.props.type]=!0,r["adyen-checkout__payment-method--"+(null!==(a=n.props.fundingSource)&&void 0!==a?a:"credit")]=!0,r["adyen-checkout__payment-method--selected"]=o,r[ag["adyen-checkout__payment-method--selected"]]=o,r["adyen-checkout__payment-method--loading"]=l,r["adyen-checkout__payment-method--disabling"]=i,r["adyen-checkout__payment-method--confirming"]=this.state.showDisableStoredPaymentMethodConfirmation,r["adyen-checkout__payment-method--standalone"]=c,r[ag["adyen-checkout__payment-method--loading"]]=l,r[n._id]=!0,r[this.props.className]=!0,r)),f=this.props.showRemovePaymentMethodButton&&n.props.oneClick&&o,y="remove-"+n._id,b="container-"+n._id,v="button-"+n._id,g=!n.props.oneClick&&n.brands&&n.brands.length>0;return oc("li",{key:n._id,className:h,onFocus:this.onFocus,onClick:d,onMouseDown:this.onMouseDown,onMouseUp:this.onMouseUp,"aria-labelledby":v},oc("div",{className:"adyen-checkout__payment-method__header"},oc("button",{className:"adyen-checkout__payment-method__header__title",id:v,"aria-label":n.accessibleName,"aria-expanded":o,"aria-controls":b,onClick:d},oc("span",{className:Oc({"adyen-checkout__payment-method__radio":!0,"adyen-checkout__payment-method__radio--selected":o}),"aria-hidden":"true"}),oc(og,{altDescription:n.props.name,type:n.type,src:n.icon}),oc("span",{className:Oc({"adyen-checkout__payment-method__name":!0,"adyen-checkout__payment-method__name--selected":o})},n.displayName)),f&&oc("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:this.toggleDisableConfirmation,"aria-expanded":this.state.showDisableStoredPaymentMethodConfirmation,"aria-controls":y},m.get("storedPaymentMethod.disable.button")),g&&oc("span",{className:"adyen-checkout__payment-method__brands"},n.brands.map((function(e){return oc(og,{key:e.name,altDescription:e.name,type:e.name,disabled:p&&e.name!==p,src:e.icon})})))),oc("div",{className:"adyen-checkout__payment-method__details "+ag["adyen-checkout__payment-method__details"],id:b,role:"region","aria-labelledby":v},f&&oc(ig,{id:y,open:this.state.showDisableStoredPaymentMethodConfirmation,onDisable:this.onDisableStoredPaymentMethod,onCancel:this.toggleDisableConfirmation}),oc(rg,{paymentMethodComponent:n.render(),isLoaded:s})))},r.defaultProps={paymentMethod:null,isSelected:!1,isLoaded:!1,isLoading:!1,showDisableStoredPaymentMethodConfirmation:!1,onSelect:function(){}},r}(lc),lg=function(e){var t,r=e.order,a=e.orderStatus,n=e.onOrderCancel,o=lu(),i=o.loadingContext,s=o.i18n;return oc("div",null,oc("ul",{className:"adyen-checkout__order-payment-methods-list"},null===(t=null==a?void 0:a.paymentMethods)||void 0===t?void 0:t.map((function(e,t){return oc("li",{key:e.type+"-"+t,className:"adyen-checkout__order-payment-method"},oc("div",{className:"adyen-checkout__order-payment-method__header"},oc("div",{className:"adyen-checkout__payment-method__header__title"},oc(og,{altDescription:e.name,type:e.type,src:zc({loadingContext:i})(e.type)}),"\u2022\u2022\u2022\u2022 ",e.lastFour),n&&oc("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:function(){n({order:r})}},s.get("storedPaymentMethod.disable.button"))),oc("div",{className:"adyen-checkout__order-payment-method__details"},oc("div",{className:"adyen-checkout__order-payment-method__deducted-amount"},oc("div",{className:"adyen-checkout__order-payment-method__deducted-amount__label"},s.get("deductedBalance")),oc("div",{className:"adyen-checkout__order-payment-method__deducted-amount__value"},s.amount(e.amount.value,e.amount.currency)))))}))),a.remainingAmount&&oc("div",{className:"adyen-checkout__order-remaining-amount"},s.get("partialPayment.warning")," ",oc("strong",null,s.amount(a.remainingAmount.value,a.remainingAmount.currency))))},dg=function(e){function r(){var t=null!==e&&e.apply(this,arguments)||this;return t.onSelect=function(e){return function(){return t.props.onSelect(e)}},t}return t(r,e),r.prototype.componentDidMount=function(){if(this.props.paymentMethods[0]){var e=this.props.paymentMethods[0];(this.props.openFirstStoredPaymentMethod&&!0===Dc(e,"props.oneClick")||this.props.openFirstPaymentMethod)&&this.onSelect(e)()}},r.prototype.render=function(e){var t,r=this,a=e.paymentMethods,n=e.activePaymentMethod,o=e.cachedPaymentMethods,i=e.isLoading,s=Oc(((t={})[ag["adyen-checkout__payment-methods-list"]]=!0,t["adyen-checkout__payment-methods-list"]=!0,t["adyen-checkout__payment-methods-list--loading"]=i,t));return oc(sc,null,this.props.orderStatus&&oc(lg,{order:this.props.order,orderStatus:this.props.orderStatus,onOrderCancel:this.props.onOrderCancel}),oc("ul",{className:s},a.map((function(e,t,s){var l=n&&n._id===e._id,d=e._id in o,c=n&&s[t+1]&&n._id===s[t+1]._id;return oc(sg,{className:Oc({"adyen-checkout__payment-method--next-selected":c}),standalone:1===a.length,paymentMethod:e,isSelected:l,isDisabling:l&&r.props.isDisabling,isLoaded:d,isLoading:i,onSelect:r.onSelect(e),key:e._id,showRemovePaymentMethodButton:r.props.showRemovePaymentMethodButton,onDisableStoredPaymentMethod:r.props.onDisableStoredPaymentMethod})}))))},r.defaultProps={paymentMethods:[],activePaymentMethod:null,cachedPaymentMethods:{},orderStatus:null,onSelect:function(){},onDisableStoredPaymentMethod:function(){},isDisabling:!1,isLoading:!1},r}(lc),cg=function(e){var t=e.message,r=lu(),a=r.i18n,n=r.loadingContext;return oc("div",{className:"adyen-checkout__status adyen-checkout__status--success"},oc(ap,{height:"88",className:"adyen-checkout__status__icon",src:zc({loadingContext:n,extension:"gif",imageFolder:"components/"})("success"),alt:a.get(t||"creditCard.success")}),oc("span",{className:"adyen-checkout__status__text"},a.get(t||"creditCard.success")))},ug=function(e){var t=e.message,r=lu(),a=r.loadingContext,n=r.i18n;return oc("div",{className:"adyen-checkout__status adyen-checkout__status--error"},oc(ap,{className:"adyen-checkout__status__icon",src:zc({loadingContext:a,extension:"gif",imageFolder:"components/"})("error"),alt:n.get(t||"error.message.unknown"),height:"88"}),oc("span",{className:"adyen-checkout__status__text"},n.get(t||"error.message.unknown")))};function pg(e,t){var r={path:"v1/order/status?clientKey="+e.clientKey,loadingContext:e.loadingContext};return bm(r,{orderData:t.orderData})}var mg=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={elements:[],orderStatus:null,isDisabling:!1,status:{type:"loading"},activePaymentMethod:null,cachedPaymentMethods:{}},t.prepareDropinData=function(){var e=t.props,r=e.order,a=e.clientKey,n=e.loadingContext,o=t.props.onCreateElements(),s=o[0],l=o[1],d=r?pg({clientKey:a,loadingContext:n},r):null;Promise.all([s,l,d]).then((function(e){var r=e[0],a=e[1],n=e[2];t.setState({elements:i(i([],r),a),orderStatus:n}),t.setStatus({type:"ready"}),t.props.modules.analytics&&t.props.modules.analytics.send({containerWidth:t.base&&t.base.offsetWidth,paymentMethods:a.map((function(e){return e.props.type})),component:"dropin",flavor:"dropin"})}))},t.setStatus=function(e){t.setState({status:e})},t.setActivePaymentMethod=function(e){t.setState((function(t){var a;return{activePaymentMethod:e,cachedPaymentMethods:r(r({},t.cachedPaymentMethods),(a={},a[e._id]=!0,a))}}))},t.handleOnSelectPaymentMethod=function(e){var r=t.state.activePaymentMethod;t.setActivePaymentMethod(e),(r&&r._id!==e._id||!r)&&t.props.onSelect(e)},t.handleDisableStoredPaymentMethod=function(e){t.setState({isDisabling:!0}),new Promise((function(r,a){return t.props.onDisableStoredPaymentMethod(e.props.storedPaymentMethodId,r,a)})).then((function(){t.setState((function(t){return{elements:t.elements.filter((function(t){return t._id!==e._id}))}})),t.setState({isDisabling:!1})})).catch((function(){t.setState({isDisabling:!1})}))},t}return t(a,e),a.prototype.componentDidMount=function(){this.prepareDropinData()},a.prototype.componentDidUpdate=function(e,t){t.status.type!==this.state.status.type&&this.state.activePaymentMethod&&this.state.activePaymentMethod.setStatus(this.state.status.type),"ready"===this.state.status.type&&"ready"!==t.status.type&&this.props.onReady&&this.props.onReady()},a.prototype.closeActivePaymentMethod=function(){this.setState({activePaymentMethod:null})},a.prototype.render=function(e,t){var r,a,n=t.elements,o=t.status,i=t.activePaymentMethod,s=t.cachedPaymentMethods,l="loading"===o.type,d="redirect"===o.type;switch(o.type){case"success":return oc(cg,{message:null===(r=o.props)||void 0===r?void 0:r.message});case"error":return oc(ug,{message:null===(a=o.props)||void 0===a?void 0:a.message});case"custom":return o.props.component.render();default:return oc("div",{className:"adyen-checkout__dropin adyen-checkout__dropin--"+o.type},d&&o.props.component&&o.props.component.render(),l&&o.props&&o.props.component&&o.props.component.render(),n&&!!n.length&&oc(dg,{isLoading:l||d,isDisabling:this.state.isDisabling,paymentMethods:n,activePaymentMethod:i,cachedPaymentMethods:s,order:this.props.order,orderStatus:this.state.orderStatus,onOrderCancel:this.props.onOrderCancel,onSelect:this.handleOnSelectPaymentMethod,openFirstPaymentMethod:this.props.openFirstPaymentMethod,openFirstStoredPaymentMethod:this.props.openFirstStoredPaymentMethod,onDisableStoredPaymentMethod:this.handleDisableStoredPaymentMethod,showRemovePaymentMethodButton:this.props.showRemovePaymentMethodButton}))}},a}(lc);var hg=["androidpay","samsungpay"],fg=function(e){return!hg.includes(e.constructor.type)},yg=function(e){return!!e},bg=function(e){if(e.isAvailable){var t=new Promise((function(e,t){return setTimeout(t,5e3)}));return Promise.race([e.isAvailable(),t])}return Promise.resolve(!!e)},vg=function(e,t,r){void 0===e&&(e=[]);var a=e.map((function(e){return r(e,t)})).filter(yg).filter(fg),n=a.map(bg).map((function(e){return e.catch((function(e){return e}))}));return Promise.all(n).then((function(e){return a.filter((function(t,r){return!0===e[r]}))}))},gg=function(e){function a(t){var a=e.call(this,t)||this;return a.dropinRef=null,a.handleCreate=function(){var e=a.props,t=e.paymentMethods,n=e.storedPaymentMethods,o=e.showStoredPaymentMethods,i=e.showPaymentMethods,s=function(e){return{beforeSubmit:e.beforeSubmit,onSubmit:e.onSubmit,elementRef:e.elementRef,showPayButton:e.showPayButton,isDropin:!0}}(r(r({},a.props),{elementRef:a.elementRef}));return[o?function(e,t,a){return void 0===e&&(e=[]),vg(e,r(r({},t),{oneClick:!0}),a)}(n,s,a._parentInstance.create):[],i?vg(t,s,a._parentInstance.create):[]]},a.submit=a.submit.bind(a),a.handleAction=a.handleAction.bind(a),a}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.dropinRef&&!!this.dropinRef.state.activePaymentMethod&&!!this.dropinRef.state.activePaymentMethod.isValid},enumerable:!1,configurable:!0}),a.prototype.showValidation=function(){return this.dropinRef.state.activePaymentMethod&&this.dropinRef.state.activePaymentMethod.showValidation(),this},a.prototype.setStatus=function(e,t){var r;return void 0===t&&(t={}),null===(r=this.dropinRef)||void 0===r||r.setStatus({type:e,props:t}),this},Object.defineProperty(a.prototype,"activePaymentMethod",{get:function(){var e,t;return(null===(e=this.dropinRef)||void 0===e?void 0:e.state)||(null===(t=this.dropinRef)||void 0===t?void 0:t.state.activePaymentMethod)?this.dropinRef.state.activePaymentMethod:null},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"data",{get:function(){return this.activePaymentMethod?this.dropinRef.state.activePaymentMethod.data:null},enumerable:!1,configurable:!0}),a.prototype.submit=function(){if(!this.activePaymentMethod)throw new Error("No active payment method.");this.activePaymentMethod.submit()},a.prototype.handleAction=function(e,t){var a;if(void 0===t&&(t={}),!e||!e.type)throw new Error("Invalid Action");if("redirect"!==e.type&&(null===(a=this.activePaymentMethod)||void 0===a?void 0:a.updateWithAction))return this.activePaymentMethod.updateWithAction(e);var n=this._parentInstance.createFromAction(e,r(r({},t),{elementRef:this.elementRef,onAdditionalDetails:this.handleAdditionalDetails,isDropin:!0}));return n?this.setStatus(n.props.statusType,{component:n}):null},a.prototype.closeActivePaymentMethod=function(){this.dropinRef.closeActivePaymentMethod()},a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(mg,r({},this.props,{onChange:this.setState,elementRef:this.elementRef,onCreateElements:this.handleCreate,ref:function(t){e.dropinRef=t}})))},a.type="dropin",a.defaultProps=tg,a}(hu),kg="AchInput-module_sf-input__wrapper__1V7mk",Cg="AchInput-module_adyen-checkout__input__1SeSl",_g=function(e){var t,r=e.id,a=e.dataInfo,n=e.className,o=void 0===n?"":n,i=e.label,s=e.focused,l=e.filled,d=e.errorMessage,c=void 0===d?"":d,u=e.isValid,p=void 0!==u&&u,m=e.onFocusField,h=e.dir,f="encrypted"+(r.charAt(0).toUpperCase()+r.slice(1));return oc(Ru,{label:i,focused:s,filled:l,classNameModifiers:[r],onFocusField:function(){return m(f)},errorMessage:c,isValid:p,className:o,dir:h,name:r},oc(ay,{encryptedFieldType:f,"data-info":a,className:Oc((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},t[Cg]=!0,t["adyen-checkout__input--error"]=c.length,t["adyen-checkout__input--focus"]=s,t["adyen-checkout__input--valid"]=p,t))}))},Ng=function(e){var t=e.focusedElement,r=e.onFocusField,a=e.errors,n=e.valid,o=lu().i18n;return oc("div",{className:"adyen-checkout__ach-sf__form adyen-checkout__field-wrapper"},oc(_g,{id:"bankAccountNumber",focused:"encryptedBankAccountNumber"===t,isValid:!!n.encryptedBankAccountNumber,label:o.get("ach.accountNumberField.title"),onFocusField:r,filled:!!a.encryptedBankAccountNumber||!!n.encryptedBankAccountNumber,errorMessage:!!a.encryptedBankAccountNumber&&o.get("ach.accountNumberField.invalid"),dataInfo:'{"length":"4-17", "maskInterval": 4}',className:"adyen-checkout__field--50",dir:"ltr"}),oc(_g,{id:"bankLocationId",focused:"encryptedBankLocationId"===t,isValid:!!n.encryptedBankLocationId,label:o.get("ach.accountLocationField.title"),onFocusField:r,filled:!!a.encryptedBankLocationId||!!n.encryptedBankLocationId,errorMessage:!!a.encryptedBankLocationId&&o.get("ach.accountLocationField.invalid"),dataInfo:'{"length":9}',className:"adyen-checkout__field--50",dir:"ltr"}))},wg={base:{caretColor:"#0066FF"}};function Pg(e,t){return void 0===t&&(t=!1),!t||!!e&&"string"==typeof e&&e.trim().length>0}function Fg(e){var t=this,a=lu().i18n,n=e.hasHolderName&&(e.holderName||e.data.holderName),o=Wc({}),i=o[0],s=o[1],l=Wc(r({},e.holderNameRequired&&{holderName:n})),d=l[0],c=l[1],u=Wc(r({},e.hasHolderName&&{holderName:e.holderName||e.data.holderName})),p=u[0],m=u[1],h=Wc(e.billingAddressRequired?e.data.billingAddress:null),f=h[0],y=h[1],b=Wc(!1),v=b[0],g=b[1],k=Wc(""),C=k[0],_=k[1],N=function(e){y(r(r({},f),e.data)),c(r(r({},d),{billingAddress:e.isValid}))},w=function(t){var a=t.target.value;m(r(r({},p),{holderName:a})),s(r(r({},i),{holderName:!!e.holderNameRequired&&!Pg(a)})),c(r(r({},d),{holderName:!e.holderNameRequired||Pg(a,e.holderNameRequired)}))},P=$c(null),F=$c(null),D=Wc("ready"),A=D[0],S=D[1];return this.setStatus=function(e){S(e)},this.showValidation=function(){P.current.showValidation(),e.holderNameRequired&&!d.holderName&&s(r(r({},i),{holderName:!0})),F.current&&F.current.showValidation()},Zc((function(){return t.setFocusOn=P.current.setFocusOn,t.updateStyles=P.current.updateStyles,function(){P.current.destroy()}}),[]),Zc((function(){var t=Pg(p.holderName,e.holderNameRequired),r=v,a=!e.billingAddressRequired||Boolean(d.billingAddress),n=r&&t&&a;e.onChange({data:p,isValid:n,billingAddress:f})}),[p,d,i]),oc("div",{className:"adyen-checkout__ach"},oc(Wf,r({ref:P},e,{styles:r(r({},wg),e.styles),onChange:function(t){var a=t,n=a.autoCompleteName?a.autoCompleteName:p.holderName;m(r(r(r({},p),a.data),{holderName:n})),s(r(r({},i),a.errors)),c(r(r(r({},d),a.valid),{holderName:!e.holderNameRequired||Pg(n,e.holderNameRequired)})),g(a.isSfpValid)},onFocus:function(t){var r=!0===t.focus;_(t.currentFocusObject),r?e.onFocus(t):e.onBlur(t)},render:function(t,r){var n=t.setRootNode,o=t.setFocusOn;return oc("div",{ref:n,className:"adyen-checkout__ach-input "+kg},oc(ty,{status:r.status},oc("div",{className:Oc(["adyen-checkout__fieldset","adyen-checkout__fieldset--ach"])},oc("div",{className:"adyen-checkout__fieldset__title"},a.get("ach.bankAccount")),e.hasHolderName&&oc(Ru,{label:a.get("ach.accountHolderNameField.title"),className:"adyen-checkout__pm__holderName",errorMessage:!!i.holderName&&a.get("ach.accountHolderNameField.invalid"),isValid:!!d.holderName,name:"holderName"},cp("text",{className:"adyen-checkout__pm__holderName__input "+Cg,placeholder:e.placeholders.holderName||a.get("ach.accountHolderNameField.placeholder"),value:p.holderName,required:e.holderNameRequired,onInput:w})),oc(Ng,{focusedElement:C,onFocusField:o,errors:r.errors,valid:r.valid})),e.billingAddressRequired&&oc(Nm,{label:"billingAddress",data:f,onChange:N,allowedCountries:e.billingAddressAllowedCountries,requiredFields:e.billingAddressRequiredFields,ref:F})))}})),e.showPayButton&&e.payButton({status:A,label:a.get("confirmPurchase")}))}Fg.defaultProps={details:[],type:"ach",hasHolderName:!0,holderNameRequired:!0,billingAddressRequired:!0,billingAddressAllowedCountries:["US","PR"],onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},holderName:"",data:{holderName:"",billingAddress:{}},styles:{},placeholders:{}};var Dg=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(e){var t;return r(r({},e),{holderNameRequired:null!==(t=e.hasHolderName)&&void 0!==t?t:e.holderNameRequired})},a.prototype.formatData=function(){var e,t=r(r({type:a.type},this.state.data),{ownerName:null===(e=this.state.data)||void 0===e?void 0:e.holderName});return delete t.holderName,r({paymentMethod:t},this.state.billingAddress&&{billingAddress:this.state.billingAddress})},a.prototype.updateStyles=function(e){return this.componentRef&&this.componentRef.updateStyles&&this.componentRef.updateStyles(e),this},a.prototype.setFocusOn=function(e){return this.componentRef&&this.componentRef.setFocusOn&&this.componentRef.setFocusOn(e),this},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Fg,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="ach",a}(hu),Ag=/^[+]*[0-9]{1,4}[\s/0-9]*$/;function Sg(e){var t=lu().i18n,r=gp({schema:["telephoneNumber"],defaultData:e.data,rules:{telephoneNumber:{validate:function(e){return Ag.test(e)&&e.length>=7},errorMessage:"mobileNumber.invalid",modes:["blur"]}},formatters:{telephoneNumber:function(e){return e.replace(/[^0-9+\s]/g,"")}}}),a=r.handleChangeFor,n=r.triggerValidation,o=r.data,i=r.valid,s=r.errors,l=r.isValid,d=Wc("ready"),c=d[0],u=d[1];return this.setStatus=u,this.showValidation=n,Zc((function(){e.onChange({data:o,valid:i,errors:s,isValid:l})}),[o,i,s,l]),oc("div",{className:"adyen-checkout__mb-way"},oc(Ru,{errorMessage:!!s.telephoneNumber&&t.get("mobileNumber.invalid"),label:t.get("mobileNumber"),className:Oc("adyen-checkout__input--phone-number"),isValid:i.telephoneNumber,dir:"ltr",name:"telephoneNumber"},cp("tel",{value:o.telephoneNumber,className:"adyen-checkout__pm__phoneNumber__input",placeholder:e.placeholders.telephoneNumber,required:!0,autoCorrect:"off",onChange:a("telephoneNumber","blur"),onInput:a("telephoneNumber","input")})),e.showPayButton&&e.payButton({status:c,label:t.get("confirmPurchase")}))}Sg.defaultProps={onChange:function(){}};var xg=2e3,Bg=15,Tg=6e4,zg=1e4,Ig="mbway",Mg="mbway.confirmPayment",jg="await.waitForConfirmation",Eg=!1;function Og(e){var t=this,n=lu(),o=n.i18n,i=n.loadingContext,s=Wc(!1),l=s[0],d=s[1],c=Wc(!1),u=c[0],p=c[1],m=Wc(!0),h=m[0],f=m[1],y=Wc(e.delay),b=y[0],v=y[1],g=Wc(100),k=g[0],C=g[1],_=Wc(0),N=_[0],w=_[1],P=Wc(!1),F=P[0],D=P[1],A=Wc(null),S=A[0],x=A[1],B=function(){fv(e.paymentData,e.clientKey,i).then(bv).catch((function(e){var n=e.message,o=a(e,["message"]);return{type:"network-error",props:r(r({},n&&{message:t.props.i18n.get(n)}),o)}})).then((function(r){switch(r.type){case"success":!function(r){d(!0);var a={data:{details:{payload:r.props.payload},paymentData:e.paymentData}};e.onComplete(a,t)}(r);break;case"error":!function(r){p(!0);var a={data:{details:{payload:r.props.payload},paymentData:e.paymentData}};e.onComplete(a,t)}(r);break;default:f(!1)}}))};Zc((function(){var r=e.shouldRedirectOnMobile,a=e.url,n=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent);return r&&a&&n?t.redirectToApp(a,B):B(),function(){clearTimeout(S)}}),[]),Zc((function(){if(u)return clearTimeout(S);if(l)return clearTimeout(S);if(!h){x(setTimeout((function(){B();var t=N+b;w(t),t>=e.throttleTime&&!F&&(v(e.throttleInterval),D(!0))}),b))}}),[h,N,u,l]);var T=function(e,t){return oc("div",{className:"adyen-checkout__await adyen-checkout__await--result"},oc("img",{className:"adyen-checkout__await__icon adyen-checkout__await__icon--result",src:zc({loadingContext:i,imageFolder:"components/"})(e),alt:o.get(t)}),oc("div",{className:"adyen-checkout__await__subtitle adyen-checkout__await__subtitle--result"},o.get(t)))};if(u)return T("error","error.subtitle.payment");if(l)return T("success","creditCard.success");if(h)return oc("div",{className:"adyen-checkout__await"},e.brandLogo&&oc("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),oc(Rc,{inline:!1,size:"large"}));var z=o.get("wechatpay.timetopay").split("%@");return oc("div",{className:Oc("adyen-checkout__await","adyen-checkout__await--"+e.type,e.classNameModifiers.map((function(e){return"adyen-checkout__await--"+e})))},e.brandLogo&&oc("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),oc("div",{className:"adyen-checkout__await__subtitle"},e.messageText),oc("div",{className:"adyen-checkout__await__indicator-holder"},oc("div",{className:"adyen-checkout__await__indicator-spinner"},oc(Rc,{inline:!1,size:"medium"})),oc("div",{className:"adyen-checkout__await__indicator-text"},e.awaitText)),e.showCountdownTimer&&oc("div",{className:"adyen-checkout__await__countdown-holder"},oc("div",{className:"adyen-checkout__await__progress"},oc("span",{className:"adyen-checkout__await__percentage",style:{width:k+"%"}})),oc("div",{className:"adyen-checkout__await__countdown"},z[0],"\xa0",oc(hv,{minutesFromNow:e.countdownTime,onTick:function(e){C(e.percentage)},onCompleted:function(){p(!0),clearTimeout(S),e.onError(new mu("ERROR","Payment Expired"))}}),"\xa0",z[1])),e.url&&oc("div",{className:"adyen-checkout__await__app-link"},oc("span",{className:"adyen-checkout__await__separator__label"},o.get("or")),oc(du,{classNameModifiers:["await"],onClick:function(){return t=e.url,void 0===r&&(r=function(){}),setTimeout((function(){e.onError(new mu("ERROR",e.type+" App was not found")),r()}),25),void window.location.assign(t);var t,r},label:o.get("openApp")})))}Og.defaultProps={countdownTime:15,onError:function(){},onComplete:function(){},throttleTime:6e4,throttleInterval:1e4,showCountdownTimer:!0,classNameModifiers:[],shouldRedirectOnMobile:!1,url:null};var Rg=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(e){var t=e.data,a=void 0===t?{}:t,n=e.placeholders,o=void 0===n?{}:n;return r(r({},e),{data:{telephoneNumber:a.telephoneNumber||a.phoneNumber},placeholders:{telephoneNumber:o.telephoneNumber||o.phoneNumber||"+351 932 123 456"}})},a.prototype.formatData=function(){var e;return{paymentMethod:r({type:a.type},(null===(e=this.state.data)||void 0===e?void 0:e.telephoneNumber)&&{telephoneNumber:this.state.data.telephoneNumber})}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return this.props.paymentData?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Og,{ref:function(t){e.componentRef=t},clientKey:this.props.clientKey,paymentData:this.props.paymentData,onError:this.props.onError,onComplete:this.onComplete,brandLogo:this.icon,type:Ig,messageText:this.props.i18n.get(Mg),awaitText:this.props.i18n.get(jg),showCountdownTimer:Eg,delay:xg,countdownTime:Bg,throttleTime:Tg,throttleInterval:zg})):oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Sg,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="mbway",a}(hu);function Lg(e){var t=this,r=lu(),a=r.i18n,n=r.loadingContext,o=gp({schema:["blikCode"],rules:{blikCode:{validate:function(e){return 6===(null==e?void 0:e.length)},errorMessage:"blik.invalid",modes:["blur"]}}}),i=o.handleChangeFor,s=o.triggerValidation,l=o.data,d=o.valid,c=o.errors,u=o.isValid;Zc((function(){e.onChange({data:l,errors:c,valid:d,isValid:u},t)}),[l,d,c,u]);var p=Wc("ready"),m=p[0],h=p[1];return this.setStatus=h,this.showValidation=s,oc("div",{className:"adyen-checkout__blik"},oc("p",{className:"adyen-checkout__blik__helper"},a.get("blik.help")),oc(Ru,{errorMessage:!!c.blikCode&&a.get(c.blikCode.errorMessage),label:a.get("blik.code"),classNameModifiers:["blikCode","50"],isValid:d.blikCode,dir:"ltr"},cp("text",{value:l.blikCode,name:"blikCode",spellcheck:!1,required:!0,autocorrect:"off",onInput:i("blikCode","input"),onChange:i("blikCode","blur"),placeholder:"123456",maxLength:6})),e.showPayButton&&e.payButton({status:m,icon:zc({loadingContext:n,imageFolder:"components/"})("lock")}))}Lg.defaultProps={data:{blikCode:""}};var Vg=2e3,Ug=15,Kg=6e4,Hg=1e4,qg="blik",Gg="blik.confirmPayment",Yg="await.waitForConfirmation",Wg=!1,Jg=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatData=function(){var e=!!this.props.storedPaymentMethodId;return{paymentMethod:r(r({type:a.type},!e&&{blikCode:this.state.data.blikCode}),e&&{storedPaymentMethodId:this.props.storedPaymentMethodId})}},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.props.storedPaymentMethodId||!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return this.props.paymentData?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Og,{ref:function(t){e.componentRef=t},clientKey:this.props.clientKey,paymentData:this.props.paymentData,onError:this.handleError,onComplete:this.onComplete,brandLogo:this.icon,type:qg,messageText:this.props.i18n.get(Gg),awaitText:this.props.i18n.get(Yg),showCountdownTimer:Wg,delay:Vg,countdownTime:Ug,throttleTime:Kg,throttleInterval:Hg})):oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.storedPaymentMethodId?oc(My,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}}):oc(Lg,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},a.type="blik",a}(hu);function Zg(e){var t=e.reference,r=e.totalAmount,a=e.paymentMethodType,n=lu(),o=n.loadingContext,i=n.i18n;return oc(Xy,{paymentMethodType:a,introduction:i.get("bankTransfer.instructions"),imageUrl:zc({loadingContext:o})(a),amount:r&&i.amount(r.value,r.currency),voucherDetails:[{label:i.get("bankTransfer.beneficiary"),value:e.beneficiary},{label:i.get("bankTransfer.iban"),value:e.iban},{label:i.get("bankTransfer.bic"),value:e.bic},{label:i.get("bankTransfer.reference"),value:t}]})}function Qg(e){var t=lu().i18n,r=Wc(!1),a=r[0],n=r[1],o=gp({schema:[],defaultData:e.data}),i=o.handleChangeFor,s=o.triggerValidation,l=o.data,d=o.valid,c=o.errors,u=o.isValid,p=o.setSchema;return Zc((function(){p(a?["shopperEmail"]:[])}),[a]),this.showValidation=s,Zc((function(){e.onChange({data:l,errors:c,valid:d,isValid:u})}),[l,d,c,a,u]),oc("div",{className:"adyen-checkout__bankTransfer"},oc("p",{className:"adyen-checkout__bankTransfer__introduction"},t.get("bankTransfer.introduction")),oc(Iv,{classNames:"adyen-checkout__bankTransfer__emailField",value:l.shopperEmail,errors:c.shopperEmail,onToggle:function(){return n(!a)},onInput:i("shopperEmail","input"),onChange:i("shopperEmail","blur")}))}var $g=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={isValid:!t.props.showEmailAddress,data:{}},t.handleRef=function(e){t.componentRef=e},t}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatData=function(){var e=this.state.data.shopperEmail;return r({paymentMethod:{type:a.type}},e&&{shopperEmail:e})},a.prototype.render=function(){return this.props.reference?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Zg,r({ref:this.handleRef},this.props))):this.props.showPayButton?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.showEmailAddress&&oc(Qg,r({ref:this.handleRef},this.props,{onChange:this.setState})),oc(My,r({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton}))):null},a.type="bankTransfer_IBAN",a.defaultProps={showPayButton:!0,showEmailAddress:!0},a}(hu),Xg=["CA","US"],ek=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),a.prototype.formatProps=function(t){return r(r({},e.prototype.formatProps.call(this,t)),{allowedCountries:Xg,personalDetailsRequiredFields:["firstName","lastName","telephoneNumber","shopperEmail"]})},a.type="affirm",a}(Sm),tk={socialSecurityNumber:{validate:vy,errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},rk={socialSecurityNumber:function(e){return by(e)}};function ak(e){var t=lu().i18n,r=["firstName","lastName","socialSecurityNumber"],a=gp({schema:r,defaultData:e.data,rules:tk,formatters:rk}),n=a.handleChangeFor,o=a.triggerValidation,s=a.setSchema,l=a.data,d=a.valid,c=a.errors,u=a.isValid;Zc((function(){var t=e.personalDetailsRequired?i([],r):[];s(t)}),[e.personalDetailsRequired]);var p=Wc("ready"),m=p[0],h=p[1];this.setStatus=h,this.showValidation=function(){o()},Zc((function(){e.onChange({data:l,valid:d,errors:c,isValid:u})}),[l,d,c]);var f=e.personalDetailsRequired?[]:["standalone"];return oc("div",{className:"adyen-checkout__pix-input__field"},e.personalDetailsRequired&&oc(Mv,{i18n:t,data:l,handleChangeFor:n,errors:c,valid:d}),e.showPayButton&&e.payButton({status:m,label:t.get("continueTo")+" "+e.name,classNameModifiers:f}))}ak.defaultProps={data:{},personalDetailsRequired:!1};var nk=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.formatProps=function(t){return r({delay:2e3,countdownTime:15,copyBtn:!0,introduction:"pix.instructions"},e.prototype.formatProps.call(this,t))},a.prototype.formatData=function(){var e=this.state.data,t=void 0===e?{}:e,a=t.firstName,n=t.lastName,o=t.socialSecurityNumber,i=void 0===o?"":o;return r(r({paymentMethod:{type:this.props.type||this.constructor.type}},a&&n&&{shopperName:{firstName:a,lastName:n}}),i&&{socialSecurityNumber:yy(i)})},a.prototype.render=function(){var e=this;return this.props.paymentData?this.renderQRCode():this.props.showPayButton?oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(ak,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton}))):null},a.type="pix",a.defaultProps=r({personalDetailsRequired:!1},gv.defaultProps),a}(gv),ok=/^(\d){1,8}$/,ik=/^(\d){6}$/,sk=/[^0-9]/g,lk={bankAccountNumber:{modes:["blur","input"],validate:function(e){return!!e&&ok.test(e)}},bankLocationId:[{modes:["input"],validate:function(e){return!!e&&/^(\d){1,6}$/.test(e)}},{modes:["blur"],validate:function(e){return!!e&&ik.test(e)}}],amountConsentCheckbox:{modes:["blur"],validate:function(e){return!!e}},accountConsentCheckbox:{modes:["blur"],validate:function(e){return!!e}},default:{modes:["blur"],validate:function(e){return!!e&&e.length>0}}},dk={bankAccountNumber:function(e){return e.replace(sk,"")},bankLocationId:function(e){return e.replace(sk,"")}},ck="enter-data",uk="confirm-data";function pk(e){var t,r,a=this,n=lu().i18n,o=gp({schema:["holderName","bankAccountNumber","bankLocationId","shopperEmail","amountConsentCheckbox","accountConsentCheckbox"],defaultData:e.data,formatters:dk,rules:lk}),i=o.handleChangeFor,s=o.triggerValidation,l=o.data,d=o.valid,c=o.errors,u=o.isValid,p=Wc(ck),m=p[0],h=p[1];this.setStatus=h,this.showValidation=s;return Zc((function(){e.onChange({data:l,valid:d,errors:c,isValid:u})}),[l,d,c,u]),oc("div",{className:Oc({"adyen-checkout__bacs":!0,"adyen-checkout__bacs--confirm":m===uk||"loading"===m})},m==uk&&oc("div",{className:Oc({"adyen-checkout__bacs--edit":!0,"adyen-checkout__bacs--edit-dropin":e.isDropin})},cp("text",{name:"bacsEdit",className:"adyen-checkout__bacs--edit-button",value:n.get("edit"),"aria-label":n.get("edit"),readonly:!0,onClick:function(){return a.setStatus(ck)}})),oc(Ru,{className:Oc({"adyen-checkout__bacs--holder-name":!0,"adyen-checkout__field--inactive":m===uk||"loading"===m}),label:n.get("bacs.accountHolderName"),errorMessage:!!c.holderName&&n.get("bacs.accountHolderName.invalid"),isValid:d.holderName,name:"accountHolderName"},cp("text",{name:"bacs.accountHolderName",className:"adyen-checkout__bacs-input--holder-name",placeholder:e.placeholders.holderName,value:l.holderName,"aria-invalid":!d.holderName,"aria-label":n.get("bacs.accountHolderName"),"aria-required":"true",required:!0,readonly:m===uk||"loading"===m,autocorrect:"off",onChange:i("holderName","blur"),onInput:i("holderName","input")})),oc("div",{className:"adyen-checkout__bacs__num-id adyen-checkout__field-wrapper"},oc(Ru,{errorMessage:!!c.bankAccountNumber&&n.get("bacs.accountNumber.invalid"),label:n.get("bacs.accountNumber"),className:Oc({"adyen-checkout__bacs--bank-account-number":!0,"adyen-checkout__field--inactive":m===uk||"loading"===m}),classNameModifiers:["col-70"],isValid:d.bankAccountNumber,name:"bankAccountNumber"},cp("text",{value:l.bankAccountNumber,className:"adyen-checkout__bacs-input--bank-account-number",placeholder:e.placeholders.bankAccountNumber,"aria-invalid":!d.bankAccountNumber,"aria-label":n.get("bacs.accountNumber"),"aria-required":"true",required:!0,readonly:m===uk||"loading"===m,autocorrect:"off",onChange:i("bankAccountNumber","blur"),onInput:i("bankAccountNumber","input")})),oc(Ru,{errorMessage:!!c.bankLocationId&&n.get("bacs.bankLocationId.invalid"),label:n.get("bacs.bankLocationId"),className:Oc({"adyen-checkout__bacs--bank-location-id":!0,"adyen-checkout__field--inactive":m===uk||"loading"===m}),classNameModifiers:["col-30"],isValid:d.bankLocationId,name:"bankLocationId"},cp("text",{value:l.bankLocationId,className:"adyen-checkout__bacs-input--bank-location-id",placeholder:e.placeholders.bankLocationId,"aria-invalid":!d.bankLocationId,"aria-label":n.get("bacs.bankLocationId"),"aria-required":"true",required:!0,readonly:m===uk||"loading"===m,autocorrect:"off",onChange:i("bankLocationId","blur"),onInput:i("bankLocationId","input")}))),oc(Ru,{errorMessage:!!c.shopperEmail&&n.get("shopperEmail.invalid"),label:n.get("shopperEmail"),className:Oc({"adyen-checkout__bacs--shopper-email":!0,"adyen-checkout__field--inactive":m===uk||"loading"===m}),isValid:d.shopperEmail,name:"emailAddress"},cp("emailAddress",{value:l.shopperEmail,name:"shopperEmail",className:"adyen-checkout__bacs-input--shopper-email",classNameModifiers:["large"],placeholder:e.placeholders.shopperEmail,spellcheck:!1,"aria-invalid":!d.shopperEmail,"aria-label":n.get("shopperEmail"),"aria-required":"true",required:!0,readonly:m===uk||"loading"===m,autocorrect:"off",onInput:i("shopperEmail","input"),onChange:i("shopperEmail","blur")})),m===ck&&oc(wm,{classNameModifiers:["amountConsentCheckbox"],errorMessage:!!c.amountConsentCheckbox,label:n.get("bacs.consent.amount"),onChange:i("amountConsentCheckbox"),checked:!!l.amountConsentCheckbox}),m===ck&&oc(wm,{classNameModifiers:["accountConsentCheckbox"],errorMessage:!!c.accountConsentCheckbox,label:n.get("bacs.consent.account"),onChange:i("accountConsentCheckbox"),checked:!!l.accountConsentCheckbox}),e.showPayButton&&e.payButton({status:m,label:m===ck?n.get("continue"):n.get("bacs.confirm")+" "+((null===(t=e.amount)||void 0===t?void 0:t.value)&&(null===(r=e.amount)||void 0===r?void 0:r.currency)?n.amount(e.amount.value,e.amount.currency):""),icon:zc({loadingContext:e.loadingContext,imageFolder:"components/"})("lock"),onClick:function(){return u?m===ck?a.setStatus(uk):m===uk?e.onSubmit():void 0:a.showValidation()}}))}pk.defaultProps={data:{},placeholders:{}};var mk=function(e){var t=lu(),r=t.i18n,a=t.loadingContext,n=e.url,o=e.paymentMethodType;return oc(Xy,{paymentMethodType:o,introduction:r.get("bacs.result.introduction"),imageUrl:zc({loadingContext:a})(o),downloadUrl:n,downloadButtonText:r.get("download.pdf")})},hk=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.payButton=function(e){return oc(uu,r({amount:t.props.amount,onClick:t.submit},e))},t}return t(a,e),a.prototype.formatData=function(){var e,t,n,o;return r({paymentMethod:r(r(r({type:a.type},(null===(e=this.state.data)||void 0===e?void 0:e.holderName)&&{holderName:this.state.data.holderName}),(null===(t=this.state.data)||void 0===t?void 0:t.bankAccountNumber)&&{bankAccountNumber:this.state.data.bankAccountNumber}),(null===(n=this.state.data)||void 0===n?void 0:n.bankLocationId)&&{bankLocationId:this.state.data.bankLocationId})},(null===(o=this.state.data)||void 0===o?void 0:o.shopperEmail)&&{shopperEmail:this.state.data.shopperEmail})},Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.url?oc(mk,{ref:function(t){e.componentRef=t},icon:this.icon,url:this.props.url,paymentMethodType:this.props.paymentMethodType}):oc(pk,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,payButton:this.payButton,onSubmit:this.submit})))},a.type="directdebit_GB",a}(hu),fk=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"data",{get:function(){return this.state.data},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Nm,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState})))},a}(hu),yk=function(e){function a(){return null!==e&&e.apply(this,arguments)||this}return t(a,e),Object.defineProperty(a.prototype,"data",{get:function(){return this.state.data},enumerable:!1,configurable:!0}),Object.defineProperty(a.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(Tp,r({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState})))},a}(hu);function bk(e){var t=e.sdkData;e.paymentMethodType;var r=e.payButton,n=a(e,["sdkData","paymentMethodType","payButton"]),o=$c(null),i=Wc("ready"),s=i[0],l=i[1],d=function(){l("error"),n.onComplete({data:{paymentData:n.paymentData,details:{}}})};return Zc((function(){window.klarnaAsyncCallback=function(){window.Klarna.Payments.init({client_token:t.client_token}),window.Klarna.Payments.load({container:o.current,payment_method_category:t.payment_method_category},(function(e){e.show_form&&!e.error||d()}))};var e=new Gm("https://x.klarnacdn.net/kp/lib/v1/api.js");return e.load(),function(){e.remove()}}),[]),"error"!==s&&"success"!==s?oc("div",{className:"adyen-checkout__klarna-widget"},oc("div",{ref:o}),r({status:s,disabled:"loading"===s,onClick:function(){l("loading");try{window.Klarna.Payments.authorize({payment_method_category:t.payment_method_category},(function(e){!0===e.approved&&!0===e.show_form?(l("success"),n.onComplete({data:{paymentData:n.paymentData,details:{token:e.authorization_token}}})):e.approved||!0!==e.show_form?d():(l("ready"),n.onError(e))}))}catch(e){d()}}})):null}function vk(e){var t=Wc({sdkData:e.sdkData,paymentMethodType:e.paymentMethodType,paymentData:e.paymentData}),a=t[0],n=t[1],o=Wc("ready"),i=o[0],s=o[1];return this.setAction=n,this.setStatus=s,a.sdkData?oc(bk,{sdkData:a.sdkData,paymentMethodType:a.paymentMethodType,paymentData:a.paymentData,payButton:e.payButton,onComplete:e.onComplete,onError:e.onError}):e.showPayButton?e.payButton(r(r({},e),{status:i,disabled:"loading"===i,classNameModifiers:["standalone"],label:this.props.i18n.get("continueTo")+" "+e.displayName})):null}var gk=function(e){function a(t){var a=e.call(this,t)||this;return a.payButton=function(e){return oc(uu,r({amount:a.props.amount,onClick:a.submit},e))},a.onComplete=a.onComplete.bind(a),a.updateWithAction=a.updateWithAction.bind(a),a.submit=a.submit.bind(a),a}return t(a,e),Object.defineProperty(a.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),a.prototype.formatData=function(){return{paymentMethod:r({type:this.type},this.props.useKlarnaWidget?{subtype:"sdk"}:{})}},a.prototype.updateWithAction=function(e){if(e.paymentMethodType!==this.type)throw new Error("Invalid Action");this.componentRef.setAction(e)},a.prototype.render=function(){var e=this;return oc(Am,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},oc(vk,r({},this.props,{ref:function(t){e.componentRef=t},displayName:this.displayName,onComplete:function(t){return e.props.onAdditionalDetails(t,e.elementRef)},onError:this.props.onError,payButton:this.payButton})))},a.type="klarna",a.defaultProps={useKlarnaWidget:!1},a}(hu),kk=function(e){function a(){var t=null!==e&&e.apply(this,arguments)||this;return t.payButton=function(e){return oc(uu,r({},e,{label:t.payButtonLabel(),onClick:t.submit}))},t}return t(a,e),Object.defineProperty(a.prototype,"displayName",{get:function(){var e=this.props,t=e.i18n,r=e.name;return e.storedPaymentMethodId?r+" "+t.get("twint.saved"):r||this.constructor.type},enumerable:!1,configurable:!0}),a.prototype.payButtonLabel=function(){var e=this.props,t=e.i18n,r=e.amount,a=e.storedPaymentMethodId,n=e.name;return a?cu(t,r):t.get("continueTo")+" "+n},a.type="twint",a.defaultProps={type:a.type,showPayButton:!0},a}(jy),Ck={dropin:gg,ach:Dg,address:fk,afterpay:Tm,afterpay_default:Tm,afterpay_b2b:zm,amazonpay:Jm,amex:Dy,applepay:th,bankTransfer_IBAN:$g,bcmc:Ay,bcmc_mobile:Cv,bcmc_mobile_QR:Cv,blik:Jg,billdesk_online:ph,billdesk_wallet:mh,boletobancario:Ov,boletobancario_bancodobrasil:Ov,boletobancario_bradesco:Ov,boletobancario_hsbc:Ov,boletobancario_itau:Ov,boletobancario_santander:Ov,primeiropay_boleto:Ov,card:Dy,storedCard:Dy,diners:Dy,directdebit_GB:hk,discover:Dy,doku:Bv,doku_alfamart:Bv,doku_permata_lite_atm:Bv,doku_indomaret:Bv,doku_atm_mandiri_va:Bv,doku_sinarmas_va:Bv,doku_mandiri_va:Bv,doku_cimb_va:Bv,doku_danamon_va:Bv,doku_bri_va:Bv,doku_bni_va:Bv,doku_bca_va:Bv,doku_wallet:Bv,donation:zy,dotpay:Kv,dragonpay_ebanking:Av,dragonpay_otc_banking:Av,dragonpay_otc_non_banking:Av,dragonpay_otc_philippines:Av,econtext_seven_eleven:tb,econtext_atm:tb,econtext_stores:tb,econtext_online:tb,entercash:Jy,eps:Hv,facilypay_3x:ab,facilypay_4x:nb,facilypay_6x:ob,facilypay_10x:ib,facilypay_12x:sb,giropay:Ey,ideal:lb,jcb:Dy,kcp:Dy,klarna:gk,klarna_paynow:gk,klarna_account:gk,maestro:Dy,mbway:Rg,mc:Dy,molpay_ebanking_fpx_MY:_v,molpay_ebanking_TH:Nv,molpay_ebanking_VN:wv,openbanking_UK:Pv,paypal:gb,payu_IN_cashcard:Zv,payu_IN_nb:Qv,paywithgoogle:Wy,personal_details:yk,googlepay:Wy,pix:nk,qiwiwallet:wb,ratepay:Xv,redirect:jy,securedfields:Fb,sepadirectdebit:Eb,scheme:Dy,threeDS2Challenge:iv,threeDS2DeviceFingerprint:uv,visa:Dy,wechatpay:kv,wechatpayQR:kv,oxxo:Lv,multibanco:Uv,giftcard:Wv,vipps:Jv,swish:eg,affirm:ek,twint:kk,default:null},_k=function(e,t){var a=Ck[e]||Ck.default;return a?new a(r(r({},t),{id:e+"-"+Sc()})):null},Nk=function(e,t,r){void 0===t&&(t={}),void 0===r&&(r=!1);var a=e;return"scheme"===e&&(a=r?"storedCard":"card"),t[a]||{}};function wk(e){return!this.length||this.indexOf(e.type)>-1}function Pk(e){return!this.length||this.indexOf(e.type)<0}function Fk(e){return!!e&&!!e.supportedShopperInteractions&&e.supportedShopperInteractions.includes("Ecommerce")}var Dk=["scheme","blik","twint"];function Ak(e){return!!e&&!!e.type&&Dk.includes(e.type)}var Sk=function(e){return r(r({},e),{storedPaymentMethodId:e.id})},xk=function(){function e(e,t){void 0===t&&(t={}),this.paymentMethods=[],this.storedPaymentMethods=[],function(e){var t,r;if("string"==typeof e)throw new Error('paymentMethodsResponse was provided but of an incorrect type (should be an object but a string was provided).Try JSON.parse("{...}") your paymentMethodsResponse.');if(e instanceof Array)throw new Error("paymentMethodsResponse was provided but of an incorrect type (should be an object but an array was provided).Please check you are passing the whole response.");!e||(null===(t=null==e?void 0:e.paymentMethods)||void 0===t?void 0:t.length)||(null===(r=null==e?void 0:e.storePaymentMethods)||void 0===r?void 0:r.length)||console.warn("paymentMethodsResponse was provided but no payment methods were found.")}(e),this.paymentMethods=e?function(e,t){var r=t.allowPaymentMethods,a=void 0===r?[]:r,n=t.removePaymentMethods,o=void 0===n?[]:n;return e?e.filter(wk,a).filter(Pk,o):[]}(e.paymentMethods,t):[],this.storedPaymentMethods=e?function(e,t){var r=t.allowPaymentMethods,a=void 0===r?[]:r,n=t.removePaymentMethods,o=void 0===n?[]:n;return e?e.filter(Ak).filter(wk,a).filter(Pk,o).filter(Fk).map(Sk):[]}(e.storedPaymentMethods,t):[]}return e.prototype.has=function(e){return Boolean(this.paymentMethods.find((function(t){return t.type===e})))},e.prototype.find=function(e){return this.paymentMethods.find((function(t){return t.type===e}))},e}(),Bk=function(e){return function(t,a){return _k(t.paymentMethodType,r(r(r({},t),a),{onComplete:a.onAdditionalDetails,onError:a.onError,statusType:e}))}},Tk={redirect:function(e,t){return _k("redirect",r(r(r({},t),e),{statusType:"redirect"}))},threeDS2Fingerprint:function(e,t){return _k("threeDS2DeviceFingerprint",r(r({createFromAction:t.createFromAction,token:e.token,paymentData:e.paymentData,onError:t.onError,showSpinner:!t.isDropin,isDropin:!!t.isDropin},t),{type:"IdentifyShopper",onComplete:t.onAdditionalDetails,statusType:"loading",useOriginalFlow:!0}))},threeDS2Challenge:function(e,t){var a;return _k("threeDS2Challenge",r(r({},t),{token:e.token,paymentData:e.paymentData,onComplete:t.onAdditionalDetails,onError:t.onError,size:null!==(a=t.size)&&void 0!==a?a:"02",isDropin:!!t.isDropin,type:"ChallengeShopper",statusType:"custom",useOriginalFlow:!0}))},threeDS2:function(e,t){var a="fingerprint"===e.subtype?"threeDS2DeviceFingerprint":"threeDS2Challenge",n="fingerprint"===e.subtype?e.paymentData:e.authorisationToken,o=r({token:e.token,paymentData:n,onComplete:t.onAdditionalDetails,onError:t.onError,isDropin:!!t.isDropin,loadingContext:t.loadingContext,clientKey:t.clientKey,_parentInstance:t._parentInstance,paymentMethodType:t.paymentMethodType,challengeWindowSize:t.challengeWindowSize},function(e,t){if("fingerprint"===e){var r=Rh(t.elementRef?tv:rv).from(t);return r.showSpinner=!t.isDropin,r.statusType="loading",r}return{statusType:"custom"}}(e.subtype,t));return _k(a,o)},voucher:Bk("custom"),qrCode:Bk("custom"),await:Bk("custom"),bankTransfer:Bk("custom"),sdk:Bk("custom")};var zk=function(){function e(){this.events=[]}return e.prototype.add=function(e){this.events.push(e)},e.prototype.run=function(e){var t=this.events.map((function(t){return t(e)}));return this.events=[],Promise.all(t)},e}(),Ik=function(){function e(t){var a=t.loadingContext,n=t.locale,o=t.clientKey,i=t.analytics;this.checkoutAttemptId=null,this.queue=new zk,this.props=r(r({},e.defaultProps),i),this.logEvent=function(e){return function(t){var a=r({version:"5.2.0",payload_version:1,platform:"web",locale:e.locale},t),n=Object.keys(a).map((function(e){return encodeURIComponent(e)+"="+encodeURIComponent(a[e])})).join("&");(new Image).src=e.loadingContext+"images/analytics.png?"+n}}({loadingContext:a,locale:n}),this.logTelemetry=function(e){return function(t){if(!e.clientKey)return Promise.reject();var a={errorLevel:"silent",loadingContext:e.loadingContext,path:"v2/analytics/log?clientKey="+e.clientKey},n=r({version:"5.2.0",platform:"web",locale:e.locale,flavor:"components",userAgent:navigator.userAgent,referrer:window.location.href,screenWidth:window.screen.width},t);return bm(a,n)}}({loadingContext:a,locale:n,clientKey:o}),this.collectId=function(e){var t,r=e.loadingContext,a=e.clientKey,n=e.experiments,o={errorLevel:"silent",loadingContext:r,path:"v2/analytics/id?clientKey="+a};return function(){return t||(a?t=bm(o,{experiments:n}).then((function(e){return null==e?void 0:e.id})).catch((function(){})):Promise.reject())}}({loadingContext:a,clientKey:o,experiments:this.props.experiments});var s=this.props,l=s.conversion,d=s.enabled;!0===l&&!0===d&&this.props.checkoutAttemptId&&(this.checkoutAttemptId=this.props.checkoutAttemptId,this.queue.run(this.checkoutAttemptId))}return e.prototype.send=function(e){var t=this,a=this.props,n=a.conversion,o=a.enabled,i=a.payload,s=a.telemetry;if(!0===o){if(!0!==n||this.checkoutAttemptId||this.collectId().then((function(e){t.checkoutAttemptId=e,t.queue.run(t.checkoutAttemptId)})),!0===s){this.queue.add((function(a){return t.logTelemetry(r(r(r({},e),i&&r({},i)),{checkoutAttemptId:a})).catch((function(){}))})),n&&!this.checkoutAttemptId||this.queue.run(this.checkoutAttemptId)}this.logEvent(e)}},e.defaultProps={enabled:!0,telemetry:!0,conversion:!1,checkoutAttemptId:null,experiments:[]},e}();function Mk(e){return Object.keys(e).reduce((function(t,r){return Tc.includes(r)&&(t[r]=e[r]),t}),{})}var jk=function(){function e(e,t){void 0===t&&(t=window.localStorage),this.prefix="adyen-checkout__",this.storage=t,this.key=this.prefix+e}return e.prototype.get=function(){try{return JSON.parse(this.storage.getItem(this.key))}catch(e){return null}},e.prototype.set=function(e){this.storage.setItem(this.key,JSON.stringify(e))},e.prototype.remove=function(){this.storage.removeItem(this.key)},e}();var Ek=function(){function e(e,t,a){var n=function(e){if(!e||!e.id)throw new Error("Invalid session");return r({id:e.id},e.sessionData?{sessionData:e.sessionData}:{})}(e);if(!t)throw new Error("No clientKey available");this.storage=new jk("session"),this.clientKey=t,this.loadingContext=a,this.session=n,this.session.sessionData?this.storeSession():this.session=this.getStoredSession()}return Object.defineProperty(e.prototype,"id",{get:function(){return this.session.id},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"data",{get:function(){return this.session.sessionData},enumerable:!1,configurable:!0}),e.prototype.updateSessionData=function(e){this.session.sessionData=e,this.storeSession()},e.prototype.setupSession=function(e){return function(e,t){var a="v1/sessions/"+e.id+"/setup?clientKey="+e.clientKey,n=r({sessionData:e.data},t.order?{order:{orderData:t.order.orderData,pspReference:t.order.pspReference}}:{});return bm({loadingContext:e.loadingContext,path:a,errorLevel:"fatal"},n)}(this,e)},e.prototype.submitPayment=function(e){var t=this;return function(e,t){var a="v1/sessions/"+t.id+"/payments?clientKey="+t.clientKey,n=r({sessionData:t.data},e);return bm({loadingContext:t.loadingContext,path:a,errorLevel:"fatal"},n)}(e,this).then((function(e){return e.sessionData&&t.updateSessionData(e.sessionData),e}))},e.prototype.submitDetails=function(e){var t=this;return function(e,t){var a="v1/sessions/"+t.id+"/paymentDetails?clientKey="+t.clientKey,n=r({sessionData:t.data},e);return bm({loadingContext:t.loadingContext,path:a,errorLevel:"fatal"},n)}(e,this).then((function(e){return e.sessionData&&t.updateSessionData(e.sessionData),e}))},e.prototype.checkBalance=function(e){var t=this;return function(e,t){var a="v1/sessions/"+t.id+"/paymentMethodBalance?clientKey="+t.clientKey,n=r({sessionData:t.data},e);return bm({loadingContext:t.loadingContext,path:a,errorLevel:"fatal"},n)}(e,this).then((function(e){return e.sessionData&&t.updateSessionData(e.sessionData),e}))},e.prototype.createOrder=function(){var e=this;return function(e){var t="v1/sessions/"+e.id+"/orders?clientKey="+e.clientKey,r={sessionData:e.data};return bm({loadingContext:e.loadingContext,path:t,errorLevel:"fatal"},r)}(this).then((function(t){return t.sessionData&&e.updateSessionData(t.sessionData),t}))},e.prototype.getStoredSession=function(){var e=this.storage.get();return this.id===(null==e?void 0:e.id)?e:this.session},e.prototype.storeSession=function(){this.storage.set({id:this.session.id,sessionData:this.session.sessionData})},e.prototype.removeStoredSession=function(){this.storage.remove()},e}(),Ok=function(){function e(e){var t=this;this.components=[],this.update=function(e){return void 0===e&&(e={}),t.setOptions(e),t.initialize().then((function(){return t.components.forEach((function(e){return e.update(t.getPropsForComponent(t.options))})),t}))},this.remove=function(e){return t.components=t.components.filter((function(t){return t._id!==e._id})),e.unmount(),t},this.setOptions=function(e){var a;return t.options=r(r({},t.options),e),t.options.loadingContext=function(e){void 0===e&&(e="https://checkoutshopper-live.adyen.com/checkoutshopper/");var t={test:"https://checkoutshopper-test.adyen.com/checkoutshopper/",live:"https://checkoutshopper-live.adyen.com/checkoutshopper/","live-us":"https://checkoutshopper-live-us.adyen.com/checkoutshopper/","live-au":"https://checkoutshopper-live-au.adyen.com/checkoutshopper/"};return t[e]||t[e.toLowerCase()]||e}(t.options.environment),t.options.locale=t.options.locale||t.options.shopperLocale,t.modules={risk:new Su(t.options),analytics:new Ik(t.options),i18n:new Xd(t.options.locale,t.options.translations)},t.paymentMethodsResponse=new xk(null!==(a=t.options.paymentMethodsResponse)&&void 0!==a?a:t.options.paymentMethods,t.options),delete t.options.paymentMethods,t},this.create=this.create.bind(this),this.createFromAction=this.createFromAction.bind(this),this.setOptions(e)}return e.prototype.initialize=function(){var e=this;return this.options.session?(this.session=new Ek(this.options.session,this.options.clientKey,this.options.loadingContext),this.session.setupSession(this.options).then((function(t){var a=e.options.order?e.options.order.remainingAmount:t.amount;return e.setOptions(r(r({},t),{amount:a})),e})).catch((function(t){return e.options.onError&&e.options.onError(t),e}))):Promise.resolve(this)},e.prototype.submitPayment=function(e){var t=this;if(this.options.onSubmit)return this.options.onSubmit(e);this.session&&this.session.submitPayment(e).then((function(e){e.action?t.options.onPaymentSubmitted&&t.options.onPaymentSubmitted(e,t):t.options.onPaymentCompleted&&t.options.onPaymentCompleted(e,t)})).catch((function(e){t.options.onError&&t.options.onError(e)}))},e.prototype.submitDetails=function(e){var t=this;if(this.options.onAdditionalDetails)return this.options.onAdditionalDetails(e);this.session&&this.session.submitDetails(e).then((function(e){t.options.onPaymentCompleted&&t.options.onPaymentCompleted(e,t)})).catch((function(e){t.options.onError&&t.options.onError(e,t)}))},e.prototype.create=function(e,t){var r=this.getPropsForComponent(t);return e?this.handleCreate(e,r):this.handleCreateError()},e.prototype.createFromAction=function(e,t){if(void 0===t&&(t={}),e.type){var a=Nk(e.type,this.options.paymentMethodsConfiguration);return function(e,t){void 0===t&&(t={});var r=Tk[e.type];if(r&&"function"==typeof r)return r(e,t);throw new Error("Invalid Action")}(e,r(r(r({},Mk(this.options)),a),this.getPropsForComponent(t)))}return this.handleCreateError()},e.prototype.getPropsForComponent=function(e){return r(r({paymentMethods:this.paymentMethodsResponse.paymentMethods,storedPaymentMethods:this.paymentMethodsResponse.storedPaymentMethods},e),{i18n:this.modules.i18n,modules:this.modules,session:this.session,createFromAction:this.createFromAction,_parentInstance:this})},e.prototype.handleCreate=function(e,t){if(void 0===t&&(t={}),e.prototype instanceof hu){var a=t.supportedShopperInteractions?[]:this.paymentMethodsResponse.find(t.type),n=Nk(t.type,this.options.paymentMethodsConfiguration,!!t.storedPaymentMethodId),o=Mk(this.options),i=new e(r(r(r(r({},o),a),n),t));return t.isDropin||this.components.push(i),i}if("string"==typeof e&&Ck[e])return this.handleCreate(Ck[e],r({type:e},t));if("string"==typeof e&&this.paymentMethodsResponse.has(e)){n=Nk(e,this.options.paymentMethodsConfiguration);return this.handleCreate(Ck.redirect,r(r(r(r({},Mk(this.options)),this.paymentMethodsResponse.find(e)),n),t))}if("object"==typeof e&&"string"==typeof e.type){n=Nk(e.type,this.options.paymentMethodsConfiguration,!!e.storedPaymentMethodId);return this.handleCreate(e.type,r(r(r({},e),t),n))}return this.handleCreateError(e)},e.prototype.handleCreateError=function(e){var t=e&&e.name?e.name:"The passed payment method";throw new Error(e?t+" is not a valid Checkout Component":"No Payment Method component was passed")},e.version={version:"5.2.0",revision:"3fe4131",branch:"HEAD",buildId:"@adyen/adyen-web-a6e12b4e-eb85-47b8-ab6f-cb0a18d080f2"},e}();var Rk=Object.freeze({__proto__:null,default:{payButton:"\u062f\u0641\u0639","payButton.redirecting":"\u062c\u0627\u0631\u0650 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u062c\u064a\u0647...",storeDetails:"\u062d\u0641\u0638 \u0644\u0645\u062f\u0641\u0648\u0639\u0627\u062a\u064a \u0627\u0644\u0642\u0627\u062f\u0645\u0629","creditCard.holderName":"\u0627\u0644\u0627\u0633\u0645 \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.holderName.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","creditCard.holderName.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","creditCard.numberField.title":"\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.numberField.placeholder":"3456 9012 5678 1234","creditCard.expiryDateField.title":"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.expiryDateField.placeholder":"\u0634\u0647\u0631/\u0633\u0646\u0629","creditCard.expiryDateField.month":"\u0634\u0647\u0631","creditCard.expiryDateField.month.placeholder":"\u0634\u0647\u0631","creditCard.expiryDateField.year.placeholder":"\u0633\u0646\u0629","creditCard.expiryDateField.year":"\u0633\u0646\u0629","creditCard.cvcField.title":"\u0631\u0645\u0632 CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0627\u062d\u062a\u0641\u0638 \u0628\u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0644\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062f\u0645\u0629","creditCard.cvcField.placeholder.4digits":"4 \u0623\u0631\u0642\u0627\u0645","creditCard.cvcField.placeholder.3digits":"3 \u0623\u0631\u0642\u0627\u0645","creditCard.taxNumber.placeholder":"\u064a\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629 / 0123456789",installments:"\u0639\u062f\u062f \u0627\u0644\u0623\u0642\u0633\u0627\u0637",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} \u0623\u0634\u0647\u0631","installments.oneTime":"\u0627\u0644\u062f\u0641\u0639 \u0645\u0631\u0629 \u0648\u0627\u062d\u062f\u0629","installments.installments":"\u0627\u0644\u062f\u0641\u0639 \u0639\u0644\u0649 \u0623\u0642\u0633\u0627\u0637","installments.revolving":"\u0627\u0644\u062f\u0641\u0639 \u0627\u0644\u062f\u0648\u0631\u064a","sepaDirectDebit.ibanField.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","sepaDirectDebit.nameField.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","sepa.ownerName":"\u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628","sepa.ibanNumber":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 (IBAN)","error.title":"\u062e\u0637\u0623","error.subtitle.redirect":"\u0641\u0634\u0644 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u062c\u064a\u0647","error.subtitle.payment":"\u0641\u0634\u0644 \u0627\u0644\u062f\u0641\u0639","error.subtitle.refused":"\u062a\u0645 \u0631\u0641\u0636 \u0627\u0644\u062f\u0641\u0639","error.message.unknown":"\u062d\u062f\u062b \u062e\u0637\u0623 \u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641","idealIssuer.selectField.title":"\u0627\u0644\u0628\u0646\u0643","idealIssuer.selectField.placeholder":"\u062d\u062f\u062f \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064a \u062a\u062a\u0639\u0627\u0645\u0644 \u0645\u0639\u0647","creditCard.success":"\u0646\u062c\u062d \u0627\u0644\u062f\u0641\u0639",loading:"\u062c\u0627\u0631\u0650 \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",continue:"\u0645\u062a\u0627\u0628\u0639\u0629",continueTo:"\u0645\u062a\u0627\u0628\u0639\u0629 \u0625\u0644\u0649","wechatpay.timetopay":"\u0644\u062f\u064a\u0643 %@ \u0644\u0644\u062f\u0641\u0639","wechatpay.scanqrcode":"\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629",personalDetails:"\u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0634\u062e\u0635\u064a\u0629",companyDetails:"\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0634\u0631\u0643\u0629","companyDetails.name":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629","companyDetails.registrationNumber":"\u0631\u0642\u0645 \u0627\u0644\u062a\u0633\u062c\u064a\u0644",socialSecurityNumber:"\u0631\u0642\u0645 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0627\u062c\u062a\u0645\u0627\u0639\u064a",firstName:"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",infix:"\u0628\u0627\u062f\u0626\u0629",lastName:"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062e\u064a\u0631",mobileNumber:"\u0631\u0642\u0645 \u0627\u0644\u062c\u0648\u0627\u0644","mobileNumber.invalid":"\u0631\u0642\u0645 \u062c\u0648\u0627\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",city:"\u0627\u0644\u0645\u062f\u064a\u0646\u0629",postalCode:"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",countryCode:"\u0631\u0645\u0632 \u0627\u0644\u0628\u0644\u062f",telephoneNumber:"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",dateOfBirth:"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0645\u064a\u0644\u0627\u062f",shopperEmail:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",gender:"\u0627\u0644\u0646\u0648\u0639",male:"\u0630\u0643\u0631",female:"\u0623\u0646\u062b\u0649",billingAddress:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631",street:"\u0627\u0644\u0634\u0627\u0631\u0639",stateOrProvince:"\u0627\u0644\u0648\u0644\u0627\u064a\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",country:"\u0627\u0644\u0628\u0644\u062f",houseNumberOrName:"\u0631\u0642\u0645 \u0627\u0644\u0645\u0646\u0632\u0644",separateDeliveryAddress:"\u062d\u062f\u062f \u0639\u0646\u0648\u0627\u0646 \u062a\u0633\u0644\u064a\u0645 \u0645\u0646\u0641\u0635\u0644",deliveryAddress:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062a\u0633\u0644\u064a\u0645",zipCode:"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",apartmentSuite:"\u0627\u0644\u0634\u0642\u0629 / \u0627\u0644\u062c\u0646\u0627\u062d",provinceOrTerritory:"\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064a\u0645",cityTown:"\u0627\u0644\u0645\u062f\u064a\u0646\u0629 / \u0627\u0644\u0628\u0644\u062f\u0629",address:"\u0627\u0644\u0639\u0646\u0648\u0627\u0646",state:"\u0627\u0644\u0648\u0644\u0627\u064a\u0629","field.title.optional":"(\u0627\u062e\u062a\u064a\u0627\u0631\u064a)","creditCard.cvcField.title.optional":"\u0631\u0645\u0632 CVC / CVV (\u0627\u062e\u062a\u064a\u0627\u0631\u064a)","issuerList.wallet.placeholder":"\u062d\u062f\u062f \u0645\u062d\u0641\u0638\u062a\u0643",privacyPolicy:"\u0633\u064a\u0627\u0633\u0629 \u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629","afterPay.agreement":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %@ \u0644\u0634\u0631\u0643\u0629 AfterPay",paymentConditions:"\u0634\u0631\u0648\u0637 \u0627\u0644\u062f\u0641\u0639",openApp:"\u0641\u062a\u062d \u0627\u0644\u062a\u0637\u0628\u064a\u0642","voucher.readInstructions":"\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u062a\u0639\u0644\u064a\u0645\u0627\u062a","voucher.introduction":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0642\u0633\u064a\u0645\u0629 \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.expirationDate":"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","voucher.alternativeReference":"\u0627\u0644\u0645\u0631\u062c\u0639 \u0627\u0644\u0628\u062f\u064a\u0644","dragonpay.voucher.non.bank.selectField.placeholder":"\u062d\u062f\u062f \u0645\u0642\u062f\u0645 \u0627\u0644\u062e\u062f\u0645\u0629","dragonpay.voucher.bank.selectField.placeholder":"\u062d\u062f\u062f \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064a \u062a\u062a\u0639\u0627\u0645\u0644 \u0645\u0639\u0647","voucher.paymentReferenceLabel":"\u0645\u0631\u062c\u0639 \u0627\u0644\u062f\u0641\u0639","voucher.surcharge":"\u0628\u0645\u0627 \u0641\u064a \u0630\u0644\u0643 %@ \u0631\u0633\u0645\u064b\u0627 \u0625\u0636\u0627\u0641\u064a\u064b\u0627","voucher.introduction.doku":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.shopperName":"\u0627\u0633\u0645 \u0627\u0644\u0645\u062a\u0633\u0648\u0642","voucher.merchantName":"\u0627\u0644\u062a\u0627\u062c\u0631","voucher.introduction.econtext":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.telephoneNumber":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641","voucher.shopperReference":"\u0645\u0631\u062c\u0639 \u0627\u0644\u0645\u062a\u0633\u0648\u0642","voucher.collectionInstitutionNumber":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0643\u0644\u0641\u0629 \u0628\u0627\u0644\u062a\u062d\u0635\u064a\u0644","voucher.econtext.telephoneNumber.invalid":"\u064a\u062c\u0628 \u0623\u0646 \u064a\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641 \u0628\u0637\u0648\u0644 10 \u0623\u0648 11 \u0631\u0642\u0645\u064b\u0627","boletobancario.btnLabel":"\u0625\u0646\u0634\u0627\u0621 \u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639 Boleto","boleto.sendCopyToEmail":"\u0625\u0631\u0633\u0627\u0644 \u0646\u0633\u062e\u0629 \u0625\u0644\u0649 \u0628\u0631\u064a\u062f\u064a \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a","button.copy":"\u0646\u0633\u062e","button.download":"\u062a\u0646\u0632\u064a\u0644","creditCard.storedCard.description.ariaLabel":"\u062a\u0646\u062a\u0647\u064a \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u062e\u0632\u0646\u0629 \u0641\u064a %@","voucher.entity":"\u0627\u0644\u0643\u064a\u0627\u0646",donateButton:"\u0627\u0644\u062a\u0628\u0631\u0639",notNowButton:"\u0644\u064a\u0633 \u0627\u0644\u0622\u0646",thanksForYourSupport:"\u0634\u0643\u0631\u064b\u0627 \u0639\u0644\u0649 \u062f\u0639\u0645\u0643!",preauthorizeWith:"\u062a\u0641\u0648\u064a\u0636 \u0645\u0633\u0628\u0642 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645",confirmPreauthorization:"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062a\u0641\u0648\u064a\u0636 \u0627\u0644\u0645\u0633\u0628\u0642",confirmPurchase:"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0634\u0631\u0627\u0621",applyGiftcard:"\u0627\u0633\u062a\u0631\u062f\u0627\u062f",giftcardBalance:"\u0631\u0635\u064a\u062f \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627",deductedBalance:"\u0627\u0644\u0631\u0635\u064a\u062f \u0627\u0644\u0645\u062e\u0635\u0648\u0645","creditCard.pin.title":"\u0631\u0642\u0645 \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0634\u062e\u0635\u064a","creditCard.encryptedPassword.label":"\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d\u0629","creditCard.taxNumber.label":"\u062a\u0627\u0631\u064a\u062e \u0645\u064a\u0644\u0627\u062f \u062d\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 (\u064a\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629) \u0623\u0648 \u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)","creditCard.taxNumber.labelAlt":"\u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)","creditCard.taxNumber.invalid":"\u062a\u0627\u0631\u064a\u062e \u0645\u064a\u0644\u0627\u062f \u062d\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","storedPaymentMethod.disable.button":"\u0625\u0632\u0627\u0644\u0629","storedPaymentMethod.disable.confirmation":"\u0625\u0632\u0627\u0644\u0629 \u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u062f\u0641\u0639 \u0627\u0644\u0645\u062e\u0632\u0646\u0629","storedPaymentMethod.disable.confirmButton":"\u0646\u0639\u0645\u060c \u0623\u0631\u063a\u0628 \u0641\u064a \u0625\u0632\u0627\u0644\u062a\u0647\u0627","storedPaymentMethod.disable.cancelButton":"\u0625\u0644\u063a\u0627\u0621","ach.bankAccount":"\u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","ach.accountHolderNameField.title":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628","ach.accountHolderNameField.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","ach.accountHolderNameField.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ach.accountNumberField.title":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628","ach.accountNumberField.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ach.accountLocationField.title":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA","ach.accountLocationField.invalid":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","select.state":"\u062d\u062f\u062f \u0627\u0644\u0648\u0644\u0627\u064a\u0629","select.stateOrProvince":"\u062d\u062f\u062f \u0627\u0644\u0648\u0644\u0627\u064a\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629","select.provinceOrTerritory":"\u062d\u062f\u062f \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064a\u0645","select.country":"\u062d\u062f\u062f \u0627\u0644\u0628\u0644\u062f","select.noOptionsFound":"\u0644\u0627 \u062a\u0648\u062c\u062f \u062e\u064a\u0627\u0631\u0627\u062a","select.filter.placeholder":"\u0628\u062d\u062b...","telephoneNumber.invalid":"\u0631\u0642\u0645 \u0647\u0627\u062a\u0641 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",qrCodeOrApp:"\u0623\u0648","paypal.processingPayment":"\u062c\u0627\u0631\u0650 \u0645\u0639\u0627\u0644\u062c\u0629 \u0627\u0644\u0645\u062f\u0641\u0648\u0639\u0627\u062a...",generateQRCode:"\u0625\u0646\u0634\u0627\u0621 \u0631\u0645\u0632 \u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0633\u0631\u064a\u0639\u0629","await.waitForConfirmation":"\u0641\u064a \u0627\u0646\u062a\u0638\u0627\u0631 \u0627\u0644\u062a\u0623\u0643\u064a\u062f","mbway.confirmPayment":"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062f\u0641\u0639 \u0639\u0644\u0649 \u062a\u0637\u0628\u064a\u0642 MB WAY","shopperEmail.invalid":"\u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f \u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","dateOfBirth.format":"\u064a\u0648\u0645/\u0634\u0647\u0631/\u0633\u0646\u0629","dateOfBirth.invalid":"\u064a\u062c\u0628 \u0623\u0644\u0627 \u064a\u0642\u0644 \u0639\u0645\u0631\u0643 \u0639\u0646 18 \u0639\u0627\u0645\u064b\u0627","blik.confirmPayment":"\u0627\u0641\u062a\u062d \u062a\u0637\u0628\u064a\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064a \u0644\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062f\u0641\u0639.","blik.invalid":"\u0623\u062f\u062e\u0644 6 \u0623\u0631\u0642\u0627\u0645","blik.code":"\u0631\u0645\u0632 \u0645\u0643\u0648\u0646 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645","blik.help":"\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632 \u0645\u0646 \u062a\u0637\u0628\u064a\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064a.","swish.pendingMessage":"\u0628\u0639\u062f \u0642\u064a\u0627\u0645\u0643 \u0628\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629 \u0636\u0648\u0626\u064a\u064b\u0627\u060c \u064a\u0645\u0643\u0646 \u0623\u0646 \u062a\u0638\u0644 \u0627\u0644\u062d\u0627\u0644\u0629 \u0645\u0639\u0644\u0642\u0629 \u0644\u0645\u062f\u0629 \u062a\u0635\u0644 \u0625\u0644\u0649 10 \u062f\u0642\u0627\u0626\u0642. \u0642\u062f \u062a\u0624\u062f\u064a \u0645\u062d\u0627\u0648\u0644\u0629 \u0627\u0644\u062f\u0641\u0639 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u062e\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0648\u0642\u062a \u0625\u0644\u0649 \u0641\u0631\u0636 \u0631\u0633\u0648\u0645 \u0645\u062a\u0639\u062f\u062f\u0629.","error.va.gen.01":"\u062d\u0642\u0644 \u063a\u064a\u0631 \u0645\u0643\u062a\u0645\u0644","error.va.gen.02":"\u062d\u0642\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-cc-num.01":"\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-cc-num.03":"\u062a\u0645 \u0625\u062f\u062e\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0645\u062f\u0639\u0648\u0645\u0629","error.va.sf-cc-dat.01":"\u0628\u0637\u0627\u0642\u0629 \u0642\u062f\u064a\u0645\u0629 \u062c\u062f\u064b\u0627","error.va.sf-cc-dat.02":"\u0627\u0644\u062a\u0627\u0631\u064a\u062e \u0628\u0639\u064a\u062f \u0644\u0644\u063a\u0627\u064a\u0629 \u0641\u064a \u0627\u0644\u0645\u0633\u062a\u0642\u0628\u0644","error.va.sf-cc-dat.03":"\u062a\u0646\u062a\u0647\u064a \u0635\u0644\u0627\u062d\u064a\u0629 \u0628\u0637\u0627\u0642\u062a\u0643 \u0642\u0628\u0644 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0633\u062f\u0627\u062f","error.va.sf-ach-num.01":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-ach-loc.01":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-kcp-pwd.01":"\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d\u0629","error.giftcard.no-balance":"\u0644\u0627 \u064a\u0648\u062c\u062f \u0631\u0635\u064a\u062f \u0628\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0647\u0630\u0647","error.giftcard.card-error":"\u0644\u0627 \u062a\u0648\u062c\u062f \u0628\u0633\u062c\u0644\u0627\u062a\u0646\u0627 \u0628\u0637\u0627\u0642\u0629 \u0647\u062f\u0627\u064a\u0627 \u062a\u062d\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645","error.giftcard.currency-error":"\u0644\u0627 \u062a\u0633\u0631\u064a \u0628\u0637\u0627\u0642\u0627\u062a \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0625\u0644\u0627 \u0628\u0627\u0644\u0639\u0645\u0644\u0629 \u0627\u0644\u062a\u064a \u0635\u062f\u0631\u062a \u0628\u0647\u0627","amazonpay.signout":"\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0645\u0648\u0642\u0639 Amazon","amazonpay.changePaymentDetails":"\u062a\u063a\u064a\u064a\u0631 \u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u062f\u0641\u0639","partialPayment.warning":"\u062a\u062d\u062f\u064a\u062f \u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639 \u0623\u062e\u0631\u0649 \u0644\u062a\u0633\u062f\u064a\u062f \u0627\u0644\u0645\u0628\u0644\u063a \u0627\u0644\u0645\u062a\u0628\u0642\u064a","partialPayment.remainingBalance":"\u0633\u064a\u0628\u0644\u063a \u0627\u0644\u0631\u0635\u064a\u062f \u0627\u0644\u0645\u062a\u0628\u0642\u064a %{amount}","bankTransfer.beneficiary":"\u0627\u0644\u0645\u0633\u062a\u0641\u064a\u062f","bankTransfer.iban":"IBAN","bankTransfer.bic":"\u0643\u0648\u062f \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0628\u0646\u0643\u064a","bankTransfer.reference":"\u0627\u0644\u0645\u0631\u062c\u0639","bankTransfer.introduction":"\u0642\u0645 \u0628\u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u062f\u0641\u0648\u0639\u0627\u062a \u062a\u062d\u0648\u064a\u0644 \u0628\u0646\u0643\u064a\u0629 \u062c\u062f\u064a\u062f\u0629. \u064a\u0645\u0643\u0646\u0643 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0648\u0627\u0631\u062f\u0629 \u0641\u064a \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","bankTransfer.instructions":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","bacs.accountHolderName":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","bacs.accountHolderName.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u062d\u0633\u0627\u0628 \u0628\u0646\u0643\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.accountNumber":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","bacs.accountNumber.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u0628\u0646\u0643\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.bankLocationId":"\u0631\u0645\u0632 \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0628\u0646\u0643","bacs.bankLocationId.invalid":"\u0631\u0645\u0632 \u062a\u0639\u0631\u064a\u0641 \u0628\u0646\u0643 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.consent.amount":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0644\u063a \u0623\u0639\u0644\u0627\u0647 \u0645\u0646 \u062d\u0633\u0627\u0628\u064a \u0627\u0644\u0628\u0646\u0643\u064a.","bacs.consent.account":"\u0623\u0624\u0643\u062f \u0623\u0646 \u0627\u0644\u062d\u0633\u0627\u0628 \u0628\u0627\u0633\u0645\u064a \u0648\u0623\u0646\u0627 \u0648\u062d\u062f\u064a \u0635\u0627\u062d\u0628 \u0627\u0644\u062a\u0648\u0642\u064a\u0639 \u0627\u0644\u0645\u0637\u0627\u0644\u0628 \u0628\u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0641\u064a \u0647\u0630\u0627 \u0627\u0644\u062d\u0633\u0627\u0628.",edit:"\u062a\u062d\u0631\u064a\u0631","bacs.confirm":"\u062a\u0623\u0643\u064a\u062f \u0648\u062f\u0641\u0639","bacs.result.introduction":"\u062a\u0646\u0632\u064a\u0644 \u062a\u0639\u0644\u064a\u0645\u0627\u062a \u0627\u0644\u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 (\u062a\u0639\u0644\u064a\u0645\u0627\u062a / \u062a\u0641\u0648\u064a\u0636 DDI)","download.pdf":"\u062a\u0646\u0632\u064a\u0644 \u0645\u0644\u0641 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedCardNumber.aria.label":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryDate.aria.label":"\u062d\u0642\u0644 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0634\u0647\u0631 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryMonth.aria.label":"\u062d\u0642\u0644 \u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0633\u0646\u0629 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryYear.aria.label":"\u062d\u0642\u0644 \u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedSecurityCode.aria.label":"\u062d\u0642\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646","giftcard.encryptedCardNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","giftcard.encryptedCardNumber.aria.label":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","giftcard.encryptedSecurityCode.aria.label":"\u062d\u0642\u0644 \u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627",giftcardTransactionLimit:"\u064a\u0633\u0645\u062d \u0641\u0642\u0637 \u0628\u062d\u062f \u0623\u0642\u0635\u0649 %{amount} \u0644\u0643\u0644 \u0645\u0639\u0627\u0645\u0644\u0629 \u0639\u0644\u0649 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0647\u0630\u0647","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a \u0627\u0644\u0645\u0624\u0645\u0646","ach.encryptedBankAccountNumber.aria.label":"\u062d\u0642\u0644 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","ach.encryptedBankLocationId.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a \u0627\u0644\u0645\u0624\u0645\u0646","ach.encryptedBankLocationId.aria.label":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a","pix.instructions":"\u0627\u0641\u062a\u062d \u0627\u0644\u062a\u0637\u0628\u064a\u0642 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0645\u0641\u062a\u0627\u062d PIX \u0627\u0644\u0645\u0633\u062c\u0644\u060c \u0648\u0627\u062e\u062a\u0631 \u0627\u0644\u062f\u0641\u0639 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 PIX \u0648\u0627\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629 \u0636\u0648\u0626\u064a\u064b\u0627 \u0623\u0648 \u0627\u0646\u0633\u062e \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0635\u0642\u0647","twint.saved":"\u0627\u0644\u0645\u062d\u0641\u0648\u0638\u0629"}}),Lk=Object.freeze({__proto__:null,default:{payButton:"Zaplatit","payButton.redirecting":"P\u0159esm\u011brov\xe1n\xed...",storeDetails:"Ulo\u017eit pro\xa0p\u0159\xed\u0161t\xed platby","creditCard.holderName":"Jm\xe9no na\xa0kart\u011b","creditCard.holderName.placeholder":"Jan Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Konec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"M\u011bs\xedc","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"K\xf3d CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamatovat si pro\xa0p\u0159\xed\u0161t\u011b","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789",installments:"Po\u010det spl\xe1tek",installmentOption:"%{times}\xd7 %{partialValue}",installmentOptionMonths:"%{times} m\u011bs\xedc\u016f","installments.oneTime":"Jednor\xe1zov\xe1 platba","installments.installments":"Platba na\xa0spl\xe1tky","installments.revolving":"Opakuj\xedc\xed se platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"Jan Nov\xe1k","sepa.ownerName":"Jm\xe9no dr\u017eitele \xfa\u010dtu","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"P\u0159esm\u011brov\xe1n\xed selhalo","error.subtitle.payment":"Platba selhala","error.subtitle.refused":"Platba zam\xedtnuta","error.message.unknown":"Do\u0161lo k\xa0nezn\xe1m\xe9 chyb\u011b","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svou banku","creditCard.success":"Platba prob\u011bhla \xfasp\u011b\u0161n\u011b",loading:"Na\u010d\xedt\xe1n\xed\u2026",continue:"Pokra\u010dovat",continueTo:"Pokra\u010dovat k","wechatpay.timetopay":"Na\xa0zaplacen\xed v\xe1m zb\xfdv\xe1 %@","wechatpay.scanqrcode":"Naskenovat QR k\xf3d",personalDetails:"Osobn\xed \xfadaje",companyDetails:"\xdadaje o\xa0spole\u010dnosti","companyDetails.name":"N\xe1zev spole\u010dnosti","companyDetails.registrationNumber":"Registra\u010dn\xed \u010d\xedslo",socialSecurityNumber:"Rodn\xe9 \u010d\xedslo",firstName:"Jm\xe9no",infix:"Prefix",lastName:"P\u0159\xedjmen\xed",mobileNumber:"\u010c\xedslo na mobil","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo mobiln\xedho telefonu",city:"M\u011bsto",postalCode:"PS\u010c",countryCode:"K\xf3d zem\u011b",telephoneNumber:"Telefonn\xed \u010d\xedslo",dateOfBirth:"Datum narozen\xed",shopperEmail:"E-mailov\xe1 adresa",gender:"Pohlav\xed",male:"Mu\u017e",female:"\u017dena",billingAddress:"Faktura\u010dn\xed adresa",street:"Ulice",stateOrProvince:"Kraj nebo okres",country:"Zem\u011b",houseNumberOrName:"\u010c\xedslo popisn\xe9",separateDeliveryAddress:"Zadat dodac\xed adresu odli\u0161nou od faktura\u010dn\xed",deliveryAddress:"Dodac\xed adresa",zipCode:"PS\u010c",apartmentSuite:"Byt",provinceOrTerritory:"Provincie nebo teritorium",cityTown:"M\u011bsto",address:"Adresa",state:"St\xe1t","field.title.optional":"(nepovinn\xe9)","creditCard.cvcField.title.optional":"K\xf3d CVC/CVV (voliteln\xe9)","issuerList.wallet.placeholder":"Vyberte svou pen\u011b\u017eenku",privacyPolicy:"Z\xe1sady ochrany osobn\xedch \xfadaj\u016f","afterPay.agreement":"Souhlas\xedm s %@ spole\u010dnosti AfterPay",paymentConditions:"platebn\xedmi podm\xednkami",openApp:"Otev\u0159ete aplikaci","voucher.readInstructions":"P\u0159e\u010dt\u011bte si pokyny","voucher.introduction":"D\u011bkujeme za\xa0n\xe1kup. K\xa0dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed kup\xf3n.","voucher.expirationDate":"Datum konce platnosti","voucher.alternativeReference":"N\xe1hradn\xed \u010d\xedslo","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte sv\xe9ho poskytovatele","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svou banku","voucher.paymentReferenceLabel":"\u010c\xedslo platby","voucher.surcharge":"V\u010detn\u011b p\u0159ir\xe1\u017eky %@","voucher.introduction.doku":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.shopperName":"Jm\xe9no kupuj\xedc\xedho","voucher.merchantName":"Obchodn\xedk","voucher.introduction.econtext":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.telephoneNumber":"Telefonn\xed \u010d\xedslo","voucher.shopperReference":"\u010c\xedslo kupuj\xedc\xedho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasn\xed instituce","voucher.econtext.telephoneNumber.invalid":"Telefonn\xed \u010d\xedslo mus\xed obsahovat 10 nebo 11 \u010d\xedslic.","boletobancario.btnLabel":"Vygenerovat Boleto","boleto.sendCopyToEmail":"Poslat mi kopii na e-mail","button.copy":"Kop\xedrovat","button.download":"St\xe1hnout","creditCard.storedCard.description.ariaLabel":"Ulo\u017een\xe1 karta kon\u010d\xed na %@","voucher.entity":"Subjekt",donateButton:"P\u0159isp\u011bt",notNowButton:"Te\u010f ne",thanksForYourSupport:"D\u011bkujeme v\xe1m za podporu!",preauthorizeWith:"P\u0159edautorizovat pomoc\xed",confirmPreauthorization:"Potvrdit p\u0159edautorizaci",confirmPurchase:"Potvrdit n\xe1kup",applyGiftcard:"Uplatnit",giftcardBalance:"Z\u016fstatek na d\xe1rkov\xe9 kart\u011b",deductedBalance:"Ode\u010dten\xfd z\u016fstatek","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prvn\xed 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplatn\xe9 heslo","creditCard.taxNumber.label":"Datum narozen\xed dr\u017eitele karty (RRMMDD) nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xe9 datum narozen\xed dr\u017eitele karty nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti","storedPaymentMethod.disable.button":"Odebrat","storedPaymentMethod.disable.confirmation":"Odebrat ulo\u017een\xfd zp\u016fsob platby","storedPaymentMethod.disable.confirmButton":"Ano, odebrat","storedPaymentMethod.disable.cancelButton":"Zru\u0161it","ach.bankAccount":"Bankovn\xed \xfa\u010det","ach.accountHolderNameField.title":"Jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountHolderNameField.placeholder":"Jan Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","select.state":"Vyberte st\xe1t","select.stateOrProvince":"Vyberte kraj nebo okres","select.provinceOrTerritory":"Vyberte provincii nebo teritorium","select.country":"Vyberte zemi","select.noOptionsFound":"Nebyly nalezeny \u017e\xe1dn\xe9 mo\u017enosti","select.filter.placeholder":"Hledat...","telephoneNumber.invalid":"Neplatn\xe9 telefonn\xed \u010d\xedslo",qrCodeOrApp:"nebo","paypal.processingPayment":"Zpracov\xe1n\xed platby...",generateQRCode:"Vygenerovat QR k\xf3d","await.waitForConfirmation":"\u010cek\xe1 se na\xa0potvrzen\xed","mbway.confirmPayment":"Potvr\u010fte platbu v\xa0aplikaci MB WAY","shopperEmail.invalid":"Neplatn\xe1 e-mailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xed v\xe1m b\xfdt alespo\u0148 18 let","blik.confirmPayment":"Spus\u0165te bankovn\xed aplikaci a potvr\u010fte platbu.","blik.invalid":"Zadejte 6 \u010d\xedsel","blik.code":"\u0160estim\xedstn\xfd k\xf3d","blik.help":"Z\xedskejte k\xf3d z bankovn\xed aplikace.","swish.pendingMessage":"Po naskenov\xe1n\xed QR k\xf3du m\u016f\u017ee trvat a\u017e 10 minut, ne\u017e se stav zm\u011bn\xed. Pokud budete zkou\u0161et b\u011bhem t\xe9to doby platbu opakovat, m\u016f\u017ee b\xfdt \u010d\xe1stka zaplacena v\xedcekr\xe1t.","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole nen\xed platn\xe9","error.va.sf-cc-num.01":"Neplatn\xe9 \u010d\xedslo karty","error.va.sf-cc-num.03":"Zad\xe1na nepodporovan\xe1 karta","error.va.sf-cc-dat.01":"P\u0159\xedli\u0161 star\xe1 karta","error.va.sf-cc-dat.02":"Datum p\u0159\xedli\u0161 daleko v budoucnosti","error.va.sf-cc-dat.03":"Platnost karty vypr\u0161\xed p\u0159ed datem z\xfa\u010dtov\xe1n\xed","error.va.sf-ach-num.01":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","error.va.sf-ach-loc.01":"Neplatn\xe9 sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","error.va.sf-kcp-pwd.01":"Neplatn\xe9 heslo","error.giftcard.no-balance":"Na d\xe1rkov\xe9 kart\u011b je nulov\xfd z\u016fstatek","error.giftcard.card-error":"V\xa0na\u0161ich z\xe1znamech nen\xed \u017e\xe1dn\xe1 d\xe1rkov\xe1 karta s\xa0t\xedmto \u010d\xedslem","error.giftcard.currency-error":"D\xe1rkov\xe9 karty jsou platn\xe9 jenom v\xa0m\u011bn\u011b, ve kter\xe9 byly vystaven\xe9","amazonpay.signout":"Odhl\xe1sit se z Amazonu","amazonpay.changePaymentDetails":"Zm\u011bnit \xfadaje o platb\u011b","partialPayment.warning":"Zvolte jin\xfd zp\u016fsob platby pro platbu zb\xfdvaj\xedc\xedch","partialPayment.remainingBalance":"Zb\xfdvaj\xedc\xed z\u016fstatek bude %{amount}","bankTransfer.beneficiary":"P\u0159\xedjemce","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Odkaz","bankTransfer.introduction":"Vytvo\u0159te novou platbu bankovn\xedm p\u0159evodem. K dokon\u010den\xed t\xe9to platby m\u016f\u017eete pou\u017e\xedt \xfadaje na n\xe1sleduj\xedc\xed obrazovce.","bankTransfer.instructions":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","bacs.accountHolderName":"Jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankovn\xedho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankovn\xedho \xfa\u010dtu","bacs.bankLocationId":"K\xf3d Sort","bacs.bankLocationId.invalid":"Neplatn\xfd k\xf3d Sort","bacs.consent.amount":"Souhlas\xedm s\xa0t\xedm, \u017ee mi bude n\xe1sleduj\xedc\xed \u010d\xe1stka ode\u010dtena z\xa0bankovn\xedho \xfa\u010dtu.","bacs.consent.account":"Potvrzuji, \u017ee \xfa\u010det je veden na moje jm\xe9no a\xa0jsem jedin\xfdm disponentem, jeho\u017e podpis je nutn\xfd ke schv\xe1len\xed p\u0159\xedm\xe9ho inkasa.",edit:"Editovat","bacs.confirm":"Potvrdit a\xa0zaplatit","bacs.result.introduction":"St\xe1hn\u011bte si pokyny k\xa0p\u0159\xedm\xe9mu inkasu (DDI / podpisov\xe9 pr\xe1vo)","download.pdf":"St\xe1hnout PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 karty","creditCard.encryptedCardNumber.aria.label":"Pole pro \u010d\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pro datum vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryDate.aria.label":"Pole pro datum vypr\u0161en\xed platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pro m\u011bs\xedc vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryMonth.aria.label":"Pole pro m\u011bs\xedc vypr\u0161en\xed platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pro rok vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryYear.aria.label":"Pole pro rok vypr\u0161en\xed platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 karty","creditCard.encryptedSecurityCode.aria.label":"Pole pro bezpe\u010dnostn\xed k\xf3d","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedCardNumber.aria.label":"Pole pro \u010d\xedslo d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.label":"Pole pro bezpe\u010dnostn\xed k\xf3d d\xe1rkov\xe9 karty",giftcardTransactionLimit:"Maxim\xe1ln\xed povolen\xe1 \u010d\xe1stka za jednu transakci touto d\xe1rkovou kartou je %{amount}.","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho bankovn\xedho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Pole pro bankovn\xed \xfa\u010det","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho k\xf3du banky","ach.encryptedBankLocationId.aria.label":"Pole pro k\xf3d banky","twint.saved":"ulo\u017eeno"}}),Vk=Object.freeze({__proto__:null,default:{payButton:"Betal","payButton.redirecting":"Omdirigerer ...",storeDetails:"Gem til min n\xe6ste betaling","creditCard.holderName":"Navn p\xe5 kort","creditCard.holderName.placeholder":"J. Hansen","creditCard.holderName.invalid":"Ugyldigt kortholdernavn","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Udl\xf8bsdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til n\xe6ste gang","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD/0123456789",installments:"Antal rater",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Afdragsbetaling","installments.revolving":"L\xf8bende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldigt kontonummer","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Kontohavernavn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fejl","error.subtitle.redirect":"Omdirigering fejlede","error.subtitle.payment":"Betaling fejlede","error.subtitle.refused":"Betaling afvist","error.message.unknown":"Der opstod en ukendt fejl","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe6lg din bank","creditCard.success":"Betaling gennemf\xf8rt",loading:"Indl\xe6ser\u2026",continue:"Forts\xe6t",continueTo:"Forts\xe6t til","wechatpay.timetopay":"Du har %@ at betale","wechatpay.scanqrcode":"Scan QR-kode",personalDetails:"Personlige oplysninger",companyDetails:"Virksomhedsoplysninger","companyDetails.name":"Virksomhedsnavn","companyDetails.registrationNumber":"CVR-nummer",socialSecurityNumber:"CPR-nummer",firstName:"Fornavn",infix:"Pr\xe6fiks",lastName:"Efternavn",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ugyldigt mobilnummer",city:"By",postalCode:"Postnummer",countryCode:"Landekode",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf8dselsdato",shopperEmail:"E-mailadresse",gender:"K\xf8n",male:"Mand",female:"Kvinde",billingAddress:"Faktureringsadresse",street:"Gade",stateOrProvince:"Region eller kommune",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Angiv en separat leveringsadresse",deliveryAddress:"Leveringsadresse",zipCode:"Postnummer",apartmentSuite:"Lejlighed/suite",provinceOrTerritory:"Provins eller territorium",cityTown:"By",address:"Adresse",state:"Stat","field.title.optional":"(valgfrit)","creditCard.cvcField.title.optional":"CVC / CVV (valgfrit)","issuerList.wallet.placeholder":"V\xe6lg tegnebog",privacyPolicy:"Politik om privatlivets fred","afterPay.agreement":"Jeg accepterer AfterPays %@",paymentConditions:"betalingsbetingelser",openApp:"\xc5bn appen","voucher.readInstructions":"L\xe6s anvisningerne","voucher.introduction":"Tak for dit k\xf8b. Brug f\xf8lgende kupon til at gennemf\xf8re din betaling.","voucher.expirationDate":"Udl\xf8bsdato","voucher.alternativeReference":"Alternativ reference","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe6lg din udbyder","dragonpay.voucher.bank.selectField.placeholder":"V\xe6lg din bank","voucher.paymentReferenceLabel":"Betalingsreference","voucher.surcharge":"Inkl. till\xe6gsbegyr p\xe5 %@","voucher.introduction.doku":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.shopperName":"Kundenavn","voucher.merchantName":"S\xe6lger","voucher.introduction.econtext":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf8bers reference","voucher.collectionInstitutionNumber":"Id-nummer til opkr\xe6vningsinstitution","voucher.econtext.telephoneNumber.invalid":"Telefonnummer skal best\xe5 af 10 eller 11 cifre","boletobancario.btnLabel":"Gener\xe9r Boleto","boleto.sendCopyToEmail":"Send en kopi til min e-mail","button.copy":"Kopi\xe9r","button.download":"Download","boleto.socialSecurityNumber":"CPF / CNPJ","creditCard.storedCard.description.ariaLabel":"Gemt kort ender p\xe5 %@","voucher.entity":"Enhed",donateButton:"Giv et bidrag",notNowButton:"Ikke nu",thanksForYourSupport:"Tak for din st\xf8tte!",preauthorizeWith:"Forh\xe5ndsgodkend med",confirmPreauthorization:"Bekr\xe6ft forh\xe5ndsgodkendelse",confirmPurchase:"Bekr\xe6ft k\xf8b",applyGiftcard:"Indl\xf8s",giftcardBalance:"Saldo p\xe5 gavekort",deductedBalance:"Fratrukket saldo","creditCard.pin.title":"Pinkode","creditCard.encryptedPassword.label":"F\xf8rste 2 cifre i adgangskode til kort","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig adgangskode","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (\xc5\xc5MMDD) eller virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.labelAlt":"Virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.invalid":"Ugyldig f\xf8dselsdato for kortholder eller virksomheds registreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern gemt betalingsm\xe5de","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Annuller","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontohavers navn","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Ugyldigt kontohavernavn","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldigt kontonummer","ach.accountLocationField.title":"ABA-registreringsnummer","ach.accountLocationField.invalid":"Ugyldigt ABA-registreringsnummer","select.state":"V\xe6lg stat","select.stateOrProvince":"V\xe6lg region eller kommune","select.provinceOrTerritory":"V\xe6lg provins eller territorium","select.country":"V\xe6lg land","select.noOptionsFound":"Ingen muligheder fundet","select.filter.placeholder":"S\xf8g ...","telephoneNumber.invalid":"Ugyldigt telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandler betaling ...",generateQRCode:"Gener\xe9r QR-kode","await.waitForConfirmation":"Venter p\xe5 bekr\xe6ftelse","mbway.confirmPayment":"Bekr\xe6ft din betaling p\xe5 appen MB WAY","shopperEmail.invalid":"Ugyldig e-mailadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du skal v\xe6re mindst 18 \xe5r","blik.confirmPayment":"\xc5bn din bankapp for at bekr\xe6fte betalingen.","blik.invalid":"Indtast 6 tal","blik.code":"6-cifret kode","blik.help":"F\xe5 koden fra din bankapp.","swish.pendingMessage":"Visning af status kan tage op til 10 minutter efter scanning. Et nyt fors\xf8g p\xe5 betaling inden for dette tidsrum kan muligvis medf\xf8re flere gebyrer.","error.va.gen.01":"Felt ikke udfyldt","error.va.gen.02":"Ugyldigt felt","error.va.sf-cc-num.01":"Ugyldigt kortnummer","error.va.sf-cc-num.03":"Ikke-underst\xf8ttet kort indtastet","error.va.sf-cc-dat.01":"Kort for gammelt","error.va.sf-cc-dat.02":"Dato for langt ude i fremtiden","error.va.sf-cc-dat.03":"Dit kort udl\xf8ber f\xf8r betalingsdatoen","error.va.sf-ach-num.01":"Ugyldigt kontonummer","error.va.sf-ach-loc.01":"Ugyldigt ABA-registreringsnummer","error.va.sf-kcp-pwd.01":"Ugyldig adgangskode","error.giftcard.no-balance":"Saldoen p\xe5 gavekortet er 0","error.giftcard.card-error":"Vi har ikke et gavekort med dette nummer i vores optegnelser","error.giftcard.currency-error":"Gavekort er kun gyldige i udstedelsesvalutaen","amazonpay.signout":"Log ud af Amazon","amazonpay.changePaymentDetails":"Skift betalingsoplysninger","partialPayment.warning":"V\xe6lg en anden betalingsm\xe5de til betaling af restbel\xf8bet","partialPayment.remainingBalance":"Restbel\xf8bet vil v\xe6re %{amount}","bankTransfer.beneficiary":"Betalingsmodtager","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Forts\xe6t med at oprette ny betalingsoverf\xf8rsel via bank. Du kan bruge oplysningerne p\xe5 den f\xf8lgende sk\xe6rm til at afslutte betalingen.","bankTransfer.instructions":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","bacs.accountHolderName":"Bankkontohavers navn","bacs.accountHolderName.invalid":"Ugyldigt navn p\xe5 bankkontohaver","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldigt bankkontonummer","bacs.bankLocationId":"Registreringsnummer","bacs.bankLocationId.invalid":"Ugyldigt registreringsnummer","bacs.consent.amount":"Jeg accepterer, at bel\xf8bet ovenfor tr\xe6kkes p\xe5 min bankkonto.","bacs.consent.account":"Jeg bekr\xe6fter, at kontoen er i mit navn, og at jeg er den eneste underskriver, der kr\xe6ves for at godkende direkte debitering af kontoen.",edit:"Rediger","bacs.confirm":"Bekr\xe6ft, og betal","bacs.result.introduction":"Download vejledningen til direkte debitering (fuldmagt til direkte debitering)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe til sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummerfelt","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe til udl\xf8bsdato for sikret kort","creditCard.encryptedExpiryDate.aria.label":"Felt til udl\xf8bsdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe til udl\xf8bsm\xe5ned for sikret kort","creditCard.encryptedExpiryMonth.aria.label":"Felt til udl\xf8bsm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe til udl\xf8bs\xe5r for sikret kort","creditCard.encryptedExpiryYear.aria.label":"Felt til udl\xf8bs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret kort","creditCard.encryptedSecurityCode.aria.label":"Felt til sikkerhedskode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe til nummer for sikret gavekort","giftcard.encryptedCardNumber.aria.label":"Felt til gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret gavekort","giftcard.encryptedSecurityCode.aria.label":"Felt til sikkerhedskode for gavekort",giftcardTransactionLimit:"Maks. %{amount} tilladt pr. transaktion p\xe5 dette gavekort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe til sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Felt til bankkonto","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe til registreringsnummer for sikret bank","ach.encryptedBankLocationId.aria.label":"Felt til registreringsnummer for bank","twint.saved":"gemt"}}),Uk=Object.freeze({__proto__:null,default:{payButton:"Zahlen","payButton.redirecting":"Umleiten\xa0\u2026",storeDetails:"F\xfcr zuk\xfcnftige Zahlvorg\xe4nge speichern","creditCard.holderName":"Name auf der Karte","creditCard.holderName.placeholder":"A. M\xfcller","creditCard.holderName.invalid":"Ung\xfcltiger Karteninhabername","creditCard.numberField.title":"Kartennummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Ablaufdatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Monat","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jahr","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"F\xfcr das n\xe4chste Mal speichern","creditCard.cvcField.placeholder.4digits":"4 Stellen","creditCard.cvcField.placeholder.3digits":"3 Stellen","creditCard.taxNumber.placeholder":"JJMMTT/0123456789",installments:"Anzahl der Raten",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} Monate","installments.oneTime":"Einmalige Zahlung","installments.installments":"Ratenzahlung","installments.revolving":"Ratenzahlung","sepaDirectDebit.ibanField.invalid":"Ung\xfcltige Kontonummer","sepaDirectDebit.nameField.placeholder":"A. M\xfcller","sepa.ownerName":"Name des Kontoinhabers","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fehler","error.subtitle.redirect":"Weiterleitung fehlgeschlagen","error.subtitle.payment":"Zahlung fehlgeschlagen","error.subtitle.refused":"Zahlvorgang verweigert","error.message.unknown":"Es ist ein unbekannter Fehler aufgetreten.","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Bank ausw\xe4hlen","creditCard.success":"Zahlung erfolgreich",loading:"Laden \u2026",continue:"Weiter",continueTo:"Weiter zu","wechatpay.timetopay":"Sie haben noch %@ um zu zahlen","wechatpay.scanqrcode":"QR-Code scannen",personalDetails:"Pers\xf6nliche Angaben",companyDetails:"Unternehmensdaten","companyDetails.name":"Unternehmensname","companyDetails.registrationNumber":"Registrierungsnummer",socialSecurityNumber:"Sozialversicherungsnummer",firstName:"Vorname",infix:"Vorwahl",lastName:"Nachname",mobileNumber:"Handynummer","mobileNumber.invalid":"Ung\xfcltige Handynummer",city:"Stadt",postalCode:"Postleitzahl",countryCode:"Landesvorwahl",telephoneNumber:"Telefonnummer",dateOfBirth:"Geburtsdatum",shopperEmail:"E-Mail-Adresse",gender:"Geschlecht",male:"M\xe4nnlich",female:"Weiblich",billingAddress:"Rechnungsadresse",street:"Stra\xdfe",stateOrProvince:"Bundesland",country:"Land",houseNumberOrName:"Hausnummer",separateDeliveryAddress:"Abweichende Lieferadresse angeben",deliveryAddress:"Lieferadresse",zipCode:"PLZ",apartmentSuite:"Wohnung/Geschoss",provinceOrTerritory:"Provinz oder Territorium",cityTown:"Ort",address:"Stra\xdfe und Hausnummer",state:"Bundesstaat","field.title.optional":"(optional)","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Virtuelle Brieftasche ausw\xe4hlen",privacyPolicy:"Datenschutz","afterPay.agreement":"Ich bin mit den %@ von AfterPay einverstanden",paymentConditions:"Zahlungsbedingungen",openApp:"App \xf6ffnen","voucher.readInstructions":"Anweisungen lesen","voucher.introduction":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung des folgenden Gutscheins ab.","voucher.expirationDate":"G\xfcltig bis","voucher.alternativeReference":"Alternative Referenz","dragonpay.voucher.non.bank.selectField.placeholder":"Anbieter ausw\xe4hlen","dragonpay.voucher.bank.selectField.placeholder":"Bank ausw\xe4hlen","voucher.paymentReferenceLabel":"Zahlungsreferenz","voucher.surcharge":"Inkl. % @Zuschlag","voucher.introduction.doku":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.shopperName":"Name des K\xe4ufers","voucher.merchantName":"H\xe4ndler","voucher.introduction.econtext":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundenreferenz","voucher.collectionInstitutionNumber":"Nummer der Zahlungsannahmestelle","voucher.econtext.telephoneNumber.invalid":"Die Telefonnummer muss 10- oder 11-stellig sein","boletobancario.btnLabel":"Boleto generieren","boleto.sendCopyToEmail":"Eine Kopie an meine E-Mail-Adresse senden","button.copy":"Kopieren","button.download":"Herunterladen","creditCard.storedCard.description.ariaLabel":"Gespeicherte Karte endet auf %@","voucher.entity":"Entit\xe4t",donateButton:"Spenden",notNowButton:"Nicht jetzt",thanksForYourSupport:"Danke f\xfcr Ihre Unterst\xfctzung!",preauthorizeWith:"Vorautorisieren mit",confirmPreauthorization:"Vorautorisierung best\xe4tigen",confirmPurchase:"Kauf best\xe4tigen",applyGiftcard:"Einl\xf6sen",giftcardBalance:"Saldo der Geschenkkarte",deductedBalance:"Abgezogener Betrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Die ersten zwei Ziffern des Kartenpassworts","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ung\xfcltiges Passwort","creditCard.taxNumber.label":"Geburtsdatum des Karteninhabers (JJMMTT) oder Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.labelAlt":"Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.invalid":"Ung\xfcltiges Geburtsdatum des Karteninhabers oder ung\xfcltige Unternehmensregistrierungsnummer","storedPaymentMethod.disable.button":"Entfernen","storedPaymentMethod.disable.confirmation":"Gespeicherte Zahlungsmethode entfernen","storedPaymentMethod.disable.confirmButton":"Ja, entfernen","storedPaymentMethod.disable.cancelButton":"Abbrechen","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Name des Kontoinhabers","ach.accountHolderNameField.placeholder":"A. M\xfcller","ach.accountHolderNameField.invalid":"Ung\xfcltiger Kontoinhabername","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ung\xfcltige Kontonummer","ach.accountLocationField.title":"ABA-Nummer","ach.accountLocationField.invalid":"Ung\xfcltige ABA-Nummer","select.state":"Bundesstaat ausw\xe4hlen","select.stateOrProvince":"Bundesland oder Provinz/Region ausw\xe4hlen","select.provinceOrTerritory":"Provinz oder Territorium ausw\xe4hlen","select.country":"Land ausw\xe4hlen","select.noOptionsFound":"Keine Optionen gefunden","select.filter.placeholder":"Suche\xa0\u2026","telephoneNumber.invalid":"Ung\xfcltige Telefonnummer",qrCodeOrApp:"oder","paypal.processingPayment":"Zahlung wird verarbeitet\xa0\u2026",generateQRCode:"QR-Code generieren","await.waitForConfirmation":"Warten auf Best\xe4tigung","mbway.confirmPayment":"Best\xe4tigen Sie Ihre Zahlung in der MB WAY-App","shopperEmail.invalid":"Ung\xfcltige E-Mail-Adresse","dateOfBirth.format":"TT.MM.JJJJ","dateOfBirth.invalid":"Sie m\xfcssen mindestens 18 Jahre alt sein","blik.confirmPayment":"\xd6ffnen Sie Ihre Banking-App, um die Zahlung zu best\xe4tigen.","blik.invalid":"6 Zahlen eingeben","blik.code":"6-stelliger Code","blik.help":"Rufen Sie den Code \xfcber Ihre Banking-App ab.","swish.pendingMessage":"Es kann sein, dass der Status bis zu 10 Minuten nach dem Scan \u201eausstehend\u201c lautet. Wenn Sie w\xe4hrenddessen einen neuen Zahlungsversuch unternehmen, kann es sein, dass Ihnen mehrere Betr\xe4ge in Rechnung gestellt werden.","error.va.gen.01":"Feld nicht ausgef\xfcllt","error.va.gen.02":"Feld ung\xfcltig","error.va.sf-cc-num.01":"Ung\xfcltige Kartennummer","error.va.sf-cc-num.03":"Nicht unterst\xfctzte Karte eingegeben","error.va.sf-cc-dat.01":"Karte zu alt","error.va.sf-cc-dat.02":"Datum zu weit in der Zukunft","error.va.sf-cc-dat.03":"Ihre Karte l\xe4uft vor dem Bezahldatum ab.","error.va.sf-ach-num.01":"Ung\xfcltige Kontonummer","error.va.sf-ach-loc.01":"Ung\xfcltige ABA-Nummer","error.va.sf-kcp-pwd.01":"Ung\xfcltiges Passwort","error.giftcard.no-balance":"Auf dieser Geschenkkarte ist kein Guthaben vorhanden","error.giftcard.card-error":"Es gibt in unserem System keine Geschenkkarte mit dieser Nummer","error.giftcard.currency-error":"Geschenkkarten sind nur in der W\xe4hrung g\xfcltig, in der sie ausgestellt wurden","amazonpay.signout":"Von Amazon abmelden","amazonpay.changePaymentDetails":"Zahlungsinformationen \xe4ndern","partialPayment.warning":"W\xe4hlen Sie eine andere Zahlungsmethode zur Zahlung des Restbetrags","partialPayment.remainingBalance":"Es verbleibt ein Restbetrag von %{amount}","bankTransfer.beneficiary":"Empf\xe4nger","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenz","bankTransfer.introduction":"Fortfahren, um eine neue Bank\xfcberweisungszahlung zu erstellen. Sie k\xf6nnen die Informationen auf dem n\xe4chsten Bildschirm verwenden, um diese Zahlung abzuschlie\xdfen.","bankTransfer.instructions":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","bacs.accountHolderName":"Name des Bankkontoinhabers","bacs.accountHolderName.invalid":"Ung\xfcltiger Bankkontoinhabername","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ung\xfcltige Bankkontonummer","bacs.bankLocationId":"Bankleitzahl","bacs.bankLocationId.invalid":"Ung\xfcltige Bankleitzahl","bacs.consent.amount":"Ich bin damit einverstanden, dass der oben genannte Betrag von meinem Bankkonto abgebucht wird.","bacs.consent.account":"Ich best\xe4tige, dass das Konto unter meinem Namen l\xe4uft und ich der einzige erforderliche Unterzeichner bin, um die Lastschrift f\xfcr dieses Konto zu autorisieren.",edit:"Bearbeiten","bacs.confirm":"Best\xe4tigen und bezahlen","bacs.result.introduction":"Laden Sie Ihre Lastschriftanweisung (DDI/Einzugserm\xe4chtigung) herunter","download.pdf":"PDF herunterladen","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Nummer der gesicherten Karte","creditCard.encryptedCardNumber.aria.label":"Feld \u201eKartennummer\u201c","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xfcr Ablaufdatum der gesicherten Karte","creditCard.encryptedExpiryDate.aria.label":"Feld \u201eAblaufdatum\u201c","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xfcr Monat des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryMonth.aria.label":"Feld \u201eMonat des Ablaufdatums\u201c","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xfcr Jahr des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryYear.aria.label":"Feld \u201eJahr des Ablaufdatums\u201c","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Karte","creditCard.encryptedSecurityCode.aria.label":"Feld \u201eSicherheitscode\u201c","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Geschenkkartennummer der gesicherten Karte","giftcard.encryptedCardNumber.aria.label":"Feld \u201eGeschenkkartennummer\u201c","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Geschenkkarte","giftcard.encryptedSecurityCode.aria.label":"Feld \u201eSicherheitscode der Geschenkkarte\u201c",giftcardTransactionLimit:"Der zul\xe4ssige H\xf6chstbetrag pro Transaktion f\xfcr diese Geschenkkarte ist %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xfcr gesicherte Bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Feld \u201eBankkonto\u201c","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xfcr gesicherte BLZ","ach.encryptedBankLocationId.aria.label":"Bankleitzahl-Feld","twint.saved":"hinterlegt"}}),Kk=Object.freeze({__proto__:null,default:{payButton:"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","payButton.redirecting":"\u0391\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7...",storeDetails:"\u0391\u03c0\u03bf\u03b8\u03ae\u03ba\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03bf\u03c5","creditCard.holderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03c3\u03c4\u03b7\u03bd \u03ba\u03ac\u03c1\u03c4\u03b1","creditCard.holderName.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","creditCard.holderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.expiryDateField.placeholder":"\u039c\u039c/\u0395\u0395","creditCard.expiryDateField.month":"\u039c\u03ae\u03bd\u03b1\u03c2","creditCard.expiryDateField.month.placeholder":"\u039c\u039c","creditCard.expiryDateField.year.placeholder":"\u0395\u0395","creditCard.expiryDateField.year":"\u0388\u03c4\u03bf\u03c2","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0391\u03c0\u03bf\u03bc\u03bd\u03b7\u03bc\u03cc\u03bd\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c6\u03bf\u03c1\u03ac","creditCard.cvcField.placeholder.4digits":"4\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.cvcField.placeholder.3digits":"3\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.taxNumber.placeholder":"\u0395\u0395\u039c\u039c\u0397\u0397 / 0123456789",installments:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03cc\u03c3\u03b5\u03c9\u03bd",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} \u03bc\u03ae\u03bd\u03b5\u03c2","installments.oneTime":"\u0395\u03c6\u03ac\u03c0\u03b1\u03be \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","installments.installments":"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03b5 \u03b4\u03cc\u03c3\u03b5\u03b9\u03c2","installments.revolving":"\u0391\u03bd\u03b1\u03ba\u03c5\u03ba\u03bb\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","sepaDirectDebit.ibanField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","sepaDirectDebit.nameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","sepa.ownerName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5","sepa.ibanNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd (IBAN)","error.title":"\u03a3\u03c6\u03ac\u03bb\u03bc\u03b1","error.subtitle.redirect":"\u0397 \u03b1\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.payment":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.refused":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03af\u03c6\u03b8\u03b7\u03ba\u03b5","error.message.unknown":"\u03a0\u03c1\u03bf\u03ad\u03ba\u03c5\u03c8\u03b5 \u03ac\u03b3\u03bd\u03c9\u03c3\u03c4\u03bf \u03c3\u03c6\u03ac\u03bb\u03bc\u03b1","idealIssuer.selectField.title":"\u03a4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1","idealIssuer.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","creditCard.success":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03b8\u03b7\u03ba\u03b5 \u03b5\u03c0\u03b9\u03c4\u03c5\u03c7\u03ce\u03c2",loading:"\u03a6\u03cc\u03c1\u03c4\u03c9\u03c3\u03b7...",continue:"\u03a3\u03c5\u03bd\u03ad\u03c7\u03b5\u03b9\u03b1",continueTo:"\u039c\u03b5\u03c4\u03ac\u03b2\u03b1\u03c3\u03b7 \u03c3\u03c4\u03b7\u03bd","wechatpay.timetopay":"\u0388\u03c7\u03b5\u03c4\u03b5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03ac\u03b8\u03b5\u03c3\u03ae \u03c3\u03b1\u03c2 %@ \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","wechatpay.scanqrcode":"\u03a3\u03ac\u03c1\u03c9\u03c3\u03b7 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR",personalDetails:"\u03a0\u03c1\u03bf\u03c3\u03c9\u03c0\u03b9\u03ba\u03ac \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1",companyDetails:"\u03a3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.name":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.registrationNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5",socialSecurityNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c6\u03bf\u03c1\u03bf\u03bb\u03bf\u03b3\u03b9\u03ba\u03bf\u03cd \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5",firstName:"\u038c\u03bd\u03bf\u03bc\u03b1",infix:"\u03a0\u03c1\u03cc\u03b8\u03b5\u03bc\u03b1",lastName:"\u0395\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf",mobileNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd","mobileNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd",city:"\u03a0\u03cc\u03bb\u03b7",postalCode:"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2",countryCode:"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c7\u03ce\u03c1\u03b1\u03c2",telephoneNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5",dateOfBirth:"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2",shopperEmail:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email",gender:"\u03a6\u03cd\u03bb\u03bf",male:"\u0386\u03bd\u03c4\u03c1\u03b1\u03c2",female:"\u0393\u03c5\u03bd\u03b1\u03af\u03ba\u03b1",billingAddress:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c4\u03b9\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2",street:"\u039f\u03b4\u03cc\u03c2",stateOrProvince:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1",country:"\u03a7\u03ce\u03c1\u03b1",houseNumberOrName:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bf\u03b9\u03ba\u03af\u03b1\u03c2",separateDeliveryAddress:"\u039a\u03b1\u03b8\u03bf\u03c1\u03af\u03c3\u03c4\u03b5 \u03bc\u03b9\u03b1 \u03be\u03b5\u03c7\u03c9\u03c1\u03b9\u03c3\u03c4\u03ae \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2",deliveryAddress:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2",zipCode:"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03ce\u03b4\u03b9\u03ba\u03b1\u03c2",apartmentSuite:"\u0394\u03b9\u03b1\u03bc\u03ad\u03c1\u03b9\u03c3\u03bc\u03b1/\u0393\u03c1\u03b1\u03c6\u03b5\u03af\u03bf",provinceOrTerritory:"\u0395\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1",cityTown:"\u03a0\u03cc\u03bb\u03b7 / \u039a\u03bf\u03b9\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1",address:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7",state:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","field.title.optional":"(\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03cc)","creditCard.cvcField.title.optional":"CVC/CVV (\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03ac)","issuerList.wallet.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf \u03c0\u03bf\u03c1\u03c4\u03bf\u03c6\u03cc\u03bb\u03b9 \u03c3\u03b1\u03c2",privacyPolicy:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b9\u03ba\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03ae\u03c4\u03bf\u03c5","afterPay.agreement":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03c4\u03bf\u03c5\u03c2 %@ \u03c4\u03bf\u03c5 AfterPay",paymentConditions:"\u03cc\u03c1\u03bf\u03c5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2",openApp:"\u0386\u03bd\u03bf\u03b9\u03b3\u03bc\u03b1 \u03c4\u03b7\u03c2 \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae\u03c2","voucher.readInstructions":"\u0394\u03b9\u03b1\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03bf\u03b4\u03b7\u03b3\u03af\u03b5\u03c2","voucher.introduction":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03bf \u03c0\u03b1\u03c1\u03b1\u03ba\u03ac\u03c4\u03c9 \u03ba\u03bf\u03c5\u03c0\u03cc\u03bd\u03b9 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.expirationDate":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","voucher.alternativeReference":"\u0395\u03bd\u03b1\u03bb\u03bb\u03b1\u03ba\u03c4\u03b9\u03ba\u03ae \u03b1\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","dragonpay.voucher.non.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf\u03bd \u03c0\u03ac\u03c1\u03bf\u03c7\u03cc \u03c3\u03b1\u03c2","dragonpay.voucher.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","voucher.paymentReferenceLabel":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","voucher.surcharge":"\u03a0\u03b5\u03c1\u03b9\u03bb\u03b1\u03bc\u03b2\u03ac\u03bd\u03b5\u03c4\u03b1\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7 %@","voucher.introduction.doku":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.shopperName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.merchantName":"\u0388\u03bc\u03c0\u03bf\u03c1\u03bf\u03c2","voucher.introduction.econtext":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.telephoneNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5","voucher.shopperReference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.collectionInstitutionNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c0\u03c1\u03b1\u03ba\u03c4\u03bf\u03c1\u03b5\u03af\u03bf\u03c5 \u03b5\u03b9\u03c3\u03c0\u03c1\u03ac\u03be\u03b5\u03c9\u03bd","voucher.econtext.telephoneNumber.invalid":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5 \u03c0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 10 \u03ae 11 \u03c8\u03b7\u03c6\u03af\u03b1","boletobancario.btnLabel":"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 Boleto","boleto.sendCopyToEmail":"\u0391\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae \u03b1\u03bd\u03c4\u03b9\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email \u03bc\u03bf\u03c5","button.copy":"\u0391\u03bd\u03c4\u03b9\u03b3\u03c1\u03b1\u03c6\u03ae","button.download":"\u039b\u03ae\u03c8\u03b7","creditCard.storedCard.description.ariaLabel":"\u0397 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c4\u03b5\u03bb\u03b5\u03b9\u03ce\u03bd\u03b5\u03b9 \u03c3\u03b5 %@","voucher.entity":"\u039f\u03bd\u03c4\u03cc\u03c4\u03b7\u03c4\u03b1",donateButton:"\u0394\u03c9\u03c1\u03b5\u03ac",notNowButton:"\u038c\u03c7\u03b9 \u03c4\u03ce\u03c1\u03b1",thanksForYourSupport:"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c5\u03c0\u03bf\u03c3\u03c4\u03ae\u03c1\u03b9\u03be\u03b7!",preauthorizeWith:"\u03a0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03bc\u03b5",confirmPreauthorization:"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03c0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7\u03c2",confirmPurchase:"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03b1\u03b3\u03bf\u03c1\u03ac\u03c2",applyGiftcard:"\u0395\u03be\u03b1\u03c1\u03b3\u03cd\u03c1\u03c9\u03c3\u03b7",giftcardBalance:"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2",deductedBalance:"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03c0\u03bf\u03c5 \u03b1\u03c6\u03b1\u03b9\u03c1\u03ad\u03b8\u03b7\u03ba\u03b5","creditCard.pin.title":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 PIN","creditCard.encryptedPassword.label":"\u03a4\u03b1 \u03c0\u03c1\u03ce\u03c4\u03b1 2 \u03c8\u03b7\u03c6\u03af\u03b1 \u03c4\u03bf\u03c5 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03c4\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2","creditCard.taxNumber.label":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 (YYMMDD) \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.labelAlt":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd","storedPaymentMethod.disable.button":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.confirmation":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03bf\u03c5 \u03c4\u03c1\u03cc\u03c0\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","storedPaymentMethod.disable.confirmButton":"\u039d\u03b1\u03b9, \u03b1\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.cancelButton":"\u0386\u03ba\u03c5\u03c1\u03bf","ach.bankAccount":"\u03a4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2","ach.accountHolderNameField.title":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountHolderNameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","ach.accountHolderNameField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountLocationField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","ach.accountLocationField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","select.state":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","select.stateOrProvince":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1","select.provinceOrTerritory":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1","select.country":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c7\u03ce\u03c1\u03b1","select.noOptionsFound":"\u0394\u03b5\u03bd \u03b2\u03c1\u03ad\u03b8\u03b7\u03ba\u03b1\u03bd \u03b5\u03c0\u03b9\u03bb\u03bf\u03b3\u03ad\u03c2","select.filter.placeholder":"\u0391\u03bd\u03b1\u03b6\u03ae\u03c4\u03b7\u03c3\u03b7...","telephoneNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5",qrCodeOrApp:"\u03ae","paypal.processingPayment":"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2...",generateQRCode:"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR","await.waitForConfirmation":"\u0391\u03bd\u03b1\u03bc\u03bf\u03bd\u03ae \u03b3\u03b9\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7\u2026","mbway.confirmPayment":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03c3\u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae MB WAY","shopperEmail.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email","dateOfBirth.format":"\u0397\u0397/\u039c\u039c/\u0395\u0395\u0395\u0395","dateOfBirth.invalid":"\u03a0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03b5\u03af\u03c3\u03c4\u03b5 \u03c4\u03bf\u03c5\u03bb\u03ac\u03c7\u03b9\u03c3\u03c4\u03bf\u03bd 18 \u03b5\u03c4\u03ce\u03bd","blik.confirmPayment":"\u0391\u03bd\u03bf\u03af\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","blik.invalid":"\u0395\u03b9\u03c3\u03b1\u03b3\u03ac\u03b3\u03b5\u03c4\u03b5 6 \u03c8\u03b7\u03c6\u03af\u03b1","blik.code":"6\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2","blik.help":"\u039b\u03ac\u03b2\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2.","swish.pendingMessage":"\u039c\u03b5\u03c4\u03ac \u03c4\u03b7 \u03c3\u03ac\u03c1\u03c9\u03c3\u03b7, \u03b7 \u03ba\u03b1\u03c4\u03ac\u03c3\u03c4\u03b1\u03c3\u03b7 \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03b5\u03ba\u03ba\u03c1\u03b5\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ad\u03c9\u03c2 10 \u03bb\u03b5\u03c0\u03c4\u03ac. \u0397 \u03b1\u03c0\u03cc\u03c0\u03b5\u03b9\u03c1\u03b1 \u03b5\u03ba \u03bd\u03ad\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b5\u03bd\u03c4\u03cc\u03c2 \u03b1\u03c5\u03c4\u03bf\u03cd \u03c4\u03bf\u03c5 \u03c7\u03c1\u03bf\u03bd\u03b9\u03ba\u03bf\u03cd \u03b4\u03b9\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03b5\u03bd\u03b4\u03ad\u03c7\u03b5\u03c4\u03b1\u03b9 \u03bd\u03b1 \u03c0\u03c1\u03bf\u03ba\u03b1\u03bb\u03ad\u03c3\u03b5\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7.","error.va.gen.01":"\u0395\u03bb\u03bb\u03b9\u03c0\u03ad\u03c2 \u03c0\u03b5\u03b4\u03af\u03bf","error.va.gen.02":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf","error.va.sf-cc-num.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","error.va.sf-cc-num.03":"\u0395\u03b9\u03c3\u03ac\u03c7\u03b8\u03b7\u03ba\u03b5 \u03bc\u03b7 \u03c5\u03c0\u03bf\u03c3\u03c4\u03b7\u03c1\u03b9\u03b6\u03cc\u03bc\u03b5\u03bd\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1","error.va.sf-cc-dat.01":"\u0397 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03c0\u03b1\u03bb\u03b9\u03ac","error.va.sf-cc-dat.02":"\u0397 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03bc\u03b1\u03ba\u03c1\u03b9\u03bd\u03ae","error.va.sf-cc-dat.03":"\u0397 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c3\u03b1\u03c2 \u03bb\u03ae\u03b3\u03b5\u03b9 \u03c0\u03c1\u03b9\u03bd \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b1\u03bd\u03b1\u03c7\u03ce\u03c1\u03b7\u03c3\u03b7\u03c2","error.va.sf-ach-num.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","error.va.sf-ach-loc.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","error.va.sf-kcp-pwd.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2","error.giftcard.no-balance":"\u0397 \u03c3\u03c5\u03b3\u03ba\u03b5\u03ba\u03c1\u03b9\u03bc\u03ad\u03bd\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03ad\u03c7\u03b5\u03b9 \u03bc\u03b7\u03b4\u03b5\u03bd\u03b9\u03ba\u03cc \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf","error.giftcard.card-error":"\u03a3\u03c4\u03b1 \u03b1\u03c1\u03c7\u03b5\u03af\u03b1 \u03bc\u03b1\u03c2 \u03b4\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03b5\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03bc\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc","error.giftcard.currency-error":"\u039f\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03b9\u03c3\u03c7\u03cd\u03bf\u03c5\u03bd \u03bc\u03cc\u03bd\u03bf \u03b3\u03b9\u03b1 \u03c4\u03bf \u03bd\u03cc\u03bc\u03b9\u03c3\u03bc\u03b1 \u03c3\u03c4\u03bf \u03bf\u03c0\u03bf\u03af\u03bf \u03b5\u03ba\u03b4\u03cc\u03b8\u03b7\u03ba\u03b1\u03bd","amazonpay.signout":"\u0391\u03c0\u03bf\u03c3\u03cd\u03bd\u03b4\u03b5\u03c3\u03b7 \u03b1\u03c0\u03cc \u03c4\u03bf Amazon","amazonpay.changePaymentDetails":"\u0391\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03c9\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","partialPayment.warning":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03ad\u03bd\u03b1\u03bd \u03ac\u03bb\u03bb\u03bf \u03c4\u03c1\u03cc\u03c0\u03bf \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ba\u03b1\u03c4\u03b1\u03b2\u03bf\u03bb\u03ae \u03c4\u03bf\u03c5 \u03b5\u03bd\u03b1\u03c0\u03bf\u03bc\u03b5\u03af\u03bd\u03b1\u03bd\u03c4\u03bf\u03c2 \u03c0\u03bf\u03c3\u03bf\u03cd","partialPayment.remainingBalance":"\u03a4\u03bf \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b8\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","bankTransfer.beneficiary":"\u0394\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c2","bankTransfer.iban":"\u0399\u0392\u0391\u039d","bankTransfer.bic":"BIC","bankTransfer.reference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","bankTransfer.introduction":"\u03a3\u03c5\u03bd\u03b5\u03c7\u03af\u03c3\u03c4\u03b5 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b4\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03ae\u03c3\u03b5\u03c4\u03b5 \u03bd\u03ad\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03ad\u03c3\u03c9 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ac\u03c2. \u039c\u03c0\u03bf\u03c1\u03b5\u03af\u03c4\u03b5 \u03bd\u03b1 \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b1 \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03c3\u03c4\u03b7\u03bd \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b7 \u03bf\u03b8\u03cc\u03bd\u03b7 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bankTransfer.instructions":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bacs.accountHolderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountHolderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.bankLocationId":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.bankLocationId.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.consent.amount":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03cc\u03c4\u03b9 \u03c4\u03bf \u03c0\u03b9\u03bf \u03c0\u03ac\u03bd\u03c9 \u03c0\u03bf\u03c3\u03cc \u03b8\u03b1 \u03b1\u03c6\u03b1\u03b9\u03c1\u03b5\u03b8\u03b5\u03af \u03b1\u03c0\u03cc \u03c4\u03bf\u03bd \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc \u03bc\u03bf\u03c5.","bacs.consent.account":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03bd\u03c9 \u03cc\u03c4\u03b9 \u03bf \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c3\u03c4\u03bf \u03cc\u03bd\u03bf\u03bc\u03ac \u03bc\u03bf\u03c5 \u03ba\u03b1\u03b9 \u03c0\u03c9\u03c2 \u03b5\u03af\u03bc\u03b1\u03b9 \u03bf/\u03b7 \u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03cc\u03c2/\u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03ae \u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03c9\u03bd/\u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5\u03c3\u03b1 \u03c0\u03bf\u03c5 \u03b1\u03c0\u03b1\u03b9\u03c4\u03b5\u03af\u03c4\u03b1\u03b9 \u03b3\u03b9\u03b1 \u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03c4\u03b7\u03c2 \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 \u03c3\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc.",edit:"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1","bacs.confirm":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03ba\u03b1\u03b9 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","bacs.result.introduction":"\u039a\u03b1\u03c4\u03b5\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u0395\u03bd\u03c4\u03bf\u03bb\u03ae \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 (DDI/\u0395\u03bd\u03c4\u03bf\u03bb\u03ae)","download.pdf":"\u039b\u03ae\u03c8\u03b7 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedCardNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryMonth.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ad\u03c2 \u03ad\u03c4\u03bf\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryYear.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ad\u03c4\u03bf\u03c5\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedSecurityCode.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedCardNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2",giftcardTransactionLimit:"\u03a4\u03bf \u03bc\u03ad\u03b3\u03b9\u03c3\u03c4\u03bf \u03b5\u03c0\u03b9\u03c4\u03c1\u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03bf \u03c0\u03bf\u03c3\u03cc \u03b1\u03bd\u03ac \u03c3\u03c5\u03bd\u03b1\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.encryptedBankAccountNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c5\u03c0\u03bf\u03ba\u03b1\u03c4\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","ach.encryptedBankLocationId.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c5\u03c0\u03bf\u03ba\u03b1\u03c4\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","twint.saved":"\u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03cd\u03c4\u03b7\u03ba\u03b5"}}),Hk=Object.freeze({__proto__:null,default:{payButton:"Pagar","payButton.redirecting":"Redirigiendo...",storeDetails:"Recordar para mi pr\xf3ximo pago","creditCard.holderName":"Nombre en la tarjeta","creditCard.holderName.placeholder":"Juan P\xe9rez","creditCard.holderName.invalid":"Nombre del titular de tarjeta no v\xe1lido","creditCard.numberField.title":"N\xfamero de tarjeta","creditCard.expiryDateField.title":"Fecha de expiraci\xf3n","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mes","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"A\xf1o","creditCard.cvcField.title":"CVC / CVV","creditCard.storeDetailsButton":"Recordar para la pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAMMDD / 0123456789",installments:"N\xfamero de plazos",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\xa0meses","installments.oneTime":"Pago \xfanico","installments.installments":"Pago fraccionado","installments.revolving":"Pago rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de cuenta no v\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nombre del titular de cuenta","sepa.ibanNumber":"N\xfamero de cuenta (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirecci\xf3n fallida","error.subtitle.payment":"Pago fallido","error.subtitle.refused":"Pago rechazado","error.message.unknown":"Se ha producido un error desconocido","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Seleccione su banco","creditCard.success":"Pago realizado correctamente",loading:"Cargando...",continue:"Continuar",continueTo:"Continuar a","wechatpay.timetopay":"Tiene %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR",personalDetails:"Datos personales",companyDetails:"Datos de la empresa","companyDetails.name":"Nombre de la empresa","companyDetails.registrationNumber":"N\xfamero de registro",socialSecurityNumber:"N\xfamero de seguridad social",firstName:"Nombre",infix:"Prefijo",lastName:"Apellidos",mobileNumber:"Tel\xe9fono m\xf3vil","mobileNumber.invalid":"N\xfamero de m\xf3vil no v\xe1lido",city:"Ciudad",postalCode:"C\xf3digo postal",countryCode:"Prefijo internacional",telephoneNumber:"N\xfamero de tel\xe9fono",dateOfBirth:"Fecha de nacimiento",shopperEmail:"Direcci\xf3n de correo electr\xf3nico",gender:"G\xe9nero",male:"Masculino",female:"Femenino",billingAddress:"Direcci\xf3n de facturaci\xf3n",street:"Calle",stateOrProvince:"Provincia o estado",country:"Pa\xeds",houseNumberOrName:"N\xfamero de vivienda",separateDeliveryAddress:"Especificar otra direcci\xf3n de env\xedo",deliveryAddress:"Direcci\xf3n de env\xedo",zipCode:"C\xf3digo postal",apartmentSuite:"Apartamento/suite",provinceOrTerritory:"Provincia o territorio",cityTown:"Ciudad/poblaci\xf3n",address:"Direcci\xf3n",state:"Estado","field.title.optional":"(opcional)","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Seleccione su monedero electr\xf3nico",privacyPolicy:"Pol\xedtica de privacidad","afterPay.agreement":"S\xed, acepto las %@ de AfterPay",paymentConditions:"condiciones de pago",openApp:"Abrir la aplicaci\xf3n","voucher.readInstructions":"Leer instrucciones","voucher.introduction":"Gracias por su compra. Use el siguiente cup\xf3n para completar su pago.","voucher.expirationDate":"Fecha de caducidad","voucher.alternativeReference":"Referencia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Seleccione su proveedor","dragonpay.voucher.bank.selectField.placeholder":"Seleccione su banco","voucher.paymentReferenceLabel":"Referencia de pago","voucher.surcharge":"Incluye recargo de %@","voucher.introduction.doku":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.shopperName":"Nombre del comprador","voucher.merchantName":"Vendedor","voucher.introduction.econtext":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.telephoneNumber":"N\xfamero de tel\xe9fono","voucher.shopperReference":"Referencia cliente","voucher.collectionInstitutionNumber":"N\xfamero de instituci\xf3n de cobro","voucher.econtext.telephoneNumber.invalid":"El n\xfamero de tel\xe9fono debe tener 10 u 11 d\xedgitos","boletobancario.btnLabel":"Generar Boleto","boleto.sendCopyToEmail":"Enviar copia a mi correo electr\xf3nico","button.copy":"Copiar","button.download":"Descargar","creditCard.storedCard.description.ariaLabel":"La tarjeta almacenada termina en %@","voucher.entity":"Entidad",donateButton:"Donar",notNowButton:"Ahora no",thanksForYourSupport:"\xa1Gracias por su contribuci\xf3n!",preauthorizeWith:"Preautorizar con",confirmPreauthorization:"Confirmar preautorizaci\xf3n",confirmPurchase:"Confirmar compra",applyGiftcard:"Canjear",giftcardBalance:"Saldo de la tarjeta regalo",deductedBalance:"Saldo deducido","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta","creditCard.encryptedPassword.invalid":"Contrase\xf1a incorrecta","creditCard.taxNumber.label":"Fecha de nacimiento del titular de la tarjeta (AAMMDD) o n\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.invalid":"Fecha de nacimiento del titular o n\xfamero de registro comercial incorrectos","storedPaymentMethod.disable.button":"Eliminar","storedPaymentMethod.disable.confirmation":"Eliminar m\xe9todo de pago almacenado","storedPaymentMethod.disable.confirmButton":"S\xed, eliminar","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Cuenta bancaria","ach.accountHolderNameField.title":"Nombre del titular de la cuenta","ach.accountHolderNameField.placeholder":"Juan P\xe9rez","ach.accountHolderNameField.invalid":"El nombre del titular de la cuenta no es v\xe1lido","ach.accountNumberField.title":"N\xfamero de cuenta","ach.accountNumberField.invalid":"N\xfamero de cuenta no v\xe1lido","ach.accountLocationField.title":"N\xfamero de ruta ABA","ach.accountLocationField.invalid":"El n\xfamero de ruta ABA no es v\xe1lido","select.state":"Seleccione el estado","select.stateOrProvince":"Seleccione el estado o provincia","select.provinceOrTerritory":"Seleccione la provincia o territorio","select.country":"Seleccione el pa\xeds","select.noOptionsFound":"No se encontraron opciones","select.filter.placeholder":"Buscar...","telephoneNumber.invalid":"El n\xfamero de tel\xe9fono no es v\xe1lido",qrCodeOrApp:"o","paypal.processingPayment":"Procesando pago...",generateQRCode:"Generar c\xf3digo QR","await.waitForConfirmation":"Esperando confirmaci\xf3n","mbway.confirmPayment":"Confirme su pago en la aplicaci\xf3n MB WAY","shopperEmail.invalid":"La direcci\xf3n de correo electr\xf3nico no es v\xe1lida","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Debe ser mayor de 18 a\xf1os","blik.confirmPayment":"Abra la aplicaci\xf3n de su banco para confirmar el pago.","blik.invalid":"Introduzca 6 d\xedgitos","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Consiga el c\xf3digo en la aplicaci\xf3n de su banco.","swish.pendingMessage":"Tras escanearlo, su estado puede seguir en pendiente hasta 10\xa0minutos. Podr\xedan realizarse varios cargos si se intenta pagar de nuevo durante este periodo.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo no v\xe1lido","error.va.sf-cc-num.01":"N\xfamero de tarjeta no v\xe1lido","error.va.sf-cc-num.03":"Se ha introducido una tarjeta no admitida","error.va.sf-cc-dat.01":"Tarjeta demasiado vieja","error.va.sf-cc-dat.02":"Fecha con demasiada antelaci\xf3n","error.va.sf-cc-dat.03":"Su tarjeta caduca antes de la fecha de pago","error.va.sf-ach-num.01":"N\xfamero de cuenta no v\xe1lido","error.va.sf-ach-loc.01":"El n\xfamero de ruta ABA no es v\xe1lido","error.va.sf-kcp-pwd.01":"Contrase\xf1a incorrecta","error.giftcard.no-balance":"Esta tarjeta regalo no tiene saldo","error.giftcard.card-error":"No tenemos ninguna tarjeta regalo con este n\xfamero en nuestros registros.","error.giftcard.currency-error":"Las tarjetas regalo solo son v\xe1lidas en la moneda en que fueron emitidas","amazonpay.signout":"Salir de Amazon","amazonpay.changePaymentDetails":"Cambiar detalles de pago","partialPayment.warning":"Seleccione otro m\xe9todo de pago para pagar la cantidad restante","partialPayment.remainingBalance":"El saldo restante ser\xe1 %{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.reference":"referencia","bankTransfer.introduction":"Contin\xfae para crear un nuevo pago mediante transferencia bancaria. Puede utilizar los detalles en la siguiente pantalla para finalizar este pago.","bankTransfer.instructions":"Gracias por su compra. Use la siguiente informaci\xf3n para completar su pago.","bacs.accountHolderName":"Nombre del titular de la cuenta bancaria","bacs.accountHolderName.invalid":"El nombre del titular de la cuenta bancaria no es v\xe1lido","bacs.accountNumber":"N\xfamero de cuenta bancaria","bacs.accountNumber.invalid":"El n\xfamero de cuenta bancaria no es v\xe1lido","bacs.bankLocationId":"C\xf3digo de sucursal","bacs.bankLocationId.invalid":"El c\xf3digo de sucursal no es v\xe1lido","bacs.consent.amount":"Estoy de acuerdo con que la cantidad anterior se deduzca de mi cuenta bancaria.","bacs.consent.account":"Confirmo que la cuenta est\xe1 a mi nombre y soy el \xfanico firmante necesario para autorizar d\xe9bitos directos en esta cuenta.",edit:"Editar","bacs.confirm":"Confirmar y pagar","bacs.result.introduction":"Descargue su instrucci\xf3n de d\xe9bito directo (IDD/mandato)","download.pdf":"Descargar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de tarjeta asegurada","creditCard.encryptedCardNumber.aria.label":"Campo del n\xfamero de tarjeta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe de la fecha de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryDate.aria.label":"Campo de la fecha de caducidad","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe del mes de caducidad de tarjeta asegurada","creditCard.encryptedExpiryMonth.aria.label":"Campo del mes de caducidad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe del a\xf1o de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryYear.aria.label":"Campo del a\xf1o de caducidad","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta asegurada","creditCard.encryptedSecurityCode.aria.label":"Campo del c\xf3digo de seguridad","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de la tarjeta de regalo asegurada","giftcard.encryptedCardNumber.aria.label":"Campo del n\xfamero de la tarjeta de regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta de regalo asegurada","giftcard.encryptedSecurityCode.aria.label":"Campo del c\xf3digo de seguridad de la tarjeta de regalo",giftcardTransactionLimit:"Se permite un m\xe1ximo de %{amount} por transacci\xf3n en esta tarjeta regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe del n\xfamero de la cuenta bancaria asegurada","ach.encryptedBankAccountNumber.aria.label":"Campo de la cuenta bancaria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe del n\xfamero de ruta del banco asegurado","ach.encryptedBankLocationId.aria.label":"Campo del n\xfamero de ruta del banco","twint.saved":"guardado"}}),qk=Object.freeze({__proto__:null,default:{payButton:"Maksa","payButton.redirecting":"Uudelleenohjataan ...",storeDetails:"Tallenna seuraavaa maksuani varten","creditCard.holderName":"Nimi kortilla","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Ei-kelvollinen kortinhaltijan nimi","creditCard.numberField.title":"Kortin numero","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4","creditCard.expiryDateField.placeholder":"KK / VV","creditCard.expiryDateField.month":"Kuukausi","creditCard.expiryDateField.month.placeholder":"KK","creditCard.expiryDateField.year.placeholder":"VV","creditCard.expiryDateField.year":"Vuosi","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Muista seuraavalla kerralla","creditCard.cvcField.placeholder.4digits":"4 lukua","creditCard.cvcField.placeholder.3digits":"3 lukua","creditCard.taxNumber.placeholder":"VVKKPP / 0123456789",installments:"Asennusten m\xe4\xe4r\xe4",installmentOption:"% {kertaa} x% {osittainenarvo}",installmentOptionMonths:"% {kertaa} kuukautta","installments.oneTime":"Kertamaksu","installments.installments":"Er\xe4maksu","installments.revolving":"Toistuva maksu","sepaDirectDebit.ibanField.invalid":"V\xe4\xe4r\xe4 tilin numero","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Haltijan nimi","sepa.ibanNumber":"Tilinumero (IBAN)","error.title":"Virhe","error.subtitle.redirect":"Uuteen kohteeseen siirto ep\xe4onnistui","error.subtitle.payment":"Maksu ep\xe4nnistui","error.subtitle.refused":"Maksu hyl\xe4tty","error.message.unknown":"Tapahtui tuntematon virhe","idealIssuer.selectField.title":"Pankki","idealIssuer.selectField.placeholder":"Valitse pankkisi","creditCard.success":"Maksu onnistui",loading:"Ladataan...",continue:"Jatka",continueTo:"Jatka kohteeseen","wechatpay.timetopay":"Sinulla on %@ maksettavana","wechatpay.scanqrcode":"Skannaa QR-koodi",personalDetails:"Henkil\xf6tiedot",companyDetails:"Yhti\xf6n tiedot","companyDetails.name":"Yhti\xf6n nimi","companyDetails.registrationNumber":"Rekisterinumero",socialSecurityNumber:"Sosiaaliturvatunnus",firstName:"Etunimi",infix:"Etuliite",lastName:"Sukunimi",mobileNumber:"Matkapuhelinnumero","mobileNumber.invalid":"Ei-kelvollinen matkapuhelinnumero",city:"Kaupunki",postalCode:"Postinumero",countryCode:"Maakoodi",telephoneNumber:"Puhelinnumero",dateOfBirth:"Syntym\xe4aika",shopperEmail:"S\xe4hk\xf6postiosoite",gender:"Sukupuoli",male:"Mies",female:"Nainen",billingAddress:"Laskutusosoite",street:"Katu",stateOrProvince:"Osavaltio tai l\xe4\xe4ni",country:"Maa",houseNumberOrName:"Talon numero",separateDeliveryAddress:"M\xe4\xe4rit\xe4 erillinen toimitusosoite",deliveryAddress:"Toimitusosoite",zipCode:"Postinumero",apartmentSuite:"Huoneisto / sviitti",provinceOrTerritory:"Maakunta tai alue",cityTown:"Kaupunki / taajama",address:"Osoite",state:"Osavaltio","field.title.optional":"(valinnainen)","creditCard.cvcField.title.optional":"CVC / CVV (valinnainen)","issuerList.wallet.placeholder":"Valitse lompakkosi",privacyPolicy:"Tietosuojamenettely","afterPay.agreement":"Hyv\xe4ksyn AfterPayn %@",paymentConditions:"maksuehdot",openApp:"Avaa sovellus","voucher.readInstructions":"Lue ohjeet","voucher.introduction":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavaa kuponkia vied\xe4ksesi maksusi p\xe4\xe4t\xf6kseen.","voucher.expirationDate":"Vanhenemisp\xe4iv\xe4m\xe4\xe4r\xe4","voucher.alternativeReference":"Vaihtoehtoinen viite","dragonpay.voucher.non.bank.selectField.placeholder":"Valitse toimittajasi","dragonpay.voucher.bank.selectField.placeholder":"Valitse pankkisi","voucher.paymentReferenceLabel":"Maksun viite","voucher.surcharge":"Sis. %@ lis\xe4maksun","voucher.introduction.doku":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.shopperName":"Ostajan nimi","voucher.merchantName":"Kauppias","voucher.introduction.econtext":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.telephoneNumber":"Puhelinnumero","voucher.shopperReference":"Ostajan viite","voucher.collectionInstitutionNumber":"Ker\xe4\xe4v\xe4n laitoksen numero","voucher.econtext.telephoneNumber.invalid":"Puhelinnumeron on oltava 10 tai 11 numeroa pitk\xe4","boletobancario.btnLabel":"Luo Boleto","boleto.sendCopyToEmail":"L\xe4het\xe4 kopio s\xe4hk\xf6postiini","button.copy":"Kopio","button.download":"Lataa","creditCard.storedCard.description.ariaLabel":"Tallennetun kortin viimeiset luvut ovat %@","voucher.entity":"Kokonaisuus",donateButton:"Lahjoita",notNowButton:"Ei nyt",thanksForYourSupport:"Kiitos tuestasi!",preauthorizeWith:"Ennkkolupa k\xe4ytt\xe4j\xe4n kanssa",confirmPreauthorization:"Vahvista ennakkolupa",confirmPurchase:"Vahvista hankinta",applyGiftcard:"Lunasta",giftcardBalance:"Lahjakortin saldo",deductedBalance:"V\xe4hennetty saldo","creditCard.pin.title":"Pin-tunnus","creditCard.encryptedPassword.label":"Kortin salasanan ensimm\xe4iset 2 lukua","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Kelpaamaton salasana","creditCard.taxNumber.label":"Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.labelAlt":"Yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.invalid":"Kelpaamaton kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero","storedPaymentMethod.disable.button":"Poista","storedPaymentMethod.disable.confirmation":"Poista tallennettu maksutapa","storedPaymentMethod.disable.confirmButton":"Kyll\xe4, poista","storedPaymentMethod.disable.cancelButton":"Peruuta","ach.bankAccount":"Pankkitili","ach.accountHolderNameField.title":"Tilinhaltijan nimi","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Ei-kelvollinen tilinhaltijan nimi","ach.accountNumberField.title":"Tilinumero","ach.accountNumberField.invalid":"V\xe4\xe4r\xe4 tilin numero","ach.accountLocationField.title":"ABA-reititysnumero","ach.accountLocationField.invalid":"Ei-kelvollinen ABA-reititysnumero","select.state":"Valitse osavaltio","select.stateOrProvince":"Valitse osavaltio tai l\xe4\xe4ni","select.provinceOrTerritory":"Valitse maakunta tai alue","select.country":"Valitse maa","select.noOptionsFound":"Vaihtoehtoja ei l\xf6ytynyt","select.filter.placeholder":"Hae...","telephoneNumber.invalid":"Ei-kelvollinen puhelinnumero",qrCodeOrApp:"tai","paypal.processingPayment":"Maksua k\xe4sitell\xe4\xe4n...",generateQRCode:"Tuota QR-koodi","await.waitForConfirmation":"Odottaa vahvistusta","mbway.confirmPayment":"Vahvista maksusi MB WAY -sovelluksella","shopperEmail.invalid":"Ei-kelvollinen s\xe4hk\xf6postiosoite","dateOfBirth.format":"PP/KK/VVVV","dateOfBirth.invalid":"Sinun on oltava v\xe4hint\xe4\xe4n 18-vuotias","blik.confirmPayment":"Avaa pankkisovelluksesi vahvistaaksesi maksun.","blik.invalid":"Sy\xf6t\xe4 6 lukua","blik.code":"6-numeroinen koodi","blik.help":"Hanki koodi pankkisovelluksestasi.","swish.pendingMessage":"Skannattuasi, tila voi odottaa jopa 10 minuuttia. Yritys maksaa uudelleen t\xe4ss\xe4 ajassa voi tuottaa moninkertaisia maksuja.","error.va.gen.01":"T\xe4ydent\xe4m\xe4t\xf6n kentt\xe4","error.va.gen.02":"Kentt\xe4 ei kelpaa","error.va.sf-cc-num.01":"V\xe4\xe4r\xe4 kortin numero","error.va.sf-cc-num.03":"Ei-tuettu kortti asetettu","error.va.sf-cc-dat.01":"Kortti on liian vanha","error.va.sf-cc-dat.02":"P\xe4iv\xe4m\xe4\xe4r\xe4 liian kaukana tulevaisuudessa","error.va.sf-cc-dat.03":"Korttisi vanhenee ennen l\xe4ht\xf6p\xe4iv\xe4\xe4","error.va.sf-ach-num.01":"V\xe4\xe4r\xe4 tilin numero","error.va.sf-ach-loc.01":"Ei-kelvollinen ABA-reititysnumero","error.va.sf-kcp-pwd.01":"Kelpaamaton salasana","error.giftcard.no-balance":"Lahjakortin saldo on nolla","error.giftcard.card-error":"Asiakirjoissamme ei ole t\xe4m\xe4n numeron lahjakorttia","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Kirjaudu ulos Amazonista","amazonpay.changePaymentDetails":"Muuta maksutietoja","partialPayment.warning":"Valitse toinen maksutapa j\xe4\xe4nn\xf6ksen maksamiseksi","partialPayment.remainingBalance":"J\xe4ljell\xe4 oleva saldo on %{summa}","bankTransfer.beneficiary":"Edunsaaja","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Viite","bankTransfer.introduction":"Jatka uuden pankkisiirtomaksun luomista. Voit viimeistell\xe4 t\xe4m\xe4n maksun seuraavan n\xe4yt\xf6n tietojen avulla.","bankTransfer.instructions":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","bacs.accountHolderName":"Tilinhaltijan nimi","bacs.accountHolderName.invalid":"Ei-kelvollinen tilinhaltijan nimi","bacs.accountNumber":"Pankkitilinumero","bacs.accountNumber.invalid":"V\xe4\xe4r\xe4 tilin numero","bacs.bankLocationId":"Lajittelukoodi","bacs.bankLocationId.invalid":"Ei-kelvollinen lajittelukoodi","bacs.consent.amount":"Hyv\xe4ksyn, ett\xe4 alla oleva summa veloitetaan pankkitililt\xe4ni.","bacs.consent.account":"Vahvistan, ett\xe4 tili on nimess\xe4ni ja olen ainoa allekirjoittaja, joka vaaditaan valtuuttamaan suoraveloitus t\xe4ll\xe4 tilill\xe4.",edit:"Muokkaa","bacs.confirm":"Vahvista ja maksa","bacs.result.introduction":"Lataa suoraveloitusohjeet (DDI / Mandate)","download.pdf":"Lataa PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle kortin numerolle","creditCard.encryptedCardNumber.aria.label":"Kortin numero -kentt\xe4","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6p\xe4iv\xe4lle","creditCard.encryptedExpiryDate.aria.label":"Viimeinen voimassaolop\xe4iv\xe4 -kentt\xe4","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6kuukaudelle","creditCard.encryptedExpiryMonth.aria.label":"Viimeinen voimassaolokuukausi -kentt\xe4","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle voimassaolovuodelle","creditCard.encryptedExpiryYear.aria.label":"Viimeinen voimassaolovuosi-kentt\xe4","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle kortin turvakoodille","creditCard.encryptedSecurityCode.aria.label":"Turvakoodikentt\xe4","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle lahjakortin numerolle","giftcard.encryptedCardNumber.aria.label":"Lahjakorttinumeron kentt\xe4","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle lahjakortin turvakoodille","giftcard.encryptedSecurityCode.aria.label":"Lahjakortin turvakoodikentt\xe4",giftcardTransactionLimit:"Maks. % {summa} sallittu tapahtumaa kohti t\xe4ll\xe4 lahjakortilla","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe suojatulle pankkitilinumerolle","ach.encryptedBankAccountNumber.aria.label":"Pankkitilikentt\xe4","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe suojatulle pankin reititysnumerolle","ach.encryptedBankLocationId.aria.label":"Pankin reititysnumerokentt\xe4","twint.saved":"tallennettu"}}),Gk=Object.freeze({__proto__:null,default:{payButton:"Payer","payButton.redirecting":"Redirection...",storeDetails:"Sauvegarder pour mon prochain paiement","creditCard.holderName":"Nom sur la carte","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nom du porteur de carte incorrect","creditCard.numberField.title":"Num\xe9ro de la carte","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Date d'expiration","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mois","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ann\xe9e","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Enregistrer pour la prochaine fois","creditCard.cvcField.placeholder.4digits":"4\xa0chiffres","creditCard.cvcField.placeholder.3digits":"3\xa0chiffres","creditCard.taxNumber.placeholder":"AAMMJJ / 0123456789",installments:"Nombre de versements",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\xa0mois","installments.oneTime":"Paiement unique","installments.installments":"Paiement \xe9chelonn\xe9","installments.revolving":"Paiement en plusieurs fois","sepaDirectDebit.ibanField.invalid":"Num\xe9ro de compte non valide","sepaDirectDebit.nameField.placeholder":"N. Bernard","sepa.ownerName":"Au nom de","sepa.ibanNumber":"Num\xe9ro de compte (IBAN)","error.title":"Erreur","error.subtitle.redirect":"\xc9chec de la redirection","error.subtitle.payment":"\xc9chec du paiement","error.subtitle.refused":"Paiement refus\xe9","error.message.unknown":"Une erreur inconnue s'est produite","idealIssuer.selectField.title":"Banque","idealIssuer.selectField.placeholder":"S\xe9lectionnez votre banque","creditCard.success":"Paiement r\xe9ussi",loading:"Chargement en cours...",continue:"Continuer",continueTo:"Poursuivre vers","wechatpay.timetopay":"Vous avez %@ pour payer cette somme","wechatpay.scanqrcode":"Scanner le code QR",personalDetails:"Informations personnelles",companyDetails:"Coordonn\xe9es de l'entreprise","companyDetails.name":"Nom de l'entreprise","companyDetails.registrationNumber":"Num\xe9ro d'enregistrement",socialSecurityNumber:"Num\xe9ro de s\xe9curit\xe9 sociale",firstName:"Pr\xe9nom",infix:"Pr\xe9fixe",lastName:"Nom de famille",mobileNumber:"Num\xe9ro de portable","mobileNumber.invalid":"Num\xe9ro de portable non valide",city:"Ville",postalCode:"Code postal",countryCode:"Code pays",telephoneNumber:"Num\xe9ro de t\xe9l\xe9phone",dateOfBirth:"Date de naissance",shopperEmail:"Adresse e-mail",gender:"Sexe",male:"Homme",female:"Femme",billingAddress:"Adresse de facturation",street:"Rue",stateOrProvince:"\xc9tat ou province",country:"Pays",houseNumberOrName:"Num\xe9ro de rue",separateDeliveryAddress:"Indiquer une adresse de livraison distincte",deliveryAddress:"Adresse de livraison",zipCode:"Code postal",apartmentSuite:"Appartement",provinceOrTerritory:"Province ou territoire",cityTown:"Ville",address:"Adresse",state:"\xc9tat","field.title.optional":"(facultatif)","creditCard.cvcField.title.optional":"CVC / CVV (facultatif)","issuerList.wallet.placeholder":"S\xe9lectionnez votre portefeuille",privacyPolicy:"Politique de confidentialit\xe9","afterPay.agreement":"J'accepte les %@ de AfterPay",paymentConditions:"conditions de paiement",openApp:"Ouvrir l'application","voucher.readInstructions":"Lire les instructions","voucher.introduction":"Merci pour votre achat, veuillez utiliser le coupon suivant pour finaliser votre paiement.","voucher.expirationDate":"Date d'expiration","voucher.alternativeReference":"Autre r\xe9f\xe9rence","dragonpay.voucher.non.bank.selectField.placeholder":"S\xe9lectionnez votre fournisseur","dragonpay.voucher.bank.selectField.placeholder":"S\xe9lectionnez votre banque","voucher.paymentReferenceLabel":"R\xe9f\xe9rence du paiement","voucher.surcharge":"Comprend une surcharge de %@","voucher.introduction.doku":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.","voucher.shopperName":"Nom de l'acheteur","voucher.merchantName":"Marchand","voucher.introduction.econtext":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.","voucher.telephoneNumber":"Num\xe9ro de t\xe9l\xe9phone","voucher.shopperReference":"R\xe9f\xe9rence client","voucher.collectionInstitutionNumber":"Num\xe9ro du point de paiement","voucher.econtext.telephoneNumber.invalid":"Le num\xe9ro de t\xe9l\xe9phone doit comporter 10 ou 11\xa0chiffres","boletobancario.btnLabel":"G\xe9n\xe9rer un Boleto","boleto.sendCopyToEmail":"Envoyer une copie \xe0 mon adresse e-mail","button.copy":"Copier","button.download":"T\xe9l\xe9charger","creditCard.storedCard.description.ariaLabel":"La carte enregistr\xe9e se termine en %@","voucher.entity":"Entit\xe9",donateButton:"Faire un don",notNowButton:"Pas maintenant",thanksForYourSupport:"Merci de votre soutien\xa0!",preauthorizeWith:"Pr\xe9-autoriser avec",confirmPreauthorization:"Confirmer la pr\xe9-autorisation",confirmPurchase:"Confirmer l'achat",applyGiftcard:"Utiliser",giftcardBalance:"Solde de la carte cadeau",deductedBalance:"Solde d\xe9duit","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Les deux premiers chiffres du code de votre carte","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Code incorrect","creditCard.taxNumber.label":"Date de naissance du porteur de carte (au format AAMMJJ) ou num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.labelAlt":"Num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.invalid":"Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise incorrect(e)","storedPaymentMethod.disable.button":"Supprimer","storedPaymentMethod.disable.confirmation":"Supprimer le mode de paiement enregistr\xe9","storedPaymentMethod.disable.confirmButton":"Oui, supprimer","storedPaymentMethod.disable.cancelButton":"Annuler","ach.bankAccount":"Compte bancaire","ach.accountHolderNameField.title":"Nom du titulaire du compte","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nom du titulaire du compte incorrect","ach.accountNumberField.title":"Num\xe9ro du compte","ach.accountNumberField.invalid":"Num\xe9ro du compte incorrect","ach.accountLocationField.title":"Code ABA","ach.accountLocationField.invalid":"Code ABA incorrect","select.state":"S\xe9lectionnez l'\xc9tat","select.stateOrProvince":"S\xe9lectionnez l'\xc9tat ou la province","select.provinceOrTerritory":"S\xe9lectionnez la province ou le territoire","select.country":"S\xe9lectionnez le pays","select.noOptionsFound":"Aucune option trouv\xe9e","select.filter.placeholder":"Recherche...","telephoneNumber.invalid":"Num\xe9ro de t\xe9l\xe9phone incorrect",qrCodeOrApp:"ou","paypal.processingPayment":"Traitement du paiement en cours...",generateQRCode:"G\xe9n\xe9rer un code QR","await.waitForConfirmation":"En attente de confirmation","mbway.confirmPayment":"Confirmez votre paiement sur l'application MB WAY","shopperEmail.invalid":"Adresse e-mail incorrecte","dateOfBirth.format":"JJ/MM/AAAA","dateOfBirth.invalid":"Vous devez \xeatre \xe2g\xe9(e) d'au moins 18\xa0ans","blik.confirmPayment":"Ouvrez votre application bancaire pour confirmer le paiement.","blik.invalid":"Saisissez les 6\xa0chiffres","blik.code":"Code \xe0 6\xa0chiffres","blik.help":"Ouvrez votre application bancaire pour obtenir le code.","swish.pendingMessage":"Apr\xe8s avoir scann\xe9 le code QR, la mise \xe0 jour du statut de paiement peut prendre jusqu'\xe0 10\xa0minutes. Si vous effectuez une nouvelle tentative de paiement dans ce d\xe9lai, cela pourrait occasionner plusieurs d\xe9bits.","error.va.gen.01":"Champ incomplet","error.va.gen.02":"Champ non valide","error.va.sf-cc-num.01":"Num\xe9ro de carte non valide","error.va.sf-cc-num.03":"Carte ins\xe9r\xe9e non prise en charge","error.va.sf-cc-dat.01":"Carte trop ancienne","error.va.sf-cc-dat.02":"La date doit \xeatre plus proche","error.va.sf-cc-dat.03":"Votre carte expirera avant la date de paiement","error.va.sf-ach-num.01":"Num\xe9ro de compte non valide","error.va.sf-ach-loc.01":"Code ABA incorrect","error.va.sf-kcp-pwd.01":"Code incorrect","error.giftcard.no-balance":"Aucun solde n'est disponible sur cette carte cadeau","error.giftcard.card-error":"Aucune carte cadeau ne correspond \xe0 ce num\xe9ro","error.giftcard.currency-error":"Les cartes cadeaux sont valables uniquement dans la devise dans laquelle elles ont \xe9t\xe9 \xe9mises","amazonpay.signout":"Se d\xe9connecter d'Amazon","amazonpay.changePaymentDetails":"Modifier les informations de paiement","partialPayment.warning":"S\xe9lectionnez un autre mode de paiement pour r\xe9gler le solde","partialPayment.remainingBalance":"Le solde restant sera de %{amount}","bankTransfer.beneficiary":"B\xe9n\xe9ficiaire","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"R\xe9f\xe9rence","bankTransfer.introduction":"Continuez \xe0 cr\xe9er un nouveau paiement par virement bancaire. Utilisez les informations de l'\xe9cran suivant pour finaliser ce paiement.","bankTransfer.instructions":"Merci pour votre achat\xa0! Veuillez utiliser les informations suivantes pour finaliser votre paiement.","bacs.accountHolderName":"Nom du titulaire du compte bancaire","bacs.accountHolderName.invalid":"Nom du titulaire du compte bancaire incorrect","bacs.accountNumber":"Num\xe9ro du compte bancaire","bacs.accountNumber.invalid":"Num\xe9ro du compte bancaire incorrect","bacs.bankLocationId":"Code de tri (sort code)","bacs.bankLocationId.invalid":"Code de tri (sort code) non valide","bacs.consent.amount":"J'accepte que le montant ci-dessus soit d\xe9duit de mon compte bancaire.","bacs.consent.account":"Je confirme \xeatre le titulaire du compte et qu'aucune autre signature que la mienne n'est requise pour autoriser un pr\xe9l\xe8vement sur ce compte.",edit:"Modifier","bacs.confirm":"Confirmer et payer","bacs.result.introduction":"T\xe9l\xe9chargez votre mandat de pr\xe9l\xe8vement (DDI)","download.pdf":"T\xe9l\xe9charger le PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de carte avec garantie","creditCard.encryptedCardNumber.aria.label":"Champ du num\xe9ro de carte","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pour la date d'expiration de la carte avec garantie","creditCard.encryptedExpiryDate.aria.label":"Champ de la date d'expiration","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pour le mois d'expiration de la carte avec garantie","creditCard.encryptedExpiryMonth.aria.label":"Champ du mois d'expiration","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pour l'ann\xe9e d'expiration de la carte avec garantie","creditCard.encryptedExpiryYear.aria.label":"Champ de l'ann\xe9e d'expiration","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte avec garantie","creditCard.encryptedSecurityCode.aria.label":"Champ du code de s\xe9curit\xe9","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de la carte-cadeau avec garantie","giftcard.encryptedCardNumber.aria.label":"Champ du num\xe9ro de la carte cadeau","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte-cadeau avec garantie","giftcard.encryptedSecurityCode.aria.label":"Champ du code de s\xe9curit\xe9 de la carte-cadeau",giftcardTransactionLimit:"Montant maximum autoris\xe9 par transaction avec cette carte cadeau\xa0: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pour le num\xe9ro du compte bancaire avec garantie","ach.encryptedBankAccountNumber.aria.label":"Champ du compte bancaire","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pour le num\xe9ro de routage du compte avec garantie","ach.encryptedBankLocationId.aria.label":"Champ du num\xe9ro de routage","twint.saved":"stock\xe9"}}),Yk=Object.freeze({__proto__:null,default:{payButton:"Platiti","payButton.redirecting":"Preusmjeravanje...",storeDetails:"Pohrani za moje sljede\u0107e pla\u0107anje","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Neva\u017ee\u0107e ime vlasnika kartice","creditCard.numberField.title":"Broj kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum isteka","creditCard.expiryDateField.placeholder":"MM/GG","creditCard.expiryDateField.month":"Mjesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"GG","creditCard.expiryDateField.year":"Godina","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamtiti za sljede\u0107i put","creditCard.cvcField.placeholder.4digits":"4 znamenke","creditCard.cvcField.placeholder.3digits":"3 znamenke","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Broj rata",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"Mjeseci: %{times}","installments.oneTime":"Jednokratno pla\u0107anje","installments.installments":"Pla\u0107anje na rate","installments.revolving":"Obnovljivo pla\u0107anje","sepaDirectDebit.ibanField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Ime vlasnika","sepa.ibanNumber":"Broj ra\u010duna (IBAN)","error.title":"Gre\u0161ka","error.subtitle.redirect":"Preusmjeravanje nije uspjelo","error.subtitle.payment":"Pla\u0107anje nije uspjelo","error.subtitle.refused":"Pla\u0107anje odbijeno","error.message.unknown":"Dogodila se nepoznata gre\u0161ka","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Odaberite banku","creditCard.success":"Pla\u0107anje uspje\u0161no",loading:"U\u010ditavanje\u2026",continue:"Nastavi",continueTo:"Nastavi na","wechatpay.timetopay":"Imate %@ za pla\u0107anje","wechatpay.scanqrcode":"Skeniraj QR k\xf4d",personalDetails:"Osobni podatci",companyDetails:"Detalji tvrtke","companyDetails.name":"Naziv tvrtke","companyDetails.registrationNumber":"Mati\u010dni broj",socialSecurityNumber:"Broj socijalnog osiguranja",firstName:"Ime",infix:"Prefiks",lastName:"Prezime",mobileNumber:"Broj mobilnog telefona","mobileNumber.invalid":"Neva\u017ee\u0107i broj mobilnog telefona",city:"Grad",postalCode:"Po\u0161tanski broj",countryCode:"Pozivni broj dr\u017eave",telephoneNumber:"Telefonski broj",dateOfBirth:"Datum ro\u0111enja",shopperEmail:"Adresa e-po\u0161te",gender:"Spol",male:"Mu\u0161karac",female:"\u017dena",billingAddress:"Adresa za ra\u010dun",street:"Ulica",stateOrProvince:"Dr\u017eava ili pokrajina",country:"Zemlja",houseNumberOrName:"Ku\u0107ni broj",separateDeliveryAddress:"Navedite zasebnu adresu za dostavu",deliveryAddress:"Adresa za dostavu",zipCode:"Po\u0161tanski broj",apartmentSuite:"Stan/apartman",provinceOrTerritory:"Pokrajina ili teritorij",cityTown:"Grad",address:"Adresa",state:"Savezna dr\u017eava","field.title.optional":"(neobavezno)","creditCard.cvcField.title.optional":"CVC/CVV (nije obavezno)","issuerList.wallet.placeholder":"Odaberite svoju nov\u010danik",privacyPolicy:"Politika privatnosti","afterPay.agreement":"Sla\u017eem se s %@ usluge AfterPay",paymentConditions:"uvjetima pla\u0107anja",openApp:"Otvorite aplikaciju","voucher.readInstructions":"Pro\u010ditajte upute","voucher.introduction":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107i kupon za dovr\u0161etak pla\u0107anja.","voucher.expirationDate":"Datum isteka","voucher.alternativeReference":"Alternativna referenca","dragonpay.voucher.non.bank.selectField.placeholder":"Odaberite davatelja usluge","dragonpay.voucher.bank.selectField.placeholder":"Odaberite banku","voucher.paymentReferenceLabel":"Referenca za pla\u0107anje","voucher.surcharge":"Uklju\u010duje %@ nadoplate","voucher.introduction.doku":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovac","voucher.introduction.econtext":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.telephoneNumber":"Broj telefona","voucher.shopperReference":"Referenca kupca","voucher.collectionInstitutionNumber":"Broj ustanove za prikupljanje","voucher.econtext.telephoneNumber.invalid":"Telefonski broj mora imati 10 ili 11 znamenki","boletobancario.btnLabel":"Generiraj Boleto","boleto.sendCopyToEmail":"Po\u0161alji kopiju na moju e-po\u0161tu","button.copy":"Kopiraj","button.download":"Preuzmi","creditCard.storedCard.description.ariaLabel":"Pohranjena kartica zavr\u0161ava na %@","voucher.entity":"Entitet",donateButton:"Doniraj",notNowButton:"Ne sada",thanksForYourSupport:"Hvala na podr\u0161ci!",preauthorizeWith:"Prethodno odobri s",confirmPreauthorization:"Potvrdite prethodno odobrenje",confirmPurchase:"Potvrdite kupnju",applyGiftcard:"Iskoristite",giftcardBalance:"Stanje na poklon-kartici",deductedBalance:"Potro\u0161eni iznos","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prve 2 znamenke lozinke kartice","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Lozinka je neto\u010dna","creditCard.taxNumber.label":"Datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.labelAlt":"Registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.invalid":"Neto\u010dan datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","storedPaymentMethod.disable.button":"Ukloni","storedPaymentMethod.disable.confirmation":"Uklonite pohranjeni na\u010din pla\u0107anja","storedPaymentMethod.disable.confirmButton":"Da, ukloni","storedPaymentMethod.disable.cancelButton":"Otka\u017ei","ach.bankAccount":"Bankovni ra\u010dun","ach.accountHolderNameField.title":"Ime vlasnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Neva\u017ee\u0107e ime vlasnika ra\u010duna","ach.accountNumberField.title":"Broj ra\u010duna","ach.accountNumberField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","ach.accountLocationField.title":"ABA identifikacijski broj","ach.accountLocationField.invalid":"Neva\u017ee\u0107i ABA identifikacijski broj","select.state":"Odaberite saveznu dr\u017eavu","select.stateOrProvince":"Odaberite dr\u017eavu ili provinciju","select.provinceOrTerritory":"Odaberite provinciju ili teritorij","select.country":"Odaberite dr\u017eavu","select.noOptionsFound":"Nije prona\u0111ena nijedna opcija","select.filter.placeholder":"Tra\u017ei...","telephoneNumber.invalid":"Neva\u017ee\u0107i telefonski broj",qrCodeOrApp:"ili","paypal.processingPayment":"Obrada pla\u0107anja u tijeku...",generateQRCode:"Generirajte QR k\xf4d","await.waitForConfirmation":"\u010ceka se potvrda","mbway.confirmPayment":"Potvrdite uplatu u aplikaciji MB WAY","shopperEmail.invalid":"Neva\u017ee\u0107a adresa e-po\u0161te","dateOfBirth.format":"DD/MM/GGGG","dateOfBirth.invalid":"Morate imati najmanje 18 godina","blik.confirmPayment":"Otvorite svoju bankovnu aplikaciju kako biste potvrdili pla\u0107anje.","blik.invalid":"Unesite 6 znamenki","blik.code":"6-znamenkasti k\xf4d","blik.help":"Preuzmite k\xf4d iz bankovne aplikacije.","swish.pendingMessage":"Nakon skeniranja status mo\u017ee biti na \u010dekanju do 10 minuta. Poku\u0161aj ponovnog pla\u0107anja u istom periodu mo\u017ee rezultirati vi\u0161estrukim naplatama.","error.va.gen.01":"Nepotpuno polje","error.va.gen.02":"Neva\u017ee\u0107e polje","error.va.sf-cc-num.01":"Neva\u017ee\u0107i broj kartice","error.va.sf-cc-num.03":"Unijeli ste nepodr\u017eanu vrstu kartice","error.va.sf-cc-dat.01":"Kartica je prestara","error.va.sf-cc-dat.02":"Datum je predaleko u budu\u0107nosti","error.va.sf-cc-dat.03":"Va\u0161a kartica istje\u010de prije datuma pla\u0107anja","error.va.sf-ach-num.01":"Neva\u017ee\u0107i broj ra\u010duna","error.va.sf-ach-loc.01":"Neva\u017ee\u0107i ABA identifikacijski broj","error.va.sf-kcp-pwd.01":"Lozinka je neto\u010dna","error.giftcard.no-balance":"Stanje na ovoj poklon-kartici iznosi nula","error.giftcard.card-error":"U na\u0161oj evidenciji nemamo poklon-karticu s ovim brojem","error.giftcard.currency-error":"Poklon-kartice vrijede samo u valuti u kojoj su izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Promijenite pojedinosti o pla\u0107anju","partialPayment.warning":"Odaberite drugi na\u010din pla\u0107anja da biste platili preostali iznos","partialPayment.remainingBalance":"Preostalo stanje na ra\u010dunu iznosit \u0107e %{amount}","bankTransfer.beneficiary":"Primatelj","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nastavite da biste kreirali novu uplatu putem bankovne transakcije. Za finaliziranje ovog pla\u0107anja mo\u017eete se koristiti pojedinostima na sljede\u0107em zaslonu.","bankTransfer.instructions":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","bacs.accountHolderName":"Ime vlasnika bankovnog ra\u010duna","bacs.accountHolderName.invalid":"Neva\u017ee\u0107e ime vlasnika bankovnog ra\u010duna","bacs.accountNumber":"Broj bankovnog ra\u010duna","bacs.accountNumber.invalid":"Neva\u017ee\u0107i broj bankovnog ra\u010duna","bacs.bankLocationId":"Identifikacijski k\xf4d banke (UK)","bacs.bankLocationId.invalid":"Neva\u017ee\u0107i identifikacijski k\xf4d banke (UK)","bacs.consent.amount":"Sla\u017eem se da se gore navedeni iznos oduzme s mog bankovnog ra\u010duna.","bacs.consent.account":"Potvr\u0111ujem da je ra\u010dun na moje ime i da sam jedini potpisnik potreban za autorizaciju izravnog tere\u0107enja na ovom ra\u010dunu.",edit:"Uredi","bacs.confirm":"Potvrdi i plati","bacs.result.introduction":"Preuzmite upute za izravno tere\u0107enje (DDI / mandat)","download.pdf":"Preuzmite PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid kartice","creditCard.encryptedCardNumber.aria.label":"Polje za broj kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za datum isteka prepaid kartice","creditCard.encryptedExpiryDate.aria.label":"Polje za datum isteka","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za mjesec isteka prepaid kartice","creditCard.encryptedExpiryMonth.aria.label":"Polje za mjesec isteka","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za godinu isteka prepaid kartice","creditCard.encryptedExpiryYear.aria.label":"Polje za godinu isteka","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid kartice","creditCard.encryptedSecurityCode.aria.label":"Polje za sigurnosni k\xf4d","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid poklon-kartice","giftcard.encryptedCardNumber.aria.label":"Polje za broj poklon-kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid poklon-kartice","giftcard.encryptedSecurityCode.aria.label":"Polje za sigurnosni k\xf4d poklon-kartice",giftcardTransactionLimit:"Na ovoj je poklon-kartici maks. dopu\u0161teno %{amount} po transakciji","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za prepaid broj bankovnog ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Polje za broj bankovnog ra\u010duna","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za identifikacijski broj prepaid banke","ach.encryptedBankLocationId.aria.label":"Polje za identifikacijski broj banke","twint.saved":"spremljeno"}}),Wk=Object.freeze({__proto__:null,default:{payButton:"Fizet\xe9s","payButton.redirecting":"\xc1tir\xe1ny\xedt\xe1s...",storeDetails:"Ment\xe9s a k\xf6vetkez\u0151 fizet\xe9shez","creditCard.holderName":"A k\xe1rty\xe1n szerepl\u0151 n\xe9v","creditCard.holderName.placeholder":"Gipsz Jakab","creditCard.holderName.invalid":"A k\xe1rtyatulajdonos neve \xe9rv\xe9nytelen","creditCard.numberField.title":"K\xe1rtyasz\xe1m","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Lej\xe1rati d\xe1tum","creditCard.expiryDateField.placeholder":"HH/\xc9\xc9","creditCard.expiryDateField.month":"H\xf3nap","creditCard.expiryDateField.month.placeholder":"HH","creditCard.expiryDateField.year.placeholder":"\xc9\xc9","creditCard.expiryDateField.year":"\xc9v","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Megjegyz\xe9s a k\xf6vetkez\u0151 alkalomra","creditCard.cvcField.placeholder.4digits":"4 sz\xe1mjegy\u0171","creditCard.cvcField.placeholder.3digits":"3 sz\xe1mjegy\u0171","creditCard.taxNumber.placeholder":"\xc9\xc9HHNN / 0123456789",installments:"R\xe9szletek sz\xe1ma",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} h\xf3nap","installments.oneTime":"Egy\xf6sszeg\u0171 fizet\xe9s","installments.installments":"R\xe9szletfizet\xe9s","installments.revolving":"T\xf6bb\xf6sszeg\u0171 fizet\xe9s","sepaDirectDebit.ibanField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","sepaDirectDebit.nameField.placeholder":"Gipsz Jakab","sepa.ownerName":"Sz\xe1mlatulajdonos neve","sepa.ibanNumber":"Sz\xe1mlasz\xe1m (IBAN)","error.title":"Hiba","error.subtitle.redirect":"Sikertelen \xe1tir\xe1ny\xedt\xe1s","error.subtitle.payment":"Sikertelen fizet\xe9s","error.subtitle.refused":"A fizet\xe9s elutas\xedtva","error.message.unknown":"Ismeretlen hiba t\xf6rt\xe9nt","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","creditCard.success":"Sikeres fizet\xe9s",loading:"Bet\xf6lt\xe9s\u2026",continue:"Folytat\xe1s",continueTo:"Folytat\xe1s a k\xf6vetkez\u0151vel:","wechatpay.timetopay":"Fizet\xe9shez rendelkez\xe9sre \xe1ll\xf3 id\u0151: %@","wechatpay.scanqrcode":"QR-k\xf3d beolvas\xe1sa",personalDetails:"Szem\xe9lyes adatok",companyDetails:"C\xe9g adatai","companyDetails.name":"C\xe9gn\xe9v","companyDetails.registrationNumber":"C\xe9gjegyz\xe9ksz\xe1m",socialSecurityNumber:"Szem\xe9lyi igazolv\xe1ny sz\xe1ma",firstName:"Keresztn\xe9v",infix:"El\u0151tag",lastName:"Vezet\xe9kn\xe9v",mobileNumber:"Mobiltelefonsz\xe1m","mobileNumber.invalid":"\xc9rv\xe9nytelen mobilsz\xe1m",city:"V\xe1ros",postalCode:"Ir\xe1ny\xedt\xf3sz\xe1m",countryCode:"Orsz\xe1gk\xf3d",telephoneNumber:"Telefonsz\xe1m",dateOfBirth:"Sz\xfclet\xe9si d\xe1tum",shopperEmail:"E-mail-c\xedm",gender:"Nem",male:"F\xe9rfi",female:"N\u0151",billingAddress:"Sz\xe1ml\xe1z\xe1si c\xedm",street:"Utca",stateOrProvince:"\xc1llam vagy tartom\xe1ny",country:"Orsz\xe1g",houseNumberOrName:"H\xe1zsz\xe1m",separateDeliveryAddress:"Elt\xe9r\u0151 sz\xe1ll\xedt\xe1si c\xedm megad\xe1sa",deliveryAddress:"Sz\xe1ll\xedt\xe1si c\xedm",zipCode:"Ir\xe1ny\xedt\xf3sz\xe1m",apartmentSuite:"Lak\xe1s/ajt\xf3sz\xe1m",provinceOrTerritory:"Tartom\xe1ny vagy ter\xfclet",cityTown:"V\xe1ros",address:"C\xedm",state:"\xc1llam","field.title.optional":"(nem k\xf6telez\u0151)","creditCard.cvcField.title.optional":"CVC/CVV (opcion\xe1lis)","issuerList.wallet.placeholder":"P\xe9nzt\xe1rca kiv\xe1laszt\xe1sa",privacyPolicy:"Adatv\xe9delmi szab\xe1lyzat","afterPay.agreement":"Elfogadom az AfterPay %@",paymentConditions:"fizet\xe9si felt\xe9teleit",openApp:"Alkalmaz\xe1s megnyit\xe1sa","voucher.readInstructions":"Olvassa el az utas\xedt\xe1sokat","voucher.introduction":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 kupont.","voucher.expirationDate":"Lej\xe1rati d\xe1tum","voucher.alternativeReference":"Alternat\xedv hivatkoz\xe1s","dragonpay.voucher.non.bank.selectField.placeholder":"Szolg\xe1ltat\xf3 kiv\xe1laszt\xe1sa","dragonpay.voucher.bank.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","voucher.paymentReferenceLabel":"Fizet\xe9si referencia","voucher.surcharge":"%@ p\xf3td\xedjat tartalmaz","voucher.introduction.doku":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.shopperName":"V\xe1s\xe1rl\xf3 neve","voucher.merchantName":"Keresked\u0151","voucher.introduction.econtext":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.telephoneNumber":"Telefonsz\xe1m","voucher.shopperReference":"V\xe1s\xe1rl\xf3i referencia","voucher.collectionInstitutionNumber":"Beszed\u0151 c\xe9g sz\xe1ma","voucher.econtext.telephoneNumber.invalid":"A telefonsz\xe1mnak 10 vagy 11 sz\xe1mjegyb\u0151l kell \xe1llnia","boletobancario.btnLabel":"Boleto l\xe9trehoz\xe1sa","boleto.sendCopyToEmail":"M\xe1solat k\xfcld\xe9se az e-mail-c\xedmemre","button.copy":"M\xe1sol\xe1s","button.download":"Let\xf6lt\xe9s","creditCard.storedCard.description.ariaLabel":"A t\xe1rolt k\xe1rtya sz\xe1m\xe1nak v\xe9gz\u0151d\xe9se: %@","voucher.entity":"Entit\xe1s",donateButton:"Adom\xe1nyoz\xe1s",notNowButton:"Most nem",thanksForYourSupport:"K\xf6sz\xf6nj\xfck a t\xe1mogat\xe1s\xe1t!",preauthorizeWith:"El\u0151zetes meghatalmaz\xe1s a k\xf6vetkez\u0151vel:",confirmPreauthorization:"El\u0151zetes meghatalmaz\xe1s j\xf3v\xe1hagy\xe1sa",confirmPurchase:"Fizet\xe9s j\xf3v\xe1hagy\xe1sa",applyGiftcard:"Bev\xe1lt\xe1s",giftcardBalance:"Aj\xe1nd\xe9kk\xe1rtya egyenlege",deductedBalance:"Levont egyenleg","creditCard.pin.title":"PIN-k\xf3d","creditCard.encryptedPassword.label":"K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\xc9rv\xe9nytelen jelsz\xf3","creditCard.taxNumber.label":"K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma (\xc9\xc9HHNN) vagy c\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.labelAlt":"C\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.invalid":"A k\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy a c\xe9gjegyz\xe9ksz\xe1m \xe9rv\xe9nytelen","storedPaymentMethod.disable.button":"Elt\xe1vol\xedt\xe1s","storedPaymentMethod.disable.confirmation":"T\xe1rolt fizet\xe9si m\xf3d elt\xe1vol\xedt\xe1sa","storedPaymentMethod.disable.confirmButton":"Igen, elt\xe1vol\xedtom","storedPaymentMethod.disable.cancelButton":"M\xe9gse","ach.bankAccount":"Banksz\xe1mla","ach.accountHolderNameField.title":"Sz\xe1mlatulajdonos neve","ach.accountHolderNameField.placeholder":"Gipsz Jakab","ach.accountHolderNameField.invalid":"A sz\xe1mlatulajdonos neve \xe9rv\xe9nytelen","ach.accountNumberField.title":"Sz\xe1mlasz\xe1m","ach.accountNumberField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","ach.accountLocationField.title":"ABA-ir\xe1ny\xedt\xf3sz\xe1m","ach.accountLocationField.invalid":"\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m","select.state":"\xc1llam kiv\xe1laszt\xe1sa","select.stateOrProvince":"\xc1llam vagy tartom\xe1ny kiv\xe1laszt\xe1sa","select.provinceOrTerritory":"Tartom\xe1ny vagy ter\xfclet kiv\xe1laszt\xe1sa","select.country":"Orsz\xe1g kiv\xe1laszt\xe1sa","select.noOptionsFound":"Nincsenek tal\xe1latok","select.filter.placeholder":"Keres\xe9s...","telephoneNumber.invalid":"\xc9rv\xe9nytelen telefonsz\xe1m",qrCodeOrApp:"vagy","paypal.processingPayment":"Fizet\xe9s feldolgoz\xe1sa\u2026",generateQRCode:"QR-k\xf3d l\xe9trehoz\xe1sa","await.waitForConfirmation":"V\xe1rakoz\xe1s a j\xf3v\xe1hagy\xe1sra","mbway.confirmPayment":"Fizet\xe9s j\xf3v\xe1hagy\xe1sa az MB WAY alkalmaz\xe1sban","shopperEmail.invalid":"\xc9rv\xe9nytelen e-mail-c\xedm","dateOfBirth.format":"NN/HH/\xc9\xc9\xc9\xc9","dateOfBirth.invalid":"Legal\xe1bb 18 \xe9vesnek kell lennie","blik.confirmPayment":"A fizet\xe9s j\xf3v\xe1hagy\xe1s\xe1hoz nyissa meg a banki alkalmaz\xe1st.","blik.invalid":"Adjon meg 6 sz\xe1mjegyet","blik.code":"6 sz\xe1mjegy\u0171 k\xf3d","blik.help":"K\xf3d lek\xe9r\xe9se a banki alkalmaz\xe1sb\xf3l.","swish.pendingMessage":"A QR-k\xf3d beolvas\xe1s\xe1t k\xf6vet\u0151en az \xe1llapot ak\xe1r 10 percig is f\xfcgg\u0151ben lehet. Ha ek\xf6zben \xfajb\xf3l fizet\xe9st k\xeds\xe9rel meg, az t\xf6bbsz\xf6ri fizet\xe9st eredm\xe9nyezhet.","error.va.gen.01":"Hi\xe1nyos mez\u0151","error.va.gen.02":"\xc9rv\xe9nytelen mez\u0151","error.va.sf-cc-num.01":"\xc9rv\xe9nytelen k\xe1rtyasz\xe1m","error.va.sf-cc-num.03":"A megadott k\xe1rtya nem t\xe1mogatott","error.va.sf-cc-dat.01":"A k\xe1rtya t\xfal r\xe9gi","error.va.sf-cc-dat.02":"T\xfal t\xe1voli j\xf6v\u0151beli d\xe1tum","error.va.sf-cc-dat.03":"A k\xe1rtya lej\xe1r a fizet\xe9s d\xe1tuma el\u0151tt","error.va.sf-ach-num.01":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","error.va.sf-ach-loc.01":"\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m","error.va.sf-kcp-pwd.01":"\xc9rv\xe9nytelen jelsz\xf3","error.giftcard.no-balance":"Az aj\xe1nd\xe9kk\xe1rtya egyenlege nulla","error.giftcard.card-error":"Nyilv\xe1ntart\xe1sunkban nem szerepel ilyen sz\xe1m\xfa aj\xe1nd\xe9kk\xe1rtya","error.giftcard.currency-error":"Az aj\xe1nd\xe9kk\xe1rty\xe1k csak abban a p\xe9nznemben \xe9rv\xe9nyesek, amelyre ki\xe1ll\xedtott\xe1k azokat","amazonpay.signout":"Kijelentkez\xe9s az Amazonr\xf3l","amazonpay.changePaymentDetails":"Fizet\xe9si adatok m\xf3dos\xedt\xe1sa","partialPayment.warning":"M\xe1sik fizet\xe9si m\xf3d v\xe1laszt\xe1sa a fennmarad\xf3 r\xe9sz fizet\xe9s\xe9hez","partialPayment.remainingBalance":"A fennmarad\xf3 egyenleg %{amount} lesz","bankTransfer.beneficiary":"Kedvezm\xe9nyezett","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencia","bankTransfer.introduction":"Folytassa, hogy elind\xedtson egy \xfaj banki \xe1tutal\xe1sos fizet\xe9st. A fizet\xe9s v\xe9gleges\xedt\xe9s\xe9hez felhaszn\xe1lhatja a k\xf6vetkez\u0151 k\xe9perny\u0151n megjelen\u0151 adatokat.","bankTransfer.instructions":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","bacs.accountHolderName":"Banksz\xe1mla-tulajdonos neve","bacs.accountHolderName.invalid":"A banksz\xe1mla-tulajdonos neve \xe9rv\xe9nytelen","bacs.accountNumber":"Banksz\xe1mlasz\xe1m","bacs.accountNumber.invalid":"\xc9rv\xe9nytelen banksz\xe1mlasz\xe1m","bacs.bankLocationId":"Banki azonos\xedt\xf3","bacs.bankLocationId.invalid":"\xc9rv\xe9nytelen banki azonos\xedt\xf3","bacs.consent.amount":"Elfogadom, hogy a fenti \xf6sszeget levonj\xe1k a banksz\xe1ml\xe1mr\xf3l.","bacs.consent.account":"Meger\u0151s\xedtem, hogy a banksz\xe1mla az \xe9n nevemen van, \xe9s \xe9n vagyok a banksz\xe1ml\xe1t \xe9rint\u0151 beszed\xe9si megb\xedz\xe1s j\xf3v\xe1hagy\xe1s\xe1hoz sz\xfcks\xe9ges egyetlen al\xe1\xedr\xf3.",edit:"Szerkeszt\xe9s","bacs.confirm":"Meger\u0151s\xedt\xe9s \xe9s fizet\xe9s","bacs.result.introduction":"Beszed\xe9si megb\xedz\xe1si utas\xedt\xe1s (meghatalmaz\xe1s) let\xf6lt\xe9se","download.pdf":"PDF let\xf6lt\xe9se","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyasz\xe1mhoz","creditCard.encryptedCardNumber.aria.label":"K\xe1rtyasz\xe1m mez\u0151je","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati d\xe1tumhoz","creditCard.encryptedExpiryDate.aria.label":"Lej\xe1rati d\xe1tum mez\u0151je","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati h\xf3naphoz","creditCard.encryptedExpiryMonth.aria.label":"Lej\xe1rati h\xf3nap mez\u0151je","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati \xe9vhez","creditCard.encryptedExpiryYear.aria.label":"Lej\xe1rati \xe9v mez\u0151je","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyabiztons\xe1gi k\xf3dhoz","creditCard.encryptedSecurityCode.aria.label":"Biztons\xe1gi k\xf3d mez\u0151je","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtyasz\xe1mhoz","giftcard.encryptedCardNumber.aria.label":"Aj\xe1nd\xe9kk\xe1rtyasz\xe1m mez\u0151je","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dhoz","giftcard.encryptedSecurityCode.aria.label":"Aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dj\xe1nak mez\u0151je",giftcardTransactionLimit:"Ezen az aj\xe1nd\xe9kk\xe1rty\xe1n a tranzakci\xf3nk\xe9nt enged\xe9lyezett maxim\xe1lis \xf6sszeg %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe a biztons\xe1gos banksz\xe1mlasz\xe1mhoz","ach.encryptedBankAccountNumber.aria.label":"Banksz\xe1mla mez\u0151je","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe a biztons\xe1gos bankazonos\xedt\xf3 k\xf3dhoz","ach.encryptedBankLocationId.aria.label":"Bankazonos\xedt\xf3 k\xf3d mez\u0151je","twint.saved":"mentve"}}),Jk=Object.freeze({__proto__:null,default:{payButton:"Paga","payButton.redirecting":"Reindirizzamento...",storeDetails:"Salva per il prossimo pagamento","creditCard.holderName":"Titolare carta","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome del titolare della carta non valido","creditCard.numberField.title":"Numero carta","creditCard.expiryDateField.title":"Data di scadenza","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mese","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Anno","creditCard.cvcField.title":"CVC/CVV","creditCard.storeDetailsButton":"Ricorda per la prossima volta","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AAMMGG/0123456789",installments:"Numero di rate",installmentOption:"%{partialValue} x%{times}",installmentOptionMonths:"%{times} mesi","installments.oneTime":"Pagamento una tantum","installments.installments":"Pagamento rateale","installments.revolving":"Pagamento ricorrente","sepaDirectDebit.ibanField.invalid":"Numero di conto non valido","sepaDirectDebit.nameField.placeholder":"A. Bianchi","sepa.ownerName":"Nome Intestatario Conto","sepa.ibanNumber":"Numero di conto (IBAN)","error.title":"Errore","error.subtitle.redirect":"Reindirizzamento non riuscito","error.subtitle.payment":"Pagamento non riuscito","error.subtitle.refused":"Pagamento respinto","error.message.unknown":"Si \xe8 verificato un errore sconosciuto","idealIssuer.selectField.title":"Banca","idealIssuer.selectField.placeholder":"Seleziona la banca","creditCard.success":"Pagamento riuscito",loading:"Caricamento in corso...",continue:"Continua",continueTo:"Procedi verso","wechatpay.timetopay":"Devi pagare %@","wechatpay.scanqrcode":"Scansiona il codice QR",personalDetails:"Dati personali",companyDetails:"Informazioni dell'azienda","companyDetails.name":"Ragione sociale","companyDetails.registrationNumber":"Numero di registrazione",socialSecurityNumber:"Numero di previdenza sociale",firstName:"Nome",infix:"Prefisso",lastName:"Cognome",mobileNumber:"Numero di cellulare","mobileNumber.invalid":"Numero di cellulare non valido",city:"Citt\xe0",postalCode:"Codice postale",countryCode:"Codice nazionale",telephoneNumber:"Numero di telefono",dateOfBirth:"Data di nascita",shopperEmail:"Indirizzo e-mail",gender:"Sesso",male:"Uomo",female:"Donna",billingAddress:"Indirizzo di fatturazione",street:"Via",stateOrProvince:"Stato o provincia",country:"Paese",houseNumberOrName:"Numero civico",separateDeliveryAddress:"Specifica un indirizzo di consegna alternativo",deliveryAddress:"Indirizzo di consegna",zipCode:"CAP",apartmentSuite:"Appartamento/suite",provinceOrTerritory:"Provincia o territorio",cityTown:"Citt\xe0",address:"Indirizzo",state:"Stato","field.title.optional":"(facoltativo)","creditCard.cvcField.title.optional":"CVC/CVV (facoltativo)","issuerList.wallet.placeholder":"Seleziona il tuo portafoglio",privacyPolicy:"Informativa sulla privacy","afterPay.agreement":"Accetto i %@ di AfterPay",paymentConditions:"termini di pagamento",openApp:"Apri l'app","voucher.readInstructions":"Leggi le istruzioni","voucher.introduction":"Grazie per il tuo acquisto, utilizza il seguente coupon per completare il pagamento.","voucher.expirationDate":"Data di scadenza","voucher.alternativeReference":"Riferimento alternativo","dragonpay.voucher.non.bank.selectField.placeholder":"Seleziona il tuo fornitore","dragonpay.voucher.bank.selectField.placeholder":"Seleziona la banca","voucher.paymentReferenceLabel":"Riferimento del pagamento","voucher.surcharge":"Include un sovrapprezzo di %@","voucher.introduction.doku":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.shopperName":"Nome dell'acquirente","voucher.merchantName":"Esercente","voucher.introduction.econtext":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.telephoneNumber":"Numero di telefono","voucher.shopperReference":"Riferimento dell'acquirente","voucher.collectionInstitutionNumber":"Codice identificativo del negozio","voucher.econtext.telephoneNumber.invalid":"Il numero di telefono deve essere di 10 o 11 cifre","boletobancario.btnLabel":"Genera Boleto","boleto.sendCopyToEmail":"Invia una copia alla mia e-mail","button.copy":"Copia","button.download":"Scarica","creditCard.storedCard.description.ariaLabel":"La carta memorizzata termina in %@","voucher.entity":"Entit\xe0",donateButton:"Dona",notNowButton:"Non ora",thanksForYourSupport:"Grazie per il tuo sostegno!",preauthorizeWith:"Preautorizza con",confirmPreauthorization:"Conferma preautorizzazione",confirmPurchase:"Conferma acquisto",applyGiftcard:"Riscatta",giftcardBalance:"Saldo del buono",deductedBalance:"Importo detratto","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prime 2 cifre della password della carta","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Password non valida","creditCard.taxNumber.label":"Data di nascita del titolare della carta (AAMMGG) o numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.labelAlt":"Numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.invalid":"Data di nascita del titolare della carta o numero di registrazione aziendale non validi","storedPaymentMethod.disable.button":"Rimuovi","storedPaymentMethod.disable.confirmation":"Rimuovi il metodo di pagamento archiviato","storedPaymentMethod.disable.confirmButton":"S\xec, rimuoverli","storedPaymentMethod.disable.cancelButton":"Cancella","ach.bankAccount":"Conto bancario","ach.accountHolderNameField.title":"Nome del titolare del conto","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome del titolare del conto non valido","ach.accountNumberField.title":"Numero di conto","ach.accountNumberField.invalid":"Numero di conto non valido","ach.accountLocationField.title":"Codice ABA","ach.accountLocationField.invalid":"Codice ABA non valido","select.state":"Seleziona stato","select.stateOrProvince":"Seleziona stato o provincia","select.provinceOrTerritory":"Seleziona provincia o territorio","select.country":"Seleziona paese","select.noOptionsFound":"Nessuna opzione trovata","select.filter.placeholder":"Cerca...","telephoneNumber.invalid":"Numero di telefono non valido",qrCodeOrApp:"o","paypal.processingPayment":"Elaborazione del pagamento in corso...",generateQRCode:"Genera codice QR","await.waitForConfirmation":"In attesa di conferma","mbway.confirmPayment":"Conferma il pagamento con l'app MB WAY","shopperEmail.invalid":"Indirizzo e-mail non valido","dateOfBirth.format":"GG/MM/AAAA","dateOfBirth.invalid":"Devi avere almeno 18 anni","blik.confirmPayment":"Apri l'app della tua banca per confermare il pagamento.","blik.invalid":"Inserisci 6 numeri","blik.code":"Codice a 6 cifre","blik.help":"Ottieni il codice dalla app della tua banca.","swish.pendingMessage":"In seguito alla scansione, lo stato della transazione pu\xf2 rimanere in sospeso per un massimo di 10 minuti. Un nuovo tentativo di pagamento durante questo lasso di tempo pu\xf2 comportare pagamenti multipli.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo non valido","error.va.sf-cc-num.01":"Numero carta non valido","error.va.sf-cc-num.03":"Tipo di carta non supportato","error.va.sf-cc-dat.01":"Carta troppo vecchia","error.va.sf-cc-dat.02":"Data troppo avanti nel futuro","error.va.sf-cc-dat.03":"La tua carta scade prima della data di check out","error.va.sf-ach-num.01":"Numero di conto non valido","error.va.sf-ach-loc.01":"Codice ABA non valido","error.va.sf-kcp-pwd.01":"Password non valida","error.giftcard.no-balance":"Questo buono regalo ha un saldo pari a zero","error.giftcard.card-error":"Non abbiamo alcun buono regalo con questo numero nei nostri archivi","error.giftcard.currency-error":"I buono regalo sono validi solo nella valuta in cui sono state emessi","amazonpay.signout":"Esci da Amazon","amazonpay.changePaymentDetails":"Modifica i dettagli di pagamento","partialPayment.warning":"Seleziona un altro metodo di pagamento per pagare l'importo rimanente","partialPayment.remainingBalance":"Il saldo rimanente sar\xe0 di %{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Riferimento","bankTransfer.introduction":"Continua per creare un nuovo pagamento tramite bonifico bancario. Puoi utilizzare i dettagli nella schermata seguente per completare l'operazione.","bankTransfer.instructions":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","bacs.accountHolderName":"Nome del titolare del conto bancario","bacs.accountHolderName.invalid":"Nome del titolare del conto bancario non valido","bacs.accountNumber":"Numero di conto bancario","bacs.accountNumber.invalid":"Numero di conto bancario non valido","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Sort code non valido","bacs.consent.amount":"Accetto che l'importo sopra indicato venga detratto dal mio conto bancario.","bacs.consent.account":"Confermo che il conto \xe8 intestato al sottoscritto e che sono l'unico firmatario a dover autorizzare l'addebito diretto su questo conto.",edit:"Modifica","bacs.confirm":"Conferma e paga","bacs.result.introduction":"Scarica le Istruzioni per l'addebito diretto (DDI / Mandato)","download.pdf":"Scarica PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta protetta","creditCard.encryptedCardNumber.aria.label":"Campo numero di carta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe data di scadenza per numero di carta protetta","creditCard.encryptedExpiryDate.aria.label":"Campo data di scadenza","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe mese di scadenza per numero di carta protetta","creditCard.encryptedExpiryMonth.aria.label":"Campo mese di scadenza","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe anno di scadenza per numero di carta protetta","creditCard.encryptedExpiryYear.aria.label":"Campo anno di scadenza","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta protetta","creditCard.encryptedSecurityCode.aria.label":"Campo codice di sicurezza","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta regalo protetta","giftcard.encryptedCardNumber.aria.label":"Campo numero carta regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta regalo protetta","giftcard.encryptedSecurityCode.aria.label":"Campo codice di sicurezza della carta regalo",giftcardTransactionLimit:"Importo massimo di %{amount} per transazione su questo buono regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe per numero di numero di conto bancario protetto","ach.encryptedBankAccountNumber.aria.label":"Campo conto bancario","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe per numero di routing bancario sicuro","ach.encryptedBankLocationId.aria.label":"Campo numero di routing bancario","twint.saved":"memorizzato"}}),Zk=Object.freeze({__proto__:null,default:{payButton:"\u652f\u6255\u3046","payButton.redirecting":"\u30ea\u30c0\u30a4\u30ec\u30af\u30c8\u3057\u3066\u3044\u307e\u3059...",storeDetails:"\u6b21\u56de\u306e\u304a\u652f\u6255\u3044\u306e\u305f\u3081\u8a73\u7d30\u3092\u4fdd\u5b58","creditCard.holderName":"\u30ab\u30fc\u30c9\u4e0a\u306e\u540d\u524d","creditCard.holderName.placeholder":"Taro Yamada","creditCard.holderName.invalid":"\u7121\u52b9\u306a\u30ab\u30fc\u30c9\u6240\u6709\u8005\u540d","creditCard.numberField.title":"\u30ab\u30fc\u30c9\u756a\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u52b9\u671f\u9650","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9 (CVC)","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u6b21\u56de\u306e\u305f\u3081\u306b\u4fdd\u5b58\u3057\u307e\u3059","creditCard.cvcField.placeholder.4digits":"4\u6841","creditCard.cvcField.placeholder.3digits":"3\u6841","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff08YYMMDD\uff09/ 0123456789",installments:"\u5206\u5272\u56de\u6570",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\u304b\u6708","installments.oneTime":"\u4e00\u62ec\u6255\u3044","installments.installments":"\u5206\u5272\u6255\u3044","installments.revolving":"\u30ea\u30dc\u6255\u3044","sepaDirectDebit.ibanField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u540d\u7fa9","sepa.ibanNumber":"\u53e3\u5ea7\u756a\u53f7 (IBAN)","error.title":"\u30a8\u30e9\u30fc","error.subtitle.redirect":"\u753b\u9762\u306e\u5207\u308a\u66ff\u3048\u5931\u6557\u306b\u3057\u307e\u3057\u305f","error.subtitle.payment":"\u652f\u6255\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f","error.subtitle.refused":"\u30ab\u30fc\u30c9\u4f1a\u793e\u3067\u53d6\u5f15\u304c\u627f\u8a8d\u3055\u308c\u307e\u305b\u3093\u3067\u3057\u305f\u3002","error.message.unknown":"\u4e0d\u660e\u306a\u30a8\u30e9\u30fc\u304c\u767a\u751f\u3057\u307e\u3057\u305f","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","creditCard.success":"\u8a8d\u8a3c\u304c\u6210\u529f\u3057\u307e\u3057\u305f",loading:"\u8aad\u307f\u8fbc\u3093\u3067\u3044\u307e\u3059...",continue:"\u7d9a\u3051\u308b",continueTo:"\u6b21\u3078\u9032\u3080\uff1a","wechatpay.timetopay":"%@\u3092\u304a\u652f\u6255\u3044\u4e0b\u3055\u3044\u3002","wechatpay.scanqrcode":"QR \u30b3\u30fc\u30c9\u3092\u30b9\u30ad\u30e3\u30f3\u3059\u308b",personalDetails:"\u500b\u4eba\u60c5\u5831",companyDetails:"\u4f1a\u793e\u60c5\u5831","companyDetails.name":"\u4f1a\u793e\u540d","companyDetails.registrationNumber":"\u767b\u9332\u756a\u53f7",socialSecurityNumber:"\u30bd\u30fc\u30b7\u30e3\u30eb\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u756a\u53f7",firstName:"\u540d",infix:"\u656c\u79f0",lastName:"\u59d3",mobileNumber:"\u643a\u5e2f\u756a\u53f7","mobileNumber.invalid":"\u7121\u52b9\u306a\u643a\u5e2f\u96fb\u8a71\u756a\u53f7",city:"\u5e02\u533a",postalCode:"\u90f5\u4fbf\u756a\u53f7",countryCode:"\u56fd\u30b3\u30fc\u30c9",telephoneNumber:"\u96fb\u8a71\u756a\u53f7",dateOfBirth:"\u751f\u5e74\u6708\u65e5",shopperEmail:"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9",gender:"\u6027\u5225",male:"\u7537\u6027",female:"\u5973\u6027",billingAddress:"\u3054\u8acb\u6c42\u4f4f\u6240",street:"\u756a\u5730",stateOrProvince:"\u90fd\u9053\u5e9c\u770c",country:"\u56fd",houseNumberOrName:"\u90e8\u5c4b\u756a\u53f7",separateDeliveryAddress:"\u5225\u306e\u914d\u9001\u5148\u4f4f\u6240\u3092\u6307\u5b9a\u3057\u3066\u304f\u3060\u3055\u3044",deliveryAddress:"\u914d\u9001\u5148\u4f4f\u6240",zipCode:"\u90f5\u4fbf\u756a\u53f7",apartmentSuite:"\u30a2\u30d1\u30fc\u30c8\u540d/\u90e8\u5c4b\u540d",provinceOrTerritory:"\u5dde\u307e\u305f\u306f\u6e96\u5dde",cityTown:"\u5e02\u533a\u753a\u6751",address:"\u4f4f\u6240",state:"\u90fd\u9053\u5e9c\u770c","field.title.optional":"\uff08\u4efb\u610f\uff09","creditCard.cvcField.title.optional":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9(\u4efb\u610f)","issuerList.wallet.placeholder":"\u30a6\u30a9\u30ec\u30c3\u30c8\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044",privacyPolicy:"\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc","afterPay.agreement":"AfterPay\u306e%@\u3067\u540c\u610f",paymentConditions:"\u652f\u6255\u6761\u4ef6",openApp:"\u30a2\u30d7\u30ea\u3092\u958b\u304f","voucher.readInstructions":"\u624b\u9806\u3092\u53c2\u7167\u3057\u3066\u304f\u3060\u3055\u3044","voucher.introduction":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u30af\u30fc\u30dd\u30f3\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.expirationDate":"\u6709\u52b9\u671f\u9650","voucher.alternativeReference":"\u5225\u306e\u53c2\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u30d7\u30ed\u30d0\u30a4\u30c0\u30fc\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","dragonpay.voucher.bank.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","voucher.paymentReferenceLabel":"\u652f\u6255\u306e\u53c2\u7167","voucher.surcharge":"%@ \u306e\u8ffd\u52a0\u6599\u91d1\u3092\u542b\u3080","voucher.introduction.doku":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.shopperName":"\u8cfc\u5165\u8005\u6c0f\u540d","voucher.merchantName":"\u696d\u8005","voucher.introduction.econtext":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u756a\u53f7","voucher.shopperReference":"\u8cfc\u5165\u8005\u5411\u3051\u53c2\u8003\u60c5\u5831","voucher.collectionInstitutionNumber":"\u53ce\u7d0d\u6a5f\u95a2\u756a\u53f7","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u756a\u53f7\u306f10\u6841\u307e\u305f\u306f11\u6841\u306b\u3057\u3066\u304f\u3060\u3055\u3044","boletobancario.btnLabel":"Boleto\u3092\u751f\u6210\u3059\u308b","boleto.sendCopyToEmail":"\u81ea\u5206\u306e\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u306b\u30b3\u30d4\u30fc\u3092\u9001\u4fe1\u3059\u308b","button.copy":"\u30b3\u30d4\u30fc","button.download":"\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","creditCard.storedCard.description.ariaLabel":"\u4fdd\u5b58\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306f\uff05@\u306b\u7d42\u4e86\u3057\u307e\u3059","voucher.entity":"\u30a8\u30f3\u30c6\u30a3\u30c6\u30a3",donateButton:"\u5bc4\u4ed8\u3059\u308b",notNowButton:"\u4eca\u306f\u3057\u306a\u3044",thanksForYourSupport:"\u3054\u652f\u63f4\u3044\u305f\u3060\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002",preauthorizeWith:"\u6b21\u3067\u4e8b\u524d\u8a8d\u8a3c\u3059\u308b\uff1a",confirmPreauthorization:"\u4e8b\u524d\u627f\u8a8d\u3092\u78ba\u8a8d\u3059\u308b",confirmPurchase:"\u8cfc\u5165\u3092\u78ba\u8a8d\u3059\u308b",applyGiftcard:"\u5229\u7528\u3059\u308b",giftcardBalance:"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8",deductedBalance:"\u5dee\u3057\u5f15\u304d\u5f8c\u6b8b\u9ad8","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"\u30ab\u30fc\u30c9\u306e\u30d1\u30b9\u30ef\u30fc\u30c9\u306e\u6700\u521d\u306e2\u6841","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u30d1\u30b9\u30ef\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","creditCard.taxNumber.label":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\uff08YYMMDD\uff09\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.labelAlt":"\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.invalid":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","storedPaymentMethod.disable.button":"\u524a\u9664","storedPaymentMethod.disable.confirmation":"\u4fdd\u5b58\u3055\u308c\u3066\u3044\u308b\u652f\u6255\u65b9\u6cd5\u3092\u524a\u9664\u3059\u308b","storedPaymentMethod.disable.confirmButton":"\u306f\u3044\u3001\u524a\u9664\u3057\u307e\u3059","storedPaymentMethod.disable.cancelButton":"\u30ad\u30e3\u30f3\u30bb\u30eb","ach.bankAccount":"\u9280\u884c\u53e3\u5ea7","ach.accountHolderNameField.title":"\u53e3\u5ea7\u540d\u7fa9","ach.accountHolderNameField.placeholder":"Taro Yamada","ach.accountHolderNameField.invalid":"\u7121\u52b9\u306a\u53e3\u5ea7\u540d\u7fa9","ach.accountNumberField.title":"\u53e3\u5ea7\u756a\u53f7","ach.accountNumberField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","ach.accountLocationField.title":"ABA\u30ca\u30f3\u30d0\u30fc","ach.accountLocationField.invalid":"\u7121\u52b9\u306aABA\u30ca\u30f3\u30d0\u30fc","select.state":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.stateOrProvince":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.provinceOrTerritory":"\u5dde\u307e\u305f\u306f\u6e96\u5dde\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.country":"\u56fd\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.noOptionsFound":"\u30aa\u30d7\u30b7\u30e7\u30f3\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f","select.filter.placeholder":"\u691c\u7d22...","telephoneNumber.invalid":"\u7121\u52b9\u306a\u96fb\u8a71\u756a\u53f7",qrCodeOrApp:"\u307e\u305f\u306f","paypal.processingPayment":"\u652f\u6255\u3044\u3092\u51e6\u7406\u3057\u3066\u3044\u307e\u3059...",generateQRCode:"QR\u30b3\u30fc\u30c9\u3092\u751f\u6210\u3059\u308b","await.waitForConfirmation":"\u78ba\u8a8d\u3092\u5f85\u3063\u3066\u3044\u307e\u3059","mbway.confirmPayment":"MB WAY\u30a2\u30d7\u30ea\u3067\u652f\u6255\u3092\u78ba\u8a8d\u3059\u308b","shopperEmail.invalid":"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u304c\u7121\u52b9\u3067\u3059","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"18\u6b73\u4ee5\u4e0a\u306e\u65b9\u306e\u307f\u3054\u5229\u7528\u3044\u305f\u3060\u3051\u307e\u3059","blik.confirmPayment":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u3092\u958b\u3044\u3066\u3001\u652f\u6255\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002","blik.invalid":"6\u3064\u306e\u6570\u5b57\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044","blik.code":"6\u6841\u306e\u30b3\u30fc\u30c9","blik.help":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u304b\u3089\u30b3\u30fc\u30c9\u3092\u53d6\u5f97\u3057\u3066\u304f\u3060\u3055\u3044\u3002","swish.pendingMessage":"\u30b9\u30ad\u30e3\u30f3\u5f8c\u3001\u30b9\u30c6\u30fc\u30bf\u30b9\u306f\u6700\u592710\u5206\u9593\u4fdd\u7559\u72b6\u614b\u306b\u306a\u308a\u307e\u3059\u3002\u3053\u306e\u9593\u306b\u518d\u5ea6\u304a\u652f\u6255\u3044\u3044\u305f\u3060\u3053\u3046\u3068\u3059\u308b\u3068\u3001\u8907\u6570\u306e\u8acb\u6c42\u304c\u767a\u751f\u3059\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059\u3002","error.va.gen.01":"\u4e0d\u5b8c\u5168\u306a\u30d5\u30a3\u30fc\u30eb\u30c9","error.va.gen.02":"\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.01":"\u30ab\u30fc\u30c9\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.03":"\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u306a\u3044\u30ab\u30fc\u30c9\u304c\u5165\u529b\u3055\u308c\u307e\u3057\u305f","error.va.sf-cc-dat.01":"\u30ab\u30fc\u30c9\u304c\u53e4\u3059\u304e\u307e\u3059","error.va.sf-cc-dat.02":"\u672a\u6765\u306e\u65e5\u4ed8\u304c\u5148\u3059\u304e\u3067\u3059","error.va.sf-cc-dat.03":"\u30c1\u30a7\u30c3\u30af\u30a2\u30a6\u30c8\u65e5\u3088\u308a\u524d\u306b\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u304c\u5207\u308c\u307e\u3059","error.va.sf-ach-num.01":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","error.va.sf-ach-loc.01":"\u7121\u52b9\u306aABA\u30ca\u30f3\u30d0\u30fc","error.va.sf-kcp-pwd.01":"\u30d1\u30b9\u30ef\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","error.giftcard.no-balance":"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8\u306f\u30bc\u30ed\u3067\u3059","error.giftcard.card-error":"\u8a18\u9332\u3067\u306f\u3001\u3053\u306e\u756a\u53f7\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3042\u308a\u307e\u305b\u3093","error.giftcard.currency-error":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3001\u767a\u884c\u3055\u308c\u305f\u901a\u8ca8\u3067\u306e\u307f\u6709\u52b9\u3067\u3059\u3002","amazonpay.signout":"Amazon\u304b\u3089\u30b5\u30a4\u30f3\u30a2\u30a6\u30c8\u3059\u308b","amazonpay.changePaymentDetails":"\u652f\u6255\u660e\u7d30\u3092\u5909\u66f4\u3059\u308b","partialPayment.warning":"\u6b8b\u91d1\u3092\u652f\u6255\u3046\u5225\u306e\u652f\u6255\u65b9\u6cd5\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","partialPayment.remainingBalance":"\u6b8b\u308a\u306e\u6b8b\u9ad8\u306f%{amount}\u306b\u306a\u308a\u307e\u3059","bankTransfer.beneficiary":"\u53d7\u76ca\u8005","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c2\u7167","bankTransfer.introduction":"\u65b0\u3057\u3044\u9280\u884c\u632f\u8fbc\u306b\u3088\u308b\u304a\u652f\u6255\u306e\u4f5c\u6210\u3092\u7d9a\u884c\u3057\u307e\u3059\u3002\u6b21\u306e\u753b\u9762\u306e\u8a73\u7d30\u3092\u4f7f\u7528\u3057\u3066\u3001\u3053\u306e\u304a\u652f\u6255\u3044\u3092\u78ba\u5b9a\u3067\u304d\u307e\u3059\u3002","bankTransfer.instructions":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","bacs.accountHolderName":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9","bacs.accountHolderName.invalid":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9\u304c\u7121\u52b9\u3067\u3059","bacs.accountNumber":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7","bacs.accountNumber.invalid":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","bacs.bankLocationId":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9","bacs.bankLocationId.invalid":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","bacs.consent.amount":"\u4e0a\u8a18\u306e\u91d1\u984d\u304c\u79c1\u306e\u9280\u884c\u53e3\u5ea7\u304b\u3089\u5f15\u304d\u843d\u3068\u3055\u308c\u308b\u3053\u3068\u306b\u540c\u610f\u3057\u307e\u3059\u3002","bacs.consent.account":"\u53e3\u5ea7\u304c\u79c1\u306e\u540d\u7fa9\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3001\u3053\u306e\u53e3\u5ea7\u304b\u3089\u306e\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u3092\u627f\u8a8d\u3059\u308b\u305f\u3081\u306b\u5fc5\u8981\u306a\u552f\u4e00\u306e\u7f72\u540d\u8005\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u307e\u3059\u3002",edit:"\u7de8\u96c6","bacs.confirm":"\u78ba\u8a8d\u3057\u3066\u652f\u6255\u3046","bacs.result.introduction":"\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u306e\u8aac\u660e (DDI/\u59d4\u4efb\u72b6) \u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9\u3059\u308b","download.pdf":"PDF\u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","creditCard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","creditCard.encryptedCardNumber.aria.label":"\u30ab\u30fc\u30c9\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u65e5\u306e iframe","creditCard.encryptedExpiryDate.aria.label":"\u6709\u52b9\u671f\u9650\u65e5\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u6708\u306e iframe","creditCard.encryptedExpiryMonth.aria.label":"\u6709\u52b9\u671f\u9650\u6708\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u5e74\u306e iframe","creditCard.encryptedExpiryYear.aria.label":"\u6709\u52b9\u671f\u9650\u5e74\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","creditCard.encryptedSecurityCode.aria.label":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9","giftcard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","giftcard.encryptedCardNumber.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","giftcard.encryptedSecurityCode.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9",giftcardTransactionLimit:"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u3067\u306e\u53d6\u5f15\u3054\u3068\u306b\u8a31\u53ef\u3055\u308c\u308b\u6700\u5927%{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u306e iframe","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u53e3\u5ea7\u30d5\u30a3\u30fc\u30eb\u30c9","ach.encryptedBankLocationId.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u652f\u5e97\u756a\u53f7\u306e iframe","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u652f\u5e97\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","twint.saved":"\u3092\u4fdd\u5b58\u3057\u307e\u3057\u305f"}}),Qk=Object.freeze({__proto__:null,default:{payButton:"\uacb0\uc81c","payButton.redirecting":"\ub9ac\ub514\ub809\uc158 \uc911...",storeDetails:"\ub2e4\uc74c \uacb0\uc81c\ub97c \uc704\ud574 \uc774 \uc218\ub2e8 \uc800\uc7a5","creditCard.holderName":"\uce74\ub4dc\uc0c1\uc758 \uc774\ub984","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc774\ub984","creditCard.numberField.title":"\uce74\ub4dc \ubc88\ud638","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\ub9cc\ub8cc\uc77c","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\uc6d4","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\uc5f0\ub3c4","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\ub2e4\uc74c\uc744 \uc704\ud574 \uc800\uc7a5","creditCard.cvcField.placeholder.4digits":"4\uc790\ub9ac","creditCard.cvcField.placeholder.3digits":"3\uc790\ub9ac","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"\ud560\ubd80 \uac1c\uc6d4 \uc218",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\uac1c\uc6d4","installments.oneTime":"\uc77c\uc2dc\ubd88 \uacb0\uc81c","installments.installments":"\ud560\ubd80 \uacb0\uc81c","installments.revolving":"\ub9ac\ubcfc\ube59 \uacb0\uc81c","sepaDirectDebit.ibanField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\uc18c\uc720\uc790 \uc774\ub984","sepa.ibanNumber":"\uacc4\uc88c \ubc88\ud638(IBAN)","error.title":"\uc624\ub958","error.subtitle.redirect":"\ub9ac\ub514\ub809\uc158 \uc2e4\ud328","error.subtitle.payment":"\uacb0\uc81c \uc2e4\ud328","error.subtitle.refused":"\uacb0\uc81c \uac70\ubd80","error.message.unknown":"\uc54c \uc218 \uc5c6\ub294 \uc624\ub958 \ubc1c\uc0dd","idealIssuer.selectField.title":"\uc740\ud589","idealIssuer.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","creditCard.success":"\uacb0\uc81c \uc131\uacf5",loading:"\ub85c\ub4dc \uc911\u2026",continue:"\uacc4\uc18d",continueTo:"\ub2e4\uc74c\uc73c\ub85c \uacc4\uc18d:","wechatpay.timetopay":"\ub0a8\uc740 \uacb0\uc81c \uc2dc\ud55c: %@","wechatpay.scanqrcode":"QR \ucf54\ub4dc \uc2a4\uce94",personalDetails:"\uac1c\uc778 \uc815\ubcf4",companyDetails:"\ud68c\uc0ac \uc815\ubcf4","companyDetails.name":"\ud68c\uc0ac\uba85","companyDetails.registrationNumber":"\ub4f1\ub85d \ubc88\ud638",socialSecurityNumber:"\uc0ac\ud68c \ubcf4\uc7a5 \ubc88\ud638(\uc8fc\ubbfc\ub4f1\ub85d\ubc88\ud638)",firstName:"\uc774\ub984",infix:"\uba85\uce6d",lastName:"\uc131",mobileNumber:"\ud734\ub300\ud3f0 \ubc88\ud638","mobileNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ud734\ub300\ud3f0 \ubc88\ud638",city:"\uc2dc",postalCode:"\uc6b0\ud3b8\ubc88\ud638",countryCode:"\uad6d\uac00 \ucf54\ub4dc",telephoneNumber:"\uc804\ud654\ubc88\ud638",dateOfBirth:"\uc0dd\ub144\uc6d4\uc77c",shopperEmail:"\uc774\uba54\uc77c \uc8fc\uc18c",gender:"\uc131\ubcc4",male:"\ub0a8\uc131",female:"\uc5ec\uc131",billingAddress:"\uccad\uad6c\uc9c0 \uc8fc\uc18c",street:"\ub3c4\ub85c\uba85",stateOrProvince:"\uc8fc/\ub3c4",country:"\uad6d\uac00",houseNumberOrName:"\uc9d1 \uc804\ud654\ubc88\ud638",separateDeliveryAddress:"\ubc30\uc1a1 \uc8fc\uc18c \ubcc4\ub3c4 \uc9c0\uc815",deliveryAddress:"\ubc30\uc1a1 \uc8fc\uc18c",zipCode:"\uc6b0\ud3b8\ubc88\ud638",apartmentSuite:"\uc544\ud30c\ud2b8/\uac74\ubb3c",provinceOrTerritory:"\ub3c4",cityTown:"\uc2dc/\uad6c",address:"\uc8fc\uc18c",state:"\uc8fc","field.title.optional":"(\uc120\ud0dd \uc0ac\ud56d)","creditCard.cvcField.title.optional":"CVC / CVV (\uc120\ud0dd)","issuerList.wallet.placeholder":"\uc804\uc790 \uc9c0\uac11 \uc120\ud0dd",privacyPolicy:"\uac1c\uc778\uc815\ubcf4 \ubcf4\ud638\uc815\ucc45","afterPay.agreement":"AfterPay\uc758 %@\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.",paymentConditions:"\uacb0\uc81c \uc870\uac74",openApp:"\uc571 \uc5f4\uae30","voucher.readInstructions":"\uc548\ub0b4 \uc77d\uae30","voucher.introduction":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ucfe0\ud3f0\uc744 \uc0ac\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.expirationDate":"\ub9cc\ub8cc\uc77c","voucher.alternativeReference":"\ub300\uccb4 \ucc38\uc870\ubc88\ud638","dragonpay.voucher.non.bank.selectField.placeholder":"\uc81c\uacf5 \uc5c5\uccb4 \uc120\ud0dd","dragonpay.voucher.bank.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","voucher.paymentReferenceLabel":"\uacb0\uc81c \ucc38\uc870\ubc88\ud638","voucher.surcharge":"%@ \ud560\uc99d\ub8cc \ud3ec\ud568","voucher.introduction.doku":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.shopperName":"\uad6c\ub9e4\uc790 \uc774\ub984","voucher.merchantName":"\uac00\ub9f9\uc810","voucher.introduction.econtext":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.telephoneNumber":"\uc804\ud654\ubc88\ud638","voucher.shopperReference":"\uad6c\ub9e4\uc790 \ucc38\uc870\ubc88\ud638","voucher.collectionInstitutionNumber":"\uc218\uae08 \uae30\uad00 \ubc88\ud638","voucher.econtext.telephoneNumber.invalid":"\uc804\ud654\ubc88\ud638\ub294 10\uc790\ub9ac \ub610\ub294 11\uc790\ub9ac \uc22b\uc790\uc5ec\uc57c \ud569\ub2c8\ub2e4","boletobancario.btnLabel":"Boleto \uc0dd\uc131","boleto.sendCopyToEmail":"\ub0b4 \uc774\uba54\uc77c\ub85c \uc0ac\ubcf8 \ubcf4\ub0b4\uae30","button.copy":"\ubcf5\uc0ac","button.download":"\ub2e4\uc6b4\ub85c\ub4dc","creditCard.storedCard.description.ariaLabel":"\uc800\uc7a5\ub41c \uce74\ub4dc\ub294 %@ \ud6c4 \uc885\ub8cc\ub429\ub2c8\ub2e4.","voucher.entity":"\ubc1c\uae09\uc0ac",donateButton:"\uae30\ubd80\ud558\uae30",notNowButton:"\ub2e4\uc74c\uc5d0 \ud558\uae30",thanksForYourSupport:"\ub3c4\uc640\uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4!",preauthorizeWith:"\uc0ac\uc804 \uc2b9\uc778 \ubc29\ubc95:",confirmPreauthorization:"\uc0ac\uc804 \uc2b9\uc778 \ud655\uc778",confirmPurchase:"\uad6c\ub9e4 \ud655\uc778",applyGiftcard:"\uae30\ud504\ud2b8 \uce74\ub4dc\ub85c \uacb0\uc81c",giftcardBalance:"\uae30\ud504\ud2b8 \uce74\ub4dc \uc794\uc561",deductedBalance:"\uacf5\uc81c \uc794\uc561","creditCard.pin.title":"\ube44\ubc00\ubc88\ud638","creditCard.encryptedPassword.label":"\uce74\ub4dc \ube44\ubc00\ubc88\ud638 \uccab 2\uc790\ub9ac","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ubc88\ud638","creditCard.taxNumber.label":"\uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c(\uc608: 870130) \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.labelAlt":"\ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638","storedPaymentMethod.disable.button":"\uc0ad\uc81c","storedPaymentMethod.disable.confirmation":"\uc800\uc7a5\ub41c \uacb0\uc81c \uc218\ub2e8 \uc0ad\uc81c","storedPaymentMethod.disable.confirmButton":"\uc608, \uc0ad\uc81c\ud569\ub2c8\ub2e4","storedPaymentMethod.disable.cancelButton":"\ucde8\uc18c","ach.bankAccount":"\uc740\ud589 \uacc4\uc88c","ach.accountHolderNameField.title":"\uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountNumberField.title":"\uacc4\uc88c \ubc88\ud638","ach.accountNumberField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","ach.accountLocationField.title":"ABA \ub77c\uc6b0\ud305 \ubc88\ud638","ach.accountLocationField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 ABA \ub77c\uc6b0\ud305 \ubc88\ud638","select.state":"\uc8fc \uc120\ud0dd","select.stateOrProvince":"\uc8fc/\ub3c4 \uc120\ud0dd","select.provinceOrTerritory":"\ub3c4 \uc120\ud0dd","select.country":"\uad6d\uac00 \uc120\ud0dd","select.noOptionsFound":"\uac80\uc0c9\ub41c \uc635\uc158 \uc5c6\uc74c","select.filter.placeholder":"\uac80\uc0c9...","telephoneNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc804\ud654\ubc88\ud638",qrCodeOrApp:"\ub610\ub294","paypal.processingPayment":"\uacb0\uc81c \ucc98\ub9ac \uc911...",generateQRCode:"QR \ucf54\ub4dc \uc0dd\uc131","await.waitForConfirmation":"\ud655\uc778 \ub300\uae30\uc911","mbway.confirmPayment":"MB WAY \uc571\uc5d0\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc2ed\uc2dc\uc624","shopperEmail.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc774\uba54\uc77c \uc8fc\uc18c","dateOfBirth.format":"DD(\uc77c)/MM(\uc6d4)/YYYY(\uc5f0\ub3c4)","dateOfBirth.invalid":"\ucd5c\uc18c 18\uc138 \uc774\uc0c1\uc774\uc5b4\uc57c \ud569\ub2c8\ub2e4","blik.confirmPayment":"\ubc45\ud0b9 \uc571\uc744 \uc5f4\uc5b4\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc138\uc694.","blik.invalid":"6\uc790\ub9ac \uc22b\uc790 \uc785\ub825","blik.code":"6\uc790\ub9ac \ucf54\ub4dc","blik.help":"\ubc45\ud0b9 \uc571\uc5d0\uc11c \ucf54\ub4dc\ub97c \uac00\uc838\uc624\uc138\uc694.","swish.pendingMessage":"\uc2a4\uce94 \ud6c4 \ucd5c\ub300 10\ubd84 \ub3d9\uc548 \uc0c1\ud0dc\uac00 \ubcf4\ub958\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4. 10\ubd84 \ub0b4\uc5d0 \ub2e4\uc2dc \uc2dc\ub3c4\ud560 \uacbd\uc6b0 \uae08\uc561\uc774 \uc5ec\ub7ec \ubc88 \uccad\uad6c\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","error.va.gen.01":"\ubbf8\uc644\ub8cc \ud544\ub4dc","error.va.gen.02":"\ud544\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-num.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \ubc88\ud638\uc785\ub2c8\ub2e4","error.va.sf-cc-num.03":"\uc9c0\uc6d0\ub418\uc9c0 \uc54a\ub294 \uce74\ub4dc\uac00 \uc785\ub825\ub418\uc5c8\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.01":"\uce74\ub4dc\uac00 \ub108\ubb34 \uc624\ub798\ub418\uc5c8\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.02":"\ud604\uc7ac\ub85c\ubd80\ud130 \ub108\ubb34 \uba3c \ub0a0\uc9dc\uc785\ub2c8\ub2e4","error.va.sf-cc-dat.03":"\uadc0\ud558\uc758 \uce74\ub4dc\uac00 \uacb0\uc81c\uc77c \uc804\uc5d0 \ub9cc\ub8cc\ub429\ub2c8\ub2e4.","error.va.sf-ach-num.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","error.va.sf-ach-loc.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 ABA \ub77c\uc6b0\ud305 \ubc88\ud638","error.va.sf-kcp-pwd.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ubc88\ud638","error.giftcard.no-balance":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc\uc5d0\ub294 \uc794\uc561\uc774 \uc5c6\uc2b5\ub2c8\ub2e4","error.giftcard.card-error":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638\ub294 \ub2f9\uc0ac\uc5d0 \ub4f1\ub85d\ub418\uc5b4 \uc788\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.giftcard.currency-error":"\uae30\ud504\ud2b8 \uce74\ub4dc\ub294 \ubc1c\uae09\ub41c \ud1b5\ud654\ub85c\ub9cc \uc0ac\uc6a9\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4","amazonpay.signout":"Amazon\uc5d0\uc11c \ub85c\uadf8\uc544\uc6c3","amazonpay.changePaymentDetails":"\uacb0\uc81c \uc815\ubcf4 \ubcc0\uacbd","partialPayment.warning":"\ub098\uba38\uc9c0 \ube44\uc6a9 \uc9c0\ubd88\uc5d0 \uc0ac\uc6a9\ud560 \ub2e4\ub978 \uacb0\uc81c \uc218\ub2e8 \uc120\ud0dd\ud558\uae30","partialPayment.remainingBalance":"\ub0a8\uc740 \uc794\uc561\uc740 %{amount}\uc785\ub2c8\ub2e4","bankTransfer.beneficiary":"\uc218\ub839\uc778","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\ucc38\uc870 \ubc88\ud638","bankTransfer.introduction":"\uc0c8 \uacc4\uc88c \uc774\uccb4 \uac74\uc744 \uacc4\uc18d \uc9c4\ud589\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ud654\uba74\uc5d0 \ub098\uc624\ub294 \uc815\ubcf4\ub97c \uc774\uc6a9\ud574 \uc774\uccb4\ub97c \uc644\ub8cc\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","bankTransfer.instructions":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","bacs.accountHolderName":"\uc608\uae08\uc8fc \uc774\ub984","bacs.accountHolderName.invalid":"\uc608\uae08\uc8fc \uc774\ub984\uc774 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.accountNumber":"\uacc4\uc88c \ubc88\ud638","bacs.accountNumber.invalid":"\uacc4\uc88c \ubc88\ud638\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.bankLocationId":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc","bacs.bankLocationId.invalid":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.consent.amount":"\uacc4\uc88c\uc5d0\uc11c \uc704\uc758 \uae08\uc561\uc744 \uc774\uccb4\ud558\ub294 \uac83\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.","bacs.consent.account":"\ubcf8\uc778\uc774 \uc774 \uacc4\uc88c\uc758 \uc608\uae08\uc8fc\uc774\uba70, \uc774 \uacc4\uc88c\uc5d0\uc11c\uc758 \uc790\ub3d9 \uc774\uccb4\ub97c \uc2b9\uc778\ud558\uae30 \uc704\ud574 \ud544\uc694\ud55c \uc720\uc77c\ud55c \uc11c\uba85\uc778\uc785\ub2c8\ub2e4.",edit:"\uc218\uc815","bacs.confirm":"\ud655\uc778 \ubc0f \uacb0\uc81c","bacs.result.introduction":"\uc790\ub3d9 \uc774\uccb4 \uc548\ub0b4(DDI/\ud544\uc218) \ub2e4\uc6b4\ub85c\ub4dc","download.pdf":"PDF \ub2e4\uc6b4\ub85c\ub4dc","creditCard.encryptedCardNumber.aria.iframeTitle":"\uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedCardNumber.aria.label":"\uce74\ub4dc \ubc88\ud638 \uc785\ub825\ub780","creditCard.encryptedExpiryDate.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \ub0a0\uc9dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryDate.aria.label":"\ub9cc\ub8cc \ub0a0\uc9dc \uc785\ub825\ub780","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc6d4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryMonth.aria.label":"\ub9cc\ub8cc \uc6d4 \uc785\ub825\ub780","creditCard.encryptedExpiryYear.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc5f0\ub3c4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryYear.aria.label":"\ub9cc\ub8cc \uc5f0\ub3c4 \uc785\ub825\ub780","creditCard.encryptedSecurityCode.aria.iframeTitle":"\uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedSecurityCode.aria.label":"\ubcf4\uc548 \ucf54\ub4dc \uc785\ub825\ub780","giftcard.encryptedCardNumber.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedCardNumber.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638 \uc785\ub825\ub780","giftcard.encryptedSecurityCode.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedSecurityCode.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \uc785\ub825\ub780",giftcardTransactionLimit:"\uc774 \uae30\ud504\ud2b8\uce74\ub4dc\ub85c \uac74\ub2f9 \uacb0\uc81c \uac00\ub2a5\ud55c \ucd5c\uace0 \uc561\uc218\ub294 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\uc740\ud589 \uacc4\uc88c \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankAccountNumber.aria.label":"\uc740\ud589 \uacc4\uc88c \uc785\ub825\ub780","ach.encryptedBankLocationId.aria.iframeTitle":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankLocationId.aria.label":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \uc785\ub825\ub780","twint.saved":"\uc800\uc7a5\ub428"}}),$k=Object.freeze({__proto__:null,default:{payButton:"Betaal","payButton.redirecting":"U wordt doorverwezen...",storeDetails:"Bewaar voor mijn volgende betaling","creditCard.holderName":"Naam op kaart","creditCard.holderName.placeholder":"J. Janssen","creditCard.holderName.invalid":"Ongeldige naam kaarthouder","creditCard.numberField.title":"Kaartnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Vervaldatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Maand","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jaar","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Onthouden voor de volgende keer","creditCard.cvcField.placeholder.4digits":"4 cijfers","creditCard.cvcField.placeholder.3digits":"3 cijfers","creditCard.taxNumber.placeholder":"JJMMDD / 0123456789",installments:"Aantal termijnen",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} maanden","installments.oneTime":"Eenmalige betaling","installments.installments":"Betaling termijnen","installments.revolving":"Terugkerende betaling","sepaDirectDebit.ibanField.invalid":"Ongeldig rekeningnummer","sepaDirectDebit.nameField.placeholder":"J. Janssen","sepa.ownerName":"Ten name van","sepa.ibanNumber":"Rekeningnummer (IBAN)","error.title":"Fout","error.subtitle.redirect":"Doorsturen niet gelukt","error.subtitle.payment":"Betaling is niet geslaagd","error.subtitle.refused":"Betaling geweigerd","error.message.unknown":"Er is een onbekende fout opgetreden","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Selecteer uw bank","creditCard.success":"Betaling geslaagd",loading:"Laden....",continue:"Doorgaan",continueTo:"Doorgaan naar","wechatpay.timetopay":"U heeft %@ om te betalen","wechatpay.scanqrcode":"QR-code scannen",personalDetails:"Persoonlijke gegevens",companyDetails:"Bedrijfsgegevens","companyDetails.name":"Bedrijfsnaam","companyDetails.registrationNumber":"Registratienummer",socialSecurityNumber:"Burgerservicenummer",firstName:"Voornaam",infix:"Voorvoegsel",lastName:"Achternaam",mobileNumber:"Telefoonnummer mobiel","mobileNumber.invalid":"Ongeldig mobiel nummer",city:"Stad",postalCode:"Postcode",countryCode:"Landcode",telephoneNumber:"Telefoonnummer",dateOfBirth:"Geboortedatum",shopperEmail:"E-mailadres",gender:"Geslacht",male:"Man",female:"Vrouw",billingAddress:"Factuuradres",street:"Straatnaam",stateOrProvince:"Staat of provincie",country:"Land",houseNumberOrName:"Huisnummer",separateDeliveryAddress:"Een afwijkend bezorgadres opgeven",deliveryAddress:"Bezorgadres",zipCode:"Postcode",apartmentSuite:"Appartement/Suite",provinceOrTerritory:"Provincie of territorium",cityTown:"Stad",address:"Adres",state:"Staat","field.title.optional":"(optioneel)","creditCard.cvcField.title.optional":"CVC / CVV (optioneel)","issuerList.wallet.placeholder":"Selecteer uw portemonnee",privacyPolicy:"Privacybeleid","afterPay.agreement":"Ik ga akkoord met de %@ van AfterPay",paymentConditions:"betalingsvoorwaarden",openApp:"Open de app","voucher.readInstructions":"Instructies lezen","voucher.introduction":"Bedankt voor uw aankoop. Gebruik deze coupon om uw betaling te voltooien.","voucher.expirationDate":"Vervaldatum","voucher.alternativeReference":"Alternatieve referentie","dragonpay.voucher.non.bank.selectField.placeholder":"Selecteer uw aanbieder","dragonpay.voucher.bank.selectField.placeholder":"Selecteer uw bank","voucher.paymentReferenceLabel":"Betalingsreferentie","voucher.surcharge":"Inclusief %@ toeslag","voucher.introduction.doku":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.shopperName":"Klantnaam","voucher.merchantName":"Verkoper","voucher.introduction.econtext":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.telephoneNumber":"Telefoonnummer","voucher.shopperReference":"Klant referentie","voucher.collectionInstitutionNumber":"Nummer ophaallocatie","voucher.econtext.telephoneNumber.invalid":"Het telefoonnummer moet uit 10 of 11 cijfers bestaan","boletobancario.btnLabel":"Boleto genereren","boleto.sendCopyToEmail":"Stuur een kopie naar mijn e-mailadres","button.copy":"Kopi\xebren","button.download":"Downloaden","creditCard.storedCard.description.ariaLabel":"Opgeslagen kaart eindigt op %@","voucher.entity":"Entiteit",donateButton:"Doneren",notNowButton:"Niet nu",thanksForYourSupport:"Bedankt voor uw donatie!",preauthorizeWith:"Preautorisatie uitvoeren met",confirmPreauthorization:"Preautorisatie bevestigen",confirmPurchase:"Aankoop bevestigen",applyGiftcard:"Inwisselen",giftcardBalance:"Saldo cadeaukaart",deductedBalance:"Afgetrokken bedrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Eerste twee cijfers van het wachtwoord van de kaart","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ongeldig wachtwoord","creditCard.taxNumber.label":"Geboortedatum (JJ-MM-DD) of bedrijfsregistratienummer (10 cijfers) van kaarthouder","creditCard.taxNumber.labelAlt":"Bedrijfsregistratienummer (10 cijfers)","creditCard.taxNumber.invalid":"Geboortedatum of bedrijfsregistratienummer van kaarthouder is ongeldig","storedPaymentMethod.disable.button":"Verwijderen","storedPaymentMethod.disable.confirmation":"Opgeslagen betalingsmethode verwijderen","storedPaymentMethod.disable.confirmButton":"Ja, verwijderen","storedPaymentMethod.disable.cancelButton":"Annuleren","ach.bankAccount":"Bankrekening","ach.accountHolderNameField.title":"Naam rekeninghouder","ach.accountHolderNameField.placeholder":"J. Janssen","ach.accountHolderNameField.invalid":"Ongeldige naam rekeninghouder","ach.accountNumberField.title":"Rekeningnummer","ach.accountNumberField.invalid":"Ongeldig rekeningnummer","ach.accountLocationField.title":"Routingnummer (ABA)","ach.accountLocationField.invalid":"Ongeldig routingnummer (ABA)","select.state":"Selecteer staat","select.stateOrProvince":"Selecteer staat of provincie","select.provinceOrTerritory":"Selecteer provincie of territorium","select.country":"Selecteer land","select.noOptionsFound":"Geen opties gevonden","select.filter.placeholder":"Zoeken...","telephoneNumber.invalid":"Ongeldig telefoonnummer",qrCodeOrApp:"of","paypal.processingPayment":"Betaling wordt verwerkt...",generateQRCode:"Genereer QR-code","await.waitForConfirmation":"Wacht op bevestiging","mbway.confirmPayment":"Bevestig uw betaling via de MB WAY-app","shopperEmail.invalid":"Ongeldig e-mailadres","dateOfBirth.format":"DD/MM/JJJJ","dateOfBirth.invalid":"U moet minimaal 18 jaar oud zijn","blik.confirmPayment":"Open uw bankapp om de betaling te bevestigen.","blik.invalid":"Voer 6 cijfers in","blik.code":"6-cijferige code","blik.help":"Haal de code op in uw bankapp.","swish.pendingMessage":"Nadat u hebt gescand, kan de status maximaal 10 minuten in behandeling zijn. Als u binnen deze periode opnieuw probeert te betalen, kunnen er meerdere keren kosten in rekening worden gebracht.","error.va.gen.01":"Onvolledig veld","error.va.gen.02":"Veld niet geldig","error.va.sf-cc-num.01":"Ongeldig kaartnummer","error.va.sf-cc-num.03":"Niet-ondersteunde kaart ingevoerd","error.va.sf-cc-dat.01":"Kaart te oud","error.va.sf-cc-dat.02":"Datum te ver in de toekomst","error.va.sf-cc-dat.03":"Uw kaart verloopt voor de betaaldatum","error.va.sf-ach-num.01":"Ongeldig rekeningnummer","error.va.sf-ach-loc.01":"Ongeldig routingnummer (ABA)","error.va.sf-kcp-pwd.01":"Ongeldig wachtwoord","error.giftcard.no-balance":"Deze cadeaukaart heeft geen saldo","error.giftcard.card-error":"We hebben geen cadeaukaart met dit nummer in onze administratie","error.giftcard.currency-error":"Cadeaukaarten zijn alleen geldig in de valuta waarin ze zijn uitgegeven","amazonpay.signout":"Afmelden bij Amazon","amazonpay.changePaymentDetails":"Betalingsgegevens wijzigen","partialPayment.warning":"Selecteer een andere betaalmethode om het resterende deel te betalen","partialPayment.remainingBalance":"Het resterende saldo is %{amount}","bankTransfer.beneficiary":"Begunstigde","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referentie","bankTransfer.introduction":"Ga door om een nieuwe overschrijving aan te maken. U kunt de gegevens in het volgende scherm gebruiken om deze betaling af te ronden.","bankTransfer.instructions":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","bacs.accountHolderName":"Naam bankrekeninghouder","bacs.accountHolderName.invalid":"Ongeldige naam bankrekeninghouder","bacs.accountNumber":"Bankrekeningnummer","bacs.accountNumber.invalid":"Ongeldig bankrekeningnummer","bacs.bankLocationId":"Bankcode","bacs.bankLocationId.invalid":"Ongeldige bankcode","bacs.consent.amount":"Ik ga ermee akkoord dat het bovengenoemde bedrag van mijn bankrekening wordt afgeschreven.","bacs.consent.account":"Ik bevestig dat de rekening op mijn naam staat en dat ik de enige ondertekenaar ben die toestemming kan geven voor automatische incasso's vanaf deze rekening.",edit:"Bewerken","bacs.confirm":"Bevestigen en betalen","bacs.result.introduction":"Download uw machtiging automatische incasso","download.pdf":"PDF downloaden","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd kaartnummer","creditCard.encryptedCardNumber.aria.label":"Veld voor kaartnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe voor vervaldatum beveiligde kaart","creditCard.encryptedExpiryDate.aria.label":"Veld voor vervaldatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe voor vervalmaand beveiligde kaart","creditCard.encryptedExpiryMonth.aria.label":"Veld voor vervalmaand","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe voor vervaljaar beveiligde kaart","creditCard.encryptedExpiryYear.aria.label":"Veld voor vervaljaar","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde kaart","creditCard.encryptedSecurityCode.aria.label":"Veld voor beveiligingscode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd cadeaubonnummer","giftcard.encryptedCardNumber.aria.label":"Veld voor cadeaubonnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde cadeaubon","giftcard.encryptedSecurityCode.aria.label":"Veld beveiligingscode cadeaubon",giftcardTransactionLimit:"Max. %{amount} toegestaan per transactie met deze cadeaubon","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe voor beveiligd bankrekeningnummer","ach.encryptedBankAccountNumber.aria.label":"Veld voor bankrekening","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe voor beveiligde BIC-code","ach.encryptedBankLocationId.aria.label":"Veld voor BIC-code","twint.saved":"opgeslagen"}}),Xk=Object.freeze({__proto__:null,default:{payButton:"Betal","payButton.redirecting":"Omdirigerer...",storeDetails:"Lagre til min neste betaling","creditCard.holderName":"Navn p\xe5 kortet","creditCard.holderName.placeholder":"O. Nordmann","creditCard.holderName.invalid":"Ugyldig navn p\xe5 kortholder","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utl\xf8psdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til neste gang","creditCard.cvcField.placeholder.4digits":"4 siffer","creditCard.cvcField.placeholder.3digits":"3 siffer","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Antall avdrag",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Avdragsbetaling","installments.revolving":"Gjentakende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldig kontonummer","sepaDirectDebit.nameField.placeholder":"O. Nordmann","sepa.ownerName":"Kortholders navn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Feil","error.subtitle.redirect":"Videresending feilet","error.subtitle.payment":"Betaling feilet","error.subtitle.refused":"Betaling avvist","error.message.unknown":"En ukjent feil oppstod","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Velg din bank","creditCard.success":"Betalingen var vellykket",loading:"Laster...",continue:"Fortsett",continueTo:"Fortsett til","wechatpay.timetopay":"Du har %@ igjen til \xe5 betale","wechatpay.scanqrcode":"Skann QR-kode",personalDetails:"Personopplysninger",companyDetails:"Firmadetaljer","companyDetails.name":"Firmanavn","companyDetails.registrationNumber":"Registreringsnummer",socialSecurityNumber:"Personnummer",firstName:"Fornavn",infix:"Prefiks",lastName:"Etternavn",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ugyldig mobilnummer",city:"Poststed",postalCode:"Postnummer",countryCode:"Landkode",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf8dselsdato",shopperEmail:"E-postadresse",gender:"Kj\xf8nn",male:"Mann",female:"Kvinne",billingAddress:"Faktureringsadresse",street:"Gate",stateOrProvince:"Fylke",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Spesifiser en separat leveringsadresse",deliveryAddress:"Leveringsadresse",zipCode:"Postnummer",apartmentSuite:"Leilighet/suite",provinceOrTerritory:"Provins eller territorium",cityTown:"By",address:"Adresse",state:"Delstat","field.title.optional":"(valgfritt)","creditCard.cvcField.title.optional":"CVC / CVV (valgfritt)","issuerList.wallet.placeholder":"Velg lommebok",privacyPolicy:"Retningslinjer for personvern","afterPay.agreement":"Jeg godtar AfterPays %@",paymentConditions:"betalingsbetingelser",openApp:"\xc5pne appen","voucher.readInstructions":"Les instruksjoner","voucher.introduction":"Takk for ditt kj\xf8p. Vennligst bruk den f\xf8lgende kupongen til \xe5 fullf\xf8re betalingen.","voucher.expirationDate":"Utl\xf8psdato","voucher.alternativeReference":"Alternativ referanse","dragonpay.voucher.non.bank.selectField.placeholder":"Velg din leverand\xf8r","dragonpay.voucher.bank.selectField.placeholder":"Velg din bank","voucher.paymentReferenceLabel":"Betalingsreferanse","voucher.surcharge":"Inkl. %@ tilleggsavgift","voucher.introduction.doku":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.shopperName":"Kundenavn","voucher.merchantName":"Forhandler","voucher.introduction.econtext":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundereferanse","voucher.collectionInstitutionNumber":"Innbetalingslokasjonsnummer","voucher.econtext.telephoneNumber.invalid":"Telefonnummeret m\xe5 v\xe6re 10 eller 11 sifre langt","boletobancario.btnLabel":"Generer Boleto","boleto.sendCopyToEmail":"Send meg en kopi p\xe5 e-post","button.copy":"Kopier","button.download":"Last ned","creditCard.storedCard.description.ariaLabel":"Lagret kort slutter p\xe5 %@","voucher.entity":"Enhet",donateButton:"Don\xe9r",notNowButton:"Ikke n\xe5",thanksForYourSupport:"Takk for din st\xf8tte!",preauthorizeWith:"Forh\xe5ndsgodkjenn med",confirmPreauthorization:"Bekreft forh\xe5ndsgodkjenning",confirmPurchase:"Bekreft kj\xf8p",applyGiftcard:"L\xf8s inn",giftcardBalance:"Gavekortsaldo",deductedBalance:"Fratrukket bel\xf8p","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"F\xf8rste 2 sifre av kortpassord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig passord","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (YYMMDD) eller bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.labelAlt":"Bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.invalid":"Ugyldig kortholders f\xf8dselsdato eller bedriftsregistreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern lagret betalingsmetode","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoholders navn","ach.accountHolderNameField.placeholder":"O. Nordmann","ach.accountHolderNameField.invalid":"Ugyldig navn p\xe5 kontoholder","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldig kontonummer","ach.accountLocationField.title":"ABA-dirigeringsnummer","ach.accountLocationField.invalid":"Ugyldig ABA-dirigeringsnummer","select.state":"Velg delstat","select.stateOrProvince":"Velg delstat eller provins","select.provinceOrTerritory":"Velg provins eller territorium","select.country":"Velg land","select.noOptionsFound":"Ingen alternativer funnet","select.filter.placeholder":"S\xf8k\xa0\u2026","telephoneNumber.invalid":"Ugyldig telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandler betaling \u2026",generateQRCode:"Generer QR-kode","await.waitForConfirmation":"Venter p\xe5 bekreftelse","mbway.confirmPayment":"Bekreft betalingen din i MB WAY-appen","shopperEmail.invalid":"Ugyldig e-postadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5 v\xe6re minst 18 \xe5r gammel","blik.confirmPayment":"\xc5pne bank-appen din for \xe5 bekrefte betalingen.","blik.invalid":"Tast inn 6 tall","blik.code":"6-sifret kode","blik.help":"Hent koden fra bank-appen din.","swish.pendingMessage":"Etter at du har skannet koden kan det ta opptil 10 minutter f\xf8r betalingen vises som bekreftet. Fors\xf8k p\xe5 \xe5 betale igjen kan f\xf8re til flere innbetalinger.","error.va.gen.01":"Ufullstendig felt","error.va.gen.02":"Feltet er ikke gyldig","error.va.sf-cc-num.01":"Ugyldig kortnummer","error.va.sf-cc-num.03":"Det angitte kortet st\xf8ttes ikke","error.va.sf-cc-dat.01":"Kortet er for gammelt","error.va.sf-cc-dat.02":"Datoen er for langt inn i fremtiden","error.va.sf-cc-dat.03":"Kortet ditt utl\xf8per f\xf8r betalingsdatoen","error.va.sf-ach-num.01":"Ugyldig kontonummer","error.va.sf-ach-loc.01":"Ugyldig ABA-dirigeringsnummer","error.va.sf-kcp-pwd.01":"Ugyldig passord","error.giftcard.no-balance":"Dette gavekortet har en saldo p\xe5 null","error.giftcard.card-error":"Vi har ikke noe gavekort med dette nummeret i registrene v\xe5re","error.giftcard.currency-error":"Gavekort er kun gyldige i den valutaen de ble utstedt i","amazonpay.signout":"Logg ut av Amazon","amazonpay.changePaymentDetails":"Endre betalingsdetaljer","partialPayment.warning":"Velg en annen betalingsmetode for \xe5 betale det gjenv\xe6rende","partialPayment.remainingBalance":"Gjenv\xe6rende saldo vil v\xe6re %{amount}","bankTransfer.beneficiary":"Mottaker","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referanse","bankTransfer.introduction":"Fortsett for \xe5 opprette en ny betaling via bankoverf\xf8ring. Du kan bruke detaljene i det f\xf8lgende skjermbildet for \xe5 fullf\xf8re betalingen.","bankTransfer.instructions":"Takk for kj\xf8pet. Vennligst benytt den f\xf8lgende informasjonen til \xe5 fullf\xf8re betalingen.","bacs.accountHolderName":"Kontoholders navn","bacs.accountHolderName.invalid":"Ugyldig kontoholdernavn","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldig bankkontonummer","bacs.bankLocationId":"Sorteringskode","bacs.bankLocationId.invalid":"Ugyldig sorteringskode","bacs.consent.amount":"Jeg samtykker til at bel\xf8pet ovenfor blir trukket fra bankkontoen min.","bacs.consent.account":"Jeg bekrefter at kontoen st\xe5r i mitt navn, og at jeg er den eneste signataren som kreves for \xe5 autorisere direktebelastningen p\xe5 denne kontoen.",edit:"Endre","bacs.confirm":"Bekreft og betal","bacs.result.introduction":"Last ned instruksjoner for direktebelastning (DDI/ mandat)","download.pdf":"Last ned PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummerfelt","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for sikret kortutl\xf8psdato","creditCard.encryptedExpiryDate.aria.label":"Felt for utl\xf8psdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for sikret kortutl\xf8psm\xe5ned","creditCard.encryptedExpiryMonth.aria.label":"Felt for utl\xf8psm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for sikret kortutl\xf8ps\xe5r","creditCard.encryptedExpiryYear.aria.label":"Felt for utl\xf8ps\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret kortsikkerhetskode","creditCard.encryptedSecurityCode.aria.label":"Felt for sikkerhetskode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret gavekortnummer","giftcard.encryptedCardNumber.aria.label":"Felt for gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret gavekort-sikkerhetskode","giftcard.encryptedSecurityCode.aria.label":"Felt for sikkerhetskode for gavekort",giftcardTransactionLimit:"Maksimalt %{amount} per transaksjon er tillatt p\xe5 dette gavekortet","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Bankkontofelt","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for sikret bankdirigeringsnummer","ach.encryptedBankLocationId.aria.label":"Felt for bankdirigeringsnummer","twint.saved":"lagret"}}),eC=Object.freeze({__proto__:null,default:{payButton:"Zap\u0142a\u0107","payButton.redirecting":"Przekierowywanie...",storeDetails:"Zapisz na potrzeby nast\u0119pnej p\u0142atno\u015bci","creditCard.holderName":"Imi\u0119 i nazwisko na karcie","creditCard.holderName.placeholder":"J. Kowalski","creditCard.holderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza karty","creditCard.numberField.title":"Numer karty ","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data wa\u017cno\u015bci","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Miesi\u0105c","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapami\u0119taj na przysz\u0142o\u015b\u0107","creditCard.cvcField.placeholder.4digits":"4 cyfry","creditCard.cvcField.placeholder.3digits":"3 cyfry","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789",installments:"Liczba rat",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} miesi\u0119cy","installments.oneTime":"P\u0142atno\u015b\u0107 jednorazowa","installments.installments":"P\u0142atno\u015b\u0107 ratalna","installments.revolving":"P\u0142atno\u015b\u0107 odnawialna","sepaDirectDebit.ibanField.invalid":"Nieprawid\u0142owy numer rachunku","sepaDirectDebit.nameField.placeholder":"J. Kowalski","sepa.ownerName":"Imi\u0119 i nazwisko posiadacza karty","sepa.ibanNumber":"Numer rachunku (IBAN)","error.title":"B\u0142\u0105d","error.subtitle.redirect":"Przekierowanie nie powiod\u0142o si\u0119","error.subtitle.payment":"P\u0142atno\u015b\u0107 nie powiod\u0142a si\u0119","error.subtitle.refused":"P\u0142atno\u015b\u0107 zosta\u0142a odrzucona","error.message.unknown":"Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Wybierz sw\xf3j bank","creditCard.success":"P\u0142atno\u015b\u0107 zako\u0144czona sukcesem",loading:"\u0141adowanie...",continue:"Kontynuuj",continueTo:"Przejd\u017a do","wechatpay.timetopay":"Masz do zap\u0142acenia %@","wechatpay.scanqrcode":"Zeskanuj kod QR",personalDetails:"Dane osobowe",companyDetails:"Dane firmy","companyDetails.name":"Nazwa firmy","companyDetails.registrationNumber":"Numer w rejestrze",socialSecurityNumber:"Numer dowodu osobistego",firstName:"Imi\u0119",infix:"Prefiks",lastName:"Nazwisko",mobileNumber:"Numer telefonu kom\xf3rkowego","mobileNumber.invalid":"Nieprawid\u0142owy numer telefonu kom\xf3rkowego",city:"Miasto",postalCode:"Kod pocztowy",countryCode:"Kod kraju",telephoneNumber:"Numer telefonu",dateOfBirth:"Data urodzenia",shopperEmail:"Adres e-mail",gender:"P\u0142e\u0107",male:"M\u0119\u017cczyzna",female:"Kobieta",billingAddress:"Adres rozliczeniowy",street:"Ulica",stateOrProvince:"Wojew\xf3dztwo",country:"Kraj",houseNumberOrName:"Numer domu i mieszkania",separateDeliveryAddress:"Podaj osobny adres dostawy",deliveryAddress:"Adres dostawy",zipCode:"Kod pocztowy",apartmentSuite:"Numer domu/mieszkania",provinceOrTerritory:"Region lub terytorium",cityTown:"Miejscowo\u015b\u0107",address:"Adres",state:"Stan","field.title.optional":"(opcjonalnie)","creditCard.cvcField.title.optional":"CVC / CVV (opcjonalnie)","issuerList.wallet.placeholder":"Wybierz sw\xf3j portfel",privacyPolicy:"Polityka prywatno\u015bci.","afterPay.agreement":"Zgadzam si\u0119 z dokumentem %@ AfterPay",paymentConditions:"warunki p\u0142atno\u015bci",openApp:"Otw\xf3rz aplikacj\u0119","voucher.readInstructions":"Przeczytaj instrukcje","voucher.introduction":"Dzi\u0119kujemy za zakup, doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu tego kuponu.","voucher.expirationDate":"Data wa\u017cno\u015bci","voucher.alternativeReference":"Dodatkowy numer referencyjny","dragonpay.voucher.non.bank.selectField.placeholder":"Wybierz dostawc\u0119","dragonpay.voucher.bank.selectField.placeholder":"Wybierz sw\xf3j bank","voucher.paymentReferenceLabel":"Nr referencyjny p\u0142atno\u015bci","voucher.surcharge":"Zawiera %@ op\u0142aty dodatkowej","voucher.introduction.doku":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.shopperName":"Imi\u0119 i nazwisko klienta","voucher.merchantName":"Sprzedaj\u0105cy","voucher.introduction.econtext":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.telephoneNumber":"Numer telefonu","voucher.shopperReference":"Dane referencyjne kupuj\u0105cych","voucher.collectionInstitutionNumber":"Numer instytucji pobieraj\u0105cej op\u0142at\u0119","voucher.econtext.telephoneNumber.invalid":"Numer telefonu musi mie\u0107 10 lub 11 cyfr","boletobancario.btnLabel":"Wygeneruj p\u0142atno\u015b\u0107 Boleto","boleto.sendCopyToEmail":"Wy\u015blij kopi\u0119 na m\xf3j e-mail","button.copy":"Kopiuj","button.download":"Pobierz","creditCard.storedCard.description.ariaLabel":"Zapisana karta ko\u0144czy si\u0119 na % @","voucher.entity":"Pozycja",donateButton:"Przeka\u017c darowizn\u0119",notNowButton:"Nie teraz",thanksForYourSupport:"Dzi\u0119kujemy za wsparcie!",preauthorizeWith:"Autoryzuj wst\u0119pnie za pomoc\u0105:",confirmPreauthorization:"Potwierd\u017a autoryzacj\u0119 wst\u0119pn\u0105",confirmPurchase:"Potwierd\u017a zakup",applyGiftcard:"Wykorzystaj",giftcardBalance:"Saldo karty podarunkowej",deductedBalance:"Saldo potr\u0105cone","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Pierwsze 2 cyfry has\u0142a karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Nieprawid\u0142owe has\u0142o","creditCard.taxNumber.label":"Data urodzenia posiadacza karty (RRMMDD) lub firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.labelAlt":"Firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.invalid":"Nieprawid\u0142owa data urodzenia posiadacza karty lub nieprawid\u0142owy firmowy numer rejestracyjny","storedPaymentMethod.disable.button":"Usu\u0144","storedPaymentMethod.disable.confirmation":"Usu\u0144 zapisan\u0105 metod\u0119 p\u0142atno\u015bci","storedPaymentMethod.disable.confirmButton":"Tak, usu\u0144","storedPaymentMethod.disable.cancelButton":"Anuluj","ach.bankAccount":"Rachunek bankowy","ach.accountHolderNameField.title":"Imi\u0119 i nazwisko posiadacza rachunku","ach.accountHolderNameField.placeholder":"J. Kowalski","ach.accountHolderNameField.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","ach.accountNumberField.title":"Numer rachunku","ach.accountNumberField.invalid":"Nieprawid\u0142owy numer rachunku","ach.accountLocationField.title":"Kod bankowy ABA Routing Number","ach.accountLocationField.invalid":"Nieprawid\u0142owy kod bankowy ABA Routing Number","select.state":"Wybierz stan","select.stateOrProvince":"Wybierz stan/wojew\xf3dztwo","select.provinceOrTerritory":"Wybierz region/terytorium","select.country":"Wybierz kraj","select.noOptionsFound":"Nie znaleziono opcji","select.filter.placeholder":"Szukaj...","telephoneNumber.invalid":"Nieprawid\u0142owy numer telefonu",qrCodeOrApp:"lub","paypal.processingPayment":"Przetwarzanie p\u0142atno\u015bci...",generateQRCode:"Wygeneruj kod QR","await.waitForConfirmation":"Oczekiwanie na potwierdzenie","mbway.confirmPayment":"Potwierd\u017a p\u0142atno\u015b\u0107 w aplikacji MB WAY","shopperEmail.invalid":"Niepoprawny adres email","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Musisz mie\u0107 co najmniej 18 lat","blik.confirmPayment":"Otw\xf3rz aplikacj\u0119 bankow\u0105, aby potwierdzi\u0107 p\u0142atno\u015b\u0107.","blik.invalid":"Wpisz 6 cyfr","blik.code":"6-cyfrowy kod","blik.help":"Uzyskaj kod ze swojej aplikacji bankowej.","swish.pendingMessage":"Po zeskanowaniu transakcja mo\u017ce mie\u0107 status \u201eOczekuj\u0105ca\u201d do 10 minut. Pr\xf3ba ponownego dokonania p\u0142atno\u015bci w tym czasie mo\u017ce spowodowa\u0107 wielokrotne naliczenie op\u0142aty.","error.va.gen.01":"Niekompletne dane w polu","error.va.gen.02":"Dane w polu s\u0105 nieprawid\u0142owe","error.va.sf-cc-num.01":"Nieprawid\u0142owy numer karty","error.va.sf-cc-num.03":"Wprowadzono nieobs\u0142ugiwan\u0105 kart\u0119","error.va.sf-cc-dat.01":"Termin wa\u017cno\u015bci karty min\u0105\u0142","error.va.sf-cc-dat.02":"Data w zbyt odleg\u0142ej przysz\u0142o\u015bci","error.va.sf-cc-dat.03":"Twoja karta traci wa\u017cno\u015b\u0107 przed dat\u0105 p\u0142atno\u015bci","error.va.sf-ach-num.01":"Nieprawid\u0142owy numer rachunku","error.va.sf-ach-loc.01":"Nieprawid\u0142owy kod bankowy ABA Routing Number","error.va.sf-kcp-pwd.01":"Nieprawid\u0142owe has\u0142o","error.giftcard.no-balance":"Saldo karty podarunkowej jest puste","error.giftcard.card-error":"W naszych rejestrach nie ma karty podarunkowej o tym numerze","error.giftcard.currency-error":"Karty podarunkowe s\u0105 wa\u017cne tylko w walucie, w kt\xf3rej zosta\u0142y wydane","amazonpay.signout":"Wyloguj si\u0119 z Amazon","amazonpay.changePaymentDetails":"Zmie\u0144 szczeg\xf3\u0142y p\u0142atno\u015bci","partialPayment.warning":"Wybierz inn\u0105 metod\u0119 p\u0142atno\u015bci, aby zap\u0142aci\u0107 pozosta\u0142\u0105 kwot\u0119","partialPayment.remainingBalance":"Pozosta\u0142e saldo wynosi %{kwota}","bankTransfer.beneficiary":"Beneficjent","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Ref. sprze.","bankTransfer.introduction":"Kontynuuj tworzenie nowej p\u0142atno\u015bci przelewem bankowym. Mo\u017cesz u\u017cy\u0107 szczeg\xf3\u0142\xf3w na nast\u0119pnym ekranie, aby sfinalizowa\u0107 t\u0119 p\u0142atno\u015b\u0107.","bankTransfer.instructions":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","bacs.accountHolderName":"Imi\u0119 i nazwisko posiadacza rachunku","bacs.accountHolderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","bacs.accountNumber":"Numer rachunku","bacs.accountNumber.invalid":"Nieprawid\u0142owy numer rachunku","bacs.bankLocationId":"Numer rozliczeniowy SORT","bacs.bankLocationId.invalid":"Nieprawid\u0142owy numer rozliczeniowy SORT","bacs.consent.amount":"Wyra\u017cam zgod\u0119 na pobranie powy\u017cszej kwoty z mojego rachunku bankowego.","bacs.consent.account":"Potwierdzam, \u017ce konto jest zarejestrowane na moje nazwisko i jestem jedynym sygnatariuszem wymaganym do autoryzacji polecenia zap\u0142aty na tym koncie.",edit:"Edytuj","bacs.confirm":"Potwierd\u017a i zap\u0142a\u0107","bacs.result.introduction":"Pobierz dyspozycj\u0119 polecenia zap\u0142aty (DDI/upowa\u017cnienie)","download.pdf":"Pobierz PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty","creditCard.encryptedCardNumber.aria.label":"Pole numeru karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Element Iframe dla daty wa\u017cno\u015bci zabezpieczonej karty","creditCard.encryptedExpiryDate.aria.label":"Pole daty wa\u017cno\u015bci","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Element Iframe dla miesi\u0105ca wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryMonth.aria.label":"Pole miesi\u0105ca wyga\u015bni\u0119cia","creditCard.encryptedExpiryYear.aria.iframeTitle":"Element Iframe dla roku wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryYear.aria.label":"Pole roku wyga\u015bni\u0119cia","creditCard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty","creditCard.encryptedSecurityCode.aria.label":"Pole kodu bezpiecze\u0144stwa","giftcard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty podarunkowej","giftcard.encryptedCardNumber.aria.label":"Pole numeru karty podarunkowej","giftcard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty podarunkowej","giftcard.encryptedSecurityCode.aria.label":"Pole kodu bezpiecze\u0144stwa karty podarunkowej",giftcardTransactionLimit:"Maks. dozwolona kwota (%{amount}) na transakcj\u0119 t\u0105 kart\u0105 upominkow\u0105","ach.encryptedBankAccountNumber.aria.iframeTitle":"Element Iframe dla zabezpieczonego numeru rachunku bankowego","ach.encryptedBankAccountNumber.aria.label":"Pole rachunku bankowego","ach.encryptedBankLocationId.aria.iframeTitle":"Element Iframe dla zabezpieczonego kodu bankowego (Bank Routing Number)","ach.encryptedBankLocationId.aria.label":"Pole kodu bankowego (Bank Routing Number)","twint.saved":"zapisano"}}),tC=Object.freeze({__proto__:null,default:{payButton:"Pagar","payButton.redirecting":"Redirecionando...",storeDetails:"Salvar para meu pr\xf3ximo pagamento","creditCard.holderName":"Nome no cart\xe3o","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome do titular do cart\xe3o inv\xe1lido","creditCard.numberField.title":"N\xfamero do cart\xe3o","creditCard.expiryDateField.title":"Data de validade","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"M\xeas","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ano","creditCard.cvcField.title":"CVC/CVV","creditCard.storeDetailsButton":"Lembrar para a pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAAMMDD / 0123456789",installments:"Op\xe7\xf5es de Parcelamento",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} meses","installments.oneTime":"Pagamento \xe0 vista","installments.installments":"Pagamento parcelado","installments.revolving":"Pagamento rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de conta inv\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Silva","sepa.ownerName":"Nome do titular\xa0da conta banc\xe1ria","sepa.ibanNumber":"N\xfamero de conta (NIB)","error.title":"Erro","error.subtitle.redirect":"Falha no redirecionamento","error.subtitle.payment":"Falha no pagamento","error.subtitle.refused":"Pagamento recusado","error.message.unknown":"Ocorreu um erro desconhecido","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Selecione seu banco","creditCard.success":"Pagamento bem-sucedido",loading:"Carregando...",continue:"Continuar",continueTo:"Continuar para","wechatpay.timetopay":"Voc\xea tem %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR",personalDetails:"Informa\xe7\xf5es pessoais",companyDetails:"Dados da empresa","companyDetails.name":"Nome da empresa","companyDetails.registrationNumber":"N\xfamero de registro",socialSecurityNumber:"CPF",firstName:"Nome",infix:"Prefixo",lastName:"Sobrenome",mobileNumber:"Celular","mobileNumber.invalid":"N\xfamero de celular inv\xe1lido",city:"Cidade",postalCode:"CEP",countryCode:"C\xf3digo do pa\xeds",telephoneNumber:"N\xfamero de telefone",dateOfBirth:"Data de nascimento",shopperEmail:"Endere\xe7o de e-mail",gender:"G\xeanero",male:"Masculino",female:"Feminino",billingAddress:"Endere\xe7o de cobran\xe7a",street:"Rua",stateOrProvince:"Estado ou prov\xedncia",country:"Pa\xeds",houseNumberOrName:"N\xfamero da casa",separateDeliveryAddress:"Especificar um endere\xe7o de entrega separado",deliveryAddress:"Endere\xe7o de entrega",zipCode:"C\xf3digo postal",apartmentSuite:"Apartamento/Conjunto",provinceOrTerritory:"Prov\xedncia ou territ\xf3rio",cityTown:"Cidade",address:"Endere\xe7o",state:"Estado","field.title.optional":"(opcional)","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Selecione uma carteira",privacyPolicy:"Pol\xedtica de Privacidade","afterPay.agreement":"Eu concordo com as %@ do AfterPay",paymentConditions:"condi\xe7\xf5es de pagamento",openApp:"Abrir o aplicativo","voucher.readInstructions":"Leia as instru\xe7\xf5es","voucher.introduction":"Obrigado pela sua compra, use o cupom a seguir para concluir o seu pagamento.","voucher.expirationDate":"Data de validade","voucher.alternativeReference":"Refer\xeancia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Selecione o seu fornecedor","dragonpay.voucher.bank.selectField.placeholder":"Selecione seu banco","voucher.paymentReferenceLabel":"Refer\xeancia de pagamento","voucher.surcharge":"Inclui %@ de sobretaxa","voucher.introduction.doku":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.shopperName":"Nome do consumidor","voucher.merchantName":"Comerciante online","voucher.introduction.econtext":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.telephoneNumber":"N\xfamero de telefone","voucher.shopperReference":"Refer\xeancia do consumidor","voucher.collectionInstitutionNumber":"N\xfamero da institui\xe7\xe3o de cobran\xe7a","voucher.econtext.telephoneNumber.invalid":"O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos","boletobancario.btnLabel":"Gerar Boleto","boleto.sendCopyToEmail":"Enviar uma c\xf3pia por e-mail","button.copy":"Copiar","button.download":"Baixar","creditCard.storedCard.description.ariaLabel":"O cart\xe3o armazenado termina em %@","voucher.entity":"Entidade",donateButton:"Doar",notNowButton:"Agora n\xe3o",thanksForYourSupport:"Obrigado pelo apoio!",preauthorizeWith:"Pr\xe9-autorizar com",confirmPreauthorization:"Confirmar pr\xe9-autoriza\xe7\xe3o",confirmPurchase:"Confirmar compra",applyGiftcard:"Resgatar",giftcardBalance:"Saldo do vale-presente",deductedBalance:"Saldo debitado","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Primeiros dois d\xedgitos da senha do cart\xe3o","creditCard.encryptedPassword.invalid":"Senha inv\xe1lida","creditCard.taxNumber.label":"Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.invalid":"Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo inv\xe1lidos","storedPaymentMethod.disable.button":"Remover","storedPaymentMethod.disable.confirmation":"Remover m\xe9todo de pagamento armazenado","storedPaymentMethod.disable.confirmButton":"Sim, remover","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Conta banc\xe1ria","ach.accountHolderNameField.title":"Nome do titular da conta","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome do titular da conta inv\xe1lido","ach.accountNumberField.title":"N\xfamero da conta","ach.accountNumberField.invalid":"N\xfamero de conta inv\xe1lido","ach.accountLocationField.title":"N\xfamero de roteamento ABA","ach.accountLocationField.invalid":"N\xfamero de roteamento ABA inv\xe1lido","select.state":"Selecionar estado","select.stateOrProvince":"Selecione estado ou prov\xedncia","select.provinceOrTerritory":"Selecionar prov\xedncia ou territ\xf3rio","select.country":"Selecione o pa\xeds","select.noOptionsFound":"Nenhuma op\xe7\xe3o encontrada","select.filter.placeholder":"Pesquisar...","telephoneNumber.invalid":"N\xfamero de telefone inv\xe1lido",qrCodeOrApp:"ou","paypal.processingPayment":"Processando pagamento...",generateQRCode:"Gerar c\xf3digo QR","await.waitForConfirmation":"Aguardando confirma\xe7\xe3o","mbway.confirmPayment":"Confirme seu pagamento no aplicativo MB WAY","shopperEmail.invalid":"Endere\xe7o de e-mail inv\xe1lido","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Voc\xea deve ter pelo menos 18 anos","blik.confirmPayment":"Abra o aplicativo do seu banco para confirmar o pagamento.","blik.invalid":"Digite 6 n\xfameros","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Obtenha o c\xf3digo no aplicativo do seu banco.","swish.pendingMessage":"Depois de escanear o QR, o status pode ficar pendente por at\xe9 10 minutos. N\xe3o tente refazer o pagamento antes desse per\xedodo para evitar cobran\xe7a duplicada.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo inv\xe1lido","error.va.sf-cc-num.01":"N\xfamero de cart\xe3o inv\xe1lido","error.va.sf-cc-num.03":"O cart\xe3o inserido n\xe3o \xe9 aceito","error.va.sf-cc-dat.01":"Cart\xe3o muito antigo","error.va.sf-cc-dat.02":"Data muito distante","error.va.sf-cc-dat.03":"Seu cart\xe3o expira antes da data do pagamento","error.va.sf-ach-num.01":"N\xfamero de conta inv\xe1lido","error.va.sf-ach-loc.01":"N\xfamero de roteamento ABA inv\xe1lido","error.va.sf-kcp-pwd.01":"Senha inv\xe1lida","error.giftcard.no-balance":"Este vale-presente tem saldo zero","error.giftcard.card-error":"N\xe3o existe um vale-presente com esse n\xfamero em nossos registros","error.giftcard.currency-error":"Os vales-presente s\xe3o v\xe1lidos somente na moeda em que foram emitidos","amazonpay.signout":"Sair do Amazon","amazonpay.changePaymentDetails":"Alterar dados de pagamento","partialPayment.warning":"Selecione outro m\xe9todo de pagamento para pagar o restante","partialPayment.remainingBalance":"O saldo restante ser\xe1 %{amount}","bankTransfer.beneficiary":"Benefici\xe1rio","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Refer\xeancia","bankTransfer.introduction":"Continue criando o novo pagamento por transfer\xeancia banc\xe1ria. Use as informa\xe7\xf5es na tela a seguir para conclu\xed-lo.","bankTransfer.instructions":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","bacs.accountHolderName":"Nome do titular da conta banc\xe1ria","bacs.accountHolderName.invalid":"Nome do titular da conta banc\xe1ria inv\xe1lido","bacs.accountNumber":"N\xfamero da conta banc\xe1ria","bacs.accountNumber.invalid":"N\xfamero da conta banc\xe1ria inv\xe1lido","bacs.bankLocationId":"C\xf3digo de classifica\xe7\xe3o","bacs.bankLocationId.invalid":"C\xf3digo de classifica\xe7\xe3o inv\xe1lido","bacs.consent.amount":"Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.","bacs.consent.account":"Confirmo que a conta est\xe1 em meu nome e que sou o \xfanico signat\xe1rio que deve autorizar o d\xe9bito direto nessa conta.",edit:"Editar","bacs.confirm":"Confirmar e pagar","bacs.result.introduction":"Baixar instru\xe7\xe3o de d\xe9bito direto (DDI)","download.pdf":"Baixar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o seguro","creditCard.encryptedCardNumber.aria.label":"Campo de n\xfamero de cart\xe3o","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe para data de validade do cart\xe3o seguro","creditCard.encryptedExpiryDate.aria.label":"Campo de data de validade","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe para m\xeas de validade do cart\xe3o seguro","creditCard.encryptedExpiryMonth.aria.label":"Campo de m\xeas de validade","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe para ano de validade do cart\xe3o seguro","creditCard.encryptedExpiryYear.aria.label":"Campo de ano de validade","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o seguro","creditCard.encryptedSecurityCode.aria.label":"Campo de c\xf3digo de seguran\xe7a","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o-presente seguro","giftcard.encryptedCardNumber.aria.label":"Campo de n\xfamero do cart\xe3o-presente","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o-presente seguro","giftcard.encryptedSecurityCode.aria.label":"Campo de c\xf3digo de seguran\xe7a do cart\xe3o-presente",giftcardTransactionLimit:"M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o-presente","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe para n\xfamero de conta banc\xe1ria segura","ach.encryptedBankAccountNumber.aria.label":"Campo de conta banc\xe1ria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe para n\xfamero de roteamento banc\xe1rio seguro","ach.encryptedBankLocationId.aria.label":"Campo de n\xfamero de roteamento banc\xe1rio","pix.instructions":"Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code ou copie e cole o c\xf3digo","twint.saved":"salvo"}}),rC=Object.freeze({__proto__:null,default:{payButton:"Pl\u0103ti\u021bi","payButton.redirecting":"Se redirec\u021bioneaz\u0103...",storeDetails:"Salveaz\u0103 pentru urm\u0103toarea mea plat\u0103","creditCard.holderName":"Numele de pe card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Numele posesorului de card este incorect","creditCard.numberField.title":"Num\u0103r card","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data expir\u0103rii","creditCard.expiryDateField.placeholder":"LL/AA","creditCard.expiryDateField.month":"Lun\u0103","creditCard.expiryDateField.month.placeholder":"LL","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"An","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Re\u021bine pentru data viitoare","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AALLZZ / 0123456789",installments:"Num\u0103r de rate",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} luni","installments.oneTime":"Plat\u0103 unic\u0103","installments.installments":"Plat\u0103 \xeen rate","installments.revolving":"Plat\u0103 recurent\u0103","sepaDirectDebit.ibanField.invalid":"Num\u0103rul de cont este incorect","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nume posesor","sepa.ibanNumber":"Num\u0103r cont (IBAN)","error.title":"Eroare","error.subtitle.redirect":"Redirec\u021bionare e\u0219uat\u0103","error.subtitle.payment":"Plat\u0103 e\u0219uat\u0103","error.subtitle.refused":"Plat\u0103 refuzat\u0103","error.message.unknown":"S-a produs o eroare necunoscut\u0103","idealIssuer.selectField.title":"Banc\u0103","idealIssuer.selectField.placeholder":"Selecta\u021bi-v\u0103 banca","creditCard.success":"Plat\u0103 reu\u0219it\u0103",loading:"Se \xeencarc\u0103...",continue:"Continuare",continueTo:"Continua\u021bi c\u0103tre","wechatpay.timetopay":"Trebuie s\u0103 achita\u021bi %@","wechatpay.scanqrcode":"Scana\u021bi codul QR",personalDetails:"Informa\u021bii personale",companyDetails:"Informa\u021bii societate","companyDetails.name":"Denumirea societ\u0103\u021bii","companyDetails.registrationNumber":"Num\u0103r de \xeenregistrare",socialSecurityNumber:"Cod numeric personal",firstName:"Prenume",infix:"Titulatur\u0103",lastName:"Nume de familie",mobileNumber:"Num\u0103r de mobil","mobileNumber.invalid":"Num\u0103r de telefon mobil incorect",city:"Ora\u0219",postalCode:"Cod po\u0219tal",countryCode:"Codul \u021b\u0103rii",telephoneNumber:"Num\u0103r de telefon",dateOfBirth:"Data na\u0219terii",shopperEmail:"Adres\u0103 de e-mail",gender:"Gen",male:"B\u0103rbat",female:"Femeie",billingAddress:"Adresa de facturare",street:"Strada",stateOrProvince:"Jude\u021b sau provincie",country:"\u021aar\u0103",houseNumberOrName:"Num\u0103r",separateDeliveryAddress:"Specifica\u021bi o adres\u0103 de livrare separat\u0103",deliveryAddress:"Adres\u0103 de livrare",zipCode:"Cod po\u0219tal",apartmentSuite:"Apartament",provinceOrTerritory:"Provincie sau teritoriu",cityTown:"Ora\u0219/localitate",address:"Adres\u0103",state:"Stat","field.title.optional":"(op\u021bional)","creditCard.cvcField.title.optional":"CVC/CVV (op\u021bional)","issuerList.wallet.placeholder":"Selecta\u021bi-v\u0103 portofelul",privacyPolicy:"Politica de confiden\u021bialitate","afterPay.agreement":"Sunt de acord cu %@ apar\u021bin\xe2nd AfterPay",paymentConditions:"condi\u021bii de plat\u0103",openApp:"Deschide\u021bi aplica\u021bia","voucher.readInstructions":"Citi\u021bi instruc\u021biunile","voucher.introduction":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103torul cupon pentru a v\u0103 finaliza plata.","voucher.expirationDate":"Data de expirare","voucher.alternativeReference":"Referin\u021b\u0103 alternativ\u0103","dragonpay.voucher.non.bank.selectField.placeholder":"Selecta\u021bi furnizorul dvs.","dragonpay.voucher.bank.selectField.placeholder":"Selecta\u021bi banca dvs.","voucher.paymentReferenceLabel":"Referin\u021ba pl\u0103\u021bii","voucher.surcharge":"Include suprataxa de %@","voucher.introduction.doku":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.shopperName":"Nume cump\u0103r\u0103tor","voucher.merchantName":"Comerciant","voucher.introduction.econtext":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.telephoneNumber":"Num\u0103r de telefon","voucher.shopperReference":"Referin\u021b\u0103 cump\u0103r\u0103tor","voucher.collectionInstitutionNumber":"Num\u0103r institu\u021bie de colectare","voucher.econtext.telephoneNumber.invalid":"Num\u0103rul de telefon trebuie s\u0103 aib\u0103 10 sau 11 cifre","boletobancario.btnLabel":"Generare Boleto","boleto.sendCopyToEmail":"Trimite o copie la adresa mea de e-mail","button.copy":"Copiere","button.download":"Desc\u0103rcare","creditCard.storedCard.description.ariaLabel":"Cardul memorat se termin\u0103 \xeen %@","voucher.entity":"Entitate",donateButton:"Dona\u021bi",notNowButton:"Nu acum",thanksForYourSupport:"V\u0103 mul\u021bumim pentru sprijin!",preauthorizeWith:"Preautorizare cu",confirmPreauthorization:"Confirma\u021bi preautorizarea",confirmPurchase:"Confirma\u021bi achizi\u021bia",applyGiftcard:"Valorificare",giftcardBalance:"Soldul de pe cardul cadou",deductedBalance:"Sold sc\u0103zut","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primele 2 cifre ale parolei aferente cardului","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Parol\u0103 incorect\u0103","creditCard.taxNumber.label":"Data de na\u0219tere a posesorului de card (AALLZZ) sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre).","creditCard.taxNumber.labelAlt":"Num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre)","creditCard.taxNumber.invalid":"Data de na\u0219tere a posesorului de card sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii este incorect","storedPaymentMethod.disable.button":"\u0218tergere","storedPaymentMethod.disable.confirmation":"\u0218terge\u021bi metoda de plat\u0103 memorat\u0103","storedPaymentMethod.disable.confirmButton":"Da, \u0219terge","storedPaymentMethod.disable.cancelButton":"Anulare","ach.bankAccount":"Cont bancar","ach.accountHolderNameField.title":"Numele titularului de cont","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Numele titularului de cont este incorect","ach.accountNumberField.title":"Num\u0103r de cont","ach.accountNumberField.invalid":"Num\u0103rul de cont este incorect","ach.accountLocationField.title":"Num\u0103r de direc\u021bionare ABA","ach.accountLocationField.invalid":"Num\u0103r de direc\u021bionare ABA incorect","select.state":"Selecta\u021bi statul","select.stateOrProvince":"Selecta\u021bi jude\u021bul sau provincia","select.provinceOrTerritory":"Selecta\u021bi provincia sau teritoriul","select.country":"Selecta\u021bi \u021bara","select.noOptionsFound":"Nu s-a g\u0103sit nicio op\u021biune","select.filter.placeholder":"C\u0103utare...","telephoneNumber.invalid":"Num\u0103r de telefon incorect",qrCodeOrApp:"sau","paypal.processingPayment":"Se prelucreaz\u0103 plata...",generateQRCode:"Genera\u021bi codul QR","await.waitForConfirmation":"Se a\u0219teapt\u0103 confirmarea","mbway.confirmPayment":"Confirma\u021bi plata \xeen aplica\u021bia MB WAY","shopperEmail.invalid":"Adres\u0103 de e-mail incorect\u0103","dateOfBirth.format":"ZZ/LL/AAAA","dateOfBirth.invalid":"Trebuie s\u0103 ave\u021bi minimum 18 ani","blik.confirmPayment":"Deschide\u021bi aplica\u021bia dvs. de banking pentru a confirma plata.","blik.invalid":"Introduce\u021bi 6 cifre","blik.code":"Cod din 6 cifre","blik.help":"Ob\u021bine\u021bi codul din aplica\u021bia dvs. de banking.","swish.pendingMessage":"Dup\u0103 ce scana\u021bi, starea poate fi \u201e\xeen a\u0219teptare\u201d timp de maximum 10 minute. \xcencerc\u0103rile de a pl\u0103ti din nou \xeen acest r\u0103stimp pot genera prelev\u0103ri multiple de fonduri.","error.va.gen.01":"C\xe2mp incomplet","error.va.gen.02":"C\xe2mp incorect","error.va.sf-cc-num.01":"Num\u0103r de card incorect","error.va.sf-cc-num.03":"A fost introdus un card neacceptat","error.va.sf-cc-dat.01":"Cardul este prea vechi","error.va.sf-cc-dat.02":"Data este prea departe \xeen viitor","error.va.sf-cc-dat.03":"Cardul dvs. expir\u0103 \xeenainte de data de check-out","error.va.sf-ach-num.01":"Num\u0103rul de cont este incorect","error.va.sf-ach-loc.01":"Num\u0103r de direc\u021bionare ABA incorect","error.va.sf-kcp-pwd.01":"Parol\u0103 incorect\u0103","error.giftcard.no-balance":"Acest card cadou are soldul zero","error.giftcard.card-error":"\xcen eviden\u021bele noastre nu figureaz\u0103 niciun card cadou cu acest num\u0103r","error.giftcard.currency-error":"Cardurile cadou sunt valabile numai \xeen moneda \xeen care au fost emise","amazonpay.signout":"Deconecta\u021bi-v\u0103 de pe platforma Amazon","amazonpay.changePaymentDetails":"Modifica\u021bi detaliile de plat\u0103","partialPayment.warning":"Pentru a achita suma r\u0103mas\u0103, selecta\u021bi o alt\u0103 metod\u0103 de plat\u0103","partialPayment.remainingBalance":"Soldul r\u0103mas va fi de %{amount}","bankTransfer.beneficiary":"Beneficiar","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referin\u0163\u0103","bankTransfer.introduction":"Continua\u021bi s\u0103 crea\u021bi o nou\u0103 plat\u0103 prin transfer bancar. Pute\u021bi utiliza detaliile din ecranul urm\u0103tor pentru a finaliza aceast\u0103 plat\u0103.","bankTransfer.instructions":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","bacs.accountHolderName":"Numele titularului contului bancar","bacs.accountHolderName.invalid":"Numele titularului contului bancar este incorect","bacs.accountNumber":"Num\u0103rul contului bancar","bacs.accountNumber.invalid":"Num\u0103rul contului bancar este incorect","bacs.bankLocationId":"Cod de identificare bancar\u0103","bacs.bankLocationId.invalid":"Cod de identificare bancar\u0103 incorect","bacs.consent.amount":"Sunt de acord ca suma men\u021bionat\u0103 mai sus s\u0103 fie dedus\u0103 din contul meu bancar.","bacs.consent.account":"Confirm c\u0103 sunt titularul acestui cont \u0219i c\u0103 sunt singurul semnatar necesar pentru autorizarea debitului direct pentru acest cont.",edit:"Editare","bacs.confirm":"Confirma\u021bi \u0219i pl\u0103ti\u021bi","bacs.result.introduction":"Desc\u0103rca\u021bi instruc\u021biunile de debitare direct\u0103 (DDI/mandat)","download.pdf":"Desc\u0103rca\u021bi PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului securizat","creditCard.encryptedCardNumber.aria.label":"C\xe2mp aferent num\u0103rului cardului","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pentru data de expirare a cardului securizat","creditCard.encryptedExpiryDate.aria.label":"C\xe2mp aferent datei de expirare","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pentru luna de expirare a cardului securizat","creditCard.encryptedExpiryMonth.aria.label":"C\xe2mp aferent lunii de expirare","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pentru anul de expirare a cardului securizat","creditCard.encryptedExpiryYear.aria.label":"C\xe2mp aferent anului de expirare","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului securizat","creditCard.encryptedSecurityCode.aria.label":"C\xe2mp aferent codului de securitate","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului cadou securizat","giftcard.encryptedCardNumber.aria.label":"C\xe2mp aferent num\u0103rului cardului cadou","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului cadou securizat","giftcard.encryptedSecurityCode.aria.label":"C\xe2mp aferent codului de securitate al cardului cadou",giftcardTransactionLimit:"Pentru acest card cadou, suma maxim\u0103 permis\u0103 per tranzac\u021bie este de %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pentru num\u0103rul contului bancar securizat","ach.encryptedBankAccountNumber.aria.label":"C\xe2mp aferent contului bancar","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pentru num\u0103rul securizat de direc\u021bionare bancar\u0103 (routing number)","ach.encryptedBankLocationId.aria.label":"C\xe2mp aferent codului de direc\u021bionare bancar\u0103 (routing number)","twint.saved":"salvat"}}),aC=Object.freeze({__proto__:null,default:{payButton:"\u0417\u0430\u043f\u043b\u0430\u0442\u0438\u0442\u044c","payButton.redirecting":"\u041f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435...",storeDetails:"\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0434\u043b\u044f \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0433\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0430","creditCard.holderName":"\u0418\u043c\u044f \u043d\u0430 \u043a\u0430\u0440\u0442\u0435","creditCard.holderName.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","creditCard.holderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.title":"\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.expiryDateField.placeholder":"\u041c\u041c/\u0413\u0413","creditCard.expiryDateField.month":"\u041c\u0435\u0441\u044f\u0446","creditCard.expiryDateField.month.placeholder":"\u041c\u041c","creditCard.expiryDateField.year.placeholder":"\u0413\u0413","creditCard.expiryDateField.year":"\u0413\u043e\u0434","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0417\u0430\u043f\u043e\u043c\u043d\u0438\u0442\u044c \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u0440\u0430\u0437","creditCard.cvcField.placeholder.4digits":"4 \u0446\u0438\u0444\u0440\u044b","creditCard.cvcField.placeholder.3digits":"3 \u0446\u0438\u0444\u0440\u044b","creditCard.taxNumber.placeholder":"\u0413\u0413\u041c\u041c\u0414\u0414 / 0123456789",installments:"\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439",installmentOption:"%{times}\xd7 %{partialValue}",installmentOptionMonths:"%{times} \u043c\u0435\u0441.","installments.oneTime":"\u041e\u0434\u043d\u043e\u0440\u0430\u0437\u043e\u0432\u044b\u0439 \u043f\u043b\u0430\u0442\u0435\u0436","installments.installments":"\u0420\u0430\u0441\u0441\u0440\u043e\u0447\u043a\u0430","installments.revolving":"\u041f\u043e\u0432\u0442\u043e\u0440\u044f\u044e\u0449\u0430\u044f\u0441\u044f \u043e\u043f\u043b\u0430\u0442\u0430","sepaDirectDebit.ibanField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","sepaDirectDebit.nameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","sepa.ownerName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430","sepa.ibanNumber":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430 (IBAN)","error.title":"\u041e\u0448\u0438\u0431\u043a\u0430","error.subtitle.redirect":"\u0421\u0431\u043e\u0439 \u043f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u044f","error.subtitle.payment":"\u0421\u0431\u043e\u0439 \u043e\u043f\u043b\u0430\u0442\u044b","error.subtitle.refused":"\u041e\u043f\u043b\u0430\u0442\u0430 \u043e\u0442\u043a\u043b\u043e\u043d\u0435\u043d\u0430","error.message.unknown":"\u0412\u043e\u0437\u043d\u0438\u043a\u043b\u0430 \u043d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u0430\u044f \u043e\u0448\u0438\u0431\u043a\u0430","idealIssuer.selectField.title":"\u0411\u0430\u043d\u043a","idealIssuer.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","creditCard.success":"\u041f\u043b\u0430\u0442\u0435\u0436 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d",loading:"\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430\u2026",continue:"\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c",continueTo:"\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a","wechatpay.timetopay":"\u0423 \u0432\u0430\u0441 %@ \u043d\u0430 \u043e\u043f\u043b\u0430\u0442\u0443","wechatpay.scanqrcode":"\u0421\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u0442\u044c QR-\u043a\u043e\u0434",personalDetails:"\u041b\u0438\u0447\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435",companyDetails:"\u0414\u0430\u043d\u043d\u044b\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.name":"\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.registrationNumber":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440",socialSecurityNumber:"\u041d\u043e\u043c\u0435\u0440 \u0441\u043e\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0433\u043e \u0441\u0442\u0440\u0430\u0445\u043e\u0432\u0430\u043d\u0438\u044f \u0438\u043b\u0438 \u0418\u041d\u041d",firstName:"\u0418\u043c\u044f",infix:"\u041f\u0440\u0438\u0441\u0442\u0430\u0432\u043a\u0430",lastName:"\u0424\u0430\u043c\u0438\u043b\u0438\u044f",mobileNumber:"\u041c\u043e\u0431\u0438\u043b\u044c\u043d\u044b\u0439 \u0442\u0435\u043b\u0435\u0444\u043e\u043d","mobileNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0439 \u043d\u043e\u043c\u0435\u0440 \u043c\u043e\u0431\u0438\u043b\u044c\u043d\u043e\u0433\u043e",city:"\u0413\u043e\u0440\u043e\u0434",postalCode:"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",countryCode:"\u041a\u043e\u0434 \u0441\u0442\u0440\u0430\u043d\u044b",telephoneNumber:"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",dateOfBirth:"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f",shopperEmail:"\u0410\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b",gender:"\u041f\u043e\u043b",male:"\u041c\u0443\u0436\u0447\u0438\u043d\u0430",female:"\u0416\u0435\u043d\u0449\u0438\u043d\u0430",billingAddress:"\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441",street:"\u0423\u043b\u0438\u0446\u0430",stateOrProvince:"\u0420\u0435\u0433\u0438\u043e\u043d",country:"\u0421\u0442\u0440\u0430\u043d\u0430",houseNumberOrName:"\u041d\u043e\u043c\u0435\u0440 \u0434\u043e\u043c\u0430",separateDeliveryAddress:"\u0423\u043a\u0430\u0436\u0438\u0442\u0435 \u043e\u0442\u0434\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438",deliveryAddress:"\u0410\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438",zipCode:"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",apartmentSuite:"\u041a\u0432\u0430\u0440\u0442\u0438\u0440\u0430 / \u043f\u043e\u043c\u0435\u0449\u0435\u043d\u0438\u0435",provinceOrTerritory:"\u041f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044f \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044f",cityTown:"\u0413\u043e\u0440\u043e\u0434",address:"\u0410\u0434\u0440\u0435\u0441",state:"\u0428\u0442\u0430\u0442","field.title.optional":"(\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)","creditCard.cvcField.title.optional":"CVC / CVV (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)","issuerList.wallet.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u043e\u0448\u0435\u043b\u0435\u043a",privacyPolicy:"\u041f\u043e\u043b\u0438\u0442\u0438\u043a\u0430 \u043a\u043e\u043d\u0444\u0438\u0434\u0435\u043d\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0441\u0442\u0438","afterPay.agreement":"\u042f \u043f\u0440\u0438\u043d\u0438\u043c\u0430\u044e %@ AfterPay",paymentConditions:"\u0443\u0441\u043b\u043e\u0432\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b",openApp:"\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435","voucher.readInstructions":"\u041f\u0440\u043e\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0438\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0438\u0438","voucher.introduction":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u043a\u0443\u043f\u043e\u043d.","voucher.expirationDate":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","voucher.alternativeReference":"\u0414\u0440\u0443\u0433\u043e\u0439 \u043a\u043e\u0434","dragonpay.voucher.non.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043e\u0435\u0433\u043e \u043e\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0430","dragonpay.voucher.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","voucher.paymentReferenceLabel":"\u041a\u043e\u0434 \u043e\u043f\u043b\u0430\u0442\u044b","voucher.surcharge":"\u0412\u043a\u043b. \u043a\u043e\u043c\u0438\u0441\u0441\u0438\u044e %@","voucher.introduction.doku":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.shopperName":"\u0418\u043c\u044f \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.merchantName":"\u041f\u0440\u043e\u0434\u0430\u0432\u0435\u0446","voucher.introduction.econtext":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.telephoneNumber":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430","voucher.shopperReference":"\u0418\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440 \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.collectionInstitutionNumber":"\u041d\u043e\u043c\u0435\u0440 \u043f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044f \u0441\u0440\u0435\u0434\u0441\u0442\u0432","voucher.econtext.telephoneNumber.invalid":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430 \u0434\u043e\u043b\u0436\u0435\u043d \u0431\u044b\u0442\u044c \u0434\u043b\u0438\u043d\u043e\u0439 10 \u0438\u043b\u0438 11 \u0446\u0438\u0444\u0440","boletobancario.btnLabel":"\u0421\u043e\u0437\u0434\u0430\u0442\u044c Boleto","boleto.sendCopyToEmail":"\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043c\u043d\u0435 \u043a\u043e\u043f\u0438\u044e \u043d\u0430 \u044d\u043b. \u043f\u043e\u0447\u0442\u0443","button.copy":"\u041a\u043e\u043f\u0438\u044f","button.download":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c","creditCard.storedCard.description.ariaLabel":"\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430 \u0437\u0430\u043a\u0430\u043d\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044f \u043d\u0430 %@","voucher.entity":"\u041e\u0431\u044a\u0435\u043a\u0442",donateButton:"\u041f\u043e\u0436\u0435\u0440\u0442\u0432\u043e\u0432\u0430\u0442\u044c",notNowButton:"\u041f\u043e\u0437\u0436\u0435",thanksForYourSupport:"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0443!",preauthorizeWith:"\u041f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044f \u0432",confirmPreauthorization:"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044e",confirmPurchase:"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u043e\u043a\u0443\u043f\u043a\u0443",applyGiftcard:"\u0418\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c",giftcardBalance:"\u0411\u0430\u043b\u0430\u043d\u0441 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b",deductedBalance:"\u0411\u0430\u043b\u0430\u043d\u0441 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0439","creditCard.pin.title":"PIN-\u043a\u043e\u0434","creditCard.encryptedPassword.label":"\u041f\u0435\u0440\u0432\u044b\u0435 2 \u0446\u0438\u0444\u0440\u044b \u043f\u0430\u0440\u043e\u043b\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedPassword.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c","creditCard.taxNumber.label":"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b (\u0413\u0413\u041c\u041c\u0414\u0414) \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.labelAlt":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0434\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f","storedPaymentMethod.disable.button":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.confirmation":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b","storedPaymentMethod.disable.confirmButton":"\u0414\u0430, \u0443\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.cancelButton":"\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c","ach.bankAccount":"\u0411\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u0441\u0447\u0435\u0442","ach.accountHolderNameField.title":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountHolderNameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","ach.accountHolderNameField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountNumberField.title":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountNumberField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountLocationField.title":"\u041c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","ach.accountLocationField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","select.state":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442","select.stateOrProvince":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442 \u0438\u043b\u0438 \u043e\u0431\u043b\u0430\u0441\u0442\u044c","select.provinceOrTerritory":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044e \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044e","select.country":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043d\u0443","select.noOptionsFound":"\u0412\u0430\u0440\u0438\u0430\u043d\u0442\u043e\u0432 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e","select.filter.placeholder":"\u041f\u043e\u0438\u0441\u043a\u2026","telephoneNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",qrCodeOrApp:"\u0438\u043b\u0438","paypal.processingPayment":"\u041f\u043b\u0430\u0442\u0435\u0436 \u043e\u0431\u0440\u0430\u0431\u0430\u0442\u044b\u0432\u0430\u0435\u0442\u0441\u044f\u2026",generateQRCode:"\u0421\u043e\u0437\u0434\u0430\u0442\u044c QR-\u043a\u043e\u0434","await.waitForConfirmation":"\u041e\u0436\u0438\u0434\u0430\u043d\u0438\u0435 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f","mbway.confirmPayment":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043e\u043f\u043b\u0430\u0442\u0443 \u0432 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0438 MB WAY","shopperEmail.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b","dateOfBirth.format":"\u0414\u0414/\u041c\u041c/\u0413\u0413\u0413\u0413","dateOfBirth.invalid":"\u0412\u0430\u043c \u0434\u043e\u043b\u0436\u043d\u043e \u0431\u044b\u0442\u044c 18 \u043b\u0435\u0442 \u0438\u043b\u0438 \u0431\u043e\u043b\u044c\u0448\u0435","blik.confirmPayment":"\u0414\u043b\u044f \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0442\u043a\u0440\u043e\u0439\u0442\u0435 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435 \u0431\u0430\u043d\u043a\u0430.","blik.invalid":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 6 \u0446\u0438\u0444\u0440","blik.code":"6-\u0437\u043d\u0430\u0447\u043d\u044b\u0439 \u043a\u043e\u0434","blik.help":"\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u0435 \u043a\u043e\u0434 \u0438\u0437 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u044f \u0432\u0430\u0448\u0435\u0433\u043e \u0431\u0430\u043d\u043a\u0430.","swish.pendingMessage":"\u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 \u043e\u043f\u043b\u0430\u0442\u044b \u043f\u043e\u0441\u043b\u0435 \u0441\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u044f \u043c\u043e\u0436\u0435\u0442 \u0437\u0430\u043d\u044f\u0442\u044c 10 \u043c\u0438\u043d\u0443\u0442. \u041f\u043e\u043f\u044b\u0442\u043a\u0430 \u043f\u0440\u043e\u0432\u0435\u0441\u0442\u0438 \u043e\u043f\u043b\u0430\u0442\u0443 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e \u0432 \u0442\u0435\u0447\u0435\u043d\u0438\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0433\u043e \u0432\u0440\u0435\u043c\u0435\u043d\u0438 \u043c\u043e\u0436\u0435\u0442 \u043f\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043a \u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u0438\u043c \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u044f\u043c \u0441\u043e \u0441\u0447\u0435\u0442\u0430.","error.va.gen.01":"\u041d\u0435\u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.gen.02":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.sf-cc-num.01":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","error.va.sf-cc-num.03":"\u0412\u0432\u0435\u0434\u0435\u043d\u0430 \u043d\u0435\u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043c\u0430\u044f \u043a\u0430\u0440\u0442\u0430","error.va.sf-cc-dat.01":"\u0423\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0430\u044f \u043a\u0430\u0440\u0442\u0430","error.va.sf-cc-dat.02":"\u0414\u0430\u0442\u0430 \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0434\u0430\u043b\u0435\u043a\u043e \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043c","error.va.sf-cc-dat.03":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u0432\u0430\u0448\u0435\u0439 \u043a\u0430\u0440\u0442\u044b \u0438\u0441\u0442\u0435\u043a\u0430\u0435\u0442 \u0434\u043e \u0434\u0430\u0442\u044b \u043e\u043f\u043b\u0430\u0442\u044b","error.va.sf-ach-num.01":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","error.va.sf-ach-loc.01":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","error.va.sf-kcp-pwd.01":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c","error.giftcard.no-balance":"\u041d\u0430 \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435 \u043d\u0435\u0442 \u0441\u0440\u0435\u0434\u0441\u0442\u0432","error.giftcard.card-error":"\u0423 \u043d\u0430\u0441 \u043d\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043d\u0430 \u043a\u0430\u0440\u0442\u0430 \u0441 \u0442\u0430\u043a\u0438\u043c \u043d\u043e\u043c\u0435\u0440\u043e\u043c","error.giftcard.currency-error":"\u041f\u0440\u0438\u043d\u0438\u043c\u0430\u044e\u0442\u0441\u044f \u0442\u043e\u043b\u044c\u043a\u043e \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u044b\u0435 \u043a\u0430\u0440\u0442\u044b \u0441\u043e\u043e\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044e\u0449\u0435\u0439 \u0432\u0430\u043b\u044e\u0442\u044b","amazonpay.signout":"\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 Amazon","amazonpay.changePaymentDetails":"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044e \u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u0435","partialPayment.warning":"\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0434\u0440\u0443\u0433\u043e\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0441\u0442\u0430\u0442\u043a\u0430","partialPayment.remainingBalance":"\u041e\u0441\u0442\u0430\u0442\u043e\u043a \u043d\u0430 \u0431\u0430\u043b\u0430\u043d\u0441\u0435 \u0441\u043e\u0441\u0442\u0430\u0432\u0438\u0442 %{amount}","bankTransfer.beneficiary":"\u041f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044c","bankTransfer.reference":"\u0421\u0441\u044b\u043b\u043a\u0430","bankTransfer.introduction":"\u0414\u043b\u044f \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u044f \u043d\u043e\u0432\u043e\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u043f\u0435\u0440\u0435\u0447\u0438\u0441\u043b\u0435\u043d\u0438\u044f \u043f\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0434\u0430\u043b\u0435\u0435. \u0414\u043b\u044f \u043e\u043a\u043e\u043d\u0447\u0430\u0442\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d\u0438\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0430 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u043c \u044d\u043a\u0440\u0430\u043d\u0435.","bankTransfer.instructions":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","bacs.accountHolderName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountHolderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber":"\u041d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.bankLocationId":"\u041a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.bankLocationId.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.consent.amount":"\u0412\u044b\u0440\u0430\u0436\u0430\u044e \u0441\u043e\u0433\u043b\u0430\u0441\u0438\u0435 \u043d\u0430 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0432\u044b\u0448\u0435\u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0439 \u0441\u0443\u043c\u043c\u044b \u0441 \u043c\u043e\u0435\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430.","bacs.consent.account":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044e, \u0447\u0442\u043e \u0441\u0447\u0435\u0442 \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d \u043d\u0430 \u043c\u043e\u0435 \u0438\u043c\u044f \u0438 \u0447\u0442\u043e \u044f \u2013 \u0435\u0434\u0438\u043d\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u0435 \u043b\u0438\u0446\u043e, \u0438\u043c\u0435\u044e\u0449\u0435\u0435 \u043f\u0440\u0430\u0432\u043e \u043f\u043e\u0434\u043f\u0438\u0441\u0438, \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u044e\u0449\u0435\u0439 \u043f\u0440\u044f\u043c\u043e\u0435 \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441\u043e \u0441\u0447\u0435\u0442\u0430.",edit:"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c","bacs.confirm":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0438 \u043e\u043f\u043b\u0430\u0442\u0438\u0442\u044c","bacs.result.introduction":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u0440\u0430\u0441\u043f\u043e\u0440\u044f\u0436\u0435\u043d\u0438\u0435 \u043f\u0440\u044f\u043c\u043e\u0433\u043e \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u044f (DDI / \u043f\u043e\u0440\u0443\u0447\u0435\u043d\u0438\u0435)","download.pdf":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedCardNumber.aria.label":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u0442\u044b \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.label":"\u041f\u043e\u043b\u0435 \u0434\u0430\u0442\u044b \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryMonth.aria.label":"\u041f\u043e\u043b\u0435 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryYear.aria.label":"\u041f\u043e\u043b\u0435 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430","creditCard.encryptedSecurityCode.aria.label":"\u041f\u043e\u043b\u0435 \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedCardNumber.aria.label":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.label":"\u041f\u043e\u043b\u0435 \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b",giftcardTransactionLimit:"\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0441\u0443\u043c\u043c\u0430 \u043e\u043f\u0435\u0440\u0430\u0446\u0438\u0438 \u043f\u043e \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","ach.encryptedBankAccountNumber.aria.label":"\u041f\u043e\u043b\u0435 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u0430","ach.encryptedBankLocationId.aria.label":"\u041f\u043e\u043b\u0435 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u0430","twint.saved":"\u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043e"}}),nC=Object.freeze({__proto__:null,default:{payButton:"Zaplati\u0165","payButton.redirecting":"Prebieha presmerovanie ...",storeDetails:"Ulo\u017ei\u0165 pre moju \u010fal\u0161iu platbu","creditCard.holderName":"Meno na karte","creditCard.holderName.placeholder":"J. Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 meno dr\u017eite\u013ea karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Koniec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Mesiac","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapam\xe4ta\u0165 na bud\xface pou\u017eitie","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD/0123456789",installments:"Po\u010det spl\xe1tok",installmentOption:"% {times} x % {partialValue}",installmentOptionMonths:"%{times} mesiace/-ov","installments.oneTime":"Jednorazov\xe1 platba","installments.installments":"Platba po spl\xe1tkach","installments.revolving":"Revolvingov\xe1 platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"J. Nov\xe1k","sepa.ownerName":"Meno dr\u017eite\u013ea","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"Nepodarilo sa presmerova\u0165","error.subtitle.payment":"Platba zlyhala","error.subtitle.refused":"Platba bola zamietnut\xe1","error.message.unknown":"Vyskytla sa nezn\xe1ma chyba","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svoju banku","creditCard.success":"Platba bola \xfaspe\u0161n\xe1",loading:"Na\u010d\xedtava sa\u2026",continue:"Pokra\u010dova\u0165",continueTo:"Pokra\u010dova\u0165 do","wechatpay.timetopay":"Na zaplatenie m\xe1te %@","wechatpay.scanqrcode":"Naskenujte QR k\xf3d",personalDetails:"Osobn\xe9 \xfadaje",companyDetails:"\xdadaje o spolo\u010dnosti","companyDetails.name":"N\xe1zov spolo\u010dnosti","companyDetails.registrationNumber":"Identifika\u010dn\xe9 \u010d\xedslo",socialSecurityNumber:"Rodn\xe9 \u010d\xedslo",firstName:"Krstn\xe9 meno",infix:"Predpona k priezvisku (ak existuje)",lastName:"Priezvisko",mobileNumber:"Mobiln\xe9 telef\xf3nne \u010d\xedslo","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo na mobil",city:"Mesto",postalCode:"PS\u010c",countryCode:"K\xf3d krajiny",telephoneNumber:"Telef\xf3nne \u010d\xedslo",dateOfBirth:"D\xe1tum narodenia",shopperEmail:"E-mailov\xe1 adresa",gender:"Pohlavie",male:"Mu\u017e",female:"\u017dena",billingAddress:"Faktura\u010dn\xe1 adresa",street:"Ulica",stateOrProvince:"Kraj",country:"Krajina",houseNumberOrName:"\u010c\xedslo domu",separateDeliveryAddress:"Zadajte samostatn\xfa dodaciu adresu",deliveryAddress:"Dodacia adresa",zipCode:"PS\u010c",apartmentSuite:"Byt/apartm\xe1n",provinceOrTerritory:"Okres alebo \xfazemie",cityTown:"Mesto/obec",address:"Adresa",state:"\u0160t\xe1t","field.title.optional":"(volite\u013en\xe9)","creditCard.cvcField.title.optional":"CVC/CVV (volite\u013en\xe9)","issuerList.wallet.placeholder":"Vyberte si pe\u0148a\u017eenku",privacyPolicy:"Z\xe1sady ochrany osobn\xfdch \xfadajov","afterPay.agreement":"S\xfahlas\xedm s %@ AfterPay",paymentConditions:"podmienkami platby",openApp:"Otvorte aplik\xe1ciu","voucher.readInstructions":"Pre\u010d\xedtajte si pokyny","voucher.introduction":"\u010eakujeme v\xe1m za n\xe1kup; na dokon\u010denie platby pou\u017eite nasleduj\xfaci kup\xf3n.","voucher.expirationDate":"D\xe1tum vypr\u0161ania platnosti","voucher.alternativeReference":"Alternat\xedvny odkaz","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte si poskytovate\u013ea","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svoju banku","voucher.paymentReferenceLabel":"Platobn\xe1 referencia","voucher.surcharge":"Vr\xe1tane poplatku vo v\xfd\u0161ke %@","voucher.introduction.doku":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.shopperName":"Meno kupuj\xfaceho","voucher.merchantName":"Predajca","voucher.introduction.econtext":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.telephoneNumber":"Telef\xf3nne \u010d\xedslo","voucher.shopperReference":"Referencia kupuj\xfaceho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasnej in\u0161tit\xfacie","voucher.econtext.telephoneNumber.invalid":"Telef\xf3nne \u010d\xedslo mus\xed ma\u0165 10 alebo 11 \u010d\xedslic","boletobancario.btnLabel":"Generova\u0165 Boleto","boleto.sendCopyToEmail":"Zasla\u0165 k\xf3piu na m\xf4j e-mail","button.copy":"Kop\xedrova\u0165","button.download":"Stiahnu\u0165","creditCard.storedCard.description.ariaLabel":"Platnos\u0165 ulo\u017eenej karty kon\u010d\xed o %@","voucher.entity":"Subjekt",donateButton:"Prispie\u0165",notNowButton:"Teraz nie",thanksForYourSupport:"\u010eakujeme za podporu!",preauthorizeWith:"Predbe\u017ene autorizova\u0165 pomocou",confirmPreauthorization:"Potvr\u010fte predbe\u017en\xfa autoriz\xe1ciu",confirmPurchase:"Potvr\u010fte n\xe1kup",applyGiftcard:"Uplatni\u0165",giftcardBalance:"Zostatok na dar\u010dekovej karte",deductedBalance:"Zn\xed\u017een\xfd zostatok","creditCard.pin.title":"K\xf3d PIN","creditCard.encryptedPassword.label":"Prv\xe9 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplan\xe9 heslo","creditCard.taxNumber.label":"D\xe1tum narodenia dr\u017eite\u013ea karty (RRRMMDD) alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xfd d\xe1tum narodenia dr\u017eite\u013ea karty alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie","storedPaymentMethod.disable.button":"Odstr\xe1ni\u0165","storedPaymentMethod.disable.confirmation":"Odstr\xe1ni\u0165 ulo\u017een\xfd sp\xf4sob platby","storedPaymentMethod.disable.confirmButton":"\xc1no, odstr\xe1ni\u0165","storedPaymentMethod.disable.cancelButton":"Zru\u0161i\u0165","ach.bankAccount":"Bankov\xfd \xfa\u010det","ach.accountHolderNameField.title":"Meno majite\u013ea \xfa\u010dtu","ach.accountHolderNameField.placeholder":"J. Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 meno majite\u013ea \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Smerovacie \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 smerovacie \u010d\xedslo ABA","select.state":"Vyberte kraj","select.stateOrProvince":"Vyberte kraj alebo okres","select.provinceOrTerritory":"Vyberte okres alebo \xfazemie","select.country":"Vyberte krajinu","select.noOptionsFound":"Neboli n\xe1jden\xe9 \u017eiadne mo\u017enosti","select.filter.placeholder":"Vyh\u013ead\xe1vanie...","telephoneNumber.invalid":"Neplatn\xe9 telef\xf3nne \u010d\xedslo",qrCodeOrApp:"alebo","paypal.processingPayment":"Platba sa sprac\xfava.",generateQRCode:"Generova\u0165 QR k\xf3d","await.waitForConfirmation":"\u010cak\xe1 sa na potvrdenie","mbway.confirmPayment":"Potvr\u010fte svoju platbu v aplik\xe1cii MB WAY","shopperEmail.invalid":"Neplatn\xe1 emailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xedte ma\u0165 aspo\u0148 18 rokov","blik.confirmPayment":"Otvorte svoju bankov\xfa aplik\xe1ciu a potvr\u010fte platbu.","blik.invalid":"Zadajte 6 \u010d\xedslic","blik.code":"6-cifern\xfd k\xf3d","blik.help":"Z\xedskajte k\xf3d zo svojej bankovej aplik\xe1cie.","swish.pendingMessage":"Po nasn\xedman\xed m\xf4\u017ee spracovanie trva\u0165 a\u017e 10 min\xfat. Pokus o op\xe4tovn\xe9 zaplatenie v tejto lehote m\xf4\u017ee vies\u0165 k nieko\u013ek\xfdm poplatkom.","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole je neplatn\xe9","error.va.sf-cc-num.01":"Neplatn\xe9 \u010d\xedslo karty","error.va.sf-cc-num.03":"Zadali ste nepodporovan\xfa kartu","error.va.sf-cc-dat.01":"Karta je pr\xedli\u0161 star\xe1","error.va.sf-cc-dat.02":"D\xe1tum je pr\xedli\u0161 \u010faleko v bud\xfacnosti","error.va.sf-cc-dat.03":"Platnos\u0165 va\u0161ej karty vypr\u0161\xed pred d\xe1tumom odhl\xe1senia","error.va.sf-ach-num.01":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","error.va.sf-ach-loc.01":"Neplatn\xe9 smerovacie \u010d\xedslo ABA","error.va.sf-kcp-pwd.01":"Neplan\xe9 heslo","error.giftcard.no-balance":"T\xe1to dar\u010dekov\xe1 karta m\xe1 nulov\xfd zostatok","error.giftcard.card-error":"V na\u0161ich z\xe1znamoch nem\xe1me \u017eiadnu dar\u010dekov\xfa kartu s t\xfdmto \u010d\xedslom","error.giftcard.currency-error":"Dar\u010dekov\xe9 karty s\xfa platn\xe9 iba v mene, v ktorej boli vydan\xe9","amazonpay.signout":"Odhl\xe1si\u0165 sa z Amazonu","amazonpay.changePaymentDetails":"Zmeni\u0165 podrobnosti o platbe","partialPayment.warning":"Ak chcete zaplati\u0165 zostatok, vyberte in\xfd sp\xf4sob platby","partialPayment.remainingBalance":"Zvy\u0161n\xfd zostatok bude %{amount}","bankTransfer.beneficiary":"Pr\xedjemca","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencie","bankTransfer.introduction":"Pokra\u010dujte vo vytv\xe1ran\xed novej platby bankov\xfdm prevodom. T\xfato platbu m\xf4\u017eete dokon\u010di\u0165 pomocou inform\xe1ci\xed na nasleduj\xfacej obrazovke.","bankTransfer.instructions":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","bacs.accountHolderName":"Meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankov\xe9ho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankov\xe9ho \xfa\u010dtu","bacs.bankLocationId":"Variabiln\xfd symbol","bacs.bankLocationId.invalid":"Neplatn\xfd variabiln\xfd symbol","bacs.consent.amount":"S\xfahlas\xedm s t\xfdm, \u017ee ni\u017e\u0161ie uveden\xe1 \u010diastka bude odp\xedsan\xe1 z m\xf4jho bankov\xe9ho \xfa\u010dtu.","bacs.consent.account":"Potvrdzujem, \u017ee \xfa\u010det je na moje meno a som jedin\xfd podpisovate\u013e, ktor\xfd je povinn\xfd autorizova\u0165 inkaso v tomto \xfa\u010dte.",edit:"Upravi\u0165","bacs.confirm":"Potvrdi\u0165 a zaplati\u0165","bacs.result.introduction":"Stiahnite si pokyny k inkasu (DDI/Mand\xe1t)","download.pdf":"Stiahnu\u0165 vo form\xe1te PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 \u010d\xedslo karty","creditCard.encryptedCardNumber.aria.label":"Pole pre \u010d\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pre de\u0148 konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryDate.aria.label":"Pole d\u0148a konca platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pre mesiac konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryMonth.aria.label":"Pole mesiaca konca platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pre rok konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryYear.aria.label":"Pole roka konca platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej karty","creditCard.encryptedSecurityCode.aria.label":"Pole bezpe\u010dnostn\xe9ho k\xf3du","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedCardNumber.aria.label":"Pole pre \u010d\xedslo dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.label":"Pole bezpe\u010dnostn\xe9ho k\xf3du dar\u010dekovej karty",giftcardTransactionLimit:"Pre transakciu s touto dar\u010dekovou kartou je povolen\xe9 maximum %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010den\xe9ho bankov\xe9ho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Pole bankov\xe9ho \xfa\u010dtu","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 smerovacie \u010d\xedslo banky","ach.encryptedBankLocationId.aria.label":"Pole smerovacieho \u010d\xedsla banky","twint.saved":"ulo\u017een\xe9"}}),oC=Object.freeze({__proto__:null,default:{payButton:"Pla\u010dilo","payButton.redirecting":"Preusmerjanje ...",storeDetails:"Shrani za moje naslednje pla\u010dilo","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Novak","creditCard.holderName.invalid":"Neveljavno ime imetnika kartice","creditCard.numberField.title":"\u0160tevilka kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum veljavnosti","creditCard.expiryDateField.placeholder":"MM/LL","creditCard.expiryDateField.month":"Mesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"LL","creditCard.expiryDateField.year":"Leto","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapomni si za prihodnji\u010d","creditCard.cvcField.placeholder.4digits":"4 \u0161tevke","creditCard.cvcField.placeholder.3digits":"3 \u0161tevke","creditCard.taxNumber.placeholder":"LLMMDD / 0123456789",installments:"\u0160tevilo obrokov",installmentOption:"%{times} \xd7 %{partialValue}",installmentOptionMonths:"\u0160t. mesecev: %{times}","installments.oneTime":"Enkratno pla\u010dilo","installments.installments":"Obro\u010dno pla\u010dilo","installments.revolving":"Revolving pla\u010dilo","sepaDirectDebit.ibanField.invalid":"Neveljavna \u0161tevilka ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Novak","sepa.ownerName":"Ime imetnika","sepa.ibanNumber":"\u0160tevilka ra\u010duna (IBAN)","error.title":"Napaka","error.subtitle.redirect":"Preusmeritev ni uspela","error.subtitle.payment":"Pla\u010dilo ni uspelo","error.subtitle.refused":"Pla\u010dilo je bilo zavrnjeno","error.message.unknown":"Pri\u0161lo je do neznane napake","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Izberite svojo banko","creditCard.success":"Pla\u010dilo je bilo uspe\u0161no",loading:"Nalaganje \u2026",continue:"Nadaljuj",continueTo:"Nadaljujte na","wechatpay.timetopay":"Pla\u010dati morate %@","wechatpay.scanqrcode":"Opti\u010dno preberite kodo QR",personalDetails:"Osebni podatki",companyDetails:"Podrobnosti o podjetju","companyDetails.name":"Ime podjetja","companyDetails.registrationNumber":"Mati\u010dna \u0161tevilka podjetja",socialSecurityNumber:"\u0160tevilka socialnega zavarovanja",firstName:"Ime",infix:"Naziv",lastName:"Priimek",mobileNumber:"\u0160tevilka mobilnega telefona","mobileNumber.invalid":"Neveljavna \u0161tevilka mobilnega telefona",city:"Mesto",postalCode:"Po\u0161tna \u0161tevilka",countryCode:"Koda dr\u017eave",telephoneNumber:"Telefonska \u0161tevilka",dateOfBirth:"Datum rojstva",shopperEmail:"Elektronski naslov",gender:"Spol",male:"Mo\u0161ki",female:"\u017denski",billingAddress:"Naslov za ra\u010dun",street:"Ulica",stateOrProvince:"Dr\u017eava ali provinca",country:"Dr\u017eava",houseNumberOrName:"Hi\u0161na \u0161tevilka",separateDeliveryAddress:"Navedite lo\u010den naslov za dostavo",deliveryAddress:"Naslov za dostavo",zipCode:"Po\u0161tna \u0161tevilka",apartmentSuite:"\u0160t. apartmaja/stanovanja",provinceOrTerritory:"Obmo\u010dje ali ozemlje",cityTown:"Mesto",address:"Naslov",state:"Dr\u017eava","field.title.optional":"(izbirno)","creditCard.cvcField.title.optional":"CVC/CVV (neobvezno)","issuerList.wallet.placeholder":"Izberite svojo denarnico",privacyPolicy:"Pravilnik o zasebnosti","afterPay.agreement":"Strinjam se s %@ ponudnika AfterPay",paymentConditions:"pla\u010dilnimi pogoji",openApp:"Odprite aplikacijo","voucher.readInstructions":"Preberite navodila","voucher.introduction":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.expirationDate":"Datum poteka veljavnosti","voucher.alternativeReference":"Druga referen\u010dna \u0161tevilka","dragonpay.voucher.non.bank.selectField.placeholder":"Izberite svojega ponudnika","dragonpay.voucher.bank.selectField.placeholder":"Izberite svojo banko","voucher.paymentReferenceLabel":"Referen\u010dna \u0161tevilka pla\u010dila","voucher.surcharge":"Vklj. %@ dopla\u010dila","voucher.introduction.doku":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovec","voucher.introduction.econtext":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.telephoneNumber":"Telefonska \u0161tevilka","voucher.shopperReference":"Referen\u010dna \u0161tevilka kupca","voucher.collectionInstitutionNumber":"\u0160tevilka ustanove za zbiranje","voucher.econtext.telephoneNumber.invalid":"Telefonska \u0161tevilka mora vsebovati 10 ali 11 \u0161tevk","boletobancario.btnLabel":"Ustvari Boleto","boleto.sendCopyToEmail":"Po\u0161lji kopijo na moj elektronski naslov","button.copy":"Kopiraj","button.download":"Prenesi","creditCard.storedCard.description.ariaLabel":"Shranjena kartica se kon\u010da na %@","voucher.entity":"Entiteta",donateButton:"Donirajte",notNowButton:"Ne zdaj",thanksForYourSupport:"Zahvaljujemo se vam za podporo!",preauthorizeWith:"Predhodna odobritev s/z:",confirmPreauthorization:"Potrdi predhodno odobritev",confirmPurchase:"Potrditev nakupa",applyGiftcard:"Unov\u010di",giftcardBalance:"Stanje na darilni kartici",deductedBalance:"Odbiti znesek","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Prvi dve \u0161tevki gesla za kartico","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neveljavno geslo","creditCard.taxNumber.label":"Datum rojstva imetnika kartice (LLMMDD) ali registracijska \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.labelAlt":"Mati\u010dna \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.invalid":"Neveljaven datum rojstva imetnika kartice ali mati\u010dna \u0161tevilka podjetja","storedPaymentMethod.disable.button":"Odstrani","storedPaymentMethod.disable.confirmation":"Odstrani shranjen na\u010din pla\u010dila","storedPaymentMethod.disable.confirmButton":"Da, odstrani","storedPaymentMethod.disable.cancelButton":"Prekli\u010di","ach.bankAccount":"Ban\u010dni ra\u010dun","ach.accountHolderNameField.title":"Ime imetnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Novak","ach.accountHolderNameField.invalid":"Neveljavno ime imetnika ra\u010duna","ach.accountNumberField.title":"\u0160tevilka ra\u010duna","ach.accountNumberField.invalid":"Neveljavna \u0161tevilka ra\u010duna","ach.accountLocationField.title":"Koda banke ABA","ach.accountLocationField.invalid":"Neveljavna koda banke ABA","select.state":"Izberite dr\u017eavo","select.stateOrProvince":"Izberite dr\u017eavo ali provinco","select.provinceOrTerritory":"Izberite obmo\u010dje ali ozemlje","select.country":"Izberite dr\u017eavo","select.noOptionsFound":"Ni najdenih mo\u017enosti","select.filter.placeholder":"Iskanje ...","telephoneNumber.invalid":"Neveljavna telefonska \u0161tevilka",qrCodeOrApp:"ali","paypal.processingPayment":"Obdelava pla\u010dila ...",generateQRCode:"Ustvari kodo QR","await.waitForConfirmation":"\u010cakanje na potrditev","mbway.confirmPayment":"Potrdite svoje pla\u010dilo v aplikaciji MB WAY","shopperEmail.invalid":"Neveljaven elektronski naslov","dateOfBirth.format":"DD/MM/LLLL","dateOfBirth.invalid":"Imeti morate najmanj 18 let","blik.confirmPayment":"Za potrditev pla\u010dila odprite svojo ban\u010dno aplikacijo.","blik.invalid":"Vnesite 6 \u0161tevilk","blik.code":"6-mestna koda","blik.help":"Pridobite kodo iz ban\u010dne aplikacije.","swish.pendingMessage":"Ko opti\u010dno preberete, lahko \u010dakanje traja do 10 minut. Poskus ponovnega pla\u010dila v tem \u010dasu lahko povzro\u010di ve\u010d odtegljajev.","error.va.gen.01":"Nepopolno polje","error.va.gen.02":"Polje ni veljavno","error.va.sf-cc-num.01":"Neveljavna \u0161tevilka kartice","error.va.sf-cc-num.03":"Vnesena je nepodprta kartica","error.va.sf-cc-dat.01":"Kartica je prestara","error.va.sf-cc-dat.02":"Datum je predale\u010d v prihodnosti","error.va.sf-cc-dat.03":"Va\u0161a kartica pote\u010de pred datumom odjave","error.va.sf-ach-num.01":"Neveljavna \u0161tevilka ra\u010duna","error.va.sf-ach-loc.01":"Neveljavna koda banke ABA","error.va.sf-kcp-pwd.01":"Neveljavno geslo","error.giftcard.no-balance":"Na tej darilni kartici ni sredstev","error.giftcard.card-error":"V na\u0161i evidenci nimamo darilne kartice s to \u0161tevilko","error.giftcard.currency-error":"Darilne kartice so veljavne samo za valuto, za katero so bile izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Sprememba podrobnosti pla\u010dila","partialPayment.warning":"Izberite drugo vrsto pla\u010dila za pla\u010dilo ostanka","partialPayment.remainingBalance":"Preostalo stanje bo %{amount}","bankTransfer.beneficiary":"Upravi\u010denec","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nadaljujte ustvarjanje novega pla\u010dila z ban\u010dnim nakazilom. Za dokon\u010danje tega pla\u010dila lahko uporabite podatke na naslednjem zaslonu.","bankTransfer.instructions":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","bacs.accountHolderName":"Ime imetnika ban\u010dnega ra\u010duna","bacs.accountHolderName.invalid":"Neveljavno ime imetnika ra\u010duna","bacs.accountNumber":"\u0160tevilka ban\u010dnega ra\u010duna","bacs.accountNumber.invalid":"Neveljavna \u0161tevilka ban\u010dnega ra\u010duna","bacs.bankLocationId":"\u0160tevilka banke","bacs.bankLocationId.invalid":"Neveljavna \u0161tevilka banke","bacs.consent.amount":"Sogla\u0161am s tem, da bo zgornji znesek odtegnjen z mojega ban\u010dnega ra\u010duna.","bacs.consent.account":"Potrjujem, da je ra\u010dun ustvarjen v mojem imenu in sem edini podpisnik za odobritev neposredne bremenitve za ta ra\u010dun.",edit:"Uredi","bacs.confirm":"Potrdi in pla\u010daj","bacs.result.introduction":"Prenesite navodila za neposredno bremenitev (DDI/mandat)","download.pdf":"Prenos datoteke PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko kartice","creditCard.encryptedCardNumber.aria.label":"Polje s \u0161tevilko kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za zavarovan potek veljavnosti kartice","creditCard.encryptedExpiryDate.aria.label":"Polje z datumom poteka veljavnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za zavarovan mesec poteka veljavnosti kartice","creditCard.encryptedExpiryMonth.aria.label":"Polje z mesecem poteka veljavnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za zavarovano leto poteka veljavnosti kartice","creditCard.encryptedExpiryYear.aria.label":"Polje z letom poteka veljavnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo kartice","creditCard.encryptedSecurityCode.aria.label":"Polje z varnostno kodo","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko darilne kartice","giftcard.encryptedCardNumber.aria.label":"Polje s \u0161tevilko darilne kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo darilne kartice","giftcard.encryptedSecurityCode.aria.label":"Polje z varnostno kodo darilne kartice",giftcardTransactionLimit:"Za posamezno transakcijo na tej darilni kartici je dovoljeno najve\u010d %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko ban\u010dnega ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Polje z ban\u010dnim ra\u010dunom","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za zavarovano kodo banke","ach.encryptedBankLocationId.aria.label":"Polje s kodo banke","twint.saved":"shranjeno"}}),iC=Object.freeze({__proto__:null,default:{payButton:"Betala","payButton.redirecting":"Omdirigerar\u2026",storeDetails:"Spara till min n\xe4sta betalning","creditCard.holderName":"Namn p\xe5 kort","creditCard.holderName.placeholder":"A. Andersson","creditCard.holderName.invalid":"Kortinnehavarens namn \xe4r ogiltigt","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utg\xe5ngsdatum","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5nad","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Spara kortuppgifter","creditCard.cvcField.placeholder.4digits":"4 siffror","creditCard.cvcField.placeholder.3digits":"3 siffror","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD / 0123456789",installments:"Antal delbetalningar",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} m\xe5nader","installments.oneTime":"Eng\xe5ngsbetalning","installments.installments":"Delbetalningar","installments.revolving":"Uppdelad betalning","sepaDirectDebit.ibanField.invalid":"Ogiltigt kontonummer","sepaDirectDebit.nameField.placeholder":"A. Andersson","sepa.ownerName":"K\xe4nt av kontoinnehavaren","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fel","error.subtitle.redirect":"Omdirigering misslyckades","error.subtitle.payment":"Betalning misslyckades","error.subtitle.refused":"Betalning avvisad","error.message.unknown":"Ett ok\xe4nt fel uppstod","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe4lj din bank","creditCard.success":"Betalning lyckades",loading:"Laddar\u2026",continue:"Forts\xe4tt",continueTo:"Forts\xe4tt till","wechatpay.timetopay":"Du har %@ att betala","wechatpay.scanqrcode":"Skanna QR-kod",personalDetails:"Personuppgifter",companyDetails:"F\xf6retagsinformation","companyDetails.name":"F\xf6retagsnamn","companyDetails.registrationNumber":"Registreringsnummer",socialSecurityNumber:"Personnummer",firstName:"F\xf6rnamn",infix:"Prefix",lastName:"Efternamn",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ogiltigt mobilnummer",city:"Stad",postalCode:"Postnummer",countryCode:"Landskod",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf6delsedatum",shopperEmail:"E-postadress",gender:"K\xf6n",male:"Man",female:"Kvinna",billingAddress:"Faktureringsadress",street:"Gatuadress",stateOrProvince:"Delstat eller region",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Ange en separat leveransadress",deliveryAddress:"Leveransadress",zipCode:"Postnummer",apartmentSuite:"L\xe4genhetsnummer",provinceOrTerritory:"Provins eller territorium",cityTown:"Ort",address:"Adress",state:"Delstat","field.title.optional":"(valfritt)","creditCard.cvcField.title.optional":"CVC/CVV (tillval)","issuerList.wallet.placeholder":"V\xe4j din pl\xe5nbok",privacyPolicy:"Sekretesspolicy","afterPay.agreement":"Jag godk\xe4nner AfterPays %@",paymentConditions:"betalvillkor",openApp:"\xd6ppna appen","voucher.readInstructions":"L\xe4s instruktionerna","voucher.introduction":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande kupong f\xf6r att slutf\xf6ra din betalning.","voucher.expirationDate":"Utg\xe5ngsdatum","voucher.alternativeReference":"Alternativ referens","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe4lj din leverant\xf6r","dragonpay.voucher.bank.selectField.placeholder":"V\xe4lj din bank","voucher.paymentReferenceLabel":"Betalreferens","voucher.surcharge":"Inklusive %@ i avgift","voucher.introduction.doku":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.shopperName":"Konsumentens namn","voucher.merchantName":"Handlare","voucher.introduction.econtext":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf6parreferens","voucher.collectionInstitutionNumber":"Nummer p\xe5 upph\xe4mtningsplats","voucher.econtext.telephoneNumber.invalid":"Telefonnumret m\xe5ste inneh\xe5lla 10 eller 11 siffror","boletobancario.btnLabel":"Generera Boleto","boleto.sendCopyToEmail":"Skicka en kopia till min e-post","button.copy":"Kopiera","button.download":"Ladda ner","creditCard.storedCard.description.ariaLabel":"Sparat kort slutar p\xe5 %@","voucher.entity":"Enhet",donateButton:"Donera",notNowButton:"Inte nu",thanksForYourSupport:"Tack f\xf6r ditt st\xf6d!",preauthorizeWith:"F\xf6rauktorisera med",confirmPreauthorization:"Bekr\xe4fta f\xf6rauktorisering",confirmPurchase:"Bekr\xe4fta k\xf6p",applyGiftcard:"L\xf6s in",giftcardBalance:"Presentkortssaldo",deductedBalance:"Avdraget saldo","creditCard.pin.title":"PIN-kod","creditCard.encryptedPassword.label":"De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ogiltigt l\xf6senord","creditCard.taxNumber.label":"Kortinnehavarens f\xf6delsedatum (\xc5\xc5MMDD) eller f\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.labelAlt":"F\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.invalid":"Ogiltigt f\xf6delsedatum eller organisationsnummer","storedPaymentMethod.disable.button":"Ta bort","storedPaymentMethod.disable.confirmation":"Ta bort sparat betalningss\xe4tt","storedPaymentMethod.disable.confirmButton":"Ja, ta bort","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoinnehavarens namn","ach.accountHolderNameField.placeholder":"A. Andersson","ach.accountHolderNameField.invalid":"Kontoinnehavarens namn \xe4r ogiltigt","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ogiltigt kontonummer","ach.accountLocationField.title":"ABA-nummer","ach.accountLocationField.invalid":"Ogiltigt ABA-nummer","select.state":"V\xe4lj delstat","select.stateOrProvince":"V\xe4lj delstat eller provins","select.provinceOrTerritory":"V\xe4lj provins eller territorium","select.country":"V\xe4lj land","select.noOptionsFound":"Inga alternativ hittades","select.filter.placeholder":"S\xf6k efter\u2026","telephoneNumber.invalid":"Ogiltigt telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandlar betalning \u2026",generateQRCode:"Generera QR-kod","await.waitForConfirmation":"V\xe4ntar p\xe5 bekr\xe4ftelse","mbway.confirmPayment":"Bekr\xe4fta din betalning i appen MB WAY","shopperEmail.invalid":"Ogiltig e-postadress","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5ste vara minst 18 \xe5r","blik.confirmPayment":"\xd6ppna din bankapp f\xf6r att bekr\xe4fta betalningen.","blik.invalid":"Ange 6 siffror","blik.code":"Sexsiffrig kod","blik.help":"H\xe4mta koden fr\xe5n din bankapp.","swish.pendingMessage":"N\xe4r du har skannat kan statusen vara v\xe4ntande i upp till tio minuter. Att f\xf6rs\xf6ka betala igen inom denna tid kan leda till flera debiteringar.","error.va.gen.01":"Ofullst\xe4ndigt f\xe4lt","error.va.gen.02":"F\xe4ltet ogiltigt","error.va.sf-cc-num.01":"Ogiltigt kortnummer","error.va.sf-cc-num.03":"Det angivna kortet st\xf6ds inte","error.va.sf-cc-dat.01":"Kortet \xe4r f\xf6r gammalt","error.va.sf-cc-dat.02":"Datumet ligger f\xf6r l\xe5ngt fram i framtiden","error.va.sf-cc-dat.03":"Ditt kort g\xe5r ut f\xf6re betalningsdatumet","error.va.sf-ach-num.01":"Ogiltigt kontonummer","error.va.sf-ach-loc.01":"Ogiltigt ABA-nummer","error.va.sf-kcp-pwd.01":"Ogiltigt l\xf6senord","error.giftcard.no-balance":"Saldot f\xf6r detta presentkort \xe4r noll","error.giftcard.card-error":"Vi har inte registrerat n\xe5got presentkort med det numret","error.giftcard.currency-error":"Presentkort \xe4r endast giltiga i den valuta som de utf\xe4rdades i","amazonpay.signout":"Logga ut fr\xe5n Amazon","amazonpay.changePaymentDetails":"\xc4ndra betalningsuppgifter","partialPayment.warning":"V\xe4lj ett annat betalningss\xe4tt f\xf6r att betala det \xe5terst\xe5ende","partialPayment.remainingBalance":"\xc5terst\xe5ende saldo blir %{amount}","bankTransfer.beneficiary":"Mottagare","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referens","bankTransfer.introduction":"Forts\xe4tt f\xf6r att skapa en ny bank\xf6verf\xf6ring. Du kan anv\xe4nda informationen p\xe5 f\xf6ljande sk\xe4rm f\xf6r att slutf\xf6ra denna betalning.","bankTransfer.instructions":"Tack f\xf6r ditt k\xf6p! Anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","bacs.accountHolderName":"Bankkontoinnehavarens namn","bacs.accountHolderName.invalid":"Ogiltigt namn p\xe5 bankkontoinnehavare","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ogiltigt bankkontonummer","bacs.bankLocationId":"Clearingnummer","bacs.bankLocationId.invalid":"Ogiltigt clearingnummer","bacs.consent.amount":"Jag godk\xe4nner att ovanst\xe5ende belopp dras fr\xe5n mitt bankkonto.","bacs.consent.account":"Jag bekr\xe4ftar att jag \xe4r kontoinnehavare och att jag \xe4r den enda person vars godk\xe4nnande kr\xe4vs f\xf6r att auktorisera autogiro fr\xe5n detta konto.",edit:"Redigera","bacs.confirm":"Bekr\xe4fta och betala","bacs.result.introduction":"Ladda ner din instruktion f\xf6r autogiro/direktdebitering (DDI / Mandate)","download.pdf":"Ladda ner PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat kortnummer","creditCard.encryptedCardNumber.aria.label":"F\xe4lt f\xf6r kortnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngsdatum f\xf6r kort","creditCard.encryptedExpiryDate.aria.label":"F\xe4lt f\xf6r utg\xe5ngsdatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xf6r s\xe4krad utg\xe5ngsm\xe5nad f\xf6r kort","creditCard.encryptedExpiryMonth.aria.label":"F\xe4lt f\xf6r utg\xe5ngsm\xe5nad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngs\xe5r f\xf6r kort","creditCard.encryptedExpiryYear.aria.label":"F\xe4lt f\xf6r utg\xe5ngs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r kort","creditCard.encryptedSecurityCode.aria.label":"F\xe4lt f\xf6r s\xe4kerhetskod","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat presentkortsnummer","giftcard.encryptedCardNumber.aria.label":"F\xe4lt f\xf6r presentkortsnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r presentkort","giftcard.encryptedSecurityCode.aria.label":"F\xe4lt f\xf6r s\xe4kerhetskod f\xf6r presentkort",giftcardTransactionLimit:"Maximalt %{amount} per transaktion \xe4r till\xe5tet p\xe5 detta presentkort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"F\xe4lt f\xf6r bankkontonummer","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xf6r s\xe4krat clearingnummer","ach.encryptedBankLocationId.aria.label":"F\xe4lt f\xf6r clearingnummer","twint.saved":"sparat"}}),sC=Object.freeze({__proto__:null,default:{payButton:"\u652f\u4ed8","payButton.redirecting":"\u6b63\u5728\u91cd\u5b9a\u5411...",storeDetails:"\u4fdd\u5b58\u4ee5\u4fbf\u4e0b\u6b21\u652f\u4ed8\u4f7f\u7528","creditCard.holderName":"\u5361\u7247\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u59d3\u540d","creditCard.numberField.title":"\u5361\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u6548\u671f","creditCard.expiryDateField.placeholder":"\u6708\u6708/\u5e74\u5e74","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"\u6708\u6708","creditCard.expiryDateField.year.placeholder":"\u5e74\u5e74","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8bb0\u4f4f\u4ee5\u4fbf\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6570","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6570","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5 / 0123456789",installments:"\u5206\u671f\u4ed8\u6b3e\u671f\u6570",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} \u4e2a\u6708","installments.oneTime":"\u5168\u6b3e\u652f\u4ed8","installments.installments":"\u5206\u671f\u652f\u4ed8","installments.revolving":"\u5faa\u73af\u652f\u4ed8","sepaDirectDebit.ibanField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u5361\u4eba\u59d3\u540d","sepa.ibanNumber":"\u8d26\u53f7 (IBAN)","error.title":"\u9519\u8bef","error.subtitle.redirect":"\u91cd\u5b9a\u5411\u5931\u8d25","error.subtitle.payment":"\u652f\u4ed8\u5931\u8d25","error.subtitle.refused":"\u652f\u4ed8\u88ab\u62d2","error.message.unknown":"\u53d1\u751f\u672a\u77e5\u9519\u8bef","idealIssuer.selectField.title":"\u94f6\u884c","idealIssuer.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","creditCard.success":"\u652f\u4ed8\u6210\u529f",loading:"\u6b63\u5728\u52a0\u8f7d...",continue:"\u7ee7\u7eed",continueTo:"\u7ee7\u7eed\u81f3","wechatpay.timetopay":"\u60a8\u9700\u8981\u652f\u4ed8 %@","wechatpay.scanqrcode":"\u626b\u63cf\u4e8c\u7ef4\u7801",personalDetails:"\u4e2a\u4eba\u8be6\u7ec6\u4fe1\u606f",companyDetails:"\u516c\u53f8\u8be6\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u79f0","companyDetails.registrationNumber":"\u6ce8\u518c\u53f7",socialSecurityNumber:"\u793e\u4f1a\u4fdd\u9669\u53f7\u7801",firstName:"\u540d\u5b57",infix:"\u524d\u7f00",lastName:"\u59d3\u6c0f",mobileNumber:"\u624b\u673a\u53f7","mobileNumber.invalid":"\u65e0\u6548\u7684\u624b\u673a\u53f7\u7801",city:"\u57ce\u5e02",postalCode:"\u90ae\u653f\u7f16\u7801",countryCode:"\u56fd\u5bb6\u4ee3\u7801",telephoneNumber:"\u7535\u8bdd\u53f7\u7801",dateOfBirth:"\u51fa\u751f\u65e5\u671f",shopperEmail:"\u7535\u5b50\u90ae\u4ef6\u5730\u5740",gender:"\u6027\u522b",male:"\u7537",female:"\u5973",billingAddress:"\u8d26\u5355\u5730\u5740",street:"\u8857\u9053",stateOrProvince:"\u5dde\u6216\u7701",country:"\u56fd\u5bb6/\u5730\u533a",houseNumberOrName:"\u95e8\u724c\u53f7",separateDeliveryAddress:"\u6307\u5b9a\u4e00\u4e2a\u5355\u72ec\u7684\u5bc4\u9001\u5730\u5740",deliveryAddress:"\u5bc4\u9001\u5730\u5740",zipCode:"\u90ae\u653f\u7f16\u7801",apartmentSuite:"\u516c\u5bd3 / \u5957\u623f",provinceOrTerritory:"\u7701\u6216\u5730\u533a",cityTown:"\u5e02 / \u9547",address:"\u5730\u5740",state:"\u5dde","field.title.optional":"\uff08\u53ef\u9009\uff09","creditCard.cvcField.title.optional":"CVC / CVV\uff08\u53ef\u9009\uff09","issuerList.wallet.placeholder":"\u9009\u62e9\u60a8\u7684\u94b1\u5305",privacyPolicy:"\u9690\u79c1\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684 %@",paymentConditions:"\u652f\u4ed8\u6761\u4ef6",openApp:"\u6253\u5f00\u5e94\u7528","voucher.readInstructions":"\u9605\u8bfb\u8bf4\u660e","voucher.introduction":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4f18\u60e0\u5238\u5b8c\u6210\u652f\u4ed8\u3002","voucher.expirationDate":"\u6709\u6548\u671f","voucher.alternativeReference":"\u5907\u9009\u4ee3\u7801","dragonpay.voucher.non.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u63d0\u4f9b\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","voucher.paymentReferenceLabel":"\u4ea4\u6613\u53f7","voucher.surcharge":"\u5305\u62ec %@ \u7684\u9644\u52a0\u8d39","voucher.introduction.doku":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.shopperName":"\u987e\u5ba2\u59d3\u540d","voucher.merchantName":"\u5546\u6237","voucher.introduction.econtext":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.telephoneNumber":"\u7535\u8bdd\u53f7\u7801","voucher.shopperReference":"\u987e\u5ba2\u53c2\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u673a\u6784\u7f16\u53f7","voucher.econtext.telephoneNumber.invalid":"\u7535\u8bdd\u53f7\u7801\u5fc5\u987b\u4e3a 10 \u6216 11 \u4f4d\u6570\u5b57","boletobancario.btnLabel":"\u751f\u6210 Boleto","boleto.sendCopyToEmail":"\u5c06\u526f\u672c\u53d1\u9001\u5230\u6211\u7684\u7535\u5b50\u90ae\u7bb1","button.copy":"\u590d\u5236","button.download":"\u4e0b\u8f7d","creditCard.storedCard.description.ariaLabel":"\u5b58\u50a8\u7684\u5361\u7247\u4ee5 \uff05@ \u7ed3\u5c3e","voucher.entity":"\u5b9e\u4f53",donateButton:"\u6350\u8d60",notNowButton:"\u6682\u4e0d",thanksForYourSupport:"\u611f\u8c22\u60a8\u7684\u652f\u6301\uff01",preauthorizeWith:"\u9884\u5148\u6388\u6743",confirmPreauthorization:"\u786e\u8ba4\u9884\u5148\u6388\u6743",confirmPurchase:"\u786e\u8ba4\u8d2d\u4e70",applyGiftcard:"\u5151\u6362",giftcardBalance:"\u793c\u54c1\u5361\u4f59\u989d",deductedBalance:"\u6263\u51cf\u4f59\u989d","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"\u5361\u7247\u5bc6\u7801\u7684\u524d 2 \u4f4d\u6570","creditCard.encryptedPassword.invalid":"\u65e0\u6548\u7684\u5bc6\u7801","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5 (YYMMDD) \u6216\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u6ce8\u518c\u53f7","storedPaymentMethod.disable.button":"\u5220\u9664","storedPaymentMethod.disable.confirmation":"\u5220\u9664\u5b58\u50a8\u7684\u652f\u4ed8\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u5220\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u94f6\u884c\u8d26\u6237","ach.accountHolderNameField.title":"\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u65e0\u6548\u7684\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountNumberField.title":"\u8d26\u53f7","ach.accountNumberField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","ach.accountLocationField.title":"ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","ach.accountLocationField.invalid":"\u65e0\u6548\u7684 ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","select.state":"\u9009\u62e9\u5dde","select.stateOrProvince":"\u9009\u62e9\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9009\u62e9\u7701\u6216\u5730\u533a","select.country":"\u9009\u62e9\u56fd\u5bb6/\u5730\u533a","select.noOptionsFound":"\u672a\u627e\u5230\u4efb\u4f55\u9009\u9879","select.filter.placeholder":"\u641c\u7d22\u2026\u2026","telephoneNumber.invalid":"\u65e0\u6548\u7684\u7535\u8bdd\u53f7\u7801",qrCodeOrApp:"\u6216\u8005","paypal.processingPayment":"\u6b63\u5728\u5904\u7406\u4ed8\u6b3e...",generateQRCode:"\u751f\u6210\u4e8c\u7ef4\u7801","await.waitForConfirmation":"\u7b49\u5f85\u786e\u8ba4","mbway.confirmPayment":"\u5728 MB WAY \u5e94\u7528\u4e0a\u786e\u8ba4\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u65e0\u6548\u7684\u90ae\u4ef6\u5730\u5740","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"\u60a8\u5fc5\u987b\u5e74\u6ee1 18 \u5468\u5c81","blik.confirmPayment":"\u6253\u5f00\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4ee5\u786e\u8ba4\u652f\u4ed8\u3002","blik.invalid":"\u8f93\u5165 6 \u4f4d\u6570","blik.code":"6 \u4f4d\u6570\u4ee3\u7801","blik.help":"\u4ece\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4e2d\u83b7\u53d6\u4ee3\u7801\u3002","swish.pendingMessage":"\u626b\u63cf\u540e\uff0c\u72b6\u6001\u53ef\u80fd\u4f1a\u4fdd\u6301\u6700\u591a 10 \u5206\u949f\u3002\u5728\u6b64\u65f6\u95f4\u5185\u518d\u6b21\u5c1d\u8bd5\u4ed8\u6b3e\u53ef\u80fd\u4f1a\u5bfc\u81f4\u591a\u6b21\u6536\u8d39\u3002","error.va.gen.01":"\u4e0d\u5b8c\u6574\u5b57\u6bb5","error.va.gen.02":"\u65e0\u6548\u5b57\u6bb5","error.va.sf-cc-num.01":"\u65e0\u6548\u7684\u5361\u53f7","error.va.sf-cc-num.03":"\u4e0d\u652f\u6301\u8f93\u5165\u7684\u5361\u7247","error.va.sf-cc-dat.01":"\u5361\u7247\u592a\u65e7","error.va.sf-cc-dat.02":"\u65e5\u671f\u592a\u4e45\u8fdc","error.va.sf-cc-dat.03":"\u60a8\u7684\u5361\u5728\u7ed3\u8d26\u65e5\u671f\u524d\u5df2\u8fc7\u671f","error.va.sf-ach-num.01":"\u65e0\u6548\u7684\u8d26\u53f7","error.va.sf-ach-loc.01":"\u65e0\u6548\u7684 ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","error.va.sf-kcp-pwd.01":"\u65e0\u6548\u7684\u5bc6\u7801","error.giftcard.no-balance":"\u793c\u54c1\u5361\u4f59\u989d\u4e3a\u96f6","error.giftcard.card-error":"\u6211\u4eec\u7684\u6570\u636e\u5e93\u4e2d\u6ca1\u6709\u8fd9\u4e2a\u53f7\u7801\u7684\u793c\u54c1\u5361","error.giftcard.currency-error":"\u793c\u54c1\u5361\u4ec5\u4ee5\u5176\u53d1\u884c\u7684\u8d27\u5e01\u4e3a\u6709\u6548\u8d27\u5e01","amazonpay.signout":"\u9000\u51fa Amazon","amazonpay.changePaymentDetails":"\u66f4\u6539\u652f\u4ed8\u8be6\u60c5","partialPayment.warning":"\u8bf7\u9009\u62e9\u5176\u4ed6\u652f\u4ed8\u65b9\u5f0f\u652f\u4ed8\u5269\u4f59\u6b3e\u9879","partialPayment.remainingBalance":"\u5269\u4f59\u989d\u5ea6\u4e3a %{amount}","bankTransfer.beneficiary":"\u6536\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"\u4e2d\u56fd\u5de5\u5546\u94f6\u884c","bankTransfer.reference":"\u53c2\u8003","bankTransfer.introduction":"\u7ee7\u7eed\u65b0\u5efa\u94f6\u884c\u8f6c\u8d26\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u5c4f\u5e55\u4e2d\u7684\u8be6\u7ec6\u4fe1\u606f\u6765\u5b8c\u6210\u8fd9\u7b14\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","bacs.accountHolderName":"\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountNumber":"\u94f6\u884c\u8d26\u53f7","bacs.accountNumber.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u53f7","bacs.bankLocationId":"\u5206\u7c7b\u4ee3\u7801","bacs.bankLocationId.invalid":"\u65e0\u6548\u7684\u5206\u7c7b\u4ee3\u7801","bacs.consent.amount":"\u6211\u540c\u610f\u4ece\u94f6\u884c\u8d26\u6237\u4e2d\u6263\u9664\u4e0a\u8ff0\u91d1\u989d\u3002","bacs.consent.account":"\u6211\u786e\u8ba4\u8be5\u8d26\u6237\u4e3a\u6211\u540d\u4e0b\u7684\u8d26\u6237\uff0c\u5e76\u4e14\u6211\u662f\u6388\u6743\u8be5\u8d26\u6237\u76f4\u63a5\u501f\u8bb0\u7684\u552f\u4e00\u7b7e\u7f72\u4eba\u3002",edit:"\u7f16\u8f91","bacs.confirm":"\u786e\u8ba4\u5e76\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f7d\u60a8\u7684\u76f4\u63a5\u501f\u8bb0\u6307\u793a\uff08DDI/\u59d4\u6258\uff09","download.pdf":"\u4e0b\u8f7d PDF \u6587\u4ef6","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u53f7 Iframe","creditCard.encryptedCardNumber.aria.label":"\u5361\u53f7\u5b57\u6bb5","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u65e5\u671f Iframe","creditCard.encryptedExpiryDate.aria.label":"\u8fc7\u671f\u65e5\u671f\u5b57\u6bb5","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u6708\u4efd Iframe","creditCard.encryptedExpiryMonth.aria.label":"\u8fc7\u671f\u6708\u4efd\u5b57\u6bb5","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u5e74\u4efd Iframe","creditCard.encryptedExpiryYear.aria.label":"\u8fc7\u671f\u5e74\u4efd\u5b57\u6bb5","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u5b89\u5168\u7801 Iframe","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u7801\u5b57\u6bb5","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u53f7 Iframe","giftcard.encryptedCardNumber.aria.label":"\u793c\u54c1\u5361\u53f7\u5b57\u6bb5","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u5b89\u5168\u7801 Iframe","giftcard.encryptedSecurityCode.aria.label":"\u793c\u54c1\u5361\u5b89\u5168\u7801\u5b57\u6bb5",giftcardTransactionLimit:"\u6b64\u793c\u54c1\u5361\u4e0a\u6bcf\u7b14\u4ea4\u6613\u5141\u8bb8\u7684\u6700\u5927\u91d1\u989d\u4e3a %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8d26\u53f7 Iframe","ach.encryptedBankAccountNumber.aria.label":"\u94f6\u884c\u8d26\u53f7\u5b57\u6bb5","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801 Iframe","ach.encryptedBankLocationId.aria.label":"\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801\u5b57\u6bb5","twint.saved":"\u5df2\u4fdd\u5b58"}}),lC=Object.freeze({__proto__:null,default:{payButton:"\u652f\u4ed8","payButton.redirecting":"\u91cd\u65b0\u5c0e\u5411\u4e2d......",storeDetails:"\u5132\u5b58\u4ee5\u4f9b\u4e0b\u6b21\u4ed8\u6b3e\u4f7f\u7528","creditCard.holderName":"\u4fe1\u7528\u5361\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u6301\u5361\u4eba\u59d3\u540d\u7121\u6548","creditCard.numberField.title":"\u4fe1\u7528\u5361\u865f\u78bc","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u5230\u671f\u65e5\u671f","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708\u4efd","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74\u4efd","creditCard.cvcField.title":"\u4fe1\u7528\u5361\u9a57\u8b49\u78bc / \u4fe1\u7528\u5361\u5b89\u5168\u78bc","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8a18\u4f4f\u4f9b\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6578","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6578","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff0f0123456789",installments:"\u5206\u671f\u4ed8\u6b3e\u7684\u671f\u6578",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"\uff05{times} \u500b\u6708","installments.oneTime":"\u4e00\u6b21\u6027\u4ed8\u6b3e","installments.installments":"\u5206\u671f\u4ed8\u6b3e","installments.revolving":"\u5ef6\u671f\u4ed8\u6b3e","sepaDirectDebit.ibanField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u6709\u4eba\u540d\u7a31","sepa.ibanNumber":"\u5e33\u6236\u865f\u78bc (IBAN)","error.title":"\u932f\u8aa4","error.subtitle.redirect":"\u7121\u6cd5\u91cd\u65b0\u5c0e\u5411","error.subtitle.payment":"\u4ed8\u6b3e\u5931\u6557","error.subtitle.refused":"\u4ed8\u6b3e\u906d\u62d2\u7d55","error.message.unknown":"\u767c\u751f\u672a\u77e5\u932f\u8aa4","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","creditCard.success":"\u4ed8\u6b3e\u6210\u529f",loading:"\u6b63\u5728\u8f09\u5165...",continue:"\u7e7c\u7e8c",continueTo:"\u7e7c\u7e8c\u524d\u5f80","wechatpay.timetopay":"\u60a8\u6709 %@ \u53ef\u4ee5\u652f\u4ed8","wechatpay.scanqrcode":"\u6383\u63cf QR \u4ee3\u78bc",personalDetails:"\u500b\u4eba\u8a73\u7d30\u8cc7\u6599",companyDetails:"\u516c\u53f8\u8a73\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u7a31","companyDetails.registrationNumber":"\u8a3b\u518a\u865f\u78bc",socialSecurityNumber:"\u793e\u6703\u5b89\u5168\u78bc",firstName:"\u540d\u5b57",infix:"\u524d\u7db4",lastName:"\u59d3\u6c0f",mobileNumber:"\u884c\u52d5\u96fb\u8a71\u865f\u78bc","mobileNumber.invalid":"\u624b\u6a5f\u865f\u78bc\u7121\u6548",city:"\u57ce\u5e02",postalCode:"\u90f5\u905e\u5340\u865f",countryCode:"\u570b\u5bb6\u4ee3\u78bc",telephoneNumber:"\u96fb\u8a71\u865f\u78bc",dateOfBirth:"\u51fa\u751f\u65e5\u671f",shopperEmail:"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740",gender:"\u6027\u5225",male:"\u7537",female:"\u5973",billingAddress:"\u5e33\u55ae\u5730\u5740",street:"\u8857\u9053",stateOrProvince:"\u5dde/\u7e23/\u5e02",country:"\u570b\u5bb6/\u5730\u5340",houseNumberOrName:"\u9580\u724c\u865f",separateDeliveryAddress:"\u6307\u5b9a\u53e6\u4e00\u500b\u6d3e\u9001\u5730\u5740",deliveryAddress:"\u6d3e\u9001\u5730\u5740",zipCode:"\u90f5\u905e\u5340\u865f",apartmentSuite:"\u516c\u5bd3\uff0f\u5957\u623f",provinceOrTerritory:"\u7701\u6216\u5730\u5340",cityTown:"\u5e02\uff0f\u93ae",address:"\u5730\u5740",state:"\u5dde","field.title.optional":"\uff08\u9078\u7528\uff09","creditCard.cvcField.title.optional":"CVC / CVV (\u53ef\u9078)","issuerList.wallet.placeholder":"\u9078\u53d6\u60a8\u7684\u96fb\u5b50\u9322\u5305",privacyPolicy:"\u96b1\u79c1\u6b0a\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684%@",paymentConditions:"\u4ed8\u6b3e\u7d30\u5247",openApp:"\u958b\u555f\u61c9\u7528\u7a0b\u5f0f","voucher.readInstructions":"\u95b1\u89bd\u8aaa\u660e","voucher.introduction":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u512a\u60e0\u5238\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.expirationDate":"\u5230\u671f\u65e5\u671f","voucher.alternativeReference":"\u5099\u9078\u53c3\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u9078\u64c7\u60a8\u7684\u4f9b\u61c9\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","voucher.paymentReferenceLabel":"\u4ed8\u6b3e\u53c3\u7167\u865f\u78bc","voucher.surcharge":"\u5305\u542b %@ \u9644\u52a0\u8cbb","voucher.introduction.doku":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.shopperName":"\u8cfc\u7269\u8005\u59d3\u540d","voucher.merchantName":"\u5546\u5bb6","voucher.introduction.econtext":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u865f\u78bc","voucher.shopperReference":"\u8cfc\u7269\u8005\u53c3\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u6a5f\u69cb\u7de8\u865f","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7684\u9577\u5ea6\u5fc5\u9808\u70ba 10 \u6216 11 \u4f4d\u6578","boletobancario.btnLabel":"\u7522\u751f Boleto","boleto.sendCopyToEmail":"\u5c07\u8907\u672c\u50b3\u9001\u81f3\u6211\u7684\u96fb\u5b50\u90f5\u4ef6","button.copy":"\u8907\u88fd","button.download":"\u4e0b\u8f09","creditCard.storedCard.description.ariaLabel":"\u5df2\u5132\u5b58\u4ee5 %@ \u7d50\u5c3e\u7684\u4fe1\u7528\u5361","voucher.entity":"\u5be6\u9ad4",donateButton:"\u6350\u8d08",notNowButton:"\u7a0d\u5f8c\u518d\u8aaa",thanksForYourSupport:"\u611f\u8b1d\u60a8\u7684\u652f\u6301\uff01",preauthorizeWith:"\u900f\u904e\u4ee5\u4e0b\u65b9\u5f0f\u9032\u884c\u9810\u5148\u6388\u6b0a\uff1a",confirmPreauthorization:"\u78ba\u8a8d\u9810\u5148\u6388\u6b0a",confirmPurchase:"\u78ba\u8a8d\u8cfc\u8cb7",applyGiftcard:"\u514c\u63db",giftcardBalance:"\u79ae\u54c1\u5361\u9918\u984d",deductedBalance:"\u6263\u9664\u9918\u984d","creditCard.pin.title":"\u6578\u5b57\u5bc6\u78bc","creditCard.encryptedPassword.label":"\u5361\u5bc6\u78bc\u7684\u524d 2 \u4f4d\u6578\u5b57","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u5bc6\u78bc\u7121\u6548","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5\uff08\u5e74\u6708\u65e5\uff09\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.invalid":"\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\u7121\u6548","storedPaymentMethod.disable.button":"\u79fb\u9664","storedPaymentMethod.disable.confirmation":"\u79fb\u9664\u5df2\u5132\u5b58\u4ed8\u6b3e\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u8acb\u79fb\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u9280\u884c\u5e33\u6236","ach.accountHolderNameField.title":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","ach.accountNumberField.title":"\u5e33\u6236\u865f\u78bc","ach.accountNumberField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","ach.accountLocationField.title":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f","ach.accountLocationField.invalid":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7121\u6548","select.state":"\u9078\u53d6\u5dde","select.stateOrProvince":"\u9078\u64c7\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9078\u53d6\u7701\u6216\u5730\u5340","select.country":"\u9078\u64c7\u570b\u5bb6\uff0f\u5730\u5340","select.noOptionsFound":"\u627e\u4e0d\u5230\u4efb\u4f55\u9078\u9805","select.filter.placeholder":"\u641c\u5c0b\u2026\u2026","telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7121\u6548",qrCodeOrApp:"\u6216","paypal.processingPayment":"\u6b63\u5728\u8655\u7406\u4ed8\u6b3e\u2026\u2026",generateQRCode:"\u7522\u751f QR \u4ee3\u78bc","await.waitForConfirmation":"\u6b63\u5728\u7b49\u5019\u78ba\u8a8d","mbway.confirmPayment":"\u5728 MB WAY \u61c9\u7528\u7a0b\u5f0f\u4e0a\u78ba\u8a8d\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740\u7121\u6548","dateOfBirth.format":"\u65e5\uff0f\u6708\uff0f\u5e74","dateOfBirth.invalid":"\u60a8\u5fc5\u9808\u5e74\u6eff 18 \u6b72","blik.confirmPayment":"\u958b\u555f\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4ee5\u78ba\u8a8d\u4ed8\u6b3e\u3002","blik.invalid":"\u8f38\u5165 6 \u500b\u6578\u5b57","blik.code":"6 \u4f4d\u6578\u4ee3\u78bc","blik.help":"\u5f9e\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4e2d\u7372\u53d6\u4ee3\u78bc\u3002","swish.pendingMessage":"\u6383\u63cf\u5f8c\uff0c\u8a72\u5f85\u5b8c\u6210\u72c0\u614b\u53ef\u80fd\u6301\u7e8c\u9577\u9054 10 \u5206\u9418\u3002\u8a66\u5716\u5728\u9019\u6bb5\u6642\u9593\u5167\u518d\u6b21\u4ed8\u6b3e\u53ef\u80fd\u6703\u5c0e\u81f4\u591a\u91cd\u6536\u8cbb\u3002","error.va.gen.01":"\u4e0d\u5b8c\u6574\u6b04\u4f4d","error.va.gen.02":"\u6b04\u4f4d\u7121\u6548","error.va.sf-cc-num.01":"\u4fe1\u7528\u5361\u865f\u78bc\u7121\u6548","error.va.sf-cc-num.03":"\u8f38\u5165\u4e86\u4e0d\u652f\u63f4\u7684\u5361","error.va.sf-cc-dat.01":"\u5361\u592a\u820a","error.va.sf-cc-dat.02":"\u672a\u4f86\u65e5\u671f\u8ddd\u4eca\u592a\u4e45","error.va.sf-cc-dat.03":"\u60a8\u7684\u5361\u6703\u65bc\u4ed8\u6b3e\u65e5\u671f\u524d\u5230\u671f","error.va.sf-ach-num.01":"\u5e33\u6236\u865f\u78bc\u7121\u6548","error.va.sf-ach-loc.01":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7121\u6548","error.va.sf-kcp-pwd.01":"\u5bc6\u78bc\u7121\u6548","error.giftcard.no-balance":"\u6b64\u79ae\u54c1\u5361\u7684\u9918\u984d\u70ba\u96f6","error.giftcard.card-error":"\u6211\u5011\u7684\u8a18\u9304\u4e2d\u4e26\u6c92\u6709\u9019\u500b\u865f\u78bc\u7684\u79ae\u54c1\u5361","error.giftcard.currency-error":"\u79ae\u54c1\u5361\u53ea\u80fd\u4ee5\u5176\u7c3d\u767c\u6642\u6240\u4f7f\u7528\u7684\u8ca8\u5e63\u9032\u884c\u7d50\u7b97","amazonpay.signout":"\u5f9e Amazon \u767b\u51fa","amazonpay.changePaymentDetails":"\u8b8a\u66f4\u4ed8\u6b3e\u660e\u7d30","partialPayment.warning":"\u9078\u53d6\u5176\u4ed6\u4ed8\u6b3e\u65b9\u5f0f\u4f86\u652f\u4ed8\u9918\u984d","partialPayment.remainingBalance":"\u9918\u984d\u5c07\u70ba %{amount}","bankTransfer.beneficiary":"\u53d7\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c3\u7167","bankTransfer.introduction":"\u7e7c\u7e8c\u5efa\u7acb\u65b0\u7684\u9280\u884c\u8f49\u5e33\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u87a2\u5e55\u4e2d\u7684\u8a73\u7d30\u8cc7\u8a0a\u4f86\u5b8c\u6210\u6b64\u9805\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","bacs.accountHolderName":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","bacs.accountNumber":"\u9280\u884c\u5e33\u6236\u865f\u78bc","bacs.accountNumber.invalid":"\u9280\u884c\u5e33\u6236\u865f\u78bc\u7121\u6548","bacs.bankLocationId":"\u9280\u884c\u4ee3\u78bc","bacs.bankLocationId.invalid":"\u9280\u884c\u4ee3\u78bc\u7121\u6548","bacs.consent.amount":"\u6211\u540c\u610f\u5f9e\u6211\u7684\u9280\u884c\u5e33\u6236\u6263\u9664\u4e0a\u8ff0\u91d1\u984d\u3002","bacs.consent.account":"\u6211\u78ba\u8a8d\u8a72\u5e33\u6236\u4ee5\u6211\u7684\u540d\u7fa9\u958b\u8a2d\uff0c\u4e26\u4e14\u6211\u662f\u6388\u6b0a\u5f9e\u8a72\u5e33\u6236\u76f4\u63a5\u6263\u6b3e\u7684\u552f\u4e00\u7c3d\u7f72\u4eba\u3002",edit:"\u7de8\u8f2f","bacs.confirm":"\u78ba\u8a8d\u4e26\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f09\u60a8\u7684\u76f4\u63a5\u6263\u6b3e\u6307\u793a\uff08DDI\uff0f\u6388\u6b0a\uff09","download.pdf":"\u4e0b\u8f09 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u865f\u7684 IFrame","creditCard.encryptedCardNumber.aria.label":"\u5361\u865f\u6b04\u4f4d","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u65e5\u671f\u7684 IFrame","creditCard.encryptedExpiryDate.aria.label":"\u5230\u671f\u65e5\u671f\u6b04\u4f4d","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u6708\u4efd\u7684 IFrame","creditCard.encryptedExpiryMonth.aria.label":"\u5230\u671f\u6708\u4efd\u6b04\u4f4d","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u5e74\u4efd\u7684 IFrame","creditCard.encryptedExpiryYear.aria.label":"\u5230\u671f\u5e74\u4efd\u6b04\u4f4d","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u5b89\u5168\u78bc\u7684 IFrame","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u78bc\u6b04\u4f4d","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u865f\u7684 IFrame","giftcard.encryptedCardNumber.aria.label":"\u79ae\u54c1\u5361\u865f\u6b04\u4f4d","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u5b89\u5168\u78bc\u7684 IFrame","giftcard.encryptedSecurityCode.aria.label":"\u79ae\u54c1\u5361\u5b89\u5168\u78bc\u6b04\u4f4d",giftcardTransactionLimit:"\u6b64\u79ae\u54c1\u5361\u6bcf\u7b46\u4ea4\u6613\u7684\u91d1\u984d\u4e0a\u9650\u70ba %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u5e33\u6236\u865f\u78bc\u7684 IFrame","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u5e33\u6236\u6b04\u4f4d","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7684 IFrame","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u6b04\u4f4d","twint.saved":"\u5132\u5b58\u7684"}});return function(e){return n(this,void 0,void 0,(function(){return o(this,(function(t){switch(t.label){case 0:return[4,new Ok(e).initialize()];case 1:return[2,t.sent()]}}))}))}}));
	//# sourceMappingURL=adyen.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 563 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 564 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	var bind = __webpack_require__(238);
	var Axios = __webpack_require__(567);
	var defaults = __webpack_require__(156);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(235);
	axios.CancelToken = __webpack_require__(566);
	axios.isCancel = __webpack_require__(236);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(581);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(235);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(156);
	var utils = __webpack_require__(35);
	var InterceptorManager = __webpack_require__(568);
	var dispatchRequest = __webpack_require__(569);
	var isAbsoluteURL = __webpack_require__(577);
	var combineURLs = __webpack_require__(575);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	var transformData = __webpack_require__(572);
	var isCancel = __webpack_require__(236);
	var defaults = __webpack_require__(156);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 570 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(237);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 573 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 575 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 577 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(35);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 581 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAddress = getAddress;
	exports.getProvinces = getProvinces;
	exports.getCities = getCities;
	exports.getDistricts = getDistricts;
	exports.getRegions = getRegions;
	exports.addAddress = addAddress;
	exports.editAddress = editAddress;
	exports.deleteAddress = deleteAddress;
	exports.setDefaultAddress = setDefaultAddress;
	exports.resetLocationCalls = resetLocationCalls;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	var f3Url = _CommonConstants2.default.Actions.f3;
	
	function getAddress(token) {
	    return function (dispatch) {
	        dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	        _axios2.default.get(apiUrl + 'address', {
	            token: token
	        }).then(function (response) {
	            dispatch({ type: 'GET_ADDRESS_FULFILLED', payload: response.data });
	        }).catch(function (err) {
	            dispatch({ type: 'ADDRESS_REJECTED', payload: err });
	        });
	    };
	}
	
	function getProvinces() {
	    var cc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PH';
	
	    return function (dispatch) {
	        _axios2.default.get(f3Url + 'locations/countries/' + cc + '/provinces?per_page=0').then(function (response) {
	            dispatch({ type: 'GET_PROVINCE_FULFILLED', payload: response.data });
	        }).catch(function (err) {
	            dispatch({ type: 'GET_PROVINCE_REJECTED', payload: err });
	        });
	    };
	}
	
	function getCities(id) {
	    return function (dispatch) {
	        dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	        if (id) {
	            _axios2.default.get(f3Url + 'locations/provinces/' + id + '/cities?per_page=0').then(function (response) {
	                dispatch({ type: 'GET_CITY_FULFILLED', payload: response.data });
	            }).catch(function (err) {
	                dispatch({ type: 'GET_CITY_REJECTED', payload: err });
	            });
	        }
	    };
	}
	
	function getDistricts(id) {
	    return function (dispatch) {
	        if (id) {
	            _axios2.default.get(f3Url + 'locations/cities/' + id + '/districts?per_page=0').then(function (response) {
	                dispatch({ type: 'GET_DISTRICT_FULFILLED', payload: response.data });
	            }).catch(function (err) {
	                dispatch({ type: 'GET_DISTRICT_REJECTED', payload: err });
	            });
	        }
	    };
	}
	
	function getRegions() {
	    return function (dispatch) {
	        _axios2.default.get(f3Url + 'locations/regions').then(function (response) {
	            dispatch({ type: 'GET_REGION_FULFILLED', payload: response.data });
	        }).catch(function (err) {
	            dispatch({ type: 'GET_REGION_REJECTED', payload: err });
	        });
	    };
	}
	
	function addAddress(parameters) {
	    return function (dispatch) {
	        dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	        return _axios2.default.post(apiUrl + 'addresses', {
	            "data": {
	                "type": "addresses",
	                "attributes": {
	                    "first_name": parameters.first_name,
	                    "last_name": parameters.last_name,
	                    "middle_initial": "",
	                    "line_1": parameters.line_1,
	                    "line_2": parameters.line_2,
	                    "city": parameters.city,
	                    "postal_code": parameters.postal_code,
	                    "region": parameters.region,
	                    "state": parameters.state,
	                    "type": "delivery",
	                    "country_code": parameters.country_code,
	                    "phone_number": parameters.phone_number
	                }
	            }
	        }).then(function (response) {
	            dispatch({ type: 'ADD_ADDRESS_FULFILLED', payload: response.data });
	            return response;
	        }).catch(function (err) {
	            dispatch({ type: 'ADDRESS_REJECTED', payload: err });
	            return err;
	        });
	    };
	}
	
	function editAddress(id, parameters) {
	    return function (dispatch) {
	        dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	        _axios2.default.put(apiUrl + 'addresses/' + id, {
	            "data": {
	                "type": "addresses",
	                "attributes": {
	                    "first_name": parameters.first_name,
	                    "last_name": parameters.last_name,
	                    "middle_initial": "",
	                    "line_1": parameters.line_1,
	                    "line_2": parameters.line_2,
	                    "city": parameters.city,
	                    "postal_code": parameters.postal_code,
	                    "region": parameters.region,
	                    "state": parameters.state,
	                    "type": "delivery",
	                    "country_code": parameters.country_code,
	                    "phone_number": parameters.phone_number
	                }
	            }
	        }).then(function (response) {
	            dispatch({ type: 'UPDATE_ADDRESS_FULFILLED', payload: response.data });
	        }).catch(function (err) {
	            dispatch({ type: 'ADDRESS_REJECTED', payload: err });
	        });
	    };
	}
	
	function deleteAddress(id) {
	    return function (dispatch) {
	        dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	        return _axios2.default.delete(apiUrl + 'addresses/' + id).then(function (response) {
	            dispatch({ type: 'DELETE_ADDRESS_FULFILLED', payload: response.data, address_id: id });
	            return response;
	        }).catch(function (err) {
	            dispatch({ type: 'ADDRESS_REJECTED', payload: err });
	        });
	    };
	}
	
	function setDefaultAddress(addressId) {
	    return function (dispatch) {
	        dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
	        _axios2.default.put(apiUrl + 'users/update-default-address', {
	            "data": {
	                "type": "user-update-default-address",
	                "attributes": {
	                    "address_id": addressId
	                }
	            }
	        }).then(function (response) {
	            dispatch({ type: 'DEFAULT_ADDRESS_FULFILLED', payload: response.data });
	        }).catch(function (err) {
	            dispatch({ type: 'ADDRESS_REJECTED', payload: err });
	        });
	    };
	}
	
	function resetLocationCalls(find) {
	    // 'GET_DISTRICT_FULFILLED'
	    // 'GET_CITY_FULFILLED'
	    return function (dispatch) {
	        dispatch({
	            type: find,
	            payload: false
	        });
	    };
	}

/***/ },
/* 583 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.showCancelledPayment = showCancelledPayment;
	exports.showErrorOnPayment = showErrorOnPayment;
	exports.clearCartMessages = clearCartMessages;
	exports.showInvalidTransactionError = showInvalidTransactionError;
	exports.updateShipmentLocations = updateShipmentLocations;
	function showCancelledPayment() {
	    return function (dispatch) {
	        dispatch({ type: 'SHOW_CANCELLED_PAYMENT_MESSAGE' });
	    };
	}
	
	function showErrorOnPayment() {
	    return function (dispatch) {
	        dispatch({ type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE' });
	    };
	}
	
	function clearCartMessages() {
	    return function (dispatch) {
	        dispatch({ type: 'CLEAR_CART_MESSAGES' });
	    };
	}
	
	function showInvalidTransactionError() {
	    return function (dispatch) {
	        dispatch({ type: 'SHOW_INVALID_TRANSACTION_ERROR' });
	    };
	}
	
	function updateShipmentLocations(location, types, shipment_location_details) {
	    return function (dispatch) {
	        if (types === "origin") {
	            dispatch({ type: 'CLEAR_CHECKOUT_FULFILLED' });
	            dispatch({ type: 'UPDATE_SHIPMENT_LOCATION_DETAILS',
	                origin: location,
	                destination: shipment_location_details.destination });
	        } else {
	            dispatch({ type: 'UPDATE_SHIPMENT_LOCATION_DETAILS',
	                origin: shipment_location_details.origin,
	                destination: location });
	        }
	    };
	}

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(126);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.checkOut = checkOut;
	exports.checkOutPayAirAndSea = checkOutPayAirAndSea;
	exports.checkOutPayAir = checkOutPayAir;
	exports.checkOutPaySea = checkOutPaySea;
	exports.checkOutAdyenDropin = checkOutAdyenDropin;
	exports.checkOutPayAirAndSeaPromo = checkOutPayAirAndSeaPromo;
	exports.checkOutPayAirPromo = checkOutPayAirPromo;
	exports.checkOutPaySeaPromo = checkOutPaySeaPromo;
	exports.getCheckOut = getCheckOut;
	exports.getCheck = getCheck;
	exports.clearCheck = clearCheck;
	exports.resetComputed = resetComputed;
	exports.clearPromoError = clearPromoError;
	exports.showEmptyItemOnCheckout = showEmptyItemOnCheckout;
	exports.setPayment = setPayment;
	exports.setCheckoutDetails = setCheckoutDetails;
	exports.resetOffsizeConsent = resetOffsizeConsent;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _store = __webpack_require__(20);
	
	var _analyticsEvents = __webpack_require__(125);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	function checkOut(token, chkItemArray, insurance, shipment_location_details, warehouse_id, scProtect, itemflags, offsizeItem) {
		var air = {};
		var sea = {};
		var airDangerous = [];
		var seaDangerous = [];
	
		if (chkItemArray.air && chkItemArray.sea == null) {
			air = {
				items: chkItemArray.air
			};
		}
		if (chkItemArray.sea && chkItemArray.air == null) {
			sea = {
				items: chkItemArray.sea
			};
		}
		if (chkItemArray.sea && chkItemArray.air) {
			air = {
				items: chkItemArray.air
			};
			sea = {
				items: chkItemArray.sea
			};
		}
		if (itemflags) {
			airDangerous = itemflags.airDangerous;
			seaDangerous = itemflags.seaDangerous;
		}
	
		var payload = {
			token: token,
			air: air, sea: sea,
			"insurance": insurance,
			shipment_location_details: shipment_location_details,
			warehouse_id: warehouse_id
		};
	
		if (scProtect) {
			payload.sc_protect = scProtect;
		}
		return function (dispatch) {
			dispatch({ type: 'SC_PROTECT_UPDATING' });
			_axios2.default.post(apiUrl + 'checkout/shipment', payload).then(function (response) {
				dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
				dispatch({ type: 'SC_PROTECT_UPDATED' });
				if (offsizeItem) {
					dispatch({ type: 'CHECKOUT_OFFSIZE_ITEM' });
				}
				localStorage.setItem("item", JSON.stringify(chkItemArray));
				localStorage.setItem("insurance", JSON.stringify(insurance));
				localStorage.setItem("shipment_location_details", JSON.stringify(shipment_location_details));
				localStorage.setItem("warehouse_id", JSON.stringify(warehouse_id));
				localStorage.setItem("airDangerous", JSON.stringify(airDangerous));
				localStorage.setItem("seaDangerous", JSON.stringify(seaDangerous));
				localStorage.setItem("totalValue", response.data.data.summary.usd.total_price);
				_store.history.push('/checkout');
			}).catch(function (err) {
				dispatch({ type: 'CHECKOUT_ITEM_REJECTED', payload: err });
				dispatch({ type: 'SC_PROTECT_UPDATED' });
			});
		};
	}
	function checkOutPayAirAndSea(token, chkItemArray, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, shipment_location_details, warehouse_id) {
		var is_dangerous_air = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 0;
		var is_dangerous_sea = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : 0;
		var scProtect = arguments[14];
		var isOffsizeCheckoutItem = arguments[15];
	
		var payload = {
			token: token,
			"insurance": insurance,
			"payment_method": "credit_card",
			"payment_provider": payment_type === 'adyen' ? 'adyen-dropin' : payment_type,
			"promo_code": promo_code,
			shipment_location_details: shipment_location_details,
			warehouse_id: warehouse_id,
			is_dangerous_air: is_dangerous_air,
			is_dangerous_sea: is_dangerous_sea,
			consent: {
				miniTnc: new Date()
			}
		};
	
		if (chkItemArray.hasOwnProperty('air')) {
			payload.air = {
				items: chkItemArray.air,
				address: air_address,
				note: note_air
			};
		}
		if (chkItemArray.hasOwnProperty('sea')) {
			payload.sea = {
				items: chkItemArray.sea,
				address: sea_address,
				note: note_sea
			};
		}
	
		if (scProtect) {
			payload.sc_protect = scProtect;
		}
	
		if (isOffsizeCheckoutItem) {
			payload.consent.offsize = new Date();
		}
	
		return function (dispatch) {
			dispatch({ type: 'SC_PROTECT_UPDATING' });
			_axios2.default.post(apiUrl + 'checkout/payment', payload).then(function (response) {
				localStorage.setItem("promoCode", promo_code);
	
				if (response.data.type === "other") {
					dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
					dispatch({ type: 'SC_PROTECT_UPDATED' });
					dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
					_store.history.push("/checkout-success?payment_type=other&Ref=" + response.data.reference_id);
				} else if (payment_type === "adyen") {
					dispatch({ type: 'SC_PROTECT_UPDATED' });
					dispatch({ type: 'CHECKOUT_ADYEN_FULFILLED', payload: response.data });
				} else if (payment_type === "paypal") {
					if (total_price === "0.00" || response.data.parameters.summary.php.total_price === "0") {
						dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
						dispatch({ type: 'SC_PROTECT_UPDATED' });
						dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
						localStorage.setItem("checkout_response", response.data.parameters.payments.reference_id);
						_store.history.push("/checkout-success");
					} else {
						localStorage.removeItem("checkout_response");
						window.location = response.data.parameters.payments.redirect;
						dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
						dispatch({ type: 'SC_PROTECT_UPDATED' });
					}
				} else {
					dispatch({ type: 'CHECKOUT_ASIAPAY_FULFILLED', payload: response.data });
					dispatch({ type: 'SC_PROTECT_UPDATED' });
	
					if (total_price === "0.00") {
						localStorage.setItem("checkout_response", response.data.parameters.payments.query.orderRef);
						dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
						_store.history.push("/checkout-success");
					} else {
						localStorage.removeItem("checkout_response");
					}
				}
			}).catch(function (err) {
				dispatch({ type: 'CHECKOUT_ITEM_REJECTED', payload: err });
				dispatch({ type: 'SC_PROTECT_UPDATED' });
				dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
			});
		};
	}
	function checkOutPayAir(token, chkItemArray, air_address, sea_address, insurance, payment_type, note_air, total_price, promo_code, shipment_location_details, warehouse_id) {
		var is_dangerous_air = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
		var is_dangerous_sea = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 0;
	
	
		var air = {};
		air = {
			items: chkItemArray.air,
			address: air_address,
			note: note_air
		};
	
		return function (dispatch) {
			_axios2.default.post(apiUrl + 'checkout/payment', {
				token: token,
				air: air,
				"insurance": insurance,
				"payment_method": "credit_card",
				"payment_provider": payment_type === 'adyen' ? 'adyen-dropin' : payment_type,
				"promo_code": promo_code,
				shipment_location_details: shipment_location_details,
				warehouse_id: warehouse_id,
				is_dangerous_air: is_dangerous_air,
				is_dangerous_sea: is_dangerous_sea
			}).then(function (response) {
				localStorage.setItem("promoCode", promo_code);
				if (response.data.type === "other") {
					dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
					_store.history.push("/checkout-success?payment_type=other&Ref=" + response.data.reference_id);
				} else if (payment_type === "adyen") {
					dispatch({ type: 'CHECKOUT_ADYEN_FULFILLED', payload: response.data });
				} else if (payment_type === "paypal") {
					if (total_price === "0.00" || response.data.parameters.summary.php.total_price === "0") {
						dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
						localStorage.setItem("checkout_response", response.data.parameters.payments.reference_id);
						_store.history.push("/checkout-success");
					} else {
						localStorage.removeItem("checkout_response");
						window.location = response.data.parameters.payments.redirect;
						dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
					}
				} else {
					dispatch({ type: 'CHECKOUT_ASIAPAY_FULFILLED', payload: response.data });
	
					if (total_price === "0.00") {
						localStorage.setItem("checkout_response", response.data.parameters.payments.query.orderRef);
						_store.history.push("/checkout-success");
					} else {
						localStorage.removeItem("checkout_response");
					}
				}
			}).catch(function (err) {
				dispatch({ type: 'CHECKOUT_ITEM_REJECTED', payload: err });
			});
		};
	}
	function checkOutPaySea(token, chkItemArray, air_address, sea_address, insurance, payment_type, note_sea, total_price, promo_code, shipment_location_details, warehouse_id) {
		var is_dangerous_sea = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
		var is_dangerous_air = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 0;
	
	
		var sea = {};
		sea = {
			items: chkItemArray.sea,
			address: sea_address,
			note: note_sea
		};
	
		return function (dispatch) {
			_axios2.default.post(apiUrl + 'checkout/payment', {
				token: token,
				sea: sea,
				"insurance": insurance,
				"payment_method": "credit_card",
				"payment_provider": payment_type === 'adyen' ? 'adyen-dropin' : payment_type,
				"promo_code": promo_code,
				shipment_location_details: shipment_location_details,
				warehouse_id: warehouse_id,
				is_dangerous_sea: is_dangerous_sea,
				is_dangerous_air: is_dangerous_air
			}).then(function (response) {
				localStorage.setItem("promoCode", promo_code);
	
				if (response.data.type === "other") {
					dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
					_store.history.push("/checkout-success?payment_type=other&Ref=" + response.data.reference_id);
				} else if (payment_type === "adyen") {
					dispatch({ type: 'CHECKOUT_ADYEN_FULFILLED', payload: response.data });
				} else if (payment_type === "paypal") {
					if (total_price === "0.00" || response.data.parameters.summary.php.total_price === "0") {
						dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
						localStorage.setItem("checkout_response", response.data.parameters.payments.reference_id);
						_store.history.push("/checkout-success");
					} else {
						localStorage.removeItem("checkout_response");
						window.location = response.data.parameters.payments.redirect;
						dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
					}
				} else {
					dispatch({ type: 'CHECKOUT_ASIAPAY_FULFILLED', payload: response.data });
	
					if (total_price === "0.00") {
						localStorage.setItem("checkout_response", response.data.parameters.payments.query.orderRef);
						_store.history.push("/checkout-success");
					} else {
						localStorage.removeItem("checkout_response");
					}
				}
			}).catch(function (err) {
				dispatch({ type: 'CHECKOUT_ITEM_REJECTED', payload: err });
			});
		};
	}
	
	function checkOutAdyenDropin(_ref) {
		var formData = _ref.formData,
		    checkoutDetails = _ref.checkoutDetails;
	
	
		var air = {};
		var sea = {};
	
		air = {
			items: checkoutDetails.itemArry.air,
			address: checkoutDetails.air_address,
			note: checkoutDetails.note_air
		};
		sea = {
			items: checkoutDetails.itemArry.sea,
			address: checkoutDetails.sea_address,
			note: checkoutDetails.note_sea
		};
	
		var adyenPayload = formData;
		if (formData.data && !formData.data.storePaymentMethod) {
			adyenPayload.data.storePaymentMethod = false;
		}
	
		var payload = {
			token: checkoutDetails.token,
			air: air,
			sea: sea,
			"insurance": checkoutDetails.insurance,
			"payment_method": "credit_card",
			"payment_provider": 'adyen-dropin',
			"promo_code": checkoutDetails.promo_code,
			'shipment_location_details': checkoutDetails.shipment_location_details,
			'warehouse_id': checkoutDetails.warehouse_id,
			'is_dangerous_sea': checkoutDetails.is_dangerous_sea,
			'is_dangerous_air': checkoutDetails.is_dangerous_air,
			'adyen-payment-method': adyenPayload,
			data: formData.data,
			consent: checkoutDetails.consent
		};
	
		if (checkoutDetails.scProtect) {
			payload.sc_protect = checkoutDetails.scProtect;
		}
	
		return function (dispatch) {
			return _axios2.default.post(apiUrl + 'checkout/payment', payload).then(function (res) {
				localStorage.setItem("promoCode", checkoutDetails.promo_code);
	
				if (res.data.attributes.resultCode === 'RedirectShopper') {
					return res.data.attributes.action;
				}
				dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
				_store.history.push('/checkout-success?payment_type=adyen&authResult=' + res.data.attributes.resultCode.toUpperCase() + '&merchantReference=' + res.data.attributes.merchantReference + '&pspReference=' + res.data.attributes.pspReference + '&shopperLocale=en_GB');
			}).catch(function (err) {
				dispatch({ type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE' });
				dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
				_store.history.push('/cart');
			});
		};
	}
	function checkOutPayAirAndSeaPromo(token, chkItemArray, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, scProtect) {
		var payload = {
			token: token,
			"insurance": insurance,
			"payment_provider": payment_type,
			"promo_code": promo_code,
			shipment_location_details: shipment_location_details,
			warehouse_id: warehouse_id
		};
		if (scProtect) {
			payload.sc_protect = scProtect;
		}
		if (chkItemArray.hasOwnProperty("air")) {
			payload.air = {
				items: chkItemArray.air,
				address: chkItemArray.air.address
			};
		}
		if (chkItemArray.hasOwnProperty("sea")) {
			payload.sea = {
				items: chkItemArray.sea,
				address: chkItemArray.sea.address
			};
		}
	
		return function (dispatch) {
			dispatch({ type: 'PROMO_COMPUTED_PENDING' });
			dispatch({ type: 'SC_PROTECT_UPDATING' });
			_axios2.default.post(apiUrl + 'checkout/shipment', payload).then(function (response) {
				dispatch({ type: 'PROMO_COMPUTED_FULFILLED', payload: response.data });
				localStorage.setItem("totalValue", response.data.data.summary.usd.total_price);
				dispatch({ type: 'SC_PROTECT_UPDATED' });
			}).catch(function (err) {
				dispatch({ type: 'PROMO_COMPUTED_REJECTED', payload: err });
				dispatch({ type: 'SC_PROTECT_UPDATED' });
			});
		};
	}
	function checkOutPayAirPromo(token, chkItemArray, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, scProtect) {
	
		var air = {};
	
		air = {
			items: chkItemArray.air,
			address: chkItemArray.air.address
	
		};
	
		var payload = {
			token: token,
			air: air,
			"insurance": insurance,
			"payment_provider": payment_type,
			"promo_code": promo_code,
			shipment_location_details: shipment_location_details,
			warehouse_id: warehouse_id
		};
		if (scProtect) {
			payload.sc_protect = { avail: 1 };
		}
		return function (dispatch) {
			dispatch({ type: 'PROMO_COMPUTED_PENDING' });
			_axios2.default.post(apiUrl + 'checkout/shipment', payload).then(function (response) {
				dispatch({ type: 'PROMO_COMPUTED_FULFILLED', payload: response.data });
				localStorage.setItem("totalValue", response.data.data.summary.usd.total_price);
			}).catch(function (err) {
				dispatch({ type: 'PROMO_COMPUTED_REJECTED', payload: err });
			});
		};
	}
	function checkOutPaySeaPromo(token, chkItemArray, insurance, promo_code, payment_type, shipment_location_details, warehouse_id) {
	
		var sea = {};
		sea = {
			items: chkItemArray.sea,
			address: chkItemArray.sea.address
		};
		return function (dispatch) {
			dispatch({ type: 'PROMO_COMPUTED_PENDING' });
			_axios2.default.post(apiUrl + 'checkout/shipment', {
				token: token,
				sea: sea,
				"insurance": insurance,
				"payment_provider": payment_type,
				"promo_code": promo_code,
				shipment_location_details: shipment_location_details,
				warehouse_id: warehouse_id
			}).then(function (response) {
				dispatch({ type: 'PROMO_COMPUTED_FULFILLED', payload: response.data });
				localStorage.setItem("totalValue", response.data.data.summary.usd.total_price);
			}).catch(function (err) {
				dispatch({ type: 'PROMO_COMPUTED_REJECTED', payload: err });
			});
		};
	}
	
	function getCheckOut(token, chkItemArray, insurance, shipment_location_details, warehouse_id, scProtect, addressAir, addressSea) {
		return function (dispatch) {
			dispatch({ type: 'SC_PROTECT_UPDATING' });
			var payload = {
				token: token,
				"air": {
					"items": chkItemArray.air,
					"address": addressAir
				},
				"sea": {
					"items": chkItemArray.sea,
					"address": addressSea
				},
				"insurance": insurance,
				shipment_location_details: shipment_location_details,
				warehouse_id: warehouse_id
			};
	
			if (scProtect) {
				payload.sc_protect = scProtect;
			}
	
			_axios2.default.post(apiUrl + 'checkout/shipment', payload).then(function (response) {
				dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
				dispatch({ type: 'RESET_INSURED_VALUE_ERROR', payload: response.data });
				dispatch({ type: 'SC_PROTECT_UPDATED' });
				localStorage.setItem("item", JSON.stringify(chkItemArray));
				localStorage.setItem("insurance", JSON.stringify(insurance));
				localStorage.setItem("shipment_location_details", JSON.stringify(shipment_location_details));
				localStorage.setItem("warehouse_id", JSON.stringify(warehouse_id));
				localStorage.setItem("totalValue", response.data.data.summary.usd.total_price);
			}).catch(function (err) {
				dispatch({ type: 'CHECKOUT_ITEM_REJECTED', payload: err });
				dispatch({ type: 'SC_PROTECT_UPDATED' });
			});
		};
	}
	
	function getCheck(token, chkItemArray, shipment_location_details, insurance, warehouse_id, willResetInsuredError, scProtect) {
		var _this = this;
	
		return function () {
			var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
				var payload, response;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
	
								dispatch({ type: 'PARCEL_UPDATING' });
								dispatch({ type: 'CHECKOUT_ITEM_REQUEST' });
	
								payload = {
									token: token,
									"air": {
										"items": chkItemArray.air
									},
									"sea": {
										"items": chkItemArray.sea
									},
									shipment_location_details: shipment_location_details,
									insurance: insurance,
									warehouse_id: warehouse_id
								};
	
								if (scProtect) {
									payload.sc_protect = scProtect;
								}
								_context.next = 7;
								return _axios2.default.post(apiUrl + 'shipments', payload);
	
							case 7:
								response = _context.sent;
	
								dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data });
								dispatch({ type: 'PARCEL_UPDATED' });
								_context.next = 16;
								break;
	
							case 12:
								_context.prev = 12;
								_context.t0 = _context['catch'](0);
	
								dispatch({ type: 'CHECKOUT_ITEM_REJECTED', payload: _context.t0 });
								dispatch({ type: 'PARCEL_UPDATED' });
	
							case 16:
								if (willResetInsuredError) {
									dispatch({ type: 'RESET_INSURED_VALUE_ERROR', payload: null });
									dispatch({ type: 'PARCEL_UPDATED' });
								}
	
							case 17:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 12]]);
			}));
	
			return function (_x7) {
				return _ref2.apply(this, arguments);
			};
		}();
		// return function (dispatch) {
		// 	dispatch({type: 'CHECKOUT_ITEM_REQUEST'})
		//     axios.post(apiUrl + 'shipments', {
		//         token,
		//         "air": {
		//             "items": chkItemArray.air,
		//         },
		//         "sea": {
		//             "items": chkItemArray.sea,
		//         },
		//         shipment_location_details,
		//         insurance,
		//         warehouse_id,
		// 	})
		// 	.then((response) => {
		// 		dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,})
		// 	}).catch((err) => {
		//         dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
		//     });
	
		//     if (willResetInsuredError) {
		//         dispatch({type: 'RESET_INSURED_VALUE_ERROR', payload: null,});
		//     }
		// }
	}
	
	function clearCheck() {
		return function (dispatch) {
			dispatch({ type: 'CLEAR_CHECKOUT_FULFILLED' });
			dispatch({ type: 'REMOVE_INSURED_VALUE_ERROR_MESSAGE' });
			dispatch({ type: 'RESET_UPDATE_ACCOUNTS' });
		};
	}
	
	function resetComputed() {
		return function (dispatch) {
			dispatch({ type: 'RESET_COMPUTED' });
		};
	}
	
	function clearPromoError() {
		return function (dispatch) {
			dispatch({ type: 'CLEAR_PROMO_ERROR' });
		};
	}
	
	function showEmptyItemOnCheckout() {
		return function (dispatch) {
			dispatch({ type: 'SHOW_EMPTY_CHECKOUT_MESSAGE' });
		};
	}
	
	function setPayment(payment_provider, payment_status, reference_id, payer_id, psp_reference) {
		return function (dispatch) {
			dispatch({ type: "PAYMENT_FETCHING" });
			_axios2.default.put(apiUrl + 'checkout/payment-callback', {
				"payment_provider": payment_provider,
				"payment_status": payment_status,
				"reference_id": reference_id,
				"payer_id": payer_id,
				"psp_reference": psp_reference
			}).then(function (response) {
				dispatch({ type: 'PAYMENT_FULFILLED', payload: response.data });
				if (payment_status === 'canceled' || payment_status === 'CANCELLED') {
					// for cancelled transactions normal path
					dispatch({ type: 'SHOW_CANCELLED_PAYMENT_MESSAGE' });
					(0, _analyticsEvents.recordEvent)('Cart', 'Cart', 'Checkout', 'Failed');
				} else if (payment_status === 'REFUSED') {
					dispatch({ type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE' });
					(0, _analyticsEvents.recordEvent)('Cart', 'Cart', 'Checkout', 'Failed');
				} else {
					(0, _analyticsEvents.recordEvent)('Cart', 'Cart', 'Checkout', 'Success', 'USD', localStorage.totalValue, localStorage.promoCode);
					window.AF('pba', 'event', { eventType: 'EVENT', eventLabel: 'Success', eventCategory: 'Cart', eventRevenue: localStorage.totalValue, eventRevenueCurrency: 'USD', eventValue: '', eventName: 'Checkout' });
				}
			}).catch(function (err) {
				dispatch({ type: 'PAYMENT_REJECTED', payload: err });
				(0, _analyticsEvents.recordEvent)('Cart', 'Cart', 'Checkout', 'Failed');
				if (err.response.data.errors.detail === "Transaction is not a valid for free shipping.") {
					dispatch({ type: 'SHOW_INVALID_TRANSACTION_ERROR' });
					_store.history.push('/cart');
				} else if (payment_status !== 'canceled') {
					// for cancelled transactions through paypal's return to merchant
					dispatch({ type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE' });
					_store.history.push('/cart');
				}
			});
		};
	}
	
	function setCheckoutDetails(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, shipment_location_details, warehouse_id, is_dangerous_air, is_dangerous_sea, scProtect, isOffsizeCheckoutItem) {
		var consent = {
			miniTnc: new Date()
		};
		if (isOffsizeCheckoutItem) {
			consent.offsize = new Date();
		}
		return function (dispatch) {
			dispatch({ type: 'CHECKOUT_DETAILS', payload: { token: token, itemArry: itemArry, air_address: air_address, sea_address: sea_address, insurance: insurance, payment_type: payment_type, note_air: note_air, note_sea: note_sea, total_price: total_price, promo_code: promo_code, shipment_location_details: shipment_location_details, warehouse_id: warehouse_id, is_dangerous_air: is_dangerous_air, is_dangerous_sea: is_dangerous_sea, scProtect: scProtect, consent: consent } });
		};
	}
	
	function resetOffsizeConsent() {
		return function (dispatch) {
			dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
		};
	}

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getEstimate = getEstimate;
	exports.clearEstimate = clearEstimate;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	var CLEAR_ESTIMATE = "CLEAR_ESTIMATE";
	var GET_ESTIMATE_REJECTED = "GET_ESTIMATE_REJECTED";
	var GET_ESTIMATE_FULFILLED = "GET_ESTIMATE_FULFILLED";
	var GET_ESTIMATE_CALCULATING = "GET_ESTIMATE_CALCULATING";
	
	function getEstimate(weight, length, width, height, insured_value, special_handling, warehouse_id, destination_country, sc_protect) {
		return function (dispatch) {
			dispatch({ type: GET_ESTIMATE_CALCULATING });
			_axios2.default.post(apiUrl + 'shipping-estimate', {
				'item': {
					weight: weight,
					length: length,
					width: width,
					height: height,
					insured_value: insured_value,
					special_handling: special_handling,
					warehouse_id: warehouse_id,
					destination_country: destination_country,
					sc_protect: sc_protect
				}
			}).then(function (response) {
				dispatch({
					type: GET_ESTIMATE_FULFILLED,
					payload: response.data
				});
			}).catch(function (err) {
				dispatch({
					type: GET_ESTIMATE_REJECTED,
					payload: err });
			});
		};
	}
	function clearEstimate() {
		return function (dispatch) {
			dispatch({
				type: CLEAR_ESTIMATE
			});
		};
	}

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(33);
	
	__webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvisoryExtensionModal = function (_Component) {
	  _inherits(AdvisoryExtensionModal, _Component);
	
	  function AdvisoryExtensionModal() {
	    _classCallCheck(this, AdvisoryExtensionModal);
	
	    return _possibleConstructorReturn(this, (AdvisoryExtensionModal.__proto__ || Object.getPrototypeOf(AdvisoryExtensionModal)).apply(this, arguments));
	  }
	
	  _createClass(AdvisoryExtensionModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.props.show, onHide: this.props.close, autoFocus: true, dialogClassName: 'custom-modal' },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true, style: { "padding": "0" } }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: this.props.content })
	      );
	    }
	  }]);
	
	  return AdvisoryExtensionModal;
	}(_react.Component);
	
	exports.default = AdvisoryExtensionModal;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(58);
	
	var _reactRedux = __webpack_require__(46);
	
	var _Signup = __webpack_require__(90);
	
	var Signup = _interopRequireWildcard(_Signup);
	
	var _Signin = __webpack_require__(50);
	
	var Signin = _interopRequireWildcard(_Signin);
	
	var _EstimateAction = __webpack_require__(585);
	
	var Estimate = _interopRequireWildcard(_EstimateAction);
	
	var _ShipmentAction = __webpack_require__(241);
	
	var Shipment = _interopRequireWildcard(_ShipmentAction);
	
	var _CmsActions = __webpack_require__(119);
	
	var Cms = _interopRequireWildcard(_CmsActions);
	
	var _SettingsAction = __webpack_require__(240);
	
	var SettingsAction = _interopRequireWildcard(_SettingsAction);
	
	var _Main = __webpack_require__(617);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function mapStateToProps(state) {
	  return {
	    login: state.signin,
	    register: state.signup,
	    auth: state.auth,
	    estimate: state.estimate,
	    shipmentInfo: state.shipment,
	    cms: state.cms,
	    settings: state.settings
	
	  };
	}
	
	function mapDispachToProps(dispatch) {
	  return (0, _redux.bindActionCreators)(Object.assign({}, Signin, Signup, Estimate, Shipment, Cms, SettingsAction), dispatch);
	}
	
	var App = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(_Main2.default);
	
	exports.default = App;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BFMHeader = function BFMHeader() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bfm-header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'bfm-header-message' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: 'bfm-header-message-header' },
	          'BUY-FOR-ME SERVICE'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'bfm-header-message-text' },
	          'Tell us what items you\u2019d like to buy and we\u2019ll make your shopping experience easier.'
	        )
	      )
	    ),
	    _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/buy-for-me-image@2x-20220615011033.png', alt: 'buy-for-me' })
	  );
	};
	
	exports.default = BFMHeader;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetStarted = function GetStarted() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bfm-get-started' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: 'bfm-section-header' },
	        'Shopping ideas to get you started'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'bfm-started-message-text' },
	        'Trending items, top picks, hot sales'
	      )
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'bfm-button', onClick: function onClick() {
	          return _store.history.push('/buy-for-me-shopping-guide');
	        } },
	      'SHOPPING GUIDE'
	    )
	  );
	};
	
	exports.default = GetStarted;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HowItWorks = function HowItWorks() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bfm-how-it-works' },
	    _react2.default.createElement(
	      'p',
	      { className: 'bfm-section-header' },
	      'HOW IT WORKS'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'bfm-steps-wrapper' },
	      _constants.steps.map(function (_ref) {
	        var img = _ref.img,
	            text = _ref.text;
	        return _react2.default.createElement(
	          'div',
	          { className: 'bfm-step-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bfm-step-item-image' },
	            _react2.default.createElement('img', { src: img, alt: 'step' })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bfm-step-item-text' },
	            text
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'bfm-note-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'bfm-note' },
	        _react2.default.createElement(
	          'p',
	          { style: { fontWeight: 600 } },
	          'Notes:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { style: { fontSize: '16px' } },
	          _react2.default.createElement(
	            'li',
	            null,
	            'Your item will be added to your ShippingCart account.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Buy-For-Me service fee will be based on your total item cost including local shipping fee (LSF) per checkout per store.'
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyle: 'none' } },
	            _react2.default.createElement(
	              'table',
	              { className: 'table item-list' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Item + LSF Cost'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Buy-For-Me Fee'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Less than 300USD'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Fixed 15USD'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '300USD and more'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '5% of total cost'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyle: 'none' } },
	            _react2.default.createElement(
	              'i',
	              { style: { color: '#707070', fontSize: '14px' } },
	              '*A 5% transactional fee will be added.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyle: 'none' } },
	            _react2.default.createElement(
	              'i',
	              { style: { color: '#707070', fontSize: '14px' } },
	              '*Local shipping refers to the delivery of item to our warehouse abroad. Some online stores waive  local shipping fees.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = HowItWorks;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _reactRouter = __webpack_require__(14);
	
	__webpack_require__(830);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TNCModal = function (_Component) {
	  _inherits(TNCModal, _Component);
	
	  function TNCModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TNCModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TNCModal.__proto__ || Object.getPrototypeOf(TNCModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      checkAgree: false,
	      termsBottom: false,
	      termReachedBottom: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TNCModal, [{
	    key: 'handleOnScroll',
	    value: function handleOnScroll(e) {
	      var bottom = Math.round(e.target.scrollHeight - e.target.scrollTop) <= e.target.clientHeight + 2;
	      if (bottom) {
	        this.setState({
	          termsBottom: true,
	          termReachedBottom: true
	        });
	      } else {
	        this.setState({ termsBottom: false });
	      }
	    }
	  }, {
	    key: 'handleClickContinue',
	    value: function handleClickContinue() {
	      this.setState({
	        checkAgree: false,
	        termsBottom: false,
	        termReachedBottom: false
	      });
	      this.props.continue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.modalClosed && this.state.termReachedBottom) {
	        this.setState({
	          checkAgree: false,
	          termsBottom: false,
	          termReachedBottom: false
	        });
	      }
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: this.props.show, onHide: this.props.close, autoFocus: true, dialogClassName: 'custom-modal bfm-terms-modal', style: { 'padding': '1px' } },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true, style: { background: '#F9F9F9', textAlign: 'center' } },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            { style: { padding: '20px', width: '100%', fontWeight: 600 } },
	            'BUY-FOR-ME TERMS OF SERVICE'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          { className: 'modal-padding' },
	          _react2.default.createElement(
	            'section',
	            { className: 'modal-body bfm-modal-content', style: { height: '400px', overflow: 'auto', margin: '20px 0px', padding: '0px 20px' }, onScroll: function onScroll(e) {
	                return _this2.handleOnScroll(e);
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'This Buy-For-Me Terms of Service shall supplement the ShippingCart Terms and Conditions accessible ',
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/terms-conditions', target: '_blank' },
	                  'here'
	                ),
	                '.'
	              ),
	              'You may use our Buy-For-Me service for a nominal fee based on your total item cost including local delivery fee and transaction fee per checkout per store. Our warehouse partners will place the order for you, according to the instructions you provide, and pay for the purchase on your behalf. You acknowledge that your use of the Buy-For-Me service is governed by these Terms of Service and the Terms and Conditions of ShippingCart. By placing a Buy-For-Me order with us, You are agreeing to be bound by the Terms of Service set forth below.'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { style: { listStyle: 'none' } },
	              _react2.default.createElement(
	                'li',
	                null,
	                'Section 1: Buy-For-Me Service Orders',
	                _react2.default.createElement(
	                  'ul',
	                  { style: { listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' } },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'In order to avail of the Buy-For-Me service, You must first complete the Buy-For-Me order form. The instructions You submit on the Buy-For-Me order form must specify the exact Product to be purchased, including the item name, website link, and item details such as quantity, size, color, etc. Any product questions should be addressed to the merchant before your submission. We will not facilitate any communications between you and the merchant.  Upon submission of the order form, you warrant that the information provided therein is accurate and complete. As used in this document, \u201Cmerchant\u201D shall refer to the merchant, vendor, or seller from whom You wish to order and purchase Products from.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'You understand that it is your sole responsibility to ensure the accuracy of the instructions and item details submitted to us through the Buy-For-Me order form. ShippingCart will not be liable to You or any other party for any loss, damage, costs, or purchase of Products arising from any information (including incorrect, incomplete, or inaccurate information) provided by You in the Buy-For-Me order form.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'We reserve the right to refuse Your Buy-For-Me order in the following instances:',
	                    _react2.default.createElement(
	                      'ul',
	                      { style: { listStyle: 'decimal', padding: '0px 0px 0px 20px' } },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'You fail to supply complete information in the order form;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'The order includes a Product coming from an auction;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'The order contains a prohibited item that we cannot ship or otherwise constitutes an Unacceptable Shipment under the ShippingCart Terms and Conditions; or'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'Any Product in the order is out-of-stock.'
	                      )
	                    ),
	                    'When an order is refused for whatever reason, Customer Care will reach out via email to inform You.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'A Buy-For-Me service order cannot be changed or cancelled once You have paid the PayPal invoice link. By placing an order, You are deemed to have accepted our Terms of Service and you assume full responsibility for the product fees, shipping costs to our warehouse and service fee associated with the orders you place.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'If we receive a chargeback notification regarding Your payment made via PayPal invoice link, Your account will be permanently suspended and the items we have purchased on Your behalf will be disposed of or sold by us without incurring any liability whatsoever to You or any other party. ShippingCart will not approve any disputes submitted via PayPal regarding your order.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'If ShippingCart, in its sole discretion, deems that items purchased on your behalf is a result of fraudulent activity or related to a restricted or prohibited business, or linked to any illegal activity under applicable laws, ShippingCart reserves the right to take any action that it may deem necessary under the circumstances without further notice to You or any other party, including but not limited to, suspending your account, marking the item as restricted to prohibit send out, and reporting such activity to the source and/or local authority or governing body in which You reside in.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Section 2: Buy-For-Me Service Fee',
	                _react2.default.createElement(
	                  'ul',
	                  { style: { listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' } },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'For items that are $300 and above - The Buy-For-Me service fee is 5% of the total item cost including the local delivery fee with a 5% transaction fee per checkout per store.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'For items that are $299.99 and below - The Buy-For-Me service fee is fixed at USD15 with a 5% transaction fee per checkout per store.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The 5% transaction fee is computed from the total item cost including the local delivery fee plus the applicable Buy-For-Me service fee. This transaction fee applies per checkout per store.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Buy-For-Me Service fee will be billed in USD via PayPal invoice link. The Customer Care Team will send the PayPal invoice link by email.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Section 3: Returns, Refunds, Exchanges',
	                _react2.default.createElement(
	                  'ul',
	                  { style: { listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' } },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'For paid orders, a refund can be processed if a Product in the order is out-of-stock, provided that the refund amount will only cover the item/s that we cannot purchase. We will search for a similar Product to replace the item that is out-of-stock if you have indicated this as your preference on the Buy-For-Me order form. In the event that an item/s in the order is out-of-stock, Customer Care will reach out via email to inform you.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'We are not responsible for any errors of the merchants in fulfillment of orders or otherwise. Arrangements with the merchant for any requests for returns, refunds or exchange of items must be addressed to the merchant directly in accordance with the merchant\u2019s terms and policies, including their policies on who will shoulder the return fees. We are also not responsible for any and all defects in the Products unless the same have been caused due to our direct acts or omissions.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'We do not facilitate any exchanges for Products. We will facilitate the return delivery of item(s) ordered from the merchant while the goods are still at the ShippingCart warehouse. You agree to shoulder applicable return charges.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Section 4: Limitation of Liability',
	                _react2.default.createElement(
	                  'ul',
	                  { style: { listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' } },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'You understand and acknowledge that the quality of the Products purchased from merchants through our Buy-For-Me service and the accuracy of the claims regarding such Products are the sole responsibility of the manufacturer and/ or distributor of the Products. We do not warrant, represent or guarantee the quality of the Products or that the claims made by the manufacturer and/ or distributor are accurate. To the full extent permissible by applicable law, We disclaim all warranties (whether express or implied) including but not limited to, that the Products are merchantable, will meet Your function and/ or requirements or be fit for a particular purpose. We shall not be responsible for any loss or injury or damage incurred as a result of your use of the Products, or the failure of the Products to conform with any warranties made by the merchant, if any.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The merchants are third parties and the transactions made between you and the said merchants and/or between the warehouse operators and the merchants shall be governed by the terms of service of said merchants. We further disclaim any and all warranties related to the merchants including the latter\u2019s authorities, licenses, and business operations. You understand that the Product or service warranties granted by the merchants to the warehouse operators, if any, may not be passed on or assigned to You. We shall not be liable for losses or damage suffered by You arising from or reasonably related to the foregoing.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Section 5: General',
	                _react2.default.createElement(
	                  'ul',
	                  { style: { listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' } },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'We reserve the right to amend, delete, or add to these Terms of Service from time to time without giving notice and with immediate effect. Your continued use of the Buy-For-Me service shall signify your acceptance of the Terms of Service as amended.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'We reserve the right to modify or terminate the Buy-For-Me service for any reason, without notice at any time.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'We reserve the right to refuse service to anyone for any reason at any time. We further reserve the right to modify the fees we charge for this service. You shall be notified in case we implement any changes to the fees.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Any dispute arising out of or in connection with a Buy-For-Me order shall be resolved in accordance with the ShippingCart Terms and Conditions.'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex' } },
	            _react2.default.createElement('input', {
	              id: 'checkbox',
	              'data-id': 'checkbox',
	              onChange: function onChange() {
	                return _this2.setState({ checkAgree: !_this2.state.checkAgree });
	              },
	              value: this.state.checkAgree,
	              type: 'checkbox',
	              style: { width: '35px', height: '17px' },
	              disabled: !this.state.termsBottom && !this.state.termReachedBottom ? "disabled" : ""
	            }),
	            _react2.default.createElement(
	              'label',
	              { id: 'checkbox', htmlFor: 'checkbox', style: { fontWeight: 'normal' } },
	              'Ticking this box means that you have read, understood, and agree to our Terms of Service.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer', style: { textAlign: 'center', padding: '15px 29px' } },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', onClick: function onClick() {
	                  return _this2.handleClickContinue();
	                }, className: 'btn btn-register', style: { width: '180px', background: '#AA0E0E', borderRadius: '20px', border: '1px solid #AA0E0E', color: '#FFF' }, disabled: !this.state.checkAgree },
	              'CONTINUE'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TNCModal;
	}(_react.Component);
	
	exports.default = TNCModal;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(851);
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _BFMHeader = __webpack_require__(588);
	
	var _BFMHeader2 = _interopRequireDefault(_BFMHeader);
	
	var _constants = __webpack_require__(244);
	
	var _HowItWorks = __webpack_require__(590);
	
	var _HowItWorks2 = _interopRequireDefault(_HowItWorks);
	
	var _store = __webpack_require__(20);
	
	var _utils = __webpack_require__(593);
	
	var _TNCModal = __webpack_require__(591);
	
	var _TNCModal2 = _interopRequireDefault(_TNCModal);
	
	var _GetStarted = __webpack_require__(589);
	
	var _GetStarted2 = _interopRequireDefault(_GetStarted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// import ItemFormInput from './ItemFormInput';
	
	// import { Link } from 'react-router';
	
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	var createReactClass = __webpack_require__(16);
	var arrayString = [];
	
	var BuyForMe = createReactClass({
	  displayName: 'BuyForMe',
	
	  getInitialState: function getInitialState() {
	    return {
	      showModal: false,
	      activeStepIndicator: _constants.stepFillOut,
	      formStatus: 'fillOut',
	      form: {
	        emailAddress: '',
	        accountNumber: '',
	        origin: '',
	        shippingMethod: 'None',
	        items: [{
	          itemName: '',
	          websiteLink: '',
	          quantity: '',
	          size: '',
	          color: '',
	          others: '',
	          image: ''
	        }]
	      },
	      images: [],
	      error: false,
	      successData: null,
	      closedModal: false,
	      emailErrorMsg: '',
	      errorUpload: []
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.login.login && nextProps.login.login.party && !this.state.form.accountNumber) {
	      var defaultEmail = nextProps.login.login.party.email;
	      var defaultAccountNumber = nextProps.login.login.party.account_number;
	      var defaultForm = Object.assign({}, this.state.form, { emailAddress: defaultEmail, accountNumber: defaultAccountNumber });
	      this.setState({
	        form: defaultForm
	      });
	    }
	  },
	  handleInputChange: function handleInputChange(e, index) {
	    var name = e.target.name;
	    var value = e.target.value;
	
	    var formCopy = Object.assign({}, this.state.form);
	    var currentInput = _defineProperty({}, name, value);
	
	    if (name === 'origin' && value !== 'JP' && value !== 'KR') {
	      var _formCopy = Object.assign({}, this.state.form);
	      _formCopy.items.forEach(function (item) {
	        item.image = '';
	      });
	      this.setState({ form: _formCopy });
	      this.setState({ images: [] });
	    }
	
	    if (name === 'quantity' && value) {
	      var re = /^[0-9.\b]+$/;
	      if (!re.test(e.target.value)) return;
	      if (value < 1) return;
	    }
	
	    if (index !== undefined) {
	      formCopy.items[index] = Object.assign({}, formCopy.items[index], currentInput);
	      this.setState({ form: formCopy });
	      return;
	    }
	    var currentForm = Object.assign({}, this.state.form, currentInput);
	    this.setState({ form: currentForm });
	  },
	  handleRemoveItem: function handleRemoveItem(index) {
	    var formCopy = Object.assign({}, this.state.form);
	    formCopy.items.splice(index, 1);
	    this.setState({ form: formCopy });
	
	    var imageList = this.state.images;
	    var imageKey = imageList.findIndex(function (obj) {
	      return obj.key === index;
	    });
	    imageList.splice(imageKey, 1);
	    this.setState({ images: imageList });
	  },
	  renderButtons: function renderButtons() {
	    var _this = this;
	
	    if (this.state.successData && this.state.successData.ticket) return;
	
	    if (this.state.formStatus === 'fillOut') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'bfm-form-buttons' },
	        _react2.default.createElement(
	          'button',
	          { className: 'bfm-button', onClick: this.handleAddItem },
	          'Add Item'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'bfm-button', style: { backgroundColor: '#AA0E0E', color: '#fff' }, onClick: this.handleReview },
	          'PROCEED'
	        )
	      );
	    }
	    if (this.state.formStatus === 'confirmation') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'bfm-form-buttons' },
	        _react2.default.createElement(
	          'button',
	          { className: 'bfm-button', onClick: function onClick() {
	              _this.resetForm();
	            }
	          },
	          'Cancel'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'bfm-button', style: { backgroundColor: '#AA0E0E', color: '#fff' }, onClick: this.handleSubmit },
	          ' Submit'
	        )
	      );
	    }
	  },
	  handleAddItem: function handleAddItem() {
	    var formCopy = Object.assign({}, this.state.form);
	    formCopy.items.push({
	      itemName: '',
	      websiteLink: '',
	      quantity: '',
	      size: '',
	      color: '',
	      others: '',
	      image: ''
	    });
	
	    this.setState({ form: Object.assign({}, formCopy) });
	  },
	  handleShowTNCModal: function handleShowTNCModal() {
	    this.setState({
	      showModal: true,
	      closedModal: false
	    });
	  },
	  handleCloseModal: function handleCloseModal() {
	    this.setState({
	      showModal: false,
	      closedModal: true
	    });
	  },
	  handleReview: function handleReview() {
	    window.scrollTo(0, 820);
	    this.setState({
	      error: false,
	      emailErrorMsg: ''
	    });
	    if (this.checkForErrors(this.state.form)) {
	      this.setState({ error: true });
	      return;
	    }
	    this.handleShowTNCModal();
	  },
	  handleContinue: function handleContinue() {
	    window.scrollTo(0, 220);
	    this.setState({
	      formStatus: 'confirmation',
	      activeStepIndicator: _constants.stepConfirmation,
	      showModal: false
	    });
	  },
	  handleSubmit: function handleSubmit() {
	    var _this2 = this;
	
	    this.convertObjectToString(this.state.form);
	    if (this.state.images) {
	      var data = new FormData();
	      var images = this.state.images.length;
	      for (var x = 0; x < images; x++) {
	        data.append("images[]", this.state.images[x]);
	      }
	      data.append("subject", 'SC Buy for ' + this.state.form.emailAddress);
	      data.append("details", (0, _utils.renderHTML)(this.state.form));
	      data.append("assignee_email", 'customercare@shippingcart.com');
	      data.append("requester", this.state.form.emailAddress);
	
	      (0, _axios2.default)({
	        url: apiUrl + 'users/create/support-ticket',
	        method: 'post',
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        },
	        data: data
	      }).then(function (res) {
	        _this2.setState({ successData: res.data });
	        arrayString = [];
	        window.scrollTo(0, 820);
	      });
	    } else {
	      _axios2.default.post(apiUrl + 'users/create/support-ticket', {
	        data: {
	          subject: 'SC Buy for ' + this.state.form.emailAddress,
	          details: (0, _utils.renderHTML)(this.state.form),
	          assignee_email: 'customercare@shippingcart.com',
	          requester: this.state.form.emailAddress
	        }
	      }).then(function (res) {
	        _this2.setState({ successData: res.data });
	        arrayString = [];
	        window.scrollTo(0, 820);
	      });
	    }
	  },
	  resetForm: function resetForm() {
	    this.setState({
	      form: {
	        emailAddress: this.props.login.login.party && this.props.login.login.party.email,
	        accountNumber: this.props.login.login.party && this.props.login.login.party.account_number,
	        origin: '',
	        items: [{
	          itemName: '',
	          websiteLink: '',
	          quantity: '',
	          size: '',
	          color: '',
	          others: '',
	          image: ''
	        }]
	      },
	      formStatus: 'fillOut',
	      activeStepIndicator: _constants.stepFillOut,
	      emailErrorMsg: '',
	      images: []
	    });
	  },
	  checkImageAndLink: function checkImageAndLink(item) {
	    if (item.image) {
	      return 'link';
	    }
	    return 'image';
	  },
	  checkForErrors: function checkForErrors(values) {
	    var _this3 = this;
	
	    if (Object.values(this.state.form).includes('') || this.validateEmail(this.state.form.emailAddress)) {
	      if (this.validateEmail(this.state.form.emailAddress)) this.setState({ emailErrorMsg: 'Please enter a valid email address.' });
	      return true;
	    }
	    var currentValue = false;
	    this.state.form.items.forEach(function (item) {
	      if (item.image || item.link) {
	        return true;
	      }
	      var filterItem = Object.keys(item).filter(function (key) {
	        return key !== 'others' && key !== _this3.checkImageAndLink(item);
	      }).reduce(function (obj, key) {
	        obj[key] = item[key];
	        return obj;
	      }, {});
	      if (Object.values(filterItem).includes('')) {
	        currentValue = true;
	      };
	    });
	    return currentValue;
	  },
	  convertObjectToString: function convertObjectToString(obj) {
	    var _this4 = this;
	
	    Object.entries(obj).every(function (item) {
	      if (item[1] instanceof Array) {
	        item[1].forEach(function (itemDetail) {
	          _this4.convertObjectToString(itemDetail);
	          return false;
	        });
	      } else {
	        arrayString.push(item[0].replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
	          return str.toUpperCase();
	        }) + ': ' + item[1]);
	        return true;
	      }
	      return true;
	    });
	  },
	  validateEmail: function validateEmail(email) {
	    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) return true;
	  },
	  onDrop: function onDrop(accepted, rejected, index) {
	    var error = null;
	    var maxAllowedSize = 5120;
	    var fileSizeKiloBytes = accepted[0] && accepted[0].size / 1024;
	
	    if (rejected.length > 0) {
	      error = "Invalid file format";
	    }
	    if (accepted && fileSizeKiloBytes > maxAllowedSize) {
	      error = "File can't be uploaded because it exceeded the maximum file size (5MB)";
	    }
	
	    if (error) {
	      var itemNumber = { error: error, key: index };
	      var copyErrorUpdload = this.state.errorUpload;
	      var errorKey = this.state.errorUpload.findIndex(function (obj) {
	        return obj.key === index;
	      });
	      if (errorKey !== -1) {
	        copyErrorUpdload.splice(errorKey, 1);
	      }
	      copyErrorUpdload.push(itemNumber);
	      this.setState({ errorUpload: copyErrorUpdload });
	    } else {
	      var _errorKey = this.state.errorUpload.findIndex(function (obj) {
	        return obj.key === index;
	      });
	      this.state.errorUpload.splice(_errorKey, 1);
	      this.setState({ errorUpload: this.state.errorUpload });
	
	      var imageName = 'Item ' + (index + 1);
	      var renamedAcceptedFiles = accepted.map(function (file) {
	        var changedFileName = new File([file], imageName, { type: file.type });
	        changedFileName.preview = accepted[0].preview;
	        changedFileName.key = index;
	        return changedFileName;
	      });
	
	      this.state.images.push(renamedAcceptedFiles[0]);
	      this.setState({ images: this.state.images });
	
	      var formCopy = Object.assign({}, this.state.form);
	      var currentInput = { image: renamedAcceptedFiles[0] };
	      formCopy.items[index] = Object.assign({}, formCopy.items[index], currentInput);
	      this.setState({ form: formCopy });
	    }
	  },
	  handleDeleteImage: function handleDeleteImage(index) {
	    var imageList = this.state.images;
	    var imageKey = imageList.findIndex(function (obj) {
	      return obj.key === index;
	    });
	    imageList.splice(imageKey, 1);
	    this.setState({ images: imageList });
	
	    var formCopy = Object.assign({}, this.state.form);
	    var currentInput = { image: '' };
	    formCopy.items[index] = Object.assign({}, formCopy.items[index], currentInput);
	    this.setState({ form: formCopy });
	  },
	  render: function render() {
	    // const checkLoggedIn = this.props.login.login && this.props.login.login.party;
	    return _react2.default.createElement(
	      'div',
	      { className: 'bfm-wrapper' },
	      _react2.default.createElement(_BFMHeader2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'bfm-content' },
	        _react2.default.createElement(_HowItWorks2.default, null),
	        _react2.default.createElement(_GetStarted2.default, null),
	        this.state.successData ? _react2.default.createElement(
	          'div',
	          { className: 'bfm-fill-it-out-1', style: { backgroundColor: 'white' } },
	          _react2.default.createElement(
	            'p',
	            { className: 'bfm-section-header' },
	            'SUCCESS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bfm-steps-indicator' },
	            _constants.stepSuccess.map(function (_ref) {
	              var icon = _ref.icon,
	                  text = _ref.text,
	                  isActive = _ref.isActive;
	              return _react2.default.createElement(
	                'div',
	                { className: 'bfm-step-item' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('img', { src: icon, alt: 'icon' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'bfm-step-item-text', style: isActive ? { borderTop: '4px solid #0258A3', color: '#707070' } : {} },
	                  text
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-center' },
	            _react2.default.createElement(
	              'div',
	              { style: { width: 343, textAlign: 'center' } },
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: 20, fontWeight: 600 } },
	                'Request submitted!'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Your reference # is ',
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontWeight: 600 } },
	                  this.state.successData ? this.state.successData.ticket.id : 'BFM00000'
	                ),
	                '. Our Customer Care Team will validate the information submitted and you will receive a notification via email within 24 hours.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'bfm-form-buttons' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'bfm-button bfm-success-button', onClick: function onClick() {
	                      _store.history.push('/');
	                    } },
	                  'Back to Homepage'
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement('div', null)
	      ),
	      _react2.default.createElement(_TNCModal2.default, { show: this.state.showModal, close: this.handleCloseModal, 'continue': this.handleContinue, modalClosed: this.state.closedModal })
	    );
	  }
	});
	
	exports.default = BuyForMe;

/***/ },
/* 593 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var renderHTML = exports.renderHTML = function renderHTML(form) {
	  return (
	    //eslint-disable-next-line
	    '<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>ShippingCart - Support Ticket</title></head><body style="max-width:600px;margin:0 auto;padding:20px;box-sizing:border-box;font-family:Poppins,Arial,sans-serif"><table><tr><th><img src="https://cdn.shippingcart.com/assets/sc-logo-primary-20220705064812.png" width="300px"></th></tr><tr><td><table cellspacing="0" cellpadding="0" style="box-sizing:border-box;font-size:13px;background-color:#f1f1f1;color:#555"><tr><td colspan="2" style="padding:0 15px;background:#9acb51;color:#fff;border:2px solid #9acb51"><h3 style="font-size:16px;font-weight:700">New Support Request from ShippingCart</h3></td></tr><tr><td width="30%" style="padding:15px 10px;vertical-align:top;border-right:2px solid #f8f8f8;border-bottom:2px solid #f8f8f8">Email address</td><td style="padding:15px 10px;border-bottom:1px solid #f8f8f8">' + form.emailAddress + '</td></tr><tr><td width="30%" style="padding:15px 10px;vertical-align:top;border-right:2px solid #f8f8f8;border-bottom:2px solid #f8f8f8">Account Number</td><td style="padding:15px 10px;border-bottom:1px solid #f8f8f8">' + form.accountNumber + '</td></tr><tr><td width="30%" style="padding:15px 10px;vertical-align:top;border-right:2px solid #f8f8f8;border-bottom:2px solid #f8f8f8">Origin</td><td style="padding:15px 10px;border-bottom:1px solid #f8f8f8">' + form.origin + '</td></tr><tr><td width="30%" style="padding:15px 10px;vertical-align:top;border-right:2px solid #f8f8f8;border-bottom:2px solid #f8f8f8">Prefered shipping method</td><td style="padding:15px 10px;border-bottom:1px solid #f8f8f8">' + form.shippingMethod + '</td></tr>' + form.items.map(function (item) {
	      return Object.entries(item).map(function (att) {
	        //eslint-disable-next-line
	        return '<tr><td width="30%" style="padding:15px 10px;vertical-align:top;border-right:2px solid #f8f8f8;border-bottom:2px solid #f8f8f8">' + att[0].replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
	          return str.toUpperCase();
	        }) + '</td><td style="padding:15px 10px;border-bottom:1px solid #f8f8f8">' + att[1] + '</td></tr>';
	      }).join('');
	    }) + '</table></td></tr></table></body></html>'
	  );
	};

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _DamagedBanner = __webpack_require__(91);
	
	var _DamagedBanner2 = _interopRequireDefault(_DamagedBanner);
	
	var _DamagedModal = __webpack_require__(121);
	
	var _DamagedModal2 = _interopRequireDefault(_DamagedModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
	var seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';
	var itemListIcon = 'https://cdn.shippingcart.com/assets/item-list-graphic-20231115084133.svg';
	var protectedIcon = 'https://cdn.shippingcart.com/assets/protect-20231116072249.svg';
	var unProtectedIcon = 'https://cdn.shippingcart.com/assets/no_protect-20231116072255.svg';
	var scProtectBadge = 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg';
	
	var INSURANCE_BENEFITS = [{
	  protected: 'Up to 100% refund on your insured value.',
	  notProtected: 'No protection against loss or damage during transit.'
	}, {
	  protected: 'Up to 100% refund on shipping when delivered late',
	  notProtected: 'No refund for shipping fee in case of delay.'
	}, {
	  protected: 'Up to P5,000 coverage on merchant return.',
	  notProtected: 'No shipping fee refunds when returning wrong or defective items to the merchant.'
	}];
	
	var CheckoutBreakdown = function (_Component) {
	  _inherits(CheckoutBreakdown, _Component);
	
	  function CheckoutBreakdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CheckoutBreakdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckoutBreakdown.__proto__ || Object.getPrototypeOf(CheckoutBreakdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      itemModal: '',
	      isSCProtectDetailsShown: true,
	      scProtectModal: false,
	      damagedModalOpen: false
	    }, _this.close = function () {
	      _this.setState({ itemModal: '' });
	    }, _this.alertBanner = function () {
	      if (_this.props.data && !_this.props.data.insurance_eligible && _this.props.data.insurance_error && _this.props.data.insurance_error.total_package_value) {
	        return _react2.default.createElement(_DamagedBanner2.default, {
	          message: 'Your shipment is not eligible for SC Protect coverage as the total value exceeds the maximum limit of USD 20,000.00.',
	          bgColor: '#FFE9EB',
	          damaged: false
	        });
	      } else {
	        if (_this.props.data && _this.props.data.damage_items && !!_this.props.data.damage_items.total) {
	          return _react2.default.createElement(_DamagedBanner2.default, {
	            message: _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { fontWeight: 600 } },
	                _this.props.data.damage_items.total,
	                ' out of',
	                ' ',
	                _this.props.data.summary.usd.total_qty,
	                ' packages'
	              ),
	              ' ',
	              'contains',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                {
	                  style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer' },
	                  onClick: function onClick() {
	                    return _this.setState({ damagedModalOpen: true });
	                  }
	                },
	                'damaged item'
	              ),
	              ' ',
	              'which are excluded from SC Protect when you checkout.'
	            ),
	            bgColor: '#FFE9EB'
	          });
	        }
	        return '';
	      }
	    }, _this.handleFixedAirCargo = function () {
	      if (_this.props.data.air.usd && _this.props.data.air.usd.single_parcel_fixed_rate) {
	        return _react2.default.createElement(
	          'div',
	          { style: { display: "inline-flex", alignItems: "center" } },
	          'Fixed Air Cargo Fee'
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'inline-flex', alignItems: 'center' } },
	        'Total Air Cargo Fee',
	        _react2.default.createElement(
	          'div',
	          { className: 'fa fa-question-circle', style: { width: '18px', height: '18px', marginLeft: '5px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkout tooltip white', style: { backgroundColor: '#316edc', width: '250px', left: '-111px' } },
	            _react2.default.createElement(
	              'div',
	              { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '13px' } },
	                  'Chargeable weight'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _this.props.data.air.usd.total_chargeable_weight,
	                  ' lbs'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '13px', textTransform: 'capitalize' } },
	                  'Air Cargo rate'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: { marginRight: '5px' } },
	                    'X'
	                  ),
	                  ' ',
	                  'USD ' + ((0, _utils.numbersWithComma)(Number(_this.props.data.air.usd.per_pound_value).toFixed(2)) || 0.00)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'right', fontSize: '13px' } },
	                'USD ' + ((0, _utils.numbersWithComma)(_this.props.data.air.usd.total_chargeable_amount.toFixed(2)) || 0.00)
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '13px' } },
	                  'Fixed handling fee'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: { marginRight: '5px' } },
	                    '+'
	                  ),
	                  'USD ' + ((0, _utils.numbersWithComma)(_this.props.data.air.usd.total_fixed_rate && _this.props.data.air.usd.total_fixed_rate.toFixed(2)) || 0.00)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px' } },
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '13px', fontWeight: 600, textTransform: 'capitalize' } },
	                'Total Air Cargo Fee'
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '13px', fontWeight: 600 } },
	                'USD ' + ((0, _utils.numbersWithComma)(_this.props.data.air.usd.total_cargo) || 0.00)
	              )
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CheckoutBreakdown, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var minChargableWeight = this.props.minChargableWeight && JSON.parse(this.props.minChargableWeight.settings);
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.data && this.props.data.items.hasOwnProperty("air") && _react2.default.createElement(
	          'div',
	          { style: { padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232', marginBottom: '10px' } },
	            this.handleFixedAirCargo(),
	            _react2.default.createElement(
	              'span',
	              null,
	              'USD ' + (0, _utils.numbersWithComma)(this.props.data.air.usd.total_cargo)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	              _react2.default.createElement('img', { src: itemListIcon, alt: 'air', width: 18, style: { marginRight: '5px' } }),
	              'List of items'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', fontWeight: 600, color: '#0375D9', cursor: 'pointer' }, onClick: function onClick() {
	                  return _this2.setState({ itemModal: 'air' });
	                } },
	              this.props.data.air.total_qty,
	              ' item/s'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	              _react2.default.createElement('img', { src: airIcon, alt: 'air', width: 18, style: { marginRight: '5px' } }),
	              'Est. delivery'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', color: '#323232' } },
	              this.props.data.delivery.air
	            )
	          )
	        ),
	        this.props.data && this.props.data.items.hasOwnProperty("sea") && _react2.default.createElement(
	          'div',
	          { style: { padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232', marginBottom: '10px' } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'inline-flex', alignItems: 'center' } },
	              'Total Sea Cargo Fee',
	              _react2.default.createElement(
	                'div',
	                { className: 'fa fa-question-circle', style: { width: '18px', height: '18px', marginLeft: '5px' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checkout tooltip white', style: { backgroundColor: '#316edc', width: '250px', left: '-111px' } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { display: 'flex', justifyContent: 'space-between' } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: '13px' } },
	                        'Chargeable weight'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        this.props.data.sea.total_chargeable_weight,
	                        ' lbs'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { style: { display: 'flex', justifyContent: 'space-between' } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: '13px', textTransform: 'capitalize' } },
	                        'Sea Cargo rate'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          { style: { marginRight: '5px' } },
	                          'X'
	                        ),
	                        ' ',
	                        'USD ' + ((0, _utils.numbersWithComma)(Number(this.props.data.sea.usd.per_pound_value).toFixed(2)) || 0.00)
	                      )
	                    ),
	                    this.props.data.sea && this.props.data.sea.usd.is_sea_higher_rate && _react2.default.createElement(
	                      'div',
	                      { style: { fontSize: '10px', fontStyle: 'italic', textAlign: 'left' } },
	                      'Higher rates apply if any side of a package is over ',
	                      minChargableWeight && minChargableWeight.sea_max_dimension && minChargableWeight.sea_max_dimension.value,
	                      ' inches.'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { display: 'flex', justifyContent: 'right', fontSize: '13px' } },
	                      'USD ' + ((0, _utils.numbersWithComma)(this.props.data.sea.usd.total_chargeable_amount.toFixed(2)) || 0.00)
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { style: { display: 'flex', justifyContent: 'space-between' } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: '13px' } },
	                        'Fixed handling fee'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          { style: { marginRight: '5px' } },
	                          '+'
	                        ),
	                        'USD ' + ((0, _utils.numbersWithComma)(this.props.data.sea.usd.total_fixed_rate && this.props.data.sea.usd.total_fixed_rate.toFixed(2)) || 0.00)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px' } },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontSize: '13px', fontWeight: 600, textTransform: 'capitalize' } },
	                      'Total Sea Cargo Fee'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontSize: '13px', fontWeight: 600 } },
	                      'USD ' + ((0, _utils.numbersWithComma)(this.props.data.sea.usd.total_cargo) || 0.00)
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'USD ' + (0, _utils.numbersWithComma)(this.props.data.sea.usd.total_cargo)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	              _react2.default.createElement('img', { src: itemListIcon, alt: 'air', width: 18, style: { marginRight: '5px' } }),
	              'List of items'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', fontWeight: 600, color: '#0375D9', cursor: 'pointer' }, onClick: function onClick() {
	                  return _this2.setState({ itemModal: 'sea' });
	                } },
	              this.props.data.sea.total_qty,
	              ' item/s'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	              _react2.default.createElement('img', { src: seaIcon, alt: 'air', width: 18, style: { marginRight: '5px' } }),
	              'Est. delivery'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '16px', color: '#323232' } },
	              this.props.data.delivery.sea
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Storage Fee'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'USD ' + (this.props.data && (0, _utils.numbersWithComma)(this.props.data.summary.usd.total_storage_charge.toFixed(2)))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Total SC Protect Fee',
	              _react2.default.createElement('img', { src: scProtectBadge, alt: 'air', width: 18, style: { marginLeft: '5px' } })
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'USD ' + (this.props.data && (0, _utils.numbersWithComma)(this.props.data.summary.usd.total_insurance))
	            )
	          ),
	          this.alertBanner(),
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: function onClick() {
	                  _this2.setState({ isSCProtectDetailsShown: !_this2.state.isSCProtectDetailsShown });
	                }
	              },
	              this.state.isSCProtectDetailsShown ? _react2.default.createElement('i', { className: 'fa fa-angle-down', style: { color: '#636363', fontSize: '20px' } }) : _react2.default.createElement('i', { className: 'fa fa-angle-up', style: { color: '#636363', fontSize: '20px' } })
	            )
	          ),
	          this.state.isSCProtectDetailsShown && _react2.default.createElement(
	            'div',
	            null,
	            this.props.isSCProtectActive && this.props.data && this.props.data.insurance_eligible === 1 && _react2.default.createElement(
	              'div',
	              { style: { paddingTop: '20px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	                  'Premium'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', color: '#323232' } },
	                  'USD ',
	                  this.props.data && this.props.data.insurance && this.props.data.insurance.basic_premium
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	                  'Documentary Stamps'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', color: '#323232' } },
	                  'USD ',
	                  this.props.data && this.props.data.insurance && this.props.data.insurance.stamps
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	                  'Value Added Tax'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', color: '#323232' } },
	                  'USD ',
	                  this.props.data && this.props.data.insurance && this.props.data.insurance.vat
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', fontWeight: 600, color: '#636363' } },
	                  'Local Government Tax'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '16px', color: '#323232' } },
	                  'USD ',
	                  this.props.data && this.props.data.insurance && this.props.data.insurance.lgt
	                )
	              ),
	              _react2.default.createElement('hr', null)
	            ),
	            this.props.isSCProtectActive && _react2.default.createElement(
	              'div',
	              { style: { fontSize: '16px', color: '#636363', fontWeight: 600, padding: '10px 0px' } },
	              'Summary of Benefits:'
	            ),
	            INSURANCE_BENEFITS.map(function (benefit, index) {
	              return _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '8px', display: 'flex' }, key: index },
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginRight: '5px' } },
	                  _react2.default.createElement('img', {
	                    src: _this2.props.isSCProtectActive ? protectedIcon : unProtectedIcon,
	                    alt: 'icon'
	                  })
	                ),
	                _this2.props.isSCProtectActive ? benefit.protected : benefit.notProtected
	              );
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600 } },
	              'Avail SC Protect',
	              _react2.default.createElement(
	                'label',
	                { className: 'switch' },
	                _react2.default.createElement('input', {
	                  checked: this.props.isSCProtectActive ? 'checked' : '',
	                  type: 'checkbox',
	                  disabled: this.props.data && !this.props.data.insurance_eligible && this.props.data.insurance_error && this.props.data.insurance_error.total_package_value,
	                  onChange: function onChange() {
	                    return !_this2.props.isSCProtectActive ? _this2.props.handleSwitchToggle() : _this2.setState({ scProtectModal: true });
	                  }
	                }),
	                _react2.default.createElement('div', { className: 'slider round' })
	              )
	            ),
	            this.props.data && this.props.data.insurance_eligible === 1 && _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px', alignItems: 'center' } },
	              _react2.default.createElement('img', { src: scProtectBadge, alt: 'badge', width: 18, height: 18, style: { marginRight: '5px' } }),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '10px', fontWeight: 600, color: '#636363' } },
	                'SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { className: 'alert-modal-checkout', show: this.state.itemModal, onHide: this.close, autoFocus: true },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Title,
	              null,
	              'Air Cargo Items'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            this.state.itemModal && this.props.data.items[this.state.itemModal].map(function (item) {
	              return _react2.default.createElement(
	                'div',
	                { key: item.id },
	                item.description
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            { style: { "textAlign": "center" } },
	            _react2.default.createElement(
	              'button',
	              { className: 'alert-modal-btn btn', onClick: this.close },
	              'OK GOT IT!'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { className: 'alert-modal-checkout', show: this.state.scProtectModal, onHide: function onHide() {
	              return _this2.setState({ scProtectModal: false });
	            }, autoFocus: true },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Title,
	              null,
	              'Insurance Coverage'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { margin: '5px 0px' } },
	              'Are you sure you don\u2019t want to protect your goods with shipping protection?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { margin: '5px 0px' } },
	              'Without SC Protect, your items may be at risk for any unexpected issues; damage or loss during shipping.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { margin: '5px 0px' } },
	              'We encourage you to take a moment to reconsider!'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            { style: { "textAlign": "center" } },
	            _react2.default.createElement(
	              'button',
	              { className: 'alert-modal-btn btn', style: { width: '100%' }, onClick: function onClick() {
	                  return _this2.setState({ scProtectModal: false });
	                } },
	              'AVAIL SC PROTECT'
	            ),
	            _react2.default.createElement(
	              'a',
	              { style: { color: '#707070', fontWeight: 600, fontSize: 14, display: 'flex', justifyContent: 'center', padding: '15px', alignItems: 'center' },
	                onClick: function onClick() {
	                  _this2.props.handleSwitchToggle();
	                  _this2.setState({ scProtectModal: false });
	                } },
	              'Checkout without SC Protect'
	            )
	          )
	        ),
	        _react2.default.createElement(_DamagedModal2.default, {
	          isOpen: this.state.damagedModalOpen,
	          handleClose: function handleClose() {
	            return _this2.setState({ damagedModalOpen: false });
	          },
	          damageItems: this.props.data && this.props.data.damage_items
	        })
	      );
	    }
	  }]);
	
	  return CheckoutBreakdown;
	}(_react.Component);
	
	exports.default = CheckoutBreakdown;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(114);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageNotFound = __webpack_require__(620);
	
	var _PageNotFound2 = _interopRequireDefault(_PageNotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var Cms = createReactClass({
	  displayName: 'Cms',
	
	  getInitialState: function getInitialState() {
	    return {
	      body: "<div></div>"
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.props.getCmsBody(this.props.params.cms);
	
	    var hash = window.location.hash;
	
	    if (hash !== '') {
	      setTimeout(function () {
	        var id = hash.replace('#', '');
	        var element = document.getElementById(id);
	        if (element) element.scrollIntoView();
	      }, 1000);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    //this.props.resetCms();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.params.cms !== nextProps.params.cms) {
	      this.props.getCmsBody(nextProps.params.cms);
	    }
	    var body = nextProps.cms.getCms && nextProps.cms.CmsContent ? nextProps.location.search === "?draft" ? nextProps.cms.CmsContent.data.content.draft : nextProps.cms.CmsContent.data.content.body : this.state.body;
	    this.setState({ body: body });
	    var title = "ShippingCart";
	    title = nextProps.cms.fetching ? title : nextProps.cms.getCms && nextProps.cms.CmsContent ? nextProps.cms.CmsContent.data.name + " | " + title : "Page not found :(";
	    document.title = title;
	
	    // if (nextProps.auth.isAuthenticated !== this.props.auth.isAuthenticated){
	    //   const email = nextProps.login.login.party.email ? nextProps.login.login.party.email : "";
	    //   this.setState({email}, () => this.netcoreScript(this.state.email))
	    // }
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    // const w = window; 
	    // <!-- NetCore Script -->
	    // this.netcoreScript = (email) => {
	    //   w.smartech('create','ADGMOT35CHFLVDHBJNIG50K969R5IJDR7QSKURD40EMEKF18IN70');
	    //   w.smartech('register', '5cbfa9252c18508b714b90fa118de653');
	    //   w.smartech('identify', email ? email : ""); // under '', please pass the EMAIL of web visitor. Else please do not pass any value
	    //   w.smartech('dispatch',1,{});        
	    // };
	    // this.netcoreScript(this.state.email)
	    // <!-- NetCore Script -->    
	  },
	  createMarkup: function createMarkup(data) {
	    return { __html: data };
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.cms.CmsContent && this.props.cms.CmsContent.data.description ? _react2.default.createElement(_reactHelmet2.default, {
	        meta: [{ name: 'description', content: this.props.cms.CmsContent.data.description }] }) : null,
	      this.props.cms.fetching ? _react2.default.createElement('div', { className: 'container page-container cms', dangerouslySetInnerHTML: this.createMarkup(this.state.body) }) : this.props.cms.getCms ? _react2.default.createElement('div', { className: 'container page-container cms', dangerouslySetInnerHTML: this.createMarkup(this.state.body) }) : _react2.default.createElement(_PageNotFound2.default, this.props)
	    );
	  }
	});
	
	exports.default = Cms;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Countdown = function (_Component) {
	  _inherits(Countdown, _Component);
	
	  function Countdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Countdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      days: 0,
	      hours: 0,
	      min: 0,
	      sec: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Countdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // update every second
	      this.interval = setInterval(function () {
	        var date = _this2.calculateCountdown(_this2.props.date);
	        date ? _this2.setState(date) : _this2.stop();
	      }, 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'calculateCountdown',
	    value: function calculateCountdown(endDate) {
	      var diff = (Date.parse(new Date(endDate)) - Date.parse(new Date())) / 1000;
	
	      // clear countdown when date is reached
	      if (diff <= 0) return false;
	
	      var timeLeft = {
	        years: 0,
	        days: 0,
	        hours: 0,
	        min: 0,
	        sec: 0
	      };
	
	      // calculate time difference between now and expected date
	      if (diff >= 365.25 * 86400) {
	        // 365.25 * 24 * 60 * 60
	        timeLeft.years = Math.floor(diff / (365.25 * 86400));
	        diff -= timeLeft.years * 365.25 * 86400;
	      }
	      if (diff >= 86400) {
	        // 24 * 60 * 60
	        timeLeft.days = Math.floor(diff / 86400);
	        diff -= timeLeft.days * 86400;
	      }
	      if (diff >= 3600) {
	        // 60 * 60
	        timeLeft.hours = Math.floor(diff / 3600);
	        diff -= timeLeft.hours * 3600;
	      }
	      if (diff >= 60) {
	        timeLeft.min = Math.floor(diff / 60);
	        diff -= timeLeft.min * 60;
	      }
	      timeLeft.sec = diff;
	
	      return timeLeft;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      clearInterval(this.interval);
	    }
	  }, {
	    key: 'addLeadingZeros',
	    value: function addLeadingZeros(value) {
	      value = String(value);
	      while (value.length < 2) {
	        value = '0' + value;
	      }
	      return value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var countDown = this.state;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Countdown' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Countdown-col' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Countdown-col-element' },
	            _react2.default.createElement(
	              'div',
	              { className: 'timer' },
	              this.addLeadingZeros(countDown.days)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'timer-label' },
	              countDown.days === 1 ? 'DAY' : 'DAYS'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Countdown-col' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Countdown-col-element' },
	            _react2.default.createElement(
	              'div',
	              { className: 'timer' },
	              this.addLeadingZeros(countDown.hours)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'timer-label' },
	              'HOURS'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Countdown-col' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Countdown-col-element' },
	            _react2.default.createElement(
	              'div',
	              { className: 'timer' },
	              this.addLeadingZeros(countDown.min)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'timer-label' },
	              'MINUTES'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Countdown-col' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Countdown-col-element' },
	            _react2.default.createElement(
	              'div',
	              { className: 'timer' },
	              this.addLeadingZeros(countDown.sec)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'timer-label' },
	              'SECONDS'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Countdown;
	}(_react.Component);
	
	exports.default = Countdown;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	__webpack_require__(185);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardNavigation = function DashboardNavigation(props) {
	  return _react2.default.createElement(
	    'ul',
	    { className: 'main-nav' },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: _utils.disabledCart && !props.enabledCart ? props.prevPath.pathname : '/cart',
	          className: _utils.disabledCart ? 'isDisabled' : '',
	          activeClassName: _utils.disabledCart ? '' : 'active' },
	        'Cart'
	      )
	    ),
	    props.fetchCart ? null : props.offsize && props.offsize.length > 0 ? _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/offsize', activeClassName: 'active' },
	        'Off-size Items'
	      )
	    ) : null,
	    props.fetchProhibited ? null : props.prohibited ? props.prohibited.data.length > 0 ? _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/prohibited', activeClassName: 'active' },
	        _react2.default.createElement('i', { className: 'prohibited-alert fa fa-exclamation-triangle' }),
	        ' Prohibited Items'
	      )
	    ) : null : null,
	    [{ route: '/shipment', label: 'Shipments' }, { route: '/account', label: 'Account' }].map(function (link, i) {
	      return _react2.default.createElement(
	        'li',
	        { key: i },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: _utils.disabledCart && !props.enabledCart && link.route === '/cart' ? props.prevPath.pathname : link.route,
	            className: _utils.disabledCart && link.route === '/cart' ? 'isDisabled' : '',
	            activeClassName: _utils.disabledCart && link.route === '/cart' ? '' : 'active' },
	          link.label
	        )
	      );
	    })
	  );
	};
	
	exports.default = DashboardNavigation;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _Header = __webpack_require__(123);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _DashboardNav = __webpack_require__(597);
	
	var _DashboardNav2 = _interopRequireDefault(_DashboardNav);
	
	var _DashboardAddress = __webpack_require__(249);
	
	var _DashboardAddress2 = _interopRequireDefault(_DashboardAddress);
	
	var _utils = __webpack_require__(13);
	
	var _whiteListed = __webpack_require__(93);
	
	var _reactDeviceDetect = __webpack_require__(1022);
	
	var _Countdown = __webpack_require__(596);
	
	var _Countdown2 = _interopRequireDefault(_Countdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var appConfig = __webpack_require__(71);
	var extensionId = appConfig.extensionId;
	/* eslint-enable */
	var createReactClass = __webpack_require__(16);
	var DefaultDashboardBody = createReactClass({
	  displayName: 'DefaultDashboardBody',
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	    window.addEventListener('resize', this.updateWindowDimensions);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.updateWindowDimensions);
	  },
	  componentWillMount: function componentWillMount() {
	    var token = localStorage.jwtToken;
	    this.props.signedIn(token);
	    localStorage.setItem("TourFinish", "false");
	    this.props.getCopyrightYear();
	    this.props.getCartBanner();
	
	    var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
	    var isMac = navigator.userAgent.toLowerCase().indexOf('mac') > -1;
	    if (isChrome) {
	      if (isMac) {
	        localStorage.setItem("cartExtensionModalShowed", true);
	      } else {
	        (0, _utils.extensionDetect)(extensionId);
	      }
	    } else {
	      localStorage.setItem("cartExtensionModalShowed", true);
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      cmsList: [],
	      first_name: '',
	      last_name: '',
	      account_number: '',
	      phone_number: '',
	      enabledCart: false,
	      prevPath: ''
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.login.login.party) {
	      var enabledCart = _utils.adminUserIds.find(function (e) {
	        return e === nextProps.login.login.party.account_number;
	      });
	      this.setState({
	        first_name: (0, _utils.serializeSpecialChars)(nextProps.login.login.party.first_name),
	        last_name: (0, _utils.serializeSpecialChars)(nextProps.login.login.party.last_name),
	        account_number: nextProps.login.login.party.account_number,
	        phone_number: nextProps.login.login.party.phone_number,
	        enabledCart: enabledCart ? true : false
	      });
	    }
	    if (_utils.disabledCart && nextProps.location !== this.props.location) {
	      this.setState({ prevPath: nextProps.location });
	    }
	  },
	  handleLogout: function handleLogout() {
	    localStorage.removeItem('jwtToken');
	    this.props.logout();
	  },
	  updateWindowDimensions: function updateWindowDimensions() {
	    this.setState({ width: window.innerWidth });
	  },
	  hanldeBannerLink: function hanldeBannerLink(link) {
	    if (link.includes('shippingcart.com')) {
	      return link.split('shippingcart.com')[1];
	    }
	    return link;
	  },
	  render: function render() {
	    var _this = this;
	
	    // let warehouse = this.props.customerInfo.warehouse_fetched ? this.props.customerInfo.warehouse.data : null;
	    var cartBanner = this.props.cms.cartBanner && this.props.cms.getCartBanner.data[0];
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header2.default, {
	        isAuthenticated: true,
	        login: this.props.login,
	        logout: this.handleLogout
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'body-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'customer storage' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'customer-wrapper' },
	              cartBanner && cartBanner.status === 1 && _react2.default.createElement(
	                'div',
	                { className: 'dashboard-ad' },
	                _reactDeviceDetect.isMobile || this.state.width < '960' || window.innerWidth < '960' ? _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: cartBanner.redirection_mobile_link ? this.hanldeBannerLink(cartBanner.redirection_mobile_link) : this.hanldeBannerLink(cartBanner.redirection_web_link), target: '_blank' },
	                  _react2.default.createElement('img', { src: cartBanner.banner_mobile_url ? cartBanner.banner_mobile_url : cartBanner.banner_web_url, alt: 'banner-ad', style: { maxHeight: '100px' } })
	                ) : _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: this.hanldeBannerLink(cartBanner.redirection_web_link), target: '_blank' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('img', { src: cartBanner.banner_web_url, alt: 'banner-ad', style: cartBanner.ended_timer_at ? { width: '80%', height: '55px' } : { width: '100%', maxHeight: '55px' } }),
	                    cartBanner.ended_timer_at && _react2.default.createElement(_Countdown2.default, { date: cartBanner.ended_timer_at })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'aside',
	                { className: 'address-sidebar' },
	                this.props.customerInfo.warehouse_fetched ? (0, _whiteListed.filterWarehouse)(this.props.customerInfo.warehouse.data, this.props.login.login.party).map(function (address, key) {
	                  return _react2.default.createElement(_DashboardAddress2.default, {
	                    first_name: _this.state.first_name,
	                    last_name: _this.state.last_name,
	                    account_number: _this.state.account_number,
	                    key: key,
	                    address: address,
	                    unTrimmedAddress: true,
	                    highlightOregon: true
	                  });
	                }) : _react2.default.createElement('div', { className: 'address-box' }),
	                _react2.default.createElement('div', { className: 'shadow' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'side-banner' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'wrapper' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '#', target: '_blank' },
	                      _react2.default.createElement('div', { className: 'side-img' })
	                    )
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'shadow' })
	              ),
	              _react2.default.createElement(
	                'a',
	                { id: 'hashtabs', name: 'hashtabs' },
	                ""
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'main', role: 'main' },
	                _react2.default.createElement('div', { className: 'main-header' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'main-wrapper' },
	                  _react2.default.createElement(_DashboardNav2.default, {
	                    fetchProhibited: this.props.parcelInfo.prohibited_fetching,
	                    prohibited: this.props.parcelInfo.prohibited,
	                    fetchCart: this.props.parcelInfo.cart_fetching,
	                    offsize: this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.offsizeItems,
	                    enabledCart: this.state.enabledCart,
	                    prevPath: this.state.prevPath
	                  }),
	                  _react2.default.cloneElement(Object.assign({}, this.props).children, Object.assign({}, this.props))
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, {
	        currentPath: this.props.location.pathname,
	        currentYear: this.props.login.year
	      })
	    );
	  }
	});
	
	exports.default = DefaultDashboardBody;

/***/ },
/* 599 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var krAddress = exports.krAddress = {
	  addressLine1: '방화동 양천로 81 쥬피터빌딩,3층',
	  city: '서울',
	  state: '강서구'
	};
	
	var jpAddress = exports.jpAddress = {
	  addressLine1: 'ショッピングカート合同会社',
	  state: '仙台市 若林区木ノ下',
	  city: '宮城県',
	  chome: '3-1-2'
	};

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(824);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _utils = __webpack_require__(13);
	
	var _restrictedAreas = __webpack_require__(256);
	
	var _lodash = __webpack_require__(139);
	
	var _RestrictedTooltip = __webpack_require__(621);
	
	var _RestrictedTooltip2 = _interopRequireDefault(_RestrictedTooltip);
	
	var _times = __webpack_require__(879);
	
	var _times2 = _interopRequireDefault(_times);
	
	var _angleLeft = __webpack_require__(320);
	
	var _angleLeft2 = _interopRequireDefault(_angleLeft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// import { renderFlagIconRound } from '../../utils/warehouseFlags';
	
	var createReactClass = __webpack_require__(16);
	var Account = createReactClass({
	  displayName: 'Account',
	  componentWillMount: function componentWillMount() {
	    var script = document.createElement("script");
	    script.setAttribute('class', 'lbcx');
	    script.type = "text/javascript";
	    script.src = "/js/custom.js";
	    script.async = true;
	    document.body.appendChild(script);
	
	    var x = document.getElementsByClassName("lbcx");
	
	    for (var i = 0; i < x.length; i++) {
	      document.body.removeChild(x.item(i));
	    }
	
	    // if (this.props.login.hasOwnProperty('provinces')) {
	    //   if (!this.props.login.provinces) {
	    //     this.props.getProvinces();
	    //   }
	    // }
	    if (this.props.login.hasOwnProperty('region')) {
	      if (!this.props.login.region) {
	        this.props.getRegions();
	      }
	    }
	    var token = localStorage.jwtToken;
	    this.props.signedIn(token);
	
	    if (localStorage.account_redirect) {
	      this.setState({
	        activeTab: 'account_information'
	      });
	    }
	  },
	  getInitialState: function getInitialState() {
	    return {
	      first_name: "",
	      last_name: "",
	      countryPrefix: "+63",
	      add_countryPrefix: "+63",
	      phone_number: "",
	      address_phone_number: "",
	      gender: "",
	      birthdate: "",
	      email: "",
	      password_confirm: "",
	      password: "",
	      new_password: "",
	      new_confirm_password: "",
	      errors: {
	        "Profile": {
	          "first_name": " What's your first name? ",
	          "last_name": " What's your last name? ",
	          "phone_number": " What's your contact number.? "
	        },
	        "Email": {
	          "email": " Give us a valid email address ",
	          "password_confirm": " Empty current password "
	        },
	        "Password": {
	          "password": " Empty current password ",
	          "new_password": " New password must be greater than or equal to 6 characters ",
	          "new_confirm_password": " Confirmed password must be greater than or equal to 6 characters "
	        },
	        "Address": {
	          "add_first_name": "",
	          "add_last_name": "",
	          "add_line_1": "Street Address",
	          "add_line_2": "Barangay",
	          "add_state": "",
	          "add_city": "",
	          "add_postal_code": ""
	        }
	      },
	      focus_key: "",
	      storeAddress: true,
	      addressId: 0,
	      add_first_name: "",
	      add_last_name: "",
	      street: "",
	      region: "",
	      country: "",
	      province: "",
	      city: "",
	      district: "",
	      postal_code: "",
	      editProvince: {},
	      fetchedCities: false,
	      fetchedDistricts: false,
	      enableProvince: false,
	      enableCity: false,
	      enableDistrict: false,
	      IsFormSubmitted: false,
	      IsEditingInput: false,
	      IsProfileUp: false,
	      IsEmailUp: false,
	      IsPasswordUp: false,
	      profileClicked: false,
	      emailClicked: false,
	      passwordClicked: false,
	      // Modal
	      showModal: false,
	      deleteAddressModal: "",
	      modalTitle: '',
	      submitText: 'Submit', // HAM : this is so we don't get the uncontrolled/controlled component warning for address submit button
	      phoneNumberUpdated: false,
	      activeTab: 'address_book',
	      isAddressDeletionSuccess: false
	    };
	  },
	  loadAddresses: function loadAddresses(e) {
	    e.preventDefault();
	    this.clrErrorMsgs('Address');
	    this.resetAll();
	    this.setState({ activeTab: 'address_book' });
	  },
	  loadAccounts: function loadAccounts(e) {
	    e.preventDefault();
	    this.clrErrorMsgs('Profile');
	    this.resetAll();
	    this.setState({ activeTab: 'account_information' });
	  },
	  loadRewards: function loadRewards(e) {
	    e.preventDefault();
	    this.clrErrorMsgs();
	    this.resetAll();
	  },
	
	  // handles on click of add address button
	  handleAddButton: function handleAddButton(e) {
	    var _this = this;
	
	    this.resetAll();
	    window.scrollTo(0, 0);
	    e.preventDefault();
	    // ReactDOM.findDOMNode(this.refs.modal_header).innerHTML = "Add Address";
	    // ReactDOM.findDOMNode(this.refs.add_first_name).focus();
	    this.setState({
	      storeAddress: true,
	      modalTitle: 'Add Address',
	      submitText: "SAVE",
	      enableProvince: false,
	      enableCity: false,
	      enableDistrict: false,
	      focus_key: "add_first_name",
	      add_first_name: "",
	      add_last_name: "",
	      street: "",
	      country: "",
	      province: "",
	      city: "",
	      district: "",
	      postal_code: "",
	      region: "",
	      showModal: true
	    }, function () {
	      _this.clrErrorMsgs("Address");
	      _this.refs.add_first_name.focus();
	    });
	  },
	
	  // handles on click of edit address button
	  handleEditButton: function handleEditButton(e, addressId) {
	    var _this2 = this;
	
	    e.preventDefault();
	    this.setState({ isAddressDeletionSuccess: false });
	    this.setState({ modalTitle: 'Edit Address', showModal: true }, function () {
	      _this2.refs.add_first_name.focus();
	    });
	    // TODO:  This is just a work around find another way to trigger edit link to show modal address on REFRESH 2/22/2017    
	    // this.refs.add_address.click(); // <---- HAM : WTF!!! 
	    // ReactDOM.findDOMNode(this.refs.modal_header).innerHTML = "Edit Address";
	    this.setState({});
	    // ReactDOM.findDOMNode(this.refs.add_first_name).focus();
	    //console.log(this.addFirstNameInput);
	    this.setState({
	      submitText: "Save",
	      enableProvince: true,
	      enableCity: true,
	      enableDistrict: true,
	      focus_key: "add_first_name",
	      fetchedDistricts: false,
	      district: ""
	    });
	
	    // var addressId = parseInt(e.target.getAttribute('data-address-id'), 10) || 0;
	    try {
	      if (this.props.login.hasOwnProperty('login')) {
	        // Map the object from the list of address
	        var obj = this.props.login.login.party.addresses.filter(function (i) {
	          return i.id === addressId;
	        })[0];
	
	        if (this.isNotEmptyObj(obj)) {
	          this.setState({
	            addressId: addressId,
	            add_first_name: obj.full_name.first_name,
	            add_last_name: obj.full_name.last_name,
	            street: obj.line_1,
	            country: obj.country_code,
	            province: obj.state,
	            city: obj.city,
	            district_name: obj.line_2,
	            postal_code: obj.postal_code,
	            add_countryPrefix: obj.phone_number ? obj.phone_number.substring(0, 3) : '',
	            address_phone_number: obj.phone_number ? obj.phone_number.substring(3) : ''
	          }, function () {
	            var _this3 = this;
	
	            this.props.getProvinces(obj.country_code);
	            var selectedProvince = _reactDom2.default.findDOMNode(this.refs.province);
	            var province_id = 0;
	            var region_id = 0;
	
	            setTimeout(function () {
	              for (var i = 0; i < selectedProvince.options.length; i++) {
	                if (selectedProvince.options[i].value === obj.state) {
	                  province_id = selectedProvince.options[i].getAttribute('data-province-id');
	                  region_id = selectedProvince.options[i].getAttribute('data-region');
	                  break;
	                }
	              }
	
	              if (_this3.state.country === "PH") {
	                _this3.setRegion(region_id);
	              }
	
	              // if province id was set.
	              if (province_id > 0) {
	                // this.setState({ storeAddress: false, });
	                var t = _this3;
	                t.unsubscribe = _store2.default.subscribe(function () {
	                  var selectedCity = _reactDom2.default.findDOMNode(t.refs.city);
	                  var city_id = 0;
	                  for (var _i = 0; _i < (selectedCity ? selectedCity.options.length : null); _i++) {
	                    if (selectedCity.options[_i].value === obj.city) {
	                      city_id = selectedCity.options[_i].getAttribute('data-city-id');
	                      break;
	                    }
	                  }
	                  if (city_id > 0) {
	                    t.props.getDistricts(city_id);
	                    if (typeof t.unsubscribe === 'function') {
	                      t.unsubscribe();
	                    }
	                  }
	                });
	                // get the cities belongs to this province.
	                _this3.props.getCities(province_id);
	              }
	
	              setTimeout(function () {
	                //set district id state
	                if (_this3.props.login && _this3.props.login.district_fetched) {
	                  _this3.setState({ district: (_this3.props.login.districts.data || _this3.props.login.districts).find(function (d) {
	                      return d.postal_code === obj.postal_code && d.name === obj.line_2;
	                    }).id });
	                }
	              }, 2900);
	            }, 2300);
	          });
	        }
	      }
	    } catch (ex) {
	      return false;
	    }
	  },
	  handleDeleteButton: function handleDeleteButton(addressId) {
	    var _this4 = this;
	
	    // e.preventDefault();
	    this.clrErrorMsgs("Address");
	    this.setState({ isAddressDeletionSuccess: false });
	    // var addressId = parseInt(e.target.getAttribute('data-address-id'), 10) || 0;
	    this.props.deleteAddress(addressId).then(function (res) {
	      if (res && res.data && res.data.is_success) {
	        _this4.setState({ isAddressDeletionSuccess: true });
	      }
	    });
	    this.setState({ deleteAddressModal: "" });
	  },
	  handleMakeDefaultButton: function handleMakeDefaultButton(e) {
	    e.preventDefault();
	    this.clrErrorMsgs("Address");
	    var addressId = parseInt(e.target.getAttribute('data-address-id'), 10) || 0;
	    if (addressId > 0) {
	      this.props.setDefaultAddress(addressId);
	    }
	  },
	  formAddress: function formAddress(e) {
	    var _this5 = this;
	
	    e.preventDefault();
	    var token = localStorage.jwtToken;
	    var parameters = {
	      token: token,
	      "first_name": this.state.add_first_name,
	      "middle_initial": "",
	      "last_name": this.state.add_last_name,
	      "line_1": this.state.street,
	      "type": "delivery",
	      "line_2": this.state.district_name,
	      "city": this.state.city,
	      "state": this.state.province,
	      "postal_code": this.state.postal_code,
	      "region": this.state.region,
	      "country_code": this.state.country,
	      "phone_number": this.state.add_countryPrefix && this.state.address_phone_number && '' + this.state.add_countryPrefix + this.state.address_phone_number
	    };
	    // if true then it will add else update
	    if (!this.state.addressId) {
	      this.props.addAddress(parameters);
	    } else {
	      this.props.editAddress(this.state.addressId, parameters);
	    }
	    this.setState({ IsFormSubmitted: true }, function () {
	      _this5.clrErrorMsgs("Address");
	    });
	  },
	  handleInputChange: function handleInputChange(e) {
	    var target = e.target;
	    var name = target.name;
	    var value = target.value;
	    if (name === "last_name" || name === "first_name") {
	      this.setState(_defineProperty({}, name, (0, _utils.serializeSpecialChars)(value)));
	    } else if (name === "countryPrefix") {
	      this.setState(_defineProperty({}, name, value));
	      this.setState({ phone_number: "" });
	    } else if (name === "add_countryPrefix") {
	      this.setState(_defineProperty({}, name, value));
	      this.setState({ phone_number: "" });
	    } else {
	
	      this.setState(_defineProperty({}, name, value));
	    }
	
	    this.setState({
	      IsEditingInput: true
	    });
	  },
	  handleCountries: function handleCountries(e) {
	    var _this6 = this;
	
	    this.setState({
	      country: e.target.value,
	      enableProvince: e.target.value ? true : false,
	      enableCity: false,
	      enableDistrict: false,
	      province: "",
	      region: "",
	      city: "",
	      district: "",
	      postal_code: ""
	    }, function () {
	      _this6.props.getProvinces(_this6.state.country);
	    });
	  },
	  handleProvinces: function handleProvinces(e) {
	    var index = e.nativeEvent.target.selectedIndex;
	    var province_id = e.nativeEvent.target[index].getAttribute('data-province-id') || 0;
	    var region_id = e.nativeEvent.target[index].getAttribute('data-region') || 0;
	    if (this.state.country === "PH") {
	      this.setRegion(region_id);
	    }
	    if (province_id !== 0) {
	      this.props.getCities(province_id);
	    } else {
	      this.props.resetLocationCalls('GET_CITY_FULFILLED');
	      this.props.resetLocationCalls('GET_DISTRICT_FULFILLED');
	    }
	    this.setState({
	      province: e.target.value,
	      enableCity: e.target.value ? true : false,
	      // enableDistrict:(e.target.value ? true:false),
	      city: "",
	      district: "",
	      postal_code: ""
	    });
	  },
	  handleCities: function handleCities(e) {
	    var index = e.nativeEvent.target.selectedIndex;
	    var city_id = e.nativeEvent.target[index].getAttribute('data-city-id') || 0;
	    if (city_id !== 0) {
	      this.props.getDistricts(city_id);
	    } else {
	      this.props.resetLocationCalls('GET_DISTRICT_FULFILLED');
	    }
	    this.setState({
	      city: e.target.value,
	      enableDistrict: e.target.value ? true : false,
	      district: "",
	      postal_code: ""
	    });
	  },
	  handleDistricts: function handleDistricts(e) {
	    var index = e.nativeEvent.target.selectedIndex;
	    var postal_code = e.nativeEvent.target[index].getAttribute('data-postal-code') || "";
	    var district_name = e.nativeEvent.target[index].getAttribute('data-district-name') || "";
	    this.setState({
	      district: e.target.value,
	      district_name: district_name,
	      postal_code: postal_code
	    });
	  },
	  handleProfile: function handleProfile(e) {
	    e.preventDefault();
	    var phoneNumberUpdated = false;
	    if (!this.state.countryPrefix) {
	      return this.refs.errors_phone_number.innerHTML = 'Please select country prefix', this.refs.errors_phone_number.className = "input-error", this.refs.errors_phone_number.parentElement.className = "control has-error";
	    }
	    if (this.state.phone_number.length < 7) {
	      return this.refs.errors_phone_number.innerHTML = 'The phone number must be at least 7 characters.', this.refs.errors_phone_number.className = "input-error", this.refs.errors_phone_number.parentElement.className = "control has-error";
	    }
	    if (this.props.login.login.party.phone_number && this.props.login.login.party.phone_number.slice(3, 13) !== this.state.phone_number) {
	      phoneNumberUpdated = true;
	    }
	    if (!this.props.login.login.party.phone_number && this.state.phone_number) {
	      phoneNumberUpdated = true;
	    }
	    this.setState({ focus_key: "first_name" });
	    var first_name = this.refs.first_name.value;
	    var last_name = this.refs.last_name.value;
	    var phone_number = this.state.countryPrefix + this.refs.phone_number.value;
	    var token = localStorage.jwtToken;
	    var gender = this.state.gender;
	    var birthday = this.refs.birthday.value ? this.formatDateOnly(this.refs.birthday.value, '/', '-') : '';
	    if (!phoneNumberUpdated) {
	      this.props.updateCustomerProfile(null, null, phoneNumberUpdated, first_name, last_name, phone_number, gender, birthday, token);
	    } else {
	      this.props.putReSendOTP(null, phoneNumberUpdated, first_name, last_name, phone_number, gender, birthday, token);
	    }
	    this.setState({ IsFormSubmitted: true });
	    this.clrErrorMsgs("Profile");
	  },
	  handleEmail: function handleEmail(e) {
	    e.preventDefault();
	    this.setState({ focus_key: "email" });
	    var email = this.state.email;
	    var password_confirm = this.state.password_confirm;
	    var token = localStorage.jwtToken;
	    this.props.updateCustomerEmail(email, password_confirm, token);
	    this.setState({ IsFormSubmitted: true });
	    this.clrErrorMsgs("Email");
	  },
	  handlePassword: function handlePassword(e) {
	    e.preventDefault();
	    this.setState({ focus_key: "password" });
	    var password = this.refs.password.value;
	    var new_password = this.refs.new_password.value;
	    var new_confirm_password = this.refs.new_confirm_password.value;
	    var token = localStorage.jwtToken;
	    this.props.updateCustomerPassword(password, new_password, new_confirm_password, token);
	    this.setState({ IsFormSubmitted: true });
	    this.clrErrorMsgs("Password");
	  },
	  handleCancel: function handleCancel(str, cancelOnly, e) {
	    e.preventDefault();
	    this.clrErrorMsgs(str);
	    this.resetAll();
	    if (str && cancelOnly) {
	      var _setState5;
	
	      var name = 'Is' + str + 'Up';
	      this.setState((_setState5 = {}, _defineProperty(_setState5, name, false), _defineProperty(_setState5, 'showModal', false), _setState5));
	      window.scrollTo(0, 0);
	    }
	    return false;
	  },
	  toggleProfile: function toggleProfile(str, e) {
	    var _this7 = this;
	
	    this.handleCancel(str, false, e);
	    if (this.state.profileClicked && this.state.IsProfileUp) {
	      this.setState({ profileClicked: false, IsProfileUp: false }, function () {
	        _this7.refs.profile_cancel.click();
	      });
	    } else {
	      this.setState({
	        IsProfileUp: true,
	        profileClicked: true
	      });
	    }
	    if (this.state.IsEmailUp) {
	      this.refs.email_cancel.click();
	    }
	    if (this.state.IsPasswordUp) {
	      this.refs.password_cancel.click();
	    }
	    _reactDom2.default.findDOMNode(this.refs.first_name).focus();
	    return false;
	  },
	  toggleEmail: function toggleEmail(str, e) {
	    var _this8 = this;
	
	    this.handleCancel(str, false, e);
	    if (this.state.emailClicked && this.state.IsEmailUp) {
	      this.setState({ emailClicked: false, IsEmailUp: false }, function () {
	        _this8.refs.email_cancel.click();
	      });
	    } else {
	      this.setState({
	        IsEmailUp: true,
	        emailClicked: true
	      });
	    }
	    if (this.state.IsProfileUp) {
	      this.refs.profile_cancel.click();
	    }
	    if (this.state.IsPasswordUp) {
	      this.refs.password_cancel.click();
	    }
	    _reactDom2.default.findDOMNode(this.refs.email).focus();
	    return false;
	  },
	  togglePassword: function togglePassword(str, e) {
	    var _this9 = this;
	
	    this.handleCancel(str, false, e);
	    if (this.state.passwordClicked && this.state.IsPasswordUp) {
	      this.setState({ passwordClicked: false, IsPasswordUp: false }, function () {
	        _this9.refs.password_cancel.click();
	      });
	    } else {
	      this.setState({
	        IsPasswordUp: true,
	        passwordClicked: true
	      });
	    }
	    if (this.state.IsProfileUp) {
	      this.refs.profile_cancel.click();
	    }
	    if (this.state.IsEmailUp) {
	      this.refs.email_cancel.click();
	    }
	    _reactDom2.default.findDOMNode(this.refs.password).focus();
	    return false;
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this10 = this;
	
	    if (!this.state.IsFormSubmitted && !this.state.IsEditingInput) {
	      this.setState({
	        first_name: nextProps.login.fetched ? nextProps.login.login.party.first_name ? nextProps.login.login.party.first_name : "" : "",
	        last_name: nextProps.login.fetched ? nextProps.login.login.party.last_name ? nextProps.login.login.party.last_name : "" : "",
	        phone_number: nextProps.login.fetched ? (0, _utils.prefixNumber)(nextProps.login.login.party.phone_number.slice(0, 3)) ? nextProps.login.login.party.phone_number.slice(3) : nextProps.login.login.party.phone_number : "",
	        countryPrefix: nextProps.login.fetched ? (0, _utils.prefixNumber)(nextProps.login.login.party.phone_number.slice(0, 3)) ? nextProps.login.login.party.phone_number.slice(0, 3) : "" : "",
	        gender: nextProps.login.fetched ? nextProps.login.login.party.gender ? nextProps.login.login.party.gender : "" : "",
	        birthdate: nextProps.login.fetched ? nextProps.login.login.party.birthdate ? nextProps.login.login.party.birthdate : "" : "",
	        email: nextProps.login.fetched ? nextProps.login.login.party.email ? nextProps.login.login.party.email : "" : ""
	      }, function () {
	        _this10.setState({
	          phone_number: _this10.state.phone_number.length > 10 ? '' : _this10.state.phone_number
	        });
	      });
	    }
	    if (nextProps.login.updateProfileData && nextProps.login.updateProfileData.data) {
	      this.setState({
	        successUpdateProfile: true
	      });
	    }
	    (0, _jquery2.default)('#SCTitle').text("Account | ShippingCart");
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    // PRE SELECT CITY FROM ADDRESS INFO
	    if (this.props.login.hasOwnProperty('cities') && !this.state.fetchedDistricts) {
	      // this will prevent the component to update forever!!
	      if (this.props.login.cities && !this.state.storeAddress) {
	        if (this.isNotEmptyObj(this.props.login.cities)) {
	          var selected = _reactDom2.default.findDOMNode(this.refs.city);
	          var city_id = 0;
	          for (var i = 0; i < selected.options.length; i++) {
	            if (selected.options[i].value === this.state.city) {
	              city_id = selected.options[i].getAttribute('data-city-id');
	              break;
	            }
	          }
	          city_id = parseInt(city_id, 10) || 0;
	          // if city id was set.
	          if (city_id > 0) {
	            this.setState({ fetchedDistricts: true });
	            // get the districts belongs to this city.
	            this.props.getDistricts(city_id);
	            this.setState({
	              enableCity: true,
	              enableDistrict: true
	            });
	          }
	        } else {
	          this.setState({
	            enableCity: false,
	            enableDistrict: false
	          });
	        }
	      }
	    }
	
	    // // PRE SELECT DISTRICT FROM ADDRESS INFO
	    // if(this.props.login.hasOwnProperty('districts')  && !this.state.fetchedDistricts){
	    //   // this will prevent the component to update forever!!
	    //   if(this.props.login.districts && !this.storeAddress){
	    //     if(this.isNotEmptyObj(this.props.login.districts)){
	    //       var selected =  ReactDOM.findDOMNode(this.refs.districts);
	    //       for (let i = 0; i < selected.options.length; i++) {
	    //           if (selected.options[i].text === this.state.editAddress.line_2) {
	    //               selected.selectedIndex = i;
	    //               break;
	    //           }
	    //       }
	    //       this.setState({fetchedDistricts:true});
	    //     }
	    //   }
	    // }
	    if (this.state.IsFormSubmitted) {
	      try {
	        var status = this.props.login.error ? this.props.login.error.response ? this.props.login.error.response.status : this.props.login.error.status : 200;
	        // clear error or success fields.
	        // this.clrErrorMsgs();
	        // if there's an error
	        if (status !== 200) {
	          // failed validation
	          if (status === 422) {
	            var params = this.props.login.error.response ? this.props.login.error.response.data.errors : this.props.login.error.data.errors;
	            if (this.state.focus_key) {
	              this.refs["notify_error_" + this.state.focus_key].className = "sc-alert sc-alert-danger";
	              this.refs["notify_error_" + this.state.focus_key].parentElement.className = "notify";
	              _reactDom2.default.findDOMNode(this.refs["notify_error_" + this.state.focus_key].parentElement.parentElement.parentElement).scrollIntoView(true);
	            }
	            var focus = true;
	            if (params) {
	              for (var ek in params) {
	                if (params.hasOwnProperty(ek)) {
	                  if (params[ek]) {
	                    var str = (this.state.focus_key === "add_first_name" ? "errors_add_" : "errors_") + params[ek].title;
	                    if (this.refs[str]) {
	                      this.refs[str].innerHTML = (0, _utils.maskAddressErrorMessage)(params[ek].detail, this.state.country);
	                      this.refs[str].className = "input-error";
	                      this.refs[str].parentElement.className = "control has-error";
	                      if (focus) {
	                        _reactDom2.default.findDOMNode(this.refs[str].nextSibling).focus();
	                        focus = false;
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	          this.setState({ IsFormSubmitted: false });
	        } else {
	          if (this.props.login.updateEmail || this.props.login.updatePassword || this.props.login.addAddress || this.props.login.editAddress || this.props.login.updateProfile) {
	            // This will handles the Update from adding and updating Address information
	            if (this.props.login.addAddress || this.props.login.editAddress) {
	              // if true then close the modal and reset its info.
	              // this.refs.modal_address_cancel.click();
	              this.setState({ showModal: false });
	            }
	            if (this.state.focus_key) {
	              this.refs["notify_success_" + this.state.focus_key].className = "sc-alert sc-alert-success";
	              this.refs["notify_success_" + this.state.focus_key].parentElement.className = "notify";
	              if (this.state.focus_key === "add_first_name") {
	                this.refs.addressSuccessText.innerHTML = this.props.login.addAddress ? "You've added a new address." : this.props.login.editAddress ? "You've successfully updated your address." : "";
	
	                _reactDom2.default.findDOMNode(this.refs.address_book.parentElement.parentElement.parentElement).scrollIntoView(true);
	              } else {
	                _reactDom2.default.findDOMNode(this.refs["notify_success_" + this.state.focus_key].parentElement.parentElement.parentElement).scrollIntoView(true);
	              }
	            }
	            this.setState({ IsFormSubmitted: false });
	          }
	        }
	      } catch (ex) {
	        return false;
	      }
	    }
	
	    if (this.props.login.error) {
	      if (this.props.login.error.response) {
	        if (this.props.login.error.response.status === 401) {
	          _store.history.push("/signin");
	        }
	      }
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->    
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.setState({ focus_key: "" });
	    this.props.resetAccounts();
	    // this.clrErrorMsgs();
	    localStorage.removeItem('account_redirect');
	  },
	  formatDateOnly: function formatDateOnly(arr, separator, format) {
	    if (arr) {
	      if (separator === "/") {
	        arr = arr.split(separator);
	        arr.unshift(arr[arr.length - 1]);
	        arr.pop();
	        return arr.join(format);
	      } else if (separator === "-") {
	        arr = arr.split(separator);
	        arr.push(arr[0]);
	        arr.shift();
	        return arr.join(format);
	      }
	    } else {
	      arr = "mm/dd/yyyy";
	    }
	    return arr;
	  },
	  clrErrorMsgs: function clrErrorMsgs() {
	    var notify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    var errors = this.state.errors;
	    // clear here the labels original text
	    for (var k in errors) {
	      if (errors.hasOwnProperty(k)) {
	        var listError = notify ? errors[notify] : errors[k];
	        // clear here the labels original text
	        for (var err in listError) {
	          if (listError.hasOwnProperty(err)) {
	            if (this.refs.hasOwnProperty('errors_' + err)) {
	              this.refs["errors_" + err].className = "disnone";
	              this.refs["errors_" + err].innerHTML = listError[err];
	              this.refs["errors_" + err].parentNode.className = "control";
	            }
	          }
	        }
	      }
	      this.setState({ successUpdateProfile: false });
	    }
	    var focus_key = { "Address": "add_first_name", "Profile": "first_name", "Email": "email", "Password": "password" };
	    if (focus_key[notify]) {
	      this.refs["notify_success_" + focus_key[notify]].parentElement.className = "disnone";
	      this.refs["notify_success_" + focus_key[notify]].className = "disnone";
	      if (this.refs.hasOwnProperty('notify_error_' + focus_key[notify])) {
	        this.refs["notify_error_" + focus_key[notify]].className = "disnone";
	      }
	    } else {
	      for (var j in focus_key) {
	        if (focus_key.hasOwnProperty(j)) {
	          this.refs["notify_success_" + focus_key[j]].parentElement.className = "disnone";
	          this.refs["notify_success_" + focus_key[j]].className = "disnone";
	          this.refs["notify_error_" + focus_key[j]].className = "disnone";
	        }
	      }
	    }
	    this.setState({ password_confirm: "" });
	    this.refs.password.value = "";
	    this.refs.new_password.value = "";
	    this.refs.new_confirm_password.value = "";
	  },
	  resetAll: function resetAll() {
	    this.setState({
	      focus_key: "",
	      storeAddress: true,
	      addressId: 0,
	      add_first_name: "",
	      add_last_name: "",
	      street: "",
	      region: "",
	      province: "",
	      city: "",
	      district: "",
	      postal_code: "",
	      editProvince: {},
	      fetchedCities: false,
	      fetchedDistricts: false,
	      enableProvince: false,
	      enableCity: false,
	      enableDistrict: false,
	      IsFormSubmitted: false,
	      IsEditingInput: false
	    });
	    this.props.resetAccounts();
	    // const gender =  this.props.login.fetched ? this.props.login.login.party.gender : null;
	    // if(gender)
	    //   ReactDOM.findDOMNode(this.refs[gender]).checked = true;
	    // var birthdate = this.props.login.fetched ? this.props.login.login.party.birthdate : null;
	    // if(birthdate){
	    //   birthdate = this.formatDateOnly(birthdate,'-','/');
	    //   ReactDOM.findDOMNode(this.refs.birthdate).innerHTML = birthdate;
	    //   ReactDOM.findDOMNode(this.refs.birthday).value = birthdate;
	    // }
	  },
	
	  // this will check if object is empty or not. by Adam Zerner on StackOverFlow : Used By Rexgama
	  isNotEmptyObj: function isNotEmptyObj(obj) {
	    var result = Object.keys(obj).length !== 0 && obj.constructor === Object;
	    return result;
	  },
	  setRegion: function setRegion(id) {
	    var region_id = parseInt(id, 10) || 0;
	    // Map the object from the list of address
	    if (this.props.login.hasOwnProperty('region') && region_id > 0) {
	      var regionObj = this.props.login.region.data.filter(function (i) {
	        return i.id === region_id;
	      })[0];
	      if (this.isNotEmptyObj(regionObj)) {
	        if (regionObj.hasOwnProperty('name')) {
	          this.setState({
	            region: regionObj.name
	          });
	        }
	      }
	    } else {
	      this.setState({
	        region: ""
	      });
	    }
	  },
	  handleModalHide: function handleModalHide() {
	    this.setState({ showModal: false });
	  },
	  handleEnableButton: function handleEnableButton() {
	    if (this.props.login.fetched) {
	      if (this.props.login.login.party.email === this.state.email) {
	        if (!this.state.password_confirm) {
	          return true;
	        }
	        if (this.props.login.login.party.fb_id) {
	          if (!this.state.password_confirm) {
	            return false;
	          }
	        }
	        return true;
	      }
	      return false;
	    }
	  },
	  handleShowPassword: function handleShowPassword(e) {
	    var name = e.target.name;
	    if (this.refs['show_' + name].checked) {
	      this.refs[name].type = 'text';
	    } else {
	      this.refs[name].type = 'password';
	    }
	  },
	  renderAddresses: function renderAddresses() {
	    var _this11 = this;
	
	    if (!this.props.login.fetched) return;
	    var addresses = [].concat(_toConsumableArray(this.props.login.login.party.addresses));
	    this.props.login.login.party.addresses.forEach(function (address) {
	      var isRestricted = false;
	      (0, _lodash.find)(_restrictedAreas.restrictedAreas.provinces, function (restrictedArea) {
	        if (address.state === restrictedArea.province) {
	          isRestricted = true;
	        }
	      });
	      if (!isRestricted) {
	        (0, _lodash.find)(_restrictedAreas.restrictedAreas.cities, function (restrictedArea) {
	          if (address.state === restrictedArea.province && address.city === restrictedArea.city) {
	            isRestricted = true;
	          }
	        });
	      }
	      if (!isRestricted) {
	        (0, _lodash.find)(_restrictedAreas.restrictedAreas.brgys, function (restrictedArea) {
	          if (address.state === restrictedArea.province && address.city === restrictedArea.city && address.line_2 === restrictedArea.brgy) {
	            isRestricted = true;
	          }
	        });
	      }
	      if (isRestricted) {
	        address.isRestricted = true;
	      }
	    });
	    return _react2.default.createElement(
	      'ul',
	      {
	        style: {
	          display: "flex",
	          flexFlow: "row wrap"
	        } },
	      _react2.default.createElement(
	        'li',
	        { className: 'tab-box address-box-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'make-default add-address-box', onClick: function onClick(e) {
	              return _this11.handleAddButton(e);
	            } },
	          _react2.default.createElement('i', { className: 'fa fa-plus', 'aria-hidden': 'true', style: { alignSelf: "end", fontSize: "24px" } }),
	          'Add address'
	        )
	      ),
	      addresses.filter(function (add) {
	        return _this11.props.login.login.party.address_id === add.id || addresses.length === 1;
	      }).map(function (add, i) {
	        return _react2.default.createElement(
	          'li',
	          { style: { minHeight: "190px" }, className: 'tab-box address-box-wrapper', key: i },
	          _react2.default.createElement(
	            'div',
	            { className: 'make-default', id: 'default' },
	            _react2.default.createElement(
	              'p',
	              null,
	              (add.full_name || JSON.parse(add.name)).first_name,
	              ' ',
	              (add.full_name || JSON.parse(add.name)).last_name,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                { className: 'address', style: { color: '#333333' } },
	                (0, _utils.ellipses)(add.line_1, 85) + ', ' + add.line_2 + ', ' + add.city + ', ' + add.state + ', ' + (0, _utils.maskLocationName)(add.country_code) + ', ' + add.postal_code
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { display: 'block', color: '#333333' } },
	                add.phone_number || _this11.props.login.login.party.phone_number
	              )
	            ),
	            add.isRestricted && _react2.default.createElement(_RestrictedTooltip2.default, null),
	            _react2.default.createElement(
	              'div',
	              { style: { alignSelf: "center", display: "inline-flex", placeContent: "space-between" } },
	              _react2.default.createElement(
	                'span',
	                { className: 'account-default-button-disabled default-p' },
	                'Default'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: "inline-flex" } },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick(e) {
	                      return _this11.handleEditButton(e, add.id);
	                    }, 'data-address-id': add.id, className: 'pull-right', 'data-do': 'edit-address', 'data-on': 'click', style: { float: 'none', marginRight: "15px", color: "#707070", fontSize: "24px" } },
	                  _react2.default.createElement('i', { className: 'fa fa-pencil', 'aria-hidden': 'true' }),
	                  ' '
	                ),
	                _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true', style: { fontSize: "24px", color: "#C6C6C6", alignSelf: "center", marginRight: "10px" } })
	              )
	            )
	          )
	        );
	      }),
	      addresses.filter(function (add) {
	        return _this11.props.login.login.party.address_id !== add.id && addresses.length > 1;
	      }).map(function (add, i) {
	        return _react2.default.createElement(
	          'li',
	          { style: { minHeight: "190px" }, className: 'tab-box address-box-wrapper', key: i },
	          _react2.default.createElement(
	            'div',
	            { className: 'make-default', id: _this11.props.login.login.party.address_id === add.id && !add.isRestricted && 'default' },
	            _react2.default.createElement(
	              'p',
	              null,
	              (add.full_name || JSON.parse(add.name)).first_name,
	              ' ',
	              (add.full_name || JSON.parse(add.name)).last_name,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                { className: 'address', style: { color: '#333333' } },
	                (0, _utils.ellipses)(add.line_1, 85) + ', ' + add.line_2 + ', ' + add.city + ', ' + add.state + ', ' + (0, _utils.maskLocationName)(add.country_code) + ', ' + add.postal_code,
	                _react2.default.createElement(
	                  'span',
	                  { style: { display: 'block', color: '#333333' } },
	                  add.phone_number || _this11.props.login.login.party.phone_number
	                )
	              )
	            ),
	            add.isRestricted && _react2.default.createElement(_RestrictedTooltip2.default, null),
	            _react2.default.createElement(
	              'div',
	              { style: { alignSelf: "center", display: "inline-flex", placeContent: "space-between" } },
	              _this11.props.login.login.party.address_id === add.id && !add.isRestricted ? _react2.default.createElement(
	                'span',
	                { className: 'account-default-button-disabled default-p' },
	                'Default'
	              ) : _react2.default.createElement(
	                'button',
	                { onClick: _this11.handleMakeDefaultButton, 'data-address-id': add.id, className: 'account-default-button', disabled: add.isRestricted && true },
	                ' Set as default'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: "inline-flex" } },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick(e) {
	                      return _this11.handleEditButton(e, add.id);
	                    }, 'data-address-id': add.id, 'data-do': 'add-address', 'data-on': 'click', style: { float: 'none', marginRight: "15px", color: "#707070", fontSize: "24px" } },
	                  _react2.default.createElement('i', { className: 'fa fa-pencil', 'aria-hidden': 'true' }),
	                  ' '
	                ),
	                _this11.props.login.login.party.address_id !== add.id ? _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this11.setState({ deleteAddressModal: add.id });
	                    }, 'data-on': 'click', style: { float: 'none', marginRight: "10px", color: "#707070", fontSize: "24px" } },
	                  _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
	                  ' '
	                ) : _react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true', style: { fontSize: "24px", color: "#C6C6C6", alignSelf: "center", marginRight: "10px" } })
	              )
	            )
	          )
	        );
	      })
	    );
	  },
	  render: function render() {
	    var _this12 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'main-content account-content' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'nav nav-tabs lbcx-tabs', role: 'tablist' },
	        _react2.default.createElement(
	          'li',
	          { role: 'presentation', className: this.state.activeTab === 'address_book' ? 'active' : '' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '#address_book', onClick: this.loadAddresses, 'aria-controls': 'active', role: 'tab', 'data-toggle': 'tab' },
	            'Address Book'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { role: 'presentation', className: this.state.activeTab === 'account_information' ? 'active' : '' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '#account_information', onClick: this.loadAccounts, 'aria-controls': 'archive', role: 'tab', 'data-toggle': 'tab' },
	            'Account Information '
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'account-hr' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'tab-content', style: { width: "99%" } },
	        _react2.default.createElement(
	          'div',
	          { role: 'tabpanel', className: 'tab-pane ' + (this.state.activeTab === 'address_book' ? 'active' : ''), id: 'address_book', ref: 'address_book' },
	          _react2.default.createElement('div', { className: 'clearfix' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'disnone' },
	            _react2.default.createElement(
	              'div',
	              { ref: 'notify_success_add_first_name', className: 'sc-alert sc-alert-success' },
	              _react2.default.createElement('i', { className: 'sc' }),
	              _react2.default.createElement(
	                'span',
	                { ref: 'addressSuccessText' },
	                ' Address.'
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'clearfix' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-header' },
	            'Delivery Address \xA0'
	          ),
	          this.state.isAddressDeletionSuccess && _react2.default.createElement(
	            'div',
	            { className: 'deleted-message' },
	            'Address has been successfully deleted. ',
	            _react2.default.createElement(
	              'span',
	              { className: 'deleted-message-span', onClick: function onClick() {
	                  _this12.setState({ isAddressDeletionSuccess: false });
	                } },
	              _react2.default.createElement('img', { src: _times2.default, alt: 'close' })
	            )
	          ),
	          this.renderAddresses()
	        ),
	        _react2.default.createElement(
	          'div',
	          { role: 'tabpanel', className: 'tab-pane ' + (this.state.activeTab === 'account_information' ? 'active' : ''), id: 'account_information' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-header2' },
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    this.state.IsProfileUp ? _react2.default.createElement(
	                      'div',
	                      { className: 'edit-account', onClick: this.toggleProfile.bind(this, "Profile"), 'data-toggle': 'collapse', 'data-target': '#profile', 'aria-hidden': 'true' },
	                      _react2.default.createElement('i', { className: 'fa fa-caret-down pull-left' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'pull-left ' },
	                        'Profile'
	                      )
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'collapsebtn edit-account', 'data-toggle': 'collapse', 'data-target': '#profile', 'aria-hidden': 'true', onClick: this.toggleProfile.bind(this, "Profile") },
	                      _react2.default.createElement('i', { className: 'fa fa-caret-right pull-left  ' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'pull-left ' },
	                        'Profile'
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pull-right collapsebtn', 'data-toggle': 'collapse', 'data-target': '#profile', 'aria-hidden': 'true', onClick: this.toggleProfile.bind(this, "Profile") },
	                        ' Edit'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'profile', className: 'collapse' },
	                      _react2.default.createElement('div', null),
	                      _react2.default.createElement(
	                        'form',
	                        { className: 'account-info', method: 'POST', onSubmit: this.handleProfile },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'disnone' },
	                          _react2.default.createElement(
	                            'div',
	                            { ref: 'notify_success_first_name', className: 'sc-alert sc-alert-success' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            'Profile successfully updated.'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { ref: 'notify_error_first_name', className: 'sc-alert sc-alert-danger' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            'Please validate all fields.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'First Name '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_first_name', className: 'disnone' }),
	                          _react2.default.createElement('input', { type: 'text', id: 'profileFocus', ref: 'first_name', name: 'first_name', maxLength: '20', value: this.state.first_name, onChange: this.handleInputChange })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Last Name '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_last_name', className: 'disnone' }),
	                          _react2.default.createElement('input', { type: 'text', ref: 'last_name', name: 'last_name', maxLength: '20', value: this.state.last_name, onChange: this.handleInputChange })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Contact Number '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_phone_number', className: 'disnone' }),
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex' } },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'mobile-country' },
	                              _react2.default.createElement(
	                                'select',
	                                { value: this.state.countryPrefix, onChange: this.handleInputChange, name: 'countryPrefix' },
	                                _react2.default.createElement(
	                                  'option',
	                                  { value: '' },
	                                  'Prefix'
	                                ),
	                                _utils.mapPrefixNumber.map(function (prefix) {
	                                  return _react2.default.createElement(
	                                    'option',
	                                    { value: prefix.value },
	                                    prefix.label
	                                  );
	                                })
	                              )
	                            ),
	                            _react2.default.createElement('input', { type: 'text', style: { margin: '0px 0px 0px 71px' }, ref: 'phone_number', name: 'phone_number', maxLength: '10', value: this.state.phone_number, onChange: this.handleInputChange, autoComplete: 'off' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Gender ',
	                            _react2.default.createElement(
	                              'em',
	                              null,
	                              '(optional)'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'break' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'radio' },
	                              _react2.default.createElement('input', { id: 'customer-gender-male', type: 'radio', name: 'gender', value: 'male', checked: this.state.gender === "male", ref: 'male', onClick: this.handleInputChange }),
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'customer-gender-male' },
	                                'Male\xA0'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'radio' },
	                              _react2.default.createElement('input', { id: 'customer-gender-female', type: 'radio', name: 'gender', value: 'female', checked: this.state.gender === "female", ref: 'female', onClick: this.handleInputChange }),
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'customer-gender-female' },
	                                ' Female'
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'input-wrapper group-input' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'control' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Birthday ',
	                              _react2.default.createElement(
	                                'em',
	                                null,
	                                '(optional)'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group calendar', 'data-do': 'datetime' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'view', ref: 'birthdate' },
	                                this.formatDateOnly(this.state.birthdate, '-', '/')
	                              ),
	                              _react2.default.createElement('input', { id: 'datepicker',
	                                type: 'text',
	                                name: 'birthdate',
	                                value: this.state.birthdate,
	                                ref: 'birthday',
	                                onClick: this.handleInputChange,
	                                readOnly: true
	                              }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                _react2.default.createElement('i', { className: 'fa fa-calendar' })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-register btn-orange' },
	                            'Save'
	                          ),
	                          '  ',
	                          _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', 'data-target': '#profile', ref: 'profile_cancel', 'data-do': 'datetime', className: 'cancel', onClick: this.handleCancel.bind(this, "Profile", true) },
	                            'Cancel'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    this.state.IsEmailUp ? _react2.default.createElement(
	                      'div',
	                      { className: 'edit-account', 'data-toggle': 'collapse', 'data-target': '#email', 'aria-hidden': 'true', onClick: this.toggleEmail.bind(this, "Email") },
	                      _react2.default.createElement('i', { className: 'fa fa-caret-down pull-left' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'pull-left' },
	                        'Email'
	                      )
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'collapsebtn edit-account', 'data-toggle': 'collapse', 'data-target': '#email', 'aria-hidden': 'true', onClick: this.toggleEmail.bind(this, "Email") },
	                      _react2.default.createElement('i', { className: 'fa fa-caret-right pull-left ' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'pull-left ' },
	                        'Email'
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pull-right  collapsebtn', 'data-toggle': 'collapse', 'data-target': '#email', 'aria-hidden': 'true', onClick: this.toggleEmail.bind(this, "Email") },
	                        ' Edit'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'email', className: 'collapse' },
	                      _react2.default.createElement('div', null),
	                      _react2.default.createElement(
	                        'form',
	                        { className: 'account-info', onSubmit: this.handleEmail },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'disnone' },
	                          _react2.default.createElement(
	                            'div',
	                            { ref: 'notify_success_email', className: 'sc-alert sc-alert-success' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            'Email successfully updated. We have sent you an email about changing your email address.'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { ref: 'notify_error_email', className: 'sc-alert sc-alert-danger' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            'Please validate all fields.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Email Address'
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_email', className: 'disnone' }),
	                          _react2.default.createElement('input', { type: 'email', id: 'emailFocus', ref: 'email', maxLength: '255', name: 'email', onChange: this.handleInputChange, value: this.state.email, autoComplete: 'off' })
	                        ),
	                        this.props.login.fetched ? this.props.login.login.party.fb_id ? null : _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Password '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_password_confirm', className: 'disnone' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-group' },
	                            _react2.default.createElement('input', {
	                              type: 'password',
	                              maxLength: '100',
	                              className: 'form-control',
	                              name: 'password_confirm',
	                              ref: 'password_confirm',
	                              value: this.state.password_confirm,
	                              onChange: this.handleInputChange }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group-addon' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'checkbox checkbox_nomargin' },
	                                _react2.default.createElement('input', {
	                                  id: 'show_password_confirm',
	                                  name: 'password_confirm',
	                                  type: 'checkbox',
	                                  ref: 'show_password_confirm',
	                                  onClick: function onClick(e) {
	                                    return _this12.handleShowPassword(e);
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'label',
	                                  { htmlFor: 'show_password_confirm' },
	                                  'SHOW'
	                                )
	                              )
	                            )
	                          )
	                        ) : null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-register btn-orange', disabled: this.handleEnableButton() },
	                            'Save'
	                          ),
	                          '  ',
	                          _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', 'data-target': '#email', ref: 'email_cancel', className: 'cancel', onClick: this.handleCancel.bind(this, "Email", true) },
	                            'Cancel'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    this.state.IsPasswordUp ? _react2.default.createElement(
	                      'div',
	                      { className: 'edit-account', 'data-toggle': 'collapse', 'data-target': '#password', 'aria-hidden': 'true', onClick: this.togglePassword.bind(this, "Password") },
	                      _react2.default.createElement('i', { className: 'fa fa-caret-down pull-left  ' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'pull-left  ' },
	                        'Password'
	                      )
	                    ) : _react2.default.createElement(
	                      'div',
	                      { className: 'collapsebtn edit-account', 'data-toggle': 'collapse', 'data-target': '#password', 'aria-hidden': 'true', onClick: this.togglePassword.bind(this, "Password") },
	                      _react2.default.createElement('i', { className: 'fa fa-caret-right pull-left  ' }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'pull-left  ' },
	                        'Password'
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'pull-right   collapsebtn', 'data-toggle': 'collapse', 'data-target': '#password', 'aria-hidden': 'true', onClick: this.togglePassword.bind(this, "Password") },
	                        ' Edit'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'password', className: 'collapse' },
	                      _react2.default.createElement('div', null),
	                      _react2.default.createElement(
	                        'form',
	                        { className: 'account-info', ref: '', method: 'PUT', onSubmit: this.handlePassword },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'disnone' },
	                          _react2.default.createElement(
	                            'div',
	                            { ref: 'notify_success_password', className: 'sc-alert sc-alert-success' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            'You can now use your new password to access your ShippingCart account! ',
	                            _react2.default.createElement('br', null),
	                            ' \xA0 \xA0 \xA0 \xA0 We have sent you an email about changing your password.'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { ref: 'notify_error_password', className: 'sc-alert sc-alert-danger' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            'Please validate all fields.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Current Password '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_password', className: 'disnone' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-group' },
	                            _react2.default.createElement('input', { type: 'password', className: 'form-control', id: 'passwordFocus', maxLength: '100', name: 'password', ref: 'password' }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group-addon' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'checkbox checkbox_nomargin' },
	                                _react2.default.createElement('input', {
	                                  id: 'show_password',
	                                  name: 'password',
	                                  type: 'checkbox',
	                                  ref: 'show_password',
	                                  onClick: function onClick(e) {
	                                    return _this12.handleShowPassword(e);
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'label',
	                                  { htmlFor: 'show_password' },
	                                  'SHOW'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'New Password '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_new_password', className: 'disnone' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-group' },
	                            _react2.default.createElement('input', { type: 'password', className: 'form-control', maxLength: '100', name: 'new_password', ref: 'new_password' }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group-addon' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'checkbox checkbox_nomargin' },
	                                _react2.default.createElement('input', {
	                                  id: 'show_new_password',
	                                  name: 'new_password',
	                                  type: 'checkbox',
	                                  ref: 'show_new_password',
	                                  onClick: function onClick(e) {
	                                    return _this12.handleShowPassword(e);
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'label',
	                                  { htmlFor: 'show_new_password' },
	                                  'SHOW'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Re-enter Password '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_new_confirm_password', className: 'disnone' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-group' },
	                            _react2.default.createElement('input', { type: 'password', className: 'form-control', maxLength: '100', name: 'new_confirm_password', ref: 'new_confirm_password' }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group-addon' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'checkbox checkbox_nomargin' },
	                                _react2.default.createElement('input', {
	                                  id: 'show_new_confirm_password',
	                                  name: 'new_confirm_password',
	                                  type: 'checkbox',
	                                  ref: 'show_new_confirm_password',
	                                  onClick: function onClick(e) {
	                                    return _this12.handleShowPassword(e);
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  'label',
	                                  { htmlFor: 'show_new_confirm_password' },
	                                  'SHOW'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'control' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-register btn-orange' },
	                            'Save'
	                          ),
	                          _react2.default.createElement(
	                            'a',
	                            { 'data-toggle': 'collapse', 'data-target': '#password', ref: 'password_cancel', className: 'cancel', onClick: this.handleCancel.bind(this, "Password", true) },
	                            'Cancel'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          onHide: this.handleModalHide,
	          show: this.state.showModal
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { style: { marginBottom: 0, paddingBottom: 0 } },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            { style: { color: '#333333', fontWeight: 600 } },
	            this.state.modalTitle
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'pull-right', style: { color: '#707070', fontSize: 12, marginTop: 5 } },
	            'All fields are required.'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          { style: { padding: 20, color: '#707070' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'disnone' },
	            _react2.default.createElement(
	              'div',
	              { ref: 'notify_error_add_first_name', className: 'sc-alert sc-alert-danger', style: { margin: 0, width: '100%' } },
	              _react2.default.createElement('i', { className: 'sc' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Fill in all fields to add address.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { id: 'address', onSubmit: this.formAddress, className: 'form-horizontal' },
	            _react2.default.createElement(
	              'section',
	              null,
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  'First Name '
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_first_name', className: 'disnone' }),
	                _react2.default.createElement('input', { placeholder: 'Enter details here', type: 'text', onChange: this.handleInputChange, id: 'add_first_name', name: 'add_first_name', maxLength: '20', ref: 'add_first_name', className: 'account-form-control letter-only', value: this.state.add_first_name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  'Last Name '
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_last_name', className: 'disnone' }),
	                _react2.default.createElement('input', { placeholder: 'Enter details here', type: 'text', onChange: this.handleInputChange, name: 'add_last_name', maxLength: '20', ref: 'add_last_name', className: ' account-form-control letter-only', value: this.state.add_last_name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  'Street Address '
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_line_1', className: 'disnone' }),
	                _react2.default.createElement('input', { placeholder: 'Enter details here', type: 'text', onChange: this.handleInputChange, name: 'street', maxLength: '255', ref: 'street', className: ' account-form-control letter-only', value: this.state.street })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  'Country'
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_country_code', className: 'disnone' }),
	                _react2.default.createElement(
	                  'select',
	                  { placeholder: 'Select Province', onChange: this.handleCountries, className: 'account-form-control', name: 'country', ref: 'country' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '', disabled: true, selected: true },
	                    'Select Country'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'PH' },
	                    'Philippines'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _angleLeft2.default, alt: 'icon', className: 'account-dropdown-icon' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  this.state.country === "MY" ? "State/Province" : "Province"
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_state', className: 'disnone' }),
	                _react2.default.createElement(
	                  'select',
	                  { placeholder: 'Select Province', value: this.state.province, onChange: this.handleProvinces, className: 'account-form-control', name: 'province', disabled: this.state.enableProvince ? "" : "disabled", ref: 'province' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '', disabled: true, selected: true },
	                    'Select ',
	                    this.state.country === "MY" ? "State/Province" : "Province"
	                  ),
	                  this.props.login.provinces ? (this.props.login.provinces.data || this.props.login.provinces).map(function (add, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: i, value: add.name, 'data-province-id': add.id, 'data-region': add.parent_id },
	                      add.name
	                    );
	                  }) : null
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  'City'
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_city', className: 'disnone' }),
	                _react2.default.createElement(
	                  'select',
	                  { value: this.state.city, onChange: this.handleCities, className: 'account-form-control', name: 'city', disabled: this.state.enableCity ? "" : "disabled", ref: 'city' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '', disabled: true, selected: true },
	                    'Select City'
	                  ),
	                  this.props.login.cities ? (this.props.login.cities.data || this.props.login.cities).map(function (add, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: i, value: add.name, 'data-city-id': add.id },
	                      add.name
	                    );
	                  }) : null
	                ),
	                _react2.default.createElement('img', { src: _angleLeft2.default, alt: 'icon', className: 'account-dropdown-icon' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  this.state.country === "MY" ? "District/Barangay" : "Barangay"
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_line_2', className: 'disnone' }),
	                _react2.default.createElement(
	                  'select',
	                  { value: this.state.district, onChange: this.handleDistricts, className: 'account-form-control', name: 'district', disabled: this.state.enableDistrict ? "" : "disabled", ref: 'districts' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    'Select ',
	                    this.state.country === "MY" ? "District/Barangay" : "Barangay"
	                  ),
	                  this.props.login.districts ? (this.props.login.districts.data || this.props.login.districts).map(function (add, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: i, value: add.id, 'data-district-id': add.id, 'data-postal-code': add.postal_code, 'data-district-name': add.name },
	                      add.name,
	                      ' ',
	                      _this12.state.country === "MY" && '(' + add.postal_code + ')'
	                    );
	                  }) : null
	                ),
	                _react2.default.createElement('img', { src: _angleLeft2.default, alt: 'icon', className: 'account-dropdown-icon' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  'Postal '
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_postal_code', className: 'disnone' }),
	                _react2.default.createElement('input', { type: 'text', className: 'account-form-control letter-only', disabled: 'disabled', ref: 'postal', value: this.state.postal_code })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 15 } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'account-form-label' },
	                  'Contact Number '
	                ),
	                '\xA0',
	                _react2.default.createElement('label', { ref: 'errors_add_phone_number', className: 'disnone' }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: 'flex' } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'select',
	                      { style: { width: 75 }, value: this.state.add_countryPrefix, onChange: this.handleInputChange, name: 'add_countryPrefix', className: 'account-form-control' },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'Prefix'
	                      ),
	                      _utils.mapPrefixNumber.map(function (prefix) {
	                        return _react2.default.createElement(
	                          'option',
	                          { value: prefix.value },
	                          prefix.label
	                        );
	                      })
	                    ),
	                    _react2.default.createElement('img', { src: _angleLeft2.default, alt: 'icon', className: 'account-dropdown-icon', style: { left: 77 } })
	                  ),
	                  _react2.default.createElement('input', { type: 'text', style: { margin: '0px 0px 0px 20px', width: '100%' }, ref: 'phone_number', name: 'address_phone_number', maxLength: '10', value: this.state.address_phone_number, onChange: this.handleInputChange, autoComplete: 'off', className: 'account-form-control' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'account-modal-footer', style: { marginTop: 15 } },
	              _react2.default.createElement('input', { className: 'account-add-address-button ', value: this.state.submitText, type: 'submit' }),
	              _react2.default.createElement(
	                'div',
	                { style: { width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
	                _react2.default.createElement(
	                  'a',
	                  { style: { color: '#707070', fontWeight: 600, fontSize: 14 }, onClick: this.handleCancel.bind(this, "Address", true), ref: 'modal_address_cancel', 'data-dismiss': 'modal', 'aria-label': 'Close' },
	                  'CANCEL'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          onHide: function onHide() {
	            return _this12.setState({ deleteAddressModal: "" });
	          },
	          show: this.state.deleteAddressModal,
	          className: 'delete-address-modal'
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(_reactBootstrap.Modal.Title, null)
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            'section',
	            { className: 'modal-body' },
	            _react2.default.createElement(
	              'p',
	              { className: 'delete-modal-content' },
	              'Are you sure you want to delete this address?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2.default.createElement(
	              'button',
	              { className: 'delete-button-yes', onClick: function onClick() {
	                  return _this12.handleDeleteButton(_this12.state.deleteAddressModal);
	                } },
	              'YES'
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'delete-button-no', onClick: function onClick() {
	                  return _this12.setState({ deleteAddressModal: "" });
	                } },
	              'NO'
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = Account;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _propTypes = __webpack_require__(37);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vanillaMasker = __webpack_require__(559);
	
	var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);
	
	var _reactSticky = __webpack_require__(544);
	
	var _store = __webpack_require__(20);
	
	var _utils = __webpack_require__(13);
	
	var _lodash = __webpack_require__(139);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _AdvisoryExtensionModal = __webpack_require__(586);
	
	var _AdvisoryExtensionModal2 = _interopRequireDefault(_AdvisoryExtensionModal);
	
	var _AdvisoryModal = __webpack_require__(120);
	
	var _AdvisoryModal2 = _interopRequireDefault(_AdvisoryModal);
	
	var _RequiredModal = __webpack_require__(251);
	
	var _RequiredModal2 = _interopRequireDefault(_RequiredModal);
	
	var _Tour = __webpack_require__(157);
	
	var _Tour2 = _interopRequireDefault(_Tour);
	
	__webpack_require__(185);
	
	__webpack_require__(310);
	
	__webpack_require__(311);
	
	var _Tutorial = __webpack_require__(158);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _vas = __webpack_require__(187);
	
	var _vas2 = _interopRequireDefault(_vas);
	
	var _whiteListed = __webpack_require__(93);
	
	var _warehouseFlags = __webpack_require__(73);
	
	var _ComputationBreakdown = __webpack_require__(250);
	
	var _ComputationBreakdown2 = _interopRequireDefault(_ComputationBreakdown);
	
	var _DamagedBanner = __webpack_require__(91);
	
	var _DamagedBanner2 = _interopRequireDefault(_DamagedBanner);
	
	var _DamagedModal = __webpack_require__(121);
	
	var _DamagedModal2 = _interopRequireDefault(_DamagedModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// import AlertAdvisory from '../AlertAdvisory';
	
	var createReactClass = __webpack_require__(16);
	var Dashboard = createReactClass({
	  displayName: 'Dashboard',
	
	
	  contextTypes: {
	    router: _propTypes2.default.object.isRequired
	  },
	  getInitialState: function getInitialState() {
	
	    return {
	      style: 'top: 1000px;',
	      parcel: {},
	      disabled: true,
	      chkItemArray: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] },
	      chkItemArray2: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] },
	      data: [],
	      cargo: "",
	      insurance: {},
	      itemOrigin: {},
	      id: "",
	      insured_value: "",
	      checked_all: false,
	      changepassword: false,
	      checked: [],
	      checked_insured_value: {},
	      cancelled: false,
	      selectAll: true,
	      overpriced: [],
	      number: "",
	      incompleteInfo: false,
	      timeout: null,
	      payment_error: false,
	      isFetched: false,
	      tour: {
	        address: false,
	        cart: false,
	        shipments: false,
	        account: false,
	        estimate: false,
	        track: false
	      },
	      phone_number: '',
	      isHaywardEmpty: true,
	      damagedModalOpen: false,
	      minInsuredValue: false,
	      cartConsent: false
	    };
	  },
	  checkIfInsuredValueIsValid: function checkIfInsuredValueIsValid(insured_value, max_insured_value) {
	    if (insured_value < 1) {
	      this.props.showInsuredValueLessThanZeroErrorMessage();
	      return false;
	    }
	
	    if (isNaN(insured_value)) {
	      this.props.showInsuredValueNaNErrorMessage();
	      return false;
	    }
	
	    if (insured_value.length === 0 || parseInt(insured_value, 10) > max_insured_value) {
	      this.props.showInsuredValueErrorMessage();
	      return false;
	    }
	
	    return true;
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.props.clearCheck();
	    this.props.resetOffsizeConsent();
	    this.sendInsuredValue = (0, _lodash.debounce)(function (id, event) {
	
	      _this.props.removeInsuredValueErrorMessage();
	      var last_insured_value = event.target.dataset.lastvalue || null;
	      var insured_value = event.target.value;
	      var _state = _this.state,
	          checked = _state.checked,
	          checked_insured_value = _state.checked_insured_value;
	
	      var max_insured_value = JSON.parse(_this.props.settings.destinationSettings.data.filter(function (data) {
	        return data.name === "general_setting";
	      })[0].settings).insurance_max_value.value;
	      var warehouse_id = _this.props.customerInfo.warehouse.data.find(function (data) {
	        return data.id === Number(_this.props.cart.shipment_location_details.origin);
	      }).id;
	      var token = localStorage.jwtToken;
	      if (_this.checkIfInsuredValueIsValid(insured_value, max_insured_value)) {
	
	        if (checked.indexOf(id) === -1) {
	          checked.push(id);
	        }
	
	        _this.setState({ checked: checked });
	
	        if (_this.refs["checkbox" + id].checked) {
	          _this.props.updateInsuredValueAndRecalculateShipmentCost(id, event.target.value, token, _this.state.chkItemArray, _this.state.insurance, _this.state.itemOrigin, _this.props.cart.shipment_location_details, false);
	        } else {
	          _this.props.updateInsuredValue(token, id, event.target.value, warehouse_id, _this.props.cart.shipment_location_details.destination);
	        }
	      } else {
	        // this.refs["insured_value" + id].value = last_insured_value;
	        _this.setState({
	          checked_insured_value: Object.assign({}, checked_insured_value, _defineProperty({}, id, last_insured_value || ""))
	        });
	      }
	
	      //pertains to checking and unchecking of item ang select all behavior ->fluxion
	      var totalCheck = _this.state.chkItemArray.air.length + _this.state.chkItemArray.sea.length;
	
	      if (_this.state.checked.length > 0) {
	        if (_this.state.checked.length > totalCheck) {
	          _this.refs.selectAll.checked = false;
	        } else {
	          _this.refs.selectAll.checked = true;
	        }
	        _this.setState({ selectAll: false });
	      } else {
	        _this.refs.selectAll.checked = false;
	        _this.setState({ selectAll: true });
	      }
	
	      //if (this.refs["insured_value" + id].value === '' || this.refs["insured_value" + id].value <= 0) {
	      if (_this.state.checked_insured_value[id] === '' || _this.state.checked_insured_value[id] <= 0) {
	        if (_this.refs["checkbox" + id].checked) {
	          _this.refs["checkbox" + id].click();
	        }
	      }
	
	      //if current item is checked, must call this.props.getCheck to recalculate
	
	      /*FOR DYNAMIC COMPUTATION BASED ON INSURED VALUE INPUT*/
	      // if (this.refs["insured_value" + id].value !== '' && this.refs["insured_value" + id].value > 0 && this.refs["checkbox" + id].checked) {
	      //   if (parseInt(this.refs["insured_value" + id].value, 10) > parseInt(this.props.settings.general_settings.data.settings.insurance_max_value.value, 10)) {
	      //     let overpriced = this.state.overpriced;
	      //     overpriced.push(id);
	      //     this.setState({ overpriced: overpriced, })
	      //     window.scrollTo(0, 0);
	      //     this.props.clearCheck();
	      //   } else {
	      //     let insured_value = this.state.insurance;
	      //     let overpriced = this.state.overpriced;
	      //     insured_value[id] = this.refs["insured_value" + id].value;
	      //     overpriced.splice(this.state.overpriced.indexOf(id), 1);
	      //     this.setState({ insurance: insured_value, overpriced: overpriced, }, () => {
	
	      //       if (this.state.overpriced.length === 0) {
	      //         this.props.getCheck(token, this.state.chkItemArray, this.state.insurance,false);
	      //       }
	      //     });
	      //   }
	      // }
	    }, 1000);
	
	    var token = localStorage.jwtToken;
	    var warehouse_id = this.props.settings.gen_set_fetched ? this.props.settings.general_settings.data.warehouse_id : null;
	    // this.props.getParcel(token);
	    this.props.getCartData(this.props.parcelInfo.cartData && (0, _warehouseFlags.warehouseIDToCode)(this.props.parcelInfo.cartData.active_warehouse.id) || null);
	    this.props.getProhibitedParcel(token);
	    this.props.getModalBlocks('cartExtension');
	    this.props.getModalBlocks('cart');
	    this.props.getStorageSettings(warehouse_id);
	
	    if (!this.props.login.fetched) {
	      this.props.signedIn(token);
	    }
	
	    (0, _jquery2.default)('.cart').addClass('active');
	    localStorage.ChangePassword ? this.setState({ changepassword: true }) : this.setState({ changepassword: false });
	    localStorage.removeItem('ChangePassword');
	
	    /*FOR CANCELLED TRANSACTIONS*/
	    if (Object.prototype.hasOwnProperty.call(this.props.location, 'query')) {
	      if (this.props.location.query.status === "canceled" || this.props.location.query.status === "rejected" || this.props.location.query.status === "expired") {
	        var payment_provider = this.props.location.query.payment_provider;
	        var ref_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'Ref') ? this.props.location.query.Ref : this.props.location.query.token;
	        var payment_status = this.props.location.query.status;
	
	        if (payment_provider === 'paypal') {
	          this.props.setPayment(payment_provider, payment_status, ref_id);
	        }
	      }
	    }
	
	    // if(this.props.customerInfo.warehouse.data){
	    //   const id = this.props.customerInfo.warehouse.data.find(data => data.id === this.props.cart.shipment_location_details.origin).id
	    //   this.props.getDestinationSettings(id, this.props.cart.shipment_location_details.destination);
	    // } 
	
	    if (localStorage.trackPackage2) {
	      _store.history.push("/track");
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (nextProps.login.fetched && nextProps.login.login.party) {
	      var admin = _utils.adminUserIds.find(function (id) {
	        return id === nextProps.login.login.party.account_number;
	      });
	      if (!admin && _utils.disabledCart) {
	        return _store.history.push('/shipment');
	      }
	    }
	    (0, _jquery2.default)('#SCTitle').text("Cart | ShippingCart");
	    var checked_insured_value = this.state.checked_insured_value;
	
	    if (nextProps.parcelInfo.cartData && !nextProps.parcelInfo.error) {
	      var checked = this.state.checked;
	
	
	      if (nextProps.parcelInfo.cartData.items.length > 0) {
	        this.setState({ selectAll: false });
	
	        nextProps.parcelInfo.cartData.items.forEach(function (parcel) {
	          if (parcel.insured_value) {
	            _this2.setState(_defineProperty({}, "chk_" + parcel.id, parcel.id));
	
	            if (checked.indexOf(parcel.id) === -1) {
	              checked.push(parcel.id);
	              checked_insured_value[parcel.id] = parcel.insured_value;
	            }
	
	            if (Number(nextProps.cart.shipment_location_details.origin) !== parcel.warehouse_id || nextProps.cart.shipment_location_details.destination === "MY" && parcel.flags.allowed_air !== 1 && parcel.flags.allowed_sea === 1) {
	              var index = checked.indexOf(parcel.id);
	              if (index > -1) {
	                checked.splice(index, 1);
	              }
	            }
	
	            _this2.setState({ checked: checked, checked_insured_value: checked_insured_value });
	          }
	        });
	      }
	    }
	
	    if (nextProps.parcelInfo.insured_value_error) {
	      var parcel_id = nextProps.parcelInfo.insured_value_update_error.data.errors.meta.parcel_id;
	      var last_insured_value = nextProps.parcelInfo.insured_value_update_error.data.errors.meta.insured_value;
	      //this.refs["insured_value" + parcel_id].value = last_insured_value;
	      this.setState({
	        checked_insured_value: Object.assign({}, checked_insured_value, _defineProperty({}, parcel_id, last_insured_value || ""))
	      });
	
	      var overpriced = this.state.overpriced;
	      overpriced.splice(this.state.overpriced.indexOf(parcel_id), 1);
	      this.setState({ overpriced: overpriced });
	
	      if (!last_insured_value || isNaN(last_insured_value) || last_insured_value === 0) {
	        this.setState(_defineProperty({}, "chk_" + parcel_id, ''));
	      } else {
	        this.setState(_defineProperty({}, "chk_" + parcel_id, parcel_id));
	      }
	
	      if (this.state.chkItemArray.sea.length > 0 || this.state.chkItemArray.air.length > 0) {
	        var token = localStorage.jwtToken;
	        this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin, true);
	      }
	    } else {
	      if (nextProps.parcelInfo.updated_parcel) {
	
	        var _parcel_id = nextProps.parcelInfo.updated_parcel.data.id;
	        var insured_value = nextProps.parcelInfo.updated_parcel.data.insured_value;
	        checked_insured_value[_parcel_id] = insured_value;
	
	        if (!this.props.parcelInfo.less_than_zero_error_message) {
	          var _setState3;
	
	          this.setState((_setState3 = {}, _defineProperty(_setState3, "chk_" + _parcel_id, _parcel_id), _defineProperty(_setState3, 'checked_insured_value', checked_insured_value), _setState3));
	        }
	      }
	    }
	    if (nextProps.login.login.party) {
	      if (!nextProps.login.login.party.email || nextProps.login.login.party.email === nextProps.login.login.party.fb_id + '@gmail.com' || !nextProps.login.login.party.phone_number || !(0, _utils.prefixNumber)(nextProps.login.login.party.phone_number.slice(0, 3))) {
	        this.setState({ incompleteInfo: true });
	      } else {
	        this.setState({ incompleteInfo: false });
	      }
	      if (nextProps.login.login.party.phone_number) {
	        this.setState({ phone_number: nextProps.login.login.party.phone_number });
	      }
	      this.setState({ accountDetails: nextProps.login.login.party });
	    }
	
	    var cartModalContent = nextProps.cms.getModal && nextProps.cms.modalContent && nextProps.cms.modalContent.data.variable === "Cart-Modal" ? nextProps.cms.modalContent.data.status : false;
	    this.setState({ cartModalContent: cartModalContent });
	  },
	  componentWillUnmount: function componentWillUnmount() {
	
	    this.props.clearCheck();
	    localStorage.removeItem("trackPackage2");
	    this.props.clearCartMessages();
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    (0, _vanillaMasker2.default)(document.getElementsByClassName("insured-input")).maskNumber();
	    (0, _vanillaMasker2.default)(document.querySelectorAll(".insured_input")).maskNumber();
	
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->    
	    if (this.props.parcelInfo.getCartData) {
	      var defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
	      if (this.props.parcelInfo.cartData.hayward_item_count) {
	        this.setState({ isHaywardEmpty: false });
	      }
	      this.props.updateShipmentLocations(defaultWarehouseId, "origin", this.props.cart.shipment_location_details);
	      this.props.getDestinationSettings(defaultWarehouseId, this.props.cart.shipment_location_details.destination);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (this.props.login.error) {
	      if (this.props.login.status === 401) {
	        _store.history.push("/signin");
	      }
	    }
	    if (prevState.phone_number !== this.state.phone_number && prevProps.parcelInfo.getCartData !== this.props.parcelInfo.getCartData) {
	      // const defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
	      // if(this.state.phone_number.includes("+60") && defaultWarehouseId !== 4 && defaultWarehouseId !== 5){
	      //   this.props.updateShipmentLocations("MY", "destination", this.props.cart.shipment_location_details)
	      // }
	      if (this.state.phone_number.includes("+63")) {
	        this.props.updateShipmentLocations("PH", "destination", this.props.cart.shipment_location_details);
	      }
	    }
	    if (prevProps.parcelInfo.getCartData !== this.props.parcelInfo.getCartData) {
	      var defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
	      if (this.props.parcelInfo.cartData.hayward_item_count) {
	        this.setState({ isHaywardEmpty: false });
	      }
	      this.props.updateShipmentLocations(defaultWarehouseId, "origin", this.props.cart.shipment_location_details);
	      this.props.getDestinationSettings(defaultWarehouseId, this.props.cart.shipment_location_details.destination);
	    }
	  },
	  clearTimeout: function clearTimeout(val) {
	    setTimeout();
	  },
	  handleInputInsuredValue: function handleInputInsuredValue(id, event) {
	    var checked_insured_value = this.state.checked_insured_value;
	
	
	    this.setState({
	      checked_insured_value: Object.assign({}, checked_insured_value, _defineProperty({}, id, event.target.value.toString().split(".").map(function (el, i) {
	        return i ? el.split("").slice(0, 2).join("") : el;
	      }).join(".")))
	    });
	
	    event.persist();
	    this.sendInsuredValue(id, event);
	  },
	  handleCheck: function handleCheck(id, event) {
	    //handler for checkbox enabling
	
	    var last_value = event.currentTarget.dataset.lastvalue;
	    var number = parseInt(event.target.value, 10) || 0;
	    var num = event.target.value;
	    var checked = this.state.checked;
	
	    if (num.length === 0) {
	      this.refs["insured_value" + id].value = "";
	      this.setState(_defineProperty({}, "chk_" + id, ""));
	    }
	
	    if (num.length === 1) {
	      if (!isNaN(num) && num !== 0) {
	        //if the value is a number and it is not = 0
	        this.setState({ number: num });
	        this.setState(_defineProperty({}, "chk_" + id, id));
	      } else {
	        this.refs["insured_value" + id].value = last_value; // if not a number, remove character in textbox
	        this.setState(_defineProperty({}, "chk_" + id, ""));
	      }
	    } else {
	      if (!isNaN(num)) {
	        this.setState({ number: num });
	        this.setState(_defineProperty({}, "chk_" + id, id));
	      } else {
	        this.refs["insured_value" + id].value = last_value; //revert the value in the textbox to the previous number without non-numeric characters.
	      }
	    }
	    if (number <= 0) {
	      this.setState(_defineProperty({}, "chk_" + id, "")); //this.state.chk_id = null if insured value is null
	
	      if (checked.indexOf(id) !== -1) {
	        checked.splice(checked.indexOf(id), 1);
	      }
	
	      this.setState({ checked: checked });
	    } else {
	      this.setState(_defineProperty({}, "chk_" + id, id));
	      if (checked.indexOf(id) === -1) {
	        checked.push(id);
	      }
	      this.setState({ checked: checked });
	    }
	    var totalCheck = this.state.chkItemArray.air.length + this.state.chkItemArray.sea.length;
	    if (this.state.checked.length > 0) {
	      if (this.state.checked.length > totalCheck) {
	        this.refs.selectAll.checked = false;
	      } else {
	        this.refs.selectAll.checked = true;
	      }
	      this.setState({ selectAll: false });
	    } else {
	      this.refs.selectAll.checked = false;
	      this.setState({ selectAll: true });
	    }
	  },
	  handleCheckout: function handleCheckout() {
	    //Triggered when SHIP IT button is clicked.
	    var token = localStorage.jwtToken;
	
	    var chkItemArray = {
	      air: this.props.customerCheckout.checkout.data.hasOwnProperty("air") ? [].concat(_toConsumableArray(this.props.customerCheckout.checkout.data.air.parcels)) : [],
	      sea: this.props.customerCheckout.checkout.data.hasOwnProperty("sea") ? [].concat(_toConsumableArray(this.props.customerCheckout.checkout.data.sea.parcels)) : []
	    };
	
	    var sc_protect = { avail: 1 };
	    this.props.checkOut(token, chkItemArray, this.state.insurance, this.props.cart.shipment_location_details, this.state.itemOrigin, sc_protect, this.state.chkItemArray);
	  },
	  checkAll: function checkAll() {
	    this.state.checked_all ? this.setState({ checked_all: false }) : this.setState({ checked_all: true });
	  },
	  handleMethod: function handleMethod(id) {
	    //handler for shipping method change
	    var chkArray = this.state.chkItemArray;
	    var token = localStorage.jwtToken;
	
	    if (chkArray.air.indexOf(id) !== -1) {
	      chkArray.sea.push(id);
	      chkArray.seaDangerous.push(id);
	      chkArray.air.splice(this.state.chkItemArray.air.indexOf(id), 1);
	      chkArray.airDangerous.splice(this.state.chkItemArray.airDangerous.indexOf(id), 1);
	      this.setState({ chkItemArray: chkArray });
	    } else if (chkArray.sea.indexOf(id) !== -1) {
	      chkArray.air.push(id);
	      chkArray.airDangerous.push(id);
	      chkArray.sea.splice(this.state.chkItemArray.sea.indexOf(id), 1);
	      chkArray.seaDangerous.splice(this.state.chkItemArray.seaDangerous.indexOf(id), 1);
	      this.setState({ chkItemArray: chkArray });
	    }
	    if (this.state.overpriced.length === 0 && (this.state.chkItemArray.air.length > 0 || this.state.chkItemArray.sea.length > 0) && this.state.itemOrigin.hasOwnProperty(id)) {
	      this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin, true);
	    }
	  },
	  handleClick: function handleClick(id, warehouse_id, flags, event) {
	    var _this3 = this;
	
	    //handler for checked/unchecked box
	    this.props.clearCartMessages();
	    this.props.removeInsuredValueErrorMessage();
	    var token = localStorage.jwtToken;
	    var max_insured_value = JSON.parse(this.props.settings.destinationSettings.data.filter(function (data) {
	      return data.name === "general_setting";
	    })[0].settings).insurance_max_value.value;
	
	    if (event.target.checked) {
	      //if box is checked
	      this.setState({
	        id: id,
	        insured_value: this.state.checked_insured_value[id],
	        itemOrigin: warehouse_id
	      }, function () {
	        if (parseInt(_this3.state.insured_value, 10) > parseInt(max_insured_value, 10)) {
	          var overpriced = _this3.state.overpriced;
	          overpriced.push(id);
	          _this3.setState({ overpriced: overpriced });
	          window.scrollTo(0, 0);
	        } else {
	          var _overpriced = _this3.state.overpriced;
	          _overpriced.splice(_this3.state.overpriced.indexOf(id), 1);
	          _this3.setState({ overpriced: _overpriced });
	        }
	      });
	      var parcel_value = this.state.checked_insured_value[id];
	      var parcel_insurance = this.state.insurance;
	      var parcel_wid = warehouse_id;
	      var parcel_origin = this.state.itemOrigin;
	      parcel_insurance[id] = parcel_value;
	      parcel_origin[id] = parcel_wid;
	      this.setState({ insurance: parcel_insurance, itemOrigin: parcel_origin });
	      var chkArr = this.state.chkItemArray;
	
	      if (this.refs["shipment_method" + id].value === 'sea' || this.refs["shipment_method" + id].value === "Sea cargo only") {
	        chkArr.sea.push(id); //PUSH TO SEA THE ID OF PARCEL
	        if (flags.dangerous === 1) {
	          chkArr.seaDangerous.push(id);
	        }
	      } else {
	        chkArr.air.push(id); //PUSH TO AIR THE ID OF PARCEL
	        if (flags.dangerous === 1) {
	          chkArr.airDangerous.push(id);
	        }
	      }
	      this.setState({ chkItemArray: chkArr });
	      if (this.state.overpriced.length === 0) {
	        this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin, true);
	      }
	    } else {
	      //if box is UNCHECKED
	      this.setState({
	        insured_value: ""
	      });
	
	      var overpriced = this.state.overpriced;
	      overpriced.splice(this.state.overpriced.indexOf(id), 1);
	      this.setState({ overpriced: overpriced });
	
	      var insurance = {};
	      var origin = {};
	      insurance = this.state.insurance;
	      origin = this.state.itemOrigin;
	      chkArr = this.state.chkItemArray;
	      if (this.refs["shipment_method" + id].value === 'sea' || this.refs["shipment_method" + id].value === "Sea cargo only") {
	        chkArr.sea.splice(this.state.chkItemArray.sea.indexOf(id), 1); //remove from SEA array
	        chkArr.seaDangerous.splice(this.state.chkItemArray.seaDangerous.indexOf(id), 1); //remove from SEA array
	        delete insurance[id];
	        delete origin[id];
	      } else {
	        chkArr.air.splice(this.state.chkItemArray.air.indexOf(id), 1); //remove from AIR array
	        chkArr.airDangerous.splice(this.state.chkItemArray.airDangerous.indexOf(id), 1); //remove from SEA array
	        delete insurance[id];
	        delete origin[id];
	      }
	      this.setState({
	        chkItemArray: chkArr
	      }, function () {
	        if (_this3.state.chkItemArray.sea.length > 0 || _this3.state.chkItemArray.air.length > 0) {
	          _this3.props.getCheck(token, _this3.state.chkItemArray, _this3.props.cart.shipment_location_details, _this3.state.insurance, _this3.state.itemOrigin, true);
	        } else {
	          _this3.setState({ id: "", cartConsent: false });
	          _this3.props.clearCheck();
	        }
	      });
	    }
	    var totalCheck = this.state.chkItemArray.air.length + this.state.chkItemArray.sea.length;
	    if (this.state.checked.length > 0) {
	      if (this.state.checked.length === totalCheck) {
	        this.refs.selectAll.checked = true;
	        this.setState({ selectAll: false });
	      } else {
	        this.refs.selectAll.checked = false;
	      }
	    } else {
	      this.refs.selectAll.checked = false;
	      this.setState({ selectAll: true });
	    }
	  },
	  handleCheckAll: function handleCheckAll(warehouse_id, parcels, e) {
	    this.setState({ chkItemArray: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] } });
	    this.setState({ chkItemArray2: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] } });
	
	    var dangerous = parcels.filter(function (parcel) {
	      return parcel.insured_value;
	    }).map(function (parcel) {
	      return parcel.flags.dangerous;
	    });
	
	    var i = 0;
	    var checked = this.state.checked;
	    var chkItemArray2 = this.state.chkItemArray2;
	    var insurance = {};
	    var origin = {};
	    var token = localStorage.jwtToken;
	
	    for (i = 0; i < checked.length; i++) {
	      if (this.refs["checkbox" + checked[i]] && !this.refs["checkbox" + checked[i]].disabled) {
	        this.refs["checkbox" + checked[i]].checked = e.target.checked;
	        if (this.refs["checkbox" + checked[i]] && this.refs["checkbox" + checked[i]].checked) {
	          this.setState({ id: "id" });
	          if (this.refs["shipment_method" + checked[i]].value === "sea" || this.refs["shipment_method" + checked[i]].value === "Sea cargo only") {
	            chkItemArray2.sea.push(checked[i]);
	            insurance[checked[i]] = this.state.checked_insured_value[checked[i]];
	            origin[checked[i]] = warehouse_id[i];
	
	            if (dangerous[i] === 1) {
	              chkItemArray2.seaDangerous.push(checked[i]);
	            }
	          } else {
	            chkItemArray2.air.push(checked[i]);
	            insurance[checked[i]] = this.state.checked_insured_value[checked[i]];
	            origin[checked[i]] = warehouse_id[i];
	
	            if (dangerous[i] === 1) {
	              chkItemArray2.airDangerous.push(checked[i]);
	            }
	          }
	          this.setState({ itemOrigin: origin, insurance: insurance, chkItemArray: chkItemArray2 });
	        } else {
	          if (this.refs["shipment_method" + checked[i]].value === "sea" || this.refs["shipment_method" + checked[i]].value === "Sea cargo only") {
	            chkItemArray2.sea.splice(chkItemArray2.sea.indexOf(checked[i]), 1);
	            chkItemArray2.seaDangerous.splice(chkItemArray2.sea.indexOf(checked[i]), 1);
	            delete insurance[checked[i]];
	            delete origin[checked[i]];
	          } else {
	            chkItemArray2.air.splice(chkItemArray2.air.indexOf(checked[i]), 1);
	            chkItemArray2.airDangerous.splice(chkItemArray2.air.indexOf(checked[i]), 1);
	            delete insurance[checked[i]];
	            delete origin[checked[i]];
	          }
	          this.setState({ itemOrigin: origin, insurance: insurance, chkItemArray: chkItemArray2 });
	        }
	      }
	    }
	    if (this.state.chkItemArray2.air.length || this.state.chkItemArray2.sea.length) {
	      this.props.getCheck(token, this.state.chkItemArray2, this.props.cart.shipment_location_details, insurance, origin, true);
	    } else {
	      this.setState({ cartConsent: false });
	      this.props.clearCheck();
	    }
	  },
	  handleForm: function handleForm(e) {
	    e.preventDefault();
	  },
	  handleDate: function handleDate(date) {
	    if (date) {
	      var sliced_date = date.slice(0, 10);
	      var split_date = sliced_date.split("-");
	      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4);
	      return new_date;
	    } else {
	      return null;
	    }
	  },
	  handleInsuredHover: function handleInsuredHover(id) {
	    _reactDom2.default.findDOMNode(this.refs["insured_value" + id]).focus();
	  },
	  handleRemoveInsuredHover: function handleRemoveInsuredHover(id) {
	    _reactDom2.default.findDOMNode(this.refs["insured_value" + id]).blur();
	  },
	  setUSHaywardasActiveOrigin: function setUSHaywardasActiveOrigin() {
	    var _this4 = this;
	
	    var destination = this.props.cart.shipment_location_details.destination;
	    this.props.updateShipmentLocations(1, "origin", this.props.cart.shipment_location_details);
	    this.props.getStorageSettings(1);
	    this.props.getDestinationSettings(1, destination);
	    this.state.checked.map(function (check) {
	      return _this4.refs["checkbox" + check].checked = false;
	    });
	    this.refs.selectAll.checked = false;
	    this.props.clearCheck();
	
	    this.setState({
	      chkItemArray: {
	        "sea": [],
	        "air": [],
	        seaDangerous: [],
	        airDangerous: []
	      },
	      insurance: {},
	      id: "",
	      itemOrigin: {}
	    });
	  },
	  handleShipmentLocations: function handleShipmentLocations(e, type) {
	    var origin = Number(e.target.value);
	    var destination = void 0;
	    if (origin === 4 || origin === 5) {
	      this.props.cart.shipment_location_details.destination = "PH";
	    }
	    this.props.updateShipmentLocations(e.target.value, type, this.props.cart.shipment_location_details);
	    if (type === "origin") {
	      // warehouse_id = this.props.customerInfo.warehouse.data.find(data => data.id === e.target.value).id
	      destination = this.props.cart.shipment_location_details.destination;
	      this.props.getStorageSettings(origin);
	      this.props.getCartData((0, _warehouseFlags.warehouseIDToCode)(origin));
	      this.props.clearCheck();
	      this.setState({
	        chkItemArray: {
	          "sea": [],
	          "air": [],
	          seaDangerous: [],
	          airDangerous: []
	        }
	      });
	    }
	    if (type === "destination") {
	      origin = Number(this.props.cart.shipment_location_details.origin);
	      destination = e.target.value;
	
	      this.props.getCartData((0, _warehouseFlags.warehouseIDToCode)(origin));
	      this.props.clearCheck();
	      this.setState({
	        chkItemArray: {
	          "sea": [],
	          "air": [],
	          seaDangerous: [],
	          airDangerous: []
	        }
	      });
	    }
	    this.props.getDestinationSettings(origin, destination);
	    this.refs.selectAll.checked = false;
	    this.props.clearCheck();
	
	    this.setState({
	      chkItemArray: {
	        "sea": [],
	        "air": [],
	        seaDangerous: [],
	        airDangerous: []
	      },
	      chkItemArray2: {
	        "sea": [],
	        "air": [],
	        seaDangerous: [],
	        airDangerous: []
	      },
	      insurance: {},
	      id: "",
	      itemOrigin: {},
	      checked: [],
	      cartConsent: false
	    });
	  },
	  cartModal: function cartModal() {
	    return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null };
	  },
	  cartExtensionModal: function cartExtensionModal() {
	    return { __html: this.props.cms.getModal ? this.props.cms.modalExtensionContent.data.content.body : null };
	  },
	  render: function render() {
	    var _this5 = this;
	
	    // const days = this.props.settings.stor_set_fetched ? this.props.settings.storage_settings.data.settings.days_free_of_charge.value - this.props.settings.storage_settings.data.settings.item_free_charge_threshold.value : null;
	    // const free_change = this.props.settings.stor_set_fetched ? this.props.settings.storage_settings.data.settings.days_free_of_charge.value : null;
	    var parcel_details = this.props.parcelInfo.cartData ? this.props.parcelInfo.cartData.items : [];
	    var origin = Number(this.props.cart.shipment_location_details.origin);
	    var customerType = this.props.login && this.props.login.login.party && JSON.parse(this.props.login.login.party.party.metadata).customer_type;
	    // COVID 19 RESPONSE
	    var inboundBanner = this.props.settings.destinationSettings && JSON.parse(this.props.settings.destinationSettings.data.filter(function (data) {
	      return data.name === 'inbound_banner';
	    })[0].settings);
	
	    var minChargableWeight = this.props.settings.destinationSettings && JSON.parse(this.props.settings.destinationSettings.data.filter(function (data) {
	      return data.name === "minimum_chargeable_weight";
	    })[0].settings);
	
	    // if (this.props.parcelInfo.cartData){
	    //     // parcel_details = this.props.parcelInfo.cartData.items.filter(parcel =>
	    //     //   (parcel.warehouse_id === origin)
	    //     // )
	    //     if (this.props.cart.shipment_location_details.destination === "MY") {
	    //       parcel_details = this.props.parcelInfo.cartData.items.filter(parcel =>
	    //       (parcel.warehouse_id === origin && parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea !== 1) || 
	    //       (parcel.warehouse_id === origin && parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea === 1)
	    //       )
	    //     }
	    // }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.state.accountDetails && this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.items.length > 0 && _react2.default.createElement(_Tutorial2.default, { type: 'cart_tutorial', accountDetails: this.state.accountDetails }),
	      _react2.default.createElement(
	        'div',
	        { className: this.state.changepassword ? "sc-alert signup" : "disnone" },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'You can now use your new password to access your ShippingCart account!'
	      ),
	      this.props.cart.cancelled_payment ? this.props.customerCheckout.error && this.props.customerCheckout.error.response.data.errors.detail === "Cannot update payment is already paid." ? null : _react2.default.createElement(
	        'div',
	        { className: 'sc-alert  cart-sc' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'Your transaction is cancelled.'
	      ) : null,
	      this.props.cart.show_empty_checkout_items ? _react2.default.createElement(
	        'div',
	        { className: 'sc-alert  signup' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'You have no items to check out. Please select an item again and proceed to payment.'
	      ) : null,
	      this.props.cart.payment_error ? this.props.cart.cancelled_payment || this.props.customerCheckout.error && this.props.customerCheckout.error.response.data.errors.detail === "Cannot update payment is already paid." ? _react2.default.createElement(
	        'div',
	        { className: 'sc-alert  cart-sc2' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'Your payment is being processed. You will receive an email notification once your payment has been confirmed.'
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'sc-alert sc-alert-danger2' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'Unable to process payment.'
	      ) : null,
	      this.props.cart.invalid_transaction ? _react2.default.createElement(
	        'div',
	        { className: 'sc-alert sc-alert-danger2' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'We were unable to process your ShippingCart payment. Wait for a few minutes, then check if your item/s are back in your Cart before attempting to check out again.'
	      ) : null,
	      !_utils.disabledCart && _react2.default.createElement(_Tour2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'main-content storage-content' },
	        !this.props.parcelInfo.getCartData ? null : this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.items.length >= 0 ? _react2.default.createElement(
	          'div',
	          { className: 'storage-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cart-header' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Hi ',
	              this.props.login.fetched ? this.props.login.login.party.first_name : null,
	              ', shipping something today?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shipment-destination' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'FROM'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'source select-gradient' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'selected-method', value: origin, onChange: function onChange(e) {
	                      return _this5.handleShipmentLocations(e, "origin");
	                    }, disabled: this.props.parcelInfo.parcel_updating },
	                  this.props.customerInfo.warehouse.data && (0, _whiteListed.filterWarehouse)(this.props.customerInfo.warehouse.data, this.props.login.login.party).map(function (warehouse) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: warehouse.id },
	                      (0, _utils.maskCartWarehouseLabel)(warehouse, (0, _whiteListed.filterWarehouse)(_this5.props.customerInfo.warehouse.data, _this5.props.login.login.party).find(function (item) {
	                        return item.id === 6;
	                      }))
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'TO'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'destination select-gradient' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'selected-method', value: this.props.cart.shipment_location_details.destination, onChange: function onChange(e) {
	                      return _this5.handleShipmentLocations(e, "destination");
	                    } },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'PH' },
	                    'Philippines'
	                  )
	                )
	              )
	            )
	          ),
	          this.props.cart.shipment_location_details.destination === "MY" && _react2.default.createElement(
	            'div',
	            { style: { "fontSize": "12px", "fontStyle": "italic" } },
	            '*Please note that only AIR cargo is available for shipments from ',
	            (0, _utils.maskWarehouseById)(origin),
	            ' to ',
	            this.props.cart.shipment_location_details.destination,
	            '.'
	          ),
	          //dynamic banner
	          inboundBanner.status && inboundBanner.status.value === 1 && _react2.default.createElement(
	            'div',
	            { className: 'sc-warning', style: { display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement('i', {
	              className: 'fa fa-exclamation-circle',
	              style: { marginRight: '10px', color: '#feab10', fontSize: 17 }
	            }),
	            inboundBanner.message.value,
	            _react2.default.createElement(
	              'a',
	              { href: '/' + inboundBanner.redirection_link.value, target: '_blank' },
	              _react2.default.createElement('i', { className: 'fa fa-angle-right fa-lg icon-angle-right', 'aria-hidden': 'true' }),
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.parcelInfo.display_error_message || this.state.overpriced.length > 0 ? '' : 'disnone' },
	            _react2.default.createElement(
	              'div',
	              { ref: 'errors_credentials', className: 'sc-alert sc-alert-danger' },
	              _react2.default.createElement('i', { className: 'sc' }),
	              'The value of this item needs verification. Visit our Contact Us page for assistance.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.parcelInfo.less_than_zero_error_message ? '' : 'disnone', style: { marginTop: '5px' } },
	            _react2.default.createElement(
	              'div',
	              { ref: 'errors_credentials', className: 'sc-alert sc-alert-danger' },
	              _react2.default.createElement('i', { className: 'sc' }),
	              'You cannot declare an insured value below 1USD.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.parcelInfo.insured_value_nan_error_message ? '' : 'disnone' },
	            _react2.default.createElement(
	              'div',
	              { ref: 'errors_credentials', className: 'sc-alert sc-alert-danger' },
	              _react2.default.createElement('i', { className: 'sc' }),
	              'Insured value must be numbers only'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'partial messages clearfix' }),
	          this.props.parcelInfo.cart_fetching ? null : !this.props.parcelInfo.cart_fetching && parcel_details ? _react2.default.createElement(
	            _reactSticky.StickyContainer,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'form',
	                { className: 'pull-left cartable', id: 'ship-it', onSubmit: this.handleForm },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'item-list', id: 'stored-items' },
	                  _react2.default.createElement(
	                    'thead',
	                    { style: { backgroundColor: '#F1F1F1' } },
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Select Item/s'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Insured value'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'fa fa-question-circle fa-fw' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip white package-value-tooltip', style: { width: 300, textAlign: 'left' } },
	                            _react2.default.createElement(
	                              'p',
	                              { style: { fontSize: '10px', margin: '3px 0px' } },
	                              'Declare the value of your items correctly to keep them secure.'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: { fontSize: '10px', margin: '3px 0px' } },
	                              'This helps us make sure you\u2019re fairly reimbursed, in case anything happens, such as damage during shipping or if something goes missing.'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: { fontSize: '10px', margin: '3px 0px' } },
	                              'Remember, our insurance covers up to $20,000 per shipment, with a limit of $10,000 for each item.'
	                            ),
	                            _react2.default.createElement(
	                              'a',
	                              { href: 'https://help-center.shippingcart.com/hc/en-us/articles/4907826208143-What-is-declared-value-and-why-is-it-important-', style: { fontSize: '10px', fontWeight: 600 }, target: '_blank', rel: 'noopener noreferrer' },
	                              'Importance of declaring proper insured value'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Shipping method'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'fa fa-question-circle fa-fw' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip white' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Select your desired shipping mode. It takes 10 days via Air Cargo and 45 days via Sea Cargo.'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Details'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    parcel_details.filter(function (parcel) {
	                      return parcel.warehouse_id === _this5.props.cart.shipment_location_details.origin;
	                    }).map(function (parcel) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { id: parcel.id, key: parcel.id },
	                        _react2.default.createElement(
	                          'td',
	                          { className: _this5.state["chk_" + parcel.id] === parcel.id ? "item-name" : "item-name no-insurance" },
	                          (parcel.flags.vas_type !== 'PULL_OUT' || parcel.flags.vas_status !== 'COMPLETED') && _react2.default.createElement(
	                            'div',
	                            { className: 'checkbox',
	                              onMouseEnter: _this5.state["chk_" + parcel.id] === parcel.id ? null : _this5.handleInsuredHover.bind(_this5, parcel.id),
	                              onMouseLeave: _this5.state["chk_" + parcel.id] === parcel.id ? null : _this5.handleRemoveInsuredHover.bind(_this5, parcel.id) },
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this5.state["chk_" + parcel.id] === parcel.id ? "disnone" : "tooltip white black" },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Please declare the insured value (in USD) of this package to properly valuate your goods.'
	                              )
	                            ),
	                            _react2.default.createElement('input', {
	                              id: ["lbl" + parcel.id],
	                              'data-id': parcel.id,
	                              ref: ["checkbox" + parcel.id],
	                              onClick: _this5.handleClick.bind(_this5, parcel.id, parcel.warehouse_id, parcel.flags),
	                              'data-select': 'single',
	                              'data-item': '154990',
	                              'data-do': 'item-select',
	                              'data-on': 'change',
	                              type: 'checkbox',
	                              className: 'item-select',
	                              disabled: !parcel.insured_value || parcel.flags.vas_request || parcel.flags.vas_type === 'PULL_OUT' && parcel.flags.vas_status === 'COMPLETED' ? "disabled" : ""
	                            }),
	                            _react2.default.createElement('label', { id: ["lbl" + parcel.id], htmlFor: ["lbl" + parcel.id] }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this5.state["chk_" + parcel.id] === parcel.id ? "disnone" : "tooltip insured-tooltip white" },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Please declare the insured value (in USD) of this package to properly valuate your goods.'
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'item-info' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'name' },
	                              _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: "/parcel/" + parcel.id },
	                                (0, _utils.ellipses)(customerType === 'social seller' ? parcel.description : parcel.tracking_number, 120)
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'date' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'cart-weight', style: { display: 'none' } },
	                                parcel.dimensions.weight.weight,
	                                ' ',
	                                parcel.dimensions.weight.uom
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: parseInt(parcel.storage.storage_days, 10) >= parseInt(parcel.storage.storage_max_days - parcel.storage.max_day_threshold, 10) && !parcel.flags.free_storage ? "aging-red" : "" },
	                                parcel.storage.storage_days > 1 ? parcel.storage.storage_days + " days" : parcel.storage.storage_days + " day",
	                                ' in storage'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: parseInt(parcel.storage.storage_days, 10) >= parseInt(parcel.storage.storage_max_days - parcel.storage.max_day_threshold, 10) ? "tooltip aging-date white" : "disnone" },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  parseInt(parcel.storage.storage_days, 10) < parseInt(parcel.storage.storage_max_days, 10) ? 'Your item is nearing its ' + parcel.storage.storage_max_days + '-day storage limit. Ship out now!' : 'This is your last day to ship this item. Ship out now!'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'item-icon', style: { textAlign: 'center' } },
	                            parcel.flags.vas_status === 'PENDING' || parcel.flags.vas_status === 'VAS_APPROVED' || parcel.flags.vas_status === 'PAID' ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa special-handling-icon fa-fw' },
	                              _react2.default.createElement('img', { src: _vas2.default, alt: 'VAS icon' }),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white' },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'This item has an active request.'
	                                )
	                              )
	                            ) : null,
	                            parcel.flags.special_handling === 1 ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa special-handling-icon fa-fw', style: { height: '24px', width: '24px', backgroundSize: '17px', marginTop: '4px' } },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white icon-tooltip-special-handling', style: { display: 'inline-flex', width: '260px', alignItems: 'center', left: '-132px' } },
	                                _react2.default.createElement(
	                                  'p',
	                                  { style: { margin: '0px' } },
	                                  'This package requires special handling. '
	                                ),
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/special-handling', target: '_blank' },
	                                  _react2.default.createElement('i', { className: 'icon-arrow-blue fa fa-angle-right icon-angle-right', 'aria-hidden': 'true' }),
	                                  ' '
	                                )
	                              )
	                            ) : null,
	                            parcel.flags.is_abandoned === 1 ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa icon-hope fa-fw' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white', style: { top: '-70px' } },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'This is a Project Hope item.'
	                                )
	                              )
	                            ) : null,
	                            parcel.is_damaged ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa icon-damaged fa-fw', style: { height: '14px', top: '-1px' } },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white', style: { top: '-109px', height: 'auto' } },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'This package contains ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'damaged items'
	                                  ),
	                                  ' which are excluded from SC Protect when you checkout.'
	                                )
	                              )
	                            ) : null
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'insured' },
	                          'USD \xA0',
	                          _react2.default.createElement('input', { type: 'text', name: 'insured_value',
	                            id: parcel.id,
	                            className: 'insured-input',
	                            min: '0',
	                            ref: ["insured_value" + parcel.id]
	                            //defaultValue={parcel.insured_value}
	                            , value: _this5.state.checked_insured_value[parcel.id] || "",
	                            'data-lastvalue': parcel.insured_value,
	                            onChange: _this5.handleInputInsuredValue.bind(_this5, parcel.id),
	                            maxLength: '7'
	                          }),
	                          '\xA0'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'shipping-method' },
	                          parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea === 1 ? _this5.props.cart.shipment_location_details.destination === "MY" ? _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-disable', name: 'button', value: 'Air cargo only', ref: ["shipment_method" + parcel.id] },
	                            'Air cargo only'
	                          ) : _react2.default.createElement(
	                            'div',
	                            { className: 'select-gradient' },
	                            _react2.default.createElement(
	                              'select',
	                              { 'data-id': '154990', name: 'method[154990]', onChange: _this5.handleMethod.bind(_this5, parcel.id, parcel.warehouse_id), className: 'shipping-method selected-method', 'data-do': 'item-select', 'data-on': 'change', ref: ["shipment_method" + parcel.id] },
	                              _react2.default.createElement(
	                                'option',
	                                { value: 'air' },
	                                'Air Cargo'
	                              ),
	                              _react2.default.createElement(
	                                'option',
	                                { value: 'sea' },
	                                'Sea Cargo'
	                              )
	                            )
	                          ) : null,
	                          parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea !== 1 ? _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-disable', name: 'button', value: 'Air cargo only', ref: ["shipment_method" + parcel.id] },
	                            'Air cargo only'
	                          ) : null,
	                          parcel.flags.allowed_air !== 1 && parcel.flags.allowed_sea === 1 ? _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-disable', name: 'button', value: 'Sea cargo only', ref: ["shipment_method" + parcel.id] },
	                            'Sea cargo only'
	                          ) : null
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/parcel/" + parcel.id },
	                            'View'
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'list-actions clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'select-all checkbox' },
	                    _react2.default.createElement('input', {
	                      id: 'select-all',
	                      type: 'checkbox',
	                      className: 'item-select',
	                      'data-select': 'all',
	                      'data-do': 'item-select',
	                      'data-on': 'change',
	                      onClick: this.handleCheckAll.bind(this, parcel_details.map(function (parcel) {
	                        return parcel.warehouse_id;
	                      }), parcel_details),
	                      ref: 'selectAll',
	                      disabled: this.state.selectAll || this.state.checked.length === 0
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'select-all' },
	                      'Select All \xA0 | \xA0',
	                      _react2.default.createElement(
	                        'span',
	                        { id: 'selected-count' },
	                        Object.keys(this.state.itemOrigin).length
	                      ),
	                      ' out of',
	                      _react2.default.createElement(
	                        'span',
	                        { id: 'total-count' },
	                        ' ',
	                        parcel_details.filter(function (parcel) {
	                          return parcel.warehouse_id === _this5.props.cart.shipment_location_details.origin;
	                        }).length
	                      ),
	                      ' items selected'
	                    )
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'hidden', name: 'csrf', value: '5ac6a0d3ea10c942d3e7d1c067cc54c5' }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'customer_id', value: '10614' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'estimations-wrapper pull-right' },
	                _react2.default.createElement(
	                  _reactSticky.Sticky,
	                  { className: 'sticky' },
	                  function (_ref) {
	                    var style = _ref.style,
	                        isSticky = _ref.isSticky;
	
	                    return _react2.default.createElement(
	                      'header',
	                      { style: style },
	                      _react2.default.createElement(
	                        'form',
	                        { id: 'ship-it' },
	                        _react2.default.createElement('div', { className: 'arrow_right' }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'estimation-actions' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'header' },
	                            _react2.default.createElement('i', { className: _this5.state.id ? "fa fa-tags faa-shake animated fa-fw" : "fa fa-tags fa-fw" }),
	                            _react2.default.createElement(
	                              'i',
	                              { className: 'message' },
	                              'Shipment Cost'
	                            )
	                          ),
	                          _this5.props.customerCheckout.fetched && _this5.state.id && Object.keys(_this5.state.itemOrigin).length > 0 ?
	                          // this.props.customerCheckout.fetchItemComputation ? <i className="fa fa-spinner fa-spin" /> :
	
	                          // this.props.cart.shipment_location_details.destination !== 'MY'  ? 
	                          _this5.props.customerCheckout.fetched && _this5.props.customerCheckout.checkout.data && _react2.default.createElement(
	                            'div',
	                            { style: { border: '1px solid #E2E2E2', width: '100%', borderRadius: '10px', backgroundColor: '#FFF' } },
	                            _this5.props.customerCheckout.checkout.data.hasOwnProperty("air") && _react2.default.createElement(_ComputationBreakdown2.default, { type: 'air', data: _this5.props.customerCheckout.checkout.data }),
	                            _this5.props.customerCheckout.checkout.data.hasOwnProperty("sea") && _react2.default.createElement(_ComputationBreakdown2.default, { type: 'sea', data: _this5.props.customerCheckout.checkout.data, minChargableWeight: minChargableWeight }),
	                            _react2.default.createElement(
	                              'div',
	                              { style: { borderTop: '1px solid #E2E2E2', width: '100%', padding: '20px 16px' } },
	                              _react2.default.createElement(
	                                'div',
	                                { style: { display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 600, color: '#323232', borderBottom: '1px solid #F1F1F1', marginBottom: '10px', paddingBottom: '10px' } },
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  'Storage Fee'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  'USD ' + ((0, _utils.numbersWithComma)(Number(_this5.props.customerCheckout.checkout.data.summary.total_storage_charge).toFixed(2)) || '0.00')
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { style: { display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 600, color: '#323232' } },
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { marginRight: 7, alignSelf: 'center' } },
	                                  _react2.default.createElement('img', {
	                                    src: 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg',
	                                    alt: 'sc-protect',
	                                    height: 18,
	                                    width: 18
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { fontStyle: 'italic', fontWeight: 400 } },
	                                  'SC Protect fee will be computed in the next step.'
	                                )
	                              ),
	                              !!_this5.props.customerCheckout.checkout.data.damage_items.total && _react2.default.createElement(_DamagedBanner2.default, {
	                                message: _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'span',
	                                    { style: { fontWeight: 600 } },
	                                    _this5.props.customerCheckout.checkout.data.damage_items.total,
	                                    ' out of',
	                                    ' ',
	                                    _this5.props.customerCheckout.checkout.data.summary.total_qty,
	                                    ' packages'
	                                  ),
	                                  ' ',
	                                  'contains',
	                                  ' ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    {
	                                      style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer' },
	                                      onClick: function onClick() {
	                                        return _this5.setState({ damagedModalOpen: true });
	                                      }
	                                    },
	                                    'damaged item'
	                                  ),
	                                  ' ',
	                                  'which are excluded from SC Protect when you checkout.'
	                                ),
	                                bgColor: '#FFE9EB'
	                              })
	                            )
	                          ) : _react2.default.createElement(
	                            'div',
	                            { className: 'no-estimations' },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Input how much it\u2019s worth, select your preferred item/s, and choose the shipping method to get your shipment cost.'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'ship-it-btn wrapper' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-actions' },
	                          _this5.props.customerCheckout.checkout.data && _this5.props.customerCheckout.checkout.data.summary.total_price && _react2.default.createElement(
	                            'div',
	                            { style: { borderRadius: '10px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', padding: '20px 16px', textAlign: 'left', marginBottom: '10px' } },
	                            _react2.default.createElement(
	                              'div',
	                              { style: { fontSize: '16px', fontWeight: 600, marginBottom: '16px' } },
	                              'By proceeding,'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { style: { display: 'inline-flex' } },
	                              _react2.default.createElement(
	                                'div',
	                                { style: { padding: '0px 9px' } },
	                                _react2.default.createElement('input', {
	                                  id: 'cart-tnc',
	                                  name: 'cart-tnc',
	                                  type: 'checkbox',
	                                  ref: 'cart-tnc',
	                                  onClick: function onClick() {
	                                    return _this5.setState({ cartConsent: !_this5.state.cartConsent });
	                                  },
	                                  className: 'cart-tnc'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'cart-tnc', style: { fontWeight: 400 } },
	                                'I confirm that the declared insured value of each item is correct. Any misdeclaration will be subject to ',
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/terms-conditions', style: { fontSize: '13px', fontWeight: 600 }, target: '_blank' },
	                                  'ShippingCart\'s terms and conditions'
	                                ),
	                                '.'
	                              )
	                            )
	                          ),
	                          _this5.props.customerCheckout.checkout.data && _this5.props.customerCheckout.checkout.data.summary.total_price ? _react2.default.createElement(
	                            'div',
	                            { style: { borderRadius: '10px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', padding: '20px 16px' } },
	                            _react2.default.createElement(
	                              'div',
	                              { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '20px', fontSize: '20px', fontWeight: 600 } },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                'Shipment Cost'
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                'USD ',
	                                _this5.props.customerCheckout.checkout.data && _this5.props.customerCheckout.checkout.data.summary.total_price
	                              )
	                            ),
	                            _react2.default.createElement('input', { id: 'submitCart', className: 'proceedToCheckoutButton', type: 'submit', onClick: _this5.handleCheckout, value: 'Proceed to payment', disabled: !_this5.props.customerCheckout.fetchItemComputation && (_this5.state.chkItemArray.sea.length !== 0 || _this5.state.chkItemArray.air.length !== 0) && _this5.state.overpriced.length === 0 && !_this5.props.parcelInfo.parcel_updating && !_this5.props.customerCheckout.sc_protect_updating && _this5.state.cartConsent ? "" : "disabled" })
	                          ) : _react2.default.createElement('input', { id: 'submitCart', type: 'submit', onClick: _this5.handleCheckout, className: _this5.state.chkItemArray.sea.length !== 0 || _this5.state.chkItemArray.air.length !== 0 ? "btn ship-it" : "btn active ", value: 'Proceed to payment', disabled: !_this5.props.customerCheckout.fetchItemComputation && (_this5.state.chkItemArray.sea.length !== 0 || _this5.state.chkItemArray.air.length !== 0) && _this5.state.overpriced.length === 0 && !_this5.props.parcelInfo.parcel_updating && !_this5.props.customerCheckout.sc_protect_updating && _this5.state.cartConsent ? "" : "disabled" }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'details' },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'You can still review your orders before payment.'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              ' We group your items according to shipping method'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              ' (air or sea) and deliver them to your doorstep.'
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }
	                )
	              )
	            )
	          ) : null
	        ) : !this.props.parcelInfo.cart_fetching && this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.items.length <= 0 ? _react2.default.createElement(
	          'div',
	          { className: 'storage-wrapper' },
	          _react2.default.createElement('div', { className: 'header' }),
	          _react2.default.createElement('div', { className: 'partial messages clearfix' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'estimations-wrapper storage-empty' },
	            _react2.default.createElement(
	              'div',
	              { className: 'notify' },
	              _react2.default.createElement(
	                'div',
	                { className: 'notify-header' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement('span', { className: 'icon' }),
	                  'Your cart storage is empty.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'notify-content' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Did you ship something to your ShippingCart address?'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We\'ll let you know as soon as we\'ve accepted your package and immediately queue it for processing.',
	                  _react2.default.createElement('br', null),
	                  ' Processing involves weighing, photographing any documentation from your seller that includes list of what\'s in your package, and encoding into our system before it can be viewed in your cart.'
	                )
	              )
	            )
	          )
	        ) : null
	      ),
	      this.state.incompleteInfo ? _react2.default.createElement(_RequiredModal2.default, { show: true,
	        first_name: this.props.login.login.party.first_name,
	        last_name: this.props.login.login.party.last_name,
	        email: this.props.login.login.party.email,
	        phone_number: this.props.login.login.party.phone_number,
	        error: this.props.login.error && this.props.login.error.data ? this.props.login.error.data.errors : null,
	        fb_id: this.props.login.login.party.fb_id
	      }) : null,
	      localStorage.cartExtensionModalShowed ? null : this.props.cms.modalExtensionContent ? this.props.cms.getModal && this.props.cms.modalExtensionContent.data.status ? _react2.default.createElement(_AdvisoryExtensionModal2.default, { show: this.props.cms.showAdvisoryExtensionModal['cart'],
	        close: function close(dispatch) {
	          return _this5.props.closeModal('cartExtension');
	        },
	        content: this.cartExtensionModal()
	      }) : null : null,
	      localStorage.cartModalShowed ? null : this.props.cms.modalContent ? !_utils.disabledCart && this.props.cms.getModal && this.props.cms.modalContent.data.status ? _react2.default.createElement(_AdvisoryModal2.default, { show: this.props.cms.showAdvisoryModal['cart'],
	        close: function close(dispatch) {
	          return _this5.props.closeModal('cart');
	        },
	        content: this.cartModal()
	      }) : null : null,
	      _react2.default.createElement(_DamagedModal2.default, {
	        isOpen: this.state.damagedModalOpen,
	        handleClose: function handleClose() {
	          return _this5.setState({ damagedModalOpen: false });
	        },
	        damageItems: this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.damage_items
	      })
	    );
	  }
	});
	
	exports.default = Dashboard;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(58);
	
	var _reactRedux = __webpack_require__(46);
	
	var _Signup = __webpack_require__(90);
	
	var Signup = _interopRequireWildcard(_Signup);
	
	var _Signin = __webpack_require__(50);
	
	var Signin = _interopRequireWildcard(_Signin);
	
	var _DashboardActions = __webpack_require__(239);
	
	var DashboardActions = _interopRequireWildcard(_DashboardActions);
	
	var _ParcelAction = __webpack_require__(72);
	
	var ParcelAction = _interopRequireWildcard(_ParcelAction);
	
	var _ShipmentAction = __webpack_require__(241);
	
	var ShipmentAction = _interopRequireWildcard(_ShipmentAction);
	
	var _AddressAction = __webpack_require__(582);
	
	var AddressAction = _interopRequireWildcard(_AddressAction);
	
	var _CheckoutActions = __webpack_require__(584);
	
	var CheckoutActions = _interopRequireWildcard(_CheckoutActions);
	
	var _SettingsAction = __webpack_require__(240);
	
	var SettingsAction = _interopRequireWildcard(_SettingsAction);
	
	var _CmsActions = __webpack_require__(119);
	
	var Cms = _interopRequireWildcard(_CmsActions);
	
	var _CartAction = __webpack_require__(583);
	
	var CartAction = _interopRequireWildcard(_CartAction);
	
	var _Dashboard = __webpack_require__(248);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function mapStateToProps(state) {
	  return {
	    login: state.signin,
	    register: state.signup,
	    auth: state.auth,
	    customerInfo: state.dashboard,
	    parcelInfo: state.parcel,
	    shipmentInfo: state.shipment,
	    customerAddress: state.address,
	    customerCheckout: state.checkout,
	    settings: state.settings,
	    cms: state.cms,
	    cart: state.cart
	  };
	}
	function mapDispachToProps(dispatch) {
	  return (0, _redux.bindActionCreators)(Object.assign({}, Signin, Signup, DashboardActions, ParcelAction, ShipmentAction, AddressAction, CheckoutActions, Cms, SettingsAction, CartAction), dispatch);
	}
	
	var DashboardConnection = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(_Dashboard2.default);
	
	exports.default = DashboardConnection;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _propTypes = __webpack_require__(37);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vanillaMasker = __webpack_require__(559);
	
	var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);
	
	var _reactSticky = __webpack_require__(544);
	
	var _store = __webpack_require__(20);
	
	var _utils = __webpack_require__(13);
	
	var _lodash = __webpack_require__(139);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Tour = __webpack_require__(157);
	
	var _Tour2 = _interopRequireDefault(_Tour);
	
	__webpack_require__(185);
	
	__webpack_require__(310);
	
	__webpack_require__(311);
	
	var _Tutorial = __webpack_require__(158);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _vas = __webpack_require__(187);
	
	var _vas2 = _interopRequireDefault(_vas);
	
	var _whiteListed = __webpack_require__(93);
	
	var _warehouseFlags = __webpack_require__(73);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _ComputationBreakdown = __webpack_require__(250);
	
	var _ComputationBreakdown2 = _interopRequireDefault(_ComputationBreakdown);
	
	var _DamagedModal = __webpack_require__(121);
	
	var _DamagedModal2 = _interopRequireDefault(_DamagedModal);
	
	var _DamagedBanner = __webpack_require__(91);
	
	var _DamagedBanner2 = _interopRequireDefault(_DamagedBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// import AlertAdvisory from '../AlertAdvisory';
	
	var createReactClass = __webpack_require__(16);
	var OffsizeItemsDashboard = createReactClass({
	  displayName: 'OffsizeItemsDashboard',
	
	
	  contextTypes: {
	    router: _propTypes2.default.object.isRequired
	  },
	  getInitialState: function getInitialState() {
	
	    return {
	      style: 'top: 1000px;',
	      parcel: {},
	      disabled: true,
	      chkItemArray: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] },
	      chkItemArray2: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] },
	      data: [],
	      cargo: "",
	      insurance: {},
	      itemOrigin: {},
	      id: "",
	      insured_value: "",
	      checked_all: false,
	      changepassword: false,
	      checked: [],
	      checked_insured_value: {},
	      cancelled: false,
	      selectAll: true,
	      overpriced: [],
	      number: "",
	      incompleteInfo: false,
	      timeout: null,
	      payment_error: false,
	      isFetched: false,
	      tour: {
	        address: false,
	        cart: false,
	        shipments: false,
	        account: false,
	        estimate: false,
	        track: false
	      },
	      phone_number: '',
	      isHaywardEmpty: true,
	      alertModal: false,
	      damagedModalOpen: false,
	      cartConsent: false,
	      offsizeConsent: false
	    };
	  },
	  checkIfInsuredValueIsValid: function checkIfInsuredValueIsValid(insured_value, max_insured_value) {
	    if (insured_value < 1) {
	      this.props.showInsuredValueLessThanZeroErrorMessage();
	      return false;
	    }
	
	    if (isNaN(insured_value)) {
	      this.props.showInsuredValueNaNErrorMessage();
	      return false;
	    }
	
	    if (insured_value.length === 0 || parseInt(insured_value, 10) > max_insured_value) {
	      this.props.showInsuredValueErrorMessage();
	      return false;
	    }
	
	    return true;
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.props.clearCheck();
	    this.props.resetOffsizeConsent();
	    this.sendInsuredValue = (0, _lodash.debounce)(function (id, event) {
	
	      _this.props.removeInsuredValueErrorMessage();
	      var last_insured_value = event.target.dataset.lastvalue || null;
	      var insured_value = event.target.value;
	      var _state = _this.state,
	          checked = _state.checked,
	          checked_insured_value = _state.checked_insured_value;
	
	      var max_insured_value = JSON.parse(_this.props.settings.destinationSettings.data.filter(function (data) {
	        return data.name === "general_setting";
	      })[0].settings).insurance_max_value.value;
	      var warehouse_id = _this.props.customerInfo.warehouse.data.find(function (data) {
	        return data.id === Number(_this.props.cart.shipment_location_details.origin);
	      }).id;
	      var token = localStorage.jwtToken;
	      if (_this.checkIfInsuredValueIsValid(insured_value, max_insured_value)) {
	
	        if (checked.indexOf(id) === -1) {
	          checked.push(id);
	        }
	
	        _this.setState({ checked: checked });
	
	        if (_this.refs["checkbox" + id].checked) {
	          _this.props.updateInsuredValueAndRecalculateShipmentCost(id, event.target.value, token, _this.state.chkItemArray, _this.state.insurance, _this.state.itemOrigin, _this.props.cart.shipment_location_details, false);
	        } else {
	          _this.props.updateInsuredValue(token, id, event.target.value, warehouse_id, _this.props.cart.shipment_location_details.destination);
	        }
	      } else {
	        // this.refs["insured_value" + id].value = last_insured_value;
	        _this.setState({
	          checked_insured_value: Object.assign({}, checked_insured_value, _defineProperty({}, id, last_insured_value || ""))
	        });
	      }
	
	      //pertains to checking and unchecking of item ang select all behavior ->fluxion
	      var totalCheck = _this.state.chkItemArray.air.length + _this.state.chkItemArray.sea.length;
	
	      if (_this.state.checked.length > 0) {
	        if (_this.state.checked.length > totalCheck) {
	          _this.refs.selectAll.checked = false;
	        } else {
	          _this.refs.selectAll.checked = true;
	        }
	        _this.setState({ selectAll: false });
	      } else {
	        _this.refs.selectAll.checked = false;
	        _this.setState({ selectAll: true });
	      }
	
	      //if (this.refs["insured_value" + id].value === '' || this.refs["insured_value" + id].value <= 0) {
	      if (_this.state.checked_insured_value[id] === '' || _this.state.checked_insured_value[id] <= 0) {
	        if (_this.refs["checkbox" + id].checked) {
	          _this.refs["checkbox" + id].click();
	        }
	      }
	
	      //if current item is checked, must call this.props.getCheck to recalculate
	
	      /*FOR DYNAMIC COMPUTATION BASED ON INSURED VALUE INPUT*/
	      // if (this.refs["insured_value" + id].value !== '' && this.refs["insured_value" + id].value > 0 && this.refs["checkbox" + id].checked) {
	      //   if (parseInt(this.refs["insured_value" + id].value, 10) > parseInt(this.props.settings.general_settings.data.settings.insurance_max_value.value, 10)) {
	      //     let overpriced = this.state.overpriced;
	      //     overpriced.push(id);
	      //     this.setState({ overpriced: overpriced, })
	      //     window.scrollTo(0, 0);
	      //     this.props.clearCheck();
	      //   } else {
	      //     let insured_value = this.state.insurance;
	      //     let overpriced = this.state.overpriced;
	      //     insured_value[id] = this.refs["insured_value" + id].value;
	      //     overpriced.splice(this.state.overpriced.indexOf(id), 1);
	      //     this.setState({ insurance: insured_value, overpriced: overpriced, }, () => {
	
	      //       if (this.state.overpriced.length === 0) {
	      //         this.props.getCheck(token, this.state.chkItemArray, this.state.insurance,false);
	      //       }
	      //     });
	      //   }
	      // }
	    }, 1000);
	
	    var token = localStorage.jwtToken;
	    var warehouse_id = this.props.settings.gen_set_fetched ? this.props.settings.general_settings.data.warehouse_id : null;
	    // this.props.getParcel(token);
	    this.props.getCartData(this.props.parcelInfo.cartData && (0, _warehouseFlags.warehouseIDToCode)(this.props.parcelInfo.cartData.active_warehouse.id) || null);
	    this.props.getProhibitedParcel(token);
	    this.props.getStorageSettings(warehouse_id);
	
	    if (!this.props.login.fetched) {
	      this.props.signedIn(token);
	    }
	
	    (0, _jquery2.default)('.cart').addClass('active');
	    localStorage.ChangePassword ? this.setState({ changepassword: true }) : this.setState({ changepassword: false });
	    localStorage.removeItem('ChangePassword');
	
	    /*FOR CANCELLED TRANSACTIONS*/
	    if (Object.prototype.hasOwnProperty.call(this.props.location, 'query')) {
	      if (this.props.location.query.status === "canceled" || this.props.location.query.status === "rejected" || this.props.location.query.status === "expired") {
	        var payment_provider = this.props.location.query.payment_provider;
	        var ref_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'Ref') ? this.props.location.query.Ref : this.props.location.query.token;
	        var payment_status = this.props.location.query.status;
	
	        if (payment_provider === 'paypal') {
	          this.props.setPayment(payment_provider, payment_status, ref_id);
	        }
	      }
	    }
	
	    // if(this.props.customerInfo.warehouse.data){
	    //   const id = this.props.customerInfo.warehouse.data.find(data => data.id === this.props.cart.shipment_location_details.origin).id
	    //   this.props.getDestinationSettings(id, this.props.cart.shipment_location_details.destination);
	    // } 
	
	    if (localStorage.trackPackage2) {
	      _store.history.push("/track");
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (nextProps.login.fetched && nextProps.login.login.party) {
	      var admin = _utils.adminUserIds.find(function (id) {
	        return id === nextProps.login.login.party.account_number;
	      });
	      if (!admin && _utils.disabledCart) {
	        return _store.history.push('/shipment');
	      }
	    }
	    (0, _jquery2.default)('#SCTitle').text("Cart | ShippingCart");
	    var checked_insured_value = this.state.checked_insured_value;
	
	    if (nextProps.parcelInfo.cartData && !nextProps.parcelInfo.error) {
	      var checked = this.state.checked;
	
	
	      if (nextProps.parcelInfo.cartData.offsizeItems.length > 0) {
	        this.setState({ selectAll: false });
	
	        nextProps.parcelInfo.cartData.offsizeItems.forEach(function (parcel) {
	          if (parcel.insured_value) {
	            _this2.setState(_defineProperty({}, "chk_" + parcel.id, parcel.id));
	
	            if (checked.indexOf(parcel.id) === -1) {
	              checked.push(parcel.id);
	              checked_insured_value[parcel.id] = parcel.insured_value;
	            }
	
	            if (Number(nextProps.cart.shipment_location_details.origin) !== parcel.warehouse_id || nextProps.cart.shipment_location_details.destination === "MY" && parcel.flags.allowed_air !== 1 && parcel.flags.allowed_sea === 1) {
	              var index = checked.indexOf(parcel.id);
	              if (index > -1) {
	                checked.splice(index, 1);
	              }
	            }
	
	            _this2.setState({ checked: checked, checked_insured_value: checked_insured_value });
	          }
	        });
	      }
	    }
	
	    if (nextProps.parcelInfo.insured_value_error) {
	      var parcel_id = nextProps.parcelInfo.insured_value_update_error.data.errors.meta.parcel_id;
	      var last_insured_value = nextProps.parcelInfo.insured_value_update_error.data.errors.meta.insured_value;
	      //this.refs["insured_value" + parcel_id].value = last_insured_value;
	      this.setState({
	        checked_insured_value: Object.assign({}, checked_insured_value, _defineProperty({}, parcel_id, last_insured_value || ""))
	      });
	
	      var overpriced = this.state.overpriced;
	      overpriced.splice(this.state.overpriced.indexOf(parcel_id), 1);
	      this.setState({ overpriced: overpriced });
	
	      if (!last_insured_value || isNaN(last_insured_value) || last_insured_value === 0) {
	        this.setState(_defineProperty({}, "chk_" + parcel_id, ''));
	      } else {
	        this.setState(_defineProperty({}, "chk_" + parcel_id, parcel_id));
	      }
	
	      if (this.state.chkItemArray.sea.length > 0 || this.state.chkItemArray.air.length > 0) {
	        var token = localStorage.jwtToken;
	        this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin, true);
	      }
	    } else {
	      if (nextProps.parcelInfo.updated_parcel) {
	
	        var _parcel_id = nextProps.parcelInfo.updated_parcel.data.id;
	        var insured_value = nextProps.parcelInfo.updated_parcel.data.insured_value;
	        checked_insured_value[_parcel_id] = insured_value;
	
	        if (!this.props.parcelInfo.less_than_zero_error_message) {
	          var _setState3;
	
	          this.setState((_setState3 = {}, _defineProperty(_setState3, "chk_" + _parcel_id, _parcel_id), _defineProperty(_setState3, 'checked_insured_value', checked_insured_value), _setState3));
	        }
	      }
	    }
	    if (nextProps.login.login.party) {
	      if (!nextProps.login.login.party.email || nextProps.login.login.party.email === nextProps.login.login.party.fb_id + '@gmail.com' || !nextProps.login.login.party.phone_number || !(0, _utils.prefixNumber)(nextProps.login.login.party.phone_number.slice(0, 3))) {
	        this.setState({ incompleteInfo: true });
	      } else {
	        this.setState({ incompleteInfo: false });
	      }
	      if (nextProps.login.login.party.phone_number) {
	        this.setState({ phone_number: nextProps.login.login.party.phone_number });
	      }
	      this.setState({ accountDetails: nextProps.login.login.party });
	    }
	
	    if (nextProps.parcelInfo.cartData && nextProps.parcelInfo.cartData.offsizeItems.length <= 0) {
	      _store.history.push('/cart');
	    }
	
	    // const cartModalContent = nextProps.cms.getModal && nextProps.cms.modalContent && nextProps.cms.modalContent.data.variable === "Cart-Modal" ? nextProps.cms.modalContent.data.status : false;
	    // this.setState({cartModalContent})
	  },
	  componentWillUnmount: function componentWillUnmount() {
	
	    this.props.clearCheck();
	    localStorage.removeItem("trackPackage2");
	    this.props.clearCartMessages();
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    (0, _vanillaMasker2.default)(document.getElementsByClassName("insured-input")).maskNumber();
	    (0, _vanillaMasker2.default)(document.querySelectorAll(".insured_input")).maskNumber();
	
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->    
	    if (this.props.parcelInfo.getCartData) {
	      var defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
	      if (this.props.parcelInfo.cartData.hayward_item_count) {
	        this.setState({ isHaywardEmpty: false });
	      }
	      this.props.updateShipmentLocations(defaultWarehouseId, "origin", this.props.cart.shipment_location_details);
	      this.props.getDestinationSettings(defaultWarehouseId, this.props.cart.shipment_location_details.destination);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (this.props.login.error) {
	      if (this.props.login.status === 401) {
	        _store.history.push("/signin");
	      }
	    }
	    // if(prevState.phone_number !== this.state.phone_number){
	    //   if(this.state.phone_number.includes("+60")){
	    //     this.props.updateShipmentLocations("MY", "destination", this.props.cart.shipment_location_details)
	    //   }
	    //   if(this.state.phone_number.includes("+63")){
	    //     this.props.updateShipmentLocations("PH", "destination", this.props.cart.shipment_location_details)
	    //   }
	    // }
	    if (prevProps.parcelInfo.getCartData !== this.props.parcelInfo.getCartData) {
	      var defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
	      if (this.props.parcelInfo.cartData.hayward_item_count) {
	        this.setState({ isHaywardEmpty: false });
	      }
	      this.props.updateShipmentLocations(defaultWarehouseId, "origin", this.props.cart.shipment_location_details);
	      this.props.getDestinationSettings(defaultWarehouseId, this.props.cart.shipment_location_details.destination);
	    }
	  },
	  clearTimeout: function clearTimeout(val) {
	    setTimeout();
	  },
	  handleInputInsuredValue: function handleInputInsuredValue(id, event) {
	    var checked_insured_value = this.state.checked_insured_value;
	
	
	    this.setState({
	      checked_insured_value: Object.assign({}, checked_insured_value, _defineProperty({}, id, event.target.value.toString().split(".").map(function (el, i) {
	        return i ? el.split("").slice(0, 2).join("") : el;
	      }).join(".")))
	    });
	
	    event.persist();
	    this.sendInsuredValue(id, event);
	  },
	  handleCheck: function handleCheck(id, event) {
	    //handler for checkbox enabling
	
	    var last_value = event.currentTarget.dataset.lastvalue;
	    var number = parseInt(event.target.value, 10) || 0;
	    var num = event.target.value;
	    var checked = this.state.checked;
	
	    if (num.length === 0) {
	      this.refs["insured_value" + id].value = "";
	      this.setState(_defineProperty({}, "chk_" + id, ""));
	    }
	
	    if (num.length === 1) {
	      if (!isNaN(num) && num !== 0) {
	        //if the value is a number and it is not = 0
	        this.setState({ number: num });
	        this.setState(_defineProperty({}, "chk_" + id, id));
	      } else {
	        this.refs["insured_value" + id].value = last_value; // if not a number, remove character in textbox
	        this.setState(_defineProperty({}, "chk_" + id, ""));
	      }
	    } else {
	      if (!isNaN(num)) {
	        this.setState({ number: num });
	        this.setState(_defineProperty({}, "chk_" + id, id));
	      } else {
	        this.refs["insured_value" + id].value = last_value; //revert the value in the textbox to the previous number without non-numeric characters.
	      }
	    }
	    if (number <= 0) {
	      this.setState(_defineProperty({}, "chk_" + id, "")); //this.state.chk_id = null if insured value is null
	
	      if (checked.indexOf(id) !== -1) {
	        checked.splice(checked.indexOf(id), 1);
	      }
	
	      this.setState({ checked: checked });
	    } else {
	      this.setState(_defineProperty({}, "chk_" + id, id));
	      if (checked.indexOf(id) === -1) {
	        checked.push(id);
	      }
	      this.setState({ checked: checked });
	    }
	    // var totalCheck = this.state.chkItemArray.air.length + this.state.chkItemArray.sea.length;
	    // if (this.state.checked.length > 0) {
	    //   if (this.state.checked.length > totalCheck) {
	    //     this.refs.selectAll.checked = false;
	    //   }
	    //   else {
	    //     this.refs.selectAll.checked = true;
	    //   }
	    //   this.setState({ selectAll: false, });
	    // }
	    // else {
	    //   this.refs.selectAll.checked = false;
	    //   this.setState({ selectAll: true, });
	    // }
	  },
	  handleCheckout: function handleCheckout() {
	    //Triggered when SHIP IT button is clicked.
	    var token = localStorage.jwtToken;
	    var offsizeItem = true;
	
	    var chkItemArray = {
	      air: this.props.customerCheckout.checkout.data.hasOwnProperty("air") ? [].concat(_toConsumableArray(this.props.customerCheckout.checkout.data.air.parcels)) : [],
	      sea: this.props.customerCheckout.checkout.data.hasOwnProperty("sea") ? [].concat(_toConsumableArray(this.props.customerCheckout.checkout.data.sea.parcels)) : []
	    };
	
	    var sc_protect = void 0;
	    if (this.props.cart.shipment_location_details.destination !== 'MY') {
	      sc_protect = { avail: 1 };
	    }
	    this.props.checkOut(token, chkItemArray, this.state.insurance, this.props.cart.shipment_location_details, this.state.itemOrigin, sc_protect, this.state.chkItemArray, offsizeItem);
	  },
	  checkAll: function checkAll() {
	    this.state.checked_all ? this.setState({ checked_all: false }) : this.setState({ checked_all: true });
	  },
	  handleMethod: function handleMethod(id) {
	    //handler for shipping method change
	    var chkArray = this.state.chkItemArray;
	    var token = localStorage.jwtToken;
	
	    if (chkArray.air.indexOf(id) !== -1) {
	      chkArray.sea.push(id);
	      chkArray.seaDangerous.push(id);
	      chkArray.air.splice(this.state.chkItemArray.air.indexOf(id), 1);
	      chkArray.airDangerous.splice(this.state.chkItemArray.airDangerous.indexOf(id), 1);
	      this.setState({ chkItemArray: chkArray });
	    } else if (chkArray.sea.indexOf(id) !== -1) {
	      chkArray.air.push(id);
	      chkArray.airDangerous.push(id);
	      chkArray.sea.splice(this.state.chkItemArray.sea.indexOf(id), 1);
	      chkArray.seaDangerous.splice(this.state.chkItemArray.seaDangerous.indexOf(id), 1);
	      this.setState({ chkItemArray: chkArray });
	    }
	    if (this.state.overpriced.length === 0 && (this.state.chkItemArray.air.length > 0 || this.state.chkItemArray.sea.length > 0) && this.state.itemOrigin.hasOwnProperty(id)) {
	
	      this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin, true);
	    }
	  },
	  handleClick: function handleClick(id, warehouse_id, flags, event) {
	    var _this3 = this;
	
	    //handler for checked/unchecked box
	    this.props.clearCartMessages();
	    this.props.removeInsuredValueErrorMessage();
	    var token = localStorage.jwtToken;
	    var max_insured_value = JSON.parse(this.props.settings.destinationSettings.data.filter(function (data) {
	      return data.name === "general_setting";
	    })[0].settings).insurance_max_value.value;
	
	    if (event.target.checked) {
	      //if box is checked
	      this.setState({
	        id: id,
	        insured_value: this.state.checked_insured_value[id],
	        itemOrigin: warehouse_id
	      }, function () {
	        if (parseInt(_this3.state.insured_value, 10) > parseInt(max_insured_value, 10)) {
	          var overpriced = _this3.state.overpriced;
	          overpriced.push(id);
	          _this3.setState({ overpriced: overpriced });
	          window.scrollTo(0, 0);
	        } else {
	          var _overpriced = _this3.state.overpriced;
	          _overpriced.splice(_this3.state.overpriced.indexOf(id), 1);
	          _this3.setState({ overpriced: _overpriced });
	        }
	      });
	      var parcel_value = this.state.checked_insured_value[id];
	      var parcel_insurance = this.state.insurance;
	      var parcel_wid = warehouse_id;
	      var parcel_origin = this.state.itemOrigin;
	      parcel_insurance[id] = parcel_value;
	      parcel_origin[id] = parcel_wid;
	      this.setState({ insurance: parcel_insurance, itemOrigin: parcel_origin });
	      var chkArr = this.state.chkItemArray;
	
	      if (this.refs["shipment_method" + id].value === 'sea' || this.refs["shipment_method" + id].value === "Sea cargo only") {
	        chkArr.sea.length = 0; //PUSH TO SEA THE ID OF PARCEL
	        chkArr.sea.push(id); //PUSH TO SEA THE ID OF PARCEL
	        if (flags.dangerous === 1) {
	          chkArr.seaDangerous.length = 0; //PUSH TO SEA THE ID OF PARCEL
	          chkArr.seaDangerous.push(id);
	        }
	      } else {
	        chkArr.air.length = 0; //PUSH TO AIR THE ID OF PARCEL
	        chkArr.air.push(id); //PUSH TO AIR THE ID OF PARCEL
	        if (flags.dangerous === 1) {
	          chkArr.airDangerous.push(id);
	        }
	      }
	      this.setState({ chkItemArray: chkArr });
	      if (this.state.overpriced.length === 0) {
	        this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin, true);
	      }
	    } else {
	      //if box is UNCHECKED
	      this.setState({
	        insured_value: ""
	      });
	
	      var overpriced = this.state.overpriced;
	      overpriced.splice(this.state.overpriced.indexOf(id), 1);
	      this.setState({ overpriced: overpriced });
	
	      var insurance = {};
	      var origin = {};
	      insurance = this.state.insurance;
	      origin = this.state.itemOrigin;
	      chkArr = this.state.chkItemArray;
	      if (this.refs["shipment_method" + id].value === 'sea' || this.refs["shipment_method" + id].value === "Sea cargo only") {
	        chkArr.sea.splice(this.state.chkItemArray.sea.indexOf(id), 1); //remove from SEA array
	        chkArr.seaDangerous.splice(this.state.chkItemArray.seaDangerous.indexOf(id), 1); //remove from SEA array
	        delete insurance[id];
	        delete origin[id];
	      } else {
	        chkArr.air.splice(this.state.chkItemArray.air.indexOf(id), 1); //remove from AIR array
	        chkArr.airDangerous.splice(this.state.chkItemArray.airDangerous.indexOf(id), 1); //remove from SEA array
	        delete insurance[id];
	        delete origin[id];
	      }
	      this.setState({
	        chkItemArray: chkArr
	      }, function () {
	        if (_this3.state.chkItemArray.sea.length > 0 || _this3.state.chkItemArray.air.length > 0) {
	          _this3.props.getCheck(token, _this3.state.chkItemArray, _this3.props.cart.shipment_location_details, _this3.state.insurance, _this3.state.itemOrigin, true);
	        } else {
	          _this3.setState({ id: "" });
	          _this3.props.clearCheck();
	        }
	      });
	    }
	    // var totalCheck = this.state.chkItemArray.air.length + this.state.chkItemArray.sea.length;
	    // if (this.state.checked.length > 0) {
	    //   if (this.state.checked.length === totalCheck) {
	    //     this.refs.selectAll.checked = true;
	    //     this.setState({ selectAll: false, });
	    //   } else {
	    //     this.refs.selectAll.checked = false;
	    //   }
	    // } else {
	    //   this.refs.selectAll.checked = false;
	    //   this.setState({ selectAll: true, });
	    // }
	  },
	  handleCheckAll: function handleCheckAll(warehouse_id, parcels, e) {
	    this.setState({ chkItemArray: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] } });
	    this.setState({ chkItemArray2: { "sea": [], "air": [], seaDangerous: [], airDangerous: [] } });
	
	    var dangerous = parcels.filter(function (parcel) {
	      return parcel.insured_value;
	    }).map(function (parcel) {
	      return parcel.flags.dangerous;
	    });
	
	    var i = 0;
	    var checked = this.state.checked;
	    var chkItemArray2 = this.state.chkItemArray2;
	    var insurance = {};
	    var origin = {};
	    var token = localStorage.jwtToken;
	
	    for (i = 0; i < checked.length; i++) {
	      if (this.refs["checkbox" + checked[i]] && !this.refs["checkbox" + checked[i]].disabled) {
	        this.refs["checkbox" + checked[i]].checked = e.target.checked;
	        if (this.refs["checkbox" + checked[i]] && this.refs["checkbox" + checked[i]].checked) {
	          this.setState({ id: "id" });
	          if (this.refs["shipment_method" + checked[i]].value === "sea" || this.refs["shipment_method" + checked[i]].value === "Sea cargo only") {
	            chkItemArray2.sea.push(checked[i]);
	            insurance[checked[i]] = this.state.checked_insured_value[checked[i]];
	            origin[checked[i]] = warehouse_id[i];
	
	            if (dangerous[i] === 1) {
	              chkItemArray2.seaDangerous.push(checked[i]);
	            }
	          } else {
	            chkItemArray2.air.push(checked[i]);
	            insurance[checked[i]] = this.state.checked_insured_value[checked[i]];
	            origin[checked[i]] = warehouse_id[i];
	
	            if (dangerous[i] === 1) {
	              chkItemArray2.airDangerous.push(checked[i]);
	            }
	          }
	          this.setState({ itemOrigin: origin, insurance: insurance, chkItemArray: chkItemArray2 });
	        } else {
	          if (this.refs["shipment_method" + checked[i]].value === "sea" || this.refs["shipment_method" + checked[i]].value === "Sea cargo only") {
	            chkItemArray2.sea.splice(chkItemArray2.sea.indexOf(checked[i]), 1);
	            chkItemArray2.seaDangerous.splice(chkItemArray2.sea.indexOf(checked[i]), 1);
	            delete insurance[checked[i]];
	            delete origin[checked[i]];
	          } else {
	            chkItemArray2.air.splice(chkItemArray2.air.indexOf(checked[i]), 1);
	            chkItemArray2.airDangerous.splice(chkItemArray2.air.indexOf(checked[i]), 1);
	            delete insurance[checked[i]];
	            delete origin[checked[i]];
	          }
	          this.setState({ itemOrigin: origin, insurance: insurance, chkItemArray: chkItemArray2 });
	        }
	      }
	
	      if (this.state.chkItemArray2.air.length || this.state.chkItemArray2.sea.length) {
	
	        this.props.getCheck(token, this.state.chkItemArray2, this.props.cart.shipment_location_details, insurance, origin, true);
	      } else {
	        this.props.clearCheck();
	      }
	    }
	  },
	  handleForm: function handleForm(e) {
	    e.preventDefault();
	  },
	  handleDate: function handleDate(date) {
	    if (date) {
	      var sliced_date = date.slice(0, 10);
	      var split_date = sliced_date.split("-");
	      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4);
	      return new_date;
	    } else {
	      return null;
	    }
	  },
	  handleInsuredHover: function handleInsuredHover(id) {
	    _reactDom2.default.findDOMNode(this.refs["insured_value" + id]).focus();
	  },
	  handleRemoveInsuredHover: function handleRemoveInsuredHover(id) {
	    _reactDom2.default.findDOMNode(this.refs["insured_value" + id]).blur();
	  },
	  setUSHaywardasActiveOrigin: function setUSHaywardasActiveOrigin() {
	    var _this4 = this;
	
	    var destination = this.props.cart.shipment_location_details.destination;
	    this.props.updateShipmentLocations(1, "origin", this.props.cart.shipment_location_details);
	    this.props.getStorageSettings(1);
	    this.props.getDestinationSettings(1, destination);
	    this.state.checked.map(function (check) {
	      return _this4.refs["checkbox" + check].checked = false;
	    });
	    this.refs.selectAll.checked = false;
	    this.props.clearCheck();
	
	    this.setState({
	      chkItemArray: {
	        "sea": [],
	        "air": [],
	        seaDangerous: [],
	        airDangerous: []
	      },
	      insurance: {},
	      id: "",
	      itemOrigin: {}
	    });
	  },
	  handleShipmentLocations: function handleShipmentLocations(e, type) {
	    var _this5 = this;
	
	    var origin = Number(e.target.value);
	    var destination = void 0;
	    if (origin === 4 || origin === 5) {
	      this.props.cart.shipment_location_details.destination = "PH";
	    }
	    this.props.updateShipmentLocations(e.target.value, type, this.props.cart.shipment_location_details);
	    if (type === "origin") {
	      // warehouse_id = this.props.customerInfo.warehouse.data.find(data => data.id === e.target.value).id
	      destination = this.props.cart.shipment_location_details.destination;
	      this.props.getStorageSettings(origin);
	      this.props.getCartData((0, _warehouseFlags.warehouseIDToCode)(origin));
	    }
	    if (type === "destination") {
	      origin = Number(this.props.cart.shipment_location_details.origin);
	      destination = e.target.value;
	    }
	    this.props.getDestinationSettings(origin, destination);
	    this.state.checked.map(function (check) {
	      return _this5.refs["checkbox" + check].checked = false;
	    });
	    this.refs.selectAll.checked = false;
	    this.props.clearCheck();
	
	    this.setState({
	      chkItemArray: {
	        "sea": [],
	        "air": [],
	        seaDangerous: [],
	        airDangerous: []
	      },
	      insurance: {},
	      id: "",
	      itemOrigin: {}
	    });
	  },
	  cartModal: function cartModal() {
	    return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null };
	  },
	  cartExtensionModal: function cartExtensionModal() {
	    return { __html: this.props.cms.getModal ? this.props.cms.modalExtensionContent.data.content.body : null };
	  },
	  render: function render() {
	    var _this6 = this;
	
	    // const days = this.props.settings.stor_set_fetched ? this.props.settings.storage_settings.data.settings.days_free_of_charge.value - this.props.settings.storage_settings.data.settings.item_free_charge_threshold.value : null;
	    // const free_change = this.props.settings.stor_set_fetched ? this.props.settings.storage_settings.data.settings.days_free_of_charge.value : null;
	    var parcel_details = this.props.parcelInfo.cartData ? this.props.parcelInfo.cartData.offsizeItems : [];
	    var origin = Number(this.props.cart.shipment_location_details.origin);
	    var customerType = this.props.login && this.props.login.login.party && JSON.parse(this.props.login.login.party.party.metadata).customer_type;
	    // COVID 19 RESPONSE
	
	    if (this.props.parcelInfo.cartData) {
	      // parcel_details = this.props.parcelInfo.cartData.items.filter(parcel =>
	      //   (parcel.warehouse_id === origin)
	      // )
	      parcel_details = this.props.parcelInfo.cartData.offsizeItems.filter(function (parcel) {
	        return parcel.warehouse_id === origin && parcel.flags.allowed_air !== 1 && parcel.flags.allowed_sea === 1 || parcel.warehouse_id === origin && parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea === 1;
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.state.accountDetails && this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.offsizeItems.length > 0 && _react2.default.createElement(_Tutorial2.default, { type: 'cart_tutorial', accountDetails: this.state.accountDetails }),
	      _react2.default.createElement(
	        'div',
	        { className: this.state.changepassword ? "sc-alert signup" : "disnone" },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'You can now use your new password to access your ShippingCart account!'
	      ),
	      this.props.cart.cancelled_payment ? this.props.customerCheckout.error && this.props.customerCheckout.error.response.data.errors.detail === "Cannot update payment is already paid." ? null : _react2.default.createElement(
	        'div',
	        { className: 'sc-alert  cart-sc' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'Your transaction is cancelled.'
	      ) : null,
	      this.props.cart.show_empty_checkout_items ? _react2.default.createElement(
	        'div',
	        { className: 'sc-alert  signup' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'You have no items to check out. Please select an item again and proceed to payment.'
	      ) : null,
	      this.props.cart.payment_error ? this.props.cart.cancelled_payment || this.props.customerCheckout.error && this.props.customerCheckout.error.response.data.errors.detail === "Cannot update payment is already paid." ? _react2.default.createElement(
	        'div',
	        { className: 'sc-alert  cart-sc2' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'Your payment is being processed. You will receive an email notification once your payment has been confirmed.'
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'sc-alert sc-alert-danger2' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'Unable to process payment.'
	      ) : null,
	      this.props.cart.invalid_transaction ? _react2.default.createElement(
	        'div',
	        { className: 'sc-alert sc-alert-danger2' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'We were unable to process your ShippingCart payment. Wait for a few minutes, then check if your item/s are back in your Cart before attempting to check out again.'
	      ) : null,
	      !_utils.disabledCart && _react2.default.createElement(_Tour2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'main-content storage-content' },
	        !this.props.parcelInfo.getCartData ? null : this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.offsizeItems.length >= 0 ? _react2.default.createElement(
	          'div',
	          { className: 'storage-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'cart-header' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Hi ',
	              this.props.login.fetched ? this.props.login.login.party.first_name : null,
	              ', shipping something today?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'shipment-destination' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'FROM'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'source select-gradient' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'selected-method', value: origin, onChange: function onChange(e) {
	                      return _this6.handleShipmentLocations(e, "origin");
	                    } },
	                  this.props.customerInfo.warehouse.data && (0, _whiteListed.filterWarehouse)(this.props.customerInfo.warehouse.data, this.props.login.login.party).map(function (warehouse) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: warehouse.id },
	                      (0, _utils.maskCartWarehouseLabel)(warehouse, (0, _whiteListed.filterWarehouse)(_this6.props.customerInfo.warehouse.data, _this6.props.login.login.party).find(function (item) {
	                        return item.id === 6;
	                      }))
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'TO'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'destination select-gradient' },
	                _react2.default.createElement(
	                  'select',
	                  { className: 'selected-method', value: this.props.cart.shipment_location_details.destination, onChange: function onChange(e) {
	                      return _this6.handleShipmentLocations(e, "destination");
	                    } },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'PH' },
	                    'Philippines'
	                  ),
	                  origin !== 4 && origin !== 5 && window.location.pathname !== '/offsize' && _react2.default.createElement(
	                    'option',
	                    { value: 'MY' },
	                    'Malaysia'
	                  )
	                )
	              )
	            )
	          ),
	          this.props.cart.shipment_location_details.destination === "MY" && _react2.default.createElement(
	            'div',
	            { style: { "fontSize": "12px", "fontStyle": "italic" } },
	            '*Please note that only AIR cargo is available for shipments from ',
	            (0, _utils.maskWarehouseById)(origin),
	            ' to ',
	            this.props.cart.shipment_location_details.destination,
	            '.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'sc-warning', style: { padding: '10px 24px', height: 'auto', background: '#FEF6E7', borderRadius: '5px', border: 'none' } },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Off-size items must be shipped individually. Additional charges may be billed on top of your shipping fee depending on the item.'
	            ),
	            _react2.default.createElement(
	              'a',
	              { style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer', fontSize: '14px' }, href: 'https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-', target: '_blank', rel: 'noopener noreferrer' },
	              _react2.default.createElement('i', {
	                className: 'fa fa-info-circle',
	                style: { color: '#0375D9', fontSize: 13, marginRight: '5px' }
	              }),
	              'Learn more.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.parcelInfo.display_error_message || this.state.overpriced.length > 0 ? '' : 'disnone' },
	            _react2.default.createElement(
	              'div',
	              { ref: 'errors_credentials', className: 'sc-alert sc-alert-danger' },
	              _react2.default.createElement('i', { className: 'sc' }),
	              'The value of this item needs verification. Visit our Contact Us page for assistance.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.parcelInfo.less_than_zero_error_message ? '' : 'disnone', style: { marginTop: '5px' } },
	            _react2.default.createElement(
	              'div',
	              { ref: 'errors_credentials', className: 'sc-alert sc-alert-danger' },
	              _react2.default.createElement('i', { className: 'sc' }),
	              'You cannot declare an insured value below 1USD.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.parcelInfo.insured_value_nan_error_message ? '' : 'disnone' },
	            _react2.default.createElement(
	              'div',
	              { ref: 'errors_credentials', className: 'sc-alert sc-alert-danger' },
	              _react2.default.createElement('i', { className: 'sc' }),
	              'Insured value must be numbers only'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'partial messages clearfix' }),
	          this.props.parcelInfo.cart_fetching ? null : !this.props.parcelInfo.cart_fetching && parcel_details ? _react2.default.createElement(
	            _reactSticky.StickyContainer,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'form',
	                { className: 'pull-left cartable', id: 'ship-it', onSubmit: this.handleForm },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'item-list', id: 'stored-items' },
	                  _react2.default.createElement(
	                    'thead',
	                    { style: { backgroundColor: '#F1F1F1' } },
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Select Item/s'
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Insured value'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'fa fa-question-circle fa-fw' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip white package-value-tooltip', style: { width: 300, textAlign: 'left' } },
	                            _react2.default.createElement(
	                              'p',
	                              { style: { fontSize: '10px', margin: '3px 0px' } },
	                              'Declare the value of your items correctly to keep them secure.'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: { fontSize: '10px', margin: '3px 0px' } },
	                              'This helps us make sure you\u2019re fairly reimbursed, in case anything happens, such as damage during shipping or if something goes missing.'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: { fontSize: '10px', margin: '3px 0px' } },
	                              'Remember, our insurance covers up to $20,000 per shipment, with a limit of $10,000 for each item.'
	                            ),
	                            _react2.default.createElement(
	                              'a',
	                              { href: 'https://help-center.shippingcart.com/hc/en-us/articles/4907826208143-What-is-declared-value-and-why-is-it-important-', style: { fontSize: '10px', fontWeight: 600 }, target: '_blank', rel: 'noopener noreferrer' },
	                              'Importance of declaring proper insured value'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'Shipping method'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'fa fa-question-circle fa-fw' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip white' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Select your desired shipping mode. It takes 10 days via Air Cargo and 45 days via Sea Cargo.'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        null,
	                        'Details'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    parcel_details.map(function (parcel) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { id: parcel.id, key: parcel.id },
	                        _react2.default.createElement(
	                          'td',
	                          { className: _this6.state["chk_" + parcel.id] === parcel.id ? "item-name" : "item-name no-insurance" },
	                          (parcel.flags.vas_type !== 'PULL_OUT' || parcel.flags.vas_status !== 'COMPLETED') && _react2.default.createElement(
	                            'div',
	                            { className: 'checkbox',
	                              onMouseEnter: _this6.state["chk_" + parcel.id] === parcel.id ? null : _this6.handleInsuredHover.bind(_this6, parcel.id),
	                              onMouseLeave: _this6.state["chk_" + parcel.id] === parcel.id ? null : _this6.handleRemoveInsuredHover.bind(_this6, parcel.id) },
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state["chk_" + parcel.id] === parcel.id ? "disnone" : "tooltip white black" },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Please declare the insured value (in USD) of this package to properly valuate your goods.'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'radio' },
	                              _react2.default.createElement('input', {
	                                id: ["lbl" + parcel.id],
	                                'data-id': parcel.id,
	                                ref: ["checkbox" + parcel.id],
	                                onClick: _this6.handleClick.bind(_this6, parcel.id, parcel.warehouse_id, parcel.flags)
	                                // data-select="single"
	                                // data-item="154990"
	                                // data-do="item-select"
	                                // data-on="change"
	                                , type: 'radio',
	                                name: 'offsize_select'
	                                // className="css-checkbox"
	                                , disabled: !parcel.insured_value || parcel.flags.vas_request || parcel.flags.vas_type === 'PULL_OUT' && parcel.flags.vas_status === 'COMPLETED' ? "disabled" : ""
	                              }),
	                              _react2.default.createElement('label', { id: ["lbl" + parcel.id], htmlFor: ["lbl" + parcel.id] })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: _this6.state["chk_" + parcel.id] === parcel.id ? "disnone" : "tooltip insured-tooltip white" },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                'Please declare the insured value (in USD) of this package to properly valuate your goods.'
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'item-info' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'name' },
	                              _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: "/parcel/" + parcel.id },
	                                (0, _utils.ellipses)(customerType === 'social seller' ? parcel.description : parcel.tracking_number, 120)
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'date' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'cart-weight', style: { display: 'none' } },
	                                parcel.dimensions.weight.weight,
	                                ' ',
	                                parcel.dimensions.weight.uom
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: parseInt(parcel.storage.storage_days, 10) >= parseInt(parcel.storage.storage_max_days - parcel.storage.max_day_threshold, 10) && !parcel.flags.free_storage ? "aging-red" : "" },
	                                parcel.storage.storage_days > 1 ? parcel.storage.storage_days + " days" : parcel.storage.storage_days + " day",
	                                ' in storage'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: parseInt(parcel.storage.storage_days, 10) >= parseInt(parcel.storage.storage_max_days - parcel.storage.max_day_threshold, 10) ? "tooltip aging-date white" : "disnone" },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  parseInt(parcel.storage.storage_days, 10) < parseInt(parcel.storage.storage_max_days, 10) ? 'Your item is nearing its ' + parcel.storage.storage_max_days + '-day storage limit. Ship out now!' : 'This is your last day to ship this item. Ship out now!'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'item-icon', style: { textAlign: 'center' } },
	                            parcel.flags.vas_status === 'PENDING' || parcel.flags.vas_status === 'VAS_APPROVED' || parcel.flags.vas_status === 'PAID' ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa special-handling-icon fa-fw', style: { marginBottom: '3px' } },
	                              _react2.default.createElement('img', { src: _vas2.default, alt: 'VAS icon' }),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white' },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'This item has an active request.'
	                                )
	                              )
	                            ) : null,
	                            parcel.flags.is_abandoned === 1 ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa icon-hope fa-fw' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white', style: { top: '-70px' } },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'This is a Project Hope item.'
	                                )
	                              )
	                            ) : null,
	                            parcel.is_damaged ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa icon-damaged fa-fw', style: { height: '14px', top: '-3px' } },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white', style: { top: '-109px', height: 'auto' } },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'This package contains ',
	                                  _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'damaged items'
	                                  ),
	                                  ' which are excluded from SC Protect when you checkout.'
	                                )
	                              )
	                            ) : null,
	                            parcel.flags.off_size ? _react2.default.createElement(
	                              'div',
	                              { className: 'fa icon-offsize fa-fw', style: { height: '14px' } },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip special-handling-tooltip white', style: { top: '-70px' } },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  'This package is identified as off-size.'
	                                )
	                              )
	                            ) : null
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'insured' },
	                          'USD \xA0',
	                          _react2.default.createElement('input', { type: 'text', name: 'insured_value',
	                            id: parcel.id,
	                            className: 'insured-input',
	                            min: '0',
	                            ref: ["insured_value" + parcel.id]
	                            //defaultValue={parcel.insured_value}
	                            , value: _this6.state.checked_insured_value[parcel.id] || "",
	                            'data-lastvalue': parcel.insured_value,
	                            onChange: _this6.handleInputInsuredValue.bind(_this6, parcel.id),
	                            maxLength: '7'
	                          }),
	                          '\xA0'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'shipping-method' },
	                          parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea === 1 ? window.location.pathname === '/offsize' ? _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-disable', name: 'button', value: 'Sea cargo only', ref: ["shipment_method" + parcel.id] },
	                            'Sea cargo only'
	                          ) : _react2.default.createElement(
	                            'div',
	                            { className: 'select-gradient' },
	                            _react2.default.createElement(
	                              'select',
	                              { 'data-id': '154990', name: 'method[154990]', onChange: _this6.handleMethod.bind(_this6, parcel.id, parcel.warehouse_id), className: 'shipping-method selected-method', 'data-do': 'item-select', 'data-on': 'change', ref: ["shipment_method" + parcel.id] },
	                              _react2.default.createElement(
	                                'option',
	                                { value: 'air' },
	                                'Air Cargo'
	                              ),
	                              _react2.default.createElement(
	                                'option',
	                                { value: 'sea' },
	                                'Sea Cargo'
	                              )
	                            )
	                          ) : null,
	                          parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea !== 1 ? _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-disable', name: 'button', value: 'Air cargo only', ref: ["shipment_method" + parcel.id] },
	                            'Air cargo only'
	                          ) : null,
	                          parcel.flags.allowed_air !== 1 && parcel.flags.allowed_sea === 1 ? _react2.default.createElement(
	                            'button',
	                            { type: 'button', className: 'btn btn-disable', name: 'button', value: 'Sea cargo only', ref: ["shipment_method" + parcel.id] },
	                            'Sea cargo only'
	                          ) : null
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/parcel/" + parcel.id },
	                            'View'
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'hidden', name: 'csrf', value: '5ac6a0d3ea10c942d3e7d1c067cc54c5' }),
	                _react2.default.createElement('input', { type: 'hidden', name: 'customer_id', value: '10614' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'estimations-wrapper pull-right' },
	                _react2.default.createElement(
	                  _reactSticky.Sticky,
	                  { className: 'sticky' },
	                  function (_ref) {
	                    var style = _ref.style,
	                        isSticky = _ref.isSticky;
	
	                    return _react2.default.createElement(
	                      'header',
	                      { style: style },
	                      _react2.default.createElement(
	                        'form',
	                        { id: 'ship-it' },
	                        _react2.default.createElement('div', { className: 'arrow_right' }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'estimation-actions' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'header' },
	                            _react2.default.createElement('i', { className: _this6.state.id ? "fa fa-tags faa-shake animated fa-fw" : "fa fa-tags fa-fw" }),
	                            _react2.default.createElement(
	                              'i',
	                              { className: 'message' },
	                              'Shipment Cost'
	                            )
	                          ),
	                          _this6.props.customerCheckout.fetched && _this6.state.id && Object.keys(_this6.state.itemOrigin).length > 0 ?
	                          // this.props.customerCheckout.fetchItemComputation ? <i className="fa fa-spinner fa-spin" /> :
	
	                          _this6.props.customerCheckout.fetched && _this6.props.customerCheckout.checkout.data && _react2.default.createElement(
	                            'div',
	                            { style: { border: '1px solid #E2E2E2', width: '100%', borderRadius: '10px', backgroundColor: '#FFF' } },
	                            _this6.props.customerCheckout.checkout.data.hasOwnProperty("air") && _react2.default.createElement(_ComputationBreakdown2.default, { type: 'air', data: _this6.props.customerCheckout.checkout.data }),
	                            _this6.props.customerCheckout.checkout.data.hasOwnProperty("sea") && _react2.default.createElement(_ComputationBreakdown2.default, { type: 'sea', data: _this6.props.customerCheckout.checkout.data }),
	                            _react2.default.createElement(
	                              'div',
	                              { style: { borderTop: '1px solid #E2E2E2', width: '100%', padding: '20px 16px' } },
	                              _react2.default.createElement(
	                                'div',
	                                { style: { display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 600, color: '#323232', borderBottom: '1px solid #F1F1F1', marginBottom: '10px', paddingBottom: '10px' } },
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  'Storage Fee'
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  'USD ' + _this6.props.customerCheckout.checkout.data.summary.total_storage_charge
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { style: { display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 600, color: '#323232' } },
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { marginRight: 7, alignSelf: 'center' } },
	                                  _react2.default.createElement('img', {
	                                    src: 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg',
	                                    alt: 'sc-protect',
	                                    height: 18,
	                                    width: 18
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { fontStyle: 'italic', fontWeight: 400 } },
	                                  'SC Protect fee will be computed in the next step.'
	                                )
	                              ),
	                              !!_this6.props.customerCheckout.checkout.data.damage_items.total && _react2.default.createElement(_DamagedBanner2.default, {
	                                message: _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  _react2.default.createElement(
	                                    'span',
	                                    { style: { fontWeight: 600 } },
	                                    _this6.props.customerCheckout.checkout.data.damage_items.total,
	                                    ' out of',
	                                    ' ',
	                                    _this6.props.customerCheckout.checkout.data.summary.total_qty,
	                                    ' packages'
	                                  ),
	                                  ' ',
	                                  'contains',
	                                  ' ',
	                                  _react2.default.createElement(
	                                    'span',
	                                    {
	                                      style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer' },
	                                      onClick: function onClick() {
	                                        return _this6.setState({ damagedModalOpen: true });
	                                      }
	                                    },
	                                    'damaged item'
	                                  ),
	                                  ' ',
	                                  'which are excluded from SC Protect when you checkout.'
	                                ),
	                                bgColor: '#FFE9EB'
	                              })
	                            )
	                          ) : _react2.default.createElement(
	                            'div',
	                            { className: 'no-estimations' },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Input how much it\u2019s worth, select your preferred item/s, and choose the shipping method to get your shipment cost.'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'ship-it-btn wrapper' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-actions' },
	                          _this6.props.customerCheckout.checkout.data && _this6.props.customerCheckout.checkout.data.summary.total_price && _react2.default.createElement(
	                            'div',
	                            { style: { borderRadius: '10px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', padding: '20px 16px', textAlign: 'left', marginBottom: '10px' } },
	                            _react2.default.createElement(
	                              'div',
	                              { style: { fontSize: '16px', fontWeight: 600, marginBottom: '16px' } },
	                              'By proceeding,'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { style: { display: 'inline-flex' } },
	                              _react2.default.createElement(
	                                'div',
	                                { style: { padding: '0px 9px' } },
	                                _react2.default.createElement('input', {
	                                  id: 'cart-tnc',
	                                  name: 'cart-tnc',
	                                  type: 'checkbox',
	                                  ref: 'cart-tnc',
	                                  onClick: function onClick() {
	                                    return _this6.setState({ offsizeConsent: !_this6.state.offsizeConsent });
	                                  },
	                                  className: 'cart-tnc'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'cart-tnc', style: { fontWeight: 400 } },
	                                'I understand that off-size items may require special services such as facilitation and trucking to fulfill delivery of the shipment. I agree to settle additional charges that may be billed separately on top of the shipment cost.'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { style: { display: 'inline-flex', marginTop: '10px' } },
	                              _react2.default.createElement(
	                                'div',
	                                { style: { padding: '0px 9px' } },
	                                _react2.default.createElement('input', {
	                                  id: 'cart-tnc',
	                                  name: 'cart-tnc',
	                                  type: 'checkbox',
	                                  ref: 'cart-tnc',
	                                  onClick: function onClick() {
	                                    return _this6.setState({ cartConsent: !_this6.state.cartConsent });
	                                  },
	                                  className: 'cart-tnc'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'cart-tnc', style: { fontWeight: 400 } },
	                                'I confirm that the declared insured value of each item is correct. Any misdeclaration will be subject to ',
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: '/terms-conditions', style: { fontSize: '13px', fontWeight: 600 }, target: '_blank' },
	                                  'ShippingCart\'s terms and conditions'
	                                ),
	                                '.'
	                              )
	                            )
	                          ),
	                          _this6.props.customerCheckout.checkout.data && _this6.props.customerCheckout.checkout.data.summary.total_price ? _react2.default.createElement(
	                            'div',
	                            { style: { borderRadius: '10px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', padding: '20px 16px' } },
	                            _react2.default.createElement(
	                              'div',
	                              { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '20px', fontSize: '20px', fontWeight: 600 } },
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                'Shipment Cost'
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                'USD ',
	                                _this6.props.customerCheckout.checkout.data && _this6.props.customerCheckout.checkout.data.summary.total_price
	                              )
	                            ),
	                            _react2.default.createElement('input', { id: 'submitCart', className: 'proceedToCheckoutButton', type: 'submit', onClick: _this6.handleCheckout, value: 'Proceed to payment', disabled: !_this6.props.customerCheckout.fetchItemComputation && (_this6.state.chkItemArray.sea.length !== 0 || _this6.state.chkItemArray.air.length !== 0) && _this6.state.overpriced.length === 0 && !_this6.props.parcelInfo.parcel_updating && _this6.state.cartConsent && _this6.state.offsizeConsent ? "" : "disabled" })
	                          ) : _react2.default.createElement('input', { id: 'submitCart', type: 'submit', onClick: _this6.handleCheckout, className: _this6.state.chkItemArray.sea.length !== 0 || _this6.state.chkItemArray.air.length !== 0 ? "btn ship-it" : "btn active ", value: 'Proceed to payment', disabled: !_this6.props.customerCheckout.fetchItemComputation && (_this6.state.chkItemArray.sea.length !== 0 || _this6.state.chkItemArray.air.length !== 0) && _this6.state.overpriced.length === 0 && _this6.state.cartConsent && _this6.state.offsizeConsent ? "" : "disabled" }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'details' },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'You can still review your orders before payment.'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              ' We group your items according to shipping method'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              ' (air or sea) and deliver them to your doorstep.'
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }
	                )
	              )
	            )
	          ) : null
	        ) : !this.props.parcelInfo.cart_fetching && this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.offsizeItems.length <= 0 ? _react2.default.createElement(
	          'div',
	          { className: 'storage-wrapper' },
	          _react2.default.createElement('div', { className: 'header' }),
	          _react2.default.createElement('div', { className: 'partial messages clearfix' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'estimations-wrapper storage-empty' },
	            _react2.default.createElement(
	              'div',
	              { className: 'notify' },
	              _react2.default.createElement(
	                'div',
	                { className: 'notify-header' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement('span', { className: 'icon' }),
	                  'Your cart storage is empty.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'notify-content' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Did you ship something to your ShippingCart address?'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We\'ll let you know as soon as we\'ve accepted your package and immediately queue it for processing.',
	                  _react2.default.createElement('br', null),
	                  ' Processing involves weighing, photographing any documentation from your seller that includes list of what\'s in your package, and encoding into our system before it can be viewed in your cart.'
	                )
	              )
	            )
	          )
	        ) : null
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { className: 'alert-modal-checkout', show: this.state.alertModal, onHide: function onHide() {
	            return _this6.setState({ alertModal: false });
	          }, autoFocus: true },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            'p',
	            { style: { fontSize: '20px', fontWeight: 600 } },
	            'Important Notice'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Off-size items may require special services such as trucking to fulfill delivery of the shipment.',
	            _react2.default.createElement('br', null),
	            ' By proceeding, you agree to settle any additional charges that may be billed separately on top of the shipment cost.'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Footer,
	          { style: { "textAlign": "center", display: 'flex', flexDirection: 'column', alignItems: 'center' } },
	          _react2.default.createElement(
	            'button',
	            { className: 'alert-modal-btn btn', style: { width: '100%', backgroundColor: '#FEAB10', borderRadius: '5px', marginBottom: '5px', fontSize: '16px', fontWeight: 600 }, onClick: this.handleCheckout },
	            'AGREE'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'alert-modal-btn btn', style: { width: '100%', backgroundColor: '#FFF', color: '#707070', fontSize: '16px', fontWeight: 600 }, onClick: function onClick() {
	                return _this6.setState({ alertModal: false });
	              } },
	            'CANCEL'
	          )
	        )
	      ),
	      _react2.default.createElement(_DamagedModal2.default, {
	        isOpen: this.state.damagedModalOpen,
	        handleClose: function handleClose() {
	          return _this6.setState({ damagedModalOpen: false });
	        },
	        damageItems: this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.damage_items
	      })
	    );
	  }
	});
	
	exports.default = OffsizeItemsDashboard;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(126);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(58);
	
	var _reactRedux = __webpack_require__(46);
	
	var _ParcelAction = __webpack_require__(72);
	
	var ParcelAction = _interopRequireWildcard(_ParcelAction);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactLinesEllipsis = __webpack_require__(1108);
	
	var _reactLinesEllipsis2 = _interopRequireDefault(_reactLinesEllipsis);
	
	var _utils = __webpack_require__(13);
	
	var _reactImageMagnify = __webpack_require__(1105);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(835);
	
	var _Tutorial = __webpack_require__(158);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _vas = __webpack_require__(187);
	
	var _vas2 = _interopRequireDefault(_vas);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	//import DownloadLink from 'react-download-link';
	//import ImageDownloader from '../../../node_modules/react-native-imagedownloader/ImageDownLoader';
	
	
	var createReactClass = __webpack_require__(16);
	var Parcel = createReactClass({
	  displayName: 'Parcel',
	
	
	  getInitialState: function getInitialState() {
	
	    return {
	      showModalImage: false,
	      image: null,
	      imageList: null,
	      showModalDamage: false,
	      upcItemNote: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.getParcelById(this.props.params.id);
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	    (0, _jquery2.default)('.cart').addClass('active');
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.params.id !== this.props.params.id) {
	      this.props.getParcelById(this.props.params.id);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({ image: nextProps.parcelInfo.fetched ? nextProps.parcelInfo.parcel.data.images[0] : null });
	    if (nextProps.parcelInfo.parcel && nextProps.parcelInfo.parcel.data) {
	      var data = nextProps.parcelInfo.parcel.data.images;
	      this.setState({ imageList: data });
	    }
	    (0, _jquery2.default)('#SCTitle').text(nextProps.params.id + " | ShippingCart");
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2.default)('.cart').removeClass('active');
	  },
	  showModal: function showModal(name, text) {
	    var _setState;
	
	    this.setState((_setState = {}, _defineProperty(_setState, name, true), _defineProperty(_setState, 'upcItemNote', text), _setState));
	  },
	  close: function close(name) {
	    var _setState2;
	
	    this.setState((_setState2 = {}, _defineProperty(_setState2, name, false), _defineProperty(_setState2, 'upcItemNote', null), _setState2));
	  },
	  handleImage: function handleImage(item) {
	    // const image = this.state.imageList ? this.state.imageList[id] : this.props.parcelInfo.parcel.data.images[id]
	    this.setState({ image: item });
	  },
	  handleDate: function handleDate(date) {
	
	    if (date) {
	      var sliced_date = date.slice(0, 10);
	      var split_date = sliced_date.split("-");
	      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4);
	
	      return new_date;
	    } else {
	      return null;
	    }
	  },
	  download: function download(imageLink) {
	    return fetch(imageLink + '?image', {
	      method: "GET",
	      headers: {}
	    }).then(function (response) {
	      response.arrayBuffer().then(function (buffer) {
	        var url = window.URL.createObjectURL(new Blob([buffer]));
	        var link = document.createElement("a");
	        link.href = url;
	        link.setAttribute("download", imageLink.slice((imageLink.lastIndexOf("/") - 1 >>> 0) + 2)); //or any other extension
	        document.body.appendChild(link);
	        link.click();
	      });
	    }).catch(function (err) {
	      console.log(err);
	    });
	  },
	  render: function render() {
	    var _this = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Tutorial2.default, { type: 'item_tutorial', accountDetails: this.props.login.login && this.props.login.login.party }),
	      this.props.parcelInfo.error && this.props.parcelInfo.error.response ? this.props.parcelInfo.error.response.data.errors.detail === "Parcel does not exist." ? _react2.default.createElement(
	        'div',
	        { className: 'sc-alert sc-alert-danger2' },
	        _react2.default.createElement('i', { className: 'sc' }),
	        'Oops! This item is no longer in your cart.'
	      ) : null : null,
	      this.props.parcelInfo.fetching ? null : this.props.parcelInfo.fetched ? _react2.default.createElement(
	        'div',
	        { className: 'body-wrapper' },
	        _react2.default.createElement(
	          'section',
	          { className: 'customer item storage-item-detail' },
	          _react2.default.createElement(
	            'div',
	            { className: 'customer-wrapper clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'main', role: 'main' },
	              _react2.default.createElement(
	                'div',
	                { className: 'main-content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'back' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '<'
	                  ),
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/cart' },
	                    'Back'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item-wrapper' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'item-name' },
	                    this.props.parcelInfo.parcel.data.tracking_number,
	                    (this.props.parcelInfo.parcel.data.flags.vas_status === 'PENDING' || this.props.parcelInfo.parcel.data.flags.vas_status === 'VAS_APPROVED') && _react2.default.createElement(
	                      'div',
	                      { className: 'fa special-handling-icon fa-fw', style: {
	                          marginLeft: '10px'
	                        } },
	                      _react2.default.createElement('img', { src: _vas2.default, alt: 'VAS icon' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip special-handling-tooltip white' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'This item has an active request.'
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item-detail-wrapper clearfix' },
	                  Number(this.props.parcelInfo.parcel.data.flags.special_handling) === 1 && !this.props.parcelInfo.parcel.data.flags.off_size && _react2.default.createElement(
	                    'div',
	                    { className: 'parcel-special-handling-wrapper' },
	                    _react2.default.createElement('span', { className: 'parcel-special-handling-icon fa special-handling-icon fa-fw' }),
	                    _react2.default.createElement(
	                      'p',
	                      { style: { margin: '0px', width: '100%' } },
	                      'This package requires special handling.'
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/special-handling', target: '_blank' },
	                      _react2.default.createElement('i', { className: 'fa fa-angle-right fa-lg icon-angle-right', style: { float: 'right', color: '#0375D9' }, 'aria-hidden': 'true' }),
	                      ' '
	                    )
	                  ),
	                  Number(this.props.parcelInfo.parcel.data.flags.off_size) === 1 && _react2.default.createElement(
	                    'div',
	                    { className: 'parcel-special-handling-wrapper' },
	                    _react2.default.createElement('span', { className: 'parcel-special-handling-icon fa icon-offsize fa-fw' }),
	                    _react2.default.createElement(
	                      'p',
	                      { style: { margin: '0px', width: '100%' } },
	                      'This package is identified as off-size.'
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-', target: '_blank', rel: 'noopener noreferrer' },
	                      _react2.default.createElement('i', { className: 'fa fa-angle-right fa-lg icon-angle-right', style: { float: 'right', color: '#0375D9' }, 'aria-hidden': 'true' }),
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'thumbnails' },
	                    this.state.imageList ? this.state.imageList.map(function (item, i) {
	                      return _react2.default.createElement(
	                        'li',
	                        { className: 'active', key: i },
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'select-image',
	                            'data-do': 'select-item-image', 'data-on': 'click', onClick: function onClick() {
	                              return _this.handleImage(item);
	                            } },
	                          _react2.default.createElement('img', { src: item.image ? item.image : item, alt: '' })
	                        )
	                      );
	                    }) : null
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'item-content' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'data-do': 'image-modal', className: 'item-content-wrapper clearfix' },
	                      _react2.default.createElement(
	                        'figure',
	                        { className: 'active-item-image' },
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'zoomImage', onClick: function onClick() {
	                              return _this.showModal("showModalImage");
	                            } },
	                          this.state.image ? _react2.default.createElement(_reactImageMagnify.ReactImageMagnify, {
	                            largeImage: {
	                              alt: '',
	                              src: this.state.image,
	                              width: 700,
	                              height: 850
	                            },
	                            smallImage: {
	                              alt: '',
	                              src: this.state.image,
	                              isFluidWidth: true
	                            },
	                            enlargedImageContainerClassName: "parcel-zoom-container",
	                            lensStyle: {
	                              backgroundColor: "rgba(0, 0, 0, 0.2)"
	                            }
	                          }) : null
	                        ),
	                        _react2.default.createElement(
	                          _reactBootstrap.Modal,
	                          { show: this.state.showModalImage, onHide: function onHide() {
	                              return _this.close("showModalImage");
	                            }, autoFocus: true },
	                          _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	                          _react2.default.createElement(
	                            _reactBootstrap.Modal.Body,
	                            null,
	                            _react2.default.createElement('img', { className: 'imgwd100', src: this.state.image, alt: '' })
	                          ),
	                          _react2.default.createElement(_reactBootstrap.Modal.Footer, null)
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'item-name', style: { display: 'flex', justifyContent: 'space-between', margin: '5px' } },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            this.props.parcelInfo.parcel.data.description
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                  while (1) {
	                                    switch (_context.prev = _context.next) {
	                                      case 0:
	                                        _context.next = 2;
	                                        return _this.download(_this.state.image && (_this.state.image.image || _this.state.image));
	
	                                      case 2:
	                                        return _context.abrupt('return', _context.sent);
	
	                                      case 3:
	                                      case 'end':
	                                        return _context.stop();
	                                    }
	                                  }
	                                }, _callee, _this);
	                              })), className: 'download-image', style: { width: '50%', textAlign: 'right', cursor: 'pointer', color: 'blue' } },
	                            'Download Image'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'upc-wrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'upc-title' },
	                            'Item Description'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'upc-item-wrapper' },
	                            this.props.parcelInfo.parcel.data && this.props.parcelInfo.parcel.data.upc_items.length > 0 ? this.props.parcelInfo.parcel.data.upc_items.map(function (item) {
	                              return _react2.default.createElement(
	                                'div',
	                                { className: 'upc-item-content' },
	                                item.is_damaged ? _react2.default.createElement(
	                                  'div',
	                                  { style: { padding: '5px 0px 0px' } },
	                                  _react2.default.createElement('i', { className: 'fa icon-damaged fa-fw', onClick: function onClick() {
	                                      return _this.showModal("showModalDamage", item.notes);
	                                    } })
	                                ) : _react2.default.createElement('span', { style: { marginLeft: '20px' } }),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'upc-items' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'upc-item-quantity' },
	                                    'x' + item.no_of_items
	                                  ),
	                                  _react2.default.createElement(_reactLinesEllipsis2.default, {
	                                    text: item.description,
	                                    maxLine: '2',
	                                    ellipsis: ' ...',
	                                    trimRight: true,
	                                    basedOn: 'letters'
	                                  })
	                                )
	                              );
	                            }) : _react2.default.createElement(
	                              'div',
	                              { className: 'upc-item-content' },
	                              _react2.default.createElement('span', { style: { marginLeft: '20px' } }),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'upc-items' },
	                                _react2.default.createElement(_reactLinesEllipsis2.default, {
	                                  text: this.props.parcelInfo.parcel.data.description,
	                                  maxLine: '2',
	                                  ellipsis: ' ...',
	                                  trimRight: true,
	                                  basedOn: 'letters'
	                                })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactBootstrap.Modal,
	                        {
	                          onHide: function onHide() {
	                            return _this.close("showModalDamage");
	                          },
	                          show: this.state.showModalDamage,
	                          autoFocus: true
	                        },
	                        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	                        _react2.default.createElement(
	                          _reactBootstrap.Modal.Body,
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', backgroundColor: '#FEF6E7', border: '1px solid #FEAB10', padding: '10px', marginBottom: '20px', borderRadius: '4px' } },
	                            _react2.default.createElement(
	                              'div',
	                              { style: { alignSelf: 'center', marginRight: '8px' } },
	                              _react2.default.createElement('i', { className: 'fa icon-damaged fa-fw', style: { backgroundSize: 'contain' } })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              'This package contains damaged items which are excluded from SC Protect when you checkout.'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: '16px', fontWeight: 600, marginBottom: '6px' } },
	                            'Note from the warehouse'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', alignItems: 'center' } },
	                            this.state.upcItemNote ? this.state.upcItemNote : 'The item received damaged.'
	                          )
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Modal.Footer, null)
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'details' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'item-list-details' },
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'From:'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                (0, _utils.maskLocationName)(this.props.parcelInfo.parcel.data.warehouse_country) + " Warehouse"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Date Added',
	                                _react2.default.createElement('br', null),
	                                ' in storage:'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                this.handleDate(this.props.parcelInfo.parcel.data.updated_at_warehouse)
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Shop:'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                this.props.parcelInfo.parcel.data.origin
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'From ',
	                                this.props.parcelInfo.parcel.data.courier,
	                                '#:'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                this.props.parcelInfo.parcel.data.tracking_number
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Dimensions:'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                this.props.parcelInfo.parcel.data.dimensions.volume.length,
	                                ' x ',
	                                this.props.parcelInfo.parcel.data.dimensions.volume.width,
	                                ' x ',
	                                this.props.parcelInfo.parcel.data.dimensions.volume.height,
	                                ' ',
	                                this.props.parcelInfo.parcel.data.dimensions.volume.uom === "in" ? "inch" : this.props.parcelInfo.parcel.data.dimensions.volume.uom
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Actual Weight:'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                this.props.parcelInfo.parcel.data.dimensions.weight.weight,
	                                ' ',
	                                this.props.parcelInfo.parcel.data.dimensions.weight.uom === "lb" ? "lbs" : this.props.parcelInfo.parcel.data.dimensions.weight.uom
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                'Chargeable',
	                                _react2.default.createElement('br', null),
	                                ' Weight:'
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                this.props.parcelInfo.parcel.data.storage.chargeable_weight,
	                                ' ',
	                                this.props.parcelInfo.parcel.data.dimensions.weight.uom === "lb" ? "lbs" : this.props.parcelInfo.parcel.data.dimensions.weight.uom
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'storage-meter' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'storage-meter-header clearfix' },
	                            _react2.default.createElement(
	                              'h3',
	                              { className: 'title' },
	                              'Cart Storage Meter'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'storage-status' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'status-label' },
	                                'Total Fee'
	                              ),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'status' },
	                                this.props.parcelInfo.parcel.data.storage.excess_charge === "0.00" ? "FREE" : "USD " + (0, _utils.numbersWithComma)(this.props.parcelInfo.parcel.data.storage.excess_charge.toFixed(2))
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(
	                              'strong',
	                              { className: 'countdown' },
	                              this.props.parcelInfo.parcel.data.storage.total_days,
	                              ' days in your Storage'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'storage-progress' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'progress' },
	                                parseInt(this.props.parcelInfo.parcel.data.storage.total_days, 10) === 0 ? _react2.default.createElement('div', { className: 'progress hide' }) : parseInt(this.props.parcelInfo.parcel.data.storage.total_days, 10) < parseInt(this.props.parcelInfo.parcel.data.storage.max_days, 10) - parseInt(this.props.parcelInfo.parcel.data.storage.max_day_threshold, 10) || this.props.parcelInfo.parcel.data.flags.free_storage ? _react2.default.createElement('div', { className: 'progress-bar free-phase', style: { width: this.props.parcelInfo.parcel.data.storage.total_days / this.props.parcelInfo.parcel.data.storage.max_days * 100 + 5 + "%" } }) : null,
	                                parseInt(this.props.parcelInfo.parcel.data.storage.total_days, 10) >= parseInt(this.props.parcelInfo.parcel.data.storage.max_days, 10) - parseInt(this.props.parcelInfo.parcel.data.storage.max_day_threshold, 10) && parseInt(this.props.parcelInfo.parcel.data.storage.total_days, 10) < parseInt(this.props.parcelInfo.parcel.data.storage.max_days, 10) && !this.props.parcelInfo.parcel.data.flags.free_storage ? _react2.default.createElement('div', { className: 'progress-bar first-phase', style: { width: this.props.parcelInfo.parcel.data.storage.total_days / this.props.parcelInfo.parcel.data.storage.max_days * 100 + 3 + "%" } }) : null,
	                                parseInt(this.props.parcelInfo.parcel.data.storage.total_days, 10) >= this.props.parcelInfo.parcel.data.storage.max_days && !this.props.parcelInfo.parcel.data.flags.free_storage ? _react2.default.createElement('div', { className: 'progress-bar last-phase', style: { width: this.props.parcelInfo.parcel.data.storage.total_days / this.props.parcelInfo.parcel.data.storage.max_days * 100 + "%" } }) : null
	                              ),
	                              _react2.default.createElement(
	                                'ul',
	                                { className: 'number-of-days' },
	                                _react2.default.createElement(
	                                  'li',
	                                  null,
	                                  'Day 1'
	                                ),
	                                _react2.default.createElement('li', { className: 'current-day',
	                                  style: { left: this.props.parcelInfo.parcel.data.storage.days_free / this.props.parcelInfo.parcel.data.storage.max_days * 100 + "%" } }),
	                                _react2.default.createElement(
	                                  'li',
	                                  { className: 'day90' },
	                                  'Day ',
	                                  this.props.parcelInfo.parcel.data.storage.max_days
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'about-storage' },
	                              'The ',
	                              this.props.parcelInfo.parcel.data.storage.days_free,
	                              '-day free storage starts when your package has been processed and posted to your cart. All packages over ',
	                              this.props.parcelInfo.parcel.data.storage.max_days,
	                              ' days will be removed from your cart and disposed of at our discretion according to ',
	                              _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/terms-conditions' },
	                                'Section 5-d'
	                              ),
	                              ' of the Terms and Conditions. Please ship out your packages within the ',
	                              this.props.parcelInfo.parcel.data.storage.max_days,
	                              '-day period to avoid any inconvenience.'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    this.props.parcelInfo.parcel.data.note ? _react2.default.createElement(
	                      'div',
	                      { className: 'note-from-warehouse' },
	                      _react2.default.createElement(
	                        'h4',
	                        { className: 'note-label' },
	                        'Note from the Warehouse'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'message-wrapper' },
	                        _react2.default.createElement('div', { className: 'arrow-box' }),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'message' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'open-quote' },
	                            '\u201C'
	                          ),
	                          ' ',
	                          this.props.parcelInfo.parcel.data.note,
	                          ' ',
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'close-quote' },
	                            '\u201D'
	                          )
	                        )
	                      )
	                    ) : null
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'shadow' })
	          )
	        )
	      ) : null
	    );
	  }
	});
	
	function mapStateToProps(state) {
	  return {
	    parcel: state.parcel
	  };
	}
	
	function mapDispachToProps(dispatch) {
	  return (0, _redux.bindActionCreators)(Object.assign({}, ParcelAction), dispatch);
	}
	(0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(Parcel);
	
	exports.default = Parcel;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(836);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var ProhibitedItemsDashboard = createReactClass({
	  displayName: 'ProhibitedItemsDashboard',
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    (0, _jquery2.default)('#SCTitle').text("Prohibited | ShippingCart");
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	  },
	  handleProhibited: function handleProhibited(e) {
	    e.preventDefault();
	    window.FreshWidget.show();
	  },
	  handleDate: function handleDate(date) {
	    if (date) {
	      var sliced_date = date.slice(0, 10);
	      var split_date = sliced_date.split("-");
	      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4);
	
	      return new_date;
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var fName = this.props.login.login ? this.props.login.login.party.first_name : "";
	    var lName = this.props.login.login ? this.props.login.login.party.last_name : "";
	    var accountNumber = this.props.login.login ? this.props.login.login.party.account_number : "";
	    var new_line = escape("\n");
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'main-content prohibited-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'prohibited-wrapper not-eligible' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'You have items not eligible for international shipping'
	            )
	          ),
	          _react2.default.createElement(
	            'table',
	            { className: 'prohibited-list', id: 'prohibited-items' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Item/s'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Courier'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Action'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              this.props.parcelInfo.parcel_fetching ? null : !this.props.parcelInfo.parcel_fetching && this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.map(function (item, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'item-info' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'name' },
	                      item.description
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'date' },
	                      'DATE STORED: ',
	                      _this.handleDate(item.updated_at_warehouse)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'courier-info' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'courier-name' },
	                      item.courier
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'item-tracking' },
	                      'Tracking # ',
	                      item.tracking_number
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'contact' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'customer-label' },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-orange', href: 'mailto:customercare@shippingcart.com?subject=[Prohibited Item] ' + fName + ' ' + lName + ' / ' + item.tracking_number + '&body=Customer Name: ' + fName + ' ' + lName + new_line + 'Account Number: ' + accountNumber + new_line + 'Courier Tracking: ' + item.tracking_number + new_line + 'Received Date: ' + _this.handleDate(item.created_at) + new_line + 'Prohibited Item Name: ' + item.description },
	                        'Contact Customer Care for return'
	                      )
	                    )
	                  )
	                );
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'note' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Note that as the buyer, you will need to shoulder any fees and taxes incurred by the return of your item/s. We recommend you take action immediately as storage fees will apply after 30 days of receipt.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'modal_tracking', className: 'modal tracking' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-dialog' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'modal-header clearfix' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'modal-title' },
	                  'Current Activity:'
	                ),
	                _react2.default.createElement('p', { className: 'activity' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                _react2.default.createElement('div', { className: 'shipment-status' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tracking #: ',
	                  _react2.default.createElement('span', { className: 'modal-tracking-num' })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'hidden csrf' },
	                  '616b9bd66380e926bc97d3c5895f3d5a'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'shipment-wrap' })
	          ),
	          _react2.default.createElement('div', { className: 'loader-overlay' })
	        )
	      ),
	      _react2.default.createElement(
	        'script',
	        { id: 'tntLazyInfo', type: 'text/html' },
	        _react2.default.createElement(
	          'div',
	          { className: 'track-and-trace' },
	          _react2.default.createElement(
	            'div',
	            { className: 'top-label' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Latest Update:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'update-date' },
	            '[[date]]'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'update-details' },
	            '[[details]]'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'script',
	        { id: 'tntLazyLoader', type: 'text/html' },
	        _react2.default.createElement(
	          'div',
	          { className: 'track-and-trace' },
	          _react2.default.createElement(
	            'div',
	            { className: 'top-label' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Latest Update:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'loader' },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'sr-only' },
	              'Loading...'
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = ProhibitedItemsDashboard;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(33);
	
	var _dateFns = __webpack_require__(54);
	
	var _store = __webpack_require__(20);
	
	__webpack_require__(839);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(13);
	
	var _uuid = __webpack_require__(70);
	
	var _AdvisoryModal = __webpack_require__(120);
	
	var _AdvisoryModal2 = _interopRequireDefault(_AdvisoryModal);
	
	var _Tour = __webpack_require__(157);
	
	var _Tour2 = _interopRequireDefault(_Tour);
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _OutBoundBanner = __webpack_require__(92);
	
	var _OutBoundBanner2 = _interopRequireDefault(_OutBoundBanner);
	
	var _DamagedBanner = __webpack_require__(91);
	
	var _DamagedBanner2 = _interopRequireDefault(_DamagedBanner);
	
	var _DamagedModal = __webpack_require__(121);
	
	var _DamagedModal2 = _interopRequireDefault(_DamagedModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// import AlertAdvisory from '../AlertAdvisory';
	
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	var createReactClass = __webpack_require__(16);
	var Shipment = createReactClass({
	  displayName: 'Shipment',
	  getInitialState: function getInitialState() {
	    return {
	      activePage: 1,
	      per_page: 10,
	      status: "",
	      range: "",
	      value: "3months",
	      showModalImage: false,
	      collapsedTrackDetails: [],
	      showModal: false,
	      body: "<div></div>",
	      image: null,
	      zoomIndex: 0,
	      zoomDirection: null,
	      tabID: "All",
	      settings: false,
	      isDownloading: false,
	      damagedModalOpen: false,
	      damagedItemsList: null
	    };
	  },
	  close1: function close1() {
	    this.setState({ showModal: false, showModalSplit: false });
	  },
	  open: function open(tracking_number, e) {
	    e.preventDefault();
	    this.setState({ showModal: true });
	    this.props.getOrderDetails(tracking_number);
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->        
	
	    _utils.disabledCart && this.props.getModalBlocks('cart');
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.login.error) {
	      if (this.props.login.error.response.data.status === 401) {
	        _store.history.push("/signin");
	      }
	    }
	
	    var hash = this.props.location.hash.replace('#', '');
	    if (hash) {
	      var node = _reactDom2.default.findDOMNode(this.refs[hash]);
	      if (node) {
	        node.scrollIntoView({
	          block: 'center',
	          behavior: 'smooth',
	          inline: 'center'
	        });
	      }
	    }
	
	    // if (prevProps.login.login.status !== this.props.login.login.status) {
	    //   const email = this.props.login.login.party.email;
	    //   this.setState({email},() => this.netcoreScript(this.state.email));
	    // }
	  },
	  componentWillMount: function componentWillMount() {
	    var page = this.state.activePage;
	    var per_page = this.state.per_page;
	    var status = this.state.status;
	
	    this.props.getShipment(localStorage.jwtToken, page, per_page, status, this.state.value);
	    var token = localStorage.jwtToken;
	    this.props.signedIn(token);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
	    this.setState({ body: nextProps.shipmentInfo.fetched_order ? nextProps.shipmentInfo.order.data.charge.remarks : null });
	    document.title = "Shipments | ShippingCart";
	
	    if (!nextState.settings && nextProps.shipmentInfo.shipment !== this.props.shipmentInfo.shipment) {
	      if (nextProps.shipmentInfo.shipment && nextProps.shipmentInfo.shipment.data) {
	        var shipmentCountryCode = nextProps.shipmentInfo.shipment.data[0].pickup_address.country.code === 'US' ? 'OR' : nextProps.shipmentInfo.shipment.data[0].pickup_address.country.code;
	        var shipmentWarehouseId = (0, _utils.maskOriginID)(shipmentCountryCode);
	        this.props.getGlobalSettings(shipmentWarehouseId);
	      }
	    }
	    if (nextProps.settings.globalSettings !== this.props.settings.globalSettings) {
	      var data = nextProps.settings.globalSettings.data;
	
	      var settings = data.map(function (item) {
	        return item;
	      });
	      this.setState({ settings: settings });
	    }
	  },
	  closeCollapse: function closeCollapse() {
	    window.$('.collapse').collapse('hide');
	  },
	  handleSelect: function handleSelect(eventKey) {
	    this.setState({
	      activePage: eventKey
	    });
	
	    var per_page = this.state.per_page;
	    var status = this.state.status;
	
	    this.closeCollapse();
	    this.props.getShipment(localStorage.jwtToken, eventKey, per_page, status, this.state.value);
	    window.scrollTo(0, 0);
	  },
	  handleStatusDisplay: function handleStatusDisplay(status) {
	    var _this = this;
	
	    this.closeCollapse();
	    switch (status) {
	      case "all":
	        this.setState({ status: "",
	          activePage: 1,
	          tabID: "All" }, function () {
	          return _this.props.getShipment(localStorage.jwtToken, _this.state.activePage, _this.state.per_page, _this.state.status, _this.state.value);
	        });
	        break;
	      case "pending":
	        this.setState({ status: "pending",
	          activePage: 1,
	          tabID: "PendingPayment" }, function () {
	          return _this.props.getShipment(localStorage.jwtToken, _this.state.activePage, _this.state.per_page, _this.state.status, _this.state.value);
	        });
	        break;
	      case "preparing":
	        this.setState({ status: "confirmed,consolidated,for_pickup,for_consolidation",
	          activePage: 1,
	          tabID: "PreparingShipment" }, function () {
	          return _this.props.getShipment(localStorage.jwtToken, _this.state.activePage, _this.state.per_page, _this.state.status, _this.state.value);
	        });
	        break;
	      case "inTransit":
	        this.setState({ status: "failed_pickup,in_transit,out_for_delivery,failed_delivery,return_in_transit,returned,failed_return,for_acceptance,accepted,for_transfer,out_for_return,for_dropoff,dropped_off,received_at_delivery_hub,received_at_delivery_area,at_sorting_center,dws_update",
	          activePage: 1,
	          tabID: "InTransit" }, function () {
	          return _this.props.getShipment(localStorage.jwtToken, _this.state.activePage, _this.state.per_page, _this.state.status, _this.state.value);
	        });
	        break;
	      case "delivered":
	        this.setState({ status: "claimed,delivered,picked_up",
	          activePage: 1,
	          tabID: "Delivered" }, function () {
	          return _this.props.getShipment(localStorage.jwtToken, _this.state.activePage, _this.state.per_page, _this.state.status, _this.state.value);
	        });
	        break;
	      default:
	    }
	  },
	  change: function change(event) {
	    //change SPAN OF TIME (60 days, 2016,2017, etc)
	    this.setState({ value: event.target.value, activePage: 1 }, function () {
	      this.props.getShipment(localStorage.jwtToken, this.state.activePage, this.state.per_page, this.state.status, this.state.value);
	    });
	  },
	  formatDateWithTime: function formatDateWithTime(arr) {
	    if (arr) {
	      arr = arr.split(" ");
	      arr = arr[0];
	      arr = arr.split("-");
	      var res = [arr[1], arr[2], arr[0]];
	
	      return res.join("/");
	    }
	    return arr;
	  },
	  handleStatuses: function handleStatuses(shipment_status, type, payment_status) {
	    var str = shipment_status === "canceled" && payment_status === "rejected" ? payment_status : shipment_status;
	
	    if (str) {
	      if (type === "class") {
	        switch (str) {
	          case "confirmed":
	          case "for_pickup":
	          case "consolidated":
	          case "for_consolidation":
	            return "paid";
	          case "failed_pickup":
	          case "in_transit":
	          case "out_for_delivery":
	          case "failed_delivery":
	          case "return_in_transit":
	          case "returned":
	          case "failed_return":
	          case "for_acceptance":
	          case "accepted":
	          case "received_at_pickup_hub":
	          case "received_at_delivery_hub":
	          case "for_return":
	          case "received_at_delivery_area":
	          case "at_sorting_center":
	          case "in_transit_to_delivery_area":
	          case "transferred_to_partner":
	          case "for_transfer":
	          case "out_for_return":
	          case "for_dropoff":
	          case "dropped_off":
	          case "dws_update":
	            return "transit";
	          case "canceled":
	          case "rejected":
	            return "cancelled";
	          case "delivered":
	          case "claimed":
	          case "picked_up":
	            return "delivered";
	          default:
	            return str.replace("_", "-");
	        }
	      } else if (type === "text") {
	        switch (str) {
	          case "confirmed":
	          case "for_pickup":
	          case "consolidated":
	          case "for_consolidation":
	            return "PREPARING FOR SHIPMENT";
	          case "failed_pickup":
	          case "in_transit":
	          case "out_for_delivery":
	          case "failed_delivery":
	          case "return_in_transit":
	          case "returned":
	          case "failed_return":
	          case "for_acceptance":
	          case "accepted":
	          case "received_at_pickup_hub":
	          case "received_at_delivery_hub":
	          case "for_return":
	          case "received_at_delivery_area":
	          case "at_sorting_center":
	          case "in_transit_to_delivery_area":
	          case "transferred_to_partner":
	          case "for_transfer":
	          case "out_for_return":
	          case "for_dropoff":
	          case "dropped_off":
	          case "dws_update":
	            return "ON ITS WAY";
	          case "canceled":
	            return "CANCELLED";
	          case "delivered":
	          case "claimed":
	          case "picked_up":
	            return "DELIVERED";
	          default:
	            return str.replace("_", " ").toUpperCase();
	        }
	      }
	    }
	    return str;
	  },
	  handleImage: function handleImage(image) {
	    var image1 = [];
	    image.filter(function (item) {
	      return item.type === "product";
	    }).map(function (item) {
	      return item.metadata.parcel.images.map(function (it) {
	        return image1.push(it);
	      });
	    });
	    this.setState({ image: image1, showModalImage: true });
	    this.setState({ zoomIndex: 0, zoomDirection: null });
	  },
	  close: function close() {
	    this.setState({ showModalImage: false });
	  },
	  createMarkup: function createMarkup(data) {
	    return { __html: data };
	  },
	  handleCarousel: function handleCarousel(modal, selectedIndex, e) {
	    var _setState;
	
	    var index = modal + "Index";
	    var direction = modal + "Direction";
	
	    this.setState((_setState = {}, _defineProperty(_setState, index, selectedIndex), _defineProperty(_setState, direction, e.direction), _setState));
	  },
	  renderItemAmount: function renderItemAmount(items, type, currency) {
	    var amount = void 0;
	
	    items.map(function (item) {
	      return type.indexOf(item.description) >= 0 ? amount = item.amount : null;
	    });
	    return amount === 0.00 ? "FREE" : currency === "USD" ? "USD " + (0, _utils.numbersWithComma)(amount.toFixed(2)) : "₱ " + (0, _utils.numbersWithComma)(amount.toFixed(2));
	  },
	  renderSubTotal: function renderSubTotal(items) {
	    var subtotal = items.filter(function (fees) {
	      return fees.description === 'Shipping Fee' || fees.description === 'Insurance Fee' || fees.description === 'Storage Fee';
	    }).reduce(function (acc, fees) {
	      return acc + fees.amount;
	    }, 0);
	    return (0, _utils.numbersWithComma)(Number(subtotal).toFixed(2));
	  },
	  handle3plTracking: function handle3plTracking(segment, origin, destination, shipment) {
	    if (origin === "US" && destination === "PH") {
	      return segment.type === "transfer" ? segment.reference_id : segment.type === "acceptance" ? segment.reference_id : null;
	    }
	    if (origin === "US" && destination === "MY") {
	      return segment.type === "delivery" ? segment.reference_id : null;
	    }
	    if (origin === "UK" && destination === "PH") {
	      return segment.type === 'delivery' ? segment.reference_id : null;
	    }
	    if ((origin === "UK" || origin === "AU" || origin === "KR" || origin === "JP") && destination === "MY") {
	      return segment.type === "delivery" ? segment.reference_id : null;
	    }
	    if ((origin === "AU" || origin === "JP") && destination === "PH") {
	      return segment.type === "delivery" ? segment.reference_id : null;
	    }
	    if (origin === "KR" && destination === "PH") {
	      return segment.type === "delivery" ? segment.reference_id : null;
	    }
	  },
	  cartModal: function cartModal() {
	    return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null };
	  },
	  downloadFile: function downloadFile(link) {
	    var _this2 = this;
	
	    fetch(link).then(function (res) {
	      var dlLink = res.url;
	      res.blob().then(function (blob) {
	        var url = window.URL.createObjectURL(blob);
	        var a = document.createElement("a");
	        // a.style = "display: none";
	        a.href = url;
	        a.setAttribute('download', dlLink.substring(dlLink.lastIndexOf("/")).split('?', 1));
	        document.body.appendChild(a);
	        a.click();
	        document.body.removeChild(a);
	
	        _this2.setState({ isDownloading: false });
	      });
	    });
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var outBoundBannerData = this.state.settings && this.state.settings.filter(function (data) {
	      return data.name === "outbound_banner";
	    });
	    return _react2.default.createElement(
	      'div',
	      null,
	      _utils.disabledCart && _react2.default.createElement(_Tour2.default, null),
	      this.state.isDownloading && _react2.default.createElement(
	        'div',
	        { style: { top: 0, right: 0, left: 0, bottom: 0, position: 'fixed', alignItems: 'center', background: 'rgba(0,0,0,0.6)', zIndex: '999999', justifyContent: 'center', display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { style: { color: '#FFF' } },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            'Loading...'
	          )
	        )
	      ),
	      _react2.default.createElement('iframe', { title: (0, _uuid.v4)(), src: 'https://9848754.fls.doubleclick.net/activityi;src=9848754;type=paysh0;cat=paysh0;qty=1;cost=1;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?', width: '1', height: '1', frameBorder: '0', style: { display: 'none' } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'main-content shipments ' },
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { className: 'view-shipping', show: this.state.showModal, onHide: this.close1 },
	          _react2.default.createElement(
	            'header',
	            { className: 'modal-header' },
	            _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	            this.props.shipmentInfo.fetched_order ? _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'pull-left currentactivity' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Current Activity:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  this.props.shipmentInfo.order.data.events && this.props.shipmentInfo.order.data.events.map(function (ev, i, arr) {
	                    return i === _this3.props.shipmentInfo.order.data.events.length - 1 ? ev.status === 'for_acceptance' || ev.status === 'for_transfer' || _this3.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office") ? (0, _utils.maskEventRemarks)(arr[i - 1].remarks) : (0, _utils.maskEventRemarks)(ev.remarks, ev.status_updated_at, ev.status) : null;
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'pull-right text-center' },
	                _react2.default.createElement(
	                  'label',
	                  { className: this.handleStatuses(this.props.shipmentInfo.fetched_order ? this.props.shipmentInfo.order.data.status : null, "class") },
	                  this.handleStatuses(this.props.shipmentInfo.fetched_order ? this.props.shipmentInfo.order.data.status : null, "text")
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tracking #: ',
	                  this.props.shipmentInfo.fetched_order ? this.props.shipmentInfo.order.data.tracking_number : null
	                )
	              )
	            ) : null
	          ),
	          this.props.shipmentInfo.fetched_order ? _react2.default.createElement(
	            'div',
	            { className: 'modal-body padding-3percent' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Shipping History: '
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Date/Time'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Activity'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                this.props.shipmentInfo.order.data.events ? this.props.shipmentInfo.order.data.events.reverse().map(function (ev, i) {
	                  return ev.status === "consolidated" || ev.status === "for_acceptance" || ev.status === 'for_transfer' || _this3.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks && ev.remarks.toLowerCase().includes("accepted at office") ? null : _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _dateFns.format)((0, _utils.isMigratedEventRemarks)(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _utils.maskEventRemarks)(ev.remarks, ev.status_updated_at, ev.status)
	                    )
	                  );
	                }) : null
	              )
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { show: this.state.showModalImage, onHide: this.close },
	          _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Carousel,
	              { className: this.state.image ? this.state.image.length > 1 ? "" : "disnone" : "", activeIndex: this.state.zoomIndex, direction: this.state.zoomDirection, onSelect: this.handleCarousel.bind(this, "zoom") },
	              this.state.image ? this.state.image.map(function (datas, i) {
	                return _react2.default.createElement(
	                  _reactBootstrap.Carousel.Item,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'imgcase', key: i },
	                    _react2.default.createElement('img', { className: 'imgwd100', src: datas, alt: '' })
	                  )
	                );
	              }) : null
	            ),
	            _react2.default.createElement('img', { className: this.state.image ? this.state.image.length === 1 ? "imgwd100" : "disnone" : "disnone", src: this.state.image, alt: '' })
	          ),
	          _react2.default.createElement(_reactBootstrap.Modal.Footer, null)
	        ),
	        this.state.settings && outBoundBannerData && _react2.default.createElement(
	          'div',
	          { className: 'shipment-outbound-banner' },
	          _react2.default.createElement(_OutBoundBanner2.default, { outBoundBannerData: outBoundBannerData })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'top-actions' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'shipment-status', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#All', 'aria-controls': 'active', onClick: function onClick() {
	                    return _this3.handleStatusDisplay("all");
	                  }, role: 'tab', 'data-toggle': 'tab' },
	                'All'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: '' },
	              _react2.default.createElement(
	                'a',
	                { href: '#PendingPayment', onClick: function onClick() {
	                    return _this3.handleStatusDisplay("pending");
	                  }, 'aria-controls': 'archive', role: 'tab', 'data-toggle': 'tab' },
	                'Pending Payment'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: '' },
	              _react2.default.createElement(
	                'a',
	                { href: '#PreparingShipment', onClick: function onClick() {
	                    return _this3.handleStatusDisplay("preparing");
	                  }, 'aria-controls': 'archive', role: 'tab', 'data-toggle': 'tab' },
	                'Preparing for Shipment'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: '' },
	              _react2.default.createElement(
	                'a',
	                { href: '#InTransit', onClick: function onClick() {
	                    return _this3.handleStatusDisplay("inTransit");
	                  }, 'aria-controls': 'archive', role: 'tab', 'data-toggle': 'tab' },
	                'On its Way'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: '' },
	              _react2.default.createElement(
	                'a',
	                { href: '#Delivered', onClick: function onClick() {
	                    return _this3.handleStatusDisplay("delivered");
	                  }, 'aria-controls': 'archive', role: 'tab', 'data-toggle': 'tab' },
	                'Delivered'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'filter' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.total : null,
	              ' Shipments in'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'dropdown' },
	              _react2.default.createElement(
	                'select',
	                { className: 'btn btn-white-gradient minimal', value: this.state.value, onChange: this.change },
	                _react2.default.createElement(
	                  'option',
	                  { value: '3months' },
	                  'Last 3 Months'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '6months' },
	                  'Last 6 Months'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: new Date().getFullYear() },
	                  new Date().getFullYear()
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: new Date().getFullYear() - 1 },
	                  new Date().getFullYear() - 1
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'shipment-list tab-content' },
	          _react2.default.createElement(
	            'div',
	            { role: 'tabpanel', className: 'tab-pane active', id: '{this.state.tabID}' },
	            this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.from == null ? _react2.default.createElement(
	              'div',
	              { className: 'shipment-list clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'no-result' },
	                'No Results Found'
	              )
	            ) : this.props.shipmentInfo.fetching ? null : this.props.shipmentInfo.shipment.data.filter(function (ship) {
	              return ship.payment_reference_id !== "";
	            }).map(function (ship, i) {
	              return _react2.default.createElement(
	                'div',
	                { key: i, className: 'shipment-list-wrapper', ref: ship.reference_id },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shipment-head clearfix', style: { backgroundColor: '#F1F1F1' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-type' },
	                    ship.shipment.includes("air") ? _react2.default.createElement(
	                      'h5',
	                      { className: 'air' },
	                      'Air Cargo'
	                    ) : _react2.default.createElement(
	                      'h5',
	                      { className: 'sea' },
	                      'Sea Cargo'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-transaction' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Transaction Date:'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      (0, _dateFns.format)(new Date(ship.tat.pending * 1000), 'MM/DD/YYYY')
	                    ),
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Transaction #:'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ship.payment_reference_id
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-to' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'From:'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      (0, _utils.maskLocationName)(ship.pickup_address.country.code) + " Warehouse"
	                    ),
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Ship to:'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ship.delivery_address.name,
	                      _react2.default.createElement('br', null),
	                      ' ',
	                      ship.delivery_address.line_1,
	                      ',\xA0',
	                      ship.delivery_address.district,
	                      '\xA0 ',
	                      ship.delivery_address.city,
	                      ',\xA0',
	                      ship.delivery_address.state,
	                      '\xA0 ',
	                      ship.delivery_address.country.name,
	                      ',\xA0',
	                      ship.delivery_address.postal_code
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ship.delivery_address.phone_number
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-delivery' },
	                    _react2.default.createElement(
	                      'h6',
	                      null,
	                      'Estimated Delivery Date:'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      (0, _dateFns.format)(ship.shipment.includes("air") ? ship.metadata.delivery_tat ? ship.metadata.delivery_tat.air : null : ship.metadata.delivery_tat ? ship.metadata.delivery_tat.sea : null, 'MM/DD/YYYY')
	                    )
	                  )
	                ),
	                ship.damage_items && !!ship.damage_items.total && _react2.default.createElement(_DamagedBanner2.default, {
	                  message: _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontWeight: 600 } },
	                      ship.damage_items && ship.damage_items.total,
	                      ' out of',
	                      ' ',
	                      ship.parcels && ship.parcels.total,
	                      ' packages'
	                    ),
	                    ' ',
	                    'contains',
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      {
	                        style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer' },
	                        onClick: function onClick() {
	                          return _this3.setState({ damagedModalOpen: true, damagedItemsList: ship.damage_items });
	                        }
	                      },
	                      'damaged item'
	                    ),
	                    ' ',
	                    'which are excluded from SC Protect when you checkout.'
	                  ),
	                  bgColor: '#FFE9EB',
	                  marginTop: '0px',
	                  padding: '10px 20px'
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shipment-box clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'data-do': 'image-modal', className: 'shipment-image', style: { maxWidth: '160px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { style: { backgroundColor: '#2C985B', color: '#F9F9F9', padding: '5px', width: 'fit-content', marginBottom: '10px', borderRadius: '4px', textTransform: 'uppercase', fontWeight: 600, fontSize: '12px' } },
	                        'Box 1'
	                      ),
	                      ship.items ? ship.items.filter(function (item) {
	                        return item.type === "product";
	                      }).map(function (item, i) {
	                        return _react2.default.createElement(
	                          'div',
	                          { key: i, className: i === 0 ? "" : "disnone" },
	                          _react2.default.createElement(
	                            'a',
	                            { onClick: _this3.handleImage.bind(_this3, ship.items), 'data-toggle': 'lightbox', 'data-gallery': 'hiddenimages' },
	                            _react2.default.createElement('img', { src: item.metadata.parcel.images[0], className: 'img-responsive', alt: '' })
	                          )
	                        );
	                      }) : null
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-item', style: { maxWidth: '175px' } },
	                      _react2.default.createElement(
	                        'h6',
	                        null,
	                        'Item/s'
	                      ),
	                      ship.printable && _react2.default.createElement(
	                        'button',
	                        { style: {
	                            border: 'none',
	                            background: 'none',
	                            color: '#0375D9',
	                            padding: 0
	                          }, onClick: function onClick() {
	                            _axios2.default.post(apiUrl + 'users/print/bol', { "data": {
	                                "tracking_number": [ship.tracking_number],
	                                "shipment": ship.shipment,
	                                "country_destination": ship.delivery_address.country.code
	                              } }).then(function (res) {
	                              var link = res.data.bol;
	                              _this3.downloadFile(link);
	                            }).catch(function (err) {
	                              console.log(err, 'error');
	                            });
	                          } },
	                        'Download Bill of Lading'
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        ship.items.filter(function (item) {
	                          return item.type === "product";
	                        }).map(function (item, i) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: i },
	                            item.description,
	                            item.metadata.parcel.flags.is_abandoned ? _react2.default.createElement('span', { className: 'icon-hope' }) : null
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-status', style: { maxWidth: '325px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'shipment-update', style: { padding: '10px 0px' }, 'data-lazy': 'true', 'data-lazy-id': '68577', 'data-lazy-tracking': '1095781790', 'data-lazy-status': 'PAID', 'data-lazy-delivered-date': '' },
	                        _this3.handleStatuses(ship.status, "text") === "PREPARING FOR SHIPMENT" ? _react2.default.createElement(
	                          'div',
	                          { className: 'tracking-update' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'track-and-trace' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'top-label' },
	                              _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Latest Update:'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'update-details' },
	                              'Your package is being processed for shipping.'
	                            )
	                          )
	                        ) : null,
	                        ship.reason && ship.payment_status === 'rejected' && _react2.default.createElement(
	                          'div',
	                          { className: 'track-and-trace' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'top-label' },
	                            _react2.default.createElement(
	                              'strong',
	                              null,
	                              'Reason:'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'update-details' },
	                            ship.reason
	                          )
	                        ),
	                        _this3.handleStatuses(ship.status, "text") === "DELIVERED" || _this3.handleStatuses(ship.status, "text") === "ON ITS WAY" ? _react2.default.createElement(
	                          'div',
	                          { className: 'tracking-update' },
	                          ship.events ? ship.events.map(function (ev, i, arr) {
	                            return i === ship.events.length - 1 ? _react2.default.createElement(
	                              'div',
	                              { className: 'track-and-trace', key: i },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'top-label' },
	                                _react2.default.createElement(
	                                  'strong',
	                                  null,
	                                  'Latest Update:'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'update-date' },
	                                (0, _dateFns.format)((0, _utils.isMigratedEventRemarks)(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'update-details' },
	                                ev.status === 'for_acceptance' || ship && ship.shipment === 'uk-sea' && ev.remarks && ev.remarks.toLowerCase().includes("accepted at office") ? (0, _utils.maskEventRemarks)(arr[i - 1].remarks) : (0, _utils.maskEventRemarks)(ev.remarks, ev.status_updated_at, ship.status)
	                              )
	                            ) : null;
	                          }) : null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'modalanchor', onClick: _this3.open.bind(_this3, ship.tracking_number) },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _this3.handleStatuses(ship.status, "text") === "DELIVERED" ? "Tracking History" : "Tracking Details"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Tracking #: ',
	                            ship.tracking_number
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Alternate Tracking:\xA0',
	                            ship.segments && ship.segments.map(function (segment, id) {
	                              return _react2.default.createElement(
	                                'a',
	                                { key: id, target: 'blank',
	                                  href: 'https://parcelsapp.com/en/tracking/' + _this3.handle3plTracking(segment, ship.pickup_address.country.code, ship.delivery_address.country.code, ship.shipment) },
	                                _this3.handle3plTracking(segment, ship.pickup_address.country.code, ship.delivery_address.country.code, ship.shipment)
	                              );
	                            })
	                          ),
	                          ship.status === 'delivered' && _react2.default.createElement(
	                            'a',
	                            { href: '/referral?utm_source=web&utm_medium=delivered-shipment&utm_campaign=ph-web-delivered-shipment-referral-20220727' },
	                            _react2.default.createElement(
	                              'button',
	                              { className: 'btn btn-orange referral-button' },
	                              'REFERRAL PROMO | LEARN MORE'
	                            )
	                          )
	                        ) : null
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-status', style: { maxWidth: '198px' } },
	                      _react2.default.createElement(
	                        'h6',
	                        { style: { marginBottom: '5px' } },
	                        'Status:'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'shipment-status-wrapper' },
	                        _this3.handleStatuses(ship.status, "text", ship.payment_status)
	                      ),
	                      ship.sc_protect && ship.sc_protect.coc && _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', flexDirection: 'column', margin: '15px 0px' } },
	                        _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg', alt: 'badge', width: 18, height: 18 }),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: '10px', marginTop: '5px' } },
	                          'SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: '13px', fontWeight: 600, color: '#0375D9', marginTop: '15px', cursor: 'pointer' },
	                            onClick: function onClick() {
	                              _this3.setState({ isDownloading: true });
	                              _axios2.default.get(apiUrl + 'policy/' + ship.sc_protect.coc).then(function (res) {
	                                var link = res.data.data.policy;
	                                _this3.downloadFile(link);
	                              }).catch(function (err) {
	                                console.log(err, 'error');
	                                _this3.setState({ isDownloading: false });
	                              });
	                            } },
	                          'Download Insurance Policy'
	                        )
	                      )
	                    )
	                  )
	                ),
	                ship.children ? ship.children.length > 0 ? ship.children.map(function (child, i) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'shipment-box clearfix', key: i },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-box-wrapper' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'data-do': 'image-modal', className: 'shipment-image', style: { maxWidth: '160px' } },
	                        _react2.default.createElement(
	                          'div',
	                          { style: { backgroundColor: '#2C985B', color: '#F9F9F9', padding: '5px', width: 'fit-content', marginBottom: '10px', borderRadius: '4px', textTransform: 'uppercase', fontWeight: 600, fontSize: '12px' } },
	                          'Box ',
	                          i + 2
	                        ),
	                        child.items ? child.items.filter(function (item) {
	                          return item.type === "product";
	                        }).map(function (item, i) {
	                          return _react2.default.createElement(
	                            'div',
	                            { key: i, className: i === 0 ? "" : "disnone" },
	                            _react2.default.createElement(
	                              'a',
	                              { onClick: _this3.handleImage.bind(_this3, child.items), 'data-toggle': 'lightbox', 'data-gallery': 'hiddenimages' },
	                              _react2.default.createElement('img', { src: item.metadata.parcel.images[0], className: 'img-responsive', alt: '' })
	                            )
	                          );
	                        }) : null
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'shipment-item', style: { maxWidth: '175px' } },
	                        _react2.default.createElement(
	                          'h6',
	                          null,
	                          'Item/s'
	                        ),
	                        ship.printable && _react2.default.createElement(
	                          'button',
	                          { style: {
	                              border: 'none',
	                              background: 'none',
	                              color: '#0375D9',
	                              padding: 0
	                            }, onClick: function onClick() {
	                              _axios2.default.post(apiUrl + 'users/print/bol', { "data": {
	                                  "tracking_number": [child.tracking_number],
	                                  "shipment": child.shipment,
	                                  "country_destination": ship.delivery_address.country.code
	                                } }).then(function (res) {
	                                var link = res.data.bol;
	                                _this3.downloadFile(link);
	                              }).catch(function (err) {
	                                console.log(err, 'error');
	                              });
	                            } },
	                          'Download Bill of Lading'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          child.items && child.items.filter(function (item) {
	                            return item.type === "product";
	                          }).map(function (item, i) {
	                            return _react2.default.createElement(
	                              'li',
	                              { key: i },
	                              item.description,
	                              item.metadata.parcel.flags.is_abandoned ? _react2.default.createElement('span', { className: 'icon-hope' }) : null
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'shipment-status', style: { maxWidth: '325px' } },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'shipment-update', style: { padding: '10px 0px' }, 'data-lazy': 'true', 'data-lazy-id': '68577', 'data-lazy-tracking': '1095781790', 'data-lazy-status': 'PAID', 'data-lazy-delivered-date': '' },
	                          _this3.handleStatuses(child.status, "text") === "PREPARING FOR SHIPMENT" ? _react2.default.createElement(
	                            'div',
	                            { className: 'tracking-update' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'track-and-trace' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'top-label' },
	                                _react2.default.createElement(
	                                  'strong',
	                                  null,
	                                  'Latest Update:'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'update-details' },
	                                'Your package is being processed for shipping.'
	                              )
	                            )
	                          ) : null,
	                          _this3.handleStatuses(child.status, "text") === "DELIVERED" || _this3.handleStatuses(child.status, "text") === "ON ITS WAY" ? _react2.default.createElement(
	                            'div',
	                            { className: 'tracking-update' },
	                            child.events ? child.events.map(function (ev, i, arr) {
	                              return i === 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'track-and-trace', key: i },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'top-label' },
	                                  _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    'Latest Update:'
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'update-date' },
	                                  (0, _dateFns.format)((0, _utils.isMigratedEventRemarks)(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'update-details' },
	                                  ev.status === 'for_acceptance' || child && child.shipment === 'uk-sea' && ev.remarks && ev.remarks.toLowerCase().includes("accepted at office") ? (0, _utils.maskEventRemarks)(arr[i - 1].remarks) : (0, _utils.maskEventRemarks)(arr[arr.length - 1].remarks, ev.status_updated_at, child.status)
	                                )
	                              ) : null;
	                            }) : null,
	                            _react2.default.createElement(
	                              'a',
	                              { className: 'modalanchor', onClick: _this3.open.bind(_this3, child.tracking_number) },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                _this3.handleStatuses(child.status, "text") === "DELIVERED" ? "Tracking History" : "Tracking Details"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Tracking #: ',
	                              child.tracking_number
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Alternate Tracking:\xA0',
	                              child.segments && child.segments.map(function (segment, id) {
	                                return _react2.default.createElement(
	                                  'a',
	                                  { key: id, target: 'blank',
	                                    href: 'https://parcelsapp.com/en/tracking/' + _this3.handle3plTracking(segment, ship.pickup_address.country.code, ship.delivery_address.country.code, ship.shipment) },
	                                  _this3.handle3plTracking(segment, ship.pickup_address.country.code, ship.delivery_address.country.code, ship.shipment)
	                                );
	                              })
	                            ),
	                            child.status === 'delivered' && _react2.default.createElement(
	                              'a',
	                              { href: '/referral?utm_source=web&utm_medium=delivered-shipment&utm_campaign=ph-web-delivered-shipment-referral-20220727' },
	                              _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-orange referral-button' },
	                                'REFERRAL PROMO | LEARN MORE'
	                              )
	                            )
	                          ) : null
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'shipment-status', style: { maxWidth: '198px' } },
	                        _react2.default.createElement(
	                          'h6',
	                          { style: { marginBottom: '5px' } },
	                          'Status:'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'shipment-status-wrapper' },
	                          _this3.handleStatuses(child.status, "text", child.payment_status)
	                        ),
	                        ship.sc_protect && ship.sc_protect.coc && _react2.default.createElement(
	                          'div',
	                          { style: { display: 'flex', flexDirection: 'column', margin: '15px 0px' } },
	                          _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg', alt: 'badge', width: 18, height: 18 }),
	                          _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: '10px', marginTop: '5px' } },
	                            'SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: '13px', fontWeight: 600, color: '#0375D9', marginTop: '15px', cursor: 'pointer' },
	                              onClick: function onClick() {
	                                _this3.setState({ isDownloading: true });
	                                _axios2.default.get(apiUrl + 'policy/' + ship.sc_protect.coc).then(function (res) {
	                                  var link = res.data.data.policy;
	                                  _this3.downloadFile(link);
	                                }).catch(function (err) {
	                                  console.log(err, 'error');
	                                  _this3.setState({ isDownloading: false });
	                                });
	                              } },
	                            'Download Insurance Policy'
	                          )
	                        )
	                      )
	                    )
	                  );
	                }) : null : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'transaction clearfix' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'transaction-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'collapse-head collapsed', 'data-toggle': 'collapse', 'data-target': "#" + ship.id, ref: ship.id },
	                      'Transaction Details:'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: ship.id, className: 'collapse collapse-content' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'breakdown' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'breakdown-item clearfix' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'left' },
	                            ship.shipment.includes("air") ? "Air" : "Sea",
	                            ' Cargo Fee:'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'right' },
	                            _this3.renderItemAmount(ship.items, ['Shipping Fee', 'Cargo Fee'], ship.currency)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'breakdown-item clearfix' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'left' },
	                            _react2.default.createElement(
	                              'div',
	                              { style: { display: 'inline-flex' } },
	                              'SC Protect Fee',
	                              ship.sc_protect && ship.sc_protect.opt_in && _react2.default.createElement(
	                                'div',
	                                { className: 'fa icon-sc-protect fa-fw', style: { width: '16px', height: '16px', backgroundSize: 'cover', alignSelf: 'center', marginLeft: '5px', marginRight: '3px' } },
	                                ship.sc_protect.type === 'stere' && _react2.default.createElement(
	                                  'div',
	                                  { className: 'tooltip special-handling-tooltip white' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.'
	                                  )
	                                )
	                              ),
	                              ':'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'right' },
	                            _this3.renderItemAmount(ship.items, 'Insurance Fee', ship.currency)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'breakdown-item clearfix' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'left' },
	                            'Storage Fee:'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'right' },
	                            _this3.renderItemAmount(ship.items, 'Storage Fee', ship.currency)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'breakdown-item clearfix' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'left' },
	                            ship.shipment.includes("air") ? "Air" : "Sea",
	                            ' Cargo Subtotal:'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'right' },
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              ship.total === "0.00" ? "FREE" : ship.currency === "USD" ? "USD " : "₱ ",
	                              _this3.renderSubTotal(ship.items)
	                            )
	                          )
	                        ),
	                        ship.items.map(function (item, i) {
	                          return item.type === "discount" ? item.metadata ? _react2.default.createElement(
	                            'div',
	                            { key: i },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'breakdown-item clearfix' },
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'left' },
	                                'Discount (',
	                                item.metadata.code,
	                                '|',
	                                item.metadata.value,
	                                item.metadata.type === "percentage" ? "%" : null,
	                                ' OFF):'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'right' },
	                                '- ',
	                                ship.currency === "USD" ? "USD " : "₱ ",
	                                ' ',
	                                parseFloat(ship.discount) * -1
	                              )
	                            )
	                          ) : null : null;
	                        }),
	                        Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_orders') && parseInt(ship.metadata.sc_promotional_orders, 10) ? ship.shipment.includes('sea') && Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_fee_per_shipment') && ship.metadata.sc_promotional_fee_per_shipment.sea !== "0" ? _react2.default.createElement(
	                          'div',
	                          { className: 'breakdown-item clearfix' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'left' },
	                            'Project Hope Donation:'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'right' },
	                            'USD ',
	                            (0, _utils.numbersWithComma)(Number(ship.metadata.sc_promotional_fee_per_shipment.sea).toFixed(2))
	                          )
	                        ) : ship.shipment.includes('air') && Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_fee_per_shipment') && ship.metadata.sc_promotional_fee_per_shipment.air !== "0" ? _react2.default.createElement(
	                          'div',
	                          { className: 'breakdown-item clearfix' },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'left' },
	                            'Project Hope Donation:'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'right' },
	                            'USD ',
	                            Object.prototype.hasOwnProperty.call(ship.metadata, 'sc_promotional_fee_per_shipment') ? (0, _utils.numbersWithComma)(Number(ship.metadata.sc_promotional_fee_per_shipment.air).toFixed(2)) : "5.00"
	                          )
	                        ) : null : null
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'total' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'total-item clearfix' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'left' },
	                              'Total ShippingCart Fee:'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'right' },
	                              ship.currency === "USD" ? "USD " : "₱ ",
	                              '  ',
	                              (0, _utils.numbersWithComma)(Number(ship.total).toFixed(2))
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'left' },
	                            ship.printable && _react2.default.createElement(
	                              'button',
	                              { style: {
	                                  border: 'none',
	                                  background: 'none',
	                                  width: 166,
	                                  color: '#0375D9'
	                                }, onClick: function onClick() {
	                                  _axios2.default.post(apiUrl + 'users/print/invoice', { "data": {
	                                      "tracking_number": [ship.tracking_number],
	                                      "reference_id": ship.reference_id
	                                    } }).then(function (res) {
	                                    var link = res.data.pod;
	                                    _this3.downloadFile(link);
	                                  }).catch(function (err) {
	                                    console.log(err, 'error');
	                                  });
	                                } },
	                              'Download Invoice'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              );
	            }) : null,
	            this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.from == null ? null : _react2.default.createElement(_reactBootstrap.Pagination, { first: true, prev: true, next: true, ellipsis: true,
	              last: this.state.activePage + 2 >= this.props.shipmentInfo.shipment.last_page ? false : this.props.shipmentInfo.shipment.last_page,
	              boundaryLinks: false,
	              items: this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.last_page : null,
	              maxButtons: 5,
	              activePage: this.state.activePage,
	              onSelect: this.handleSelect
	            }) : null
	          )
	        ),
	        _react2.default.createElement('div', { className: 'bottom-actions clearfix' })
	      ),
	      localStorage.cartModalShowed ? null : this.props.cms.modalContent ? _utils.disabledCart && this.props.cms.getModal && this.props.cms.modalContent.data.status ? _react2.default.createElement(_AdvisoryModal2.default, { show: this.props.cms.showAdvisoryModal['cart'],
	        close: function close(dispatch) {
	          return _this3.props.closeModal('cart');
	        },
	        content: this.cartModal()
	      }) : null : null,
	      _react2.default.createElement(_DamagedModal2.default, {
	        isOpen: this.state.damagedModalOpen,
	        handleClose: function handleClose() {
	          return _this3.setState({ damagedModalOpen: false, damagedItemsList: null });
	        },
	        damageItems: this.state.damagedItemsList
	      })
	    );
	  }
	});
	
	exports.default = Shipment;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(828);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(114);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _AdvisoryModal = __webpack_require__(120);
	
	var _AdvisoryModal2 = _interopRequireDefault(_AdvisoryModal);
	
	var _uuid = __webpack_require__(70);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var Home = createReactClass({
	  displayName: 'Home',
	
	  getInitialState: function getInitialState() {
	    return {
	      homeContent: "<div></div>",
	      showModal: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    // <!-- Lightning Bolt Begins -->
	    var lbscript = document.createElement("script");
	    lbscript.type = "text/javascript";
	    lbscript.src = "/js/lightningbolt.js";
	    lbscript.async = true;
	    document.body.appendChild(lbscript);
	
	    var lbscript1 = document.createElement("script");
	    lbscript1.type = "text/javascript";
	    lbscript1.setAttribute('id', 'lightning_bolt');
	    lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
	    lbscript1.async = true;
	    document.body.appendChild(lbscript1);
	    // <!-- Lightning Bolt Ends -->
	
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->    
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.props.getCmsBody('homepage');
	    this.props.getModalBlocks('home');
	    this.timeOut = setTimeout(function () {
	      return _this.setState({ showModal: true });
	    }, 7000);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	
	    var homeContent = nextProps.cms.getCms && nextProps.cms.CmsContent ? nextProps.cms.CmsContent.data.content.body : this.state.homeContent;
	    var homeModalContent = nextProps.cms.getModal && nextProps.cms.modalContent && nextProps.cms.modalContent.data.variable === "Homepage-Modal" ? nextProps.cms.modalContent.data.status : false;
	    this.setState({ homeContent: homeContent, homeModalContent: homeModalContent });
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var x = document.getElementsByClassName("lbcx");
	
	    if (this.props.cms.getCms) {
	      var signup = document.getElementById('home-sign-up');
	      var signin = document.getElementById('home-sign-in');
	
	      if (this.props.auth.isAuthenticated) {
	        signup.style.display = 'none';
	        signin.style.display = 'none';
	      } else {
	        signup.style.display = 'block';
	        signin.style.display = 'block';
	      }
	    }
	
	    for (var i = 0; i < x.length; i++) {
	      document.body.removeChild(x.item(i));
	    }
	
	    var script = document.createElement("script");
	    script.setAttribute('class', 'lbcx');
	    script.type = "text/javascript";
	    script.src = "/js/dropdown.js";
	    script.async = true;
	    document.body.appendChild(script);
	
	    var script3 = document.createElement("script");
	    script3.setAttribute('class', 'lbcx');
	    script3.type = "text/javascript";
	    script3.src = "/js/custom.js";
	    script3.async = true;
	    document.body.appendChild(script3);
	
	    for (var j = 0; j < x.length; j++) {
	      document.body.removeChild(x.item(j));
	    }
	  },
	  homeModal: function homeModal() {
	    return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null };
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timeOut);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var axel = Math.random() + "";
	    var a = axel * 10000000000000;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('iframe', { title: (0, _uuid.v4)(), src: 'https://9848754.fls.doubleclick.net/activityi;src=9848754;type=homeo0;cat=homep0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a + '?', width: '1', height: '1', frameBorder: '0', style: { display: 'none' } }),
	      _react2.default.createElement(
	        'noscript',
	        null,
	        _react2.default.createElement('iframe', { title: (0, _uuid.v4)(), src: 'https://9848754.fls.doubleclick.net/activityi;src=9848754;type=homeo0;cat=homep0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?', width: '1', height: '1', frameBorder: '0', style: { display: 'none' } })
	      ),
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'ShippingCart | Ship Your Finds',
	        meta: [{ name: 'description', content: "ShippingCart lets you shop from online stores in the US & the UK & ship straight to the PH. Sign up today & enjoy low rates with fast delivery." }]
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'body-wrapper' },
	        _react2.default.createElement('div', { className: 'main-wrapper', dangerouslySetInnerHTML: { __html: this.state.homeContent } }),
	        this.state.showModal && this.state.homeModalContent ? _react2.default.createElement(_AdvisoryModal2.default, { show: this.props.cms.showAdvisoryModal['home'],
	          close: function close(dispatch) {
	            return _this2.props.closeModal('home');
	          },
	          content: this.homeModal()
	        }) : null
	      )
	    );
	  }
	});
	
	exports.default = Home;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CloudFlareBadge = function (_Component) {
	  _inherits(CloudFlareBadge, _Component);
	
	  function CloudFlareBadge() {
	    _classCallCheck(this, CloudFlareBadge);
	
	    return _possibleConstructorReturn(this, (CloudFlareBadge.__proto__ || Object.getPrototypeOf(CloudFlareBadge)).apply(this, arguments));
	  }
	
	  _createClass(CloudFlareBadge, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var badgeType = this.props.type ? this.props.type : "g";
	      var s = document.createElement('script');
	      s.type = 'text/javascript';
	      s.async = true;
	      s.setAttribute("data-cfbadgetype", badgeType);
	      s.setAttribute("data-cfbadgeskin", "dkgray");
	      s.src = '//ajax.cloudflare.com/cdn-cgi/nexp/cloudflare.js';
	      this.securitybadge.appendChild(s);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', {
	        ref: function ref(el) {
	          return _this2.securitybadge = el;
	        },
	        className: this.props.type === "e" && "cloudflarebadge-e"
	      });
	    }
	  }]);
	
	  return CloudFlareBadge;
	}(_react.Component);
	
	exports.default = CloudFlareBadge;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _constant = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FatFooter = function FatFooter(props) {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'big-footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'top-nav footer-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'top row container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-sc-logo-wrapper' },
	          _react2.default.createElement('div', { className: 'footer-sc-logo' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-link-wrapper' },
	          _constant.footerLinks.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'footer-link-box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'footer-link-label' },
	                item.title
	              ),
	              item.links.map(function (link) {
	                return link.external ? _react2.default.createElement(
	                  'div',
	                  { className: 'footer-link' },
	                  _react2.default.createElement(
	                    'a',
	                    { id: link.id, href: link.url, target: link.target ? link.target : "" },
	                    link.icon && _react2.default.createElement('img', { width: 14, height: 14, style: { marginRight: '10px', marginBottom: '5px' }, src: link.icon, alt: '' }),
	                    link.label
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'footer-link' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { id: link.id, to: link.url },
	                    link.label
	                  )
	                );
	              })
	            );
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-link-label' },
	              'Download the ShippingCart App'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-sc-app' },
	              _react2.default.createElement('img', { width: 96, height: 96, src: 'https://cdn.shippingcart.com/assets/qr_code-opt-20211214073949.png', alt: '' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'footer-sc-app-button' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://sc-app-launch.onelink.me/im4v', target: '_blank', rel: 'noopener noreferrer' },
	                  _react2.default.createElement('img', { width: 96, height: 30, src: 'https://cdn.shippingcart.com/assets/google-play-20200601054551.png', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://sc-app-launch.onelink.me/im4v', target: '_blank', rel: 'noopener noreferrer' },
	                  _react2.default.createElement('img', { width: 96, height: 30, src: 'https://cdn.shippingcart.com/assets/apple-store-opt-20211214073949.png', alt: '' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-mobile-link-wrapper' },
	          _constant.footerLinks.filter(function (item) {
	            return item.title === 'Social Media';
	          }).map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'footer-link-box' },
	              _react2.default.createElement(
	                'div',
	                { className: 'footer-link-label' },
	                item.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'footer-mobile-link' },
	                item.links.map(function (link) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'footer-link' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: link.url, target: link.target ? link.target : "" },
	                      link.icon && _react2.default.createElement('img', { width: 14, height: 14, style: { marginRight: '10px', marginBottom: '5px' }, src: link.icon, alt: '' })
	                    )
	                  );
	                })
	              )
	            );
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-link-label' },
	              'Download the ShippingCart App'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-sc-app' },
	              _react2.default.createElement(
	                'div',
	                { className: 'footer-sc-app-button' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://sc-app-launch.onelink.me/im4v', style: { marginRight: '10px' }, target: '_blank', rel: 'noopener noreferrer' },
	                  _react2.default.createElement('img', { width: 96, height: 30, src: 'https://cdn.shippingcart.com/assets/google-play-20200601054551.png', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://sc-app-launch.onelink.me/im4v', target: '_blank', rel: 'noopener noreferrer' },
	                  _react2.default.createElement('img', { width: 96, height: 30, src: 'https://cdn.shippingcart.com/assets/apple-store-opt-20211214073949.png', alt: '' })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'footer-bottom-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Copyright \xA9 ',
	          props.currentYear,
	          ' ShippingCart.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'footer-bottom-link-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-bottom-link' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/terms-conditions' },
	            'Terms and Condition'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/privacy-policy' },
	            'Privacy Policy'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = FatFooter;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlimFooter = function SlimFooter(props) {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'footer-minimal' },
	    _react2.default.createElement(
	      'div',
	      { className: 'footer-bottom-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Copyright \xA9 ',
	          props.currentYear,
	          ' ShippingCart.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'footer-bottom-link-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-bottom-link' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/terms-conditions' },
	            'Terms and Condition'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/privacy-policy' },
	            'Privacy Policy'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = SlimFooter;

/***/ },
/* 611 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var footerLinks = exports.footerLinks = [{
	  title: "Company",
	  links: [{
	    id: 'about-us-link',
	    label: "About Us",
	    url: "/about-us"
	  }, {
	    id: 'how-it-works-link',
	    label: "How it works",
	    url: "/how-it-works"
	  }]
	}, {
	  title: "Where to Shop",
	  links: [{
	    id: 'shop-in-au-link',
	    label: "Australia",
	    url: "/shop-in-au?utm_source=web&utm_medium=deals&utm_campaign=ph-web-deals-australia-launch-20210309"
	  }, {
	    id: 'shop-in-kr-link',
	    label: "Korea",
	    url: "/shop-in-kr?utm_source=website&utm_medium=header&utm_campaign=ph-web-tab-korea-shopping-20210922"
	  }, {
	    id: 'shop-in-jp-link',
	    label: "Japan",
	    url: "/shop-in-jp?utm_source=web&utm_medium=banner&utm_campaign=shop-in-japan20210120"
	  }, {
	    id: 'shop-in-uk-link',
	    label: "United Kingdom",
	    url: "/shop-in-uk"
	  }, {
	    id: 'shop-in-us-link',
	    label: "United States",
	    url: "/shop-in-us"
	  }]
	}, {
	  title: "Help Center",
	  links: [{
	    id: 'faqs-link',
	    label: "FAQs",
	    url: "https://help-center.shippingcart.com/hc/en-us",
	    external: true
	  }, {
	    id: 'special-handling-link',
	    label: "Special Handling",
	    url: "/special-handling"
	  }, {
	    id: 'prohibited-items-link',
	    label: "Prohibited Items",
	    url: "/prohibited-items"
	  }]
	}, {
	  title: "Social Media",
	  links: [{
	    id: 'fb-link',
	    label: "Facebook",
	    url: "https://www.facebook.com/ShippingCartCom",
	    external: true,
	    target: '_blank',
	    icon: 'https://cdn.shippingcart.com/assets/facebook-20221005084929.svg'
	  }, {
	    id: 'instagram-link',
	    label: "Instagram",
	    url: "https://www.instagram.com/shippingcart",
	    external: true,
	    target: '_blank',
	    icon: 'https://cdn.shippingcart.com/assets/instagram-20221005084935.svg'
	  }, {
	    id: 'youtube-link',
	    label: "Youtube",
	    url: "https://www.youtube.com/c/ShippingCart",
	    external: true,
	    target: '_blank',
	    icon: 'https://cdn.shippingcart.com/assets/youtube-20221005084942.svg'
	  }, {
	    id: 'twitter-link',
	    label: "Twitter",
	    url: "https://twitter.com/shippingcart?utm_source=website&utm_medium=footer&utm_campaign=ph-web-footer",
	    external: true,
	    target: '_blank',
	    icon: 'https://cdn.shippingcart.com/assets/twitter-20221005084948.svg'
	  }, {
	    id: 'tiktok-link',
	    label: "TikTok",
	    url: "https://bit.ly/3SgbGNZ",
	    external: true,
	    target: '_blank',
	    icon: 'https://cdn.shippingcart.com/assets/tiktok-20221005083352.svg'
	  }]
	}];

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _constants = __webpack_require__(124);
	
	var _brandIconWhite = __webpack_require__(316);
	
	var _brandIconWhite2 = _interopRequireDefault(_brandIconWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileHeaderMenu = function MobileHeaderMenu(_ref) {
	  var isShown = _ref.isShown,
	      login = _ref.login,
	      isAuthenticated = _ref.isAuthenticated,
	      closeMenu = _ref.closeMenu;
	
	
	  var renderRewards = function renderRewards(token, accountNumber, name) {
	    return isAuthenticated ? _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: "https://rewards.shippingcart.com?token=" + token + "&account_number=" + accountNumber + "&name=" + name },
	        "Rewards"
	      )
	    ) : _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: "https://rewards.shippingcart.com" },
	        "Rewards"
	      )
	    );
	  };
	
	  // const handleTrackPackage = () => {
	  //   localStorage.setItem("trackPackage", "true");
	  // }
	
	  var renderMenu = function renderMenu(header, menu) {
	    return _react2.default.createElement(
	      "div",
	      { style: { margin: '30px 0px' } },
	      _react2.default.createElement(
	        "p",
	        { style: { fontWeight: 600, marginBottom: 15 } },
	        header
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: "mobile-list" },
	        menu.map(function (_ref2) {
	          var title = _ref2.title,
	              url = _ref2.url,
	              external = _ref2.external;
	          return !external ? _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: url, onClick: function onClick() {
	                  closeMenu();
	                } },
	              title
	            )
	          ) : _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: url },
	              title
	            )
	          );
	        })
	      )
	    );
	  };
	
	  var renderFirstName = function renderFirstName() {
	    var firstName = '';
	    if (login && login.login.party && login.login.party.first_name) {
	      firstName = login.login.party.first_name;
	    }
	    return firstName;
	  };
	
	  var renderOffers = function renderOffers() {
	    return _react2.default.createElement(
	      "div",
	      { style: { margin: '30px 0px' } },
	      _react2.default.createElement(
	        "p",
	        { style: { fontWeight: 600, marginBottom: 15 } },
	        "Offers"
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: "mobile-list" },
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/promotions" },
	            "Promos"
	          )
	        ),
	        renderRewards(localStorage.jwtToken ? localStorage.jwtToken : null, login && login.login.party ? login.login.party.account_number : null, renderFirstName()),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/referral" },
	            "Referral"
	          )
	        )
	      )
	    );
	  };
	
	  return isShown && _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "nav",
	      { id: "fullSidebarNav", className: "sidenav open-nav mobile-menu-wrapper", style: { marginLeft: 0 } },
	      _react2.default.createElement("img", { alt: "logo", src: _brandIconWhite2.default }),
	      _react2.default.createElement(
	        "div",
	        { style: { marginTop: 40 } },
	        renderMenu('Where to shop', _constants.whereToShopMenu),
	        renderMenu('Services', _constants.servicesMenu),
	        renderOffers(),
	        renderMenu('Help Center', _constants.helpCenterMenu),
	        renderMenu('Legal', _constants.legalMenu)
	      )
	    ),
	    _react2.default.createElement("div", {
	      className: "overlay-menu",
	      "data-do": "hamburger",
	      "data-on": "click",
	      onClick: function onClick() {
	        closeMenu();
	      },
	      style: {
	        opacity: 1,
	        zIndex: 999
	      } })
	  );
	};
	
	exports.default = MobileHeaderMenu;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _utils = __webpack_require__(13);
	
	var _dateFns = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileNotifMenu = function MobileNotifMenu(_ref) {
	  var isShown = _ref.isShown,
	      notification = _ref.notification,
	      readAllNotification = _ref.readAllNotification,
	      readNotification = _ref.readNotification,
	      closeSideNav = _ref.closeSideNav;
	
	  var handleClick = function handleClick(id, data) {
	    var read = 1;
	    closeSideNav();
	    readNotification(id, read);
	
	    if (data && data.redirection_type === "delivered") {
	      window.open('https://www.surveymonkey.com/r/5CWMVST?account_number=' + data.account_number + '&tracking_number=' + data.tracking_number + '&date_delivered=' + data.delivered_date + '&origin_country=' + data.origin + '&shipment_method=' + data.shipment_method, "_blank");
	    }
	  };
	
	  var handleOverlayClick = function handleOverlayClick() {
	    closeSideNav();
	  };
	
	  var handleReadAll = function handleReadAll() {
	    var read = 1;
	    var id = notification ? notification[0].attributes.party_id : null;
	    readAllNotification(id, read);
	  };
	  return isShown && _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'nav',
	      { className: 'mobile-sidenav open-nav', style: { "marginRight": "0" } },
	      _react2.default.createElement(
	        'div',
	        { className: 'mobile-notification' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'notif-title' },
	          'Notification',
	          notification && notification.length >= 2 ? "s" : null,
	          ' \xA0',
	          notification && notification.length === 0 ? null : _react2.default.createElement(
	            'span',
	            { className: 'notif-count' },
	            notification.length,
	            ' new'
	          ),
	          notification && notification.length === 0 ? null : _react2.default.createElement(
	            'span',
	            { className: 'notif-mark', role: 'button', onClick: handleReadAll },
	            _react2.default.createElement('span', { className: 'markasread icon-markasread' }),
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mobile-notif-body' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            notification && notification.length !== 0 ? notification.map(function (notif) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'notif-list', key: notif.id },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { className: 'mobile-notif-link', to: (0, _utils.maskRedirectLink)(JSON.parse(notif.attributes.data), notif.attributes.reference_id), onClick: function onClick() {
	                      handleClick(notif.id, JSON.parse(notif.attributes.data));
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { direction: 'left' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'f-left' },
	                      _react2.default.createElement('span', { className: 'mobile-notif-icon ' + JSON.parse(notif.attributes.data).icon })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { direction: 'right', className: 'mobile-notif-details' },
	                      JSON.parse(notif.attributes.data).redirection_type === "prohibited" ? _react2.default.createElement(
	                        'span',
	                        { className: 'vertical-box-orient' },
	                        notif.attributes.template,
	                        ' ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'notif-tracking' },
	                          notif.attributes.reference_id
	                        )
	                      ) : JSON.parse(notif.attributes.data).redirection_type === "order_details" ? _react2.default.createElement(
	                        'span',
	                        { className: 'vertical-box-orient' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'notif-tracking' },
	                          JSON.parse(notif.attributes.data).tracking_number,
	                          ' '
	                        ),
	                        notif.attributes.template
	                      ) : JSON.parse(notif.attributes.data).redirection_type === "payment_success" ? _react2.default.createElement(
	                        'span',
	                        { className: 'vertical-box-orient' },
	                        notif.attributes.template,
	                        ' ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'notif-tracking' },
	                          JSON.parse(notif.attributes.data).tracking_number
	                        )
	                      ) : _react2.default.createElement(
	                        'span',
	                        { className: 'vertical-box-orient' },
	                        notif.attributes.template,
	                        ' (Transaction #',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'notif-tracking' },
	                          notif.attributes.reference_id
	                        ),
	                        ')'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'notif-date' },
	                        (0, _dateFns.format)(notif.attributes.created_at, "MM/DD/YYYY hh:mma")
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'mobile-mark-read' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('i', { className: 'markasread icon-markasread', 'aria-hidden': 'true', role: 'button', onClick: function onClick() {
	                        handleClick(notif.id);
	                      } })
	                  )
	                )
	              );
	            }) : _react2.default.createElement(
	              'li',
	              { className: 'center mobile-empty' },
	              _react2.default.createElement('span', { className: 'mobile-icon-empty icon-notif-empty' }),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'h4',
	                { className: 'empty-msg' },
	                'You have no notification'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'see-all' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/notification' },
	            'See all notifications'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'overlay-menu',
	        'data-do': 'notification',
	        'data-on': 'click',
	        onClick: function onClick() {
	          handleOverlayClick();
	        },
	        style: {
	          opacity: 1,
	          zIndex: 999
	        } },
	      _react2.default.createElement('i', { className: 'fa fa-chevron-right' })
	    )
	  );
	};
	
	exports.default = MobileNotifMenu;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _constants = __webpack_require__(124);
	
	var _brandIconWhite = __webpack_require__(316);
	
	var _brandIconWhite2 = _interopRequireDefault(_brandIconWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileProfileMenu = function MobileProfileMenu(_ref) {
	  var isShown = _ref.isShown,
	      login = _ref.login,
	      isAuthenticated = _ref.isAuthenticated,
	      isMenuDisabled = _ref.isMenuDisabled,
	      logout = _ref.logout,
	      closeMenu = _ref.closeMenu;
	
	  var renderFirstName = function renderFirstName() {
	    var firstName = '';
	    if (login && login.login.party && login.login.party.first_name) {
	      firstName = login.login.party.first_name;
	    }
	    return firstName;
	  };
	
	  return isShown && _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "nav",
	      { id: "fullSidebarNav", className: "sidenav open-nav mobile-menu-wrapper" },
	      _react2.default.createElement("img", { alt: "logo", src: _brandIconWhite2.default }),
	      _react2.default.createElement(
	        "p",
	        { style: { margin: '40px 0px 20px 0px', fontWeight: 600 } },
	        "Hello! ",
	        renderFirstName(),
	        "."
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: "mobile-list" },
	        _constants.accountLinks.map(function (link, i) {
	          return _react2.default.createElement(
	            "li",
	            { key: i, onClick: function onClick() {
	                closeMenu();
	              } },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: link.route, className: isMenuDisabled && link.route === '/cart' ? 'isDisabled' : '' },
	              link.label
	            )
	          );
	        }),
	        _react2.default.createElement(
	          "li",
	          { onClick: function onClick() {
	              closeMenu();
	            } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/", onClick: logout },
	            " Logout "
	          )
	        )
	      )
	    ),
	    _react2.default.createElement("div", {
	      className: "overlay-menu",
	      "data-do": "hamburger",
	      "data-on": "click",
	      onClick: function onClick() {
	        closeMenu();
	      },
	      style: {
	        opacity: 1,
	        zIndex: 999
	      } })
	  );
	};
	
	exports.default = MobileProfileMenu;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _notification = __webpack_require__(319);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _notificationActive = __webpack_require__(318);
	
	var _notificationActive2 = _interopRequireDefault(_notificationActive);
	
	var _utils = __webpack_require__(13);
	
	var _ToolTip = __webpack_require__(629);
	
	var _ToolTip2 = _interopRequireDefault(_ToolTip);
	
	var _dateFns = __webpack_require__(54);
	
	var _notificationTemplate = __webpack_require__(257);
	
	var _warehouseFlags = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationMenu = function NotificationMenu(_ref) {
	  var notification = _ref.notification,
	      readNotification = _ref.readNotification,
	      readAllNotification = _ref.readAllNotification,
	      isAuthenticated = _ref.isAuthenticated;
	
	
	  var handleClick = function handleClick(id, data) {
	    var read = 1;
	    readNotification(id, read);
	
	    if (data && data.redirection_type === 'delivered') {
	      window.open('https://www.surveymonkey.com/r/5CWMVST?account_number=' + data.account_number + '&tracking_number=' + data.tracking_number + '&date_delivered=' + data.delivered_date + '&origin_country=' + data.origin + '&shipment_method=' + data.shipment_method, "_blank");
	    }
	  };
	  var handleNotifIcon = function handleNotifIcon(data) {
	    if (data.redirection_type === "vas_payment_failed") {
	      return 'icon-request-payment-canceled-rejected';
	    }
	    if (data.redirection_type === "vas_rejected") {
	      return 'icon-request-status-canceled-rejected';
	    }
	    if (data.redirection_type === "vas_approved") {
	      return 'vas-status-inprogress';
	    }
	    return data.icon;
	  };
	
	  var handleReadAll = function handleReadAll() {
	    var read = 1;
	    var id = notification ? notification[0].attributes.party_id : null;
	    readAllNotification(id, read);
	  };
	  return isAuthenticated && _react2.default.createElement(
	    'div',
	    { className: 'notif-dropdown has-sub', style: { display: 'flex', alignItems: 'center' } },
	    _react2.default.createElement('img', { className: 'dropdown-toggle', 'data-toggle': 'dropdown', alt: 'icon', src: !!notification.length ? _notificationActive2.default : _notification2.default, style: { paddingRight: 20, borderRight: '1px solid #E2E2E2' } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'sub sub-info dropdown-menu notification' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'notif-title' },
	        'Notification',
	        notification.length >= 2 ? "s" : null,
	        ' \xA0\xA0',
	        notification.length === 0 ? null : _react2.default.createElement(
	          'span',
	          { className: 'notif-count' },
	          notification.length,
	          ' new'
	        ),
	        notification.length === 0 ? null : _react2.default.createElement(
	          'span',
	          { className: 'notif-mark', role: 'button', onClick: function onClick() {
	              handleReadAll();
	            } },
	          'Mark all as read ',
	          _react2.default.createElement('span', { className: 'markasread icon-markasread' }),
	          ' '
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'notif-body' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'notif-ul' },
	          notification.length !== 0 ? notification.map(function (notif) {
	            return _react2.default.createElement(
	              'li',
	              { className: 'notif-list notif-link', key: notif.id, style: { margin: 10 } },
	              _react2.default.createElement(
	                'div',
	                { direction: 'left', style: { display: 'flex', justifyContent: 'flex-end' } },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: (0, _utils.maskRedirectLink)(JSON.parse(notif.attributes.data), notif.attributes.reference_id),
	                    style: { display: 'flex', alignItems: 'center' },
	                    onClick: function onClick() {
	                      handleClick(notif.id, JSON.parse(notif.attributes.data));
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'f-left', style: { marginRight: '10px' } },
	                    _react2.default.createElement('span', { className: 'notif-icon ' + handleNotifIcon(JSON.parse(notif.attributes.data)) })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: (0, _utils.maskRedirectLink)(JSON.parse(notif.attributes.data), notif.attributes.reference_id),
	                    style: { textDecoration: 'none' },
	                    onClick: function onClick() {
	                      handleClick(notif.id, JSON.parse(notif.attributes.data));
	                    } },
	                  _react2.default.createElement(
	                    'div',
	                    { direction: 'right', className: 'notif-details' },
	                    JSON.parse(notif.attributes.data).warehouse && _react2.default.createElement(
	                      'span',
	                      { className: 'notif-tracking' },
	                      _react2.default.createElement('img', { src: (0, _warehouseFlags.renderFlagSquareSmall)(JSON.parse(notif.attributes.data).warehouse), alt: 'warehouse', style: { width: '29px', height: '27px', margin: '-1px 0px -4px -5px' } }),
	                      (0, _notificationTemplate.notificationTemplate)(notif.attributes)
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'clamp-line vertical-box-orient ' },
	                      notif.attributes.template
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'notif-date' },
	                      (0, _dateFns.format)(notif.attributes.created_at, "MM/DD/YYYY hh:mma")
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _ToolTip2.default,
	                    { message: 'Mark as read', position: 'top' },
	                    _react2.default.createElement('i', { className: 'markasread icon-markasread', 'aria-hidden': 'true', role: 'button', onClick: function onClick() {
	                        handleClick(notif.id, notif);
	                      } })
	                  )
	                )
	              )
	            );
	          }) : _react2.default.createElement(
	            'li',
	            { className: 'center empty' },
	            _react2.default.createElement('span', { className: 'notif-empty icon-notif-empty' }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'h4',
	              { className: 'empty-msg' },
	              'You have no notification'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'see-all' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/notification' },
	          'See all notifications'
	        )
	      )
	    )
	  );
	};
	
	exports.default = NotificationMenu;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _angleLeftWhite = __webpack_require__(870);
	
	var _angleLeftWhite2 = _interopRequireDefault(_angleLeftWhite);
	
	var _constants = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondaryMenu = function SecondaryMenu(accountNumber, firstName) {
	  var renderMenuDropdown = function renderMenuDropdown(label, menu, isHelpCenter) {
	    return _react2.default.createElement(
	      'li',
	      { className: 'dropdown secondary-nav-link' },
	      _react2.default.createElement(
	        'div',
	        { className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
	        label,
	        _react2.default.createElement(
	          'span',
	          { className: 'margin-left-10' },
	          _react2.default.createElement('img', { className: 'rotate-icon', alt: 'icon', src: _angleLeftWhite2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'dropdown-menu secondary-nav-links-wrapper' },
	        menu.map(function (_ref) {
	          var title = _ref.title,
	              url = _ref.url,
	              external = _ref.external,
	              id = _ref.id;
	          return !external ? _react2.default.createElement(
	            'li',
	            { className: 'list-item' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { id: id, to: url },
	              title
	            )
	          ) : _react2.default.createElement(
	            'li',
	            { className: 'list-item' },
	            _react2.default.createElement(
	              'a',
	              { id: id, target: '_blank', href: url },
	              title
	            )
	          );
	        }),
	        isHelpCenter && _react2.default.createElement(
	          'li',
	          { li: true, className: 'secondary-dropdown' },
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: 16, padding: '0px 20px', color: '#fff' } },
	            'Legal',
	            _react2.default.createElement(
	              'span',
	              { className: 'margin-left-10 rotate-icon' },
	              _react2.default.createElement('img', { alt: 'icon', className: 'rotate-icon-sub', src: _angleLeftWhite2.default })
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'secondary-dropdown-menu' },
	            _constants.legalMenu.map(function (_ref2) {
	              var title = _ref2.title,
	                  url = _ref2.url,
	                  external = _ref2.external,
	                  id = _ref2.id;
	              return !external ? _react2.default.createElement(
	                'li',
	                { className: 'list-item' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { id: id, to: url },
	                  title
	                )
	              ) : _react2.default.createElement(
	                'li',
	                { className: 'list-item' },
	                _react2.default.createElement(
	                  'a',
	                  { id: id, target: '_blank', href: url },
	                  title
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'secondary-nav' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'secondary-nav-links' },
	      renderMenuDropdown('Where to shop', _constants.whereToShopMenu),
	      renderMenuDropdown('Services', _constants.servicesMenu),
	      renderMenuDropdown('Offers', (0, _constants.offersMenu)(accountNumber, firstName)),
	      renderMenuDropdown('Help Center', _constants.helpCenterMenu, true)
	    )
	  );
	};
	
	exports.default = SecondaryMenu;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(20);
	
	var _MobileHeader = __webpack_require__(122);
	
	var _MobileHeader2 = _interopRequireDefault(_MobileHeader);
	
	var _Header = __webpack_require__(123);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	__webpack_require__(823);
	
	__webpack_require__(827);
	
	__webpack_require__(841);
	
	__webpack_require__(831);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _analyticsEvents = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var Main = createReactClass({
	  displayName: 'Main',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      isHome: true,
	      isSideNavOpen: false,
	      cmsList: [],
	      loading: true,
	      footerLinks: ["2", "3", "4", "7"],
	      bottomNavLinks: ["1", "5", "6"],
	      bottomNavLinksClass: ["first about pull-left", "second terms pull-left", "third privacy pull-left"]
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.props.location.pathname !== "/home" && this.props.location.pathname !== "/" ? this.setState({ isHome: false }) : this.setState({ isHome: true });
	    this.props.getCMSList();
	    this.props.getCopyrightYear();
	    (0, _analyticsEvents.gtmPush)({
	      event: 'view',
	      platform: 'web'
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this = this;
	
	    window.scrollTo(0, 0);
	    if (this.props.location.pathname !== nextProps.location.pathname) {
	      if (nextProps.location.pathname === "/home" || nextProps.location.pathname === "/") {
	        this.setState({ isHome: true });
	      } else {
	        this.setState({ isHome: false });
	      }
	    }
	    this.setState({
	      cmsList: nextProps.cms.getCmsList ? nextProps.cms.CmsList.data : []
	    });
	    if (nextProps.cms.getHomePageFetching) {
	      this.setState({ loading: true });
	    }
	    if (nextProps.cms.getHomePage) {
	      this.setState({ loading: false });
	    }
	    if (nextProps.cms.getMainBannerListFetching) {
	      this.setState({ loading: true });
	    }
	    if (nextProps.cms.getMainBannerList) {
	      this.setState({ loading: false });
	    }
	    if (nextProps.cms.fetching) {
	      this.setState({ loading: true });
	    }
	    // HAM : 404 page and shipping-estimates should show the footer
	    if (nextProps.cms.getCms || nextProps.cms.CmsContent === null) {
	      this.setState({ loading: false });
	    }
	    if (nextProps.location.pathname === "/home" || nextProps.location.pathname === "/") {
	      this.setState({ loading: true }, function () {
	        nextProps.cms.getHomePage ? _this.setState({ loading: false }) : _this.setState({ loading: true });
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.login.error) {
	      if (this.props.login.error.response && this.props.login.error.response.data.status === 401) {
	        _store.history.push("/signin");
	      }
	      if (this.props.login.error && this.props.login.error.data && this.props.login.error.data.status === 401) {
	        _store.history.push("/signin");
	      }
	    }
	  },
	  handleTrackPackage: function handleTrackPackage() {
	    localStorage.setItem("trackPackage", "true");
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: this.state.isHome ? "home index" : "home" },
	      window.location.pathname !== '/otp-service' ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_MobileHeader2.default, {
	          isAuthenticated: this.props.auth.isAuthenticated,
	          login: this.props.login,
	          isSideNavOpen: this.state.isSideNavOpen,
	          logout: this.props.logout
	        }),
	        _react2.default.createElement(_Header2.default, {
	          isAuthenticated: this.props.auth.isAuthenticated,
	          login: this.props.login,
	          logout: this.props.logout
	        })
	      ) : null,
	      _react2.default.cloneElement(Object.assign({}, this.props).children, Object.assign({}, this.props)),
	      _react2.default.createElement(_Footer2.default, {
	        currentPath: this.props.location.pathname,
	        currentYear: this.props.login.year
	      })
	    );
	  }
	});
	exports.default = Main;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _reactRouter = __webpack_require__(14);
	
	var _dateFns = __webpack_require__(54);
	
	__webpack_require__(833);
	
	var _ParcelAction = __webpack_require__(72);
	
	var _utils = __webpack_require__(13);
	
	var _notificationTemplate = __webpack_require__(257);
	
	var _warehouseFlags = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notification = function (_Component) {
	  _inherits(Notification, _Component);
	
	  function Notification() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Notification);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.handleNotifIcon = function (data) {
	      if (data.redirection_type === "vas_payment_failed") {
	        return 'icon-request-payment-canceled-rejected';
	      }
	      if (data.redirection_type === "vas_rejected") {
	        return 'icon-request-status-canceled-rejected';
	      }
	      if (data.redirection_type === "vas_approved") {
	        return 'vas-status-inprogress';
	      }
	      return data.icon;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Notification, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.isAuthenticated && this.props.login.fetched) {
	        var id = this.props.login.login.party.party_id;
	        this.props.getNotification(id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'handleClick',
	    value: function handleClick(id, data) {
	      var read = 1;
	      this.props.readNotification(id, read);
	      if (data && data.redirection_type === 'delivered') {
	        window.open('https://www.surveymonkey.com/r/5CWMVST?account_number=' + data.account_number + '&tracking_number=' + data.tracking_number + '&date_delivered=' + data.delivered_date + '&origin_country=' + data.origin + '&shipment_method=' + data.shipment_method, "_blank");
	      }
	    }
	  }, {
	    key: 'handleReadAll',
	    value: function handleReadAll() {
	      var read = 1;
	      var id = this.props.parcel.notification_fetched ? this.props.parcel.notification.data[0].attributes.party_id : null;
	      this.props.readAllNotification(id, read);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var notification = this.props.parcel.notification_fetched ? this.props.parcel.notification.data : null;
	      var notifLenght = this.props.parcel.notification_fetched ? this.props.parcel.notification.data.filter(function (notif) {
	        return notif.attributes.read === 0;
	      }).length : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'body-wrapper container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'notification-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Notification',
	                notification ? notification.length >= 2 ? "s" : null : null,
	                ' \xA0',
	                !notifLenght ? null : _react2.default.createElement(
	                  'span',
	                  { className: 'notif-count' },
	                  notifLenght !== 0 ? notifLenght : null,
	                  ' new'
	                ),
	                !notifLenght ? null : _react2.default.createElement(
	                  'span',
	                  { className: 'notification-mark', role: 'button', onClick: this.handleReadAll.bind(this) },
	                  'Mark all as read ',
	                  _react2.default.createElement('span', { className: 'markasread icon-markasread' }),
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            notification ? notification.map(function (notif) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'notification-list ' + (notif.attributes.read === 0 ? 'notif-unread' : "") + ' ', key: notif.id },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { className: 'notification-link', to: (0, _utils.maskRedirectLink)(JSON.parse(notif.attributes.data), notif.attributes.reference_id), onClick: _this2.handleClick.bind(_this2, notif.id, JSON.parse(notif.attributes.data)) },
	                  _react2.default.createElement(
	                    'div',
	                    { direction: 'left' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'f-left' },
	                      _react2.default.createElement('span', { className: 'notification-icon ' + _this2.handleNotifIcon(JSON.parse(notif.attributes.data)) })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { direction: 'right', className: 'notification-details' },
	                      JSON.parse(notif.attributes.data).warehouse && _react2.default.createElement(
	                        'span',
	                        { className: 'notif-tracking' },
	                        _react2.default.createElement('img', { src: (0, _warehouseFlags.renderFlagSquareSmall)(JSON.parse(notif.attributes.data).warehouse), alt: 'warehouse', style: { width: '29px', height: '27px', margin: '-1px 0px -4px -5px' } }),
	                        (0, _notificationTemplate.notificationTemplate)(notif.attributes)
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        notif.attributes.template
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'notif-date' },
	                        (0, _dateFns.format)(notif.attributes.created_at, "MM/DD/YYYY hh:mma")
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: notif.attributes.read === 0 ? "mark-read" : "hide" },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('i', { className: 'markread icon-markasread', 'aria-hidden': 'true', role: 'button', onClick: _this2.handleClick.bind(_this2, notif.id) })
	                  )
	                )
	              );
	            }) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react.Component);
	
	var mapDispachToProps = { getNotification: _ParcelAction.getNotification, readNotification: _ParcelAction.readNotification, readAllNotification: _ParcelAction.readAllNotification };
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    parcel: state.parcel
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(Notification);
	//export default Notification;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOtpInput = __webpack_require__(1109);
	
	var _reactOtpInput2 = _interopRequireDefault(_reactOtpInput);
	
	var _reactRecaptcha = __webpack_require__(529);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	__webpack_require__(834);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Signup = __webpack_require__(90);
	
	var _Signin = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OneTimePassword = function (_Component) {
	  _inherits(OneTimePassword, _Component);
	
	  function OneTimePassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OneTimePassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OneTimePassword.__proto__ || Object.getPrototypeOf(OneTimePassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      otpValue: '',
	      error: null,
	      disabledLink: false,
	      payload: null,
	      time: 30,
	      recaptcha: ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OneTimePassword, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (localStorage.otp_response) {
	        this.setState({ payload: JSON.parse(localStorage.getItem('otp_response')) });
	      } else {
	        _store.history.goBack();
	      }
	      this.startTimer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      localStorage.removeItem('otp_response');
	      localStorage.removeItem('otp_redirect');
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var error = null;
	      if (nextProps.login.sendOTPError !== this.props.login.sendOTPError) {
	        if (localStorage.getItem('otp_redirect') === 'signup') {
	          error = nextProps.login.sendOTPError && nextProps.login.sendOTPError.response && nextProps.login.sendOTPError.response.data.errors.detail.otp_code;
	          this.setState({ error: error });
	        } else {
	          error = nextProps.login.sendOTPError && nextProps.login.sendOTPError.data && nextProps.login.sendOTPError.data.errors.detail.otp_code;
	          this.setState({ error: error });
	        }
	      }
	      if (this.props.register.register !== nextProps.register.register) {
	        this.setState({ payload: nextProps.register.register });
	      }
	      if (this.props.login.sendOTPSuccess !== nextProps.login.sendOTPSuccess) {
	        this.setState({ payload: nextProps.login.sendOTPSuccess });
	      }
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(otpValue) {
	      if (otpValue.match(/^[0-9]*$/)) {
	        this.setState({ otpValue: otpValue, error: null });
	      }
	      return;
	    }
	  }, {
	    key: 'handleEnable',
	    value: function handleEnable() {
	      if (this.state.otpValue) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'sendOtpCode',
	    value: function sendOtpCode(e) {
	      e.preventDefault();
	      //this.props.sendOtp(this.props.payload, this.state.otp);
	      if (localStorage.getItem('otp_redirect') === 'signup') {
	        _store2.default.dispatch((0, _Signup.sendOtp)(this.state.payload, this.state.otpValue));
	      }
	      if (localStorage.getItem('otp_redirect') === 'account') {
	        _store2.default.dispatch((0, _Signin.updateCustomerProfile)(this.state.payload, this.state.otpValue));
	      }
	      if (localStorage.getItem('otp_redirect') === 'requiredModal') {
	        this.props.addCustomerProfile(this.state.payload, this.state.otpValue);
	      }
	    }
	  }, {
	    key: 'resendOtpCode',
	    value: function resendOtpCode(e) {
	      e.preventDefault();
	      if (localStorage.getItem('otp_redirect') === 'signup') {
	        var copyPayload = Object.assign({}, this.state.payload);
	        copyPayload.recaptcha = this.state.recaptcha;
	        _store2.default.dispatch((0, _Signup.signup)(copyPayload));
	      }
	      if (localStorage.getItem('otp_redirect') === 'account') {
	        _store2.default.dispatch((0, _Signin.putReSendOTP)(this.state.payload, null));
	      }
	      if (localStorage.getItem('otp_redirect') === 'requiredModal') {
	        this.props.putReSendOTPRequired(this.state.payload);
	      }
	      this.startTimer();
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this2 = this;
	
	      this.setState({ disabledLink: true });
	      this.timer = window.setInterval(function () {
	        _this2.setState({ time: _this2.state.time - 1 }, function () {
	          if (_this2.state.time === 0) {
	            _this2.setState({ time: 1, disabledLink: false });
	            clearInterval(_this2.timer);
	          }
	        }); // <-- Change this line!
	      }, 1000);
	      if (this.state.time === 0) {
	        this.setState({ time: 1, disabledLink: false });
	        clearInterval(this.timer);
	      }
	    }
	  }, {
	    key: 'verifyCallback',
	    value: function verifyCallback(response) {
	      this.setState({ recaptcha: response });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'body-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { id: 'shippingcart_app', className: 'header-original' },
	            _react2.default.createElement(
	              'div',
	              { className: 'otp-header' },
	              _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/img/sc-logo.png', alt: '' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'container otp-page-body' },
	              _react2.default.createElement(
	                'div',
	                { className: 'center' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'One-Time Password'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'otp-border' },
	                _react2.default.createElement(
	                  'form',
	                  { className: 'form-horizontal' },
	                  _react2.default.createElement(
	                    'section',
	                    { className: 'modal-body' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'control' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'You will receive a one-time password (OTP) on your registered mobile number ending in ',
	                        this.state.payload.phone_number && this.state.payload.phone_number.slice(this.state.payload.phone_number.length - 4)
	                      ),
	                      _react2.default.createElement(_reactOtpInput2.default, {
	                        onChange: function onChange(otp) {
	                          return _this3.handleInputChange(otp);
	                        },
	                        numInputs: 6,
	                        value: this.state.otpValue,
	                        separator: _react2.default.createElement(
	                          'span',
	                          null,
	                          '\xA0\xA0'
	                        ),
	                        shouldAutoFocus: true,
	                        inputStyle: 'otp-input-style',
	                        hasErrored: this.state.error !== null ? true : false,
	                        errorStyle: 'otp-error-style'
	                      })
	                    ),
	                    this.state.error ? _react2.default.createElement(
	                      'label',
	                      { className: 'inline-error-message' },
	                      this.state.error
	                    ) : null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Did not receive one-time password (OTP)?'
	                    ),
	                    !this.state.disabledLink && localStorage.getItem('otp_redirect') === 'signup' && _react2.default.createElement(_reactRecaptcha2.default, { sitekey: '6Ld0ERUUAAAAAP_R4QOXrx2K-furHNW55cv26LGF',
	                      size: 'default', render: 'explicit',
	                      verifyCallback: this.verifyCallback.bind(this),
	                      style: { margin: '10px' }
	                      // onChange={this.handleOnChange}
	                    }),
	                    _react2.default.createElement(
	                      'a',
	                      { className: this.state.disabledLink || !this.state.recaptcha && localStorage.getItem('otp_redirect') === 'signup' ? "link-disabled" : "", onClick: function onClick(e) {
	                          return !_this3.state.disabledLink || _this3.state.recaptcha && localStorage.getItem('otp_redirect') === 'signup' ? _this3.resendOtpCode(e) : "";
	                        } },
	                      'Resend ',
	                      this.state.disabledLink ? 'after ' + this.state.time + ' seconds' : 'OTP'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'otp-footer' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', onClick: function onClick(e) {
	                          return _this3.sendOtpCode(e);
	                        }, className: 'sc-btn primary-btn', disabled: this.handleEnable() },
	                      'Send'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OneTimePassword;
	}(_react.Component);
	
	exports.default = OneTimePassword;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var PageNotFound = createReactClass({
	    displayName: 'PageNotFound',
	    componentWillMount: function componentWillMount() {
	        if (localStorage.jwtToken) {
	            var token = localStorage.jwtToken;
	            this.props.signedIn(token);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        window.scrollTo(0, 0);
	    },
	    render: function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'body-wrapper' },
	                _react2.default.createElement(
	                    'section',
	                    { className: 'container not-found' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'main-img' },
	                            _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/404-image4.jpg', className: 'img-responsive' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'main-right' },
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                'Can\'t find what you\'re looking for?'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Page was most likely moved, updated, or removed. These should point you in the right direction:'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'help-static' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' }),
	                                    'Want to know ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/usa-to-philippines-shipping' },
	                                        'how to use'
	                                    ),
	                                    ' ShippingCart?'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' }),
	                                    'Want to know our ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/shipping-rates-usa-to-philippines' },
	                                        'rates'
	                                    ),
	                                    '?'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' }),
	                                    'Want to know our current ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/promotions' },
	                                        'promos'
	                                    ),
	                                    '?'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' }),
	                                    'Have other questions? Visit our ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/faqs' },
	                                        'help center'
	                                    ),
	                                    '.'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'help-category' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Need help on where to shop for finds in the US?'
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/shop-health-beauty' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'category' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cat1' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'image' },
	                                                _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/shop-health-page.png' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'text' },
	                                                'Shop Health & Beauty'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'arrow' },
	                                                _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/shop-home-garden' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'category' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cat2' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'image' },
	                                                _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/shop-home-page.png' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'text' },
	                                                'Shop Home & Garden'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'arrow' },
	                                                _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/shop-gadgets-electronics' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'category' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cat3' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'image' },
	                                                _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/shop-gadget-page.png' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'text' },
	                                                'Shop Gadgets & Electronics'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'arrow' },
	                                                _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/shop-fashion-clothing' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'category' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cat4' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'image' },
	                                                _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/shop-fashion-page.png' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'text' },
	                                                'Shop Fashion & Clothing'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'arrow' },
	                                                _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/mens-finds' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'category' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cat5' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'image' },
	                                                _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/shop-men-page2.png' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'text' },
	                                                'Men\'s Finds'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'arrow' },
	                                                _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/womens-finds' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'category' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cat6' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'image' },
	                                                _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/shop-women-page-2.png' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'text' },
	                                                'Women\'s Finds'
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'arrow' },
	                                                _react2.default.createElement('i', { className: 'fa fa-chevron-right', 'aria-hidden': 'true' })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'prohibited' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'cat6' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'image' },
	                                            _react2.default.createElement('img', { alt: 'temp', src: 'https://cdn.shippingcart.com/images/front/prohibited-icon-page.png' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'text' },
	                                            'NOTE: There are certain items that are prohibited. ShippingCart WILL NOT process any orders for these items. Check list  ',
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: '/prohibited-items' },
	                                                'here'
	                                            ),
	                                            '.'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	exports.default = PageNotFound;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(838);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RestrictedComponent() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'tool-tip' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('i', {
	        className: 'fa fa-exclamation-circle',
	        style: { marginRight: '5px', color: '#feab10' } }),
	      'Suspended Delivery Location'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { width: '30%' } },
	      _react2.default.createElement(
	        'a',
	        { href: '/covid19-response', target: 'blank', style: { color: '#000' } },
	        'See full list',
	        _react2.default.createElement('i', { className: 'fa fa-chevron-right', style: { marginLeft: '5px' } })
	      )
	    )
	  );
	}
	
	exports.default = RestrictedComponent;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(114);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(46);
	
	var _reactRouter = __webpack_require__(14);
	
	var _jquery = __webpack_require__(40);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(840);
	
	var _utils = __webpack_require__(13);
	
	var _DashboardActions = __webpack_require__(239);
	
	var _uuid = __webpack_require__(70);
	
	var _whiteListed = __webpack_require__(93);
	
	var _OutBoundBanner = __webpack_require__(92);
	
	var _OutBoundBanner2 = _interopRequireDefault(_OutBoundBanner);
	
	var _ShippingEstimateBreakdown = __webpack_require__(623);
	
	var _ShippingEstimateBreakdown2 = _interopRequireDefault(_ShippingEstimateBreakdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// import AlertAdvisory from './AlertAdvisory';
	
	var createReactClass = __webpack_require__(16);
	var metadata = "Calculate how much your US/UK package will cost when you have it delivered to the PH. Click here to use ShippingCart’s free cost estimator tool.";
	var ShippingEstimate = createReactClass({
	  displayName: 'ShippingEstimate',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      weight_status: true,
	      length_status: true,
	      width_status: true,
	      height_status: true,
	      insured_status: true,
	      insured_value_status: true,
	      max_weight: 6,
	      max_length: 5,
	      max_width: 5,
	      max_height: 5,
	      max_insured: 8,
	      length: "",
	      width: "",
	      height: "",
	      insured: "",
	      number: "",
	      calculated: false,
	      insured_value_text: "",
	      optionsState: "",
	      origin: '3',
	      destination: "PH",
	      offsize: false,
	      selectDefaultValue: "",
	      selectDefaultLabel: "None",
	      submitted: false
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.props.getWarehouse();
	    this.props.clearEstimate();
	    (0, _jquery2.default)('#SCTitle').text("Get Shipping Estimate | ShippingCart");
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	    this.refs.weight.focus();
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var insurance_max = null;
	    if (this.state.settings) {
	      var insurance = null;
	      insurance = this.state.settings.filter(function (data) {
	        return data.name === "general_setting";
	      });
	      insurance_max = insurance ? parseFloat(JSON.parse(insurance[0].settings).insurance_max_value.value) : null;
	      this.setState({ insurance_max: insurance_max });
	    }
	    if (nextProps.estimate.fetched) {
	      this.setState({ calculated: true });
	    }
	    if (nextProps.estimate.fetched) {
	      this.setState({
	        weight_status: true,
	        length_status: true,
	        width_status: true,
	        height_status: true,
	        insured_status: true,
	        insured_value_status: true
	      });
	    }
	    if (nextProps.estimate.error !== null) {
	      if (nextProps.estimate.error.response && nextProps.estimate.error.response.data.parameters) {
	        if (this.state.insured > insurance_max) {
	          this.setState({
	            insured_status: false, calculated: false, insured_value_status: false,
	            insured_value_text: 'Insured value cannot be over ' + insurance_max
	          });
	        }
	        if (nextProps.estimate.error.response.data.parameters["item.insured_value"]) {
	          this.setState({ insured_status: false, calculated: false });
	        }
	        if (nextProps.estimate.error.response.data.parameters["item.height"]) {
	          this.setState({ height_status: false, calculated: false });
	        }
	        if (nextProps.estimate.error.response.data.parameters["item.width"]) {
	          this.setState({ width_status: false, calculated: false });
	        }
	        if (nextProps.estimate.error.response.data.parameters["item.length"]) {
	          this.setState({ length_status: false, calculated: false });
	        }
	        if (nextProps.estimate.error.response.data.parameters["item.weight"]) {
	          this.setState({ weight_status: false, calculated: false });
	        }
	      }
	    }
	    if (nextProps.settings.destinationSettings !== this.props.settings.destinationSettings) {
	      var data = nextProps.settings.destinationSettings.data;
	
	      var settings = data.map(function (item) {
	        return item;
	      });
	      this.setState({ settings: settings });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.warehouse.warehouse !== this.props.warehouse.warehouse) {
	      this.props.getDestinationSettings(this.props.warehouse.warehouse.data[0].id, this.state.destination);
	    }
	    if (prevState.origin !== this.state.origin) {
	      this.props.getDestinationSettings(this.state.origin, this.state.destination);
	    }
	    if (prevState.destination !== this.state.destination) {
	      this.props.getDestinationSettings(this.state.origin, this.state.destination);
	    }
	  },
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	    var weight = this.refs.weight.value;
	    var length = this.refs.length.value;
	    var width = this.refs.width.value;
	    var height = this.refs.height.value;
	    var insured_value = this.refs.insured_value.value;
	    var special_handling = "";
	
	    //this.checkMaxInsuredSetting();
	
	    if (this.refs.special_handling.value === "") {
	      special_handling = "0";
	    } else {
	      special_handling = "1";
	    }
	
	    var sc_protect = void 0;
	    if (this.state.destination !== 'MY') {
	      sc_protect = { avail: 1 };
	    }
	
	    this.setState({ weight_status: true, height_status: true, length_status: true, width_status: true, insured_status: true, insured_value_status: true });
	    this.props.getEstimate(weight, length, width, height, insured_value, special_handling, this.state.origin, this.state.destination, sc_protect);
	  },
	  reset: function reset(e) {
	    e.preventDefault();
	    this.refs.weight.value = "";
	    this.refs.length.value = "";
	    this.refs.height.value = "";
	    this.refs.width.value = "";
	    this.refs.insured_value.value = "";
	    this.refs.special_handling.value = "";
	    this.props.clearEstimate();
	
	    window.scrollTo(0, 0);
	    this.setState({ calculated: false });
	    this.setState({
	      number: "",
	      length: "",
	      height: "",
	      width: "",
	      insured: "",
	      insured_value_text: "",
	      weight_status: true,
	      length_status: true,
	      width_status: true,
	      height_status: true,
	      insured_status: true,
	      insured_value_status: true,
	      offsize: false,
	      selectDefaultValue: "",
	      selectDefaultLabel: "None"
	    });
	    this.refs.weight.focus();
	  },
	  weightValidator: function weightValidator(event) {
	    var num = event.target.value;
	
	    if (num.length === 0) {
	      this.refs.weight.value = "";
	    }
	
	    if (num.length === 1) {
	      //1 digit
	      this.setState({ max_weight: 6 });
	
	      if (!isNaN(num) && num !== 0) {
	        this.setState({ number: num });
	      } else {
	        //NOT a number.
	        this.refs.weight.value = "";
	      }
	    } else {
	      // 2 or more digits
	      if (!isNaN(num)) {
	        //if it is a NUMBER
	
	        if (num < 10) {
	          this.setState({ number: num });
	          if (num.length === 4) {
	            this.setState({ max_weight: 4 });
	          }
	        } else if (num >= 10 && num < 100) {
	          this.setState({ number: num });
	          if (num.length === 5) {
	            this.setState({ max_weight: 5 });
	          }
	        } else if (num >= 100 && num < 1000) {
	          this.setState({ number: num });
	          if (num.length === 6) {
	            this.setState({ max_weight: 6 });
	          }
	        } else if (num >= 1000) {
	          this.refs.weight.value = this.state.number;
	        }
	      } else {
	        // NOT a number.
	        this.refs.weight.value = this.state.number;
	      }
	    }
	  },
	  lengthValidator: function lengthValidator(event) {
	    var num = event.target.value;
	
	    if (num.length === 0) {
	      this.refs.length.value = "";
	    }
	
	    if (num.length === 1) {
	      //1 digit
	      this.setState({ max_length: 5 });
	
	      if (!isNaN(num) && num !== 0) {
	        this.setState({ length: num });
	      } else {
	        //NOT a number.
	        this.refs.length.value = "";
	      }
	    } else {
	      // 2 or more digits
	      if (!isNaN(num)) {
	        //if it is a NUMBER
	
	        if (num < 10) {
	          this.setState({ length: num });
	          if (num.length === 4) {
	            this.setState({ max_length: 4 });
	          }
	        } else if (num >= 10 && num < 100) {
	          this.setState({ length: num });
	          if (num.length === 5) {
	            this.setState({ max_length: 5 });
	          }
	        } else if (num >= 100) {
	          this.refs.length.value = this.state.length;
	        }
	      } else {
	        // NOT a number.
	        this.refs.length.value = this.state.length;
	      }
	    }
	  },
	  widthValidator: function widthValidator(event) {
	    var num = event.target.value;
	
	    if (num.length === 0) {
	      this.refs.width.value = "";
	    }
	
	    if (num.length === 1) {
	      //1 digit
	      this.setState({ max_width: 5 });
	
	      if (!isNaN(num) && num !== 0) {
	        this.setState({ width: num });
	      } else {
	        //NOT a number.
	        this.refs.width.value = "";
	      }
	    } else {
	      // 2 or more digits
	      if (!isNaN(num)) {
	        //if it is a NUMBER
	
	        if (num < 10) {
	          this.setState({ width: num });
	          if (num.length === 4) {
	            this.setState({ max_width: 4 });
	          }
	        } else if (num >= 10 && num < 100) {
	          this.setState({ width: num });
	          if (num.length === 5) {
	            this.setState({ max_width: 5 });
	          }
	        } else if (num >= 100) {
	          this.refs.width.value = this.state.width;
	        }
	      } else {
	        // NOT a number.
	        this.refs.width.value = this.state.width;
	      }
	    }
	  },
	  heightValidator: function heightValidator(event) {
	    var num = event.target.value;
	
	    if (num.length === 0) {
	      this.refs.height.value = "";
	    }
	
	    if (num.length === 1) {
	      //1 digit
	      this.setState({ max_height: 5 });
	
	      if (!isNaN(num) && num !== 0) {
	        this.setState({ height: num });
	      } else {
	        //NOT a number.
	        this.refs.height.value = "";
	      }
	    } else {
	      // 2 or more digits
	      if (!isNaN(num)) {
	        //if it is a NUMBER
	
	        if (num < 10) {
	          this.setState({ height: num });
	          if (num.length === 4) {
	            this.setState({ max_height: 4 });
	          }
	        } else if (num >= 10 && num < 100) {
	          this.setState({ height: num });
	          if (num.length === 5) {
	            this.setState({ max_height: 5 });
	          }
	        } else if (num >= 100) {
	          this.refs.height.value = this.state.height;
	        }
	      } else {
	        // NOT a number.
	        this.refs.height.value = this.state.height;
	      }
	    }
	  },
	  InsuredValueValidator: function InsuredValueValidator(event) {
	    var num = event.target.value;
	
	    if (num.length === 0) {
	      this.refs.insured_value.value = "";
	    }
	
	    if (num.length === 1) {
	      //1 digit
	      this.setState({ max_insured: 8 });
	
	      if (!isNaN(num) && num !== 0) {
	        this.setState({ insured: num });
	      } else {
	        //NOT a number.
	        this.refs.insured_value.value = "";
	      }
	    } else {
	      // 2 or more digits
	      if (!isNaN(num)) {
	        //if it is a NUMBER
	
	        if (num < 10) {
	          this.setState({ insured: num });
	          if (num.length === 4) {
	            this.setState({ max_insured: 4 });
	          }
	        } else if (num >= 10 && num < 100) {
	          this.setState({ insured: num });
	          if (num.length === 5) {
	            this.setState({ max_insured: 5 });
	          }
	        } else if (num >= 100 && num < 1000) {
	          this.setState({ insured: num });
	          if (num.length === 6) {
	            this.setState({ max_insured: 6 });
	          }
	        } else if (num >= 1000 && num < 10000) {
	          this.setState({ insured: num });
	          if (num.length === 7) {
	            this.setState({ max_insured: 7 });
	          }
	        } else if (num >= 10000 && num < 100000) {
	          this.setState({ insured: num });
	          if (num.length === 8) {
	            this.setState({ max_insured: 8 });
	          }
	        } else if (num >= 100000) {
	          this.refs.insured_value.value = this.state.insured;
	        }
	      } else {
	        // NOT a number.
	        this.refs.insured_value.value = this.state.insured;
	      }
	    }
	  },
	
	  //SC-224 - an error message should be provided when the user typed in Insured value 
	  //more than the configured "Maximum value for Insured Value per Item" in admin tools
	  /*checkMaxInsuredSetting: function (e) {  
	    var insured_value = parseFloat(this.refs.insured_value.value);
	    var insurance_max_value = parseFloat(this.props.settings.general_settings.data.settings.insurance_max_value.value);
	     if ( insured_value  >  insurance_max_value) {            
	      this.setState({ insured_value_status: true});        
	      this.setState({insured_value_text: "Declared value entered is more than the configured insured value per item"});      
	      this.setState({ insured_status: true});  
	      e.preventDefault();
	      return false;
	    } else {
	      this.setState({ insured_value_status: false});      
	      this.setState({insured_value_text: ""});
	    }
	  },  */
	  // SC-474 - Off-size items handling
	  checkOffsizeItemsHandling: function checkOffsizeItemsHandling(offSizeData) {
	    this.setState({ calculated: false });
	
	    var _JSON$parse = JSON.parse(offSizeData[0].settings),
	        weight = _JSON$parse.weight,
	        dimension = _JSON$parse.dimension;
	
	    var length = Number(this.refs.length.value);
	    var width = Number(this.refs.width.value);
	    var height = Number(this.refs.height.value);
	    var weightValue = Number(this.refs.weight.value);
	
	    if (length > Number(dimension.value) || width > Number(dimension.value) || height > Number(dimension.value) || weightValue > Number(weight.value)) {
	      this.setState({ offsize: true });
	      this.setState({ selectDefaultValue: "off-size items" });
	      this.setState({ selectDefaultLabel: 'Off-size item exceeding ' + dimension.value + ' inches (any side) and/or ' + weight.value + ' lbs' });
	    } else {
	      this.setState({ offsize: false });
	      this.setState({ selectDefaultValue: "" });
	      this.setState({ selectDefaultLabel: "None" });
	    }
	  },
	  onChangeLocation: function onChangeLocation(e, type) {
	    var _this = this;
	
	    e.preventDefault();
	    var weight = this.refs.weight.value;
	    var length = this.refs.length.value;
	    var width = this.refs.width.value;
	    var height = this.refs.height.value;
	    var insured_value = this.refs.insured_value.value;
	    var special_handling = "";
	    if (this.refs.special_handling.value === "") {
	      special_handling = "0";
	    } else {
	      special_handling = "1";
	    }
	
	    var sc_protect = void 0;
	
	    this.setState({ weight_status: true, height_status: true, length_status: true, width_status: true, insured_status: true, insured_value_status: true }, function () {
	      if (_this.state.destination !== 'MY') {
	        sc_protect = { avail: 1 };
	      }
	    });
	
	    this.setState(_defineProperty({}, type, e.target.value), function () {
	      return weight && length && width && height && insured_value ? _this.props.getEstimate(weight, length, width, height, insured_value, special_handling, _this.state.origin, _this.state.destination, sc_protect) : null;
	    });
	  },
	  injectMediaDonutScript: function injectMediaDonutScript() {
	
	    var axel = Math.random() + "";
	    var a = axel * 10000000000000;
	    document.write('<iframe title=' + (0, _uuid.v4)() + ' src={https://9848754.fls.doubleclick.net/activityi;src=9848754;type=shipp0;cat=shipp0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a + '? } width="1" height="1" frameBorder="0" style="display:none"></iframe>');
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var per_pound = void 0,
	        fixed_fees = void 0,
	        outBoundBannerData = void 0,
	        offSizeData = null,
	        airFixedFee = 10.00,
	        maxWeight = 5,
	        maxDimension = 23,
	        fixedShippingFee = 15,
	        minChargableWeight = null;
	    if (this.state.settings) {
	      per_pound = this.state.settings.filter(function (data) {
	        return data.name === "per_pound_value";
	      });
	      fixed_fees = this.state.settings.filter(function (data) {
	        return data.name === "fixed_fees";
	      })[0];
	      outBoundBannerData = this.state.settings.filter(function (data) {
	        return data.name === "outbound_banner";
	      });
	      offSizeData = this.state.settings.filter(function (data) {
	        return data.name === "offsize";
	      });
	      minChargableWeight = this.state.settings.filter(function (data) {
	        return data.name === "minimum_chargeable_weight";
	      })[0];
	    }
	
	    if (fixed_fees) {
	      fixed_fees = fixed_fees.settings && JSON.parse(fixed_fees.settings);
	      airFixedFee = fixed_fees.air_fixed_fee.value || airFixedFee;
	      maxWeight = fixed_fees.max_weight.value || maxWeight;
	      maxDimension = fixed_fees.max_dimension.value || maxDimension;
	      fixedShippingFee = fixed_fees.fixed_shipping_fee.value || fixedShippingFee;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'noscript',
	        null,
	        _react2.default.createElement('iframe', { title: (0, _uuid.v4)(), src: 'https://9848754.fls.doubleclick.net/activityi;src=9848754;type=shipp0;cat=shipp0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?', width: '1', height: '1', frameBorder: '0', style: { display: 'none' } })
	      ),
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement('meta', { name: 'description', content: metadata, 'data-react-helmet': 'true' })
	      ),
	      this.props.estimate.fetching && _react2.default.createElement(
	        'div',
	        { style: { top: 0, right: 0, left: 0, bottom: 0, position: 'fixed', alignItems: 'center', background: 'rgba(0,0,0,0.6)', zIndex: '999999', justifyContent: 'center', display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { style: { color: '#FFF' } },
	          _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            'Loading...'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'page-estimateshipping' },
	        _react2.default.createElement(
	          'div',
	          { id: 'shippingcart_app', className: 'header-original' },
	          _react2.default.createElement(
	            'div',
	            { className: 'body-wrapper' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'container estimate-shipping page-container' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'page-title' },
	                  'Get Shipping Estimate'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-7 estimate' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-5 estimate-form', style: { width: '53%' } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'instructions' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Get your shipment cost estimate with our cost estimator. The cost estimator is a tool that provides an estimate of your shipping fee and is based on the information that you provide. It does not reflect the actual shipment cost, which will depend on actual box measurements, shipping method, and currency rate, among others.'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'cart-header' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'shipment-destination' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'FROM: '
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'select-gradient disInline' },
	                            _react2.default.createElement(
	                              'select',
	                              { value: this.state.origin, onChange: function onChange(e) {
	                                  return _this2.onChangeLocation(e, "origin");
	                                } },
	                              this.props.warehouse.warehouse_fetched ? (0, _whiteListed.filterWarehouse)(this.props.warehouse.warehouse.data, this.props.login.login.party).map(function (value) {
	                                return _react2.default.createElement(
	                                  'option',
	                                  { key: value.id, value: value.id },
	                                  (0, _utils.maskLocationName)(value.country_code)
	                                );
	                              }) : null
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'TO: '
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'select-gradient disInline' },
	                            _react2.default.createElement(
	                              'select',
	                              { value: this.state.destination, onChange: function onChange(e) {
	                                  return _this2.onChangeLocation(e, "destination");
	                                } },
	                              _react2.default.createElement(
	                                'option',
	                                { value: 'PH' },
	                                'Philippines'
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.onSubmit },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'notify' },
	                          this.state.weight_status && this.state.width_status && this.state.length_status && this.state.height_status && this.state.insured_status ? null : !this.state.number || !this.state.insured || !this.state.length || !this.state.width || !this.state.height ? _react2.default.createElement(
	                            'div',
	                            { className: 'sc-alert sc-alert-danger' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            ' Fill in all the required fields. '
	                          ) : this.state.number <= 0 || this.state.insured < 1 || this.state.length <= 0 || this.state.width <= 0 || this.state.height <= 0 || this.state.insured > this.state.insurance_max ? _react2.default.createElement(
	                            'div',
	                            { className: 'sc-alert sc-alert-danger' },
	                            _react2.default.createElement('i', { className: 'sc' }),
	                            ' Please check allowed minimum value '
	                          ) : null
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'weight form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            'How much does it weigh?'
	                          ),
	                          this.state.weight_status ? null : !this.state.number ? _react2.default.createElement(
	                            'span',
	                            { className: 'inline-error-message' },
	                            ' ',
	                            '\xA0',
	                            ' Enter weight '
	                          ) : this.state.number <= 0 ? _react2.default.createElement(
	                            'span',
	                            { className: 'inline-error-message' },
	                            ' ',
	                            '\xA0',
	                            ' Enter value greater than 0 '
	                          ) : null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-with-inline-text' },
	                            _react2.default.createElement('input', { type: 'text', maxLength: this.state.max_weight, onInput: this.weightValidator, onChange: function onChange() {
	                                return _this2.checkOffsizeItemsHandling(offSizeData);
	                              }, className: this.state.weight_status ? "form-control" : "form-control error-input", ref: 'weight' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'inline-text' },
	                              'pounds'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'dimensions form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            'What are the dimensions?'
	                          ),
	                          this.state.length_status && this.state.width_status && this.state.height_status ? null : !this.state.length && !this.state.width && !this.state.height ? _react2.default.createElement(
	                            'span',
	                            { className: 'inline-error-message' },
	                            ' ',
	                            '\xA0',
	                            ' Enter length, width and height '
	                          ) : !this.state.length || !this.state.width || !this.state.height ? _react2.default.createElement(
	                            'span',
	                            { className: 'inline-error-message' },
	                            ' ',
	                            '\xA0',
	                            ' Enter valid input '
	                          ) : this.state.length <= 0 || this.state.width <= 0 || this.state.height <= 0 ? _react2.default.createElement(
	                            'span',
	                            { className: 'inline-error-message' },
	                            ' ',
	                            '\xA0',
	                            ' Enter value greater than 0 '
	                          ) : null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-with-inline-text' },
	                            _react2.default.createElement('input', { type: 'text', maxLength: this.state.max_length, onInput: this.lengthValidator, onChange: function onChange() {
	                                return _this2.checkOffsizeItemsHandling(offSizeData);
	                              }, className: this.state.length_status ? "form-control" : "form-control error-input", placeholder: 'length', ref: 'length' }),
	                            _react2.default.createElement('input', { type: 'text', maxLength: this.state.max_width, onInput: this.widthValidator, onChange: function onChange() {
	                                return _this2.checkOffsizeItemsHandling(offSizeData);
	                              }, className: this.state.width_status ? "form-control" : "form-control error-input", placeholder: 'width', ref: 'width' }),
	                            _react2.default.createElement('input', { type: 'text', maxLength: this.state.max_height, onInput: this.heightValidator, onChange: function onChange() {
	                                return _this2.checkOffsizeItemsHandling(offSizeData);
	                              }, className: this.state.height_status ? "form-control" : "form-control error-input", placeholder: 'height', ref: 'height' }),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'inline-text' },
	                              'inches'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'insured-declared-value form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            'How much is the Insured Value?'
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'error-message' },
	                            ' ',
	                            this.state.insured > this.state.insurance_max ? this.state.insured_value_text : null,
	                            ' '
	                          ),
	                          this.state.insured_status ? null : !this.state.insured ? _react2.default.createElement(
	                            'span',
	                            { className: 'error-message' },
	                            ' Enter Insured Value '
	                          ) : this.state.insured <= 0 ? _react2.default.createElement(
	                            'span',
	                            { className: 'inline-error-message' },
	                            ' ',
	                            '\xA0',
	                            ' Enter value greater than 0 '
	                          ) : null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-with-inline-text' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'inline-text prefix' },
	                              '$'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', maxLength: this.state.max_insured, onInput: this.InsuredValueValidator, className: this.state.insured_status ? "form-control" : "form-control error-input", ref: 'insured_value' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'special-handling form-group' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            'Does your shipment have items that require special handling?'
	                          ),
	                          _react2.default.createElement(
	                            'select',
	                            { className: 'form-control', ref: 'special_handling', defaultValue: this.state.selectDefaultValue, disabled: this.state.offsize ? "disabled" : "" },
	                            _react2.default.createElement(
	                              'option',
	                              { value: this.state.offsize ? this.state.selectDefaultValue : "", selected: 'selected' },
	                              this.state.selectDefaultLabel
	                            ),
	                            this.state.offsize ? "" : "<option value='' selected='selected'>None</option>",
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'automotive parts' },
	                              'Collectibles'
	                            ),
	                            offSizeData && this.state.offsize && _react2.default.createElement(
	                              'option',
	                              { value: 'off-size items' },
	                              'Off-size item exceeding ',
	                              JSON.parse(offSizeData[0].settings).dimension.value,
	                              ' inches (any side) and/or ',
	                              JSON.parse(offSizeData[0].settings).weight.value,
	                              ' lbs'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'telecom_equipment' },
	                              'Electronic products powered by Li-ion batteries'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'fragile_breakable' },
	                              'Breakable / Fragile Items'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-buttons' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-orange gradient' },
	                            'Get Shipping Estimate'
	                          ),
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'reset-form', onClick: this.reset },
	                            'Reset'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-7 estimate-results', style: { width: '48%' } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'results' },
	                        this.state.calculated ? this.state.offsize ? _react2.default.createElement(
	                          'div',
	                          { className: 'sc-warning', style: { padding: '10px 24px', height: 'auto', background: '#FEF6E7', borderRadius: '5px', border: 'none', width: 'auto', margin: '10px' } },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            'Off-size items must be shipped individually. Additional charges may be billed on top of your shipping fee depending on the item.'
	                          ),
	                          _react2.default.createElement(
	                            'a',
	                            { style: { color: '#0375D9', fontWeight: 600, cursor: 'pointer', fontSize: '14px' }, href: 'https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-', target: '_blank', rel: 'noopener noreferrer' },
	                            _react2.default.createElement('i', {
	                              className: 'fa fa-exclamation-circle',
	                              style: { color: '#0375D9', fontSize: 13, marginRight: '5px' }
	                            }),
	                            'Learn more.'
	                          )
	                        ) : _react2.default.createElement(
	                          'div',
	                          { style: { margin: 10 } },
	                          _react2.default.createElement(_OutBoundBanner2.default, { outBoundBannerData: outBoundBannerData })
	                        ) : null,
	                        this.state.calculated ? null : _react2.default.createElement(
	                          'div',
	                          { className: 'estimate-instruction' },
	                          _react2.default.createElement('i', { className: 'sc sc-light-box' }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Fill in the appropriate fields as accurately as possible to get your shipping fee estimation.'
	                          )
	                        ),
	                        this.state.calculated ? _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(_ShippingEstimateBreakdown2.default, { data: this.props.estimate.estimate.data, offSize: this.state.offsize, destination: this.state.destination, minChargableWeight: minChargableWeight })
	                        ) : null
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-5 rates' },
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'section-title' },
	                      'Rates'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'ShippingCart can ship your goods home via Air or Sea Cargo.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Shipment cost is computed using pounds (lbs) and US Dollars and is inclusive of all taxes.'
	                    ),
	                    _react2.default.createElement(
	                      'table',
	                      { className: 'table rate-list' },
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Shipment Method'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Rate'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Air Cargo'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'USD',
	                            per_pound ? JSON.parse(per_pound[0].settings).lbs_value_air.value : null,
	                            '/pound'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Air Cargo (',
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/special-handling' },
	                              'Special Handling'
	                            ),
	                            ')'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'USD',
	                            per_pound ? JSON.parse(per_pound[0].settings).lbs_value_special_handling_air ? JSON.parse(per_pound[0].settings).lbs_value_special_handling_air.value : JSON.parse(per_pound[0].settings).lbs_value_dangerous_air.value : null,
	                            '/pound'
	                          )
	                        )
	                      ),
	                      this.state.destination !== 'MY' && _react2.default.createElement(
	                        'tbody',
	                        { style: { borderTop: 'none' } },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Sea Cargo'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'USD',
	                            per_pound ? JSON.parse(per_pound[0].settings).lbs_value_sea.value : null,
	                            '/cubic inch ',
	                            _react2.default.createElement('br', null),
	                            ' (unliweight)'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Sea Cargo (',
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/special-handling' },
	                              'Special Handling'
	                            ),
	                            ')'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'USD',
	                            per_pound ? JSON.parse(per_pound[0].settings).lbs_value_special_handling_sea.value : null,
	                            '/cubic inch ',
	                            _react2.default.createElement('br', null),
	                            ' (unliweight)'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'Sea Cargo (',
	                            _react2.default.createElement(
	                              'a',
	                              { href: 'https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-', target: '_blank', rel: 'noopener noreferrer' },
	                              'Off-size'
	                            ),
	                            ')'
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            'USD',
	                            per_pound ? JSON.parse(per_pound[0].settings).offsize_rate_sea.value : null,
	                            '/cubic inch ',
	                            _react2.default.createElement('br', null),
	                            ' (unliweight)'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'bold', style: { marginBottom: '0px' } },
	                      'How do I calculate the Shipment Cost?'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Shipment cost is calculated as follows:',
	                      _react2.default.createElement('br', null),
	                      'Cargo Fee + Fixed Handling Fee + Storage Fee (if any) + SC Protect Fee (if any)'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'We highly recommend that you encode the correct insured value of your items so that you will be fairly reimbursed for any unfortunate incidents that may occur. ',
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/sc-protect' },
	                        'SC Protect'
	                      ),
	                      ' covers up to $20,000 per shipment, with a $10,000 limit per item.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'bold', style: { marginBottom: '0px' } },
	                      'How do I compute Cargo Fee?'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Cargo Fee is charged as either a fixed fee or computed based on the total chargeable weight.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'A single item under ',
	                      maxWeight,
	                      'lbs with dimension not greater than ',
	                      maxDimension,
	                      'inches (any side) is charged a fixed air cargo fee of $',
	                      fixedShippingFee,
	                      ' if shipped via Air Cargo.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Otherwise, cargo fee is computed based on ',
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Chargeable Weight x Rate'
	                      ),
	                      '. A Fixed Handling Fee of $',
	                      airFixedFee,
	                      ' is added when the cargo fee is computed based on chargeable weight.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'bold', style: { marginBottom: '0px' } },
	                      'What is chargeable weight?'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'The chargeable weight for your package is its actual weight or volumetric weight, whichever is higher. ShippingCart rounds up to two decimal places of the chargeable weight. Minimum chargeable weight is 1lb for Air Cargo and volumetric weight of a 12x12x12 box for Sea Cargo. To determine the actual and volumetric weight of your package, a dimensioning machine is used to weigh your item/s. This is done while it\'s inside its original packaging. Note that if your item/s arrives in your courier\'s or distributor\'s box (e.g. Fedex, Amazon), we remove the courier\'s box before your item(s) is measured and weighed. We measure and weigh your item/s in its original/manufacturer\'s packaging to help you save on shipping fees.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'The formula for Volumetric Weight is: Length x Width x Height / 166 (dimensional weight factor).',
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'em',
	                        { style: { fontSize: '12px' } },
	                        '*Sea Cargo Shipments are only measured based on the volumetric weight or dimensional weight.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Please note that we follow the dimensional weight factor of the International Air Weight Transport Association (IATA).'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'bold', style: { marginBottom: '0px' } },
	                      'Special Handling and Off-size Items'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'We offer shipping for items that require special handling (i.e. dangerous goods). For a complete list of these items, visit our ',
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/special-handling' },
	                        'Special Handling Service Guide'
	                      ),
	                      '.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'It\'s important to remember that when an item requiring special handling is consolidated with regular items for shipment, the rate for Air Cargo for Items with Special Handling applies. Consolidation is free.'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'An item will be tagged as \u201Coff-size\u201D in your cart if it exceeds the allowable maximum dimension and/or weight that can be shipped via air cargo depending on which origin the item will be coming from. Values may differ for each origin as this is based on our Forwarding partner\u2019s capacity. ',
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: 'https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-' },
	                        'Off-size items can only be shipped via sea cargo to the PH'
	                      ),
	                      '.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'template',
	                { id: 'alerts_component_template' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert' },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' '
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var mapDispachToProps = { getWarehouse: _DashboardActions.getWarehouse };
	
	var mapStateToProps = function mapStateToProps(state) {
	  return { warehouse: state.dashboard };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(ShippingEstimate);

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
	var seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';
	var protectedIcon = 'https://cdn.shippingcart.com/assets/protect-20231116072249.svg';
	var SCProtectIcon = 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg';
	
	var INSURANCE_BENEFITS = ['Protection against loss or damage during transit.', 'Guaranteed on-time delivery, or your shipping fee is on us.', 'Refund your shipping fee when returning wrong or defective items back to the merchant.'];
	
	var ShippingEstimateBreakdown = function (_Component) {
	  _inherits(ShippingEstimateBreakdown, _Component);
	
	  function ShippingEstimateBreakdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ShippingEstimateBreakdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShippingEstimateBreakdown.__proto__ || Object.getPrototypeOf(ShippingEstimateBreakdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShippingEstimateBreakdown, [{
	    key: 'handleFixedAirCargo',
	    value: function handleFixedAirCargo() {
	      if (this.props.data.air && this.props.data.air.usd.single_parcel_fixed_rate) {
	        return _react2.default.createElement(
	          'div',
	          {
	            style: {
	              borderBottom: "1px solid #F1F1F1",
	              paddingBottom: "10px",
	              marginTop: "20px"
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: { display: "flex", justifyContent: "space-between" } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: "#636363" } },
	              'Fixed Air Cargo fee'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'USD ' + (this.props.data.air.usd.total_cargo || '0.00')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'div',
	              { style: { fontWeight: 600, color: '#636363', display: 'inline-flex' } },
	              'SC Protect fee ',
	              _react2.default.createElement('img', { src: SCProtectIcon, alt: 'air', width: 18, style: { marginLeft: '5px' } })
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { marginRight: '5px' } },
	                '+'
	              ),
	              'USD ' + ((0, _utils.numbersWithComma)(this.props.data.air.usd.total_insurance) || 0.00)
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '20px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: '#636363' } },
	              'Chargeable weight'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              this.props.data.air.usd.total_chargeable_weight,
	              ' lbs'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: '#636363', textTransform: 'capitalize' } },
	              'Air Cargo rate'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { marginRight: '5px' } },
	                'X'
	              ),
	              ' ',
	              'USD ' + (this.props.data.air.usd.per_pound_value || 0.00)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'right', fontWeight: 600, color: '#323232' } },
	            'USD ' + ((0, _utils.numbersWithComma)(this.props.data.air.usd.total_chargeable_amount.toFixed(2)) || 0.00)
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: '#636363' } },
	              'Fixed handling fee'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'USD ' + ((0, _utils.numbersWithComma)(this.props.data.air.usd.total_fixed_rate && this.props.data.air.usd.total_fixed_rate.toFixed(2)) || 0.00)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            'div',
	            { style: { fontWeight: 600, color: '#636363', display: 'inline-flex' } },
	            'SC Protect fee ',
	            _react2.default.createElement('img', { src: SCProtectIcon, alt: 'air', width: 18, style: { marginLeft: '5px' } })
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: { marginRight: '5px' } },
	              '+'
	            ),
	            'USD ' + ((0, _utils.numbersWithComma)(this.props.data.air.usd.total_insurance) || 0.00)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var minChargableWeight = this.props.minChargableWeight && JSON.parse(this.props.minChargableWeight.settings);
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.offSize ? null : _react2.default.createElement(
	          'div',
	          { style: { padding: '20px 16px', fontSize: '16px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', flexDirection: 'row' } },
	            _react2.default.createElement('img', { src: airIcon, alt: 'air', width: 24 }),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', flexDirection: 'column', marginLeft: '5px' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#323232', fontWeight: 600, textTransform: 'capitalize' } },
	                'Air Cargo'
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '10px', color: '#323232' } },
	                'Est. delivery: ',
	                this.props.data.delivery.air
	              )
	            )
	          ),
	          this.handleFixedAirCargo(),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: '#323232', textTransform: 'capitalize' } },
	              'Total Air Cargo Fee'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: '#323232' } },
	              'USD ' + ((0, _utils.numbersWithComma)(this.props.data.air.usd.total_price.toFixed(2)) || 0.00)
	            )
	          )
	        ),
	        this.props.offSize || this.props.destination === "MY" ? null : _react2.default.createElement('hr', { style: { margin: '10px 16px' } }),
	        this.props.destination === "MY" ? null : _react2.default.createElement(
	          'div',
	          { style: { padding: '20px 16px', fontSize: '16px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', flexDirection: 'row' } },
	            _react2.default.createElement('img', { src: seaIcon, alt: 'sea', width: 24 }),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', flexDirection: 'column', marginLeft: '5px' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#323232', fontWeight: 600, textTransform: 'capitalize' } },
	                'Sea Cargo'
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '10px', color: '#323232' } },
	                'Est. delivery: ',
	                this.props.data.delivery.sea
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '20px' } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between' } },
	              _react2.default.createElement(
	                'span',
	                { style: { fontWeight: 600, color: '#636363' } },
	                'Chargeable weight'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.data.sea.usd.total_chargeable_weight,
	                ' lbs'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between' } },
	              _react2.default.createElement(
	                'span',
	                { style: { fontWeight: 600, color: '#636363', textTransform: 'capitalize' } },
	                'Sea Cargo rate'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { style: { marginRight: '5px' } },
	                  'X'
	                ),
	                ' ',
	                'USD ' + (this.props.data.sea.usd.per_pound_value || 0.00)
	              )
	            ),
	            this.props.data.sea && this.props.data.sea.usd.is_sea_higher_rate && _react2.default.createElement(
	              'div',
	              { style: { fontSize: '10px', fontStyle: 'italic' } },
	              'Higher rates apply if any side of a package is over ',
	              minChargableWeight && minChargableWeight.sea_max_dimension && minChargableWeight.sea_max_dimension.value,
	              ' inches.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { borderBottom: '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px' } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'right', fontWeight: 600, color: '#323232' } },
	              'USD ' + ((0, _utils.numbersWithComma)(this.props.data.sea.usd.total_chargeable_amount.toFixed(2)) || 0.00)
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between' } },
	              _react2.default.createElement(
	                'span',
	                { style: { fontWeight: 600, color: '#636363' } },
	                'Fixed handling fee'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'USD ' + ((0, _utils.numbersWithComma)(this.props.data.sea.usd.total_fixed_rate && this.props.data.sea.usd.total_fixed_rate.toFixed(2)) || 0.00)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between' } },
	              _react2.default.createElement(
	                'div',
	                { style: { fontWeight: 600, color: '#636363', display: 'inline-flex' } },
	                'SC Protect fee ',
	                _react2.default.createElement('img', { src: SCProtectIcon, alt: 'sea', width: 18, style: { marginLeft: '5px' } })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { style: { marginRight: '5px' } },
	                  '+'
	                ),
	                'USD ' + ((0, _utils.numbersWithComma)(this.props.data.sea.usd.total_insurance) || 0.00)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: '#323232', textTransform: 'capitalize' } },
	              'Total Sea Cargo Fee'
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: 600, color: '#323232' } },
	              'USD ' + ((0, _utils.numbersWithComma)(this.props.data.sea.usd.total_price.toFixed(2)) || 0.00)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { border: '1px solid #0375D9', backgroundColor: '#E5F1FB', padding: '20px', borderRadius: '10px', margin: '20px 16px' } },
	          _react2.default.createElement(
	            'div',
	            { style: { color: '#636363', fontWeight: 600 } },
	            'Benefits of SC Protect:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px', color: '#323232' } },
	            INSURANCE_BENEFITS.map(function (benefit, index) {
	              return _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '8px', display: 'flex' }, key: index },
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginRight: '5px' } },
	                  _react2.default.createElement('img', {
	                    src: protectedIcon,
	                    alt: 'icon'
	                  })
	                ),
	                benefit
	              );
	            })
	          ),
	          this.props.data.insurance_eligible === 1 && _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', marginTop: '10px', alignItems: 'center' } },
	            _react2.default.createElement('img', { src: SCProtectIcon, alt: 'badge', width: 24, height: 24, style: { marginRight: '5px' } }),
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '10px', fontWeight: 600, color: '#636363' } },
	              'SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShippingEstimateBreakdown;
	}(_react.Component);
	
	exports.default = ShippingEstimateBreakdown;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(842);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _FacebookLogin = __webpack_require__(252);
	
	var _FacebookLogin2 = _interopRequireDefault(_FacebookLogin);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _MobileHeader = __webpack_require__(122);
	
	var _MobileHeader2 = _interopRequireDefault(_MobileHeader);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _utils = __webpack_require__(13);
	
	var _brandLogo = __webpack_require__(188);
	
	var _brandLogo2 = _interopRequireDefault(_brandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var appConfig = __webpack_require__(71);
	var fbAppId = appConfig.fbAppId;
	var extensionId = appConfig.extensionId;
	/* eslint-enable */
	
	var createReactClass = __webpack_require__(16);
	var SignIn = createReactClass({
	  displayName: 'SignIn',
	  getInitialState: function getInitialState() {
	    return {
	      isFormSubmitted: false,
	      resetPassword: false,
	      rememberMe: false,
	      trackPackage: false,
	      noOtherError: true,
	      email: null,
	      password: null
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    if (localStorage.resetPassword) {
	      this.setState({ resetPassword: true });
	    }
	    localStorage.removeItem('resetPassword');
	    localStorage.trackPackage ? this.setState({ trackPackage: true }) : this.setState({ trackPackage: false });
	
	    /*if (localStorage.rememberMe === "true") {
	      this.setState({ email: localStorage.email, password: localStorage.password, })
	    }
	    else {
	      this.setState({ email: null, password: null, });
	      localStorage.removeItem("email");
	      localStorage.removeItem("password");
	    }*/
	    this.props.getCopyrightYear();
	    document.title = "Sign in | ShippingCart";
	
	    /*SC-695 Add script to remove email and password keys in localstorage */
	    localStorage.removeItem("email");
	    localStorage.removeItem("password");
	    localStorage.removeItem('checkoutModalShowed');
	
	    var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
	    var isMac = navigator.userAgent.toLowerCase().indexOf('mac') > -1;
	    if (isChrome) {
	      if (isMac) {
	        localStorage.setItem("cartExtensionModalShowed", true);
	      } else {
	        (0, _utils.extensionDetect)(extensionId);
	      }
	    } else {
	      localStorage.setItem("cartExtensionModalShowed", true);
	    }
	    if (this.props.location.query && this.props.location.query.rewardPage) {
	      localStorage.setItem('rewardPage', true);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.resetAccounts();
	    this.clrErrorMsgs();
	    localStorage.removeItem("trackPackage");
	  },
	  responseFacebook: function responseFacebook(response) {
	    var token = response.accessToken;
	    this.props.FacebookSignedIn(token);
	  },
	  handleSubmit: function handleSubmit(e) {
	    e.preventDefault();
	    this.clrErrorMsgs();
	    var email = this.refs.email.value;
	    var password = this.refs.password.value;
	
	    if (email.length === 0 || password.length === 0) {
	      this.handleSubmitFieldValidation(email, password);
	    } else {
	      this.props.signin(email, password);
	      this.setState({ isFormSubmitted: true });
	      localStorage.setItem("rememberMe", this.state.rememberMe);
	    }
	  },
	  handleSubmitFieldValidation: function handleSubmitFieldValidation(email, password) {
	
	    if (email.length === 0) {
	      this.refs.errors_email.className = "input-error";
	      this.refs.errors_email.innerHTML = "The email field is required";
	      this.refs.errors_email.parentElement.className = "control has-error";
	    }
	
	    if (password.length === 0) {
	      this.refs.errors_password.className = "input-error";
	      this.refs.errors_password.innerHTML = "The password field is required";
	      this.refs.errors_password.parentElement.className = "control has-error";
	    }
	  },
	  handleClick: function handleClick() {
	    if (this.refs.show_password.checked) {
	      this.refs.password.type = 'text';
	    } else {
	      this.refs.password.type = 'password';
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	
	    // <!-- Lightning Bolt Begins -->
	    var lbscript = document.createElement("script");
	    lbscript.type = "text/javascript";
	    lbscript.src = "/js/lightningbolt.js";
	    lbscript.async = true;
	    document.body.appendChild(lbscript);
	
	    var lbscript1 = document.createElement("script");
	    lbscript1.type = "text/javascript";
	    lbscript1.setAttribute('id', 'lightning_bolt');
	    lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
	    lbscript1.async = true;
	    document.body.appendChild(lbscript1);
	    // <!-- Lightning Bolt Ends -->
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.login.fetched && localStorage.trackPackage) {
	      localStorage.setItem("trackPackage2", true);
	    }
	    /*if (nextProps.login.fetched && localStorage.rememberMe === "true") {
	      localStorage.setItem("email", this.refs.email.value);
	      localStorage.setItem("password", this.refs.password.value);
	    }*/
	    if (!nextProps.login.error) {
	      this.clrErrorMsgs();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.state.isFormSubmitted) {
	      window.scrollTo(0, 0);
	      var status = this.props.login.error ? this.props.login.error.response.status : 200;
	      this.clrErrorMsgs();
	      if (status !== 200) {
	        if (status === 422) {
	          var err = this.props.login.error.response.data.parameters;
	          var focus = true;
	          for (var key in err) {
	            if (err.hasOwnProperty(key)) {
	              if (key !== "status") {
	                this.refs["errors_" + key].innerHTML = err[key];
	              }
	              this.refs["errors_" + key].className = key === "status" ? "sc-alert sc-alert-danger archive" : "input-error";
	              if (key === "status") {
	                this.refs["errors_" + key].parentElement.className = "notify";
	              }
	              if (focus && this.refs[key]) {
	                focus = false;
	                _reactDom2.default.findDOMNode(this.refs[key]).focus();
	              }
	            }
	          }
	        } else if (status === 401 && this.props.login.error.response.data.errors.detail) {
	          this.refs.errors_credentials.parentElement.className = "notify";
	          _reactDom2.default.findDOMNode(this.refs.email).focus();
	          this.setState({ noOtherError: false });
	          this.setState({ isFormSubmitted: false });
	        }
	      }
	    }
	  },
	  clrErrorMsgs: function clrErrorMsgs() {
	    if (this.refs.errors_credentials.parentElement) {
	      this.refs.errors_credentials.parentElement.className = "disnone";
	    }
	    if (this.refs.errors_email.parentElement) {
	      this.refs.errors_email.parentElement.className = "";
	    }
	    if (this.refs.errors_email) {
	      this.refs.errors_email.className = "disnone";
	    }
	    if (this.refs.errors_password.parentElement) {
	      this.refs.errors_password.parentElement.className = "";
	    }
	    if (this.refs.errors_password) {
	      this.refs.errors_password.className = "disnone";
	    }
	    if (this.refs.errors_status) {
	      this.refs.errors_status.className = "disnone";
	    }
	    if (this.refs.errors_status) {
	      this.refs.errors_status.parentElement.className = "disnone";
	    }
	  },
	  toggleRememberMe: function toggleRememberMe() {
	    var _this = this;
	
	    this.setState({
	      rememberMe: !this.state.rememberMe
	    }, function () {
	      if (_this.state.rememberMe) {
	        localStorage.setItem("rememberMe", true);
	      } else {
	        localStorage.setItem("rememberMe", false);
	      }
	    });
	  },
	  handleWidget: function handleWidget(e) {
	    e.preventDefault();
	    window.FreshWidget.show();
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_MobileHeader2.default, {
	        isAuthenticated: false,
	        isSideNavOpen: false
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'page-login header-minimal-head' },
	        _react2.default.createElement(
	          'header',
	          { className: 'site-header header-minimal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/' },
	                _react2.default.createElement('img', { alt: 'icon', src: _brandLogo2.default, style: { height: 35, width: 210, margin: 25 } })
	              )
	            ),
	            _react2.default.createElement(
	              'nav',
	              { className: 'top-nav' },
	              _react2.default.createElement('ul', null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'body-wrapper signinpage' },
	          _react2.default.createElement(
	            'section',
	            { className: 'container login' },
	            _react2.default.createElement(
	              'div',
	              { className: 'login-header clearfix' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Welcome back!'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'back' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/home' },
	                  '< Back to home'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'login-wrapper clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.resetPassword ? "notify" : "disnone" },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.resetPassword ? "sc-alert sc-alert-success" : "disnone" },
	                    _react2.default.createElement('i', { className: 'sc' }),
	                    'Email Sent!'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'disnone' },
	                  _react2.default.createElement(
	                    'div',
	                    { ref: 'errors_credentials', className: 'sc-alert sc-alert-danger' },
	                    _react2.default.createElement('i', { className: 'sc' }),
	                    this.props.login.error && (this.props.login.error.response.data.errors.detail.includes("Invalid") || this.props.login.error.response.data.errors.detail.includes("email isn't associated")) ? "Incorrect email address and/or password." : this.props.login.error && this.props.login.error.response.data.errors.detail.includes("Maximum Login") ? _react2.default.createElement(
	                      'span',
	                      null,
	                      'You have reached the maximum number of failed login attempts. Please ',
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/reset-password' },
	                        'reset your password.'
	                      )
	                    ) : this.props.login.error && this.props.login.error.response.data.errors.detail.includes("Insufficient") ? this.props.login.error.response.data.errors.detail : this.props.login.error && this.props.login.error.response.data.errors.detail.includes("inactive") ? _react2.default.createElement(
	                      'span',
	                      null,
	                      'This account has been archived. To activate it, ',
	                      _react2.default.createElement(
	                        'a',
	                        { onClick: this.handleWidget },
	                        'contact'
	                      ),
	                      ' ShippingCart Customer Care.'
	                    ) : this.props.login.error && this.props.login.error.response.data.errors.detail.includes("You cannot register") ? this.props.login.error.response.data.errors.detail : this.props.login.error && this.props.login.error.response.data.errors.detail.includes("Your account has been permanently suspended") ? _react2.default.createElement(
	                      'span',
	                      null,
	                      'Your account has been permanently suspended based on ',
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/terms-conditions' },
	                        'Section 4-H'
	                      ),
	                      ' of our Terms of Service.'
	                    ) : this.props.login.error && this.props.login.error.response.data.errors.detail
	                  )
	                ),
	                this.props.login.errorFB ? this.props.login.errorFB.response.data.errors.detail.includes("access token") ? null : _react2.default.createElement(
	                  'div',
	                  { className: 'sc-alert sc-alert-danger' },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  this.props.login.errorFB.response.data.errors.detail.includes("inactive") ? _react2.default.createElement(
	                    'span',
	                    null,
	                    'This account has been archived. To activate it, ',
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: this.handleWidget },
	                      'contact'
	                    ),
	                    ' ShippingCart Customer Care.'
	                  ) : this.props.login.errorFB.response.data.errors.detail === "Trying to get property of non-object" ? _react2.default.createElement(
	                    'span',
	                    null,
	                    'This email isn\'t associated with any ShippingCart account. ',
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/signup' },
	                      'Sign up.'
	                    )
	                  ) : this.props.login.errorFB.response.data.errors.detail
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.trackPackage && this.state.noOtherError ? "sc-alert sc-alert-danger" : "disnone" },
	                  _react2.default.createElement('i', { className: 'sc' }),
	                  'You must login in order to access the page.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sign-in' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Sign in with email:'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'login-form' },
	                    _react2.default.createElement(
	                      'form',
	                      { id: 'login_form', onSubmit: this.handleSubmit },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-input' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'input-wrapper group-input' },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              'Email address '
	                            ),
	                            '\xA0',
	                            _react2.default.createElement('label', { ref: 'errors_email', className: 'disnone' }),
	                            _react2.default.createElement('input', { type: 'email', maxLength: '50', className: 'form-control', ref: 'email', defaultValue: this.state.email, autoFocus: true })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'input-wrapper group-input' },
	                          _react2.default.createElement(
	                            'label',
	                            null,
	                            'Password '
	                          ),
	                          '\xA0',
	                          _react2.default.createElement('label', { ref: 'errors_password', className: 'disnone' }),
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'input-group' },
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('input', { type: 'password', maxLength: '100', className: 'form-control  show-password', ref: 'password', defaultValue: this.state.password })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'input-group-addon' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'checkbox checkbox_nomargin' },
	                                  _react2.default.createElement('input', { id: 'show_password', name: 'show_password', type: 'checkbox', ref: 'show_password', onClick: this.handleClick }),
	                                  _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'show_password' },
	                                    'SHOW'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'submit' },
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-login align-right btn-orange' },
	                          'Sign in using our secure server'
	                        ),
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/reset-password' },
	                          'Forgot your password?'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'or'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'fb-login group' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'btn-facebook clearfix', disabled: true },
	                    _react2.default.createElement(_FacebookLogin2.default, { socialId: fbAppId, language: 'en_US', fields: 'email', scope: 'public_profile,user_friends,email', responseHandler: this.responseFacebook, xfbml: true, version: 'v8.0', className: 'custombtnfacebook', buttonText: 'Sign in with Facebook' })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Don\u2019t have an account yet? \xA0',
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/signup' },
	                      'Sign up here'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, {
	          currentPath: this.props.location.pathname,
	          currentYear: this.props.login.year
	        })
	      )
	    );
	  }
	});
	
	exports.default = SignIn;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(58);
	
	var _reactRedux = __webpack_require__(46);
	
	var _Signup = __webpack_require__(90);
	
	var SignupAction = _interopRequireWildcard(_Signup);
	
	var _Signin = __webpack_require__(50);
	
	var SigninAction = _interopRequireWildcard(_Signin);
	
	var _SignIn = __webpack_require__(624);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function mapStateToProps(state) {
	  return {
	    login: state.signin,
	    register: state.signup
	  };
	}
	function mapDispachToProps(dispatch) {
	  return (0, _redux.bindActionCreators)(Object.assign({}, SigninAction, SignupAction), dispatch);
	}
	var SignInContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(_SignIn2.default);
	exports.default = SignInContainer;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(843);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _FacebookLogin = __webpack_require__(252);
	
	var _FacebookLogin2 = _interopRequireDefault(_FacebookLogin);
	
	var _reactRecaptcha = __webpack_require__(529);
	
	var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);
	
	var _MobileHeader = __webpack_require__(122);
	
	var _MobileHeader2 = _interopRequireDefault(_MobileHeader);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _utils = __webpack_require__(13);
	
	var _uuid = __webpack_require__(70);
	
	var _warehouseCode = __webpack_require__(159);
	
	var _brandLogo = __webpack_require__(188);
	
	var _brandLogo2 = _interopRequireDefault(_brandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint-disable */
	var appConfig = __webpack_require__(71);
	var fbAppId = appConfig.fbAppId;
	var extensionId = appConfig.extensionId;
	/* eslint-enable */
	
	var createReactClass = __webpack_require__(16);
	var SignUp = createReactClass({
	    displayName: 'SignUp',
	    componentWillMount: function componentWillMount() {
	        var script = document.createElement("script");
	
	        var x = document.getElementsByClassName("lbcx");
	
	        for (var i = 0; i < x.length; i++) {
	            document.body.removeChild(x.item(i));
	        }
	
	        script.setAttribute('class', 'lbcx');
	        script.src = "js/custom.js";
	        script.async = true;
	
	        document.body.appendChild(script);
	
	        this.props.getCopyrightYear();
	
	        localStorage.removeItem('checkoutModalShowed');
	
	        document.title = "Sign up | ShippingCart";
	
	        var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
	        var isMac = navigator.userAgent.toLowerCase().indexOf('mac') > -1;
	        if (isChrome) {
	            if (!isMac) {
	                (0, _utils.extensionDetect)(extensionId);
	            }
	        } else {
	            localStorage.setItem("cartExtensionModalShowed", true);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        window.scrollTo(0, 0);
	
	        // <!-- Lightning Bolt Begins -->
	        var lbscript = document.createElement("script");
	        lbscript.type = "text/javascript";
	        lbscript.src = "/js/lightningbolt.js";
	        lbscript.async = true;
	        document.body.appendChild(lbscript);
	
	        var lbscript1 = document.createElement("script");
	        lbscript1.type = "text/javascript";
	        lbscript1.setAttribute('id', 'lightning_bolt');
	        lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
	        lbscript1.async = true;
	        document.body.appendChild(lbscript1);
	        // <!-- Lightning Bolt Ends -->
	
	        localStorage.setItem('grabKey', this.queryParam("s2s"));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.props.resetAccounts();
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        if (this.state.submitted) {
	            window.scrollTo(0, 0);
	            var status = this.props.error ? this.props.error.response.status : 200;
	
	            if (status !== 200) {
	                this.refs.notify_error.parentElement.className = "notify";
	
	                var errText = document.getElementsByClassName('input-error');
	                var errKey = errText.length;
	
	                while (errKey--) {
	                    errText[errKey].parentElement.className = "control";
	                    errText[errKey].className = "disnone";
	                }
	
	                if (status === 422) {
	                    var errors = this.props.error.response.data.errors;
	
	                    for (var i = 0; i < errors.length; i++) {
	                        this.refs["errors_" + errors[i].title].innerHTML = errors[i].detail;
	                        this.refs["errors_" + errors[i].title].className = "input-error";
	                        this.refs["errors_" + errors[i].title].parentElement.className = "control has-error";
	                    }
	                }
	            }
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.register.fetched) {
	            this.setState({
	                showModal: true
	            });
	        }
	    },
	    responseFacebook: function responseFacebook(response) {
	        var token = response.accessToken;
	        this.props.FacebookSignedUp(token);
	    },
	
	
	    getInitialState: function getInitialState() {
	        return {
	            first_name: '',
	            last_name: '',
	            email: '',
	            password: '',
	            password_confirmation: '',
	            contact_number: '',
	            submitted: false,
	            recaptcha: '',
	            countryPrefix: '+63',
	            errors: ['first_name', 'last_name', 'email', 'password', 'password_confirmation', 'phone_number', 'gender', 'birthdate', 'recaptcha']
	        };
	    },
	    clearErrors: function clearErrors() {
	        var _this = this;
	
	        this.state.errors.forEach(function (error) {
	            _this.refs['errors_' + error].innerHTML = '';
	            _this.refs['errors_' + error].className = '';
	        });
	    },
	    handleSubmit: function handleSubmit(e) {
	        e.preventDefault();
	        this.clearErrors();
	        if (this.state.contact_number.length < 7) {
	            this.refs["errors_phone_number"].innerHTML = 'Phone number should have minimum of 7 digits.';
	            this.refs["errors_phone_number"].className = "input-error";
	            this.refs["errors_phone_number"].parentElement.className = "control has-error";
	            return;
	        }
	        this.refs.notify_error.parentElement.className = "disnone";
	        var email = this.state.email;
	        var password = this.state.password;
	        var password_confirmation = this.state.password_confirmation;
	        var first_name = this.state.first_name;
	        var middle_name = "";
	        var last_name = this.state.last_name;
	        var gender = "";
	        var contact_number = this.state.countryPrefix + this.state.contact_number;
	        var checkbox = this.refs.terms.checked;
	        var birthdate = this.formatDateOnly(this.refs.birthdate.value, '/', '-');
	        var recaptcha = this.state.recaptcha;
	        var partnerCode = window.location.search.includes("pcode") ? window.location.search.split("&")[0].slice(7) : null;
	        if (this.refs.male.checked) {
	            gender = "male";
	        } else if (this.refs.female.checked) {
	            gender = "female";
	        } else {
	            gender = "";
	        }
	
	        if (checkbox) {
	            this.props.signup(null, email, password, password_confirmation, first_name, middle_name, last_name, gender, contact_number, birthdate, recaptcha, partnerCode);
	            this.setState({ submitted: true, recaptcha: "" });
	        }
	        this.refs.terms.checked = false;
	        this.recaptchaInstance.reset();
	    },
	    handleChange: function handleChange(e) {
	        var target = e.target;
	        var name = target.name;
	        var value = target.value;
	
	        this.setState(_defineProperty({}, name, value));
	    },
	    handleEnable: function handleEnable() {
	        if (this.state.first_name && this.state.last_name && this.state.email && this.state.password && this.state.password_confirmation && this.state.contact_number && this.state.contact_number && this.state.recaptcha && this.refs.terms.checked) {
	            return false;
	        }
	        return true;
	    },
	    verifyCallback: function verifyCallback(response) {
	        this.setState({ recaptcha: response });
	    },
	    callback: function callback() {},
	    formatDateOnly: function formatDateOnly(arr, separator, format) {
	        if (arr) {
	            if (separator === "/") {
	                arr = arr.split(separator);
	                arr.unshift(arr[arr.length - 1]);
	                arr.pop();
	                return arr.join(format);
	            } else if (separator === "-") {
	                arr = arr.split(separator);
	                arr.push(arr[0]);
	                arr.shift();
	                return arr.join(format);
	            }
	        }
	        return arr;
	    },
	    handleShowPassword: function handleShowPassword(e) {
	        var name = e.target.name;
	        if (this.refs['show_' + name].checked) {
	            this.refs[name].type = 'text';
	        } else {
	            this.refs[name].type = 'password';
	        }
	    },
	    injectMediaDonutScript: function injectMediaDonutScript() {
	        var axel = Math.random() + "";
	        var a = axel * 10000000000000;
	        document.write('<iframe title=' + (0, _uuid.v4)() + ' src=https://9848754.fls.doubleclick.net/activityi;src=9848754;type=signu0;cat=signu0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a + '? width="1" height="1" frameBorder="0" style="display:none"></iframe>');
	    },
	    queryParam: function queryParam(key) {
	        // eslint-disable-next-line no-useless-escape
	        key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	        var regex = new RegExp("[\\?&]" + key + "=([^&#]*)").exec(window.location.search);
	        return null === regex ? "" : decodeURIComponent(regex[1].replace(/\+/g, " "));
	    },
	    handleWidget: function handleWidget(e) {
	        e.preventDefault();
	        window.FreshWidget.show();
	    },
	    render: function render() {
	        var _this2 = this;
	
	        var captchaSize = 'default';
	
	        if (window.innerWidth < 350) {
	            captchaSize = 'compact';
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'noscript',
	                null,
	                _react2.default.createElement('iframe', { title: (0, _uuid.v4)(), src: 'https://9848754.fls.doubleclick.net/activityi;src=9848754;type=signu0;cat=signu0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?', width: '1', height: '1', frameBorder: '0', style: { display: 'none' } })
	            ),
	            _react2.default.createElement(_MobileHeader2.default, { isAuthenticated: false, isSideNavOpen: false }),
	            _react2.default.createElement(
	                'div',
	                { id: 'shippingcart_app', className: 'header-minimal' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'site-header header-minimal' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/' },
	                                _react2.default.createElement('img', { alt: 'icon', src: _brandLogo2.default, style: { height: 35, width: 210, margin: 25 } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'nav',
	                            { className: 'top-nav' },
	                            _react2.default.createElement('ul', null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body-wrapper signinpage' },
	                    _react2.default.createElement(
	                        'section',
	                        { className: 'container register', 'data-do': 'register-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'register-wrapper' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'register-header' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'back-link' },
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/home' },
	                                        ' < Back to home'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'register-header-text' },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        null,
	                                        'Sign up with ShippingCart'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'register-text' },
	                                        'Start shopping from ',
	                                        _warehouseCode.warehouseAND,
	                                        ' online shops and ship to your doorstep.'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'register-form clearfix' },
	                                this.props.login.errorFB && this.props.login.errorFB.response.data.errors.detail.includes("inactive") ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'sc-alert sc-alert-danger' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'This account has been archived. To activate it, ',
	                                        _react2.default.createElement(
	                                            'a',
	                                            { onClick: this.handleWidget },
	                                            'contact'
	                                        ),
	                                        ' ShippingCart Customer Care.'
	                                    )
	                                ) : null,
	                                this.props.login.errorFB && !this.props.login.errorFB.response.data.errors.detail.includes("inactive") ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'sc-alert sc-alert-danger' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        this.props.login.errorFB.response.data.errors.detail
	                                    )
	                                ) : null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'left' },
	                                    _react2.default.createElement(
	                                        'form',
	                                        { id: 'register-form-form', method: 'POST', onSubmit: this.handleSubmit },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'disnone' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { ref: 'notify_error', className: 'sc-alert sc-alert-danger' },
	                                                this.props.error && this.props.error.response && this.props.error.response.data.errors.detail === 'Partners Code is invalid' ? _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    ' ',
	                                                    _react2.default.createElement('i', { className: 'sc' }),
	                                                    ' ',
	                                                    this.props.error.response.data.errors.detail,
	                                                    ' '
	                                                ) : _react2.default.createElement(
	                                                    'div',
	                                                    null,
	                                                    _react2.default.createElement('i', { className: 'sc' }),
	                                                    'Fill in all the required fields to sign up.'
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-input group' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'First Name '
	                                                    ),
	                                                    '\xA0',
	                                                    _react2.default.createElement('label', { ref: 'errors_first_name', className: 'disnone' }),
	                                                    _react2.default.createElement('input', { autoFocus: true, type: 'text', ref: 'first_name', maxLength: '20',
	                                                        className: 'register-input form-control letter-only ',
	                                                        name: 'first_name', defaultValue: '',
	                                                        onChange: this.handleChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Last Name'
	                                                    ),
	                                                    '\xA0',
	                                                    _react2.default.createElement('label', { ref: 'errors_last_name', className: 'disnone' }),
	                                                    _react2.default.createElement('input', { type: 'text', ref: 'last_name', maxLength: '20',
	                                                        className: 'register-input form-control letter-only ',
	                                                        name: 'last_name', defaultValue: '',
	                                                        onChange: this.handleChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Email Address '
	                                                    ),
	                                                    '\xA0',
	                                                    _react2.default.createElement('label', { ref: 'errors_email', className: 'disnone' }),
	                                                    _react2.default.createElement('input', { type: 'email', ref: 'email', maxLength: '50',
	                                                        className: 'register-input form-control ',
	                                                        name: 'email', defaultValue: '',
	                                                        onChange: this.handleChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control ' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Password'
	                                                    ),
	                                                    '\xA0',
	                                                    _react2.default.createElement('label', { ref: 'errors_password', className: 'disnone' }),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'input-group' },
	                                                        _react2.default.createElement('input', { type: 'password',
	                                                            ref: 'password', maxLength: '100',
	                                                            className: 'register-input form-control',
	                                                            name: 'password', defaultValue: '',
	                                                            onChange: this.handleChange }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'input-group-addon' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'checkbox checkbox_nomargin' },
	                                                                _react2.default.createElement('input', {
	                                                                    id: 'show_password',
	                                                                    name: 'password',
	                                                                    type: 'checkbox',
	                                                                    ref: 'show_password',
	                                                                    onClick: function onClick(e) {
	                                                                        return _this2.handleShowPassword(e);
	                                                                    }
	                                                                }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { htmlFor: 'show_password' },
	                                                                    'SHOW'
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Re-enter Password'
	                                                    ),
	                                                    '\xA0',
	                                                    _react2.default.createElement('label', { ref: 'errors_password_confirmation', className: 'disnone' }),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'input-group' },
	                                                        _react2.default.createElement('input', { type: 'password', ref: 'password_confirmation',
	                                                            maxLength: '100', className: 'register-input form-control',
	                                                            name: 'password_confirmation', defaultValue: '',
	                                                            onChange: this.handleChange }),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'input-group-addon' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'checkbox checkbox_nomargin' },
	                                                                _react2.default.createElement('input', {
	                                                                    id: 'show_password_confirmation',
	                                                                    name: 'password_confirmation',
	                                                                    type: 'checkbox',
	                                                                    ref: 'show_password_confirmation',
	                                                                    onClick: function onClick(e) {
	                                                                        return _this2.handleShowPassword(e);
	                                                                    }
	                                                                }),
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    { htmlFor: 'show_password_confirmation' },
	                                                                    'SHOW'
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Contact Number'
	                                                    ),
	                                                    '\xA0',
	                                                    _react2.default.createElement('label', { ref: 'errors_phone_number', className: 'disnone' }),
	                                                    _react2.default.createElement('br', null),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { style: { display: 'flex' } },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'mobile-country' },
	                                                            _react2.default.createElement(
	                                                                'select',
	                                                                { onChange: this.handleChange, name: 'countryPrefix' },
	                                                                _utils.mapPrefixNumber.map(function (prefix) {
	                                                                    return _react2.default.createElement(
	                                                                        'option',
	                                                                        { value: prefix.value },
	                                                                        prefix.label
	                                                                    );
	                                                                })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', ref: 'phone_number', maxLength: '10', style: { margin: '0px 0px 0px 71px' },
	                                                            className: 'register-input form-control ',
	                                                            name: 'contact_number', defaultValue: '',
	                                                            autoComplete: 'off',
	                                                            onChange: this.handleChange })
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Gender'
	                                                    ),
	                                                    _react2.default.createElement('label', { ref: 'errors_gender', className: 'disnone' }),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'break' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'radio' },
	                                                            _react2.default.createElement('input', { id: 'customer-gender-male', type: 'radio',
	                                                                name: 'customer_gender', value: 'male', ref: 'male',
	                                                                defaultChecked: true }),
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                { htmlFor: 'customer-gender-male' },
	                                                                'Male'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'radio' },
	                                                            _react2.default.createElement('input', { id: 'customer-gender-female', type: 'radio',
	                                                                name: 'customer_gender', value: 'female',
	                                                                ref: 'female' }),
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                { htmlFor: 'customer-gender-female' },
	                                                                'Female'
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        'Birthdate ',
	                                                        _react2.default.createElement(
	                                                            'em',
	                                                            null,
	                                                            '(optional)'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement('label', { ref: 'errors_birthdate', className: 'disnone' }),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'input-group calendar', 'data-do': 'datetime' },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'view' },
	                                                            'mm/dd/yyyy'
	                                                        ),
	                                                        _react2.default.createElement('input', { id: 'datepicker', type: 'text', name: 'customer_birthdate',
	                                                            className: 'form-control', ref: 'birthdate', readOnly: true }),
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { className: 'input-group-addon' },
	                                                            _react2.default.createElement('i', { className: 'fa fa-calendar' })
	                                                        )
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input captcha' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control' },
	                                                    _react2.default.createElement('label', { ref: 'errors_recaptcha', className: 'disnone' }),
	                                                    _react2.default.createElement(_reactRecaptcha2.default, { sitekey: '6Ld0ERUUAAAAAP_R4QOXrx2K-furHNW55cv26LGF',
	                                                        size: captchaSize, render: 'explicit',
	                                                        verifyCallback: this.verifyCallback,
	                                                        onloadCallback: this.callback,
	                                                        ref: function ref(e) {
	                                                            return _this2.recaptchaInstance = e;
	                                                        },
	                                                        onChange: this.handleChange })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'input-wrapper group-input' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'control terms-checkbox' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'checkbox' },
	                                                        _react2.default.createElement('input', { id: 'terms-accepted', type: 'checkbox',
	                                                            name: 'terms', 'data-do': 'terms-accept',
	                                                            'data-on': 'change', ref: 'terms',
	                                                            onChange: this.handleChange }),
	                                                        _react2.default.createElement(
	                                                            'label',
	                                                            { className: 'terms-accepted', htmlFor: 'terms-accepted' },
	                                                            'Signing up for ShippingCart account means you accept our',
	                                                            _react2.default.createElement(
	                                                                _reactRouter.Link,
	                                                                { to: '/terms-conditions' },
	                                                                ' Terms and Conditions'
	                                                            ),
	                                                            ' and',
	                                                            _react2.default.createElement(
	                                                                _reactRouter.Link,
	                                                                { to: '/privacy-policy' },
	                                                                ' Privacy Policy'
	                                                            ),
	                                                            '. This also subscribes you to our communication updates to give you access to promos and announcements. You can unsubscribe anytime!'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'submit-group group' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'register-btn' },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { disabled: this.handleEnable(), type: 'submit',
	                                                        className: 'btn btn-register align-right btn-orange' },
	                                                    'Sign up'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'or' },
	                                        'or'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'right' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'fb-register group' },
	                                        _react2.default.createElement('div', { id: 'fb-root' }),
	                                        !window.location.search.includes("pcode") && _react2.default.createElement(
	                                            'a',
	                                            { className: 'btn-facebook clearfix' },
	                                            _react2.default.createElement(_FacebookLogin2.default, { socialId: fbAppId, language: 'en_US',
	                                                fields: 'email', scope: 'public_profile,user_friends,email',
	                                                responseHandler: this.responseFacebook, xfbml: false,
	                                                version: 'v8.0', className: 'custombtnfacebook',
	                                                buttonText: 'Sign Up Using Facebook' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'login-link' },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                'Already registered? ',
	                                                _react2.default.createElement(
	                                                    _reactRouter.Link,
	                                                    { to: '/signin' },
	                                                    'Sign in'
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bottom-shadow-wrapper' },
	                            _react2.default.createElement('div', { className: 'shadow' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(_Footer2.default, { currentPath: this.props.location.pathname, currentYear: this.props.login.year })
	            )
	        );
	    }
	});
	
	exports.default = SignUp;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(58);
	
	var _reactRedux = __webpack_require__(46);
	
	var _Signup = __webpack_require__(90);
	
	var SignupAction = _interopRequireWildcard(_Signup);
	
	var _Signin = __webpack_require__(50);
	
	var SigninAction = _interopRequireWildcard(_Signin);
	
	var _SignUp = __webpack_require__(626);
	
	var _SignUp2 = _interopRequireDefault(_SignUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function mapStateToProps(state) {
	
	  return {
	    login: state.signin,
	    register: state.signup,
	    error: state.signup.error
	  };
	}
	function mapDispachToProps(dispatch) {
	  return (0, _redux.bindActionCreators)(Object.assign({}, SigninAction, SignupAction), dispatch);
	}
	var SignUpContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispachToProps)(_SignUp2.default);
	exports.default = SignUpContainer;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var TestLogin = createReactClass({
	  displayName: 'TestLogin',
	  getInitialState: function getInitialState() {
	    return {
	      email: "",
	      passcode: ""
	    };
	  },
	  handleSubmit: function handleSubmit(e) {
	    e.preventDefault();
	    console.log(this.props);
	    //   console.log(this.state.email);
	    this.props.testLogin(this.state.email, this.state.passcode);
	  },
	  handleInput: function handleInput(evt) {
	    this.setState({ email: evt.target.value });
	  },
	  handleInputPC: function handleInputPC(evt) {
	    this.setState({ passcode: evt.target.value });
	  },
	  render: function render() {
	    return (
	      // <div>
	      //     <h1>God Login</h1>
	      //     <input type="text" defaultValue={this.state.email} onInput={this.handleInput}/>
	      //     <button onClick={this.handleSubmit}>Go</button>
	      // </div>
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'page-login header-minimal-head' },
	          _react2.default.createElement(
	            'header',
	            { className: 'site-header header-minimal' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'nav',
	                { className: 'top-nav' },
	                _react2.default.createElement('ul', null)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-wrapper signinpage' },
	            _react2.default.createElement(
	              'section',
	              { className: 'container login' },
	              _react2.default.createElement(
	                'div',
	                { className: 'login-header clearfix' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Welcome back!'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'login-wrapper clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'left' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sign-in' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'login-form' },
	                      _react2.default.createElement(
	                        'form',
	                        { id: 'login_form', onSubmit: this.handleSubmit },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-input' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'input-wrapper group-input' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Email address '
	                              ),
	                              '\xA0',
	                              _react2.default.createElement('label', { ref: 'errors_email', className: 'disnone' }),
	                              _react2.default.createElement('input', { type: 'text', maxLength: '50', className: 'form-control', onInput: this.handleInput, defaultValue: this.state.email, autoFocus: true })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(
	                                'label',
	                                null,
	                                'Passcode '
	                              ),
	                              '\xA0',
	                              _react2.default.createElement('label', { ref: 'errors_email', className: 'disnone' }),
	                              _react2.default.createElement('input', { type: 'password', maxLength: '50', className: 'form-control', onInput: this.handleInputPC, defaultValue: this.state.passcode, autoFocus: true })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'submit' },
	                          _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-login align-right btn-orange' },
	                            'Sign in using our secure server'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = TestLogin;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(845);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolTip = function (_React$Component) {
	  _inherits(ToolTip, _React$Component);
	
	  function ToolTip(props) {
	    _classCallCheck(this, ToolTip);
	
	    var _this = _possibleConstructorReturn(this, (ToolTip.__proto__ || Object.getPrototypeOf(ToolTip)).call(this, props));
	
	    _this.state = {
	      displayTooltip: false
	    };
	    _this.hideTooltip = _this.hideTooltip.bind(_this);
	    _this.showTooltip = _this.showTooltip.bind(_this);
	    return _this;
	  }
	
	  _createClass(ToolTip, [{
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      this.setState({ displayTooltip: false });
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      this.setState({ displayTooltip: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var message = this.props.message;
	      var position = this.props.position;
	      return _react2.default.createElement(
	        'span',
	        { className: 'tooltip-position',
	          onMouseLeave: this.hideTooltip
	        },
	        this.state.displayTooltip && _react2.default.createElement(
	          'div',
	          { className: 'tooltip-bubble tooltip-' + position },
	          _react2.default.createElement(
	            'div',
	            { className: 'tooltip-message' },
	            message
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          {
	            className: 'tooltip-trigger',
	            onMouseOver: this.showTooltip
	          },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ToolTip;
	}(_react2.default.Component);
	
	exports.default = ToolTip;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(848);
	
	var _dateFns = __webpack_require__(54);
	
	var _utils = __webpack_require__(13);
	
	var _OutBoundBanner = __webpack_require__(92);
	
	var _OutBoundBanner2 = _interopRequireDefault(_OutBoundBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Track = function (_Component) {
	  _inherits(Track, _Component);
	
	  function Track() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Track);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Track.__proto__ || Object.getPrototypeOf(Track)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      latest: '',
	      latestRemarks: '',
	      status: '',
	      estimatedDate: '',
	      deliveredDate: '',
	      trackingNumber: '',
	      searchResult: '',
	      settings: null
	    }, _this.handleKeyDown = function (e) {
	      if (!_this.state.trackingNumber) return;
	      if (e.key === 'Enter') {
	        _this.props.getTrackDetails(_this.state.trackingNumber);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Track, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var tracking_number = this.props.params.id;
	      if (tracking_number) {
	        this.props.getTrackDetails(tracking_number);
	        this.setState({ trackingNumber: tracking_number });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // <!-- NetCore Script -->
	      var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	      window.smartech && (0, _utils.netcoreScript)(accountNumber);
	      // <!-- NetCore Script -->      
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.params.id !== this.props.params.id) {
	        this.props.getTrackDetails(this.props.params.id);
	        this.setState({ trackingNumber: this.props.params.id });
	      }
	    }
	    // handleTrackPackage() {
	    // 	localStorage.setItem("trackPackage", "true");
	    // }
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.shipmentInfo.track) {
	        this.setState({ searchResult: nextProps.shipmentInfo.track });
	        if (nextProps.shipmentInfo.track !== this.props.shipmentInfo.track) {
	          this.props.getGlobalSettings(nextProps.shipmentInfo.track.shipment && (0, _utils.maskOriginID)(nextProps.shipmentInfo.track.shipment.toUpperCase().slice(0, 2)));
	        }
	        if (nextProps.settings.globalSettings !== this.props.settings.globalSettings) {
	          var data = nextProps.settings.globalSettings.data;
	
	          var settings = data.map(function (item) {
	            return item;
	          });
	          this.setState({ settings: settings });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.removeTrackDetails();
	    }
	  }, {
	    key: 'handleStatus',
	    value: function handleStatus(track_status) {
	      switch (track_status) {
	        case "confirmed":
	        case "for_pickup":
	        case "consolidated":
	        case "for_consolidation":
	          return "Preparing for Shipment";
	        case "failed_pickup":
	        case "in_transit":
	        case "out_for_delivery":
	        case "failed_delivery":
	        case "return_in_transit":
	        case "returned":
	        case "failed_return":
	        case "for_acceptance":
	        case "accepted":
	        case "received_at_pickup_hub":
	        case "received_at_delivery_hub":
	        case "for_return":
	        case "received_at_delivery_area":
	        case "at_sorting_center":
	        case "in_transit_to_delivery_area":
	        case "transferred_to_partner":
	        case "for_transfer":
	        case "out_for_return":
	        case "for_dropoff":
	        case "dropped_off":
	        case "dws_update":
	          return "On Its Way";
	        case "pending":
	        case "canceled":
	        case "rejected":
	          return "Cancelled";
	        case "delivered":
	        case "claimed":
	        case "picked_up":
	          return "Delivered";
	        default:
	          return "";
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _e$target = e.target,
	          value = _e$target.value,
	          name = _e$target.name;
	
	      if (/\s/g.test(value)) return;
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'handleSearchButton',
	    value: function handleSearchButton() {
	      if (!this.state.trackingNumber) return;
	      this.props.getTrackDetails(this.state.trackingNumber);
	    }
	  }, {
	    key: 'reverseTrackingEvents',
	    value: function reverseTrackingEvents(shipment) {
	      return shipment.events.sort(function (a, b) {
	        return a.created_at < b.created_at ? 1 : -1;
	      }).filter(function (event) {
	        if (event.status === 'for_acceptance') return null;
	        if (event.status === 'for_transfer') return null;
	        if (shipment.shipment === 'uk-sea' && event.remarks.toLowerCase().includes('accepted at office')) return null;
	        if (event.status === 'consolidated' && shipment.events.length > 1) return null;
	        return event;
	      });
	    }
	  }, {
	    key: 'handleCanceledStatus',
	    value: function handleCanceledStatus(status) {
	      switch (status) {
	        case "canceled":
	        case "CANCELED":
	        case "cancelled":
	        case "CANCELLED":
	        case "rejected":
	        case "REJECTED":
	          return false;
	        default:
	          return true;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var marketingBanners = [{ key: 1, img: 'https://cdn.shippingcart.com/assets/bfm-main-image-20220819044707.png', title: 'BUY-FOR-ME SERVICE', description: 'Tell us what items you’d like to buy and we’ll make your shopping experience easier.', link: '/buy-for-me-shopping-guide' }, { key: 2, img: 'https://cdn.shippingcart.com/assets/turbo-boxes-20220719015550.png', title: 'SOCIAL SELLERS', description: 'Want to receive your online orders for your biz from the US, UK, Korea, Japan and Australia quickly and affordably?', link: '/shippingcart-sellers' }, { key: 3, img: 'https://cdn.shippingcart.com/assets/pasabuyanihan-main-image-1-20220630030011.png', title: 'PASABUYANIHAN', description: 'Lahat ng international orders mo, at nila, kayang kaya sa isang shipping', link: '/pasabuyanihan' }];
	
	      var outBoundBannerData = this.state.settings && this.state.settings.filter(function (data) {
	        return data.name === "outbound_banner";
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'page-track' },
	          _react2.default.createElement(
	            'div',
	            { id: 'shippingcart_app', className: 'header-original' },
	            _react2.default.createElement(
	              'div',
	              { className: 'body-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'track-header' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'page-title' },
	                  'Track Your Package'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'search-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'search-title' },
	                    'Enter your ShippingCart tracking number'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'search-input' },
	                    _react2.default.createElement('input', { type: 'search', className: 'search-input-field', value: this.state.trackingNumber, name: 'trackingNumber', onChange: function onChange(e) {
	                        return _this2.onChange(e);
	                      }, placeholder: '1234-5678-ABCD', onKeyDown: this.handleKeyDown }),
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', onClick: function onClick() {
	                          return _this2.handleSearchButton();
	                        } },
	                      'Search'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'page-body-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'container page-body', hidden: !this.state.searchResult },
	                  this.props.shipmentInfo.fetchTrackDetail ? _react2.default.createElement(
	                    'div',
	                    { className: 'spinner' },
	                    _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' })
	                  ) : this.state.searchResult.shipment && this.handleCanceledStatus(this.state.searchResult.status) ? _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: '40px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'shipment-history-title' },
	                      'Shipment History'
	                    ),
	                    outBoundBannerData && _react2.default.createElement(
	                      'div',
	                      { style: { margin: '10px 0px' } },
	                      _react2.default.createElement(_OutBoundBanner2.default, { outBoundBannerData: outBoundBannerData })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'track-list-wrapper' },
	                      this.state.searchResult.events.length > 0 ? this.reverseTrackingEvents(this.state.searchResult).map(function (event, index) {
	                        return event && event.status !== 'for_transfer' && _react2.default.createElement(
	                          'div',
	                          { className: 'track-list-item' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'track-icon-wrapper' },
	                            _react2.default.createElement('i', { className: 'fa fa-map-marker', 'aria-hidden': 'true', style: index === 0 ? { fontSize: '30px', color: 'rgb(170, 14, 14)' } : { fontSize: '30px' } }),
	                            _react2.default.createElement('span', { className: 'track-dash-line' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'track-list-content' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'track-remarks' },
	                              (0, _utils.maskEventRemarks)(event.remarks, event.status_updated_at, event.status)
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'track-dates' },
	                              (0, _dateFns.format)(event.created_at, 'MM/DD/YYYY hh:mm A')
	                            )
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        'div',
	                        { className: 'track-list-item', style: { placeContent: 'center' } },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'track-icon-wrapper' },
	                          _react2.default.createElement('i', { className: 'fa fa-map-marker', 'aria-hidden': 'true', style: { fontSize: '30px', color: 'rgb(170, 14, 14)' } }),
	                          _react2.default.createElement('span', { className: 'track-dash-line' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'track-list-content' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'track-remarks' },
	                            'Your package is being processed for shipping.'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'track-dates' },
	                            (0, _dateFns.format)(this.state.searchResult.transaction_date, 'MM/DD/YYYY hh:mm A')
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'information-wrapper' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'information-box' },
	                          _react2.default.createElement('span', { className: 'information-icon' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'information-content' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'information-title' },
	                              'Frequently Asked Questions'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'information-description' },
	                              'For more info visit our ',
	                              _react2.default.createElement(
	                                'a',
	                                { href: 'https://help-center.shippingcart.com/hc/en-us', target: '_blank', rel: 'noopener noreferrer' },
	                                'help center'
	                              ),
	                              '.'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'empty-wrapper' },
	                    _react2.default.createElement('span', { className: 'search-empty search-not-found-icon' }),
	                    _react2.default.createElement(
	                      'h3',
	                      { className: 'search-empty-msg' },
	                      'Tracking details not found!'
	                    ),
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'search-empty-msg2' },
	                      'Check your tracking number and try it again.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'marketing-banner' },
	                marketingBanners && marketingBanners.map(function (banner) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'marketing-banner-box', id: banner.key },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'banner-image-wrapper' },
	                      _react2.default.createElement('img', { className: 'banner-image-link', src: banner.img, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'track-banner-title' },
	                        banner.title
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'track-banner-description' },
	                        banner.description
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { href: banner.link, target: '_blank' },
	                        'Learn more'
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Track;
	}(_react.Component);
	
	exports.default = Track;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _dateFns = __webpack_require__(54);
	
	var _Header = __webpack_require__(123);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _utils = __webpack_require__(13);
	
	__webpack_require__(846);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReactClass = __webpack_require__(16);
	var TrackDetail = createReactClass({
	  displayName: 'TrackDetail',
	  componentWillMount: function componentWillMount() {
	    document.title = "Tracking Details";
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.shipmentInfo.fetched_order) {
	      var status = nextProps.shipmentInfo.order.data.status;
	
	
	      switch (status) {
	        case "confirmed":
	        case "for_pickup":
	        case "consolidated":
	        case "for_consolidation":
	          this.setState({ orderStatus: { class: 'prepshipment', imagePath: 'shipment2' } });
	          break;
	        case "failed_pickup":
	        case "in_transit":
	        case "out_for_delivery":
	        case "failed_delivery":
	        case "return_in_transit":
	        case "returned":
	        case "failed_return":
	        case "for_acceptance":
	        case "accepted":
	        case "received_at_pickup_hub":
	        case "received_at_delivery_hub":
	        case "for_return":
	        case "received_at_delivery_area":
	        case "at_sorting_center":
	        case "in_transit_to_delivery_area":
	        case "transferred_to_partner":
	        case "for_transfer":
	        case "out_for_return":
	        case "for_dropoff":
	        case "dropped_off":
	        case "dws_update":
	          this.setState({ orderStatus: { class: 'intransit', imagePath: 'shipment1', size: '130%' } });
	          break;
	        case "delivered":
	        case "claimed":
	        case "picked_up":
	          this.setState({ orderStatus: { class: 'delivered', imagePath: 'shipment3', size: '135%' } });
	          break;
	        default:
	          this.setState({ orderStatus: { class: status } });
	      }
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    window.scrollTo(0, 0);
	    var token = localStorage.jwtToken;
	    this.props.getOrderDetails(this.props.params.id, token);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.resetOrders();
	  },
	  handleStatuses: function handleStatuses(shipment_status, type, payment_status) {
	    var str = shipment_status === "canceled" && payment_status === "rejected" ? payment_status : shipment_status;
	
	    if (str) {
	      if (type === "class") {
	        switch (str) {
	          case "confirmed":
	          case "for_pickup":
	          case "consolidated":
	          case "for_consolidation":
	            return "paid";
	          case "failed_pickup":
	          case "in_transit":
	          case "out_for_delivery":
	          case "failed_delivery":
	          case "return_in_transit":
	          case "returned":
	          case "failed_return":
	          case "for_acceptance":
	          case "accepted":
	          case "received_at_pickup_hub":
	          case "received_at_delivery_hub":
	          case "for_return":
	          case "received_at_delivery_area":
	          case "at_sorting_center":
	          case "in_transit_to_delivery_area":
	          case "transferred_to_partner":
	          case "for_transfer":
	          case "out_for_return":
	          case "for_dropoff":
	          case "dropped_off":
	          case "dws_update":
	            return "transit";
	          case "canceled":
	          case "rejected":
	            return "cancelled";
	          case "delivered":
	          case "claimed":
	          case "picked_up":
	            return "delivered";
	          default:
	            return str.replace("_", "-");
	        }
	      } else if (type === "text") {
	        switch (str) {
	          case "confirmed":
	          case "for_pickup":
	          case "consolidated":
	          case "for_consolidation":
	            return "PREPARING FOR SHIPMENT";
	          case "failed_pickup":
	          case "in_transit":
	          case "out_for_delivery":
	          case "failed_delivery":
	          case "return_in_transit":
	          case "returned":
	          case "failed_return":
	          case "for_acceptance":
	          case "accepted":
	          case "received_at_pickup_hub":
	          case "received_at_delivery_hub":
	          case "for_return":
	          case "received_at_delivery_area":
	          case "at_sorting_center":
	          case "in_transit_to_delivery_area":
	          case "transferred_to_partner":
	          case "for_transfer":
	          case "out_for_return":
	          case "for_dropoff":
	          case "dropped_off":
	          case "dws_update":
	            return "ON ITS WAY";
	          case "canceled":
	            return "CANCELLED";
	          case "delivered":
	          case "claimed":
	          case "picked_up":
	            return "DELIVERED";
	          default:
	            return str.replace("_", " ").toUpperCase();
	        }
	      }
	    }
	    return str;
	  },
	  render: function render() {
	    var _this = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header2.default, {
	        isAuthenticated: true,
	        login: this.props.login,
	        logout: this.props.logout
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'body-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'view-shipping' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container padding-top-20' },
	            _react2.default.createElement(
	              'div',
	              { className: 'clearfix' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'pull-left' },
	                'Shipment Details'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/track-package', className: 'pull-right back-link u' },
	                '< Back'
	              )
	            ),
	            this.props.shipmentInfo.fetched_order && _react2.default.createElement(
	              'div',
	              { className: 'shipmentdetails ' + this.state.orderStatus.class },
	              _react2.default.createElement('div', { className: 'statusbox' }),
	              _react2.default.createElement('hr', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-left imgbox' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { style: { 'max-width': this.state.orderStatus.size }, src: '/img/' + this.state.orderStatus.imagePath + '.png', alt: '' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pull-right contentbox' },
	                  this.props.shipmentInfo.order.data.shipment.includes("air") ? _react2.default.createElement(
	                    'span',
	                    { className: 'aircargo cargotype' },
	                    'Air Cargo'
	                  ) : _react2.default.createElement(
	                    'span',
	                    { className: 'seacargo cargotype' },
	                    'Sea Cargo'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clearfix' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-4' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Transaction Date:'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _dateFns.format)(this.props.shipmentInfo.order.data.tat.pending ? this.props.shipmentInfo.order.data.tat.pending.date : this.props.shipmentInfo.order.data.created_at, 'MM/DD/YYYY')
	                      ),
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Tracking #:'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.shipmentInfo.order.data.tracking_number
	                      ),
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Item/s:'
	                      ),
	                      this.props.shipmentInfo.order.data.items.filter(function (item) {
	                        return item.type === 'product';
	                      }).map(function (item, i) {
	                        return _react2.default.createElement(
	                          'p',
	                          { key: i },
	                          item.description
	                        );
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-4' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'From:'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _utils.maskLocationName)(this.props.shipmentInfo.order.data.pickup_address.country.code),
	                        ' Warehouse'
	                      ),
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Ship to:'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        this.props.shipmentInfo.order.data.delivery_address.name,
	                        ', ',
	                        this.props.shipmentInfo.order.data.delivery_address.line_1,
	                        ', ',
	                        this.props.shipmentInfo.order.data.delivery_address.district,
	                        ', ',
	                        this.props.shipmentInfo.order.data.delivery_address.city,
	                        ', ',
	                        this.props.shipmentInfo.order.data.delivery_address.state,
	                        ', ',
	                        this.props.shipmentInfo.order.data.delivery_address.country.name,
	                        ' '
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-xs-4' },
	                      this.state.orderStatus.class !== 'delivered' && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'h2',
	                          null,
	                          'Estimated Delivery Date:'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          (0, _dateFns.format)(this.props.shipmentInfo.order.data.shipment.includes("air") ? this.props.shipmentInfo.order.data.metadata.delivery_tat.air : this.props.shipmentInfo.order.data.metadata.delivery_tat.sea, 'MM/DD/YYYY')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Latest Update:'
	                      ),
	                      this.props.shipmentInfo.order.data.events.map(function (ev, i, arr) {
	                        return i === _this.props.shipmentInfo.order.data.events.length - 1 && _react2.default.createElement(
	                          'div',
	                          { key: i },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            (0, _dateFns.format)((0, _utils.isMigratedEventRemarks)(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            ev.status === 'for_acceptance' || _this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office") ? (0, _utils.maskEventRemarks)(arr[i - 1].remarks) : (0, _utils.maskEventRemarks)(ev.remarks, ev.status_updated_at, ev.status)
	                          )
	                        );
	                      }),
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'modalanchor', 'data-toggle': 'modal', 'data-target': '#shiphistory' },
	                        'View Shipping Details'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'shiphistory', className: 'modal', style: { 'zIndex': '99999' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-dialog' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal-content' },
	                  _react2.default.createElement(
	                    'header',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
	                      _react2.default.createElement(
	                        'span',
	                        { 'aria-hidden': 'true' },
	                        '\xD7'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'clearfix' },
	                      this.props.shipmentInfo.fetched_order && _react2.default.createElement(
	                        'div',
	                        { className: 'pull-left currentactivity' },
	                        _react2.default.createElement(
	                          'h2',
	                          null,
	                          'Current Activity:'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          this.props.shipmentInfo.order.data.events.map(function (ev, i, arr) {
	                            return i === _this.props.shipmentInfo.order.data.events.length - 1 ? ev.status === 'for_acceptance' || _this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office") ? (0, _utils.maskEventRemarks)(arr[i - 1].remarks) : (0, _utils.maskEventRemarks)(ev.remarks, ev.status_updated_at, ev.status) : null;
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right text-center padding-top-20' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: this.handleStatuses(this.props.shipmentInfo.fetched_order && this.props.shipmentInfo.order.data.status, "class") },
	                          this.handleStatuses(this.props.shipmentInfo.fetched_order && this.props.shipmentInfo.order.data.status, "text")
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Tracking #: ',
	                          this.props.shipmentInfo.fetched_order && this.props.shipmentInfo.order.data.tracking_number
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'modal-body padding-3percent' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Shipping History: '
	                    ),
	                    _react2.default.createElement(
	                      'table',
	                      null,
	                      _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date/Time'
	                          ),
	                          _react2.default.createElement(
	                            'th',
	                            null,
	                            'Activity'
	                          )
	                        )
	                      ),
	                      this.props.shipmentInfo.fetched_order && _react2.default.createElement(
	                        'tbody',
	                        null,
	                        this.props.shipmentInfo.order.data.events.slice(0).reverse().map(function (ev, i) {
	                          return ev.status === "consolidated" || ev.status === 'for_acceptance' || _this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office") ? null : _react2.default.createElement(
	                            'tr',
	                            { key: i },
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              (0, _dateFns.format)((0, _utils.isMigratedEventRemarks)(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              (0, _utils.maskEventRemarks)(ev.remarks, ev.status_updated_at, ev.status)
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = TrackDetail;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uuid = __webpack_require__(70);
	
	var _reactHelmet = __webpack_require__(114);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _constants = __webpack_require__(633);
	
	__webpack_require__(849);
	
	var _utils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = "Shop from your favorite online stores in the UK & have your items shipped to the Philippines. Sign up at ShippingCart today.";
	var name = "Shop from UK Online stores & Ship to the Philippines | ShippingCart";
	
	var createReactClass = __webpack_require__(16);
	
	var UKShopping = createReactClass({
	  displayName: 'UKShopping',
	  componentDidMount: function componentDidMount() {
	    document.getElementById('chck1').checked = true;
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->
	  },
	  renderMerchantLogos: function renderMerchantLogos(category) {
	    return _constants.partnerMerchants[category].map(function (_ref) {
	      var logo = _ref.logo,
	          link = _ref.link,
	          alt = _ref.alt;
	      return _react2.default.createElement(
	        'div',
	        { key: (0, _uuid.v4)(), className: 'logo-store' },
	        _react2.default.createElement(
	          'a',
	          { href: link, target: '_blank', rel: 'noopener noreferrer' },
	          _react2.default.createElement('img', { src: logo, alt: alt })
	        )
	      );
	    });
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement('meta', { name: 'description', content: metadata, 'data-react-helmet': 'true' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          name
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'sc-smartbar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sc-smartbar', id: 'smartbar-close' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box-container' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'SIGN UP AND SHIP NOW:'
	              ),
	              ' Use code ',
	              _react2.default.createElement(
	                'span',
	                null,
	                '20NEWSC'
	              ),
	              ' to get 20% OFF on Air shipment. New customers only.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'xbtn' },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onclick: 'document.getElementById(\'smartbar-close\').style.display=\'none\'', className: 'close' },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\xD7'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container row1-cols2-layout' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'headers' },
	              'Buy from UK Online Shopping Sites and Ship to the Philippines'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wrapper-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'cols cols-1' },
	                _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/shop-in-uk-img-20200602030840.png', alt: 'shop-in-us', height: '400', width: '400' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'cols cols-2' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Love UK online shopping? Shipping your orders just got easier with ShippingCart. Whether you want to buy from eBay or shop for the latest clothes and fashion at ASOS, shipping to the Philippines is faster and more affordable with us!'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'How to Shop, Ship, and Save Smart with ShippingCart'
	                  )
	                ),
	                _react2.default.createElement(
	                  'ol',
	                  { className: 'uk-ordered-list' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Sign up for free today to receive your UK shipping address. '
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Shop from your favorite UK stores and check out using your ShippingCart UK address.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Consolidate your packages into one shipment to save up to 70% on shipping fees.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Select a shipping method, pay, and wait for your package.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'With ShippingCart, you can buy from Amazon UK and ship to the Philippines at competitive delivery rates. You can also shop from other beloved brands that offer bags, clothes, shoes, electronics, toys, and many more.'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'odd' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-static' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Top Picks'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('topPicks')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Fashion and Beauty'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('fashionBeauty')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'odd' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Home'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('home')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Tech'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('tech')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container hero seo-element' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content seo-element' },
	            _react2.default.createElement(
	              'div',
	              { className: 'seo-content' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'header' },
	                'FREQUENTLY ASKED QUESTIONS'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tabs' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck1', value: 'on' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck1' },
	                        'How does package consolidation work?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Shipping multiple packages direct from UK online shopping stores is costly. With ShippingCart\'s consolidation service, our expert packers can combine your orders from different stores into a single shipment, helping you save on international shipping fees.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Here\u2019s how it works:'
	                        ),
	                        _react2.default.createElement(
	                          'ol',
	                          { className: 'chck1' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Sign up for a free account on ShippingCart and we\u2019ll give you our UK shipping address.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Shop from different UK online shopping stores and use the UK address at checkout.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Wait for all your orders to arrive. We provide free storage for up to 30 days.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Once all your orders have arrived at our hub, select your preferred shipping method to the Philippines, and then pay.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Get excited while waiting for your package!'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'We will always try to consolidate your purchases from different UK online shopping sites into one shipment unless you specify otherwise. Also, it\'s best to choose a single shipment method for your consolidated items as we charge separately for air and sea cargo.'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck2' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck2' },
	                        'Which UK stores can I shop from?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'UK online shopping stores are available to everyone in the Philippines -- including you! You can shop these popular online stores in the UK from the comfort of your home:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'chck2' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Amazon UK',
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Amazon UK is one of the most popular destinations for UK online shopping. As the number one destination for online shopping in the UK, you can purchase everything from high-end electronics and antique furniture to rare comic books and Funko pops you won\u2019t find anywhere in the Philippines.'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'eBay',
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'eBay is the ultimate UK online shopping destination for everyday items, toys, books, furniture pieces, sports items, health supplements, collectables, and more! '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'ASOS',
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'When it comes to UK online shopping stores, this online store brings you the freshest clothing, accessories, shoes, and gifts to express your individuality. Aside from their roster of in-house brands, ASOS also has a slick range of fashion labels you won\'t find anywhere else, making it a unique fashion destination when you\u2019re shopping online in the UK.'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Argos',
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'If you\'re shopping online in the UK for household and department store items, Argos is the site to be. As a premier UK online shopping destination, they have something you and your entire family will love, including products from top brands like Nespresso, LEGO, Bose, Beats, Samsung, Dyson, and exclusive lines like Chad Valley.'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Next',
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'Next is an in-house label of high-end women\'s, men\'s, and children\'s clothing -- along with accessories and housewares. While they have several physical stores, their site is a popular online shopping destination in the UK. '
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Zagg',
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'If you\'re looking for high-end technologies, ZAGG is your go-to online shopping store in the UK. Their award-winning product selection includes screen protection, mobile keyboards, power management solutions, phone cases, and personal audio.'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck3' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck3' },
	                        'How long does it take to ship to the Philippines?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Once your orders have been shipped to our UK address, estimated time of arrival from our hub to the PH depends on your chosen shipment method. For instance, your items can arrive in as fast as 10 days via air cargo. If you prefer a more budget-friendly option, we offer shipping via sea cargo that takes up to 45 days.'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck4' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck4' },
	                        'How much does it cost to ship items from the UK to the Philippines?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Find out how competitive our rates are with our shipping fee estimator. It will calculate the total costs of your shipment based on the information you provide. It\'s quick, easy, and free!'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck5' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck5' },
	                        'How do I track my orders?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'The online store you ordered from (e.g. Amazon or eBay) should give you the tracking number of your package so you can monitor it while it\'s on transit to the ShippingCart warehouse. If you don\'t have the tracking number, contact the online store and ask for it. After your package has arrived at our warehouse, we will send you an email notice. If you have the ShippingCart mobile app installed, you can receive push notifications about the status of your package.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Once your shipment is on the way to the Philippines, we\'ll notify you via email or push notifications, and give you a tracking number so you can constantly check on the status of your package. Our chat support is also available every day from 10:00 a.m. to 7:00 p.m. (UTC+08:00) except holidays for any concerns or inquiries.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'With ShippingCart, the process of buying from UK online shopping stores is simple and easy. Convenient tools and reliable delivery service from the UK to your door -- that\'s our promise to you.'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = UKShopping;

/***/ },
/* 633 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var partnerMerchants = exports.partnerMerchants = {
	  topPicks: [{
	    link: 'http://amazon.co.uk/',
	    alt: 'Amazon Logo',
	    logo: 'https://cdn.shippingcart.com/assets/amazon-20191216085009.svg'
	  }, {
	    link: 'https://www.ebay.co.uk/',
	    alt: 'Ebay Logo',
	    logo: 'https://cdn.shippingcart.com/assets/ebay-20191216085009.svg'
	  }, {
	    link: 'https://www.asos.com/women/',
	    alt: 'Asos Logo',
	    logo: 'https://cdn.shippingcart.com/assets/asos-20191216085009.svg'
	  }, {
	    link: 'https://www.tkmaxx.com/uk/en/',
	    alt: 'TKmaxx Logo',
	    logo: 'https://cdn.shippingcart.com/assets/tkmaxx-20200116055236.svg'
	  }],
	  fashionBeauty: [{
	    link: 'https://www.allbirds.co.uk/collections/womens',
	    alt: 'All Birds Logo',
	    logo: 'https://cdn.shippingcart.com/assets/allbirds-20191216085009.svg'
	  }, {
	    link: 'https://athleta.gap.com/',
	    alt: 'Athleta Logo',
	    logo: 'https://cdn.shippingcart.com/assets/athleta-20191216085009.svg'
	  }, {
	    link: 'https://www.barneys.com/',
	    alt: 'Barneys Logo',
	    logo: 'https://cdn.shippingcart.com/assets/barneys-new-york-20191216085010.svg'
	  }, {
	    link: 'https://www.brora.co.uk/',
	    alt: 'Brora Logo',
	    logo: 'https://cdn.shippingcart.com/assets/brora-20191216085009.svg'
	  }, {
	    link: 'https://www.brummellsoflondon.com/',
	    alt: 'Brummell of London Logo',
	    logo: 'https://cdn.shippingcart.com/assets/brummellsoflondon-20191216085010.svg'
	  }, {
	    link: 'https://www.cultbeauty.co.uk/',
	    alt: 'Cult Beauty Logo',
	    logo: 'https://cdn.shippingcart.com/assets/cult-beauty-20191216085010.svg'
	  }, {
	    link: 'https://www.dunelondon.com/',
	    alt: 'Dune London Logo',
	    logo: 'https://cdn.shippingcart.com/assets/dunelondon-20191216085009.svg'
	  }, {
	    link: 'https://www.coggles.com/',
	    alt: 'Coggles Logo',
	    logo: 'https://cdn.shippingcart.com/assets/coggles-20200116055236.svg'
	  }, {
	    link: 'https://www.eastex.co.uk/',
	    alt: 'Eastex Logo',
	    logo: 'https://cdn.shippingcart.com/assets/eastex-20191216085009.svg'
	  }, {
	    link: 'https://www.evelom.com/',
	    alt: 'Evelom Logo',
	    logo: 'https://cdn.shippingcart.com/assets/evelom-20191216085009.svg'
	  }, {
	    link: 'https://www.footlocker.com/',
	    alt: 'Footlocker Logo',
	    logo: 'https://cdn.shippingcart.com/assets/footlocker-20191216085009.svg'
	  }, {
	    link: 'https://www.footasylum.com/',
	    alt: 'Foot Asylum Logo',
	    logo: 'https://cdn.shippingcart.com/assets/footasylum-20191216085010.svg'
	  }, {
	    link: 'https://www.harrods.com/en-gb',
	    alt: 'Harrods Logo',
	    logo: 'https://cdn.shippingcart.com/assets/harrods-20191216085010.svg'
	  }, {
	    link: 'https://www.isabellaoliver.com/eu',
	    alt: 'Issabella Oliver Logo',
	    logo: 'https://cdn.shippingcart.com/assets/isabella-oliver-20191216085010.svg'
	  }, {
	    link: 'https://www.jacques-vert.co.uk/',
	    alt: 'Jacques Vert Logo',
	    logo: 'https://cdn.shippingcart.com/assets/jacques-vert-20191216085010.svg'
	  }, {
	    link: 'https://www.jdsports.co.uk/',
	    alt: 'JDsports Logo',
	    logo: 'https://cdn.shippingcart.com/assets/jd-sports-20191216085009.svg'
	  }, {
	    link: 'https://www.kickers.co.uk/',
	    alt: 'Kickers Logo',
	    logo: 'https://cdn.shippingcart.com/assets/kickers-20191216085010.svg'
	  }, {
	    link: 'https://www.kurtgeiger.com/',
	    alt: 'Kurt Geiger Logo',
	    logo: 'https://cdn.shippingcart.com/assets/kurt-geiger-20191216085009.svg'
	  }, {
	    link: 'http://www.linksoflondon.com/',
	    alt: 'Links of London Logo',
	    logo: 'https://cdn.shippingcart.com/assets/links-of-london-20191216085010.svg'
	  }, {
	    link: 'https://www.longchamp.com/gb/en',
	    alt: 'Longchamp Logo',
	    logo: 'https://cdn.shippingcart.com/assets/longchamp-paris-20191216085010.svg'
	  }, {
	    link: 'https://www.longtallsally.com/?gclid=EAIaIQobChMI-qOr3PaM3QIVloePCh2hmgv2EAAYASAAEgL4TvD_BwE',
	    alt: 'Long Tall Sally Logo',
	    logo: 'https://cdn.shippingcart.com/assets/long-tall-sally-20191216085010.svg'
	  }, {
	    link: 'https://www.mainlinemenswear.co.uk/',
	    alt: 'Mainline Menswear Logo',
	    logo: 'https://cdn.shippingcart.com/assets/mainline-mens-wear-20191216085010.svg'
	  }, {
	    link: 'https://www.marksandspencer.com/',
	    alt: 'Marks and Spencer Logo',
	    logo: 'https://cdn.shippingcart.com/assets/marks-and-spencer-20191216085010.svg'
	  }, {
	    link: 'https://www.quizclothing.co.uk/',
	    alt: 'Quiz Clothing Logo',
	    logo: 'https://cdn.shippingcart.com/assets/quiz-clothing-20191216085010.svg'
	  }, {
	    link: 'https://nelly.com/uk/womens-fashion/brands/rare-london-475/',
	    alt: 'Rare Londo Logo',
	    logo: 'https://cdn.shippingcart.com/assets/rare-london-20191216085013.svg'
	  }, {
	    link: 'https://www.ratandboa.com/',
	    alt: 'Rat and Boa Logo',
	    logo: 'https://cdn.shippingcart.com/assets/rat-and-boa-20200116055236.svg'
	  }, {
	    link: 'https://www.reiss.com/',
	    alt: 'Reiss Logo',
	    logo: 'https://cdn.shippingcart.com/assets/reiss-20191216085010.svg'
	  }, {
	    link: 'https://www.schuh.eu/en-eu/',
	    alt: 'Schuh Logo',
	    logo: 'https://cdn.shippingcart.com/assets/schuh-20191216085010.svg'
	  }, {
	    link: 'https://www.speedo.com/international/en',
	    alt: 'Speedo Logo',
	    logo: 'https://cdn.shippingcart.com/assets/speedo-20191216085010.svg'
	  }, {
	    link: 'https://www.sweatybetty.com/',
	    alt: 'Sweaty Betty Logo',
	    logo: 'https://cdn.shippingcart.com/assets/sweaty-betty-london-20191216085010.svg'
	  }, {
	    link: 'https://www.warehouse-london.com/row/home',
	    alt: 'Warehouse London Logo',
	    logo: 'https://cdn.shippingcart.com/assets/warehouse-london-20191216085012.svg'
	  }, {
	    link: 'https://www.zalando.co.uk/',
	    alt: 'Zalando Logo',
	    logo: 'https://cdn.shippingcart.com/assets/zalando-20191216085010.svg'
	  }, {
	    link: 'https://www.zavvi.com/',
	    alt: 'Zavvi Logo',
	    logo: 'https://cdn.shippingcart.com/assets/zavvi-20200116055236.svg'
	  }],
	  home: [{
	    link: 'https://www.crateandbarrel.com/',
	    alt: 'Crate and Barrel Logo',
	    logo: 'https://cdn.shippingcart.com/assets/crate-barrel-20191216085010.svg'
	  }, {
	    link: 'https://www.oka.com/',
	    alt: 'Oka Logo',
	    logo: 'https://cdn.shippingcart.com/assets/oka-20191216085011.svg'
	  }, {
	    link: 'https://www.barnesandnoble.com/',
	    alt: 'Barnes and Noble Logo',
	    logo: 'https://cdn.shippingcart.com/assets/barnes-noble-20191216085010.svg'
	  }, {
	    link: 'https://www.thebookpeople.co.uk/webapp/wcs/stores/servlet/qs_home_tbp?storeId=10001&amp;catalogId=10051&amp;langId=100',
	    alt: 'The Book People Logo',
	    logo: 'https://cdn.shippingcart.com/assets/the-book-people-20191216085013.svg'
	  }, {
	    link: 'https://www.made.com/',
	    alt: 'Made Logo',
	    logo: 'https://cdn.shippingcart.com/assets/made-20200116055236.svg'
	  }],
	  tech: [{
	    link: 'https://www.zagg.com/us/en_us/',
	    alt: 'Zagg Logo',
	    logo: 'https://cdn.shippingcart.com/assets/zagg-20191216085012.svg'
	  }]
	};
	
	var banners = exports.banners = [{
	  img: 'https://cdn.shippingcart.com/assets/origin-banner-large-20200128071132.jpg',
	  alt: 'origin-banner-large',
	  customClass: 'large-banner'
	}, {
	  img: 'https://cdn.shippingcart.com/assets/origin-banner-small-20200128071132.jpg',
	  alt: 'origin-banner-small',
	  customClass: 'small-banner'
	}];

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uuid = __webpack_require__(70);
	
	var _reactHelmet = __webpack_require__(114);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _constants = __webpack_require__(635);
	
	__webpack_require__(850);
	
	var _utils = __webpack_require__(13);
	
	var _store = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = "Enjoy fast and affordable shipping from the US to your doorstep in the Philippines with ShippingCart. Visit this page to find out more.";
	var title = "Shop in the US and Ship to the Philippines | ShippingCart";
	
	var tableBodyBorderLeftRight = {
	  borderRight: '1px solid #E2E2E2',
	  borderLeft: '1px solid #E2E2E2',
	  padding: '10px 20px'
	};
	
	var tableHeaderStyle = {
	  border: '1px solid #E2E2E2',
	  padding: '20px',
	  fontWeight: 600
	};
	
	var createReactClass = __webpack_require__(16);
	
	var USShopping = createReactClass({
	  displayName: 'USShopping',
	  componentDidMount: function componentDidMount() {
	    document.getElementById('chck1').checked = true;
	    // <!-- NetCore Script -->
	    var accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '';
	    window.smartech && (0, _utils.netcoreScript)(accountNumber);
	    // <!-- NetCore Script -->    
	  },
	  renderMerchantLogos: function renderMerchantLogos(category) {
	    return _constants.partnerMerchants[category].map(function (_ref) {
	      var logo = _ref.logo,
	          link = _ref.link,
	          alt = _ref.alt;
	      return _react2.default.createElement(
	        'div',
	        { key: (0, _uuid.v4)(), className: 'logo-store' },
	        _react2.default.createElement(
	          'a',
	          { href: link, target: '_blank', rel: 'noopener noreferrer' },
	          _react2.default.createElement('img', { src: logo, alt: alt })
	        )
	      );
	    });
	  },
	
	  // const renderBanners = () => (
	  //   banners.map(({img, alt, customClass}) => (
	  //     <div key={uuid()} className={`content ${customClass}`}>
	  //       <img src={img} alt={alt} />
	  //     </div>
	  //   ))
	  // )
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement('meta', { name: 'description', content: metadata, 'data-react-helmet': 'true' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { style: { background: 'transparent url("https://cdn.shippingcart.com/assets/wave-bg@2x-20230509032549.jpg")', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom', backgroundColor: '#FFF' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container row1-cols2-layout' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content', style: { marginTop: '30px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrapper-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'cols cols-1' },
	                _react2.default.createElement('img', { src: 'https://cdn.shippingcart.com/assets/oregon-update-main-banner-1@2x-20230509023152.png', alt: 'shop-in-us', height: '360', width: '423' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'cols cols-2' },
	                _react2.default.createElement(
	                  'p',
	                  { style: { fontSize: '24px', fontWeight: 600, color: '#333333' } },
	                  'Buy from the US, and Ship to the Philippines'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'With ShippingCart, buying from US sites like Amazon, Carter\u2019s and Disney, and shipping to the Philippines is more affordable as we offer competitive prices with no hidden charges. We also offer free storage for up to 30 days.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { style: { fontWeight: 600 } },
	                    ' And with our Oregon warehouse, no more sales tax will be added to your online purchases!'
	                  ),
	                  ' Just input the free US Oregon delivery address that is displayed on your ShippingCart account when you checkout from eStores.'
	                ),
	                this.props.isAuthenticated || localStorage.jwtToken ? null : _react2.default.createElement(
	                  'button',
	                  {
	                    onClick: function onClick() {
	                      return _store.history.push('/signup');
	                    },
	                    style: { backgroundColor: '#AA0E0E', border: '1px solid #AA0E0E', borderRadius: '23px', width: '195px', height: '46px', fontSize: '16px', fontWeight: 600, color: '#FFF' }
	                  },
	                  'SIGN UP NOW'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'odd' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: '24px', fontWeight: 600, color: '#333333', margin: '20px 0px' } },
	            'Here are sample savings when you use an Oregon delivery address upon checking out'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'us-item-list' },
	            _react2.default.createElement(
	              'table',
	              { style: { backgroundColor: '#fff', borderRadius: '10px', width: '100%', fontSize: '16px' } },
	              _react2.default.createElement(
	                'thead',
	                { style: { border: '1px solid #E2E2E2' } },
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'center', style: tableHeaderStyle },
	                    'Item'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'center', style: tableHeaderStyle },
	                    'Using a California Address'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'center', style: tableHeaderStyle },
	                    'Using a no-sales tax Oregon address'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'center', style: tableHeaderStyle },
	                    'Savings'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { style: tableBodyBorderLeftRight },
	                    'Apple iPad Mini'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$543.49'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$499.99'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$43.50'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { style: tableBodyBorderLeftRight },
	                    'Air Jordan 1'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$152.15'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$138.00'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$14.15'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { style: tableBodyBorderLeftRight },
	                    'Solo Leveling Comic Box Set, Vol 1 - 5'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$95.63'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$90.00'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$5.63'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { style: tableBodyBorderLeftRight },
	                    'Harry Potter 18-inch Funko Pop Vinyl'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$106.24'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$99.99'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$6.25'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { style: tableBodyBorderLeftRight },
	                    'Kyrie Irving Autographed 16x20'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$318.74'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$299.99'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'center', style: tableBodyBorderLeftRight },
	                    '$18.75'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { style: { backgroundColor: '#FFF' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Top Picks'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('topPicks')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'odd' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Fashion & Beauty'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('fashionBeauty')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { style: { backgroundColor: '#FFF' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Lifestyle & Tech'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('lifestlyleTech')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'odd' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Toys, Kids & Babies'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('toysKids')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { style: { backgroundColor: '#FFF' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container logos' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'header' },
	              'Sports, Hobby & Health'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-stores' },
	              this.renderMerchantLogos('sportsHobbyHealth')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'odd', hidden: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'container hero seo-element' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content seo-element' },
	            _react2.default.createElement(
	              'div',
	              { className: 'seo-content' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'header', style: { color: '#707070', fontWeight: '600', paddingBottom: '40px' } },
	                'FREQUENTLY ASKED QUESTIONS'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tabs' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck1', onChange: function onChange(e) {
	                          console.log(e.target.checked, 'TEST');
	                        } }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck1' },
	                        'How to buy from the US and ship to the Philippines?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'When you become a member today, we\'ll give you a free US address to use when you shop from online stores. We will then handle all the shipping from our hub to your doorstep.'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Shopping from online stores like Amazon and shipping to the Philippines is this quick and easy:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'listStyle' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Sign up for an account today and get a free ShippingCart US address.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Shop from your favorite online retailers.'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'At checkout, use your free ShippingCart US address.'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Your purchase will be delivered to our address.  We will consolidate all your orders, and then ship to the Philippines \u2013 straight to you!'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Plan on buying from eBay and shipping to the Philippines?'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Don\u2019t stop there! You can also shop for shoes, clothes, makeup, and many other items at other US stores like:'
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'listStyle' },
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Amazon'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Walmart.com'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Asos'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Nordstrom'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'eBags'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Drugstore.com'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Walgreens'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'GAP'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Neiman Marcus'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Victoria\u2019s Secret'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Bath & Body Works'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Rue La La'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Colourpop'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'bliss'
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            'Saks Fifth Avenue'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'When your orders arrive at our hub, our expert packers can combine them in a single shipment, helping you save on your shipping fee to the Philippines.'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck2' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck2' },
	                        'How long does it take to ship to Philippines?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'ShippingCart always looks for fast and affordable ways for our customers to shop in the US and ship to the Philippines. Depending on your chosen shipment method, your items can arrive in the PH in just 14 days via air cargo. If you prefer a more budget-friendly option, we offer shipment via sea cargo that takes up to 45 days.'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck3' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck3' },
	                        'How does package consolidation work?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'When you\u2019re ready to ship your items, you can ship them out individually or wait for your other items to arrive so you can consolidate them all into a single shipment. '
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'ShippingCart\u2019s free consolidation service helps you save on handling fees, reducing your overall shipping costs. However, please note that even if you consolidate your packages under one transaction, handling fees are charged separately for air and sea cargo. It\u2019s best to choose a single shipping method for all your packages.'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tab' },
	                      _react2.default.createElement('input', { type: 'checkbox', id: 'chck4' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'tab-label', htmlFor: 'chck4' },
	                        'How much does it cost to ship items from the US to the Philippines?'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tab-content' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Find out how low our rates are with our cost calculator. Get your shipment fee estimate based on the information you provide. It\u2019s quick, free, and easy!'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = USShopping;

/***/ },
/* 635 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var partnerMerchants = exports.partnerMerchants = {
	  topPicks: [{
	    logo: 'https://cdn.shippingcart.com/assets/6pm-20200127083844.svg',
	    alt: '6pm Logo',
	    link: 'https://www.6pm.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/disney-20200127083844.svg',
	    alt: 'Disney Logo',
	    link: 'https://www.disney.ph/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/walgreens-20200127083844.svg',
	    alt: 'Walgreens Logo',
	    link: 'https://www.walgreens.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/benefit-20200127083844.svg',
	    alt: 'Benefit Cosmetics Logo',
	    link: 'https://www.benefitcosmetics.com/ph/en'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/carters-20200127083843.svg',
	    alt: 'Carters Logo',
	    link: 'https://www.carters.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/bath-body-works-20200127083844.svg',
	    alt: 'Bath Body Works Logo',
	    link: 'https://www.bathandbodyworks.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/gap-20200127083843.svg',
	    alt: 'Gap Logo',
	    link: 'https://www.gap.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/forever-21-20200127083844.svg',
	    alt: 'Forever21 Logo',
	    link: 'https://www.forever21.com/us/Shop'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/victoria-secret-20200127083844.svg',
	    alt: 'Victoria Secret Logo',
	    link: 'https://www.victoriassecret.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/adidas-20200127083843.svg',
	    alt: 'Addidas Logo',
	    link: 'https://www.adidas.com/us'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/amazon-20200127083843.svg',
	    alt: 'Amazon Logo',
	    link: 'https://www.amazon.com/'
	  }],
	  fashionBeauty: [{
	    logo: 'https://cdn.shippingcart.com/assets/525-america-20200206093302.svg',
	    alt: '525 America Logo',
	    link: 'www.525america.com'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/aldo-20200206093302.svg',
	    alt: 'Aldo Shoes Logo',
	    link: 'https://www.aldoshoes.com/us/en_US'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/allurez-20200206093305.svg',
	    alt: 'Allurez Logo',
	    link: 'https://www.allurez.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/american-eagle-20200206093302.svg',
	    alt: 'American Eagel Logo',
	    link: 'https://www.ae.com/us/en'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/ann-taylor-20200206093303.svg',
	    alt: 'Ann Taylor Logo',
	    link: 'https://www.anntaylor.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/armani-exchange-20200206093302.svg',
	    alt: 'Armani Exchange Logo',
	    link: 'https://www.armaniexchange.com/us'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/colour-pop-20200206093302.svg',
	    alt: 'Colour Pop Logo',
	    link: 'https://colourpop.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/kipling-usa-20200206093302.svg',
	    alt: 'Kipling Logo',
	    link: 'https://www.kipling-usa.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/backcountry-20200206093301.svg',
	    alt: 'Backcountry Logo',
	    link: 'https://www.backcountry.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/bagking-20200206093305.svg',
	    alt: 'Bag King Logo',
	    link: 'https://www.bagking.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/banana-republic-20200206093302.svg',
	    alt: '6pm Logo',
	    link: 'https://bananarepublic.gap.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/beauty-bar-20200206093306.svg',
	    alt: 'Beauty Bar Logo',
	    link: 'https://www.amazon.com/b/ref=beautybar_redirect?node=16575127011'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/bh-cosmetics-20200206093305.svg',
	    alt: 'BH Cosmetics Logo',
	    link: 'https://www.bhcosmetics.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/bhfo-20200206093305.svg',
	    alt: 'BHFO Logo',
	    link: 'https://www.bhfo.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/bliss-20200206093302.svg',
	    alt: 'Bliss World Logo',
	    link: 'https://www.blissworld.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/burton-20200206093302.svg',
	    alt: 'Burton Logo',
	    link: 'https://www.burton.com/us/en/home'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/crocs-20200206093301.svg',
	    alt: 'Crocs Logo',
	    link: 'https://www.crocs.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/diesel-20200206093302.svg',
	    alt: 'Diesel Logo',
	    link: 'https://global.diesel.com/home'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/dorothy-perkins-20200206093302.svg',
	    alt: 'Dorothy Perkins Logo',
	    link: 'https://us.dorothyperkins.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/ebags-20200206093303.svg',
	    alt: 'EBags Logo',
	    link: 'https://www.ebags.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/haute-look-20200206093302.svg',
	    alt: 'Hautelook Logo',
	    link: 'https://www.hautelook.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/burton-20200206093302.svg',
	    alt: 'Inernational Jock Logo',
	    link: 'http://www.internationaljock.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/jcrew-20200206093301.svg',
	    alt: 'Jcrew Logo',
	    link: 'https://www.jcrew.com/'
	  }, {
	    logo: 'https://cdn.shippingcart.com/assets/juicy-couture-20200206093304.svg',
	    alt: 'Juicy Couture Logo',
	    link: 'http://www.juicycouture.com/'
	  }, {
	    link: 'https://www.karmaloop.com/',
	    alt: 'Karma Loop Logo',
	    logo: 'https://cdn.shippingcart.com/assets/karma-loop-20200206093302.svg'
	  }, {
	    link: 'https://www.lacoste.com/us/',
	    alt: 'Lacoste Logo',
	    logo: 'https://cdn.shippingcart.com/assets/lacoste-20200206093302.svg'
	  }, {
	    link: 'https://www.saksfifthavenue.com/',
	    alt: 'Saks Fifth Avenue Logo',
	    logo: 'https://cdn.shippingcart.com/assets/saks-fifth-avenue-20200206093304.svg'
	  }, {
	    link: 'https://www.luckybrand.com/',
	    alt: 'Lucky Brand Logo',
	    logo: 'https://cdn.shippingcart.com/assets/lucky-brand-20200206093302.svg'
	  }, {
	    link: 'https://www.maidenform.com/',
	    alt: 'Maiden Form Logo',
	    logo: 'https://cdn.shippingcart.com/assets/maiden-form-20200206093959.svg'
	  }, {
	    link: 'https://www.marcjacobs.com/',
	    alt: 'Marc Jacobs Logo',
	    logo: 'https://cdn.shippingcart.com/assets/marc-jacobs-20200206093302.svg'
	  }, {
	    link: 'https://www.modcloth.com/on/demandware.store/Sites-modcloth-Site/default/Default-Start?src=paid_brand&amp;utm_source=ppc&amp;utm_medium=google&amp;utm_campaign=G.SEM.ROW_BR.X_Brand&amp;utm_term=modcloth&amp;gclid=EAIaIQobChMIr-y5u_uM3QIVgTgrCh15NwAxEAAYASAAEgIPW_D_BwE&amp;gclsrc=aw.ds',
	    alt: 'Modcloth Logo',
	    logo: 'https://cdn.shippingcart.com/assets/mod-cloth-20200206093302.svg'
	  }, {
	    link: 'https://www.neimanmarcus.com/',
	    alt: 'Neiman Marcus Logo',
	    logo: 'https://cdn.shippingcart.com/assets/neiman-marcus-20200206093304.svg'
	  }, {
	    link: 'https://www.ninewest.com/',
	    alt: 'Nine West Logo',
	    logo: 'https://cdn.shippingcart.com/assets/nine-west-20200206093302.svg'
	  }, {
	    link: 'https://shop.nordstrom.com/',
	    alt: 'Nordstorm Logo',
	    logo: 'https://cdn.shippingcart.com/assets/nordstorm-20200206093302.svg'
	  }, {
	    link: 'https://www.paulsmith.com/us',
	    alt: 'Paul Smith Logo',
	    logo: 'https://cdn.shippingcart.com/assets/paul-smith-20200206093301.svg'
	  }, {
	    link: 'https://www.ruelala.com/boutique/',
	    alt: 'Ruelala Logo',
	    logo: 'https://cdn.shippingcart.com/assets/ruelala-20200206093302.svg'
	  }, {
	    link: 'https://www.shoes.com/',
	    alt: 'Shoebuy Logo',
	    logo: 'https://cdn.shippingcart.com/assets/shoebuy-20200206093301.svg'
	  }, {
	    link: 'https://www.skinstore.com/',
	    alt: 'Skin Store Logo',
	    logo: 'https://cdn.shippingcart.com/assets/skin-store-20200206093305.svg'
	  }, {
	    link: 'https://www.stussy.com/',
	    alt: 'Stussy Logo',
	    logo: 'https://cdn.shippingcart.com/assets/stussy-20200206093306.svg'
	  }, {
	    link: 'https://www.thehut.com/',
	    alt: 'The Hut Logo',
	    logo: 'https://cdn.shippingcart.com/assets/the-hut-20200206093302.svg'
	  }, {
	    link: 'https://www.timetospa.com/',
	    alt: 'Time To Spa Logo',
	    logo: 'https://cdn.shippingcart.com/assets/time-to-spa-20200206093302.svg'
	  }, {
	    link: 'https://www.toms.com/',
	    alt: 'Toms Logo',
	    logo: 'https://cdn.shippingcart.com/assets/toms-20200206093302.svg'
	  }, {
	    link: 'https://www.toryburch.com/',
	    alt: 'Tony Burch logo',
	    logo: 'https://cdn.shippingcart.com/assets/tory-burch-20200206093302.svg'
	  }, {
	    link: 'https://www.ugg.com/',
	    alt: 'Ugg Logo',
	    logo: 'https://cdn.shippingcart.com/assets/ugg-20200206093302.svg'
	  }, {
	    link: 'https://www.urbanoutfitters.com/',
	    alt: 'Urban Outfitters Logo',
	    logo: 'https://cdn.shippingcart.com/assets/urbanoutfitters-20200206093302.svg'
	  }, {
	    link: 'https://www.vince.com/',
	    alt: 'Vince Logo',
	    logo: 'https://cdn.shippingcart.com/assets/vince-20200206093302.svg'
	  }, {
	    link: 'https://www.whatgreatskin.com/',
	    alt: 'What Great Skin Logo',
	    logo: 'https://cdn.shippingcart.com/assets/what-great-skin-20200206094515.svg'
	  }, {
	    link: 'https://www.yoox.com/us',
	    alt: 'Yoox Logo',
	    logo: 'https://cdn.shippingcart.com/assets/yoox-20200206093302.svg'
	  }, {
	    link: 'https://www.zappos.com/',
	    alt: 'Zappos Logo',
	    logo: 'https://cdn.shippingcart.com/assets/zappos-20200206093304.svg'
	  }, {
	    link: 'https://www.kyliecosmetics.com/',
	    alt: 'Kylie Cosmetics Logo',
	    logo: 'https://cdn.shippingcart.com/assets/kylie-cosmetics-20200311042145.svg'
	  }],
	  lifestlyleTech: [{
	    link: 'https://www.4allmemory.com/',
	    alt: '4all Memory Logo',
	    logo: 'https://cdn.shippingcart.com/assets/4-all-memory-20200206071411.svg'
	  }, {
	    link: 'https://www.adorama.com/',
	    alt: 'Adorama Logo',
	    logo: 'https://cdn.shippingcart.com/assets/adorama-20200206071412.svg'
	  }, {
	    link: 'https://www.bhphotovideo.com/',
	    alt: 'BNH Logo',
	    logo: 'https://cdn.shippingcart.com/assets/bnh-20200206071412.svg'
	  }, {
	    link: 'https://www.boscovs.com/ast/home-1',
	    alt: 'Boscovs Logo',
	    logo: 'https://cdn.shippingcart.com/assets/boscovs-20200206071412.svg'
	  }, {
	    link: 'https://www.amazon.com/b/ref=casa_redirect?node=16575124011',
	    alt: 'Casa Logo',
	    logo: 'https://cdn.shippingcart.com/assets/casa-20200206071412.svg'
	  }, {
	    link: 'https://www.olloclip.com/',
	    alt: 'Olloclip Logo',
	    logo: 'https://cdn.shippingcart.com/assets/olloclip-20200206071412.svg'
	  }, {
	    link: 'https://www.crucial.com/',
	    alt: 'Crucial Logo',
	    logo: 'https://cdn.shippingcart.com/assets/crucial-20200206071412.svg'
	  }, {
	    link: 'https://fab.com/',
	    alt: 'Fab Logo',
	    logo: 'https://cdn.shippingcart.com/assets/fab-20200206071412.svg'
	  }, {
	    link: 'http://www.gnc.com/',
	    alt: 'GNC Logo',
	    logo: 'https://cdn.shippingcart.com/assets/gnc-20200206071411.svg'
	  }, {
	    link: 'https://griffintechnology.com/',
	    alt: 'Griffin Technology Logo',
	    logo: 'https://cdn.shippingcart.com/assets/griffin-20200206071411.svg'
	  }, {
	    link: 'https://www.importcds.com/',
	    alt: 'Importcds Logo',
	    logo: 'https://cdn.shippingcart.com/assets/importcds-20200206071412.svg'
	  }, {
	    link: 'http://www.mwave.com/mwave/index.asp?',
	    alt: 'Mwave Logo',
	    logo: 'https://cdn.shippingcart.com/assets/mwave-20200206071411.svg'
	  }, {
	    link: 'https://www.newegg.com/',
	    alt: 'NewEgg Logo',
	    logo: 'https://cdn.shippingcart.com/assets/newegg-20200206071412.svg'
	  }, {
	    link: 'https://www.overstock.com/',
	    alt: 'Overstock Logo',
	    logo: 'https://cdn.shippingcart.com/assets/overstock-20200206071412.svg'
	  }, {
	    link: 'https://www.powersupportintl.com/',
	    alt: 'Power Support Logo',
	    logo: 'https://cdn.shippingcart.com/assets/power-support-20200206071411.svg'
	  }, {
	    link: 'https://www.amazon.com/b/ref=soap_redirect?node=16575125011',
	    alt: 'Soap Logo',
	    logo: 'https://cdn.shippingcart.com/assets/soap-20200206071412.svg'
	  }, {
	    link: 'https://www.sony.com/',
	    alt: 'Sony Logo',
	    logo: 'https://cdn.shippingcart.com/assets/sony-20200206071412.svg'
	  }, {
	    link: 'https://www.spigen.com/',
	    alt: 'Spingen Logo',
	    logo: 'https://cdn.shippingcart.com/assets/spigen-20200206071412.svg'
	  }, {
	    link: 'https://www.wayfair.com/',
	    alt: 'Wayfair Logo',
	    logo: 'https://cdn.shippingcart.com/assets/wayfair-20200206071412.svg'
	  }, {
	    link: 'https://www.xbox.com/en-SG/',
	    alt: 'Xbox Logo',
	    logo: 'https://cdn.shippingcart.com/assets/xbox-20200206071412.svg'
	  }, {
	    link: 'https://www.zagg.com/us/en_us/',
	    alt: 'Zagg Logo',
	    logo: 'https://cdn.shippingcart.com/assets/zagg-20200206071412.svg'
	  }],
	  toysKids: [{
	    link: 'https://www.amazon.com/b/ref=yoyo_redirect?node=16575126011',
	    alt: 'Yoyo Logo',
	    logo: 'https://cdn.shippingcart.com/assets/yoyo-20200206055815.svg'
	  }, {
	    link: 'https://www.thinkgeek.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/think-geek-20200206055815.svg'
	  }, {
	    link: 'https://www.childrensplace.com/us/home',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/the-childrens-place-20200206055814.svg'
	  }, {
	    link: 'https://seekairun.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/see-kai-run-20200206055814.svg'
	  }, {
	    link: 'https://www.partycity.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/party-city-20200206055815.svg'
	  }, {
	    link: 'https://www.oshkosh.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/oshkosh-20200206055814.svg'
	  }, {
	    link: 'http://www.orientaltrading.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/oriental-trading-20200206055815.svg'
	  }, {
	    link: 'https://mini-la-mode.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/mini-la-mode-20200206055814.svg'
	  }, {
	    link: 'https://www.melissaanddoug.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/melissa-doug-20200206055815.svg'
	  }, {
	    link: 'https://www.mattel.com/en-us',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/mattel-20200206055814.svg'
	  }, {
	    link: 'https://www.leapfrog.com/en-us/home',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/leapfrog-20200206055815.svg'
	  }, {
	    link: 'https://www.shopjustice.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/justice-20200206055815.svg'
	  }, {
	    link: 'https://www.iseeme.com/en-us/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/iseeme-20200206055815.svg'
	  }, {
	    link: 'https://www.gymboree.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/gymboree-20200206055815.svg'
	  }, {
	    link: 'https://www.fisher-price.com/en_SEA/index.html',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/fisher-price-20200206055815.svg'
	  }, {
	    link: 'https://www.amazon.com/b/ref=diapers_redirect?node=16575122011',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/diapers-20200206055815.svg'
	  }, {
	    link: 'https://www.cathkidston.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/cath-kidston-20200206055815.svg'
	  }, {
	    link: 'https://www.californiababy.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/california-baby-20200206055814.svg'
	  }, {
	    link: 'https://www.babyearth.com/',
	    alt: 'Logo',
	    logo: 'https://cdn.shippingcart.com/assets/baby-earth-20200206055814.svg'
	  }],
	  sportsHobbyHealth: [{
	    link: 'https://www.yogaoutlet.com/?10np&amp;utm_source=yolinkshare&amp;utm_medium=affiliate&amp;utm_campaign=LSgcknZyZpA&amp;utm_content=152&amp;siteID=LSgcknZyZpA-8zvnb71AeBlY0CckqNQ4jg',
	    alt: 'Yoga Outlet Logo',
	    logo: 'https://cdn.shippingcart.com/assets/yoga-outlet-20200206082819.svg'
	  }, {
	    link: 'https://www.betterworldbooks.com/',
	    alt: 'Better World Books Logo',
	    logo: 'https://cdn.shippingcart.com/assets/better-world-books-20200206082819.svg'
	  }, {
	    link: 'https://www.bodybuilding.com/store/bodybuilding.html',
	    alt: 'Body Building Logo',
	    logo: 'https://cdn.shippingcart.com/assets/body-building-20200206082819.svg'
	  }, {
	    link: 'https://www.burton.com/us/en/home',
	    alt: 'Burton Logo',
	    logo: 'https://cdn.shippingcart.com/assets/burton-20200206082819.svg'
	  }, {
	    link: 'https://www.callawaygolf.com/',
	    alt: 'Callaway Logo',
	    logo: 'https://cdn.shippingcart.com/assets/callaway-20200206082819.svg'
	  }, {
	    link: 'https://www.christianbook.com/',
	    alt: 'Christian Book Logo',
	    logo: 'https://cdn.shippingcart.com/assets/christian-book-20200206082819.svg'
	  }, {
	    link: 'https://www.eastbay.com/',
	    alt: 'Eastbay Logo',
	    logo: 'https://cdn.shippingcart.com/assets/eastbay-20200206082819.svg'
	  }, {
	    link: 'https://www.finishline.com/',
	    alt: 'Finish Line Logo',
	    logo: 'https://cdn.shippingcart.com/assets/finish-line-20200206082819.svg'
	  }, {
	    link: 'https://www.footaction.com/',
	    alt: 'Foot Action Logo',
	    logo: 'https://cdn.shippingcart.com/assets/footaction-20200206082819.svg'
	  }, {
	    link: 'https://www.herbalife.com/',
	    alt: 'Herbal Life Logo',
	    logo: 'https://cdn.shippingcart.com/assets/herbal-life-20200206082819.svg'
	  }, {
	    link: 'https://www.iherb.com/',
	    alt: 'iHerb Logo',
	    logo: 'https://cdn.shippingcart.com/assets/iherb-20200206082819.svg'
	  }, {
	    link: 'https://www.luckyvitamin.com/',
	    alt: 'Lucky Vitamin Logo',
	    logo: 'https://cdn.shippingcart.com/assets/lucky-vitamin-20200206082819.svg'
	  }, {
	    link: 'https://shop.lululemon.com/',
	    alt: 'Lululemon Logo',
	    logo: 'https://cdn.shippingcart.com/assets/lululemon-20200206082819.svg'
	  }, {
	    link: 'https://www.moosejaw.com/',
	    alt: 'Moosejaw Logo',
	    logo: 'https://cdn.shippingcart.com/assets/moosejaw-20200206082819.svg'
	  }, {
	    link: 'https://moskomoto.com/',
	    alt: 'Mosko Moto Logo',
	    logo: 'https://cdn.shippingcart.com/assets/mosko-moto-20200206082819.svg'
	  }, {
	    link: 'https://www.nuskin.com/content/nuskin/en_US/home.html',
	    alt: 'Nuskin Logo',
	    logo: 'https://cdn.shippingcart.com/assets/nuskin-20200206082819.svg'
	  }, {
	    link: 'https://www.rockbottomgolf.com/',
	    alt: 'Rock Bottom Golf Logo',
	    logo: 'https://cdn.shippingcart.com/assets/rock-bottom-golf-20200206082819.svg'
	  }, {
	    link: 'https://www.runningwarehouse.com/',
	    alt: 'Running Warehouse Logo',
	    logo: 'https://cdn.shippingcart.com/assets/running-warehouse-20200206082819.svg'
	  }, {
	    link: 'https://www.swansonvitamins.com/',
	    alt: 'Swanson Logo',
	    logo: 'https://cdn.shippingcart.com/assets/swanson-20200206082819.svg'
	  }, {
	    link: 'https://www.tennis-warehouse.com/',
	    alt: 'Tennis Warehouse Logo',
	    logo: 'https://cdn.shippingcart.com/assets/tennis-warehouse-20200206082819.svg'
	  }, {
	    link: 'https://www.thriftbooks.com/',
	    alt: 'Thriftbooks Logo',
	    logo: 'https://cdn.shippingcart.com/assets/thriftbooks-20200206082819.svg'
	  }, {
	    link: 'https://www.vitacost.com/',
	    alt: 'Vita Cost Logo',
	    logo: 'https://cdn.shippingcart.com/assets/vita-cost-20200206082819.svg'
	  }]
	};
	
	var banners = exports.banners = [{
	  img: 'https://cdn.shippingcart.com/assets/origin-banner-large-20200128072801.jpg',
	  alt: 'origin-banner-large',
	  customClass: 'large-banner'
	}, {
	  img: 'https://cdn.shippingcart.com/assets/origin-banner-small-20200128072801.jpg',
	  alt: 'origin-banner-small',
	  customClass: 'small-banner'
	}];

/***/ },
/* 636 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var areaWithDelay = exports.areaWithDelay = {
	  provinces: [{
	    province: ''
	  }],
	  cities: [{
	    province: '',
	    city: ''
	  }],
	  brgys: [{
	    province: '',
	    city: ''
	  }]
	};

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _jsonwebtoken = __webpack_require__(331);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	var _Signin = __webpack_require__(50);
	
	var _ParcelAction = __webpack_require__(72);
	
	var _setAuthorizationToken = __webpack_require__(160);
	
	var _setAuthorizationToken2 = _interopRequireDefault(_setAuthorizationToken);
	
	var _App = __webpack_require__(587);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _DashboardConnection = __webpack_require__(602);
	
	var _DashboardConnection2 = _interopRequireDefault(_DashboardConnection);
	
	var _Home = __webpack_require__(607);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _TestLogin = __webpack_require__(628);
	
	var _TestLogin2 = _interopRequireDefault(_TestLogin);
	
	var _SignInContainer = __webpack_require__(625);
	
	var _SignInContainer2 = _interopRequireDefault(_SignInContainer);
	
	var _SignUpContainer = __webpack_require__(627);
	
	var _SignUpContainer2 = _interopRequireDefault(_SignUpContainer);
	
	var _SignupSuccess = __webpack_require__(254);
	
	var _SignupSuccess2 = _interopRequireDefault(_SignupSuccess);
	
	var _ShippingEstimate = __webpack_require__(622);
	
	var _ShippingEstimate2 = _interopRequireDefault(_ShippingEstimate);
	
	var _Checkout = __webpack_require__(247);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _TrackPackage = __webpack_require__(255);
	
	var _TrackPackage2 = _interopRequireDefault(_TrackPackage);
	
	var _AdyenPayment = __webpack_require__(243);
	
	var _AdyenPayment2 = _interopRequireDefault(_AdyenPayment);
	
	var _TrackDetail = __webpack_require__(631);
	
	var _TrackDetail2 = _interopRequireDefault(_TrackDetail);
	
	var _Track = __webpack_require__(630);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _ChangePassword = __webpack_require__(245);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _ResetPassword = __webpack_require__(253);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _CheckOutSuccess = __webpack_require__(246);
	
	var _CheckOutSuccess2 = _interopRequireDefault(_CheckOutSuccess);
	
	var _Cms = __webpack_require__(595);
	
	var _Cms2 = _interopRequireDefault(_Cms);
	
	var _Dashboard = __webpack_require__(248);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Cart = __webpack_require__(601);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _Parcel = __webpack_require__(604);
	
	var _Parcel2 = _interopRequireDefault(_Parcel);
	
	var _Shipment = __webpack_require__(606);
	
	var _Shipment2 = _interopRequireDefault(_Shipment);
	
	var _Account = __webpack_require__(600);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _ProhibitedItems = __webpack_require__(605);
	
	var _ProhibitedItems2 = _interopRequireDefault(_ProhibitedItems);
	
	var _Notification = __webpack_require__(618);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _USShopping = __webpack_require__(634);
	
	var _USShopping2 = _interopRequireDefault(_USShopping);
	
	var _UKShopping = __webpack_require__(632);
	
	var _UKShopping2 = _interopRequireDefault(_UKShopping);
	
	var _OneTimePassword = __webpack_require__(619);
	
	var _OneTimePassword2 = _interopRequireDefault(_OneTimePassword);
	
	var _index = __webpack_require__(592);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRouter = __webpack_require__(14);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__(46);
	
	var _OffsizeItems = __webpack_require__(603);
	
	var _OffsizeItems2 = _interopRequireDefault(_OffsizeItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import react router deps
	
	// import Promo from './components/Promo';
	
	
	//Import Components
	
	
	//Actions
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	//Utils
	
	
	if (localStorage.jwtToken) {
	  (0, _setAuthorizationToken2.default)(localStorage.jwtToken);
	  _store2.default.dispatch((0, _Signin.setCurrentUser)(_jsonwebtoken2.default.decode(localStorage.jwtToken)));
	  _store2.default.dispatch((0, _Signin.signedIn)(localStorage.jwtToken));
	  if (window.location.pathname !== '/otp-service') {
	    _store2.default.dispatch((0, _ParcelAction.getParcel)(localStorage.jwtToken));
	  }
	}
	
	var authenticateCTR = true;
	// If user is authenticated
	var Authenticated = function Authenticated(nextState, replace, callback) {
	
	  _axios2.default.get(apiUrl + 'accounts').then(function (response) {
	    if (response.data.status === 200 && authenticateCTR) {
	      replace('/cart');
	      authenticateCTR = false;
	    }
	    callback();
	  }).catch(function () {
	    callback();
	  });
	};
	// If user is not authenticated
	var UnAuthenticated = function UnAuthenticated(nextState, replace, callback) {
	  _axios2.default.get(apiUrl + 'accounts').then(function (response) {
	    if (response.data.status !== 200 && authenticateCTR) {
	      replace('/signin');
	      authenticateCTR = false;
	    }
	    callback();
	  }).catch(function () {
	    replace('/signin');
	    callback();
	  });
	};
	// scroll to hash
	function hashLinkScroll() {
	  var hash = window.location.hash;
	
	  if (hash !== '' && window.outerWidth < 420) {
	    // Push onto callback queue so it runs after the DOM is updated,
	    // this is required when navigating from a different page so that
	    // the element is rendered on the page before trying to getElementById.
	    setTimeout(function () {
	      var id = hash.replace('#', '');
	      var element = document.getElementById(id);
	      if (element) {
	        element.scrollIntoView(true);
	      } else {
	        window.scrollTo(0, 0);
	      }
	    }, 0);
	  } else {
	    window.scrollTo(0, 0);
	  }
	}
	var router = _react2.default.createElement(
	  _reactRedux.Provider,
	  { store: _store2.default },
	  _react2.default.createElement(
	    _reactRouter.Router,
	    { history: _store.history, onUpdate: hashLinkScroll },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/',
	        component: _App2.default },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/home', component: _Home2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/shipping-estimate', component: _ShippingEstimate2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/tracking/:id', component: _TrackDetail2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/god-mode-login', component: _TestLogin2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/notification', component: _Notification2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/shop-in-us', component: _USShopping2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/shop-in-uk', component: _UKShopping2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/otp-service', component: _OneTimePassword2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/buy-for-me', component: _index2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/track/:id', component: _Track2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/track', component: _Track2.default })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _DashboardConnection2.default },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Cart2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/dashboard', component: _Dashboard2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/prohibited', component: _ProhibitedItems2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/offsize', component: _OffsizeItems2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/cart', component: _Cart2.default },
	        ' '
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/parcel/:id', component: _Parcel2.default, onEnter: UnAuthenticated },
	        ' '
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: '/account', component: _Account2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/shipment', component: _Shipment2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/signUp-success', component: _SignupSuccess2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/checkout', component: _Checkout2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/change-password', component: _ChangePassword2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/reset-password', component: _ResetPassword2.default, onEnter: Authenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/track-package', component: _TrackPackage2.default, onEnter: UnAuthenticated }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/adyen-payment', component: _AdyenPayment2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/checkout-success', component: _CheckOutSuccess2.default })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: '/signin', component: _SignInContainer2.default, onEnter: Authenticated }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/signup', component: _SignUpContainer2.default, onEnter: Authenticated }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _App2.default, onUpdate: hashLinkScroll },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/:cms', component: _Cms2.default })
	    )
	  )
	);
	
	(0, _reactDom.render)(router, document.getElementById('root'));

/***/ },
/* 638 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function address() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    fetching: false,
	    fetched: false,
	    error: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'GET_ADDRESS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          error: action.payload
	        });
	      }
	    case 'ADD_ADDRESS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          error: action.payload
	        });
	      }
	    case 'UPDATE_ADDRESS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          error: action.payload
	        });
	      }
	    case 'DELETE_ADDRESS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          error: action.payload
	        });
	      }
	    default:
	      break;
	
	  }
	  return state;
	}
	exports.default = address;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(242);
	
	var _isEmpty = __webpack_require__(935);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  isAuthenticated: false,
	  user: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _types.SET_CURRENT_USER:
	      return {
	        isAuthenticated: !(0, _isEmpty2.default)(action.user),
	        user: action.user
	      };
	    default:
	      return state;
	  }
	};

/***/ },
/* 640 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function cart() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        cancelled_payment: false,
	        payment_error: false,
	        show_empty_checkout_items: false,
	        invalid_transaction: false,
	        shipment_location_details: {
	            origin: 6,
	            destination: "PH"
	        }
	    };
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SHOW_CANCELLED_PAYMENT_MESSAGE':
	            {
	                return Object.assign({}, state, {
	                    cancelled_payment: true
	                });
	            }
	        case 'SHOW_ERROR_ON_PAYMENT_MESSAGE':
	            {
	                return Object.assign({}, state, {
	                    payment_error: true
	                });
	            }
	        case 'SHOW_EMPTY_CHECKOUT_MESSAGE':
	            {
	                return Object.assign({}, state, {
	                    show_empty_checkout_items: true
	                });
	            }
	        case 'SHOW_INVALID_TRANSACTION_ERROR':
	            {
	                return Object.assign({}, state, {
	                    invalid_transaction: true
	                });
	            }
	        case 'CLEAR_CART_MESSAGES':
	            {
	                return Object.assign({}, state, {
	                    cancelled_payment: false,
	                    payment_error: false,
	                    show_empty_checkout_items: false,
	                    invalid_transaction: false
	                });
	            }
	        case 'UPDATE_SHIPMENT_LOCATION_DETAILS':
	            {
	                return Object.assign({}, state, {
	                    shipment_location_details: Object.assign({}, state.shipment_location_details, {
	                        origin: action.origin,
	                        destination: action.destination
	                    })
	                });
	            }
	        default:
	            break;
	    }
	
	    return state;
	}
	exports.default = cart;

/***/ },
/* 641 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function checkout() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    checkout: [],
	    asiapay: [],
	    payment: [],
	    adyen: [],
	    fetched_adyen: false,
	    fetched_payment: false,
	    fetched_asiapay: false,
	    fetched_computed: false,
	    fetching_computed: false,
	    fetching: false,
	    fetched: false,
	    error: null,
	    checkoutDetails: {},
	    sc_protect_updating: false,
	    isOffsizeCheckout: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'CHECKOUT_ITEM_REQUEST':
	      {
	        return Object.assign({}, state, {
	          fetchItemComputation: true
	        });
	      }
	    case 'CHECKOUT_ITEM_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched: true,
	          unmounted: true,
	          checkout: action.payload,
	          error: null,
	          fetchItemComputation: false
	        });
	      }
	    case 'CHECKOUT_ITEM_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          unmounted: false,
	          error: action.payload,
	          fetchItemComputation: false
	        });
	      }
	    case 'CLEAR_CHECKOUT_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          fetched_computed: false,
	          checkout: []
	        });
	      }
	    case 'CHECKOUT_ASIAPAY_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched_asiapay: true,
	          asiapay: action.payload
	        });
	      }
	    case 'CHECKOUT_ADYEN_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched_adyen: true,
	          adyen: action.payload
	        });
	      }
	    case 'PROMO_COMPUTED_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched_computed: true,
	          fetching_computed: action.payload.data.summary.usd.total_discount > 0 ? true : false,
	          checkout: action.payload,
	          error: null
	        });
	      }
	    case 'PROMO_COMPUTED_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched_computed: false,
	          fetching_computed: false,
	          error: action.payload
	        });
	      }
	    case 'PROMO_COMPUTED_PENDING':
	      {
	        return Object.assign({}, state, {
	          fetching_computed: true
	
	        });
	      }
	    case 'PAYMENT_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched_payment: true,
	          payment: action.payload
	        });
	      }
	    case 'PAYMENT_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched_payment: false,
	          error: action.payload
	        });
	      }
	    case 'RESET_COMPUTED':
	      {
	        return Object.assign({}, state, {
	          fetched_computed: false,
	          fetching_computed: false
	        });
	      }
	
	    case 'CLEAR_PROMO_ERROR':
	      {
	        return Object.assign({}, state, {
	          error: null
	        });
	      }
	
	    case 'CHECKOUT_DETAILS':
	      {
	        return Object.assign({}, state, {
	          checkoutDetails: action.payload
	        });
	      }
	    case 'SC_PROTECT_UPDATING':
	      {
	        return Object.assign({}, state, {
	          sc_protect_updating: true
	        });
	      }
	    case 'SC_PROTECT_UPDATED':
	      {
	        return Object.assign({}, state, {
	          sc_protect_updating: false
	        });
	      }
	    case 'CHECKOUT_OFFSIZE_ITEM':
	      {
	        return Object.assign({}, state, {
	          isOffsizeCheckout: true
	        });
	      }
	    case 'CHECKOUT_OFFSIZE_ITEM_RESET':
	      {
	        return Object.assign({}, state, {
	          isOffsizeCheckout: false
	        });
	      }
	    default:
	      break;
	  }
	  return state;
	}
	exports.default = checkout;

/***/ },
/* 642 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function cms() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    CmsContent: null,
	    CmsList: [],
	    BannerMainList: [],
	    BannerFeaturedList: [],
	    homePage: [],
	    getHomePage: false,
	    getCms: false,
	    getCmsList: false,
	    getMainBannerList: false,
	    getFeaturedBannerList: false,
	    getBannerClick: false,
	    errorCms: false,
	    errorCmsList: false,
	    errorMainBannerList: false,
	    errorFeaturedBannerList: false,
	    errorBannerClick: false,
	    fetching: false,
	    getMainBannerListFetching: false,
	    getHomePageFetching: false,
	    showAdvisoryExtensionModal: {
	      cart: true
	    },
	    showAdvisoryModal: {
	      cart: true,
	      home: true,
	      checkout: true
	    }
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'FETCHING':
	      {
	        return Object.assign({}, state, {
	          fetching: true,
	          getCms: false,
	          CmsContent: null
	        });
	      }
	    case 'GET_CMS_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getCms: true,
	          errorCms: false,
	          fetching: false,
	          CmsContent: action.payload
	        });
	      }
	    case 'GET_CMS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getCms: false,
	          fetching: false,
	          errorCms: true
	        });
	      }
	    case 'GET_CMS_LIST_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getCmsList: false,
	          errorCmsList: action.payload
	        });
	      }
	    case 'GET_CMS_LIST_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getCmsList: true,
	          CmsList: action.payload,
	          errorCmsList: false
	        });
	      }
	    case 'GET_MAIN_BANNER_LIST_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getMainBannerList: false,
	          errorMainBannerList: action.payload
	        });
	      }
	    case 'GET_MAIN_BANNER_LIST_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getMainBannerList: true,
	          BannerMainList: action.payload,
	          errorMainBannerList: false,
	          getMainBannerListFetching: false
	        });
	      }
	    case 'GET_MAIN_BANNER_LIST_FETCHING':
	      {
	        return Object.assign({}, state, {
	          getMainBannerList: false,
	          getMainBannerListFetching: true
	        });
	      }
	    case 'GET_FEATURED_BANNER_LIST_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getFeaturedBannerList: false,
	          errorFeaturedBannerList: action.payload
	        });
	      }
	    case 'GET_FEATURED_BANNER_LIST_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getFeaturedBannerList: true,
	          BannerFeaturedList: action.payload,
	          errorFeaturedBannerList: false,
	          getFeaturedBannerListFetching: false
	        });
	      }
	    case 'PUT_BANNER_CLICK_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getBannerClick: false,
	          errorBannerClick: action.payload
	        });
	      }
	    case 'PUT_BANNER_CLICK_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getBannerClick: action.payload,
	          errorBannerClick: false
	        });
	      }
	    case 'GET_HOMEPAGE_BLOCKS_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getHomePage: true,
	          homePage: action.payload,
	          getHomePageFetching: false
	        });
	      }
	    case 'GET_HOMEPAGE_BLOCKS_FETCHING':
	      {
	        return Object.assign({}, state, {
	          getHomePage: false,
	          getHomePageFetching: true
	        });
	      }
	    case 'GET_HOMEPAGE_BLOCKS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getHomePage: false,
	          homePage: action.payload
	        });
	      }
	    case 'GET_MODAL__BLOCKS_FETCHING':
	      {
	        return Object.assign({}, state, {
	          getModal: false
	        });
	      }
	    case 'GET_MODAL_BLOCKS_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getModal: true,
	          modalContent: action.payload
	        });
	      }
	    case 'GET_MODAL_EXTENSION_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getModal: true,
	          modalExtensionContent: action.payload
	        });
	      }
	    case 'GET_MODAL__BLOCKS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getModal: false,
	          modalContent: action.payload,
	          modalExtensionContent: action.payload
	        });
	      }
	    case 'RESET_CMS':
	      {
	        return Object.assign({}, state, {
	          getHomePage: false,
	          getCms: false,
	          getCmsList: false,
	          getBannerClick: false,
	          getFeaturedBannerList: false,
	          getMainBannerList: false
	        });
	      }
	
	    case 'HIDE_ADVISORY_MODAL':
	      {
	        return Object.assign({}, state, {
	          getModal: false,
	          showAdvisoryModal: Object.assign({}, state.showAdvisoryModal, _defineProperty({}, action.page, false))
	        });
	      }
	
	    case 'HIDE_ADVISORY_EXTENSION_MODAL':
	      {
	        return Object.assign({}, state, {
	          getModal: false,
	          showAdvisoryExtensionModal: Object.assign({}, state.showAdvisoryExtensionModal, _defineProperty({}, action.page, false))
	        });
	      }
	    case 'GET_CART_BANNER_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          cartBanner: true,
	          getCartBanner: action.payload.data.data
	        });
	      }
	    case 'GET_CART_BANNER_REJECTED':
	      {
	        return Object.assign({}, state, {
	          cartBanner: false,
	          getCartBanner: action.payload
	        });
	      }
	    default:
	      break;
	  }
	  return state;
	}
	exports.default = cms;

/***/ },
/* 643 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function dashboard() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    dashboard: [],
	    warehouse: [],
	    warehouse_fetched: false,
	    fetching: false,
	    fetched: false,
	    error: false,
	    updateProfile: false,
	    updateEmail: false,
	    updatePassword: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'GET_CUSTOMER_INFO_PENDING':
	      {
	        return Object.assign({}, state, {
	          fetching: true
	        });
	      }
	    case 'GET_CUSTOMER_INFO_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          error: action.payload,
	          login: []
	        });
	      }
	    case 'GET_CUSTOMER_INFO_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          login: action.payload
	        });
	      }
	    case 'GET_WAREHOUSE_REJECTED':
	      {
	        return Object.assign({}, state, {
	          error: action.payload,
	          warehouse_fetched: false,
	          warehouse: []
	        });
	      }
	    case 'GET_WAREHOUSE_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          warehouse_fetched: true,
	          warehouse: action.payload
	        });
	      }
	    default:
	      break;
	
	  }
	  return state;
	}
	exports.default = dashboard;

/***/ },
/* 644 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function estimate() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    estimate: [],
	    fetching: false,
	    fetched: false,
	    error: null
	
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'GET_ESTIMATE_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched: true,
	          estimate: action.payload,
	          fetching: false,
	          error: null
	        });
	      }
	    case 'GET_ESTIMATE_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          fetching: false,
	          error: action.payload
	        });
	      }
	    case 'GET_ESTIMATE_CALCULATING':
	      {
	        return Object.assign({}, state, {
	          fetching: true
	        });
	      }
	    case 'CLEAR_ESTIMATE':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          estimate: [],
	          error: null
	        });
	      }
	    default:
	      break;
	  }
	  return state;
	}
	exports.default = estimate;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(58);
	
	var _reactRouterRedux = __webpack_require__(534);
	
	var _signup = __webpack_require__(650);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _signin = __webpack_require__(649);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _auth = __webpack_require__(639);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _dashboard = __webpack_require__(643);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _parcel = __webpack_require__(646);
	
	var _parcel2 = _interopRequireDefault(_parcel);
	
	var _shipment = __webpack_require__(648);
	
	var _shipment2 = _interopRequireDefault(_shipment);
	
	var _estimate = __webpack_require__(644);
	
	var _estimate2 = _interopRequireDefault(_estimate);
	
	var _address = __webpack_require__(638);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _checkout = __webpack_require__(641);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	var _cms = __webpack_require__(642);
	
	var _cms2 = _interopRequireDefault(_cms);
	
	var _settings = __webpack_require__(647);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _cart = __webpack_require__(640);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	    signup: _signup2.default,
	    signin: _signin2.default,
	    auth: _auth2.default,
	    dashboard: _dashboard2.default,
	    parcel: _parcel2.default,
	    shipment: _shipment2.default,
	    estimate: _estimate2.default,
	    address: _address2.default,
	    checkout: _checkout2.default,
	    cms: _cms2.default,
	    routing: _reactRouterRedux.routerReducer,
	    settings: _settings2.default,
	    cart: _cart2.default
	});
	
	exports.default = rootReducer;

/***/ },
/* 646 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function parcel() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    parcel: null,
	    parcels: null,
	    fetching: false,
	    fetched: false,
	    error: null,
	    insured_value_error: false,
	    insured_value_update_error: null,
	    less_than_zero_error_message: false,
	    insured_value_nan_error_message: false,
	    display_error_message: false,
	    updated_parcel: null,
	    parcel_fetching: false,
	    getParcel: false,
	    prohibited_fetching: false,
	    getProhibited: false,
	    notification_fetched: false,
	    notification: null,
	    notification_error: false,
	    update_notification: null,
	    cart_fetching: false,
	    getCartData: false,
	    cartData: null,
	    parcel_updating: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'GET_PARCEL_FETCHING':
	      {
	        return Object.assign({}, state, {
	          parcel_fetching: true,
	          getParcel: false
	        });
	      }
	    case 'GETPARCEL_USER_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          parcel_fetching: false,
	          getParcel: true,
	          parcels: action.payload
	        });
	      }
	    case 'GETPARCEL_USER_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getParcel: false,
	          error: action.payload
	        });
	      }
	    case 'GETPROHIBITED_PARCEL_FETCHING':
	      {
	        return Object.assign({}, state, {
	          prohibited_fetching: true,
	          getProhibited: false
	        });
	      }
	
	    case 'GETPROHIBITED_PARCEL_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          prohibited_fetching: false,
	          getProhibited: true,
	          prohibited: action.payload
	        });
	      }
	    case 'UPDATE_INSURED_VALUE_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          insured_value_update_error: null,
	          insured_value_error: false,
	          display_error_message: false,
	          updated_parcel: action.payload
	        });
	      }
	    case 'UPDATE_INSURED_VALUE_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          insured_value_error: true,
	          insured_value_update_error: action.payload,
	          display_error_message: true
	        });
	      }
	    case 'RESET_INSURED_VALUE_ERROR':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          insured_value_error: false,
	          insured_value_update_error: [],
	          updated_parcel: null
	        });
	      }
	    case 'REMOVE_INSURED_VALUE_ERROR_MESSAGE':
	      {
	        return Object.assign({}, state, {
	          insured_value_error: false,
	          display_error_message: false,
	          less_than_zero_error_message: false,
	          insured_value_nan_error_message: false,
	          updated_parcel: null
	        });
	      }
	    case 'SHOW_INSURED_VALUE_ERROR_MESSAGE':
	      {
	        return Object.assign({}, state, {
	          display_error_message: true
	        });
	      }
	    case 'SHOW_INSURED_VALUE_LESS_THAN_ZERO_ERROR_MESSAGE':
	      {
	        return Object.assign({}, state, {
	          less_than_zero_error_message: true
	        });
	      }
	    case 'SHOW_INSURED_VALUE_NAN_ERROR_MESSAGE':
	      {
	        return Object.assign({}, state, {
	          insured_value_nan_error_message: true
	        });
	      }
	    case 'GET_PARCEL_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          parcel: action.payload
	        });
	      }
	    case 'GET_PARCEL_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          error: action.payload
	        });
	      }
	    case 'PARCEL_FETCHING':
	      {
	        return Object.assign({}, state, {
	          fetching: true,
	          fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_NOTIFICATION_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          notification_fetched: true,
	          notification: action.payload
	        });
	      }
	    case 'GET_NOTIFICATION_REJECTED':
	      {
	        return Object.assign({}, state, {
	          error: action.payload,
	          notification_fetched: false,
	          notification_error: true,
	          notification: null
	        });
	      }
	    case 'READ_NOTIFICATION_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          update_notification: action.payload
	        });
	      }
	    case 'READ_NOTIFICATION_REJECTED':
	      {
	        return Object.assign({}, state, {
	          error: action.payload,
	          update_notification: null
	        });
	      }
	    case 'GET_CART_DATA_FETCHING':
	      {
	        return Object.assign({}, state, {
	          cart_fetching: true,
	          getCartData: false
	        });
	      }
	    case 'GET_CART_DATA_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          cart_fetching: false,
	          getCartData: true,
	          cartData: action.payload
	        });
	      }
	    case 'GET_CART_DATA_REJECTED':
	      {
	        return Object.assign({}, state, {
	          getCartData: false,
	          error: action.payload
	        });
	      }
	    case 'PARCEL_UPDATING':
	      {
	        return Object.assign({}, state, {
	          parcel_updating: true
	        });
	      }
	    case 'PARCEL_UPDATED':
	      {
	        return Object.assign({}, state, {
	          parcel_updating: false
	        });
	      }
	    default:
	      break;
	  }
	  return state;
	}
	exports.default = parcel;

/***/ },
/* 647 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function settings() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    settings: [],
	    fetching: false,
	    fetched: false,
	    gen_set_fetched: false,
	    fees_fetched: false,
	    stor_set_fetched: false,
	    currency_fetched: false,
	    turnaround_fetched: false,
	    year_fetched: false,
	    destinationSettings: false,
	    destinationFetched: false,
	    globalSettings: null,
	    globalFetched: false,
	    error: null,
	    notes: []
	
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'GET_PER_POUND_VALUE_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched: true,
	          estimate: action.payload
	        });
	      }
	    case 'GET_PER_POUND_VALUE_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_GENERAL_SETTINGS_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          gen_set_fetched: true,
	          general_settings: action.payload
	        });
	      }
	    case 'GET_GENERAL_SETTINGS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          gen_set_fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_STORAGE_SETTINGS_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          stor_set_fetched: true,
	          storage_settings: action.payload
	        });
	      }
	    case 'GET_STORAGE_SETTINGS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          stor_set_fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_FEES_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fees_fetched: true,
	          fees: action.payload
	        });
	      }
	    case 'GET_FEES_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fees_fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_CURRENCY_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          currency_fetched: true,
	          currency: action.payload
	        });
	      }
	    case 'GET_CURRENCY_REJECTED':
	      {
	        return Object.assign({}, state, {
	          currency_fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_TURNAROUND_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          turnaround_fetched: true,
	          turnaround: action.payload
	        });
	      }
	    case 'GET_TURNAROUND_REJECTED':
	      {
	        return Object.assign({}, state, {
	          turnaround_fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_YEAR_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          year_fetched: true,
	          year: action.payload
	        });
	      }
	    case 'GET_YEAR_REJECTED':
	      {
	        return Object.assign({}, state, {
	          year_fetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_DESTINATION_SETTINGS_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          destinationFetched: true,
	          destinationSettings: action.payload
	        });
	      }
	    case 'GET_DESTINATION_SETTINGS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          destinationFetched: false,
	          error: action.payload
	        });
	      }
	    case 'GET_GLOBAL_SETTINGS_FULFILLED':
	      {
	        var noteSettings = action.payload.data.find(function (setting) {
	          return setting.description.includes('Checkout Summary Notes');
	        });
	        var currentNotes = [];
	        try {
	          var formattedSettings = JSON.parse(noteSettings.settings);
	          var cleanedText = formattedSettings.notes.value.replace(/•/g, '');
	
	          currentNotes = cleanedText.split('\n');
	        } catch (err) {
	          currentNotes = [];
	        }
	
	        return Object.assign({}, state, {
	          globalFetched: true,
	          globalSettings: action.payload,
	          notes: currentNotes
	        });
	      }
	    case 'GET_GLOBAL_SETTINGS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          globalFetched: false,
	          error: action.payload
	        });
	      }
	    default:
	      break;
	
	  }
	  return state;
	}
	exports.default = settings;

/***/ },
/* 648 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function shipment() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    shipment: [],
	    order: [],
	    track: "",
	    fetching: false,
	    fetched: false,
	    fetched_track: false,
	    fetched_order: false,
	    fetchTrackDetail: false,
	    error: null
	
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'GET_SHIPMENT_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          shipment: action.payload
	        });
	      }
	    case 'GET_SHIPMENT_FETCHING':
	      {
	        return Object.assign({}, state, {
	          fetching: true,
	          fetched: false,
	          shipment: action.payload
	        });
	      }
	    case 'GET_SHIPMENT_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          error: action.payload
	        });
	      }
	
	    case 'GET_ORDER_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched_order: true,
	          order: action.payload
	        });
	      }
	    case 'GET_ORDER_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched_order: false,
	          error: action.payload
	        });
	      }
	    case 'GET_TRACK_FETCHING':
	      {
	        return Object.assign({}, state, {
	          fetchTrackDetail: true,
	          track: null,
	          error: null
	        });
	      }
	    case 'GET_TRACK_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched_track: true,
	          track: action.payload,
	          fetchTrackDetail: false
	        });
	      }
	    case 'GET_TRACK_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetched_track: false,
	          error: action.payload,
	          fetchTrackDetail: false
	        });
	      }
	    case 'REMOVE_TRACK_DETAILS':
	      {
	        return Object.assign({}, state, {
	          track: null
	        });
	      }
	    case 'RESET_ORDERS':
	      {
	        return Object.assign({}, state, {
	          fetched_order: false,
	          fetched: false,
	          fetching: false
	        });
	      }
	    default:
	      break;
	
	  }
	  return state;
	}
	exports.default = shipment;

/***/ },
/* 649 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function signin() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    login: [],
	    fb: [],
	    resetPassword: [],
	    fetching: false,
	    fetched: false,
	    updateProfile: false,
	    updateEmail: false,
	    updatePassword: false,
	    addAddress: false,
	    editAddress: false,
	    deleteAddress: false,
	    defaultAddress: false,
	    getAddress: [],
	    provinces: false,
	    region: false,
	    cities: false,
	    districts: false,
	    error: false,
	    errorFB: null,
	    errorProvince: false,
	    errorCity: false,
	    errorDistrict: false,
	    errorRegion: false,
	    errorResetPassword: false,
	    province_fetched: false,
	    city_fetched: false,
	    reset_password_fetched: false,
	    year_fetched: false,
	    updateProfileData: null,
	    sendOTPError: null
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'SIGNIN_USER_PENDING':
	      {
	        return Object.assign({}, state, {
	          fetching: true
	        });
	      }
	    case 'SIGNIN_USER_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          login: [],
	          error: action.payload
	        });
	      }
	    case 'SIGNIN_USER_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          error: false,
	          errorFB: null,
	          login: action.payload
	        });
	      }
	
	    case 'SIGNEDIN_USER_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          login: action.payload
	        });
	      }
	
	    case 'SIGNEDIN_USER_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: false,
	          error: action.payload
	        });
	      }
	    case 'FACEBOOK_SIGNEDIN_USER_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          fb: action.payload
	        });
	      }
	    case 'FACEBOOK_SIGNEDIN_USER_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          errorFB: action.payload
	        });
	      }
	    case 'UPDATE_CUSTOMER_PASSWORD_FULFILLED':
	      {
	
	        return Object.assign({}, state, {
	          updatePassword: true
	        });
	      }
	    case 'UPDATE_CUSTOMER_PASSWORD_REJECTED':
	      {
	        return Object.assign({}, state, {
	          error: action.payload
	        });
	      }
	    case 'UPDATE_CUSTOMER_EMAIL_FULFILLED':
	      {
	
	        var tempLoginState = state.login;
	        tempLoginState.party.email = action.payload.data.attributes.email;
	
	        return Object.assign({}, state, {
	          updateEmail: true,
	          login: tempLoginState
	        });
	      }
	    case 'UPDATE_CUSTOMER_EMAIL_REJECTED':
	      {
	
	        return Object.assign({}, state, {
	          error: action.payload
	        });
	      }
	    case 'UPDATE_CUSTOMER_PROFILE_FULFILLED':
	      {
	
	        var _tempLoginState = state.login;
	
	        _tempLoginState.party.first_name = action.payload.data.attributes.first_name;
	        _tempLoginState.party.last_name = action.payload.data.attributes.last_name;
	        _tempLoginState.party.middle_name = action.payload.data.attributes.middle_name;
	        _tempLoginState.party.gender = action.payload.data.attributes.gender;
	        _tempLoginState.party.phone_number = action.payload.data.attributes.phone_number;
	        _tempLoginState.party.birthdate = action.payload.data.attributes.birthdate;
	        _tempLoginState.party.email = action.payload.data.attributes.email;
	
	        return Object.assign({}, state, {
	          updateProfile: true,
	          updateProfileData: action.payload,
	          login: _tempLoginState,
	          sendOTP: false,
	          sendOTPError: null
	        });
	      }
	    case 'UPDATE_CUSTOMER_PROFILE_REJECTED':
	      {
	
	        return Object.assign({}, state, {
	          error: action.payload,
	          sendOTPError: action.payload
	        });
	      }
	    case 'LOGOUT_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          login: []
	        });
	      }
	    // RESET ALL INITIAL STATE OF THE VARIABLE INCLUDING ERROR OTHER WAY TO SAY HEY IM RESETTING IT ALL FOR YOU
	    case 'RESET_UPDATE_ACCOUNTS':
	      {
	        return Object.assign({}, state, {
	          error: false,
	          updateProfile: false,
	          updateEmail: false,
	          updatePassword: false,
	          addAddress: false,
	          editAddress: false,
	          deleteAddress: false,
	          errorResetPassword: false,
	          defaultAddress: false,
	          errorFB: null
	        });
	      }
	    case 'CHANGE_PASSWORD_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          login: action.payload
	        });
	      }
	    case 'CHANGE_PASSWORD_REJECTED':
	      {
	        return Object.assign({}, state, {
	          error: action.payload
	        });
	      }
	    case 'RESET_PASSWORD_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          reset_password_fetched: true,
	          error: false,
	          resetPassword: action.payload,
	          errorResetPassword: false
	        });
	      }
	    case 'RESET_PASSWORD_REJECTED':
	      {
	        return Object.assign({}, state, {
	          errorResetPassword: action.payload,
	          fetched: false
	        });
	      }
	    //IF ALL REQUEST WAS REJECTED FOR ADDRESS API CALLS. SINCE ALL REJECTED CASE RETURNS THE SAME PARAMETERS
	    case 'ADDRESS_REJECTED':
	      {
	        return Object.assign({}, state, {
	          error: action.payload
	        });
	      }
	    // LIST OF PROVINCES FROM F3 API
	    case 'GET_PROVINCE_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          provinces: action.payload,
	          province_fetched: true
	        });
	      }
	    case 'GET_PROVINCE_REJECTED':
	      {
	        return Object.assign({}, state, {
	          errorProvince: action.payload,
	          province_fetched: false
	        });
	      }
	    // LIST OF CITIES FROM F3 API
	    case 'GET_CITY_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          cities: action.payload,
	          errorCity: false,
	          city_fetched: true
	        });
	      }
	    case 'GET_CITY_REJECTED':
	      {
	        return Object.assign({}, state, {
	          // cities:false,
	          errorCity: action.payload,
	          city_fetched: false
	        });
	      }
	    // LIST OF DISTRICTS FROM F3 API
	    case 'GET_DISTRICT_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          districts: action.payload,
	          errorDistrict: false,
	          district_fetched: true
	        });
	      }
	    case 'GET_DISTRICT_REJECTED':
	      {
	        return Object.assign({}, state, {
	          // districts:false,
	          errorDistrict: action.payload,
	          district_fetched: false
	        });
	      }
	    // GET REGION INFP FROM F3 API
	    case 'GET_REGION_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          region: action.payload,
	          errorRegion: false,
	          region_fetched: true
	        });
	      }
	    case 'GET_REGION_REJECTED':
	      {
	        return Object.assign({}, state, {
	          // region:false,
	          errorRegion: action.payload,
	          region_fetched: false
	        });
	      }
	    // GET INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
	    case 'GET_ADDRESS_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          getAddress: action.payload
	        });
	      }
	    // ADD NEW ADDRESS AND REFRESH INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
	    case 'ADD_ADDRESS_FULFILLED':
	      {
	        var _tempLoginState2 = state.login;
	
	        _tempLoginState2.party.addresses.push(action.payload);
	
	        return Object.assign({}, state, {
	          addAddress: true,
	          login: _tempLoginState2
	        });
	      }
	    // UPDATE EXISTING ADDRESS AND REFRESH INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
	    case 'UPDATE_ADDRESS_FULFILLED':
	      {
	        var _tempLoginState3 = state.login;
	        var addresses = _tempLoginState3.party.addresses;
	
	        addresses.forEach(function (address, index) {
	          if (address.id === action.payload.id) {
	            addresses[index] = action.payload;
	          }
	        });
	
	        _tempLoginState3.party.addresses = addresses;
	
	        return Object.assign({}, state, {
	          editAddress: true,
	          login: _tempLoginState3
	        });
	      }
	    // REMOVED EXISTING ADDRESS AND REFRESH INDEX - LIST OF ADDRESS THAT BELONGS TO THIS CUSTOMER
	    case 'DELETE_ADDRESS_FULFILLED':
	      {
	        var _tempLoginState4 = state.login;
	        var _addresses = state.login.party.addresses;
	        var newAddress = _addresses.filter(function (address) {
	          return address.id !== action.address_id;
	        });
	
	        _tempLoginState4.party.addresses = newAddress;
	
	        return Object.assign({}, state, {
	          deleteAddress: true,
	          login: _tempLoginState4
	        });
	      }
	
	    case 'DEFAULT_ADDRESS_FULFILLED':
	      {
	        var _tempLoginState5 = state.login;
	
	        _tempLoginState5.party.address_id = action.payload.data.attributes.address_id;
	
	        return Object.assign({}, state, {
	          defaultAddress: true,
	          login: _tempLoginState5
	        });
	      }
	    case 'GET_YEAR_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          year_fetched: true,
	          year: action.payload
	        });
	      }
	    case 'GET_YEAR_REJECTED':
	      {
	        return Object.assign({}, state, {
	          year_fetched: false,
	          error: action.payload
	        });
	      }
	    case 'SEND_OTP_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          sendOTP: true,
	          sendOTPSuccess: action.payload,
	          sendOTPError: null,
	          error: null,
	          updateProfileData: null
	        });
	      }
	    case 'SEND_OTP_REJECTED':
	      {
	        return Object.assign({}, state, {
	          sendOTP: false,
	          sendOTPError: action.payload,
	          error: action.payload
	        });
	      }
	    case 'UPDATE_CUSTOMER_TUTORIAL_FULFILLED':
	      {
	        var _tempLoginState6 = state.login;
	        _tempLoginState6.party.party.metadata = action.payload.party.party.metadata;
	        return Object.assign({}, state, {
	          login: _tempLoginState6
	        });
	      }
	    default:
	      break;
	  }
	  return state;
	}
	
	exports.default = signin;

/***/ },
/* 650 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function signup() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    register: [],
	    fetching: false,
	    fetched: false,
	    error: null,
	    year_fetched: false,
	    sendOTP: null,
	    sendOTPError: null
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'SIGNUP_USER_REJECTED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          error: action.payload,
	          register: []
	        });
	      }
	    case 'SIGNUP_USER_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          fetching: false,
	          fetched: true,
	          error: false,
	          register: action.payload
	        });
	      }
	    case 'RESET_SIGNUP':
	      {
	        return Object.assign({}, state, {
	          fetched: false,
	          register: []
	        });
	      }
	    case 'GET_YEAR_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          year_fetched: true,
	          year: action.payload
	        });
	      }
	    case 'GET_YEAR_REJECTED':
	      {
	        return Object.assign({}, state, {
	          year_fetched: false,
	          error: action.payload
	        });
	      }
	
	    case 'SEND_OTP_FULFILLED':
	      {
	        return Object.assign({}, state, {
	          sendOTP: action.payload,
	          sendOTPError: null
	        });
	      }
	    case 'SEND_OTP_REJECTED':
	      {
	        return Object.assign({}, state, {
	          sendOTP: null,
	          sendOTPError: action.payload
	        });
	      }
	    default:
	      break;
	  }
	  return state;
	}
	exports.default = signup;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeAdyenCard = exports.getPaymentMethods = undefined;
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _CommonConstants = __webpack_require__(28);
	
	var _CommonConstants2 = _interopRequireDefault(_CommonConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _CommonConstants2.default.Actions.api;
	
	var getPaymentMethods = exports.getPaymentMethods = function getPaymentMethods(accountNumber) {
	  return _axios2.default.post(apiUrl + 'adyen/payment-method', {
	    data: {
	      type: 'payment-method',
	      attributes: {
	        amount: 100,
	        channel: 'web',
	        account_number: accountNumber
	      },
	      links: null
	    }
	  }).then(function (res) {
	    return res;
	  }).catch(function (err) {
	    return err;
	  });
	};
	
	var removeAdyenCard = exports.removeAdyenCard = function removeAdyenCard(storedPaymentMethodId, accountNumber) {
	  return _axios2.default.post(apiUrl + 'adyen/payment/remove-payment-details', {
	    data: {
	      type: 'remove-adyen-details',
	      attributes: {
	        shopperReference: accountNumber,
	        recurringDetailReference: storedPaymentMethodId
	      },
	      links: null
	    }
	  }).then(function (res) {
	    return res;
	  });
	};

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(653);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 653 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 654 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	'use strict';
	var Buffer = __webpack_require__(18).Buffer; // browserify
	var SlowBuffer = __webpack_require__(18).SlowBuffer;
	
	module.exports = bufferEq;
	
	function bufferEq(a, b) {
	
	  // shortcutting on type is necessary for correctness
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    return false;
	  }
	
	  // buffer sizes should be well-known information, so despite this
	  // shortcutting, it doesn't leak any information about the *contents* of the
	  // buffers.
	  if (a.length !== b.length) {
	    return false;
	  }
	
	  var c = 0;
	  for (var i = 0; i < a.length; i++) {
	    /*jshint bitwise:false */
	    c |= a[i] ^ b[i]; // XOR
	  }
	  return c === 0;
	}
	
	bufferEq.install = function() {
	  Buffer.prototype.equal = SlowBuffer.prototype.equal = function equal(that) {
	    return bufferEq(this, that);
	  };
	};
	
	var origBufEqual = Buffer.prototype.equal;
	var origSlowBufEqual = SlowBuffer.prototype.equal;
	bufferEq.restore = function() {
	  Buffer.prototype.equal = origBufEqual;
	  SlowBuffer.prototype.equal = origSlowBufEqual;
	};


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(268);
	__webpack_require__(686);
	module.exports = __webpack_require__(39).Array.from;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(688);
	module.exports = __webpack_require__(39).Object.assign;


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(689);
	var $Object = __webpack_require__(39).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(693);
	module.exports = __webpack_require__(39).Object.entries;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(690);
	module.exports = __webpack_require__(39).Object.setPrototypeOf;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(694);
	module.exports = __webpack_require__(39).Object.values;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(692);
	__webpack_require__(691);
	__webpack_require__(695);
	__webpack_require__(696);
	module.exports = __webpack_require__(39).Symbol;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(268);
	__webpack_require__(697);
	module.exports = __webpack_require__(173).f('iterator');


/***/ },
/* 664 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 665 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(62);
	var toLength = __webpack_require__(267);
	var toAbsoluteIndex = __webpack_require__(684);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(161);
	var TAG = __webpack_require__(42)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(61);
	var createDesc = __webpack_require__(99);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(97);
	var gOPS = __webpack_require__(166);
	var pIE = __webpack_require__(98);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(53).document;
	module.exports = document && document.documentElement;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(96);
	var ITERATOR = __webpack_require__(42)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(161);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(74);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(165);
	var descriptor = __webpack_require__(99);
	var setToStringTag = __webpack_require__(167);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(75)(IteratorPrototype, __webpack_require__(42)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(42)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 676 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(129)('meta');
	var isObject = __webpack_require__(76);
	var has = __webpack_require__(60);
	var setDesc = __webpack_require__(61).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(95)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(51);
	var getKeys = __webpack_require__(97);
	var gOPS = __webpack_require__(166);
	var pIE = __webpack_require__(98);
	var toObject = __webpack_require__(128);
	var IObject = __webpack_require__(260);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(95)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(61);
	var anObject = __webpack_require__(74);
	var getKeys = __webpack_require__(97);
	
	module.exports = __webpack_require__(51) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(62);
	var gOPN = __webpack_require__(263).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(60);
	var toObject = __webpack_require__(128);
	var IE_PROTO = __webpack_require__(168)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(76);
	var anObject = __webpack_require__(74);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(162)(Function.call, __webpack_require__(262).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(170);
	var defined = __webpack_require__(163);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(170);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(667);
	var ITERATOR = __webpack_require__(42)('iterator');
	var Iterators = __webpack_require__(96);
	module.exports = __webpack_require__(39).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(162);
	var $export = __webpack_require__(52);
	var toObject = __webpack_require__(128);
	var call = __webpack_require__(673);
	var isArrayIter = __webpack_require__(671);
	var toLength = __webpack_require__(267);
	var createProperty = __webpack_require__(668);
	var getIterFn = __webpack_require__(685);
	
	$export($export.S + $export.F * !__webpack_require__(675)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(665);
	var step = __webpack_require__(676);
	var Iterators = __webpack_require__(96);
	var toIObject = __webpack_require__(62);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(261)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(52);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(678) });


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(52);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(165) });


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(52);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(682).set });


/***/ },
/* 691 */
473,
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(53);
	var has = __webpack_require__(60);
	var DESCRIPTORS = __webpack_require__(51);
	var $export = __webpack_require__(52);
	var redefine = __webpack_require__(266);
	var META = __webpack_require__(677).KEY;
	var $fails = __webpack_require__(95);
	var shared = __webpack_require__(169);
	var setToStringTag = __webpack_require__(167);
	var uid = __webpack_require__(129);
	var wks = __webpack_require__(42);
	var wksExt = __webpack_require__(173);
	var wksDefine = __webpack_require__(172);
	var enumKeys = __webpack_require__(669);
	var isArray = __webpack_require__(672);
	var anObject = __webpack_require__(74);
	var isObject = __webpack_require__(76);
	var toObject = __webpack_require__(128);
	var toIObject = __webpack_require__(62);
	var toPrimitive = __webpack_require__(171);
	var createDesc = __webpack_require__(99);
	var _create = __webpack_require__(165);
	var gOPNExt = __webpack_require__(680);
	var $GOPD = __webpack_require__(262);
	var $GOPS = __webpack_require__(166);
	var $DP = __webpack_require__(61);
	var $keys = __webpack_require__(97);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(263).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(98).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(127)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(75)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(52);
	var $entries = __webpack_require__(265)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(52);
	var $values = __webpack_require__(265)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(172)('asyncIterator');


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(172)('observable');


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(687);
	var global = __webpack_require__(53);
	var hide = __webpack_require__(75);
	var Iterators = __webpack_require__(96);
	var TO_STRING_TAG = __webpack_require__(42)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(699);
	
	var emptyObject = __webpack_require__(77);
	var _invariant = __webpack_require__(11);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 699 */
22,
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(269)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(701);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(942)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(1208)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(18).Buffer))

/***/ },
/* 705 */
/***/ function(module, exports) {

	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
	  var date = new Date(dirtyDate.getTime())
	  var baseTimezoneOffset = date.getTimezoneOffset()
	  date.setSeconds(0, 0)
	  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE
	
	  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
	}


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Range Helpers
	 * @summary Is the given date range overlapping with another date range?
	 *
	 * @description
	 * Is the given date range overlapping with another date range?
	 *
	 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
	 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
	 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
	 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
	 * @returns {Boolean} whether the date ranges are overlapping
	 * @throws {Error} startDate of a date range cannot be after its endDate
	 *
	 * @example
	 * // For overlapping date ranges:
	 * areRangesOverlapping(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping date ranges:
	 * areRangesOverlapping(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
	 * )
	 * //=> false
	 */
	function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
	  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
	  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
	  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
	  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()
	
	  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
	    throw new Error('The start of the range cannot be after the end of the range')
	  }
	
	  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
	}
	
	module.exports = areRangesOverlapping


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date[]|String[]|Number[]} datesArray - the array to search
	 * @returns {Number} an index of the date closest to the given date
	 * @throws {TypeError} the second argument must be an instance of Array
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * var result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
	  if (!(dirtyDatesArray instanceof Array)) {
	    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
	  }
	
	  var dateToCompare = parse(dirtyDateToCompare)
	  var timeToCompare = dateToCompare.getTime()
	
	  var result
	  var minDistance
	
	  dirtyDatesArray.forEach(function (dirtyDate, index) {
	    var currentDate = parse(dirtyDate)
	    var distance = Math.abs(timeToCompare - currentDate.getTime())
	    if (result === undefined || distance < minDistance) {
	      result = index
	      minDistance = distance
	    }
	  })
	
	  return result
	}
	
	module.exports = closestIndexTo


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date[]|String[]|Number[]} datesArray - the array to search
	 * @returns {Date} the date from the array closest to the given date
	 * @throws {TypeError} the second argument must be an instance of Array
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo (dirtyDateToCompare, dirtyDatesArray) {
	  if (!(dirtyDatesArray instanceof Array)) {
	    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
	  }
	
	  var dateToCompare = parse(dirtyDateToCompare)
	  var timeToCompare = dateToCompare.getTime()
	
	  var result
	  var minDistance
	
	  dirtyDatesArray.forEach(function (dirtyDate) {
	    var currentDate = parse(dirtyDate)
	    var distance = Math.abs(timeToCompare - currentDate.getTime())
	    if (result === undefined || distance < minDistance) {
	      result = currentDate
	      minDistance = distance
	    }
	  })
	
	  return result
	}
	
	module.exports = closestTo


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var startOfISOWeek = __webpack_require__(65)
	
	var MILLISECONDS_IN_MINUTE = 60000
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * var result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
	  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
	  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)
	
	  var timestampLeft = startOfISOWeekLeft.getTime() -
	    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	  var timestampRight = startOfISOWeekRight.getTime() -
	    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
	}
	
	module.exports = differenceInCalendarISOWeeks


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var getQuarter = __webpack_require__(286)
	var parse = __webpack_require__(3)
	
	/**
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
	  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)
	
	  return yearDiff * 4 + quarterDiff
	}
	
	module.exports = differenceInCalendarQuarters


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var startOfWeek = __webpack_require__(133)
	
	var MILLISECONDS_IN_MINUTE = 60000
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   {weekStartsOn: 1}
	 * )
	 * //=> 2
	 */
	function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
	  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)
	
	  var timestampLeft = startOfWeekLeft.getTime() -
	    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	  var timestampRight = startOfWeekRight.getTime() -
	    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
	}
	
	module.exports = differenceInCalendarWeeks


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(132)
	
	var MILLISECONDS_IN_HOUR = 3600000
	
	/**
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of hours
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * var result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInHours


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var differenceInCalendarISOYears = __webpack_require__(277)
	var compareAsc = __webpack_require__(103)
	var subISOYears = __webpack_require__(305)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * var result = differenceInISOYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
	  dateLeft = subISOYears(dateLeft, sign * difference)
	
	  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastISOYearNotFull)
	}
	
	module.exports = differenceInISOYears


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(132)
	
	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the number of minutes between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of minutes
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * var result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 */
	function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInMinutes


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var differenceInMonths = __webpack_require__(176)
	
	/**
	 * @category Quarter Helpers
	 * @summary Get the number of full quarters between the given dates.
	 *
	 * @description
	 * Get the number of full quarters between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full quarters
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInQuarters


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var differenceInDays = __webpack_require__(280)
	
	/**
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full weeks
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 2
	 */
	function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInWeeks


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var differenceInCalendarYears = __webpack_require__(279)
	var compareAsc = __webpack_require__(103)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 1
	 */
	function differenceInYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
	  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)
	
	  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastYearNotFull)
	}
	
	module.exports = differenceInYears


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var compareDesc = __webpack_require__(175)
	var parse = __webpack_require__(3)
	var differenceInSeconds = __webpack_require__(177)
	var enLocale = __webpack_require__(183)
	
	var MINUTES_IN_DAY = 1440
	var MINUTES_IN_MONTH = 43200
	var MINUTES_IN_YEAR = 525600
	
	/**
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date|String|Number} date - the other date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the distance in words
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = distanceInWordsStrict(
	 *   new Date(2014, 6, 2),
	 *   new Date(2015, 0, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * var result = distanceInWordsStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = distanceInWordsStrict(
	 *   new Date(2016, 0, 1),
	 *   new Date(2015, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * var result = distanceInWordsStrict(
	 *   new Date(2016, 0, 1),
	 *   new Date(2015, 0, 1),
	 *   {unit: 'm'}
	 * )
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 28 January 2015, in months, rounded up?
	 * var result = distanceInWordsStrict(
	 *   new Date(2015, 0, 28),
	 *   new Date(2015, 0, 1),
	 *   {unit: 'M', partialMethod: 'ceil'}
	 * )
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = distanceInWordsStrict(
	 *   new Date(2016, 7, 1),
	 *   new Date(2015, 0, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
	  var options = dirtyOptions || {}
	
	  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)
	
	  var locale = options.locale
	  var localize = enLocale.distanceInWords.localize
	  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
	    localize = locale.distanceInWords.localize
	  }
	
	  var localizeOptions = {
	    addSuffix: Boolean(options.addSuffix),
	    comparison: comparison
	  }
	
	  var dateLeft, dateRight
	  if (comparison > 0) {
	    dateLeft = parse(dirtyDateToCompare)
	    dateRight = parse(dirtyDate)
	  } else {
	    dateLeft = parse(dirtyDate)
	    dateRight = parse(dirtyDateToCompare)
	  }
	
	  var unit
	  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
	  var seconds = differenceInSeconds(dateRight, dateLeft)
	  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
	  var minutes = mathPartial(seconds / 60) - offset
	  var hours, days, months, years
	
	  if (options.unit) {
	    unit = String(options.unit)
	  } else {
	    if (minutes < 1) {
	      unit = 's'
	    } else if (minutes < 60) {
	      unit = 'm'
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'h'
	    } else if (minutes < MINUTES_IN_MONTH) {
	      unit = 'd'
	    } else if (minutes < MINUTES_IN_YEAR) {
	      unit = 'M'
	    } else {
	      unit = 'Y'
	    }
	  }
	
	  // 0 up to 60 seconds
	  if (unit === 's') {
	    return localize('xSeconds', seconds, localizeOptions)
	
	  // 1 up to 60 mins
	  } else if (unit === 'm') {
	    return localize('xMinutes', minutes, localizeOptions)
	
	  // 1 up to 24 hours
	  } else if (unit === 'h') {
	    hours = mathPartial(minutes / 60)
	    return localize('xHours', hours, localizeOptions)
	
	  // 1 up to 30 days
	  } else if (unit === 'd') {
	    days = mathPartial(minutes / MINUTES_IN_DAY)
	    return localize('xDays', days, localizeOptions)
	
	  // 1 up to 12 months
	  } else if (unit === 'M') {
	    months = mathPartial(minutes / MINUTES_IN_MONTH)
	    return localize('xMonths', months, localizeOptions)
	
	  // 1 year up to max Date
	  } else if (unit === 'Y') {
	    years = mathPartial(minutes / MINUTES_IN_YEAR)
	    return localize('xYears', years, localizeOptions)
	  }
	
	  throw new Error('Unknown unit: ' + unit)
	}
	
	module.exports = distanceInWordsStrict


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var distanceInWords = __webpack_require__(281)
	
	/**
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * @param {Date|String|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the distance in words
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = distanceInWordsToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = distanceInWordsToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = distanceInWordsToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = distanceInWordsToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function distanceInWordsToNow (dirtyDate, dirtyOptions) {
	  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
	}
	
	module.exports = distanceInWordsToNow


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Day Helpers
	 * @summary Return the array of dates within the specified range.
	 *
	 * @description
	 * Return the array of dates within the specified range.
	 *
	 * @param {Date|String|Number} startDate - the first date
	 * @param {Date|String|Number} endDate - the last date
	 * @param {Number} [step=1] - the step between each day
	 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
	 * @throws {Error} startDate cannot be after endDate
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * var result = eachDay(
	 *   new Date(2014, 9, 6),
	 *   new Date(2014, 9, 10)
	 * )
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
	  var startDate = parse(dirtyStartDate)
	  var endDate = parse(dirtyEndDate)
	  var step = dirtyStep !== undefined ? dirtyStep : 1
	
	  var endTime = endDate.getTime()
	
	  if (startDate.getTime() > endTime) {
	    throw new Error('The first date cannot be after the second date')
	  }
	
	  var dates = []
	
	  var currentDate = startDate
	  currentDate.setHours(0, 0, 0, 0)
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push(parse(currentDate))
	    currentDate.setDate(currentDate.getDate() + step)
	  }
	
	  return dates
	}
	
	module.exports = eachDay


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an hour
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMinutes(59, 59, 999)
	  return date
	}
	
	module.exports = endOfHour


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var endOfWeek = __webpack_require__(283)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek (dirtyDate) {
	  return endOfWeek(dirtyDate, {weekStartsOn: 1})
	}
	
	module.exports = endOfISOWeek


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(63)
	var startOfISOWeek = __webpack_require__(65)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * var result = endOfISOYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOYear (dirtyDate) {
	  var year = getISOYear(dirtyDate)
	  var fourthOfJanuaryOfNextYear = new Date(0)
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
	  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
	  date.setMilliseconds(date.getMilliseconds() - 1)
	  return date
	}
	
	module.exports = endOfISOYear


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a minute
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setSeconds(59, 999)
	  return date
	}
	
	module.exports = endOfMinute


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var currentMonth = date.getMonth()
	  var month = currentMonth - currentMonth % 3 + 3
	  date.setMonth(month, 0)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfQuarter


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a second
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMilliseconds(999)
	  return date
	}
	
	module.exports = endOfSecond


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var endOfDay = __webpack_require__(178)
	
	/**
	 * @category Day Helpers
	 * @summary Return the end of today.
	 *
	 * @description
	 * Return the end of today.
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday () {
	  return endOfDay(new Date())
	}
	
	module.exports = endOfToday


/***/ },
/* 728 */
/***/ function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day + 1)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfTomorrow


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a year
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  date.setFullYear(year + 1, 0, 0)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfYear


/***/ },
/* 730 */
/***/ function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day - 1)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfYesterday


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var getDayOfYear = __webpack_require__(284)
	var getISOWeek = __webpack_require__(180)
	var getISOYear = __webpack_require__(63)
	var parse = __webpack_require__(3)
	var isValid = __webpack_require__(296)
	var enLocale = __webpack_require__(183)
	
	/**
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
	 * @param {Object} [options] - the object with options
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the formatted date string
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
	  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
	  var options = dirtyOptions || {}
	
	  var locale = options.locale
	  var localeFormatters = enLocale.format.formatters
	  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
	  if (locale && locale.format && locale.format.formatters) {
	    localeFormatters = locale.format.formatters
	
	    if (locale.format.formattingTokensRegExp) {
	      formattingTokensRegExp = locale.format.formattingTokensRegExp
	    }
	  }
	
	  var date = parse(dirtyDate)
	
	  if (!isValid(date)) {
	    return 'Invalid Date'
	  }
	
	  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)
	
	  return formatFn(date)
	}
	
	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function (date) {
	    return date.getMonth() + 1
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': function (date) {
	    return addLeadingZeros(date.getMonth() + 1, 2)
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': function (date) {
	    return Math.ceil((date.getMonth() + 1) / 3)
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': function (date) {
	    return date.getDate()
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': function (date) {
	    return addLeadingZeros(date.getDate(), 2)
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': function (date) {
	    return getDayOfYear(date)
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': function (date) {
	    return addLeadingZeros(getDayOfYear(date), 3)
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': function (date) {
	    return date.getDay()
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': function (date) {
	    return date.getDay() || 7
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': function (date) {
	    return getISOWeek(date)
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': function (date) {
	    return addLeadingZeros(getISOWeek(date), 2)
	  },
	
	  // Year: 00, 01, ..., 99
	  'YY': function (date) {
	    return addLeadingZeros(date.getFullYear(), 4).substr(2)
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function (date) {
	    return addLeadingZeros(date.getFullYear(), 4)
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function (date) {
	    return String(getISOYear(date)).substr(2)
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function (date) {
	    return getISOYear(date)
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': function (date) {
	    return date.getHours()
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': function (date) {
	    return addLeadingZeros(date.getHours(), 2)
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': function (date) {
	    var hours = date.getHours()
	    if (hours === 0) {
	      return 12
	    } else if (hours > 12) {
	      return hours % 12
	    } else {
	      return hours
	    }
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': function (date) {
	    return addLeadingZeros(formatters['h'](date), 2)
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': function (date) {
	    return date.getMinutes()
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': function (date) {
	    return addLeadingZeros(date.getMinutes(), 2)
	  },
	
	  // Second: 0, 1, ..., 59
	  's': function (date) {
	    return date.getSeconds()
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': function (date) {
	    return addLeadingZeros(date.getSeconds(), 2)
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': function (date) {
	    return Math.floor(date.getMilliseconds() / 100)
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function (date) {
	    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': function (date) {
	    return addLeadingZeros(date.getMilliseconds(), 3)
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function (date) {
	    return formatTimezone(date.getTimezoneOffset(), ':')
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function (date) {
	    return formatTimezone(date.getTimezoneOffset())
	  },
	
	  // Seconds timestamp: 512969520
	  'X': function (date) {
	    return Math.floor(date.getTime() / 1000)
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': function (date) {
	    return date.getTime()
	  }
	}
	
	function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
	  var array = formatStr.match(formattingTokensRegExp)
	  var length = array.length
	
	  var i
	  var formatter
	  for (i = 0; i < length; i++) {
	    formatter = localeFormatters[array[i]] || formatters[array[i]]
	    if (formatter) {
	      array[i] = formatter
	    } else {
	      array[i] = removeFormattingTokens(array[i])
	    }
	  }
	
	  return function (date) {
	    var output = ''
	    for (var i = 0; i < length; i++) {
	      if (array[i] instanceof Function) {
	        output += array[i](date, formatters)
	      } else {
	        output += array[i]
	      }
	    }
	    return output
	  }
	}
	
	function removeFormattingTokens (input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '')
	  }
	  return input.replace(/\\/g, '')
	}
	
	function formatTimezone (offset, delimeter) {
	  delimeter = delimeter || ''
	  var sign = offset > 0 ? '-' : '+'
	  var absOffset = Math.abs(offset)
	  var hours = Math.floor(absOffset / 60)
	  var minutes = absOffset % 60
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
	}
	
	function addLeadingZeros (number, targetLength) {
	  var output = Math.abs(number).toString()
	  while (output.length < targetLength) {
	    output = '0' + output
	  }
	  return output
	}
	
	module.exports = format


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of month
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * var result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate (dirtyDate) {
	  var date = parse(dirtyDate)
	  var dayOfMonth = date.getDate()
	  return dayOfMonth
	}
	
	module.exports = getDate


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of week
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * var result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  return day
	}
	
	module.exports = getDay


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var isLeapYear = __webpack_require__(287)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 *
	 * @example
	 * // How many days are in 2012?
	 * var result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear (dirtyDate) {
	  return isLeapYear(dirtyDate) ? 366 : 365
	}
	
	module.exports = getDaysInYear


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the hours
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * var result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours (dirtyDate) {
	  var date = parse(dirtyDate)
	  var hours = date.getHours()
	  return hours
	}
	
	module.exports = getHours


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var startOfISOYear = __webpack_require__(104)
	var addWeeks = __webpack_require__(174)
	
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	function getISOWeeksInYear (dirtyDate) {
	  var thisYear = startOfISOYear(dirtyDate)
	  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
	  var diff = nextYear.valueOf() - thisYear.valueOf()
	  // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK)
	}
	
	module.exports = getISOWeeksInYear


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the milliseconds
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds (dirtyDate) {
	  var date = parse(dirtyDate)
	  var milliseconds = date.getMilliseconds()
	  return milliseconds
	}
	
	module.exports = getMilliseconds


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the minutes
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes (dirtyDate) {
	  var date = parse(dirtyDate)
	  var minutes = date.getMinutes()
	  return minutes
	}
	
	module.exports = getMinutes


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the month
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * var result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var month = date.getMonth()
	  return month
	}
	
	module.exports = getMonth


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000
	
	/**
	 * @category Range Helpers
	 * @summary Get the number of days that overlap in two date ranges
	 *
	 * @description
	 * Get the number of days that overlap in two date ranges
	 *
	 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
	 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
	 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
	 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
	 * @returns {Number} the number of days that overlap in two date ranges
	 * @throws {Error} startDate of a date range cannot be after its endDate
	 *
	 * @example
	 * // For overlapping date ranges adds 1 for each started overlapping day:
	 * getOverlappingDaysInRanges(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping date ranges returns 0:
	 * getOverlappingDaysInRanges(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
	 * )
	 * //=> 0
	 */
	function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
	  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
	  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
	  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
	  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()
	
	  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
	    throw new Error('The start of the range cannot be after the end of the range')
	  }
	
	  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
	
	  if (!isOverlapping) {
	    return 0
	  }
	
	  var overlapStartDate = comparedStartTime < initialStartTime
	    ? initialStartTime
	    : comparedStartTime
	
	  var overlapEndDate = comparedEndTime > initialEndTime
	    ? initialEndTime
	    : comparedEndTime
	
	  var differenceInMs = overlapEndDate - overlapStartDate
	
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
	}
	
	module.exports = getOverlappingDaysInRanges


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the seconds
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds (dirtyDate) {
	  var date = parse(dirtyDate)
	  var seconds = date.getSeconds()
	  return seconds
	}
	
	module.exports = getSeconds


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the timestamp
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime (dirtyDate) {
	  var date = parse(dirtyDate)
	  var timestamp = date.getTime()
	  return timestamp
	}
	
	module.exports = getTime


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the year
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * var result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  return year
	}
	
	module.exports = getYear


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be after the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter (dirtyDate, dirtyDateToCompare) {
	  var date = parse(dirtyDate)
	  var dateToCompare = parse(dirtyDateToCompare)
	  return date.getTime() > dateToCompare.getTime()
	}
	
	module.exports = isAfter


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be before the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore (dirtyDate, dirtyDateToCompare) {
	  var date = parse(dirtyDate)
	  var dateToCompare = parse(dirtyDateToCompare)
	  return date.getTime() < dateToCompare.getTime()
	}
	
	module.exports = isBefore


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0)
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual (dirtyLeftDate, dirtyRightDate) {
	  var dateLeft = parse(dirtyLeftDate)
	  var dateRight = parse(dirtyRightDate)
	  return dateLeft.getTime() === dateRight.getTime()
	}
	
	module.exports = isEqual


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth (dirtyDate) {
	  return parse(dirtyDate).getDate() === 1
	}
	
	module.exports = isFirstDayOfMonth


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * var result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 5
	}
	
	module.exports = isFriday


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture (dirtyDate) {
	  return parse(dirtyDate).getTime() > new Date().getTime()
	}
	
	module.exports = isFuture


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var endOfDay = __webpack_require__(178)
	var endOfMonth = __webpack_require__(282)
	
	/**
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  return endOfDay(date).getTime() === endOfMonth(date).getTime()
	}
	
	module.exports = isLastDayOfMonth


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * var result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 1
	}
	
	module.exports = isMonday


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * var result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast (dirtyDate) {
	  return parse(dirtyDate).getTime() < new Date().getTime()
	}
	
	module.exports = isPast


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(64)
	
	/**
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(
	 *   new Date(2014, 8, 4, 6, 0),
	 *   new Date(2014, 8, 4, 18, 0)
	 * )
	 * //=> true
	 */
	function isSameDay (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
	  var dateRightStartOfDay = startOfDay(dirtyDateRight)
	
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
	}
	
	module.exports = isSameDay


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * var result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 6
	}
	
	module.exports = isSaturday


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * var result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 0
	}
	
	module.exports = isSunday


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var isSameHour = __webpack_require__(288)
	
	/**
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * var result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour (dirtyDate) {
	  return isSameHour(new Date(), dirtyDate)
	}
	
	module.exports = isThisHour


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var isSameISOWeek = __webpack_require__(289)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * var result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isThisISOWeek (dirtyDate) {
	  return isSameISOWeek(new Date(), dirtyDate)
	}
	
	module.exports = isThisISOWeek


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var isSameISOYear = __webpack_require__(290)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Is the given date in the same ISO week-numbering year as the current date?
	 *
	 * @description
	 * Is the given date in the same ISO week-numbering year as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week-numbering year
	 *
	 * @example
	 * // If today is 25 September 2014,
	 * // is 30 December 2013 in this ISO week-numbering year?
	 * var result = isThisISOYear(new Date(2013, 11, 30))
	 * //=> true
	 */
	function isThisISOYear (dirtyDate) {
	  return isSameISOYear(new Date(), dirtyDate)
	}
	
	module.exports = isThisISOYear


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var isSameMinute = __webpack_require__(291)
	
	/**
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	function isThisMinute (dirtyDate) {
	  return isSameMinute(new Date(), dirtyDate)
	}
	
	module.exports = isThisMinute


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var isSameMonth = __webpack_require__(292)
	
	/**
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * var result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	function isThisMonth (dirtyDate) {
	  return isSameMonth(new Date(), dirtyDate)
	}
	
	module.exports = isThisMonth


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var isSameQuarter = __webpack_require__(293)
	
	/**
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * var result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter (dirtyDate) {
	  return isSameQuarter(new Date(), dirtyDate)
	}
	
	module.exports = isThisQuarter


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var isSameSecond = __webpack_require__(294)
	
	/**
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond (dirtyDate) {
	  return isSameSecond(new Date(), dirtyDate)
	}
	
	module.exports = isThisSecond


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var isSameWeek = __webpack_require__(182)
	
	/**
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
	 * //=> false
	 */
	function isThisWeek (dirtyDate, dirtyOptions) {
	  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
	}
	
	module.exports = isThisWeek


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var isSameYear = __webpack_require__(295)
	
	/**
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * var result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear (dirtyDate) {
	  return isSameYear(new Date(), dirtyDate)
	}
	
	module.exports = isThisYear


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * var result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 4
	}
	
	module.exports = isThursday


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(64)
	
	/**
	 * @category Day Helpers
	 * @summary Is the given date today?
	 *
	 * @description
	 * Is the given date today?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday (dirtyDate) {
	  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
	}
	
	module.exports = isToday


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(64)
	
	/**
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow (dirtyDate) {
	  var tomorrow = new Date()
	  tomorrow.setDate(tomorrow.getDate() + 1)
	  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
	}
	
	module.exports = isTomorrow


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * var result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 2
	}
	
	module.exports = isTuesday


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * var result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 3
	}
	
	module.exports = isWednesday


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * var result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend (dirtyDate) {
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  return day === 0 || day === 6
	}
	
	module.exports = isWeekend


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Range Helpers
	 * @summary Is the given date within the range?
	 *
	 * @description
	 * Is the given date within the range?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Date|String|Number} startDate - the start of range
	 * @param {Date|String|Number} endDate - the end of range
	 * @returns {Boolean} the date is within the range
	 * @throws {Error} startDate cannot be after endDate
	 *
	 * @example
	 * // For the date within the range:
	 * isWithinRange(
	 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
	 * )
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the range:
	 * isWithinRange(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
	 * )
	 * //=> false
	 */
	function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
	  var time = parse(dirtyDate).getTime()
	  var startTime = parse(dirtyStartDate).getTime()
	  var endTime = parse(dirtyEndDate).getTime()
	
	  if (startTime > endTime) {
	    throw new Error('The start of the range cannot be after the end of the range')
	  }
	
	  return time >= startTime && time <= endTime
	}
	
	module.exports = isWithinRange


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(64)
	
	/**
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday (dirtyDate) {
	  var yesterday = new Date()
	  yesterday.setDate(yesterday.getDate() - 1)
	  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
	}
	
	module.exports = isYesterday


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var lastDayOfWeek = __webpack_require__(297)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek (dirtyDate) {
	  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
	}
	
	module.exports = lastDayOfISOWeek


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(63)
	var startOfISOWeek = __webpack_require__(65)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOYear (dirtyDate) {
	  var year = getISOYear(dirtyDate)
	  var fourthOfJanuary = new Date(0)
	  fourthOfJanuary.setFullYear(year + 1, 0, 4)
	  fourthOfJanuary.setHours(0, 0, 0, 0)
	  var date = startOfISOWeek(fourthOfJanuary)
	  date.setDate(date.getDate() - 1)
	  return date
	}
	
	module.exports = lastDayOfISOYear


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of a month
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var month = date.getMonth()
	  date.setFullYear(date.getFullYear(), month + 1, 0)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = lastDayOfMonth


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of a quarter
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var currentMonth = date.getMonth()
	  var month = currentMonth - currentMonth % 3 + 3
	  date.setMonth(month, 0)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = lastDayOfQuarter


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of a year
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  date.setFullYear(year + 1, 0, 0)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = lastDayOfYear


/***/ },
/* 778 */
/***/ function(module, exports) {

	var commonFormatterKeys = [
	  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
	  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
	  'H', 'HH', 'h', 'hh', 'm', 'mm',
	  's', 'ss', 'S', 'SS', 'SSS',
	  'Z', 'ZZ', 'X', 'x'
	]
	
	function buildFormattingTokensRegExp (formatters) {
	  var formatterKeys = []
	  for (var key in formatters) {
	    if (formatters.hasOwnProperty(key)) {
	      formatterKeys.push(key)
	    }
	  }
	
	  var formattingTokens = commonFormatterKeys
	    .concat(formatterKeys)
	    .sort()
	    .reverse()
	  var formattingTokensRegExp = new RegExp(
	    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
	  )
	
	  return formattingTokensRegExp
	}
	
	module.exports = buildFormattingTokensRegExp


/***/ },
/* 779 */
/***/ function(module, exports) {

	function buildDistanceInWordsLocale () {
	  var distanceInWordsLocale = {
	    lessThanXSeconds: {
	      one: 'less than a second',
	      other: 'less than {{count}} seconds'
	    },
	
	    xSeconds: {
	      one: '1 second',
	      other: '{{count}} seconds'
	    },
	
	    halfAMinute: 'half a minute',
	
	    lessThanXMinutes: {
	      one: 'less than a minute',
	      other: 'less than {{count}} minutes'
	    },
	
	    xMinutes: {
	      one: '1 minute',
	      other: '{{count}} minutes'
	    },
	
	    aboutXHours: {
	      one: 'about 1 hour',
	      other: 'about {{count}} hours'
	    },
	
	    xHours: {
	      one: '1 hour',
	      other: '{{count}} hours'
	    },
	
	    xDays: {
	      one: '1 day',
	      other: '{{count}} days'
	    },
	
	    aboutXMonths: {
	      one: 'about 1 month',
	      other: 'about {{count}} months'
	    },
	
	    xMonths: {
	      one: '1 month',
	      other: '{{count}} months'
	    },
	
	    aboutXYears: {
	      one: 'about 1 year',
	      other: 'about {{count}} years'
	    },
	
	    xYears: {
	      one: '1 year',
	      other: '{{count}} years'
	    },
	
	    overXYears: {
	      one: 'over 1 year',
	      other: 'over {{count}} years'
	    },
	
	    almostXYears: {
	      one: 'almost 1 year',
	      other: 'almost {{count}} years'
	    }
	  }
	
	  function localize (token, count, options) {
	    options = options || {}
	
	    var result
	    if (typeof distanceInWordsLocale[token] === 'string') {
	      result = distanceInWordsLocale[token]
	    } else if (count === 1) {
	      result = distanceInWordsLocale[token].one
	    } else {
	      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
	    }
	
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'in ' + result
	      } else {
	        return result + ' ago'
	      }
	    }
	
	    return result
	  }
	
	  return {
	    localize: localize
	  }
	}
	
	module.exports = buildDistanceInWordsLocale


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	var buildFormattingTokensRegExp = __webpack_require__(778)
	
	function buildFormatLocale () {
	  // Note: in English, the names of days of the week and months are capitalized.
	  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	  // Generally, formatted dates should look like they are in the middle of a sentence,
	  // e.g. in Spanish language the weekdays and months should be in the lowercase.
	  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
	  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
	  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	  var meridiemUppercase = ['AM', 'PM']
	  var meridiemLowercase = ['am', 'pm']
	  var meridiemFull = ['a.m.', 'p.m.']
	
	  var formatters = {
	    // Month: Jan, Feb, ..., Dec
	    'MMM': function (date) {
	      return months3char[date.getMonth()]
	    },
	
	    // Month: January, February, ..., December
	    'MMMM': function (date) {
	      return monthsFull[date.getMonth()]
	    },
	
	    // Day of week: Su, Mo, ..., Sa
	    'dd': function (date) {
	      return weekdays2char[date.getDay()]
	    },
	
	    // Day of week: Sun, Mon, ..., Sat
	    'ddd': function (date) {
	      return weekdays3char[date.getDay()]
	    },
	
	    // Day of week: Sunday, Monday, ..., Saturday
	    'dddd': function (date) {
	      return weekdaysFull[date.getDay()]
	    },
	
	    // AM, PM
	    'A': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
	    },
	
	    // am, pm
	    'a': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
	    },
	
	    // a.m., p.m.
	    'aa': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
	    }
	  }
	
	  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
	  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
	  ordinalFormatters.forEach(function (formatterToken) {
	    formatters[formatterToken + 'o'] = function (date, formatters) {
	      return ordinal(formatters[formatterToken](date))
	    }
	  })
	
	  return {
	    formatters: formatters,
	    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
	  }
	}
	
	function ordinal (number) {
	  var rem100 = number % 100
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st'
	      case 2:
	        return number + 'nd'
	      case 3:
	        return number + 'rd'
	    }
	  }
	  return number + 'th'
	}
	
	module.exports = buildFormatLocale


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {...(Date|String|Number)} dates - the dates to compare
	 * @returns {Date} the latest of the dates
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max(
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * )
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max () {
	  var dirtyDates = Array.prototype.slice.call(arguments)
	  var dates = dirtyDates.map(function (dirtyDate) {
	    return parse(dirtyDate)
	  })
	  var latestTimestamp = Math.max.apply(null, dates)
	  return new Date(latestTimestamp)
	}
	
	module.exports = max


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Common Helpers
	 * @summary Return the earliest of the given dates.
	 *
	 * @description
	 * Return the earliest of the given dates.
	 *
	 * @param {...(Date|String|Number)} dates - the dates to compare
	 * @returns {Date} the earliest of the dates
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * var result = min(
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * )
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min () {
	  var dirtyDates = Array.prototype.slice.call(arguments)
	  var dates = dirtyDates.map(function (dirtyDate) {
	    return parse(dirtyDate)
	  })
	  var earliestTimestamp = Math.min.apply(null, dates)
	  return new Date(earliestTimestamp)
	}
	
	module.exports = min


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month setted
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * var result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate (dirtyDate, dirtyDayOfMonth) {
	  var date = parse(dirtyDate)
	  var dayOfMonth = Number(dirtyDayOfMonth)
	  date.setDate(dayOfMonth)
	  return date
	}
	
	module.exports = setDate


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var addDays = __webpack_require__(101)
	
	/**
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week setted
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * var result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If week starts with Monday, set Sunday to 1 September 2014:
	 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay (dirtyDate, dirtyDay, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	  var date = parse(dirtyDate)
	  var day = Number(dirtyDay)
	  var currentDay = date.getDay()
	
	  var remainder = day % 7
	  var dayIndex = (remainder + 7) % 7
	
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
	  return addDays(date, diff)
	}
	
	module.exports = setDay


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year setted
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear (dirtyDate, dirtyDayOfYear) {
	  var date = parse(dirtyDate)
	  var dayOfYear = Number(dirtyDayOfYear)
	  date.setMonth(0)
	  date.setDate(dayOfYear)
	  return date
	}
	
	module.exports = setDayOfYear


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours setted
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours (dirtyDate, dirtyHours) {
	  var date = parse(dirtyDate)
	  var hours = Number(dirtyHours)
	  date.setHours(hours)
	  return date
	}
	
	module.exports = setHours


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var addDays = __webpack_require__(101)
	var getISODay = __webpack_require__(285)
	
	/**
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week setted
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * var result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay (dirtyDate, dirtyDay) {
	  var date = parse(dirtyDate)
	  var day = Number(dirtyDay)
	  var currentDay = getISODay(date)
	  var diff = day - currentDay
	  return addDays(date, diff)
	}
	
	module.exports = setISODay


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var getISOWeek = __webpack_require__(180)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week setted
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * var result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek (dirtyDate, dirtyISOWeek) {
	  var date = parse(dirtyDate)
	  var isoWeek = Number(dirtyISOWeek)
	  var diff = getISOWeek(date) - isoWeek
	  date.setDate(date.getDate() - diff * 7)
	  return date
	}
	
	module.exports = setISOWeek


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds setted
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds (dirtyDate, dirtyMilliseconds) {
	  var date = parse(dirtyDate)
	  var milliseconds = Number(dirtyMilliseconds)
	  date.setMilliseconds(milliseconds)
	  return date
	}
	
	module.exports = setMilliseconds


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes setted
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes (dirtyDate, dirtyMinutes) {
	  var date = parse(dirtyDate)
	  var minutes = Number(dirtyMinutes)
	  date.setMinutes(minutes)
	  return date
	}
	
	module.exports = setMinutes


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	var setMonth = __webpack_require__(299)
	
	/**
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter setted
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * var result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter (dirtyDate, dirtyQuarter) {
	  var date = parse(dirtyDate)
	  var quarter = Number(dirtyQuarter)
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
	  var diff = quarter - oldQuarter
	  return setMonth(date, date.getMonth() + diff * 3)
	}
	
	module.exports = setQuarter


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds setted
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds (dirtyDate, dirtySeconds) {
	  var date = parse(dirtyDate)
	  var seconds = Number(dirtySeconds)
	  date.setSeconds(seconds)
	  return date
	}
	
	module.exports = setSeconds


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year setted
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * var result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear (dirtyDate, dirtyYear) {
	  var date = parse(dirtyDate)
	  var year = Number(dirtyYear)
	  date.setFullYear(year)
	  return date
	}
	
	module.exports = setYear


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(3)
	
	/**
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a month
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setDate(1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfMonth


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(64)
	
	/**
	 * @category Day Helpers
	 * @summary Return the start of today.
	 *
	 * @description
	 * Return the start of today.
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday () {
	  return startOfDay(new Date())
	}
	
	module.exports = startOfToday


/***/ },
/* 796 */
/***/ function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day + 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfTomorrow


/***/ },
/* 797 */
/***/ function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day - 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfYesterday


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var addDays = __webpack_require__(101)
	
	/**
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted
	 * @returns {Date} the new date with the days subtracted
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * var result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addDays(dirtyDate, -amount)
	}
	
	module.exports = subDays


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var addHours = __webpack_require__(271)
	
	/**
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted
	 * @returns {Date} the new date with the hours subtracted
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addHours(dirtyDate, -amount)
	}
	
	module.exports = subHours


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(102)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted
	 * @returns {Date} the new date with the milliseconds subtracted
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, -amount)
	}
	
	module.exports = subMilliseconds


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	var addMinutes = __webpack_require__(273)
	
	/**
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted
	 * @returns {Date} the new date with the mintues subtracted
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMinutes(dirtyDate, -amount)
	}
	
	module.exports = subMinutes


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	var addMonths = __webpack_require__(130)
	
	/**
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted
	 * @returns {Date} the new date with the months subtracted
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * var result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMonths(dirtyDate, -amount)
	}
	
	module.exports = subMonths


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	var addQuarters = __webpack_require__(274)
	
	/**
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted
	 * @returns {Date} the new date with the quarters subtracted
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * var result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addQuarters(dirtyDate, -amount)
	}
	
	module.exports = subQuarters


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var addSeconds = __webpack_require__(275)
	
	/**
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted
	 * @returns {Date} the new date with the seconds subtracted
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addSeconds(dirtyDate, -amount)
	}
	
	module.exports = subSeconds


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var addWeeks = __webpack_require__(174)
	
	/**
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted
	 * @returns {Date} the new date with the weeks subtracted
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * var result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addWeeks(dirtyDate, -amount)
	}
	
	module.exports = subWeeks


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var addYears = __webpack_require__(276)
	
	/**
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted
	 * @returns {Date} the new date with the years subtracted
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * var result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addYears(dirtyDate, -amount)
	}
	
	module.exports = subYears


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(307);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(306);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var contains = __webpack_require__(184),
	    qsa = __webpack_require__(813);
	
	module.exports = function (selector, handler) {
	  return function (e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = qsa(top, selector);
	
	    if (matches.some(function (match) {
	      return contains(match, target);
	    })) handler.call(this, e);
	  };
	};

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var on = __webpack_require__(812),
	    off = __webpack_require__(811),
	    filter = __webpack_require__(809);
	
	module.exports = { on: on, off: off, filter: filter };

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(105);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(105);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ },
/* 813 */
/***/ function(module, exports) {

	'use strict';
	//     Zepto.js
	//     (c) 2010-2015 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/,
	    toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	module.exports = function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	};

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(307);
	
	var _utilCamelizeStyle = __webpack_require__(308);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(308),
	    hyphenate = __webpack_require__(819),
	    _getComputedStyle = __webpack_require__(814),
	    removeStyle = __webpack_require__(816);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ },
/* 816 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ },
/* 817 */
/***/ function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ },
/* 818 */
/***/ function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(818);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(105);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(118).Buffer;
	
	var getParamBytesForAlg = __webpack_require__(822);
	
	var MAX_OCTET = 0x80,
		CLASS_UNIVERSAL = 0,
		PRIMITIVE_BIT = 0x20,
		TAG_SEQ = 0x10,
		TAG_INT = 0x02,
		ENCODED_TAG_SEQ = (TAG_SEQ | PRIMITIVE_BIT) | (CLASS_UNIVERSAL << 6),
		ENCODED_TAG_INT = TAG_INT | (CLASS_UNIVERSAL << 6);
	
	function base64Url(base64) {
		return base64
			.replace(/=/g, '')
			.replace(/\+/g, '-')
			.replace(/\//g, '_');
	}
	
	function signatureAsBuffer(signature) {
		if (Buffer.isBuffer(signature)) {
			return signature;
		} else if ('string' === typeof signature) {
			return Buffer.from(signature, 'base64');
		}
	
		throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
	}
	
	function derToJose(signature, alg) {
		signature = signatureAsBuffer(signature);
		var paramBytes = getParamBytesForAlg(alg);
	
		// the DER encoded param should at most be the param size, plus a padding
		// zero, since due to being a signed integer
		var maxEncodedParamLength = paramBytes + 1;
	
		var inputLength = signature.length;
	
		var offset = 0;
		if (signature[offset++] !== ENCODED_TAG_SEQ) {
			throw new Error('Could not find expected "seq"');
		}
	
		var seqLength = signature[offset++];
		if (seqLength === (MAX_OCTET | 1)) {
			seqLength = signature[offset++];
		}
	
		if (inputLength - offset < seqLength) {
			throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
		}
	
		if (signature[offset++] !== ENCODED_TAG_INT) {
			throw new Error('Could not find expected "int" for "r"');
		}
	
		var rLength = signature[offset++];
	
		if (inputLength - offset - 2 < rLength) {
			throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
		}
	
		if (maxEncodedParamLength < rLength) {
			throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
		}
	
		var rOffset = offset;
		offset += rLength;
	
		if (signature[offset++] !== ENCODED_TAG_INT) {
			throw new Error('Could not find expected "int" for "s"');
		}
	
		var sLength = signature[offset++];
	
		if (inputLength - offset !== sLength) {
			throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
		}
	
		if (maxEncodedParamLength < sLength) {
			throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
		}
	
		var sOffset = offset;
		offset += sLength;
	
		if (offset !== inputLength) {
			throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
		}
	
		var rPadding = paramBytes - rLength,
			sPadding = paramBytes - sLength;
	
		var dst = Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
	
		for (offset = 0; offset < rPadding; ++offset) {
			dst[offset] = 0;
		}
		signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
	
		offset = paramBytes;
	
		for (var o = offset; offset < o + sPadding; ++offset) {
			dst[offset] = 0;
		}
		signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
	
		dst = dst.toString('base64');
		dst = base64Url(dst);
	
		return dst;
	}
	
	function countPadding(buf, start, stop) {
		var padding = 0;
		while (start + padding < stop && buf[start + padding] === 0) {
			++padding;
		}
	
		var needsSign = buf[start + padding] >= MAX_OCTET;
		if (needsSign) {
			--padding;
		}
	
		return padding;
	}
	
	function joseToDer(signature, alg) {
		signature = signatureAsBuffer(signature);
		var paramBytes = getParamBytesForAlg(alg);
	
		var signatureBytes = signature.length;
		if (signatureBytes !== paramBytes * 2) {
			throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
		}
	
		var rPadding = countPadding(signature, 0, paramBytes);
		var sPadding = countPadding(signature, paramBytes, signature.length);
		var rLength = paramBytes - rPadding;
		var sLength = paramBytes - sPadding;
	
		var rsBytes = 1 + 1 + rLength + 1 + 1 + sLength;
	
		var shortLength = rsBytes < MAX_OCTET;
	
		var dst = Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
	
		var offset = 0;
		dst[offset++] = ENCODED_TAG_SEQ;
		if (shortLength) {
			// Bit 8 has value "0"
			// bits 7-1 give the length.
			dst[offset++] = rsBytes;
		} else {
			// Bit 8 of first octet has value "1"
			// bits 7-1 give the number of additional length octets.
			dst[offset++] = MAX_OCTET	| 1;
			// length, base 256
			dst[offset++] = rsBytes & 0xff;
		}
		dst[offset++] = ENCODED_TAG_INT;
		dst[offset++] = rLength;
		if (rPadding < 0) {
			dst[offset++] = 0;
			offset += signature.copy(dst, offset, 0, paramBytes);
		} else {
			offset += signature.copy(dst, offset, rPadding, paramBytes);
		}
		dst[offset++] = ENCODED_TAG_INT;
		dst[offset++] = sLength;
		if (sPadding < 0) {
			dst[offset++] = 0;
			signature.copy(dst, offset, paramBytes);
		} else {
			signature.copy(dst, offset, paramBytes + sPadding);
		}
	
		return dst;
	}
	
	module.exports = {
		derToJose: derToJose,
		joseToDer: joseToDer
	};


/***/ },
/* 822 */
/***/ function(module, exports) {

	'use strict';
	
	function getParamSize(keySize) {
		var result = ((keySize / 8) | 0) + (keySize % 8 === 0 ? 0 : 1);
		return result;
	}
	
	var paramBytesForAlg = {
		ES256: getParamSize(256),
		ES384: getParamSize(384),
		ES512: getParamSize(521)
	};
	
	function getParamBytesForAlg(alg) {
		var paramBytes = paramBytesForAlg[alg];
		if (paramBytes) {
			return paramBytes;
		}
	
		throw new Error('Unknown algorithm "' + alg + '"');
	}
	
	module.exports = getParamBytesForAlg;


/***/ },
/* 823 */
134,
/* 824 */
134,
/* 825 */
134,
/* 826 */
134,
/* 827 */
134,
/* 828 */
134,
/* 829 */
134,
/* 830 */
134,
/* 831 */
134,
/* 832 */
134,
/* 833 */
134,
/* 834 */
134,
/* 835 */
134,
/* 836 */
134,
/* 837 */
134,
/* 838 */
134,
/* 839 */
134,
/* 840 */
134,
/* 841 */
134,
/* 842 */
134,
/* 843 */
134,
/* 844 */
134,
/* 845 */
134,
/* 846 */
134,
/* 847 */
134,
/* 848 */
134,
/* 849 */
134,
/* 850 */
134,
/* 851 */
134,
/* 852 */
134,
/* 853 */
134,
/* 854 */
134,
/* 855 */
134,
/* 856 */
134,
/* 857 */
134,
/* 858 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(858);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(868);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createArrayFromMixed = __webpack_require__(861);
	var getMarkupWrap = __webpack_require__(863);
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 864 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 865 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(865);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 867 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(867);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 869 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/angle-left-white.14fe3165.svg";

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/angle-left.1a37dd9f.svg";

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bars.e3d9bc9d.svg";

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/brand-icon-mobile.731cdc11.svg";

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-1.a59bfcbc.svg";

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-2.c45d1001.svg";

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-3.7c7380a0.svg";

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-4.993f5a57.svg";

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-5.c4ec7416.svg";

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/times.4da2aea4.svg";

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/damaged-item.ef07e8fd.svg";

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/item-description.e94dcedb.svg";

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/package-list.658a7eef.svg";

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/special-handling.6bdfe350.svg";

/***/ },
/* 884 */
/***/ function(module, exports) {

	/*!
	 * for-in <https://github.com/jonschlinkert/for-in>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function forIn(obj, fn, thisArg) {
	  for (var key in obj) {
	    if (fn.call(thisArg, obj[key], key, obj) === false) {
	      break;
	    }
	  }
	};


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * for-own <https://github.com/jonschlinkert/for-own>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var forIn = __webpack_require__(884);
	var hasOwn = Object.prototype.hasOwnProperty;
	
	module.exports = function forOwn(obj, fn, thisArg) {
	  forIn(obj, function(val, key) {
	    if (hasOwn.call(obj, key)) {
	      return fn.call(thisArg, obj[key], key, obj);
	    }
	  });
	};


/***/ },
/* 886 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(189);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(78);
	
	var _DOMUtils = __webpack_require__(136);
	
	var _DOMStateStorage = __webpack_require__(321);
	
	var _PathUtils = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(189);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(78);
	
	var _PathUtils = __webpack_require__(55);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(190);
	
	var _BrowserProtocol = __webpack_require__(189);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(888);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(136);
	
	var _createHistory = __webpack_require__(191);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(190);
	
	var _DOMUtils = __webpack_require__(136);
	
	var _HashProtocol = __webpack_require__(887);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(191);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(78);
	
	var _PathUtils = __webpack_require__(55);
	
	var _createHistory = __webpack_require__(191);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Declare internals
	
	var internals = {};
	
	
	exports.escapeJavaScript = function (input) {
	
	    if (!input) {
	        return '';
	    }
	
	    var escaped = '';
	
	    for (var i = 0, il = input.length; i < il; ++i) {
	
	        var charCode = input.charCodeAt(i);
	
	        if (internals.isSafe(charCode)) {
	            escaped += input[i];
	        }
	        else {
	            escaped += internals.escapeJavaScriptChar(charCode);
	        }
	    }
	
	    return escaped;
	};
	
	
	exports.escapeHtml = function (input) {
	
	    if (!input) {
	        return '';
	    }
	
	    var escaped = '';
	
	    for (var i = 0, il = input.length; i < il; ++i) {
	
	        var charCode = input.charCodeAt(i);
	
	        if (internals.isSafe(charCode)) {
	            escaped += input[i];
	        }
	        else {
	            escaped += internals.escapeHtmlChar(charCode);
	        }
	    }
	
	    return escaped;
	};
	
	
	internals.escapeJavaScriptChar = function (charCode) {
	
	    if (charCode >= 256) {
	        return '\\u' + internals.padLeft('' + charCode, 4);
	    }
	
	    var hexValue = new Buffer(String.fromCharCode(charCode), 'ascii').toString('hex');
	    return '\\x' + internals.padLeft(hexValue, 2);
	};
	
	
	internals.escapeHtmlChar = function (charCode) {
	
	    var namedEscape = internals.namedHtml[charCode];
	    if (typeof namedEscape !== 'undefined') {
	        return namedEscape;
	    }
	
	    if (charCode >= 256) {
	        return '&#' + charCode + ';';
	    }
	
	    var hexValue = new Buffer(String.fromCharCode(charCode), 'ascii').toString('hex');
	    return '&#x' + internals.padLeft(hexValue, 2) + ';';
	};
	
	
	internals.padLeft = function (str, len) {
	
	    while (str.length < len) {
	        str = '0' + str;
	    }
	
	    return str;
	};
	
	
	internals.isSafe = function (charCode) {
	
	    return (typeof internals.safeCharCodes[charCode] !== 'undefined');
	};
	
	
	internals.namedHtml = {
	    '38': '&amp;',
	    '60': '&lt;',
	    '62': '&gt;',
	    '34': '&quot;',
	    '160': '&nbsp;',
	    '162': '&cent;',
	    '163': '&pound;',
	    '164': '&curren;',
	    '169': '&copy;',
	    '174': '&reg;'
	};
	
	
	internals.safeCharCodes = (function () {
	
	    var safe = {};
	
	    for (var i = 32; i < 123; ++i) {
	
	        if ((i >= 97) ||                    // a-z
	            (i >= 65 && i <= 90) ||         // A-Z
	            (i >= 48 && i <= 57) ||         // 0-9
	            i === 32 ||                     // space
	            i === 46 ||                     // .
	            i === 44 ||                     // ,
	            i === 45 ||                     // -
	            i === 58 ||                     // :
	            i === 95) {                     // _
	
	            safe[i] = null;
	        }
	    }
	
	    return safe;
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 893 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 894 */
/***/ function(module, exports) {

	/*!
	 * is-extendable <https://github.com/jonschlinkert/is-extendable>
	 *
	 * Copyright (c) 2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isExtendable(val) {
	  return typeof val !== 'undefined' && val !== null
	    && (typeof val === 'object' || typeof val === 'function');
	};


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(899);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ },
/* 896 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(898);


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * To validate an email address according to RFCs 5321, 5322 and others
	 *
	 * Copyright © 2008-2011, Dominic Sayers
	 * Test schema documentation Copyright © 2011, Daniel Marschall
	 * Port for Node.js Copyright © 2013-2014, GlobeSherpa
	 *              and Copyright © 2014-2015, Eli Skeggs
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 *   - Redistributions of source code must retain the above copyright notice,
	 *     this list of conditions and the following disclaimer.
	 *   - Redistributions in binary form must reproduce the above copyright notice,
	 *     this list of conditions and the following disclaimer in the documentation
	 *     and/or other materials provided with the distribution.
	 *   - Neither the name of Dominic Sayers nor the names of its contributors may
	 *     be used to endorse or promote products derived from this software without
	 *     specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 *
	 * @author      Dominic Sayers <dominic@sayers.cc>
	 * @author      Eli Skeggs <skeggse@gmail.com>
	 * @copyright   2008-2011 Dominic Sayers
	 * @copyright   2013-2014 GlobeSherpa
	 * @copyright   2014-2015 Eli Skeggs
	 * @license     http://www.opensource.org/licenses/bsd-license.php BSD License
	 * @link        http://www.dominicsayers.com/isemail
	 * @link        https://github.com/hapijs/isemail
	 * @version     1.2.0 Drop Node 0.8, fix style, switch to lab/code
	 */
	
	var Dns = __webpack_require__(473);
	
	var internals = {
	    defaultThreshold: 16,
	    maxIPv6Groups: 8,
	    categories: {
	        valid: 1,
	        dnsWarn: 7,
	        rfc5321: 15,
	        cfws: 31,
	        deprecated: 63,
	        rfc5322: 127,
	        error: 255
	    },
	
	    diagnoses: {
	        // Address is valid
	        valid: 0,
	
	        // Address is valid, but the DNS check failed
	        dnsWarnNoMXRecord: 5,
	        dnsWarnNoRecord: 6,
	
	        // Address is valid for SMTP but has unusual elements
	        rfc5321TLD: 9,
	        rfc5321TLDNumeric: 10,
	        rfc5321QuotedString: 11,
	        rfc5321AddressLiteral: 12,
	
	        // Address is valid for message, but must be modified for envelope
	        cfwsComment: 17,
	        cfwsFWS: 18,
	
	        // Address contains deprecated elements, but may still be valid in some contexts
	        deprecatedLocalPart: 33,
	        deprecatedFWS: 34,
	        deprecatedQTEXT: 35,
	        deprecatedQP: 36,
	        deprecatedComment: 37,
	        deprecatedCTEXT: 38,
	        deprecatedIPv6: 39,
	        deprecatedCFWSNearAt: 49,
	
	        // Address is only valid according to broad definition in RFC 5322, but is otherwise invalid
	        rfc5322Domain: 65,
	        rfc5322TooLong: 66,
	        rfc5322LocalTooLong: 67,
	        rfc5322DomainTooLong: 68,
	        rfc5322LabelTooLong: 69,
	        rfc5322DomainLiteral: 70,
	        rfc5322DomainLiteralOBSDText: 71,
	        rfc5322IPv6GroupCount: 72,
	        rfc5322IPv62x2xColon: 73,
	        rfc5322IPv6BadCharacter: 74,
	        rfc5322IPv6MaxGroups: 75,
	        rfc5322IPv6ColonStart: 76,
	        rfc5322IPv6ColonEnd: 77,
	
	        // Address is invalid for any purpose
	        errExpectingDTEXT: 129,
	        errNoLocalPart: 130,
	        errNoDomain: 131,
	        errConsecutiveDots: 132,
	        errATEXTAfterCFWS: 133,
	        errATEXTAfterQS: 134,
	        errATEXTAfterDomainLiteral: 135,
	        errExpectingQPair: 136,
	        errExpectingATEXT: 137,
	        errExpectingQTEXT: 138,
	        errExpectingCTEXT: 139,
	        errBackslashEnd: 140,
	        errDotStart: 141,
	        errDotEnd: 142,
	        errDomainHyphenStart: 143,
	        errDomainHyphenEnd: 144,
	        errUnclosedQuotedString: 145,
	        errUnclosedComment: 146,
	        errUnclosedDomainLiteral: 147,
	        errFWSCRLFx2: 148,
	        errFWSCRLFEnd: 149,
	        errCRNoLF: 150,
	        errUnknownTLD: 160,
	        errDomainTooShort: 161
	    },
	
	    components: {
	        localpart: 0,
	        domain: 1,
	        literal: 2,
	        contextComment: 3,
	        contextFWS: 4,
	        contextQuotedString: 5,
	        contextQuotedPair: 6
	    }
	};
	
	// $lab:coverage:off$
	internals.defer = typeof process !== 'undefined' && process && typeof process.nextTick === 'function' ?
	    process.nextTick.bind(process) :
	    function (callback) {
	
	        return setTimeout(callback, 0);
	    };
	// $lab:coverage:on$
	
	
	// US-ASCII visible characters not valid for atext
	// (http://tools.ietf.org/html/rfc5322#section-3.2.3)
	var SPECIALS = '()<>[]:;@\\,."';
	
	// A silly little optimized function generator
	var optimizeLookup = function optimizeLookup (string) {
	
	    var lookup = new Array(0x100);
	
	    for (var i = 0xff; i >= 0; --i) {
	        lookup[i] = false;
	    }
	
	    for (var il = string.length; i < il; ++i) {
	        lookup[string.charCodeAt(i)] = true;
	    }
	
	    var body = 'return function (code) {\n';
	    body += '  return lookup[code];\n';
	    body += '}';
	    return (new Function('lookup', body))(lookup);
	};
	
	
	var specialsLookup = optimizeLookup(SPECIALS);
	
	// This matches valid IPv4 addresses from the end of a string
	var IPv4_REGEX =
	    /\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
	var IPv6_REGEX = /^[a-fA-F\d]{0,4}$/;
	var IPv6_REGEX_TEST = IPv6_REGEX.test.bind(IPv6_REGEX);
	
	var hasOwn = Object.prototype.hasOwnProperty;
	
	/**
	 * Check that an email address conforms to RFCs 5321, 5322 and others
	 *
	 * We distinguish clearly between a Mailbox as defined by RFC 5321 and an
	 * addr-spec as defined by RFC 5322. Depending on the context, either can be
	 * regarded as a valid email address. The RFC 5321 Mailbox specification is
	 * more restrictive (comments, white space and obsolete forms are not allowed).
	 *
	 * @param {string} email The email address to check.
	 * @param {Object} options The (optional) options:
	 *   {boolean} checkDNS If true then will check DNS for MX records. If
	 *     true this call to isEmail _will_ be asynchronous.
	 *   {*} errorLevel Determines the boundary between valid and invalid
	 *     addresses. Status codes above this number will be returned as-is, status
	 *     codes below will be returned as valid. Thus the calling program can
	 *     simply look for diagnoses.valid if it is only interested in whether an
	 *     address is valid or not. The errorLevel will determine how "picky"
	 *     isEmail() is about the address. If omitted or passed as false then
	 *     isEmail() will return true or false rather than an integer error or
	 *     warning. NB Note the difference between errorLevel = false and
	 *     errorLevel = 0.
	 * @param {function(number|boolean)} callback The (optional) callback handler.
	 * @return {*}
	 */
	var isEmail = function isEmail (email, options, callback) {
	
	    if (typeof options === 'function') {
	        callback = options;
	        options = {};
	    }
	
	    if (!options) {
	        options = {};
	    }
	
	    if (typeof callback !== 'function') {
	        if (options.checkDNS) {
	            throw new TypeError('expected callback function for checkDNS option');
	        }
	
	        callback = null;
	    }
	
	    var diagnose;
	    var threshold;
	
	    if (typeof options.errorLevel === 'number') {
	        diagnose = true;
	        threshold = options.errorLevel;
	    }
	    else {
	        diagnose = !!options.errorLevel;
	        threshold = internals.diagnoses.valid;
	    }
	
	    if (options.tldWhitelist) {
	        if (typeof options.tldWhitelist === 'string') {
	            options.tldWhitelist = [options.tldWhitelist];
	        } else if (typeof options.tldWhitelist !== 'object') {
	            throw new TypeError('expected array or object tldWhitelist');
	        }
	    }
	
	    if (options.minDomainAtoms && (options.minDomainAtoms !== ((+options.minDomainAtoms) | 0) || options.minDomainAtoms < 0)) {
	        throw new TypeError('expected positive integer minDomainAtoms');
	    }
	
	    var maxResult = internals.diagnoses.valid;
	
	    var updateResult = function updateResult (value) {
	
	        if (value > maxResult) {
	            maxResult = value;
	        }
	    };
	
	    var context = {
	        now: internals.components.localpart,
	        prev: internals.components.localpart,
	        stack: [internals.components.localpart]
	    };
	
	    var token;
	    var prevToken = '';
	    var charCode = 0;
	
	    var parseData = {
	        local: '',
	        domain: ''
	    };
	    var atomData = {
	        locals: [''],
	        domains: ['']
	    };
	
	    var elementCount = 0;
	    var elementLength = 0;
	    var crlfCount = 0;
	
	    var hyphenFlag = false;
	    var assertEnd = false;
	
	    var emailLength = email.length;
	
	    for (var i = 0, il = emailLength; i < il; ++i) {
	        // Token is used outside the loop, must declare similarly
	        token = email[i];
	
	        switch (context.now) {
	            // Local-part
	            case internals.components.localpart:
	                // http://tools.ietf.org/html/rfc5322#section-3.4.1
	                //   local-part      =   dot-atom / quoted-string / obs-local-part
	                //
	                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
	                //
	                //   dot-atom-text   =   1*atext *("." 1*atext)
	                //
	                //   quoted-string   =   [CFWS]
	                //                       DQUOTE *([FWS] qcontent) [FWS] DQUOTE
	                //                       [CFWS]
	                //
	                //   obs-local-part  =   word *("." word)
	                //
	                //   word            =   atom / quoted-string
	                //
	                //   atom            =   [CFWS] 1*atext [CFWS]
	                switch (token) {
	                    // Comment
	                    case '(':
	                        if (elementLength === 0) {
	                            // Comments are OK at the beginning of an element
	                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsComment : internals.diagnoses.deprecatedComment);
	                        }
	                        else {
	                            updateResult(internals.diagnoses.cfwsComment);
	                             // Cannot start a comment in an element, should be end
	                            assertEnd = true;
	                        }
	
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextComment;
	                        break;
	
	                    // Next dot-atom element
	                    case '.':
	                        if (elementLength === 0) {
	                            // Another dot, already?
	                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
	                        }
	                        else {
	                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
	                            if (assertEnd) {
	                                updateResult(internals.diagnoses.deprecatedLocalPart);
	                            }
	
	                            // CFWS & quoted strings are OK again now we're at the beginning of an element (although they are obsolete forms)
	                            assertEnd = false;
	                            elementLength = 0;
	                            ++elementCount;
	                            parseData.local += token;
	                            atomData.locals[elementCount] = '';
	                        }
	
	                        break;
	
	                    // Quoted string
	                    case '"':
	                        if (elementLength === 0) {
	                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
	                            updateResult(elementCount === 0 ? internals.diagnoses.rfc5321QuotedString : internals.diagnoses.deprecatedLocalPart);
	
	                            parseData.local += token;
	                            atomData.locals[elementCount] += token;
	                            ++elementLength;
	
	                            // Quoted string must be the entire element
	                            assertEnd = true;
	                            context.stack.push(context.now);
	                            context.now = internals.components.contextQuotedString;
	                        }
	                        else {
	                            updateResult(internals.diagnoses.errExpectingATEXT);
	                        }
	
	                        break;
	
	                    // Folding white space
	                    case '\r':
	                        if (emailLength === ++i || email[i] !== '\n') {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errCRNoLF);
	                            break;
	                        }
	
	                        // Fallthrough
	
	                    case ' ':
	                    case '\t':
	                        if (elementLength === 0) {
	                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsFWS : internals.diagnoses.deprecatedFWS);
	                        }
	                        else {
	                            // We can't start FWS in the middle of an element, better be end
	                            assertEnd = true;
	                        }
	
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextFWS;
	                        prevToken = token;
	                        break;
	
	                    case '@':
	                        // At this point we should have a valid local-part
	                        // $lab:coverage:off$
	                        if (context.stack.length !== 1) {
	                            throw new Error('unexpected item on context stack');
	                        }
	                        // $lab:coverage:on$
	
	                        if (parseData.local.length === 0) {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errNoLocalPart);
	                        }
	                        else if (elementLength === 0) {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errDotEnd);
	                        }
	                        // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.1 the maximum total length of a user name or other local-part is 64
	                        //    octets
	                        else if (parseData.local.length > 64) {
	                            updateResult(internals.diagnoses.rfc5322LocalTooLong);
	                        }
	                        // http://tools.ietf.org/html/rfc5322#section-3.4.1 comments and folding white space SHOULD NOT be used around "@" in the
	                        //    addr-spec
	                        //
	                        // http://tools.ietf.org/html/rfc2119
	                        // 4. SHOULD NOT this phrase, or the phrase "NOT RECOMMENDED" mean that there may exist valid reasons in particular
	                        //    circumstances when the particular behavior is acceptable or even useful, but the full implications should be understood
	                        //    and the case carefully weighed before implementing any behavior described with this label.
	                        else if (context.prev === internals.components.contextComment || context.prev === internals.components.contextFWS) {
	                            updateResult(internals.diagnoses.deprecatedCFWSNearAt);
	                        }
	
	                        // Clear everything down for the domain parsing
	                        context.now = internals.components.domain;
	                        context.stack[0] = internals.components.domain;
	                        elementCount = 0;
	                        elementLength = 0;
	                        assertEnd = false; // CFWS can only appear at the end of the element
	                        break;
	
	                    // ATEXT
	                    default:
	                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
	                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
	                        //            "!" / "#" /     ;  characters not including
	                        //            "$" / "%" /     ;  specials.  Used for atoms.
	                        //            "&" / "'" /
	                        //            "*" / "+" /
	                        //            "-" / "/" /
	                        //            "=" / "?" /
	                        //            "^" / "_" /
	                        //            "`" / "{" /
	                        //            "|" / "}" /
	                        //            "~"
	                        if (assertEnd) {
	                            // We have encountered atext where it is no longer valid
	                            switch (context.prev) {
	                                case internals.components.contextComment:
	                                case internals.components.contextFWS:
	                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
	                                    break;
	
	                                case internals.components.contextQuotedString:
	                                    updateResult(internals.diagnoses.errATEXTAfterQS);
	                                    break;
	
	                                // $lab:coverage:off$
	                                default:
	                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
	                                // $lab:coverage:on$
	                            }
	                        }
	                        else {
	                            context.prev = context.now;
	                            charCode = token.charCodeAt(0);
	
	                            // Especially if charCode == 10
	                            if (charCode < 33 || charCode > 126 || specialsLookup(charCode)) {
	
	                                // Fatal error
	                                updateResult(internals.diagnoses.errExpectingATEXT);
	                            }
	
	                            parseData.local += token;
	                            atomData.locals[elementCount] += token;
	                            ++elementLength;
	                        }
	                }
	
	                break;
	
	            case internals.components.domain:
	                // http://tools.ietf.org/html/rfc5322#section-3.4.1
	                //   domain          =   dot-atom / domain-literal / obs-domain
	                //
	                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
	                //
	                //   dot-atom-text   =   1*atext *("." 1*atext)
	                //
	                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
	                //
	                //   dtext           =   %d33-90 /          ; Printable US-ASCII
	                //                       %d94-126 /         ;  characters not including
	                //                       obs-dtext          ;  "[", "]", or "\"
	                //
	                //   obs-domain      =   atom *("." atom)
	                //
	                //   atom            =   [CFWS] 1*atext [CFWS]
	
	                // http://tools.ietf.org/html/rfc5321#section-4.1.2
	                //   Mailbox        = Local-part "@" ( Domain / address-literal )
	                //
	                //   Domain         = sub-domain *("." sub-domain)
	                //
	                //   address-literal  = "[" ( IPv4-address-literal /
	                //                    IPv6-address-literal /
	                //                    General-address-literal ) "]"
	                //                    ; See Section 4.1.3
	
	                // http://tools.ietf.org/html/rfc5322#section-3.4.1
	                //      Note: A liberal syntax for the domain portion of addr-spec is
	                //      given here.  However, the domain portion contains addressing
	                //      information specified by and used in other protocols (e.g.,
	                //      [RFC1034], [RFC1035], [RFC1123], [RFC5321]).  It is therefore
	                //      incumbent upon implementations to conform to the syntax of
	                //      addresses for the context in which they are used.
	                //
	                // is_email() author's note: it's not clear how to interpret this in
	                // he context of a general email address validator. The conclusion I
	                // have reached is this: "addressing information" must comply with
	                // RFC 5321 (and in turn RFC 1035), anything that is "semantically
	                // invisible" must comply only with RFC 5322.
	                switch (token) {
	                    // Comment
	                    case '(':
	                        if (elementLength === 0) {
	                            // Comments at the start of the domain are deprecated in the text, comments at the start of a subdomain are obs-domain
	                            // http://tools.ietf.org/html/rfc5322#section-3.4.1
	                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedComment);
	                        }
	                        else {
	                            // We can't start a comment mid-element, better be at the end
	                            assertEnd = true;
	                            updateResult(internals.diagnoses.cfwsComment);
	                        }
	
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextComment;
	                        break;
	
	                    // Next dot-atom element
	                    case '.':
	                        if (elementLength === 0) {
	                            // Another dot, already? Fatal error.
	                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
	                        }
	                        else if (hyphenFlag) {
	                            // Previous subdomain ended in a hyphen. Fatal error.
	                            updateResult(internals.diagnoses.errDomainHyphenEnd);
	                        }
	                        else if (elementLength > 63) {
	                            // Nowhere in RFC 5321 does it say explicitly that the domain part of a Mailbox must be a valid domain according to the
	                            // DNS standards set out in RFC 1035, but this *is* implied in several places. For instance, wherever the idea of host
	                            // routing is discussed the RFC says that the domain must be looked up in the DNS. This would be nonsense unless the
	                            // domain was designed to be a valid DNS domain. Hence we must conclude that the RFC 1035 restriction on label length
	                            // also applies to RFC 5321 domains.
	                            //
	                            // http://tools.ietf.org/html/rfc1035#section-2.3.4
	                            // labels          63 octets or less
	
	                            updateResult(internals.diagnoses.rfc5322LabelTooLong);
	                        }
	
	                        // CFWS is OK again now we're at the beginning of an element (although
	                        // it may be obsolete CFWS)
	                        assertEnd = false;
	                        elementLength = 0;
	                        ++elementCount;
	                        atomData.domains[elementCount] = '';
	                        parseData.domain += token;
	
	                        break;
	
	                    // Domain literal
	                    case '[':
	                        if (parseData.domain.length === 0) {
	                            // Domain literal must be the only component
	                            assertEnd = true;
	                            ++elementLength;
	                            context.stack.push(context.now);
	                            context.now = internals.components.literal;
	                            parseData.domain += token;
	                            atomData.domains[elementCount] += token;
	                            parseData.literal = '';
	                        }
	                        else {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errExpectingATEXT);
	                        }
	
	                        break;
	
	                    // Folding white space
	                    case '\r':
	                        if (emailLength === ++i || email[i] !== '\n') {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errCRNoLF);
	                            break;
	                        }
	
	                        // Fallthrough
	
	                    case ' ':
	                    case '\t':
	                        if (elementLength === 0) {
	                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedFWS);
	                        }
	                        else {
	                            // We can't start FWS in the middle of an element, so this better be the end
	                            updateResult(internals.diagnoses.cfwsFWS);
	                            assertEnd = true;
	                        }
	
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextFWS;
	                        prevToken = token;
	                        break;
	
	                    // This must be ATEXT
	                    default:
	                        // RFC 5322 allows any atext...
	                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
	                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
	                        //            "!" / "#" /     ;  characters not including
	                        //            "$" / "%" /     ;  specials.  Used for atoms.
	                        //            "&" / "'" /
	                        //            "*" / "+" /
	                        //            "-" / "/" /
	                        //            "=" / "?" /
	                        //            "^" / "_" /
	                        //            "`" / "{" /
	                        //            "|" / "}" /
	                        //            "~"
	
	                        // But RFC 5321 only allows letter-digit-hyphen to comply with DNS rules
	                        //   (RFCs 1034 & 1123)
	                        // http://tools.ietf.org/html/rfc5321#section-4.1.2
	                        //   sub-domain     = Let-dig [Ldh-str]
	                        //
	                        //   Let-dig        = ALPHA / DIGIT
	                        //
	                        //   Ldh-str        = *( ALPHA / DIGIT / "-" ) Let-dig
	                        //
	                        if (assertEnd) {
	                            // We have encountered ATEXT where it is no longer valid
	                            switch (context.prev) {
	                                case internals.components.contextComment:
	                                case internals.components.contextFWS:
	                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
	                                    break;
	
	                                case internals.components.literal:
	                                    updateResult(internals.diagnoses.errATEXTAfterDomainLiteral);
	                                    break;
	
	                                // $lab:coverage:off$
	                                default:
	                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
	                                // $lab:coverage:on$
	                            }
	                        }
	
	                        charCode = token.charCodeAt(0);
	                        // Assume this token isn't a hyphen unless we discover it is
	                        hyphenFlag = false;
	
	                        if (charCode < 33 || charCode > 126 || specialsLookup(charCode)) {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errExpectingATEXT);
	                        }
	                        else if (token === '-') {
	                            if (elementLength === 0) {
	                                // Hyphens cannot be at the beginning of a subdomain, fatal error
	                                updateResult(internals.diagnoses.errDomainHyphenStart);
	                            }
	
	                            hyphenFlag = true;
	                        }
	                        // Check if it's a neither a number nor a latin letter
	                        else if (charCode < 48 || charCode > 122 || (charCode > 57 && charCode < 65) || (charCode > 90 && charCode < 97)) {
	                            // This is not an RFC 5321 subdomain, but still OK by RFC 5322
	                            updateResult(internals.diagnoses.rfc5322Domain);
	                        }
	
	                        parseData.domain += token;
	                        atomData.domains[elementCount] += token;
	                        ++elementLength;
	                }
	
	                break;
	
	            // Domain literal
	            case internals.components.literal:
	                // http://tools.ietf.org/html/rfc5322#section-3.4.1
	                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
	                //
	                //   dtext           =   %d33-90 /          ; Printable US-ASCII
	                //                       %d94-126 /         ;  characters not including
	                //                       obs-dtext          ;  "[", "]", or "\"
	                //
	                //   obs-dtext       =   obs-NO-WS-CTL / quoted-pair
	                switch (token) {
	                    // End of domain literal
	                    case ']':
	                        if (maxResult < internals.categories.deprecated) {
	                            // Could be a valid RFC 5321 address literal, so let's check
	
	                            // http://tools.ietf.org/html/rfc5321#section-4.1.2
	                            //   address-literal  = "[" ( IPv4-address-literal /
	                            //                    IPv6-address-literal /
	                            //                    General-address-literal ) "]"
	                            //                    ; See Section 4.1.3
	                            //
	                            // http://tools.ietf.org/html/rfc5321#section-4.1.3
	                            //   IPv4-address-literal  = Snum 3("."  Snum)
	                            //
	                            //   IPv6-address-literal  = "IPv6:" IPv6-addr
	                            //
	                            //   General-address-literal  = Standardized-tag ":" 1*dcontent
	                            //
	                            //   Standardized-tag  = Ldh-str
	                            //                     ; Standardized-tag MUST be specified in a
	                            //                     ; Standards-Track RFC and registered with IANA
	                            //
	                            //   dcontent      = %d33-90 / ; Printable US-ASCII
	                            //                 %d94-126 ; excl. "[", "\", "]"
	                            //
	                            //   Snum          = 1*3DIGIT
	                            //                 ; representing a decimal integer
	                            //                 ; value in the range 0 through 255
	                            //
	                            //   IPv6-addr     = IPv6-full / IPv6-comp / IPv6v4-full / IPv6v4-comp
	                            //
	                            //   IPv6-hex      = 1*4HEXDIG
	                            //
	                            //   IPv6-full     = IPv6-hex 7(":" IPv6-hex)
	                            //
	                            //   IPv6-comp     = [IPv6-hex *5(":" IPv6-hex)] "::"
	                            //                 [IPv6-hex *5(":" IPv6-hex)]
	                            //                 ; The "::" represents at least 2 16-bit groups of
	                            //                 ; zeros.  No more than 6 groups in addition to the
	                            //                 ; "::" may be present.
	                            //
	                            //   IPv6v4-full   = IPv6-hex 5(":" IPv6-hex) ":" IPv4-address-literal
	                            //
	                            //   IPv6v4-comp   = [IPv6-hex *3(":" IPv6-hex)] "::"
	                            //                 [IPv6-hex *3(":" IPv6-hex) ":"]
	                            //                 IPv4-address-literal
	                            //                 ; The "::" represents at least 2 16-bit groups of
	                            //                 ; zeros.  No more than 4 groups in addition to the
	                            //                 ; "::" and IPv4-address-literal may be present.
	
	                            var index = -1;
	                            var addressLiteral = parseData.literal;
	                            var matchesIP = IPv4_REGEX.exec(addressLiteral);
	
	                            // Maybe extract IPv4 part from the end of the address-literal
	                            if (matchesIP) {
	                                index = matchesIP.index;
	                                if (index !== 0) {
	                                    // Convert IPv4 part to IPv6 format for futher testing
	                                    addressLiteral = addressLiteral.slice(0, index) + '0:0';
	                                }
	                            }
	
	                            if (index === 0) {
	                                // Nothing there except a valid IPv4 address, so...
	                                updateResult(internals.diagnoses.rfc5321AddressLiteral);
	                            }
	                            else if (addressLiteral.slice(0, 5).toLowerCase() !== 'ipv6:') {
	                                updateResult(internals.diagnoses.rfc5322DomainLiteral);
	                            }
	                            else {
	                                var match = addressLiteral.slice(5);
	                                var maxGroups = internals.maxIPv6Groups;
	                                var groups = match.split(':');
	                                index = match.indexOf('::');
	
	                                if (!~index) {
	                                    // Need exactly the right number of groups
	                                    if (groups.length !== maxGroups) {
	                                        updateResult(internals.diagnoses.rfc5322IPv6GroupCount);
	                                    }
	                                }
	                                else if (index !== match.lastIndexOf('::')) {
	                                    updateResult(internals.diagnoses.rfc5322IPv62x2xColon);
	                                }
	                                else {
	                                    if (index === 0 || index === match.length - 2) {
	                                        // RFC 4291 allows :: at the start or end of an address with 7 other groups in addition
	                                        ++maxGroups;
	                                    }
	
	                                    if (groups.length > maxGroups) {
	                                        updateResult(internals.diagnoses.rfc5322IPv6MaxGroups);
	                                    }
	                                    else if (groups.length === maxGroups) {
	                                        // Eliding a single "::"
	                                        updateResult(internals.diagnoses.deprecatedIPv6);
	                                    }
	                                }
	
	                                // IPv6 testing strategy
	                                if (match[0] === ':' && match[1] !== ':') {
	                                    updateResult(internals.diagnoses.rfc5322IPv6ColonStart);
	                                }
	                                else if (match[match.length - 1] === ':' && match[match.length - 2] !== ':') {
	                                    updateResult(internals.diagnoses.rfc5322IPv6ColonEnd);
	                                }
	                                else if (groups.every(IPv6_REGEX_TEST)) {
	                                    updateResult(internals.diagnoses.rfc5321AddressLiteral);
	                                }
	                                else {
	                                    updateResult(internals.diagnoses.rfc5322IPv6BadCharacter);
	                                }
	                            }
	                        }
	                        else {
	                            updateResult(internals.diagnoses.rfc5322DomainLiteral);
	                        }
	
	                        parseData.domain += token;
	                        atomData.domains[elementCount] += token;
	                        ++elementLength;
	                        context.prev = context.now;
	                        context.now = context.stack.pop();
	                        break;
	
	                    case '\\':
	                        updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextQuotedPair;
	                        break;
	
	                    // Folding white space
	                    case '\r':
	                        if (emailLength === ++i || email[i] !== '\n') {
	                            updateResult(internals.diagnoses.errCRNoLF);
	                            break;
	                        }
	
	                        // Fallthrough
	
	                    case ' ':
	                    case '\t':
	                        updateResult(internals.diagnoses.cfwsFWS);
	
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextFWS;
	                        prevToken = token;
	                        break;
	
	                    // DTEXT
	                    default:
	                        // http://tools.ietf.org/html/rfc5322#section-3.4.1
	                        //   dtext         =   %d33-90 /  ; Printable US-ASCII
	                        //                     %d94-126 / ;  characters not including
	                        //                     obs-dtext  ;  "[", "]", or "\"
	                        //
	                        //   obs-dtext     =   obs-NO-WS-CTL / quoted-pair
	                        //
	                        //   obs-NO-WS-CTL =   %d1-8 /    ; US-ASCII control
	                        //                     %d11 /     ;  characters that do not
	                        //                     %d12 /     ;  include the carriage
	                        //                     %d14-31 /  ;  return, line feed, and
	                        //                     %d127      ;  white space characters
	                        charCode = token.charCodeAt(0);
	
	                        // '\r', '\n', ' ', and '\t' have already been parsed above
	                        if (charCode > 127 || charCode === 0 || token === '[') {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errExpectingDTEXT);
	                            break;
	                        }
	                        else if (charCode < 33 || charCode === 127) {
	                            updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
	                        }
	
	                        parseData.literal += token;
	                        parseData.domain += token;
	                        atomData.domains[elementCount] += token;
	                        ++elementLength;
	                }
	
	                break;
	
	            // Quoted string
	            case internals.components.contextQuotedString:
	                // http://tools.ietf.org/html/rfc5322#section-3.2.4
	                //   quoted-string = [CFWS]
	                //                   DQUOTE *([FWS] qcontent) [FWS] DQUOTE
	                //                   [CFWS]
	                //
	                //   qcontent      = qtext / quoted-pair
	                switch (token) {
	                    // Quoted pair
	                    case '\\':
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextQuotedPair;
	                        break;
	
	                    // Folding white space. Spaces are allowed as regular characters inside a quoted string - it's only FWS if we include '\t' or '\r\n'
	                    case '\r':
	                        if (emailLength === ++i || email[i] !== '\n') {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errCRNoLF);
	                            break;
	                        }
	
	                        // Fallthrough
	
	                    case '\t':
	                        // http://tools.ietf.org/html/rfc5322#section-3.2.2
	                        //   Runs of FWS, comment, or CFWS that occur between lexical tokens in
	                        //   a structured header field are semantically interpreted as a single
	                        //   space character.
	
	                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
	                        //   the CRLF in any FWS/CFWS that appears within the quoted-string [is]
	                        //   semantically "invisible" and therefore not part of the
	                        //   quoted-string
	
	                        parseData.local += ' ';
	                        atomData.locals[elementCount] += ' ';
	                        ++elementLength;
	
	                        updateResult(internals.diagnoses.cfwsFWS);
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextFWS;
	                        prevToken = token;
	                        break;
	
	                    // End of quoted string
	                    case '"':
	                        parseData.local += token;
	                        atomData.locals[elementCount] += token;
	                        ++elementLength;
	                        context.prev = context.now;
	                        context.now = context.stack.pop();
	                        break;
	
	                    // QTEXT
	                    default:
	                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
	                        //   qtext          =   %d33 /             ; Printable US-ASCII
	                        //                      %d35-91 /          ;  characters not including
	                        //                      %d93-126 /         ;  "\" or the quote character
	                        //                      obs-qtext
	                        //
	                        //   obs-qtext      =   obs-NO-WS-CTL
	                        //
	                        //   obs-NO-WS-CTL  =   %d1-8 /            ; US-ASCII control
	                        //                      %d11 /             ;  characters that do not
	                        //                      %d12 /             ;  include the carriage
	                        //                      %d14-31 /          ;  return, line feed, and
	                        //                      %d127              ;  white space characters
	                        charCode = token.charCodeAt(0);
	
	                        if (charCode > 127 || charCode === 0 || charCode === 10) {
	                            updateResult(internals.diagnoses.errExpectingQTEXT);
	                        }
	                        else if (charCode < 32 || charCode === 127) {
	                            updateResult(internals.diagnoses.deprecatedQTEXT);
	                        }
	
	                        parseData.local += token;
	                        atomData.locals[elementCount] += token;
	                        ++elementLength;
	                }
	
	                // http://tools.ietf.org/html/rfc5322#section-3.4.1
	                //   If the string can be represented as a dot-atom (that is, it contains
	                //   no characters other than atext characters or "." surrounded by atext
	                //   characters), then the dot-atom form SHOULD be used and the quoted-
	                //   string form SHOULD NOT be used.
	
	                break;
	            // Quoted pair
	            case internals.components.contextQuotedPair:
	                // http://tools.ietf.org/html/rfc5322#section-3.2.1
	                //   quoted-pair     =   ("\" (VCHAR / WSP)) / obs-qp
	                //
	                //   VCHAR           =  %d33-126   ; visible (printing) characters
	                //   WSP             =  SP / HTAB  ; white space
	                //
	                //   obs-qp          =   "\" (%d0 / obs-NO-WS-CTL / LF / CR)
	                //
	                //   obs-NO-WS-CTL   =   %d1-8 /   ; US-ASCII control
	                //                       %d11 /    ;  characters that do not
	                //                       %d12 /    ;  include the carriage
	                //                       %d14-31 / ;  return, line feed, and
	                //                       %d127     ;  white space characters
	                //
	                // i.e. obs-qp       =  "\" (%d0-8, %d10-31 / %d127)
	                charCode = token.charCodeAt(0);
	
	                if (charCode > 127) {
	                    // Fatal error
	                    updateResult(internals.diagnoses.errExpectingQPair);
	                }
	                else if ((charCode < 31 && charCode !== 9) || charCode === 127) {
	                    // ' ' and '\t' are allowed
	                    updateResult(internals.diagnoses.deprecatedQP);
	                }
	
	                // At this point we know where this qpair occurred so we could check to see if the character actually needed to be quoted at all.
	                // http://tools.ietf.org/html/rfc5321#section-4.1.2
	                //   the sending system SHOULD transmit the form that uses the minimum quoting possible.
	
	                context.prev = context.now;
	                // End of qpair
	                context.now = context.stack.pop();
	                token = '\\' + token;
	
	                switch (context.now) {
	                    case internals.components.contextComment:
	                        break;
	
	                    case internals.components.contextQuotedString:
	                        parseData.local += token;
	                        atomData.locals[elementCount] += token;
	
	                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
	                        elementLength += 2;
	                        break;
	
	                    case internals.components.literal:
	                        parseData.domain += token;
	                        atomData.domains[elementCount] += token;
	
	                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
	                        elementLength += 2;
	                        break;
	
	                    // $lab:coverage:off$
	                    default:
	                        throw new Error('quoted pair logic invoked in an invalid context: ' + context.now);
	                    // $lab:coverage:on$
	                }
	                break;
	
	            // Comment
	            case internals.components.contextComment:
	                // http://tools.ietf.org/html/rfc5322#section-3.2.2
	                //   comment  = "(" *([FWS] ccontent) [FWS] ")"
	                //
	                //   ccontent = ctext / quoted-pair / comment
	                switch (token) {
	                    // Nested comment
	                    case '(':
	                        // Nested comments are ok
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextComment;
	                        break;
	
	                    // End of comment
	                    case ')':
	                        context.prev = context.now;
	                        context.now = context.stack.pop();
	                        break;
	
	                    // Quoted pair
	                    case '\\':
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextQuotedPair;
	                        break;
	
	                    // Folding white space
	                    case '\r':
	                        if (emailLength === ++i || email[i] !== '\n') {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errCRNoLF);
	                            break;
	                        }
	
	                        // Fallthrough
	
	                    case ' ':
	                    case '\t':
	                        updateResult(internals.diagnoses.cfwsFWS);
	
	                        context.stack.push(context.now);
	                        context.now = internals.components.contextFWS;
	                        prevToken = token;
	                        break;
	
	                    // CTEXT
	                    default:
	                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
	                        //   ctext         = %d33-39 /  ; Printable US-ASCII
	                        //                   %d42-91 /  ;  characters not including
	                        //                   %d93-126 / ;  "(", ")", or "\"
	                        //                   obs-ctext
	                        //
	                        //   obs-ctext     = obs-NO-WS-CTL
	                        //
	                        //   obs-NO-WS-CTL = %d1-8 /    ; US-ASCII control
	                        //                   %d11 /     ;  characters that do not
	                        //                   %d12 /     ;  include the carriage
	                        //                   %d14-31 /  ;  return, line feed, and
	                        //                   %d127      ;  white space characters
	                        charCode = token.charCodeAt(0);
	
	                        if (charCode > 127 || charCode === 0 || charCode === 10) {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errExpectingCTEXT);
	                            break;
	                        }
	                        else if (charCode < 32 || charCode === 127) {
	                            updateResult(internals.diagnoses.deprecatedCTEXT);
	                        }
	                }
	
	                break;
	
	            // Folding white space
	            case internals.components.contextFWS:
	                // http://tools.ietf.org/html/rfc5322#section-3.2.2
	                //   FWS     =   ([*WSP CRLF] 1*WSP) /  obs-FWS
	                //                                   ; Folding white space
	
	                // But note the erratum:
	                // http://www.rfc-editor.org/errata_search.php?rfc=5322&eid=1908:
	                //   In the obsolete syntax, any amount of folding white space MAY be
	                //   inserted where the obs-FWS rule is allowed.  This creates the
	                //   possibility of having two consecutive "folds" in a line, and
	                //   therefore the possibility that a line which makes up a folded header
	                //   field could be composed entirely of white space.
	                //
	                //   obs-FWS =   1*([CRLF] WSP)
	
	                if (prevToken === '\r') {
	                    if (token === '\r') {
	                        // Fatal error
	                        updateResult(internals.diagnoses.errFWSCRLFx2);
	                        break;
	                    }
	
	                    if (++crlfCount > 1) {
	                        // Multiple folds => obsolete FWS
	                        updateResult(internals.diagnoses.deprecatedFWS);
	                    }
	                    else {
	                        crlfCount = 1;
	                    }
	                }
	
	                switch (token) {
	                    case '\r':
	                        if (emailLength === ++i || email[i] !== '\n') {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errCRNoLF);
	                        }
	
	                        break;
	
	                    case ' ':
	                    case '\t':
	                        break;
	
	                    default:
	                        if (prevToken === '\r') {
	                            // Fatal error
	                            updateResult(internals.diagnoses.errFWSCRLFEnd);
	                        }
	
	                        crlfCount = 0;
	
	                        // End of FWS
	                        context.prev = context.now;
	                        context.now = context.stack.pop();
	
	                        // Look at this token again in the parent context
	                        --i;
	                }
	
	                prevToken = token;
	                break;
	
	            // Unexpected context
	            // $lab:coverage:off$
	            default:
	                throw new Error('unknown context: ' + context.now);
	            // $lab:coverage:on$
	        } // Primary state machine
	
	        if (maxResult > internals.categories.rfc5322) {
	            // Fatal error, no point continuing
	            break;
	        }
	    } // Token loop
	
	    // Check for errors
	    if (maxResult < internals.categories.rfc5322) {
	        // Fatal errors
	        if (context.now === internals.components.contextQuotedString) {
	            updateResult(internals.diagnoses.errUnclosedQuotedString);
	        }
	        else if (context.now === internals.components.contextQuotedPair) {
	            updateResult(internals.diagnoses.errBackslashEnd);
	        }
	        else if (context.now === internals.components.contextComment) {
	            updateResult(internals.diagnoses.errUnclosedComment);
	        }
	        else if (context.now === internals.components.literal) {
	            updateResult(internals.diagnoses.errUnclosedDomainLiteral);
	        }
	        else if (token === '\r') {
	            updateResult(internals.diagnoses.errFWSCRLFEnd);
	        }
	        else if (parseData.domain.length === 0) {
	            updateResult(internals.diagnoses.errNoDomain);
	        }
	        else if (elementLength === 0) {
	            updateResult(internals.diagnoses.errDotEnd);
	        }
	        else if (hyphenFlag) {
	            updateResult(internals.diagnoses.errDomainHyphenEnd);
	        }
	
	        // Other errors
	        else if (parseData.domain.length > 255) {
	            // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.2
	            //   The maximum total length of a domain name or number is 255 octets.
	            updateResult(internals.diagnoses.rfc5322DomainTooLong);
	        }
	        else if (parseData.local.length + parseData.domain.length + /* '@' */ 1 > 254) {
	            // http://tools.ietf.org/html/rfc5321#section-4.1.2
	            //   Forward-path   = Path
	            //
	            //   Path           = "<" [ A-d-l ":" ] Mailbox ">"
	            //
	            // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.3
	            //   The maximum total length of a reverse-path or forward-path is 256 octets (including the punctuation and element separators).
	            //
	            // Thus, even without (obsolete) routing information, the Mailbox can only be 254 characters long. This is confirmed by this verified
	            // erratum to RFC 3696:
	            //
	            // http://www.rfc-editor.org/errata_search.php?rfc=3696&eid=1690
	            //   However, there is a restriction in RFC 2821 on the length of an address in MAIL and RCPT commands of 254 characters.  Since
	            //   addresses that do not fit in those fields are not normally useful, the upper limit on address lengths should normally be considered
	            //   to be 254.
	            updateResult(internals.diagnoses.rfc5322TooLong);
	        }
	        else if (elementLength > 63) {
	            // http://tools.ietf.org/html/rfc1035#section-2.3.4
	            // labels   63 octets or less
	            updateResult(internals.diagnoses.rfc5322LabelTooLong);
	        }
	        else if (options.minDomainAtoms && atomData.domains.length < options.minDomainAtoms) {
	            updateResult(internals.diagnoses.errDomainTooShort);
	        }
	        else if (options.tldWhitelist) {
	            var tldAtom = atomData.domains[elementCount];
	            if (Array.isArray(options.tldWhitelist)) {
	                var tldValid = false;
	                for (i = 0, il = options.tldWhitelist.length; i < il; ++i) {
	                    if (tldAtom === options.tldWhitelist[i]) {
	                        tldValid = true;
	                        break;
	                    }
	                }
	
	                if (!tldValid) {
	                    updateResult(internals.diagnoses.errUnknownTLD);
	                }
	            }
	            else if (!hasOwn.call(options.tldWhitelist, tldAtom)) {
	                updateResult(internals.diagnoses.errUnknownTLD);
	            }
	        }
	    } // Check for errors
	
	    var dnsPositive = false;
	    var finishImmediately = false;
	
	    var finish = function finish () {
	
	        if (!dnsPositive && maxResult < internals.categories.dnsWarn) {
	            // Per RFC 5321, domain atoms are limited to letter-digit-hyphen, so we only need to check code <= 57 to check for a digit
	            var code = atomData.domains[elementCount].charCodeAt(0);
	            if (code <= 57) {
	                updateResult(internals.diagnoses.rfc5321TLDNumeric);
	            }
	            else if (elementCount === 0) {
	                updateResult(internals.diagnoses.rfc5321TLD);
	            }
	        }
	
	        if (maxResult < threshold) {
	            maxResult = internals.diagnoses.valid;
	        }
	
	        var finishResult = diagnose ? maxResult : maxResult < internals.defaultThreshold;
	
	        if (callback) {
	            if (finishImmediately) {
	                callback(finishResult);
	            } else {
	                internals.defer(callback.bind(null, finishResult));
	            }
	        }
	
	        return finishResult;
	    }; // Finish
	
	    if (options.checkDNS && maxResult < internals.categories.dnsWarn) {
	        // http://tools.ietf.org/html/rfc5321#section-2.3.5
	        //   Names that can be resolved to MX RRs or address (i.e., A or AAAA) RRs (as discussed in Section 5) are permitted, as are CNAME RRs whose
	        //   targets can be resolved, in turn, to MX or address RRs.
	        //
	        // http://tools.ietf.org/html/rfc5321#section-5.1
	        //   The lookup first attempts to locate an MX record associated with the name.  If a CNAME record is found, the resulting name is processed
	        //   as if it were the initial name. ... If an empty list of MXs is returned, the address is treated as if it was associated with an implicit
	        //   MX RR, with a preference of 0, pointing to that host.
	        //
	        // isEmail() author's note: We will regard the existence of a CNAME to be sufficient evidence of the domain's existence. For performance
	        // reasons we will not repeat the DNS lookup for the CNAME's target, but we will raise a warning because we didn't immediately find an MX
	        // record.
	        if (elementCount === 0) {
	            // Checking TLD DNS only works if you explicitly check from the root
	            parseData.domain += '.';
	        }
	
	        var dnsDomain = parseData.domain;
	        Dns.resolveMx(dnsDomain, function resolveDNS (err, mxRecords) {
	
	            // If we have a fatal error, then we must assume that there are no records
	            if (err && err.code !== Dns.NODATA) {
	                updateResult(internals.diagnoses.dnsWarnNoRecord);
	                return finish();
	            }
	
	            if (mxRecords && mxRecords.length) {
	                dnsPositive = true;
	                return finish();
	            }
	
	            var count = 3;
	            var done = false;
	            updateResult(internals.diagnoses.dnsWarnNoMXRecord);
	
	            var handleRecords = function handleRecords (err, records) {
	
	                if (done) {
	                    return;
	                }
	
	                --count;
	
	                if (records && records.length) {
	                    done = true;
	                    return finish();
	                }
	
	                if (count === 0) {
	                    // No usable records for the domain can be found
	                    updateResult(internals.diagnoses.dnsWarnNoRecord);
	                    done = true;
	                    finish();
	                }
	            };
	
	            Dns.resolveCname(dnsDomain, handleRecords);
	            Dns.resolve4(dnsDomain, handleRecords);
	            Dns.resolve6(dnsDomain, handleRecords);
	        });
	
	        finishImmediately = true;
	    }
	    else {
	        var result = finish();
	        finishImmediately = true;
	        return result;
	    } // CheckDNS
	};
	
	
	isEmail.diagnoses = (function exportDiagnoses () {
	
	    var diag = {};
	    for (var key in internals.diagnoses) {
	        diag[key] = internals.diagnoses[key];
	    }
	    return diag;
	})();
	
	module.exports = isEmail;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 899 */
/***/ function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Any = __webpack_require__(43);
	var Cast = __webpack_require__(106);
	var Errors = __webpack_require__(47);
	var Hoek = __webpack_require__(32);
	
	
	// Declare internals
	
	var internals = {};
	
	
	internals.fastSplice = function (arr, i) {
	
	    var il = arr.length;
	    var pos = i;
	
	    while (pos < il) {
	        arr[pos++] = arr[pos];
	    }
	
	    --arr.length;
	};
	
	
	internals.Array = function () {
	
	    Any.call(this);
	    this._type = 'array';
	    this._inner.items = [];
	    this._inner.ordereds = [];
	    this._inner.inclusions = [];
	    this._inner.exclusions = [];
	    this._inner.requireds = [];
	    this._flags.sparse = false;
	};
	
	Hoek.inherits(internals.Array, Any);
	
	
	internals.Array.prototype._base = function (value, state, options) {
	
	    var result = {
	        value: value
	    };
	
	    if (typeof value === 'string' &&
	        options.convert) {
	
	        try {
	            var converted = JSON.parse(value);
	            if (Array.isArray(converted)) {
	                result.value = converted;
	            }
	        }
	        catch (e) { }
	    }
	
	    var isArray = Array.isArray(result.value);
	    var wasArray = isArray;
	    if (options.convert && this._flags.single && !isArray) {
	        result.value = [result.value];
	        isArray = true;
	    }
	
	    if (!isArray) {
	        result.errors = Errors.create('array.base', null, state, options);
	        return result;
	    }
	
	    if (this._inner.inclusions.length ||
	        this._inner.exclusions.length ||
	        !this._flags.sparse) {
	
	        // Clone the array so that we don't modify the original
	        if (wasArray) {
	            result.value = result.value.slice(0);
	        }
	
	        result.errors = internals.checkItems.call(this, result.value, wasArray, state, options);
	
	        if (result.errors && wasArray && options.convert && this._flags.single) {
	
	            // Attempt a 2nd pass by putting the array inside one.
	            var previousErrors = result.errors;
	
	            result.value = [result.value];
	            result.errors = internals.checkItems.call(this, result.value, wasArray, state, options);
	
	            if (result.errors) {
	
	                // Restore previous errors and value since this didn't validate either.
	                result.errors = previousErrors;
	                result.value = result.value[0];
	            }
	        }
	    }
	
	    return result;
	};
	
	
	internals.checkItems = function (items, wasArray, state, options) {
	
	    var errors = [];
	    var errored;
	
	    var requireds = this._inner.requireds.slice();
	    var ordereds = this._inner.ordereds.slice();
	    var inclusions = this._inner.inclusions.concat(requireds);
	
	    for (var v = 0, vl = items.length; v < vl; ++v) {
	        errored = false;
	        var item = items[v];
	        var isValid = false;
	        var localState = { key: v, path: (state.path ? state.path + '.' : '') + v, parent: items, reference: state.reference };
	        var res;
	
	        // Sparse
	
	        if (!this._flags.sparse && item === undefined) {
	            errors.push(Errors.create('array.sparse', null, { key: state.key, path: localState.path }, options));
	
	            if (options.abortEarly) {
	                return errors;
	            }
	
	            continue;
	        }
	
	        // Exclusions
	
	        for (var i = 0, il = this._inner.exclusions.length; i < il; ++i) {
	            res = this._inner.exclusions[i]._validate(item, localState, {});                // Not passing options to use defaults
	
	            if (!res.errors) {
	                errors.push(Errors.create(wasArray ? 'array.excludes' : 'array.excludesSingle', { pos: v, value: item }, { key: state.key, path: localState.path }, options));
	                errored = true;
	
	                if (options.abortEarly) {
	                    return errors;
	                }
	
	                break;
	            }
	        }
	
	        if (errored) {
	            continue;
	        }
	
	        // Ordered
	        if (this._inner.ordereds.length) {
	            if (ordereds.length > 0) {
	                var ordered = ordereds.shift();
	                res = ordered._validate(item, localState, options);
	                if (!res.errors) {
	                    if (ordered._flags.strip) {
	                        internals.fastSplice(items, v);
	                        --v;
	                        --vl;
	                    }
	                    else {
	                        items[v] = res.value;
	                    }
	                }
	                else {
	                    errors.push(Errors.create('array.ordered', { pos: v, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
	                    if (options.abortEarly) {
	                        return errors;
	                    }
	                }
	                continue;
	            }
	            else if (!this._inner.items.length) {
	                errors.push(Errors.create('array.orderedLength', { pos: v, limit: this._inner.ordereds.length }, { key: state.key, path: localState.path }, options));
	                if (options.abortEarly) {
	                    return errors;
	                }
	                continue;
	            }
	        }
	
	        // Requireds
	
	        var requiredChecks = [];
	        for (i = 0, il = requireds.length; i < il; ++i) {
	            res = requiredChecks[i] = requireds[i]._validate(item, localState, options);
	            if (!res.errors) {
	                items[v] = res.value;
	                isValid = true;
	                internals.fastSplice(requireds, i);
	                --i;
	                --il;
	                break;
	            }
	        }
	
	        if (isValid) {
	            continue;
	        }
	
	        // Inclusions
	
	        for (i = 0, il = inclusions.length; i < il; ++i) {
	            var inclusion = inclusions[i];
	
	            // Avoid re-running requireds that already didn't match in the previous loop
	            var previousCheck = requireds.indexOf(inclusion);
	            if (previousCheck !== -1) {
	                res = requiredChecks[previousCheck];
	            }
	            else {
	                res = inclusion._validate(item, localState, options);
	
	                if (!res.errors) {
	                    if (inclusion._flags.strip) {
	                        internals.fastSplice(items, v);
	                        --v;
	                        --vl;
	                    }
	                    else {
	                        items[v] = res.value;
	                    }
	                    isValid = true;
	                    break;
	                }
	            }
	
	            // Return the actual error if only one inclusion defined
	            if (il === 1) {
	                if (options.stripUnknown) {
	                    internals.fastSplice(items, v);
	                    --v;
	                    --vl;
	                    isValid = true;
	                    break;
	                }
	
	                errors.push(Errors.create(wasArray ? 'array.includesOne' : 'array.includesOneSingle', { pos: v, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
	                errored = true;
	
	                if (options.abortEarly) {
	                    return errors;
	                }
	
	                break;
	            }
	        }
	
	        if (errored) {
	            continue;
	        }
	
	        if (this._inner.inclusions.length && !isValid) {
	            if (options.stripUnknown) {
	                internals.fastSplice(items, v);
	                --v;
	                --vl;
	                continue;
	            }
	
	            errors.push(Errors.create(wasArray ? 'array.includes' : 'array.includesSingle', { pos: v, value: item }, { key: state.key, path: localState.path }, options));
	
	            if (options.abortEarly) {
	                return errors;
	            }
	        }
	    }
	
	    if (requireds.length) {
	        internals.fillMissedErrors(errors, requireds, state, options);
	    }
	
	    if (ordereds.length) {
	        internals.fillOrderedErrors(errors, ordereds, state, options);
	    }
	
	    return errors.length ? errors : null;
	};
	
	internals.fillMissedErrors = function (errors, requireds, state, options) {
	
	    var knownMisses = [];
	    var unknownMisses = 0;
	    for (var i = 0, il = requireds.length; i < il; ++i) {
	        var label = Hoek.reach(requireds[i], '_settings.language.label');
	        if (label) {
	            knownMisses.push(label);
	        }
	        else {
	            ++unknownMisses;
	        }
	    }
	
	    if (knownMisses.length) {
	        if (unknownMisses) {
	            errors.push(Errors.create('array.includesRequiredBoth', { knownMisses: knownMisses, unknownMisses: unknownMisses }, { key: state.key, path: state.patk }, options));
	        }
	        else {
	            errors.push(Errors.create('array.includesRequiredKnowns', { knownMisses: knownMisses }, { key: state.key, path: state.path }, options));
	        }
	    }
	    else {
	        errors.push(Errors.create('array.includesRequiredUnknowns', { unknownMisses: unknownMisses }, { key: state.key, path: state.path }, options));
	    }
	};
	
	internals.fillOrderedErrors = function (errors, ordereds, state, options) {
	
	    var requiredOrdereds = [];
	
	    for (var i = 0, il = ordereds.length; i < il; ++i) {
	        var presence = Hoek.reach(ordereds[i], '_flags.presence');
	        if (presence === 'required') {
	            requiredOrdereds.push(ordereds[i]);
	        }
	    }
	
	    if (requiredOrdereds.length) {
	        internals.fillMissedErrors(errors, requiredOrdereds, state, options);
	    }
	};
	
	internals.Array.prototype.describe = function () {
	
	    var description = Any.prototype.describe.call(this);
	
	    if (this._inner.ordereds.length) {
	        description.orderedItems = [];
	
	        for (var o = 0, ol = this._inner.ordereds.length; o < ol; ++o) {
	            description.orderedItems.push(this._inner.ordereds[o].describe());
	        }
	    }
	
	    if (this._inner.items.length) {
	        description.items = [];
	
	        for (var i = 0, il = this._inner.items.length; i < il; ++i) {
	            description.items.push(this._inner.items[i].describe());
	        }
	    }
	
	    return description;
	};
	
	
	internals.Array.prototype.items = function () {
	
	    var obj = this.clone();
	
	    Hoek.flatten(Array.prototype.slice.call(arguments)).forEach(function (type, index) {
	
	        try {
	            type = Cast.schema(type);
	        }
	        catch (castErr) {
	            if (castErr.hasOwnProperty('path')) {
	                castErr.path = index + '.' + castErr.path;
	            }
	            else {
	                castErr.path = index;
	            }
	            castErr.message += '(' + castErr.path + ')';
	            throw castErr;
	        }
	
	        obj._inner.items.push(type);
	
	        if (type._flags.presence === 'required') {
	            obj._inner.requireds.push(type);
	        }
	        else if (type._flags.presence === 'forbidden') {
	            obj._inner.exclusions.push(type.optional());
	        }
	        else {
	            obj._inner.inclusions.push(type);
	        }
	    });
	
	    return obj;
	};
	
	
	internals.Array.prototype.ordered = function () {
	
	    var obj = this.clone();
	
	    Hoek.flatten(Array.prototype.slice.call(arguments)).forEach(function (type, index) {
	
	        try {
	            type = Cast.schema(type);
	        }
	        catch (castErr) {
	            if (castErr.hasOwnProperty('path')) {
	                castErr.path = index + '.' + castErr.path;
	            }
	            else {
	                castErr.path = index;
	            }
	            castErr.message += '(' + castErr.path + ')';
	            throw castErr;
	        }
	        obj._inner.ordereds.push(type);
	    });
	
	    return obj;
	};
	
	
	internals.Array.prototype.min = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('min', limit, function (value, state, options) {
	
	        if (value.length >= limit) {
	            return null;
	        }
	
	        return Errors.create('array.min', { limit: limit, value: value }, state, options);
	    });
	};
	
	
	internals.Array.prototype.max = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('max', limit, function (value, state, options) {
	
	        if (value.length <= limit) {
	            return null;
	        }
	
	        return Errors.create('array.max', { limit: limit, value: value }, state, options);
	    });
	};
	
	
	internals.Array.prototype.length = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('length', limit, function (value, state, options) {
	
	        if (value.length === limit) {
	            return null;
	        }
	
	        return Errors.create('array.length', { limit: limit, value: value }, state, options);
	    });
	};
	
	
	internals.Array.prototype.unique = function () {
	
	    return this._test('unique', undefined, function (value, state, options) {
	
	        var found = {
	            string: {},
	            number: {},
	            undefined: {},
	            boolean: {},
	            object: [],
	            function: []
	        };
	
	        for (var i = 0, il = value.length; i < il; ++i) {
	            var item = value[i];
	            var type = typeof item;
	            var records = found[type];
	
	            // All available types are supported, so it's not possible to reach 100% coverage without ignoring this line.
	            // I still want to keep the test for future js versions with new types (eg. Symbol).
	            if (/* $lab:coverage:off$ */ records /* $lab:coverage:on$ */) {
	                if (Array.isArray(records)) {
	                    for (var r = 0, rl = records.length; r < rl; ++r) {
	                        if (Hoek.deepEqual(records[r], item)) {
	                            return Errors.create('array.unique', { pos: i, value: item }, state, options);
	                        }
	                    }
	
	                    records.push(item);
	                }
	                else {
	                    if (records[item]) {
	                        return Errors.create('array.unique', { pos: i, value: item }, state, options);
	                    }
	
	                    records[item] = true;
	                }
	            }
	        }
	    });
	};
	
	
	internals.Array.prototype.sparse = function (enabled) {
	
	    var obj = this.clone();
	    obj._flags.sparse = enabled === undefined ? true : !!enabled;
	    return obj;
	};
	
	
	internals.Array.prototype.single = function (enabled) {
	
	    var obj = this.clone();
	    obj._flags.single = enabled === undefined ? true : !!enabled;
	    return obj;
	};
	
	
	module.exports = new internals.Array();


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Load modules
	
	var Any = __webpack_require__(43);
	var Errors = __webpack_require__(47);
	var Hoek = __webpack_require__(32);
	
	
	// Declare internals
	
	var internals = {};
	
	
	internals.Binary = function () {
	
	    Any.call(this);
	    this._type = 'binary';
	};
	
	Hoek.inherits(internals.Binary, Any);
	
	
	internals.Binary.prototype._base = function (value, state, options) {
	
	    var result = {
	        value: value
	    };
	
	    if (typeof value === 'string' &&
	        options.convert) {
	
	        try {
	            var converted = new Buffer(value, this._flags.encoding);
	            result.value = converted;
	        }
	        catch (e) { }
	    }
	
	    result.errors = Buffer.isBuffer(result.value) ? null : Errors.create('binary.base', null, state, options);
	    return result;
	};
	
	
	internals.Binary.prototype.encoding = function (encoding) {
	
	    Hoek.assert(Buffer.isEncoding(encoding), 'Invalid encoding:', encoding);
	
	    var obj = this.clone();
	    obj._flags.encoding = encoding;
	    return obj;
	};
	
	
	internals.Binary.prototype.min = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('min', limit, function (value, state, options) {
	
	        if (value.length >= limit) {
	            return null;
	        }
	
	        return Errors.create('binary.min', { limit: limit, value: value }, state, options);
	    });
	};
	
	
	internals.Binary.prototype.max = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('max', limit, function (value, state, options) {
	
	        if (value.length <= limit) {
	            return null;
	        }
	
	        return Errors.create('binary.max', { limit: limit, value: value }, state, options);
	    });
	};
	
	
	internals.Binary.prototype.length = function (limit) {
	
	    Hoek.assert(Hoek.isInteger(limit) && limit >= 0, 'limit must be a positive integer');
	
	    return this._test('length', limit, function (value, state, options) {
	
	        if (value.length === limit) {
	            return null;
	        }
	
	        return Errors.create('binary.length', { limit: limit, value: value }, state, options);
	    });
	};
	
	
	module.exports = new internals.Binary();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Any = __webpack_require__(43);
	var Cast = __webpack_require__(106);
	var Ref = __webpack_require__(66);
	
	
	// Declare internals
	
	var internals = {
	    alternatives: __webpack_require__(193),
	    array: __webpack_require__(900),
	    boolean: __webpack_require__(325),
	    binary: __webpack_require__(901),
	    date: __webpack_require__(194),
	    number: __webpack_require__(326),
	    object: __webpack_require__(327),
	    string: __webpack_require__(328)
	};
	
	
	internals.root = function () {
	
	    var any = new Any();
	
	    var root = any.clone();
	    root.any = function () {
	
	        return any;
	    };
	
	    root.alternatives = root.alt = function () {
	
	        return arguments.length ? internals.alternatives.try.apply(internals.alternatives, arguments) : internals.alternatives;
	    };
	
	    root.array = function () {
	
	        return internals.array;
	    };
	
	    root.boolean = root.bool = function () {
	
	        return internals.boolean;
	    };
	
	    root.binary = function () {
	
	        return internals.binary;
	    };
	
	    root.date = function () {
	
	        return internals.date;
	    };
	
	    root.func = function () {
	
	        return internals.object._func();
	    };
	
	    root.number = function () {
	
	        return internals.number;
	    };
	
	    root.object = function () {
	
	        return arguments.length ? internals.object.keys.apply(internals.object, arguments) : internals.object;
	    };
	
	    root.string = function () {
	
	        return internals.string;
	    };
	
	    root.ref = function () {
	
	        return Ref.create.apply(null, arguments);
	    };
	
	    root.isRef = function (ref) {
	
	        return Ref.isRef(ref);
	    };
	
	    root.validate = function (value /*, [schema], [options], callback */) {
	
	        var last = arguments[arguments.length - 1];
	        var callback = typeof last === 'function' ? last : null;
	
	        var count = arguments.length - (callback ? 1 : 0);
	        if (count === 1) {
	            return any.validate(value, callback);
	        }
	
	        var options = count === 3 ? arguments[2] : {};
	        var schema = root.compile(arguments[1]);
	
	        return schema._validateWithOptions(value, options, callback);
	    };
	
	    root.describe = function () {
	
	        var schema = arguments.length ? root.compile(arguments[0]) : any;
	        return schema.describe();
	    };
	
	    root.compile = function (schema) {
	
	        try {
	            return Cast.schema(schema);
	        }
	        catch (err) {
	            if (err.hasOwnProperty('path')) {
	                err.message += '(' + err.path + ')';
	            }
	            throw err;
	        }
	    };
	
	    root.assert = function (value, schema, message) {
	
	        root.attempt(value, schema, message);
	    };
	
	    root.attempt = function (value, schema, message) {
	
	        var result = root.validate(value, schema);
	        var error = result.error;
	        if (error) {
	            if (!message) {
	                error.message = error.annotate();
	                throw error;
	            }
	
	            if (!(message instanceof Error)) {
	                error.message = message + ' ' + error.annotate();
	                throw error;
	            }
	
	            throw message;
	        }
	
	        return result.value;
	    };
	
	    return root;
	};
	
	
	module.exports = internals.root();


/***/ },
/* 903 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.errors = {
	    root: 'value',
	    key: '"{{!key}}" ',
	    messages: {
	        wrapArrays: true
	    },
	    any: {
	        unknown: 'is not allowed',
	        invalid: 'contains an invalid value',
	        empty: 'is not allowed to be empty',
	        required: 'is required',
	        allowOnly: 'must be one of {{valids}}',
	        default: 'threw an error when running default method'
	    },
	    alternatives: {
	        base: 'not matching any of the allowed alternatives'
	    },
	    array: {
	        base: 'must be an array',
	        includes: 'at position {{pos}} does not match any of the allowed types',
	        includesSingle: 'single value of "{{!key}}" does not match any of the allowed types',
	        includesOne: 'at position {{pos}} fails because {{reason}}',
	        includesOneSingle: 'single value of "{{!key}}" fails because {{reason}}',
	        includesRequiredUnknowns: 'does not contain {{unknownMisses}} required value(s)',
	        includesRequiredKnowns: 'does not contain {{knownMisses}}',
	        includesRequiredBoth: 'does not contain {{knownMisses}} and {{unknownMisses}} other required value(s)',
	        excludes: 'at position {{pos}} contains an excluded value',
	        excludesSingle: 'single value of "{{!key}}" contains an excluded value',
	        min: 'must contain at least {{limit}} items',
	        max: 'must contain less than or equal to {{limit}} items',
	        length: 'must contain {{limit}} items',
	        ordered: 'at position {{pos}} fails because {{reason}}',
	        orderedLength: 'at position {{pos}} fails because array must contain at most {{limit}} items',
	        sparse: 'must not be a sparse array',
	        unique: 'position {{pos}} contains a duplicate value'
	    },
	    boolean: {
	        base: 'must be a boolean'
	    },
	    binary: {
	        base: 'must be a buffer or a string',
	        min: 'must be at least {{limit}} bytes',
	        max: 'must be less than or equal to {{limit}} bytes',
	        length: 'must be {{limit}} bytes'
	    },
	    date: {
	        base: 'must be a number of milliseconds or valid date string',
	        min: 'must be larger than or equal to "{{limit}}"',
	        max: 'must be less than or equal to "{{limit}}"',
	        isoDate: 'must be a valid ISO 8601 date',
	        ref: 'references "{{ref}}" which is not a date'
	    },
	    function: {
	        base: 'must be a Function'
	    },
	    object: {
	        base: 'must be an object',
	        child: 'child "{{!key}}" fails because {{reason}}',
	        min: 'must have at least {{limit}} children',
	        max: 'must have less than or equal to {{limit}} children',
	        length: 'must have {{limit}} children',
	        allowUnknown: 'is not allowed',
	        with: 'missing required peer "{{peer}}"',
	        without: 'conflict with forbidden peer "{{peer}}"',
	        missing: 'must contain at least one of {{peers}}',
	        xor: 'contains a conflict between exclusive peers {{peers}}',
	        or: 'must contain at least one of {{peers}}',
	        and: 'contains {{present}} without its required peers {{missing}}',
	        nand: '!!"{{main}}" must not exist simultaneously with {{peers}}',
	        assert: '!!"{{ref}}" validation failed because "{{ref}}" failed to {{message}}',
	        rename: {
	            multiple: 'cannot rename child "{{from}}" because multiple renames are disabled and another key was already renamed to "{{to}}"',
	            override: 'cannot rename child "{{from}}" because override is disabled and target "{{to}}" exists'
	        },
	        type: 'must be an instance of "{{type}}"'
	    },
	    number: {
	        base: 'must be a number',
	        min: 'must be larger than or equal to {{limit}}',
	        max: 'must be less than or equal to {{limit}}',
	        less: 'must be less than {{limit}}',
	        greater: 'must be greater than {{limit}}',
	        float: 'must be a float or double',
	        integer: 'must be an integer',
	        negative: 'must be a negative number',
	        positive: 'must be a positive number',
	        precision: 'must have no more than {{limit}} decimal places',
	        ref: 'references "{{ref}}" which is not a number',
	        multiple: 'must be a multiple of {{multiple}}'
	    },
	    string: {
	        base: 'must be a string',
	        min: 'length must be at least {{limit}} characters long',
	        max: 'length must be less than or equal to {{limit}} characters long',
	        length: 'length must be {{limit}} characters long',
	        alphanum: 'must only contain alpha-numeric characters',
	        token: 'must only contain alpha-numeric and underscore characters',
	        regex: {
	            base: 'with value "{{!value}}" fails to match the required pattern: {{pattern}}',
	            name: 'with value "{{!value}}" fails to match the {{name}} pattern'
	        },
	        email: 'must be a valid email',
	        uri: 'must be a valid uri',
	        uriCustomScheme: 'must be a valid uri with a scheme matching the {{scheme}} pattern',
	        isoDate: 'must be a valid ISO 8601 date',
	        guid: 'must be a valid GUID',
	        hex: 'must only contain hexadecimal characters',
	        hostname: 'must be a valid hostname',
	        lowercase: 'must only contain lowercase characters',
	        uppercase: 'must only contain uppercase characters',
	        trim: 'must not have leading or trailing whitespace',
	        creditCard: 'must be a credit card',
	        ref: 'references "{{ref}}" which is not a number',
	        ip: 'must be a valid ip address with a {{cidr}} CIDR',
	        ipVersion: 'must be a valid ip address of one of the following versions {{version}} with a {{cidr}} CIDR'
	    }
	};


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	var RFC3986 = __webpack_require__(329);
	
	var internals = {
	    Ip: {
	        cidrs: {
	            required: '\\/(?:' + RFC3986.cidr + ')',
	            optional: '(?:\\/(?:' + RFC3986.cidr + '))?',
	            forbidden: ''
	        },
	        versions: {
	            ipv4: RFC3986.IPv4address,
	            ipv6: RFC3986.IPv6address,
	            ipvfuture: RFC3986.IPvFuture
	        }
	    }
	};
	
	internals.Ip.createIpRegex = function (versions, cidr) {
	
	    var regex;
	    for (var i = 0, il = versions.length; i < il; ++i) {
	        var version = versions[i];
	        if (!regex) {
	            regex = '^(?:' + internals.Ip.versions[version];
	        }
	        regex += '|' + internals.Ip.versions[version];
	    }
	
	    return new RegExp(regex + ')' + internals.Ip.cidrs[cidr] + '$');
	};
	
	module.exports = internals.Ip;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var RFC3986 = __webpack_require__(329);
	
	var internals = {
	    Uri: {
	        createUriRegex: function (optionalScheme) {
	
	            var scheme = RFC3986.scheme;
	
	            // If we were passed a scheme, use it instead of the generic one
	            if (optionalScheme) {
	
	                // Have to put this in a non-capturing group to handle the OR statements
	                scheme = '(?:' + optionalScheme + ')';
	            }
	
	            /**
	             * URI = scheme ":" hier-part [ "?" query ] [ "#" fragment ]
	             */
	            return new RegExp('^' + scheme + ':' + RFC3986.hierPart + '(?:\\?' + RFC3986.query + ')?' + '(?:#' + RFC3986.fragment + ')?$');
	        }
	    }
	};
	
	module.exports = internals.Uri;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var ms = __webpack_require__(334);
	
	module.exports = function (time, iat) {
	  var timestamp = iat || Math.floor(Date.now() / 1000);
	
	  if (typeof time === 'string') {
	    var milliseconds = ms(time);
	    if (typeof milliseconds === 'undefined') {
	      return;
	    }
	    return Math.floor(timestamp + milliseconds / 1000);
	  } else if (typeof time === 'number') {
	    return timestamp + time;
	  } else {
	    return;
	  }
	
	};

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Joi = __webpack_require__(902);
	var timespan = __webpack_require__(906);
	var xtend = __webpack_require__(560);
	var jws = __webpack_require__(195);
	var once = __webpack_require__(911);
	
	var sign_options_schema = Joi.object().keys({
	  expiresIn: [Joi.number().integer(), Joi.string()],
	  notBefore: [Joi.number().integer(), Joi.string()],
	  audience: [Joi.string(), Joi.array()],
	  algorithm: Joi.string().valid('RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512', 'HS256', 'HS384', 'HS512', 'none'),
	  header: Joi.object(),
	  encoding: Joi.string(),
	  issuer: Joi.string(),
	  subject: Joi.string(),
	  jwtid: Joi.string(),
	  noTimestamp: Joi.boolean(),
	  keyid: Joi.string()
	});
	
	var registered_claims_schema = Joi.object().keys({
	  iat: Joi.number(),
	  exp: Joi.number(),
	  nbf: Joi.number()
	}).unknown();
	
	
	var options_to_payload = {
	  'audience': 'aud',
	  'issuer': 'iss',
	  'subject': 'sub',
	  'jwtid': 'jti'
	};
	
	var options_for_objects = [
	  'expiresIn',
	  'notBefore',
	  'noTimestamp',
	  'audience',
	  'issuer',
	  'subject',
	  'jwtid',
	];
	
	module.exports = function (payload, secretOrPrivateKey, options, callback) {
	  options = options || {};
	
	  var isObjectPayload = typeof payload === 'object' &&
	                        !Buffer.isBuffer(payload);
	
	  var header = xtend({
	    alg: options.algorithm || 'HS256',
	    typ: isObjectPayload ? 'JWT' : undefined,
	    kid: options.keyid
	  }, options.header);
	
	  function failure(err) {
	    if (callback) {
	      return callback(err);
	    }
	    throw err;
	  }
	
	
	  if (typeof payload === 'undefined') {
	    return failure(new Error('payload is required'));
	  } else if (isObjectPayload) {
	    var payload_validation_result = registered_claims_schema.validate(payload);
	
	    if (payload_validation_result.error) {
	      return failure(payload_validation_result.error);
	    }
	
	    payload = xtend(payload);
	  } else {
	    var invalid_options = options_for_objects.filter(function (opt) {
	      return typeof options[opt] !== 'undefined';
	    });
	
	    if (invalid_options.length > 0) {
	      return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + (typeof payload ) + ' payload'));
	    }
	  }
	
	  if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') {
	    return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
	  }
	
	  if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') {
	    return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
	  }
	
	  var validation_result = sign_options_schema.validate(options);
	
	  if (validation_result.error) {
	    return failure(validation_result.error);
	  }
	
	  var timestamp = payload.iat || Math.floor(Date.now() / 1000);
	
	  if (!options.noTimestamp) {
	    payload.iat = timestamp;
	  } else {
	    delete payload.iat;
	  }
	
	  if (typeof options.notBefore !== 'undefined') {
	    payload.nbf = timespan(options.notBefore);
	    if (typeof payload.nbf === 'undefined') {
	      return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	    }
	  }
	
	  if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
	    payload.exp = timespan(options.expiresIn, timestamp);
	    if (typeof payload.exp === 'undefined') {
	      return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	    }
	  }
	
	  Object.keys(options_to_payload).forEach(function (key) {
	    var claim = options_to_payload[key];
	    if (typeof options[key] !== 'undefined') {
	      if (typeof payload[claim] !== 'undefined') {
	        return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
	      }
	      payload[claim] = options[key];
	    }
	  });
	
	  var encoding = options.encoding || 'utf8';
	
	  if (typeof callback === 'function') {
	    callback = callback && once(callback);
	
	    jws.createSign({
	      header: header,
	      privateKey: secretOrPrivateKey,
	      payload: payload,
	      encoding: encoding
	    }).once('error', callback)
	      .once('done', function (signature) {
	        callback(null, signature);
	      });
	  } else {
	    return jws.sign({header: header, payload: payload, secret: secretOrPrivateKey, encoding: encoding});
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var JsonWebTokenError = __webpack_require__(137);
	var NotBeforeError    = __webpack_require__(332);
	var TokenExpiredError = __webpack_require__(333);
	var decode            = __webpack_require__(330);
	var jws               = __webpack_require__(195);
	var ms                = __webpack_require__(334);
	var xtend             = __webpack_require__(560);
	
	module.exports = function (jwtString, secretOrPublicKey, options, callback) {
	  if ((typeof options === 'function') && !callback) {
	    callback = options;
	    options = {};
	  }
	
	  if (!options) {
	    options = {};
	  }
	
	  //clone this object since we are going to mutate it.
	  options = xtend(options);
	  var done;
	
	  if (callback) {
	    done = function() {
	      var args = Array.prototype.slice.call(arguments, 0);
	      return process.nextTick(function() {
	        callback.apply(null, args);
	      });
	    };
	  } else {
	    done = function(err, data) {
	      if (err) throw err;
	      return data;
	    };
	  }
	
	  if (!jwtString){
	    return done(new JsonWebTokenError('jwt must be provided'));
	  }
	
	  var parts = jwtString.split('.');
	
	  if (parts.length !== 3){
	    return done(new JsonWebTokenError('jwt malformed'));
	  }
	
	  var hasSignature = parts[2].trim() !== '';
	
	  if (!hasSignature && secretOrPublicKey){
	    return done(new JsonWebTokenError('jwt signature is required'));
	  }
	
	  if (hasSignature && !secretOrPublicKey) {
	    return done(new JsonWebTokenError('secret or public key must be provided'));
	  }
	
	  if (!hasSignature && !options.algorithms) {
	    options.algorithms = ['none'];
	  }
	
	  if (!options.algorithms) {
	    options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') ||
	                         ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ?
	                          [ 'RS256','RS384','RS512','ES256','ES384','ES512' ] :
	                         ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ?
	                          [ 'RS256','RS384','RS512' ] :
	                          [ 'HS256','HS384','HS512' ];
	
	  }
	
	  var decodedToken;
	  try {
	    decodedToken = jws.decode(jwtString);
	  } catch(err) {
	    return done(new JsonWebTokenError('invalid token'));
	  }
	
	  if (!decodedToken) {
	    return done(new JsonWebTokenError('invalid token'));
	  }
	
	  var header = decodedToken.header;
	
	  if (!~options.algorithms.indexOf(header.alg)) {
	    return done(new JsonWebTokenError('invalid algorithm'));
	  }
	
	  var valid;
	
	  try {
	    valid = jws.verify(jwtString, header.alg, secretOrPublicKey);
	  } catch (e) {
	    return done(e);
	  }
	
	  if (!valid)
	    return done(new JsonWebTokenError('invalid signature'));
	
	  var payload;
	
	  try {
	    payload = decode(jwtString);
	  } catch(err) {
	    return done(err);
	  }
	
	  if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
	    if (typeof payload.nbf !== 'number') {
	      return done(new JsonWebTokenError('invalid nbf value'));
	    }
	    if (payload.nbf > Math.floor(Date.now() / 1000) + (options.clockTolerance || 0)) {
	      return done(new NotBeforeError('jwt not active', new Date(payload.nbf * 1000)));
	    }
	  }
	
	  if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
	    if (typeof payload.exp !== 'number') {
	      return done(new JsonWebTokenError('invalid exp value'));
	    }
	    if (Math.floor(Date.now() / 1000) >= payload.exp + (options.clockTolerance || 0)) {
	      return done(new TokenExpiredError('jwt expired', new Date(payload.exp * 1000)));
	    }
	  }
	
	  if (options.audience) {
	    var audiences = Array.isArray(options.audience)? options.audience : [options.audience];
	    var target = Array.isArray(payload.aud) ? payload.aud : [payload.aud];
	
	    var match = target.some(function(aud) { return audiences.indexOf(aud) != -1; });
	
	    if (!match)
	      return done(new JsonWebTokenError('jwt audience invalid. expected: ' + audiences.join(' or ')));
	  }
	
	  if (options.issuer) {
	    var invalid_issuer =
	        (typeof options.issuer === 'string' && payload.iss !== options.issuer) ||
	        (Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1);
	
	    if (invalid_issuer) {
	      return done(new JsonWebTokenError('jwt issuer invalid. expected: ' + options.issuer));
	    }
	  }
	
	  if (options.subject) {
	    if (payload.sub !== options.subject) {
	      return done(new JsonWebTokenError('jwt subject invalid. expected: ' + options.subject));
	    }
	  }
	
	  if (options.jwtid) {
	    if (payload.jti !== options.jwtid) {
	      return done(new JsonWebTokenError('jwt jwtid invalid. expected: ' + options.jwtid));
	    }
	  }
	
	  if (options.maxAge) {
	    var maxAge = ms(options.maxAge);
	    if (typeof payload.iat !== 'number') {
	      return done(new JsonWebTokenError('iat required when maxAge is specified'));
	    }
	    if (Date.now() - (payload.iat * 1000) > maxAge + (options.clockTolerance || 0) * 1000) {
	      return done(new TokenExpiredError('maxAge exceeded', new Date(payload.iat * 1000 + maxAge)));
	    }
	  }
	
	  return done(null, payload);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(118).Buffer;
	var DataStream = __webpack_require__(336);
	var jwa = __webpack_require__(335);
	var Stream = __webpack_require__(68);
	var toString = __webpack_require__(337);
	var util = __webpack_require__(59);
	
	function base64url(string, encoding) {
	  return Buffer
	    .from(string, encoding)
	    .toString('base64')
	    .replace(/=/g, '')
	    .replace(/\+/g, '-')
	    .replace(/\//g, '_');
	}
	
	function jwsSecuredInput(header, payload, encoding) {
	  encoding = encoding || 'utf8';
	  var encodedHeader = base64url(toString(header), 'binary');
	  var encodedPayload = base64url(toString(payload), encoding);
	  return util.format('%s.%s', encodedHeader, encodedPayload);
	}
	
	function jwsSign(opts) {
	  var header = opts.header;
	  var payload = opts.payload;
	  var secretOrKey = opts.secret || opts.privateKey;
	  var encoding = opts.encoding;
	  var algo = jwa(header.alg);
	  var securedInput = jwsSecuredInput(header, payload, encoding);
	  var signature = algo.sign(securedInput, secretOrKey);
	  return util.format('%s.%s', securedInput, signature);
	}
	
	function SignStream(opts) {
	  var secret = opts.secret||opts.privateKey||opts.key;
	  var secretStream = new DataStream(secret);
	  this.readable = true;
	  this.header = opts.header;
	  this.encoding = opts.encoding;
	  this.secret = this.privateKey = this.key = secretStream;
	  this.payload = new DataStream(opts.payload);
	  this.secret.once('close', function () {
	    if (!this.payload.writable && this.readable)
	      this.sign();
	  }.bind(this));
	
	  this.payload.once('close', function () {
	    if (!this.secret.writable && this.readable)
	      this.sign();
	  }.bind(this));
	}
	util.inherits(SignStream, Stream);
	
	SignStream.prototype.sign = function sign() {
	  try {
	    var signature = jwsSign({
	      header: this.header,
	      payload: this.payload.buffer,
	      secret: this.secret.buffer,
	      encoding: this.encoding
	    });
	    this.emit('done', signature);
	    this.emit('data', signature);
	    this.emit('end');
	    this.readable = false;
	    return signature;
	  } catch (e) {
	    this.readable = false;
	    this.emit('error', e);
	    this.emit('close');
	  }
	};
	
	SignStream.sign = jwsSign;
	
	module.exports = SignStream;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(118).Buffer;
	var DataStream = __webpack_require__(336);
	var jwa = __webpack_require__(335);
	var Stream = __webpack_require__(68);
	var toString = __webpack_require__(337);
	var util = __webpack_require__(59);
	var JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
	
	function isObject(thing) {
	  return Object.prototype.toString.call(thing) === '[object Object]';
	}
	
	function safeJsonParse(thing) {
	  if (isObject(thing))
	    return thing;
	  try { return JSON.parse(thing); }
	  catch (e) { return undefined; }
	}
	
	function headerFromJWS(jwsSig) {
	  var encodedHeader = jwsSig.split('.', 1)[0];
	  return safeJsonParse(Buffer.from(encodedHeader, 'base64').toString('binary'));
	}
	
	function securedInputFromJWS(jwsSig) {
	  return jwsSig.split('.', 2).join('.');
	}
	
	function signatureFromJWS(jwsSig) {
	  return jwsSig.split('.')[2];
	}
	
	function payloadFromJWS(jwsSig, encoding) {
	  encoding = encoding || 'utf8';
	  var payload = jwsSig.split('.')[1];
	  return Buffer.from(payload, 'base64').toString(encoding);
	}
	
	function isValidJws(string) {
	  return JWS_REGEX.test(string) && !!headerFromJWS(string);
	}
	
	function jwsVerify(jwsSig, algorithm, secretOrKey) {
	  if (!algorithm) {
	    var err = new Error("Missing algorithm parameter for jws.verify");
	    err.code = "MISSING_ALGORITHM";
	    throw err;
	  }
	  jwsSig = toString(jwsSig);
	  var signature = signatureFromJWS(jwsSig);
	  var securedInput = securedInputFromJWS(jwsSig);
	  var algo = jwa(algorithm);
	  return algo.verify(securedInput, signature, secretOrKey);
	}
	
	function jwsDecode(jwsSig, opts) {
	  opts = opts || {};
	  jwsSig = toString(jwsSig);
	
	  if (!isValidJws(jwsSig))
	    return null;
	
	  var header = headerFromJWS(jwsSig);
	
	  if (!header)
	    return null;
	
	  var payload = payloadFromJWS(jwsSig);
	  if (header.typ === 'JWT' || opts.json)
	    payload = JSON.parse(payload, opts.encoding);
	
	  return {
	    header: header,
	    payload: payload,
	    signature: signatureFromJWS(jwsSig)
	  };
	}
	
	function VerifyStream(opts) {
	  opts = opts || {};
	  var secretOrKey = opts.secret||opts.publicKey||opts.key;
	  var secretStream = new DataStream(secretOrKey);
	  this.readable = true;
	  this.algorithm = opts.algorithm;
	  this.encoding = opts.encoding;
	  this.secret = this.publicKey = this.key = secretStream;
	  this.signature = new DataStream(opts.signature);
	  this.secret.once('close', function () {
	    if (!this.signature.writable && this.readable)
	      this.verify();
	  }.bind(this));
	
	  this.signature.once('close', function () {
	    if (!this.secret.writable && this.readable)
	      this.verify();
	  }.bind(this));
	}
	util.inherits(VerifyStream, Stream);
	VerifyStream.prototype.verify = function verify() {
	  try {
	    var valid = jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
	    var obj = jwsDecode(this.signature.buffer, this.encoding);
	    this.emit('done', valid, obj);
	    this.emit('data', valid);
	    this.emit('end');
	    this.readable = false;
	    return valid;
	  } catch (e) {
	    this.readable = false;
	    this.emit('error', e);
	    this.emit('close');
	  }
	};
	
	VerifyStream.decode = jwsDecode;
	VerifyStream.isValid = isValidJws;
	VerifyStream.verify = jwsVerify;
	
	module.exports = VerifyStream;


/***/ },
/* 911 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = once;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(108),
	    root = __webpack_require__(56);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(108),
	    root = __webpack_require__(56);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(108),
	    root = __webpack_require__(56);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(108),
	    root = __webpack_require__(56);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(108),
	    root = __webpack_require__(56);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(107),
	    isObjectLike = __webpack_require__(138);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(343),
	    isMasked = __webpack_require__(927),
	    isObject = __webpack_require__(345),
	    toSource = __webpack_require__(342);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(107),
	    isLength = __webpack_require__(344),
	    isObjectLike = __webpack_require__(138);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(340),
	    nativeKeys = __webpack_require__(928);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 921 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(56);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(341);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(338);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(912),
	    Map = __webpack_require__(913),
	    Promise = __webpack_require__(914),
	    Set = __webpack_require__(915),
	    WeakMap = __webpack_require__(916),
	    baseGetTag = __webpack_require__(107),
	    toSource = __webpack_require__(342);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 926 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(922);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(341);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(339);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)(module)))

/***/ },
/* 930 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(917),
	    isObjectLike = __webpack_require__(138);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 932 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(343),
	    isLength = __webpack_require__(344);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(56),
	    stubFalse = __webpack_require__(937);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)(module)))

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(920),
	    getTag = __webpack_require__(925),
	    isArguments = __webpack_require__(931),
	    isArray = __webpack_require__(932),
	    isArrayLike = __webpack_require__(933),
	    isBuffer = __webpack_require__(934),
	    isPrototype = __webpack_require__(340),
	    isTypedArray = __webpack_require__(936);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(919),
	    baseUnary = __webpack_require__(921),
	    nodeUtil = __webpack_require__(929);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 937 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 346,
		"./af.js": 346,
		"./ar": 353,
		"./ar-dz": 347,
		"./ar-dz.js": 347,
		"./ar-kw": 348,
		"./ar-kw.js": 348,
		"./ar-ly": 349,
		"./ar-ly.js": 349,
		"./ar-ma": 350,
		"./ar-ma.js": 350,
		"./ar-sa": 351,
		"./ar-sa.js": 351,
		"./ar-tn": 352,
		"./ar-tn.js": 352,
		"./ar.js": 353,
		"./az": 354,
		"./az.js": 354,
		"./be": 355,
		"./be.js": 355,
		"./bg": 356,
		"./bg.js": 356,
		"./bm": 357,
		"./bm.js": 357,
		"./bn": 358,
		"./bn.js": 358,
		"./bo": 359,
		"./bo.js": 359,
		"./br": 360,
		"./br.js": 360,
		"./bs": 361,
		"./bs.js": 361,
		"./ca": 362,
		"./ca.js": 362,
		"./cs": 363,
		"./cs.js": 363,
		"./cv": 364,
		"./cv.js": 364,
		"./cy": 365,
		"./cy.js": 365,
		"./da": 366,
		"./da.js": 366,
		"./de": 369,
		"./de-at": 367,
		"./de-at.js": 367,
		"./de-ch": 368,
		"./de-ch.js": 368,
		"./de.js": 369,
		"./dv": 370,
		"./dv.js": 370,
		"./el": 371,
		"./el.js": 371,
		"./en-SG": 372,
		"./en-SG.js": 372,
		"./en-au": 373,
		"./en-au.js": 373,
		"./en-ca": 374,
		"./en-ca.js": 374,
		"./en-gb": 375,
		"./en-gb.js": 375,
		"./en-ie": 376,
		"./en-ie.js": 376,
		"./en-il": 377,
		"./en-il.js": 377,
		"./en-nz": 378,
		"./en-nz.js": 378,
		"./eo": 379,
		"./eo.js": 379,
		"./es": 382,
		"./es-do": 380,
		"./es-do.js": 380,
		"./es-us": 381,
		"./es-us.js": 381,
		"./es.js": 382,
		"./et": 383,
		"./et.js": 383,
		"./eu": 384,
		"./eu.js": 384,
		"./fa": 385,
		"./fa.js": 385,
		"./fi": 386,
		"./fi.js": 386,
		"./fo": 387,
		"./fo.js": 387,
		"./fr": 390,
		"./fr-ca": 388,
		"./fr-ca.js": 388,
		"./fr-ch": 389,
		"./fr-ch.js": 389,
		"./fr.js": 390,
		"./fy": 391,
		"./fy.js": 391,
		"./ga": 392,
		"./ga.js": 392,
		"./gd": 393,
		"./gd.js": 393,
		"./gl": 394,
		"./gl.js": 394,
		"./gom-latn": 395,
		"./gom-latn.js": 395,
		"./gu": 396,
		"./gu.js": 396,
		"./he": 397,
		"./he.js": 397,
		"./hi": 398,
		"./hi.js": 398,
		"./hr": 399,
		"./hr.js": 399,
		"./hu": 400,
		"./hu.js": 400,
		"./hy-am": 401,
		"./hy-am.js": 401,
		"./id": 402,
		"./id.js": 402,
		"./is": 403,
		"./is.js": 403,
		"./it": 405,
		"./it-ch": 404,
		"./it-ch.js": 404,
		"./it.js": 405,
		"./ja": 406,
		"./ja.js": 406,
		"./jv": 407,
		"./jv.js": 407,
		"./ka": 408,
		"./ka.js": 408,
		"./kk": 409,
		"./kk.js": 409,
		"./km": 410,
		"./km.js": 410,
		"./kn": 411,
		"./kn.js": 411,
		"./ko": 412,
		"./ko.js": 412,
		"./ku": 413,
		"./ku.js": 413,
		"./ky": 414,
		"./ky.js": 414,
		"./lb": 415,
		"./lb.js": 415,
		"./lo": 416,
		"./lo.js": 416,
		"./lt": 417,
		"./lt.js": 417,
		"./lv": 418,
		"./lv.js": 418,
		"./me": 419,
		"./me.js": 419,
		"./mi": 420,
		"./mi.js": 420,
		"./mk": 421,
		"./mk.js": 421,
		"./ml": 422,
		"./ml.js": 422,
		"./mn": 423,
		"./mn.js": 423,
		"./mr": 424,
		"./mr.js": 424,
		"./ms": 426,
		"./ms-my": 425,
		"./ms-my.js": 425,
		"./ms.js": 426,
		"./mt": 427,
		"./mt.js": 427,
		"./my": 428,
		"./my.js": 428,
		"./nb": 429,
		"./nb.js": 429,
		"./ne": 430,
		"./ne.js": 430,
		"./nl": 432,
		"./nl-be": 431,
		"./nl-be.js": 431,
		"./nl.js": 432,
		"./nn": 433,
		"./nn.js": 433,
		"./pa-in": 434,
		"./pa-in.js": 434,
		"./pl": 435,
		"./pl.js": 435,
		"./pt": 437,
		"./pt-br": 436,
		"./pt-br.js": 436,
		"./pt.js": 437,
		"./ro": 438,
		"./ro.js": 438,
		"./ru": 439,
		"./ru.js": 439,
		"./sd": 440,
		"./sd.js": 440,
		"./se": 441,
		"./se.js": 441,
		"./si": 442,
		"./si.js": 442,
		"./sk": 443,
		"./sk.js": 443,
		"./sl": 444,
		"./sl.js": 444,
		"./sq": 445,
		"./sq.js": 445,
		"./sr": 447,
		"./sr-cyrl": 446,
		"./sr-cyrl.js": 446,
		"./sr.js": 447,
		"./ss": 448,
		"./ss.js": 448,
		"./sv": 449,
		"./sv.js": 449,
		"./sw": 450,
		"./sw.js": 450,
		"./ta": 451,
		"./ta.js": 451,
		"./te": 452,
		"./te.js": 452,
		"./tet": 453,
		"./tet.js": 453,
		"./tg": 454,
		"./tg.js": 454,
		"./th": 455,
		"./th.js": 455,
		"./tl-ph": 456,
		"./tl-ph.js": 456,
		"./tlh": 457,
		"./tlh.js": 457,
		"./tr": 458,
		"./tr.js": 458,
		"./tzl": 459,
		"./tzl.js": 459,
		"./tzm": 461,
		"./tzm-latn": 460,
		"./tzm-latn.js": 460,
		"./tzm.js": 461,
		"./ug-cn": 462,
		"./ug-cn.js": 462,
		"./uk": 463,
		"./uk.js": 463,
		"./ur": 464,
		"./ur.js": 464,
		"./uz": 466,
		"./uz-latn": 465,
		"./uz-latn.js": 465,
		"./uz.js": 466,
		"./vi": 467,
		"./vi.js": 467,
		"./x-pseudo": 468,
		"./x-pseudo.js": 468,
		"./yo": 469,
		"./yo.js": 469,
		"./zh-cn": 470,
		"./zh-cn.js": 470,
		"./zh-hk": 471,
		"./zh-hk.js": 471,
		"./zh-tw": 472,
		"./zh-tw.js": 472
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 938;


/***/ },
/* 939 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * object.omit <https://github.com/jonschlinkert/object.omit>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(894);
	var forOwn = __webpack_require__(885);
	
	module.exports = function omit(obj, keys) {
	  if (!isObject(obj)) return {};
	
	  keys = [].concat.apply([], [].slice.call(arguments, 1));
	  var last = keys[keys.length - 1];
	  var res = {}, fn;
	
	  if (typeof last === 'function') {
	    fn = keys.pop();
	  }
	
	  var isFunction = typeof fn === 'function';
	  if (!keys.length && !isFunction) {
	    return obj;
	  }
	
	  forOwn(obj, function(value, key) {
	    if (keys.indexOf(key) === -1) {
	
	      if (!isFunction) {
	        res[key] = value;
	      } else if (fn(value, key, obj)) {
	        res[key] = value;
	      }
	    }
	  });
	  return res;
	};


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(474);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(474);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(36);
	var invariant = __webpack_require__(11);
	var ReactPropTypesSecret = __webpack_require__(947);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 947 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1191);
	var objectAssign = __webpack_require__(949);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 949 */
22,
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(943)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(490);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(80);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _react2['default'].PropTypes.func,
	  closeLabel: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(475);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(109);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CarouselCaption = __webpack_require__(957);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(477);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(199);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _react2['default'].PropTypes.bool,
	  indicators: _react2['default'].PropTypes.bool,
	  interval: _react2['default'].PropTypes.number,
	  controls: _react2['default'].PropTypes.bool,
	  pauseOnHover: _react2['default'].PropTypes.bool,
	  wrap: _react2['default'].PropTypes.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _react2['default'].PropTypes.func,
	  onSlideEnd: _react2['default'].PropTypes.func,
	  activeIndex: _react2['default'].PropTypes.number,
	  defaultActiveIndex: _react2['default'].PropTypes.number,
	  direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	  prevIcon: _react2['default'].PropTypes.node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _react2['default'].PropTypes.string,
	  nextIcon: _react2['default'].PropTypes.node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.getActiveIndex();
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _capitalize = __webpack_require__(492);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _react2['default'].PropTypes.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _react2['default'].PropTypes.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _react2['default'].PropTypes.string,
	  srOnly: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(140);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(142);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _react2['default'].PropTypes.string,
	  bsSize: _react2['default'].PropTypes.string,
	  title: _react2['default'].PropTypes.node.isRequired,
	  noCaret: _react2['default'].PropTypes.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(1015);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(196);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(519);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _react2['default'].PropTypes.bool,
	  pullRight: _react2['default'].PropTypes.bool,
	  onClose: _react2['default'].PropTypes.func,
	  labelledBy: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  onSelect: _react2['default'].PropTypes.func,
	  rootCloseEvent: _react2['default'].PropTypes.oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event);
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        onClose = _props.onClose,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'onClose', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: onClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _react2['default'].PropTypes.bool,
	  inline: _react2['default'].PropTypes.bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(966);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(967);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _react2['default'].PropTypes.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _react2['default'].PropTypes.string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', FormControl);
	module.exports = exports['default'];

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyphicon = __webpack_require__(199);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _react2['default'].PropTypes.string,
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(972);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(973);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(80);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(480);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Media = __webpack_require__(200);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Media = __webpack_require__(200);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(150);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _react2['default'].PropTypes.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _react2['default'].PropTypes.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _react2['default'].PropTypes.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(810);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(306);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(105);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(820);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(1110);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(522);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(141);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(481);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(985);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(482);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(483);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(484);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(142);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _react2['default'].PropTypes.oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _react2['default'].PropTypes.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _react2['default'].PropTypes.shape({
	    onHide: _react2['default'].PropTypes.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _react2['default'].PropTypes.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(140);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(142);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _react2['default'].PropTypes.node.isRequired,
	  noCaret: _react2['default'].PropTypes.bool,
	  active: _react2['default'].PropTypes.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(154);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(479);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(487);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(988);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(989);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(990);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _react2['default'].PropTypes.bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _react2['default'].PropTypes.bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _react2['default'].PropTypes.bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _react2['default'].PropTypes.bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _react2['default'].PropTypes.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _react2['default'].PropTypes.func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _react2['default'].PropTypes.func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _react2['default'].PropTypes.bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _react2['default'].PropTypes.bool,
	
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool,
	    onToggle: _react.PropTypes.func.isRequired,
	    onSelect: _react.PropTypes.func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _react2['default'].PropTypes.bool,
	    pullLeft: _react2['default'].PropTypes.bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _react.PropTypes.shape({
	      bsClass: _react.PropTypes.string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(198);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _react.PropTypes.func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _react.PropTypes.node
	};
	
	var contextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool,
	    onToggle: _react.PropTypes.func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(184);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(488);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _react2['default'].PropTypes.oneOfType([triggerType, _react2['default'].PropTypes.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _react2['default'].PropTypes.number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _react2['default'].PropTypes.number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _react2['default'].PropTypes.number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _react2['default'].PropTypes.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _react2['default'].PropTypes.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onClick: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onFocus: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onMouseOut: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onMouseOver: _react2['default'].PropTypes.func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _react2['default'].PropTypes.oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _react2['default'].PropTypes.oneOf([null]),
	  /**
	   * @private
	   */
	  show: _react2['default'].PropTypes.oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	
	    var triggerProps = {
	      'aria-describedby': overlay.props.id
	    };
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(489);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(1013);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PagerItem = __webpack_require__(489);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _react2['default'].PropTypes.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(996);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _react2['default'].PropTypes.number,
	  items: _react2['default'].PropTypes.number,
	  maxButtons: _react2['default'].PropTypes.number,
	
	  /**
	   * When `true`, will display the first and the last button page
	   */
	  boundaryLinks: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	    var hasHiddenPagesAfter = void 0;
	
	    if (maxButtons) {
	      var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
	      startPage = Math.max(hiddenPagesBefore, 1);
	      hasHiddenPagesAfter = items >= startPage + maxButtons;
	
	      if (!hasHiddenPagesAfter) {
	        endPage = items;
	        startPage = items - maxButtons + 1;
	        if (startPage < 1) {
	          startPage = 1;
	        }
	      } else {
	        endPage = startPage + maxButtons - 1;
	      }
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var pagenumber = startPage; pagenumber <= endPage; pagenumber++) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: pagenumber,
	          eventKey: pagenumber,
	          active: pagenumber === activePage
	        }),
	        pagenumber
	      ));
	    }
	
	    if (boundaryLinks && ellipsis && startPage !== 1) {
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsisFirst',
	          disabled: true,
	          componentClass: buttonProps.componentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          ellipsis === true ? '\u2026' : ellipsis
	        )
	      ));
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (maxButtons && hasHiddenPagesAfter && ellipsis) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsis',
	          disabled: true,
	          componentClass: buttonProps.componentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          ellipsis === true ? '\u2026' : ellipsis
	        )
	      ));
	
	      if (boundaryLinks && endPage !== items) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(27);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _react2['default'].PropTypes.string,
	  eventKey: _react2['default'].PropTypes.any,
	  onSelect: _react2['default'].PropTypes.func,
	  disabled: _react2['default'].PropTypes.bool,
	  active: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(80);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(198);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _react2['default'].PropTypes.bool,
	  onSelect: _react2['default'].PropTypes.func,
	  header: _react2['default'].PropTypes.node,
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  footer: _react2['default'].PropTypes.node,
	  defaultExpanded: _react2['default'].PropTypes.bool,
	  expanded: _react2['default'].PropTypes.bool,
	  eventKey: _react2['default'].PropTypes.any,
	  headerRole: _react2['default'].PropTypes.string,
	  panelRole: _react2['default'].PropTypes.string,
	
	  // From Collapse.
	  onEnter: _react2['default'].PropTypes.func,
	  onEntering: _react2['default'].PropTypes.func,
	  onEntered: _react2['default'].PropTypes.func,
	  onExit: _react2['default'].PropTypes.func,
	  onExiting: _react2['default'].PropTypes.func,
	  onExited: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(151);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * Title content
	   */
	  title: _react2['default'].PropTypes.node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(80);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _react.PropTypes.number,
	  now: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  label: _react.PropTypes.node,
	  srOnly: _react.PropTypes.bool,
	  striped: _react.PropTypes.bool,
	  active: _react.PropTypes.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _react.PropTypes.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _react.PropTypes.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(109);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(140);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(1004);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(142);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _react2['default'].PropTypes.string,
	  bsSize: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  /**
	   * The content of the split button.
	   */
	  title: _react2['default'].PropTypes.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _react2['default'].PropTypes.string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(478);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabContainer = __webpack_require__(201);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(202);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(491);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _react2['default'].PropTypes.bool,
	
	  title: _react2['default'].PropTypes.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _react2['default'].PropTypes.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _react2['default'].PropTypes.bool,
	  bordered: _react2['default'].PropTypes.bool,
	  condensed: _react2['default'].PropTypes.bool,
	  hover: _react2['default'].PropTypes.bool,
	  responsive: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(151);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(154);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(485);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(486);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(201);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(202);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _react2['default'].PropTypes.oneOf(['tabs', 'pills']),
	
	  animation: _react2['default'].PropTypes.bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(44);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _react2['default'].PropTypes.string,
	  alt: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(151);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(152);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(34);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 1012 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(203);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(10);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(27);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(34);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(656), __esModule: true };

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(658), __esModule: true };

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(660), __esModule: true };

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(662), __esModule: true };

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(663), __esModule: true };

/***/ },
/* 1020 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = addEventListener;
	function addEventListener(node, eventName, handler, options) {
	    node.addEventListener(eventName, handler, options);
	    return {
	        removeEventListener: function removeEventListener() {
	            node.removeEventListener(eventName, handler, options);
	        }
	    };
	}

/***/ },
/* 1021 */
22,
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	var UAParser = __webpack_require__(1195);
	
	var UA = new UAParser();
	var browser = UA.getBrowser();
	var cpu = UA.getCPU();
	var device = UA.getDevice();
	var engine = UA.getEngine();
	var os = UA.getOS();
	var ua = UA.getUA();
	
	var setDefaults = function setDefaults(p) {
	  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
	  return p ? p : d;
	};
	var getNavigatorInstance = function getNavigatorInstance() {
	  if (typeof window !== 'undefined') {
	    if (window.navigator || navigator) {
	      return window.navigator || navigator;
	    }
	  }
	
	  return false;
	};
	var isIOS13Check = function isIOS13Check(type) {
	  var nav = getNavigatorInstance();
	  return nav && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
	};
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	var DEVICE_TYPES = {
	  MOBILE: 'mobile',
	  TABLET: 'tablet',
	  SMART_TV: 'smarttv',
	  CONSOLE: 'console',
	  WEARABLE: 'wearable',
	  BROWSER: undefined
	};
	var BROWSER_TYPES = {
	  CHROME: 'Chrome',
	  FIREFOX: "Firefox",
	  OPERA: "Opera",
	  YANDEX: "Yandex",
	  SAFARI: "Safari",
	  INTERNET_EXPLORER: "Internet Explorer",
	  EDGE: "Edge",
	  CHROMIUM: "Chromium",
	  IE: 'IE',
	  MOBILE_SAFARI: "Mobile Safari"
	};
	var OS_TYPES = {
	  IOS: 'iOS',
	  ANDROID: "Android",
	  WINDOWS_PHONE: "Windows Phone"
	};
	var initialData = {
	  isMobile: false,
	  isTablet: false,
	  isBrowser: false,
	  isSmartTV: false,
	  isConsole: false,
	  isWearable: false
	};
	var checkType = function checkType(type) {
	  switch (type) {
	    case DEVICE_TYPES.MOBILE:
	      return {
	        isMobile: true
	      };
	
	    case DEVICE_TYPES.TABLET:
	      return {
	        isTablet: true
	      };
	
	    case DEVICE_TYPES.SMART_TV:
	      return {
	        isSmartTV: true
	      };
	
	    case DEVICE_TYPES.CONSOLE:
	      return {
	        isConsole: true
	      };
	
	    case DEVICE_TYPES.WEARABLE:
	      return {
	        isWearable: true
	      };
	
	    case DEVICE_TYPES.BROWSER:
	      return {
	        isBrowser: true
	      };
	
	    default:
	      return initialData;
	  }
	};
	var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
	  return {
	    isBrowser: isBrowser,
	    browserMajorVersion: setDefaults(browser.major),
	    browserFullVersion: setDefaults(browser.version),
	    browserName: setDefaults(browser.name),
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var mobilePayload = function mobilePayload(type, device, os, ua) {
	  return _objectSpread2({}, type, {
	    vendor: setDefaults(device.vendor),
	    model: setDefaults(device.model),
	    os: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    ua: setDefaults(ua)
	  });
	};
	var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
	  return {
	    isSmartTV: isSmartTV,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var consolePayload = function consolePayload(isConsole, engine, os, ua) {
	  return {
	    isConsole: isConsole,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var wearPayload = function wearPayload(isWearable, engine, os, ua) {
	  return {
	    isWearable: isWearable,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	
	var type = checkType(device.type);
	
	function deviceDetect() {
	  var isBrowser = type.isBrowser,
	      isMobile = type.isMobile,
	      isTablet = type.isTablet,
	      isSmartTV = type.isSmartTV,
	      isConsole = type.isConsole,
	      isWearable = type.isWearable;
	
	  if (isBrowser) {
	    return broPayload(isBrowser, browser, engine, os, ua);
	  }
	
	  if (isSmartTV) {
	    return stvPayload(isSmartTV, engine, os, ua);
	  }
	
	  if (isConsole) {
	    return consolePayload(isConsole, engine, os, ua);
	  }
	
	  if (isMobile) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isTablet) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isWearable) {
	    return wearPayload(isWearable, engine, os, ua);
	  }
	}
	
	var isMobileType = function isMobileType() {
	  return device.type === DEVICE_TYPES.MOBILE;
	};
	
	var isTabletType = function isTabletType() {
	  return device.type === DEVICE_TYPES.TABLET;
	};
	
	var isMobileAndTabletType = function isMobileAndTabletType() {
	  switch (device.type) {
	    case DEVICE_TYPES.MOBILE:
	    case DEVICE_TYPES.TABLET:
	      return true;
	
	    default:
	      return false;
	  }
	};
	
	var isSmartTVType = function isSmartTVType() {
	  return device.type === DEVICE_TYPES.SMART_TV;
	};
	
	var isBrowserType = function isBrowserType() {
	  return device.type === DEVICE_TYPES.BROWSER;
	};
	
	var isWearableType = function isWearableType() {
	  return device.type === DEVICE_TYPES.WEARABLE;
	};
	
	var isConsoleType = function isConsoleType() {
	  return device.type === DEVICE_TYPES.CONSOLE;
	};
	
	var isAndroidType = function isAndroidType() {
	  return os.name === OS_TYPES.ANDROID;
	};
	
	var isWinPhoneType = function isWinPhoneType() {
	  return os.name === OS_TYPES.WINDOWS_PHONE;
	};
	
	var isIOSType = function isIOSType() {
	  return os.name === OS_TYPES.IOS;
	};
	
	var isChromeType = function isChromeType() {
	  return browser.name === BROWSER_TYPES.CHROME;
	};
	
	var isFirefoxType = function isFirefoxType() {
	  return browser.name === BROWSER_TYPES.FIREFOX;
	};
	
	var isChromiumType = function isChromiumType() {
	  return browser.name === BROWSER_TYPES.CHROMIUM;
	};
	
	var isEdgeType = function isEdgeType() {
	  return browser.name === BROWSER_TYPES.EDGE;
	};
	
	var isYandexType = function isYandexType() {
	  return browser.name === BROWSER_TYPES.YANDEX;
	};
	
	var isSafariType = function isSafariType() {
	  return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
	};
	
	var isMobileSafariType = function isMobileSafariType() {
	  return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
	};
	
	var isOperaType = function isOperaType() {
	  return browser.name === BROWSER_TYPES.OPERA;
	};
	
	var isIEType = function isIEType() {
	  return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
	};
	
	var isElectronType = function isElectronType() {
	  var nav = getNavigatorInstance();
	  var ua = nav && nav.userAgent.toLowerCase();
	  return typeof ua === 'string' ? /electron/.test(ua) : false;
	};
	
	var getIOS13 = function getIOS13() {
	  var nav = getNavigatorInstance();
	  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
	};
	
	var getIPad13 = function getIPad13() {
	  return isIOS13Check('iPad');
	};
	
	var getIphone13 = function getIphone13() {
	  return isIOS13Check('iPhone');
	};
	
	var getIPod13 = function getIPod13() {
	  return isIOS13Check('iPod');
	};
	
	var getBrowserFullVersion = function getBrowserFullVersion() {
	  return setDefaults(browser.version);
	};
	
	var getBrowserVersion = function getBrowserVersion() {
	  return setDefaults(browser.major);
	};
	
	var getOsVersion = function getOsVersion() {
	  return setDefaults(os.version);
	};
	
	var getOsName = function getOsName() {
	  return setDefaults(os.name);
	};
	
	var getBrowserName = function getBrowserName() {
	  return setDefaults(browser.name);
	};
	
	var getMobileVendor = function getMobileVendor() {
	  return setDefaults(device.vendor);
	};
	
	var getMobileModel = function getMobileModel() {
	  return setDefaults(device.model);
	};
	
	var getEngineName = function getEngineName() {
	  return setDefaults(engine.name);
	};
	
	var getEngineVersion = function getEngineVersion() {
	  return setDefaults(engine.version);
	};
	
	var getUseragent = function getUseragent() {
	  return setDefaults(ua);
	};
	
	var getDeviceType = function getDeviceType() {
	  return setDefaults(device.type, 'browser');
	};
	
	var isSmartTV = isSmartTVType();
	var isConsole = isConsoleType();
	var isWearable = isWearableType();
	var isMobileSafari = isMobileSafariType() || getIPad13();
	var isChromium = isChromiumType();
	var isMobile = isMobileAndTabletType() || getIPad13();
	var isMobileOnly = isMobileType();
	var isTablet = isTabletType() || getIPad13();
	var isBrowser = isBrowserType();
	var isAndroid = isAndroidType();
	var isWinPhone = isWinPhoneType();
	var isIOS = isIOSType() || getIPad13();
	var isChrome = isChromeType();
	var isFirefox = isFirefoxType();
	var isSafari = isSafariType();
	var isOpera = isOperaType();
	var isIE = isIEType();
	var osVersion = getOsVersion();
	var osName = getOsName();
	var fullBrowserVersion = getBrowserFullVersion();
	var browserVersion = getBrowserVersion();
	var browserName = getBrowserName();
	var mobileVendor = getMobileVendor();
	var mobileModel = getMobileModel();
	var engineName = getEngineName();
	var engineVersion = getEngineVersion();
	var getUA = getUseragent();
	var isEdge = isEdgeType();
	var isYandex = isYandexType();
	var deviceType = getDeviceType();
	var isIOS13 = getIOS13();
	var isIPad13 = getIPad13();
	var isIPhone13 = getIphone13();
	var isIPod13 = getIPod13();
	var isElectron = isElectronType();
	
	var AndroidView = function AndroidView(_ref) {
	  var renderWithFragment = _ref.renderWithFragment,
	      children = _ref.children,
	      viewClassName = _ref.viewClassName,
	      style = _ref.style;
	  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var BrowserView = function BrowserView(_ref2) {
	  var renderWithFragment = _ref2.renderWithFragment,
	      children = _ref2.children,
	      viewClassName = _ref2.viewClassName,
	      style = _ref2.style;
	  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var IEView = function IEView(_ref3) {
	  var renderWithFragment = _ref3.renderWithFragment,
	      children = _ref3.children,
	      viewClassName = _ref3.viewClassName,
	      style = _ref3.style;
	  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var IOSView = function IOSView(_ref4) {
	  var renderWithFragment = _ref4.renderWithFragment,
	      children = _ref4.children,
	      viewClassName = _ref4.viewClassName,
	      style = _ref4.style;
	  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var MobileView = function MobileView(_ref5) {
	  var renderWithFragment = _ref5.renderWithFragment,
	      children = _ref5.children,
	      viewClassName = _ref5.viewClassName,
	      style = _ref5.style;
	  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var TabletView = function TabletView(_ref6) {
	  var renderWithFragment = _ref6.renderWithFragment,
	      children = _ref6.children,
	      viewClassName = _ref6.viewClassName,
	      style = _ref6.style;
	  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var WinPhoneView = function WinPhoneView(_ref7) {
	  var renderWithFragment = _ref7.renderWithFragment,
	      children = _ref7.children,
	      viewClassName = _ref7.viewClassName,
	      style = _ref7.style;
	  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var MobileOnlyView = function MobileOnlyView(_ref8) {
	  var renderWithFragment = _ref8.renderWithFragment,
	      children = _ref8.children,
	      viewClassName = _ref8.viewClassName,
	      style = _ref8.style;
	  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var SmartTVView = function SmartTVView(_ref9) {
	  var renderWithFragment = _ref9.renderWithFragment,
	      children = _ref9.children,
	      viewClassName = _ref9.viewClassName,
	      style = _ref9.style;
	  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var ConsoleView = function ConsoleView(_ref10) {
	  var renderWithFragment = _ref10.renderWithFragment,
	      children = _ref10.children,
	      viewClassName = _ref10.viewClassName,
	      style = _ref10.style;
	  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var WearableView = function WearableView(_ref11) {
	  var renderWithFragment = _ref11.renderWithFragment,
	      children = _ref11.children,
	      viewClassName = _ref11.viewClassName,
	      style = _ref11.style;
	  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var CustomView = function CustomView(_ref12) {
	  var renderWithFragment = _ref12.renderWithFragment,
	      children = _ref12.children,
	      viewClassName = _ref12.viewClassName,
	      style = _ref12.style,
	      condition = _ref12.condition;
	  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	
	function withOrientationChange(WrappedComponent) {
	  return (
	    /*#__PURE__*/
	    function (_React$Component) {
	      _inherits(_class, _React$Component);
	
	      function _class(props) {
	        var _this;
	
	        _classCallCheck(this, _class);
	
	        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
	        _this.isEventListenerAdded = false;
	        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
	        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
	        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
	        _this.state = {
	          isLandscape: false,
	          isPortrait: false
	        };
	        return _this;
	      }
	
	      _createClass(_class, [{
	        key: "handleOrientationChange",
	        value: function handleOrientationChange() {
	          if (!this.isEventListenerAdded) {
	            this.isEventListenerAdded = true;
	          }
	
	          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	          this.setState({
	            isPortrait: orientation === 0,
	            isLandscape: orientation === 90
	          });
	        }
	      }, {
	        key: "onOrientationChange",
	        value: function onOrientationChange() {
	          this.handleOrientationChange();
	        }
	      }, {
	        key: "onPageLoad",
	        value: function onPageLoad() {
	          this.handleOrientationChange();
	        }
	      }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
	            if (!this.isEventListenerAdded) {
	              this.handleOrientationChange();
	              window.addEventListener("load", this.onPageLoad, false);
	            } else {
	              window.removeEventListener("load", this.onPageLoad, false);
	            }
	
	            window.addEventListener("resize", this.onOrientationChange, false);
	          }
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          window.removeEventListener("resize", this.onOrientationChange, false);
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
	            isLandscape: this.state.isLandscape,
	            isPortrait: this.state.isPortrait
	          }));
	        }
	      }]);
	
	      return _class;
	    }(React__default.Component)
	  );
	}
	
	exports.AndroidView = AndroidView;
	exports.BrowserView = BrowserView;
	exports.ConsoleView = ConsoleView;
	exports.CustomView = CustomView;
	exports.IEView = IEView;
	exports.IOSView = IOSView;
	exports.MobileOnlyView = MobileOnlyView;
	exports.MobileView = MobileView;
	exports.SmartTVView = SmartTVView;
	exports.TabletView = TabletView;
	exports.WearableView = WearableView;
	exports.WinPhoneView = WinPhoneView;
	exports.browserName = browserName;
	exports.browserVersion = browserVersion;
	exports.deviceDetect = deviceDetect;
	exports.deviceType = deviceType;
	exports.engineName = engineName;
	exports.engineVersion = engineVersion;
	exports.fullBrowserVersion = fullBrowserVersion;
	exports.getUA = getUA;
	exports.isAndroid = isAndroid;
	exports.isBrowser = isBrowser;
	exports.isChrome = isChrome;
	exports.isChromium = isChromium;
	exports.isConsole = isConsole;
	exports.isEdge = isEdge;
	exports.isElectron = isElectron;
	exports.isFirefox = isFirefox;
	exports.isIE = isIE;
	exports.isIOS = isIOS;
	exports.isIOS13 = isIOS13;
	exports.isIPad13 = isIPad13;
	exports.isIPhone13 = isIPhone13;
	exports.isIPod13 = isIPod13;
	exports.isMobile = isMobile;
	exports.isMobileOnly = isMobileOnly;
	exports.isMobileSafari = isMobileSafari;
	exports.isOpera = isOpera;
	exports.isSafari = isSafari;
	exports.isSmartTV = isSmartTV;
	exports.isTablet = isTablet;
	exports.isWearable = isWearable;
	exports.isWinPhone = isWinPhone;
	exports.isYandex = isYandex;
	exports.mobileModel = mobileModel;
	exports.mobileVendor = mobileVendor;
	exports.osName = osName;
	exports.osVersion = osVersion;
	exports.withOrientationChange = withOrientationChange;


/***/ },
/* 1023 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(21);
	
	var focusNode = __webpack_require__(314);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(111);
	var ExecutionEnvironment = __webpack_require__(30);
	var FallbackCompositionState = __webpack_require__(1031);
	var SyntheticCompositionEvent = __webpack_require__(1068);
	var SyntheticInputEvent = __webpack_require__(1071);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(496);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactInstrumentation = __webpack_require__(41);
	
	var camelizeStyleName = __webpack_require__(859);
	var dangerousStyleValue = __webpack_require__(1077);
	var hyphenateStyleName = __webpack_require__(866);
	var memoizeStringOnly = __webpack_require__(869);
	var warning = __webpack_require__(12);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(110);
	var EventPropagators = __webpack_require__(111);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(45);
	var SyntheticEvent = __webpack_require__(48);
	
	var getEventTarget = __webpack_require__(216);
	var isEventSupported = __webpack_require__(217);
	var isTextInputElement = __webpack_require__(513);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var DOMLazyTree = __webpack_require__(81);
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createNodesFromMarkup = __webpack_require__(862);
	var emptyFunction = __webpack_require__(36);
	var invariant = __webpack_require__(11);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 1029 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(21);
	var SyntheticMouseEvent = __webpack_require__(144);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var PooledClass = __webpack_require__(67);
	
	var getTextContentAccessor = __webpack_require__(511);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(82);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(83);
	
	var instantiateReactComponent = __webpack_require__(512);
	var KeyEscapeUtils = __webpack_require__(208);
	var shouldUpdateReactComponent = __webpack_require__(218);
	var traverseAllChildren = __webpack_require__(515);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(545);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(204);
	var ReactDOMIDOperations = __webpack_require__(1041);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var React = __webpack_require__(87);
	var ReactComponentEnvironment = __webpack_require__(210);
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactErrorUtils = __webpack_require__(211);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(41);
	var ReactNodeTypes = __webpack_require__(506);
	var ReactReconciler = __webpack_require__(83);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(77);
	var invariant = __webpack_require__(11);
	var shallowEqual = __webpack_require__(186);
	var shouldUpdateReactComponent = __webpack_require__(218);
	var warning = __webpack_require__(12);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDefaultInjection = __webpack_require__(1049);
	var ReactMount = __webpack_require__(505);
	var ReactReconciler = __webpack_require__(83);
	var ReactUpdates = __webpack_require__(45);
	var ReactVersion = __webpack_require__(1062);
	
	var findDOMNode = __webpack_require__(1078);
	var getHostComponentFromComposite = __webpack_require__(510);
	var renderSubtreeIntoContainer = __webpack_require__(1086);
	var warning = __webpack_require__(12);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var AutoFocusUtils = __webpack_require__(1024);
	var CSSPropertyOperations = __webpack_require__(1026);
	var DOMLazyTree = __webpack_require__(81);
	var DOMNamespaces = __webpack_require__(205);
	var DOMProperty = __webpack_require__(82);
	var DOMPropertyOperations = __webpack_require__(498);
	var EventPluginHub = __webpack_require__(110);
	var EventPluginRegistry = __webpack_require__(206);
	var ReactBrowserEventEmitter = __webpack_require__(143);
	var ReactDOMComponentFlags = __webpack_require__(499);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMInput = __webpack_require__(1042);
	var ReactDOMOption = __webpack_require__(1043);
	var ReactDOMSelect = __webpack_require__(500);
	var ReactDOMTextarea = __webpack_require__(1046);
	var ReactInstrumentation = __webpack_require__(41);
	var ReactMultiChild = __webpack_require__(1055);
	var ReactServerRenderingTransaction = __webpack_require__(1060);
	
	var emptyFunction = __webpack_require__(36);
	var escapeTextContentForBrowser = __webpack_require__(146);
	var invariant = __webpack_require__(11);
	var isEventSupported = __webpack_require__(217);
	var shallowEqual = __webpack_require__(186);
	var validateDOMNesting = __webpack_require__(219);
	var warning = __webpack_require__(12);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(219);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var DOMLazyTree = __webpack_require__(81);
	var ReactDOMComponentTree = __webpack_require__(21);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1040 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(204);
	var ReactDOMComponentTree = __webpack_require__(21);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var DOMPropertyOperations = __webpack_require__(498);
	var LinkedValueUtils = __webpack_require__(209);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(45);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var React = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMSelect = __webpack_require__(500);
	
	var warning = __webpack_require__(12);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var getNodeForCharacterOffset = __webpack_require__(1083);
	var getTextContentAccessor = __webpack_require__(511);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var DOMChildrenOperations = __webpack_require__(204);
	var DOMLazyTree = __webpack_require__(81);
	var ReactDOMComponentTree = __webpack_require__(21);
	
	var escapeTextContentForBrowser = __webpack_require__(146);
	var invariant = __webpack_require__(11);
	var validateDOMNesting = __webpack_require__(219);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15),
	    _assign = __webpack_require__(22);
	
	var LinkedValueUtils = __webpack_require__(209);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(45);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var ReactUpdates = __webpack_require__(45);
	var Transaction = __webpack_require__(145);
	
	var emptyFunction = __webpack_require__(36);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1023);
	var BeforeInputEventPlugin = __webpack_require__(1025);
	var ChangeEventPlugin = __webpack_require__(1027);
	var DefaultEventPluginOrder = __webpack_require__(1029);
	var EnterLeaveEventPlugin = __webpack_require__(1030);
	var HTMLDOMPropertyConfig = __webpack_require__(1032);
	var ReactComponentBrowserEnvironment = __webpack_require__(1034);
	var ReactDOMComponent = __webpack_require__(1037);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMEmptyComponent = __webpack_require__(1039);
	var ReactDOMTreeTraversal = __webpack_require__(1047);
	var ReactDOMTextComponent = __webpack_require__(1045);
	var ReactDefaultBatchingStrategy = __webpack_require__(1048);
	var ReactEventListener = __webpack_require__(1052);
	var ReactInjection = __webpack_require__(1053);
	var ReactReconcileTransaction = __webpack_require__(1058);
	var SVGDOMPropertyConfig = __webpack_require__(1063);
	var SelectEventPlugin = __webpack_require__(1064);
	var SimpleEventPlugin = __webpack_require__(1065);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1050 */
546,
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(110);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var EventListener = __webpack_require__(313);
	var ExecutionEnvironment = __webpack_require__(30);
	var PooledClass = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(45);
	
	var getEventTarget = __webpack_require__(216);
	var getUnboundedScrollPosition = __webpack_require__(864);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(82);
	var EventPluginHub = __webpack_require__(110);
	var EventPluginUtils = __webpack_require__(207);
	var ReactComponentEnvironment = __webpack_require__(210);
	var ReactEmptyComponent = __webpack_require__(501);
	var ReactBrowserEventEmitter = __webpack_require__(143);
	var ReactHostComponent = __webpack_require__(503);
	var ReactUpdates = __webpack_require__(45);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1076);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var ReactComponentEnvironment = __webpack_require__(210);
	var ReactInstanceMap = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(41);
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactReconciler = __webpack_require__(83);
	var ReactChildReconciler = __webpack_require__(1033);
	
	var emptyFunction = __webpack_require__(36);
	var flattenChildren = __webpack_require__(1079);
	var invariant = __webpack_require__(11);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1057 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var CallbackQueue = __webpack_require__(497);
	var PooledClass = __webpack_require__(67);
	var ReactBrowserEventEmitter = __webpack_require__(143);
	var ReactInputSelection = __webpack_require__(504);
	var ReactInstrumentation = __webpack_require__(41);
	var Transaction = __webpack_require__(145);
	var ReactUpdateQueue = __webpack_require__(212);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1056);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(22);
	
	var PooledClass = __webpack_require__(67);
	var Transaction = __webpack_require__(145);
	var ReactInstrumentation = __webpack_require__(41);
	var ReactServerUpdateQueue = __webpack_require__(1061);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(212);
	
	var warning = __webpack_require__(12);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1062 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.0';

/***/ },
/* 1063 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(111);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInputSelection = __webpack_require__(504);
	var SyntheticEvent = __webpack_require__(48);
	
	var getActiveElement = __webpack_require__(315);
	var isTextInputElement = __webpack_require__(513);
	var shallowEqual = __webpack_require__(186);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var EventListener = __webpack_require__(313);
	var EventPropagators = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(21);
	var SyntheticAnimationEvent = __webpack_require__(1066);
	var SyntheticClipboardEvent = __webpack_require__(1067);
	var SyntheticEvent = __webpack_require__(48);
	var SyntheticFocusEvent = __webpack_require__(1070);
	var SyntheticKeyboardEvent = __webpack_require__(1072);
	var SyntheticMouseEvent = __webpack_require__(144);
	var SyntheticDragEvent = __webpack_require__(1069);
	var SyntheticTouchEvent = __webpack_require__(1073);
	var SyntheticTransitionEvent = __webpack_require__(1074);
	var SyntheticUIEvent = __webpack_require__(113);
	var SyntheticWheelEvent = __webpack_require__(1075);
	
	var emptyFunction = __webpack_require__(36);
	var getEventCharCode = __webpack_require__(214);
	var invariant = __webpack_require__(11);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(inst) {
	  if (inst) {
	    var disabled = inst._currentElement && inst._currentElement.props.disabled;
	
	    if (disabled) {
	      return isInteractive(inst._tag);
	    }
	  }
	
	  return false;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	        // Disabled elements should not respond to mouse events
	        if (shouldPreventMouseEvent(targetInst)) {
	          return null;
	        }
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(144);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(113);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(113);
	
	var getEventCharCode = __webpack_require__(214);
	var getEventKey = __webpack_require__(1080);
	var getEventModifierState = __webpack_require__(215);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(113);
	
	var getEventModifierState = __webpack_require__(215);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(48);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(144);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1076 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(496);
	var warning = __webpack_require__(12);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(15);
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInstanceMap = __webpack_require__(112);
	
	var getHostComponentFromComposite = __webpack_require__(510);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(208);
	var traverseAllChildren = __webpack_require__(515);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(545);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(214);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1081 */
549,
/* 1082 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1083 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(146);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(505);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1087 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(1089);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1089 */
22,
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1096);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectAssign = __webpack_require__(1093);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _object = __webpack_require__(1094);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _noop = __webpack_require__(1091);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	        _this.state = {
	            isHovering: false
	        };
	
	        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	        _this.onMouseOver = _this.onMouseOver.bind(_this);
	        _this.onMouseOut = _this.onMouseOut.bind(_this);
	        _this.setIsHovering = _this.setIsHovering.bind(_this);
	        _this.unsetIsHovering = _this.unsetIsHovering.bind(_this);
	        _this.componentWillUnmount = _this.componentWillUnmount.bind(_this);
	
	        _this.timerIds = [];
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'onMouseEnter',
	        value: function onMouseEnter(e) {
	            this.props.onMouseEnter({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'onMouseLeave',
	        value: function onMouseLeave(e) {
	            this.props.onMouseLeave({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'onMouseOver',
	        value: function onMouseOver(e) {
	            this.props.onMouseOver({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'onMouseOut',
	        value: function onMouseOut(e) {
	            this.props.onMouseOut({
	                e: e,
	                setIsHovering: this.setIsHovering,
	                unsetIsHovering: this.unsetIsHovering
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearTimers();
	        }
	    }, {
	        key: 'setIsHovering',
	        value: function setIsHovering() {
	            var _this2 = this;
	
	            this.clearTimers();
	
	            var hoverScheduleId = setTimeout(function () {
	                var newState = { isHovering: true };
	                _this2.setState(newState, function () {
	                    _this2.props.onHoverChanged(newState);
	                });
	            }, this.props.hoverDelayInMs);
	
	            this.timerIds.push(hoverScheduleId);
	        }
	    }, {
	        key: 'unsetIsHovering',
	        value: function unsetIsHovering() {
	            var _this3 = this;
	
	            this.clearTimers();
	
	            var hoverOffScheduleId = setTimeout(function () {
	                var newState = { isHovering: false };
	                _this3.setState(newState, function () {
	                    _this3.props.onHoverChanged(newState);
	                });
	            }, this.props.hoverOffDelayInMs);
	
	            this.timerIds.push(hoverOffScheduleId);
	        }
	    }, {
	        key: 'clearTimers',
	        value: function clearTimers() {
	            var ids = this.timerIds;
	            while (ids.length) {
	                clearTimeout(ids.pop());
	            }
	        }
	    }, {
	        key: 'getIsReactComponent',
	        value: function getIsReactComponent(reactElement) {
	            return typeof reactElement.type === 'function';
	        }
	    }, {
	        key: 'shouldDecorateChild',
	        value: function shouldDecorateChild(child) {
	            return !!child && this.getIsReactComponent(child) && this.props.shouldDecorateChildren;
	        }
	    }, {
	        key: 'decorateChild',
	        value: function decorateChild(child, props) {
	            return (0, _react.cloneElement)(child, props);
	        }
	    }, {
	        key: 'renderChildrenWithProps',
	        value: function renderChildrenWithProps(children, props) {
	            var _this4 = this;
	
	            if (typeof children === 'function') {
	                return children(props);
	            }
	
	            return _react.Children.map(children, function (child) {
	                return _this4.shouldDecorateChild(child) ? _this4.decorateChild(child, props) : child;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                className = _props.className;
	
	            var childProps = (0, _objectAssign2.default)({}, { isHovering: this.state.isHovering }, (0, _object2.default)(this.props, ['children', 'className', 'hoverDelayInMs', 'hoverOffDelayInMs', 'onHoverChanged', 'onMouseEnter', 'onMouseLeave', 'onMouseOver', 'onMouseOut', 'shouldDecorateChildren']));
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: className,
	                    onMouseEnter: this.onMouseEnter,
	                    onMouseLeave: this.onMouseLeave,
	                    onMouseOver: this.onMouseOver,
	                    onMouseOut: this.onMouseOut
	                },
	                this.renderChildrenWithProps(children, childProps)
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component);
	
	_class.displayName = 'ReactHoverObserver';
	_class.defaultProps = {
	    hoverDelayInMs: 0,
	    hoverOffDelayInMs: 0,
	    onHoverChanged: _noop2.default,
	    onMouseEnter: function onMouseEnter(_ref) {
	        var setIsHovering = _ref.setIsHovering;
	        return setIsHovering();
	    },
	    onMouseLeave: function onMouseLeave(_ref2) {
	        var unsetIsHovering = _ref2.unsetIsHovering;
	        return unsetIsHovering();
	    },
	    onMouseOver: _noop2.default,
	    onMouseOut: _noop2.default,
	    shouldDecorateChildren: true
	};
	_class.propTypes = {
	    className: _propTypes2.default.string,
	    hoverDelayInMs: _propTypes2.default.number,
	    hoverOffDelayInMs: _propTypes2.default.number,
	    onHoverChanged: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseOver: _propTypes2.default.func,
	    onMouseOut: _propTypes2.default.func,
	    shouldDecorateChildren: _propTypes2.default.bool
	};
	exports.default = _class;
	;

/***/ },
/* 1091 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {};

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-extendable <https://github.com/jonschlinkert/is-extendable>
	 *
	 * Copyright (c) 2015-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isPlainObject = __webpack_require__(895);
	
	module.exports = function isExtendable(val) {
	  return isPlainObject(val) || typeof val === 'function' || Array.isArray(val);
	};


/***/ },
/* 1093 */
22,
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * object.omit <https://github.com/jonschlinkert/object.omit>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(1092);
	
	module.exports = function omit(obj, props, fn) {
	  if (!isObject(obj)) return {};
	
	  if (typeof props === 'function') {
	    fn = props;
	    props = [];
	  }
	
	  if (typeof props === 'string') {
	    props = [props];
	  }
	
	  var isFunction = typeof fn === 'function';
	  var keys = Object.keys(obj);
	  var res = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var val = obj[key];
	
	    if (!props || (props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj)))) {
	      res[key] = val;
	    }
	  }
	  return res;
	};


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1097);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1095)();
	}


/***/ },
/* 1097 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(94), __webpack_require__(148)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('clamp'), require('./Lens'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.clamp, global.Lens);
	        global.LensBottom = mod.exports;
	    }
	})(this, function (exports, _react, _clamp, _Lens) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _clamp2 = _interopRequireDefault(_clamp);
	
	    var _Lens2 = _interopRequireDefault(_Lens);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var LensBottom = function LensBottom(_ref) {
	        var cursorOffset = _ref.cursorOffset,
	            position = _ref.position,
	            fadeDurationInMs = _ref.fadeDurationInMs,
	            isHovering = _ref.isHovering,
	            smallImage = _ref.smallImage,
	            style = _ref.style;
	
	
	        var maxHeight = smallImage.height - cursorOffset.y * 2;
	        var height = (0, _clamp2.default)(smallImage.height - position.y - cursorOffset.y, 0, maxHeight);
	        var computedStyle = {
	            height: height + 'px',
	            width: '100%',
	            bottom: '0px'
	        };
	
	        return _react2.default.createElement(_Lens2.default, {
	            fadeDurationInMs: fadeDurationInMs,
	            isHovering: isHovering,
	            style: Object.assign({}, style, computedStyle)
	        });
	    };
	
	    exports.default = LensBottom;
	});

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(94), __webpack_require__(148)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('clamp'), require('./Lens'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.clamp, global.Lens);
	        global.LensLeft = mod.exports;
	    }
	})(this, function (exports, _react, _clamp, _Lens) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _clamp2 = _interopRequireDefault(_clamp);
	
	    var _Lens2 = _interopRequireDefault(_Lens);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var LensLeft = function LensLeft(_ref) {
	        var cursorOffset = _ref.cursorOffset,
	            position = _ref.position,
	            fadeDurationInMs = _ref.fadeDurationInMs,
	            isHovering = _ref.isHovering,
	            smallImage = _ref.smallImage,
	            style = _ref.style;
	
	
	        var height = cursorOffset.y * 2;
	        var maxHeight = smallImage.height - height;
	        var maxWidth = smallImage.width - cursorOffset.x * 2;
	        var width = (0, _clamp2.default)(position.x - cursorOffset.x, 0, maxWidth);
	        var translateY = (0, _clamp2.default)(position.y - cursorOffset.y, 0, maxHeight);
	        var computedStyle = {
	            height: height + 'px',
	            width: width + 'px',
	            top: '0px',
	            left: '0px'
	        };
	
	        return _react2.default.createElement(_Lens2.default, {
	            fadeDurationInMs: fadeDurationInMs,
	            isHovering: isHovering,
	            style: Object.assign({}, style, computedStyle),
	            translateY: translateY
	        });
	    };
	
	    exports.default = LensLeft;
	});

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(94), __webpack_require__(148)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('clamp'), require('./Lens'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.clamp, global.Lens);
	        global.LensRight = mod.exports;
	    }
	})(this, function (exports, _react, _clamp, _Lens) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _clamp2 = _interopRequireDefault(_clamp);
	
	    var _Lens2 = _interopRequireDefault(_Lens);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var LensRight = function LensRight(_ref) {
	        var cursorOffset = _ref.cursorOffset,
	            position = _ref.position,
	            fadeDurationInMs = _ref.fadeDurationInMs,
	            isHovering = _ref.isHovering,
	            smallImage = _ref.smallImage,
	            style = _ref.style;
	
	
	        var height = cursorOffset.y * 2;
	        var maxHeight = smallImage.height - height;
	        var maxWidth = smallImage.width - cursorOffset.x * 2;
	        var width = (0, _clamp2.default)(smallImage.width - position.x - cursorOffset.x, 0, maxWidth);
	        var translateY = (0, _clamp2.default)(Math.round(position.y - cursorOffset.y), 0, maxHeight);
	        var computedStyle = {
	            height: height + 'px',
	            width: width + 'px',
	            top: '0px',
	            right: '0px'
	        };
	
	        return _react2.default.createElement(_Lens2.default, {
	            fadeDurationInMs: fadeDurationInMs,
	            isHovering: isHovering,
	            style: Object.assign({}, style, computedStyle),
	            translateY: translateY
	        });
	    };
	
	    exports.default = LensRight;
	});

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(94), __webpack_require__(148)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('clamp'), require('./Lens'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.clamp, global.Lens);
	        global.LensTop = mod.exports;
	    }
	})(this, function (exports, _react, _clamp, _Lens) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _clamp2 = _interopRequireDefault(_clamp);
	
	    var _Lens2 = _interopRequireDefault(_Lens);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var LensTop = function LensTop(_ref) {
	        var cursorOffset = _ref.cursorOffset,
	            position = _ref.position,
	            fadeDurationInMs = _ref.fadeDurationInMs,
	            isHovering = _ref.isHovering,
	            smallImage = _ref.smallImage,
	            style = _ref.style;
	
	
	        var maxHeight = smallImage.height - cursorOffset.y * 2;
	        var height = (0, _clamp2.default)(position.y - cursorOffset.y, 0, maxHeight);
	        var computedStyle = {
	            height: height + 'px',
	            width: '100%',
	            top: '0px'
	        };
	
	        return _react2.default.createElement(_Lens2.default, {
	            fadeDurationInMs: fadeDurationInMs,
	            isHovering: isHovering,
	            style: Object.assign({}, style, computedStyle)
	        });
	    };
	
	    exports.default = LensTop;
	});

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(37)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('prop-types'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.propTypes);
	        global.Point = mod.exports;
	    }
	})(this, function (exports, _propTypes) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    exports.default = _propTypes2.default.shape({
	        x: _propTypes2.default.number.isRequired,
	        y: _propTypes2.default.number.isRequired
	    });
	});

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(37), __webpack_require__(532), __webpack_require__(495), __webpack_require__(1090), __webpack_require__(1101), __webpack_require__(1099), __webpack_require__(1100), __webpack_require__(1098), __webpack_require__(517), __webpack_require__(220)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('prop-types'), require('react-required-if'), require('react-cursor-position'), require('react-hover-observer'), require('./LensTop'), require('./LensLeft'), require('./LensRight'), require('./LensBottom'), require('./EnlargedImage'), require('./ImageShape'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.propTypes, global.reactRequiredIf, global.reactCursorPosition, global.reactHoverObserver, global.LensTop, global.LensLeft, global.LensRight, global.LensBottom, global.EnlargedImage, global.ImageShape);
	        global.ReactImageMagnify = mod.exports;
	    }
	})(this, function (exports, _react, _propTypes, _reactRequiredIf, _reactCursorPosition, _reactHoverObserver, _LensTop, _LensLeft, _LensRight, _LensBottom, _EnlargedImage, _ImageShape) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    var _reactRequiredIf2 = _interopRequireDefault(_reactRequiredIf);
	
	    var _reactCursorPosition2 = _interopRequireDefault(_reactCursorPosition);
	
	    var _reactHoverObserver2 = _interopRequireDefault(_reactHoverObserver);
	
	    var _LensTop2 = _interopRequireDefault(_LensTop);
	
	    var _LensLeft2 = _interopRequireDefault(_LensLeft);
	
	    var _LensRight2 = _interopRequireDefault(_LensRight);
	
	    var _LensBottom2 = _interopRequireDefault(_LensBottom);
	
	    var _EnlargedImage2 = _interopRequireDefault(_EnlargedImage);
	
	    var _ImageShape2 = _interopRequireDefault(_ImageShape);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var ReactImageMagnify = function (_React$Component) {
	        _inherits(ReactImageMagnify, _React$Component);
	
	        function ReactImageMagnify(props) {
	            _classCallCheck(this, ReactImageMagnify);
	
	            var _this = _possibleConstructorReturn(this, (ReactImageMagnify.__proto__ || Object.getPrototypeOf(ReactImageMagnify)).call(this, props));
	
	            _this.state = {
	                smallImageWidth: 0,
	                smallImageHeight: 0
	            };
	
	            _this.onSmallImageLoad = _this.onSmallImageLoad.bind(_this);
	            _this.setSmallImageDimensionState = _this.setSmallImageDimensionState.bind(_this);
	            return _this;
	        }
	
	        _createClass(ReactImageMagnify, [{
	            key: 'onSmallImageLoad',
	            value: function onSmallImageLoad() {
	                if (!this.props.smallImage.isFluidWidth) {
	                    return;
	                }
	
	                this.setSmallImageDimensionState();
	            }
	        }, {
	            key: 'setSmallImageDimensionState',
	            value: function setSmallImageDimensionState() {
	                var _smallImageEl = this.smallImageEl,
	                    smallImageWidth = _smallImageEl.offsetWidth,
	                    smallImageHeight = _smallImageEl.offsetHeight;
	
	
	                this.setState({
	                    smallImageWidth: smallImageWidth,
	                    smallImageHeight: smallImageHeight
	                });
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                if (this.props.smallImage.isFluidWidth) {
	                    this.setSmallImageDimensionState();
	                    window.addEventListener('resize', this.setSmallImageDimensionState);
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                if (this.props.smallImage.isFluidWidth) {
	                    window.removeEventListener('resize', this.setSmallImageDimensionState);
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this2 = this;
	
	                var _props = this.props,
	                    className = _props.className,
	                    enlargedImageContainerClassName = _props.enlargedImageContainerClassName,
	                    enlargedImageContainerStyle = _props.enlargedImageContainerStyle,
	                    enlargedImageClassName = _props.enlargedImageClassName,
	                    enlargedImageStyle = _props.enlargedImageStyle,
	                    fadeDurationInMs = _props.fadeDurationInMs,
	                    hoverDelayInMs = _props.hoverDelayInMs,
	                    hoverOffDelayInMs = _props.hoverOffDelayInMs,
	                    isSmallImageFluidWidth = _props.smallImage.isFluidWidth,
	                    imageClassName = _props.imageClassName,
	                    imageStyle = _props.imageStyle,
	                    largeImage = _props.largeImage,
	                    lensStyle = _props.lensStyle,
	                    style = _props.style,
	                    enlargedImagePosition = _props.enlargedImagePosition;
	
	
	                var fluidWidthSmallImage = Object.assign({}, this.props.smallImage, {
	                    width: this.state.smallImageWidth,
	                    height: this.state.smallImageHeight
	                });
	                var fixedWidthSmallImage = this.props.smallImage;
	                var smallImage = isSmallImageFluidWidth ? fluidWidthSmallImage : fixedWidthSmallImage;
	
	                var cursorOffset = {
	                    x: Math.round(smallImage.width / largeImage.width * smallImage.width / 2),
	                    y: Math.round(smallImage.height / largeImage.height * smallImage.height / 2)
	                };
	
	                var defaultLensStyle = {
	                    backgroundColor: 'rgba(0,0,0,.4)'
	                };
	                if (enlargedImagePosition === 'over') {
	                    defaultLensStyle = {};
	                }
	                var compositLensStyle = Object.assign({}, defaultLensStyle, lensStyle);
	
	                var fluidWidthContainerStyle = {
	                    width: 'auto',
	                    height: 'auto',
	                    fontSize: '0px',
	                    position: 'relative'
	                };
	                var fixedWidthContainerStyle = {
	                    width: smallImage.width + 'px',
	                    height: smallImage.height + 'px',
	                    position: 'relative'
	                };
	                var priorityContainerStyle = isSmallImageFluidWidth ? fluidWidthContainerStyle : fixedWidthContainerStyle;
	                var compositContainerStyle = Object.assign({
	                    cursor: 'crosshair'
	                }, style, priorityContainerStyle);
	
	                var fluidWidthSmallImageStyle = {
	                    width: '100%',
	                    height: 'auto',
	                    display: 'block'
	                };
	                var fixedWidthSmallImageStyle = {
	                    width: smallImage.width + 'px',
	                    height: smallImage.height + 'px'
	                };
	                var prioritySmallImageStyle = isSmallImageFluidWidth ? fluidWidthSmallImageStyle : fixedWidthSmallImageStyle;
	                var compositSmallImageStyle = Object.assign({}, imageStyle, prioritySmallImageStyle);
	
	                return _react2.default.createElement(
	                    _reactCursorPosition2.default,
	                    {
	                        className: className,
	                        style: compositContainerStyle
	                    },
	                    _react2.default.createElement(
	                        _reactHoverObserver2.default,
	                        {
	                            hoverDelayInMs: hoverDelayInMs,
	                            hoverOffDelayInMs: hoverOffDelayInMs,
	                            onMouseEnter: function onMouseEnter(_ref) {
	                                var setIsHovering = _ref.setIsHovering;
	                                return setIsHovering();
	                            },
	                            onMouseLeave: function onMouseLeave(_ref2) {
	                                var unsetIsHovering = _ref2.unsetIsHovering;
	                                return unsetIsHovering();
	                            },
	                            onMouseOver: function onMouseOver(_ref3) {
	                                var e = _ref3.e,
	                                    unsetIsHovering = _ref3.unsetIsHovering;
	
	                                if (e.target.getAttribute('data-hover') === 'false') {
	                                    unsetIsHovering();
	                                }
	                            }
	                        },
	                        _react2.default.createElement('img', {
	                            src: smallImage.src,
	                            srcSet: smallImage.srcSet,
	                            sizes: smallImage.sizes,
	                            alt: smallImage.alt,
	                            className: imageClassName,
	                            style: compositSmallImageStyle,
	                            ref: function ref(el) {
	                                return _this2.smallImageEl = el;
	                            },
	                            onLoad: this.onSmallImageLoad
	                        }),
	                        _react2.default.createElement(_LensTop2.default, {
	                            cursorOffset: cursorOffset,
	                            fadeDurationInMs: fadeDurationInMs,
	                            smallImage: smallImage,
	                            style: compositLensStyle
	                        }),
	                        _react2.default.createElement(_LensLeft2.default, {
	                            cursorOffset: cursorOffset,
	                            fadeDurationInMs: fadeDurationInMs,
	                            smallImage: smallImage,
	                            style: compositLensStyle
	                        }),
	                        _react2.default.createElement(_LensRight2.default, {
	                            cursorOffset: cursorOffset,
	                            fadeDurationInMs: fadeDurationInMs,
	                            smallImage: smallImage,
	                            style: compositLensStyle
	                        }),
	                        _react2.default.createElement(_LensBottom2.default, {
	                            cursorOffset: cursorOffset,
	                            fadeDurationInMs: fadeDurationInMs,
	                            smallImage: smallImage,
	                            style: compositLensStyle
	                        }),
	                        _react2.default.createElement(_EnlargedImage2.default, {
	                            containerClassName: enlargedImageContainerClassName,
	                            containerStyle: enlargedImageContainerStyle,
	                            cursorOffset: cursorOffset,
	                            fadeDurationInMs: fadeDurationInMs,
	                            imageClassName: enlargedImageClassName,
	                            imageStyle: enlargedImageStyle,
	                            largeImage: largeImage,
	                            smallImage: smallImage,
	                            imagePosition: enlargedImagePosition
	                        })
	                    )
	                );
	            }
	        }]);
	
	        return ReactImageMagnify;
	    }(_react2.default.Component);
	
	    ReactImageMagnify.propTypes = {
	        className: _propTypes2.default.string,
	        enlargedImageContainerClassName: _propTypes2.default.string,
	        enlargedImageContainerStyle: _propTypes2.default.object,
	        enlargedImageClassName: _propTypes2.default.string,
	        enlargedImageStyle: _propTypes2.default.object,
	        fadeDurationInMs: _propTypes2.default.number,
	        hoverDelayInMs: _propTypes2.default.number,
	        hoverOffDelayInMs: _propTypes2.default.number,
	        imageClassName: _propTypes2.default.string,
	        imageStyle: _propTypes2.default.object,
	        largeImage: _ImageShape2.default,
	        lensStyle: _propTypes2.default.object,
	        smallImage: _propTypes2.default.shape({
	            alt: _propTypes2.default.string,
	            isFluidWidth: _propTypes2.default.bool,
	            src: _propTypes2.default.string.isRequired,
	            srcSet: _propTypes2.default.string,
	            sizes: _propTypes2.default.string,
	            width: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
	                return !props.isFluidWidth;
	            }),
	            height: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
	                return !props.isFluidWidth;
	            })
	        }),
	        style: _propTypes2.default.object,
	        enlargedImagePosition: _propTypes2.default.oneOf(['beside', 'over'])
	    };
	    ReactImageMagnify.defaultProps = {
	        enlargedImagePosition: 'beside',
	        fadeDurationInMs: 300,
	        hoverDelayInMs: 250,
	        hoverOffDelayInMs: 150
	    };
	    exports.default = ReactImageMagnify;
	});

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(37), __webpack_require__(495), __webpack_require__(532), __webpack_require__(517), __webpack_require__(220)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('prop-types'), require('react-cursor-position'), require('react-required-if'), require('./EnlargedImage'), require('./ImageShape'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.propTypes, global.reactCursorPosition, global.reactRequiredIf, global.EnlargedImage, global.ImageShape);
	        global.ReactImageMagnifyTouch = mod.exports;
	    }
	})(this, function (exports, _react, _propTypes, _reactCursorPosition, _reactRequiredIf, _EnlargedImage, _ImageShape) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    var _reactCursorPosition2 = _interopRequireDefault(_reactCursorPosition);
	
	    var _reactRequiredIf2 = _interopRequireDefault(_reactRequiredIf);
	
	    var _EnlargedImage2 = _interopRequireDefault(_EnlargedImage);
	
	    var _ImageShape2 = _interopRequireDefault(_ImageShape);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var ReactImageMagnifyTouch = function (_React$Component) {
	        _inherits(ReactImageMagnifyTouch, _React$Component);
	
	        function ReactImageMagnifyTouch(props) {
	            _classCallCheck(this, ReactImageMagnifyTouch);
	
	            var _this = _possibleConstructorReturn(this, (ReactImageMagnifyTouch.__proto__ || Object.getPrototypeOf(ReactImageMagnifyTouch)).call(this, props));
	
	            _this.state = {
	                smallImageWidth: 0,
	                smallImageHeight: 0
	            };
	
	            _this.onSmallImageLoad = _this.onSmallImageLoad.bind(_this);
	            _this.setSmallImageDimensionState = _this.setSmallImageDimensionState.bind(_this);
	            return _this;
	        }
	
	        _createClass(ReactImageMagnifyTouch, [{
	            key: 'onSmallImageLoad',
	            value: function onSmallImageLoad() {
	                if (!this.props.smallImage.isFluidWidth) {
	                    return;
	                }
	
	                this.setSmallImageDimensionState();
	            }
	        }, {
	            key: 'setSmallImageDimensionState',
	            value: function setSmallImageDimensionState() {
	                var _smallImageEl = this.smallImageEl,
	                    smallImageWidth = _smallImageEl.offsetWidth,
	                    smallImageHeight = _smallImageEl.offsetHeight;
	
	
	                this.setState({
	                    smallImageWidth: smallImageWidth,
	                    smallImageHeight: smallImageHeight
	                });
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                if (this.props.smallImage.isFluidWidth) {
	                    this.setSmallImageDimensionState();
	                    window.addEventListener('resize', this.setSmallImageDimensionState);
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                if (this.props.smallImage.isFluidWidth) {
	                    window.removeEventListener('resize', this.setSmallImageDimensionState);
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this2 = this;
	
	                var _props = this.props,
	                    className = _props.className,
	                    enlargedImageContainerClassName = _props.enlargedImageContainerClassName,
	                    enlargedImageContainerStyle = _props.enlargedImageContainerStyle,
	                    enlargedImageClassName = _props.enlargedImageClassName,
	                    enlargedImageStyle = _props.enlargedImageStyle,
	                    fadeDurationInMs = _props.fadeDurationInMs,
	                    isActivatedOnTouch = _props.isActivatedOnTouch,
	                    imageClassName = _props.imageClassName,
	                    imageStyle = _props.imageStyle,
	                    largeImage = _props.largeImage,
	                    pressDuration = _props.pressDuration,
	                    pressMoveThreshold = _props.pressMoveThreshold,
	                    isSmallImageFluidWidth = _props.smallImage.isFluidWidth,
	                    style = _props.style,
	                    enlargedImagePosition = _props.enlargedImagePosition;
	
	
	                var fluidWidthSmallImage = Object.assign({}, this.props.smallImage, {
	                    width: this.state.smallImageWidth,
	                    height: this.state.smallImageHeight
	                });
	                var fixedWidthSmallImage = this.props.smallImage;
	                var smallImage = isSmallImageFluidWidth ? fluidWidthSmallImage : fixedWidthSmallImage;
	
	                var cursorOffset = {
	                    x: Math.round(smallImage.width / largeImage.width * smallImage.width / 2),
	                    y: Math.round(smallImage.height / largeImage.height * smallImage.height / 2)
	                };
	
	                var fluidWidthContainerStyle = {
	                    width: 'auto',
	                    height: 'auto',
	                    fontSize: '0px',
	                    position: 'relative'
	                };
	                var fixedWidthContainerStyle = {
	                    width: smallImage.width + 'px',
	                    height: smallImage.height + 'px',
	                    position: 'relative'
	                };
	                var priorityContainerStyle = isSmallImageFluidWidth ? fluidWidthContainerStyle : fixedWidthContainerStyle;
	                var compositContainerStyle = Object.assign({}, style, priorityContainerStyle);
	
	                var fluidWidthSmallImageStyle = {
	                    width: '100%',
	                    height: 'auto',
	                    display: 'block',
	                    pointerEvents: 'none'
	                };
	                var fixedWidthSmallImageStyle = {
	                    width: smallImage.width + 'px',
	                    height: smallImage.height + 'px',
	                    pointerEvents: 'none'
	                };
	                var prioritySmallImageStyle = isSmallImageFluidWidth ? fluidWidthSmallImageStyle : fixedWidthSmallImageStyle;
	                var compositSmallImageStyle = Object.assign({}, imageStyle, prioritySmallImageStyle);
	
	                return _react2.default.createElement(
	                    _reactCursorPosition2.default,
	                    {
	                        className: className,
	                        isActivatedOnTouch: isActivatedOnTouch,
	                        mapChildProps: function mapChildProps(_ref) {
	                            var isActive = _ref.isActive,
	                                isPositionOutside = _ref.isPositionOutside,
	                                position = _ref.position;
	                            return {
	                                isHovering: isActive,
	                                isPositionOutside: isPositionOutside,
	                                position: position
	                            };
	                        },
	                        pressDuration: pressDuration,
	                        pressMoveThreshold: pressMoveThreshold,
	                        style: compositContainerStyle
	                    },
	                    _react2.default.createElement('img', {
	                        src: smallImage.src,
	                        alt: smallImage.alt,
	                        className: imageClassName,
	                        onLoad: this.onSmallImageLoad,
	                        ref: function ref(el) {
	                            return _this2.smallImageEl = el;
	                        },
	                        style: compositSmallImageStyle,
	                        srcSet: smallImage.srcSet,
	                        sizes: smallImage.sizes
	                    }),
	                    _react2.default.createElement(_EnlargedImage2.default, {
	                        containerClassName: enlargedImageContainerClassName,
	                        containerStyle: enlargedImageContainerStyle,
	                        cursorOffset: cursorOffset,
	                        fadeDurationInMs: fadeDurationInMs,
	                        imageClassName: enlargedImageClassName,
	                        imageStyle: Object.assign({}, enlargedImageStyle, { pointerEvents: 'none' }),
	                        isRenderOnDemand: false,
	                        largeImage: largeImage,
	                        smallImage: smallImage,
	                        imagePosition: enlargedImagePosition
	                    })
	                );
	            }
	        }]);
	
	        return ReactImageMagnifyTouch;
	    }(_react2.default.Component);
	
	    ReactImageMagnifyTouch.propTypes = {
	        className: _propTypes2.default.string,
	        enlargedImageContainerClassName: _propTypes2.default.string,
	        enlargedImageContainerStyle: _propTypes2.default.object,
	        enlargedImageClassName: _propTypes2.default.string,
	        enlargedImageStyle: _propTypes2.default.object,
	        fadeDurationInMs: _propTypes2.default.number,
	        isActivatedOnTouch: _propTypes2.default.bool,
	        imageClassName: _propTypes2.default.string,
	        imageStyle: _propTypes2.default.object,
	        largeImage: _ImageShape2.default,
	        pressDuration: _propTypes2.default.number,
	        pressMoveThreshold: _propTypes2.default.number,
	        smallImage: _propTypes2.default.shape({
	            alt: _propTypes2.default.string,
	            isFluidWidth: _propTypes2.default.bool,
	            src: _propTypes2.default.string.isRequired,
	            srcSet: _propTypes2.default.string,
	            sizes: _propTypes2.default.string,
	            width: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
	                return !props.isFluidWidth;
	            }),
	            height: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
	                return !props.isFluidWidth;
	            })
	        }),
	        style: _propTypes2.default.object,
	        enlargedImagePosition: _propTypes2.default.oneOf(['beside', 'over'])
	    };
	    ReactImageMagnifyTouch.defaultProps = {
	        fadeDurationInMs: 500,
	        enlargedImagePosition: 'over'
	    };
	    exports.default = ReactImageMagnifyTouch;
	});

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1103), __webpack_require__(1104)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('./ReactImageMagnify'), require('./ReactImageMagnifyTouch'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.ReactImageMagnify, global.ReactImageMagnifyTouch);
	        global.index = mod.exports;
	    }
	})(this, function (exports, _ReactImageMagnify, _ReactImageMagnifyTouch) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	    exports.ReactImageMagnifyTouch = exports.ReactImageMagnify = undefined;
	
	    var _ReactImageMagnify2 = _interopRequireDefault(_ReactImageMagnify);
	
	    var _ReactImageMagnifyTouch2 = _interopRequireDefault(_ReactImageMagnifyTouch);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    exports.ReactImageMagnify = _ReactImageMagnify2.default;
	    exports.ReactImageMagnifyTouch = _ReactImageMagnifyTouch2.default;
	});

/***/ },
/* 1106 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  canvasStyle: {
	    position: 'absolute',
	    bottom: 0,
	    left: 0,
	    height: 0,
	    overflow: 'hidden',
	    'padding-top': 0,
	    'padding-bottom': 0,
	    border: 'none'
	  },
	  mirrorProps: ['box-sizing', 'width', 'font-size', 'font-weight', 'font-family', 'font-style', 'letter-spacing', 'text-indent', 'white-space', 'word-break', 'overflow-wrap', 'padding-left', 'padding-right']
	};
	


/***/ },
/* 1107 */
/***/ function(module, exports) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function omit(obj, omittedKeys) {
	  if (!obj || _typeof(obj) !== 'object') {
	    return obj;
	  }
	
	  var ret = {};
	  Object.keys(obj).forEach(function (key) {
	    if (omittedKeys.indexOf(key) > -1) {
	      return;
	    }
	
	    ret[key] = obj[key];
	  });
	  return ret;
	}
	
	module.exports = {
	  omit: omit
	};
	


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
	
	function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(1106),
	    canvasStyle = _require.canvasStyle,
	    mirrorProps = _require.mirrorProps;
	
	var _require2 = __webpack_require__(1107),
	    omit = _require2.omit;
	
	function prevSibling(node, count) {
	  while (node && count--) {
	    node = node.previousElementSibling;
	  }
	
	  return node;
	}
	
	var defaultProps = {
	  basedOn: undefined,
	  className: '',
	  component: 'div',
	  ellipsis: '…',
	  // &hellip;
	  maxLine: 1,
	  onReflow: function onReflow() {},
	  text: '',
	  trimRight: true,
	  winWidth: undefined // for the HOC
	
	};
	var usedProps = Object.keys(defaultProps);
	/**
	 * props.text {String} the text you want to clamp
	 * props.maxLine {Number|String} max lines allowed
	 * props.ellipsis {String} the ellipsis indicator
	 * props.trimRight {Boolean} should we trimRight the clamped text?
	 * props.basedOn {String} letters|words
	 * props.className {String}
	 */
	
	var LinesEllipsis =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(LinesEllipsis, _React$Component);
	
	  function LinesEllipsis(props) {
	    var _this;
	
	    _classCallCheck(this, LinesEllipsis);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinesEllipsis).call(this, props));
	    _this.state = {
	      text: props.text,
	      clamped: false
	    };
	    _this.units = [];
	    _this.maxLine = 0;
	    _this.canvas = null;
	    return _this;
	  }
	
	  _createClass(LinesEllipsis, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initCanvas();
	      this.reflow(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.winWidth !== this.props.winWidth) {
	        this.copyStyleToCanvas();
	      }
	
	      if (this.props !== prevProps) {
	        this.reflow(this.props);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.canvas.parentNode.removeChild(this.canvas);
	    }
	  }, {
	    key: "setState",
	    value: function setState(state, callback) {
	      if (typeof state.clamped !== 'undefined') {
	        this.clamped = state.clamped;
	      }
	
	      return _get(_getPrototypeOf(LinesEllipsis.prototype), "setState", this).call(this, state, callback);
	    }
	  }, {
	    key: "initCanvas",
	    value: function initCanvas() {
	      if (this.canvas) return;
	      var canvas = this.canvas = document.createElement('div');
	      canvas.className = "LinesEllipsis-canvas ".concat(this.props.className);
	      canvas.setAttribute('aria-hidden', 'true');
	      this.copyStyleToCanvas();
	      Object.keys(canvasStyle).forEach(function (key) {
	        canvas.style[key] = canvasStyle[key];
	      });
	      document.body.appendChild(canvas);
	    }
	  }, {
	    key: "copyStyleToCanvas",
	    value: function copyStyleToCanvas() {
	      var _this2 = this;
	
	      var targetStyle = window.getComputedStyle(this.target);
	      mirrorProps.forEach(function (key) {
	        _this2.canvas.style[key] = targetStyle[key];
	      });
	    }
	  }, {
	    key: "reflow",
	    value: function reflow(props) {
	      /* eslint-disable no-control-regex */
	      var basedOn = props.basedOn || (/^[\x00-\x7F]+$/.test(props.text) ? 'words' : 'letters');
	
	      switch (basedOn) {
	        case 'words':
	          this.units = props.text.split(/\b|(?=\W)/);
	          break;
	
	        case 'letters':
	          this.units = Array.from(props.text);
	          break;
	
	        default:
	          throw new Error("Unsupported options basedOn: ".concat(basedOn));
	      }
	
	      this.maxLine = +props.maxLine || 1;
	      this.canvas.innerHTML = this.units.map(function (c) {
	        return "<span class='LinesEllipsis-unit'>".concat(c, "</span>");
	      }).join('');
	      var ellipsisIndex = this.putEllipsis(this.calcIndexes());
	      var clamped = ellipsisIndex > -1;
	      var newState = {
	        clamped: clamped,
	        text: clamped ? this.units.slice(0, ellipsisIndex).join('') : props.text
	      };
	      this.setState(newState, props.onReflow.bind(this, newState));
	    }
	  }, {
	    key: "calcIndexes",
	    value: function calcIndexes() {
	      var indexes = [0];
	      var elt = this.canvas.firstElementChild;
	      if (!elt) return indexes;
	      var index = 0;
	      var line = 1;
	      var offsetTop = elt.offsetTop;
	
	      while (elt = elt.nextElementSibling) {
	        if (elt.offsetTop > offsetTop) {
	          line++;
	          indexes.push(index);
	          offsetTop = elt.offsetTop;
	        }
	
	        index++;
	
	        if (line > this.maxLine) {
	          break;
	        }
	      }
	
	      return indexes;
	    }
	  }, {
	    key: "putEllipsis",
	    value: function putEllipsis(indexes) {
	      if (indexes.length <= this.maxLine) return -1;
	      var lastIndex = indexes[this.maxLine];
	      var units = this.units.slice(0, lastIndex);
	      var maxOffsetTop = this.canvas.children[lastIndex].offsetTop;
	      this.canvas.innerHTML = units.map(function (c, i) {
	        return "<span class='LinesEllipsis-unit'>".concat(c, "</span>");
	      }).join('') + "<wbr><span class='LinesEllipsis-ellipsis'>".concat(this.props.ellipsis, "</span>");
	      var ndEllipsis = this.canvas.lastElementChild;
	      var ndPrevUnit = prevSibling(ndEllipsis, 2);
	
	      while (ndPrevUnit && (ndEllipsis.offsetTop > maxOffsetTop || // IE & Edge: doesn't support <wbr>
	      ndEllipsis.offsetHeight > ndPrevUnit.offsetHeight || ndEllipsis.offsetTop > ndPrevUnit.offsetTop)) {
	        this.canvas.removeChild(ndPrevUnit);
	        ndPrevUnit = prevSibling(ndEllipsis, 2);
	        units.pop();
	      }
	
	      return units.length;
	    } // expose
	
	  }, {
	    key: "isClamped",
	    value: function isClamped() {
	      return this.clamped; // do not use state.clamped. #27
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$state = this.state,
	          text = _this$state.text,
	          clamped = _this$state.clamped;
	
	      var _this$props = this.props,
	          Component = _this$props.component,
	          ellipsis = _this$props.ellipsis,
	          trimRight = _this$props.trimRight,
	          className = _this$props.className,
	          rest = _objectWithoutProperties(_this$props, ["component", "ellipsis", "trimRight", "className"]);
	
	      return React.createElement(Component, _extends({
	        className: "LinesEllipsis ".concat(clamped ? 'LinesEllipsis--clamped' : '', " ").concat(className),
	        ref: function ref(node) {
	          return _this3.target = node;
	        }
	      }, omit(rest, usedProps)), clamped && trimRight ? text.replace(/[\s\uFEFF\xA0]+$/, '') : text, React.createElement("wbr", null), clamped && React.createElement("span", {
	        className: "LinesEllipsis-ellipsis"
	      }, ellipsis));
	    }
	  }]);
	
	  return LinesEllipsis;
	}(React.Component);
	
	LinesEllipsis.defaultProps = defaultProps;
	module.exports = LinesEllipsis;
	


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// keyCode constants
	var BACKSPACE = 8;
	var LEFT_ARROW = 37;
	var RIGHT_ARROW = 39;
	var DELETE = 46;
	
	// Doesn't really check if it's a style Object
	// Basic implemenetation to check if it's not a string
	// of classNames and is an Object
	// TODO: Better implementation
	var isStyleObject = function isStyleObject(obj) {
	  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	};
	
	var SingleOtpInput = function (_PureComponent) {
	  _inherits(SingleOtpInput, _PureComponent);
	
	  function SingleOtpInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SingleOtpInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleOtpInput.__proto__ || Object.getPrototypeOf(SingleOtpInput)).call.apply(_ref, [this].concat(args))), _this), _this.getClasses = function () {
	      for (var _len2 = arguments.length, classes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        classes[_key2] = arguments[_key2];
	      }
	
	      return classes.filter(function (c) {
	        return !isStyleObject(c) && c !== false;
	      }).join(' ');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SingleOtpInput, [{
	    key: 'componentDidMount',
	
	
	    // Focus on first render
	    // Only when shouldAutoFocus is true
	    value: function componentDidMount() {
	      var input = this.input,
	          _props = this.props,
	          focus = _props.focus,
	          shouldAutoFocus = _props.shouldAutoFocus;
	
	
	      if (input && focus && shouldAutoFocus) {
	        input.focus();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var input = this.input,
	          focus = this.props.focus;
	
	      // Check if focusedInput changed
	      // Prevent calling function if input already in focus
	
	      if (prevProps.focus !== focus && input && focus) {
	        input.focus();
	        input.select();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          separator = _props2.separator,
	          isLastChild = _props2.isLastChild,
	          inputStyle = _props2.inputStyle,
	          focus = _props2.focus,
	          isDisabled = _props2.isDisabled,
	          hasErrored = _props2.hasErrored,
	          errorStyle = _props2.errorStyle,
	          focusStyle = _props2.focusStyle,
	          disabledStyle = _props2.disabledStyle,
	          shouldAutoFocus = _props2.shouldAutoFocus,
	          isInputNum = _props2.isInputNum,
	          value = _props2.value,
	          rest = _objectWithoutProperties(_props2, ['separator', 'isLastChild', 'inputStyle', 'focus', 'isDisabled', 'hasErrored', 'errorStyle', 'focusStyle', 'disabledStyle', 'shouldAutoFocus', 'isInputNum', 'value']);
	
	      var numValueLimits = isInputNum ? { min: 0, max: 9 } : {};
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', alignItems: 'center' } },
	        _react2.default.createElement('input', _extends({
	          style: Object.assign({ width: '1em', textAlign: 'center' }, isStyleObject(inputStyle) && inputStyle, focus && isStyleObject(focusStyle) && focusStyle, isDisabled && isStyleObject(disabledStyle) && disabledStyle, hasErrored && isStyleObject(errorStyle) && errorStyle),
	          className: this.getClasses(inputStyle, focus && focusStyle, isDisabled && disabledStyle, hasErrored && errorStyle),
	          type: isInputNum ? 'number' : 'tel'
	        }, numValueLimits, {
	          maxLength: '1',
	          ref: function ref(input) {
	            _this2.input = input;
	          },
	          disabled: isDisabled,
	          value: value ? value : ''
	        }, rest)),
	        !isLastChild && separator
	      );
	    }
	  }]);
	
	  return SingleOtpInput;
	}(_react.PureComponent);
	
	var OtpInput = function (_Component) {
	  _inherits(OtpInput, _Component);
	
	  function OtpInput() {
	    var _ref2;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, OtpInput);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = OtpInput.__proto__ || Object.getPrototypeOf(OtpInput)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {
	      activeInput: 0
	    }, _this3.getOtpValue = function () {
	      return _this3.props.value ? _this3.props.value.toString().split('') : [];
	    }, _this3.handleOtpChange = function (otp) {
	      var _this3$props = _this3.props,
	          onChange = _this3$props.onChange,
	          isInputNum = _this3$props.isInputNum;
	
	      var otpValue = otp.join('');
	      onChange(isInputNum ? Number(otpValue) : otpValue);
	    }, _this3.focusInput = function (input) {
	      var numInputs = _this3.props.numInputs;
	
	      var activeInput = Math.max(Math.min(numInputs - 1, input), 0);
	
	      _this3.setState({ activeInput: activeInput });
	    }, _this3.focusNextInput = function () {
	      var activeInput = _this3.state.activeInput;
	
	      _this3.focusInput(activeInput + 1);
	    }, _this3.focusPrevInput = function () {
	      var activeInput = _this3.state.activeInput;
	
	      _this3.focusInput(activeInput - 1);
	    }, _this3.changeCodeAtFocus = function (value) {
	      var activeInput = _this3.state.activeInput;
	
	      var otp = _this3.getOtpValue();
	      otp[activeInput] = value[0];
	
	      _this3.handleOtpChange(otp);
	    }, _this3.handleOnPaste = function (e) {
	      e.preventDefault();
	      var numInputs = _this3.props.numInputs;
	      var activeInput = _this3.state.activeInput;
	
	      var otp = _this3.getOtpValue();
	
	      // Get pastedData in an array of max size (num of inputs - current position)
	      var pastedData = e.clipboardData.getData('text/plain').slice(0, numInputs - activeInput).split('');
	
	      // Paste data from focused input onwards
	      for (var pos = 0; pos < numInputs; ++pos) {
	        if (pos >= activeInput && pastedData.length > 0) {
	          otp[pos] = pastedData.shift();
	        }
	      }
	
	      _this3.handleOtpChange(otp);
	    }, _this3.handleOnChange = function (e) {
	      _this3.changeCodeAtFocus(e.target.value);
	      _this3.focusNextInput();
	    }, _this3.handleOnKeyDown = function (e) {
	      if (e.keyCode === BACKSPACE || e.key === 'Backspace') {
	        e.preventDefault();
	        _this3.changeCodeAtFocus('');
	        _this3.focusPrevInput();
	      } else if (e.keyCode === DELETE || e.key === 'Delete') {
	        e.preventDefault();
	        _this3.changeCodeAtFocus('');
	      } else if (e.keyCode === LEFT_ARROW || e.key === 'ArrowLeft') {
	        e.preventDefault();
	        _this3.focusPrevInput();
	      } else if (e.keyCode === RIGHT_ARROW || e.key === 'ArrowRight') {
	        e.preventDefault();
	        _this3.focusNextInput();
	      }
	    }, _this3.checkLength = function (e) {
	      if (e.target.value.length > 1) {
	        e.preventDefault();
	        _this3.focusNextInput();
	      }
	    }, _this3.renderInputs = function () {
	      var activeInput = _this3.state.activeInput;
	      var _this3$props2 = _this3.props,
	          numInputs = _this3$props2.numInputs,
	          inputStyle = _this3$props2.inputStyle,
	          focusStyle = _this3$props2.focusStyle,
	          separator = _this3$props2.separator,
	          isDisabled = _this3$props2.isDisabled,
	          disabledStyle = _this3$props2.disabledStyle,
	          hasErrored = _this3$props2.hasErrored,
	          errorStyle = _this3$props2.errorStyle,
	          shouldAutoFocus = _this3$props2.shouldAutoFocus,
	          isInputNum = _this3$props2.isInputNum;
	
	      var otp = _this3.getOtpValue();
	      var inputs = [];
	
	      var _loop = function _loop(i) {
	        inputs.push(_react2.default.createElement(SingleOtpInput, {
	          key: i,
	          focus: activeInput === i,
	          value: otp && otp[i],
	          onChange: _this3.handleOnChange,
	          onKeyDown: _this3.handleOnKeyDown,
	          onInput: _this3.checkLength,
	          onPaste: _this3.handleOnPaste,
	          onFocus: function onFocus(e) {
	            _this3.setState({ activeInput: i });
	            e.target.select();
	          },
	          onBlur: function onBlur() {
	            return _this3.setState({ activeInput: -1 });
	          },
	          separator: separator,
	          inputStyle: inputStyle,
	          focusStyle: focusStyle,
	          isLastChild: i === numInputs - 1,
	          isDisabled: isDisabled,
	          disabledStyle: disabledStyle,
	          hasErrored: hasErrored,
	          errorStyle: errorStyle,
	          shouldAutoFocus: shouldAutoFocus,
	          isInputNum: isInputNum
	        }));
	      };
	
	      for (var i = 0; i < numInputs; i++) {
	        _loop(i);
	      }
	
	      return inputs;
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  // Helper to return OTP from input
	
	
	  // Focus on input by index
	
	
	  // Focus on next input
	
	
	  // Focus on previous input
	
	
	  // Change OTP value at focused input
	
	
	  // Handle pasted OTP
	
	
	  // Handle cases of backspace, delete, left arrow, right arrow
	
	
	  _createClass(OtpInput, [{
	    key: 'render',
	    value: function render() {
	      var containerStyle = this.props.containerStyle;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: Object.assign({ display: 'flex' }, isStyleObject(containerStyle) && containerStyle),
	          className: !isStyleObject(containerStyle) && containerStyle
	        },
	        this.renderInputs()
	      );
	    }
	  }]);
	
	  return OtpInput;
	}(_react.Component);
	
	OtpInput.defaultProps = {
	  numInputs: 4,
	  onChange: function onChange(otp) {
	    return console.log(otp);
	  },
	  isDisabled: false,
	  shouldAutoFocus: false,
	  value: ''
	};
	exports.default = OtpInput;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(224);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(518);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(1111);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(115);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(521);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(1114);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(84);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(1117);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(222);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(221);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(223);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(1119);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(1131);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(522);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(1116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(518);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1113);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(519);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(17);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(224);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(1115);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(221);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(115);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 1114 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(525);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1123);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(526);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(115);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 1116 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(116));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(523));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(1118));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1120));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(523));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 1120 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(116));
	
	var _style = _interopRequireDefault(__webpack_require__(223));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(563));
	
	var _offset = _interopRequireDefault(__webpack_require__(525));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(1122));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(526));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1124));
	
	var _style = _interopRequireDefault(__webpack_require__(223));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(149));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(528));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1126 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1127 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1128 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1129 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1129));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(84));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(530);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(530);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1134);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1135);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(197);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(324);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1134 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(58);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(533);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload;
	        var method = _action$payload.method;
	        var args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(535);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  var _ref$selectLocationSt = _ref.selectLocationState;
	  var selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt;
	  var _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay;
	  var adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var currentLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      listener(lastPublishedLocation);
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(536);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(86);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(538);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(86);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(57);
	
	var _InternalPropTypes = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(57);
	
	var _InternalPropTypes = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager2 = __webpack_require__(542);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(117);
	
	var _RouterContext = __webpack_require__(228);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(57);
	
	var _RouterUtils = __webpack_require__(539);
	
	var _routerWarning = __webpack_require__(86);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(225);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	var enterHooks = new PendingHooks();
	var changeHooks = new PendingHooks();
	
	function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	  var isSync = hook.length < asyncArity;
	
	  var transitionHook = function transitionHook() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (isSync) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	
	  pendingHooks.add(transitionHook);
	
	  return transitionHook;
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location) {
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  enterHooks.clear();
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (enterHooks.has(hooks[index])) {
	        next();
	        enterHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  changeHooks.clear();
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (changeHooks.has(hooks[index])) {
	        next();
	        changeHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](state, nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(228);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(86);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(889);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(541);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(85);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(225);
	
	var _PromiseUtils = __webpack_require__(537);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(85);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(890);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(541);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(85);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(135);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(540);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(542);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(57);
	
	var _RouterUtils = __webpack_require__(539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(225);
	
	var _PromiseUtils = __webpack_require__(537);
	
	var _PatternUtils = __webpack_require__(85);
	
	var _routerWarning = __webpack_require__(86);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(324);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(226);
	
	var _PropTypes = __webpack_require__(227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(1184));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(37);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(950);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_PureComponent) {
	  _inherits(Container, _PureComponent);
	
	  function Container() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Container);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], _this.subscribers = [], _this.subscribe = function (handler) {
	      _this.subscribers = _this.subscribers.concat(handler);
	    }, _this.unsubscribe = function (handler) {
	      _this.subscribers = _this.subscribers.filter(function (current) {
	        return current !== handler;
	      });
	    }, _this.notifySubscribers = function (evt) {
	      if (!_this.framePending) {
	        var currentTarget = evt.currentTarget;
	
	
	        (0, _raf2.default)(function () {
	          _this.framePending = false;
	
	          var _this$node$getBoundin = _this.node.getBoundingClientRect(),
	              top = _this$node$getBoundin.top,
	              bottom = _this$node$getBoundin.bottom;
	
	          _this.subscribers.forEach(function (handler) {
	            return handler({
	              distanceFromTop: top,
	              distanceFromBottom: bottom,
	              eventSource: currentTarget === window ? document.body : _this.node
	            });
	          });
	        });
	        _this.framePending = true;
	      }
	    }, _this.getParent = function () {
	      return _this.node;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Container, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        subscribe: this.subscribe,
	        unsubscribe: this.unsubscribe,
	        getParent: this.getParent
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.events.forEach(function (event) {
	        return window.addEventListener(event, _this2.notifySubscribers);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      this.events.forEach(function (event) {
	        return window.removeEventListener(event, _this3.notifySubscribers);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement('div', _extends({}, this.props, {
	        ref: function ref(node) {
	          return _this4.node = node;
	        },
	        onScroll: this.notifySubscribers,
	        onTouchStart: this.notifySubscribers,
	        onTouchMove: this.notifySubscribers,
	        onTouchEnd: this.notifySubscribers
	      }));
	    }
	  }]);
	
	  return Container;
	}(_react.PureComponent);
	
	Container.childContextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Container;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(37);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sticky = function (_Component) {
	  _inherits(Sticky, _Component);
	
	  function Sticky() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sticky);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSticky: false,
	      wasSticky: false,
	      style: {}
	    }, _this.handleContainerEvent = function (_ref2) {
	      var distanceFromTop = _ref2.distanceFromTop,
	          distanceFromBottom = _ref2.distanceFromBottom,
	          eventSource = _ref2.eventSource;
	
	      var parent = _this.context.getParent();
	
	      var preventingStickyStateChanges = false;
	      if (_this.props.relative) {
	        preventingStickyStateChanges = eventSource !== parent;
	        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
	      }
	
	      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
	      var contentClientRect = _this.content.getBoundingClientRect();
	      var calculatedHeight = contentClientRect.height;
	
	      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;
	
	      var wasSticky = !!_this.state.isSticky;
	      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;
	
	      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;
	
	      var style = !isSticky ? {} : {
	        position: 'fixed',
	        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
	        left: placeholderClientRect.left,
	        width: placeholderClientRect.width
	      };
	
	      if (!_this.props.disableHardwareAcceleration) {
	        style.transform = 'translateZ(0)';
	      }
	
	      _this.setState({
	        isSticky: isSticky,
	        wasSticky: wasSticky,
	        distanceFromTop: distanceFromTop,
	        distanceFromBottom: distanceFromBottom,
	        calculatedHeight: calculatedHeight,
	        style: style
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sticky, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");
	
	      this.context.subscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.context.unsubscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var element = _react2.default.cloneElement(this.props.children({
	        isSticky: this.state.isSticky,
	        wasSticky: this.state.wasSticky,
	        distanceFromTop: this.state.distanceFromTop,
	        distanceFromBottom: this.state.distanceFromBottom,
	        calculatedHeight: this.state.calculatedHeight,
	        style: this.state.style
	      }), { ref: function ref(content) {
	          _this2.content = _reactDom2.default.findDOMNode(content);
	        } });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { ref: function ref(placeholder) {
	            return _this2.placeholder = placeholder;
	          } }),
	        element
	      );
	    }
	  }]);
	
	  return Sticky;
	}(_react.Component);
	
	Sticky.propTypes = {
	  topOffset: _propTypes2.default.number,
	  bottomOffset: _propTypes2.default.number,
	  relative: _propTypes2.default.bool,
	  children: _propTypes2.default.func.isRequired
	};
	Sticky.defaultProps = {
	  relative: false,
	  topOffset: 0,
	  bottomOffset: 0,
	  disableCompensation: false,
	  disableHardwareAcceleration: false
	};
	Sticky.contextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Sticky;

/***/ },
/* 1157 */
208,
/* 1158 */
[1210, 89],
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1158);
	var ReactElement = __webpack_require__(88);
	
	var emptyFunction = __webpack_require__(36);
	var traverseAllChildren = __webpack_require__(1167);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(89),
	    _assign = __webpack_require__(153);
	
	var ReactComponent = __webpack_require__(229);
	var ReactElement = __webpack_require__(88);
	var ReactPropTypeLocationNames = __webpack_require__(547);
	var ReactNoopUpdateQueue = __webpack_require__(230);
	
	var emptyObject = __webpack_require__(77);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(12);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(88);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(88);
	var ReactPropTypeLocationNames = __webpack_require__(547);
	var ReactPropTypesSecret = __webpack_require__(1163);
	
	var emptyFunction = __webpack_require__(36);
	var getIteratorFn = __webpack_require__(549);
	var warning = __webpack_require__(12);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 1163 */
1057,
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(153);
	
	var ReactComponent = __webpack_require__(229);
	var ReactNoopUpdateQueue = __webpack_require__(230);
	
	var emptyObject = __webpack_require__(77);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 1165 */
1062,
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(89);
	
	var ReactElement = __webpack_require__(88);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(89);
	
	var ReactCurrentOwner = __webpack_require__(49);
	var REACT_ELEMENT_TYPE = __webpack_require__(546);
	
	var getIteratorFn = __webpack_require__(549);
	var invariant = __webpack_require__(11);
	var KeyEscapeUtils = __webpack_require__(1157);
	var warning = __webpack_require__(12);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(550);
	
	var _diff = __webpack_require__(1170);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp;
	  var duration = options.duration;
	
	  return function (action, time, took) {
	    var parts = ['action'];
	    if (timestamp) {
	      parts.push('@ ' + time);
	    }
	    parts.push(action.type);
	    if (duration) {
	      parts.push('(in ' + took.toFixed(2) + ' ms)');
	    }
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger;
	  var actionTransformer = options.actionTransformer;
	  var _options$titleFormatt = options.titleFormatter;
	  var titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt;
	  var collapsed = options.collapsed;
	  var colors = options.colors;
	  var level = options.level;
	  var diff = options.diff;
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started;
	    var startedTime = logEntry.startedTime;
	    var action = logEntry.action;
	    var prevState = logEntry.prevState;
	    var error = logEntry.error;
	    var took = logEntry.took;
	    var nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : null;
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed('%c ' + title, titleCSS);else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group('%c ' + title, titleCSS);else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error', 'color: ' + colors.error(error, prevState) + '; font-weight: bold', error);else logger[errorLevel]('error', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('—— log end ——');
	    }
	  });
	}

/***/ },
/* 1169 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports['default'];

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(807);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind;
	  var path = diff.path;
	  var lhs = diff.lhs;
	  var rhs = diff.rhs;
	  var index = diff.index;
	  var item = diff.item;
	
	  switch (kind) {
	    case 'E':
	      return path.join('.') + ' ' + lhs + ' → ' + rhs;
	    case 'N':
	      return path.join('.') + ' ' + rhs;
	    case 'D':
	      return '' + path.join('.');
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return null;
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log('%c ' + dictionary[kind].text, style(kind), output);
	    });
	  } else {
	    logger.log('—— no diff ——');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('—— diff end —— ');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(1168);
	
	var _helpers = __webpack_require__(550);
	
	var _defaults = __webpack_require__(1169);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger;
	  var transformer = loggerOptions.transformer;
	  var stateTransformer = loggerOptions.stateTransformer;
	  var errorTransformer = loggerOptions.errorTransformer;
	  var predicate = loggerOptions.predicate;
	  var logErrors = loggerOptions.logErrors;
	  var diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = undefined;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	exports.default = createLogger;
	module.exports = exports['default'];

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = promiseMiddleware;
	
	var _isPromise = __webpack_require__(1173);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTypes = ['PENDING', 'FULFILLED', 'REJECTED'];
	
	/**
	 * @function promiseMiddleware
	 * @description
	 * @returns {function} thunk
	 */
	function promiseMiddleware() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var promiseTypeSuffixes = config.promiseTypeSuffixes || defaultTypes;
	
	  return function (ref) {
	    var dispatch = ref.dispatch;
	
	
	    return function (next) {
	      return function (action) {
	        if (action.payload) {
	          if (!(0, _isPromise2.default)(action.payload) && !(0, _isPromise2.default)(action.payload.promise)) {
	            return next(action);
	          }
	        } else {
	          return next(action);
	        }
	
	        // Deconstruct the properties of the original action object to constants
	        var type = action.type,
	            payload = action.payload,
	            meta = action.meta;
	
	        // Assign values for promise type suffixes
	
	        var _promiseTypeSuffixes = _slicedToArray(promiseTypeSuffixes, 3),
	            PENDING = _promiseTypeSuffixes[0],
	            FULFILLED = _promiseTypeSuffixes[1],
	            REJECTED = _promiseTypeSuffixes[2];
	
	        /**
	         * @function getAction
	         * @description Utility function for creating a rejected or fulfilled
	         * flux standard action object.
	         * @param {boolean} Is the action rejected?
	         * @returns {object} action
	         */
	
	
	        var getAction = function getAction(newPayload, isRejected) {
	          return _extends({
	            type: type + '_' + (isRejected ? REJECTED : FULFILLED)
	          }, newPayload === null || typeof newPayload === 'undefined' ? {} : {
	            payload: newPayload
	          }, meta !== undefined ? { meta: meta } : {}, isRejected ? {
	            error: true
	          } : {});
	        };
	
	        /**
	         * Assign values for promise and data variables. In the case the payload
	         * is an object with a `promise` and `data` property, the values of those
	         * properties will be used. In the case the payload is a promise, the
	         * value of the payload will be used and data will be null.
	         */
	        var promise = void 0;
	        var data = void 0;
	
	        if (!(0, _isPromise2.default)(action.payload) && _typeof(action.payload) === 'object') {
	          promise = payload.promise;
	          data = payload.data;
	        } else {
	          promise = payload;
	          data = undefined;
	        }
	
	        /**
	         * First, dispatch the pending action. This flux standard action object
	         * describes the pending state of a promise and will include any data
	         * (for optimistic updates) and/or meta from the original action.
	         */
	        next(_extends({
	          type: type + '_' + PENDING
	        }, data !== undefined ? { payload: data } : {}, meta !== undefined ? { meta: meta } : {}));
	
	        /*
	         * @function handleReject
	         * @description Dispatch the rejected action and return
	         * an error object. The error object is the original error
	         * that was thrown. The user of the library is responsible for
	         * best practices in ensure that they are throwing an Error object.
	         * @params reason The reason the promise was rejected
	         * @returns {object}
	         */
	        var handleReject = function handleReject(reason) {
	          var rejectedAction = getAction(reason, true);
	          dispatch(rejectedAction);
	          throw reason;
	        };
	
	        /*
	         * @function handleFulfill
	         * @description Dispatch the fulfilled action and
	         * return the success object. The success object should
	         * contain the value and the dispatched action.
	         * @param value The value the promise was resloved with
	         * @returns {object}
	         */
	        var handleFulfill = function handleFulfill() {
	          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	          var resolvedAction = getAction(value, false);
	          dispatch(resolvedAction);
	
	          return { value: value, action: resolvedAction };
	        };
	
	        /**
	         * Second, dispatch a rejected or fulfilled action. This flux standard
	         * action object will describe the resolved state of the promise. In
	         * the case of a rejected promise, it will include an `error` property.
	         *
	         * In order to allow proper chaining of actions using `then`, a new
	         * promise is constructed and returned. This promise will resolve
	         * with two properties: (1) the value (if fulfilled) or reason
	         * (if rejected) and (2) the flux standard action.
	         *
	         * Rejected object:
	         * {
	         *   reason: ...
	         *   action: {
	         *     error: true,
	         *     type: 'ACTION_REJECTED',
	         *     payload: ...
	         *   }
	         * }
	         *
	         * Fulfilled object:
	         * {
	         *   value: ...
	         *   action: {
	         *     type: 'ACTION_FULFILLED',
	         *     payload: ...
	         *   }
	         * }
	         */
	        return promise.then(handleFulfill, handleReject);
	      };
	    };
	  };
	}

/***/ },
/* 1173 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPromise;
	function isPromise(value) {
	  if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	    return value && typeof value.then === 'function';
	  }
	
	  return false;
	}

/***/ },
/* 1174 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch;
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(551);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1176 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(552);
	
	var _isPlainObject = __webpack_require__(197);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(553);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18).Buffer))

/***/ },
/* 1179 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(18).Buffer
	var Hash   = __webpack_require__(1179)(Buffer)
	
	exports.sha1 = __webpack_require__(1181)(Buffer, Hash)
	exports.sha256 = __webpack_require__(1182)(Buffer, Hash)
	exports.sha512 = __webpack_require__(1183)(Buffer, Hash)


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(59).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(59).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(59).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 1184 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 1185 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(69)


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(554)


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(555);
	exports.Stream = __webpack_require__(68);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(232);
	exports.Duplex = __webpack_require__(69);
	exports.Transform = __webpack_require__(231);
	exports.PassThrough = __webpack_require__(554);
	if (!process.browser && ({"NODE_ENV":"production","PUBLIC_URL":""}).READABLE_STREAM === 'disable') {
	  module.exports = __webpack_require__(68);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(231)


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(232)


/***/ },
/* 1191 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(1193)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1193 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Hoek = __webpack_require__(32);
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports = module.exports = internals.Topo = function () {
	
	    this._items = [];
	    this.nodes = [];
	};
	
	
	internals.Topo.prototype.add = function (nodes, options) {
	
	    var self = this;
	
	    options = options || {};
	
	    // Validate rules
	
	    var before = [].concat(options.before || []);
	    var after = [].concat(options.after || []);
	    var group = options.group || '?';
	    var sort = options.sort || 0;                   // Used for merging only
	
	    Hoek.assert(before.indexOf(group) === -1, 'Item cannot come before itself:', group);
	    Hoek.assert(before.indexOf('?') === -1, 'Item cannot come before unassociated items');
	    Hoek.assert(after.indexOf(group) === -1, 'Item cannot come after itself:', group);
	    Hoek.assert(after.indexOf('?') === -1, 'Item cannot come after unassociated items');
	
	    ([].concat(nodes)).forEach(function (node, i) {
	
	        var item = {
	            seq: self._items.length,
	            sort: sort,
	            before: before,
	            after: after,
	            group: group,
	            node: node
	        };
	
	        self._items.push(item);
	    });
	
	    // Insert event
	
	    var error = this._sort();
	    Hoek.assert(!error, 'item', (group !== '?' ? 'added into group ' + group : ''), 'created a dependencies error');
	
	    return this.nodes;
	};
	
	
	internals.Topo.prototype.merge = function (others) {
	
	    others = [].concat(others);
	    for (var o = 0, ol = others.length; o < ol; ++o) {
	        var other = others[o];
	        if (other) {
	            for (var i = 0, il = other._items.length; i < il; ++i) {
	                var item = Hoek.shallow(other._items[i]);
	                this._items.push(item);
	            }
	        }
	    }
	
	    // Sort items
	
	    this._items.sort(internals.mergeSort);
	    for (i = 0, il = this._items.length; i < il; ++i) {
	        this._items[i].seq = i;
	    }
	
	    var error = this._sort();
	    Hoek.assert(!error, 'merge created a dependencies error');
	
	    return this.nodes;
	};
	
	
	internals.mergeSort = function (a, b) {
	
	    return a.sort === b.sort ? 0 : (a.sort < b.sort ? -1 : 1);
	};
	
	
	internals.Topo.prototype._sort = function () {
	
	    // Construct graph
	
	    var groups = {};
	    var graph = {};
	    var graphAfters = {};
	
	    for (var i = 0, il = this._items.length; i < il; ++i) {
	        var item = this._items[i];
	        var seq = item.seq;                         // Unique across all items
	        var group = item.group;
	
	        // Determine Groups
	
	        groups[group] = groups[group] || [];
	        groups[group].push(seq);
	
	        // Build intermediary graph using 'before'
	
	        graph[seq] = item.before;
	
	        // Build second intermediary graph with 'after'
	
	        var after = item.after;
	        for (var j = 0, jl = after.length; j < jl; ++j) {
	            graphAfters[after[j]] = (graphAfters[after[j]] || []).concat(seq);
	        }
	    }
	
	    // Expand intermediary graph
	
	    var graphNodes = Object.keys(graph);
	    for (i = 0, il = graphNodes.length; i < il; ++i) {
	        var node = graphNodes[i];
	        var expandedGroups = [];
	
	        var graphNodeItems = Object.keys(graph[node]);
	        for (j = 0, jl = graphNodeItems.length; j < jl; ++j) {
	            group = graph[node][graphNodeItems[j]];
	            groups[group] = groups[group] || [];
	
	            for (var k = 0, kl = groups[group].length; k < kl; ++k) {
	
	                expandedGroups.push(groups[group][k]);
	            }
	        }
	        graph[node] = expandedGroups;
	    }
	
	    // Merge intermediary graph using graphAfters into final graph
	
	    var afterNodes = Object.keys(graphAfters);
	    for (i = 0, il = afterNodes.length; i < il; ++i) {
	        group = afterNodes[i];
	
	        if (groups[group]) {
	            for (j = 0, jl = groups[group].length; j < jl; ++j) {
	                node = groups[group][j];
	                graph[node] = graph[node].concat(graphAfters[group]);
	            }
	        }
	    }
	
	    // Compile ancestors
	
	    var children;
	    var ancestors = {};
	    graphNodes = Object.keys(graph);
	    for (i = 0, il = graphNodes.length; i < il; ++i) {
	        node = graphNodes[i];
	        children = graph[node];
	
	        for (j = 0, jl = children.length; j < jl; ++j) {
	            ancestors[children[j]] = (ancestors[children[j]] || []).concat(node);
	        }
	    }
	
	    // Topo sort
	
	    var visited = {};
	    var sorted = [];
	
	    for (i = 0, il = this._items.length; i < il; ++i) {
	        var next = i;
	
	        if (ancestors[i]) {
	            next = null;
	            for (j = 0, jl = this._items.length; j < jl; ++j) {
	                if (visited[j] === true) {
	                    continue;
	                }
	
	                if (!ancestors[j]) {
	                    ancestors[j] = [];
	                }
	
	                var shouldSeeCount = ancestors[j].length;
	                var seenCount = 0;
	                for (var l = 0, ll = shouldSeeCount; l < ll; ++l) {
	                    if (sorted.indexOf(ancestors[j][l]) >= 0) {
	                        ++seenCount;
	                    }
	                }
	
	                if (seenCount === shouldSeeCount) {
	                    next = j;
	                    break;
	                }
	            }
	        }
	
	        if (next !== null) {
	            next = next.toString();         // Normalize to string TODO: replace with seq
	            visited[next] = true;
	            sorted.push(next);
	        }
	    }
	
	    if (sorted.length !== this._items.length) {
	        return new Error('Invalid dependencies');
	    }
	
	    var seqIndex = {};
	    for (i = 0, il = this._items.length; i < il; ++i) {
	
	        item = this._items[i];
	        seqIndex[item.seq] = item;
	    }
	
	    var sortedNodes = [];
	    this._items = sorted.map(function (value) {
	
	        var sortedItem = seqIndex[value];
	        sortedNodes.push(sortedItem.node);
	        return sortedItem;
	    });
	
	    this.nodes = sortedNodes;
	};


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * UAParser.js v0.7.21
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
	 * Licensed under MIT License
	 */
	(function(window,undefined){"use strict";var LIBVERSION="0.7.21",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(Avast)\/([\w\.]+)/i],[[NAME,"Avast Secure Browser"],VERSION],[/(AVG)\/([\w\.]+)/i],[[NAME,"AVG Secure Browser"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(baiduboxapp)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"],[TYPE,SMARTTV]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/android.+(bah2?-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(1197);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	/*! https://mths.be/utf8js v3.0.0 by @mathias */
	;(function(root) {
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		function checkScalarValue(codePoint) {
			if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
		}
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				checkScalarValue(codePoint);
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function utf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read first byte
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					checkScalarValue(codePoint);
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid UTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function utf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		root.version = '3.0.0';
		root.encode = utf8encode;
		root.decode = utf8decode;
	
	}( false ? this.utf8 = {} : exports));


/***/ },
/* 1199 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1200 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1201 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/*
	 * Browser-compatible JavaScript MD5
	 *
	 * Modification of JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	function md5(bytes) {
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
	}
	/*
	 * Convert an array of little-endian words to an array of bytes
	 */
	
	
	function md5ToHexEncodedArray(input) {
	  var i;
	  var x;
	  var output = [];
	  var length32 = input.length * 32;
	  var hexTab = '0123456789abcdef';
	  var hex;
	
	  for (i = 0; i < length32; i += 8) {
	    x = input[i >> 5] >>> i % 32 & 0xff;
	    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
	    output.push(hex);
	  }
	
	  return output;
	}
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length.
	 */
	
	
	function wordsToMd5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	
	  return [a, b, c, d];
	}
	/*
	 * Convert an array bytes to an array of little-endian words
	 * Characters >255 have their high-byte silently ignored.
	 */
	
	
	function bytesToWords(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	
	  var length8 = input.length * 8;
	
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
	  }
	
	  return output;
	}
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	
	
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xffff;
	}
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	
	
	function bitRotateLeft(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	}
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	
	
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn(b & c | ~b & d, a, b, x, s, t);
	}
	
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn(b & d | c & ~d, a, b, x, s, t);
	}
	
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	var _default = md5;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1202 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	// Adapted from Chris Veness' SHA1 code at
	// http://www.movable-type.co.uk/scripts/sha1.html
	function f(s, x, y, z) {
	  switch (s) {
	    case 0:
	      return x & y ^ ~x & z;
	
	    case 1:
	      return x ^ y ^ z;
	
	    case 2:
	      return x & y ^ x & z ^ y & z;
	
	    case 3:
	      return x ^ y ^ z;
	  }
	}
	
	function ROTL(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function sha1(bytes) {
	  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
	  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  bytes.push(0x80);
	  var l = bytes.length / 4 + 2;
	  var N = Math.ceil(l / 16);
	  var M = new Array(N);
	
	  for (var i = 0; i < N; i++) {
	    M[i] = new Array(16);
	
	    for (var j = 0; j < 16; j++) {
	      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
	    }
	  }
	
	  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
	  M[N - 1][14] = Math.floor(M[N - 1][14]);
	  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
	
	  for (var i = 0; i < N; i++) {
	    var W = new Array(80);
	
	    for (var t = 0; t < 16; t++) W[t] = M[i][t];
	
	    for (var t = 16; t < 80; t++) {
	      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
	    }
	
	    var a = H[0];
	    var b = H[1];
	    var c = H[2];
	    var d = H[3];
	    var e = H[4];
	
	    for (var t = 0; t < 80; t++) {
	      var s = Math.floor(t / 20);
	      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
	      e = d;
	      d = c;
	      c = ROTL(b, 30) >>> 0;
	      b = a;
	      a = T;
	    }
	
	    H[0] = H[0] + a >>> 0;
	    H[1] = H[1] + b >>> 0;
	    H[2] = H[2] + c >>> 0;
	    H[3] = H[3] + d >>> 0;
	    H[4] = H[4] + e >>> 0;
	  }
	
	  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
	}
	
	var _default = sha1;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(557));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(233));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	var _nodeId;
	
	var _clockseq; // Previous uuid creation time
	
	
	var _lastMSecs = 0;
	var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
	
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	
	  if (node == null || clockseq == null) {
	    var seedBytes = options.random || (options.rng || _rng.default)();
	
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
	    }
	
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	
	
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
	
	  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
	
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	
	
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  } // Per 4.2.1.2 Throw error if too many uuids are requested
	
	
	  if (nsecs >= 10000) {
	    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	
	  msecs += 12219292800000; // `time_low`
	
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff; // `time_mid`
	
	  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff; // `time_high_and_version`
	
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	
	  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	
	  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
	
	  b[i++] = clockseq & 0xff; // `node`
	
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : (0, _bytesToUuid.default)(b);
	}
	
	var _default = v1;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(558));
	
	var _md = _interopRequireDefault(__webpack_require__(1201));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v3 = (0, _v.default)('v3', 0x30, _md.default);
	var _default = v3;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(557));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(233));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof options == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	
	
	  rnds[6] = rnds[6] & 0x0f | 0x40;
	  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
	
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || (0, _bytesToUuid.default)(rnds);
	}
	
	var _default = v4;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(558));
	
	var _sha = _interopRequireDefault(__webpack_require__(1202));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v5 = (0, _v.default)('v5', 0x50, _sha.default);
	var _default = v5;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1207 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1208 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1209 */
1208,
/* 1210 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.9c1d5147.js
 **/